import * as React from 'react';
import React__default, { useMemo, Component, useState, useRef, useEffect, useCallback, useImperativeHandle, useLayoutEffect as useLayoutEffect$5, isValidElement, createRef, forwardRef, Fragment as Fragment$2, Children, useContext, createContext } from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import * as reactDom from 'react-dom';
import reactDom__default, { createPortal } from 'react-dom';
import { useHistory as useHistory$1, useLocation } from 'react-router-dom';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck$4(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$2(subClass, superClass);
}

function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$1(o);
}

function _setPrototypeOf$2(o, p) {
  _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$2(o, p);
}

function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$1(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$1(self);
}

function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$1(this, result);
  };
}

function _slicedToArray$1(arr, i) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1();
}

function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1();
}

function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
}

function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray$1(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit$1(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}

function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _classCallCheck$1(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else {obj[key]=value;}return obj;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});if(superClass)_setPrototypeOf$1(subClass,superClass);}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _setPrototypeOf$1(o,p){_setPrototypeOf$1=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf$1(o,p);}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}return _assertThisInitialized(self);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else {result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_unsupportedIterableToArray(arr,i)||_nonIterableRest();}function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_unsupportedIterableToArray(arr)||_nonIterableSpread();}function _arrayWithoutHoles(arr){if(Array.isArray(arr))return _arrayLikeToArray(arr);}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function _iterableToArray(iter){if(typeof Symbol!=="undefined"&&iter[Symbol.iterator]!=null||iter["@@iterator"]!=null)return Array.from(iter);}function _iterableToArrayLimit(arr,i){var _i=arr==null?null:typeof Symbol!=="undefined"&&arr[Symbol.iterator]||arr["@@iterator"];if(_i==null)return;var _arr=[];var _n=true;var _d=false;var _s,_e;try{for(_i=_i.call(arr);!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var ActiveUserSvg='data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDE4IDEyIiBmaWxsPSJub25lIj4KPHBhdGggZD0iTTkuODI4ODMgMTAuNzk5N1Y5LjY1NjgxQzkuODI4ODMgOS4wNTA2IDkuNTg4MDIgOC40NjkyMiA5LjE1OTM2IDguMDQwNTZDOC43MzA3MSA3LjYxMTkxIDguMTQ5MzMgNy4zNzEwOSA3LjU0MzEyIDcuMzcxMDlIMi45NzE2OUMyLjM2NTQ4IDcuMzcxMDkgMS43ODQxIDcuNjExOTEgMS4zNTU0NCA4LjA0MDU2QzAuOTI2NzkgOC40NjkyMiAwLjY4NTk3NCA5LjA1MDYgMC42ODU5NzQgOS42NTY4MVYxMC43OTk3IiBzdHJva2U9IiMyNTc1NjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNS4yNTczOSA1LjA4NTU5QzYuNTE5NzYgNS4wODU1OSA3LjU0MzExIDQuMDYyMjQgNy41NDMxMSAyLjc5OTg3QzcuNTQzMTEgMS41Mzc1MSA2LjUxOTc2IDAuNTE0MTYgNS4yNTczOSAwLjUxNDE2QzMuOTk1MDMgMC41MTQxNiAyLjk3MTY4IDEuNTM3NTEgMi45NzE2OCAyLjc5OTg3QzIuOTcxNjggNC4wNjIyNCAzLjk5NTAzIDUuMDg1NTkgNS4yNTczOSA1LjA4NTU5WiIgc3Ryb2tlPSIjMjU3NTY3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE2LjY4NiAyLjc5OThMMTIuNjUyMiA2LjIyODM4TDEwLjk3MTcgNC43OTkxMyIgc3Ryb2tlPSIjMjU3NTY3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+';var AddSvg='data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTJweCIgaGVpZ2h0PSIxMnB4IiB2aWV3Qm94PSIwIDAgMTIgMTIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDY0ICg5MzUzNykgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+YWRkIGNvcHk8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPgogICAgICAgIDxnIGlkPSJBcnRib2FyZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTI2MC4wMDAwMDAsIC03NDMuMDAwMDAwKSIgc3Ryb2tlPSIjRkZGRkZGIiBzdHJva2Utd2lkdGg9IjIiPgogICAgICAgICAgICA8ZyBpZD0iYWRkLWNvcHkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI2MS4wMDAwMDAsIDc0NC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxsaW5lIHgxPSI1IiB5MT0iMC4zMzMyNSIgeDI9IjUiIHkyPSI5LjY2NjYiIGlkPSJQYXRoIj48L2xpbmU+CiAgICAgICAgICAgICAgICA8bGluZSB4MT0iMC4zMzMwMSIgeTE9IjUiIHgyPSI5LjY2NjMiIHkyPSI1IiBpZD0iUGF0aCI+PC9saW5lPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=';var AddBlueSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuMDAwNDkgMVY5IiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMSA0Ljk5ODA1SDkiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==';var AddDisabledSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMy4zMzMyNVYxMi42NjY2IiBzdHJva2U9IiNGRjY2NDUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik04IDMuMzMzMjVWMTIuNjY2NiIgc3Ryb2tlPSIjQjJCNEM1IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMy4zMzM1IDhIMTIuNjY2OCIgc3Ryb2tlPSIjRkY2NjQ1IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMy4zMzM1IDhIMTIuNjY2OCIgc3Ryb2tlPSIjQjJCNEM1IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var AddGroupSvg='data:image/svg+xml;base64,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';var AddHoverSvg='data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTJweCIgaGVpZ2h0PSIxMnB4IiB2aWV3Qm94PSIwIDAgMTIgMTIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDY0ICg5MzUzNykgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+YWRkIGNvcHkgMjwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+CiAgICAgICAgPGcgaWQ9IkFydGJvYXJkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjYwLjAwMDAwMCwgLTc2MC4wMDAwMDApIiBzdHJva2U9IiNGRjY2NDUiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxnIGlkPSJhZGQtY29weS0yIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNjEuMDAwMDAwLCA3NjEuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8bGluZSB4MT0iNSIgeTE9IjAuMzMzMjUiIHgyPSI1IiB5Mj0iOS42NjY2IiBpZD0iUGF0aCI+PC9saW5lPgogICAgICAgICAgICAgICAgPGxpbmUgeDE9IjAuMzMzMDEiIHkxPSI1IiB4Mj0iOS42NjYzIiB5Mj0iNSIgaWQ9IlBhdGgiPjwvbGluZT4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+';var AdminConsoleSvg='data:image/svg+xml;base64,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';var AppCardPlaceholderSvg='data:image/svg+xml;base64,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';var AppCardServerPlaceholderSvg='data:image/svg+xml;base64,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';var ApproveSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxNCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuNSA1TDUuMTY2NjcgOUwxMi41IDEiIHN0cm9rZT0iIzNEQzNBQiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+';var Arrow_downSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI0IiB2aWV3Qm94PSIwIDAgOCA0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMC42NjY1ODYgMC42NjY2NjZMMy45OTk5MiA0TDcuMzMzMjUgMC42NjY2NjciIGZpbGw9IiMwMDA4NTAiLz4KPC9zdmc+';var Arrow_upSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI0IiB2aWV3Qm94PSIwIDAgOCA0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNy4zMzM0MSAzLjMzMzMzTDQuMDAwMDggMEwwLjY2Njc0OCAzLjMzMzMzIiBmaWxsPSIjMDAwODUwIi8+Cjwvc3ZnPg==';var AutoRefreshStartIconSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNzA0NzYgMUgxMi45MTk2QzEzLjMxNDcgMSAxMy42OTM3IDEuMTU2OTggMTMuOTczMSAxLjQzNjRDMTQuMjUyNSAxLjcxNTgxIDE0LjQwOTUgMi4wOTQ3OSAxNC40MDk1IDIuNDg5OTVWNy43MDQ3NkgxTTcuNzA0NzYgMVYxNC40MDk1SDIuNDg5OTVDMi4wOTQ3OSAxNC40MDk1IDEuNzE1ODEgMTQuMjUyNSAxLjQzNjQgMTMuOTczMUMxLjE1Njk4IDEzLjY5MzcgMSAxMy4zMTQ3IDEgMTIuOTE5NlYyLjQ4OTk1QzEgMi4wOTQ3OSAxLjE1Njk4IDEuNzE1ODEgMS40MzY0IDEuNDM2NEMxLjcxNTgxIDEuMTU2OTggMi4wOTQ3OSAxIDIuNDg5OTUgMUg3LjcwNDc2WiIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE2Ljc1MTggMTIuMkMxNi4yMTk4IDEwLjk4OSAxNS4wMDQ0IDEwLjE0MjggMTMuNTkwOCAxMC4xNDI4QzExLjY4NjUgMTAuMTQyOCAxMC4xNDI5IDExLjY3NzggMTAuMTQyOSAxMy41NzE0QzEwLjE0MjkgMTUuNDY1IDExLjY4NjUgMTcgMTMuNTkwOCAxN0MxNS4wMDQ3IDE3IDE2LjIxOTggMTYuMTUzNSAxNi43NTE4IDE0Ljk0MjUiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNS4yODU3IDEyLjI4NTdIMTYuNzk0M0MxNi44MjEzIDEyLjI4NTcgMTYuODQ4IDEyLjI4MDQgMTYuODczIDEyLjI3QzE2Ljg5OCAxMi4yNTk3IDE2LjkyMDYgMTIuMjQ0NSAxNi45Mzk3IDEyLjIyNTRDMTYuOTU4OCAxMi4yMDYzIDE2Ljk3NCAxMi4xODM3IDE2Ljk4NDMgMTIuMTU4N0MxNi45OTQ3IDEyLjEzMzcgMTcgMTIuMTA3IDE3IDEyLjA4VjEwLjU3MTQiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==';var AutoRefreshStopIconSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOSAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNzA0NzYgMkgxMy45MTk2QzE0LjMxNDcgMiAxNC42OTM3IDIuMTU2OTggMTQuOTczMSAyLjQzNjRDMTUuMjUyNSAyLjcxNTgxIDE1LjQwOTUgMy4wOTQ3OSAxNS40MDk1IDMuNDg5OTVWOC43MDQ3NkgyTTguNzA0NzYgMlYxNS40MDk1SDMuNDg5OTVDMy4wOTQ3OSAxNS40MDk1IDIuNzE1ODEgMTUuMjUyNSAyLjQzNjQgMTQuOTczMUMyLjE1Njk4IDE0LjY5MzcgMiAxNC4zMTQ3IDIgMTMuOTE5NlYzLjQ4OTk1QzIgMy4wOTQ3OSAyLjE1Njk4IDIuNzE1ODEgMi40MzY0IDIuNDM2NEMyLjcxNTgxIDIuMTU2OTggMy4wOTQ3OSAyIDMuNDg5OTUgMkg4LjcwNDc2WiIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE3Ljc1MTggMTMuMkMxNy4yMTk4IDExLjk4OSAxNi4wMDQ0IDExLjE0MjggMTQuNTkwOCAxMS4xNDI4QzEyLjY4NjUgMTEuMTQyOCAxMS4xNDI5IDEyLjY3NzggMTEuMTQyOSAxNC41NzE0QzExLjE0MjkgMTYuNDY1IDEyLjY4NjUgMTggMTQuNTkwOCAxOEMxNi4wMDQ3IDE4IDE3LjIxOTggMTcuMTUzNSAxNy43NTE4IDE1Ljk0MjUiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNi4yODU3IDEzLjI4NTdIMTcuNzk0M0MxNy44MjEzIDEzLjI4NTcgMTcuODQ4IDEzLjI4MDQgMTcuODczIDEzLjI3QzE3Ljg5OCAxMy4yNTk3IDE3LjkyMDYgMTMuMjQ0NSAxNy45Mzk3IDEzLjIyNTRDMTcuOTU4OCAxMy4yMDYzIDE3Ljk3NCAxMy4xODM3IDE3Ljk4NDMgMTMuMTU4N0MxNy45OTQ3IDEzLjEzMzcgMTggMTMuMTA3IDE4IDEzLjA4VjExLjU3MTQiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNS41IDIuNDU0NTlMMS41IDE2LjQ1NDYiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNi41IDEuNDU0NTlMMS41IDE2LjQ1NDYiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==';var BackBlueSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxMyIgdmlld0JveD0iMCAwIDggMTMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik03IDFMMSA2LjVMNyAxMiIgc3Ryb2tlPSIjMDAwODUwIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var BackGreySvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxMyIgdmlld0JveD0iMCAwIDggMTMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik03IDFMMSA2LjVMNyAxMiIgc3Ryb2tlPSIjQjJCNEM1IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var CheckmarkSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuOTMxOCAwLjYxNDc0NkM0LjczMTg5IDAuNjE0NzQ2IDAuNTE1NjI1IDQuODMxMDEgMC41MTU2MjUgMTAuMDMwOUMwLjUxNTYyNSAxNS4yMzA4IDQuNzMxODkgMTkuNDQ3MSA5LjkzMTggMTkuNDQ3MUMxNS4xMzE3IDE5LjQ0NzEgMTkuMzQ4IDE1LjIzMDggMTkuMzQ4IDEwLjAzMDlDMTkuMzQ4IDQuODMxMDEgMTUuMTMxNyAwLjYxNDc0NiA5LjkzMTggMC42MTQ3NDZaTTEzLjk5ODggNi45NTU5NUw5LjU3MjM5IDEzLjA5MzNDOS41MTA1MiAxMy4xNzk2IDkuNDI4OTcgMTMuMjUgOS4zMzQ0OCAxMy4yOTg1QzkuMjM5OTkgMTMuMzQ3MSA5LjEzNTI5IDEzLjM3MjQgOS4wMjkwNyAxMy4zNzI0QzguOTIyODQgMTMuMzcyNCA4LjgxODE1IDEzLjM0NzEgOC43MjM2NiAxMy4yOTg1QzguNjI5MTcgMTMuMjUgOC41NDc2MiAxMy4xNzk2IDguNDg1NzUgMTMuMDkzM0w1Ljg2NDc3IDkuNDYxMzNDNS43ODQ5IDkuMzQ5OTMgNS44NjQ3NyA5LjE5NDQgNi4wMDEzOSA5LjE5NDRINi45ODcxNUM3LjIwMTUzIDkuMTk0NCA3LjQwNTQxIDkuMjk3MzkgNy41MzE1MiA5LjQ3Mzk0TDkuMDI4MDIgMTEuNTUwNUwxMi4zMzIxIDYuOTY4NTZDMTIuNDU4MiA2Ljc5NDExIDEyLjY2IDYuNjg5MDIgMTIuODc2NSA2LjY4OTAySDEzLjg2MjJDMTMuOTk4OCA2LjY4OTAyIDE0LjA3ODcgNi44NDQ1NiAxMy45OTg4IDYuOTU1OTVaIiBmaWxsPSIjMTIzQkU1Ii8+Cjwvc3ZnPg==';var CheckmarkWhiteSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI3IiB2aWV3Qm94PSIwIDAgOCA3IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMSAzTDMuNSA1LjVMNyAxIiBzdHJva2U9IndoaXRlIi8+Cjwvc3ZnPg==';var CircledFileSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTQiIGhlaWdodD0iNTQiIHZpZXdCb3g9IjAgMCA1NCA1NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzBfMTM1KSI+CjxwYXRoIGQ9Ik0yNyA1NEM0MS45MTE3IDU0IDU0IDQxLjkxMTcgNTQgMjdDNTQgMTIuMDg4MyA0MS45MTE3IDAgMjcgMEMxMi4wODgzIDAgMCAxMi4wODgzIDAgMjdDMCA0MS45MTE3IDEyLjA4ODMgNTQgMjcgNTRaIiBmaWxsPSIjMEQ2RUZEIi8+CjxwYXRoIGQ9Ik0yOS41IDE0LjVIMTkuNUMxOC44MzcgMTQuNSAxOC4yMDExIDE0Ljc2MzQgMTcuNzMyMiAxNS4yMzIyQzE3LjI2MzQgMTUuNzAxMSAxNyAxNi4zMzcgMTcgMTdWMzdDMTcgMzcuNjYzIDE3LjI2MzQgMzguMjk4OSAxNy43MzIyIDM4Ljc2NzhDMTguMjAxMSAzOS4yMzY2IDE4LjgzNyAzOS41IDE5LjUgMzkuNUgzNC41QzM1LjE2MyAzOS41IDM1Ljc5ODkgMzkuMjM2NiAzNi4yNjc4IDM4Ljc2NzhDMzYuNzM2NiAzOC4yOTg5IDM3IDM3LjY2MyAzNyAzN1YyMkwyOS41IDE0LjVaIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjkuNSAxNC41VjIySDM3IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMzIgMjguMjVIMjIiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0zMiAzMy4yNUgyMiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTI0LjUgMjMuMjVIMjMuMjVIMjIiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMF8xMzUiPgo8cmVjdCB3aWR0aD0iNTQiIGhlaWdodD0iNTQiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+';var ClearIconSvg='data:image/svg+xml;base64,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';var ColumnsSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMlYxNE04IDJIMTIuNjY2N0MxMy4wMjAzIDIgMTMuMzU5NCAyLjE0MDQ4IDEzLjYwOTUgMi4zOTA1MkMxMy44NTk1IDIuNjQwNTcgMTQgMi45Nzk3MSAxNCAzLjMzMzMzVjEyLjY2NjdDMTQgMTMuMDIwMyAxMy44NTk1IDEzLjM1OTQgMTMuNjA5NSAxMy42MDk1QzEzLjM1OTQgMTMuODU5NSAxMy4wMjAzIDE0IDEyLjY2NjcgMTRIOFYyWk04IDJIMy4zMzMzM0MyLjk3OTcxIDIgMi42NDA1NyAyLjE0MDQ4IDIuMzkwNTIgMi4zOTA1MkMyLjE0MDQ4IDIuNjQwNTcgMiAyLjk3OTcxIDIgMy4zMzMzM1YxMi42NjY3QzIgMTMuMDIwMyAyLjE0MDQ4IDEzLjM1OTQgMi4zOTA1MiAxMy42MDk1QzIuNjQwNTcgMTMuODU5NSAyLjk3OTcxIDE0IDMuMzMzMzMgMTRIOFYyWiIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+';var CopySvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjMzMzMgNkg3LjMzMzMzQzYuNTk2OTUgNiA2IDYuNTk2OTUgNiA3LjMzMzMzVjEzLjMzMzNDNiAxNC4wNjk3IDYuNTk2OTUgMTQuNjY2NyA3LjMzMzMzIDE0LjY2NjdIMTMuMzMzM0MxNC4wNjk3IDE0LjY2NjcgMTQuNjY2NyAxNC4wNjk3IDE0LjY2NjcgMTMuMzMzM1Y3LjMzMzMzQzE0LjY2NjcgNi41OTY5NSAxNC4wNjk3IDYgMTMuMzMzMyA2WiIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTMuMzMzMjUgOS45OTk5MkgyLjY2NjU5QzIuMzEyOTYgOS45OTk5MiAxLjk3MzgyIDkuODU5NDQgMS43MjM3OCA5LjYwOTM5QzEuNDczNzMgOS4zNTkzNSAxLjMzMzI1IDkuMDIwMjEgMS4zMzMyNSA4LjY2NjU5VjIuNjY2NTlDMS4zMzMyNSAyLjMxMjk2IDEuNDczNzMgMS45NzM4MiAxLjcyMzc4IDEuNzIzNzhDMS45NzM4MiAxLjQ3MzczIDIuMzEyOTYgMS4zMzMyNSAyLjY2NjU5IDEuMzMzMjVIOC42NjY1OUM5LjAyMDIxIDEuMzMzMjUgOS4zNTkzNSAxLjQ3MzczIDkuNjA5MzkgMS43MjM3OEM5Ljg1OTQ0IDEuOTczODIgOS45OTk5MiAyLjMxMjk2IDkuOTk5OTIgMi42NjY1OVYzLjMzMzI1IiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var DashWhiteSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNCIgaGVpZ2h0PSIyIiB2aWV3Qm94PSIwIDAgNCAyIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMCAxSDQiIHN0cm9rZT0id2hpdGUiLz4KPC9zdmc+';var DeleteSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgNEgyLjMzMzMzSDEzIiBzdHJva2U9IiNFMjI0MjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNC4zMzMyNSAzLjk5OTkyVjIuNjY2NTlDNC4zMzMyNSAyLjMxMjk2IDQuNDczNzMgMS45NzM4MiA0LjcyMzc4IDEuNzIzNzhDNC45NzM4MyAxLjQ3MzczIDUuMzEyOTYgMS4zMzMyNSA1LjY2NjU5IDEuMzMzMjVIOC4zMzMyNUM4LjY4Njg3IDEuMzMzMjUgOS4wMjYwMSAxLjQ3MzczIDkuMjc2MDYgMS43MjM3OEM5LjUyNjExIDEuOTczODIgOS42NjY1OSAyLjMxMjk2IDkuNjY2NTkgMi42NjY1OVYzLjk5OTkyTTExLjY2NjYgMy45OTk5MlYxMy4zMzMzQzExLjY2NjYgMTMuNjg2OSAxMS41MjYxIDE0LjAyNiAxMS4yNzYxIDE0LjI3NjFDMTEuMDI2IDE0LjUyNjEgMTAuNjg2OSAxNC42NjY2IDEwLjMzMzMgMTQuNjY2NkgzLjY2NjU5QzMuMzEyOTYgMTQuNjY2NiAyLjk3MzgyIDE0LjUyNjEgMi43MjM3OCAxNC4yNzYxQzIuNDczNzMgMTQuMDI2IDIuMzMzMjUgMTMuNjg2OSAyLjMzMzI1IDEzLjMzMzNWMy45OTk5MkgxMS42NjY2WiIgc3Ryb2tlPSIjRTIyNDI0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTUuNjY2NzUgNy4zMzMyNVYxMS4zMzMzIiBzdHJva2U9IiNFMjI0MjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOC4zMzMyNSA3LjMzMzI1VjExLjMzMzMiIHN0cm9rZT0iI0UyMjQyNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==';var DeleteInactiveSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgNC4wODY5MUgyLjMzMzMzSDEzIiBzdHJva2U9IiNCN0I3QjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNC4zMzMyNSA0LjA4NjU5VjIuNzUzMjZDNC4zMzMyNSAyLjM5OTYzIDQuNDczNzMgMi4wNjA0OSA0LjcyMzc4IDEuODEwNDVDNC45NzM4MyAxLjU2MDQgNS4zMTI5NiAxLjQxOTkyIDUuNjY2NTkgMS40MTk5Mkg4LjMzMzI1QzguNjg2ODcgMS40MTk5MiA5LjAyNjAxIDEuNTYwNCA5LjI3NjA2IDEuODEwNDVDOS41MjYxMSAyLjA2MDQ5IDkuNjY2NTkgMi4zOTk2MyA5LjY2NjU5IDIuNzUzMjZWNC4wODY1OU0xMS42NjY2IDQuMDg2NTlWMTMuNDE5OUMxMS42NjY2IDEzLjc3MzUgMTEuNTI2MSAxNC4xMTI3IDExLjI3NjEgMTQuMzYyN0MxMS4wMjYgMTQuNjEyOCAxMC42ODY5IDE0Ljc1MzMgMTAuMzMzMyAxNC43NTMzSDMuNjY2NTlDMy4zMTI5NiAxNC43NTMzIDIuOTczODIgMTQuNjEyOCAyLjcyMzc4IDE0LjM2MjdDMi40NzM3MyAxNC4xMTI3IDIuMzMzMjUgMTMuNzczNSAyLjMzMzI1IDEzLjQxOTlWNC4wODY1OUgxMS42NjY2WiIgc3Ryb2tlPSIjQjdCN0I3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTUuNjY2NzUgNy40MTk5MlYxMS40MTk5IiBzdHJva2U9IiNCN0I3QjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOC4zMzMyNSA3LjQxOTkyVjExLjQxOTkiIHN0cm9rZT0iI0I3QjdCNyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==';var DenySvg='data:image/svg+xml;base64,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';var DoneSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMyAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgNUw0LjY2NjY3IDlMMTIgMSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+';var DoneClickedSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiByeD0iNSIgZmlsbD0iI0ZGNjY0NSIvPgo8cGF0aCBkPSJNNyAxMkwxMC42NjY3IDE2TDE4IDgiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==';var DoneDisabledSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMyAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgNUw0LjY2NjY3IDlMMTIgMSIgc3Ryb2tlPSIjQjJCNEM1IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var DoneHoverSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMyAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgNUw0LjY2NjY3IDlMMTIgMSIgc3Ryb2tlPSIjRkY2NjQ1IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var DownloadSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuMzMzNSAxMS4zMzMzTDguMDAwMTYgMTMuOTk5OUwxMC42NjY4IDExLjMzMzMiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik04IDhWMTQiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMy45MiAxMi4wNkMxNC40OTk2IDExLjY1MjQgMTQuOTM0MiAxMS4wNzA3IDE1LjE2MDggMTAuMzk5NEMxNS4zODc0IDkuNzI4MDUgMTUuMzk0MiA5LjAwMTk3IDE1LjE4MDIgOC4zMjY1MUMxNC45NjYyIDcuNjUxMDQgMTQuNTQyNSA3LjA2MTM1IDEzLjk3MDcgNi42NDNDMTMuMzk4OCA2LjIyNDY0IDEyLjcwODUgNS45OTk0IDEyIDUuOTk5OTZIMTEuMTZDMTAuOTU5NCA1LjIxODU0IDEwLjU4NDMgNC40OTI3OSAxMC4wNjI3IDMuODc3MzRDOS41NDExMiAzLjI2MTkgOC44ODY3MiAyLjc3MjggOC4xNDg3NiAyLjQ0Njg2QzcuNDEwOCAyLjEyMDkyIDYuNjA4NTIgMS45NjY2NCA1LjgwMjMxIDEuOTk1NjNDNC45OTYwOSAyLjAyNDYzIDQuMjA2OTYgMi4yMzYxNCAzLjQ5NDMyIDIuNjE0MjRDMi43ODE2OCAyLjk5MjM0IDIuMTY0MTEgMy41MjcxOSAxLjY4ODA4IDQuMTc4NTFDMS4yMTIwNiA0LjgyOTgzIDAuODg5OTkgNS41ODA2NSAwLjc0NjEyOSA2LjM3NDQ2QzAuNjAyMjY5IDcuMTY4MjYgMC42NDAzNjIgNy45ODQzNSAwLjg1NzU0MiA4Ljc2MTNDMS4wNzQ3MiA5LjUzODI1IDEuNDY1MzMgMTAuMjU1OCAxLjk5OTk2IDEwLjg2IiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var DownloadWhiteSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuMzMzNSAxMS4zMzMzTDguMDAwMTYgMTMuOTk5OUwxMC42NjY4IDExLjMzMzMiIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik04IDhWMTQiIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMy45MiAxMi4wNkMxNC40OTk2IDExLjY1MjQgMTQuOTM0MiAxMS4wNzA3IDE1LjE2MDggMTAuMzk5NEMxNS4zODc0IDkuNzI4MDUgMTUuMzk0MiA5LjAwMTk3IDE1LjE4MDIgOC4zMjY1MUMxNC45NjYyIDcuNjUxMDQgMTQuNTQyNSA3LjA2MTM1IDEzLjk3MDcgNi42NDNDMTMuMzk4OCA2LjIyNDY0IDEyLjcwODUgNS45OTk0IDEyIDUuOTk5OTZIMTEuMTZDMTAuOTU5NCA1LjIxODU0IDEwLjU4NDMgNC40OTI3OSAxMC4wNjI3IDMuODc3MzRDOS41NDExMiAzLjI2MTkgOC44ODY3MiAyLjc3MjggOC4xNDg3NiAyLjQ0Njg2QzcuNDEwOCAyLjEyMDkyIDYuNjA4NTIgMS45NjY2NCA1LjgwMjMxIDEuOTk1NjNDNC45OTYwOSAyLjAyNDYzIDQuMjA2OTYgMi4yMzYxNCAzLjQ5NDMyIDIuNjE0MjRDMi43ODE2OCAyLjk5MjM0IDIuMTY0MTEgMy41MjcxOSAxLjY4ODA4IDQuMTc4NTFDMS4yMTIwNiA0LjgyOTgzIDAuODg5OTkgNS41ODA2NSAwLjc0NjEyOSA2LjM3NDQ2QzAuNjAyMjY5IDcuMTY4MjYgMC42NDAzNjIgNy45ODQzNSAwLjg1NzU0MiA4Ljc2MTNDMS4wNzQ3MiA5LjUzODI1IDEuNDY1MzMgMTAuMjU1OCAxLjk5OTk2IDEwLjg2IiBzdHJva2U9IiNGRkYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var DropdownSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iMzkiIHZpZXdCb3g9IjAgMCA0MCAzOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfZCkiPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDApIj4KPHJlY3QgeD0iNi45MjI4NSIgeT0iNS4yODQxOCIgd2lkdGg9IjI2LjMzNTEiIGhlaWdodD0iMjYuMDM5OCIgcng9IjcuMTgyMjkiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xMi45MDgyIDE1LjkzNjVMMjAuMDkwNSAyMy4wMzgzTDI3LjI3MjggMTUuOTM2NSIgc3Ryb2tlPSIjMDAwODUwIiBzdHJva2Utd2lkdGg9IjEuNzk1NTciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+CjwvZz4KPGRlZnM+CjxmaWx0ZXIgaWQ9ImZpbHRlcjBfZCIgeD0iLTAuMjc0NDE0IiB5PSItMS40OTEyMSIgd2lkdGg9IjQwLjcyOTIiIGhlaWdodD0iNDAuNDA3MSIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPgo8ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlQWxwaGEiIHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAxMjcgMCIvPgo8ZmVPZmZzZXQgZHk9IjEiLz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iMyIvPgo8ZmVDb2xvck1hdHJpeCB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMC4xIDAiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbjI9IkJhY2tncm91bmRJbWFnZUZpeCIgcmVzdWx0PSJlZmZlY3QxX2Ryb3BTaGFkb3ciLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJlZmZlY3QxX2Ryb3BTaGFkb3ciIHJlc3VsdD0ic2hhcGUiLz4KPC9maWx0ZXI+CjxjbGlwUGF0aCBpZD0iY2xpcDAiPgo8cmVjdCB4PSI1LjcyNTU5IiB5PSIzLjUwODc5IiB3aWR0aD0iMjguNzI5MiIgaGVpZ2h0PSIyOC40MDcxIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPg==';var Dropdown_menu_icon_downSvg='data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTRweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMTQgMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDY0ICg5MzUzNykgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+ZHJvcGRvd25fbWVudV9pY29uX2Rvd248L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iQXJ0Ym9hcmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01MTguMDAwMDAwLCAtNzA2LjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0iZHJvcGRvd25fbWVudV9pY29uX2Rvd24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUxOC4wMDAwMDAsIDcwNi4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUiIGZpbGw9IiNGRkZGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgeD0iMCIgeT0iMCIgd2lkdGg9IjE0IiBoZWlnaHQ9IjE0IiByeD0iMyI+PC9yZWN0PgogICAgICAgICAgICAgICAgPHBvbHlsaW5lIGlkPSJQYXRoIiBzdHJva2U9IiMwMDA4NTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgcG9pbnRzPSI0IDYgNyA5IDEwIDYiPjwvcG9seWxpbmU+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==';var Dropdown_menu_icon_upSvg='data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTRweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMTQgMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDY0ICg5MzUzNykgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+ZHJvcGRvd25fbWVudV9pY29uX3VwPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkFydGJvYXJkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzY2LjAwMDAwMCwgLTY1NS4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9ImRyb3Bkb3duX21lbnVfaWNvbl91cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzY2LjAwMDAwMCwgNjU1LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZSIgZmlsbD0iI0ZGRkZGRiIgZmlsbC1ydWxlPSJub256ZXJvIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3LjAwMDAwMCwgNy4wMDAwMDApIHJvdGF0ZSgtMTgwLjAwMDAwMCkgdHJhbnNsYXRlKC03LjAwMDAwMCwgLTcuMDAwMDAwKSAiIHg9IjMuNTUyNzEzNjhlLTE1IiB5PSItMy41NTI3MTM2OGUtMTUiIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgcng9IjMiPjwvcmVjdD4KICAgICAgICAgICAgICAgIDxwb2x5bGluZSBpZD0iUGF0aCIgc3Ryb2tlPSIjMDAwODUwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHBvaW50cz0iMTAgOCA3IDUgNCA4Ij48L3BvbHlsaW5lPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=';var DuplicateSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuMzMzMjUgOS45OTk2N0gyLjY2NjU5QzIuMzEyOTYgOS45OTk2NyAxLjk3MzgyIDkuODU5MiAxLjcyMzc4IDkuNjA5MTVDMS40NzM3MyA5LjM1OTEgMS4zMzMyNSA5LjAxOTk2IDEuMzMzMjUgOC42NjYzNFYyLjY2NjM0QzEuMzMzMjUgMi4zMTI3MiAxLjQ3MzczIDEuOTczNTggMS43MjM3OCAxLjcyMzUzQzEuOTczODIgMS40NzM0OCAyLjMxMjk2IDEuMzMzMDEgMi42NjY1OSAxLjMzMzAxSDguNjY2NTlDOS4wMjAyMSAxLjMzMzAxIDkuMzU5MzUgMS40NzM0OCA5LjYwOTM5IDEuNzIzNTNDOS44NTk0NCAxLjk3MzU4IDkuOTk5OTIgMi4zMTI3MiA5Ljk5OTkyIDIuNjY2MzRWMy4zMzMwMSIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEzLjMzMzMgNkg3LjMzMzMzQzYuNTk2OTUgNiA2IDYuNTk2OTUgNiA3LjMzMzMzVjEzLjMzMzNDNiAxNC4wNjk3IDYuNTk2OTUgMTQuNjY2NyA3LjMzMzMzIDE0LjY2NjdIMTMuMzMzM0MxNC4wNjk3IDE0LjY2NjcgMTQuNjY2NyAxNC4wNjk3IDE0LjY2NjcgMTMuMzMzM1Y3LjMzMzMzQzE0LjY2NjcgNi41OTY5NSAxNC4wNjk3IDYgMTMuMzMzMyA2WiIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPGxpbmUgeDE9IjguNSIgeTE9IjEwLjUiIHgyPSIxMi41IiB5Mj0iMTAuNSIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPGxpbmUgeDE9IjEwLjUiIHkxPSIxMi41IiB4Mj0iMTAuNSIgeTI9IjguNSIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+';var DuplicateInactiveSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuMzMzMjUgMTAuNDE5NkgyLjY2NjU5QzIuMzEyOTYgMTAuNDE5NiAxLjk3MzgyIDEwLjI3OTEgMS43MjM3OCAxMC4wMjkxQzEuNDczNzMgOS43NzkwMiAxLjMzMzI1IDkuNDM5ODkgMS4zMzMyNSA5LjA4NjI2VjMuMDg2MjZDMS4zMzMyNSAyLjczMjY0IDEuNDczNzMgMi4zOTM1IDEuNzIzNzggMi4xNDM0NUMxLjk3MzgyIDEuODkzNDEgMi4zMTI5NiAxLjc1MjkzIDIuNjY2NTkgMS43NTI5M0g4LjY2NjU5QzkuMDIwMjEgMS43NTI5MyA5LjM1OTM1IDEuODkzNDEgOS42MDkzOSAyLjE0MzQ1QzkuODU5NDQgMi4zOTM1IDkuOTk5OTIgMi43MzI2NCA5Ljk5OTkyIDMuMDg2MjZWMy43NTI5MyIgc3Ryb2tlPSIjQjdCN0I3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEzLjMzMzMgNi40MTk5Mkg3LjMzMzMzQzYuNTk2OTUgNi40MTk5MiA2IDcuMDE2ODggNiA3Ljc1MzI2VjEzLjc1MzNDNiAxNC40ODk2IDYuNTk2OTUgMTUuMDg2NiA3LjMzMzMzIDE1LjA4NjZIMTMuMzMzM0MxNC4wNjk3IDE1LjA4NjYgMTQuNjY2NyAxNC40ODk2IDE0LjY2NjcgMTMuNzUzM1Y3Ljc1MzI2QzE0LjY2NjcgNy4wMTY4OCAxNC4wNjk3IDYuNDE5OTIgMTMuMzMzMyA2LjQxOTkyWiIgc3Ryb2tlPSIjQjdCN0I3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPGxpbmUgeDE9IjguNSIgeTE9IjEwLjkxOTkiIHgyPSIxMi41IiB5Mj0iMTAuOTE5OSIgc3Ryb2tlPSIjQjdCN0I3IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPGxpbmUgeDE9IjEwLjUiIHkxPSIxMi45MTk5IiB4Mj0iMTAuNSIgeTI9IjguOTE5OTIiIHN0cm9rZT0iI0I3QjdCNyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPg==';var EditSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMzMzMjUgMi42NjY3NUgyLjY2NjU5QzIuMzEyOTYgMi42NjY3NSAxLjk3MzgyIDIuODA3MjIgMS43MjM3OCAzLjA1NzI3QzEuNDczNzMgMy4zMDczMiAxLjMzMzI1IDMuNjQ2NDYgMS4zMzMyNSA0LjAwMDA4VjEzLjMzMzRDMS4zMzMyNSAxMy42ODcgMS40NzM3MyAxNC4wMjYyIDEuNzIzNzggMTQuMjc2MkMxLjk3MzgyIDE0LjUyNjMgMi4zMTI5NiAxNC42NjY3IDIuNjY2NTkgMTQuNjY2N0gxMS45OTk5QzEyLjM1MzUgMTQuNjY2NyAxMi42OTI3IDE0LjUyNjMgMTIuOTQyNyAxNC4yNzYyQzEzLjE5MjggMTQuMDI2MiAxMy4zMzMzIDEzLjY4NyAxMy4zMzMzIDEzLjMzMzRWOC42NjY3NSIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEyLjMzMzMgMS42NjY2NUMxMi41OTg1IDEuNDAxNDQgMTIuOTU4MiAxLjI1MjQ0IDEzLjMzMzMgMS4yNTI0NEMxMy43MDgzIDEuMjUyNDQgMTQuMDY4IDEuNDAxNDQgMTQuMzMzMyAxLjY2NjY1QzE0LjU5ODUgMS45MzE4NyAxNC43NDc1IDIuMjkxNTggMTQuNzQ3NSAyLjY2NjY1QzE0Ljc0NzUgMy4wNDE3MyAxNC41OTg1IDMuNDAxNDQgMTQuMzMzMyAzLjY2NjY1TDcuOTk5OTIgOS45OTk5OUw1LjMzMzI1IDEwLjY2NjdMNS45OTk5MiA3Ljk5OTk5TDEyLjMzMzMgMS42NjY2NVoiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==';var EditClickedSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMzMzMjUgMi42NjY3NUgyLjY2NjU5QzIuMzEyOTYgMi42NjY3NSAxLjk3MzgyIDIuODA3MjIgMS43MjM3OCAzLjA1NzI3QzEuNDczNzMgMy4zMDczMiAxLjMzMzI1IDMuNjQ2NDYgMS4zMzMyNSA0LjAwMDA4VjEzLjMzMzRDMS4zMzMyNSAxMy42ODcgMS40NzM3MyAxNC4wMjYyIDEuNzIzNzggMTQuMjc2MkMxLjk3MzgyIDE0LjUyNjMgMi4zMTI5NiAxNC42NjY3IDIuNjY2NTkgMTQuNjY2N0gxMS45OTk5QzEyLjM1MzUgMTQuNjY2NyAxMi42OTI3IDE0LjUyNjMgMTIuOTQyNyAxNC4yNzYyQzEzLjE5MjggMTQuMDI2MiAxMy4zMzMzIDEzLjY4NyAxMy4zMzMzIDEzLjMzMzRWOC42NjY3NSIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEyLjMzMzMgMS42NjY2NUMxMi41OTg1IDEuNDAxNDQgMTIuOTU4MiAxLjI1MjQ0IDEzLjMzMzMgMS4yNTI0NEMxMy43MDgzIDEuMjUyNDQgMTQuMDY4IDEuNDAxNDQgMTQuMzMzMyAxLjY2NjY1QzE0LjU5ODUgMS45MzE4NyAxNC43NDc1IDIuMjkxNTggMTQuNzQ3NSAyLjY2NjY1QzE0Ljc0NzUgMy4wNDE3MyAxNC41OTg1IDMuNDAxNDQgMTQuMzMzMyAzLjY2NjY1TDcuOTk5OTIgOS45OTk5OUw1LjMzMzI1IDEwLjY2NjdMNS45OTk5MiA3Ljk5OTk5TDEyLjMzMzMgMS42NjY2NVoiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==';var EditHoverSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMzMzMjUgMi42NjY3NUgyLjY2NjU5QzIuMzEyOTYgMi42NjY3NSAxLjk3MzgyIDIuODA3MjIgMS43MjM3OCAzLjA1NzI3QzEuNDczNzMgMy4zMDczMiAxLjMzMzI1IDMuNjQ2NDYgMS4zMzMyNSA0LjAwMDA4VjEzLjMzMzRDMS4zMzMyNSAxMy42ODcgMS40NzM3MyAxNC4wMjYyIDEuNzIzNzggMTQuMjc2MkMxLjk3MzgyIDE0LjUyNjMgMi4zMTI5NiAxNC42NjY3IDIuNjY2NTkgMTQuNjY2N0gxMS45OTk5QzEyLjM1MzUgMTQuNjY2NyAxMi42OTI3IDE0LjUyNjMgMTIuOTQyNyAxNC4yNzYyQzEzLjE5MjggMTQuMDI2MiAxMy4zMzMzIDEzLjY4NyAxMy4zMzMzIDEzLjMzMzRWOC42NjY3NSIgc3Ryb2tlPSIjMDAwODUwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEyLjMzMzMgMS42NjY2NUMxMi41OTg1IDEuNDAxNDQgMTIuOTU4MiAxLjI1MjQ0IDEzLjMzMzMgMS4yNTI0NEMxMy43MDgzIDEuMjUyNDQgMTQuMDY4IDEuNDAxNDQgMTQuMzMzMyAxLjY2NjY1QzE0LjU5ODUgMS45MzE4NyAxNC43NDc1IDIuMjkxNTggMTQuNzQ3NSAyLjY2NjY1QzE0Ljc0NzUgMy4wNDE3MyAxNC41OTg1IDMuNDAxNDQgMTQuMzMzMyAzLjY2NjY1TDcuOTk5OTIgOS45OTk5OUw1LjMzMzI1IDEwLjY2NjdMNS45OTk5MiA3Ljk5OTk5TDEyLjMzMzMgMS42NjY2NVoiIHN0cm9rZT0iIzAwMDg1MCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==';var EnrollmentSvg='data:image/svg+xml;base64,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';var ExclamationMarkSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNSAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNSAwQzYuMDE2NjQgMCA0LjU2NjYgMC40Mzk4NjcgMy4zMzMyMyAxLjI2Mzk4QzIuMDk5ODYgMi4wODgwOSAxLjEzODU2IDMuMjU5NDMgMC41NzA5MDcgNC42Mjk4N0MwLjAwMzI0OTYzIDYuMDAwMzIgLTAuMTQ1Mjc1IDcuNTA4MzIgMC4xNDQxMTQgOC45NjMxOEMwLjQzMzUwMyAxMC40MTggMS4xNDc4MSAxMS43NTQ0IDIuMTk2NyAxMi44MDMzQzMuMjQ1NiAxMy44NTIyIDQuNTgxOTcgMTQuNTY2NSA2LjAzNjgzIDE0Ljg1NTlDNy40OTE2OCAxNS4xNDUzIDguOTk5NjggMTQuOTk2OCAxMC4zNzAxIDE0LjQyOTFDMTEuNzQwNiAxMy44NjE0IDEyLjkxMTkgMTIuOTAwMSAxMy43MzYgMTEuNjY2OEMxNC41NjAxIDEwLjQzMzQgMTUgOC45ODMzNiAxNSA3LjVDMTUgNi41MTUwOSAxNC44MDYgNS41Mzk4MiAxNC40MjkxIDQuNjI5ODdDMTQuMDUyMiAzLjcxOTkzIDEzLjQ5OTcgMi44OTMxNCAxMi44MDMzIDIuMTk2N0MxMi4xMDY5IDEuNTAwMjYgMTEuMjgwMSAwLjk0NzgxNCAxMC4zNzAxIDAuNTcwOTA0QzkuNDYwMTkgMC4xOTM5OTMgOC40ODQ5MiAwIDcuNSAwWk03LjUgMTEuMjVDNy4zNTE2NyAxMS4yNSA3LjIwNjY2IDExLjIwNiA3LjA4MzMyIDExLjEyMzZDNi45NTk5OSAxMS4wNDEyIDYuODYzODYgMTAuOTI0MSA2LjgwNzA5IDEwLjc4N0M2Ljc1MDMzIDEwLjY1IDYuNzM1NDggMTAuNDk5MiA2Ljc2NDQxIDEwLjM1MzdDNi43OTMzNSAxMC4yMDgyIDYuODY0NzggMTAuMDc0NiA2Ljk2OTY3IDkuOTY5NjdDNy4wNzQ1NiA5Ljg2NDc4IDcuMjA4MiA5Ljc5MzM1IDcuMzUzNjkgOS43NjQ0MUM3LjQ5OTE3IDkuNzM1NDcgNy42NDk5NyA5Ljc1MDMyIDcuNzg3MDIgOS44MDcwOUM3LjkyNDA2IDkuODYzODYgOC4wNDExOSA5Ljk1OTk4IDguMTIzNiAxMC4wODMzQzguMjA2MDIgMTAuMjA2NyA4LjI1IDEwLjM1MTcgOC4yNSAxMC41QzguMjUgMTAuNjk4OSA4LjE3MDk5IDEwLjg4OTcgOC4wMzAzMyAxMS4wMzAzQzcuODg5NjggMTEuMTcxIDcuNjk4OTIgMTEuMjUgNy41IDExLjI1Wk04LjI1IDguMjVDOC4yNSA4LjQ0ODkxIDguMTcwOTkgOC42Mzk2OCA4LjAzMDMzIDguNzgwMzNDNy44ODk2OCA4LjkyMDk4IDcuNjk4OTIgOSA3LjUgOUM3LjMwMTA5IDkgNy4xMTAzMyA4LjkyMDk4IDYuOTY5NjcgOC43ODAzM0M2LjgyOTAyIDguNjM5NjggNi43NSA4LjQ0ODkxIDYuNzUgOC4yNVY0LjVDNi43NSA0LjMwMTA5IDYuODI5MDIgNC4xMTAzMiA2Ljk2OTY3IDMuOTY5NjdDNy4xMTAzMyAzLjgyOTAyIDcuMzAxMDkgMy43NSA3LjUgMy43NUM3LjY5ODkyIDMuNzUgNy44ODk2OCAzLjgyOTAyIDguMDMwMzMgMy45Njk2N0M4LjE3MDk5IDQuMTEwMzIgOC4yNSA0LjMwMTA5IDguMjUgNC41VjguMjVaIiBmaWxsPSIjMDAwODUwIi8+Cjwvc3ZnPg==';var ExportSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxNiAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xNC44IDdWNS4xNzVMMTAuMTI1IDAuNUgyLjkwMDAxQzIuNDQ5MTQgMC41IDIuMDE2NzQgMC42NzkxMDcgMS42OTc5MyAwLjk5NzkxOEMxLjM3OTEyIDEuMzE2NzMgMS4yMDAwMSAxLjc0OTEzIDEuMjAwMDEgMi4yVjE1LjhDMS4yMDAwMSAxNi4yNTA5IDEuMzc5MTIgMTYuNjgzMyAxLjY5NzkzIDE3LjAwMjFDMi4wMTY3NCAxNy4zMjA5IDIuNDQ5MTQgMTcuNSAyLjkwMDAxIDE3LjVIMTMuMUMxMy41NTA5IDE3LjUgMTMuOTgzMyAxNy4zMjA5IDE0LjMwMjEgMTcuMDAyMUMxNC42MjA5IDE2LjY4MzMgMTQuOCAxNi4yNTA5IDE0LjggMTUuOFYxNiIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KICAgIDxwYXRoIGQ9Ik05LjcwMDAxIDAuNVY1LjZIMTQuOCIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KICAgIDxwYXRoIGQ9Ik0xNC4zNSAxMS41NUw3LjI0OTk4IDExLjU1TTE0LjM1IDExLjU1TDExLjggMTQuMU0xNC4zNSAxMS41NUwxMS44IDkiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==';var EyeBlueSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxOCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgNi44MTgxOEMxIDYuODE4MTggMy45MDkwOSAxIDkgMUMxNC4wOTA5IDEgMTcgNi44MTgxOCAxNyA2LjgxODE4QzE3IDYuODE4MTggMTQuMDkwOSAxMi42MzY0IDkgMTIuNjM2NEMzLjkwOTA5IDEyLjYzNjQgMSA2LjgxODE4IDEgNi44MTgxOFoiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik05IDkuMDAwMTFDMTAuMjA1IDkuMDAwMTEgMTEuMTgxOCA4LjAyMzI4IDExLjE4MTggNi44MTgyOUMxMS4xODE4IDUuNjEzMzEgMTAuMjA1IDQuNjM2NDcgOSA0LjYzNjQ3QzcuNzk1MDIgNC42MzY0NyA2LjgxODE4IDUuNjEzMzEgNi44MTgxOCA2LjgxODI5QzYuODE4MTggOC4wMjMyOCA3Ljc5NTAyIDkuMDAwMTEgOSA5LjAwMDExWiIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+';var EyeCrossBlueSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxOCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjMyNzkgMTEuNDkxN0MxMi4xMDM4IDEyLjQ1MzQgMTAuNTMwMSAxMi45NzggOS4wNDM3MiAxMi45NzhDMy45NzI2OCAxMi45NzggMSA3LjEyMDEgMSA3LjEyMDFDMS44NzQzMiA1LjQ1ODkgMy4xODU3OSAzLjk3MjU2IDQuNjcyMTMgMi43NDg1Mk03LjM4MjUxIDEuNTI0NDdDNy45MDcxIDEuNDM3MDQgOC40MzE2OSAxLjM0OTYxIDguOTU2MjggMS4zNDk2MUMxNC4wMjczIDEuMzQ5NjEgMTcgNy4yMDc1MyAxNyA3LjIwNzUzQzE2LjU2MjggNy45OTQ0MiAxNi4wMzgzIDguNzgxMyAxNS40MjYyIDkuNTY4MTlNMTAuNTMwMSA4Ljc4MTNDOS43NDMxNyA5LjY1NTYyIDguMzQ0MjYgOS43NDMwNSA3LjQ2OTk0IDguODY4NzNDNi41OTU2MyA3Ljk5NDQyIDYuNTA4MiA2LjY4Mjk0IDcuMjk1MDggNS44MDg2M0w3LjM4MjUxIDUuNzIxMTkiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLW1pdGVybGltaXQ9IjMuMzMzMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yLjc0ODYzIDFMMTUuMTYzOSAxMy40MTUzIiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1taXRlcmxpbWl0PSIzLjMzMzMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var EyeCrossGraySvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxOCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjMyNzkgMTEuNDkxN0MxMi4xMDM4IDEyLjQ1MzQgMTAuNTMwMSAxMi45NzggOS4wNDM3MiAxMi45NzhDMy45NzI2OCAxMi45NzggMSA3LjEyMDEgMSA3LjEyMDFDMS44NzQzMiA1LjQ1ODkgMy4xODU3OSAzLjk3MjU2IDQuNjcyMTMgMi43NDg1Mk03LjM4MjUxIDEuNTI0NDdDNy45MDcxIDEuNDM3MDQgOC40MzE2OSAxLjM0OTYxIDguOTU2MjggMS4zNDk2MUMxNC4wMjczIDEuMzQ5NjEgMTcgNy4yMDc1MyAxNyA3LjIwNzUzQzE2LjU2MjggNy45OTQ0MiAxNi4wMzgzIDguNzgxMyAxNS40MjYyIDkuNTY4MTlNMTAuNTMwMSA4Ljc4MTNDOS43NDMxNyA5LjY1NTYyIDguMzQ0MjYgOS43NDMwNSA3LjQ2OTk0IDguODY4NzNDNi41OTU2MyA3Ljk5NDQyIDYuNTA4MiA2LjY4Mjk0IDcuMjk1MDggNS44MDg2M0w3LjM4MjUxIDUuNzIxMTkiIHN0cm9rZT0iIzRGNEY0RiIgc3Ryb2tlLW1pdGVybGltaXQ9IjMuMzMzMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yLjc0ODYzIDFMMTUuMTYzOSAxMy40MTUzIiBzdHJva2U9IiM0RjRGNEYiIHN0cm9rZS1taXRlcmxpbWl0PSIzLjMzMzMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var EyeGraySvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxOCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgNi44MTgxOEMxIDYuODE4MTggMy45MDkwOSAxIDkgMUMxNC4wOTA5IDEgMTcgNi44MTgxOCAxNyA2LjgxODE4QzE3IDYuODE4MTggMTQuMDkwOSAxMi42MzY0IDkgMTIuNjM2NEMzLjkwOTA5IDEyLjYzNjQgMSA2LjgxODE4IDEgNi44MTgxOFoiIHN0cm9rZT0iIzRGNEY0RiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik04Ljk5OTk5IDkuMDAwMTFDMTAuMjA1IDkuMDAwMTEgMTEuMTgxOCA4LjAyMzI4IDExLjE4MTggNi44MTgyOUMxMS4xODE4IDUuNjEzMzEgMTAuMjA1IDQuNjM2NDcgOC45OTk5OSA0LjYzNjQ3QzcuNzk1MDEgNC42MzY0NyA2LjgxODE4IDUuNjEzMzEgNi44MTgxOCA2LjgxODI5QzYuODE4MTggOC4wMjMyOCA3Ljc5NTAxIDkuMDAwMTEgOC45OTk5OSA5LjAwMDExWiIgc3Ryb2tlPSIjNEY0RjRGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+';var FileSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNjY2NzUgMS4zMzMyNUg0LjAwMDA4QzMuNjQ2NDYgMS4zMzMyNSAzLjMwNzMyIDEuNDczNzMgMy4wNTcyNyAxLjcyMzc4QzIuODA3MjIgMS45NzM4MiAyLjY2Njc1IDIuMzEyOTYgMi42NjY3NSAyLjY2NjU5VjEzLjMzMzNDMi42NjY3NSAxMy42ODY5IDIuODA3MjIgMTQuMDI2IDMuMDU3MjcgMTQuMjc2MUMzLjMwNzMyIDE0LjUyNjEgMy42NDY0NiAxNC42NjY2IDQuMDAwMDggMTQuNjY2NkgxMi4wMDAxQzEyLjM1MzcgMTQuNjY2NiAxMi42OTI4IDE0LjUyNjEgMTIuOTQyOSAxNC4yNzYxQzEzLjE5MjkgMTQuMDI2IDEzLjMzMzQgMTMuNjg2OSAxMy4zMzM0IDEzLjMzMzNWNS45OTk5Mkw4LjY2Njc1IDEuMzMzMjVaIiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOC42NjY3NSAxLjMzMzI1VjUuOTk5OTJIMTMuMzMzNCIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+';var FilterSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CjxwYXRoIGQ9Ik0yLjAwMDA4IDIuNjY2NzVMNi42NjY3NSAyLjY2Njc1IiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOS4zMzMzMyAyLjY2Njc1TDE0IDIuNjY2NzUiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yIDhMOCA4IiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTAuNjY2NyA4TDE0IDgiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xLjk5OTkyIDEzLjMzMzNMNS4zMzMyNSAxMy4zMzMzIiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOCAxMy4zMzMzTDE0IDEzLjMzMzMiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik02LjY2Njc1IDAuNjY2NzQ4TDYuNjY2NzUgNC42NjY3NSIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEwLjY2NjcgNkwxMC42NjY3IDEwIiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNS4zMzMyNSAxMS4zMzMzTDUuMzMzMjUgMTUuMzMzMyIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMCI+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2KSByb3RhdGUoOTApIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+';var FormsSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAxOCAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzIDNIMTVDMTUuNTMwNCAzIDE2LjAzOTEgMy4yMTA3MSAxNi40MTQyIDMuNTg1NzlDMTYuNzg5MyAzLjk2MDg2IDE3IDQuNDY5NTcgMTcgNVYxOUMxNyAxOS41MzA0IDE2Ljc4OTMgMjAuMDM5MSAxNi40MTQyIDIwLjQxNDJDMTYuMDM5MSAyMC43ODkzIDE1LjUzMDQgMjEgMTUgMjFIM0MyLjQ2OTU3IDIxIDEuOTYwODYgMjAuNzg5MyAxLjU4NTc5IDIwLjQxNDJDMS4yMTA3MSAyMC4wMzkxIDEgMTkuNTMwNCAxIDE5VjVDMSA0LjQ2OTU3IDEuMjEwNzEgMy45NjA4NiAxLjU4NTc5IDMuNTg1NzlDMS45NjA4NiAzLjIxMDcxIDIuNDY5NTcgMyAzIDNINSIgc3Ryb2tlPSIjMDAwODUwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEyIDFINkM1LjQ0NzcyIDEgNSAxLjQ0NzcyIDUgMlY0QzUgNC41NTIyOCA1LjQ0NzcyIDUgNiA1SDEyQzEyLjU1MjMgNSAxMyA0LjU1MjI4IDEzIDRWMkMxMyAxLjQ0NzcyIDEyLjU1MjMgMSAxMiAxWiIgc3Ryb2tlPSIjMDAwODUwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPGxpbmUgeDE9IjQuNSIgeTE9IjguNSIgeDI9IjEzLjUiIHkyPSI4LjUiIHN0cm9rZT0iIzAwMDg1MCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxsaW5lIHgxPSI0LjUiIHkxPSIxMS41IiB4Mj0iMTMuNSIgeTI9IjExLjUiIHN0cm9rZT0iIzAwMDg1MCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxsaW5lIHgxPSI0LjUiIHkxPSIxNC41IiB4Mj0iMTMuNSIgeTI9IjE0LjUiIHN0cm9rZT0iIzAwMDg1MCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxsaW5lIHgxPSI0LjUiIHkxPSIxNy41IiB4Mj0iMTMuNSIgeTI9IjE3LjUiIHN0cm9rZT0iIzAwMDg1MCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPg==';var GroupsFilledSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxNiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjYgNS43MTEwM0MxMS44NjI2IDUuNzExMDMgMTIuMTIyNyA1LjY2MDIyIDEyLjM2NTQgNS41NjE1MUMxMi42MDggNS40NjI3OSAxMi44Mjg1IDUuMzE4MSAxMy4wMTQyIDUuMTM1N0MxMy4xOTk5IDQuOTUzMyAxMy4zNDcyIDQuNzM2NzYgMTMuNDQ3OCA0LjQ5ODQ0QzEzLjU0ODMgNC4yNjAxMyAxMy42IDQuMDA0NyAxMy42IDMuNzQ2NzRDMTMuNiAzLjIyNTc4IDEzLjM4OTMgMi43MjYxNiAxMy4wMTQyIDIuMzU3NzhDMTIuNjM5MSAxLjk4OTQxIDEyLjEzMDQgMS43ODI0NiAxMS42IDEuNzgyNDZDMTEuMDY5NiAxLjc4MjQ2IDEwLjU2MDkgMS45ODk0MSAxMC4xODU4IDIuMzU3NzhDOS44MTA3MSAyLjcyNjE2IDkuNiAzLjIyNTc4IDkuNiAzLjc0Njc0QzkuNiA0LjAwNDcgOS42NTE3MyA0LjI2MDEzIDkuNzUyMjQgNC40OTg0NEM5Ljg1Mjc1IDQuNzM2NzYgMTAuMDAwMSA0Ljk1MzMgMTAuMTg1OCA1LjEzNTdDMTAuNTYwOSA1LjUwNDA4IDExLjA2OTYgNS43MTEwMyAxMS42IDUuNzExMDNaTTUuNiA0LjkyNTMxQzYuMjM2NTIgNC45MjUzMSA2Ljg0Njk3IDQuNjc2OTcgNy4yOTcwNiA0LjIzNDkyQzcuNzQ3MTQgMy43OTI4NyA4IDMuMTkzMzMgOCAyLjU2ODE3QzggMS45NDMwMiA3Ljc0NzE0IDEuMzQzNDcgNy4yOTcwNiAwLjkwMTQyQzYuODQ2OTcgMC40NTkzNyA2LjIzNjUyIDAuMjExMDI5IDUuNiAwLjIxMTAyOUM0Ljk2MzQ4IDAuMjExMDI5IDQuMzUzMDMgMC40NTkzNyAzLjkwMjk0IDAuOTAxNDJDMy40NTI4NiAxLjM0MzQ3IDMuMiAxLjk0MzAyIDMuMiAyLjU2ODE3QzMuMiAzLjE5MzMzIDMuNDUyODYgMy43OTI4NyAzLjkwMjk0IDQuMjM0OTJDNC4zNTMwMyA0LjY3Njk3IDQuOTYzNDggNC45MjUzMSA1LjYgNC45MjUzMVpNMTEuNiA3LjI4MjQ2QzEwLjEzNiA3LjI4MjQ2IDcuMiA4LjAwNTMxIDcuMiA5LjQ0MzE3VjExLjIxMUgxNlY5LjQ0MzE3QzE2IDguMDA1MzEgMTMuMDY0IDcuMjgyNDYgMTEuNiA3LjI4MjQ2Wk01LjYgNi40OTY3NEMzLjczNiA2LjQ5Njc0IDAgNy40MTYwMyAwIDkuMjQ2NzRWMTEuMjExSDUuNlY5LjQ0MzE3QzUuNiA4Ljc3NTMxIDUuODY0IDcuNjA0NiA3LjQ5NiA2LjcxNjc0QzYuOCA2LjU3NTMxIDYuMTI4IDYuNDk2NzQgNS42IDYuNDk2NzRaIiBmaWxsPSIjMzAzOThBIi8+Cjwvc3ZnPg==';var GroupsOutlinedSvg='data:image/svg+xml;base64,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';var HamburgerMenuIconSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxOCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjE4IiBoZWlnaHQ9IjIuMzQ3ODMiIHJ4PSIxLjE3MzkxIiBmaWxsPSJ3aGl0ZSIvPgo8cmVjdCB5PSI1LjQ3ODAzIiB3aWR0aD0iMTgiIGhlaWdodD0iMi4zNDc4MyIgcng9IjEuMTczOTEiIGZpbGw9IndoaXRlIi8+CjxyZWN0IHk9IjEwLjk1NjUiIHdpZHRoPSIxOCIgaGVpZ2h0PSIyLjM0NzgzIiByeD0iMS4xNzM5MSIgZmlsbD0id2hpdGUiLz4KPC9zdmc+';var HouseSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAyMSAyMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgOC4zNUwxMC41IDFMMjAgOC4zNVYxOS45QzIwIDIwLjQ1NyAxOS43Nzc2IDIwLjk5MTEgMTkuMzgxNyAyMS4zODQ5QzE4Ljk4NTggMjEuNzc4NyAxOC40NDg4IDIyIDE3Ljg4ODkgMjJIMy4xMTExMUMyLjU1MTIxIDIyIDIuMDE0MjQgMjEuNzc4NyAxLjYxODMzIDIxLjM4NDlDMS4yMjI0MiAyMC45OTExIDEgMjAuNDU3IDEgMTkuOVY4LjM1WiIgc3Ryb2tlPSIjMDAwODUwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTggMjJWMTJIMTNWMjIiIHN0cm9rZT0iIzAwMDg1MCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==';var HttpSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjUgMjRDMTguODUxMyAyNCAyNCAxOC44NTEzIDI0IDEyLjVDMjQgNi4xNDg3MyAxOC44NTEzIDEgMTIuNSAxQzYuMTQ4NzMgMSAxIDYuMTQ4NzMgMSAxMi41QzEgMTguODUxMyA2LjE0ODczIDI0IDEyLjUgMjRaIiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xIDEyLjVIMjQiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEyLjQ5OTkgMUMxNS4zNzY0IDQuMTQ5MTEgMTcuMDExMSA4LjIzNTg0IDE3LjA5OTkgMTIuNUMxNy4wMTExIDE2Ljc2NDIgMTUuMzc2NCAyMC44NTA5IDEyLjQ5OTkgMjRDOS42MjM0MyAyMC44NTA5IDcuOTg4NzQgMTYuNzY0MiA3Ljg5OTkgMTIuNUM3Ljk4ODc0IDguMjM1ODQgOS42MjM0MyA0LjE0OTExIDEyLjQ5OTkgMVYxWiIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var HttpsSvg='data:image/svg+xml;base64,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';var ImportSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgOVYxMy44QzEgMTQuMTE4MyAxLjE4NDM3IDE0LjQyMzUgMS41MTI1NiAxNC42NDg1QzEuODQwNzUgMTQuODczNiAyLjI4NTg3IDE1IDIuNzUgMTVIMTMuMjVDMTMuNzE0MSAxNSAxNC4xNTkyIDE0Ljg3MzYgMTQuNDg3NCAxNC42NDg1QzE0LjgxNTYgMTQuNDIzNSAxNSAxNC4xMTgzIDE1IDEzLjhWOSIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTUgN0w4IDEwTDExIDciIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik04IDEwTDggMiIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+';var ImportGroupSvg='data:image/svg+xml;base64,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';var InfoSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgMTdDMTMuNDE4MyAxNyAxNyAxMy40MTgzIDE3IDlDMTcgNC41ODE3MiAxMy40MTgzIDEgOSAxQzQuNTgxNzIgMSAxIDQuNTgxNzIgMSA5QzEgMTMuNDE4MyA0LjU4MTcyIDE3IDkgMTdaIiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOSAxM1Y4IiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8Y2lyY2xlIGN4PSI5IiBjeT0iNSIgcj0iMSIgZmlsbD0iIzEyM0JFNSIvPgo8L3N2Zz4=';var InfoClickedSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgMTdDMTMuNDE4MyAxNyAxNyAxMy40MTgzIDE3IDlDMTcgNC41ODE3MiAxMy40MTgzIDEgOSAxQzQuNTgxNzIgMSAxIDQuNTgxNzIgMSA5QzEgMTMuNDE4MyA0LjU4MTcyIDE3IDkgMTdaIiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOSAxM1Y4IiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8Y2lyY2xlIGN4PSI5IiBjeT0iNSIgcj0iMSIgZmlsbD0iIzEyM0JFNSIvPgo8L3N2Zz4=';var InfoHoverSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgMTdDMTMuNDE4MyAxNyAxNyAxMy40MTgzIDE3IDlDMTcgNC41ODE3MiAxMy40MTgzIDEgOSAxQzQuNTgxNzIgMSAxIDQuNTgxNzIgMSA5QzEgMTMuNDE4MyA0LjU4MTcyIDE3IDkgMTdaIiBzdHJva2U9IiMwMDA4NTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOSAxM1Y4IiBzdHJva2U9IiMwMDA4NTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8Y2lyY2xlIGN4PSI5IiBjeT0iNSIgcj0iMSIgZmlsbD0iIzAwMDg1MCIvPgo8L3N2Zz4=';var LabelAdminSvg='data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iN3B4IiBoZWlnaHQ9IjhweCIgdmlld0JveD0iMCAwIDcgOCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNjQgKDkzNTM3KSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDx0aXRsZT5WZWN0b3IgKDEpPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkFydGJvYXJkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOC4wMDAwMDAsIC0yMy4wMDAwMDApIiBmaWxsPSIjMkM0RDdFIiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICAgICAgICAgICA8ZyBpZD0iVmVjdG9yLSgxKSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOC4wMDAwMDAsIDIzLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTMuNSwzLjMzMzMzIEMzLjcwODkyLDMuMzMzMzMgMy45MTU4LDMuMjkwMjIgNC4xMDg4MSwzLjIwNjQ3IEM0LjMwMTgzLDMuMTIyNzEgNC40NzcyMSwyLjk5OTk0IDQuNjI0OTQsMi44NDUxOCBDNC43NzI2NywyLjY5MDQxIDQuODg5ODYsMi41MDY2OCA0Ljk2OTgxLDIuMzA0NDcgQzUuMDQ5NzYsMi4xMDIyNiA1LjA5MDkxLDEuODg1NTQgNS4wOTA5MSwxLjY2NjY3IEM1LjA5MDkxLDEuMjI0NjQgNC45MjMzLDAuODAwNzE2IDQuNjI0OTQsMC40ODgxNTUgQzQuMzI2NTksMC4xNzU1OTUgMy45MjE5NCwwIDMuNSwwIEMzLjA3ODA2LDAgMi42NzM0MSwwLjE3NTU5NSAyLjM3NTA2LDAuNDg4MTU1IEMyLjA3NjcsMC44MDA3MTYgMS45MDkwOSwxLjIyNDY0IDEuOTA5MDksMS42NjY2NyBDMS45MDkwOSwxLjg4NTU0IDEuOTUwMjQsMi4xMDIyNiAyLjAzMDE5LDIuMzA0NDcgQzIuMTEwMTQsMi41MDY2OCAyLjIyNzMzLDIuNjkwNDEgMi4zNzUwNiwyLjg0NTE4IEMyLjY3MzQxLDMuMTU3NzQgMy4wNzgwNiwzLjMzMzMzIDMuNSwzLjMzMzMzIFogTTMuNSw0LjY2NjY3IEMyLjMzNTQ1LDQuNjY2NjcgMCw1LjI4IDAsNi41IEwwLDggTDcsOCBMNyw2LjUgQzcsNS4yOCA0LjY2NDU1LDQuNjY2NjcgMy41LDQuNjY2NjcgWiIgaWQ9IlNoYXBlIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==';var LabelAuditorSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEwIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMCAzLjQ0OTkyQzkuNjQxNTggMi41NDExMSA5LjA0Mzc2IDEuNzQ2MzIgOC4yNzAwMSAxLjE0OTkyQzcuNTkyNSAwLjU5NjY5OSA2Ljc4NDEgMC4yMjcwMjQgNS45MjI0OSAwLjA3NjQxNjRDNS4wNjA4NyAtMC4wNzQxOTExIDQuMTc1IC0wLjAwMDY2ODQ2NiAzLjM1IDAuMjg5OTE5QzIuNTkwNTUgMC41MzIwMjIgMS44OTUyMSAwLjk0MTY5IDEuMzE1MzYgMS40ODg2NUMwLjczNTUxMyAyLjAzNTYxIDAuMjg1OTg4IDIuNzA1ODggNC44NTEyNmUtMDYgMy40NDk5MkMtMC4wMTQ3MzE0IDMuNDk4ODMgLTAuMDE0NzMxNCAzLjU1MSA0Ljg1MDMzZS0wNiAzLjU5OTkyQzAuMTQyNTIzIDMuOTQ2NTcgMC4zMTMwODkgNC4yODEwMSAwLjUxMDAwNSA0LjU5OTkyQzAuOTcxMjQ3IDUuMzI4NDggMS42MDQ4NCA1LjkzMjIxIDIuMzU0OCA2LjM1Nzc3QzMuMTA0NzcgNi43ODMzMyAzLjk0OCA3LjAxNzYyIDQuODEgNy4wMzk5MkM1LjM1MDIyIDcuMDUxMjEgNS44ODkxOSA2Ljk4Mzg0IDYuNDEgNi44Mzk5MkM3LjIyMDQ0IDYuNjEyNjEgNy45NjY4IDYuMTk5NjYgOC41ODk5MyA1LjYzMzgxQzkuMjEzMDYgNS4wNjc5NiA5LjY5NTg0IDQuMzY0NzUgMTAgMy41Nzk5MkMxMC4wMTUzIDMuNTM3OTMgMTAuMDE1MyAzLjQ5MTkgMTAgMy40NDk5MlpNNS42MyA1LjI3OTkyQzUuMzkyOTIgNS4zNjc1NyA1LjE0MDAzIDUuNDA0MzEgNC44ODc4MSA1LjM4NzczQzQuNjM1NTggNS4zNzExNiA0LjM4OTY3IDUuMzAxNjUgNC4xNjYxIDUuMTgzNzNDMy45NDI1MiA1LjA2NTgxIDMuNzQ2MjggNC45MDIxMiAzLjU5MDE3IDQuNzAzMzNDMy40MzQwNSA0LjUwNDUzIDMuMzIxNTYgNC4yNzUwOCAzLjI2IDQuMDI5OTJDMy4yNiAzLjg2OTkyIDMuMjYgMy42OTk5MiAzLjE4IDMuNTI5OTJDMy4xNzk1NyAzLjExMTkgMy4zMTc3MyAyLjcwNTU0IDMuNTcyODYgMi4zNzQ0MUMzLjgyNzk5IDIuMDQzMjkgNC4xODU3IDEuODA2MDggNC41OSAxLjY5OTkyQzUuMDI5NDYgMS41OTg3NCA1LjQ5MDkgMS42NjcxNiA1Ljg4MjA5IDEuODkxNDlDNi4yNzMyOCAyLjExNTgyIDYuNTY1MzggMi40Nzk1MyA2LjcgMi45MDk5MkM2Ljg2MTM4IDMuMzY2NzIgNi44NDAxOSAzLjg2ODE5IDYuNjQwODQgNC4zMDk3NUM2LjQ0MTQ4IDQuNzUxMyA2LjA3OTM3IDUuMDk4ODUgNS42MyA1LjI3OTkyWiIgZmlsbD0iIzE5NzhBMiIvPgo8L3N2Zz4=';var LabelHighriskSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUgMEM0LjAxMTEgMCAzLjA0NDQgMC4yOTMyNDUgMi4yMjIxNSAwLjg0MjY1MkMxLjM5OTkxIDEuMzkyMDYgMC43NTkwNDMgMi4xNzI5NSAwLjM4MDYwNSAzLjA4NjU4QzAuMDAyMTY2NDIgNC4wMDAyMSAtMC4wOTY4NTAzIDUuMDA1NTUgMC4wOTYwNzU5IDUuOTc1NDVDMC4yODkwMDIgNi45NDUzNiAwLjc2NTIwNiA3LjgzNjI3IDEuNDY0NDcgOC41MzU1M0MyLjE2MzczIDkuMjM0OCAzLjA1NDY1IDkuNzExIDQuMDI0NTUgOS45MDM5M0M0Ljk5NDQ2IDEwLjA5NjkgNS45OTk3OSA5Ljk5Nzg0IDYuOTEzNDIgOS42MTk0QzcuODI3MDUgOS4yNDA5NiA4LjYwNzk0IDguNjAwMSA5LjE1NzM1IDcuNzc3ODVDOS43MDY3NiA2Ljk1NTYxIDEwIDUuOTg4OTEgMTAgNUMxMCA0LjM0MzM5IDkuODcwNjcgMy42OTMyMSA5LjYxOTQgMy4wODY1OEM5LjM2ODEzIDIuNDc5OTUgOC45OTk4MyAxLjkyODc2IDguNTM1NTQgMS40NjQ0N0M4LjA3MTI0IDEuMDAwMTcgNy41MjAwNSAwLjYzMTg3NiA2LjkxMzQyIDAuMzgwNjAyQzYuMzA2NzkgMC4xMjkzMjkgNS42NTY2MSAwIDUgMFpNNSA3LjVDNC45MDExMSA3LjUgNC44MDQ0NCA3LjQ3MDY4IDQuNzIyMjIgNy40MTU3NEM0LjYzOTk5IDcuMzYwNzkgNC41NzU5MSA3LjI4MjcgNC41MzgwNiA3LjE5MTM0QzQuNTAwMjIgNy4wOTk5OCA0LjQ5MDMyIDYuOTk5NDUgNC41MDk2MSA2LjkwMjQ1QzQuNTI4OSA2LjgwNTQ2IDQuNTc2NTIgNi43MTYzNyA0LjY0NjQ1IDYuNjQ2NDVDNC43MTYzOCA2LjU3NjUyIDQuODA1NDcgNi41Mjg5IDQuOTAyNDYgNi41MDk2MUM0Ljk5OTQ1IDYuNDkwMzEgNS4wOTk5OCA2LjUwMDIyIDUuMTkxMzQgNi41MzgwNkM1LjI4MjcxIDYuNTc1OSA1LjM2MDggNi42Mzk5OSA1LjQxNTc0IDYuNzIyMjFDNS40NzA2OCA2LjgwNDQ0IDUuNSA2LjkwMTExIDUuNSA3QzUuNSA3LjEzMjYxIDUuNDQ3MzIgNy4yNTk3OSA1LjM1MzU2IDcuMzUzNTVDNS4yNTk3OSA3LjQ0NzMyIDUuMTMyNjEgNy41IDUgNy41Wk01LjUgNS41QzUuNSA1LjYzMjYxIDUuNDQ3MzIgNS43NTk3OSA1LjM1MzU2IDUuODUzNTVDNS4yNTk3OSA1Ljk0NzMyIDUuMTMyNjEgNiA1IDZDNC44NjczOSA2IDQuNzQwMjIgNS45NDczMiA0LjY0NjQ1IDUuODUzNTVDNC41NTI2OCA1Ljc1OTc5IDQuNSA1LjYzMjYxIDQuNSA1LjVWM0M0LjUgMi44NjczOSA0LjU1MjY4IDIuNzQwMjEgNC42NDY0NSAyLjY0NjQ1QzQuNzQwMjIgMi41NTI2OCA0Ljg2NzM5IDIuNSA1IDIuNUM1LjEzMjYxIDIuNSA1LjI1OTc5IDIuNTUyNjggNS4zNTM1NiAyLjY0NjQ1QzUuNDQ3MzIgMi43NDAyMSA1LjUgMi44NjczOSA1LjUgM1Y1LjVaIiBmaWxsPSIjREY1ODU4Ii8+Cjwvc3ZnPg==';var LabelHighriskGreySvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUgMEM0LjAxMTEgMCAzLjA0NDQgMC4yOTMyNDUgMi4yMjIxNSAwLjg0MjY1MkMxLjM5OTkxIDEuMzkyMDYgMC43NTkwNDMgMi4xNzI5NSAwLjM4MDYwNSAzLjA4NjU4QzAuMDAyMTY2NDIgNC4wMDAyMSAtMC4wOTY4NTAzIDUuMDA1NTUgMC4wOTYwNzU5IDUuOTc1NDVDMC4yODkwMDIgNi45NDUzNiAwLjc2NTIwNiA3LjgzNjI3IDEuNDY0NDcgOC41MzU1M0MyLjE2MzczIDkuMjM0OCAzLjA1NDY1IDkuNzExIDQuMDI0NTUgOS45MDM5M0M0Ljk5NDQ2IDEwLjA5NjkgNS45OTk3OSA5Ljk5Nzg0IDYuOTEzNDIgOS42MTk0QzcuODI3MDUgOS4yNDA5NiA4LjYwNzk0IDguNjAwMSA5LjE1NzM1IDcuNzc3ODVDOS43MDY3NiA2Ljk1NTYxIDEwIDUuOTg4OTEgMTAgNUMxMCA0LjM0MzM5IDkuODcwNjcgMy42OTMyMSA5LjYxOTQgMy4wODY1OEM5LjM2ODEzIDIuNDc5OTUgOC45OTk4MyAxLjkyODc2IDguNTM1NTQgMS40NjQ0N0M4LjA3MTI0IDEuMDAwMTcgNy41MjAwNSAwLjYzMTg3NiA2LjkxMzQyIDAuMzgwNjAyQzYuMzA2NzkgMC4xMjkzMjkgNS42NTY2MSAwIDUgMFpNNSA3LjVDNC45MDExMSA3LjUgNC44MDQ0NCA3LjQ3MDY4IDQuNzIyMjIgNy40MTU3NEM0LjYzOTk5IDcuMzYwNzkgNC41NzU5MSA3LjI4MjcgNC41MzgwNiA3LjE5MTM0QzQuNTAwMjIgNy4wOTk5OCA0LjQ5MDMyIDYuOTk5NDUgNC41MDk2MSA2LjkwMjQ1QzQuNTI4OSA2LjgwNTQ2IDQuNTc2NTIgNi43MTYzNyA0LjY0NjQ1IDYuNjQ2NDVDNC43MTYzOCA2LjU3NjUyIDQuODA1NDcgNi41Mjg5IDQuOTAyNDYgNi41MDk2MUM0Ljk5OTQ1IDYuNDkwMzEgNS4wOTk5OCA2LjUwMDIyIDUuMTkxMzQgNi41MzgwNkM1LjI4MjcxIDYuNTc1OSA1LjM2MDggNi42Mzk5OSA1LjQxNTc0IDYuNzIyMjFDNS40NzA2OCA2LjgwNDQ0IDUuNSA2LjkwMTExIDUuNSA3QzUuNSA3LjEzMjYxIDUuNDQ3MzIgNy4yNTk3OSA1LjM1MzU2IDcuMzUzNTVDNS4yNTk3OSA3LjQ0NzMyIDUuMTMyNjEgNy41IDUgNy41Wk01LjUgNS41QzUuNSA1LjYzMjYxIDUuNDQ3MzIgNS43NTk3OSA1LjM1MzU2IDUuODUzNTVDNS4yNTk3OSA1Ljk0NzMyIDUuMTMyNjEgNiA1IDZDNC44NjczOSA2IDQuNzQwMjIgNS45NDczMiA0LjY0NjQ1IDUuODUzNTVDNC41NTI2OCA1Ljc1OTc5IDQuNSA1LjYzMjYxIDQuNSA1LjVWM0M0LjUgMi44NjczOSA0LjU1MjY4IDIuNzQwMjEgNC42NDY0NSAyLjY0NjQ1QzQuNzQwMjIgMi41NTI2OCA0Ljg2NzM5IDIuNSA1IDIuNUM1LjEzMjYxIDIuNSA1LjI1OTc5IDIuNTUyNjggNS4zNTM1NiAyLjY0NjQ1QzUuNDQ3MzIgMi43NDAyMSA1LjUgMi44NjczOSA1LjUgM1Y1LjVaIiBmaWxsPSIjQjJCNEM0Ii8+Cjwvc3ZnPg==';var LabelSupervisorSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDEwIDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik03LjI1IDMuNUM3LjQxNDE1IDMuNSA3LjU3NjcgMy40Njc2NyA3LjcyODM1IDMuNDA0ODVDNy44ODAwMSAzLjM0MjAzIDguMDE3ODEgMy4yNDk5NiA4LjEzMzg4IDMuMTMzODhDOC4yNDk5NiAzLjAxNzgxIDguMzQyMDMgMi44ODAwMSA4LjQwNDg1IDIuNzI4MzVDOC40Njc2NyAyLjU3NjcgOC41IDIuNDE0MTUgOC41IDIuMjVDOC41IDEuOTE4NDggOC4zNjgzIDEuNjAwNTQgOC4xMzM4OCAxLjM2NjEyQzcuODk5NDYgMS4xMzE3IDcuNTgxNTIgMSA3LjI1IDFDNi45MTg0OCAxIDYuNjAwNTQgMS4xMzE3IDYuMzY2MTIgMS4zNjYxMkM2LjEzMTcgMS42MDA1NCA2IDEuOTE4NDggNiAyLjI1QzYgMi40MTQxNSA2LjAzMjMzIDIuNTc2NyA2LjA5NTE1IDIuNzI4MzVDNi4xNTc5NyAyLjg4MDAxIDYuMjUwMDQgMy4wMTc4MSA2LjM2NjEyIDMuMTMzODhDNi42MDA1NCAzLjM2ODMgNi45MTg0OCAzLjUgNy4yNSAzLjVaTTMuNSAzQzMuODk3ODIgMyA0LjI3OTM2IDIuODQxOTYgNC41NjA2NiAyLjU2MDY2QzQuODQxOTYgMi4yNzkzNiA1IDEuODk3ODIgNSAxLjVDNSAxLjEwMjE4IDQuODQxOTYgMC43MjA2NDQgNC41NjA2NiAwLjQzOTM0QzQuMjc5MzYgMC4xNTgwMzUgMy44OTc4MiAwIDMuNSAwQzMuMTAyMTggMCAyLjcyMDY0IDAuMTU4MDM1IDIuNDM5MzQgMC40MzkzNEMyLjE1ODA0IDAuNzIwNjQ0IDIgMS4xMDIxOCAyIDEuNUMyIDEuODk3ODIgMi4xNTgwNCAyLjI3OTM2IDIuNDM5MzQgMi41NjA2NkMyLjcyMDY0IDIuODQxOTYgMy4xMDIxOCAzIDMuNSAzWk03LjI1IDQuNUM2LjMzNSA0LjUgNC41IDQuOTYgNC41IDUuODc1VjdIMTBWNS44NzVDMTAgNC45NiA4LjE2NSA0LjUgNy4yNSA0LjVaTTMuNSA0QzIuMzM1IDQgMCA0LjU4NSAwIDUuNzVWN0gzLjVWNS44NzVDMy41IDUuNDUgMy42NjUgNC43MDUgNC42ODUgNC4xNEM0LjI1IDQuMDUgMy44MyA0IDMuNSA0WiIgZmlsbD0iIzZCODhCNSIvPgo8L3N2Zz4=';var LabelSupervisorGreySvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDEwIDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik03LjI1IDMuNUM3LjQxNDE1IDMuNSA3LjU3NjcgMy40Njc2NyA3LjcyODM1IDMuNDA0ODVDNy44ODAwMSAzLjM0MjAzIDguMDE3ODEgMy4yNDk5NiA4LjEzMzg4IDMuMTMzODhDOC4yNDk5NiAzLjAxNzgxIDguMzQyMDMgMi44ODAwMSA4LjQwNDg1IDIuNzI4MzVDOC40Njc2NyAyLjU3NjcgOC41IDIuNDE0MTUgOC41IDIuMjVDOC41IDEuOTE4NDggOC4zNjgzIDEuNjAwNTQgOC4xMzM4OCAxLjM2NjEyQzcuODk5NDYgMS4xMzE3IDcuNTgxNTIgMSA3LjI1IDFDNi45MTg0OCAxIDYuNjAwNTQgMS4xMzE3IDYuMzY2MTIgMS4zNjYxMkM2LjEzMTcgMS42MDA1NCA2IDEuOTE4NDggNiAyLjI1QzYgMi40MTQxNSA2LjAzMjMzIDIuNTc2NyA2LjA5NTE1IDIuNzI4MzVDNi4xNTc5NyAyLjg4MDAxIDYuMjUwMDQgMy4wMTc4MSA2LjM2NjEyIDMuMTMzODhDNi42MDA1NCAzLjM2ODMgNi45MTg0OCAzLjUgNy4yNSAzLjVaTTMuNSAzQzMuODk3ODIgMyA0LjI3OTM2IDIuODQxOTYgNC41NjA2NiAyLjU2MDY2QzQuODQxOTYgMi4yNzkzNiA1IDEuODk3ODIgNSAxLjVDNSAxLjEwMjE4IDQuODQxOTYgMC43MjA2NDQgNC41NjA2NiAwLjQzOTM0QzQuMjc5MzYgMC4xNTgwMzUgMy44OTc4MiAwIDMuNSAwQzMuMTAyMTggMCAyLjcyMDY0IDAuMTU4MDM1IDIuNDM5MzQgMC40MzkzNEMyLjE1ODA0IDAuNzIwNjQ0IDIgMS4xMDIxOCAyIDEuNUMyIDEuODk3ODIgMi4xNTgwNCAyLjI3OTM2IDIuNDM5MzQgMi41NjA2NkMyLjcyMDY0IDIuODQxOTYgMy4xMDIxOCAzIDMuNSAzWk03LjI1IDQuNUM2LjMzNSA0LjUgNC41IDQuOTYgNC41IDUuODc1VjdIMTBWNS44NzVDMTAgNC45NiA4LjE2NSA0LjUgNy4yNSA0LjVaTTMuNSA0QzIuMzM1IDQgMCA0LjU4NSAwIDUuNzVWN0gzLjVWNS44NzVDMy41IDUuNDUgMy42NjUgNC43MDUgNC42ODUgNC4xNEM0LjI1IDQuMDUgMy44MyA0IDMuNSA0WiIgZmlsbD0iI0IyQjRDNCIvPgo8L3N2Zz4=';var LineArrowDownSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMCkiPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDEpIj4KPHBhdGggZD0iTTEgMkw1IDZMOSAyIiBzdHJva2U9IiMwMDA4NTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDAiPgo8cmVjdCB3aWR0aD0iMTAiIGhlaWdodD0iNiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPGNsaXBQYXRoIGlkPSJjbGlwMSI+CjxyZWN0IHdpZHRoPSIxMCIgaGVpZ2h0PSI2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPg==';var LineArrowUpSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMCkiPgo8cGF0aCBkPSJNOSA1TDUgMUwxIDUiIHN0cm9rZT0iIzAwMDg1MCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDAiPgo8cmVjdCB3aWR0aD0iMTAiIGhlaWdodD0iNiIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwIDYpIHJvdGF0ZSgtMTgwKSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPg==';var LockSvg='data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTJweCIgaGVpZ2h0PSIxN3B4IiB2aWV3Qm94PSIwIDAgMTIgMTciIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDY0ICg5MzUzNykgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+bG9jazwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJBcnRib2FyZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEzMC4wMDAwMDAsIC01Mi4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9ImxvY2siIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyNy4wMDAwMDAsIDUyLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IlBhdGgiIHBvaW50cz0iMCAwIDE4IDAgMTggMTggMCAxOCI+PC9wb2x5Z29uPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTEzLjUsNiBMMTIuNzUsNiBMMTIuNzUsNC41IEMxMi43NSwyLjQzIDExLjA3LDAuNzUgOSwwLjc1IEM2LjkzLDAuNzUgNS4yNSwyLjQzIDUuMjUsNC41IEw1LjI1LDYgTDQuNSw2IEMzLjY3NSw2IDMsNi42NzUgMyw3LjUgTDMsMTUgQzMsMTUuODI1IDMuNjc1LDE2LjUgNC41LDE2LjUgTDEzLjUsMTYuNSBDMTQuMzI1LDE2LjUgMTUsMTUuODI1IDE1LDE1IEwxNSw3LjUgQzE1LDYuNjc1IDE0LjMyNSw2IDEzLjUsNiBaIE05LDEyLjc1IEM4LjE3NSwxMi43NSA3LjUsMTIuMDc1IDcuNSwxMS4yNSBDNy41LDEwLjQyNSA4LjE3NSw5Ljc1IDksOS43NSBDOS44MjUsOS43NSAxMC41LDEwLjQyNSAxMC41LDExLjI1IEMxMC41LDEyLjA3NSA5LjgyNSwxMi43NSA5LDEyLjc1IFogTTExLjMyNSw2IEw2LjY3NSw2IEw2LjY3NSw0LjUgQzYuNjc1LDMuMjE3NSA3LjcxNzUsMi4xNzUgOSwyLjE3NSBDMTAuMjgyNSwyLjE3NSAxMS4zMjUsMy4yMTc1IDExLjMyNSw0LjUgTDExLjMyNSw2IFoiIGlkPSJTaGFwZSIgZmlsbD0iIzAwMDAwMCIgZmlsbC1ydWxlPSJub256ZXJvIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==';var LogoutSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUgMTNIMi4zMzMzM0MxLjk3OTcxIDEzIDEuNjQwNTcgMTIuODU5NSAxLjM5MDUyIDEyLjYwOTVDMS4xNDA0OCAxMi4zNTk0IDEgMTIuMDIwMyAxIDExLjY2NjdWMi4zMzMzM0MxIDEuOTc5NzEgMS4xNDA0OCAxLjY0MDU3IDEuMzkwNTIgMS4zOTA1MkMxLjY0MDU3IDEuMTQwNDggMS45Nzk3MSAxIDIuMzMzMzMgMUg1IiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOS42NjY2MyAxMC4zMzM0TDEzIDcuMDAwMDJMOS42NjY2MyAzLjY2NjY5IiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTMgN0g1IiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var LogsSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxOCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3IDcuOTk5OEgxMy44TDExLjQgMTUuMTk5OEw2LjYgMC43OTk4MDVMNC4yIDcuOTk5OEgxIiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var MailSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIuNjY2NTkgMi42NjY3NUgxMy4zMzMzQzE0LjA2NjYgMi42NjY3NSAxNC42NjY2IDMuMjY2NzUgMTQuNjY2NiA0LjAwMDA4VjEyLjAwMDFDMTQuNjY2NiAxMi43MzM0IDE0LjA2NjYgMTMuMzMzNCAxMy4zMzMzIDEzLjMzMzRIMi42NjY1OUMxLjkzMzI1IDEzLjMzMzQgMS4zMzMyNSAxMi43MzM0IDEuMzMzMjUgMTIuMDAwMVY0LjAwMDA4QzEuMzMzMjUgMy4yNjY3NSAxLjkzMzI1IDIuNjY2NzUgMi42NjY1OSAyLjY2Njc1WiIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE0LjY2NjYgNEw3Ljk5OTkyIDguNjY2NjdMMS4zMzMyNSA0IiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var MoreSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMyIgaGVpZ2h0PSIxMyIgdmlld0JveD0iMCAwIDMgMTMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjEuNSIgY3k9IjEuNSIgcj0iMS41IiBmaWxsPSIjMTIzQkU1Ii8+CjxjaXJjbGUgY3g9IjEuNSIgY3k9IjYuNSIgcj0iMS41IiBmaWxsPSIjMTIzQkU1Ii8+CjxjaXJjbGUgY3g9IjEuNSIgY3k9IjExLjUiIHI9IjEuNSIgZmlsbD0iIzEyM0JFNSIvPgo8L3N2Zz4=';var MoreClickedSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMyIgaGVpZ2h0PSIxMyIgdmlld0JveD0iMCAwIDMgMTMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjEuNSIgY3k9IjEuNSIgcj0iMS41IiBmaWxsPSIjMTIzQkU1Ii8+CjxjaXJjbGUgY3g9IjEuNSIgY3k9IjYuNSIgcj0iMS41IiBmaWxsPSIjMTIzQkU1Ii8+CjxjaXJjbGUgY3g9IjEuNSIgY3k9IjExLjUiIHI9IjEuNSIgZmlsbD0iIzEyM0JFNSIvPgo8L3N2Zz4=';var MoreHoverSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMyIgaGVpZ2h0PSIxMyIgdmlld0JveD0iMCAwIDMgMTMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjEuNSIgY3k9IjEuNSIgcj0iMS41IiBmaWxsPSIjMDAwODUwIi8+CjxjaXJjbGUgY3g9IjEuNSIgY3k9IjYuNSIgcj0iMS41IiBmaWxsPSIjMDAwODUwIi8+CjxjaXJjbGUgY3g9IjEuNSIgY3k9IjExLjUiIHI9IjEuNSIgZmlsbD0iIzAwMDg1MCIvPgo8L3N2Zz4=';var NextSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDQgMTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDlMNSA1TDEgMSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+';var OpenKeyboardSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxNiAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC44MTQwMjYiIHk9IjAuNDg1ODQiIHdpZHRoPSIzIiBoZWlnaHQ9IjIiIGZpbGw9IiMxMjNCRTUiLz4KPHJlY3QgeD0iNC44MTQwMyIgeT0iMC40ODU4NCIgd2lkdGg9IjMiIGhlaWdodD0iMiIgZmlsbD0iIzEyM0JFNSIvPgo8cmVjdCB4PSI4LjgxNDAzIiB5PSIwLjQ4NTg0IiB3aWR0aD0iMyIgaGVpZ2h0PSIyIiBmaWxsPSIjMTIzQkU1Ii8+CjxyZWN0IHg9IjEyLjgxNCIgeT0iMC40ODU4NCIgd2lkdGg9IjMiIGhlaWdodD0iMiIgZmlsbD0iIzEyM0JFNSIvPgo8cmVjdCB4PSIwLjgxNDAyNiIgeT0iNC40ODU4NCIgd2lkdGg9IjMiIGhlaWdodD0iMiIgZmlsbD0iIzEyM0JFNSIvPgo8cmVjdCB4PSI0LjgxNDAzIiB5PSI0LjQ4NTg0IiB3aWR0aD0iMyIgaGVpZ2h0PSIyIiBmaWxsPSIjMTIzQkU1Ii8+CjxyZWN0IHg9IjguODE0MDMiIHk9IjQuNDg1ODQiIHdpZHRoPSIzIiBoZWlnaHQ9IjIiIGZpbGw9IiMxMjNCRTUiLz4KPHJlY3QgeD0iMTIuODE0IiB5PSI0LjQ4NTg0IiB3aWR0aD0iMyIgaGVpZ2h0PSIyIiBmaWxsPSIjMTIzQkU1Ii8+CjxyZWN0IHg9IjAuODE0MDI2IiB5PSI4LjQ4NTg0IiB3aWR0aD0iMyIgaGVpZ2h0PSIyIiBmaWxsPSIjMTIzQkU1Ii8+CjxyZWN0IHg9IjQuODE0MDMiIHk9IjguNDg1ODQiIHdpZHRoPSI3IiBoZWlnaHQ9IjIiIGZpbGw9IiMxMjNCRTUiLz4KPHJlY3QgeD0iMTIuODE0IiB5PSI4LjQ4NTg0IiB3aWR0aD0iMyIgaGVpZ2h0PSIyIiBmaWxsPSIjMTIzQkU1Ii8+Cjwvc3ZnPg==';var OsAndroidIconSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEzIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMyA3LjU4OTk1SDBDMC4xODY4NzUgNS4zNzE4MiAxLjQ1NDM4IDMuNDg2ODIgMy4zMTUgMi40NzkzMkwyLjIzNDM4IDAuNjAyNDQ3QzIuMTg1NjMgMC41MjkzMjIgMi4xODU2MyAwLjQyMzY5NyAyLjIzNDM4IDAuMzUwNTcyQzIuMzMxODggMC4yMDQzMjIgMi41NTEyNSAwLjIyMDU3MiAyLjYyNDM4IDAuMzc0OTQ3TDMuNzIxMjUgMi4yNzYyQzUuNDkyNSAxLjQ3OTk1IDcuNTE1NjIgMS40Nzk5NSA5LjI4Njg3IDIuMjc2MkwxMC4zNzU2IDAuMzc0OTQ3QzEwLjQxNjMgMC4yOTM2OTcgMTAuNTA1NiAwLjI0NDk0NyAxMC41OTUgMC4yNTMwNzJDMTAuNzY1NiAwLjI2MTE5NyAxMC44NjMxIDAuNDU2MTk3IDEwLjc2NTYgMC42MDI0NDdMOS42ODUgMi40NzkzMkMxMS41NDU2IDMuNDg2ODIgMTIuODEzMSA1LjM3MTgyIDEzIDcuNTg5OTVaTTQuMDQ2MjUgNS4xOTMwN0M0LjA0NjI1IDUuMDk1NTcgNC4wMjE4NyA1LjAwNjIgMy45NzMxMiA0LjkyNDk1QzMuNzYxODcgNC41Njc0NSAzLjI0MTg3IDQuNTY3NDUgMy4wMzg3NSA0LjkyNDk1QzIuODM1NjIgNS4yODI0NSAzLjA4NzUgNS43Mzc0NSAzLjUxIDUuNzM3NDVDMy44MTA2MyA1LjczNzQ1IDQuMDU0MzcgNS40OTM3IDQuMDU0MzcgNS4xOTMwN0g0LjA0NjI1Wk0xMC4wMjYyIDUuMTkzMDdDMTAuMDI2MiA1LjA5NTU3IDEwLjAwMTkgNS4wMDYyIDkuOTUzMTIgNC45MjQ5NUM5Ljc0MTg3IDQuNTY3NDUgOS4yMjE4OCA0LjU2NzQ1IDkuMDE4NzUgNC45MjQ5NUM4LjgxNTYzIDUuMjgyNDUgOS4wNjc1IDUuNzM3NDUgOS40OSA1LjczNzQ1QzkuNzkwNjMgNS43Mzc0NSAxMC4wMzQ0IDUuNDkzNyAxMC4wMzQ0IDUuMTkzMDdIMTAuMDI2MloiIGZpbGw9IiMzMDM5OEEiLz4KPC9zdmc+';var OsIosIconSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDkgMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik04LjUgMS4xOTA5NFYxMC42NDg4QzguNSAxMS4yNDkxIDguMDA5OTUgMTEuNzM5MiA3LjQwOTY1IDExLjczOTJIMS41OTAzNUMwLjk5MDA0NiAxMS43MzkyIDAuNSAxMS4yNDkxIDAuNSAxMC42NDg4VjEuMTkwOTRDMC41IDAuNTkwNjMyIDAuOTkwMDQ2IDAuMTAwNTg2IDEuNTkwMzUgMC4xMDA1ODZINy40MDk2NUM4LjAwOTk1IDAuMTAwNTg2IDguNSAwLjU5MDYzMiA4LjUgMS4xOTA5NFpNNy4wNDIxMSAxLjU1MjM1SDEuOTU3ODlWOC44Mjk1M0g3LjA0ODI0VjEuNTU4NDdMNy4wNDIxMSAxLjU1MjM1Wk01LjIyMjgyIDkuOTE5ODhIMy43NjQ5M0MzLjU2Mjc5IDkuOTE5ODggMy40MDM1MiAxMC4wODUzIDMuNDAzNTIgMTAuMjgxM0MzLjQwMzUyIDEwLjQ3NzMgMy41Njg5MSAxMC42NDI3IDMuNzQ2NTUgMTAuNjQyN0g1LjIyMjgyQzUuNDI0OTYgMTAuNjQyNyA1LjU4NDIzIDEwLjQ3NzMgNS41ODQyMyAxMC4yNTY4QzUuNTg0MjMgMTAuMDc5MSA1LjQxODg0IDkuOTEzNzYgNS4yMjI4MiA5LjkxMzc2VjkuOTE5ODhaIiBmaWxsPSIjMzAzOThBIi8+Cjwvc3ZnPg==';var OsLinuxIconSvg='data:image/svg+xml;base64,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';var OsMacIconSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCAzNCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI4LjA4IDM4LjRDMjUuOTEyIDQwLjUwNCAyMy41MiA0MC4xNzYgMjEuMjQgMzkuMTg0QzE4LjgxNiAzOC4xNzIgMTYuNiAzOC4xMDggMTQuMDQgMzkuMTg0QzEwLjg1MiA0MC41NiA5LjE2MDAyIDQwLjE2IDcuMjQwMDIgMzguNEMtMy41OTk5NyAyNy4yNCAtMS45OTk5NyAxMC4yNCAxMC4zMiA5LjYwMDAzQzEzLjMwOCA5Ljc2MDAzIDE1LjQgMTEuMjUyIDE3LjE2IDExLjM3NkMxOS43NzYgMTAuODQ0IDIyLjI4IDkuMzIwMDMgMjUuMDggOS41MjAwM0MyOC40NDQgOS43OTIwMyAzMC45NiAxMS4xMiAzMi42NCAxMy41MDhDMjUuNzIgMTcuNjY4IDI3LjM2IDI2Ljc4OCAzMy43MTYgMjkuMzQ4QzMyLjQ0NCAzMi42ODggMzAuODEyIDM1Ljk4OCAyOC4wNzYgMzguNDI4TDI4LjA4IDM4LjRaTTE2LjkyIDkuNDgwMDNDMTYuNTk2IDQuNTIwMDMgMjAuNjE2IDAuNDQwMDM5IDI1LjI0IDAuMDQwMDM5MUMyNS44NzYgNS43NjAwMyAyMC4wNCAxMC4wNCAxNi45MiA5LjQ4MDAzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+';var OsWinIconSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgNS42MzcyN0wxNi4yMjE0IDMuNDI4MDlMMTYuMjI4NSAxOS4wNzQ5TDAuMDE0ODE4MiAxOS4xNjcyTDAgNS42MzcyN1pNMTYuMjEzNiAyMC44Nzc3TDE2LjIyNjIgMzYuNTM4MkwwLjAxMjU5MDkgMzQuMzA5TDAuMDExNjgxOCAyMC43NzI3TDE2LjIxMzYgMjAuODc3N1pNMTguMTggMy4xMzkwOUwzOS42ODgyIDBWMTguODc1OUwxOC4xOCAxOS4wNDY3VjMuMTM5MDlaTTM5LjY5MzIgMjEuMDI1TDM5LjY4ODIgMzkuODE1OUwxOC4xOCAzNi43ODAzTDE4LjE0OTkgMjAuOTg5OEwzOS42OTMyIDIxLjAyNVoiIGZpbGw9IiMwMEFERUYiLz4KPC9zdmc+';var OtherSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMTVDMTEuODY2IDE1IDE1IDExLjg2NiAxNSA4QzE1IDQuMTM0MDEgMTEuODY2IDEgOCAxQzQuMTM0MDEgMSAxIDQuMTM0MDEgMSA4QzEgMTEuODY2IDQuMTM0MDEgMTUgOCAxNVoiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik01Ljk2Mjg5IDUuODk5NzFDNi4xMjc0NiA1LjQzMTg4IDYuNDUyMyA1LjAzNzM5IDYuODc5ODYgNC43ODYxMUM3LjMwNzQyIDQuNTM0ODMgNy44MTAxMiA0LjQ0Mjk3IDguMjk4OTEgNC41MjY4MUM4Ljc4NzcxIDQuNjEwNjYgOS4yMzEwNiA0Ljg2NDc4IDkuNTUwNDQgNS4yNDQxOEM5Ljg2OTgzIDUuNjIzNTkgMTAuMDQ0NiA2LjEwMzc4IDEwLjA0MzkgNi41OTk3MUMxMC4wNDM5IDcuOTk5NzEgNy45NDM4OSA4LjY5OTcxIDcuOTQzODkgOC42OTk3MSIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTcuOTk5NzYgMTEuNUg4LjAwNjQyIiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var OtherClickedSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMTVDMTEuODY2IDE1IDE1IDExLjg2NiAxNSA4QzE1IDQuMTM0MDEgMTEuODY2IDEgOCAxQzQuMTM0MDEgMSAxIDQuMTM0MDEgMSA4QzEgMTEuODY2IDQuMTM0MDEgMTUgOCAxNVoiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik01Ljk2Mjg5IDUuODk5NzFDNi4xMjc0NiA1LjQzMTg4IDYuNDUyMyA1LjAzNzM5IDYuODc5ODYgNC43ODYxMUM3LjMwNzQyIDQuNTM0ODMgNy44MTAxMiA0LjQ0Mjk3IDguMjk4OTEgNC41MjY4MUM4Ljc4NzcxIDQuNjEwNjYgOS4yMzEwNiA0Ljg2NDc4IDkuNTUwNDQgNS4yNDQxOEM5Ljg2OTgzIDUuNjIzNTkgMTAuMDQ0NiA2LjEwMzc4IDEwLjA0MzkgNi41OTk3MUMxMC4wNDM5IDcuOTk5NzEgNy45NDM4OSA4LjY5OTcxIDcuOTQzODkgOC42OTk3MSIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTggMTEuNUg4LjAwNjY3IiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var OtherHoverSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMTVDMTEuODY2IDE1IDE1IDExLjg2NiAxNSA4QzE1IDQuMTM0MDEgMTEuODY2IDEgOCAxQzQuMTM0MDEgMSAxIDQuMTM0MDEgMSA4QzEgMTEuODY2IDQuMTM0MDEgMTUgOCAxNVoiIHN0cm9rZT0iIzAwMDg1MCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik01Ljk2Mjg5IDUuODk5NzFDNi4xMjc0NiA1LjQzMTg4IDYuNDUyMyA1LjAzNzM5IDYuODc5ODYgNC43ODYxMUM3LjMwNzQyIDQuNTM0ODMgNy44MTAxMiA0LjQ0Mjk3IDguMjk4OTEgNC41MjY4MUM4Ljc4NzcxIDQuNjEwNjYgOS4yMzEwNiA0Ljg2NDc4IDkuNTUwNDQgNS4yNDQxOEM5Ljg2OTgzIDUuNjIzNTkgMTAuMDQ0NiA2LjEwMzc4IDEwLjA0MzkgNi41OTk3MUMxMC4wNDM5IDcuOTk5NzEgNy45NDM4OSA4LjY5OTcxIDcuOTQzODkgOC42OTk3MSIgc3Ryb2tlPSIjMDAwODUwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTggMTEuNUg4LjAwNjY3IiBzdHJva2U9IiMwMDA4NTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var PcIconSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuNTAwMDIgNy41VjguNUg3LjUwMDAyVjkuNUgyLjUwMDAyVjguNUg0LjUwMDAyVjcuNUgwLjQ5NjAyQzAuNDMwMzYzIDcuNDk5NjEgMC4zNjU0MjkgNy40ODYyNiAwLjMwNDkzOSA3LjQ2MDczQzAuMjQ0NDUgNy40MzUxOSAwLjE4OTU5NCA3LjM5Nzk3IDAuMTQzNTE2IDcuMzUxMkMwLjA5NzQzODMgNy4zMDQ0MiAwLjA2MTA0NDUgNy4yNDkwMSAwLjAzNjQyMDcgNy4xODgxNUMwLjAxMTc5NjkgNy4xMjcyOCAtMC4wMDA1NzI5MDYgNy4wNjIxNiAyLjAzNzNlLTA1IDYuOTk2NVYwLjUwMzVDMi4wMzczZS0wNSAwLjIyNTUgMC4yMjc1MiAwIDAuNDk2MDIgMEg5LjUwNDAyQzkuNzc4MDIgMCAxMCAwLjIyNDUgMTAgMC41MDM1VjYuOTk2NUMxMCA3LjI3NDUgOS43NzI1MiA3LjUgOS41MDQwMiA3LjVINS41MDAwMloiIGZpbGw9IiM1QzdEOTgiLz4KPC9zdmc+';var PermissionsSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMiAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjQzMTkgNi41TDE3LjkzMTkgM00xOS45MzE5IDFMMTcuOTMxOSAzTDE5LjkzMTkgMVpNMTAuMzIxOSAxMC42MUMxMC44MzgzIDExLjExOTUgMTEuMjQ4NyAxMS43MjYgMTEuNTI5NyAxMi4zOTQ4QzExLjgxMDYgMTMuMDYzNSAxMS45NTY1IDEzLjc4MTMgMTEuOTU4OSAxNC41MDY2QzExLjk2MTQgMTUuMjMyIDExLjgyMDMgMTUuOTUwNyAxMS41NDM4IDE2LjYyMTNDMTEuMjY3NCAxNy4yOTE5IDEwLjg2MSAxNy45MDEyIDEwLjM0ODEgMTguNDE0MUM5LjgzNTE1IDE4LjkyNzEgOS4yMjU4NCAxOS4zMzM0IDguNTU1MjIgMTkuNjA5OUM3Ljg4NDYgMTkuODg2NCA3LjE2NTkxIDIwLjAyNzUgNi40NDA1NSAyMC4wMjVDNS43MTUxOCAyMC4wMjI2IDQuOTk3NDYgMTkuODc2NyA0LjMyODcxIDE5LjU5NThDMy42NTk5NSAxOS4zMTQ4IDMuMDUzMzggMTguOTA0MyAyLjU0MzkyIDE4LjM4OEMxLjU0MjA1IDE3LjM1MDcgMC45ODc2NzcgMTUuOTYxNCAxLjAwMDIxIDE0LjUxOTNDMS4wMTI3NCAxMy4wNzcyIDEuNTkxMTcgMTEuNjk3NyAyLjYxMDkxIDEwLjY3OEMzLjYzMDY2IDkuNjU4MjUgNS4wMTAxMyA5LjA3OTgyIDYuNDUyMjEgOS4wNjcyOUM3Ljg5NDI5IDkuMDU0NzYgOS4yODM2IDkuNjA5MTMgMTAuMzIwOSAxMC42MTFMMTAuMzIxOSAxMC42MVpNMTAuMzIxOSAxMC42MUwxNC40MzE5IDYuNUwxMC4zMjE5IDEwLjYxWk0xNC40MzE5IDYuNUwxNy40MzE5IDkuNUwyMC45MzE5IDZMMTcuOTMxOSAzTDE0LjQzMTkgNi41WiIgc3Ryb2tlPSIjMDAwODUwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+';var PersonSvg='data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTJweCIgaGVpZ2h0PSIxMnB4IiB2aWV3Qm94PSIwIDAgMTIgMTIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDY0ICg5MzUzNykgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+cGVyc29uPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkFydGJvYXJkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTExLjAwMDAwMCwgLTU1LjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0icGVyc29uIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDguMDAwMDAwLCA1Mi4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik05LDkgQzEwLjY1NzUsOSAxMiw3LjY1NzUgMTIsNiBDMTIsNC4zNDI1IDEwLjY1NzUsMyA5LDMgQzcuMzQyNSwzIDYsNC4zNDI1IDYsNiBDNiw3LjY1NzUgNy4zNDI1LDkgOSw5IFogTTksMTAuNSBDNi45OTc1LDEwLjUgMywxMS41MDUgMywxMy41IEwzLDE1IEwxNSwxNSBMMTUsMTMuNSBDMTUsMTEuNTA1IDExLjAwMjUsMTAuNSA5LDEwLjUgWiIgaWQ9IlNoYXBlIiBmaWxsPSIjMDAwMDAwIiBmaWxsLXJ1bGU9Im5vbnplcm8iPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJQYXRoIiBwb2ludHM9IjAgMCAxOCAwIDE4IDE4IDAgMTgiPjwvcG9seWdvbj4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+';var PersonalDesktopSvg='data:image/svg+xml;base64,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';var PersonalDesktopIconSvg='data:image/svg+xml;base64,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';var PinActiveSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxMCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMS44MDI0OSIgeT0iMC43OTc2MDciIHdpZHRoPSI2Ljc3MjE0IiBoZWlnaHQ9IjAuOTU2NjAyIiByeD0iMC40NzgzMDEiIGZpbGw9IiMxMjNCRTUiLz4KPHJlY3QgeD0iNS42NzIyNCIgeT0iOS40MDY4NiIgd2lkdGg9IjQuNzgzMDEiIGhlaWdodD0iMC45Njc0NDgiIHJ4PSIwLjQ4MzcyNCIgdHJhbnNmb3JtPSJyb3RhdGUoOTAgNS42NzIyNCA5LjQwNjg2KSIgZmlsbD0iIzEyM0JFNSIvPgo8cGF0aCBkPSJNMy43MzczNSAxLjI3MDQzQzMuNDcwMTkgMS4yNzA0MyAzLjI1MzYyIDEuNDg3IDMuMjUzNjIgMS43NTQxNVY1LjQ0MDVMMC45MDk4MzYgOS4xNDg1MUMwLjgxNTY0NyA5LjI5NzUzIDAuODA5OTggOS40ODU5OCAwLjg5NTA0NiA5LjY0MDM5QzAuOTgwMTEyIDkuNzk0NzkgMS4xNDI0NCA5Ljg5MDY5IDEuMzE4NzMgOS44OTA2OUg4LjU3NDU4QzguNzQyNjIgOS44OTA2OSA4Ljg5ODYyIDkuODAzNDggOC45ODY2NCA5LjY2MDM0QzkuMDc0NjYgOS41MTcyIDkuMDgyMDkgOS4zMzg2NCA5LjAwNjI2IDkuMTg4NjhMNy4xMjM0MSA1LjQ2NTIxVjEuNzU0MTVDNy4xMjM0MSAxLjQ4NyA2LjkwNjg0IDEuMjcwNDMgNi42Mzk2OSAxLjI3MDQzTDMuNzM3MzUgMS4yNzA0M1oiIGZpbGw9IiMxMjNCRTUiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLXdpZHRoPSIwLjk2NzQ0OCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==';var PinInactiveSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjYuNzUzMjQiIGhlaWdodD0iMC45NTkzMjUiIHJ4PSIwLjQ3OTY2MyIgdHJhbnNmb3JtPSJtYXRyaXgoMC44Njg0NDkgMC40OTU3NzggLTAuNTA0MjM0IDAuODYzNTY3IDcuNjA5MDEgMC45MjE3NTMpIiBmaWxsPSIjQTBBM0JEIi8+CjxyZWN0IHdpZHRoPSI0Ljc5NjYzIiBoZWlnaHQ9IjAuOTY0NzQ4IiByeD0iMC40ODIzNzQiIHRyYW5zZm9ybT0ibWF0cml4KC0wLjUwNDIzNCAwLjg2MzU2NyAtMC44Njg0NDkgLTAuNDk1Nzc4IDYuNjA3NjcgMTAuMjkxMSkiIGZpbGw9IiNBMEEzQkQiLz4KPHBhdGggZD0iTTkuMDQ1MjggMi4yODg4OUM4LjgxMzI3IDIuMTU2NDQgOC41MTU5OSAyLjIzNjA5IDguMzgxMjggMi40NjY4TDYuNTE2NjcgNS42NjAxOUwyLjYxMTEyIDcuNzEzMDZDMi40NTQ1OSA3Ljc5NTM0IDIuMzU1MDkgNy45NTUyNCAyLjM1MTM0IDguMTMwNTNDMi4zNDc1OSA4LjMwNTgzIDIuNDQwMTggOC40Njg4NCAyLjU5MzA4IDguNTU2MTNMOC44NzY4NCAxMi4xNDM0QzkuMDIyNjEgMTIuMjI2NiA5LjIwMTgyIDEyLjIyODcgOS4zNTAzNiAxMi4xNDlDOS40OTg4OSAxMi4wNjkzIDkuNTk1NTEgMTEuOTE5MSA5LjYwNTY0IDExLjc1MjNMOS44NTc5NCA3LjU5NkwxMS43MzUgNC4zODEzNEMxMS44Njk3IDQuMTUwNjQgMTEuNzkwOCAzLjg1NjI0IDExLjU1ODggMy43MjM3OUw5LjA0NTI4IDIuMjg4ODlaIiBzdHJva2U9IiNBMEEzQkQiIHN0cm9rZS13aWR0aD0iMC45Njc0NDgiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var PortSvg='data:image/svg+xml;base64,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';var ProfileDefaultSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1IDBDNi44Njg1IDAgMCA2Ljg2ODUgMCAxNUMwIDIzLjEzMTUgNi44Njg1IDMwIDE1IDMwQzIzLjEzMTUgMzAgMzAgMjMuMTMxNSAzMCAxNUMzMCA2Ljg2ODUgMjMuMTMxNSAwIDE1IDBaTTE1IDcuNUMxNy41OTA1IDcuNSAxOS41IDkuNDA4IDE5LjUgMTJDMTkuNSAxNC41OTIgMTcuNTkwNSAxNi41IDE1IDE2LjVDMTIuNDExIDE2LjUgMTAuNSAxNC41OTIgMTAuNSAxMkMxMC41IDkuNDA4IDEyLjQxMSA3LjUgMTUgNy41Wk03LjM0MSAyMi4xNThDOC42ODY1IDIwLjE3OCAxMC45MzA1IDE4Ljg1OCAxMy41IDE4Ljg1OEgxNi41QzE5LjA3MSAxOC44NTggMjEuMzEzNSAyMC4xNzggMjIuNjU5IDIyLjE1OEMyMC43NDIgMjQuMjEgMTguMDIyNSAyNS41IDE1IDI1LjVDMTEuOTc3NSAyNS41IDkuMjU4IDI0LjIxIDcuMzQxIDIyLjE1OFoiIGZpbGw9IiMyQzREN0UiLz4KPC9zdmc+';var QuestionMarkSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMTVDMTEuODY2IDE1IDE1IDExLjg2NiAxNSA4QzE1IDQuMTM0MDEgMTEuODY2IDEgOCAxQzQuMTM0MDEgMSAxIDQuMTM0MDEgMSA4QzEgMTEuODY2IDQuMTM0MDEgMTUgOCAxNVoiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik01Ljk2Mjg5IDUuODk5NzFDNi4xMjc0NiA1LjQzMTg4IDYuNDUyMyA1LjAzNzM5IDYuODc5ODYgNC43ODYxMUM3LjMwNzQyIDQuNTM0ODMgNy44MTAxMiA0LjQ0Mjk3IDguMjk4OTEgNC41MjY4MUM4Ljc4NzcxIDQuNjEwNjYgOS4yMzEwNiA0Ljg2NDc4IDkuNTUwNDQgNS4yNDQxOEM5Ljg2OTgzIDUuNjIzNTkgMTAuMDQ0NiA2LjEwMzc4IDEwLjA0MzkgNi41OTk3MUMxMC4wNDM5IDcuOTk5NzEgNy45NDM4OSA4LjY5OTcxIDcuOTQzODkgOC42OTk3MSIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTcuOTk5NzYgMTEuNUg4LjAwNjQyIiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var RdpSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNSAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjcgMUgyLjNDMS41ODIwMyAxIDEgMS41NzcyNyAxIDIuMjg5MzhWOC43MzYyNkMxIDkuNDQ4MzcgMS41ODIwMyAxMC4wMjU2IDIuMyAxMC4wMjU2SDEyLjdDMTMuNDE4IDEwLjAyNTYgMTQgOS40NDgzNyAxNCA4LjczNjI2VjIuMjg5MzhDMTQgMS41NzcyNyAxMy40MTggMSAxMi43IDFaIiBzdHJva2U9IiMwMDA4NTAiIHN0cm9rZS13aWR0aD0iMS4xMTM4NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00LjkwMDE1IDEzSDEwLjEwMDEiIHN0cm9rZT0iIzAwMDg1MCIgc3Ryb2tlLXdpZHRoPSIxLjExMzg1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTcuNDk5NzYgMTAuNDIxNFYxMy4wMDAxIiBzdHJva2U9IiMwMDA4NTAiIHN0cm9rZS13aWR0aD0iMS4xMTM4NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik05LjYwMDEgNkw4LjEwMDEgNC41TDkuNjAwMSAzIiBzdHJva2U9IiMwMDA4NTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNS42MDAxIDVMNy4xMDAxIDYuNUw1LjYwMDEgOCIgc3Ryb2tlPSIjMDAwODUwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+';var RecordingConsoleSvg='data:image/svg+xml;base64,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';var RecordingIconSvg='data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDE2IDEyIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzEyM2JlNTt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNOSwzYTIsMiwwLDAsMSwyLDJ2NmEyLDIsMCwwLDEtMiwySDNhMiwyLDAsMCwxLTItMlY1QTIsMiwwLDAsMSwzLDNIOU05LDJIM0EzLDMsMCwwLDAsMCw1djZhMywzLDAsMCwwLDMsM0g5YTMsMywwLDAsMCwzLTNWNUEzLDMsMCwwLDAsOSwyWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtMikiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xNSw1LjN2NS40TDEyLjIyLDEwQS40My40MywwLDAsMSwxMiw5LjY3VjYuMzNBLjQzLjQzLDAsMCwxLDEyLjIyLDZMMTUsNS4zbS4yNy0xLjA3LS4yNCwwTDEyLDUuMDhhMS4zNiwxLjM2LDAsMCwwLTEsMS4yNVY5LjY3YTEuMzYsMS4zNiwwLDAsMCwxLDEuMjVsMy4wNi44Mi4yNCwwQS43Mi43MiwwLDAsMCwxNiwxMVY1YS43Mi43MiwwLDAsMC0uNzMtLjc3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtMikiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik02LDYuNUExLjUsMS41LDAsMSwxLDQuNSw4LDEuNSwxLjUsMCwwLDEsNiw2LjVtMC0xQTIuNSwyLjUsMCwxLDAsOC41LDgsMi41LDIuNSwwLDAsMCw2LDUuNVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTIpIi8+PC9zdmc+';var ResetEnrollmentSvg='data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMyIgdmlld0JveD0iMCAwIDIyIDIzIiBmaWxsPSJub25lIj4KPHBhdGggZD0iTTE2Ljg1OTYgMi45Mzg5NkwxNy4wOTcyIDYuMTUwNDRMMTMuODg1NyA2LjM4OCIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE2Ljg4NjYgNS45MjU3MkMxNC4zODgxIDMuMzM4MjkgMTAuMzcwMSAyLjY3ODk1IDcuMTIyNTUgNC41NTM5NUMzLjI5NDcxIDYuNzYzOTUgMS45ODQzNCAxMS42NTQzIDQuMTk0MzQgMTUuNDgyMUM2LjE5NzUxIDE4Ljk1MTcgMTAuNDAyOCAyMC4zNTMgMTQuMDIyOSAxOC45MzkyIiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOC4wMjI5NSA5LjUzOTU1SDEzLjAyMjkiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik04LjAxODggMTIuMDM5NkwxMi4wMTg4IDEyLjAzOTYiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik04LjAxODggMTQuNTM5NkwxMS4wMTg4IDE0LjUzOTYiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNi43MjY0IDkuNTE4MjlDMTYuODQ1OSA5LjMxMTI3IDE3LjA0MjggOS4xNjAyIDE3LjI3MzcgOS4wOTgzM0MxNy41MDQ2IDkuMDM2NDcgMTcuNzUwNiA5LjA2ODg1IDE3Ljk1NzYgOS4xODgzOEMxOC4xNjQ3IDkuMzA3OSAxOC4zMTU3IDkuNTA0NzcgMTguMzc3NiA5LjczNTY3QzE4LjQzOTUgOS45NjY1NyAxOC40MDcxIDEwLjIxMjYgMTguMjg3NSAxMC40MTk2TDE1LjQzMzMgMTUuMzYzMkwxMy45MDE3IDE2LjIxMzVMMTMuODcyMiAxNC40NjE5TDE2LjcyNjQgOS41MTgyOVoiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==';var ResetPasswordSvg='data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDIwIDE3IiBmaWxsPSJub25lIj4KPHBhdGggZD0iTTE4LjYyIDMuOTY5NzNMMTcuMjIgNi44Njk3M0wxNC4zMiA1LjQ2OTczIiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTcuMTUgNi41N0MxNi4yOCAzLjA4IDEzLjEzIDAuNSA5LjM4MDAyIDAuNUM0Ljk2MDAyIDAuNSAxLjM4MDAyIDQuMDggMS4zODAwMiA4LjVDMS4zODAwMiAxMi45MiA0Ljk2MDAyIDE2LjUgOS4zODAwMiAxNi41QzEyLjQ2IDE2LjUgMTUuMTMgMTQuNzYgMTYuNDcgMTIuMjEiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMi41IDExLjcwMDJWNy43MDAyQzEyLjUgNy40MjQwNSAxMi4yNzYxIDcuMjAwMiAxMiA3LjIwMDJIN0M2LjcyMzg2IDcuMjAwMiA2LjUgNy40MjQwNSA2LjUgNy43MDAyVjExLjcwMDJDNi41IDExLjk3NjMgNi43MjM4NiAxMi4yMDAyIDcgMTIuMjAwMkgxMkMxMi4yNzYxIDEyLjIwMDIgMTIuNSAxMS45NzYzIDEyLjUgMTEuNzAwMloiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTEuNSA3LjIwMDJWNi4yMDAyQzExLjUgNS4wOTU2MyAxMC42MDQ2IDQuMjAwMiA5LjUgNC4yMDAyVjQuMjAwMkM4LjM5NTQzIDQuMjAwMiA3LjUgNS4wOTU2MyA3LjUgNi4yMDAyVjcuMjAwMiIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+';var RestoreSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuNjQ5MDEgMTMuOTg1OEg4LjI0OTAxQzEwLjg3OSAxMy45ODU4IDEzLjAwOSAxMS44NTU4IDEzLjAwOSA5LjIyNTgyQzEzLjAwOSA2LjU5NTgyIDEwLjg3OSA0LjQ2NTgyIDguMjQ5MDEgNC40NjU4MkgxLjY0OTAxIiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik01LjA5OTA0IDcuOTQ1ODRMMS42MTkwNCA0LjQ2NTg0TDUuMDk5MDQgMC45ODU4NCIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4=';var RestoreSelectedSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuNjQ5MDEgMTMuNzk1NEg4LjI0OTAxQzEwLjg3OSAxMy43OTU0IDEzLjAwOSAxMS42NjU0IDEzLjAwOSA5LjAzNTM5QzEzLjAwOSA2LjQwNTM5IDEwLjg3OSA0LjI3NTM5IDguMjQ5MDEgNC4yNzUzOUgxLjY0OTAxIiBzdHJva2U9IndoaXRlIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNNS4wOTkwNCA3Ljc1NTQxTDEuNjE5MDQgNC4yNzU0MUw1LjA5OTA0IDAuNzk1NDEiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPg==';var RotationSvg='data:image/svg+xml;base64,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';var RotationDisabledSvg='data:image/svg+xml;base64,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';var SearchSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMzMzMzMgMTIuNjY2N0MxMC4yNzg5IDEyLjY2NjcgMTIuNjY2NyAxMC4yNzg5IDEyLjY2NjcgNy4zMzMzM0MxMi42NjY3IDQuMzg3ODEgMTAuMjc4OSAyIDcuMzMzMzMgMkM0LjM4NzgxIDIgMiA0LjM4NzgxIDIgNy4zMzMzM0MyIDEwLjI3ODkgNC4zODc4MSAxMi42NjY3IDcuMzMzMzMgMTIuNjY2N1oiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNC4wMDAxIDE0LjAwMDFMMTEuMTAwMSAxMS4xMDAxIiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var SearchClickedSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMzMzMzMgMTIuNjY2N0MxMC4yNzg5IDEyLjY2NjcgMTIuNjY2NyAxMC4yNzg5IDEyLjY2NjcgNy4zMzMzM0MxMi42NjY3IDQuMzg3ODEgMTAuMjc4OSAyIDcuMzMzMzMgMkM0LjM4NzgxIDIgMiA0LjM4NzgxIDIgNy4zMzMzM0MyIDEwLjI3ODkgNC4zODc4MSAxMi42NjY3IDcuMzMzMzMgMTIuNjY2N1oiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNC4wMDAxIDE0LjAwMDFMMTEuMTAwMSAxMS4xMDAxIiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var SearchHoverSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMzMzMzMgMTIuNjY2N0MxMC4yNzg5IDEyLjY2NjcgMTIuNjY2NyAxMC4yNzg5IDEyLjY2NjcgNy4zMzMzM0MxMi42NjY3IDQuMzg3ODEgMTAuMjc4OSAyIDcuMzMzMzMgMkM0LjM4NzgxIDIgMiA0LjM4NzgxIDIgNy4zMzMzM0MyIDEwLjI3ODkgNC4zODc4MSAxMi42NjY3IDcuMzMzMzMgMTIuNjY2N1oiIHN0cm9rZT0iIzAwMDg1MCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNC4wMDAxIDE0LjAwMDFMMTEuMTAwMSAxMS4xMDAxIiBzdHJva2U9IiMwMDA4NTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var SearchIconSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMzMzMzMgMTIuNjY2N0MxMC4yNzg5IDEyLjY2NjcgMTIuNjY2NyAxMC4yNzg5IDEyLjY2NjcgNy4zMzMzM0MxMi42NjY3IDQuMzg3ODEgMTAuMjc4OSAyIDcuMzMzMzMgMkM0LjM4NzgxIDIgMiA0LjM4NzgxIDIgNy4zMzMzM0MyIDEwLjI3ODkgNC4zODc4MSAxMi42NjY3IDcuMzMzMzMgMTIuNjY2N1oiIHN0cm9rZT0iIzAwMDg1MCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNC4wMDAxIDE0LjAwMDFMMTEuMTAwMSAxMS4xMDAxIiBzdHJva2U9IiMwMDA4NTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var SecureSvg='data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iI0ZGNjY0NSIgd2lkdGg9IjE4cHgiIGhlaWdodD0iMThweCI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTEyIDFMMyA1djZjMCA1LjU1IDMuODQgMTAuNzQgOSAxMiA1LjE2LTEuMjYgOS02LjQ1IDktMTJWNWwtOS00em03IDEwYzAgNC41Mi0yLjk4IDguNjktNyA5LjkzLTQuMDItMS4yNC03LTUuNDEtNy05LjkzVjYuM2w3LTMuMTEgNyAzLjExVjExem0tMTEuNTkuNTlMNiAxM2w0IDQgOC04LTEuNDEtMS40MkwxMCAxNC4xN3oiLz48L3N2Zz4=';var SecureGreySvg='data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iI0QxRDFEMSIgd2lkdGg9IjE4cHgiIGhlaWdodD0iMThweCI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTEyIDFMMyA1djZjMCA1LjU1IDMuODQgMTAuNzQgOSAxMiA1LjE2LTEuMjYgOS02LjQ1IDktMTJWNWwtOS00em03IDEwYzAgNC41Mi0yLjk4IDguNjktNyA5LjkzLTQuMDItMS4yNC03LTUuNDEtNy05LjkzVjYuM2w3LTMuMTEgNyAzLjExVjExem0tMTEuNTkuNTlMNiAxM2w0IDQgOC04LTEuNDEtMS40MkwxMCAxNC4xN3oiLz48L3N2Zz4=';var ShieldIconSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9InNoaWVsZC1jaGVjay0tc2hpZWxkLXByb3RlY3Rpb24tc2VjdXJpdHktZGVmZW5kLWNyaW1lLXdhci1jb3Zlci1jaGVjayI+CjxwYXRoIGlkPSJWZWN0b3IiIGQ9Ik03Ljk2Mzg4IDE2QzcuOTYzODggMTYgMi45MDQzNCAxNC4wMzEyIDEuNzAxNiA4LjgyODEyQzEuMjU2OTUgNi43NzA0NCAxLjAyMjAzIDQuNjc3OTQgMSAyLjU3ODc1TDcuOTYzODggMUwxNC45MzE4IDIuNTc4NzVDMTUuMTEyMiA0LjY5NzIxIDE0LjkzNDMgNi44MjkwMiAxNC40MDQ2IDguODk1NjNDMTMuMDM1NCAxNC4wMzEyIDcuOTYzODggMTYgNy45NjM4OCAxNloiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBpZD0iVmVjdG9yXzIiIGQ9Ik0xMS41IDUuNUw3LjUgMTBMNS41IDguNSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvZz4KPC9zdmc+';var SmbSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNyAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjUgMUgyLjVDMS42NzE1NyAxIDEgMS43Njc1MSAxIDIuNzE0MjlWMTEuMjg1N0MxIDEyLjIzMjUgMS42NzE1NyAxMyAyLjUgMTNIMTQuNUMxNS4zMjg0IDEzIDE2IDEyLjIzMjUgMTYgMTEuMjg1N1YyLjcxNDI5QzE2IDEuNzY3NTEgMTUuMzI4NCAxIDE0LjUgMVoiIHN0cm9rZT0iIzAwMDg1MCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNCAxMC4yTDE0IDMuOEMxNCAzLjM1ODE3IDEzLjY2NDIgMyAxMy4yNSAzTDExLjc1IDNDMTEuMzM1OCAzIDExIDMuMzU4MTcgMTEgMy44TDExIDEwLjJDMTEgMTAuNjQxOCAxMS4zMzU4IDExIDExLjc1IDExTDEzLjI1IDExQzEzLjY2NDIgMTEgMTQgMTAuNjQxOCAxNCAxMC4yWiIgc3Ryb2tlPSIjMDAwODUwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTkgMTAuMkw5IDMuOEM5IDMuMzU4MTcgOC42NjQyMSAzIDguMjUgM0w2Ljc1IDNDNi4zMzU3OSAzIDYgMy4zNTgxNyA2IDMuOEw2IDEwLjJDNiAxMC42NDE4IDYuMzM1NzkgMTEgNi43NSAxMUw4LjI1IDExQzguNjY0MjEgMTEgOSAxMC42NDE4IDkgMTAuMloiIHN0cm9rZT0iIzAwMDg1MCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00IDQuOUw0IDQuMUM0IDQuMDQ0NzcgMy44ODgwNyA0IDMuNzUgNEwzLjI1IDRDMy4xMTE5MyA0IDMgNC4wNDQ3NyAzIDQuMUwzIDQuOUMzIDQuOTU1MjMgMy4xMTE5MyA1IDMuMjUgNUwzLjc1IDVDMy44ODgwNyA1IDQgNC45NTUyMyA0IDQuOVoiIHN0cm9rZT0iIzAwMDg1MCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00IDcuOUw0IDcuMUM0IDcuMDQ0NzcgMy44ODgwNyA3IDMuNzUgN0wzLjI1IDdDMy4xMTE5MyA3IDMgNy4wNDQ3NyAzIDcuMUwzIDcuOUMzIDcuOTU1MjMgMy4xMTE5MyA4IDMuMjUgOEwzLjc1IDhDMy44ODgwNyA4IDQgNy45NTUyMyA0IDcuOVoiIHN0cm9rZT0iIzAwMDg1MCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==';var SortArrowSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgNUw1IDlMOSA1IiBzdHJva2U9IiMwMDA4NTAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxsaW5lIHgxPSI1IiB5MT0iLTQuMzcxMTRlLTA4IiB4Mj0iNSIgeTI9IjgiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4=';var SshSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjQgNEgzLjZDMi43MTYzNCA0IDIgNC43NTQ5NSAyIDUuNjg2MjRWMTQuMTE3NEMyIDE1LjA0ODcgMi43MTYzNCAxNS44MDM2IDMuNiAxNS44MDM2SDE2LjRDMTcuMjgzNyAxNS44MDM2IDE4IDE1LjA0ODcgMTggMTQuMTE3NFY1LjY4NjI0QzE4IDQuNzU0OTUgMTcuMjgzNyA0IDE2LjQgNFoiIHN0cm9rZT0iIzAwMDg1MCIgc3Ryb2tlLXdpZHRoPSIxLjExMzg1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTUuOTU3MDMgMTEuOTUwNEw4LjMwOTk3IDkuNDkxMzJMNS45NTcwMyA3LjAzMjIzIiBzdHJva2U9IiMwMDA4NTAiIHN0cm9rZS13aWR0aD0iMS4xMTM4NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMC4wOTQyIDEyLjc3MDVIMTMuMjMxNSIgc3Ryb2tlPSIjMDAwODUwIiBzdHJva2Utd2lkdGg9IjEuMTEzODUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var StatusIconApprovedSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiByeD0iMy41NDE2NyIgZmlsbD0iIzNEQzNBQiIvPgo8cGF0aCBkPSJNNC42NjY1IDcuOTk5OTJMNy4xMTA5NSAxMC42NjY2TDExLjk5OTggNS4zMzMyNSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjQxNjY3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+';var StatusIconFailedSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMTVDMTEuODY2IDE1IDE1IDExLjg2NiAxNSA4QzE1IDQuMTM0MDEgMTEuODY2IDEgOCAxQzQuMTM0MDEgMSAxIDQuMTM0MDEgMSA4QzEgMTEuODY2IDQuMTM0MDEgMTUgOCAxNVoiIGZpbGw9IiNEMjJDMkMiIHN0cm9rZT0iI0QyMkMyQyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik04IDVMOCA5IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8Y2lyY2xlIGN4PSI4IiBjeT0iMTIiIHI9IjEiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPg==';var StatusIconNotApprovedSvg='data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDY0ICg5MzUzNykgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+c3RhdHVzLWljb24tYXBwcm92ZWQgY29weSAyPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkFydGJvYXJkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtODguMDAwMDAwLCAtMzY3LjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0ic3RhdHVzLWljb24tYXBwcm92ZWQtY29weS0yIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4OC4wMDAwMDAsIDM2Ny4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUiIGZpbGw9IiNFNDFDMUMiIGZpbGwtcnVsZT0ibm9uemVybyIgeD0iMCIgeT0iMCIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiByeD0iMy41NDE2NyI+PC9yZWN0PgogICAgICAgICAgICAgICAgPGcgaWQ9IlBhdGgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcuODMzMzMzLCA4LjE2NjY2Nykgcm90YXRlKC00NS4wMDAwMDApIHRyYW5zbGF0ZSgtNy44MzMzMzMsIC04LjE2NjY2NykgdHJhbnNsYXRlKDQuMzMzMzMzLCA0LjY2NjY2NykiIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuNiI+CiAgICAgICAgICAgICAgICAgICAgPHBvbHlsaW5lIHBvaW50cz0iMy40OTk4ODc1IDAgMy40OTk4ODc1IDMuNTAxOTA1NzggMy40OTk4ODc1IDciPjwvcG9seWxpbmU+CiAgICAgICAgICAgICAgICAgICAgPGxpbmUgeDE9Ii0xLjEzNjg2ODM4ZS0xMyIgeTE9IjMuNTAwMDU2MjUiIHgyPSI3IiB5Mj0iMy41MDAwNTYyNSI+PC9saW5lPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=';var StatusIconSuccessSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMTVDMTEuODY2IDE1IDE1IDExLjg2NiAxNSA4QzE1IDQuMTM0MDEgMTEuODY2IDEgOCAxQzQuMTM0MDEgMSAxIDQuMTM0MDEgMSA4QzEgMTEuODY2IDQuMTM0MDEgMTUgOCAxNVoiIGZpbGw9IiMzREM0QUIiIHN0cm9rZT0iIzNFQkVCMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMC43OTk5IDYuMTU5MThMNy4wMzA2NyA5LjY1OTE4TDUuODk5OSA4LjYxMDIzIiBmaWxsPSIjM0RDNEFCIi8+CjxwYXRoIGQ9Ik0xMC43OTk5IDYuMTU5MThMNy4wMzA2NyA5LjY1OTE4TDUuODk5OSA4LjYxMDIzIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var SupervisorConsoleSvg='data:image/svg+xml;base64,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';var TelnetSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxNyAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgNi44NjQyNkgxNiIgc3Ryb2tlPSIjMDAwODUwIiBzdHJva2Utb3BhY2l0eT0iMC41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTcuNTAwMjQgMS44NjQyNlYxMS44NjQzIiBzdHJva2U9IiMwMDA4NTAiIHN0cm9rZS1vcGFjaXR5PSIwLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMS4wMDA3MyAyLjM2NDI2TDE2LjAwMDcgMS4zNjQyNlYxMi4zNjQzTDEuMDAwNzMgMTEuMzY0M1YyLjM2NDI2WiIgc3Ryb2tlPSIjMDAwODUwIiBzdHJva2Utb3BhY2l0eT0iMC41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+';var TemplateSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAxOCAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzIDNIMTVDMTUuNTMwNCAzIDE2LjAzOTEgMy4yMTA3MSAxNi40MTQyIDMuNTg1NzlDMTYuNzg5MyAzLjk2MDg2IDE3IDQuNDY5NTcgMTcgNVYxOUMxNyAxOS41MzA0IDE2Ljc4OTMgMjAuMDM5MSAxNi40MTQyIDIwLjQxNDJDMTYuMDM5MSAyMC43ODkzIDE1LjUzMDQgMjEgMTUgMjFIM0MyLjQ2OTU3IDIxIDEuOTYwODYgMjAuNzg5MyAxLjU4NTc5IDIwLjQxNDJDMS4yMTA3MSAyMC4wMzkxIDEgMTkuNTMwNCAxIDE5VjVDMSA0LjQ2OTU3IDEuMjEwNzEgMy45NjA4NiAxLjU4NTc5IDMuNTg1NzlDMS45NjA4NiAzLjIxMDcxIDIuNDY5NTcgMyAzIDNINSIgc3Ryb2tlPSIjMDAwODUwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEyIDFINkM1LjQ0NzcyIDEgNSAxLjQ0NzcyIDUgMlY0QzUgNC41NTIyOCA1LjQ0NzcyIDUgNiA1SDEyQzEyLjU1MjMgNSAxMyA0LjU1MjI4IDEzIDRWMkMxMyAxLjQ0NzcyIDEyLjU1MjMgMSAxMiAxWiIgc3Ryb2tlPSIjMDAwODUwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+';var TestConnectionSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDE0QzEzLjEwNDYgMTQgMTQgMTMuMTA0NiAxNCAxMkMxNCAxMC44OTU0IDEzLjEwNDYgMTAgMTIgMTBDMTAuODk1NCAxMCAxMCAxMC44OTU0IDEwIDEyQzEwIDEzLjEwNDYgMTAuODk1NCAxNCAxMiAxNFoiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00IDZDNS4xMDQ1NyA2IDYgNS4xMDQ1NyA2IDRDNiAyLjg5NTQzIDUuMTA0NTcgMiA0IDJDMi44OTU0MyAyIDIgMi44OTU0MyAyIDRDMiA1LjEwNDU3IDIuODk1NDMgNiA0IDZaIiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOC42NjY3NSA0SDEwLjY2NjdDMTEuMDIwNCA0IDExLjM1OTUgNC4xNDA0OCAxMS42MDk2IDQuMzkwNTJDMTEuODU5NiA0LjY0MDU3IDEyLjAwMDEgNC45Nzk3MSAxMi4wMDAxIDUuMzMzMzNWMTAiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00IDZWMTQiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==';var TrashSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgNEgyLjMzMzMzSDEzIiBzdHJva2U9IiNFMjI0MjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNC4zMzMyNSAzLjk5OTkyVjIuNjY2NTlDNC4zMzMyNSAyLjMxMjk2IDQuNDczNzMgMS45NzM4MiA0LjcyMzc4IDEuNzIzNzhDNC45NzM4MyAxLjQ3MzczIDUuMzEyOTYgMS4zMzMyNSA1LjY2NjU5IDEuMzMzMjVIOC4zMzMyNUM4LjY4Njg3IDEuMzMzMjUgOS4wMjYwMSAxLjQ3MzczIDkuMjc2MDYgMS43MjM3OEM5LjUyNjExIDEuOTczODIgOS42NjY1OSAyLjMxMjk2IDkuNjY2NTkgMi42NjY1OVYzLjk5OTkyTTExLjY2NjYgMy45OTk5MlYxMy4zMzMzQzExLjY2NjYgMTMuNjg2OSAxMS41MjYxIDE0LjAyNiAxMS4yNzYxIDE0LjI3NjFDMTEuMDI2IDE0LjUyNjEgMTAuNjg2OSAxNC42NjY2IDEwLjMzMzMgMTQuNjY2NkgzLjY2NjU5QzMuMzEyOTYgMTQuNjY2NiAyLjk3MzgyIDE0LjUyNjEgMi43MjM3OCAxNC4yNzYxQzIuNDczNzMgMTQuMDI2IDIuMzMzMjUgMTMuNjg2OSAyLjMzMzI1IDEzLjMzMzNWMy45OTk5MkgxMS42NjY2WiIgc3Ryb2tlPSIjRTIyNDI0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTUuNjY2NzUgNy4zMzMyNVYxMS4zMzMzIiBzdHJva2U9IiNFMjI0MjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOC4zMzMyNSA3LjMzMzI1VjExLjMzMzMiIHN0cm9rZT0iI0UyMjQyNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==';var UnlinkSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik03LjgwNzU5IDUuNDIyODFMMTAuNTM0NSAyLjY5NTkyQzExLjg0OTcgMS4zODA2NiAxMy45ODg5IDEuMzgwNjYgMTUuMzA0MSAyLjY5NTkyQzE2LjYxOTQgNC4wMTExOSAxNi42MTk0IDYuMTUwMyAxNS4zMDQxIDcuNDY1NTdMMTIuNTc3MiAxMC4xOTI1IiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CiAgICA8cGF0aCBkPSJNNS43NjQ4MyA3LjQ2NTU4TDMuMzggOS44NTA0QzIuMDY0NzQgMTEuMTY1NyAyLjA2NDc0IDEzLjMwNDggMy4zOCAxNC42MkM0LjY5NTI3IDE1LjkzNTMgNi44MzQzOCAxNS45MzUzIDguMTQ5NjUgMTQuNjJMMTAuNTM0NSAxMi4yMzUyIiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CiAgICA8cGF0aCBkPSJNNC44NzM1MyA0Ljg3MzVMMi44MjU5NiAyLjgyNTkzIiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CiAgICA8cGF0aCBkPSJNNi42MTc1OCAzLjg5MDY5VjEiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KICAgIDxwYXRoIGQ9Ik0zLjg5MDY5IDYuNjE3NjhIMSIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgogICAgPHBhdGggZD0iTTEzLjEzMTMgMTMuMTMxM0wxNS4xNzQgMTUuMTc0MSIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgogICAgPHBhdGggZD0iTTE0LjEwOTMgMTEuMzg3MkgxNyIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgogICAgPHBhdGggZD0iTTExLjM4NzIgMTQuMTA5NFYxNy4wMDAxIiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPg==';var UpdatePasswordSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjUgMTMuNUMxNi41IDE1LjEgMTUuMSAxNi41IDEzLjUgMTYuNUgzLjVDMS45IDE2LjUgMC41IDE1LjEgMC41IDEzLjVWNy41QzAuNSA1LjggMS45IDQuNSAzLjUgNC41SDEzLjVDMTUuMSA0LjUgMTYuNSA1LjggMTYuNSA3LjVWMTMuNVoiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00LjUgNC41QzQuNSA0LjUgNC41IDMuNiA0LjUgMi41QzQuNSAxLjQgNS44IDAuNSA3LjUgMC41SDkuNUMxMS4xIDAuNSAxMi41IDEuNCAxMi41IDIuNUMxMi41IDMuNiAxMi41IDQuNSAxMi41IDQuNSIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTQuNSAxMS41QzUuMDUyMjggMTEuNSA1LjUgMTEuMDUyMyA1LjUgMTAuNUM1LjUgOS45NDc3MiA1LjA1MjI4IDkuNSA0LjUgOS41QzMuOTQ3NzIgOS41IDMuNSA5Ljk0NzcyIDMuNSAxMC41QzMuNSAxMS4wNTIzIDMuOTQ3NzIgMTEuNSA0LjUgMTEuNVoiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik04LjUgMTEuNUM5LjA1MjI4IDExLjUgOS41IDExLjA1MjMgOS41IDEwLjVDOS41IDkuOTQ3NzIgOS4wNTIyOCA5LjUgOC41IDkuNUM3Ljk0NzcyIDkuNSA3LjUgOS45NDc3MiA3LjUgMTAuNUM3LjUgMTEuMDUyMyA3Ljk0NzcyIDExLjUgOC41IDExLjVaIiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTIuNSAxMS41QzEzLjA1MjMgMTEuNSAxMy41IDExLjA1MjMgMTMuNSAxMC41QzEzLjUgOS45NDc3MiAxMy4wNTIzIDkuNSAxMi41IDkuNUMxMS45NDc3IDkuNSAxMS41IDkuOTQ3NzIgMTEuNSAxMC41QzExLjUgMTEuMDUyMyAxMS45NDc3IDExLjUgMTIuNSAxMS41WiIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+';var UploadSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjY2NjcgMTEuNjY2N0w4LjAwMDA4IDkuMDAwMDhMNS4zMzM0MSAxMS42NjY3IiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOC4wMDAxMiAxNUw4LjAwMDEyIDkiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMy45MiAxMi4wNkMxNC40OTk2IDExLjY1MjQgMTQuOTM0MiAxMS4wNzA3IDE1LjE2MDggMTAuMzk5NEMxNS4zODc0IDkuNzI4MDUgMTUuMzk0MiA5LjAwMTk3IDE1LjE4MDIgOC4zMjY1MUMxNC45NjYyIDcuNjUxMDQgMTQuNTQyNSA3LjA2MTM1IDEzLjk3MDcgNi42NDNDMTMuMzk4OCA2LjIyNDY0IDEyLjcwODUgNS45OTk0IDEyIDUuOTk5OTZIMTEuMTZDMTAuOTU5NCA1LjIxODU0IDEwLjU4NDMgNC40OTI3OSAxMC4wNjI3IDMuODc3MzRDOS41NDExMiAzLjI2MTkgOC44ODY3MiAyLjc3MjggOC4xNDg3NiAyLjQ0Njg2QzcuNDEwOCAyLjEyMDkyIDYuNjA4NTIgMS45NjY2NCA1LjgwMjMxIDEuOTk1NjNDNC45OTYwOSAyLjAyNDYzIDQuMjA2OTYgMi4yMzYxNCAzLjQ5NDMyIDIuNjE0MjRDMi43ODE2OCAyLjk5MjM0IDIuMTY0MTEgMy41MjcxOSAxLjY4ODA4IDQuMTc4NTFDMS4yMTIwNiA0LjgyOTgzIDAuODg5OTkgNS41ODA2NSAwLjc0NjEyOSA2LjM3NDQ2QzAuNjAyMjY5IDcuMTY4MjYgMC42NDAzNjIgNy45ODQzNSAwLjg1NzU0MiA4Ljc2MTNDMS4wNzQ3MiA5LjUzODI1IDEuNDY1MzMgMTAuMjU1OCAxLjk5OTk2IDEwLjg2IiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var UploadFileSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xNCAxMFYxMi42NjY3QzE0IDEzLjAyMDMgMTMuODU5NSAxMy4zNTk0IDEzLjYwOTUgMTMuNjA5NUMxMy4zNTk0IDEzLjg1OTUgMTMuMDIwMyAxNCAxMi42NjY3IDE0SDMuMzMzMzNDMi45Nzk3MSAxNCAyLjY0MDU3IDEzLjg1OTUgMi4zOTA1MiAxMy42MDk1QzIuMTQwNDggMTMuMzU5NCAyIDEzLjAyMDMgMiAxMi42NjY3VjEwIiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgogICAgPHBhdGggZD0iTTExLjMzMzUgNS4zMzMyNUw4LjAwMDE2IDEuOTk5OTJMNC42NjY4MyA1LjMzMzI1IiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgogICAgPHBhdGggZD0iTTguMDAwMjQgMkw4LjAwMDI0IDEwIiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var UsersSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxOCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjYzNjQgMTQuMDkwOVYxMi42MzY0QzEyLjYzNjQgMTEuODY0OCAxMi4zMjk5IDExLjEyNDkgMTEuNzg0MyAxMC41NzkzQzExLjIzODggMTAuMDMzOCAxMC40OTg4IDkuNzI3MjYgOS43MjcyNyA5LjcyNzI2SDMuOTA5MDlDMy4xMzc1NSA5LjcyNzI2IDIuMzk3NjEgMTAuMDMzOCAxLjg1MjA1IDEwLjU3OTNDMS4zMDY0OSAxMS4xMjQ5IDEgMTEuODY0OCAxIDEyLjYzNjRWMTQuMDkwOSIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTYuODE3MjkgNi44MTgxOEM4LjQyMzk0IDYuODE4MTggOS43MjYzOSA1LjUxNTc0IDkuNzI2MzkgMy45MDkwOUM5LjcyNjM5IDIuMzAyNDQgOC40MjM5NCAxIDYuODE3MjkgMUM1LjIxMDY1IDEgMy45MDgyIDIuMzAyNDQgMy45MDgyIDMuOTA5MDlDMy45MDgyIDUuNTE1NzQgNS4yMTA2NSA2LjgxODE4IDYuODE3MjkgNi44MTgxOFoiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNy4wMDAyIDE0LjA5MDlWMTIuNjM2NEMxNi45OTk3IDExLjk5MTggMTYuNzg1MiAxMS4zNjU2IDE2LjM5MDMgMTAuODU2MkMxNS45OTU0IDEwLjM0NjggMTUuNDQyNSA5Ljk4Mjk1IDE0LjgxODQgOS44MjE4MSIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTExLjkwODIgMS4wOTQ1NEMxMi41MzQgMS4yNTQ3NiAxMy4wODg2IDEuNjE4NjkgMTMuNDg0NyAyLjEyODk1QzEzLjg4MDcgMi42MzkyMSAxNC4wOTU3IDMuMjY2NzggMTQuMDk1NyAzLjkxMjczQzE0LjA5NTcgNC41NTg2NyAxMy44ODA3IDUuMTg2MjQgMTMuNDg0NyA1LjY5NjVDMTMuMDg4NiA2LjIwNjc2IDEyLjUzNCA2LjU3MDY5IDExLjkwODIgNi43MzA5MSIgc3Ryb2tlPSIjMTIzQkU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+';var VSignBlueSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI2IiB2aWV3Qm94PSIwIDAgOCA2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMC45MDMzMiAzTDIuODcxMDYgNUw2LjgwNjU1IDEiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var VSignGreySvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI2IiB2aWV3Qm94PSIwIDAgOCA2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMC45MDMzMiAzTDIuODcxMDYgNUw2LjgwNjU1IDEiIHN0cm9rZT0iI0IyQjRDNCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var ViewBySvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMUwxIDQuNUw4IDhMMTUgNC41TDggMVoiIHN0cm9rZT0iIzEyM0JFNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xIDExLjVMOCAxNUwxNSAxMS41IiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMSA4TDggMTEuNUwxNSA4IiBzdHJva2U9IiMxMjNCRTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var VncSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxNCAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjk2NTYgMC44NjY2OTlIMi4xMDcyOUMxLjQyNjcxIDAuODY2Njk5IDAuODc1IDEuNDA4NjkgMC44NzUgMi4wNzcyOFY4LjEzMDE4QzAuODc1IDguNzk4NzYgMS40MjY3MSA5LjM0MDc2IDIuMTA3MjkgOS4zNDA3NkgxMS45NjU2QzEyLjY0NjIgOS4zNDA3NiAxMy4xOTc5IDguNzk4NzYgMTMuMTk3OSA4LjEzMDE4VjIuMDc3MjhDMTMuMTk3OSAxLjQwODY5IDEyLjY0NjIgMC44NjY2OTkgMTEuOTY1NiAwLjg2NjY5OVoiIHN0cm9rZT0iIzAwMDg1MCIgc3Ryb2tlLXdpZHRoPSIxLjExMzg1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTQuNTcyMDIgMTIuMTMzM0g5LjUwMTE4IiBzdHJva2U9IiMwMDA4NTAiIHN0cm9rZS13aWR0aD0iMS4xMTM4NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik03LjAzNjEzIDkuNzEyNFYxMi4xMzM2IiBzdHJva2U9IiMwMDA4NTAiIHN0cm9rZS13aWR0aD0iMS4xMTM4NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==';var WaitingEnrollmentSvg='data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNyIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDE3IDE3IiBmaWxsPSJub25lIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI0NThfNzI0KSI+CjxwYXRoIGQ9Ik03Ljk0NjQxIDEzLjUxNDJDNC40ODg3NyAxMy41MTQyIDEuNjg1OTcgMTAuODI4IDEuNjg1OTcgNy41MTQxNkMxLjY4NTk3IDQuMjAwMzYgNC40ODg3NyAxLjUxNDE2IDcuOTQ2NDEgMS41MTQxNkMxMC41MTMyIDEuNTE0MTYgMTIuNzIgMi45OTQ5NiAxMy42ODYgNS4xMTQxNiIgc3Ryb2tlPSIjMDAwODUwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTUuMTg1OTcgOC4yMTQxNkg4LjAwMTk3QzguMDUyNCA4LjIxNDE2IDguMTAyMzQgOC4yMDQyMyA4LjE0ODkyIDguMTg0OTNDOC4xOTU1MSA4LjE2NTYzIDguMjM3ODUgOC4xMzczNSA4LjI3MzUgOC4xMDE2OUM4LjMwOTE2IDguMDY2MDMgOC4zMzc0NSA4LjAyMzcgOC4zNTY3NCA3Ljk3NzExQzguMzc2MDQgNy45MzA1MiA4LjM4NTk3IDcuODgwNTkgOC4zODU5NyA3LjgzMDE2VjUuMDE0MTYiIHN0cm9rZT0iIzAwMDg1MCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMS4yNjk0IDE1LjUxNDJIMTUuMTAyNEMxNS40NDYyIDE1LjUxNDIgMTUuNzE5NiAxNS4yNCAxNS42ODI2IDE0LjkyNDJDMTUuNDQzOSAxMi44ODkyIDE0LjAxOTIgMTIuOTIyOCAxNC4wMTkyIDEyLjAxNDJDMTQuMDE5MiAxMS4xMDU1IDE1LjQ2MjEgMTEuMTU2IDE1LjY4MjQgOS4xMDQxMUMxNS43MTcyIDguNzg4MSAxNS40NDYyIDguNTE0MTYgMTUuMTAyNCA4LjUxNDE2SDExLjI2OTRDMTAuOTI1NiA4LjUxNDE2IDEwLjY1NTMgOC43ODgxIDEwLjY4OTQgOS4xMDQxMUMxMC45MDk3IDExLjE1NiAxMi4zNTI2IDExLjA4ODcgMTIuMzUyNiAxMi4wMTQyQzEyLjM1MjYgMTIuOTM5NiAxMC45Mjc5IDEyLjg4OTIgMTAuNjg5NCAxNC45MjQyQzEwLjY1MjIgMTUuMjQgMTAuOTI1NiAxNS41MTQyIDExLjI2OTQgMTUuNTE0MloiIHN0cm9rZT0iIzAwMDg1MCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMjQ1OF83MjQiPgo8cmVjdCB4PSIwLjY4NTk3NCIgeT0iMC41MTQxNiIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPg==';var WarningSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE4MjQxXzY4MjkxKSI+CjxjaXJjbGUgY3g9IjciIGN5PSI3IiByPSI2LjQiIHN0cm9rZT0iI0U0MUMxQyIgc3Ryb2tlLXdpZHRoPSIxLjIiLz4KPHBhdGggZD0iTTcgNC4yNjk1M1Y3LjI2OTUzIiBzdHJva2U9IiNFNDFDMUMiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTcgMTAuNDgwNUM2LjU5IDEwLjQ4MDUgNi4yNSAxMC4xNDA1IDYuMjUgOS43MzA0N0M2LjI1IDkuMzIwNDcgNi41OCA4Ljk4MDQ3IDcgOC45ODA0N0M3LjQxIDguOTgwNDcgNy43NSA5LjMyMDQ3IDcuNzUgOS43MzA0N0M3Ljc1IDEwLjE0MDUgNy40MSAxMC40ODA1IDcgMTAuNDgwNVoiIGZpbGw9IiNFNDFDMUMiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xODI0MV82ODI5MSI+CjxyZWN0IHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4=';var XIconSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDJMMiAxMCIgc3Ryb2tlPSIjMDAwODUwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIgMkwxMCAxMCIgc3Ryb2tlPSIjMDAwODUwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+';var XIconWhiteSvg='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgMUwxIDkiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMSAxTDkgOSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==';var XInactiveIconSvg='data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iOHB4IiBoZWlnaHQ9IjhweCIgdmlld0JveD0iMCAwIDggOCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNjQgKDkzNTM3KSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDx0aXRsZT5Hcm91cDwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+CiAgICAgICAgPGcgaWQ9IkFydGJvYXJkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTE1LjAwMDAwMCwgLTY2LjAwMDAwMCkiIHN0cm9rZT0iI0M4Q0NEOSIgc3Ryb2tlLXdpZHRoPSIxLjUiPgogICAgICAgICAgICA8ZyBpZD0iVmVjdG9yLTEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExNi4wMDAwMDAsIDY3LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwIj4KICAgICAgICAgICAgICAgICAgICA8bGluZSB4MT0iNS45MDMyMyIgeTE9IjAiIHgyPSItNS4yODQ2NjE2ZS0xNCIgeTI9IjYiIGlkPSJQYXRoIj48L2xpbmU+CiAgICAgICAgICAgICAgICAgICAgPGxpbmUgeDE9Ii01LjI4NDY2MTZlLTE0IiB5MT0iMCIgeDI9IjUuOTAzMjMiIHkyPSI2IiBpZD0iUGF0aCI+PC9saW5lPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=';var XiconSvg='data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTFweCIgaGVpZ2h0PSI5cHgiIHZpZXdCb3g9IjAgMCAxMSA5IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4KICAgICAgICA8ZyBpZD0iQXJ0Ym9hcmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMDA5LjAwMDAwMCwgLTE4OS4wMDAwMDApIiBzdHJva2U9IiMwMDA4NTAiPgogICAgICAgICAgICA8ZyBpZD0ieC1pY29uIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDEwLjAwMDAwMCwgMTg5LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGxpbmUgeDE9IjguNjY2ODMiIHkxPSIwLjMzMzI1IiB4Mj0iMC4zMzM1IiB5Mj0iOC42NjY1OSIgaWQ9IlBhdGgiPjwvbGluZT4KICAgICAgICAgICAgICAgIDxsaW5lIHgxPSIwLjMzMzUiIHkxPSIwLjMzMzI1IiB4Mj0iOC42NjY4MyIgeTI9IjguNjY2NTkiIGlkPSJQYXRoIj48L2xpbmU+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==';var Icon=function Icon(_ref){var id=_ref.id,_ref$size=_ref.size,size=_ref$size===void 0?16:_ref$size,_ref$style=_ref.style,style=_ref$style===void 0?{}:_ref$style;var selectedIcon;switch(id){case'columns':selectedIcon=ColumnsSvg;break;case'edit-clicked':selectedIcon=EditClickedSvg;break;case'https':selectedIcon=HttpsSvg;break;case'telnet':selectedIcon=TelnetSvg;break;case'search':selectedIcon=SearchSvg;break;case'checkmark':selectedIcon=CheckmarkSvg;break;case'update-password':selectedIcon=UpdatePasswordSvg;break;case'house':selectedIcon=HouseSvg;break;case'done-disabled':selectedIcon=DoneDisabledSvg;break;case'status-icon-success':selectedIcon=StatusIconSuccessSvg;break;case'pin-active':selectedIcon=PinActiveSvg;break;case'auto-refresh-start-icon':selectedIcon=AutoRefreshStartIconSvg;break;case'http':selectedIcon=HttpSvg;break;case'person':selectedIcon=PersonSvg;break;case'logout':selectedIcon=LogoutSvg;break;case'label-highrisk':selectedIcon=LabelHighriskSvg;break;case'secure':selectedIcon=SecureSvg;break;case'info-hover':selectedIcon=InfoHoverSvg;break;case'x-icon-white':selectedIcon=XIconWhiteSvg;break;case'export':selectedIcon=ExportSvg;break;case'v-sign-blue':selectedIcon=VSignBlueSvg;break;case'label-highrisk-grey':selectedIcon=LabelHighriskGreySvg;break;case'os-ios-icon':selectedIcon=OsIosIconSvg;break;case'line-arrow-up':selectedIcon=LineArrowUpSvg;break;case'info-clicked':selectedIcon=InfoClickedSvg;break;case'dropdown_menu_icon_down':selectedIcon=Dropdown_menu_icon_downSvg;break;case'rotation-disabled':selectedIcon=RotationDisabledSvg;break;case'file':selectedIcon=FileSvg;break;case'duplicate':selectedIcon=DuplicateSvg;break;case'permissions':selectedIcon=PermissionsSvg;break;case'shield-icon':selectedIcon=ShieldIconSvg;break;case'logs':selectedIcon=LogsSvg;break;case'x-icon':selectedIcon=XIconSvg;break;case'recording-icon':selectedIcon=RecordingIconSvg;break;case'supervisor-console':selectedIcon=SupervisorConsoleSvg;break;case'secure-grey':selectedIcon=SecureGreySvg;break;case'status-icon-approved':selectedIcon=StatusIconApprovedSvg;break;case'lock':selectedIcon=LockSvg;break;case'more-hover':selectedIcon=MoreHoverSvg;break;case'done-clicked':selectedIcon=DoneClickedSvg;break;case'checkmark-white':selectedIcon=CheckmarkWhiteSvg;break;case'search-hover':selectedIcon=SearchHoverSvg;break;case'approve':selectedIcon=ApproveSvg;break;case'open-keyboard':selectedIcon=OpenKeyboardSvg;break;case'personal-desktop-icon':selectedIcon=PersonalDesktopIconSvg;break;case'app-card-placeholder':selectedIcon=AppCardPlaceholderSvg;break;case'import-group':selectedIcon=ImportGroupSvg;break;case'mail':selectedIcon=MailSvg;break;case'download':selectedIcon=DownloadSvg;break;case'rotation':selectedIcon=RotationSvg;break;case'import':selectedIcon=ImportSvg;break;case'other-clicked':selectedIcon=OtherClickedSvg;break;case'enrollment':selectedIcon=EnrollmentSvg;break;case'circled-file':selectedIcon=CircledFileSvg;break;case'add-hover':selectedIcon=AddHoverSvg;break;case'arrow_up':selectedIcon=Arrow_upSvg;break;case'auto-refresh-stop-icon':selectedIcon=AutoRefreshStopIconSvg;break;case'xicon':selectedIcon=XiconSvg;break;case'duplicate-inactive':selectedIcon=DuplicateInactiveSvg;break;case'label-supervisor-grey':selectedIcon=LabelSupervisorGreySvg;break;case'back-blue':selectedIcon=BackBlueSvg;break;case'pin-inactive':selectedIcon=PinInactiveSvg;break;case'os-android-icon':selectedIcon=OsAndroidIconSvg;break;case'sort-arrow':selectedIcon=SortArrowSvg;break;case'warning':selectedIcon=WarningSvg;break;case'info':selectedIcon=InfoSvg;break;case'smb':selectedIcon=SmbSvg;break;case'add':selectedIcon=AddSvg;break;case'port':selectedIcon=PortSvg;break;case'os-win-icon':selectedIcon=OsWinIconSvg;break;case'admin-console':selectedIcon=AdminConsoleSvg;break;case'recording-console':selectedIcon=RecordingConsoleSvg;break;case'copy':selectedIcon=CopySvg;break;case'app-card-server-placeholder':selectedIcon=AppCardServerPlaceholderSvg;break;case'back-grey':selectedIcon=BackGreySvg;break;case'groups-filled':selectedIcon=GroupsFilledSvg;break;case'label-admin':selectedIcon=LabelAdminSvg;break;case'dash-white':selectedIcon=DashWhiteSvg;break;case'x-inactive-icon':selectedIcon=XInactiveIconSvg;break;case'forms':selectedIcon=FormsSvg;break;case'search-icon':selectedIcon=SearchIconSvg;break;case'add-group':selectedIcon=AddGroupSvg;break;case'exclamation-mark':selectedIcon=ExclamationMarkSvg;break;case'add-disabled':selectedIcon=AddDisabledSvg;break;case'eye-blue':selectedIcon=EyeBlueSvg;break;case'other-hover':selectedIcon=OtherHoverSvg;break;case'arrow_down':selectedIcon=Arrow_downSvg;break;case'clear-icon':selectedIcon=ClearIconSvg;break;case'edit-hover':selectedIcon=EditHoverSvg;break;case'os-mac-icon':selectedIcon=OsMacIconSvg;break;case'eye-cross-blue':selectedIcon=EyeCrossBlueSvg;break;case'groups-outlined':selectedIcon=GroupsOutlinedSvg;break;case'more':selectedIcon=MoreSvg;break;case'test-connection':selectedIcon=TestConnectionSvg;break;case'status-icon-not-approved':selectedIcon=StatusIconNotApprovedSvg;break;case'trash':selectedIcon=TrashSvg;break;case'more-clicked':selectedIcon=MoreClickedSvg;break;case'rdp':selectedIcon=RdpSvg;break;case'download-white':selectedIcon=DownloadWhiteSvg;break;case'template':selectedIcon=TemplateSvg;break;case'personal-desktop':selectedIcon=PersonalDesktopSvg;break;case'edit':selectedIcon=EditSvg;break;case'unlink':selectedIcon=UnlinkSvg;break;case'next':selectedIcon=NextSvg;break;case'view-by':selectedIcon=ViewBySvg;break;case'done-hover':selectedIcon=DoneHoverSvg;break;case'status-icon-failed':selectedIcon=StatusIconFailedSvg;break;case'v-sign-grey':selectedIcon=VSignGreySvg;break;case'delete':selectedIcon=DeleteSvg;break;case'question-mark':selectedIcon=QuestionMarkSvg;break;case'hamburger-menu-icon':selectedIcon=HamburgerMenuIconSvg;break;case'dropdown':selectedIcon=DropdownSvg;break;case'waiting-enrollment':selectedIcon=WaitingEnrollmentSvg;break;case'label-auditor':selectedIcon=LabelAuditorSvg;break;case'active-user':selectedIcon=ActiveUserSvg;break;case'dropdown_menu_icon_up':selectedIcon=Dropdown_menu_icon_upSvg;break;case'filter':selectedIcon=FilterSvg;break;case'ssh':selectedIcon=SshSvg;break;case'eye-gray':selectedIcon=EyeGraySvg;break;case'profile-default':selectedIcon=ProfileDefaultSvg;break;case'upload':selectedIcon=UploadSvg;break;case'reset-password':selectedIcon=ResetPasswordSvg;break;case'line-arrow-down':selectedIcon=LineArrowDownSvg;break;case'os-linux-icon':selectedIcon=OsLinuxIconSvg;break;case'done':selectedIcon=DoneSvg;break;case'upload-file':selectedIcon=UploadFileSvg;break;case'eye-cross-gray':selectedIcon=EyeCrossGraySvg;break;case'deny':selectedIcon=DenySvg;break;case'other':selectedIcon=OtherSvg;break;case'search-clicked':selectedIcon=SearchClickedSvg;break;case'vnc':selectedIcon=VncSvg;break;case'label-supervisor':selectedIcon=LabelSupervisorSvg;break;case'users':selectedIcon=UsersSvg;break;case'add-blue':selectedIcon=AddBlueSvg;break;case'pc-icon':selectedIcon=PcIconSvg;break;case'delete-inactive':selectedIcon=DeleteInactiveSvg;break;case'restore':selectedIcon=RestoreSvg;break;case'restore-selected':selectedIcon=RestoreSelectedSvg;break;case'reset-enrollment':selectedIcon=ResetEnrollmentSvg;break;default:selectedIcon='';break;}return/*#__PURE__*/React__default.createElement("img",{src:selectedIcon,alt:"",height:size,width:size,style:style});};var colors={baseGray:'#D4D7DB',black:'#000',pageBackground:'#F9FBFF',selected:'#123BE5',callToAction:'#FF6645',highRed:'#E22525',lowGreen:'#2BEABE',successGreen:'#26A891',tableTextGray:'#4F4F4F',failureRed:'#D22C2C',cardWhite:'#FFFFFF',textFieldBackground:'#F8F9FE',darkBlue:'#000850',textLightBlue:'#8084A7',inactiveTagText:'#B2B4C4',inactiveBackground:'#EEF1F5',disabledGrey:'#D1D1D1',inactiveWhite:'#F5F7FA',dividerBlue:'#ADB9E9',dividerGrey:'#DBDBDB',selectedTab:'#2C51E9',dialogBackground:'#EFF2F6',selectionBackground:'#E7F0FC',lightBlue:'rgba(18, 59, 229, 0.7)',dividerLightGrey:'#A0A3BD',inactiveToggleBackground:'#C8CCD9',labelSupervisorBackground:'#DFE9F8',labelAdminBackground:'#E8ECF0',labelHighriskBackground:'#FBDCDC',labelSupervisorText:'#6B88B5',labelAdminText:'#2C4D7E',labelHighriskText:'#DF5858',labelGreyText:'#B2B4C5',labelAuditorBackground:'#D4F2FF',labelAuditorText:'#1978A2',darkOrange:'#DF7858',lightOrange:'#FFE7DA',tableBody:'#4F4F4F',greyBlue:'#C5CADD',unselectedGrey:'#979BA9',disabledText:'#A0A3BD',lowRed:'#E22424',connectedGreenBackGround:'#D8ECEC',connectedGreen:'#35A994',lightGrey:'#828282',dividerGray:'#E7EAED',lightBlueBackground:'#428BF8',yellow:'#FFA73F',greenGrass:'#1EB99D',oceanBlue:'#428BF8',purpleHaze:'#956FD6',pinkLady:'#FD82B1',darkYellow:'#ECC550',greyOcean:'#7b80a5',lightPurple:'#A699F5'};var fonts$1={heebo:"'Heebo', sans-serif",montserrat:"'Montserrat', sans-serif"};/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */function __rest$1(s,e){var t={};for(var p in s){if(Object.prototype.hasOwnProperty.call(s,p)&&e.indexOf(p)<0)t[p]=s[p];}if(s!=null&&typeof Object.getOwnPropertySymbols==="function")for(var i=0,p=Object.getOwnPropertySymbols(s);i<p.length;i++){if(e.indexOf(p[i])<0&&Object.prototype.propertyIsEnumerable.call(s,p[i]))t[p[i]]=s[p[i]];}return t;}function r$1$1(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==_typeof(e))if(Array.isArray(e))for(t=0;t<e.length;t++){e[t]&&(f=r$1$1(e[t]))&&(n&&(n+=" "),n+=f);}else for(t in e){e[t]&&(n&&(n+=" "),n+=t);}return n;}function clsx$1(){for(var e,t,f=0,n="";f<arguments.length;){(e=arguments[f++])&&(t=r$1$1(e))&&(n&&(n+=" "),n+=t);}return n;}var styles$1={'page-header':{color:colors.darkBlue,fontWeight:300,fontFamily:fonts$1.montserrat,fontSize:'22px'},'header-1':{color:colors.textLightBlue,fontWeight:500,fontFamily:fonts$1.montserrat,fontSize:'14px'},'header-2':{color:colors.darkBlue,fontWeight:500,fontFamily:fonts$1.montserrat,fontSize:'15px'},'header-3':{color:colors.darkBlue,fontWeight:500,fontFamily:fonts$1.montserrat,fontSize:'13px'},'card-header-big':{color:colors.darkBlue,fontWeight:600,fontFamily:fonts$1.montserrat,fontSize:'15px'},body:{color:colors.darkBlue,fontWeight:400,fontFamily:fonts$1.heebo,fontSize:'13px'},'user-name':{color:colors.cardWhite,fontWeight:'normal',fontFamily:fonts$1.heebo,fontSize:'14px'},'toast-message':{color:colors.cardWhite,fontWeight:500,fontFamily:fonts$1.heebo,fontSize:'14px'},'app-number-title':{color:colors.darkBlue,fontWeight:'normal',fontFamily:fonts$1.montserrat,fontSize:'20px'},'protocol-title':{fontWeight:500,fontFamily:fonts$1.heebo,fontSize:'21px'},'default-tab':{fontWeight:500,fontFamily:fonts$1.heebo,fontSize:'13px',color:colors.textLightBlue},'login-title':{color:colors.darkBlue,fontFamily:fonts$1.montserrat,fontSize:'48px',fontWeight:500},tag:{color:colors.cardWhite,fontFamily:fonts$1.heebo,fontSize:'11px',fontWeight:400},'status-banner':{color:colors.cardWhite,fontFamily:fonts$1.heebo,fontSize:'11px',fontWeight:500},'login-sub-title':{color:colors.darkBlue,fontFamily:fonts$1.montserrat,fontSize:'22px',fontWeight:500},'login-contact-comment':{color:colors.textLightBlue,fontFamily:fonts$1.heebo,fontSize:'13px',fontWeight:'normal'},'table-body':{color:colors.tableBody,fontFamily:fonts$1.heebo,fontSize:'13px',fontWeight:'normal'},'subnav-header':{color:colors.darkBlue,fontFamily:fonts$1.montserrat,fontSize:'18px',fontWeight:600},'subnav-header-light':{color:colors.darkBlue,fontFamily:fonts$1.montserrat,fontSize:'18px',fontWeight:400},'table-total-header':{color:colors.textLightBlue,fontFamily:fonts$1.montserrat,fontSize:'16px',fontWeight:500},'header-4':{fontSize:'11px',fontStyle:'normal',fontWeight:500,fontFamily:fonts$1.montserrat,color:colors.darkBlue},'console-app-title':{color:colors.darkBlue,fontFamily:fonts$1.montserrat,fontSize:'16px',fontWeight:500},'console-app-body':{color:colors.lightGrey,fontFamily:fonts$1.heebo,fontSize:'11px',fontWeight:'normal'},'sidenav-sub-option':{color:colors.unselectedGrey,fontFamily:fonts$1.heebo,fontWeight:'normal',fontSize:'11px'}};var useStyles$o$1=createUseStyles({textField:function textField(_ref){var variant=_ref.variant;return styles$1[variant];}});/**
 *
 * text props:
 * component will resolve in the html tag (by defualt p tag)
 * variant will apply styling for the element
 */var Text$1=function Text(_a){var children=_a.children,style=_a.style,variant=_a.variant,_a$component=_a.component,component=_a$component===void 0?'p':_a$component,color=_a.color,title=_a.title,_a$className=_a.className,className=_a$className===void 0?'':_a$className,props=__rest$1(_a,["children","style","variant","component","color","title","className"]);var variantStyle=useStyles$o$1({variant:variant});var textClassName=useMemo(function(){return clsx$1('CyoloUI-Text',className,variantStyle.textField);},[className,variantStyle]);// making it so empty color doesnt rewrite variant style colors
var dynamicStyle=useMemo(function(){return color?Object.assign(Object.assign({},style),{color:color}):style;},[color,style]);var ComponentTag=useMemo(function(){return "".concat(component);},[component]);return/*#__PURE__*/React__default.createElement(ComponentTag,Object.assign({className:textClassName,style:dynamicStyle,title:title},props),children);};var ClickDurationMili$2=250;var resolveBackgroundCardColor$1=function resolveBackgroundCardColor(variant,hover,clicked,disabled){if(disabled)return '#EEF1F5';if(['done','add'].includes(variant)&&hover&&!clicked)return '#FFF';else return '#FF532E';};var resolveIcon$2=function resolveIcon(variant,clicked,hover,disabled){if(disabled){switch(variant){case'done':return 'done-disabled';default:return 'add-disabled';}}if(hover&&!clicked){switch(variant){case'done':return 'done-hover';default:return 'add-hover';}}switch(variant){case'add':return 'add';case'next':return 'next';case'done':return 'done';}};var resolveText=function resolveText(variant){switch(variant){case'done':return 'Done';case'add':return 'Add user';case'next':return 'Next';}};var resolveTextColor=function resolveTextColor(variant,disabled){if(disabled)return colors.disabledGrey;switch(variant){case'add':return colors.darkBlue;default:return colors.callToAction;}};var ActionButton=/*#__PURE__*/function(_Component){_inherits(ActionButton,_Component);var _super=_createSuper(ActionButton);function ActionButton(){var _this;_classCallCheck$1(this,ActionButton);_this=_super.apply(this,arguments);_this.state={hovered:false,clicked:false};_this.handleMouseEnter=function(){_this.setState({hovered:true});};_this.handleMouseLeave=function(){_this.setState({hovered:false});};_this.handleClick=function(){var onClick=_this.props.onClick;if(_this.clickTimeoutId)window.clearTimeout(_this.clickTimeoutId);_this.setState({clicked:true});_this.clickTimeoutId=window.setTimeout(function(){_this.setState({clicked:false});},ClickDurationMili$2);// call original props onClick
onClick&&onClick();};return _this;}_createClass(ActionButton,[{key:"componentWillUnmount",value:function componentWillUnmount(){if(this.clickTimeoutId)window.clearTimeout(this.clickTimeoutId);}},{key:"render",value:function render(){var _this$props=this.props,text=_this$props.text,variant=_this$props.variant,_this$props$disabled=_this$props.disabled,disabled=_this$props$disabled===void 0?false:_this$props$disabled,style=_this$props.style;var _this$state=this.state,hovered=_this$state.hovered,clicked=_this$state.clicked;var classes=['CyoloUI-ActionButton-Card'];if(disabled){classes.push('CyoloUI-ActionButton-Disabled');}if(clicked){classes.push('CyoloUI-ActionButton-Card-Clicked');}return/*#__PURE__*/React__default.createElement("div",{className:"CyoloUI-ActionButton",onMouseEnter:this.handleMouseEnter,onMouseLeave:this.handleMouseLeave,onClick:this.handleClick,style:style},/*#__PURE__*/React__default.createElement("div",{className:classes.join(' '),style:{backgroundColor:resolveBackgroundCardColor$1(variant,hovered,clicked,disabled)}},/*#__PURE__*/React__default.createElement(Icon,{id:resolveIcon$2(variant,clicked,hovered,disabled)})),/*#__PURE__*/React__default.createElement(Text$1,{variant:'body',color:resolveTextColor(variant,disabled),style:{marginLeft:'12px',fontSize:'13px'}},text||resolveText(variant)));}}]);return ActionButton;}(Component);var ActionIcon=/*#__PURE__*/function(_Component){_inherits(ActionIcon,_Component);var _super=_createSuper(ActionIcon);function ActionIcon(props){var _this;_classCallCheck$1(this,ActionIcon);_this=_super.call(this,props);_this.handleOnSelected=function(event){var onClick=_this.props.onClick;// if timeout already exists, clear it
if(_this.selectedTimeoutId)window.clearTimeout(_this.selectedTimeoutId);// update the state
_this.setState({clicked:true});// create a new timeout
_this.selectedTimeoutId=window.setTimeout(function(){_this.setState({clicked:false});_this.selectedTimeoutId=undefined;},400);onClick&&onClick(event);};_this.state={clicked:false};return _this;}_createClass(ActionIcon,[{key:"componentWillUnmount",value:function componentWillUnmount(){if(this.selectedTimeoutId)window.clearTimeout(this.selectedTimeoutId);}},{key:"render",value:function render(){var _this$props=this.props,children=_this$props.children,_this$props$iconName=_this$props.iconName,iconName=_this$props$iconName===void 0?undefined:_this$props$iconName,_this$props$enabled=_this$props.enabled,enabled=_this$props$enabled===void 0?true:_this$props$enabled,text=_this$props.text,_this$props$className=_this$props.className,className=_this$props$className===void 0?'':_this$props$className;var clicked=this.state.clicked;// the root div classes arrays
var classes=['CyoloUI-ActionIcon-Icon'];// selected text color defines what will be the color
// of the text in case its selected
var selectedTextColor=colors.selected;// check if the icon is the delete icon
if(iconName==='delete'){classes.push('CyoloUI-ActionIcon-Icon-Delete');selectedTextColor=colors.lowRed;}// textColor is the actual text color to be shown
var textColor=clicked?selectedTextColor:colors.darkBlue;return/*#__PURE__*/React__default.createElement("div",{className:"CyoloUI-ActionIcon ".concat(className),style:enabled?null:{pointerEvents:'none'},onClick:this.handleOnSelected},iconName&&/*#__PURE__*/React__default.createElement("div",{className:classes.join(' ')},/*#__PURE__*/React__default.createElement(Icon,{id:iconName})),Boolean((text===null||text===void 0?void 0:text.length)||children)&&/*#__PURE__*/React__default.createElement("div",{className:"CyoloUI-ActionIcon-Text"},/*#__PURE__*/React__default.createElement(Text$1,{variant:"body",color:textColor},text||children)));}}]);return ActionIcon;}(Component);var StandaloneLoadingIndicator=function StandaloneLoadingIndicator(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?'white':_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?64:_ref$size;var ringClass;switch(color){case'white':ringClass='CyoloUI-Rings-White';break;case'blue':ringClass='CyoloUI-Rings-Blue';break;case'orange':ringClass='CyoloUI-Rings-Orange';break;}var borderSize=size/8;return/*#__PURE__*/React__default.createElement("div",{className:['CyoloUI-Rings',ringClass].join(' '),style:{height:size,width:size}},Array(4).fill(undefined).map(function(_,i){return/*#__PURE__*/React__default.createElement("div",{key:i,style:{height:size,width:size,border:"".concat(borderSize,"px solid #fff")}});}));};var LoadingIndicator=function LoadingIndicator(_ref){var message=_ref.message,_ref$color=_ref.color,color=_ref$color===void 0?'white':_ref$color;return/*#__PURE__*/React__default.createElement("div",{className:"CyoloUI-LoadingIndicator-root"},/*#__PURE__*/React__default.createElement(StandaloneLoadingIndicator,{color:color}),message&&/*#__PURE__*/React__default.createElement("p",{className:"CyoloUI-LoadingIndicator-message"},message));};/**
 * base colors for theme
 */var colorPalette={primary:'#123be5',secondary:'#000850',gray:'#4F4F4F',black:'#000000',white:'#ffffff',natural:'#eff2f6',naturalDisabled:'#f8f9fa',error:'#E41C1C',success:'#3dc3ab',warning:'#ff6645',info:'#0DCAF0',border:'#DEE2E6'};/**
 * return all contrast options of base color (light, dark, extraLight etc..)
 * the the base color is set to "color" attr
 */var getColorContrastOptions=function getColorContrastOptions(baseColor){var dark=arguments.length>1&&arguments[1]!==undefined?arguments[1]:colorPalette.white;return {extraLight:addAlpha(colorLuminance(baseColor,'200'),0.6),light:addAlpha(colorLuminance(baseColor,'400'),0.8),color:baseColor,dark:colorLuminance(baseColor,'600'),extraDark:colorLuminance(baseColor,'800'),darkMode:dark};};/**
 * luminte hex colors
 * use: colorLuminance("#6699CC", 600);
 */var colorLuminance=function colorLuminance(hex){var lum=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'500';var contrastToDecimal={'200':0.8,'400':0.4,'600':-0.4,'800':-0.8};// validate hex
hex=String(hex).replace(/[^0-9a-f]/gi,'');if(hex.length<6){hex=hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];}// convert to decimal and change luminosity
var decLum=contrastToDecimal[lum]||0;var rgb='#',c,i;for(i=0;i<3;i++){c=parseInt(hex.substr(i*2,2),16);c=Math.round(Math.min(Math.max(0,c+c*decLum),255)).toString(16);rgb+=('00'+c).substr(c.length);}return rgb;};// return an array of hex representaion for the RGB colors.
// ['f', f', 'f', 'f', 'f', 'f'] => ['ff', 'ff', 'ff']
var hexAsRgbSplitReducer=function hexAsRgbSplitReducer(acc,_,index,str){if(index%2==0){var firstChar=str[index]?str[index]:'';var secondChar=str[index+1]?str[index+1]:'';acc=[].concat(_toConsumableArray(acc),[firstChar+secondChar]);}return acc;};// add alpha(opacity) to given color & return hex
function addAlpha(color,alpha){if(alpha==1){return color;}var background=0xf5;var hex=String(color).replace(/[^0-9a-f]/gi,'');var hexAsRgbWithAlpha=hex.split('').reduce(hexAsRgbSplitReducer,[]).map(function(i){return Math.floor(parseInt("0x".concat(i),16)*alpha+background*(1-alpha));});return '#'+(hexAsRgbWithAlpha[0]<<16|hexAsRgbWithAlpha[1]<<8|hexAsRgbWithAlpha[2]).toString(16);}var fontSizeBase=13;var fonts={heebo:"'Heebo', sans-serif",montserrat:"'Montserrat', sans-serif"};/**
 * apps cyolo Theme
 *
 * getColorContrastOptions structure:
 *  'extraLight': #colorString,
 *  'Light': #colorString,
 *  'color': #colorString,
 *  'dark': #colorString,
 *  'extraDark': #colorString
 *  'darkMode': #colorString,
 */var defaultTheme$1={version:1,mode:null,direction:'ltr',palette:{primary:getColorContrastOptions(colorPalette.primary),black:{color:colorPalette.black},white:{color:colorPalette.white},background:{color:colorPalette.natural},backgroundDisabled:{color:colorPalette.naturalDisabled},text:{color:colorPalette.natrual},grey:getColorContrastOptions(colorPalette.gray),error:getColorContrastOptions(colorPalette.error),success:getColorContrastOptions(colorPalette.success),warning:getColorContrastOptions(colorPalette.warning),secondary:getColorContrastOptions(colorPalette.secondary),info:getColorContrastOptions(colorPalette.info),border:getColorContrastOptions(colorPalette.border)},shape:{borderRadius:10,borderRadiusLight:4,borderRadiusHeavy:20,borderRadiusCircle:'50%'},typography:{fontBaseSize:fontSizeBase,h1:{fontSize:'clamp(2.625rem, 1.2857rem + 3.5714vw, 4rem)',fontWeight:800,fontFamily:fonts.montserrat},h2:{fontSize:'clamp(1.5rem, 0.9643rem + 1.4286vw, 2.25rem)',fontWeight:800,fontFamily:fonts.montserrat},h3:{fontSize:'2.25rem',fontWeight:400,fontFamily:fonts.montserrat},h4:{fontSize:'1.75rem',fontWeight:400,fontFamily:fonts.montserrat},h5:{fontSize:'1rem',fontWeight:600,fontFamily:fonts.montserrat},p:{fontSize:'1rem',fontWeight:400,fontFamily:fonts.heebo},li:{fontSize:'1rem',fontWeight:400,fontFamily:fonts.heebo},fontWeightLight:300,fontWeightRegular:400,fontWeightMedium:500,fontWeightBold:700},shadows:['0px 1px 15px rgba(0, 41, 146, 0.07)','1px 1px 25px rgba(0, 0, 0, 0.1)'],transitions:{slow:'1s ease-in-out',medium:'.5s ease-in-out',fast:'.2s ease-in-out'},zIndex:{normal:0,medium:250,high:500,max:1000}};var cyTheme=Object.assign({},defaultTheme$1);/**
 * returns cyolo custom theme in case no theme
 * provided by react context
 */var useThemeSafe=function useThemeSafe(){var themeContext=useTheme();var isCustomTheme=Boolean(themeContext===null||themeContext===void 0?void 0:themeContext.palette);if(!isCustomTheme){console.warn('cyolo custom theme not found');return cyTheme;}return themeContext;};var _elementMapping;var elementMapping=(_elementMapping={},_defineProperty(_elementMapping,'license',/*#__PURE__*/React__default.createElement(Icon,{id:"pc-icon",size:14})),_defineProperty(_elementMapping,'software-update-in-progress',/*#__PURE__*/React__default.createElement(StandaloneLoadingIndicator,{color:"blue",size:8})),_elementMapping);var Banner=function Banner(_ref){var variant=_ref.variant,children=_ref.children;var theme=useThemeSafe();var style=useStyles$n$1({variant:variant,theme:theme});var iconElement=elementMapping[variant];return/*#__PURE__*/React__default.createElement("div",{className:style.banner},iconElement,/*#__PURE__*/React__default.createElement(Text$1,{variant:"body",className:style.textField},children));};var styleConfig=function styleConfig(theme){var _ref2;return _ref2={},_defineProperty(_ref2,'license',{banner:{backgroundColor:theme.palette.white.color},text:{color:theme.palette.secondary.color,marginLeft:3}}),_defineProperty(_ref2,'enrollment',{banner:{backgroundColor:theme.palette.warning.extraLight},text:{color:theme.palette.warning.color}}),_defineProperty(_ref2,'software-update-in-progress',{banner:{backgroundColor:theme.palette.white.color},text:{color:theme.palette.secondary.color,marginLeft:3}}),_ref2;};var useStyles$n$1=createUseStyles(function(theme){return {banner:function banner(_ref3){var variant=_ref3.variant;return Object.assign({display:'flex',justifyContent:'center',alignItems:'center',width:'fit-content',padding:'2px 8px',boxSizing:'border-box',border:"1px solid ".concat(theme.palette.white.color),borderRadius:20},styleConfig(theme)[variant].banner);},textField:function textField(_ref4){var variant=_ref4.variant;return styleConfig(theme)[variant].text;}};});var baseContainerStyles={height:'25px',display:'flex',justifyContent:'center',alignItems:'center',borderRadius:'5px',padding:'6px 24px 6px 24px',boxShadow:'0px 1.84505px 11.0703px rgba(0, 0, 0, 0.1)',border:'none',outline:'none',cursor:'pointer'};/* Disabled */var disabledButtonStyle=Object.assign(Object.assign({},baseContainerStyles),{backgroundColor:colors.disabledGrey,color:colors.cardWhite,cursor:'not-allowed'});/* Primary */var basePrimaryButtonStyle=Object.assign(Object.assign({},baseContainerStyles),{backgroundColor:colors.callToAction,color:colors.cardWhite});var primaryButtonStyles={"default":Object.assign({},basePrimaryButtonStyle),hover:Object.assign(Object.assign({},basePrimaryButtonStyle),{boxShadow:'1px 1px 25px rgba(0, 0, 0, 0.1)'}),selected:Object.assign({},basePrimaryButtonStyle),disabled:Object.assign(Object.assign({},basePrimaryButtonStyle),disabledButtonStyle)};/* Secondary */var baseSecondaryButtonStyle=Object.assign(Object.assign({},baseContainerStyles),{backgroundColor:colors.cardWhite,color:colors.darkBlue});var secondaryButtonStyles={"default":Object.assign({},baseSecondaryButtonStyle),hover:Object.assign(Object.assign({},baseSecondaryButtonStyle),{boxShadow:'0px 1px 6px rgba(0, 0, 0, 0.1)'}),selected:Object.assign({},baseSecondaryButtonStyle),disabled:Object.assign(Object.assign({},baseSecondaryButtonStyle),disabledButtonStyle)};var deleteButtonStyles={"default":Object.assign(Object.assign({},basePrimaryButtonStyle),{backgroundColor:'#E22525'}),hover:Object.assign(Object.assign({},basePrimaryButtonStyle),{boxShadow:'1px 1px 25px rgba(0, 0, 0, 0.1)'}),selected:Object.assign({},basePrimaryButtonStyle),disabled:Object.assign(Object.assign({},basePrimaryButtonStyle),disabledButtonStyle)};var styles$2={button:{primary:primaryButtonStyles,secondary:secondaryButtonStyles,"delete":deleteButtonStyles}};var resolveButtonStyle=function resolveButtonStyle(variant,disabled,hover,selected){var buttonTypeStyles=styles$2.button[variant];if(disabled)return buttonTypeStyles.disabled;if(selected)return buttonTypeStyles.selected;if(hover)return buttonTypeStyles.hover;return buttonTypeStyles["default"];};var Button=/*#__PURE__*/function(_Component){_inherits(Button,_Component);var _super=_createSuper(Button);function Button(){var _this;_classCallCheck$1(this,Button);_this=_super.apply(this,arguments);_this.state={selected:false,hover:false};return _this;}_createClass(Button,[{key:"render",value:function render(){var _this2=this;var _a=this.props,children=_a.children,style=_a.style,_a$disabled=_a.disabled,disabled=_a$disabled===void 0?false:_a$disabled,variant=_a.variant,className=_a.className,onClick=_a.onClick,_a$type=_a.type,type=_a$type===void 0?'button':_a$type,icon=_a.icon,rest=__rest$1(_a,["children","style","disabled","variant","className","onClick","type","icon"]);var _this$state=this.state,hover=_this$state.hover,selected=_this$state.selected;var buttonStyle=resolveButtonStyle(variant,disabled,hover,selected);return/*#__PURE__*/React__default.createElement("button",Object.assign({},rest,{className:className,onClick:onClick,disabled:disabled,style:Object.assign(Object.assign({},buttonStyle),style),// all this props are needed due to accessability demands
onFocus:function onFocus(){return _this2.setState({selected:true});},onBlur:function onBlur(){return _this2.setState({selected:false});},onMouseOver:function onMouseOver(){return _this2.setState({hover:true});},onMouseOut:function onMouseOut(){return _this2.setState({hover:false});},type:type}),icon,/*#__PURE__*/React__default.createElement(Text$1,{variant:"body",color:buttonStyle.color},children));}}]);return Button;}(Component);var includesTypeOf$1=function includesTypeOf(children,type){return React__default.Children.map(children,function(child){var _a;return (_a=child)===null||_a===void 0?void 0:_a.type;}).includes(type);};var CardHeader=function CardHeader(_ref){var children=_ref.children;return/*#__PURE__*/React__default.createElement("div",{className:"CyoloUI-CardHeader"},children);};var Card=/*#__PURE__*/React__default.forwardRef(function(_a,forwardedRef){var _a$addPadding=_a.addPadding,addPadding=_a$addPadding===void 0?true:_a$addPadding,children=_a.children,className=_a.className,other=__rest$1(_a,["addPadding","children","className"]);var theme=useThemeSafe();var styles=useStyles$m$1({theme:theme,addPadding:addPadding,cardHeaderInChildren:children?includesTypeOf$1(children,CardHeader):false});return/*#__PURE__*/React__default.createElement("div",Object.assign({},other,{ref:forwardedRef,className:clsx$1(styles.baseCard,className)}),children);});Card.displayName='Card';var useStyles$m$1=createUseStyles(function(theme){return {baseCard:function baseCard(props){return {position:'relative',height:'fit-content',boxShadow:theme.shadows[0],borderRadius:theme.shape.borderRadiusLight,background:theme.palette.white.color,padding:props.cardHeaderInChildren?[[58,10,8,10]]:props.addPadding?[[8]]:''};}};});var CheckboxStatusesEnum;(function(CheckboxStatusesEnum){CheckboxStatusesEnum["Checked"]="checked";CheckboxStatusesEnum["NotChecked"]="not-checked";})(CheckboxStatusesEnum||(CheckboxStatusesEnum={}));var baseCheckbox={outline:'none',width:12,height:12,boxSizing:'border-box',border:'1px solid',padding:0,margin:0,borderRadius:'2px',display:'flex',alignItems:'center',justifyContent:'center'};var useStyles$l$1=createUseStyles(function(theme){return {checkbox:function checkbox(props){var styleByStatus=props.checked?{backgroundColor:theme.palette.primary.color}:{backgroundColor:theme.palette.white.color};var disabledStyles=props.disabled?{opacity:0.2,cursor:'inherit'}:{opacity:1,cursor:'pointer'};return Object.assign(Object.assign(Object.assign({flexShrink:0,borderColor:theme.palette.primary.color},baseCheckbox),styleByStatus),disabledStyles);},input:{display:'none'}};});var Checkbox=function Checkbox(_a){var checked=_a.checked,variant=_a.variant,_a$disabled=_a.disabled,disabled=_a$disabled===void 0?false:_a$disabled,className=_a.className,_a$onChange=_a.onChange,onChange=_a$onChange===void 0?function(){}:_a$onChange,rest=__rest$1(_a,["checked","variant","disabled","className","onChange"]);var theme=useThemeSafe();var style=useStyles$l$1({theme:theme,checked:checked,disabled:disabled});var checkMarkID=variant==='multi'?'dash-white':'checkmark-white';var size=variant==='multi'?6:10;return/*#__PURE__*/React__default.createElement("label",{className:clsx$1(style.checkbox,className)},/*#__PURE__*/React__default.createElement("input",Object.assign({type:"checkbox",className:style.input,disabled:disabled,checked:checked,onChange:onChange},rest)),checked&&/*#__PURE__*/React__default.createElement(Icon,{size:size,id:checkMarkID}));};var Image=/*#__PURE__*/function(_React$Component){_inherits(Image,_React$Component);var _super=_createSuper(Image);function Image(props){var _this;_classCallCheck$1(this,Image);_this=_super.call(this,props);_this.state={srcPos:0};return _this;}_createClass(Image,[{key:"render",value:function render(){var _this2=this;var _this$props=this.props,alt=_this$props.alt,src=_this$props.src,style=_this$props.style,_this$props$className=_this$props.className,className=_this$props$className===void 0?'CyoloUI-Image':_this$props$className,size=_this$props.size;var srcPos=this.state.srcPos;var srcToShow;if(typeof src!=='string'){// src is a list of srcs
var lengthLimitedSrcPos=Math.min(src.length-1,srcPos);srcToShow=src[lengthLimitedSrcPos];}else {srcToShow=src;}return/*#__PURE__*/React__default.createElement("img",{className:className,style:Object.assign({height:size,width:size},style),alt:alt,src:srcToShow,onError:function onError(){return _this2.setState({srcPos:srcPos+1});}});}}]);return Image;}(React__default.Component);var Chip=function Chip(_ref){var value=_ref.value,onDelete=_ref.onDelete,className=_ref.className,icon=_ref.icon,_ref$disabled=_ref.disabled,disabled=_ref$disabled===void 0?false:_ref$disabled;var theme=useThemeSafe();var styles=useStyles$k$1({theme:theme,disabled:disabled});var chipClassName=useMemo(function(){return clsx$1('CyoloUI-Chip',className,styles.chip);},[className,styles]);var renderIcon=function renderIcon(){if(!icon){return null;}if(/*#__PURE__*/ /*#__PURE__*/isValidElement(icon)&&typeof icon!=='string'){return icon;}return/*#__PURE__*/React__default.createElement(Image,{src:icon,alt:"",size:15,className:styles.icon});};return/*#__PURE__*/React__default.createElement("div",{className:chipClassName},/*#__PURE__*/React__default.createElement("div",{className:styles.chipName},renderIcon(),/*#__PURE__*/React__default.createElement(Text$1,{variant:"body",title:value},value)),onDelete&&/*#__PURE__*/React__default.createElement("div",{className:styles.cancelIcon,onClick:onDelete},/*#__PURE__*/React__default.createElement(Icon,{id:"x-icon",size:12})));};var useStyles$k$1=createUseStyles(function(theme){return {chip:function chip(props){return {height:16,background:theme.palette.background.color,borderRadius:theme.shape.borderRadiusLight,display:'flex',alignItems:'center',justifyContent:'space-between',padding:8,width:'fit-content',maxWidth:240,cursor:props.disabled?'not-allowed':'default'};},chipName:{display:'flex',alignItems:'center',maxWidth:212,gap:8,'& > .CyoloUI-Text':{whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}},icon:{display:'flex',alignItems:'center'},cancelIcon:function cancelIcon(props){return {display:'flex',alignItems:'center',cursor:props.disabled?'not-allowed':'pointer',marginLeft:8,transition:"".concat(theme.transitions.fast," opacity"),'&:hover':{opacity:0.5},'&:active':{opacity:1}};}};});var Divider$1=function Divider(_ref){var orientation=_ref.orientation,_ref$thickness=_ref.thickness,thickness=_ref$thickness===void 0?'2px':_ref$thickness,color=_ref.color,_ref$length=_ref.length,length=_ref$length===void 0?'100%':_ref$length,className=_ref.className;var theme=useThemeSafe();var styles=useStyles$j$1({theme:theme,color:color,length:length,orientation:orientation,thickness:thickness});return/*#__PURE__*/React__default.createElement("div",{className:clsx$1(styles.divider,className)});};var useStyles$j$1=createUseStyles({divider:function divider(_ref2){var _ref3;var thickness=_ref2.thickness,orientation=_ref2.orientation,length=_ref2.length,theme=_ref2.theme,color=_ref2.color;return _ref3={},_defineProperty(_ref3,orientation==='horizontal'?'height':'width',thickness),_defineProperty(_ref3,orientation==='horizontal'?'width':'height',length),_defineProperty(_ref3,"backgroundColor",color||theme.palette.grey.extraLight),_ref3;}});var Header=function Header(_a){var children=_a.children,className=_a.className,opened=_a.opened,renderArrow=_a.renderArrow,props=__rest$1(_a,["children","className","opened","renderArrow"]);var classes=useStyles$i$1();return/*#__PURE__*/React__default.createElement("div",null,/*#__PURE__*/React__default.createElement("div",Object.assign({},props,{className:clsx$1(classes.header,className)}),renderArrow?renderArrow(opened):/*#__PURE__*/React__default.createElement(Icon,{id:!opened?'line-arrow-down':'line-arrow-up',size:10}),children));};var Body=function Body(_a){var children=_a.children,className=_a.className,props=__rest$1(_a,["children","className"]);var classes=useStyles$i$1();return/*#__PURE__*/React__default.createElement("div",Object.assign({},props,{className:clsx$1(classes.body,className)}),children);};var useStyles$i$1=createUseStyles(function(theme){return {header:{padding:16,cursor:'pointer',display:'flex',alignItems:'center',gap:8},body:{padding:[[24,18,18,18]]},footer:{padding:[[0,18,18,18]]},divider:{marginBottom:24}};});var Collapse=function Collapse(_ref){var initialState=_ref.initialState,opened=_ref.opened,children=_ref.children,onCardClick=_ref.onCardClick,className=_ref.className,_ref$showDivider=_ref.showDivider,showDivider=_ref$showDivider===void 0?true:_ref$showDivider,onChange=_ref.onChange;//check if component is controlled from outside
var isControlled=useMemo(function(){return opened!==undefined;},[opened]);var hasDefaultState=initialState!==undefined;var _useState=useState(hasDefaultState?initialState:false),_useState2=_slicedToArray(_useState,2),internalOpened=_useState2[0],setInternalOpened=_useState2[1];var theme=useThemeSafe();var classes=useStyles$h$1({theme:theme,opened:opened});var collapseRef=useRef(null);var firstRender=useRef(true);var openedValue=useMemo(function(){return isControlled?opened:internalOpened;},[isControlled,opened,internalOpened]);useEffect(function(){// prevent animation on first render
if(firstRender.current){expandElement(collapseRef.current,'collapsed',openedValue);onChange===null||onChange===void 0?void 0:onChange(openedValue);firstRender.current=false;return;}return animateExpandElement(collapseRef.current,'collapsed',openedValue,onChange);},[openedValue]);var childrenArray=React__default.Children.toArray(children);var headerChild=childrenArray[0];var isHeaderFirstChild=/*#__PURE__*/ /*#__PURE__*/React__default.isValidElement(headerChild)&&headerChild.type===Header;if(!isHeaderFirstChild){throw new Error('Collapse.Header should be the first child of Collapse');}var otherChildren=React__default.Children.map(childrenArray,function(child){if(typeof child!=='string'&&typeof child!=='number'&&child.type===Header){return null;}return child;});return/*#__PURE__*/React__default.createElement("div",{className:clsx$1('CyoloUI-Collapse',classes.wrapper,className),onClick:onCardClick},/*#__PURE__*/React__default.cloneElement(headerChild,Object.assign(Object.assign({},headerChild.props),{onClick:function onClick(e){var _a,_b;isControlled?(_b=(_a=headerChild.props).onClick)===null||_b===void 0?void 0:_b.call(_a,e):setInternalOpened(function(prev){return !prev;});},opened:openedValue})),/*#__PURE__*/React__default.createElement("div",{className:classes.body,ref:collapseRef},showDivider&&/*#__PURE__*/React__default.createElement(Divider$1,{orientation:"horizontal",color:theme.palette.background.color}),otherChildren));};Collapse.Header=Header;Collapse.Body=Body;var useStyles$h$1=createUseStyles(function(theme){return {wrapper:{display:'flex',flexDirection:'column',backgroundColor:theme.palette.white.color,borderRadius:theme.shape.borderRadiusLight,boxShadow:theme.shadows[0]},body:{overflow:'hidden',height:'auto',transition:"height ".concat(theme.transitions.fast),'&.collapsed':{height:0}}};});/**
 * function that opens and closes element
 * params
 * @elem takes element that is going to be animated
 * @collapseClass className with collapsed styles
 */var expandElement=function expandElement(elem,collapseClass,isOpen){if(!elem){return;}isOpen&&elem.classList.remove(collapseClass);!isOpen&&elem.classList.add(collapseClass);};var animateExpandElement=function animateExpandElement(elem,collapseClass,isOpen,onChange){if(!elem){return;}elem.style.height='';elem.style.transition='none';var startHeight=window.getComputedStyle(elem).height;// Remove the collapse class, and force a layout calculation to get the final height
expandElement(elem,collapseClass,isOpen);var height=window.getComputedStyle(elem).height;// Set the start height to begin the transition
elem.style.height=startHeight;// wait until the next frame so that everything has time to update before starting the transition
requestAnimationFrame(function(){elem.style.transition='';requestAnimationFrame(function(){elem.style.height=height;});});var handleTransitionEnd=function handleTransitionEnd(){onChange===null||onChange===void 0?void 0:onChange(isOpen);elem.style.height='';};// Clear the saved height values after the transition
elem.addEventListener('transitionend',handleTransitionEnd);return function(){elem.removeEventListener('transitionend',handleTransitionEnd);};};var CollapseArrow=function CollapseArrow(_ref){var color=_ref.color,opened=_ref.opened,stroke=_ref.stroke,showDoubleArrows=_ref.showDoubleArrows;var theme=useThemeSafe();var styles=useStyles$g$1({theme:theme,color:color,opened:opened,showDoubleArrows:showDoubleArrows});if(showDoubleArrows){return/*#__PURE__*/React__default.createElement("div",{className:styles.root},/*#__PURE__*/React__default.createElement("svg",{width:"10",height:"6",viewBox:"0 0 10 6",fill:"none",xmlns:"http://www.w3.org/2000/svg"},/*#__PURE__*/React__default.createElement("path",{d:"M9 5L5 1L1 5",stroke:stroke||theme.palette.white.color,strokeLinecap:"round",strokeLinejoin:"round"})),/*#__PURE__*/React__default.createElement("svg",{width:"10",height:"6",viewBox:"0 0 10 6",fill:"none",xmlns:"http://www.w3.org/2000/svg"},/*#__PURE__*/React__default.createElement("path",{d:"M9 5L5 1L1 5",stroke:stroke||theme.palette.white.color,strokeLinecap:"round",strokeLinejoin:"round"})));}return/*#__PURE__*/React__default.createElement("div",{className:styles.root},/*#__PURE__*/React__default.createElement("svg",{width:"10",height:"6",viewBox:"0 0 10 6",fill:"none",xmlns:"http://www.w3.org/2000/svg"},/*#__PURE__*/React__default.createElement("path",{d:"M9 5L5 1L1 5",stroke:stroke||theme.palette.white.color,strokeLinecap:"round",strokeLinejoin:"round"})));};var useStyles$g$1=createUseStyles(function(theme){return {root:function root(props){return {flexShrink:0,borderRadius:theme.shape.borderRadiusCircle,backgroundColor:props.color||theme.palette.primary.color,width:24,height:24,display:'flex',flexDirection:props.showDoubleArrows?'column':'row',justifyContent:'center',alignItems:'center',transform:!props.opened&&'rotate(-180deg)',transition:"transform ".concat(theme.transitions.fast)};}};});var commonjsGlobal$1=typeof globalThis!=='undefined'?globalThis:typeof window!=='undefined'?window:typeof global!=='undefined'?global:typeof self!=='undefined'?self:{};function getDefaultExportFromCjs$1(x){return x&&x.__esModule&&Object.prototype.hasOwnProperty.call(x,'default')?x['default']:x;}function getAugmentedNamespace$1(n){if(n.__esModule)return n;var a=Object.defineProperty({},'__esModule',{value:true});Object.keys(n).forEach(function(k){var d=Object.getOwnPropertyDescriptor(n,k);Object.defineProperty(a,k,d.get?d:{enumerable:true,get:function get(){return n[k];}});});return a;}function createCommonjsModule$2(fn){var module={exports:{}};return fn(module,module.exports),module.exports;}/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var b$1="function"===typeof Symbol&&Symbol["for"],c$1=b$1?Symbol["for"]("react.element"):60103,d$2=b$1?Symbol["for"]("react.portal"):60106,e$1=b$1?Symbol["for"]("react.fragment"):60107,f$1=b$1?Symbol["for"]("react.strict_mode"):60108,g$4=b$1?Symbol["for"]("react.profiler"):60114,h$3=b$1?Symbol["for"]("react.provider"):60109,k$2=b$1?Symbol["for"]("react.context"):60110,l$2=b$1?Symbol["for"]("react.async_mode"):60111,m$6=b$1?Symbol["for"]("react.concurrent_mode"):60111,n$4=b$1?Symbol["for"]("react.forward_ref"):60112,p$8=b$1?Symbol["for"]("react.suspense"):60113,q$9=b$1?Symbol["for"]("react.suspense_list"):60120,r$b=b$1?Symbol["for"]("react.memo"):60115,t$9=b$1?Symbol["for"]("react.lazy"):60116,v$8=b$1?Symbol["for"]("react.block"):60121,w$8=b$1?Symbol["for"]("react.fundamental"):60117,x$5=b$1?Symbol["for"]("react.responder"):60118,y$7=b$1?Symbol["for"]("react.scope"):60119;function z$9(a){if("object"===_typeof(a)&&null!==a){var u=a.$$typeof;switch(u){case c$1:switch(a=a.type,a){case l$2:case m$6:case e$1:case g$4:case f$1:case p$8:return a;default:switch(a=a&&a.$$typeof,a){case k$2:case n$4:case t$9:case r$b:case h$3:return a;default:return u;}}case d$2:return u;}}}function A$7(a){return z$9(a)===m$6;}var AsyncMode$1=l$2;var ConcurrentMode$1=m$6;var ContextConsumer$1=k$2;var ContextProvider$1=h$3;var Element$1$1=c$1;var ForwardRef$1=n$4;var Fragment$1=e$1;var Lazy$1=t$9;var Memo$1=r$b;var Portal$1=d$2;var Profiler$1=g$4;var StrictMode$1=f$1;var Suspense$1=p$8;var isAsyncMode$1=function isAsyncMode(a){return A$7(a)||z$9(a)===l$2;};var isConcurrentMode$1=A$7;var isContextConsumer$1=function isContextConsumer(a){return z$9(a)===k$2;};var isContextProvider$1=function isContextProvider(a){return z$9(a)===h$3;};var isElement$1$1=function isElement$1(a){return "object"===_typeof(a)&&null!==a&&a.$$typeof===c$1;};var isForwardRef$1=function isForwardRef(a){return z$9(a)===n$4;};var isFragment$1=function isFragment(a){return z$9(a)===e$1;};var isLazy$1=function isLazy(a){return z$9(a)===t$9;};var isMemo$1=function isMemo(a){return z$9(a)===r$b;};var isPortal$1=function isPortal(a){return z$9(a)===d$2;};var isProfiler$1=function isProfiler(a){return z$9(a)===g$4;};var isStrictMode$1=function isStrictMode(a){return z$9(a)===f$1;};var isSuspense$1=function isSuspense(a){return z$9(a)===p$8;};var isValidElementType$1=function isValidElementType(a){return "string"===typeof a||"function"===typeof a||a===e$1||a===m$6||a===g$4||a===f$1||a===p$8||a===q$9||"object"===_typeof(a)&&null!==a&&(a.$$typeof===t$9||a.$$typeof===r$b||a.$$typeof===h$3||a.$$typeof===k$2||a.$$typeof===n$4||a.$$typeof===w$8||a.$$typeof===x$5||a.$$typeof===y$7||a.$$typeof===v$8);};var typeOf$1=z$9;var reactIs_production_min$1={AsyncMode:AsyncMode$1,ConcurrentMode:ConcurrentMode$1,ContextConsumer:ContextConsumer$1,ContextProvider:ContextProvider$1,Element:Element$1$1,ForwardRef:ForwardRef$1,Fragment:Fragment$1,Lazy:Lazy$1,Memo:Memo$1,Portal:Portal$1,Profiler:Profiler$1,StrictMode:StrictMode$1,Suspense:Suspense$1,isAsyncMode:isAsyncMode$1,isConcurrentMode:isConcurrentMode$1,isContextConsumer:isContextConsumer$1,isContextProvider:isContextProvider$1,isElement:isElement$1$1,isForwardRef:isForwardRef$1,isFragment:isFragment$1,isLazy:isLazy$1,isMemo:isMemo$1,isPortal:isPortal$1,isProfiler:isProfiler$1,isStrictMode:isStrictMode$1,isSuspense:isSuspense$1,isValidElementType:isValidElementType$1,typeOf:typeOf$1};/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var reactIs_development$1=createCommonjsModule$2(function(module,exports){if(process.env.NODE_ENV!=="production"){(function(){// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol=typeof Symbol==='function'&&Symbol["for"];var REACT_ELEMENT_TYPE=hasSymbol?Symbol["for"]('react.element'):0xeac7;var REACT_PORTAL_TYPE=hasSymbol?Symbol["for"]('react.portal'):0xeaca;var REACT_FRAGMENT_TYPE=hasSymbol?Symbol["for"]('react.fragment'):0xeacb;var REACT_STRICT_MODE_TYPE=hasSymbol?Symbol["for"]('react.strict_mode'):0xeacc;var REACT_PROFILER_TYPE=hasSymbol?Symbol["for"]('react.profiler'):0xead2;var REACT_PROVIDER_TYPE=hasSymbol?Symbol["for"]('react.provider'):0xeacd;var REACT_CONTEXT_TYPE=hasSymbol?Symbol["for"]('react.context'):0xeace;// TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?
var REACT_ASYNC_MODE_TYPE=hasSymbol?Symbol["for"]('react.async_mode'):0xeacf;var REACT_CONCURRENT_MODE_TYPE=hasSymbol?Symbol["for"]('react.concurrent_mode'):0xeacf;var REACT_FORWARD_REF_TYPE=hasSymbol?Symbol["for"]('react.forward_ref'):0xead0;var REACT_SUSPENSE_TYPE=hasSymbol?Symbol["for"]('react.suspense'):0xead1;var REACT_SUSPENSE_LIST_TYPE=hasSymbol?Symbol["for"]('react.suspense_list'):0xead8;var REACT_MEMO_TYPE=hasSymbol?Symbol["for"]('react.memo'):0xead3;var REACT_LAZY_TYPE=hasSymbol?Symbol["for"]('react.lazy'):0xead4;var REACT_BLOCK_TYPE=hasSymbol?Symbol["for"]('react.block'):0xead9;var REACT_FUNDAMENTAL_TYPE=hasSymbol?Symbol["for"]('react.fundamental'):0xead5;var REACT_RESPONDER_TYPE=hasSymbol?Symbol["for"]('react.responder'):0xead6;var REACT_SCOPE_TYPE=hasSymbol?Symbol["for"]('react.scope'):0xead7;function isValidElementType(type){return typeof type==='string'||typeof type==='function'||// Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
type===REACT_FRAGMENT_TYPE||type===REACT_CONCURRENT_MODE_TYPE||type===REACT_PROFILER_TYPE||type===REACT_STRICT_MODE_TYPE||type===REACT_SUSPENSE_TYPE||type===REACT_SUSPENSE_LIST_TYPE||_typeof(type)==='object'&&type!==null&&(type.$$typeof===REACT_LAZY_TYPE||type.$$typeof===REACT_MEMO_TYPE||type.$$typeof===REACT_PROVIDER_TYPE||type.$$typeof===REACT_CONTEXT_TYPE||type.$$typeof===REACT_FORWARD_REF_TYPE||type.$$typeof===REACT_FUNDAMENTAL_TYPE||type.$$typeof===REACT_RESPONDER_TYPE||type.$$typeof===REACT_SCOPE_TYPE||type.$$typeof===REACT_BLOCK_TYPE);}function typeOf(object){if(_typeof(object)==='object'&&object!==null){var $$typeof=object.$$typeof;switch($$typeof){case REACT_ELEMENT_TYPE:var type=object.type;switch(type){case REACT_ASYNC_MODE_TYPE:case REACT_CONCURRENT_MODE_TYPE:case REACT_FRAGMENT_TYPE:case REACT_PROFILER_TYPE:case REACT_STRICT_MODE_TYPE:case REACT_SUSPENSE_TYPE:return type;default:var $$typeofType=type&&type.$$typeof;switch($$typeofType){case REACT_CONTEXT_TYPE:case REACT_FORWARD_REF_TYPE:case REACT_LAZY_TYPE:case REACT_MEMO_TYPE:case REACT_PROVIDER_TYPE:return $$typeofType;default:return $$typeof;}}case REACT_PORTAL_TYPE:return $$typeof;}}return undefined;}// AsyncMode is deprecated along with isAsyncMode
var AsyncMode=REACT_ASYNC_MODE_TYPE;var ConcurrentMode=REACT_CONCURRENT_MODE_TYPE;var ContextConsumer=REACT_CONTEXT_TYPE;var ContextProvider=REACT_PROVIDER_TYPE;var Element=REACT_ELEMENT_TYPE;var ForwardRef=REACT_FORWARD_REF_TYPE;var Fragment=REACT_FRAGMENT_TYPE;var Lazy=REACT_LAZY_TYPE;var Memo=REACT_MEMO_TYPE;var Portal=REACT_PORTAL_TYPE;var Profiler=REACT_PROFILER_TYPE;var StrictMode=REACT_STRICT_MODE_TYPE;var Suspense=REACT_SUSPENSE_TYPE;var hasWarnedAboutDeprecatedIsAsyncMode=false;// AsyncMode should be deprecated
function isAsyncMode(object){{if(!hasWarnedAboutDeprecatedIsAsyncMode){hasWarnedAboutDeprecatedIsAsyncMode=true;// Using console['warn'] to evade Babel and ESLint
console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, '+'and will be removed in React 17+. Update your code to use '+'ReactIs.isConcurrentMode() instead. It has the exact same API.');}}return isConcurrentMode(object)||typeOf(object)===REACT_ASYNC_MODE_TYPE;}function isConcurrentMode(object){return typeOf(object)===REACT_CONCURRENT_MODE_TYPE;}function isContextConsumer(object){return typeOf(object)===REACT_CONTEXT_TYPE;}function isContextProvider(object){return typeOf(object)===REACT_PROVIDER_TYPE;}function isElement(object){return _typeof(object)==='object'&&object!==null&&object.$$typeof===REACT_ELEMENT_TYPE;}function isForwardRef(object){return typeOf(object)===REACT_FORWARD_REF_TYPE;}function isFragment(object){return typeOf(object)===REACT_FRAGMENT_TYPE;}function isLazy(object){return typeOf(object)===REACT_LAZY_TYPE;}function isMemo(object){return typeOf(object)===REACT_MEMO_TYPE;}function isPortal(object){return typeOf(object)===REACT_PORTAL_TYPE;}function isProfiler(object){return typeOf(object)===REACT_PROFILER_TYPE;}function isStrictMode(object){return typeOf(object)===REACT_STRICT_MODE_TYPE;}function isSuspense(object){return typeOf(object)===REACT_SUSPENSE_TYPE;}exports.AsyncMode=AsyncMode;exports.ConcurrentMode=ConcurrentMode;exports.ContextConsumer=ContextConsumer;exports.ContextProvider=ContextProvider;exports.Element=Element;exports.ForwardRef=ForwardRef;exports.Fragment=Fragment;exports.Lazy=Lazy;exports.Memo=Memo;exports.Portal=Portal;exports.Profiler=Profiler;exports.StrictMode=StrictMode;exports.Suspense=Suspense;exports.isAsyncMode=isAsyncMode;exports.isConcurrentMode=isConcurrentMode;exports.isContextConsumer=isContextConsumer;exports.isContextProvider=isContextProvider;exports.isElement=isElement;exports.isForwardRef=isForwardRef;exports.isFragment=isFragment;exports.isLazy=isLazy;exports.isMemo=isMemo;exports.isPortal=isPortal;exports.isProfiler=isProfiler;exports.isStrictMode=isStrictMode;exports.isSuspense=isSuspense;exports.isValidElementType=isValidElementType;exports.typeOf=typeOf;})();}});var reactIs$1=createCommonjsModule$2(function(module){if(process.env.NODE_ENV==='production'){module.exports=reactIs_production_min$1;}else {module.exports=reactIs_development$1;}});/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ /* eslint-disable no-unused-vars */var getOwnPropertySymbols$1=Object.getOwnPropertySymbols;var hasOwnProperty$1$1=Object.prototype.hasOwnProperty;var propIsEnumerable$1=Object.prototype.propertyIsEnumerable;function toObject$1(val){if(val===null||val===undefined){throw new TypeError('Object.assign cannot be called with null or undefined');}return Object(val);}function shouldUseNative$1(){try{if(!Object.assign){return false;}// Detect buggy property enumeration order in older V8 versions.
// https://bugs.chromium.org/p/v8/issues/detail?id=4118
var test1=new String('abc');// eslint-disable-line no-new-wrappers
test1[5]='de';if(Object.getOwnPropertyNames(test1)[0]==='5'){return false;}// https://bugs.chromium.org/p/v8/issues/detail?id=3056
var test2={};for(var i=0;i<10;i++){test2['_'+String.fromCharCode(i)]=i;}var order2=Object.getOwnPropertyNames(test2).map(function(n){return test2[n];});if(order2.join('')!=='0123456789'){return false;}// https://bugs.chromium.org/p/v8/issues/detail?id=3056
var test3={};'abcdefghijklmnopqrst'.split('').forEach(function(letter){test3[letter]=letter;});if(Object.keys(Object.assign({},test3)).join('')!=='abcdefghijklmnopqrst'){return false;}return true;}catch(err){// We don't expect any of the above to throw, but better to be safe.
return false;}}var objectAssign$1=shouldUseNative$1()?Object.assign:function(target,source){var from;var to=toObject$1(target);var symbols;for(var s=1;s<arguments.length;s++){from=Object(arguments[s]);for(var key in from){if(hasOwnProperty$1$1.call(from,key)){to[key]=from[key];}}if(getOwnPropertySymbols$1){symbols=getOwnPropertySymbols$1(from);for(var i=0;i<symbols.length;i++){if(propIsEnumerable$1.call(from,symbols[i])){to[symbols[i]]=from[symbols[i]];}}}}return to;};/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var ReactPropTypesSecret$2$1='SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';var ReactPropTypesSecret_1$1=ReactPropTypesSecret$2$1;var has$2$1=Function.call.bind(Object.prototype.hasOwnProperty);var ReactPropTypesSecret$1$1=ReactPropTypesSecret_1$1;var has$1$1=has$2$1;/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var printWarning$2$1=function printWarning$2(){};if(process.env.NODE_ENV!=='production'){var ReactPropTypesSecret$3=ReactPropTypesSecret$1$1;var loggedTypeFailures$1={};var has$3=has$1$1;printWarning$2$1=function printWarning$2(text){var message='Warning: '+text;if(typeof console!=='undefined'){console.error(message);}try{// --- Welcome to debugging React ---
// This error was thrown as a convenience so that you can use this stack
// to find the callsite that caused this warning to fire.
throw new Error(message);}catch(x){/**/}};}/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */function checkPropTypes$1$1(typeSpecs,values,location,componentName,getStack){if(process.env.NODE_ENV!=='production'){for(var typeSpecName in typeSpecs){if(has$3(typeSpecs,typeSpecName)){var error;// Prop type validation may throw. In case they do, we don't want to
// fail the render phase where it didn't fail before. So we log it.
// After these have been cleaned up, we'll let them throw.
try{// This is intentionally an invariant that gets caught. It's the same
// behavior as without this statement except with a better message.
if(typeof typeSpecs[typeSpecName]!=='function'){var err=Error((componentName||'React class')+': '+location+' type `'+typeSpecName+'` is invalid; '+'it must be a function, usually from the `prop-types` package, but received `'+_typeof(typeSpecs[typeSpecName])+'`.'+'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');err.name='Invariant Violation';throw err;}error=typeSpecs[typeSpecName](values,typeSpecName,componentName,location,null,ReactPropTypesSecret$3);}catch(ex){error=ex;}if(error&&!(error instanceof Error)){printWarning$2$1((componentName||'React class')+': type specification of '+location+' `'+typeSpecName+'` is invalid; the type checker '+'function must return `null` or an `Error` but returned a '+_typeof(error)+'. '+'You may have forgotten to pass an argument to the type checker '+'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and '+'shape all require an argument).');}if(error instanceof Error&&!(error.message in loggedTypeFailures$1)){// Only monitor this failure once because there tends to be a lot of the
// same error.
loggedTypeFailures$1[error.message]=true;var stack=getStack?getStack():'';printWarning$2$1('Failed '+location+' type: '+error.message+(stack!=null?stack:''));}}}}}/**
 * Resets warning cache when testing.
 *
 * @private
 */checkPropTypes$1$1.resetWarningCache=function(){if(process.env.NODE_ENV!=='production'){loggedTypeFailures$1={};}};var checkPropTypes_1$1=checkPropTypes$1$1;var checkPropTypes$2=checkPropTypes_1$1;/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var printWarning$1$1=function printWarning$1(){};if(process.env.NODE_ENV!=='production'){printWarning$1$1=function printWarning$1(text){var message='Warning: '+text;if(typeof console!=='undefined'){console.error(message);}try{// --- Welcome to debugging React ---
// This error was thrown as a convenience so that you can use this stack
// to find the callsite that caused this warning to fire.
throw new Error(message);}catch(x){}};}function emptyFunctionThatReturnsNull$1(){return null;}var factoryWithTypeCheckers$1=function factoryWithTypeCheckers(isValidElement,throwOnDirectAccess){/* global Symbol */var ITERATOR_SYMBOL=typeof Symbol==='function'&&Symbol.iterator;var FAUX_ITERATOR_SYMBOL='@@iterator';// Before Symbol spec.
/**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */function getIteratorFn(maybeIterable){var iteratorFn=maybeIterable&&(ITERATOR_SYMBOL&&maybeIterable[ITERATOR_SYMBOL]||maybeIterable[FAUX_ITERATOR_SYMBOL]);if(typeof iteratorFn==='function'){return iteratorFn;}}/**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */var ANONYMOUS='<<anonymous>>';// Important!
// Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
var ReactPropTypes={array:createPrimitiveTypeChecker('array'),bigint:createPrimitiveTypeChecker('bigint'),bool:createPrimitiveTypeChecker('boolean'),func:createPrimitiveTypeChecker('function'),number:createPrimitiveTypeChecker('number'),object:createPrimitiveTypeChecker('object'),string:createPrimitiveTypeChecker('string'),symbol:createPrimitiveTypeChecker('symbol'),any:createAnyTypeChecker(),arrayOf:createArrayOfTypeChecker,element:createElementTypeChecker(),elementType:createElementTypeTypeChecker(),instanceOf:createInstanceTypeChecker,node:createNodeChecker(),objectOf:createObjectOfTypeChecker,oneOf:createEnumTypeChecker,oneOfType:createUnionTypeChecker,shape:createShapeTypeChecker,exact:createStrictShapeTypeChecker};/**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/function is(x,y){// SameValue algorithm
if(x===y){// Steps 1-5, 7-10
// Steps 6.b-6.e: +0 != -0
return x!==0||1/x===1/y;}else {// Step 6.a: NaN == NaN
return x!==x&&y!==y;}}/*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */function PropTypeError(message,data){this.message=message;this.data=data&&_typeof(data)==='object'?data:{};this.stack='';}// Make `instanceof Error` still work for returned errors.
PropTypeError.prototype=Error.prototype;function createChainableTypeChecker(validate){if(process.env.NODE_ENV!=='production'){var manualPropTypeCallCache={};var manualPropTypeWarningCount=0;}function checkType(isRequired,props,propName,componentName,location,propFullName,secret){componentName=componentName||ANONYMOUS;propFullName=propFullName||propName;if(secret!==ReactPropTypesSecret$1$1){if(throwOnDirectAccess){// New behavior only for users of `prop-types` package
var err=new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. '+'Use `PropTypes.checkPropTypes()` to call them. '+'Read more at http://fb.me/use-check-prop-types');err.name='Invariant Violation';throw err;}else if(process.env.NODE_ENV!=='production'&&typeof console!=='undefined'){// Old behavior for people using React.PropTypes
var cacheKey=componentName+':'+propName;if(!manualPropTypeCallCache[cacheKey]&&// Avoid spamming the console because they are often not actionable except for lib authors
manualPropTypeWarningCount<3){printWarning$1$1('You are manually calling a React.PropTypes validation '+'function for the `'+propFullName+'` prop on `'+componentName+'`. This is deprecated '+'and will throw in the standalone `prop-types` package. '+'You may be seeing this warning due to a third-party PropTypes '+'library. See https://fb.me/react-warning-dont-call-proptypes '+'for details.');manualPropTypeCallCache[cacheKey]=true;manualPropTypeWarningCount++;}}}if(props[propName]==null){if(isRequired){if(props[propName]===null){return new PropTypeError('The '+location+' `'+propFullName+'` is marked as required '+('in `'+componentName+'`, but its value is `null`.'));}return new PropTypeError('The '+location+' `'+propFullName+'` is marked as required in '+('`'+componentName+'`, but its value is `undefined`.'));}return null;}else {return validate(props,propName,componentName,location,propFullName);}}var chainedCheckType=checkType.bind(null,false);chainedCheckType.isRequired=checkType.bind(null,true);return chainedCheckType;}function createPrimitiveTypeChecker(expectedType){function validate(props,propName,componentName,location,propFullName,secret){var propValue=props[propName];var propType=getPropType(propValue);if(propType!==expectedType){// `propValue` being instance of, say, date/regexp, pass the 'object'
// check, but we can offer a more precise error message here rather than
// 'of type `object`'.
var preciseType=getPreciseType(propValue);return new PropTypeError('Invalid '+location+' `'+propFullName+'` of type '+('`'+preciseType+'` supplied to `'+componentName+'`, expected ')+('`'+expectedType+'`.'),{expectedType:expectedType});}return null;}return createChainableTypeChecker(validate);}function createAnyTypeChecker(){return createChainableTypeChecker(emptyFunctionThatReturnsNull$1);}function createArrayOfTypeChecker(typeChecker){function validate(props,propName,componentName,location,propFullName){if(typeof typeChecker!=='function'){return new PropTypeError('Property `'+propFullName+'` of component `'+componentName+'` has invalid PropType notation inside arrayOf.');}var propValue=props[propName];if(!Array.isArray(propValue)){var propType=getPropType(propValue);return new PropTypeError('Invalid '+location+' `'+propFullName+'` of type '+('`'+propType+'` supplied to `'+componentName+'`, expected an array.'));}for(var i=0;i<propValue.length;i++){var error=typeChecker(propValue,i,componentName,location,propFullName+'['+i+']',ReactPropTypesSecret$1$1);if(error instanceof Error){return error;}}return null;}return createChainableTypeChecker(validate);}function createElementTypeChecker(){function validate(props,propName,componentName,location,propFullName){var propValue=props[propName];if(!isValidElement(propValue)){var propType=getPropType(propValue);return new PropTypeError('Invalid '+location+' `'+propFullName+'` of type '+('`'+propType+'` supplied to `'+componentName+'`, expected a single ReactElement.'));}return null;}return createChainableTypeChecker(validate);}function createElementTypeTypeChecker(){function validate(props,propName,componentName,location,propFullName){var propValue=props[propName];if(!reactIs$1.isValidElementType(propValue)){var propType=getPropType(propValue);return new PropTypeError('Invalid '+location+' `'+propFullName+'` of type '+('`'+propType+'` supplied to `'+componentName+'`, expected a single ReactElement type.'));}return null;}return createChainableTypeChecker(validate);}function createInstanceTypeChecker(expectedClass){function validate(props,propName,componentName,location,propFullName){if(!(props[propName]instanceof expectedClass)){var expectedClassName=expectedClass.name||ANONYMOUS;var actualClassName=getClassName(props[propName]);return new PropTypeError('Invalid '+location+' `'+propFullName+'` of type '+('`'+actualClassName+'` supplied to `'+componentName+'`, expected ')+('instance of `'+expectedClassName+'`.'));}return null;}return createChainableTypeChecker(validate);}function createEnumTypeChecker(expectedValues){if(!Array.isArray(expectedValues)){if(process.env.NODE_ENV!=='production'){if(arguments.length>1){printWarning$1$1('Invalid arguments supplied to oneOf, expected an array, got '+arguments.length+' arguments. '+'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');}else {printWarning$1$1('Invalid argument supplied to oneOf, expected an array.');}}return emptyFunctionThatReturnsNull$1;}function validate(props,propName,componentName,location,propFullName){var propValue=props[propName];for(var i=0;i<expectedValues.length;i++){if(is(propValue,expectedValues[i])){return null;}}var valuesString=JSON.stringify(expectedValues,function replacer(key,value){var type=getPreciseType(value);if(type==='symbol'){return String(value);}return value;});return new PropTypeError('Invalid '+location+' `'+propFullName+'` of value `'+String(propValue)+'` '+('supplied to `'+componentName+'`, expected one of '+valuesString+'.'));}return createChainableTypeChecker(validate);}function createObjectOfTypeChecker(typeChecker){function validate(props,propName,componentName,location,propFullName){if(typeof typeChecker!=='function'){return new PropTypeError('Property `'+propFullName+'` of component `'+componentName+'` has invalid PropType notation inside objectOf.');}var propValue=props[propName];var propType=getPropType(propValue);if(propType!=='object'){return new PropTypeError('Invalid '+location+' `'+propFullName+'` of type '+('`'+propType+'` supplied to `'+componentName+'`, expected an object.'));}for(var key in propValue){if(has$1$1(propValue,key)){var error=typeChecker(propValue,key,componentName,location,propFullName+'.'+key,ReactPropTypesSecret$1$1);if(error instanceof Error){return error;}}}return null;}return createChainableTypeChecker(validate);}function createUnionTypeChecker(arrayOfTypeCheckers){if(!Array.isArray(arrayOfTypeCheckers)){process.env.NODE_ENV!=='production'?printWarning$1$1('Invalid argument supplied to oneOfType, expected an instance of array.'):void 0;return emptyFunctionThatReturnsNull$1;}for(var i=0;i<arrayOfTypeCheckers.length;i++){var checker=arrayOfTypeCheckers[i];if(typeof checker!=='function'){printWarning$1$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but '+'received '+getPostfixForTypeWarning(checker)+' at index '+i+'.');return emptyFunctionThatReturnsNull$1;}}function validate(props,propName,componentName,location,propFullName){var expectedTypes=[];for(var i=0;i<arrayOfTypeCheckers.length;i++){var checker=arrayOfTypeCheckers[i];var checkerResult=checker(props,propName,componentName,location,propFullName,ReactPropTypesSecret$1$1);if(checkerResult==null){return null;}if(checkerResult.data&&has$1$1(checkerResult.data,'expectedType')){expectedTypes.push(checkerResult.data.expectedType);}}var expectedTypesMessage=expectedTypes.length>0?', expected one of type ['+expectedTypes.join(', ')+']':'';return new PropTypeError('Invalid '+location+' `'+propFullName+'` supplied to '+('`'+componentName+'`'+expectedTypesMessage+'.'));}return createChainableTypeChecker(validate);}function createNodeChecker(){function validate(props,propName,componentName,location,propFullName){if(!isNode(props[propName])){return new PropTypeError('Invalid '+location+' `'+propFullName+'` supplied to '+('`'+componentName+'`, expected a ReactNode.'));}return null;}return createChainableTypeChecker(validate);}function invalidValidatorError(componentName,location,propFullName,key,type){return new PropTypeError((componentName||'React class')+': '+location+' type `'+propFullName+'.'+key+'` is invalid; '+'it must be a function, usually from the `prop-types` package, but received `'+type+'`.');}function createShapeTypeChecker(shapeTypes){function validate(props,propName,componentName,location,propFullName){var propValue=props[propName];var propType=getPropType(propValue);if(propType!=='object'){return new PropTypeError('Invalid '+location+' `'+propFullName+'` of type `'+propType+'` '+('supplied to `'+componentName+'`, expected `object`.'));}for(var key in shapeTypes){var checker=shapeTypes[key];if(typeof checker!=='function'){return invalidValidatorError(componentName,location,propFullName,key,getPreciseType(checker));}var error=checker(propValue,key,componentName,location,propFullName+'.'+key,ReactPropTypesSecret$1$1);if(error){return error;}}return null;}return createChainableTypeChecker(validate);}function createStrictShapeTypeChecker(shapeTypes){function validate(props,propName,componentName,location,propFullName){var propValue=props[propName];var propType=getPropType(propValue);if(propType!=='object'){return new PropTypeError('Invalid '+location+' `'+propFullName+'` of type `'+propType+'` '+('supplied to `'+componentName+'`, expected `object`.'));}// We need to check all keys in case some are required but missing from props.
var allKeys=objectAssign$1({},props[propName],shapeTypes);for(var key in allKeys){var checker=shapeTypes[key];if(has$1$1(shapeTypes,key)&&typeof checker!=='function'){return invalidValidatorError(componentName,location,propFullName,key,getPreciseType(checker));}if(!checker){return new PropTypeError('Invalid '+location+' `'+propFullName+'` key `'+key+'` supplied to `'+componentName+'`.'+'\nBad object: '+JSON.stringify(props[propName],null,'  ')+'\nValid keys: '+JSON.stringify(Object.keys(shapeTypes),null,'  '));}var error=checker(propValue,key,componentName,location,propFullName+'.'+key,ReactPropTypesSecret$1$1);if(error){return error;}}return null;}return createChainableTypeChecker(validate);}function isNode(propValue){switch(_typeof(propValue)){case'number':case'string':case'undefined':return true;case'boolean':return !propValue;case'object':if(Array.isArray(propValue)){return propValue.every(isNode);}if(propValue===null||isValidElement(propValue)){return true;}var iteratorFn=getIteratorFn(propValue);if(iteratorFn){var iterator=iteratorFn.call(propValue);var step;if(iteratorFn!==propValue.entries){while(!(step=iterator.next()).done){if(!isNode(step.value)){return false;}}}else {// Iterator will provide entry [k,v] tuples rather than values.
while(!(step=iterator.next()).done){var entry=step.value;if(entry){if(!isNode(entry[1])){return false;}}}}}else {return false;}return true;default:return false;}}function isSymbol(propType,propValue){// Native Symbol.
if(propType==='symbol'){return true;}// falsy value can't be a Symbol
if(!propValue){return false;}// 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
if(propValue['@@toStringTag']==='Symbol'){return true;}// Fallback for non-spec compliant Symbols which are polyfilled.
if(typeof Symbol==='function'&&propValue instanceof Symbol){return true;}return false;}// Equivalent of `typeof` but with special handling for array and regexp.
function getPropType(propValue){var propType=_typeof(propValue);if(Array.isArray(propValue)){return 'array';}if(propValue instanceof RegExp){// Old webkits (at least until Android 4.0) return 'function' rather than
// 'object' for typeof a RegExp. We'll normalize this here so that /bla/
// passes PropTypes.object.
return 'object';}if(isSymbol(propType,propValue)){return 'symbol';}return propType;}// This handles more types than `getPropType`. Only used for error messages.
// See `createPrimitiveTypeChecker`.
function getPreciseType(propValue){if(typeof propValue==='undefined'||propValue===null){return ''+propValue;}var propType=getPropType(propValue);if(propType==='object'){if(propValue instanceof Date){return 'date';}else if(propValue instanceof RegExp){return 'regexp';}}return propType;}// Returns a string that is postfixed to a warning about an invalid type.
// For example, "undefined" or "of type array"
function getPostfixForTypeWarning(value){var type=getPreciseType(value);switch(type){case'array':case'object':return 'an '+type;case'boolean':case'date':case'regexp':return 'a '+type;default:return type;}}// Returns class name of the object, if any.
function getClassName(propValue){if(!propValue.constructor||!propValue.constructor.name){return ANONYMOUS;}return propValue.constructor.name;}ReactPropTypes.checkPropTypes=checkPropTypes$2;ReactPropTypes.resetWarningCache=checkPropTypes$2.resetWarningCache;ReactPropTypes.PropTypes=ReactPropTypes;return ReactPropTypes;};/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */function emptyFunction$1(){}function emptyFunctionWithReset$1(){}emptyFunctionWithReset$1.resetWarningCache=emptyFunction$1;var factoryWithThrowingShims$1=function factoryWithThrowingShims(){function shim(props,propName,componentName,location,propFullName,secret){if(secret===ReactPropTypesSecret$1$1){// It is still safe when called from React.
return;}var err=new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. '+'Use PropTypes.checkPropTypes() to call them. '+'Read more at http://fb.me/use-check-prop-types');err.name='Invariant Violation';throw err;}shim.isRequired=shim;function getShim(){return shim;}// Important!
// Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
var ReactPropTypes={array:shim,bigint:shim,bool:shim,func:shim,number:shim,object:shim,string:shim,symbol:shim,any:shim,arrayOf:getShim,element:shim,elementType:shim,instanceOf:getShim,node:shim,objectOf:getShim,oneOf:getShim,oneOfType:getShim,shape:getShim,exact:getShim,checkPropTypes:emptyFunctionWithReset$1,resetWarningCache:emptyFunction$1};ReactPropTypes.PropTypes=ReactPropTypes;return ReactPropTypes;};var require$$1$1=factoryWithTypeCheckers$1;var require$$2$1=factoryWithThrowingShims$1;/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var propTypes$1=createCommonjsModule$2(function(module){if(process.env.NODE_ENV!=='production'){var ReactIs=reactIs$1;// By explicitly using `prop-types` you are opting into new development behavior.
// http://fb.me/prop-types-in-prod
var throwOnDirectAccess=true;module.exports=require$$1$1(ReactIs.isElement,throwOnDirectAccess);}else {// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports=require$$2$1();}});var tabbable_1$1=createCommonjsModule$2(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});exports["default"]=findTabbableDescendants;/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */var tabbableNode=/input|select|textarea|button|object|iframe/;function hidesContents(element){var zeroSize=element.offsetWidth<=0&&element.offsetHeight<=0;// If the node is empty, this is good enough
if(zeroSize&&!element.innerHTML)return true;try{// Otherwise we need to check some styles
var style=window.getComputedStyle(element);return zeroSize?style.getPropertyValue("overflow")!=="visible"||// if 'overflow: visible' set, check if there is actually any overflow
element.scrollWidth<=0&&element.scrollHeight<=0:style.getPropertyValue("display")=="none";}catch(exception){// eslint-disable-next-line no-console
console.warn("Failed to inspect element style");return false;}}function visible(element){var parentElement=element;var rootNode=element.getRootNode&&element.getRootNode();while(parentElement){if(parentElement===document.body)break;// if we are not hidden yet, skip to checking outside the Web Component
if(rootNode&&parentElement===rootNode)parentElement=rootNode.host.parentNode;if(hidesContents(parentElement))return false;parentElement=parentElement.parentNode;}return true;}function focusable(element,isTabIndexNotNaN){var nodeName=element.nodeName.toLowerCase();var res=tabbableNode.test(nodeName)&&!element.disabled||(nodeName==="a"?element.href||isTabIndexNotNaN:isTabIndexNotNaN);return res&&visible(element);}function tabbable(element){var tabIndex=element.getAttribute("tabindex");if(tabIndex===null)tabIndex=undefined;var isTabIndexNaN=isNaN(tabIndex);return (isTabIndexNaN||tabIndex>=0)&&focusable(element,!isTabIndexNaN);}function findTabbableDescendants(element){var descendants=[].slice.call(element.querySelectorAll("*"),0).reduce(function(finished,el){return finished.concat(!el.shadowRoot?[el]:findTabbableDescendants(el.shadowRoot));},[]);return descendants.filter(tabbable);}module.exports=exports["default"];});var resetState_1$2$1=resetState$2$1;var log_1$2$1=log$2$1;var handleBlur_1$1=handleBlur$1;var handleFocus_1$1=handleFocus$1;var markForFocusLater_1$1=markForFocusLater$1;var returnFocus_1$1=returnFocus$1;var popWithoutFocus_1$1=popWithoutFocus$1;var setupScopedFocus_1$1=setupScopedFocus$1;var teardownScopedFocus_1$1=teardownScopedFocus$1;var _tabbable2$1=_interopRequireDefault$2$1(tabbable_1$1);function _interopRequireDefault$2$1(obj){return obj&&obj.__esModule?obj:{"default":obj};}var focusLaterElements$1=[];var modalElement$1=null;var needToFocus$1=false;/* eslint-disable no-console */ /* istanbul ignore next */function resetState$2$1(){focusLaterElements$1=[];}/* istanbul ignore next */function log$2$1(){if(process.env.NODE_ENV!=="production"){console.log("focusManager ----------");focusLaterElements$1.forEach(function(f){var check=f||{};console.log(check.nodeName,check.className,check.id);});console.log("end focusManager ----------");}}/* eslint-enable no-console */function handleBlur$1(){needToFocus$1=true;}function handleFocus$1(){if(needToFocus$1){needToFocus$1=false;if(!modalElement$1){return;}// need to see how jQuery shims document.on('focusin') so we don't need the
// setTimeout, firefox doesn't support focusin, if it did, we could focus
// the element outside of a setTimeout. Side-effect of this implementation
// is that the document.body gets focus, and then we focus our element right
// after, seems fine.
setTimeout(function(){if(modalElement$1.contains(document.activeElement)){return;}var el=(0, _tabbable2$1["default"])(modalElement$1)[0]||modalElement$1;el.focus();},0);}}function markForFocusLater$1(){focusLaterElements$1.push(document.activeElement);}/* eslint-disable no-console */function returnFocus$1(){var preventScroll=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var toFocus=null;try{if(focusLaterElements$1.length!==0){toFocus=focusLaterElements$1.pop();toFocus.focus({preventScroll:preventScroll});}return;}catch(e){console.warn(["You tried to return focus to",toFocus,"but it is not in the DOM anymore"].join(" "));}}/* eslint-enable no-console */function popWithoutFocus$1(){focusLaterElements$1.length>0&&focusLaterElements$1.pop();}function setupScopedFocus$1(element){modalElement$1=element;if(window.addEventListener){window.addEventListener("blur",handleBlur$1,false);document.addEventListener("focus",handleFocus$1,true);}else {window.attachEvent("onBlur",handleBlur$1);document.attachEvent("onFocus",handleFocus$1);}}function teardownScopedFocus$1(){modalElement$1=null;if(window.addEventListener){window.removeEventListener("blur",handleBlur$1);document.removeEventListener("focus",handleFocus$1);}else {window.detachEvent("onBlur",handleBlur$1);document.detachEvent("onFocus",handleFocus$1);}}var focusManager$1=/*#__PURE__*/Object.defineProperty({resetState:resetState_1$2$1,log:log_1$2$1,handleBlur:handleBlur_1$1,handleFocus:handleFocus_1$1,markForFocusLater:markForFocusLater_1$1,returnFocus:returnFocus_1$1,popWithoutFocus:popWithoutFocus_1$1,setupScopedFocus:setupScopedFocus_1$1,teardownScopedFocus:teardownScopedFocus_1$1},'__esModule',{value:true});var scopeTab_1$1=createCommonjsModule$2(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});exports["default"]=scopeTab;var _tabbable2=_interopRequireDefault(tabbable_1$1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function getActiveElement(){var el=arguments.length>0&&arguments[0]!==undefined?arguments[0]:document;return el.activeElement.shadowRoot?getActiveElement(el.activeElement.shadowRoot):el.activeElement;}function scopeTab(node,event){var tabbable=(0, _tabbable2["default"])(node);if(!tabbable.length){// Do nothing, since there are no elements that can receive focus.
event.preventDefault();return;}var target=void 0;var shiftKey=event.shiftKey;var head=tabbable[0];var tail=tabbable[tabbable.length-1];var activeElement=getActiveElement();// proceed with default browser behavior on tab.
// Focus on last element on shift + tab.
if(node===activeElement){if(!shiftKey)return;target=tail;}if(tail===activeElement&&!shiftKey){target=head;}if(head===activeElement&&shiftKey){target=tail;}if(target){event.preventDefault();target.focus();return;}// Safari radio issue.
//
// Safari does not move the focus to the radio button,
// so we need to force it to really walk through all elements.
//
// This is very error prone, since we are trying to guess
// if it is a safari browser from the first occurence between
// chrome or safari.
//
// The chrome user agent contains the first ocurrence
// as the 'chrome/version' and later the 'safari/version'.
var checkSafari=/(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);var isSafariDesktop=checkSafari!=null&&checkSafari[1]!="Chrome"&&/\biPod\b|\biPad\b/g.exec(navigator.userAgent)==null;// If we are not in safari desktop, let the browser control
// the focus
if(!isSafariDesktop)return;var x=tabbable.indexOf(activeElement);if(x>-1){x+=shiftKey?-1:1;}target=tabbable[x];// If the tabbable element does not exist,
// focus head/tail based on shiftKey
if(typeof target==="undefined"){event.preventDefault();target=shiftKey?tail:head;target.focus();return;}event.preventDefault();target.focus();}module.exports=exports["default"];});/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */var __DEV__$1=process.env.NODE_ENV!=='production';var warning$1=function warning(){};if(__DEV__$1){var printWarning$3=function printWarning(format,args){var len=arguments.length;args=new Array(len>1?len-1:0);for(var key=1;key<len;key++){args[key-1]=arguments[key];}var argIndex=0;var message='Warning: '+format.replace(/%s/g,function(){return args[argIndex++];});if(typeof console!=='undefined'){console.error(message);}try{// --- Welcome to debugging React ---
// This error was thrown as a convenience so that you can use this stack
// to find the callsite that caused this warning to fire.
throw new Error(message);}catch(x){}};warning$1=function warning(condition,format,args){var len=arguments.length;args=new Array(len>2?len-2:0);for(var key=2;key<len;key++){args[key-2]=arguments[key];}if(format===undefined){throw new Error('`warning(condition, format, ...args)` requires a warning '+'message argument');}if(!condition){printWarning$3.apply(null,[format].concat(args));}};}var warning_1$1=warning$1;var exenv$1=createCommonjsModule$2(function(module){/* global define */(function(){var canUseDOM=!!(typeof window!=='undefined'&&window.document&&window.document.createElement);var ExecutionEnvironment={canUseDOM:canUseDOM,canUseWorkers:typeof Worker!=='undefined',canUseEventListeners:canUseDOM&&!!(window.addEventListener||window.attachEvent),canUseViewport:canUseDOM&&!!window.screen};if(module.exports){module.exports=ExecutionEnvironment;}else {window.ExecutionEnvironment=ExecutionEnvironment;}})();});var safeHTMLElement$1=createCommonjsModule$2(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});exports.canUseDOM=exports.SafeNodeList=exports.SafeHTMLCollection=undefined;var _exenv2=_interopRequireDefault(exenv$1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}var EE=_exenv2["default"];var SafeHTMLElement=EE.canUseDOM?window.HTMLElement:{};exports.SafeHTMLCollection=EE.canUseDOM?window.HTMLCollection:{};exports.SafeNodeList=EE.canUseDOM?window.NodeList:{};exports.canUseDOM=EE.canUseDOM;exports["default"]=SafeHTMLElement;});var resetState_1$1$1=resetState$1$1;var log_1$1$1=log$1$1;var assertNodeList_1$1=assertNodeList$1;var setElement_1$1=setElement$1;var validateElement_1$1=validateElement$1;var hide_1$1=hide$2$1;var show_1$1=show$1;var documentNotReadyOrSSRTesting_1$1=documentNotReadyOrSSRTesting$1;var _warning2$1=_interopRequireDefault$1$1(warning_1$1);function _interopRequireDefault$1$1(obj){return obj&&obj.__esModule?obj:{"default":obj};}var globalElement$1=null;/* eslint-disable no-console */ /* istanbul ignore next */function resetState$1$1(){if(globalElement$1){if(globalElement$1.removeAttribute){globalElement$1.removeAttribute("aria-hidden");}else if(globalElement$1.length!=null){globalElement$1.forEach(function(element){return element.removeAttribute("aria-hidden");});}else {document.querySelectorAll(globalElement$1).forEach(function(element){return element.removeAttribute("aria-hidden");});}}globalElement$1=null;}/* istanbul ignore next */function log$1$1(){if(process.env.NODE_ENV!=="production"){var check=globalElement$1||{};console.log("ariaAppHider ----------");console.log(check.nodeName,check.className,check.id);console.log("end ariaAppHider ----------");}}/* eslint-enable no-console */function assertNodeList$1(nodeList,selector){if(!nodeList||!nodeList.length){throw new Error("react-modal: No elements were found for selector "+selector+".");}}function setElement$1(element){var useElement=element;if(typeof useElement==="string"&&safeHTMLElement$1.canUseDOM){var el=document.querySelectorAll(useElement);assertNodeList$1(el,useElement);useElement=el;}globalElement$1=useElement||globalElement$1;return globalElement$1;}function validateElement$1(appElement){var el=appElement||globalElement$1;if(el){return Array.isArray(el)||el instanceof HTMLCollection||el instanceof NodeList?el:[el];}else {(0, _warning2$1["default"])(false,["react-modal: App element is not defined.","Please use `Modal.setAppElement(el)` or set `appElement={el}`.","This is needed so screen readers don't see main content","when modal is opened. It is not recommended, but you can opt-out","by setting `ariaHideApp={false}`."].join(" "));return [];}}function hide$2$1(appElement){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=validateElement$1(appElement)[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var el=_step.value;el.setAttribute("aria-hidden","true");}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator["return"]){_iterator["return"]();}}finally{if(_didIteratorError){throw _iteratorError;}}}}function show$1(appElement){var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=validateElement$1(appElement)[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var el=_step2.value;el.removeAttribute("aria-hidden");}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2["return"]){_iterator2["return"]();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}}function documentNotReadyOrSSRTesting$1(){globalElement$1=null;}var ariaAppHider$1=/*#__PURE__*/Object.defineProperty({resetState:resetState_1$1$1,log:log_1$1$1,assertNodeList:assertNodeList_1$1,setElement:setElement_1$1,validateElement:validateElement_1$1,hide:hide_1$1,show:show_1$1,documentNotReadyOrSSRTesting:documentNotReadyOrSSRTesting_1$1},'__esModule',{value:true});var classList$1=createCommonjsModule$2(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});exports.resetState=resetState;exports.log=log;var htmlClassList={};var docBodyClassList={};/* eslint-disable no-console */ /* istanbul ignore next */function removeClass(at,cls){at.classList.remove(cls);}/* istanbul ignore next */function resetState(){var htmlElement=document.getElementsByTagName("html")[0];for(var cls in htmlClassList){removeClass(htmlElement,htmlClassList[cls]);}var body=document.body;for(var _cls in docBodyClassList){removeClass(body,docBodyClassList[_cls]);}htmlClassList={};docBodyClassList={};}/* istanbul ignore next */function log(){if(process.env.NODE_ENV!=="production"){var classes=document.getElementsByTagName("html")[0].className;var buffer="Show tracked classes:\n\n";buffer+="<html /> ("+classes+"):\n  ";for(var x in htmlClassList){buffer+="  "+x+" "+htmlClassList[x]+"\n  ";}classes=document.body.className;buffer+="\n\ndoc.body ("+classes+"):\n  ";for(var _x in docBodyClassList){buffer+="  "+_x+" "+docBodyClassList[_x]+"\n  ";}buffer+="\n";console.log(buffer);}}/* eslint-enable no-console */ /**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */var incrementReference=function incrementReference(poll,className){if(!poll[className]){poll[className]=0;}poll[className]+=1;return className;};/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */var decrementReference=function decrementReference(poll,className){if(poll[className]){poll[className]-=1;}return className;};/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */var trackClass=function trackClass(classListRef,poll,classes){classes.forEach(function(className){incrementReference(poll,className);classListRef.add(className);});};/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */var untrackClass=function untrackClass(classListRef,poll,classes){classes.forEach(function(className){decrementReference(poll,className);poll[className]===0&&classListRef.remove(className);});};/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */exports.add=function add(element,classString){return trackClass(element.classList,element.nodeName.toLowerCase()=="html"?htmlClassList:docBodyClassList,classString.split(" "));};/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */exports.remove=function remove(element,classString){return untrackClass(element.classList,element.nodeName.toLowerCase()=="html"?htmlClassList:docBodyClassList,classString.split(" "));};});var log_1$3=log$3;var resetState_1$3=resetState$3;function _classCallCheck$3(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}// Tracks portals that are open and emits events to subscribers
var PortalOpenInstances$1=function PortalOpenInstances(){var _this=this;_classCallCheck$3(this,PortalOpenInstances);this.register=function(openInstance){if(_this.openInstances.indexOf(openInstance)!==-1){if(process.env.NODE_ENV!=="production"){// eslint-disable-next-line no-console
console.warn("React-Modal: Cannot register modal instance that's already open");}return;}_this.openInstances.push(openInstance);_this.emit("register");};this.deregister=function(openInstance){var index=_this.openInstances.indexOf(openInstance);if(index===-1){if(process.env.NODE_ENV!=="production"){// eslint-disable-next-line no-console
console.warn("React-Modal: Unable to deregister "+openInstance+" as "+"it was never registered");}return;}_this.openInstances.splice(index,1);_this.emit("deregister");};this.subscribe=function(callback){_this.subscribers.push(callback);};this.emit=function(eventType){_this.subscribers.forEach(function(subscriber){return subscriber(eventType,// shallow copy to avoid accidental mutation
_this.openInstances.slice());});};this.openInstances=[];this.subscribers=[];};var portalOpenInstances$1=new PortalOpenInstances$1();/* eslint-disable no-console */ /* istanbul ignore next */function log$3(){console.log("portalOpenInstances ----------");console.log(portalOpenInstances$1.openInstances.length);portalOpenInstances$1.openInstances.forEach(function(p){return console.log(p);});console.log("end portalOpenInstances ----------");}/* istanbul ignore next */function resetState$3(){portalOpenInstances$1=new PortalOpenInstances$1();}/* eslint-enable no-console */var _default$1=portalOpenInstances$1;var portalOpenInstances_1$1=/*#__PURE__*/Object.defineProperty({log:log_1$3,resetState:resetState_1$3,"default":_default$1},'__esModule',{value:true});var _portalOpenInstances2$1=_interopRequireDefault$3(portalOpenInstances_1$1);function _interopRequireDefault$3(obj){return obj&&obj.__esModule?obj:{"default":obj};}// Body focus trap see Issue #742
var before$1=void 0,after$1=void 0,instances$1=[];/* eslint-enable no-console */function focusContent$1(){if(instances$1.length===0){if(process.env.NODE_ENV!=="production"){// eslint-disable-next-line no-console
console.warn("React-Modal: Open instances > 0 expected");}return;}instances$1[instances$1.length-1].focusContent();}function bodyTrap$1(eventType,openInstances){if(!before$1&&!after$1){before$1=document.createElement("div");before$1.setAttribute("data-react-modal-body-trap","");before$1.style.position="absolute";before$1.style.opacity="0";before$1.setAttribute("tabindex","0");before$1.addEventListener("focus",focusContent$1);after$1=before$1.cloneNode();after$1.addEventListener("focus",focusContent$1);}instances$1=openInstances;if(instances$1.length>0){// Add focus trap
if(document.body.firstChild!==before$1){document.body.insertBefore(before$1,document.body.firstChild);}if(document.body.lastChild!==after$1){document.body.appendChild(after$1);}}else {// Remove focus trap
if(before$1.parentElement){before$1.parentElement.removeChild(before$1);}if(after$1.parentElement){after$1.parentElement.removeChild(after$1);}}}_portalOpenInstances2$1["default"].subscribe(bodyTrap$1);var _propTypes$1=propTypes$1;var ModalPortal_1$1=createCommonjsModule$2(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _typeof$1=typeof Symbol==="function"&&_typeof(Symbol.iterator)==="symbol"?function(obj){return _typeof(obj);}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":_typeof(obj);};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _propTypes2=_interopRequireDefault(_propTypes$1);var focusManager$1$1=_interopRequireWildcard(focusManager$1);var _scopeTab2=_interopRequireDefault(scopeTab_1$1);var ariaAppHider$1$1=_interopRequireWildcard(ariaAppHider$1);var classList$1$1=_interopRequireWildcard(classList$1);var _safeHTMLElement2=_interopRequireDefault(safeHTMLElement$1);var _portalOpenInstances2=_interopRequireDefault(portalOpenInstances_1$1);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else {var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj["default"]=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(_typeof(call)==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+_typeof(superClass));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// so that our CSS is statically analyzable
var CLASS_NAMES={overlay:"ReactModal__Overlay",content:"ReactModal__Content"};var TAB_KEY=9;var ESC_KEY=27;var ariaHiddenInstances=0;var ModalPortal=function(_Component){_inherits(ModalPortal,_Component);function ModalPortal(props){_classCallCheck(this,ModalPortal);var _this=_possibleConstructorReturn(this,(ModalPortal.__proto__||Object.getPrototypeOf(ModalPortal)).call(this,props));_this.setOverlayRef=function(overlay){_this.overlay=overlay;_this.props.overlayRef&&_this.props.overlayRef(overlay);};_this.setContentRef=function(content){_this.content=content;_this.props.contentRef&&_this.props.contentRef(content);};_this.afterClose=function(){var _this$props=_this.props,appElement=_this$props.appElement,ariaHideApp=_this$props.ariaHideApp,htmlOpenClassName=_this$props.htmlOpenClassName,bodyOpenClassName=_this$props.bodyOpenClassName;// Remove classes.
bodyOpenClassName&&classList$1$1.remove(document.body,bodyOpenClassName);htmlOpenClassName&&classList$1$1.remove(document.getElementsByTagName("html")[0],htmlOpenClassName);// Reset aria-hidden attribute if all modals have been removed
if(ariaHideApp&&ariaHiddenInstances>0){ariaHiddenInstances-=1;if(ariaHiddenInstances===0){ariaAppHider$1$1.show(appElement);}}if(_this.props.shouldFocusAfterRender){if(_this.props.shouldReturnFocusAfterClose){focusManager$1$1.returnFocus(_this.props.preventScroll);focusManager$1$1.teardownScopedFocus();}else {focusManager$1$1.popWithoutFocus();}}if(_this.props.onAfterClose){_this.props.onAfterClose();}_portalOpenInstances2["default"].deregister(_this);};_this.open=function(){_this.beforeOpen();if(_this.state.afterOpen&&_this.state.beforeClose){clearTimeout(_this.closeTimer);_this.setState({beforeClose:false});}else {if(_this.props.shouldFocusAfterRender){focusManager$1$1.setupScopedFocus(_this.node);focusManager$1$1.markForFocusLater();}_this.setState({isOpen:true},function(){_this.openAnimationFrame=requestAnimationFrame(function(){_this.setState({afterOpen:true});if(_this.props.isOpen&&_this.props.onAfterOpen){_this.props.onAfterOpen({overlayEl:_this.overlay,contentEl:_this.content});}});});}};_this.close=function(){if(_this.props.closeTimeoutMS>0){_this.closeWithTimeout();}else {_this.closeWithoutTimeout();}};_this.focusContent=function(){return _this.content&&!_this.contentHasFocus()&&_this.content.focus({preventScroll:true});};_this.closeWithTimeout=function(){var closesAt=Date.now()+_this.props.closeTimeoutMS;_this.setState({beforeClose:true,closesAt:closesAt},function(){_this.closeTimer=setTimeout(_this.closeWithoutTimeout,_this.state.closesAt-Date.now());});};_this.closeWithoutTimeout=function(){_this.setState({beforeClose:false,isOpen:false,afterOpen:false,closesAt:null},_this.afterClose);};_this.handleKeyDown=function(event){if(event.keyCode===TAB_KEY){(0, _scopeTab2["default"])(_this.content,event);}if(_this.props.shouldCloseOnEsc&&event.keyCode===ESC_KEY){event.stopPropagation();_this.requestClose(event);}};_this.handleOverlayOnClick=function(event){if(_this.shouldClose===null){_this.shouldClose=true;}if(_this.shouldClose&&_this.props.shouldCloseOnOverlayClick){if(_this.ownerHandlesClose()){_this.requestClose(event);}else {_this.focusContent();}}_this.shouldClose=null;};_this.handleContentOnMouseUp=function(){_this.shouldClose=false;};_this.handleOverlayOnMouseDown=function(event){if(!_this.props.shouldCloseOnOverlayClick&&event.target==_this.overlay){event.preventDefault();}};_this.handleContentOnClick=function(){_this.shouldClose=false;};_this.handleContentOnMouseDown=function(){_this.shouldClose=false;};_this.requestClose=function(event){return _this.ownerHandlesClose()&&_this.props.onRequestClose(event);};_this.ownerHandlesClose=function(){return _this.props.onRequestClose;};_this.shouldBeClosed=function(){return !_this.state.isOpen&&!_this.state.beforeClose;};_this.contentHasFocus=function(){return document.activeElement===_this.content||_this.content.contains(document.activeElement);};_this.buildClassName=function(which,additional){var classNames=(typeof additional==="undefined"?"undefined":_typeof$1(additional))==="object"?additional:{base:CLASS_NAMES[which],afterOpen:CLASS_NAMES[which]+"--after-open",beforeClose:CLASS_NAMES[which]+"--before-close"};var className=classNames.base;if(_this.state.afterOpen){className=className+" "+classNames.afterOpen;}if(_this.state.beforeClose){className=className+" "+classNames.beforeClose;}return typeof additional==="string"&&additional?className+" "+additional:className;};_this.attributesFromObject=function(prefix,items){return Object.keys(items).reduce(function(acc,name){acc[prefix+"-"+name]=items[name];return acc;},{});};_this.state={afterOpen:false,beforeClose:false};_this.shouldClose=null;_this.moveFromContentToOverlay=null;return _this;}_createClass(ModalPortal,[{key:"componentDidMount",value:function componentDidMount(){if(this.props.isOpen){this.open();}}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){if(process.env.NODE_ENV!=="production"){if(prevProps.bodyOpenClassName!==this.props.bodyOpenClassName){// eslint-disable-next-line no-console
console.warn('React-Modal: "bodyOpenClassName" prop has been modified. '+"This may cause unexpected behavior when multiple modals are open.");}if(prevProps.htmlOpenClassName!==this.props.htmlOpenClassName){// eslint-disable-next-line no-console
console.warn('React-Modal: "htmlOpenClassName" prop has been modified. '+"This may cause unexpected behavior when multiple modals are open.");}}if(this.props.isOpen&&!prevProps.isOpen){this.open();}else if(!this.props.isOpen&&prevProps.isOpen){this.close();}// Focus only needs to be set once when the modal is being opened
if(this.props.shouldFocusAfterRender&&this.state.isOpen&&!prevState.isOpen){this.focusContent();}}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(this.state.isOpen){this.afterClose();}clearTimeout(this.closeTimer);cancelAnimationFrame(this.openAnimationFrame);}},{key:"beforeOpen",value:function beforeOpen(){var _props=this.props,appElement=_props.appElement,ariaHideApp=_props.ariaHideApp,htmlOpenClassName=_props.htmlOpenClassName,bodyOpenClassName=_props.bodyOpenClassName;// Add classes.
bodyOpenClassName&&classList$1$1.add(document.body,bodyOpenClassName);htmlOpenClassName&&classList$1$1.add(document.getElementsByTagName("html")[0],htmlOpenClassName);if(ariaHideApp){ariaHiddenInstances+=1;ariaAppHider$1$1.hide(appElement);}_portalOpenInstances2["default"].register(this);}// Don't steal focus from inner elements
},{key:"render",value:function render(){var _props2=this.props,id=_props2.id,className=_props2.className,overlayClassName=_props2.overlayClassName,defaultStyles=_props2.defaultStyles,children=_props2.children;var contentStyles=className?{}:defaultStyles.content;var overlayStyles=overlayClassName?{}:defaultStyles.overlay;if(this.shouldBeClosed()){return null;}var overlayProps={ref:this.setOverlayRef,className:this.buildClassName("overlay",overlayClassName),style:_extends({},overlayStyles,this.props.style.overlay),onClick:this.handleOverlayOnClick,onMouseDown:this.handleOverlayOnMouseDown};var contentProps=_extends({id:id,ref:this.setContentRef,style:_extends({},contentStyles,this.props.style.content),className:this.buildClassName("content",className),tabIndex:"-1",onKeyDown:this.handleKeyDown,onMouseDown:this.handleContentOnMouseDown,onMouseUp:this.handleContentOnMouseUp,onClick:this.handleContentOnClick,role:this.props.role,"aria-label":this.props.contentLabel},this.attributesFromObject("aria",_extends({modal:true},this.props.aria)),this.attributesFromObject("data",this.props.data||{}),{"data-testid":this.props.testId});var contentElement=this.props.contentElement(contentProps,children);return this.props.overlayElement(overlayProps,contentElement);}}]);return ModalPortal;}(React__default.Component);ModalPortal.defaultProps={style:{overlay:{},content:{}},defaultStyles:{}};ModalPortal.propTypes={isOpen:_propTypes2["default"].bool.isRequired,defaultStyles:_propTypes2["default"].shape({content:_propTypes2["default"].object,overlay:_propTypes2["default"].object}),style:_propTypes2["default"].shape({content:_propTypes2["default"].object,overlay:_propTypes2["default"].object}),className:_propTypes2["default"].oneOfType([_propTypes2["default"].string,_propTypes2["default"].object]),overlayClassName:_propTypes2["default"].oneOfType([_propTypes2["default"].string,_propTypes2["default"].object]),bodyOpenClassName:_propTypes2["default"].string,htmlOpenClassName:_propTypes2["default"].string,ariaHideApp:_propTypes2["default"].bool,appElement:_propTypes2["default"].oneOfType([_propTypes2["default"].instanceOf(_safeHTMLElement2["default"]),_propTypes2["default"].instanceOf(safeHTMLElement$1.SafeHTMLCollection),_propTypes2["default"].instanceOf(safeHTMLElement$1.SafeNodeList),_propTypes2["default"].arrayOf(_propTypes2["default"].instanceOf(_safeHTMLElement2["default"]))]),onAfterOpen:_propTypes2["default"].func,onAfterClose:_propTypes2["default"].func,onRequestClose:_propTypes2["default"].func,closeTimeoutMS:_propTypes2["default"].number,shouldFocusAfterRender:_propTypes2["default"].bool,shouldCloseOnOverlayClick:_propTypes2["default"].bool,shouldReturnFocusAfterClose:_propTypes2["default"].bool,preventScroll:_propTypes2["default"].bool,role:_propTypes2["default"].string,contentLabel:_propTypes2["default"].string,aria:_propTypes2["default"].object,data:_propTypes2["default"].object,children:_propTypes2["default"].node,shouldCloseOnEsc:_propTypes2["default"].bool,overlayRef:_propTypes2["default"].func,contentRef:_propTypes2["default"].func,id:_propTypes2["default"].string,overlayElement:_propTypes2["default"].func,contentElement:_propTypes2["default"].func,testId:_propTypes2["default"].string};exports["default"]=ModalPortal;module.exports=exports["default"];});/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */function componentWillMount$1(){// Call this.constructor.gDSFP to support sub-classes.
var state=this.constructor.getDerivedStateFromProps(this.props,this.state);if(state!==null&&state!==undefined){this.setState(state);}}function componentWillReceiveProps$1(nextProps){// Call this.constructor.gDSFP to support sub-classes.
// Use the setState() updater to ensure state isn't stale in certain edge cases.
function updater(prevState){var state=this.constructor.getDerivedStateFromProps(nextProps,prevState);return state!==null&&state!==undefined?state:null;}// Binding "this" is important for shallow renderer support.
this.setState(updater.bind(this));}function componentWillUpdate$1(nextProps,nextState){try{var prevProps=this.props;var prevState=this.state;this.props=nextProps;this.state=nextState;this.__reactInternalSnapshotFlag=true;this.__reactInternalSnapshot=this.getSnapshotBeforeUpdate(prevProps,prevState);}finally{this.props=prevProps;this.state=prevState;}}// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount$1.__suppressDeprecationWarning=true;componentWillReceiveProps$1.__suppressDeprecationWarning=true;componentWillUpdate$1.__suppressDeprecationWarning=true;function polyfill$2(Component){var prototype=Component.prototype;if(!prototype||!prototype.isReactComponent){throw new Error('Can only polyfill class components');}if(typeof Component.getDerivedStateFromProps!=='function'&&typeof prototype.getSnapshotBeforeUpdate!=='function'){return Component;}// If new component APIs are defined, "unsafe" lifecycles won't be called.
// Error if any of these lifecycles are present,
// Because they would work differently between older and newer (16.3+) versions of React.
var foundWillMountName=null;var foundWillReceivePropsName=null;var foundWillUpdateName=null;if(typeof prototype.componentWillMount==='function'){foundWillMountName='componentWillMount';}else if(typeof prototype.UNSAFE_componentWillMount==='function'){foundWillMountName='UNSAFE_componentWillMount';}if(typeof prototype.componentWillReceiveProps==='function'){foundWillReceivePropsName='componentWillReceiveProps';}else if(typeof prototype.UNSAFE_componentWillReceiveProps==='function'){foundWillReceivePropsName='UNSAFE_componentWillReceiveProps';}if(typeof prototype.componentWillUpdate==='function'){foundWillUpdateName='componentWillUpdate';}else if(typeof prototype.UNSAFE_componentWillUpdate==='function'){foundWillUpdateName='UNSAFE_componentWillUpdate';}if(foundWillMountName!==null||foundWillReceivePropsName!==null||foundWillUpdateName!==null){var componentName=Component.displayName||Component.name;var newApiName=typeof Component.getDerivedStateFromProps==='function'?'getDerivedStateFromProps()':'getSnapshotBeforeUpdate()';throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n'+componentName+' uses '+newApiName+' but also contains the following legacy lifecycles:'+(foundWillMountName!==null?'\n  '+foundWillMountName:'')+(foundWillReceivePropsName!==null?'\n  '+foundWillReceivePropsName:'')+(foundWillUpdateName!==null?'\n  '+foundWillUpdateName:'')+'\n\nThe above lifecycles should be removed. Learn more about this warning here:\n'+'https://fb.me/react-async-component-lifecycle-hooks');}// React <= 16.2 does not support static getDerivedStateFromProps.
// As a workaround, use cWM and cWRP to invoke the new static lifecycle.
// Newer versions of React will ignore these lifecycles if gDSFP exists.
if(typeof Component.getDerivedStateFromProps==='function'){prototype.componentWillMount=componentWillMount$1;prototype.componentWillReceiveProps=componentWillReceiveProps$1;}// React <= 16.2 does not support getSnapshotBeforeUpdate.
// As a workaround, use cWU to invoke the new lifecycle.
// Newer versions of React will ignore that lifecycle if gSBU exists.
if(typeof prototype.getSnapshotBeforeUpdate==='function'){if(typeof prototype.componentDidUpdate!=='function'){throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');}prototype.componentWillUpdate=componentWillUpdate$1;var componentDidUpdate=prototype.componentDidUpdate;prototype.componentDidUpdate=function componentDidUpdatePolyfill(prevProps,prevState,maybeSnapshot){// 16.3+ will not execute our will-update method;
// It will pass a snapshot value to did-update though.
// Older versions will require our polyfilled will-update value.
// We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
// Because for <= 15.x versions this might be a "prevContext" object.
// We also can't just check "__reactInternalSnapshot",
// Because get-snapshot might return a falsy value.
// So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
var snapshot=this.__reactInternalSnapshotFlag?this.__reactInternalSnapshot:maybeSnapshot;componentDidUpdate.call(this,prevProps,prevState,snapshot);};}return Component;}var reactLifecyclesCompat_es$1=/*#__PURE__*/Object.freeze({__proto__:null,polyfill:polyfill$2});var _reactLifecyclesCompat$1=/*@__PURE__*/getAugmentedNamespace$1(reactLifecyclesCompat_es$1);var Modal_1$1=createCommonjsModule$2(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});exports.bodyOpenClassName=exports.portalClassName=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react2=_interopRequireDefault(React__default);var _reactDom2=_interopRequireDefault(reactDom__default);var _propTypes2=_interopRequireDefault(_propTypes$1);var _ModalPortal2=_interopRequireDefault(ModalPortal_1$1);var ariaAppHider$1$1=_interopRequireWildcard(ariaAppHider$1);var _safeHTMLElement2=_interopRequireDefault(safeHTMLElement$1);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else {var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj["default"]=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(_typeof(call)==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+_typeof(superClass));}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var portalClassName=exports.portalClassName="ReactModalPortal";var bodyOpenClassName=exports.bodyOpenClassName="ReactModal__Body--open";var isReact16=safeHTMLElement$1.canUseDOM&&_reactDom2["default"].createPortal!==undefined;var createHTMLElement=function createHTMLElement(name){return document.createElement(name);};var getCreatePortal=function getCreatePortal(){return isReact16?_reactDom2["default"].createPortal:_reactDom2["default"].unstable_renderSubtreeIntoContainer;};function getParentElement(parentSelector){return parentSelector();}var Modal=function(_Component){_inherits(Modal,_Component);function Modal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Modal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Modal.__proto__||Object.getPrototypeOf(Modal)).call.apply(_ref,[this].concat(args))),_this),_this.removePortal=function(){!isReact16&&_reactDom2["default"].unmountComponentAtNode(_this.node);var parent=getParentElement(_this.props.parentSelector);if(parent&&parent.contains(_this.node)){parent.removeChild(_this.node);}else {// eslint-disable-next-line no-console
console.warn('React-Modal: "parentSelector" prop did not returned any DOM '+"element. Make sure that the parent element is unmounted to "+"avoid any memory leaks.");}},_this.portalRef=function(ref){_this.portal=ref;},_this.renderPortal=function(props){var createPortal=getCreatePortal();var portal=createPortal(_this,_react2["default"].createElement(_ModalPortal2["default"],_extends({defaultStyles:Modal.defaultStyles},props)),_this.node);_this.portalRef(portal);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Modal,[{key:"componentDidMount",value:function componentDidMount(){if(!safeHTMLElement$1.canUseDOM)return;if(!isReact16){this.node=createHTMLElement("div");}this.node.className=this.props.portalClassName;var parent=getParentElement(this.props.parentSelector);parent.appendChild(this.node);!isReact16&&this.renderPortal(this.props);}},{key:"getSnapshotBeforeUpdate",value:function getSnapshotBeforeUpdate(prevProps){var prevParent=getParentElement(prevProps.parentSelector);var nextParent=getParentElement(this.props.parentSelector);return {prevParent:prevParent,nextParent:nextParent};}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,_,snapshot){if(!safeHTMLElement$1.canUseDOM)return;var _props=this.props,isOpen=_props.isOpen,portalClassName=_props.portalClassName;if(prevProps.portalClassName!==portalClassName){this.node.className=portalClassName;}var prevParent=snapshot.prevParent,nextParent=snapshot.nextParent;if(nextParent!==prevParent){prevParent.removeChild(this.node);nextParent.appendChild(this.node);}// Stop unnecessary renders if modal is remaining closed
if(!prevProps.isOpen&&!isOpen)return;!isReact16&&this.renderPortal(this.props);}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(!safeHTMLElement$1.canUseDOM||!this.node||!this.portal)return;var state=this.portal.state;var now=Date.now();var closesAt=state.isOpen&&this.props.closeTimeoutMS&&(state.closesAt||now+this.props.closeTimeoutMS);if(closesAt){if(!state.beforeClose){this.portal.closeWithTimeout();}setTimeout(this.removePortal,closesAt-now);}else {this.removePortal();}}},{key:"render",value:function render(){if(!safeHTMLElement$1.canUseDOM||!isReact16){return null;}if(!this.node&&isReact16){this.node=createHTMLElement("div");}var createPortal=getCreatePortal();return createPortal(_react2["default"].createElement(_ModalPortal2["default"],_extends({ref:this.portalRef,defaultStyles:Modal.defaultStyles},this.props)),this.node);}}],[{key:"setAppElement",value:function setAppElement(element){ariaAppHider$1$1.setElement(element);}/* eslint-disable react/no-unused-prop-types */ /* eslint-enable react/no-unused-prop-types */}]);return Modal;}(React__default.Component);Modal.propTypes={isOpen:_propTypes2["default"].bool.isRequired,style:_propTypes2["default"].shape({content:_propTypes2["default"].object,overlay:_propTypes2["default"].object}),portalClassName:_propTypes2["default"].string,bodyOpenClassName:_propTypes2["default"].string,htmlOpenClassName:_propTypes2["default"].string,className:_propTypes2["default"].oneOfType([_propTypes2["default"].string,_propTypes2["default"].shape({base:_propTypes2["default"].string.isRequired,afterOpen:_propTypes2["default"].string.isRequired,beforeClose:_propTypes2["default"].string.isRequired})]),overlayClassName:_propTypes2["default"].oneOfType([_propTypes2["default"].string,_propTypes2["default"].shape({base:_propTypes2["default"].string.isRequired,afterOpen:_propTypes2["default"].string.isRequired,beforeClose:_propTypes2["default"].string.isRequired})]),appElement:_propTypes2["default"].oneOfType([_propTypes2["default"].instanceOf(_safeHTMLElement2["default"]),_propTypes2["default"].instanceOf(safeHTMLElement$1.SafeHTMLCollection),_propTypes2["default"].instanceOf(safeHTMLElement$1.SafeNodeList),_propTypes2["default"].arrayOf(_propTypes2["default"].instanceOf(_safeHTMLElement2["default"]))]),onAfterOpen:_propTypes2["default"].func,onRequestClose:_propTypes2["default"].func,closeTimeoutMS:_propTypes2["default"].number,ariaHideApp:_propTypes2["default"].bool,shouldFocusAfterRender:_propTypes2["default"].bool,shouldCloseOnOverlayClick:_propTypes2["default"].bool,shouldReturnFocusAfterClose:_propTypes2["default"].bool,preventScroll:_propTypes2["default"].bool,parentSelector:_propTypes2["default"].func,aria:_propTypes2["default"].object,data:_propTypes2["default"].object,role:_propTypes2["default"].string,contentLabel:_propTypes2["default"].string,shouldCloseOnEsc:_propTypes2["default"].bool,overlayRef:_propTypes2["default"].func,contentRef:_propTypes2["default"].func,id:_propTypes2["default"].string,overlayElement:_propTypes2["default"].func,contentElement:_propTypes2["default"].func};Modal.defaultProps={isOpen:false,portalClassName:portalClassName,bodyOpenClassName:bodyOpenClassName,role:"dialog",ariaHideApp:true,closeTimeoutMS:0,shouldFocusAfterRender:true,shouldCloseOnEsc:true,shouldCloseOnOverlayClick:true,shouldReturnFocusAfterClose:true,preventScroll:false,parentSelector:function parentSelector(){return document.body;},overlayElement:function overlayElement(props,contentEl){return _react2["default"].createElement("div",props,contentEl);},contentElement:function contentElement(props,children){return _react2["default"].createElement("div",props,children);}};Modal.defaultStyles={overlay:{position:"fixed",top:0,left:0,right:0,bottom:0,backgroundColor:"rgba(255, 255, 255, 0.75)"},content:{position:"absolute",top:"40px",left:"40px",right:"40px",bottom:"40px",border:"1px solid #ccc",background:"#fff",overflow:"auto",WebkitOverflowScrolling:"touch",borderRadius:"4px",outline:"none",padding:"20px"}};(0, _reactLifecyclesCompat$1.polyfill)(Modal);if(process.env.NODE_ENV!=="production"){Modal.setCreateHTMLElement=function(fn){return createHTMLElement=fn;};}exports["default"]=Modal;});var lib$1=createCommonjsModule$2(function(module,exports){Object.defineProperty(exports,"__esModule",{value:true});var _Modal2=_interopRequireDefault(Modal_1$1);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}exports["default"]=_Modal2["default"];module.exports=exports["default"];});var Modal$1=/*@__PURE__*/getDefaultExportFromCjs$1(lib$1);var ClickDurationMili$1=300;var resolveBackgroundCardColor=function resolveBackgroundCardColor(enabled){if(!enabled)return '#EEF1F5';else return '#FFFFFF';};var resolveIcon$1=function resolveIcon(variant,enabled){if(!enabled){switch(variant){case'back':return 'back-grey';default:return 'x-inactive-icon';}}switch(variant){case'back':return 'back-blue';case'close':return 'x-icon';}};var GeneralButton=/*#__PURE__*/function(_Component){_inherits(GeneralButton,_Component);var _super=_createSuper(GeneralButton);function GeneralButton(){var _this;_classCallCheck$1(this,GeneralButton);_this=_super.apply(this,arguments);_this.state={hovered:false,clicked:false};_this.handleMouseEnter=function(){_this.setState({hovered:true});};_this.handleMouseLeave=function(){_this.setState({hovered:false});};_this.handleClick=function(){var onClick=_this.props.onClick;if(_this.clickTimeoutId)window.clearTimeout(_this.clickTimeoutId);_this.setState({clicked:true});_this.clickTimeoutId=window.setTimeout(function(){_this.setState({clicked:false});},ClickDurationMili$1);// call original props onClick
onClick&&onClick();};return _this;}_createClass(GeneralButton,[{key:"componentWillUnmount",value:function componentWillUnmount(){if(this.clickTimeoutId)window.clearTimeout(this.clickTimeoutId);}},{key:"render",value:function render(){var _this$props=this.props,variant=_this$props.variant,_this$props$enabled=_this$props.enabled,enabled=_this$props$enabled===void 0?true:_this$props$enabled,style=_this$props.style,className=_this$props.className;var clicked=this.state.clicked;var classes=['CyoloUI-GeneralButton-Card'];if(!enabled){classes.push('CyoloUI-GeneralButton-Disabled');}if(clicked){classes.push('CyoloUI-GeneralButton-Card-Clicked');}return/*#__PURE__*/React__default.createElement("div",{className:clsx$1('CyoloUI-GeneralButton',className),onMouseEnter:this.handleMouseEnter,onMouseLeave:this.handleMouseLeave,onClick:this.handleClick,style:Object.assign({},style)},/*#__PURE__*/React__default.createElement("div",{className:classes.join(' '),style:{backgroundColor:resolveBackgroundCardColor(enabled)}},/*#__PURE__*/React__default.createElement(Icon,{id:resolveIcon$1(variant,enabled)})));}}]);return GeneralButton;}(Component);var useStyles$f$1=createUseStyles(function(theme){return {modal:function modal(_ref){var width=_ref.width;return {border:'none',flex:1,top:'50%',left:'50%',padding:0,right:'auto',bottom:'auto',marginRight:'-50%',transform:'translate(-50%, -50%)',backgroundColor:theme.palette.background.color,width:width?"".concat(width,"%"):null,outline:'none',borderRadius:theme.shape.borderRadiusLight,position:'absolute',overflow:'hidden'};},overlay:{position:'fixed',inset:0,zIndex:theme.zIndex.high,background:'rgba(0, 0, 0, 0.5)'},xButton:{position:'absolute',top:8,right:8},topBar:{padding:'10px 20px',display:'flex',flexDirection:'row',backgroundColor:theme.palette.white.color,boxShadow:'1px 1px 25px rgba(0, 0, 0, 0.1)',alignItems:'center'},content:{padding:'10px 20px',overflow:'auto'},bottom:{padding:'0px 2px',display:'flex',flexDirection:'row',alignItems:'center'},actions:{padding:'10px 10px',display:'flex',flexDirection:'row',justifyContent:'flex-end',flex:1},bottomText:{padding:'0px 20px',display:'flex',flexDirection:'row',justifyContent:'flex-start',flex:1},title:{whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',paddingRight:24}};});// @ts-nocheck
var Dialog=function Dialog(_ref){var children=_ref.children,width=_ref.width,title=_ref.title,_ref$showXButton=_ref.showXButton,showXButton=_ref$showXButton===void 0?true:_ref$showXButton,_ref$acceptButtonText=_ref.acceptButtonText,acceptButtonText=_ref$acceptButtonText===void 0?'Accept':_ref$acceptButtonText,_ref$cancelButtonText=_ref.cancelButtonText,cancelButtonText=_ref$cancelButtonText===void 0?'Cancel':_ref$cancelButtonText,onAccept=_ref.onAccept,onCancel=_ref.onCancel,bottomText=_ref.bottomText,_ref$valid=_ref.valid,valid=_ref$valid===void 0?true:_ref$valid,style=_ref.style,className=_ref.className;var theme=useThemeSafe();var classes=useStyles$f$1({theme:theme,width:width});var showCancelBtn=!!(cancelButtonText&&onCancel);var showAcceptBtn=!!(acceptButtonText&&onAccept);var showDivider=showAcceptBtn||showCancelBtn||!!bottomText;return/*#__PURE__*/React__default.createElement("div",null,/*#__PURE__*/React__default.createElement(Modal$1,{isOpen:true,appElement:document===null||document===void 0?void 0:document.getElementById('root'),overlayClassName:classes.overlay,className:clsx$1(classes.modal,className),style:style,onRequestClose:onCancel},/*#__PURE__*/React__default.createElement("div",{className:classes.topBar},/*#__PURE__*/React__default.createElement(Text$1,{variant:"header-2",className:classes.title,title:title},title),showXButton&&/*#__PURE__*/React__default.createElement(GeneralButton,{variant:"close",className:classes.xButton,onClick:onCancel})),/*#__PURE__*/React__default.createElement("div",{className:classes.content},children),showDivider&&/*#__PURE__*/React__default.createElement(Divider$1,{orientation:"horizontal",thickness:"1px",className:classes.disabledGrey}),/*#__PURE__*/React__default.createElement("div",{className:classes.bottom},/*#__PURE__*/React__default.createElement("div",{className:classes.bottomText},/*#__PURE__*/React__default.createElement(Text$1,{variant:"body"},bottomText)),/*#__PURE__*/React__default.createElement("div",{className:classes.actions},/*#__PURE__*/React__default.createElement("div",null),showCancelBtn&&/*#__PURE__*/React__default.createElement(Button,{variant:"secondary",onClick:onCancel,style:{margin:'0 8px'}},cancelButtonText),showAcceptBtn&&/*#__PURE__*/React__default.createElement(Button,{variant:"primary",disabled:!valid,onClick:onAccept,style:{margin:'0 8px'}},acceptButtonText)))));};var DropdownAddButton=function DropdownAddButton(_ref){var actionBtn=_ref.actionBtn,onVisibilityChange=_ref.onVisibilityChange;var classes=useStyles$e$1();var onClick=function onClick(){actionBtn.onClick();onVisibilityChange(false);};return/*#__PURE__*/React__default.createElement("div",{className:classes.actionContent,onClick:onClick},/*#__PURE__*/React__default.createElement(Icon,{id:"add-blue"}),/*#__PURE__*/React__default.createElement(Text$1,{className:classes.text,variant:"body"},actionBtn.text));};var useStyles$e$1=createUseStyles({actionContent:{display:'flex',marginBottom:4,marginLeft:8,alignItems:'flex-start',cursor:'pointer'},text:{marginLeft:8,marginTop:1}});/**
 * Simple ponyfill for Object.fromEntries
 */var fromEntries$1=function fromEntries(entries){return entries.reduce(function(acc,_ref){var key=_ref[0],value=_ref[1];acc[key]=value;return acc;},{});};/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */var useIsomorphicLayoutEffect$2=typeof window!=='undefined'&&window.document&&window.document.createElement?React.useLayoutEffect:React.useEffect;var top$1='top';var bottom$1='bottom';var right$1='right';var left$1='left';var auto$1='auto';var basePlacements$1=[top$1,bottom$1,right$1,left$1];var start$1='start';var end$1='end';var clippingParents$1='clippingParents';var viewport$1='viewport';var popper$1='popper';var reference$1='reference';var variationPlacements$1=/*#__PURE__*/basePlacements$1.reduce(function(acc,placement){return acc.concat([placement+"-"+start$1,placement+"-"+end$1]);},[]);var placements$1=/*#__PURE__*/[].concat(basePlacements$1,[auto$1]).reduce(function(acc,placement){return acc.concat([placement,placement+"-"+start$1,placement+"-"+end$1]);},[]);// modifiers that need to read the DOM
var beforeRead$1='beforeRead';var read$1='read';var afterRead$1='afterRead';// pure-logic modifiers
var beforeMain$1='beforeMain';var main$1='main';var afterMain$1='afterMain';// modifier with the purpose to write to the DOM (or write into a framework state)
var beforeWrite$1='beforeWrite';var write$1='write';var afterWrite$1='afterWrite';var modifierPhases$1=[beforeRead$1,read$1,afterRead$1,beforeMain$1,main$1,afterMain$1,beforeWrite$1,write$1,afterWrite$1];function getNodeName$1(element){return element?(element.nodeName||'').toLowerCase():null;}function getWindow$2(node){if(node==null){return window;}if(node.toString()!=='[object Window]'){var ownerDocument=node.ownerDocument;return ownerDocument?ownerDocument.defaultView||window:window;}return node;}function isElement$2(node){var OwnElement=getWindow$2(node).Element;return node instanceof OwnElement||node instanceof Element;}function isHTMLElement$3(node){var OwnElement=getWindow$2(node).HTMLElement;return node instanceof OwnElement||node instanceof HTMLElement;}function isShadowRoot$1(node){// IE 11 has no ShadowRoot
if(typeof ShadowRoot==='undefined'){return false;}var OwnElement=getWindow$2(node).ShadowRoot;return node instanceof OwnElement||node instanceof ShadowRoot;}// and applies them to the HTMLElements such as popper and arrow
function applyStyles$2(_ref){var state=_ref.state;Object.keys(state.elements).forEach(function(name){var style=state.styles[name]||{};var attributes=state.attributes[name]||{};var element=state.elements[name];// arrow is optional + virtual elements
if(!isHTMLElement$3(element)||!getNodeName$1(element)){return;}// Flow doesn't support to extend this property, but it's the most
// effective way to apply styles to an HTMLElement
// $FlowFixMe[cannot-write]
Object.assign(element.style,style);Object.keys(attributes).forEach(function(name){var value=attributes[name];if(value===false){element.removeAttribute(name);}else {element.setAttribute(name,value===true?'':value);}});});}function effect$2$1(_ref2){var state=_ref2.state;var initialStyles={popper:{position:state.options.strategy,left:'0',top:'0',margin:'0'},arrow:{position:'absolute'},reference:{}};Object.assign(state.elements.popper.style,initialStyles.popper);state.styles=initialStyles;if(state.elements.arrow){Object.assign(state.elements.arrow.style,initialStyles.arrow);}return function(){Object.keys(state.elements).forEach(function(name){var element=state.elements[name];var attributes=state.attributes[name]||{};var styleProperties=Object.keys(state.styles.hasOwnProperty(name)?state.styles[name]:initialStyles[name]);// Set all values to an empty string to unset them
var style=styleProperties.reduce(function(style,property){style[property]='';return style;},{});// arrow is optional + virtual elements
if(!isHTMLElement$3(element)||!getNodeName$1(element)){return;}Object.assign(element.style,style);Object.keys(attributes).forEach(function(attribute){element.removeAttribute(attribute);});});};}// eslint-disable-next-line import/no-unused-modules
var applyStyles$1$1={name:'applyStyles',enabled:true,phase:'write',fn:applyStyles$2,effect:effect$2$1,requires:['computeStyles']};function getBasePlacement$1(placement){return placement.split('-')[0];}var max$2=Math.max;var min$2=Math.min;var round$1=Math.round;function getBoundingClientRect$1(element,includeScale){if(includeScale===void 0){includeScale=false;}var rect=element.getBoundingClientRect();var scaleX=1;var scaleY=1;if(isHTMLElement$3(element)&&includeScale){var offsetHeight=element.offsetHeight;var offsetWidth=element.offsetWidth;// Do not attempt to divide by 0, otherwise we get `Infinity` as scale
// Fallback to 1 in case both values are `0`
if(offsetWidth>0){scaleX=round$1(rect.width)/offsetWidth||1;}if(offsetHeight>0){scaleY=round$1(rect.height)/offsetHeight||1;}}return {width:rect.width/scaleX,height:rect.height/scaleY,top:rect.top/scaleY,right:rect.right/scaleX,bottom:rect.bottom/scaleY,left:rect.left/scaleX,x:rect.left/scaleX,y:rect.top/scaleY};}// means it doesn't take into account transforms.
function getLayoutRect$1(element){var clientRect=getBoundingClientRect$1(element);// Use the clientRect sizes if it's not been transformed.
// Fixes https://github.com/popperjs/popper-core/issues/1223
var width=element.offsetWidth;var height=element.offsetHeight;if(Math.abs(clientRect.width-width)<=1){width=clientRect.width;}if(Math.abs(clientRect.height-height)<=1){height=clientRect.height;}return {x:element.offsetLeft,y:element.offsetTop,width:width,height:height};}function contains$1(parent,child){var rootNode=child.getRootNode&&child.getRootNode();// First, attempt with faster native method
if(parent.contains(child)){return true;}// then fallback to custom implementation with Shadow DOM support
else if(rootNode&&isShadowRoot$1(rootNode)){var next=child;do{if(next&&parent.isSameNode(next)){return true;}// $FlowFixMe[prop-missing]: need a better way to handle this...
next=next.parentNode||next.host;}while(next);}// Give up, the result is false
return false;}function getComputedStyle$2(element){return getWindow$2(element).getComputedStyle(element);}function isTableElement$1(element){return ['table','td','th'].indexOf(getNodeName$1(element))>=0;}function getDocumentElement$1(element){// $FlowFixMe[incompatible-return]: assume body is always available
return ((isElement$2(element)?element.ownerDocument:// $FlowFixMe[prop-missing]
element.document)||window.document).documentElement;}function getParentNode$1(element){if(getNodeName$1(element)==='html'){return element;}return(// this is a quicker (but less type safe) way to save quite some bytes from the bundle
// $FlowFixMe[incompatible-return]
// $FlowFixMe[prop-missing]
element.assignedSlot||// step into the shadow DOM of the parent of a slotted node
element.parentNode||(// DOM Element detected
isShadowRoot$1(element)?element.host:null)||// ShadowRoot detected
// $FlowFixMe[incompatible-call]: HTMLElement is a Node
getDocumentElement$1(element)// fallback
);}function getTrueOffsetParent$1(element){if(!isHTMLElement$3(element)||// https://github.com/popperjs/popper-core/issues/837
getComputedStyle$2(element).position==='fixed'){return null;}return element.offsetParent;}// `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function getContainingBlock$1(element){var isFirefox=navigator.userAgent.toLowerCase().indexOf('firefox')!==-1;var isIE=navigator.userAgent.indexOf('Trident')!==-1;if(isIE&&isHTMLElement$3(element)){// In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
var elementCss=getComputedStyle$2(element);if(elementCss.position==='fixed'){return null;}}var currentNode=getParentNode$1(element);if(isShadowRoot$1(currentNode)){currentNode=currentNode.host;}while(isHTMLElement$3(currentNode)&&['html','body'].indexOf(getNodeName$1(currentNode))<0){var css=getComputedStyle$2(currentNode);// This is non-exhaustive but covers the most common CSS properties that
// create a containing block.
// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
if(css.transform!=='none'||css.perspective!=='none'||css.contain==='paint'||['transform','perspective'].indexOf(css.willChange)!==-1||isFirefox&&css.willChange==='filter'||isFirefox&&css.filter&&css.filter!=='none'){return currentNode;}else {currentNode=currentNode.parentNode;}}return null;}// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent$1(element){var window=getWindow$2(element);var offsetParent=getTrueOffsetParent$1(element);while(offsetParent&&isTableElement$1(offsetParent)&&getComputedStyle$2(offsetParent).position==='static'){offsetParent=getTrueOffsetParent$1(offsetParent);}if(offsetParent&&(getNodeName$1(offsetParent)==='html'||getNodeName$1(offsetParent)==='body'&&getComputedStyle$2(offsetParent).position==='static')){return window;}return offsetParent||getContainingBlock$1(element)||window;}function getMainAxisFromPlacement$1(placement){return ['top','bottom'].indexOf(placement)>=0?'x':'y';}function within$1(min$1,value,max$1){return max$2(min$1,min$2(value,max$1));}function withinMaxClamp$1(min,value,max){var v=within$1(min,value,max);return v>max?max:v;}function getFreshSideObject$1(){return {top:0,right:0,bottom:0,left:0};}function mergePaddingObject$1(paddingObject){return Object.assign({},getFreshSideObject$1(),paddingObject);}function expandToHashMap$1(value,keys){return keys.reduce(function(hashMap,key){hashMap[key]=value;return hashMap;},{});}var toPaddingObject$1=function toPaddingObject(padding,state){padding=typeof padding==='function'?padding(Object.assign({},state.rects,{placement:state.placement})):padding;return mergePaddingObject$1(typeof padding!=='number'?padding:expandToHashMap$1(padding,basePlacements$1));};function arrow$2(_ref){var _state$modifiersData$;var state=_ref.state,name=_ref.name,options=_ref.options;var arrowElement=state.elements.arrow;var popperOffsets=state.modifiersData.popperOffsets;var basePlacement=getBasePlacement$1(state.placement);var axis=getMainAxisFromPlacement$1(basePlacement);var isVertical=[left$1,right$1].indexOf(basePlacement)>=0;var len=isVertical?'height':'width';if(!arrowElement||!popperOffsets){return;}var paddingObject=toPaddingObject$1(options.padding,state);var arrowRect=getLayoutRect$1(arrowElement);var minProp=axis==='y'?top$1:left$1;var maxProp=axis==='y'?bottom$1:right$1;var endDiff=state.rects.reference[len]+state.rects.reference[axis]-popperOffsets[axis]-state.rects.popper[len];var startDiff=popperOffsets[axis]-state.rects.reference[axis];var arrowOffsetParent=getOffsetParent$1(arrowElement);var clientSize=arrowOffsetParent?axis==='y'?arrowOffsetParent.clientHeight||0:arrowOffsetParent.clientWidth||0:0;var centerToReference=endDiff/2-startDiff/2;// Make sure the arrow doesn't overflow the popper if the center point is
// outside of the popper bounds
var min=paddingObject[minProp];var max=clientSize-arrowRect[len]-paddingObject[maxProp];var center=clientSize/2-arrowRect[len]/2+centerToReference;var offset=within$1(min,center,max);// Prevents breaking syntax highlighting...
var axisProp=axis;state.modifiersData[name]=(_state$modifiersData$={},_state$modifiersData$[axisProp]=offset,_state$modifiersData$.centerOffset=offset-center,_state$modifiersData$);}function effect$1$1(_ref2){var state=_ref2.state,options=_ref2.options;var _options$element=options.element,arrowElement=_options$element===void 0?'[data-popper-arrow]':_options$element;if(arrowElement==null){return;}// CSS selector
if(typeof arrowElement==='string'){arrowElement=state.elements.popper.querySelector(arrowElement);if(!arrowElement){return;}}if(process.env.NODE_ENV!=="production"){if(!isHTMLElement$3(arrowElement)){console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).','To use an SVG arrow, wrap it in an HTMLElement that will be used as','the arrow.'].join(' '));}}if(!contains$1(state.elements.popper,arrowElement)){if(process.env.NODE_ENV!=="production"){console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper','element.'].join(' '));}return;}state.elements.arrow=arrowElement;}// eslint-disable-next-line import/no-unused-modules
var arrow$1$1={name:'arrow',enabled:true,phase:'main',fn:arrow$2,effect:effect$1$1,requires:['popperOffsets'],requiresIfExists:['preventOverflow']};function getVariation$1(placement){return placement.split('-')[1];}var unsetSides$1={top:'auto',right:'auto',bottom:'auto',left:'auto'};// Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function roundOffsetsByDPR$1(_ref){var x=_ref.x,y=_ref.y;var win=window;var dpr=win.devicePixelRatio||1;return {x:round$1(x*dpr)/dpr||0,y:round$1(y*dpr)/dpr||0};}function mapToStyles$1(_ref2){var _Object$assign2;var popper=_ref2.popper,popperRect=_ref2.popperRect,placement=_ref2.placement,variation=_ref2.variation,offsets=_ref2.offsets,position=_ref2.position,gpuAcceleration=_ref2.gpuAcceleration,adaptive=_ref2.adaptive,roundOffsets=_ref2.roundOffsets,isFixed=_ref2.isFixed;var _offsets$x=offsets.x,x=_offsets$x===void 0?0:_offsets$x,_offsets$y=offsets.y,y=_offsets$y===void 0?0:_offsets$y;var _ref3=typeof roundOffsets==='function'?roundOffsets({x:x,y:y}):{x:x,y:y};x=_ref3.x;y=_ref3.y;var hasX=offsets.hasOwnProperty('x');var hasY=offsets.hasOwnProperty('y');var sideX=left$1;var sideY=top$1;var win=window;if(adaptive){var offsetParent=getOffsetParent$1(popper);var heightProp='clientHeight';var widthProp='clientWidth';if(offsetParent===getWindow$2(popper)){offsetParent=getDocumentElement$1(popper);if(getComputedStyle$2(offsetParent).position!=='static'&&position==='absolute'){heightProp='scrollHeight';widthProp='scrollWidth';}}// $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
offsetParent=offsetParent;if(placement===top$1||(placement===left$1||placement===right$1)&&variation===end$1){sideY=bottom$1;var offsetY=isFixed&&offsetParent===win&&win.visualViewport?win.visualViewport.height:// $FlowFixMe[prop-missing]
offsetParent[heightProp];y-=offsetY-popperRect.height;y*=gpuAcceleration?1:-1;}if(placement===left$1||(placement===top$1||placement===bottom$1)&&variation===end$1){sideX=right$1;var offsetX=isFixed&&offsetParent===win&&win.visualViewport?win.visualViewport.width:// $FlowFixMe[prop-missing]
offsetParent[widthProp];x-=offsetX-popperRect.width;x*=gpuAcceleration?1:-1;}}var commonStyles=Object.assign({position:position},adaptive&&unsetSides$1);var _ref4=roundOffsets===true?roundOffsetsByDPR$1({x:x,y:y}):{x:x,y:y};x=_ref4.x;y=_ref4.y;if(gpuAcceleration){var _Object$assign;return Object.assign({},commonStyles,(_Object$assign={},_Object$assign[sideY]=hasY?'0':'',_Object$assign[sideX]=hasX?'0':'',_Object$assign.transform=(win.devicePixelRatio||1)<=1?"translate("+x+"px, "+y+"px)":"translate3d("+x+"px, "+y+"px, 0)",_Object$assign));}return Object.assign({},commonStyles,(_Object$assign2={},_Object$assign2[sideY]=hasY?y+"px":'',_Object$assign2[sideX]=hasX?x+"px":'',_Object$assign2.transform='',_Object$assign2));}function computeStyles$2(_ref5){var state=_ref5.state,options=_ref5.options;var _options$gpuAccelerat=options.gpuAcceleration,gpuAcceleration=_options$gpuAccelerat===void 0?true:_options$gpuAccelerat,_options$adaptive=options.adaptive,adaptive=_options$adaptive===void 0?true:_options$adaptive,_options$roundOffsets=options.roundOffsets,roundOffsets=_options$roundOffsets===void 0?true:_options$roundOffsets;if(process.env.NODE_ENV!=="production"){var transitionProperty=getComputedStyle$2(state.elements.popper).transitionProperty||'';if(adaptive&&['transform','top','right','bottom','left'].some(function(property){return transitionProperty.indexOf(property)>=0;})){console.warn(['Popper: Detected CSS transitions on at least one of the following','CSS properties: "transform", "top", "right", "bottom", "left".','\n\n','Disable the "computeStyles" modifier\'s `adaptive` option to allow','for smooth transitions, or remove these properties from the CSS','transition declaration on the popper element if only transitioning','opacity or background-color for example.','\n\n','We recommend using the popper element as a wrapper around an inner','element that can have any CSS property transitioned for animations.'].join(' '));}}var commonStyles={placement:getBasePlacement$1(state.placement),variation:getVariation$1(state.placement),popper:state.elements.popper,popperRect:state.rects.popper,gpuAcceleration:gpuAcceleration,isFixed:state.options.strategy==='fixed'};if(state.modifiersData.popperOffsets!=null){state.styles.popper=Object.assign({},state.styles.popper,mapToStyles$1(Object.assign({},commonStyles,{offsets:state.modifiersData.popperOffsets,position:state.options.strategy,adaptive:adaptive,roundOffsets:roundOffsets})));}if(state.modifiersData.arrow!=null){state.styles.arrow=Object.assign({},state.styles.arrow,mapToStyles$1(Object.assign({},commonStyles,{offsets:state.modifiersData.arrow,position:'absolute',adaptive:false,roundOffsets:roundOffsets})));}state.attributes.popper=Object.assign({},state.attributes.popper,{'data-popper-placement':state.placement});}// eslint-disable-next-line import/no-unused-modules
var computeStyles$1$1={name:'computeStyles',enabled:true,phase:'beforeWrite',fn:computeStyles$2,data:{}};var passive$1={passive:true};function effect$3(_ref){var state=_ref.state,instance=_ref.instance,options=_ref.options;var _options$scroll=options.scroll,scroll=_options$scroll===void 0?true:_options$scroll,_options$resize=options.resize,resize=_options$resize===void 0?true:_options$resize;var window=getWindow$2(state.elements.popper);var scrollParents=[].concat(state.scrollParents.reference,state.scrollParents.popper);if(scroll){scrollParents.forEach(function(scrollParent){scrollParent.addEventListener('scroll',instance.update,passive$1);});}if(resize){window.addEventListener('resize',instance.update,passive$1);}return function(){if(scroll){scrollParents.forEach(function(scrollParent){scrollParent.removeEventListener('scroll',instance.update,passive$1);});}if(resize){window.removeEventListener('resize',instance.update,passive$1);}};}// eslint-disable-next-line import/no-unused-modules
var eventListeners$1={name:'eventListeners',enabled:true,phase:'write',fn:function fn(){},effect:effect$3,data:{}};var hash$1$1={left:'right',right:'left',bottom:'top',top:'bottom'};function getOppositePlacement$1(placement){return placement.replace(/left|right|bottom|top/g,function(matched){return hash$1$1[matched];});}var hash$2={start:'end',end:'start'};function getOppositeVariationPlacement$1(placement){return placement.replace(/start|end/g,function(matched){return hash$2[matched];});}function getWindowScroll$1(node){var win=getWindow$2(node);var scrollLeft=win.pageXOffset;var scrollTop=win.pageYOffset;return {scrollLeft:scrollLeft,scrollTop:scrollTop};}function getWindowScrollBarX$1(element){// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
// Popper 1 is broken in this case and never had a bug report so let's assume
// it's not an issue. I don't think anyone ever specifies width on <html>
// anyway.
// Browsers where the left scrollbar doesn't cause an issue report `0` for
// this (e.g. Edge 2019, IE11, Safari)
return getBoundingClientRect$1(getDocumentElement$1(element)).left+getWindowScroll$1(element).scrollLeft;}function getViewportRect$1(element){var win=getWindow$2(element);var html=getDocumentElement$1(element);var visualViewport=win.visualViewport;var width=html.clientWidth;var height=html.clientHeight;var x=0;var y=0;// NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
// can be obscured underneath it.
// Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
// if it isn't open, so if this isn't available, the popper will be detected
// to overflow the bottom of the screen too early.
if(visualViewport){width=visualViewport.width;height=visualViewport.height;// Uses Layout Viewport (like Chrome; Safari does not currently)
// In Chrome, it returns a value very close to 0 (+/-) but contains rounding
// errors due to floating point numbers, so we need to check precision.
// Safari returns a number <= 0, usually < -1 when pinch-zoomed
// Feature detection fails in mobile emulation mode in Chrome.
// Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
// 0.001
// Fallback here: "Not Safari" userAgent
if(!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)){x=visualViewport.offsetLeft;y=visualViewport.offsetTop;}}return {width:width,height:height,x:x+getWindowScrollBarX$1(element),y:y};}// of the `<html>` and `<body>` rect bounds if horizontally scrollable
function getDocumentRect$1(element){var _element$ownerDocumen;var html=getDocumentElement$1(element);var winScroll=getWindowScroll$1(element);var body=(_element$ownerDocumen=element.ownerDocument)==null?void 0:_element$ownerDocumen.body;var width=max$2(html.scrollWidth,html.clientWidth,body?body.scrollWidth:0,body?body.clientWidth:0);var height=max$2(html.scrollHeight,html.clientHeight,body?body.scrollHeight:0,body?body.clientHeight:0);var x=-winScroll.scrollLeft+getWindowScrollBarX$1(element);var y=-winScroll.scrollTop;if(getComputedStyle$2(body||html).direction==='rtl'){x+=max$2(html.clientWidth,body?body.clientWidth:0)-width;}return {width:width,height:height,x:x,y:y};}function isScrollParent$1(element){// Firefox wants us to check `-x` and `-y` variations as well
var _getComputedStyle=getComputedStyle$2(element),overflow=_getComputedStyle.overflow,overflowX=_getComputedStyle.overflowX,overflowY=_getComputedStyle.overflowY;return /auto|scroll|overlay|hidden/.test(overflow+overflowY+overflowX);}function getScrollParent$1(node){if(['html','body','#document'].indexOf(getNodeName$1(node))>=0){// $FlowFixMe[incompatible-return]: assume body is always available
return node.ownerDocument.body;}if(isHTMLElement$3(node)&&isScrollParent$1(node)){return node;}return getScrollParent$1(getParentNode$1(node));}/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/function listScrollParents$1(element,list){var _element$ownerDocumen;if(list===void 0){list=[];}var scrollParent=getScrollParent$1(element);var isBody=scrollParent===((_element$ownerDocumen=element.ownerDocument)==null?void 0:_element$ownerDocumen.body);var win=getWindow$2(scrollParent);var target=isBody?[win].concat(win.visualViewport||[],isScrollParent$1(scrollParent)?scrollParent:[]):scrollParent;var updatedList=list.concat(target);return isBody?updatedList:// $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
updatedList.concat(listScrollParents$1(getParentNode$1(target)));}function rectToClientRect$1(rect){return Object.assign({},rect,{left:rect.x,top:rect.y,right:rect.x+rect.width,bottom:rect.y+rect.height});}function getInnerBoundingClientRect$1(element){var rect=getBoundingClientRect$1(element);rect.top=rect.top+element.clientTop;rect.left=rect.left+element.clientLeft;rect.bottom=rect.top+element.clientHeight;rect.right=rect.left+element.clientWidth;rect.width=element.clientWidth;rect.height=element.clientHeight;rect.x=rect.left;rect.y=rect.top;return rect;}function getClientRectFromMixedType$1(element,clippingParent){return clippingParent===viewport$1?rectToClientRect$1(getViewportRect$1(element)):isElement$2(clippingParent)?getInnerBoundingClientRect$1(clippingParent):rectToClientRect$1(getDocumentRect$1(getDocumentElement$1(element)));}// A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function getClippingParents$1(element){var clippingParents=listScrollParents$1(getParentNode$1(element));var canEscapeClipping=['absolute','fixed'].indexOf(getComputedStyle$2(element).position)>=0;var clipperElement=canEscapeClipping&&isHTMLElement$3(element)?getOffsetParent$1(element):element;if(!isElement$2(clipperElement)){return [];}// $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
return clippingParents.filter(function(clippingParent){return isElement$2(clippingParent)&&contains$1(clippingParent,clipperElement)&&getNodeName$1(clippingParent)!=='body';});}// Gets the maximum area that the element is visible in due to any number of
// clipping parents
function getClippingRect$1(element,boundary,rootBoundary){var mainClippingParents=boundary==='clippingParents'?getClippingParents$1(element):[].concat(boundary);var clippingParents=[].concat(mainClippingParents,[rootBoundary]);var firstClippingParent=clippingParents[0];var clippingRect=clippingParents.reduce(function(accRect,clippingParent){var rect=getClientRectFromMixedType$1(element,clippingParent);accRect.top=max$2(rect.top,accRect.top);accRect.right=min$2(rect.right,accRect.right);accRect.bottom=min$2(rect.bottom,accRect.bottom);accRect.left=max$2(rect.left,accRect.left);return accRect;},getClientRectFromMixedType$1(element,firstClippingParent));clippingRect.width=clippingRect.right-clippingRect.left;clippingRect.height=clippingRect.bottom-clippingRect.top;clippingRect.x=clippingRect.left;clippingRect.y=clippingRect.top;return clippingRect;}function computeOffsets$1(_ref){var reference=_ref.reference,element=_ref.element,placement=_ref.placement;var basePlacement=placement?getBasePlacement$1(placement):null;var variation=placement?getVariation$1(placement):null;var commonX=reference.x+reference.width/2-element.width/2;var commonY=reference.y+reference.height/2-element.height/2;var offsets;switch(basePlacement){case top$1:offsets={x:commonX,y:reference.y-element.height};break;case bottom$1:offsets={x:commonX,y:reference.y+reference.height};break;case right$1:offsets={x:reference.x+reference.width,y:commonY};break;case left$1:offsets={x:reference.x-element.width,y:commonY};break;default:offsets={x:reference.x,y:reference.y};}var mainAxis=basePlacement?getMainAxisFromPlacement$1(basePlacement):null;if(mainAxis!=null){var len=mainAxis==='y'?'height':'width';switch(variation){case start$1:offsets[mainAxis]=offsets[mainAxis]-(reference[len]/2-element[len]/2);break;case end$1:offsets[mainAxis]=offsets[mainAxis]+(reference[len]/2-element[len]/2);break;}}return offsets;}function detectOverflow$1(state,options){if(options===void 0){options={};}var _options=options,_options$placement=_options.placement,placement=_options$placement===void 0?state.placement:_options$placement,_options$boundary=_options.boundary,boundary=_options$boundary===void 0?clippingParents$1:_options$boundary,_options$rootBoundary=_options.rootBoundary,rootBoundary=_options$rootBoundary===void 0?viewport$1:_options$rootBoundary,_options$elementConte=_options.elementContext,elementContext=_options$elementConte===void 0?popper$1:_options$elementConte,_options$altBoundary=_options.altBoundary,altBoundary=_options$altBoundary===void 0?false:_options$altBoundary,_options$padding=_options.padding,padding=_options$padding===void 0?0:_options$padding;var paddingObject=mergePaddingObject$1(typeof padding!=='number'?padding:expandToHashMap$1(padding,basePlacements$1));var altContext=elementContext===popper$1?reference$1:popper$1;var popperRect=state.rects.popper;var element=state.elements[altBoundary?altContext:elementContext];var clippingClientRect=getClippingRect$1(isElement$2(element)?element:element.contextElement||getDocumentElement$1(state.elements.popper),boundary,rootBoundary);var referenceClientRect=getBoundingClientRect$1(state.elements.reference);var popperOffsets=computeOffsets$1({reference:referenceClientRect,element:popperRect,strategy:'absolute',placement:placement});var popperClientRect=rectToClientRect$1(Object.assign({},popperRect,popperOffsets));var elementClientRect=elementContext===popper$1?popperClientRect:referenceClientRect;// positive = overflowing the clipping rect
// 0 or negative = within the clipping rect
var overflowOffsets={top:clippingClientRect.top-elementClientRect.top+paddingObject.top,bottom:elementClientRect.bottom-clippingClientRect.bottom+paddingObject.bottom,left:clippingClientRect.left-elementClientRect.left+paddingObject.left,right:elementClientRect.right-clippingClientRect.right+paddingObject.right};var offsetData=state.modifiersData.offset;// Offsets can be applied only to the popper element
if(elementContext===popper$1&&offsetData){var offset=offsetData[placement];Object.keys(overflowOffsets).forEach(function(key){var multiply=[right$1,bottom$1].indexOf(key)>=0?1:-1;var axis=[top$1,bottom$1].indexOf(key)>=0?'y':'x';overflowOffsets[key]+=offset[axis]*multiply;});}return overflowOffsets;}function computeAutoPlacement$1(state,options){if(options===void 0){options={};}var _options=options,placement=_options.placement,boundary=_options.boundary,rootBoundary=_options.rootBoundary,padding=_options.padding,flipVariations=_options.flipVariations,_options$allowedAutoP=_options.allowedAutoPlacements,allowedAutoPlacements=_options$allowedAutoP===void 0?placements$1:_options$allowedAutoP;var variation=getVariation$1(placement);var placements$1$1=variation?flipVariations?variationPlacements$1:variationPlacements$1.filter(function(placement){return getVariation$1(placement)===variation;}):basePlacements$1;var allowedPlacements=placements$1$1.filter(function(placement){return allowedAutoPlacements.indexOf(placement)>=0;});if(allowedPlacements.length===0){allowedPlacements=placements$1$1;if(process.env.NODE_ENV!=="production"){console.error(['Popper: The `allowedAutoPlacements` option did not allow any','placements. Ensure the `placement` option matches the variation','of the allowed placements.','For example, "auto" cannot be used to allow "bottom-start".','Use "auto-start" instead.'].join(' '));}}// $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
var overflows=allowedPlacements.reduce(function(acc,placement){acc[placement]=detectOverflow$1(state,{placement:placement,boundary:boundary,rootBoundary:rootBoundary,padding:padding})[getBasePlacement$1(placement)];return acc;},{});return Object.keys(overflows).sort(function(a,b){return overflows[a]-overflows[b];});}function getExpandedFallbackPlacements$1(placement){if(getBasePlacement$1(placement)===auto$1){return [];}var oppositePlacement=getOppositePlacement$1(placement);return [getOppositeVariationPlacement$1(placement),oppositePlacement,getOppositeVariationPlacement$1(oppositePlacement)];}function flip$2(_ref){var state=_ref.state,options=_ref.options,name=_ref.name;if(state.modifiersData[name]._skip){return;}var _options$mainAxis=options.mainAxis,checkMainAxis=_options$mainAxis===void 0?true:_options$mainAxis,_options$altAxis=options.altAxis,checkAltAxis=_options$altAxis===void 0?true:_options$altAxis,specifiedFallbackPlacements=options.fallbackPlacements,padding=options.padding,boundary=options.boundary,rootBoundary=options.rootBoundary,altBoundary=options.altBoundary,_options$flipVariatio=options.flipVariations,flipVariations=_options$flipVariatio===void 0?true:_options$flipVariatio,allowedAutoPlacements=options.allowedAutoPlacements;var preferredPlacement=state.options.placement;var basePlacement=getBasePlacement$1(preferredPlacement);var isBasePlacement=basePlacement===preferredPlacement;var fallbackPlacements=specifiedFallbackPlacements||(isBasePlacement||!flipVariations?[getOppositePlacement$1(preferredPlacement)]:getExpandedFallbackPlacements$1(preferredPlacement));var placements=[preferredPlacement].concat(fallbackPlacements).reduce(function(acc,placement){return acc.concat(getBasePlacement$1(placement)===auto$1?computeAutoPlacement$1(state,{placement:placement,boundary:boundary,rootBoundary:rootBoundary,padding:padding,flipVariations:flipVariations,allowedAutoPlacements:allowedAutoPlacements}):placement);},[]);var referenceRect=state.rects.reference;var popperRect=state.rects.popper;var checksMap=new Map();var makeFallbackChecks=true;var firstFittingPlacement=placements[0];for(var i=0;i<placements.length;i++){var placement=placements[i];var _basePlacement=getBasePlacement$1(placement);var isStartVariation=getVariation$1(placement)===start$1;var isVertical=[top$1,bottom$1].indexOf(_basePlacement)>=0;var len=isVertical?'width':'height';var overflow=detectOverflow$1(state,{placement:placement,boundary:boundary,rootBoundary:rootBoundary,altBoundary:altBoundary,padding:padding});var mainVariationSide=isVertical?isStartVariation?right$1:left$1:isStartVariation?bottom$1:top$1;if(referenceRect[len]>popperRect[len]){mainVariationSide=getOppositePlacement$1(mainVariationSide);}var altVariationSide=getOppositePlacement$1(mainVariationSide);var checks=[];if(checkMainAxis){checks.push(overflow[_basePlacement]<=0);}if(checkAltAxis){checks.push(overflow[mainVariationSide]<=0,overflow[altVariationSide]<=0);}if(checks.every(function(check){return check;})){firstFittingPlacement=placement;makeFallbackChecks=false;break;}checksMap.set(placement,checks);}if(makeFallbackChecks){// `2` may be desired in some cases – research later
var numberOfChecks=flipVariations?3:1;var _loop=function _loop(_i){var fittingPlacement=placements.find(function(placement){var checks=checksMap.get(placement);if(checks){return checks.slice(0,_i).every(function(check){return check;});}});if(fittingPlacement){firstFittingPlacement=fittingPlacement;return "break";}};for(var _i=numberOfChecks;_i>0;_i--){var _ret=_loop(_i);if(_ret==="break")break;}}if(state.placement!==firstFittingPlacement){state.modifiersData[name]._skip=true;state.placement=firstFittingPlacement;state.reset=true;}}// eslint-disable-next-line import/no-unused-modules
var flip$1$1={name:'flip',enabled:true,phase:'main',fn:flip$2,requiresIfExists:['offset'],data:{_skip:false}};function getSideOffsets$1(overflow,rect,preventedOffsets){if(preventedOffsets===void 0){preventedOffsets={x:0,y:0};}return {top:overflow.top-rect.height-preventedOffsets.y,right:overflow.right-rect.width+preventedOffsets.x,bottom:overflow.bottom-rect.height+preventedOffsets.y,left:overflow.left-rect.width-preventedOffsets.x};}function isAnySideFullyClipped$1(overflow){return [top$1,right$1,bottom$1,left$1].some(function(side){return overflow[side]>=0;});}function hide$3(_ref){var state=_ref.state,name=_ref.name;var referenceRect=state.rects.reference;var popperRect=state.rects.popper;var preventedOffsets=state.modifiersData.preventOverflow;var referenceOverflow=detectOverflow$1(state,{elementContext:'reference'});var popperAltOverflow=detectOverflow$1(state,{altBoundary:true});var referenceClippingOffsets=getSideOffsets$1(referenceOverflow,referenceRect);var popperEscapeOffsets=getSideOffsets$1(popperAltOverflow,popperRect,preventedOffsets);var isReferenceHidden=isAnySideFullyClipped$1(referenceClippingOffsets);var hasPopperEscaped=isAnySideFullyClipped$1(popperEscapeOffsets);state.modifiersData[name]={referenceClippingOffsets:referenceClippingOffsets,popperEscapeOffsets:popperEscapeOffsets,isReferenceHidden:isReferenceHidden,hasPopperEscaped:hasPopperEscaped};state.attributes.popper=Object.assign({},state.attributes.popper,{'data-popper-reference-hidden':isReferenceHidden,'data-popper-escaped':hasPopperEscaped});}// eslint-disable-next-line import/no-unused-modules
var hide$1$1={name:'hide',enabled:true,phase:'main',requiresIfExists:['preventOverflow'],fn:hide$3};function distanceAndSkiddingToXY$1(placement,rects,offset){var basePlacement=getBasePlacement$1(placement);var invertDistance=[left$1,top$1].indexOf(basePlacement)>=0?-1:1;var _ref=typeof offset==='function'?offset(Object.assign({},rects,{placement:placement})):offset,skidding=_ref[0],distance=_ref[1];skidding=skidding||0;distance=(distance||0)*invertDistance;return [left$1,right$1].indexOf(basePlacement)>=0?{x:distance,y:skidding}:{x:skidding,y:distance};}function offset$2(_ref2){var state=_ref2.state,options=_ref2.options,name=_ref2.name;var _options$offset=options.offset,offset=_options$offset===void 0?[0,0]:_options$offset;var data=placements$1.reduce(function(acc,placement){acc[placement]=distanceAndSkiddingToXY$1(placement,state.rects,offset);return acc;},{});var _data$state$placement=data[state.placement],x=_data$state$placement.x,y=_data$state$placement.y;if(state.modifiersData.popperOffsets!=null){state.modifiersData.popperOffsets.x+=x;state.modifiersData.popperOffsets.y+=y;}state.modifiersData[name]=data;}// eslint-disable-next-line import/no-unused-modules
var offset$1$1={name:'offset',enabled:true,phase:'main',requires:['popperOffsets'],fn:offset$2};function popperOffsets$2(_ref){var state=_ref.state,name=_ref.name;// Offsets are the actual position the popper needs to have to be
// properly positioned near its reference element
// This is the most basic placement, and will be adjusted by
// the modifiers in the next step
state.modifiersData[name]=computeOffsets$1({reference:state.rects.reference,element:state.rects.popper,strategy:'absolute',placement:state.placement});}// eslint-disable-next-line import/no-unused-modules
var popperOffsets$1$1={name:'popperOffsets',enabled:true,phase:'read',fn:popperOffsets$2,data:{}};function getAltAxis$1(axis){return axis==='x'?'y':'x';}function preventOverflow$2(_ref){var state=_ref.state,options=_ref.options,name=_ref.name;var _options$mainAxis=options.mainAxis,checkMainAxis=_options$mainAxis===void 0?true:_options$mainAxis,_options$altAxis=options.altAxis,checkAltAxis=_options$altAxis===void 0?false:_options$altAxis,boundary=options.boundary,rootBoundary=options.rootBoundary,altBoundary=options.altBoundary,padding=options.padding,_options$tether=options.tether,tether=_options$tether===void 0?true:_options$tether,_options$tetherOffset=options.tetherOffset,tetherOffset=_options$tetherOffset===void 0?0:_options$tetherOffset;var overflow=detectOverflow$1(state,{boundary:boundary,rootBoundary:rootBoundary,padding:padding,altBoundary:altBoundary});var basePlacement=getBasePlacement$1(state.placement);var variation=getVariation$1(state.placement);var isBasePlacement=!variation;var mainAxis=getMainAxisFromPlacement$1(basePlacement);var altAxis=getAltAxis$1(mainAxis);var popperOffsets=state.modifiersData.popperOffsets;var referenceRect=state.rects.reference;var popperRect=state.rects.popper;var tetherOffsetValue=typeof tetherOffset==='function'?tetherOffset(Object.assign({},state.rects,{placement:state.placement})):tetherOffset;var normalizedTetherOffsetValue=typeof tetherOffsetValue==='number'?{mainAxis:tetherOffsetValue,altAxis:tetherOffsetValue}:Object.assign({mainAxis:0,altAxis:0},tetherOffsetValue);var offsetModifierState=state.modifiersData.offset?state.modifiersData.offset[state.placement]:null;var data={x:0,y:0};if(!popperOffsets){return;}if(checkMainAxis){var _offsetModifierState$;var mainSide=mainAxis==='y'?top$1:left$1;var altSide=mainAxis==='y'?bottom$1:right$1;var len=mainAxis==='y'?'height':'width';var offset=popperOffsets[mainAxis];var min$1=offset+overflow[mainSide];var max$1=offset-overflow[altSide];var additive=tether?-popperRect[len]/2:0;var minLen=variation===start$1?referenceRect[len]:popperRect[len];var maxLen=variation===start$1?-popperRect[len]:-referenceRect[len];// We need to include the arrow in the calculation so the arrow doesn't go
// outside the reference bounds
var arrowElement=state.elements.arrow;var arrowRect=tether&&arrowElement?getLayoutRect$1(arrowElement):{width:0,height:0};var arrowPaddingObject=state.modifiersData['arrow#persistent']?state.modifiersData['arrow#persistent'].padding:getFreshSideObject$1();var arrowPaddingMin=arrowPaddingObject[mainSide];var arrowPaddingMax=arrowPaddingObject[altSide];// If the reference length is smaller than the arrow length, we don't want
// to include its full size in the calculation. If the reference is small
// and near the edge of a boundary, the popper can overflow even if the
// reference is not overflowing as well (e.g. virtual elements with no
// width or height)
var arrowLen=within$1(0,referenceRect[len],arrowRect[len]);var minOffset=isBasePlacement?referenceRect[len]/2-additive-arrowLen-arrowPaddingMin-normalizedTetherOffsetValue.mainAxis:minLen-arrowLen-arrowPaddingMin-normalizedTetherOffsetValue.mainAxis;var maxOffset=isBasePlacement?-referenceRect[len]/2+additive+arrowLen+arrowPaddingMax+normalizedTetherOffsetValue.mainAxis:maxLen+arrowLen+arrowPaddingMax+normalizedTetherOffsetValue.mainAxis;var arrowOffsetParent=state.elements.arrow&&getOffsetParent$1(state.elements.arrow);var clientOffset=arrowOffsetParent?mainAxis==='y'?arrowOffsetParent.clientTop||0:arrowOffsetParent.clientLeft||0:0;var offsetModifierValue=(_offsetModifierState$=offsetModifierState==null?void 0:offsetModifierState[mainAxis])!=null?_offsetModifierState$:0;var tetherMin=offset+minOffset-offsetModifierValue-clientOffset;var tetherMax=offset+maxOffset-offsetModifierValue;var preventedOffset=within$1(tether?min$2(min$1,tetherMin):min$1,offset,tether?max$2(max$1,tetherMax):max$1);popperOffsets[mainAxis]=preventedOffset;data[mainAxis]=preventedOffset-offset;}if(checkAltAxis){var _offsetModifierState$2;var _mainSide=mainAxis==='x'?top$1:left$1;var _altSide=mainAxis==='x'?bottom$1:right$1;var _offset=popperOffsets[altAxis];var _len=altAxis==='y'?'height':'width';var _min=_offset+overflow[_mainSide];var _max=_offset-overflow[_altSide];var isOriginSide=[top$1,left$1].indexOf(basePlacement)!==-1;var _offsetModifierValue=(_offsetModifierState$2=offsetModifierState==null?void 0:offsetModifierState[altAxis])!=null?_offsetModifierState$2:0;var _tetherMin=isOriginSide?_min:_offset-referenceRect[_len]-popperRect[_len]-_offsetModifierValue+normalizedTetherOffsetValue.altAxis;var _tetherMax=isOriginSide?_offset+referenceRect[_len]+popperRect[_len]-_offsetModifierValue-normalizedTetherOffsetValue.altAxis:_max;var _preventedOffset=tether&&isOriginSide?withinMaxClamp$1(_tetherMin,_offset,_tetherMax):within$1(tether?_tetherMin:_min,_offset,tether?_tetherMax:_max);popperOffsets[altAxis]=_preventedOffset;data[altAxis]=_preventedOffset-_offset;}state.modifiersData[name]=data;}// eslint-disable-next-line import/no-unused-modules
var preventOverflow$1$1={name:'preventOverflow',enabled:true,phase:'main',fn:preventOverflow$2,requiresIfExists:['offset']};function getHTMLElementScroll$1(element){return {scrollLeft:element.scrollLeft,scrollTop:element.scrollTop};}function getNodeScroll$1(node){if(node===getWindow$2(node)||!isHTMLElement$3(node)){return getWindowScroll$1(node);}else {return getHTMLElementScroll$1(node);}}function isElementScaled$1(element){var rect=element.getBoundingClientRect();var scaleX=round$1(rect.width)/element.offsetWidth||1;var scaleY=round$1(rect.height)/element.offsetHeight||1;return scaleX!==1||scaleY!==1;}// Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.
function getCompositeRect$1(elementOrVirtualElement,offsetParent,isFixed){if(isFixed===void 0){isFixed=false;}var isOffsetParentAnElement=isHTMLElement$3(offsetParent);var offsetParentIsScaled=isHTMLElement$3(offsetParent)&&isElementScaled$1(offsetParent);var documentElement=getDocumentElement$1(offsetParent);var rect=getBoundingClientRect$1(elementOrVirtualElement,offsetParentIsScaled);var scroll={scrollLeft:0,scrollTop:0};var offsets={x:0,y:0};if(isOffsetParentAnElement||!isOffsetParentAnElement&&!isFixed){if(getNodeName$1(offsetParent)!=='body'||// https://github.com/popperjs/popper-core/issues/1078
isScrollParent$1(documentElement)){scroll=getNodeScroll$1(offsetParent);}if(isHTMLElement$3(offsetParent)){offsets=getBoundingClientRect$1(offsetParent,true);offsets.x+=offsetParent.clientLeft;offsets.y+=offsetParent.clientTop;}else if(documentElement){offsets.x=getWindowScrollBarX$1(documentElement);}}return {x:rect.left+scroll.scrollLeft-offsets.x,y:rect.top+scroll.scrollTop-offsets.y,width:rect.width,height:rect.height};}function order$1(modifiers){var map=new Map();var visited=new Set();var result=[];modifiers.forEach(function(modifier){map.set(modifier.name,modifier);});// On visiting object, check for its dependencies and visit them recursively
function sort(modifier){visited.add(modifier.name);var requires=[].concat(modifier.requires||[],modifier.requiresIfExists||[]);requires.forEach(function(dep){if(!visited.has(dep)){var depModifier=map.get(dep);if(depModifier){sort(depModifier);}}});result.push(modifier);}modifiers.forEach(function(modifier){if(!visited.has(modifier.name)){// check for visited object
sort(modifier);}});return result;}function orderModifiers$1(modifiers){// order based on dependencies
var orderedModifiers=order$1(modifiers);// order based on phase
return modifierPhases$1.reduce(function(acc,phase){return acc.concat(orderedModifiers.filter(function(modifier){return modifier.phase===phase;}));},[]);}function debounce$1$1(fn){var pending;return function(){if(!pending){pending=new Promise(function(resolve){Promise.resolve().then(function(){pending=undefined;resolve(fn());});});}return pending;};}function format$3(str){for(var _len=arguments.length,args=new Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){args[_key-1]=arguments[_key];}return [].concat(args).reduce(function(p,c){return p.replace(/%s/,c);},str);}var INVALID_MODIFIER_ERROR$1='Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';var MISSING_DEPENDENCY_ERROR$1='Popper: modifier "%s" requires "%s", but "%s" modifier is not available';var VALID_PROPERTIES$1=['name','enabled','phase','fn','effect','requires','options'];function validateModifiers$1(modifiers){modifiers.forEach(function(modifier){[].concat(Object.keys(modifier),VALID_PROPERTIES$1)// IE11-compatible replacement for `new Set(iterable)`
.filter(function(value,index,self){return self.indexOf(value)===index;}).forEach(function(key){switch(key){case'name':if(typeof modifier.name!=='string'){console.error(format$3(INVALID_MODIFIER_ERROR$1,String(modifier.name),'"name"','"string"',"\""+String(modifier.name)+"\""));}break;case'enabled':if(typeof modifier.enabled!=='boolean'){console.error(format$3(INVALID_MODIFIER_ERROR$1,modifier.name,'"enabled"','"boolean"',"\""+String(modifier.enabled)+"\""));}break;case'phase':if(modifierPhases$1.indexOf(modifier.phase)<0){console.error(format$3(INVALID_MODIFIER_ERROR$1,modifier.name,'"phase"',"either "+modifierPhases$1.join(', '),"\""+String(modifier.phase)+"\""));}break;case'fn':if(typeof modifier.fn!=='function'){console.error(format$3(INVALID_MODIFIER_ERROR$1,modifier.name,'"fn"','"function"',"\""+String(modifier.fn)+"\""));}break;case'effect':if(modifier.effect!=null&&typeof modifier.effect!=='function'){console.error(format$3(INVALID_MODIFIER_ERROR$1,modifier.name,'"effect"','"function"',"\""+String(modifier.fn)+"\""));}break;case'requires':if(modifier.requires!=null&&!Array.isArray(modifier.requires)){console.error(format$3(INVALID_MODIFIER_ERROR$1,modifier.name,'"requires"','"array"',"\""+String(modifier.requires)+"\""));}break;case'requiresIfExists':if(!Array.isArray(modifier.requiresIfExists)){console.error(format$3(INVALID_MODIFIER_ERROR$1,modifier.name,'"requiresIfExists"','"array"',"\""+String(modifier.requiresIfExists)+"\""));}break;case'options':case'data':break;default:console.error("PopperJS: an invalid property has been provided to the \""+modifier.name+"\" modifier, valid properties are "+VALID_PROPERTIES$1.map(function(s){return "\""+s+"\"";}).join(', ')+"; but \""+key+"\" was provided.");}modifier.requires&&modifier.requires.forEach(function(requirement){if(modifiers.find(function(mod){return mod.name===requirement;})==null){console.error(format$3(MISSING_DEPENDENCY_ERROR$1,String(modifier.name),requirement,requirement));}});});});}function uniqueBy$1(arr,fn){var identifiers=new Set();return arr.filter(function(item){var identifier=fn(item);if(!identifiers.has(identifier)){identifiers.add(identifier);return true;}});}function mergeByName$1(modifiers){var merged=modifiers.reduce(function(merged,current){var existing=merged[current.name];merged[current.name]=existing?Object.assign({},existing,current,{options:Object.assign({},existing.options,current.options),data:Object.assign({},existing.data,current.data)}):current;return merged;},{});// IE11 does not support Object.values
return Object.keys(merged).map(function(key){return merged[key];});}var INVALID_ELEMENT_ERROR$1='Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';var INFINITE_LOOP_ERROR$1='Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';var DEFAULT_OPTIONS$1={placement:'bottom',modifiers:[],strategy:'absolute'};function areValidElements$1(){for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return !args.some(function(element){return !(element&&typeof element.getBoundingClientRect==='function');});}function popperGenerator$1(generatorOptions){if(generatorOptions===void 0){generatorOptions={};}var _generatorOptions=generatorOptions,_generatorOptions$def=_generatorOptions.defaultModifiers,defaultModifiers=_generatorOptions$def===void 0?[]:_generatorOptions$def,_generatorOptions$def2=_generatorOptions.defaultOptions,defaultOptions=_generatorOptions$def2===void 0?DEFAULT_OPTIONS$1:_generatorOptions$def2;return function createPopper(reference,popper,options){if(options===void 0){options=defaultOptions;}var state={placement:'bottom',orderedModifiers:[],options:Object.assign({},DEFAULT_OPTIONS$1,defaultOptions),modifiersData:{},elements:{reference:reference,popper:popper},attributes:{},styles:{}};var effectCleanupFns=[];var isDestroyed=false;var instance={state:state,setOptions:function setOptions(setOptionsAction){var options=typeof setOptionsAction==='function'?setOptionsAction(state.options):setOptionsAction;cleanupModifierEffects();state.options=Object.assign({},defaultOptions,state.options,options);state.scrollParents={reference:isElement$2(reference)?listScrollParents$1(reference):reference.contextElement?listScrollParents$1(reference.contextElement):[],popper:listScrollParents$1(popper)};// Orders the modifiers based on their dependencies and `phase`
// properties
var orderedModifiers=orderModifiers$1(mergeByName$1([].concat(defaultModifiers,state.options.modifiers)));// Strip out disabled modifiers
state.orderedModifiers=orderedModifiers.filter(function(m){return m.enabled;});// Validate the provided modifiers so that the consumer will get warned
// if one of the modifiers is invalid for any reason
if(process.env.NODE_ENV!=="production"){var modifiers=uniqueBy$1([].concat(orderedModifiers,state.options.modifiers),function(_ref){var name=_ref.name;return name;});validateModifiers$1(modifiers);if(getBasePlacement$1(state.options.placement)===auto$1){var flipModifier=state.orderedModifiers.find(function(_ref2){var name=_ref2.name;return name==='flip';});if(!flipModifier){console.error(['Popper: "auto" placements require the "flip" modifier be','present and enabled to work.'].join(' '));}}var _getComputedStyle=getComputedStyle$2(popper),marginTop=_getComputedStyle.marginTop,marginRight=_getComputedStyle.marginRight,marginBottom=_getComputedStyle.marginBottom,marginLeft=_getComputedStyle.marginLeft;// We no longer take into account `margins` on the popper, and it can
// cause bugs with positioning, so we'll warn the consumer
if([marginTop,marginRight,marginBottom,marginLeft].some(function(margin){return parseFloat(margin);})){console.warn(['Popper: CSS "margin" styles cannot be used to apply padding','between the popper and its reference element or boundary.','To replicate margin, use the `offset` modifier, as well as','the `padding` option in the `preventOverflow` and `flip`','modifiers.'].join(' '));}}runModifierEffects();return instance.update();},// Sync update – it will always be executed, even if not necessary. This
// is useful for low frequency updates where sync behavior simplifies the
// logic.
// For high frequency updates (e.g. `resize` and `scroll` events), always
// prefer the async Popper#update method
forceUpdate:function forceUpdate(){if(isDestroyed){return;}var _state$elements=state.elements,reference=_state$elements.reference,popper=_state$elements.popper;// Don't proceed if `reference` or `popper` are not valid elements
// anymore
if(!areValidElements$1(reference,popper)){if(process.env.NODE_ENV!=="production"){console.error(INVALID_ELEMENT_ERROR$1);}return;}// Store the reference and popper rects to be read by modifiers
state.rects={reference:getCompositeRect$1(reference,getOffsetParent$1(popper),state.options.strategy==='fixed'),popper:getLayoutRect$1(popper)};// Modifiers have the ability to reset the current update cycle. The
// most common use case for this is the `flip` modifier changing the
// placement, which then needs to re-run all the modifiers, because the
// logic was previously ran for the previous placement and is therefore
// stale/incorrect
state.reset=false;state.placement=state.options.placement;// On each update cycle, the `modifiersData` property for each modifier
// is filled with the initial data specified by the modifier. This means
// it doesn't persist and is fresh on each update.
// To ensure persistent data, use `${name}#persistent`
state.orderedModifiers.forEach(function(modifier){return state.modifiersData[modifier.name]=Object.assign({},modifier.data);});var __debug_loops__=0;for(var index=0;index<state.orderedModifiers.length;index++){if(process.env.NODE_ENV!=="production"){__debug_loops__+=1;if(__debug_loops__>100){console.error(INFINITE_LOOP_ERROR$1);break;}}if(state.reset===true){state.reset=false;index=-1;continue;}var _state$orderedModifie=state.orderedModifiers[index],fn=_state$orderedModifie.fn,_state$orderedModifie2=_state$orderedModifie.options,_options=_state$orderedModifie2===void 0?{}:_state$orderedModifie2,name=_state$orderedModifie.name;if(typeof fn==='function'){state=fn({state:state,options:_options,name:name,instance:instance})||state;}}},// Async and optimistically optimized update – it will not be executed if
// not necessary (debounced to run at most once-per-tick)
update:debounce$1$1(function(){return new Promise(function(resolve){instance.forceUpdate();resolve(state);});}),destroy:function destroy(){cleanupModifierEffects();isDestroyed=true;}};if(!areValidElements$1(reference,popper)){if(process.env.NODE_ENV!=="production"){console.error(INVALID_ELEMENT_ERROR$1);}return instance;}instance.setOptions(options).then(function(state){if(!isDestroyed&&options.onFirstUpdate){options.onFirstUpdate(state);}});// Modifiers have the ability to execute arbitrary code before the first
// update cycle runs. They will be executed in the same order as the update
// cycle. This is useful when a modifier adds some persistent data that
// other modifiers need to use, but the modifier is run after the dependent
// one.
function runModifierEffects(){state.orderedModifiers.forEach(function(_ref3){var name=_ref3.name,_ref3$options=_ref3.options,options=_ref3$options===void 0?{}:_ref3$options,effect=_ref3.effect;if(typeof effect==='function'){var cleanupFn=effect({state:state,name:name,instance:instance,options:options});var noopFn=function noopFn(){};effectCleanupFns.push(cleanupFn||noopFn);}});}function cleanupModifierEffects(){effectCleanupFns.forEach(function(fn){return fn();});effectCleanupFns=[];}return instance;};}var defaultModifiers$1=[eventListeners$1,popperOffsets$1$1,computeStyles$1$1,applyStyles$1$1,offset$1$1,flip$1$1,preventOverflow$1$1,arrow$1$1,hide$1$1];var createPopper$1=/*#__PURE__*/popperGenerator$1({defaultModifiers:defaultModifiers$1});// eslint-disable-next-line import/no-unused-modules
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */var hasElementType$1=typeof Element!=='undefined';var hasMap$1=typeof Map==='function';var hasSet$1=typeof Set==='function';var hasArrayBuffer$1=typeof ArrayBuffer==='function'&&!!ArrayBuffer.isView;// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function equal$1(a,b){// START: fast-deep-equal es6/index.js 3.1.1
if(a===b)return true;if(a&&b&&_typeof(a)=='object'&&_typeof(b)=='object'){if(a.constructor!==b.constructor)return false;var length,i,keys;if(Array.isArray(a)){length=a.length;if(length!=b.length)return false;for(i=length;i--!==0;){if(!equal$1(a[i],b[i]))return false;}return true;}// START: Modifications:
// 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
//    to co-exist with es5.
// 2. Replace `for of` with es5 compliant iteration using `for`.
//    Basically, take:
//
//    ```js
//    for (i of a.entries())
//      if (!b.has(i[0])) return false;
//    ```
//
//    ... and convert to:
//
//    ```js
//    it = a.entries();
//    while (!(i = it.next()).done)
//      if (!b.has(i.value[0])) return false;
//    ```
//
//    **Note**: `i` access switches to `i.value`.
var it;if(hasMap$1&&a instanceof Map&&b instanceof Map){if(a.size!==b.size)return false;it=a.entries();while(!(i=it.next()).done){if(!b.has(i.value[0]))return false;}it=a.entries();while(!(i=it.next()).done){if(!equal$1(i.value[1],b.get(i.value[0])))return false;}return true;}if(hasSet$1&&a instanceof Set&&b instanceof Set){if(a.size!==b.size)return false;it=a.entries();while(!(i=it.next()).done){if(!b.has(i.value[0]))return false;}return true;}// END: Modifications
if(hasArrayBuffer$1&&ArrayBuffer.isView(a)&&ArrayBuffer.isView(b)){length=a.length;if(length!=b.length)return false;for(i=length;i--!==0;){if(a[i]!==b[i])return false;}return true;}if(a.constructor===RegExp)return a.source===b.source&&a.flags===b.flags;if(a.valueOf!==Object.prototype.valueOf)return a.valueOf()===b.valueOf();if(a.toString!==Object.prototype.toString)return a.toString()===b.toString();keys=Object.keys(a);length=keys.length;if(length!==Object.keys(b).length)return false;for(i=length;i--!==0;){if(!Object.prototype.hasOwnProperty.call(b,keys[i]))return false;}// END: fast-deep-equal
// START: react-fast-compare
// custom handling for DOM elements
if(hasElementType$1&&a instanceof Element)return false;// custom handling for React/Preact
for(i=length;i--!==0;){if((keys[i]==='_owner'||keys[i]==='__v'||keys[i]==='__o')&&a.$$typeof){// React-specific: avoid traversing React elements' _owner
// Preact-specific: avoid traversing Preact elements' __v and __o
//    __v = $_original / $_vnode
//    __o = $_owner
// These properties contain circular references and are not needed when
// comparing the actual elements (and not their owners)
// .$$typeof and ._store on just reasonable markers of elements
continue;}// all other properties should be traversed as usual
if(!equal$1(a[keys[i]],b[keys[i]]))return false;}// END: react-fast-compare
// START: fast-deep-equal
return true;}return a!==a&&b!==b;}// end fast-deep-equal
var reactFastCompare$1=function isEqual(a,b){try{return equal$1(a,b);}catch(error){if((error.message||'').match(/stack|recursion/i)){// warn on circular references, don't crash
// browsers give this different errors name and messages:
// chrome/safari: "RangeError", "Maximum call stack size exceeded"
// firefox: "InternalError", too much recursion"
// edge: "Error", "Out of stack space"
console.warn('react-fast-compare cannot handle circular refs');return false;}// some other error. we should definitely know about these
throw error;}};var EMPTY_MODIFIERS$1=[];var usePopper$1=function usePopper(referenceElement,popperElement,options){if(options===void 0){options={};}var prevOptions=React.useRef(null);var optionsWithDefaults={onFirstUpdate:options.onFirstUpdate,placement:options.placement||'bottom',strategy:options.strategy||'absolute',modifiers:options.modifiers||EMPTY_MODIFIERS$1};var _React$useState=React.useState({styles:{popper:{position:optionsWithDefaults.strategy,left:'0',top:'0'},arrow:{position:'absolute'}},attributes:{}}),state=_React$useState[0],setState=_React$useState[1];var updateStateModifier=React.useMemo(function(){return {name:'updateState',enabled:true,phase:'write',fn:function fn(_ref){var state=_ref.state;var elements=Object.keys(state.elements);reactDom.flushSync(function(){setState({styles:fromEntries$1(elements.map(function(element){return [element,state.styles[element]||{}];})),attributes:fromEntries$1(elements.map(function(element){return [element,state.attributes[element]];}))});});},requires:['computeStyles']};},[]);var popperOptions=React.useMemo(function(){var newOptions={onFirstUpdate:optionsWithDefaults.onFirstUpdate,placement:optionsWithDefaults.placement,strategy:optionsWithDefaults.strategy,modifiers:[].concat(optionsWithDefaults.modifiers,[updateStateModifier,{name:'applyStyles',enabled:false}])};if(reactFastCompare$1(prevOptions.current,newOptions)){return prevOptions.current||newOptions;}else {prevOptions.current=newOptions;return newOptions;}},[optionsWithDefaults.onFirstUpdate,optionsWithDefaults.placement,optionsWithDefaults.strategy,optionsWithDefaults.modifiers,updateStateModifier]);var popperInstanceRef=React.useRef();useIsomorphicLayoutEffect$2(function(){if(popperInstanceRef.current){popperInstanceRef.current.setOptions(popperOptions);}},[popperOptions]);useIsomorphicLayoutEffect$2(function(){if(referenceElement==null||popperElement==null){return;}var createPopper$1$1=options.createPopper||createPopper$1;var popperInstance=createPopper$1$1(referenceElement,popperElement,popperOptions);popperInstanceRef.current=popperInstance;return function(){popperInstance.destroy();popperInstanceRef.current=null;};},[referenceElement,popperElement,options.createPopper]);return {state:popperInstanceRef.current?popperInstanceRef.current.state:null,styles:state.styles,attributes:state.attributes,update:popperInstanceRef.current?popperInstanceRef.current.update:null,forceUpdate:popperInstanceRef.current?popperInstanceRef.current.forceUpdate:null};};/**
 * clickoutside custom hook
 * @param ref ref to traget element
 * @param handler callback handler on outside click event
 * @param watchList optional list. if other states varible depend and need to be watched
 */function useOutsideClick$1(ref,handler){var watchList=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var matcher=arguments.length>3?arguments[3]:undefined;useEffect(function(){var handleClickOutside=function handleClickOutside(event){if(matcher){if(matcher(event)){return;}handler();return;}if(!ref.current||ref.current.contains(event.target)){return;}handler();};// register event listener
document.addEventListener('mousedown',handleClickOutside);document.addEventListener('touchstart',handleClickOutside);return function(){// Unregister the event listener
document.removeEventListener('mousedown',handleClickOutside);document.removeEventListener('touchstart',handleClickOutside);};},[ref,handler,matcher].concat(watchList));}var useDropdownPopper$1=function useDropdownPopper(_ref){var parentRefElement=_ref.parentRefElement,visible=_ref.visible,onVisibilityChange=_ref.onVisibilityChange,_ref$placement=_ref.placement,placement=_ref$placement===void 0?'bottom-start':_ref$placement,_ref$sameWidth=_ref.sameWidth,sameWidth=_ref$sameWidth===void 0?true:_ref$sameWidth,_ref$offsetValue=_ref.offsetValue,offsetValue=_ref$offsetValue===void 0?8:_ref$offsetValue,_ref$flip=_ref.flip,flip=_ref$flip===void 0?true:_ref$flip,_ref$enableEventListe=_ref.enableEventListeners,enableEventListeners=_ref$enableEventListe===void 0?true:_ref$enableEventListe;var _useState=useState(null),_useState2=_slicedToArray(_useState,2),popperElement=_useState2[0],setPopperElement=_useState2[1];var modifiers=useMemo(function(){return [{name:'flip',enabled:flip},{name:'offset',options:{offset:[0,offsetValue]}},{name:'sameWidth',enabled:sameWidth,fn:function fn(_ref2){var state=_ref2.state;state.styles.popper.width="".concat(state.rects.reference.width,"px");},effect:function effect(_ref3){var state=_ref3.state;state.elements.popper.style.minWidth="".concat(state.elements.reference.offsetWidth,"px");},phase:'beforeWrite',requires:['computeStyles']},{name:'eventListeners',enabled:enableEventListeners}];},[sameWidth,enableEventListeners,flip]);var popperInstance=usePopper$1(parentRefElement,popperElement,{modifiers:modifiers,placement:placement});useOutsideClick$1({current:null},function(){visible&&onVisibilityChange(false);},[],function(event){if(popperElement){return popperElement.contains(event.target);}if(parentRefElement&&parentRefElement instanceof Element){return parentRefElement.contains(event.target);}return false;});return Object.assign(Object.assign({},popperInstance),{setPopperElement:setPopperElement});};var Popover=function Popover(_ref){var visible=_ref.visible,target=_ref.target,_ref$onVisibilityChan=_ref.onVisibilityChange,onVisibilityChange=_ref$onVisibilityChan===void 0?function(){}:_ref$onVisibilityChan,children=_ref.children,className=_ref.className,_ref$anchor=_ref.anchor,anchor=_ref$anchor===void 0?document.body:_ref$anchor,_ref$placement=_ref.placement,placement=_ref$placement===void 0?'bottom':_ref$placement,sameWidth=_ref.sameWidth;var theme=useThemeSafe();var styles=useStyles$d$1({theme:theme,sameWidth:sameWidth});var _useDropdownPopper=useDropdownPopper$1({onVisibilityChange:onVisibilityChange,placement:placement,visible:visible,sameWidth:sameWidth!==null&&sameWidth!==void 0?sameWidth:false,parentRefElement:target}),setPopperElement=_useDropdownPopper.setPopperElement,attributes=_useDropdownPopper.attributes,popperStyles=_useDropdownPopper.styles;if(!visible){return null;}return/*#__PURE__*/createPortal(/*#__PURE__*/React__default.createElement(Card,Object.assign({className:clsx$1('CyoloUI-Popover',styles.popover,className),style:popperStyles.popper,ref:setPopperElement},attributes.popper),children),anchor);};var useStyles$d$1=createUseStyles(function(theme){return {popover:function popover(_ref2){var sameWidth=_ref2.sameWidth;return {boxSizing:'border-box',display:'flex',flexDirection:'column',overflowY:'auto',maxWidth:!sameWidth&&'auto',minWidth:152,gap:8,zIndex:theme.zIndex.max};}};});var DropdownDivider=function DropdownDivider(){var styles=useStyle();return/*#__PURE__*/React__default.createElement(Divider$1,{className:styles.divider,orientation:"horizontal",thickness:0.5,color:colors.dividerGray});};var useStyle=createUseStyles({divider:{marginBottom:4,marginTop:4}});var DropdownItem=function DropdownItem(_ref){var _ref$type=_ref.type,type=_ref$type===void 0?'text':_ref$type,_ref$checked=_ref.checked,checked=_ref$checked===void 0?false:_ref$checked,onClick=_ref.onClick,hasInfo=_ref.hasInfo,children=_ref.children;var theme=useThemeSafe();var classes=useStyles$c$1({theme:theme,showCheckbox:type==='checkbox',hasInfo:hasInfo});var handleClick=function handleClick(e){e.stopPropagation();onClick();};var generateTitle=function generateTitle(){return typeof children==='string'?children:undefined;};return/*#__PURE__*/React__default.createElement("button",{className:classes.button,type:"button",onClick:handleClick},type==='checkbox'&&/*#__PURE__*/React__default.createElement(Checkbox,{onClick:function onClick(e){e.preventDefault();e.stopPropagation();},checked:checked}),/*#__PURE__*/React__default.createElement(Text$1,{variant:"body",component:"div",title:generateTitle(),className:classes.text},children));};var useStyles$c$1=createUseStyles(function(theme){return {button:{position:'relative',background:'none',border:'none',outline:'none',cursor:'pointer',textAlign:'left',margin:[[8,16,6,16]],padding:0,display:'flex',justifyContent:'start',alignItems:'center'},text:function text(_ref2){var showCheckbox=_ref2.showCheckbox,hasInfo=_ref2.hasInfo;return {marginTop:2,marginLeft:showCheckbox?8:0,color:hasInfo?theme.palette.secondary.color:theme.palette.grey.color,whiteSpace:'nowrap',wordWrap:'unset',textOverflow:'ellipsis',overflow:'hidden'};}};});/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */function isObject$2(value){var type=_typeof(value);return value!=null&&(type=='object'||type=='function');}var isObject_1$1=isObject$2;/** Detect free variable `global` from Node.js. */var freeGlobal$1=_typeof(commonjsGlobal$1)=='object'&&commonjsGlobal$1&&commonjsGlobal$1.Object===Object&&commonjsGlobal$1;var _freeGlobal$1=freeGlobal$1;/** Detect free variable `self`. */var freeSelf$1=(typeof self==="undefined"?"undefined":_typeof(self))=='object'&&self&&self.Object===Object&&self;/** Used as a reference to the global object. */var root$2=_freeGlobal$1||freeSelf$1||Function('return this')();var _root$1=root$2;/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */var now$1=function now(){return _root$1.Date.now();};var now_1$1=now$1;/** Used to match a single whitespace character. */var reWhitespace$1=/\s/;/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */function trimmedEndIndex$1(string){var index=string.length;while(index--&&reWhitespace$1.test(string.charAt(index))){}return index;}var _trimmedEndIndex$1=trimmedEndIndex$1;/** Used to match leading whitespace. */var reTrimStart$1=/^\s+/;/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */function baseTrim$1(string){return string?string.slice(0,_trimmedEndIndex$1(string)+1).replace(reTrimStart$1,''):string;}var _baseTrim$1=baseTrim$1;/** Built-in value references. */var Symbol$1$1=_root$1.Symbol;var _Symbol$1=Symbol$1$1;/** Used for built-in method references. */var objectProto$1$1=Object.prototype;/** Used to check objects for own properties. */var hasOwnProperty$a=objectProto$1$1.hasOwnProperty;/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */var nativeObjectToString$1$1=objectProto$1$1.toString;/** Built-in value references. */var symToStringTag$1$1=_Symbol$1?_Symbol$1.toStringTag:undefined;/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */function getRawTag$1(value){var isOwn=hasOwnProperty$a.call(value,symToStringTag$1$1),tag=value[symToStringTag$1$1];try{value[symToStringTag$1$1]=undefined;var unmasked=true;}catch(e){}var result=nativeObjectToString$1$1.call(value);if(unmasked){if(isOwn){value[symToStringTag$1$1]=tag;}else {delete value[symToStringTag$1$1];}}return result;}var _getRawTag$1=getRawTag$1;/** Used for built-in method references. */var objectProto$c=Object.prototype;/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */var nativeObjectToString$2=objectProto$c.toString;/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */function objectToString$1(value){return nativeObjectToString$2.call(value);}var _objectToString$1=objectToString$1;/** `Object#toString` result references. */var nullTag$1='[object Null]',undefinedTag$1='[object Undefined]';/** Built-in value references. */var symToStringTag$2=_Symbol$1?_Symbol$1.toStringTag:undefined;/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */function baseGetTag$1(value){if(value==null){return value===undefined?undefinedTag$1:nullTag$1;}return symToStringTag$2&&symToStringTag$2 in Object(value)?_getRawTag$1(value):_objectToString$1(value);}var _baseGetTag$1=baseGetTag$1;/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */function isObjectLike$2(value){return value!=null&&_typeof(value)=='object';}var isObjectLike_1$1=isObjectLike$2;/** `Object#toString` result references. */var symbolTag$2='[object Symbol]';/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */function isSymbol$1(value){return _typeof(value)=='symbol'||isObjectLike_1$1(value)&&_baseGetTag$1(value)==symbolTag$2;}var isSymbol_1$1=isSymbol$1;/** Used as references for various `Number` constants. */var NAN$1=0/0;/** Used to detect bad signed hexadecimal string values. */var reIsBadHex$1=/^[-+]0x[0-9a-f]+$/i;/** Used to detect binary string values. */var reIsBinary$1=/^0b[01]+$/i;/** Used to detect octal string values. */var reIsOctal$1=/^0o[0-7]+$/i;/** Built-in method references without a dependency on `root`. */var freeParseInt$1=parseInt;/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */function toNumber$1(value){if(typeof value=='number'){return value;}if(isSymbol_1$1(value)){return NAN$1;}if(isObject_1$1(value)){var other=typeof value.valueOf=='function'?value.valueOf():value;value=isObject_1$1(other)?other+'':other;}if(typeof value!='string'){return value===0?value:+value;}value=_baseTrim$1(value);var isBinary=reIsBinary$1.test(value);return isBinary||reIsOctal$1.test(value)?freeParseInt$1(value.slice(2),isBinary?2:8):reIsBadHex$1.test(value)?NAN$1:+value;}var toNumber_1$1=toNumber$1;/** Error message constants. */var FUNC_ERROR_TEXT$1='Expected a function';/* Built-in method references for those with the same name as other `lodash` methods. */var nativeMax$1=Math.max,nativeMin$1=Math.min;/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */function debounce$3(func,wait,options){var lastArgs,lastThis,maxWait,result,timerId,lastCallTime,lastInvokeTime=0,leading=false,maxing=false,trailing=true;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT$1);}wait=toNumber_1$1(wait)||0;if(isObject_1$1(options)){leading=!!options.leading;maxing='maxWait'in options;maxWait=maxing?nativeMax$1(toNumber_1$1(options.maxWait)||0,wait):maxWait;trailing='trailing'in options?!!options.trailing:trailing;}function invokeFunc(time){var args=lastArgs,thisArg=lastThis;lastArgs=lastThis=undefined;lastInvokeTime=time;result=func.apply(thisArg,args);return result;}function leadingEdge(time){// Reset any `maxWait` timer.
lastInvokeTime=time;// Start the timer for the trailing edge.
timerId=setTimeout(timerExpired,wait);// Invoke the leading edge.
return leading?invokeFunc(time):result;}function remainingWait(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime,timeWaiting=wait-timeSinceLastCall;return maxing?nativeMin$1(timeWaiting,maxWait-timeSinceLastInvoke):timeWaiting;}function shouldInvoke(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime;// Either this is the first call, activity has stopped and we're at the
// trailing edge, the system time has gone backwards and we're treating
// it as the trailing edge, or we've hit the `maxWait` limit.
return lastCallTime===undefined||timeSinceLastCall>=wait||timeSinceLastCall<0||maxing&&timeSinceLastInvoke>=maxWait;}function timerExpired(){var time=now_1$1();if(shouldInvoke(time)){return trailingEdge(time);}// Restart the timer.
timerId=setTimeout(timerExpired,remainingWait(time));}function trailingEdge(time){timerId=undefined;// Only invoke if we have `lastArgs` which means `func` has been
// debounced at least once.
if(trailing&&lastArgs){return invokeFunc(time);}lastArgs=lastThis=undefined;return result;}function cancel(){if(timerId!==undefined){clearTimeout(timerId);}lastInvokeTime=0;lastArgs=lastCallTime=lastThis=timerId=undefined;}function flush(){return timerId===undefined?result:trailingEdge(now_1$1());}function debounced(){var time=now_1$1(),isInvoking=shouldInvoke(time);lastArgs=arguments;lastThis=this;lastCallTime=time;if(isInvoking){if(timerId===undefined){return leadingEdge(lastCallTime);}if(maxing){// Handle invocations in a tight loop.
clearTimeout(timerId);timerId=setTimeout(timerExpired,wait);return invokeFunc(lastCallTime);}}if(timerId===undefined){timerId=setTimeout(timerExpired,wait);}return result;}debounced.cancel=cancel;debounced.flush=flush;return debounced;}var debounce_1$2=debounce$3;/**
 * hook that handles hover over element
 * @returns `isHovering` boolean
 */function useHover$1(refElement){var delay=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var _useState=useState(false),_useState2=_slicedToArray(_useState,2),isHovering=_useState2[0],setIsHovering=_useState2[1];var handleMouseOver=useCallback(debounce_1$2(function(){setIsHovering(true);},delay),[delay]);var handleMouseLeave=useCallback(debounce_1$2(function(){setIsHovering(false);},delay),[delay]);useEffect(function(){return function(){handleMouseOver.cancel();handleMouseLeave.cancel();};},[handleMouseOver,handleMouseLeave]);useEffect(function(){if(refElement){refElement.addEventListener('mouseover',handleMouseOver);refElement.addEventListener('mouseleave',handleMouseLeave);return function(){refElement.removeEventListener('mouseover',handleMouseOver);refElement.removeEventListener('mouseleave',handleMouseLeave);};}},[refElement,handleMouseOver,handleMouseLeave]);return isHovering;}var BulbIcon='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxOCAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguOTk4MDUgMVYyLjQ3NjIiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMy4zNDA4MiAzLjM3NjQ2TDQuMzczMjkgNC40MjQwMSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xIDkuMTE5MzhIMi40NTQxOCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNS41NDIgOS4xMTkzOEgxNi45OTYyIiBzdHJva2U9IndoaXRlIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEzLjYyMjEgNC40MjQwMUwxNC42NTQ1IDMuMzc2NDYiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYuMTg2NjIgMTIuOTYyNEM2LjIyOTMzIDEyLjk5NTYgNi4yNzI4IDEzLjAyODggNi4zMTcwNSAxMy4wNjIyVjE0LjMxOUM2LjMxNzA1IDE1Ljc5OTggNy41MTc0NCAxNy4wMDAyIDguOTk4MTkgMTcuMDAwMkMxMC40Nzg5IDE3LjAwMDIgMTEuNjc5MyAxNS43OTk4IDExLjY3OTMgMTQuMzE5VjEzLjA4NDlDMTIuNTExMyAxMi41Mzc4IDEzLjA2NiAxMS45NDA2IDEzLjQwNTYgMTEuMjA0N0MxMy43NzAzIDEwLjQxNDQgMTMuODYwNiA5LjUxODI4IDEzLjg2MDYgOC40NzQ3NEMxMy44NjA2IDUuNzE2ODggMTEuNjk5MSAzLjQ1MjY0IDguOTk4MTYgMy40NTI2NEM2LjI5NzIxIDMuNDUyNjQgNC4xMzU3NCA1LjcxNjg4IDQuMTM1NzQgOC40NzQ3NEM0LjEzNTc0IDkuNTE5NjMgNC4yMjYxNiAxMC4zNjczIDQuNTkzODQgMTEuMTM0NEM0LjkxNzI5IDExLjgwOTIgNS40MzMwMyAxMi4zNzY1IDYuMTg2NjIgMTIuOTYyNFpNMTAuNjE0IDE0Ljc4NThINy4zODI0M0M3LjU4NDc0IDE1LjQ4NzMgOC4yMzE1NSAxNi4wMDA0IDguOTk4MTkgMTYuMDAwNEM5Ljc2NDgzIDE2LjAwMDQgMTAuNDExNiAxNS40ODczIDEwLjYxNCAxNC43ODU4WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+';var QuestionMarkIcon='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMTVDMTEuODY2IDE1IDE1IDExLjg2NiAxNSA4QzE1IDQuMTM0MDEgMTEuODY2IDEgOCAxQzQuMTM0MDEgMSAxIDQuMTM0MDEgMSA4QzEgMTEuODY2IDQuMTM0MDEgMTUgOCAxNVoiIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik01Ljk2Mjg5IDUuODk5NzFDNi4xMjc0NiA1LjQzMTg4IDYuNDUyMyA1LjAzNzM5IDYuODc5ODYgNC43ODYxMUM3LjMwNzQyIDQuNTM0ODMgNy44MTAxMiA0LjQ0Mjk3IDguMjk4OTEgNC41MjY4MUM4Ljc4NzcxIDQuNjEwNjYgOS4yMzEwNiA0Ljg2NDc4IDkuNTUwNDQgNS4yNDQxOEM5Ljg2OTgzIDUuNjIzNTkgMTAuMDQ0NiA2LjEwMzc4IDEwLjA0MzkgNi41OTk3MUMxMC4wNDM5IDcuOTk5NzEgNy45NDM4OSA4LjY5OTcxIDcuOTQzODkgOC42OTk3MSIgc3Ryb2tlPSIjRkZGRkZGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTcuOTk5NzYgMTEuNUg4LjAwNjQyIiBzdHJva2U9IiNGRkZGRkYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';var DEFAULT_DELAY_MS=300;var Tooltip=function Tooltip(_ref){var text=_ref.text,children=_ref.children,_ref$anchor=_ref.anchor,anchor=_ref$anchor===void 0?document.body:_ref$anchor,icon=_ref.icon,_ref$placement=_ref.placement,placement=_ref$placement===void 0?'top':_ref$placement,_ref$showArrow=_ref.showArrow,showArrow=_ref$showArrow===void 0?true:_ref$showArrow,_ref$variant=_ref.variant,variant=_ref$variant===void 0?'dark':_ref$variant,_ref$withDelay=_ref.withDelay,withDelay=_ref$withDelay===void 0?false:_ref$withDelay,_ref$delayMs=_ref.delayMs,delayMs=_ref$delayMs===void 0?DEFAULT_DELAY_MS:_ref$delayMs;var _useState=useState(),_useState2=_slicedToArray(_useState,2),refElement=_useState2[0],setRefElement=_useState2[1];var theme=useThemeSafe();var styles=useStyles$b$1({theme:theme,variant:variant});var tooltipDelay=useMemo(function(){return withDelay&&delayMs;},[withDelay,delayMs]);var isHovering=useHover$1(refElement,tooltipDelay);var _useDropdownPopper=useDropdownPopper$1({visible:isHovering,parentRefElement:refElement,onVisibilityChange:function onVisibilityChange(){},placement:placement,sameWidth:false,flip:true}),attributes=_useDropdownPopper.attributes,setPopperElement=_useDropdownPopper.setPopperElement,popperStyles=_useDropdownPopper.styles;var renderIcon=useCallback(function(){switch(icon){case'bulb':return/*#__PURE__*/React__default.createElement(Image,{src:BulbIcon,alt:"bulb icon",size:16});case'question-mark':return/*#__PURE__*/React__default.createElement(Image,{src:QuestionMarkIcon,alt:"Question Mark icon",size:16});}},[icon]);var textColor=useMemo(function(){return variant==='dark'?theme.palette.white.color:theme.palette.grey.color;},[variant]);var showTooltip=Boolean(text)&&isHovering;return/*#__PURE__*/React__default.createElement("div",{ref:setRefElement,className:clsx$1('CyoloUI-TooltipWrapper',styles.tooltipWrapper)},children,showTooltip&&/*#__PURE__*/createPortal(/*#__PURE__*/React__default.createElement("div",Object.assign({className:clsx$1('CyoloUI-Tooltip',styles.tooltip),ref:setPopperElement,style:popperStyles.popper},attributes.popper),Boolean(icon)&&renderIcon(),/*#__PURE__*/React__default.createElement(Text$1,{variant:variant==='dark'?'tag':'header-3',component:"div",color:textColor},text),showArrow&&/*#__PURE__*/React__default.createElement("div",{style:popperStyles.arrow,className:styles.arrow,"data-popper-arrow":true})),anchor));};var useStyles$b$1=createUseStyles(function(theme){var _tooltip;return {tooltipWrapper:{width:'fit-content',display:'flex'},tooltip:(_tooltip={position:'relative',display:'flex',gap:8,zIndex:theme.zIndex.max,maxWidth:320,padding:8,backgroundColor:function backgroundColor(_ref2){var variant=_ref2.variant;return variant==='dark'?theme.palette.secondary.dark:theme.palette.white.color;},borderRadius:theme.shape.borderRadiusLight,boxShadow:function boxShadow(_ref3){var variant=_ref3.variant;return variant==='light'&&theme.shadows[0];}},_defineProperty(_tooltip,'&[data-popper-placement^="top"] > $arrow',{bottom:-4}),_defineProperty(_tooltip,'&[data-popper-placement^="bottom"] > $arrow',{top:-4}),_defineProperty(_tooltip,'&[data-popper-placement^="left"] > $arrow',{right:-4}),_defineProperty(_tooltip,'&[data-popper-placement^="right"] > $arrow',{left:-4}),_defineProperty(_tooltip,'& $arrow, & $arrow::before',{position:'absolute',width:8,height:8,zIndex:-1}),_tooltip),arrow:_defineProperty({},'&::before',{content:'""',transform:'rotate(45deg)',backgroundColor:function backgroundColor(_ref4){var variant=_ref4.variant;return variant==='dark'?theme.palette.secondary.dark:theme.palette.white.color;},zIndex:-1})};});var useStyles$a$1=createUseStyles(function(theme){return {root:{position:'relative'},container:function container(props){return {borderRadius:theme.shape.borderRadiusLight,height:32,display:'flex',flexDirection:props.inlineElementPos==='start'?'row':'row-reverse',alignItems:'center',boxSizing:'border-box',backgroundColor:props.variant==='table'?'transparent':'#f8f9fe',border:props.variant!=='table'&&props.showBorder?"1px solid ".concat(props.borderColor):'1px solid transparent'};},innerElement:function innerElement(props){return {display:'flex',justifyContent:'center',alignItems:'center',flex:[0,1,'auto'],justifySelf:props.inlineElementPos==='start'?'start':'end'};},input:function input(props){return {border:'none',fontFamily:fonts$1.heebo,lineHeight:'100%',fontSize:theme.typography.fontBaseSize,outline:'none',margin:props.inlineElementPos?props.inlineElementPos==='start'?[2,8,2,0]:[2,0,2,8]:[2,8],width:'100%',background:'none',color:props.isError?theme.palette.error.color:theme.palette.black.color,opacity:!props.enabled?0.5:1,cursor:'inherit'};},errorMsg:function errorMsg(props){return {transition:theme.transitions.fast,margin:[[0,-8,0,0]],color:[theme.palette.error.color,'!important'],display:props.showError?'flex':'none',// hack to prevent from parent element stretching
width:0,minWidth:'100%'};}};});var TextField=/*#__PURE__*/React__default.forwardRef(function(_a,forwardedRef){var value=_a.value,inlineElement=_a.inlineElement,_a$inlineElementPos=_a.inlineElementPos,inlineElementPos=_a$inlineElementPos===void 0?'start':_a$inlineElementPos,_a$placeholder=_a.placeholder,placeholder=_a$placeholder===void 0?'':_a$placeholder,_a$focusedBorderColor=_a.focusedBorderColor,focusedBorderColor=_a$focusedBorderColor===void 0?colors.darkBlue:_a$focusedBorderColor,className=_a.className,_a$type=_a.type,type=_a$type===void 0?'text':_a$type,_a$variant=_a.variant,variant=_a$variant===void 0?'regular':_a$variant,_a$errorMessage=_a.errorMessage,errorMessage=_a$errorMessage===void 0?'':_a$errorMessage,onValidate=_a.onValidate,onChange=_a.onChange,_a$enabled=_a.enabled,enabled=_a$enabled===void 0?true:_a$enabled,required=_a.required,restProps=__rest$1(_a,["value","inlineElement","inlineElementPos","placeholder","focusedBorderColor","className","type","variant","errorMessage","onValidate","onChange","enabled","required"]);var _useState=useState('regular'),_useState2=_slicedToArray(_useState,2),fieldMode=_useState2[0],setFieldMode=_useState2[1];var _useState3=useState(false),_useState4=_slicedToArray(_useState3,2),inFocus=_useState4[0],setInFocus=_useState4[1];var theme=useThemeSafe();var textFieldRef=useRef(null);// show border if the field is in focus or its in error mode
var showBorder=useMemo(function(){return inFocus||fieldMode==='error';},[inFocus,fieldMode]);// define the shown border color
var borderColor=useMemo(function(){return fieldMode==='error'?theme.palette.error.color:focusedBorderColor;},[fieldMode,focusedBorderColor,theme.palette.error.color]);// decides if we need to show the error msg as a text
// below the field
// don't show error as text below field when in table
var showBottomErrorMsg=useMemo(function(){return variant!=='table'&&fieldMode==='error';},[variant,fieldMode]);var styles=useStyles$a$1({theme:theme,borderColor:borderColor,showBorder:showBorder,variant:variant,enabled:enabled,showError:showBottomErrorMsg,isError:fieldMode==='error',inlineElementPos:inlineElement?inlineElementPos:''});var validateValue=useCallback(function(){setFieldMode('regular');// if value is empty and field is required return early
if(!String(value).length&&required){setFieldMode('error');return;}// if onValidate is not defined return early
if(!onValidate)return;// if value is empty return early
if(!String(value).length)return;var isValid=onValidate(value);if(isValid)return;// value is invalid, set mode to error
setFieldMode('error');},[onValidate,value]);var handleHideDropdown=useCallback(function(event){if(event.key==='Escape'){setInFocus(false);}},[]);var handleFocus=useCallback(function(){if(!enabled){return;}setInFocus(true);},[enabled]);var focusField=useCallback(function(){var _a;if(!enabled){return;}setInFocus(true);(_a=textFieldRef.current)===null||_a===void 0?void 0:_a.focus();},[]);var handleBlur=useCallback(function(){setInFocus(false);validateValue();},[validateValue]);useEffect(function(){document.addEventListener('keydown',handleHideDropdown,true);document.addEventListener('blur',handleBlur,true);return function(){document.removeEventListener('keydown',handleHideDropdown,true);document.removeEventListener('blur',handleBlur,true);};},[handleHideDropdown,handleBlur]);// pass ref calls
useImperativeHandle(forwardedRef,function(){return {textFieldRef:textFieldRef,focusField:focusField};},[focusField]);var handleOnChange=useCallback(function(event){// on change remove the error state of a field
// if its in one
if(fieldMode==='error'){setFieldMode('regular');}if(!onChange){return;}onChange(event);},[onChange,fieldMode]);var component=useMemo(function(){return/*#__PURE__*/React__default.createElement("div",{className:styles.root},/*#__PURE__*/React__default.createElement("div",{className:clsx$1(styles.container,className)},inlineElement&&/*#__PURE__*/React__default.createElement("div",{className:styles.innerElement},inlineElement),/*#__PURE__*/React__default.createElement("input",Object.assign({className:styles.input,type:type,value:value,placeholder:placeholder,ref:textFieldRef,onFocus:handleFocus,onChange:handleOnChange,disabled:!enabled},restProps))),/*#__PURE__*/React__default.createElement(Text$1,{variant:"tag",className:styles.errorMsg},errorMessage));},[showBorder,className,type,value,placeholder,handleFocus,handleOnChange,enabled,restProps,errorMessage,styles.root,styles.container,styles.innerElement,styles.input,styles.errorMsg]);var renderComponent=useCallback(function(){switch(variant){case'table':return/*#__PURE__*/ (// if the component is in table mode, wrap it with tooltip
React__default.createElement(Tooltip,{placement:"bottom",text:errorMessage,variant:"light",showArrow:false},component));case'regular':default:return component;}},[variant,fieldMode,errorMessage,component]);return renderComponent();});TextField.displayName='TextField';var useStyles$9$1=createUseStyles({iconContainer:{display:'flex',justifyContent:'center',alignItems:'center',padding:[0,4,0,8]}});var SearchField=function SearchField(_a){var rest=__rest$1(_a,[]);var styles=useStyles$9$1();return/*#__PURE__*/React__default.createElement(TextField,Object.assign({inlineElement:/*#__PURE__*/React__default.createElement("div",{className:styles.iconContainer},/*#__PURE__*/React__default.createElement(Icon,{id:"search-icon"})),inlineElementPos:"start",focusedBorderColor:colors.lightBlue,placeholder:"Search"},rest));};var DropdownSearchField=function DropdownSearchField(_ref){var textFilter=_ref.textFilter,onSearchFieldChange=_ref.onSearchFieldChange;var classes=useStyles$8$1();return/*#__PURE__*/React__default.createElement(SearchField,{className:classes.searchField,value:textFilter,onChange:onSearchFieldChange});};var useStyles$8$1=createUseStyles({searchField:{width:'100%',marginBottom:8}});var useStyles$7$1=createUseStyles(function(theme){return {rootCard:{zIndex:theme.zIndex.high,padding:0},card:{overflowX:'hidden'},bottomCard:function bottomCard(props){return {position:'relative',display:'flex',flexDirection:'column',zIndex:theme.zIndex.medium,maxHeight:160,maxWidth:260,overflowY:'scroll',height:props.height||'auto','&::-webkit-scrollbar':{WebkitAppearance:'none','&:vertical':{width:11},'&-thumb':{borderRadius:theme.shape.borderRadius,border:{width:2,style:'solid',color:theme.palette.white.color},backgroundColor:'rgba(0, 0, 0, 0.5)'}}};},info:function info(){return {overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',marginTop:4};}};});var DropdownCard=function DropdownCard(_ref){var items=_ref.items,itemType=_ref.itemType,showSearch=_ref.showSearch,visible=_ref.visible,parentRefElement=_ref.parentRefElement,actionBtn=_ref.actionBtn,globalOptions=_ref.globalOptions,height=_ref.height,activeItems=_ref.activeItems,itemIdResolver=_ref.itemIdResolver,itemStringResolver=_ref.itemStringResolver,onItemClickHandler=_ref.onItemClickHandler,onVisibilityChange=_ref.onVisibilityChange,itemSearchFilter=_ref.itemSearchFilter,itemInfoResolver=_ref.itemInfoResolver;var _useState=useState(''),_useState2=_slicedToArray(_useState,2),textFilter=_useState2[0],setTextFilter=_useState2[1];var theme=useThemeSafe();var classes=useStyles$7$1({theme:theme,height:height});// useMemo and check length to reduce number of calls
var filterFunc=useMemo(function(){return textFilter.length?itemSearchFilter===null||itemSearchFilter===void 0?void 0:itemSearchFilter(textFilter):undefined;},[itemSearchFilter,textFilter]);var filteredItems=useMemo(function(){return filterFunc?items.filter(filterFunc):items;},[filterFunc,items]);var handleHideDropdown=useCallback(function(event){if(!visible){return;}if(event.key==='Escape'){onVisibilityChange(false);}},[visible,onVisibilityChange]);useEffect(function(){document.addEventListener('keydown',handleHideDropdown);return function(){document.removeEventListener('keydown',handleHideDropdown);};},[handleHideDropdown]);var onSearchFieldChange=useCallback(function(e){setTextFilter(e.target.value);},[]);var isChecked=useCallback(function(item){return activeItems.map(itemIdResolver).includes(itemIdResolver(item));},[activeItems,itemIdResolver]);var handleItemClick=function handleItemClick(item){return function(){onItemClickHandler(item);};};return/*#__PURE__*/React__default.createElement(Popover,{sameWidth:true,className:classes.rootCard,visible:visible,target:parentRefElement,placement:"bottom",onVisibilityChange:onVisibilityChange},/*#__PURE__*/React__default.createElement(Card,{className:classes.card},/*#__PURE__*/React__default.createElement(React__default.Fragment,null,showSearch?/*#__PURE__*/React__default.createElement(DropdownSearchField,{textFilter:textFilter,onSearchFieldChange:onSearchFieldChange}):null,(globalOptions===null||globalOptions===void 0?void 0:globalOptions.length)?globalOptions.map(function(item,index){return/*#__PURE__*/React__default.createElement(DropdownItem,{key:"".concat(item.text,"_").concat(index),type:itemType,checked:item.isChecked,onClick:item.onClick,hasInfo:false},item.text);}):null,Boolean(showSearch||(globalOptions===null||globalOptions===void 0?void 0:globalOptions.length))?/*#__PURE__*/React__default.createElement(DropdownDivider,null):null),/*#__PURE__*/React__default.createElement("div",{className:classes.bottomCard},filteredItems.map(function(item){return/*#__PURE__*/React__default.createElement(DropdownItem,{key:itemIdResolver(item),type:itemType,checked:isChecked(item),onClick:handleItemClick(item),hasInfo:!!itemInfoResolver},itemStringResolver(item),itemInfoResolver&&/*#__PURE__*/React__default.createElement(Text$1,{variant:"table-body",className:classes.info},itemInfoResolver(item)));})),actionBtn?/*#__PURE__*/React__default.createElement(React__default.Fragment,null,!(showSearch&&!items.length)?/*#__PURE__*/React__default.createElement(DropdownDivider,null):null,/*#__PURE__*/React__default.createElement(DropdownAddButton,{actionBtn:actionBtn,onVisibilityChange:onVisibilityChange})):null));};var IconButtonStyle={height:16,width:16,padding:0,display:'flex',justifyContent:'center',alignItems:'center',background:'none',border:'none',outline:'none',cursor:'pointer'};var IconButton=function IconButton(_a){var iconID=_a.iconID,_a$size=_a.size,size=_a$size===void 0?16:_a$size,style=_a.style,rest=__rest$1(_a,["iconID","size","style"]);return/*#__PURE__*/React__default.createElement("button",Object.assign({},rest,{style:Object.assign(Object.assign({height:size,width:size},IconButtonStyle),style),type:"button"}),/*#__PURE__*/React__default.createElement(Icon,{id:iconID,size:size}));};var useMenuStyles=createUseStyles(function(theme){return {root:function root(_ref){var rootStyle=_ref.rootStyle;return Object.assign({position:'relative',width:242},rootStyle);},card:function card(_ref2){var cardStyleFromProps=_ref2.cardStyleFromProps,variant=_ref2.variant;return Object.assign(Object.assign({cursor:'pointer'},variant==='table'?{background:'none',boxShadow:'none',paddingLeft:'none',paddingRight:'none'}:{}),cardStyleFromProps);},headText:function headText(_ref3){var variant=_ref3.variant,isPlaceholderText=_ref3.isPlaceholderText;return Object.assign({textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'nowrap',position:'relative',top:0,bottom:0,right:20,left:variant==='table'?10:0},isPlaceholderText?{color:theme.palette.grey.color}:{});},headCard:{height:16,display:'flex',justifyContent:'space-between',alignItems:'center',background:'none',width:'100%'},iconButton:{marginLeft:8,borderRadius:theme.shape.borderRadiusLight,boxShadow:theme.shadows[0]}};});var MaxActiveItemsInTitle=4;var DropdownMenu=function DropdownMenu(_ref){var items=_ref.items,type=_ref.type,variant=_ref.variant,_ref$activeId=_ref.activeId,activeId=_ref$activeId===void 0?[]:_ref$activeId,showSearch=_ref.showSearch,_ref$initialSelect=_ref.initialSelect,initialSelect=_ref$initialSelect===void 0?true:_ref$initialSelect,cardStyle=_ref.cardStyle,_ref$placeholder=_ref.placeholder,placeholder=_ref$placeholder===void 0?'':_ref$placeholder,height=_ref.height,actionBtn=_ref.actionBtn,globalOptions=_ref.globalOptions,style=_ref.style,itemIdResolver=_ref.itemIdResolver,itemStringResolver=_ref.itemStringResolver,onValueChange=_ref.onValueChange,itemSearchFilter=_ref.itemSearchFilter,_ref$maxItemsInTitle=_ref.maxItemsInTitle,maxItemsInTitle=_ref$maxItemsInTitle===void 0?MaxActiveItemsInTitle:_ref$maxItemsInTitle,itemInfoResolver=_ref.itemInfoResolver;var _useState=useState(false),_useState2=_slicedToArray(_useState,2),visible=_useState2[0],setVisible=_useState2[1];// reference needed for popper
var _useState3=useState(null),_useState4=_slicedToArray(_useState3,2),referenceElement=_useState4[0],setReferenceElement=_useState4[1];var theme=useThemeSafe();var itemType=type==='single'?'text':'checkbox';var iconID=visible?'dropdown_menu_icon_up':'dropdown_menu_icon_down';var activeItems=useMemo(function(){if(!(activeId===null||activeId===void 0?void 0:activeId.length)){return [];}var activeIds=typeof activeId==='string'?[activeId]:_toConsumableArray(activeId);return items.filter(function(item){return activeIds.includes(itemIdResolver(item));});},[activeId,items,itemIdResolver]);var resolvedHeadItemString=resolveHeadItemString(items,placeholder,activeItems,type,itemStringResolver,maxItemsInTitle,globalOptions);var classes=useMenuStyles({theme:theme,variant:variant,rootStyle:style,cardStyleFromProps:cardStyle,isPlaceholderText:resolvedHeadItemString===placeholder});useEffect(function(){handleValueChange();function handleValueChange(){if(!items.length){return;}if(activeItems.length){return;}if(!initialSelect){return;}onValueChange===null||onValueChange===void 0?void 0:onValueChange(items[0]);}},[items,onValueChange,initialSelect,activeItems]);var handleOnVisibilityChange=useCallback(function(isVisible){setVisible(isVisible);},[]);var onItemClickHandler=useCallback(function(item){onValueChange(item);// only hide if type is single
if(type!=='single')return;setVisible(false);},[onValueChange,type]);var onHeaderClickHandler=function onHeaderClickHandler(){if(items.length===0&&!actionBtn)return;setVisible(function(prev){return !prev;});};return/*#__PURE__*/React__default.createElement("div",{className:classes.root,ref:setReferenceElement},/*#__PURE__*/React__default.createElement(Card,{className:classes.card,onClick:onHeaderClickHandler},/*#__PURE__*/React__default.createElement("div",{className:classes.headCard},/*#__PURE__*/React__default.createElement(Text$1,{title:resolvedHeadItemString,className:classes.headText,variant:"body"},resolvedHeadItemString),/*#__PURE__*/React__default.createElement(IconButton,{size:14,iconID:iconID,className:classes.iconButton}))),/*#__PURE__*/React__default.createElement(DropdownCard,{parentRefElement:referenceElement,visible:visible,showSearch:showSearch,itemType:itemType,items:items,globalOptions:globalOptions,actionBtn:actionBtn,height:height,activeItems:activeItems,onItemClickHandler:onItemClickHandler,itemSearchFilter:itemSearchFilter,itemIdResolver:itemIdResolver,itemStringResolver:itemStringResolver,onVisibilityChange:handleOnVisibilityChange,itemInfoResolver:itemInfoResolver}));};var activeItemsText=function activeItemsText(maxItemsInTitle,activeItems,itemStringResolver,type){//if there is only 1 item return item name
if(type==='single'){return itemStringResolver(activeItems[0]);}// are there less active items then the max limit
if(maxItemsInTitle>activeItems.length){// join them up with a , (works for single item too)
return activeItems.map(itemStringResolver).join(', ');}// return multiple
return 'Multiple';};var globalOptionsText=function globalOptionsText(globalOptions){return globalOptions.filter(function(option){return option.isChecked;}).map(function(i){return i.text;}).join(', ');};function resolveHeadItemString(items,placeholder,activeItems,type,itemStringResolver,maxItemsInTitle,globalOptions){//if active items -> return items names / 'Multiple'
if(activeItems.length){return activeItemsText(maxItemsInTitle,activeItems,itemStringResolver,type);}//if global option is checked -> return global option text
if(globalOptions&&globalOptions.some(function(i){return i.isChecked;})){return globalOptionsText(globalOptions);}return placeholder;}var Form=function Form(_a){var children=_a.children,rest=__rest$1(_a,["children"]);return/*#__PURE__*/React__default.createElement("form",Object.assign({},rest),children);};var ClickDurationMili=250;var resolveIcon=function resolveIcon(variant,clicked,hover,disabled){if(disabled){switch(variant){default:return 'add-disabled';}}switch(variant){case'trash':return 'trash';case'add':return 'add-blue';case'edit':if(clicked){return 'edit-clicked';}if(hover){return 'edit-hover';}return 'edit';case'other':if(clicked){return 'other-clicked';}if(hover){return 'other-hover';}return 'other';case'search':if(clicked){return 'search-clicked';}if(hover){return 'search-hover';}return 'search';case'more':if(clicked){return 'more-clicked';}if(hover){return 'more-hover';}return 'more';case'info':if(clicked){return 'info-clicked';}if(hover){return 'info-hover';}return 'info';}};var GeneralIcon=/*#__PURE__*/function(_Component){_inherits(GeneralIcon,_Component);var _super=_createSuper(GeneralIcon);function GeneralIcon(){var _this;_classCallCheck$1(this,GeneralIcon);_this=_super.apply(this,arguments);_this.state={hovered:false,clicked:false};_this.handleMouseEnter=function(){_this.setState({hovered:true});};_this.handleMouseLeave=function(){_this.setState({hovered:false});};_this.handleClick=function(){var onClick=_this.props.onClick;if(_this.clickTimeoutId)window.clearTimeout(_this.clickTimeoutId);_this.setState({clicked:true});_this.clickTimeoutId=window.setTimeout(function(){_this.setState({clicked:false});},ClickDurationMili);// call original props onClick
onClick&&onClick();};return _this;}_createClass(GeneralIcon,[{key:"componentWillUnmount",value:function componentWillUnmount(){if(this.clickTimeoutId)window.clearTimeout(this.clickTimeoutId);}},{key:"render",value:function render(){var _this$props=this.props,variant=_this$props.variant,_this$props$disabled=_this$props.disabled,disabled=_this$props$disabled===void 0?false:_this$props$disabled;var _this$state=this.state,hovered=_this$state.hovered,clicked=_this$state.clicked;var classes=['CyoloUI-GeneralIcons'];if(variant==='add'){classes.push('CyoloUI-GeneralIcons-Icon');classes.push('CyoloUI-GeneralIcons-Icon-Add');}if(variant==='trash'){classes.push('CyoloUI-GeneralIcons-Icon');classes.push('CyoloUI-GeneralIcons-Icon-Delete');}return/*#__PURE__*/React__default.createElement("div",{className:classes.join(' '),onMouseEnter:this.handleMouseEnter,onMouseLeave:this.handleMouseLeave,onClick:this.handleClick},/*#__PURE__*/React__default.createElement(Icon,{id:resolveIcon(variant,clicked,hovered,disabled)}));}}]);return GeneralIcon;}(Component);var GroupButton=function GroupButton(_ref){var selected=_ref.selected,options=_ref.options,onChange=_ref.onChange,className=_ref.className;var theme=useThemeSafe();var styles=useStyles$6$1({theme:theme});var optionMetaList=useMemo(function(){return options.map(function(option,idx){var isSelected=option===selected;var isFirst=idx===0;var isLast=idx===options.length-1;return {isFirst:isFirst,isLast:isLast,isSelected:isSelected,value:option};});},[selected,options]);return/*#__PURE__*/React__default.createElement("div",{className:clsx$1(styles.groupButtonRoot,className)},optionMetaList.map(function(option){return/*#__PURE__*/React__default.createElement(Button,{key:option.value,className:clsx$1(styles.buttonItem,{selected:option.isSelected,'first-btn':option.isFirst,'last-btn':option.isLast}),variant:"secondary",onClick:function onClick(){onChange(option.value);}},option.value);}));};var useStyles$6$1=createUseStyles(function(theme){return {groupButtonRoot:{display:'flex',flexWrap:'nowrap'},buttonItem:{width:132,cursor:'pointer',backgroundColor:"".concat(theme.palette.background.color," !important"),borderRadius:'0 !important','&.selected':{backgroundColor:"".concat(theme.palette.white.color," !important"),transform:"scale(1.05)"},'&.selected > .CyoloUI-Text':{color:"".concat(theme.palette.primary.color," !important"),fontWeight:theme.typography.fontWeightMedium},'&.first-btn':{borderTopLeftRadius:"".concat(theme.shape.borderRadiusLight,"px !important"),borderBottomLeftRadius:"".concat(theme.shape.borderRadiusLight,"px !important")},'&.last-btn':{borderTopRightRadius:"".concat(theme.shape.borderRadiusLight,"px !important"),borderBottomRightRadius:"".concat(theme.shape.borderRadiusLight,"px !important")}}};});var useArrowKeysNavigation$1=function useArrowKeysNavigation(optionsSize,onOutOfBound){var NO_SELECTION_INDEX=-1;var MAX_SIZE=optionsSize;var _useState=useState(NO_SELECTION_INDEX),_useState2=_slicedToArray(_useState,2),cursor=_useState2[0],setCursor=_useState2[1];var resetCursor=function resetCursor(){setCursor(NO_SELECTION_INDEX);};/**
   * next (down\right in a list)
   */var next=function next(){var nextPos=cursor+1;if(nextPos>=MAX_SIZE){return;}setCursor(nextPos);};/**
   * prev (up\left in a list)
   */var prev=function prev(){var nextPos=cursor-1;if(nextPos<0){// onOutOfBound supports back to parent focus
onOutOfBound();resetCursor();return;}setCursor(nextPos);};return {cursor:cursor,next:next,prev:prev,resetCursor:resetCursor};};/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */createCommonjsModule$2(function(module,exports){(function(){/** Used as a safe reference for `undefined` in pre-ES5 environments. */var undefined$1;/** Used as the semantic version number. */var VERSION='4.17.21';/** Used as the size to enable large array optimizations. */var LARGE_ARRAY_SIZE=200;/** Error message constants. */var CORE_ERROR_TEXT='Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',FUNC_ERROR_TEXT='Expected a function',INVALID_TEMPL_VAR_ERROR_TEXT='Invalid `variable` option passed into `_.template`';/** Used to stand-in for `undefined` hash values. */var HASH_UNDEFINED='__lodash_hash_undefined__';/** Used as the maximum memoize cache size. */var MAX_MEMOIZE_SIZE=500;/** Used as the internal argument placeholder. */var PLACEHOLDER='__lodash_placeholder__';/** Used to compose bitmasks for cloning. */var CLONE_DEEP_FLAG=1,CLONE_FLAT_FLAG=2,CLONE_SYMBOLS_FLAG=4;/** Used to compose bitmasks for value comparisons. */var COMPARE_PARTIAL_FLAG=1,COMPARE_UNORDERED_FLAG=2;/** Used to compose bitmasks for function metadata. */var WRAP_BIND_FLAG=1,WRAP_BIND_KEY_FLAG=2,WRAP_CURRY_BOUND_FLAG=4,WRAP_CURRY_FLAG=8,WRAP_CURRY_RIGHT_FLAG=16,WRAP_PARTIAL_FLAG=32,WRAP_PARTIAL_RIGHT_FLAG=64,WRAP_ARY_FLAG=128,WRAP_REARG_FLAG=256,WRAP_FLIP_FLAG=512;/** Used as default options for `_.truncate`. */var DEFAULT_TRUNC_LENGTH=30,DEFAULT_TRUNC_OMISSION='...';/** Used to detect hot functions by number of calls within a span of milliseconds. */var HOT_COUNT=800,HOT_SPAN=16;/** Used to indicate the type of lazy iteratees. */var LAZY_FILTER_FLAG=1,LAZY_MAP_FLAG=2,LAZY_WHILE_FLAG=3;/** Used as references for various `Number` constants. */var INFINITY=1/0,MAX_SAFE_INTEGER=9007199254740991,MAX_INTEGER=1.7976931348623157e+308,NAN=0/0;/** Used as references for the maximum length and index of an array. */var MAX_ARRAY_LENGTH=4294967295,MAX_ARRAY_INDEX=MAX_ARRAY_LENGTH-1,HALF_MAX_ARRAY_LENGTH=MAX_ARRAY_LENGTH>>>1;/** Used to associate wrap methods with their bit flags. */var wrapFlags=[['ary',WRAP_ARY_FLAG],['bind',WRAP_BIND_FLAG],['bindKey',WRAP_BIND_KEY_FLAG],['curry',WRAP_CURRY_FLAG],['curryRight',WRAP_CURRY_RIGHT_FLAG],['flip',WRAP_FLIP_FLAG],['partial',WRAP_PARTIAL_FLAG],['partialRight',WRAP_PARTIAL_RIGHT_FLAG],['rearg',WRAP_REARG_FLAG]];/** `Object#toString` result references. */var argsTag='[object Arguments]',arrayTag='[object Array]',asyncTag='[object AsyncFunction]',boolTag='[object Boolean]',dateTag='[object Date]',domExcTag='[object DOMException]',errorTag='[object Error]',funcTag='[object Function]',genTag='[object GeneratorFunction]',mapTag='[object Map]',numberTag='[object Number]',nullTag='[object Null]',objectTag='[object Object]',promiseTag='[object Promise]',proxyTag='[object Proxy]',regexpTag='[object RegExp]',setTag='[object Set]',stringTag='[object String]',symbolTag='[object Symbol]',undefinedTag='[object Undefined]',weakMapTag='[object WeakMap]',weakSetTag='[object WeakSet]';var arrayBufferTag='[object ArrayBuffer]',dataViewTag='[object DataView]',float32Tag='[object Float32Array]',float64Tag='[object Float64Array]',int8Tag='[object Int8Array]',int16Tag='[object Int16Array]',int32Tag='[object Int32Array]',uint8Tag='[object Uint8Array]',uint8ClampedTag='[object Uint8ClampedArray]',uint16Tag='[object Uint16Array]',uint32Tag='[object Uint32Array]';/** Used to match empty string literals in compiled template source. */var reEmptyStringLeading=/\b__p \+= '';/g,reEmptyStringMiddle=/\b(__p \+=) '' \+/g,reEmptyStringTrailing=/(__e\(.*?\)|\b__t\)) \+\n'';/g;/** Used to match HTML entities and HTML characters. */var reEscapedHtml=/&(?:amp|lt|gt|quot|#39);/g,reUnescapedHtml=/[&<>"']/g,reHasEscapedHtml=RegExp(reEscapedHtml.source),reHasUnescapedHtml=RegExp(reUnescapedHtml.source);/** Used to match template delimiters. */var reEscape=/<%-([\s\S]+?)%>/g,reEvaluate=/<%([\s\S]+?)%>/g,reInterpolate=/<%=([\s\S]+?)%>/g;/** Used to match property names within property paths. */var reIsDeepProp=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,reIsPlainProp=/^\w*$/,rePropName=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;/**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */var reRegExpChar=/[\\^$.*+?()[\]{}|]/g,reHasRegExpChar=RegExp(reRegExpChar.source);/** Used to match leading whitespace. */var reTrimStart=/^\s+/;/** Used to match a single whitespace character. */var reWhitespace=/\s/;/** Used to match wrap detail comments. */var reWrapComment=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,reWrapDetails=/\{\n\/\* \[wrapped with (.+)\] \*/,reSplitDetails=/,? & /;/** Used to match words composed of alphanumeric characters. */var reAsciiWord=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;/**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */var reForbiddenIdentifierChars=/[()=,{}\[\]\/\s]/;/** Used to match backslashes in property paths. */var reEscapeChar=/\\(\\)?/g;/**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */var reEsTemplate=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;/** Used to match `RegExp` flags from their coerced string values. */var reFlags=/\w*$/;/** Used to detect bad signed hexadecimal string values. */var reIsBadHex=/^[-+]0x[0-9a-f]+$/i;/** Used to detect binary string values. */var reIsBinary=/^0b[01]+$/i;/** Used to detect host constructors (Safari). */var reIsHostCtor=/^\[object .+?Constructor\]$/;/** Used to detect octal string values. */var reIsOctal=/^0o[0-7]+$/i;/** Used to detect unsigned integer values. */var reIsUint=/^(?:0|[1-9]\d*)$/;/** Used to match Latin Unicode letters (excluding mathematical operators). */var reLatin=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;/** Used to ensure capturing order of template delimiters. */var reNoMatch=/($^)/;/** Used to match unescaped characters in compiled string literals. */var reUnescapedString=/['\n\r\u2028\u2029\\]/g;/** Used to compose unicode character classes. */var rsAstralRange="\\ud800-\\udfff",rsComboMarksRange="\\u0300-\\u036f",reComboHalfMarksRange="\\ufe20-\\ufe2f",rsComboSymbolsRange="\\u20d0-\\u20ff",rsComboRange=rsComboMarksRange+reComboHalfMarksRange+rsComboSymbolsRange,rsDingbatRange="\\u2700-\\u27bf",rsLowerRange='a-z\\xdf-\\xf6\\xf8-\\xff',rsMathOpRange='\\xac\\xb1\\xd7\\xf7',rsNonCharRange='\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',rsPunctuationRange="\\u2000-\\u206f",rsSpaceRange=" \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",rsUpperRange='A-Z\\xc0-\\xd6\\xd8-\\xde',rsVarRange="\\ufe0e\\ufe0f",rsBreakRange=rsMathOpRange+rsNonCharRange+rsPunctuationRange+rsSpaceRange;/** Used to compose unicode capture groups. */var rsApos="['\u2019]",rsAstral='['+rsAstralRange+']',rsBreak='['+rsBreakRange+']',rsCombo='['+rsComboRange+']',rsDigits='\\d+',rsDingbat='['+rsDingbatRange+']',rsLower='['+rsLowerRange+']',rsMisc='[^'+rsAstralRange+rsBreakRange+rsDigits+rsDingbatRange+rsLowerRange+rsUpperRange+']',rsFitz="\\ud83c[\\udffb-\\udfff]",rsModifier='(?:'+rsCombo+'|'+rsFitz+')',rsNonAstral='[^'+rsAstralRange+']',rsRegional="(?:\\ud83c[\\udde6-\\uddff]){2}",rsSurrPair="[\\ud800-\\udbff][\\udc00-\\udfff]",rsUpper='['+rsUpperRange+']',rsZWJ="\\u200d";/** Used to compose unicode regexes. */var rsMiscLower='(?:'+rsLower+'|'+rsMisc+')',rsMiscUpper='(?:'+rsUpper+'|'+rsMisc+')',rsOptContrLower='(?:'+rsApos+'(?:d|ll|m|re|s|t|ve))?',rsOptContrUpper='(?:'+rsApos+'(?:D|LL|M|RE|S|T|VE))?',reOptMod=rsModifier+'?',rsOptVar='['+rsVarRange+']?',rsOptJoin='(?:'+rsZWJ+'(?:'+[rsNonAstral,rsRegional,rsSurrPair].join('|')+')'+rsOptVar+reOptMod+')*',rsOrdLower='\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',rsOrdUpper='\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',rsSeq=rsOptVar+reOptMod+rsOptJoin,rsEmoji='(?:'+[rsDingbat,rsRegional,rsSurrPair].join('|')+')'+rsSeq,rsSymbol='(?:'+[rsNonAstral+rsCombo+'?',rsCombo,rsRegional,rsSurrPair,rsAstral].join('|')+')';/** Used to match apostrophes. */var reApos=RegExp(rsApos,'g');/**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */var reComboMark=RegExp(rsCombo,'g');/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */var reUnicode=RegExp(rsFitz+'(?='+rsFitz+')|'+rsSymbol+rsSeq,'g');/** Used to match complex or compound words. */var reUnicodeWord=RegExp([rsUpper+'?'+rsLower+'+'+rsOptContrLower+'(?='+[rsBreak,rsUpper,'$'].join('|')+')',rsMiscUpper+'+'+rsOptContrUpper+'(?='+[rsBreak,rsUpper+rsMiscLower,'$'].join('|')+')',rsUpper+'?'+rsMiscLower+'+'+rsOptContrLower,rsUpper+'+'+rsOptContrUpper,rsOrdUpper,rsOrdLower,rsDigits,rsEmoji].join('|'),'g');/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */var reHasUnicode=RegExp('['+rsZWJ+rsAstralRange+rsComboRange+rsVarRange+']');/** Used to detect strings that need a more robust regexp to match words. */var reHasUnicodeWord=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;/** Used to assign default `context` object properties. */var contextProps=['Array','Buffer','DataView','Date','Error','Float32Array','Float64Array','Function','Int8Array','Int16Array','Int32Array','Map','Math','Object','Promise','RegExp','Set','String','Symbol','TypeError','Uint8Array','Uint8ClampedArray','Uint16Array','Uint32Array','WeakMap','_','clearTimeout','isFinite','parseInt','setTimeout'];/** Used to make template sourceURLs easier to identify. */var templateCounter=-1;/** Used to identify `toStringTag` values of typed arrays. */var typedArrayTags={};typedArrayTags[float32Tag]=typedArrayTags[float64Tag]=typedArrayTags[int8Tag]=typedArrayTags[int16Tag]=typedArrayTags[int32Tag]=typedArrayTags[uint8Tag]=typedArrayTags[uint8ClampedTag]=typedArrayTags[uint16Tag]=typedArrayTags[uint32Tag]=true;typedArrayTags[argsTag]=typedArrayTags[arrayTag]=typedArrayTags[arrayBufferTag]=typedArrayTags[boolTag]=typedArrayTags[dataViewTag]=typedArrayTags[dateTag]=typedArrayTags[errorTag]=typedArrayTags[funcTag]=typedArrayTags[mapTag]=typedArrayTags[numberTag]=typedArrayTags[objectTag]=typedArrayTags[regexpTag]=typedArrayTags[setTag]=typedArrayTags[stringTag]=typedArrayTags[weakMapTag]=false;/** Used to identify `toStringTag` values supported by `_.clone`. */var cloneableTags={};cloneableTags[argsTag]=cloneableTags[arrayTag]=cloneableTags[arrayBufferTag]=cloneableTags[dataViewTag]=cloneableTags[boolTag]=cloneableTags[dateTag]=cloneableTags[float32Tag]=cloneableTags[float64Tag]=cloneableTags[int8Tag]=cloneableTags[int16Tag]=cloneableTags[int32Tag]=cloneableTags[mapTag]=cloneableTags[numberTag]=cloneableTags[objectTag]=cloneableTags[regexpTag]=cloneableTags[setTag]=cloneableTags[stringTag]=cloneableTags[symbolTag]=cloneableTags[uint8Tag]=cloneableTags[uint8ClampedTag]=cloneableTags[uint16Tag]=cloneableTags[uint32Tag]=true;cloneableTags[errorTag]=cloneableTags[funcTag]=cloneableTags[weakMapTag]=false;/** Used to map Latin Unicode letters to basic Latin letters. */var deburredLetters={// Latin-1 Supplement block.
'\xc0':'A','\xc1':'A','\xc2':'A','\xc3':'A','\xc4':'A','\xc5':'A','\xe0':'a','\xe1':'a','\xe2':'a','\xe3':'a','\xe4':'a','\xe5':'a','\xc7':'C','\xe7':'c','\xd0':'D','\xf0':'d','\xc8':'E','\xc9':'E','\xca':'E','\xcb':'E','\xe8':'e','\xe9':'e','\xea':'e','\xeb':'e','\xcc':'I','\xcd':'I','\xce':'I','\xcf':'I','\xec':'i','\xed':'i','\xee':'i','\xef':'i','\xd1':'N','\xf1':'n','\xd2':'O','\xd3':'O','\xd4':'O','\xd5':'O','\xd6':'O','\xd8':'O','\xf2':'o','\xf3':'o','\xf4':'o','\xf5':'o','\xf6':'o','\xf8':'o','\xd9':'U','\xda':'U','\xdb':'U','\xdc':'U','\xf9':'u','\xfa':'u','\xfb':'u','\xfc':'u','\xdd':'Y','\xfd':'y','\xff':'y','\xc6':'Ae','\xe6':'ae','\xde':'Th','\xfe':'th','\xdf':'ss',// Latin Extended-A block.
"\u0100":'A',"\u0102":'A',"\u0104":'A',"\u0101":'a',"\u0103":'a',"\u0105":'a',"\u0106":'C',"\u0108":'C',"\u010A":'C',"\u010C":'C',"\u0107":'c',"\u0109":'c',"\u010B":'c',"\u010D":'c',"\u010E":'D',"\u0110":'D',"\u010F":'d',"\u0111":'d',"\u0112":'E',"\u0114":'E',"\u0116":'E',"\u0118":'E',"\u011A":'E',"\u0113":'e',"\u0115":'e',"\u0117":'e',"\u0119":'e',"\u011B":'e',"\u011C":'G',"\u011E":'G',"\u0120":'G',"\u0122":'G',"\u011D":'g',"\u011F":'g',"\u0121":'g',"\u0123":'g',"\u0124":'H',"\u0126":'H',"\u0125":'h',"\u0127":'h',"\u0128":'I',"\u012A":'I',"\u012C":'I',"\u012E":'I',"\u0130":'I',"\u0129":'i',"\u012B":'i',"\u012D":'i',"\u012F":'i',"\u0131":'i',"\u0134":'J',"\u0135":'j',"\u0136":'K',"\u0137":'k',"\u0138":'k',"\u0139":'L',"\u013B":'L',"\u013D":'L',"\u013F":'L',"\u0141":'L',"\u013A":'l',"\u013C":'l',"\u013E":'l',"\u0140":'l',"\u0142":'l',"\u0143":'N',"\u0145":'N',"\u0147":'N',"\u014A":'N',"\u0144":'n',"\u0146":'n',"\u0148":'n',"\u014B":'n',"\u014C":'O',"\u014E":'O',"\u0150":'O',"\u014D":'o',"\u014F":'o',"\u0151":'o',"\u0154":'R',"\u0156":'R',"\u0158":'R',"\u0155":'r',"\u0157":'r',"\u0159":'r',"\u015A":'S',"\u015C":'S',"\u015E":'S',"\u0160":'S',"\u015B":'s',"\u015D":'s',"\u015F":'s',"\u0161":'s',"\u0162":'T',"\u0164":'T',"\u0166":'T',"\u0163":'t',"\u0165":'t',"\u0167":'t',"\u0168":'U',"\u016A":'U',"\u016C":'U',"\u016E":'U',"\u0170":'U',"\u0172":'U',"\u0169":'u',"\u016B":'u',"\u016D":'u',"\u016F":'u',"\u0171":'u',"\u0173":'u',"\u0174":'W',"\u0175":'w',"\u0176":'Y',"\u0177":'y',"\u0178":'Y',"\u0179":'Z',"\u017B":'Z',"\u017D":'Z',"\u017A":'z',"\u017C":'z',"\u017E":'z',"\u0132":'IJ',"\u0133":'ij',"\u0152":'Oe',"\u0153":'oe',"\u0149":"'n","\u017F":'s'};/** Used to map characters to HTML entities. */var htmlEscapes={'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'};/** Used to map HTML entities to characters. */var htmlUnescapes={'&amp;':'&','&lt;':'<','&gt;':'>','&quot;':'"','&#39;':"'"};/** Used to escape characters for inclusion in compiled string literals. */var stringEscapes={'\\':'\\',"'":"'",'\n':'n','\r':'r',"\u2028":'u2028',"\u2029":'u2029'};/** Built-in method references without a dependency on `root`. */var freeParseFloat=parseFloat,freeParseInt=parseInt;/** Detect free variable `global` from Node.js. */var freeGlobal=_typeof(commonjsGlobal$1)=='object'&&commonjsGlobal$1&&commonjsGlobal$1.Object===Object&&commonjsGlobal$1;/** Detect free variable `self`. */var freeSelf=(typeof self==="undefined"?"undefined":_typeof(self))=='object'&&self&&self.Object===Object&&self;/** Used as a reference to the global object. */var root=freeGlobal||freeSelf||Function('return this')();/** Detect free variable `exports`. */var freeExports=exports&&!exports.nodeType&&exports;/** Detect free variable `module`. */var freeModule=freeExports&&'object'=='object'&&module&&!module.nodeType&&module;/** Detect the popular CommonJS extension `module.exports`. */var moduleExports=freeModule&&freeModule.exports===freeExports;/** Detect free variable `process` from Node.js. */var freeProcess=moduleExports&&freeGlobal.process;/** Used to access faster Node.js helpers. */var nodeUtil=function(){try{// Use `util.types` for Node.js 10+.
var types=freeModule&&freeModule.require&&freeModule.require('util').types;if(types){return types;}// Legacy `process.binding('util')` for Node.js < 10.
return freeProcess&&freeProcess.binding&&freeProcess.binding('util');}catch(e){}}();/* Node.js helper references. */var nodeIsArrayBuffer=nodeUtil&&nodeUtil.isArrayBuffer,nodeIsDate=nodeUtil&&nodeUtil.isDate,nodeIsMap=nodeUtil&&nodeUtil.isMap,nodeIsRegExp=nodeUtil&&nodeUtil.isRegExp,nodeIsSet=nodeUtil&&nodeUtil.isSet,nodeIsTypedArray=nodeUtil&&nodeUtil.isTypedArray;/*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */function apply(func,thisArg,args){switch(args.length){case 0:return func.call(thisArg);case 1:return func.call(thisArg,args[0]);case 2:return func.call(thisArg,args[0],args[1]);case 3:return func.call(thisArg,args[0],args[1],args[2]);}return func.apply(thisArg,args);}/**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */function arrayAggregator(array,setter,iteratee,accumulator){var index=-1,length=array==null?0:array.length;while(++index<length){var value=array[index];setter(accumulator,value,iteratee(value),array);}return accumulator;}/**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */function arrayEach(array,iteratee){var index=-1,length=array==null?0:array.length;while(++index<length){if(iteratee(array[index],index,array)===false){break;}}return array;}/**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */function arrayEachRight(array,iteratee){var length=array==null?0:array.length;while(length--){if(iteratee(array[length],length,array)===false){break;}}return array;}/**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */function arrayEvery(array,predicate){var index=-1,length=array==null?0:array.length;while(++index<length){if(!predicate(array[index],index,array)){return false;}}return true;}/**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */function arrayFilter(array,predicate){var index=-1,length=array==null?0:array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(predicate(value,index,array)){result[resIndex++]=value;}}return result;}/**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */function arrayIncludes(array,value){var length=array==null?0:array.length;return !!length&&baseIndexOf(array,value,0)>-1;}/**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */function arrayIncludesWith(array,value,comparator){var index=-1,length=array==null?0:array.length;while(++index<length){if(comparator(value,array[index])){return true;}}return false;}/**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */function arrayMap(array,iteratee){var index=-1,length=array==null?0:array.length,result=Array(length);while(++index<length){result[index]=iteratee(array[index],index,array);}return result;}/**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */function arrayPush(array,values){var index=-1,length=values.length,offset=array.length;while(++index<length){array[offset+index]=values[index];}return array;}/**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */function arrayReduce(array,iteratee,accumulator,initAccum){var index=-1,length=array==null?0:array.length;if(initAccum&&length){accumulator=array[++index];}while(++index<length){accumulator=iteratee(accumulator,array[index],index,array);}return accumulator;}/**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */function arrayReduceRight(array,iteratee,accumulator,initAccum){var length=array==null?0:array.length;if(initAccum&&length){accumulator=array[--length];}while(length--){accumulator=iteratee(accumulator,array[length],length,array);}return accumulator;}/**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */function arraySome(array,predicate){var index=-1,length=array==null?0:array.length;while(++index<length){if(predicate(array[index],index,array)){return true;}}return false;}/**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */var asciiSize=baseProperty('length');/**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */function asciiToArray(string){return string.split('');}/**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */function asciiWords(string){return string.match(reAsciiWord)||[];}/**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */function baseFindKey(collection,predicate,eachFunc){var result;eachFunc(collection,function(value,key,collection){if(predicate(value,key,collection)){result=key;return false;}});return result;}/**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function baseFindIndex(array,predicate,fromIndex,fromRight){var length=array.length,index=fromIndex+(fromRight?1:-1);while(fromRight?index--:++index<length){if(predicate(array[index],index,array)){return index;}}return -1;}/**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function baseIndexOf(array,value,fromIndex){return value===value?strictIndexOf(array,value,fromIndex):baseFindIndex(array,baseIsNaN,fromIndex);}/**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function baseIndexOfWith(array,value,fromIndex,comparator){var index=fromIndex-1,length=array.length;while(++index<length){if(comparator(array[index],value)){return index;}}return -1;}/**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */function baseIsNaN(value){return value!==value;}/**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */function baseMean(array,iteratee){var length=array==null?0:array.length;return length?baseSum(array,iteratee)/length:NAN;}/**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */function baseProperty(key){return function(object){return object==null?undefined$1:object[key];};}/**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */function basePropertyOf(object){return function(key){return object==null?undefined$1:object[key];};}/**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */function baseReduce(collection,iteratee,accumulator,initAccum,eachFunc){eachFunc(collection,function(value,index,collection){accumulator=initAccum?(initAccum=false,value):iteratee(accumulator,value,index,collection);});return accumulator;}/**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */function baseSortBy(array,comparer){var length=array.length;array.sort(comparer);while(length--){array[length]=array[length].value;}return array;}/**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */function baseSum(array,iteratee){var result,index=-1,length=array.length;while(++index<length){var current=iteratee(array[index]);if(current!==undefined$1){result=result===undefined$1?current:result+current;}}return result;}/**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */function baseTimes(n,iteratee){var index=-1,result=Array(n);while(++index<n){result[index]=iteratee(index);}return result;}/**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */function baseToPairs(object,props){return arrayMap(props,function(key){return [key,object[key]];});}/**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */function baseTrim(string){return string?string.slice(0,trimmedEndIndex(string)+1).replace(reTrimStart,''):string;}/**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */function baseUnary(func){return function(value){return func(value);};}/**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */function baseValues(object,props){return arrayMap(props,function(key){return object[key];});}/**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */function cacheHas(cache,key){return cache.has(key);}/**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */function charsStartIndex(strSymbols,chrSymbols){var index=-1,length=strSymbols.length;while(++index<length&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}return index;}/**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */function charsEndIndex(strSymbols,chrSymbols){var index=strSymbols.length;while(index--&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}return index;}/**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */function countHolders(array,placeholder){var length=array.length,result=0;while(length--){if(array[length]===placeholder){++result;}}return result;}/**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */var deburrLetter=basePropertyOf(deburredLetters);/**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */var escapeHtmlChar=basePropertyOf(htmlEscapes);/**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */function escapeStringChar(chr){return '\\'+stringEscapes[chr];}/**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */function getValue(object,key){return object==null?undefined$1:object[key];}/**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */function hasUnicode(string){return reHasUnicode.test(string);}/**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */function hasUnicodeWord(string){return reHasUnicodeWord.test(string);}/**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */function iteratorToArray(iterator){var data,result=[];while(!(data=iterator.next()).done){result.push(data.value);}return result;}/**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */function mapToArray(map){var index=-1,result=Array(map.size);map.forEach(function(value,key){result[++index]=[key,value];});return result;}/**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */function overArg(func,transform){return function(arg){return func(transform(arg));};}/**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */function replaceHolders(array,placeholder){var index=-1,length=array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(value===placeholder||value===PLACEHOLDER){array[index]=PLACEHOLDER;result[resIndex++]=index;}}return result;}/**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */function setToArray(set){var index=-1,result=Array(set.size);set.forEach(function(value){result[++index]=value;});return result;}/**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */function setToPairs(set){var index=-1,result=Array(set.size);set.forEach(function(value){result[++index]=[value,value];});return result;}/**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function strictIndexOf(array,value,fromIndex){var index=fromIndex-1,length=array.length;while(++index<length){if(array[index]===value){return index;}}return -1;}/**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function strictLastIndexOf(array,value,fromIndex){var index=fromIndex+1;while(index--){if(array[index]===value){return index;}}return index;}/**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */function stringSize(string){return hasUnicode(string)?unicodeSize(string):asciiSize(string);}/**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */function stringToArray(string){return hasUnicode(string)?unicodeToArray(string):asciiToArray(string);}/**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */function trimmedEndIndex(string){var index=string.length;while(index--&&reWhitespace.test(string.charAt(index))){}return index;}/**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */var unescapeHtmlChar=basePropertyOf(htmlUnescapes);/**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */function unicodeSize(string){var result=reUnicode.lastIndex=0;while(reUnicode.test(string)){++result;}return result;}/**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */function unicodeToArray(string){return string.match(reUnicode)||[];}/**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */function unicodeWords(string){return string.match(reUnicodeWord)||[];}/*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */var runInContext=function runInContext(context){context=context==null?root:_.defaults(root.Object(),context,_.pick(root,contextProps));/** Built-in constructor references. */var Array=context.Array,Date=context.Date,Error=context.Error,Function=context.Function,Math=context.Math,Object=context.Object,RegExp=context.RegExp,String=context.String,TypeError=context.TypeError;/** Used for built-in method references. */var arrayProto=Array.prototype,funcProto=Function.prototype,objectProto=Object.prototype;/** Used to detect overreaching core-js shims. */var coreJsData=context['__core-js_shared__'];/** Used to resolve the decompiled source of functions. */var funcToString=funcProto.toString;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/** Used to generate unique IDs. */var idCounter=0;/** Used to detect methods masquerading as native. */var maskSrcKey=function(){var uid=/[^.]+$/.exec(coreJsData&&coreJsData.keys&&coreJsData.keys.IE_PROTO||'');return uid?'Symbol(src)_1.'+uid:'';}();/**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */var nativeObjectToString=objectProto.toString;/** Used to infer the `Object` constructor. */var objectCtorString=funcToString.call(Object);/** Used to restore the original `_` reference in `_.noConflict`. */var oldDash=root._;/** Used to detect if a method is native. */var reIsNative=RegExp('^'+funcToString.call(hasOwnProperty).replace(reRegExpChar,'\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,'$1.*?')+'$');/** Built-in value references. */var Buffer=moduleExports?context.Buffer:undefined$1,_Symbol2=context.Symbol,Uint8Array=context.Uint8Array,allocUnsafe=Buffer?Buffer.allocUnsafe:undefined$1,getPrototype=overArg(Object.getPrototypeOf,Object),objectCreate=Object.create,propertyIsEnumerable=objectProto.propertyIsEnumerable,splice=arrayProto.splice,spreadableSymbol=_Symbol2?_Symbol2.isConcatSpreadable:undefined$1,symIterator=_Symbol2?_Symbol2.iterator:undefined$1,symToStringTag=_Symbol2?_Symbol2.toStringTag:undefined$1;var defineProperty=function(){try{var func=getNative(Object,'defineProperty');func({},'',{});return func;}catch(e){}}();/** Mocked built-ins. */var ctxClearTimeout=context.clearTimeout!==root.clearTimeout&&context.clearTimeout,ctxNow=Date&&Date.now!==root.Date.now&&Date.now,ctxSetTimeout=context.setTimeout!==root.setTimeout&&context.setTimeout;/* Built-in method references for those with the same name as other `lodash` methods. */var nativeCeil=Math.ceil,nativeFloor=Math.floor,nativeGetSymbols=Object.getOwnPropertySymbols,nativeIsBuffer=Buffer?Buffer.isBuffer:undefined$1,nativeIsFinite=context.isFinite,nativeJoin=arrayProto.join,nativeKeys=overArg(Object.keys,Object),nativeMax=Math.max,nativeMin=Math.min,nativeNow=Date.now,nativeParseInt=context.parseInt,nativeRandom=Math.random,nativeReverse=arrayProto.reverse;/* Built-in method references that are verified to be native. */var DataView=getNative(context,'DataView'),Map=getNative(context,'Map'),Promise=getNative(context,'Promise'),Set=getNative(context,'Set'),WeakMap=getNative(context,'WeakMap'),nativeCreate=getNative(Object,'create');/** Used to store function metadata. */var metaMap=WeakMap&&new WeakMap();/** Used to lookup unminified function names. */var realNames={};/** Used to detect maps, sets, and weakmaps. */var dataViewCtorString=toSource(DataView),mapCtorString=toSource(Map),promiseCtorString=toSource(Promise),setCtorString=toSource(Set),weakMapCtorString=toSource(WeakMap);/** Used to convert symbols to primitives and strings. */var symbolProto=_Symbol2?_Symbol2.prototype:undefined$1,symbolValueOf=symbolProto?symbolProto.valueOf:undefined$1,symbolToString=symbolProto?symbolProto.toString:undefined$1;/*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */function lodash(value){if(isObjectLike(value)&&!isArray(value)&&!(value instanceof LazyWrapper)){if(value instanceof LodashWrapper){return value;}if(hasOwnProperty.call(value,'__wrapped__')){return wrapperClone(value);}}return new LodashWrapper(value);}/**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */var baseCreate=function(){function object(){}return function(proto){if(!isObject(proto)){return {};}if(objectCreate){return objectCreate(proto);}object.prototype=proto;var result=new object();object.prototype=undefined$1;return result;};}();/**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */function baseLodash(){// No operation performed.
}/**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */function LodashWrapper(value,chainAll){this.__wrapped__=value;this.__actions__=[];this.__chain__=!!chainAll;this.__index__=0;this.__values__=undefined$1;}/**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */lodash.templateSettings={/**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */'escape':reEscape,/**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */'evaluate':reEvaluate,/**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */'interpolate':reInterpolate,/**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */'variable':'',/**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */'imports':{/**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */'_':lodash}};// Ensure wrappers are instances of `baseLodash`.
lodash.prototype=baseLodash.prototype;lodash.prototype.constructor=lodash;LodashWrapper.prototype=baseCreate(baseLodash.prototype);LodashWrapper.prototype.constructor=LodashWrapper;/*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */function LazyWrapper(value){this.__wrapped__=value;this.__actions__=[];this.__dir__=1;this.__filtered__=false;this.__iteratees__=[];this.__takeCount__=MAX_ARRAY_LENGTH;this.__views__=[];}/**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */function lazyClone(){var result=new LazyWrapper(this.__wrapped__);result.__actions__=copyArray(this.__actions__);result.__dir__=this.__dir__;result.__filtered__=this.__filtered__;result.__iteratees__=copyArray(this.__iteratees__);result.__takeCount__=this.__takeCount__;result.__views__=copyArray(this.__views__);return result;}/**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */function lazyReverse(){if(this.__filtered__){var result=new LazyWrapper(this);result.__dir__=-1;result.__filtered__=true;}else {result=this.clone();result.__dir__*=-1;}return result;}/**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */function lazyValue(){var array=this.__wrapped__.value(),dir=this.__dir__,isArr=isArray(array),isRight=dir<0,arrLength=isArr?array.length:0,view=getView(0,arrLength,this.__views__),start=view.start,end=view.end,length=end-start,index=isRight?end:start-1,iteratees=this.__iteratees__,iterLength=iteratees.length,resIndex=0,takeCount=nativeMin(length,this.__takeCount__);if(!isArr||!isRight&&arrLength==length&&takeCount==length){return baseWrapperValue(array,this.__actions__);}var result=[];outer:while(length--&&resIndex<takeCount){index+=dir;var iterIndex=-1,value=array[index];while(++iterIndex<iterLength){var data=iteratees[iterIndex],iteratee=data.iteratee,type=data.type,computed=iteratee(value);if(type==LAZY_MAP_FLAG){value=computed;}else if(!computed){if(type==LAZY_FILTER_FLAG){continue outer;}else {break outer;}}}result[resIndex++]=value;}return result;}// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype=baseCreate(baseLodash.prototype);LazyWrapper.prototype.constructor=LazyWrapper;/*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */function Hash(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */function hashClear(){this.__data__=nativeCreate?nativeCreate(null):{};this.size=0;}/**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */function hashDelete(key){var result=this.has(key)&&delete this.__data__[key];this.size-=result?1:0;return result;}/**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */function hashGet(key){var data=this.__data__;if(nativeCreate){var result=data[key];return result===HASH_UNDEFINED?undefined$1:result;}return hasOwnProperty.call(data,key)?data[key]:undefined$1;}/**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function hashHas(key){var data=this.__data__;return nativeCreate?data[key]!==undefined$1:hasOwnProperty.call(data,key);}/**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */function hashSet(key,value){var data=this.__data__;this.size+=this.has(key)?0:1;data[key]=nativeCreate&&value===undefined$1?HASH_UNDEFINED:value;return this;}// Add methods to `Hash`.
Hash.prototype.clear=hashClear;Hash.prototype['delete']=hashDelete;Hash.prototype.get=hashGet;Hash.prototype.has=hashHas;Hash.prototype.set=hashSet;/*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */function ListCache(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */function listCacheClear(){this.__data__=[];this.size=0;}/**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */function listCacheDelete(key){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){return false;}var lastIndex=data.length-1;if(index==lastIndex){data.pop();}else {splice.call(data,index,1);}--this.size;return true;}/**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */function listCacheGet(key){var data=this.__data__,index=assocIndexOf(data,key);return index<0?undefined$1:data[index][1];}/**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function listCacheHas(key){return assocIndexOf(this.__data__,key)>-1;}/**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */function listCacheSet(key,value){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){++this.size;data.push([key,value]);}else {data[index][1]=value;}return this;}// Add methods to `ListCache`.
ListCache.prototype.clear=listCacheClear;ListCache.prototype['delete']=listCacheDelete;ListCache.prototype.get=listCacheGet;ListCache.prototype.has=listCacheHas;ListCache.prototype.set=listCacheSet;/*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */function MapCache(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */function mapCacheClear(){this.size=0;this.__data__={'hash':new Hash(),'map':new(Map||ListCache)(),'string':new Hash()};}/**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */function mapCacheDelete(key){var result=getMapData(this,key)['delete'](key);this.size-=result?1:0;return result;}/**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */function mapCacheGet(key){return getMapData(this,key).get(key);}/**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function mapCacheHas(key){return getMapData(this,key).has(key);}/**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */function mapCacheSet(key,value){var data=getMapData(this,key),size=data.size;data.set(key,value);this.size+=data.size==size?0:1;return this;}// Add methods to `MapCache`.
MapCache.prototype.clear=mapCacheClear;MapCache.prototype['delete']=mapCacheDelete;MapCache.prototype.get=mapCacheGet;MapCache.prototype.has=mapCacheHas;MapCache.prototype.set=mapCacheSet;/*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */function SetCache(values){var index=-1,length=values==null?0:values.length;this.__data__=new MapCache();while(++index<length){this.add(values[index]);}}/**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */function setCacheAdd(value){this.__data__.set(value,HASH_UNDEFINED);return this;}/**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */function setCacheHas(value){return this.__data__.has(value);}// Add methods to `SetCache`.
SetCache.prototype.add=SetCache.prototype.push=setCacheAdd;SetCache.prototype.has=setCacheHas;/*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */function Stack(entries){var data=this.__data__=new ListCache(entries);this.size=data.size;}/**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */function stackClear(){this.__data__=new ListCache();this.size=0;}/**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */function stackDelete(key){var data=this.__data__,result=data['delete'](key);this.size=data.size;return result;}/**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */function stackGet(key){return this.__data__.get(key);}/**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function stackHas(key){return this.__data__.has(key);}/**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */function stackSet(key,value){var data=this.__data__;if(data instanceof ListCache){var pairs=data.__data__;if(!Map||pairs.length<LARGE_ARRAY_SIZE-1){pairs.push([key,value]);this.size=++data.size;return this;}data=this.__data__=new MapCache(pairs);}data.set(key,value);this.size=data.size;return this;}// Add methods to `Stack`.
Stack.prototype.clear=stackClear;Stack.prototype['delete']=stackDelete;Stack.prototype.get=stackGet;Stack.prototype.has=stackHas;Stack.prototype.set=stackSet;/*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */function arrayLikeKeys(value,inherited){var isArr=isArray(value),isArg=!isArr&&isArguments(value),isBuff=!isArr&&!isArg&&isBuffer(value),isType=!isArr&&!isArg&&!isBuff&&isTypedArray(value),skipIndexes=isArr||isArg||isBuff||isType,result=skipIndexes?baseTimes(value.length,String):[],length=result.length;for(var key in value){if((inherited||hasOwnProperty.call(value,key))&&!(skipIndexes&&(// Safari 9 has enumerable `arguments.length` in strict mode.
key=='length'||isBuff&&(key=='offset'||key=='parent')||isType&&(key=='buffer'||key=='byteLength'||key=='byteOffset')||// Skip index properties.
isIndex(key,length)))){result.push(key);}}return result;}/**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */function arraySample(array){var length=array.length;return length?array[baseRandom(0,length-1)]:undefined$1;}/**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */function arraySampleSize(array,n){return shuffleSelf(copyArray(array),baseClamp(n,0,array.length));}/**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */function arrayShuffle(array){return shuffleSelf(copyArray(array));}/**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */function assignMergeValue(object,key,value){if(value!==undefined$1&&!eq(object[key],value)||value===undefined$1&&!(key in object)){baseAssignValue(object,key,value);}}/**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */function assignValue(object,key,value){var objValue=object[key];if(!(hasOwnProperty.call(object,key)&&eq(objValue,value))||value===undefined$1&&!(key in object)){baseAssignValue(object,key,value);}}/**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */function assocIndexOf(array,key){var length=array.length;while(length--){if(eq(array[length][0],key)){return length;}}return -1;}/**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */function baseAggregator(collection,setter,iteratee,accumulator){baseEach(collection,function(value,key,collection){setter(accumulator,value,iteratee(value),collection);});return accumulator;}/**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */function baseAssign(object,source){return object&&copyObject(source,keys(source),object);}/**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */function baseAssignIn(object,source){return object&&copyObject(source,keysIn(source),object);}/**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */function baseAssignValue(object,key,value){if(key=='__proto__'&&defineProperty){defineProperty(object,key,{'configurable':true,'enumerable':true,'value':value,'writable':true});}else {object[key]=value;}}/**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */function baseAt(object,paths){var index=-1,length=paths.length,result=Array(length),skip=object==null;while(++index<length){result[index]=skip?undefined$1:get(object,paths[index]);}return result;}/**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */function baseClamp(number,lower,upper){if(number===number){if(upper!==undefined$1){number=number<=upper?number:upper;}if(lower!==undefined$1){number=number>=lower?number:lower;}}return number;}/**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */function baseClone(value,bitmask,customizer,key,object,stack){var result,isDeep=bitmask&CLONE_DEEP_FLAG,isFlat=bitmask&CLONE_FLAT_FLAG,isFull=bitmask&CLONE_SYMBOLS_FLAG;if(customizer){result=object?customizer(value,key,object,stack):customizer(value);}if(result!==undefined$1){return result;}if(!isObject(value)){return value;}var isArr=isArray(value);if(isArr){result=initCloneArray(value);if(!isDeep){return copyArray(value,result);}}else {var tag=getTag(value),isFunc=tag==funcTag||tag==genTag;if(isBuffer(value)){return cloneBuffer(value,isDeep);}if(tag==objectTag||tag==argsTag||isFunc&&!object){result=isFlat||isFunc?{}:initCloneObject(value);if(!isDeep){return isFlat?copySymbolsIn(value,baseAssignIn(result,value)):copySymbols(value,baseAssign(result,value));}}else {if(!cloneableTags[tag]){return object?value:{};}result=initCloneByTag(value,tag,isDeep);}}// Check for circular references and return its corresponding clone.
stack||(stack=new Stack());var stacked=stack.get(value);if(stacked){return stacked;}stack.set(value,result);if(isSet(value)){value.forEach(function(subValue){result.add(baseClone(subValue,bitmask,customizer,subValue,value,stack));});}else if(isMap(value)){value.forEach(function(subValue,key){result.set(key,baseClone(subValue,bitmask,customizer,key,value,stack));});}var keysFunc=isFull?isFlat?getAllKeysIn:getAllKeys:isFlat?keysIn:keys;var props=isArr?undefined$1:keysFunc(value);arrayEach(props||value,function(subValue,key){if(props){key=subValue;subValue=value[key];}// Recursively populate clone (susceptible to call stack limits).
assignValue(result,key,baseClone(subValue,bitmask,customizer,key,value,stack));});return result;}/**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */function baseConforms(source){var props=keys(source);return function(object){return baseConformsTo(object,source,props);};}/**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */function baseConformsTo(object,source,props){var length=props.length;if(object==null){return !length;}object=Object(object);while(length--){var key=props[length],predicate=source[key],value=object[key];if(value===undefined$1&&!(key in object)||!predicate(value)){return false;}}return true;}/**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */function baseDelay(func,wait,args){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return setTimeout(function(){func.apply(undefined$1,args);},wait);}/**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */function baseDifference(array,values,iteratee,comparator){var index=-1,includes=arrayIncludes,isCommon=true,length=array.length,result=[],valuesLength=values.length;if(!length){return result;}if(iteratee){values=arrayMap(values,baseUnary(iteratee));}if(comparator){includes=arrayIncludesWith;isCommon=false;}else if(values.length>=LARGE_ARRAY_SIZE){includes=cacheHas;isCommon=false;values=new SetCache(values);}outer:while(++index<length){var value=array[index],computed=iteratee==null?value:iteratee(value);value=comparator||value!==0?value:0;if(isCommon&&computed===computed){var valuesIndex=valuesLength;while(valuesIndex--){if(values[valuesIndex]===computed){continue outer;}}result.push(value);}else if(!includes(values,computed,comparator)){result.push(value);}}return result;}/**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */var baseEach=createBaseEach(baseForOwn);/**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */var baseEachRight=createBaseEach(baseForOwnRight,true);/**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */function baseEvery(collection,predicate){var result=true;baseEach(collection,function(value,index,collection){result=!!predicate(value,index,collection);return result;});return result;}/**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */function baseExtremum(array,iteratee,comparator){var index=-1,length=array.length;while(++index<length){var value=array[index],current=iteratee(value);if(current!=null&&(computed===undefined$1?current===current&&!isSymbol(current):comparator(current,computed))){var computed=current,result=value;}}return result;}/**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */function baseFill(array,value,start,end){var length=array.length;start=toInteger(start);if(start<0){start=-start>length?0:length+start;}end=end===undefined$1||end>length?length:toInteger(end);if(end<0){end+=length;}end=start>end?0:toLength(end);while(start<end){array[start++]=value;}return array;}/**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */function baseFilter(collection,predicate){var result=[];baseEach(collection,function(value,index,collection){if(predicate(value,index,collection)){result.push(value);}});return result;}/**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */function baseFlatten(array,depth,predicate,isStrict,result){var index=-1,length=array.length;predicate||(predicate=isFlattenable);result||(result=[]);while(++index<length){var value=array[index];if(depth>0&&predicate(value)){if(depth>1){// Recursively flatten arrays (susceptible to call stack limits).
baseFlatten(value,depth-1,predicate,isStrict,result);}else {arrayPush(result,value);}}else if(!isStrict){result[result.length]=value;}}return result;}/**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */var baseFor=createBaseFor();/**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */var baseForRight=createBaseFor(true);/**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */function baseForOwn(object,iteratee){return object&&baseFor(object,iteratee,keys);}/**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */function baseForOwnRight(object,iteratee){return object&&baseForRight(object,iteratee,keys);}/**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */function baseFunctions(object,props){return arrayFilter(props,function(key){return isFunction(object[key]);});}/**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */function baseGet(object,path){path=castPath(path,object);var index=0,length=path.length;while(object!=null&&index<length){object=object[toKey(path[index++])];}return index&&index==length?object:undefined$1;}/**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */function baseGetAllKeys(object,keysFunc,symbolsFunc){var result=keysFunc(object);return isArray(object)?result:arrayPush(result,symbolsFunc(object));}/**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */function baseGetTag(value){if(value==null){return value===undefined$1?undefinedTag:nullTag;}return symToStringTag&&symToStringTag in Object(value)?getRawTag(value):objectToString(value);}/**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */function baseGt(value,other){return value>other;}/**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */function baseHas(object,key){return object!=null&&hasOwnProperty.call(object,key);}/**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */function baseHasIn(object,key){return object!=null&&key in Object(object);}/**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */function baseInRange(number,start,end){return number>=nativeMin(start,end)&&number<nativeMax(start,end);}/**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */function baseIntersection(arrays,iteratee,comparator){var includes=comparator?arrayIncludesWith:arrayIncludes,length=arrays[0].length,othLength=arrays.length,othIndex=othLength,caches=Array(othLength),maxLength=Infinity,result=[];while(othIndex--){var array=arrays[othIndex];if(othIndex&&iteratee){array=arrayMap(array,baseUnary(iteratee));}maxLength=nativeMin(array.length,maxLength);caches[othIndex]=!comparator&&(iteratee||length>=120&&array.length>=120)?new SetCache(othIndex&&array):undefined$1;}array=arrays[0];var index=-1,seen=caches[0];outer:while(++index<length&&result.length<maxLength){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(!(seen?cacheHas(seen,computed):includes(result,computed,comparator))){othIndex=othLength;while(--othIndex){var cache=caches[othIndex];if(!(cache?cacheHas(cache,computed):includes(arrays[othIndex],computed,comparator))){continue outer;}}if(seen){seen.push(computed);}result.push(value);}}return result;}/**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */function baseInverter(object,setter,iteratee,accumulator){baseForOwn(object,function(value,key,object){setter(accumulator,iteratee(value),key,object);});return accumulator;}/**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */function baseInvoke(object,path,args){path=castPath(path,object);object=parent(object,path);var func=object==null?object:object[toKey(last(path))];return func==null?undefined$1:apply(func,object,args);}/**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */function baseIsArguments(value){return isObjectLike(value)&&baseGetTag(value)==argsTag;}/**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */function baseIsArrayBuffer(value){return isObjectLike(value)&&baseGetTag(value)==arrayBufferTag;}/**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */function baseIsDate(value){return isObjectLike(value)&&baseGetTag(value)==dateTag;}/**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */function baseIsEqual(value,other,bitmask,customizer,stack){if(value===other){return true;}if(value==null||other==null||!isObjectLike(value)&&!isObjectLike(other)){return value!==value&&other!==other;}return baseIsEqualDeep(value,other,bitmask,customizer,baseIsEqual,stack);}/**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */function baseIsEqualDeep(object,other,bitmask,customizer,equalFunc,stack){var objIsArr=isArray(object),othIsArr=isArray(other),objTag=objIsArr?arrayTag:getTag(object),othTag=othIsArr?arrayTag:getTag(other);objTag=objTag==argsTag?objectTag:objTag;othTag=othTag==argsTag?objectTag:othTag;var objIsObj=objTag==objectTag,othIsObj=othTag==objectTag,isSameTag=objTag==othTag;if(isSameTag&&isBuffer(object)){if(!isBuffer(other)){return false;}objIsArr=true;objIsObj=false;}if(isSameTag&&!objIsObj){stack||(stack=new Stack());return objIsArr||isTypedArray(object)?equalArrays(object,other,bitmask,customizer,equalFunc,stack):equalByTag(object,other,objTag,bitmask,customizer,equalFunc,stack);}if(!(bitmask&COMPARE_PARTIAL_FLAG)){var objIsWrapped=objIsObj&&hasOwnProperty.call(object,'__wrapped__'),othIsWrapped=othIsObj&&hasOwnProperty.call(other,'__wrapped__');if(objIsWrapped||othIsWrapped){var objUnwrapped=objIsWrapped?object.value():object,othUnwrapped=othIsWrapped?other.value():other;stack||(stack=new Stack());return equalFunc(objUnwrapped,othUnwrapped,bitmask,customizer,stack);}}if(!isSameTag){return false;}stack||(stack=new Stack());return equalObjects(object,other,bitmask,customizer,equalFunc,stack);}/**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */function baseIsMap(value){return isObjectLike(value)&&getTag(value)==mapTag;}/**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */function baseIsMatch(object,source,matchData,customizer){var index=matchData.length,length=index,noCustomizer=!customizer;if(object==null){return !length;}object=Object(object);while(index--){var data=matchData[index];if(noCustomizer&&data[2]?data[1]!==object[data[0]]:!(data[0]in object)){return false;}}while(++index<length){data=matchData[index];var key=data[0],objValue=object[key],srcValue=data[1];if(noCustomizer&&data[2]){if(objValue===undefined$1&&!(key in object)){return false;}}else {var stack=new Stack();if(customizer){var result=customizer(objValue,srcValue,key,object,source,stack);}if(!(result===undefined$1?baseIsEqual(srcValue,objValue,COMPARE_PARTIAL_FLAG|COMPARE_UNORDERED_FLAG,customizer,stack):result)){return false;}}}return true;}/**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */function baseIsNative(value){if(!isObject(value)||isMasked(value)){return false;}var pattern=isFunction(value)?reIsNative:reIsHostCtor;return pattern.test(toSource(value));}/**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */function baseIsRegExp(value){return isObjectLike(value)&&baseGetTag(value)==regexpTag;}/**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */function baseIsSet(value){return isObjectLike(value)&&getTag(value)==setTag;}/**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */function baseIsTypedArray(value){return isObjectLike(value)&&isLength(value.length)&&!!typedArrayTags[baseGetTag(value)];}/**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */function baseIteratee(value){// Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
// See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
if(typeof value=='function'){return value;}if(value==null){return identity;}if(_typeof(value)=='object'){return isArray(value)?baseMatchesProperty(value[0],value[1]):baseMatches(value);}return property(value);}/**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */function baseKeys(object){if(!isPrototype(object)){return nativeKeys(object);}var result=[];for(var key in Object(object)){if(hasOwnProperty.call(object,key)&&key!='constructor'){result.push(key);}}return result;}/**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */function baseKeysIn(object){if(!isObject(object)){return nativeKeysIn(object);}var isProto=isPrototype(object),result=[];for(var key in object){if(!(key=='constructor'&&(isProto||!hasOwnProperty.call(object,key)))){result.push(key);}}return result;}/**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */function baseLt(value,other){return value<other;}/**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */function baseMap(collection,iteratee){var index=-1,result=isArrayLike(collection)?Array(collection.length):[];baseEach(collection,function(value,key,collection){result[++index]=iteratee(value,key,collection);});return result;}/**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */function baseMatches(source){var matchData=getMatchData(source);if(matchData.length==1&&matchData[0][2]){return matchesStrictComparable(matchData[0][0],matchData[0][1]);}return function(object){return object===source||baseIsMatch(object,source,matchData);};}/**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */function baseMatchesProperty(path,srcValue){if(isKey(path)&&isStrictComparable(srcValue)){return matchesStrictComparable(toKey(path),srcValue);}return function(object){var objValue=get(object,path);return objValue===undefined$1&&objValue===srcValue?hasIn(object,path):baseIsEqual(srcValue,objValue,COMPARE_PARTIAL_FLAG|COMPARE_UNORDERED_FLAG);};}/**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */function baseMerge(object,source,srcIndex,customizer,stack){if(object===source){return;}baseFor(source,function(srcValue,key){stack||(stack=new Stack());if(isObject(srcValue)){baseMergeDeep(object,source,key,srcIndex,baseMerge,customizer,stack);}else {var newValue=customizer?customizer(safeGet(object,key),srcValue,key+'',object,source,stack):undefined$1;if(newValue===undefined$1){newValue=srcValue;}assignMergeValue(object,key,newValue);}},keysIn);}/**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */function baseMergeDeep(object,source,key,srcIndex,mergeFunc,customizer,stack){var objValue=safeGet(object,key),srcValue=safeGet(source,key),stacked=stack.get(srcValue);if(stacked){assignMergeValue(object,key,stacked);return;}var newValue=customizer?customizer(objValue,srcValue,key+'',object,source,stack):undefined$1;var isCommon=newValue===undefined$1;if(isCommon){var isArr=isArray(srcValue),isBuff=!isArr&&isBuffer(srcValue),isTyped=!isArr&&!isBuff&&isTypedArray(srcValue);newValue=srcValue;if(isArr||isBuff||isTyped){if(isArray(objValue)){newValue=objValue;}else if(isArrayLikeObject(objValue)){newValue=copyArray(objValue);}else if(isBuff){isCommon=false;newValue=cloneBuffer(srcValue,true);}else if(isTyped){isCommon=false;newValue=cloneTypedArray(srcValue,true);}else {newValue=[];}}else if(isPlainObject(srcValue)||isArguments(srcValue)){newValue=objValue;if(isArguments(objValue)){newValue=toPlainObject(objValue);}else if(!isObject(objValue)||isFunction(objValue)){newValue=initCloneObject(srcValue);}}else {isCommon=false;}}if(isCommon){// Recursively merge objects and arrays (susceptible to call stack limits).
stack.set(srcValue,newValue);mergeFunc(newValue,srcValue,srcIndex,customizer,stack);stack['delete'](srcValue);}assignMergeValue(object,key,newValue);}/**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */function baseNth(array,n){var length=array.length;if(!length){return;}n+=n<0?length:0;return isIndex(n,length)?array[n]:undefined$1;}/**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */function baseOrderBy(collection,iteratees,orders){if(iteratees.length){iteratees=arrayMap(iteratees,function(iteratee){if(isArray(iteratee)){return function(value){return baseGet(value,iteratee.length===1?iteratee[0]:iteratee);};}return iteratee;});}else {iteratees=[identity];}var index=-1;iteratees=arrayMap(iteratees,baseUnary(getIteratee()));var result=baseMap(collection,function(value,key,collection){var criteria=arrayMap(iteratees,function(iteratee){return iteratee(value);});return {'criteria':criteria,'index':++index,'value':value};});return baseSortBy(result,function(object,other){return compareMultiple(object,other,orders);});}/**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */function basePick(object,paths){return basePickBy(object,paths,function(value,path){return hasIn(object,path);});}/**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */function basePickBy(object,paths,predicate){var index=-1,length=paths.length,result={};while(++index<length){var path=paths[index],value=baseGet(object,path);if(predicate(value,path)){baseSet(result,castPath(path,object),value);}}return result;}/**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */function basePropertyDeep(path){return function(object){return baseGet(object,path);};}/**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */function basePullAll(array,values,iteratee,comparator){var indexOf=comparator?baseIndexOfWith:baseIndexOf,index=-1,length=values.length,seen=array;if(array===values){values=copyArray(values);}if(iteratee){seen=arrayMap(array,baseUnary(iteratee));}while(++index<length){var fromIndex=0,value=values[index],computed=iteratee?iteratee(value):value;while((fromIndex=indexOf(seen,computed,fromIndex,comparator))>-1){if(seen!==array){splice.call(seen,fromIndex,1);}splice.call(array,fromIndex,1);}}return array;}/**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */function basePullAt(array,indexes){var length=array?indexes.length:0,lastIndex=length-1;while(length--){var index=indexes[length];if(length==lastIndex||index!==previous){var previous=index;if(isIndex(index)){splice.call(array,index,1);}else {baseUnset(array,index);}}}return array;}/**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */function baseRandom(lower,upper){return lower+nativeFloor(nativeRandom()*(upper-lower+1));}/**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */function baseRange(start,end,step,fromRight){var index=-1,length=nativeMax(nativeCeil((end-start)/(step||1)),0),result=Array(length);while(length--){result[fromRight?length:++index]=start;start+=step;}return result;}/**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */function baseRepeat(string,n){var result='';if(!string||n<1||n>MAX_SAFE_INTEGER){return result;}// Leverage the exponentiation by squaring algorithm for a faster repeat.
// See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
do{if(n%2){result+=string;}n=nativeFloor(n/2);if(n){string+=string;}}while(n);return result;}/**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */function baseRest(func,start){return setToString(overRest(func,start,identity),func+'');}/**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */function baseSample(collection){return arraySample(values(collection));}/**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */function baseSampleSize(collection,n){var array=values(collection);return shuffleSelf(array,baseClamp(n,0,array.length));}/**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */function baseSet(object,path,value,customizer){if(!isObject(object)){return object;}path=castPath(path,object);var index=-1,length=path.length,lastIndex=length-1,nested=object;while(nested!=null&&++index<length){var key=toKey(path[index]),newValue=value;if(key==='__proto__'||key==='constructor'||key==='prototype'){return object;}if(index!=lastIndex){var objValue=nested[key];newValue=customizer?customizer(objValue,key,nested):undefined$1;if(newValue===undefined$1){newValue=isObject(objValue)?objValue:isIndex(path[index+1])?[]:{};}}assignValue(nested,key,newValue);nested=nested[key];}return object;}/**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */var baseSetData=!metaMap?identity:function(func,data){metaMap.set(func,data);return func;};/**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */var baseSetToString=!defineProperty?identity:function(func,string){return defineProperty(func,'toString',{'configurable':true,'enumerable':false,'value':constant(string),'writable':true});};/**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */function baseShuffle(collection){return shuffleSelf(values(collection));}/**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */function baseSlice(array,start,end){var index=-1,length=array.length;if(start<0){start=-start>length?0:length+start;}end=end>length?length:end;if(end<0){end+=length;}length=start>end?0:end-start>>>0;start>>>=0;var result=Array(length);while(++index<length){result[index]=array[index+start];}return result;}/**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */function baseSome(collection,predicate){var result;baseEach(collection,function(value,index,collection){result=predicate(value,index,collection);return !result;});return !!result;}/**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */function baseSortedIndex(array,value,retHighest){var low=0,high=array==null?low:array.length;if(typeof value=='number'&&value===value&&high<=HALF_MAX_ARRAY_LENGTH){while(low<high){var mid=low+high>>>1,computed=array[mid];if(computed!==null&&!isSymbol(computed)&&(retHighest?computed<=value:computed<value)){low=mid+1;}else {high=mid;}}return high;}return baseSortedIndexBy(array,value,identity,retHighest);}/**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */function baseSortedIndexBy(array,value,iteratee,retHighest){var low=0,high=array==null?0:array.length;if(high===0){return 0;}value=iteratee(value);var valIsNaN=value!==value,valIsNull=value===null,valIsSymbol=isSymbol(value),valIsUndefined=value===undefined$1;while(low<high){var mid=nativeFloor((low+high)/2),computed=iteratee(array[mid]),othIsDefined=computed!==undefined$1,othIsNull=computed===null,othIsReflexive=computed===computed,othIsSymbol=isSymbol(computed);if(valIsNaN){var setLow=retHighest||othIsReflexive;}else if(valIsUndefined){setLow=othIsReflexive&&(retHighest||othIsDefined);}else if(valIsNull){setLow=othIsReflexive&&othIsDefined&&(retHighest||!othIsNull);}else if(valIsSymbol){setLow=othIsReflexive&&othIsDefined&&!othIsNull&&(retHighest||!othIsSymbol);}else if(othIsNull||othIsSymbol){setLow=false;}else {setLow=retHighest?computed<=value:computed<value;}if(setLow){low=mid+1;}else {high=mid;}}return nativeMin(high,MAX_ARRAY_INDEX);}/**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */function baseSortedUniq(array,iteratee){var index=-1,length=array.length,resIndex=0,result=[];while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;if(!index||!eq(computed,seen)){var seen=computed;result[resIndex++]=value===0?0:value;}}return result;}/**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */function baseToNumber(value){if(typeof value=='number'){return value;}if(isSymbol(value)){return NAN;}return +value;}/**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */function baseToString(value){// Exit early for strings to avoid a performance hit in some environments.
if(typeof value=='string'){return value;}if(isArray(value)){// Recursively convert values (susceptible to call stack limits).
return arrayMap(value,baseToString)+'';}if(isSymbol(value)){return symbolToString?symbolToString.call(value):'';}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}/**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */function baseUniq(array,iteratee,comparator){var index=-1,includes=arrayIncludes,length=array.length,isCommon=true,result=[],seen=result;if(comparator){isCommon=false;includes=arrayIncludesWith;}else if(length>=LARGE_ARRAY_SIZE){var set=iteratee?null:createSet(array);if(set){return setToArray(set);}isCommon=false;includes=cacheHas;seen=new SetCache();}else {seen=iteratee?[]:result;}outer:while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(isCommon&&computed===computed){var seenIndex=seen.length;while(seenIndex--){if(seen[seenIndex]===computed){continue outer;}}if(iteratee){seen.push(computed);}result.push(value);}else if(!includes(seen,computed,comparator)){if(seen!==result){seen.push(computed);}result.push(value);}}return result;}/**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */function baseUnset(object,path){path=castPath(path,object);object=parent(object,path);return object==null||delete object[toKey(last(path))];}/**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */function baseUpdate(object,path,updater,customizer){return baseSet(object,path,updater(baseGet(object,path)),customizer);}/**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */function baseWhile(array,predicate,isDrop,fromRight){var length=array.length,index=fromRight?length:-1;while((fromRight?index--:++index<length)&&predicate(array[index],index,array)){}return isDrop?baseSlice(array,fromRight?0:index,fromRight?index+1:length):baseSlice(array,fromRight?index+1:0,fromRight?length:index);}/**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */function baseWrapperValue(value,actions){var result=value;if(result instanceof LazyWrapper){result=result.value();}return arrayReduce(actions,function(result,action){return action.func.apply(action.thisArg,arrayPush([result],action.args));},result);}/**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */function baseXor(arrays,iteratee,comparator){var length=arrays.length;if(length<2){return length?baseUniq(arrays[0]):[];}var index=-1,result=Array(length);while(++index<length){var array=arrays[index],othIndex=-1;while(++othIndex<length){if(othIndex!=index){result[index]=baseDifference(result[index]||array,arrays[othIndex],iteratee,comparator);}}}return baseUniq(baseFlatten(result,1),iteratee,comparator);}/**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */function baseZipObject(props,values,assignFunc){var index=-1,length=props.length,valsLength=values.length,result={};while(++index<length){var value=index<valsLength?values[index]:undefined$1;assignFunc(result,props[index],value);}return result;}/**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */function castArrayLikeObject(value){return isArrayLikeObject(value)?value:[];}/**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */function castFunction(value){return typeof value=='function'?value:identity;}/**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */function castPath(value,object){if(isArray(value)){return value;}return isKey(value,object)?[value]:stringToPath(toString(value));}/**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */var castRest=baseRest;/**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */function castSlice(array,start,end){var length=array.length;end=end===undefined$1?length:end;return !start&&end>=length?array:baseSlice(array,start,end);}/**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */var clearTimeout=ctxClearTimeout||function(id){return root.clearTimeout(id);};/**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */function cloneBuffer(buffer,isDeep){if(isDeep){return buffer.slice();}var length=buffer.length,result=allocUnsafe?allocUnsafe(length):new buffer.constructor(length);buffer.copy(result);return result;}/**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */function cloneArrayBuffer(arrayBuffer){var result=new arrayBuffer.constructor(arrayBuffer.byteLength);new Uint8Array(result).set(new Uint8Array(arrayBuffer));return result;}/**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */function cloneDataView(dataView,isDeep){var buffer=isDeep?cloneArrayBuffer(dataView.buffer):dataView.buffer;return new dataView.constructor(buffer,dataView.byteOffset,dataView.byteLength);}/**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */function cloneRegExp(regexp){var result=new regexp.constructor(regexp.source,reFlags.exec(regexp));result.lastIndex=regexp.lastIndex;return result;}/**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */function cloneSymbol(symbol){return symbolValueOf?Object(symbolValueOf.call(symbol)):{};}/**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */function cloneTypedArray(typedArray,isDeep){var buffer=isDeep?cloneArrayBuffer(typedArray.buffer):typedArray.buffer;return new typedArray.constructor(buffer,typedArray.byteOffset,typedArray.length);}/**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */function compareAscending(value,other){if(value!==other){var valIsDefined=value!==undefined$1,valIsNull=value===null,valIsReflexive=value===value,valIsSymbol=isSymbol(value);var othIsDefined=other!==undefined$1,othIsNull=other===null,othIsReflexive=other===other,othIsSymbol=isSymbol(other);if(!othIsNull&&!othIsSymbol&&!valIsSymbol&&value>other||valIsSymbol&&othIsDefined&&othIsReflexive&&!othIsNull&&!othIsSymbol||valIsNull&&othIsDefined&&othIsReflexive||!valIsDefined&&othIsReflexive||!valIsReflexive){return 1;}if(!valIsNull&&!valIsSymbol&&!othIsSymbol&&value<other||othIsSymbol&&valIsDefined&&valIsReflexive&&!valIsNull&&!valIsSymbol||othIsNull&&valIsDefined&&valIsReflexive||!othIsDefined&&valIsReflexive||!othIsReflexive){return -1;}}return 0;}/**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */function compareMultiple(object,other,orders){var index=-1,objCriteria=object.criteria,othCriteria=other.criteria,length=objCriteria.length,ordersLength=orders.length;while(++index<length){var result=compareAscending(objCriteria[index],othCriteria[index]);if(result){if(index>=ordersLength){return result;}var order=orders[index];return result*(order=='desc'?-1:1);}}// Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
// that causes it, under certain circumstances, to provide the same value for
// `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
// for more details.
//
// This also ensures a stable sort in V8 and other engines.
// See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
return object.index-other.index;}/**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */function composeArgs(args,partials,holders,isCurried){var argsIndex=-1,argsLength=args.length,holdersLength=holders.length,leftIndex=-1,leftLength=partials.length,rangeLength=nativeMax(argsLength-holdersLength,0),result=Array(leftLength+rangeLength),isUncurried=!isCurried;while(++leftIndex<leftLength){result[leftIndex]=partials[leftIndex];}while(++argsIndex<holdersLength){if(isUncurried||argsIndex<argsLength){result[holders[argsIndex]]=args[argsIndex];}}while(rangeLength--){result[leftIndex++]=args[argsIndex++];}return result;}/**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */function composeArgsRight(args,partials,holders,isCurried){var argsIndex=-1,argsLength=args.length,holdersIndex=-1,holdersLength=holders.length,rightIndex=-1,rightLength=partials.length,rangeLength=nativeMax(argsLength-holdersLength,0),result=Array(rangeLength+rightLength),isUncurried=!isCurried;while(++argsIndex<rangeLength){result[argsIndex]=args[argsIndex];}var offset=argsIndex;while(++rightIndex<rightLength){result[offset+rightIndex]=partials[rightIndex];}while(++holdersIndex<holdersLength){if(isUncurried||argsIndex<argsLength){result[offset+holders[holdersIndex]]=args[argsIndex++];}}return result;}/**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */function copyArray(source,array){var index=-1,length=source.length;array||(array=Array(length));while(++index<length){array[index]=source[index];}return array;}/**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */function copyObject(source,props,object,customizer){var isNew=!object;object||(object={});var index=-1,length=props.length;while(++index<length){var key=props[index];var newValue=customizer?customizer(object[key],source[key],key,object,source):undefined$1;if(newValue===undefined$1){newValue=source[key];}if(isNew){baseAssignValue(object,key,newValue);}else {assignValue(object,key,newValue);}}return object;}/**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */function copySymbols(source,object){return copyObject(source,getSymbols(source),object);}/**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */function copySymbolsIn(source,object){return copyObject(source,getSymbolsIn(source),object);}/**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */function createAggregator(setter,initializer){return function(collection,iteratee){var func=isArray(collection)?arrayAggregator:baseAggregator,accumulator=initializer?initializer():{};return func(collection,setter,getIteratee(iteratee,2),accumulator);};}/**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */function createAssigner(assigner){return baseRest(function(object,sources){var index=-1,length=sources.length,customizer=length>1?sources[length-1]:undefined$1,guard=length>2?sources[2]:undefined$1;customizer=assigner.length>3&&typeof customizer=='function'?(length--,customizer):undefined$1;if(guard&&isIterateeCall(sources[0],sources[1],guard)){customizer=length<3?undefined$1:customizer;length=1;}object=Object(object);while(++index<length){var source=sources[index];if(source){assigner(object,source,index,customizer);}}return object;});}/**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */function createBaseEach(eachFunc,fromRight){return function(collection,iteratee){if(collection==null){return collection;}if(!isArrayLike(collection)){return eachFunc(collection,iteratee);}var length=collection.length,index=fromRight?length:-1,iterable=Object(collection);while(fromRight?index--:++index<length){if(iteratee(iterable[index],index,iterable)===false){break;}}return collection;};}/**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */function createBaseFor(fromRight){return function(object,iteratee,keysFunc){var index=-1,iterable=Object(object),props=keysFunc(object),length=props.length;while(length--){var key=props[fromRight?length:++index];if(iteratee(iterable[key],key,iterable)===false){break;}}return object;};}/**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createBind(func,bitmask,thisArg){var isBind=bitmask&WRAP_BIND_FLAG,Ctor=createCtor(func);function wrapper(){var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;return fn.apply(isBind?thisArg:this,arguments);}return wrapper;}/**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */function createCaseFirst(methodName){return function(string){string=toString(string);var strSymbols=hasUnicode(string)?stringToArray(string):undefined$1;var chr=strSymbols?strSymbols[0]:string.charAt(0);var trailing=strSymbols?castSlice(strSymbols,1).join(''):string.slice(1);return chr[methodName]()+trailing;};}/**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */function createCompounder(callback){return function(string){return arrayReduce(words(deburr(string).replace(reApos,'')),callback,'');};}/**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */function createCtor(Ctor){return function(){// Use a `switch` statement to work with class constructors. See
// http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
// for more details.
var args=arguments;switch(args.length){case 0:return new Ctor();case 1:return new Ctor(args[0]);case 2:return new Ctor(args[0],args[1]);case 3:return new Ctor(args[0],args[1],args[2]);case 4:return new Ctor(args[0],args[1],args[2],args[3]);case 5:return new Ctor(args[0],args[1],args[2],args[3],args[4]);case 6:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5]);case 7:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5],args[6]);}var thisBinding=baseCreate(Ctor.prototype),result=Ctor.apply(thisBinding,args);// Mimic the constructor's `return` behavior.
// See https://es5.github.io/#x13.2.2 for more details.
return isObject(result)?result:thisBinding;};}/**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createCurry(func,bitmask,arity){var Ctor=createCtor(func);function wrapper(){var length=arguments.length,args=Array(length),index=length,placeholder=getHolder(wrapper);while(index--){args[index]=arguments[index];}var holders=length<3&&args[0]!==placeholder&&args[length-1]!==placeholder?[]:replaceHolders(args,placeholder);length-=holders.length;if(length<arity){return createRecurry(func,bitmask,createHybrid,wrapper.placeholder,undefined$1,args,holders,undefined$1,undefined$1,arity-length);}var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;return apply(fn,this,args);}return wrapper;}/**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */function createFind(findIndexFunc){return function(collection,predicate,fromIndex){var iterable=Object(collection);if(!isArrayLike(collection)){var iteratee=getIteratee(predicate,3);collection=keys(collection);predicate=function predicate(key){return iteratee(iterable[key],key,iterable);};}var index=findIndexFunc(collection,predicate,fromIndex);return index>-1?iterable[iteratee?collection[index]:index]:undefined$1;};}/**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */function createFlow(fromRight){return flatRest(function(funcs){var length=funcs.length,index=length,prereq=LodashWrapper.prototype.thru;if(fromRight){funcs.reverse();}while(index--){var func=funcs[index];if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}if(prereq&&!wrapper&&getFuncName(func)=='wrapper'){var wrapper=new LodashWrapper([],true);}}index=wrapper?index:length;while(++index<length){func=funcs[index];var funcName=getFuncName(func),data=funcName=='wrapper'?getData(func):undefined$1;if(data&&isLaziable(data[0])&&data[1]==(WRAP_ARY_FLAG|WRAP_CURRY_FLAG|WRAP_PARTIAL_FLAG|WRAP_REARG_FLAG)&&!data[4].length&&data[9]==1){wrapper=wrapper[getFuncName(data[0])].apply(wrapper,data[3]);}else {wrapper=func.length==1&&isLaziable(func)?wrapper[funcName]():wrapper.thru(func);}}return function(){var args=arguments,value=args[0];if(wrapper&&args.length==1&&isArray(value)){return wrapper.plant(value).value();}var index=0,result=length?funcs[index].apply(this,args):value;while(++index<length){result=funcs[index].call(this,result);}return result;};});}/**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createHybrid(func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity){var isAry=bitmask&WRAP_ARY_FLAG,isBind=bitmask&WRAP_BIND_FLAG,isBindKey=bitmask&WRAP_BIND_KEY_FLAG,isCurried=bitmask&(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG),isFlip=bitmask&WRAP_FLIP_FLAG,Ctor=isBindKey?undefined$1:createCtor(func);function wrapper(){var length=arguments.length,args=Array(length),index=length;while(index--){args[index]=arguments[index];}if(isCurried){var placeholder=getHolder(wrapper),holdersCount=countHolders(args,placeholder);}if(partials){args=composeArgs(args,partials,holders,isCurried);}if(partialsRight){args=composeArgsRight(args,partialsRight,holdersRight,isCurried);}length-=holdersCount;if(isCurried&&length<arity){var newHolders=replaceHolders(args,placeholder);return createRecurry(func,bitmask,createHybrid,wrapper.placeholder,thisArg,args,newHolders,argPos,ary,arity-length);}var thisBinding=isBind?thisArg:this,fn=isBindKey?thisBinding[func]:func;length=args.length;if(argPos){args=reorder(args,argPos);}else if(isFlip&&length>1){args.reverse();}if(isAry&&ary<length){args.length=ary;}if(this&&this!==root&&this instanceof wrapper){fn=Ctor||createCtor(fn);}return fn.apply(thisBinding,args);}return wrapper;}/**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */function createInverter(setter,toIteratee){return function(object,iteratee){return baseInverter(object,setter,toIteratee(iteratee),{});};}/**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */function createMathOperation(operator,defaultValue){return function(value,other){var result;if(value===undefined$1&&other===undefined$1){return defaultValue;}if(value!==undefined$1){result=value;}if(other!==undefined$1){if(result===undefined$1){return other;}if(typeof value=='string'||typeof other=='string'){value=baseToString(value);other=baseToString(other);}else {value=baseToNumber(value);other=baseToNumber(other);}result=operator(value,other);}return result;};}/**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */function createOver(arrayFunc){return flatRest(function(iteratees){iteratees=arrayMap(iteratees,baseUnary(getIteratee()));return baseRest(function(args){var thisArg=this;return arrayFunc(iteratees,function(iteratee){return apply(iteratee,thisArg,args);});});});}/**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */function createPadding(length,chars){chars=chars===undefined$1?' ':baseToString(chars);var charsLength=chars.length;if(charsLength<2){return charsLength?baseRepeat(chars,length):chars;}var result=baseRepeat(chars,nativeCeil(length/stringSize(chars)));return hasUnicode(chars)?castSlice(stringToArray(result),0,length).join(''):result.slice(0,length);}/**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */function createPartial(func,bitmask,thisArg,partials){var isBind=bitmask&WRAP_BIND_FLAG,Ctor=createCtor(func);function wrapper(){var argsIndex=-1,argsLength=arguments.length,leftIndex=-1,leftLength=partials.length,args=Array(leftLength+argsLength),fn=this&&this!==root&&this instanceof wrapper?Ctor:func;while(++leftIndex<leftLength){args[leftIndex]=partials[leftIndex];}while(argsLength--){args[leftIndex++]=arguments[++argsIndex];}return apply(fn,isBind?thisArg:this,args);}return wrapper;}/**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */function createRange(fromRight){return function(start,end,step){if(step&&typeof step!='number'&&isIterateeCall(start,end,step)){end=step=undefined$1;}// Ensure the sign of `-0` is preserved.
start=toFinite(start);if(end===undefined$1){end=start;start=0;}else {end=toFinite(end);}step=step===undefined$1?start<end?1:-1:toFinite(step);return baseRange(start,end,step,fromRight);};}/**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */function createRelationalOperation(operator){return function(value,other){if(!(typeof value=='string'&&typeof other=='string')){value=toNumber(value);other=toNumber(other);}return operator(value,other);};}/**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createRecurry(func,bitmask,wrapFunc,placeholder,thisArg,partials,holders,argPos,ary,arity){var isCurry=bitmask&WRAP_CURRY_FLAG,newHolders=isCurry?holders:undefined$1,newHoldersRight=isCurry?undefined$1:holders,newPartials=isCurry?partials:undefined$1,newPartialsRight=isCurry?undefined$1:partials;bitmask|=isCurry?WRAP_PARTIAL_FLAG:WRAP_PARTIAL_RIGHT_FLAG;bitmask&=~(isCurry?WRAP_PARTIAL_RIGHT_FLAG:WRAP_PARTIAL_FLAG);if(!(bitmask&WRAP_CURRY_BOUND_FLAG)){bitmask&=~(WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG);}var newData=[func,bitmask,thisArg,newPartials,newHolders,newPartialsRight,newHoldersRight,argPos,ary,arity];var result=wrapFunc.apply(undefined$1,newData);if(isLaziable(func)){setData(result,newData);}result.placeholder=placeholder;return setWrapToString(result,func,bitmask);}/**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */function createRound(methodName){var func=Math[methodName];return function(number,precision){number=toNumber(number);precision=precision==null?0:nativeMin(toInteger(precision),292);if(precision&&nativeIsFinite(number)){// Shift with exponential notation to avoid floating-point issues.
// See [MDN](https://mdn.io/round#Examples) for more details.
var pair=(toString(number)+'e').split('e'),value=func(pair[0]+'e'+(+pair[1]+precision));pair=(toString(value)+'e').split('e');return +(pair[0]+'e'+(+pair[1]-precision));}return func(number);};}/**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */var createSet=!(Set&&1/setToArray(new Set([,-0]))[1]==INFINITY)?noop:function(values){return new Set(values);};/**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */function createToPairs(keysFunc){return function(object){var tag=getTag(object);if(tag==mapTag){return mapToArray(object);}if(tag==setTag){return setToPairs(object);}return baseToPairs(object,keysFunc(object));};}/**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createWrap(func,bitmask,thisArg,partials,holders,argPos,ary,arity){var isBindKey=bitmask&WRAP_BIND_KEY_FLAG;if(!isBindKey&&typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}var length=partials?partials.length:0;if(!length){bitmask&=~(WRAP_PARTIAL_FLAG|WRAP_PARTIAL_RIGHT_FLAG);partials=holders=undefined$1;}ary=ary===undefined$1?ary:nativeMax(toInteger(ary),0);arity=arity===undefined$1?arity:toInteger(arity);length-=holders?holders.length:0;if(bitmask&WRAP_PARTIAL_RIGHT_FLAG){var partialsRight=partials,holdersRight=holders;partials=holders=undefined$1;}var data=isBindKey?undefined$1:getData(func);var newData=[func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity];if(data){mergeData(newData,data);}func=newData[0];bitmask=newData[1];thisArg=newData[2];partials=newData[3];holders=newData[4];arity=newData[9]=newData[9]===undefined$1?isBindKey?0:func.length:nativeMax(newData[9]-length,0);if(!arity&&bitmask&(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG)){bitmask&=~(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG);}if(!bitmask||bitmask==WRAP_BIND_FLAG){var result=createBind(func,bitmask,thisArg);}else if(bitmask==WRAP_CURRY_FLAG||bitmask==WRAP_CURRY_RIGHT_FLAG){result=createCurry(func,bitmask,arity);}else if((bitmask==WRAP_PARTIAL_FLAG||bitmask==(WRAP_BIND_FLAG|WRAP_PARTIAL_FLAG))&&!holders.length){result=createPartial(func,bitmask,thisArg,partials);}else {result=createHybrid.apply(undefined$1,newData);}var setter=data?baseSetData:setData;return setWrapToString(setter(result,newData),func,bitmask);}/**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */function customDefaultsAssignIn(objValue,srcValue,key,object){if(objValue===undefined$1||eq(objValue,objectProto[key])&&!hasOwnProperty.call(object,key)){return srcValue;}return objValue;}/**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */function customDefaultsMerge(objValue,srcValue,key,object,source,stack){if(isObject(objValue)&&isObject(srcValue)){// Recursively merge objects and arrays (susceptible to call stack limits).
stack.set(srcValue,objValue);baseMerge(objValue,srcValue,undefined$1,customDefaultsMerge,stack);stack['delete'](srcValue);}return objValue;}/**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */function customOmitClone(value){return isPlainObject(value)?undefined$1:value;}/**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */function equalArrays(array,other,bitmask,customizer,equalFunc,stack){var isPartial=bitmask&COMPARE_PARTIAL_FLAG,arrLength=array.length,othLength=other.length;if(arrLength!=othLength&&!(isPartial&&othLength>arrLength)){return false;}// Check that cyclic values are equal.
var arrStacked=stack.get(array);var othStacked=stack.get(other);if(arrStacked&&othStacked){return arrStacked==other&&othStacked==array;}var index=-1,result=true,seen=bitmask&COMPARE_UNORDERED_FLAG?new SetCache():undefined$1;stack.set(array,other);stack.set(other,array);// Ignore non-index properties.
while(++index<arrLength){var arrValue=array[index],othValue=other[index];if(customizer){var compared=isPartial?customizer(othValue,arrValue,index,other,array,stack):customizer(arrValue,othValue,index,array,other,stack);}if(compared!==undefined$1){if(compared){continue;}result=false;break;}// Recursively compare arrays (susceptible to call stack limits).
if(seen){if(!arraySome(other,function(othValue,othIndex){if(!cacheHas(seen,othIndex)&&(arrValue===othValue||equalFunc(arrValue,othValue,bitmask,customizer,stack))){return seen.push(othIndex);}})){result=false;break;}}else if(!(arrValue===othValue||equalFunc(arrValue,othValue,bitmask,customizer,stack))){result=false;break;}}stack['delete'](array);stack['delete'](other);return result;}/**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */function equalByTag(object,other,tag,bitmask,customizer,equalFunc,stack){switch(tag){case dataViewTag:if(object.byteLength!=other.byteLength||object.byteOffset!=other.byteOffset){return false;}object=object.buffer;other=other.buffer;case arrayBufferTag:if(object.byteLength!=other.byteLength||!equalFunc(new Uint8Array(object),new Uint8Array(other))){return false;}return true;case boolTag:case dateTag:case numberTag:// Coerce booleans to `1` or `0` and dates to milliseconds.
// Invalid dates are coerced to `NaN`.
return eq(+object,+other);case errorTag:return object.name==other.name&&object.message==other.message;case regexpTag:case stringTag:// Coerce regexes to strings and treat strings, primitives and objects,
// as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
// for more details.
return object==other+'';case mapTag:var convert=mapToArray;case setTag:var isPartial=bitmask&COMPARE_PARTIAL_FLAG;convert||(convert=setToArray);if(object.size!=other.size&&!isPartial){return false;}// Assume cyclic values are equal.
var stacked=stack.get(object);if(stacked){return stacked==other;}bitmask|=COMPARE_UNORDERED_FLAG;// Recursively compare objects (susceptible to call stack limits).
stack.set(object,other);var result=equalArrays(convert(object),convert(other),bitmask,customizer,equalFunc,stack);stack['delete'](object);return result;case symbolTag:if(symbolValueOf){return symbolValueOf.call(object)==symbolValueOf.call(other);}}return false;}/**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */function equalObjects(object,other,bitmask,customizer,equalFunc,stack){var isPartial=bitmask&COMPARE_PARTIAL_FLAG,objProps=getAllKeys(object),objLength=objProps.length,othProps=getAllKeys(other),othLength=othProps.length;if(objLength!=othLength&&!isPartial){return false;}var index=objLength;while(index--){var key=objProps[index];if(!(isPartial?key in other:hasOwnProperty.call(other,key))){return false;}}// Check that cyclic values are equal.
var objStacked=stack.get(object);var othStacked=stack.get(other);if(objStacked&&othStacked){return objStacked==other&&othStacked==object;}var result=true;stack.set(object,other);stack.set(other,object);var skipCtor=isPartial;while(++index<objLength){key=objProps[index];var objValue=object[key],othValue=other[key];if(customizer){var compared=isPartial?customizer(othValue,objValue,key,other,object,stack):customizer(objValue,othValue,key,object,other,stack);}// Recursively compare objects (susceptible to call stack limits).
if(!(compared===undefined$1?objValue===othValue||equalFunc(objValue,othValue,bitmask,customizer,stack):compared)){result=false;break;}skipCtor||(skipCtor=key=='constructor');}if(result&&!skipCtor){var objCtor=object.constructor,othCtor=other.constructor;// Non `Object` object instances with different constructors are not equal.
if(objCtor!=othCtor&&'constructor'in object&&'constructor'in other&&!(typeof objCtor=='function'&&objCtor instanceof objCtor&&typeof othCtor=='function'&&othCtor instanceof othCtor)){result=false;}}stack['delete'](object);stack['delete'](other);return result;}/**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */function flatRest(func){return setToString(overRest(func,undefined$1,flatten),func+'');}/**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */function getAllKeys(object){return baseGetAllKeys(object,keys,getSymbols);}/**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */function getAllKeysIn(object){return baseGetAllKeys(object,keysIn,getSymbolsIn);}/**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */var getData=!metaMap?noop:function(func){return metaMap.get(func);};/**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */function getFuncName(func){var result=func.name+'',array=realNames[result],length=hasOwnProperty.call(realNames,result)?array.length:0;while(length--){var data=array[length],otherFunc=data.func;if(otherFunc==null||otherFunc==func){return data.name;}}return result;}/**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */function getHolder(func){var object=hasOwnProperty.call(lodash,'placeholder')?lodash:func;return object.placeholder;}/**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */function getIteratee(){var result=lodash.iteratee||iteratee;result=result===iteratee?baseIteratee:result;return arguments.length?result(arguments[0],arguments[1]):result;}/**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */function getMapData(map,key){var data=map.__data__;return isKeyable(key)?data[typeof key=='string'?'string':'hash']:data.map;}/**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */function getMatchData(object){var result=keys(object),length=result.length;while(length--){var key=result[length],value=object[key];result[length]=[key,value,isStrictComparable(value)];}return result;}/**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */function getNative(object,key){var value=getValue(object,key);return baseIsNative(value)?value:undefined$1;}/**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */function getRawTag(value){var isOwn=hasOwnProperty.call(value,symToStringTag),tag=value[symToStringTag];try{value[symToStringTag]=undefined$1;var unmasked=true;}catch(e){}var result=nativeObjectToString.call(value);if(unmasked){if(isOwn){value[symToStringTag]=tag;}else {delete value[symToStringTag];}}return result;}/**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */var getSymbols=!nativeGetSymbols?stubArray:function(object){if(object==null){return [];}object=Object(object);return arrayFilter(nativeGetSymbols(object),function(symbol){return propertyIsEnumerable.call(object,symbol);});};/**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */var getSymbolsIn=!nativeGetSymbols?stubArray:function(object){var result=[];while(object){arrayPush(result,getSymbols(object));object=getPrototype(object);}return result;};/**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */var getTag=baseGetTag;// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if(DataView&&getTag(new DataView(new ArrayBuffer(1)))!=dataViewTag||Map&&getTag(new Map())!=mapTag||Promise&&getTag(Promise.resolve())!=promiseTag||Set&&getTag(new Set())!=setTag||WeakMap&&getTag(new WeakMap())!=weakMapTag){getTag=function getTag(value){var result=baseGetTag(value),Ctor=result==objectTag?value.constructor:undefined$1,ctorString=Ctor?toSource(Ctor):'';if(ctorString){switch(ctorString){case dataViewCtorString:return dataViewTag;case mapCtorString:return mapTag;case promiseCtorString:return promiseTag;case setCtorString:return setTag;case weakMapCtorString:return weakMapTag;}}return result;};}/**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */function getView(start,end,transforms){var index=-1,length=transforms.length;while(++index<length){var data=transforms[index],size=data.size;switch(data.type){case'drop':start+=size;break;case'dropRight':end-=size;break;case'take':end=nativeMin(end,start+size);break;case'takeRight':start=nativeMax(start,end-size);break;}}return {'start':start,'end':end};}/**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */function getWrapDetails(source){var match=source.match(reWrapDetails);return match?match[1].split(reSplitDetails):[];}/**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */function hasPath(object,path,hasFunc){path=castPath(path,object);var index=-1,length=path.length,result=false;while(++index<length){var key=toKey(path[index]);if(!(result=object!=null&&hasFunc(object,key))){break;}object=object[key];}if(result||++index!=length){return result;}length=object==null?0:object.length;return !!length&&isLength(length)&&isIndex(key,length)&&(isArray(object)||isArguments(object));}/**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */function initCloneArray(array){var length=array.length,result=new array.constructor(length);// Add properties assigned by `RegExp#exec`.
if(length&&typeof array[0]=='string'&&hasOwnProperty.call(array,'index')){result.index=array.index;result.input=array.input;}return result;}/**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */function initCloneObject(object){return typeof object.constructor=='function'&&!isPrototype(object)?baseCreate(getPrototype(object)):{};}/**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */function initCloneByTag(object,tag,isDeep){var Ctor=object.constructor;switch(tag){case arrayBufferTag:return cloneArrayBuffer(object);case boolTag:case dateTag:return new Ctor(+object);case dataViewTag:return cloneDataView(object,isDeep);case float32Tag:case float64Tag:case int8Tag:case int16Tag:case int32Tag:case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:return cloneTypedArray(object,isDeep);case mapTag:return new Ctor();case numberTag:case stringTag:return new Ctor(object);case regexpTag:return cloneRegExp(object);case setTag:return new Ctor();case symbolTag:return cloneSymbol(object);}}/**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */function insertWrapDetails(source,details){var length=details.length;if(!length){return source;}var lastIndex=length-1;details[lastIndex]=(length>1?'& ':'')+details[lastIndex];details=details.join(length>2?', ':' ');return source.replace(reWrapComment,'{\n/* [wrapped with '+details+'] */\n');}/**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */function isFlattenable(value){return isArray(value)||isArguments(value)||!!(spreadableSymbol&&value&&value[spreadableSymbol]);}/**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */function isIndex(value,length){var type=_typeof(value);length=length==null?MAX_SAFE_INTEGER:length;return !!length&&(type=='number'||type!='symbol'&&reIsUint.test(value))&&value>-1&&value%1==0&&value<length;}/**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */function isIterateeCall(value,index,object){if(!isObject(object)){return false;}var type=_typeof(index);if(type=='number'?isArrayLike(object)&&isIndex(index,object.length):type=='string'&&index in object){return eq(object[index],value);}return false;}/**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */function isKey(value,object){if(isArray(value)){return false;}var type=_typeof(value);if(type=='number'||type=='symbol'||type=='boolean'||value==null||isSymbol(value)){return true;}return reIsPlainProp.test(value)||!reIsDeepProp.test(value)||object!=null&&value in Object(object);}/**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */function isKeyable(value){var type=_typeof(value);return type=='string'||type=='number'||type=='symbol'||type=='boolean'?value!=='__proto__':value===null;}/**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */function isLaziable(func){var funcName=getFuncName(func),other=lodash[funcName];if(typeof other!='function'||!(funcName in LazyWrapper.prototype)){return false;}if(func===other){return true;}var data=getData(other);return !!data&&func===data[0];}/**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */function isMasked(func){return !!maskSrcKey&&maskSrcKey in func;}/**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */var isMaskable=coreJsData?isFunction:stubFalse;/**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */function isPrototype(value){var Ctor=value&&value.constructor,proto=typeof Ctor=='function'&&Ctor.prototype||objectProto;return value===proto;}/**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */function isStrictComparable(value){return value===value&&!isObject(value);}/**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */function matchesStrictComparable(key,srcValue){return function(object){if(object==null){return false;}return object[key]===srcValue&&(srcValue!==undefined$1||key in Object(object));};}/**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */function memoizeCapped(func){var result=memoize(func,function(key){if(cache.size===MAX_MEMOIZE_SIZE){cache.clear();}return key;});var cache=result.cache;return result;}/**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */function mergeData(data,source){var bitmask=data[1],srcBitmask=source[1],newBitmask=bitmask|srcBitmask,isCommon=newBitmask<(WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG|WRAP_ARY_FLAG);var isCombo=srcBitmask==WRAP_ARY_FLAG&&bitmask==WRAP_CURRY_FLAG||srcBitmask==WRAP_ARY_FLAG&&bitmask==WRAP_REARG_FLAG&&data[7].length<=source[8]||srcBitmask==(WRAP_ARY_FLAG|WRAP_REARG_FLAG)&&source[7].length<=source[8]&&bitmask==WRAP_CURRY_FLAG;// Exit early if metadata can't be merged.
if(!(isCommon||isCombo)){return data;}// Use source `thisArg` if available.
if(srcBitmask&WRAP_BIND_FLAG){data[2]=source[2];// Set when currying a bound function.
newBitmask|=bitmask&WRAP_BIND_FLAG?0:WRAP_CURRY_BOUND_FLAG;}// Compose partial arguments.
var value=source[3];if(value){var partials=data[3];data[3]=partials?composeArgs(partials,value,source[4]):value;data[4]=partials?replaceHolders(data[3],PLACEHOLDER):source[4];}// Compose partial right arguments.
value=source[5];if(value){partials=data[5];data[5]=partials?composeArgsRight(partials,value,source[6]):value;data[6]=partials?replaceHolders(data[5],PLACEHOLDER):source[6];}// Use source `argPos` if available.
value=source[7];if(value){data[7]=value;}// Use source `ary` if it's smaller.
if(srcBitmask&WRAP_ARY_FLAG){data[8]=data[8]==null?source[8]:nativeMin(data[8],source[8]);}// Use source `arity` if one is not provided.
if(data[9]==null){data[9]=source[9];}// Use source `func` and merge bitmasks.
data[0]=source[0];data[1]=newBitmask;return data;}/**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */function nativeKeysIn(object){var result=[];if(object!=null){for(var key in Object(object)){result.push(key);}}return result;}/**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */function objectToString(value){return nativeObjectToString.call(value);}/**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */function overRest(func,start,transform){start=nativeMax(start===undefined$1?func.length-1:start,0);return function(){var args=arguments,index=-1,length=nativeMax(args.length-start,0),array=Array(length);while(++index<length){array[index]=args[start+index];}index=-1;var otherArgs=Array(start+1);while(++index<start){otherArgs[index]=args[index];}otherArgs[start]=transform(array);return apply(func,this,otherArgs);};}/**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */function parent(object,path){return path.length<2?object:baseGet(object,baseSlice(path,0,-1));}/**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */function reorder(array,indexes){var arrLength=array.length,length=nativeMin(indexes.length,arrLength),oldArray=copyArray(array);while(length--){var index=indexes[length];array[length]=isIndex(index,arrLength)?oldArray[index]:undefined$1;}return array;}/**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */function safeGet(object,key){if(key==='constructor'&&typeof object[key]==='function'){return;}if(key=='__proto__'){return;}return object[key];}/**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */var setData=shortOut(baseSetData);/**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */var setTimeout=ctxSetTimeout||function(func,wait){return root.setTimeout(func,wait);};/**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */var setToString=shortOut(baseSetToString);/**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */function setWrapToString(wrapper,reference,bitmask){var source=reference+'';return setToString(wrapper,insertWrapDetails(source,updateWrapDetails(getWrapDetails(source),bitmask)));}/**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */function shortOut(func){var count=0,lastCalled=0;return function(){var stamp=nativeNow(),remaining=HOT_SPAN-(stamp-lastCalled);lastCalled=stamp;if(remaining>0){if(++count>=HOT_COUNT){return arguments[0];}}else {count=0;}return func.apply(undefined$1,arguments);};}/**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */function shuffleSelf(array,size){var index=-1,length=array.length,lastIndex=length-1;size=size===undefined$1?length:size;while(++index<size){var rand=baseRandom(index,lastIndex),value=array[rand];array[rand]=array[index];array[index]=value;}array.length=size;return array;}/**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */var stringToPath=memoizeCapped(function(string){var result=[];if(string.charCodeAt(0)===46/* . */){result.push('');}string.replace(rePropName,function(match,number,quote,subString){result.push(quote?subString.replace(reEscapeChar,'$1'):number||match);});return result;});/**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */function toKey(value){if(typeof value=='string'||isSymbol(value)){return value;}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}/**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */function toSource(func){if(func!=null){try{return funcToString.call(func);}catch(e){}try{return func+'';}catch(e){}}return '';}/**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */function updateWrapDetails(details,bitmask){arrayEach(wrapFlags,function(pair){var value='_.'+pair[0];if(bitmask&pair[1]&&!arrayIncludes(details,value)){details.push(value);}});return details.sort();}/**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */function wrapperClone(wrapper){if(wrapper instanceof LazyWrapper){return wrapper.clone();}var result=new LodashWrapper(wrapper.__wrapped__,wrapper.__chain__);result.__actions__=copyArray(wrapper.__actions__);result.__index__=wrapper.__index__;result.__values__=wrapper.__values__;return result;}/*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */function chunk(array,size,guard){if(guard?isIterateeCall(array,size,guard):size===undefined$1){size=1;}else {size=nativeMax(toInteger(size),0);}var length=array==null?0:array.length;if(!length||size<1){return [];}var index=0,resIndex=0,result=Array(nativeCeil(length/size));while(index<length){result[resIndex++]=baseSlice(array,index,index+=size);}return result;}/**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */function compact(array){var index=-1,length=array==null?0:array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(value){result[resIndex++]=value;}}return result;}/**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */function concat(){var length=arguments.length;if(!length){return [];}var args=Array(length-1),array=arguments[0],index=length;while(index--){args[index-1]=arguments[index];}return arrayPush(isArray(array)?copyArray(array):[array],baseFlatten(args,1));}/**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */var difference=baseRest(function(array,values){return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true)):[];});/**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */var differenceBy=baseRest(function(array,values){var iteratee=last(values);if(isArrayLikeObject(iteratee)){iteratee=undefined$1;}return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),getIteratee(iteratee,2)):[];});/**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */var differenceWith=baseRest(function(array,values){var comparator=last(values);if(isArrayLikeObject(comparator)){comparator=undefined$1;}return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),undefined$1,comparator):[];});/**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */function drop(array,n,guard){var length=array==null?0:array.length;if(!length){return [];}n=guard||n===undefined$1?1:toInteger(n);return baseSlice(array,n<0?0:n,length);}/**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */function dropRight(array,n,guard){var length=array==null?0:array.length;if(!length){return [];}n=guard||n===undefined$1?1:toInteger(n);n=length-n;return baseSlice(array,0,n<0?0:n);}/**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */function dropRightWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),true,true):[];}/**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */function dropWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),true):[];}/**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */function fill(array,value,start,end){var length=array==null?0:array.length;if(!length){return [];}if(start&&typeof start!='number'&&isIterateeCall(array,value,start)){start=0;end=length;}return baseFill(array,value,start,end);}/**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */function findIndex(array,predicate,fromIndex){var length=array==null?0:array.length;if(!length){return -1;}var index=fromIndex==null?0:toInteger(fromIndex);if(index<0){index=nativeMax(length+index,0);}return baseFindIndex(array,getIteratee(predicate,3),index);}/**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */function findLastIndex(array,predicate,fromIndex){var length=array==null?0:array.length;if(!length){return -1;}var index=length-1;if(fromIndex!==undefined$1){index=toInteger(fromIndex);index=fromIndex<0?nativeMax(length+index,0):nativeMin(index,length-1);}return baseFindIndex(array,getIteratee(predicate,3),index,true);}/**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */function flatten(array){var length=array==null?0:array.length;return length?baseFlatten(array,1):[];}/**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */function flattenDeep(array){var length=array==null?0:array.length;return length?baseFlatten(array,INFINITY):[];}/**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */function flattenDepth(array,depth){var length=array==null?0:array.length;if(!length){return [];}depth=depth===undefined$1?1:toInteger(depth);return baseFlatten(array,depth);}/**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */function fromPairs(pairs){var index=-1,length=pairs==null?0:pairs.length,result={};while(++index<length){var pair=pairs[index];result[pair[0]]=pair[1];}return result;}/**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */function head(array){return array&&array.length?array[0]:undefined$1;}/**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */function indexOf(array,value,fromIndex){var length=array==null?0:array.length;if(!length){return -1;}var index=fromIndex==null?0:toInteger(fromIndex);if(index<0){index=nativeMax(length+index,0);}return baseIndexOf(array,value,index);}/**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */function initial(array){var length=array==null?0:array.length;return length?baseSlice(array,0,-1):[];}/**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */var intersection=baseRest(function(arrays){var mapped=arrayMap(arrays,castArrayLikeObject);return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped):[];});/**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */var intersectionBy=baseRest(function(arrays){var iteratee=last(arrays),mapped=arrayMap(arrays,castArrayLikeObject);if(iteratee===last(mapped)){iteratee=undefined$1;}else {mapped.pop();}return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped,getIteratee(iteratee,2)):[];});/**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */var intersectionWith=baseRest(function(arrays){var comparator=last(arrays),mapped=arrayMap(arrays,castArrayLikeObject);comparator=typeof comparator=='function'?comparator:undefined$1;if(comparator){mapped.pop();}return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped,undefined$1,comparator):[];});/**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */function join(array,separator){return array==null?'':nativeJoin.call(array,separator);}/**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */function last(array){var length=array==null?0:array.length;return length?array[length-1]:undefined$1;}/**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */function lastIndexOf(array,value,fromIndex){var length=array==null?0:array.length;if(!length){return -1;}var index=length;if(fromIndex!==undefined$1){index=toInteger(fromIndex);index=index<0?nativeMax(length+index,0):nativeMin(index,length-1);}return value===value?strictLastIndexOf(array,value,index):baseFindIndex(array,baseIsNaN,index,true);}/**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */function nth(array,n){return array&&array.length?baseNth(array,toInteger(n)):undefined$1;}/**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */var pull=baseRest(pullAll);/**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */function pullAll(array,values){return array&&array.length&&values&&values.length?basePullAll(array,values):array;}/**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */function pullAllBy(array,values,iteratee){return array&&array.length&&values&&values.length?basePullAll(array,values,getIteratee(iteratee,2)):array;}/**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */function pullAllWith(array,values,comparator){return array&&array.length&&values&&values.length?basePullAll(array,values,undefined$1,comparator):array;}/**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */var pullAt=flatRest(function(array,indexes){var length=array==null?0:array.length,result=baseAt(array,indexes);basePullAt(array,arrayMap(indexes,function(index){return isIndex(index,length)?+index:index;}).sort(compareAscending));return result;});/**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */function remove(array,predicate){var result=[];if(!(array&&array.length)){return result;}var index=-1,indexes=[],length=array.length;predicate=getIteratee(predicate,3);while(++index<length){var value=array[index];if(predicate(value,index,array)){result.push(value);indexes.push(index);}}basePullAt(array,indexes);return result;}/**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */function reverse(array){return array==null?array:nativeReverse.call(array);}/**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */function slice(array,start,end){var length=array==null?0:array.length;if(!length){return [];}if(end&&typeof end!='number'&&isIterateeCall(array,start,end)){start=0;end=length;}else {start=start==null?0:toInteger(start);end=end===undefined$1?length:toInteger(end);}return baseSlice(array,start,end);}/**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */function sortedIndex(array,value){return baseSortedIndex(array,value);}/**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */function sortedIndexBy(array,value,iteratee){return baseSortedIndexBy(array,value,getIteratee(iteratee,2));}/**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */function sortedIndexOf(array,value){var length=array==null?0:array.length;if(length){var index=baseSortedIndex(array,value);if(index<length&&eq(array[index],value)){return index;}}return -1;}/**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */function sortedLastIndex(array,value){return baseSortedIndex(array,value,true);}/**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */function sortedLastIndexBy(array,value,iteratee){return baseSortedIndexBy(array,value,getIteratee(iteratee,2),true);}/**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */function sortedLastIndexOf(array,value){var length=array==null?0:array.length;if(length){var index=baseSortedIndex(array,value,true)-1;if(eq(array[index],value)){return index;}}return -1;}/**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */function sortedUniq(array){return array&&array.length?baseSortedUniq(array):[];}/**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */function sortedUniqBy(array,iteratee){return array&&array.length?baseSortedUniq(array,getIteratee(iteratee,2)):[];}/**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */function tail(array){var length=array==null?0:array.length;return length?baseSlice(array,1,length):[];}/**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */function take(array,n,guard){if(!(array&&array.length)){return [];}n=guard||n===undefined$1?1:toInteger(n);return baseSlice(array,0,n<0?0:n);}/**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */function takeRight(array,n,guard){var length=array==null?0:array.length;if(!length){return [];}n=guard||n===undefined$1?1:toInteger(n);n=length-n;return baseSlice(array,n<0?0:n,length);}/**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */function takeRightWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),false,true):[];}/**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */function takeWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3)):[];}/**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */var union=baseRest(function(arrays){return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true));});/**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */var unionBy=baseRest(function(arrays){var iteratee=last(arrays);if(isArrayLikeObject(iteratee)){iteratee=undefined$1;}return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),getIteratee(iteratee,2));});/**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */var unionWith=baseRest(function(arrays){var comparator=last(arrays);comparator=typeof comparator=='function'?comparator:undefined$1;return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),undefined$1,comparator);});/**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */function uniq(array){return array&&array.length?baseUniq(array):[];}/**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */function uniqBy(array,iteratee){return array&&array.length?baseUniq(array,getIteratee(iteratee,2)):[];}/**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */function uniqWith(array,comparator){comparator=typeof comparator=='function'?comparator:undefined$1;return array&&array.length?baseUniq(array,undefined$1,comparator):[];}/**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */function unzip(array){if(!(array&&array.length)){return [];}var length=0;array=arrayFilter(array,function(group){if(isArrayLikeObject(group)){length=nativeMax(group.length,length);return true;}});return baseTimes(length,function(index){return arrayMap(array,baseProperty(index));});}/**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */function unzipWith(array,iteratee){if(!(array&&array.length)){return [];}var result=unzip(array);if(iteratee==null){return result;}return arrayMap(result,function(group){return apply(iteratee,undefined$1,group);});}/**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */var without=baseRest(function(array,values){return isArrayLikeObject(array)?baseDifference(array,values):[];});/**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */var xor=baseRest(function(arrays){return baseXor(arrayFilter(arrays,isArrayLikeObject));});/**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */var xorBy=baseRest(function(arrays){var iteratee=last(arrays);if(isArrayLikeObject(iteratee)){iteratee=undefined$1;}return baseXor(arrayFilter(arrays,isArrayLikeObject),getIteratee(iteratee,2));});/**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */var xorWith=baseRest(function(arrays){var comparator=last(arrays);comparator=typeof comparator=='function'?comparator:undefined$1;return baseXor(arrayFilter(arrays,isArrayLikeObject),undefined$1,comparator);});/**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */var zip=baseRest(unzip);/**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */function zipObject(props,values){return baseZipObject(props||[],values||[],assignValue);}/**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */function zipObjectDeep(props,values){return baseZipObject(props||[],values||[],baseSet);}/**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */var zipWith=baseRest(function(arrays){var length=arrays.length,iteratee=length>1?arrays[length-1]:undefined$1;iteratee=typeof iteratee=='function'?(arrays.pop(),iteratee):undefined$1;return unzipWith(arrays,iteratee);});/*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */function chain(value){var result=lodash(value);result.__chain__=true;return result;}/**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */function tap(value,interceptor){interceptor(value);return value;}/**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */function thru(value,interceptor){return interceptor(value);}/**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */var wrapperAt=flatRest(function(paths){var length=paths.length,start=length?paths[0]:0,value=this.__wrapped__,interceptor=function interceptor(object){return baseAt(object,paths);};if(length>1||this.__actions__.length||!(value instanceof LazyWrapper)||!isIndex(start)){return this.thru(interceptor);}value=value.slice(start,+start+(length?1:0));value.__actions__.push({'func':thru,'args':[interceptor],'thisArg':undefined$1});return new LodashWrapper(value,this.__chain__).thru(function(array){if(length&&!array.length){array.push(undefined$1);}return array;});});/**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */function wrapperChain(){return chain(this);}/**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */function wrapperCommit(){return new LodashWrapper(this.value(),this.__chain__);}/**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */function wrapperNext(){if(this.__values__===undefined$1){this.__values__=toArray(this.value());}var done=this.__index__>=this.__values__.length,value=done?undefined$1:this.__values__[this.__index__++];return {'done':done,'value':value};}/**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */function wrapperToIterator(){return this;}/**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */function wrapperPlant(value){var result,parent=this;while(parent instanceof baseLodash){var clone=wrapperClone(parent);clone.__index__=0;clone.__values__=undefined$1;if(result){previous.__wrapped__=clone;}else {result=clone;}var previous=clone;parent=parent.__wrapped__;}previous.__wrapped__=value;return result;}/**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */function wrapperReverse(){var value=this.__wrapped__;if(value instanceof LazyWrapper){var wrapped=value;if(this.__actions__.length){wrapped=new LazyWrapper(this);}wrapped=wrapped.reverse();wrapped.__actions__.push({'func':thru,'args':[reverse],'thisArg':undefined$1});return new LodashWrapper(wrapped,this.__chain__);}return this.thru(reverse);}/**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */function wrapperValue(){return baseWrapperValue(this.__wrapped__,this.__actions__);}/*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */var countBy=createAggregator(function(result,value,key){if(hasOwnProperty.call(result,key)){++result[key];}else {baseAssignValue(result,key,1);}});/**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */function every(collection,predicate,guard){var func=isArray(collection)?arrayEvery:baseEvery;if(guard&&isIterateeCall(collection,predicate,guard)){predicate=undefined$1;}return func(collection,getIteratee(predicate,3));}/**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */function filter(collection,predicate){var func=isArray(collection)?arrayFilter:baseFilter;return func(collection,getIteratee(predicate,3));}/**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */var find=createFind(findIndex);/**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */var findLast=createFind(findLastIndex);/**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */function flatMap(collection,iteratee){return baseFlatten(map(collection,iteratee),1);}/**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */function flatMapDeep(collection,iteratee){return baseFlatten(map(collection,iteratee),INFINITY);}/**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */function flatMapDepth(collection,iteratee,depth){depth=depth===undefined$1?1:toInteger(depth);return baseFlatten(map(collection,iteratee),depth);}/**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */function forEach(collection,iteratee){var func=isArray(collection)?arrayEach:baseEach;return func(collection,getIteratee(iteratee,3));}/**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */function forEachRight(collection,iteratee){var func=isArray(collection)?arrayEachRight:baseEachRight;return func(collection,getIteratee(iteratee,3));}/**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */var groupBy=createAggregator(function(result,value,key){if(hasOwnProperty.call(result,key)){result[key].push(value);}else {baseAssignValue(result,key,[value]);}});/**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */function includes(collection,value,fromIndex,guard){collection=isArrayLike(collection)?collection:values(collection);fromIndex=fromIndex&&!guard?toInteger(fromIndex):0;var length=collection.length;if(fromIndex<0){fromIndex=nativeMax(length+fromIndex,0);}return isString(collection)?fromIndex<=length&&collection.indexOf(value,fromIndex)>-1:!!length&&baseIndexOf(collection,value,fromIndex)>-1;}/**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */var invokeMap=baseRest(function(collection,path,args){var index=-1,isFunc=typeof path=='function',result=isArrayLike(collection)?Array(collection.length):[];baseEach(collection,function(value){result[++index]=isFunc?apply(path,value,args):baseInvoke(value,path,args);});return result;});/**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */var keyBy=createAggregator(function(result,value,key){baseAssignValue(result,key,value);});/**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */function map(collection,iteratee){var func=isArray(collection)?arrayMap:baseMap;return func(collection,getIteratee(iteratee,3));}/**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */function orderBy(collection,iteratees,orders,guard){if(collection==null){return [];}if(!isArray(iteratees)){iteratees=iteratees==null?[]:[iteratees];}orders=guard?undefined$1:orders;if(!isArray(orders)){orders=orders==null?[]:[orders];}return baseOrderBy(collection,iteratees,orders);}/**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */var partition=createAggregator(function(result,value,key){result[key?0:1].push(value);},function(){return [[],[]];});/**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */function reduce(collection,iteratee,accumulator){var func=isArray(collection)?arrayReduce:baseReduce,initAccum=arguments.length<3;return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEach);}/**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */function reduceRight(collection,iteratee,accumulator){var func=isArray(collection)?arrayReduceRight:baseReduce,initAccum=arguments.length<3;return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEachRight);}/**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */function reject(collection,predicate){var func=isArray(collection)?arrayFilter:baseFilter;return func(collection,negate(getIteratee(predicate,3)));}/**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */function sample(collection){var func=isArray(collection)?arraySample:baseSample;return func(collection);}/**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */function sampleSize(collection,n,guard){if(guard?isIterateeCall(collection,n,guard):n===undefined$1){n=1;}else {n=toInteger(n);}var func=isArray(collection)?arraySampleSize:baseSampleSize;return func(collection,n);}/**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */function shuffle(collection){var func=isArray(collection)?arrayShuffle:baseShuffle;return func(collection);}/**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */function size(collection){if(collection==null){return 0;}if(isArrayLike(collection)){return isString(collection)?stringSize(collection):collection.length;}var tag=getTag(collection);if(tag==mapTag||tag==setTag){return collection.size;}return baseKeys(collection).length;}/**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */function some(collection,predicate,guard){var func=isArray(collection)?arraySome:baseSome;if(guard&&isIterateeCall(collection,predicate,guard)){predicate=undefined$1;}return func(collection,getIteratee(predicate,3));}/**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */var sortBy=baseRest(function(collection,iteratees){if(collection==null){return [];}var length=iteratees.length;if(length>1&&isIterateeCall(collection,iteratees[0],iteratees[1])){iteratees=[];}else if(length>2&&isIterateeCall(iteratees[0],iteratees[1],iteratees[2])){iteratees=[iteratees[0]];}return baseOrderBy(collection,baseFlatten(iteratees,1),[]);});/*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */var now=ctxNow||function(){return root.Date.now();};/*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */function after(n,func){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}n=toInteger(n);return function(){if(--n<1){return func.apply(this,arguments);}};}/**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */function ary(func,n,guard){n=guard?undefined$1:n;n=func&&n==null?func.length:n;return createWrap(func,WRAP_ARY_FLAG,undefined$1,undefined$1,undefined$1,undefined$1,n);}/**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */function before(n,func){var result;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}n=toInteger(n);return function(){if(--n>0){result=func.apply(this,arguments);}if(n<=1){func=undefined$1;}return result;};}/**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */var bind=baseRest(function(func,thisArg,partials){var bitmask=WRAP_BIND_FLAG;if(partials.length){var holders=replaceHolders(partials,getHolder(bind));bitmask|=WRAP_PARTIAL_FLAG;}return createWrap(func,bitmask,thisArg,partials,holders);});/**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */var bindKey=baseRest(function(object,key,partials){var bitmask=WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG;if(partials.length){var holders=replaceHolders(partials,getHolder(bindKey));bitmask|=WRAP_PARTIAL_FLAG;}return createWrap(key,bitmask,object,partials,holders);});/**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */function curry(func,arity,guard){arity=guard?undefined$1:arity;var result=createWrap(func,WRAP_CURRY_FLAG,undefined$1,undefined$1,undefined$1,undefined$1,undefined$1,arity);result.placeholder=curry.placeholder;return result;}/**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */function curryRight(func,arity,guard){arity=guard?undefined$1:arity;var result=createWrap(func,WRAP_CURRY_RIGHT_FLAG,undefined$1,undefined$1,undefined$1,undefined$1,undefined$1,arity);result.placeholder=curryRight.placeholder;return result;}/**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */function debounce(func,wait,options){var lastArgs,lastThis,maxWait,result,timerId,lastCallTime,lastInvokeTime=0,leading=false,maxing=false,trailing=true;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}wait=toNumber(wait)||0;if(isObject(options)){leading=!!options.leading;maxing='maxWait'in options;maxWait=maxing?nativeMax(toNumber(options.maxWait)||0,wait):maxWait;trailing='trailing'in options?!!options.trailing:trailing;}function invokeFunc(time){var args=lastArgs,thisArg=lastThis;lastArgs=lastThis=undefined$1;lastInvokeTime=time;result=func.apply(thisArg,args);return result;}function leadingEdge(time){// Reset any `maxWait` timer.
lastInvokeTime=time;// Start the timer for the trailing edge.
timerId=setTimeout(timerExpired,wait);// Invoke the leading edge.
return leading?invokeFunc(time):result;}function remainingWait(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime,timeWaiting=wait-timeSinceLastCall;return maxing?nativeMin(timeWaiting,maxWait-timeSinceLastInvoke):timeWaiting;}function shouldInvoke(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime;// Either this is the first call, activity has stopped and we're at the
// trailing edge, the system time has gone backwards and we're treating
// it as the trailing edge, or we've hit the `maxWait` limit.
return lastCallTime===undefined$1||timeSinceLastCall>=wait||timeSinceLastCall<0||maxing&&timeSinceLastInvoke>=maxWait;}function timerExpired(){var time=now();if(shouldInvoke(time)){return trailingEdge(time);}// Restart the timer.
timerId=setTimeout(timerExpired,remainingWait(time));}function trailingEdge(time){timerId=undefined$1;// Only invoke if we have `lastArgs` which means `func` has been
// debounced at least once.
if(trailing&&lastArgs){return invokeFunc(time);}lastArgs=lastThis=undefined$1;return result;}function cancel(){if(timerId!==undefined$1){clearTimeout(timerId);}lastInvokeTime=0;lastArgs=lastCallTime=lastThis=timerId=undefined$1;}function flush(){return timerId===undefined$1?result:trailingEdge(now());}function debounced(){var time=now(),isInvoking=shouldInvoke(time);lastArgs=arguments;lastThis=this;lastCallTime=time;if(isInvoking){if(timerId===undefined$1){return leadingEdge(lastCallTime);}if(maxing){// Handle invocations in a tight loop.
clearTimeout(timerId);timerId=setTimeout(timerExpired,wait);return invokeFunc(lastCallTime);}}if(timerId===undefined$1){timerId=setTimeout(timerExpired,wait);}return result;}debounced.cancel=cancel;debounced.flush=flush;return debounced;}/**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */var defer=baseRest(function(func,args){return baseDelay(func,1,args);});/**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */var delay=baseRest(function(func,wait,args){return baseDelay(func,toNumber(wait)||0,args);});/**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */function flip(func){return createWrap(func,WRAP_FLIP_FLAG);}/**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */function memoize(func,resolver){if(typeof func!='function'||resolver!=null&&typeof resolver!='function'){throw new TypeError(FUNC_ERROR_TEXT);}var memoized=function memoized(){var args=arguments,key=resolver?resolver.apply(this,args):args[0],cache=memoized.cache;if(cache.has(key)){return cache.get(key);}var result=func.apply(this,args);memoized.cache=cache.set(key,result)||cache;return result;};memoized.cache=new(memoize.Cache||MapCache)();return memoized;}// Expose `MapCache`.
memoize.Cache=MapCache;/**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */function negate(predicate){if(typeof predicate!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return function(){var args=arguments;switch(args.length){case 0:return !predicate.call(this);case 1:return !predicate.call(this,args[0]);case 2:return !predicate.call(this,args[0],args[1]);case 3:return !predicate.call(this,args[0],args[1],args[2]);}return !predicate.apply(this,args);};}/**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */function once(func){return before(2,func);}/**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */var overArgs=castRest(function(func,transforms){transforms=transforms.length==1&&isArray(transforms[0])?arrayMap(transforms[0],baseUnary(getIteratee())):arrayMap(baseFlatten(transforms,1),baseUnary(getIteratee()));var funcsLength=transforms.length;return baseRest(function(args){var index=-1,length=nativeMin(args.length,funcsLength);while(++index<length){args[index]=transforms[index].call(this,args[index]);}return apply(func,this,args);});});/**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */var partial=baseRest(function(func,partials){var holders=replaceHolders(partials,getHolder(partial));return createWrap(func,WRAP_PARTIAL_FLAG,undefined$1,partials,holders);});/**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */var partialRight=baseRest(function(func,partials){var holders=replaceHolders(partials,getHolder(partialRight));return createWrap(func,WRAP_PARTIAL_RIGHT_FLAG,undefined$1,partials,holders);});/**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */var rearg=flatRest(function(func,indexes){return createWrap(func,WRAP_REARG_FLAG,undefined$1,undefined$1,undefined$1,indexes);});/**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */function rest(func,start){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}start=start===undefined$1?start:toInteger(start);return baseRest(func,start);}/**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */function spread(func,start){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}start=start==null?0:nativeMax(toInteger(start),0);return baseRest(function(args){var array=args[start],otherArgs=castSlice(args,0,start);if(array){arrayPush(otherArgs,array);}return apply(func,this,otherArgs);});}/**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */function throttle(func,wait,options){var leading=true,trailing=true;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}if(isObject(options)){leading='leading'in options?!!options.leading:leading;trailing='trailing'in options?!!options.trailing:trailing;}return debounce(func,wait,{'leading':leading,'maxWait':wait,'trailing':trailing});}/**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */function unary(func){return ary(func,1);}/**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */function wrap(value,wrapper){return partial(castFunction(wrapper),value);}/*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */function castArray(){if(!arguments.length){return [];}var value=arguments[0];return isArray(value)?value:[value];}/**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */function clone(value){return baseClone(value,CLONE_SYMBOLS_FLAG);}/**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */function cloneWith(value,customizer){customizer=typeof customizer=='function'?customizer:undefined$1;return baseClone(value,CLONE_SYMBOLS_FLAG,customizer);}/**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */function cloneDeep(value){return baseClone(value,CLONE_DEEP_FLAG|CLONE_SYMBOLS_FLAG);}/**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */function cloneDeepWith(value,customizer){customizer=typeof customizer=='function'?customizer:undefined$1;return baseClone(value,CLONE_DEEP_FLAG|CLONE_SYMBOLS_FLAG,customizer);}/**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */function conformsTo(object,source){return source==null||baseConformsTo(object,source,keys(source));}/**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */function eq(value,other){return value===other||value!==value&&other!==other;}/**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */var gt=createRelationalOperation(baseGt);/**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */var gte=createRelationalOperation(function(value,other){return value>=other;});/**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */var isArguments=baseIsArguments(function(){return arguments;}())?baseIsArguments:function(value){return isObjectLike(value)&&hasOwnProperty.call(value,'callee')&&!propertyIsEnumerable.call(value,'callee');};/**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */var isArray=Array.isArray;/**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */var isArrayBuffer=nodeIsArrayBuffer?baseUnary(nodeIsArrayBuffer):baseIsArrayBuffer;/**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */function isArrayLike(value){return value!=null&&isLength(value.length)&&!isFunction(value);}/**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */function isArrayLikeObject(value){return isObjectLike(value)&&isArrayLike(value);}/**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */function isBoolean(value){return value===true||value===false||isObjectLike(value)&&baseGetTag(value)==boolTag;}/**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */var isBuffer=nativeIsBuffer||stubFalse;/**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */var isDate=nodeIsDate?baseUnary(nodeIsDate):baseIsDate;/**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */function isElement(value){return isObjectLike(value)&&value.nodeType===1&&!isPlainObject(value);}/**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */function isEmpty(value){if(value==null){return true;}if(isArrayLike(value)&&(isArray(value)||typeof value=='string'||typeof value.splice=='function'||isBuffer(value)||isTypedArray(value)||isArguments(value))){return !value.length;}var tag=getTag(value);if(tag==mapTag||tag==setTag){return !value.size;}if(isPrototype(value)){return !baseKeys(value).length;}for(var key in value){if(hasOwnProperty.call(value,key)){return false;}}return true;}/**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */function isEqual(value,other){return baseIsEqual(value,other);}/**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */function isEqualWith(value,other,customizer){customizer=typeof customizer=='function'?customizer:undefined$1;var result=customizer?customizer(value,other):undefined$1;return result===undefined$1?baseIsEqual(value,other,undefined$1,customizer):!!result;}/**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */function isError(value){if(!isObjectLike(value)){return false;}var tag=baseGetTag(value);return tag==errorTag||tag==domExcTag||typeof value.message=='string'&&typeof value.name=='string'&&!isPlainObject(value);}/**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */function isFinite(value){return typeof value=='number'&&nativeIsFinite(value);}/**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */function isFunction(value){if(!isObject(value)){return false;}// The use of `Object#toString` avoids issues with the `typeof` operator
// in Safari 9 which returns 'object' for typed arrays and other constructors.
var tag=baseGetTag(value);return tag==funcTag||tag==genTag||tag==asyncTag||tag==proxyTag;}/**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */function isInteger(value){return typeof value=='number'&&value==toInteger(value);}/**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */function isLength(value){return typeof value=='number'&&value>-1&&value%1==0&&value<=MAX_SAFE_INTEGER;}/**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */function isObject(value){var type=_typeof(value);return value!=null&&(type=='object'||type=='function');}/**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */function isObjectLike(value){return value!=null&&_typeof(value)=='object';}/**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */var isMap=nodeIsMap?baseUnary(nodeIsMap):baseIsMap;/**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */function isMatch(object,source){return object===source||baseIsMatch(object,source,getMatchData(source));}/**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */function isMatchWith(object,source,customizer){customizer=typeof customizer=='function'?customizer:undefined$1;return baseIsMatch(object,source,getMatchData(source),customizer);}/**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */function isNaN(value){// An `NaN` primitive is the only value that is not equal to itself.
// Perform the `toStringTag` check first to avoid errors with some
// ActiveX objects in IE.
return isNumber(value)&&value!=+value;}/**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */function isNative(value){if(isMaskable(value)){throw new Error(CORE_ERROR_TEXT);}return baseIsNative(value);}/**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */function isNull(value){return value===null;}/**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */function isNil(value){return value==null;}/**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */function isNumber(value){return typeof value=='number'||isObjectLike(value)&&baseGetTag(value)==numberTag;}/**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */function isPlainObject(value){if(!isObjectLike(value)||baseGetTag(value)!=objectTag){return false;}var proto=getPrototype(value);if(proto===null){return true;}var Ctor=hasOwnProperty.call(proto,'constructor')&&proto.constructor;return typeof Ctor=='function'&&Ctor instanceof Ctor&&funcToString.call(Ctor)==objectCtorString;}/**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */var isRegExp=nodeIsRegExp?baseUnary(nodeIsRegExp):baseIsRegExp;/**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */function isSafeInteger(value){return isInteger(value)&&value>=-MAX_SAFE_INTEGER&&value<=MAX_SAFE_INTEGER;}/**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */var isSet=nodeIsSet?baseUnary(nodeIsSet):baseIsSet;/**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */function isString(value){return typeof value=='string'||!isArray(value)&&isObjectLike(value)&&baseGetTag(value)==stringTag;}/**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */function isSymbol(value){return _typeof(value)=='symbol'||isObjectLike(value)&&baseGetTag(value)==symbolTag;}/**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */var isTypedArray=nodeIsTypedArray?baseUnary(nodeIsTypedArray):baseIsTypedArray;/**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */function isUndefined(value){return value===undefined$1;}/**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */function isWeakMap(value){return isObjectLike(value)&&getTag(value)==weakMapTag;}/**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */function isWeakSet(value){return isObjectLike(value)&&baseGetTag(value)==weakSetTag;}/**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */var lt=createRelationalOperation(baseLt);/**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */var lte=createRelationalOperation(function(value,other){return value<=other;});/**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */function toArray(value){if(!value){return [];}if(isArrayLike(value)){return isString(value)?stringToArray(value):copyArray(value);}if(symIterator&&value[symIterator]){return iteratorToArray(value[symIterator]());}var tag=getTag(value),func=tag==mapTag?mapToArray:tag==setTag?setToArray:values;return func(value);}/**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */function toFinite(value){if(!value){return value===0?value:0;}value=toNumber(value);if(value===INFINITY||value===-INFINITY){var sign=value<0?-1:1;return sign*MAX_INTEGER;}return value===value?value:0;}/**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */function toInteger(value){var result=toFinite(value),remainder=result%1;return result===result?remainder?result-remainder:result:0;}/**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */function toLength(value){return value?baseClamp(toInteger(value),0,MAX_ARRAY_LENGTH):0;}/**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */function toNumber(value){if(typeof value=='number'){return value;}if(isSymbol(value)){return NAN;}if(isObject(value)){var other=typeof value.valueOf=='function'?value.valueOf():value;value=isObject(other)?other+'':other;}if(typeof value!='string'){return value===0?value:+value;}value=baseTrim(value);var isBinary=reIsBinary.test(value);return isBinary||reIsOctal.test(value)?freeParseInt(value.slice(2),isBinary?2:8):reIsBadHex.test(value)?NAN:+value;}/**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */function toPlainObject(value){return copyObject(value,keysIn(value));}/**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */function toSafeInteger(value){return value?baseClamp(toInteger(value),-MAX_SAFE_INTEGER,MAX_SAFE_INTEGER):value===0?value:0;}/**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */function toString(value){return value==null?'':baseToString(value);}/*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */var assign=createAssigner(function(object,source){if(isPrototype(source)||isArrayLike(source)){copyObject(source,keys(source),object);return;}for(var key in source){if(hasOwnProperty.call(source,key)){assignValue(object,key,source[key]);}}});/**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */var assignIn=createAssigner(function(object,source){copyObject(source,keysIn(source),object);});/**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */var assignInWith=createAssigner(function(object,source,srcIndex,customizer){copyObject(source,keysIn(source),object,customizer);});/**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */var assignWith=createAssigner(function(object,source,srcIndex,customizer){copyObject(source,keys(source),object,customizer);});/**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */var at=flatRest(baseAt);/**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */function create(prototype,properties){var result=baseCreate(prototype);return properties==null?result:baseAssign(result,properties);}/**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */var defaults=baseRest(function(object,sources){object=Object(object);var index=-1;var length=sources.length;var guard=length>2?sources[2]:undefined$1;if(guard&&isIterateeCall(sources[0],sources[1],guard)){length=1;}while(++index<length){var source=sources[index];var props=keysIn(source);var propsIndex=-1;var propsLength=props.length;while(++propsIndex<propsLength){var key=props[propsIndex];var value=object[key];if(value===undefined$1||eq(value,objectProto[key])&&!hasOwnProperty.call(object,key)){object[key]=source[key];}}}return object;});/**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */var defaultsDeep=baseRest(function(args){args.push(undefined$1,customDefaultsMerge);return apply(mergeWith,undefined$1,args);});/**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */function findKey(object,predicate){return baseFindKey(object,getIteratee(predicate,3),baseForOwn);}/**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */function findLastKey(object,predicate){return baseFindKey(object,getIteratee(predicate,3),baseForOwnRight);}/**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */function forIn(object,iteratee){return object==null?object:baseFor(object,getIteratee(iteratee,3),keysIn);}/**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */function forInRight(object,iteratee){return object==null?object:baseForRight(object,getIteratee(iteratee,3),keysIn);}/**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */function forOwn(object,iteratee){return object&&baseForOwn(object,getIteratee(iteratee,3));}/**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */function forOwnRight(object,iteratee){return object&&baseForOwnRight(object,getIteratee(iteratee,3));}/**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */function functions(object){return object==null?[]:baseFunctions(object,keys(object));}/**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */function functionsIn(object){return object==null?[]:baseFunctions(object,keysIn(object));}/**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */function get(object,path,defaultValue){var result=object==null?undefined$1:baseGet(object,path);return result===undefined$1?defaultValue:result;}/**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */function has(object,path){return object!=null&&hasPath(object,path,baseHas);}/**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */function hasIn(object,path){return object!=null&&hasPath(object,path,baseHasIn);}/**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */var invert=createInverter(function(result,value,key){if(value!=null&&typeof value.toString!='function'){value=nativeObjectToString.call(value);}result[value]=key;},constant(identity));/**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */var invertBy=createInverter(function(result,value,key){if(value!=null&&typeof value.toString!='function'){value=nativeObjectToString.call(value);}if(hasOwnProperty.call(result,value)){result[value].push(key);}else {result[value]=[key];}},getIteratee);/**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */var invoke=baseRest(baseInvoke);/**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */function keys(object){return isArrayLike(object)?arrayLikeKeys(object):baseKeys(object);}/**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */function keysIn(object){return isArrayLike(object)?arrayLikeKeys(object,true):baseKeysIn(object);}/**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */function mapKeys(object,iteratee){var result={};iteratee=getIteratee(iteratee,3);baseForOwn(object,function(value,key,object){baseAssignValue(result,iteratee(value,key,object),value);});return result;}/**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */function mapValues(object,iteratee){var result={};iteratee=getIteratee(iteratee,3);baseForOwn(object,function(value,key,object){baseAssignValue(result,key,iteratee(value,key,object));});return result;}/**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */var merge=createAssigner(function(object,source,srcIndex){baseMerge(object,source,srcIndex);});/**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */var mergeWith=createAssigner(function(object,source,srcIndex,customizer){baseMerge(object,source,srcIndex,customizer);});/**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */var omit=flatRest(function(object,paths){var result={};if(object==null){return result;}var isDeep=false;paths=arrayMap(paths,function(path){path=castPath(path,object);isDeep||(isDeep=path.length>1);return path;});copyObject(object,getAllKeysIn(object),result);if(isDeep){result=baseClone(result,CLONE_DEEP_FLAG|CLONE_FLAT_FLAG|CLONE_SYMBOLS_FLAG,customOmitClone);}var length=paths.length;while(length--){baseUnset(result,paths[length]);}return result;});/**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */function omitBy(object,predicate){return pickBy(object,negate(getIteratee(predicate)));}/**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */var pick=flatRest(function(object,paths){return object==null?{}:basePick(object,paths);});/**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */function pickBy(object,predicate){if(object==null){return {};}var props=arrayMap(getAllKeysIn(object),function(prop){return [prop];});predicate=getIteratee(predicate);return basePickBy(object,props,function(value,path){return predicate(value,path[0]);});}/**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */function result(object,path,defaultValue){path=castPath(path,object);var index=-1,length=path.length;// Ensure the loop is entered when path is empty.
if(!length){length=1;object=undefined$1;}while(++index<length){var value=object==null?undefined$1:object[toKey(path[index])];if(value===undefined$1){index=length;value=defaultValue;}object=isFunction(value)?value.call(object):value;}return object;}/**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */function set(object,path,value){return object==null?object:baseSet(object,path,value);}/**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */function setWith(object,path,value,customizer){customizer=typeof customizer=='function'?customizer:undefined$1;return object==null?object:baseSet(object,path,value,customizer);}/**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */var toPairs=createToPairs(keys);/**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */var toPairsIn=createToPairs(keysIn);/**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */function transform(object,iteratee,accumulator){var isArr=isArray(object),isArrLike=isArr||isBuffer(object)||isTypedArray(object);iteratee=getIteratee(iteratee,4);if(accumulator==null){var Ctor=object&&object.constructor;if(isArrLike){accumulator=isArr?new Ctor():[];}else if(isObject(object)){accumulator=isFunction(Ctor)?baseCreate(getPrototype(object)):{};}else {accumulator={};}}(isArrLike?arrayEach:baseForOwn)(object,function(value,index,object){return iteratee(accumulator,value,index,object);});return accumulator;}/**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */function unset(object,path){return object==null?true:baseUnset(object,path);}/**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */function update(object,path,updater){return object==null?object:baseUpdate(object,path,castFunction(updater));}/**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */function updateWith(object,path,updater,customizer){customizer=typeof customizer=='function'?customizer:undefined$1;return object==null?object:baseUpdate(object,path,castFunction(updater),customizer);}/**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */function values(object){return object==null?[]:baseValues(object,keys(object));}/**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */function valuesIn(object){return object==null?[]:baseValues(object,keysIn(object));}/*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */function clamp(number,lower,upper){if(upper===undefined$1){upper=lower;lower=undefined$1;}if(upper!==undefined$1){upper=toNumber(upper);upper=upper===upper?upper:0;}if(lower!==undefined$1){lower=toNumber(lower);lower=lower===lower?lower:0;}return baseClamp(toNumber(number),lower,upper);}/**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */function inRange(number,start,end){start=toFinite(start);if(end===undefined$1){end=start;start=0;}else {end=toFinite(end);}number=toNumber(number);return baseInRange(number,start,end);}/**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */function random(lower,upper,floating){if(floating&&typeof floating!='boolean'&&isIterateeCall(lower,upper,floating)){upper=floating=undefined$1;}if(floating===undefined$1){if(typeof upper=='boolean'){floating=upper;upper=undefined$1;}else if(typeof lower=='boolean'){floating=lower;lower=undefined$1;}}if(lower===undefined$1&&upper===undefined$1){lower=0;upper=1;}else {lower=toFinite(lower);if(upper===undefined$1){upper=lower;lower=0;}else {upper=toFinite(upper);}}if(lower>upper){var temp=lower;lower=upper;upper=temp;}if(floating||lower%1||upper%1){var rand=nativeRandom();return nativeMin(lower+rand*(upper-lower+freeParseFloat('1e-'+((rand+'').length-1))),upper);}return baseRandom(lower,upper);}/*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */var camelCase=createCompounder(function(result,word,index){word=word.toLowerCase();return result+(index?capitalize(word):word);});/**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */function capitalize(string){return upperFirst(toString(string).toLowerCase());}/**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */function deburr(string){string=toString(string);return string&&string.replace(reLatin,deburrLetter).replace(reComboMark,'');}/**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */function endsWith(string,target,position){string=toString(string);target=baseToString(target);var length=string.length;position=position===undefined$1?length:baseClamp(toInteger(position),0,length);var end=position;position-=target.length;return position>=0&&string.slice(position,end)==target;}/**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */function escape(string){string=toString(string);return string&&reHasUnescapedHtml.test(string)?string.replace(reUnescapedHtml,escapeHtmlChar):string;}/**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */function escapeRegExp(string){string=toString(string);return string&&reHasRegExpChar.test(string)?string.replace(reRegExpChar,'\\$&'):string;}/**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */var kebabCase=createCompounder(function(result,word,index){return result+(index?'-':'')+word.toLowerCase();});/**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */var lowerCase=createCompounder(function(result,word,index){return result+(index?' ':'')+word.toLowerCase();});/**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */var lowerFirst=createCaseFirst('toLowerCase');/**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */function pad(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;if(!length||strLength>=length){return string;}var mid=(length-strLength)/2;return createPadding(nativeFloor(mid),chars)+string+createPadding(nativeCeil(mid),chars);}/**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */function padEnd(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;return length&&strLength<length?string+createPadding(length-strLength,chars):string;}/**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */function padStart(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;return length&&strLength<length?createPadding(length-strLength,chars)+string:string;}/**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */function parseInt(string,radix,guard){if(guard||radix==null){radix=0;}else if(radix){radix=+radix;}return nativeParseInt(toString(string).replace(reTrimStart,''),radix||0);}/**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */function repeat(string,n,guard){if(guard?isIterateeCall(string,n,guard):n===undefined$1){n=1;}else {n=toInteger(n);}return baseRepeat(toString(string),n);}/**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */function replace(){var args=arguments,string=toString(args[0]);return args.length<3?string:string.replace(args[1],args[2]);}/**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */var snakeCase=createCompounder(function(result,word,index){return result+(index?'_':'')+word.toLowerCase();});/**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */function split(string,separator,limit){if(limit&&typeof limit!='number'&&isIterateeCall(string,separator,limit)){separator=limit=undefined$1;}limit=limit===undefined$1?MAX_ARRAY_LENGTH:limit>>>0;if(!limit){return [];}string=toString(string);if(string&&(typeof separator=='string'||separator!=null&&!isRegExp(separator))){separator=baseToString(separator);if(!separator&&hasUnicode(string)){return castSlice(stringToArray(string),0,limit);}}return string.split(separator,limit);}/**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */var startCase=createCompounder(function(result,word,index){return result+(index?' ':'')+upperFirst(word);});/**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */function startsWith(string,target,position){string=toString(string);position=position==null?0:baseClamp(toInteger(position),0,string.length);target=baseToString(target);return string.slice(position,position+target.length)==target;}/**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */function template(string,options,guard){// Based on John Resig's `tmpl` implementation
// (http://ejohn.org/blog/javascript-micro-templating/)
// and Laura Doktorova's doT.js (https://github.com/olado/doT).
var settings=lodash.templateSettings;if(guard&&isIterateeCall(string,options,guard)){options=undefined$1;}string=toString(string);options=assignInWith({},options,settings,customDefaultsAssignIn);var imports=assignInWith({},options.imports,settings.imports,customDefaultsAssignIn),importsKeys=keys(imports),importsValues=baseValues(imports,importsKeys);var isEscaping,isEvaluating,index=0,interpolate=options.interpolate||reNoMatch,source="__p += '";// Compile the regexp to match each delimiter.
var reDelimiters=RegExp((options.escape||reNoMatch).source+'|'+interpolate.source+'|'+(interpolate===reInterpolate?reEsTemplate:reNoMatch).source+'|'+(options.evaluate||reNoMatch).source+'|$','g');// Use a sourceURL for easier debugging.
// The sourceURL gets injected into the source that's eval-ed, so be careful
// to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
// and escape the comment, thus injecting code that gets evaled.
var sourceURL='//# sourceURL='+(hasOwnProperty.call(options,'sourceURL')?(options.sourceURL+'').replace(/\s/g,' '):'lodash.templateSources['+ ++templateCounter+']')+'\n';string.replace(reDelimiters,function(match,escapeValue,interpolateValue,esTemplateValue,evaluateValue,offset){interpolateValue||(interpolateValue=esTemplateValue);// Escape characters that can't be included in string literals.
source+=string.slice(index,offset).replace(reUnescapedString,escapeStringChar);// Replace delimiters with snippets.
if(escapeValue){isEscaping=true;source+="' +\n__e("+escapeValue+") +\n'";}if(evaluateValue){isEvaluating=true;source+="';\n"+evaluateValue+";\n__p += '";}if(interpolateValue){source+="' +\n((__t = ("+interpolateValue+")) == null ? '' : __t) +\n'";}index=offset+match.length;// The JS engine embedded in Adobe products needs `match` returned in
// order to produce the correct `offset` value.
return match;});source+="';\n";// If `variable` is not specified wrap a with-statement around the generated
// code to add the data object to the top of the scope chain.
var variable=hasOwnProperty.call(options,'variable')&&options.variable;if(!variable){source='with (obj) {\n'+source+'\n}\n';}// Throw an error if a forbidden character was found in `variable`, to prevent
// potential command injection attacks.
else if(reForbiddenIdentifierChars.test(variable)){throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);}// Cleanup code by stripping empty strings.
source=(isEvaluating?source.replace(reEmptyStringLeading,''):source).replace(reEmptyStringMiddle,'$1').replace(reEmptyStringTrailing,'$1;');// Frame code as the function body.
source='function('+(variable||'obj')+') {\n'+(variable?'':'obj || (obj = {});\n')+"var __t, __p = ''"+(isEscaping?', __e = _.escape':'')+(isEvaluating?', __j = Array.prototype.join;\n'+"function print() { __p += __j.call(arguments, '') }\n":';\n')+source+'return __p\n}';var result=attempt(function(){return Function(importsKeys,sourceURL+'return '+source).apply(undefined$1,importsValues);});// Provide the compiled function's source by its `toString` method or
// the `source` property as a convenience for inlining compiled templates.
result.source=source;if(isError(result)){throw result;}return result;}/**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */function toLower(value){return toString(value).toLowerCase();}/**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */function toUpper(value){return toString(value).toUpperCase();}/**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */function trim(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined$1)){return baseTrim(string);}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),chrSymbols=stringToArray(chars),start=charsStartIndex(strSymbols,chrSymbols),end=charsEndIndex(strSymbols,chrSymbols)+1;return castSlice(strSymbols,start,end).join('');}/**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */function trimEnd(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined$1)){return string.slice(0,trimmedEndIndex(string)+1);}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),end=charsEndIndex(strSymbols,stringToArray(chars))+1;return castSlice(strSymbols,0,end).join('');}/**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */function trimStart(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined$1)){return string.replace(reTrimStart,'');}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),start=charsStartIndex(strSymbols,stringToArray(chars));return castSlice(strSymbols,start).join('');}/**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */function truncate(string,options){var length=DEFAULT_TRUNC_LENGTH,omission=DEFAULT_TRUNC_OMISSION;if(isObject(options)){var separator='separator'in options?options.separator:separator;length='length'in options?toInteger(options.length):length;omission='omission'in options?baseToString(options.omission):omission;}string=toString(string);var strLength=string.length;if(hasUnicode(string)){var strSymbols=stringToArray(string);strLength=strSymbols.length;}if(length>=strLength){return string;}var end=length-stringSize(omission);if(end<1){return omission;}var result=strSymbols?castSlice(strSymbols,0,end).join(''):string.slice(0,end);if(separator===undefined$1){return result+omission;}if(strSymbols){end+=result.length-end;}if(isRegExp(separator)){if(string.slice(end).search(separator)){var match,substring=result;if(!separator.global){separator=RegExp(separator.source,toString(reFlags.exec(separator))+'g');}separator.lastIndex=0;while(match=separator.exec(substring)){var newEnd=match.index;}result=result.slice(0,newEnd===undefined$1?end:newEnd);}}else if(string.indexOf(baseToString(separator),end)!=end){var index=result.lastIndexOf(separator);if(index>-1){result=result.slice(0,index);}}return result+omission;}/**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */function unescape(string){string=toString(string);return string&&reHasEscapedHtml.test(string)?string.replace(reEscapedHtml,unescapeHtmlChar):string;}/**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */var upperCase=createCompounder(function(result,word,index){return result+(index?' ':'')+word.toUpperCase();});/**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */var upperFirst=createCaseFirst('toUpperCase');/**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */function words(string,pattern,guard){string=toString(string);pattern=guard?undefined$1:pattern;if(pattern===undefined$1){return hasUnicodeWord(string)?unicodeWords(string):asciiWords(string);}return string.match(pattern)||[];}/*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */var attempt=baseRest(function(func,args){try{return apply(func,undefined$1,args);}catch(e){return isError(e)?e:new Error(e);}});/**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */var bindAll=flatRest(function(object,methodNames){arrayEach(methodNames,function(key){key=toKey(key);baseAssignValue(object,key,bind(object[key],object));});return object;});/**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */function cond(pairs){var length=pairs==null?0:pairs.length,toIteratee=getIteratee();pairs=!length?[]:arrayMap(pairs,function(pair){if(typeof pair[1]!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return [toIteratee(pair[0]),pair[1]];});return baseRest(function(args){var index=-1;while(++index<length){var pair=pairs[index];if(apply(pair[0],this,args)){return apply(pair[1],this,args);}}});}/**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */function conforms(source){return baseConforms(baseClone(source,CLONE_DEEP_FLAG));}/**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */function constant(value){return function(){return value;};}/**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */function defaultTo(value,defaultValue){return value==null||value!==value?defaultValue:value;}/**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */var flow=createFlow();/**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */var flowRight=createFlow(true);/**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */function identity(value){return value;}/**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */function iteratee(func){return baseIteratee(typeof func=='function'?func:baseClone(func,CLONE_DEEP_FLAG));}/**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */function matches(source){return baseMatches(baseClone(source,CLONE_DEEP_FLAG));}/**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */function matchesProperty(path,srcValue){return baseMatchesProperty(path,baseClone(srcValue,CLONE_DEEP_FLAG));}/**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */var method=baseRest(function(path,args){return function(object){return baseInvoke(object,path,args);};});/**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */var methodOf=baseRest(function(object,args){return function(path){return baseInvoke(object,path,args);};});/**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */function mixin(object,source,options){var props=keys(source),methodNames=baseFunctions(source,props);if(options==null&&!(isObject(source)&&(methodNames.length||!props.length))){options=source;source=object;object=this;methodNames=baseFunctions(source,keys(source));}var chain=!(isObject(options)&&'chain'in options)||!!options.chain,isFunc=isFunction(object);arrayEach(methodNames,function(methodName){var func=source[methodName];object[methodName]=func;if(isFunc){object.prototype[methodName]=function(){var chainAll=this.__chain__;if(chain||chainAll){var result=object(this.__wrapped__),actions=result.__actions__=copyArray(this.__actions__);actions.push({'func':func,'args':arguments,'thisArg':object});result.__chain__=chainAll;return result;}return func.apply(object,arrayPush([this.value()],arguments));};}});return object;}/**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */function noConflict(){if(root._===this){root._=oldDash;}return this;}/**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */function noop(){// No operation performed.
}/**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */function nthArg(n){n=toInteger(n);return baseRest(function(args){return baseNth(args,n);});}/**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */var over=createOver(arrayMap);/**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */var overEvery=createOver(arrayEvery);/**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */var overSome=createOver(arraySome);/**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */function property(path){return isKey(path)?baseProperty(toKey(path)):basePropertyDeep(path);}/**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */function propertyOf(object){return function(path){return object==null?undefined$1:baseGet(object,path);};}/**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */var range=createRange();/**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */var rangeRight=createRange(true);/**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */function stubArray(){return [];}/**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */function stubFalse(){return false;}/**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */function stubObject(){return {};}/**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */function stubString(){return '';}/**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */function stubTrue(){return true;}/**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */function times(n,iteratee){n=toInteger(n);if(n<1||n>MAX_SAFE_INTEGER){return [];}var index=MAX_ARRAY_LENGTH,length=nativeMin(n,MAX_ARRAY_LENGTH);iteratee=getIteratee(iteratee);n-=MAX_ARRAY_LENGTH;var result=baseTimes(length,iteratee);while(++index<n){iteratee(index);}return result;}/**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */function toPath(value){if(isArray(value)){return arrayMap(value,toKey);}return isSymbol(value)?[value]:copyArray(stringToPath(toString(value)));}/**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */function uniqueId(prefix){var id=++idCounter;return toString(prefix)+id;}/*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */var add=createMathOperation(function(augend,addend){return augend+addend;},0);/**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */var ceil=createRound('ceil');/**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */var divide=createMathOperation(function(dividend,divisor){return dividend/divisor;},1);/**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */var floor=createRound('floor');/**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */function max(array){return array&&array.length?baseExtremum(array,identity,baseGt):undefined$1;}/**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */function maxBy(array,iteratee){return array&&array.length?baseExtremum(array,getIteratee(iteratee,2),baseGt):undefined$1;}/**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */function mean(array){return baseMean(array,identity);}/**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */function meanBy(array,iteratee){return baseMean(array,getIteratee(iteratee,2));}/**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */function min(array){return array&&array.length?baseExtremum(array,identity,baseLt):undefined$1;}/**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */function minBy(array,iteratee){return array&&array.length?baseExtremum(array,getIteratee(iteratee,2),baseLt):undefined$1;}/**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */var multiply=createMathOperation(function(multiplier,multiplicand){return multiplier*multiplicand;},1);/**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */var round=createRound('round');/**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */var subtract=createMathOperation(function(minuend,subtrahend){return minuend-subtrahend;},0);/**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */function sum(array){return array&&array.length?baseSum(array,identity):0;}/**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */function sumBy(array,iteratee){return array&&array.length?baseSum(array,getIteratee(iteratee,2)):0;}/*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
lodash.after=after;lodash.ary=ary;lodash.assign=assign;lodash.assignIn=assignIn;lodash.assignInWith=assignInWith;lodash.assignWith=assignWith;lodash.at=at;lodash.before=before;lodash.bind=bind;lodash.bindAll=bindAll;lodash.bindKey=bindKey;lodash.castArray=castArray;lodash.chain=chain;lodash.chunk=chunk;lodash.compact=compact;lodash.concat=concat;lodash.cond=cond;lodash.conforms=conforms;lodash.constant=constant;lodash.countBy=countBy;lodash.create=create;lodash.curry=curry;lodash.curryRight=curryRight;lodash.debounce=debounce;lodash.defaults=defaults;lodash.defaultsDeep=defaultsDeep;lodash.defer=defer;lodash.delay=delay;lodash.difference=difference;lodash.differenceBy=differenceBy;lodash.differenceWith=differenceWith;lodash.drop=drop;lodash.dropRight=dropRight;lodash.dropRightWhile=dropRightWhile;lodash.dropWhile=dropWhile;lodash.fill=fill;lodash.filter=filter;lodash.flatMap=flatMap;lodash.flatMapDeep=flatMapDeep;lodash.flatMapDepth=flatMapDepth;lodash.flatten=flatten;lodash.flattenDeep=flattenDeep;lodash.flattenDepth=flattenDepth;lodash.flip=flip;lodash.flow=flow;lodash.flowRight=flowRight;lodash.fromPairs=fromPairs;lodash.functions=functions;lodash.functionsIn=functionsIn;lodash.groupBy=groupBy;lodash.initial=initial;lodash.intersection=intersection;lodash.intersectionBy=intersectionBy;lodash.intersectionWith=intersectionWith;lodash.invert=invert;lodash.invertBy=invertBy;lodash.invokeMap=invokeMap;lodash.iteratee=iteratee;lodash.keyBy=keyBy;lodash.keys=keys;lodash.keysIn=keysIn;lodash.map=map;lodash.mapKeys=mapKeys;lodash.mapValues=mapValues;lodash.matches=matches;lodash.matchesProperty=matchesProperty;lodash.memoize=memoize;lodash.merge=merge;lodash.mergeWith=mergeWith;lodash.method=method;lodash.methodOf=methodOf;lodash.mixin=mixin;lodash.negate=negate;lodash.nthArg=nthArg;lodash.omit=omit;lodash.omitBy=omitBy;lodash.once=once;lodash.orderBy=orderBy;lodash.over=over;lodash.overArgs=overArgs;lodash.overEvery=overEvery;lodash.overSome=overSome;lodash.partial=partial;lodash.partialRight=partialRight;lodash.partition=partition;lodash.pick=pick;lodash.pickBy=pickBy;lodash.property=property;lodash.propertyOf=propertyOf;lodash.pull=pull;lodash.pullAll=pullAll;lodash.pullAllBy=pullAllBy;lodash.pullAllWith=pullAllWith;lodash.pullAt=pullAt;lodash.range=range;lodash.rangeRight=rangeRight;lodash.rearg=rearg;lodash.reject=reject;lodash.remove=remove;lodash.rest=rest;lodash.reverse=reverse;lodash.sampleSize=sampleSize;lodash.set=set;lodash.setWith=setWith;lodash.shuffle=shuffle;lodash.slice=slice;lodash.sortBy=sortBy;lodash.sortedUniq=sortedUniq;lodash.sortedUniqBy=sortedUniqBy;lodash.split=split;lodash.spread=spread;lodash.tail=tail;lodash.take=take;lodash.takeRight=takeRight;lodash.takeRightWhile=takeRightWhile;lodash.takeWhile=takeWhile;lodash.tap=tap;lodash.throttle=throttle;lodash.thru=thru;lodash.toArray=toArray;lodash.toPairs=toPairs;lodash.toPairsIn=toPairsIn;lodash.toPath=toPath;lodash.toPlainObject=toPlainObject;lodash.transform=transform;lodash.unary=unary;lodash.union=union;lodash.unionBy=unionBy;lodash.unionWith=unionWith;lodash.uniq=uniq;lodash.uniqBy=uniqBy;lodash.uniqWith=uniqWith;lodash.unset=unset;lodash.unzip=unzip;lodash.unzipWith=unzipWith;lodash.update=update;lodash.updateWith=updateWith;lodash.values=values;lodash.valuesIn=valuesIn;lodash.without=without;lodash.words=words;lodash.wrap=wrap;lodash.xor=xor;lodash.xorBy=xorBy;lodash.xorWith=xorWith;lodash.zip=zip;lodash.zipObject=zipObject;lodash.zipObjectDeep=zipObjectDeep;lodash.zipWith=zipWith;// Add aliases.
lodash.entries=toPairs;lodash.entriesIn=toPairsIn;lodash.extend=assignIn;lodash.extendWith=assignInWith;// Add methods to `lodash.prototype`.
mixin(lodash,lodash);/*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
lodash.add=add;lodash.attempt=attempt;lodash.camelCase=camelCase;lodash.capitalize=capitalize;lodash.ceil=ceil;lodash.clamp=clamp;lodash.clone=clone;lodash.cloneDeep=cloneDeep;lodash.cloneDeepWith=cloneDeepWith;lodash.cloneWith=cloneWith;lodash.conformsTo=conformsTo;lodash.deburr=deburr;lodash.defaultTo=defaultTo;lodash.divide=divide;lodash.endsWith=endsWith;lodash.eq=eq;lodash.escape=escape;lodash.escapeRegExp=escapeRegExp;lodash.every=every;lodash.find=find;lodash.findIndex=findIndex;lodash.findKey=findKey;lodash.findLast=findLast;lodash.findLastIndex=findLastIndex;lodash.findLastKey=findLastKey;lodash.floor=floor;lodash.forEach=forEach;lodash.forEachRight=forEachRight;lodash.forIn=forIn;lodash.forInRight=forInRight;lodash.forOwn=forOwn;lodash.forOwnRight=forOwnRight;lodash.get=get;lodash.gt=gt;lodash.gte=gte;lodash.has=has;lodash.hasIn=hasIn;lodash.head=head;lodash.identity=identity;lodash.includes=includes;lodash.indexOf=indexOf;lodash.inRange=inRange;lodash.invoke=invoke;lodash.isArguments=isArguments;lodash.isArray=isArray;lodash.isArrayBuffer=isArrayBuffer;lodash.isArrayLike=isArrayLike;lodash.isArrayLikeObject=isArrayLikeObject;lodash.isBoolean=isBoolean;lodash.isBuffer=isBuffer;lodash.isDate=isDate;lodash.isElement=isElement;lodash.isEmpty=isEmpty;lodash.isEqual=isEqual;lodash.isEqualWith=isEqualWith;lodash.isError=isError;lodash.isFinite=isFinite;lodash.isFunction=isFunction;lodash.isInteger=isInteger;lodash.isLength=isLength;lodash.isMap=isMap;lodash.isMatch=isMatch;lodash.isMatchWith=isMatchWith;lodash.isNaN=isNaN;lodash.isNative=isNative;lodash.isNil=isNil;lodash.isNull=isNull;lodash.isNumber=isNumber;lodash.isObject=isObject;lodash.isObjectLike=isObjectLike;lodash.isPlainObject=isPlainObject;lodash.isRegExp=isRegExp;lodash.isSafeInteger=isSafeInteger;lodash.isSet=isSet;lodash.isString=isString;lodash.isSymbol=isSymbol;lodash.isTypedArray=isTypedArray;lodash.isUndefined=isUndefined;lodash.isWeakMap=isWeakMap;lodash.isWeakSet=isWeakSet;lodash.join=join;lodash.kebabCase=kebabCase;lodash.last=last;lodash.lastIndexOf=lastIndexOf;lodash.lowerCase=lowerCase;lodash.lowerFirst=lowerFirst;lodash.lt=lt;lodash.lte=lte;lodash.max=max;lodash.maxBy=maxBy;lodash.mean=mean;lodash.meanBy=meanBy;lodash.min=min;lodash.minBy=minBy;lodash.stubArray=stubArray;lodash.stubFalse=stubFalse;lodash.stubObject=stubObject;lodash.stubString=stubString;lodash.stubTrue=stubTrue;lodash.multiply=multiply;lodash.nth=nth;lodash.noConflict=noConflict;lodash.noop=noop;lodash.now=now;lodash.pad=pad;lodash.padEnd=padEnd;lodash.padStart=padStart;lodash.parseInt=parseInt;lodash.random=random;lodash.reduce=reduce;lodash.reduceRight=reduceRight;lodash.repeat=repeat;lodash.replace=replace;lodash.result=result;lodash.round=round;lodash.runInContext=runInContext;lodash.sample=sample;lodash.size=size;lodash.snakeCase=snakeCase;lodash.some=some;lodash.sortedIndex=sortedIndex;lodash.sortedIndexBy=sortedIndexBy;lodash.sortedIndexOf=sortedIndexOf;lodash.sortedLastIndex=sortedLastIndex;lodash.sortedLastIndexBy=sortedLastIndexBy;lodash.sortedLastIndexOf=sortedLastIndexOf;lodash.startCase=startCase;lodash.startsWith=startsWith;lodash.subtract=subtract;lodash.sum=sum;lodash.sumBy=sumBy;lodash.template=template;lodash.times=times;lodash.toFinite=toFinite;lodash.toInteger=toInteger;lodash.toLength=toLength;lodash.toLower=toLower;lodash.toNumber=toNumber;lodash.toSafeInteger=toSafeInteger;lodash.toString=toString;lodash.toUpper=toUpper;lodash.trim=trim;lodash.trimEnd=trimEnd;lodash.trimStart=trimStart;lodash.truncate=truncate;lodash.unescape=unescape;lodash.uniqueId=uniqueId;lodash.upperCase=upperCase;lodash.upperFirst=upperFirst;// Add aliases.
lodash.each=forEach;lodash.eachRight=forEachRight;lodash.first=head;mixin(lodash,function(){var source={};baseForOwn(lodash,function(func,methodName){if(!hasOwnProperty.call(lodash.prototype,methodName)){source[methodName]=func;}});return source;}(),{'chain':false});/*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */lodash.VERSION=VERSION;// Assign default placeholders.
arrayEach(['bind','bindKey','curry','curryRight','partial','partialRight'],function(methodName){lodash[methodName].placeholder=lodash;});// Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
arrayEach(['drop','take'],function(methodName,index){LazyWrapper.prototype[methodName]=function(n){n=n===undefined$1?1:nativeMax(toInteger(n),0);var result=this.__filtered__&&!index?new LazyWrapper(this):this.clone();if(result.__filtered__){result.__takeCount__=nativeMin(n,result.__takeCount__);}else {result.__views__.push({'size':nativeMin(n,MAX_ARRAY_LENGTH),'type':methodName+(result.__dir__<0?'Right':'')});}return result;};LazyWrapper.prototype[methodName+'Right']=function(n){return this.reverse()[methodName](n).reverse();};});// Add `LazyWrapper` methods that accept an `iteratee` value.
arrayEach(['filter','map','takeWhile'],function(methodName,index){var type=index+1,isFilter=type==LAZY_FILTER_FLAG||type==LAZY_WHILE_FLAG;LazyWrapper.prototype[methodName]=function(iteratee){var result=this.clone();result.__iteratees__.push({'iteratee':getIteratee(iteratee,3),'type':type});result.__filtered__=result.__filtered__||isFilter;return result;};});// Add `LazyWrapper` methods for `_.head` and `_.last`.
arrayEach(['head','last'],function(methodName,index){var takeName='take'+(index?'Right':'');LazyWrapper.prototype[methodName]=function(){return this[takeName](1).value()[0];};});// Add `LazyWrapper` methods for `_.initial` and `_.tail`.
arrayEach(['initial','tail'],function(methodName,index){var dropName='drop'+(index?'':'Right');LazyWrapper.prototype[methodName]=function(){return this.__filtered__?new LazyWrapper(this):this[dropName](1);};});LazyWrapper.prototype.compact=function(){return this.filter(identity);};LazyWrapper.prototype.find=function(predicate){return this.filter(predicate).head();};LazyWrapper.prototype.findLast=function(predicate){return this.reverse().find(predicate);};LazyWrapper.prototype.invokeMap=baseRest(function(path,args){if(typeof path=='function'){return new LazyWrapper(this);}return this.map(function(value){return baseInvoke(value,path,args);});});LazyWrapper.prototype.reject=function(predicate){return this.filter(negate(getIteratee(predicate)));};LazyWrapper.prototype.slice=function(start,end){start=toInteger(start);var result=this;if(result.__filtered__&&(start>0||end<0)){return new LazyWrapper(result);}if(start<0){result=result.takeRight(-start);}else if(start){result=result.drop(start);}if(end!==undefined$1){end=toInteger(end);result=end<0?result.dropRight(-end):result.take(end-start);}return result;};LazyWrapper.prototype.takeRightWhile=function(predicate){return this.reverse().takeWhile(predicate).reverse();};LazyWrapper.prototype.toArray=function(){return this.take(MAX_ARRAY_LENGTH);};// Add `LazyWrapper` methods to `lodash.prototype`.
baseForOwn(LazyWrapper.prototype,function(func,methodName){var checkIteratee=/^(?:filter|find|map|reject)|While$/.test(methodName),isTaker=/^(?:head|last)$/.test(methodName),lodashFunc=lodash[isTaker?'take'+(methodName=='last'?'Right':''):methodName],retUnwrapped=isTaker||/^find/.test(methodName);if(!lodashFunc){return;}lodash.prototype[methodName]=function(){var value=this.__wrapped__,args=isTaker?[1]:arguments,isLazy=value instanceof LazyWrapper,iteratee=args[0],useLazy=isLazy||isArray(value);var interceptor=function interceptor(value){var result=lodashFunc.apply(lodash,arrayPush([value],args));return isTaker&&chainAll?result[0]:result;};if(useLazy&&checkIteratee&&typeof iteratee=='function'&&iteratee.length!=1){// Avoid lazy use if the iteratee has a "length" value other than `1`.
isLazy=useLazy=false;}var chainAll=this.__chain__,isHybrid=!!this.__actions__.length,isUnwrapped=retUnwrapped&&!chainAll,onlyLazy=isLazy&&!isHybrid;if(!retUnwrapped&&useLazy){value=onlyLazy?value:new LazyWrapper(this);var result=func.apply(value,args);result.__actions__.push({'func':thru,'args':[interceptor],'thisArg':undefined$1});return new LodashWrapper(result,chainAll);}if(isUnwrapped&&onlyLazy){return func.apply(this,args);}result=this.thru(interceptor);return isUnwrapped?isTaker?result.value()[0]:result.value():result;};});// Add `Array` methods to `lodash.prototype`.
arrayEach(['pop','push','shift','sort','splice','unshift'],function(methodName){var func=arrayProto[methodName],chainName=/^(?:push|sort|unshift)$/.test(methodName)?'tap':'thru',retUnwrapped=/^(?:pop|shift)$/.test(methodName);lodash.prototype[methodName]=function(){var args=arguments;if(retUnwrapped&&!this.__chain__){var value=this.value();return func.apply(isArray(value)?value:[],args);}return this[chainName](function(value){return func.apply(isArray(value)?value:[],args);});};});// Map minified method names to their real names.
baseForOwn(LazyWrapper.prototype,function(func,methodName){var lodashFunc=lodash[methodName];if(lodashFunc){var key=lodashFunc.name+'';if(!hasOwnProperty.call(realNames,key)){realNames[key]=[];}realNames[key].push({'name':methodName,'func':lodashFunc});}});realNames[createHybrid(undefined$1,WRAP_BIND_KEY_FLAG).name]=[{'name':'wrapper','func':undefined$1}];// Add methods to `LazyWrapper`.
LazyWrapper.prototype.clone=lazyClone;LazyWrapper.prototype.reverse=lazyReverse;LazyWrapper.prototype.value=lazyValue;// Add chain sequence methods to the `lodash` wrapper.
lodash.prototype.at=wrapperAt;lodash.prototype.chain=wrapperChain;lodash.prototype.commit=wrapperCommit;lodash.prototype.next=wrapperNext;lodash.prototype.plant=wrapperPlant;lodash.prototype.reverse=wrapperReverse;lodash.prototype.toJSON=lodash.prototype.valueOf=lodash.prototype.value=wrapperValue;// Add lazy aliases.
lodash.prototype.first=lodash.prototype.head;if(symIterator){lodash.prototype[symIterator]=wrapperToIterator;}return lodash;};/*--------------------------------------------------------------------------*/ // Export lodash.
var _=runInContext();// Some AMD build optimizers, like r.js, check for condition patterns like:
if(freeModule){// Export for Node.js.
(freeModule.exports=_)._=_;// Export for CommonJS support.
freeExports._=_;}else {// Export to the global object.
root._=_;}}).call(commonjsGlobal$1);});var useRegisterListener$1=function useRegisterListener(_ref){var handler=_ref.handler,listener=_ref.listener;var _useState=useState(false),_useState2=_slicedToArray(_useState,2),isReady=_useState2[0],setIsReady=_useState2[1];useEffect(function(){if(!listener){return;}listener.current=handler();setIsReady(true);},[listener,handler]);return isReady;};var LoadingOverlay=function LoadingOverlay(){var theme=useThemeSafe();var classes=useStyles$5$1({theme:theme});return/*#__PURE__*/React__default.createElement("div",{className:classes.loadingOverlay},/*#__PURE__*/React__default.createElement("div",{className:classes.innerLoadingOverlay},/*#__PURE__*/React__default.createElement(StandaloneLoadingIndicator,{color:"blue"})));};var useStyles$5$1=createUseStyles(function(theme){return {loadingOverlay:{position:'fixed',backgroundColor:'#00031b20',touchAction:'none',left:0,right:0,top:0,bottom:0,zIndex:theme.zIndex.max},innerLoadingOverlay:{position:'absolute',display:'flex',alignItems:'center',justifyContent:'center',left:0,right:0,top:0,bottom:0}};});var useStyles$4$1=createUseStyles(function(theme){return {iconsWrapper:{display:'flex',gap:4,alignItems:'center'},iconContainer:{display:'flex',justifyContent:'center',alignItems:'center',padding:'0 8px 0 4px',opacity:function opacity(_ref){var hasValue=_ref.hasValue;return hasValue?'1':'0';},transition:theme.transitions.fast,gap:4}};});var PasswordField=/*#__PURE__*/React__default.forwardRef(function(_a,forwardedRef){var value=_a.value,inlineElement=_a.inlineElement,restProps=__rest$1(_a,["value","inlineElement"]);var _useState=useState(true),_useState2=_slicedToArray(_useState,2),hidePass=_useState2[0],setHidePass=_useState2[1];var _useState3=useState('eye-gray'),_useState4=_slicedToArray(_useState3,2),passIcon=_useState4[0],setPassIcon=_useState4[1];var _useState5=useState(false),_useState6=_slicedToArray(_useState5,2),isPassIconActive=_useState6[0],setIsPassIconActive=_useState6[1];var theme=useThemeSafe();var hasValue=value&&value.length!==0;var styles=useStyles$4$1({theme:theme,hasValue:hasValue});// manage icon state
useEffect(function(){setPassIcon(hidePass?'eye-gray':'eye-cross-gray');},[hidePass,setPassIcon]);// manage icon colors
useEffect(function(){if(isPassIconActive){setPassIcon(hidePass?'eye-blue':'eye-cross-blue');return;}setPassIcon(hidePass?'eye-gray':'eye-cross-gray');},[isPassIconActive,hidePass]);return/*#__PURE__*/React__default.createElement(TextField,Object.assign({ref:forwardedRef,type:hidePass?'password':'text',inlineElement:/*#__PURE__*/React__default.createElement("div",{className:styles.iconsWrapper},inlineElement?inlineElement:null,/*#__PURE__*/React__default.createElement("div",{className:styles.iconContainer},/*#__PURE__*/React__default.createElement(IconButton,{iconID:passIcon,onClick:function onClick(){setHidePass(!hidePass);},onMouseEnter:function onMouseEnter(){setIsPassIconActive(true);},onMouseLeave:function onMouseLeave(){setIsPassIconActive(false);}}))),inlineElementPos:"end",value:value},restProps));});PasswordField.displayName='PasswordField';var RadioButton=function RadioButton(_ref){var index=_ref.index,selected=_ref.selected,children=_ref.children,onClick=_ref.onClick;var innerClass=selected?'RadioButton-inner-selected':'RadioButton-inner-not-selected';var handleClick=function handleClick(){onClick(index);};return/*#__PURE__*/React__default.createElement("div",{className:"RadioButton-root",onClick:handleClick},/*#__PURE__*/React__default.createElement("div",{className:"RadioButton-outer"},/*#__PURE__*/React__default.createElement("div",{className:innerClass})),/*#__PURE__*/React__default.createElement("div",{className:"RadioButton-Text"},/*#__PURE__*/React__default.createElement(Text$1,{variant:"header-3",component:"div"},children)));};var RadioGroup=/*#__PURE__*/function(_Component){_inherits(RadioGroup,_Component);var _super=_createSuper(RadioGroup);function RadioGroup(props){var _this;_classCallCheck$1(this,RadioGroup);_this=_super.call(this,props);_this.onItemClickHandler=function(index){var _this$props=_this.props,onValueChange=_this$props.onValueChange,items=_this$props.items;onValueChange&&onValueChange(items[index]);// Makes sure onValueChange is not undefined
};_this.isChecked=function(item){var _this$props2=_this.props,activeItemId=_this$props2.activeItemId,itemIdResolver=_this$props2.itemIdResolver;return activeItemId===itemIdResolver(item);};return _this;}_createClass(RadioGroup,[{key:"render",value:function render(){var _this2=this;var _this$props3=this.props,items=_this$props3.items,itemStringResolver=_this$props3.itemStringResolver,_this$props3$style=_this$props3.style,style=_this$props3$style===void 0?{}:_this$props3$style,tooltipTextResolver=_this$props3.tooltipTextResolver;return/*#__PURE__*/React__default.createElement("div",{style:style,className:"CyoloUI-RadioGroup-root"},items.map(function(item,i){return/*#__PURE__*/React__default.createElement(RadioButton,{key:i,index:i,selected:_this2.isChecked(item),onClick:_this2.onItemClickHandler},/*#__PURE__*/React__default.createElement("div",{className:"CyoloUI-RadioGroup-item-container"},itemStringResolver(item),tooltipTextResolver&&tooltipTextResolver(item)&&/*#__PURE__*/React__default.createElement(Tooltip,{icon:"bulb",text:tooltipTextResolver(item)},/*#__PURE__*/React__default.createElement(Icon,{id:"question-mark"}))));}));}}]);return RadioGroup;}(Component);var selectedUnderlineWidth=3;var useStyles$3$1=createUseStyles(function(theme){return {tabsRoot:{},labelListContiner:{display:'flex',flexDirection:'column',position:'relative',borderBottom:"".concat(selectedUnderlineWidth,"px solid ").concat(theme.palette.grey.extraLight)},labelList:{display:'flex',flexWrap:'nowrap',justifyContent:function justifyContent(_ref){var tabAsTitle=_ref.tabAsTitle,growTabs=_ref.growTabs;return tabAsTitle||growTabs?'center':'flex-start';},gap:32},labelContainer:{flex:function flex(_ref2){var growTabs=_ref2.growTabs;return growTabs?'1 0 auto':'0 0 auto';},display:'flex',justifyContent:'center',alignItems:'center',transition:'0.2s all',padding:'0 8px 8px',borderBottom:'3px solid transparent',height:20,minWidth:104,'&:hover':{cursor:function cursor(_ref3){var tabAsTitle=_ref3.tabAsTitle;return tabAsTitle?'':'pointer';},CyoloUIText:{transition:'0.2s all ease',color:"".concat(theme.palette.primary.color," !important")}},'&[selected-tab]':{'&:hover':{cursor:function cursor(_ref4){var tabAsTitle=_ref4.tabAsTitle;return tabAsTitle?'':'pointer';},CyoloUIText:{color:"".concat(theme.palette.primary.color),opacity:1}}}},activeTabSlider:{height:selectedUnderlineWidth,bottom:-selectedUnderlineWidth,minWidth:0,position:'absolute',backgroundColor:theme.palette.primary.color,transition:'0.2s all'},tabsItemContainer:{paddingTop:16}};});/**
* should be used combined with <Tab/> as a child.
* fires onTabChange on each change.
* see options in stroybook for advance use cases.
*
* layout:
<Tabs onTabChange={(tabId) => ...}>
  <Tab id={1} label='my tab'>
    <children-content>
  </Tab >
</Tabs>
*/var Tabs=function Tabs(_a){var onTabChange=_a.onTabChange,children=_a.children,className=_a.className,tabAsTitle=_a.tabAsTitle,managed=_a.managed,growTabs=_a.growTabs,props=__rest$1(_a,["onTabChange","children","className","tabAsTitle","managed","growTabs"]);var childrenArray=React__default.Children.toArray(children);var _useState=useState(childrenArray),_useState2=_slicedToArray(_useState,2),tabsChildren=_useState2[0],setTabsChildren=_useState2[1];var _useState3=useState(0),_useState4=_slicedToArray(_useState3,2),activeTabIndex=_useState4[0],setActiveTabIndex=_useState4[1];var enableTabAsTitle=function enableTabAsTitle(tabsChildren){return tabAsTitle&&Boolean(tabsChildren.length===1);};var memoEnableTabAsTitle=useCallback(enableTabAsTitle,[tabAsTitle,tabsChildren]);var tabsChildrenSizeRef=useRef(tabsChildren.length);var tabAsTitleEnable=memoEnableTabAsTitle(tabsChildren);var theme=useThemeSafe();var classes=useStyles$3$1({tabAsTitle:tabAsTitleEnable,growTabs:growTabs,theme:theme});// TODO: useChildrenValidType not valid on minifiyed version. 14/10/2021
// useChildrenValidType('Tab', tabsChildren);
var refList=useRef([]);var activeTabSliderRef=useRef();var wrapperRef=useRef();useEffect(function(){var childrenArray=React__default.Children.toArray(children);setTabsChildren(childrenArray);},[children]);// init & support managed state
useLayoutEffect$5(function(){var activeTabIndex=getActiveTabIndexSafe();setActiveTabIndex(activeTabIndex);},Boolean(managed)?[tabsChildren,managed,tabAsTitle]:[tabAsTitle]);// support children removal during rendering
useLayoutEffect$5(function(){if(tabsChildren.length===tabsChildrenSizeRef.current){return;}tabsChildrenSizeRef.current=tabsChildren.length;var activeTabIndex=getActiveTabIndexSafe();setActiveTabIndex(activeTabIndex);},[tabsChildren]);//calculate styles on change
useEffect(function(){if(window.ResizeObserver){var resizeObserver=new window.ResizeObserver(function(){moveTabSlider(activeTabIndex);});(wrapperRef===null||wrapperRef===void 0?void 0:wrapperRef.current)&&resizeObserver.observe(wrapperRef===null||wrapperRef===void 0?void 0:wrapperRef.current);return function(){resizeObserver.disconnect();};}else {moveTabSlider(activeTabIndex);}},[activeTabIndex]);var filterTabChildById=function filterTabChildById(tabId){return React__default.Children.toArray(children).find(function(child){if(!/*#__PURE__*/React__default.isValidElement(child)){return false;}return tabId===child.props.id;});};/**
   * return first position if no active-tab found.
   */var getActiveTabIndexSafe=function getActiveTabIndexSafe(){var activeTabIdx=tabsChildren.findIndex(function(tab){var _a;return Boolean((_a=tab.props)===null||_a===void 0?void 0:_a.selectedTab);});if(activeTabIdx===-1){return 0;}return activeTabIdx;};var moveTabSlider=function moveTabSlider(targetRefIndex){var _a;var targetElem=refList.current[targetRefIndex];if(!Boolean(targetElem===null||targetElem===void 0?void 0:targetElem.getBoundingClientRect)||!Boolean((_a=targetElem===null||targetElem===void 0?void 0:targetElem.offsetParent)===null||_a===void 0?void 0:_a.getBoundingClientRect)){return;}// TabAsTitle case
if(memoEnableTabAsTitle(tabsChildren)){activeTabSliderRef.current.style.width="100%";activeTabSliderRef.current.style.left="0";return;}// apply changes
var _targetElem$getBoundi=targetElem.getBoundingClientRect(),nextWidth=_targetElem$getBoundi.width,nextLeftPos=_targetElem$getBoundi.left;var _targetElem$offsetPar=targetElem.offsetParent.getBoundingClientRect(),parentLeftOffset=_targetElem$offsetPar.left;activeTabSliderRef.current.style.width="".concat(nextWidth,"px");activeTabSliderRef.current.style.left="".concat(nextLeftPos-parentLeftOffset,"px");};var handleTabClick=function handleTabClick(tabId,refIndex){var selectedTab=filterTabChildById(tabId);if(!selectedTab){console.error('[Tab] cant find tab by id');return;}setActiveTabIndex(refIndex);if(onTabChange)onTabChange(tabId);};return/*#__PURE__*/React__default.createElement("div",Object.assign({className:clsx$1('CyoloUI-Tabs',className),ref:wrapperRef},props),/*#__PURE__*/React__default.createElement("div",{className:classes.labelListContiner},/*#__PURE__*/React__default.createElement("div",{className:clsx$1('CyoloUI-TabList',classes.labelList)},React__default.Children.toArray(tabsChildren).map(function(tabChild,index){var _a;var tabChildProps=tabChild.props;return/*#__PURE__*/React__default.createElement("div",{className:classes.labelContainer,ref:function ref(elem){return refList.current[index]=elem;},"selected-tab":(_a=tabChildProps===null||tabChildProps===void 0?void 0:tabChildProps.selectedTab)===null||_a===void 0?void 0:_a.toString(),key:tabChildProps===null||tabChildProps===void 0?void 0:tabChildProps.id,onClick:function onClick(){handleTabClick(tabChildProps===null||tabChildProps===void 0?void 0:tabChildProps.id,index);}},/*#__PURE__*/React__default.createElement(Text$1,{variant:"default-tab",component:"div",className:"label",color:activeTabIndex===index&&colors.selectedTab},tabChildProps.label));})),/*#__PURE__*/React__default.createElement("div",{className:classes.activeTabSlider,ref:activeTabSliderRef})),/*#__PURE__*/React__default.createElement("div",{className:classes.tabsItemContainer},childrenArray[activeTabIndex]));};var Tab=function Tab(_ref5){var children=_ref5.children;return/*#__PURE__*/React__default.createElement("div",{className:"cyolo-tab-root"},children);};var Tag=function Tag(_a){var _a$color=_a.color,color=_a$color===void 0?colors.baseGray:_a$color,_a$textColor=_a.textColor,textColor=_a$textColor===void 0?colors.cardWhite:_a$textColor,children=_a.children,onClick=_a.onClick,props=__rest$1(_a,["color","textColor","children","onClick"]);return/*#__PURE__*/React__default.createElement("div",Object.assign({className:clsx$1('CyoloUI-Tag',{'CyoloUI-Tag-Clickable':onClick!==undefined}),style:{backgroundColor:color},onClick:onClick},props),/*#__PURE__*/React__default.createElement(Text$1,{variant:"tag",color:textColor},children));};/**
 *
 * @param {number=} maxTags slice the children and adds indicator for hidden children
 * @returns children list with optional indicator for hidden children.
 */var TagList=function TagList(_a){var maxTags=_a.maxTags,children=_a.children,props=__rest$1(_a,["maxTags","children"]);var childrenArray=React__default.Children.toArray(children);var slicedChildren=children;var trimCounter;if(maxTags&&childrenArray.length>maxTags){slicedChildren=childrenArray.slice(0,maxTags);trimCounter=childrenArray.length-maxTags;}return/*#__PURE__*/React__default.createElement("div",Object.assign({className:"CyoloUI-Tag-List"},props),slicedChildren,/*#__PURE__*/React__default.createElement(Text$1,{className:"tag-trim-counter",variant:"console-app-body"},Boolean(trimCounter)&&"+".concat(trimCounter.toString())));};var TagsListField=function TagsListField(_ref){var values=_ref.values,className=_ref.className,onValidate=_ref.onValidate,onChange=_ref.onChange,_ref$placeholder=_ref.placeholder,placeholder=_ref$placeholder===void 0?'':_ref$placeholder,_ref$errorMessage=_ref.errorMessage,errorMessage=_ref$errorMessage===void 0?'':_ref$errorMessage,_ref$disabled=_ref.disabled,disabled=_ref$disabled===void 0?false:_ref$disabled,icon=_ref.icon;var _useState=useState(''),_useState2=_slicedToArray(_useState,2),inputText=_useState2[0],setInputText=_useState2[1];var textFieldRef=useRef(null);var _useState3=useState('regular'),_useState4=_slicedToArray(_useState3,2),fieldMode=_useState4[0],setFieldMode=_useState4[1];var theme=useThemeSafe();var styles=useStyles$2$1({theme:theme,isError:fieldMode==='error',disabled:disabled});var addValue=useCallback(function(value){onChange([].concat(_toConsumableArray(values),[value]));},[onChange]);var deleteValue=useCallback(function(value){onChange(values.filter(function(v){return v!==value;}));},[onChange]);var tagsListFieldClassName=useMemo(function(){return clsx$1('CyoloUI-Tags-List-Field',className,styles.root);},[className,styles]);var validateInputText=useCallback(function(text){setFieldMode('regular');// if onValidate is not defined return early
if(!onValidate)return true;// if value is empty return early
if(!String(text).length)return true;var isValid=onValidate(text);if(isValid)return true;// inputText is invalid, set mode to error
setFieldMode('error');return false;},[onValidate]);var handleFocus=useCallback(function(event){if(event.currentTarget===event.target){textFieldRef.current&&textFieldRef.current.focusField();}},[]);var handleEnterPress=useCallback(function(){if(disabled){return;}var isValid=validateInputText(inputText);if(isValid){addValue(inputText);setInputText('');}},[validateInputText,inputText]);var handleKeyPress=useCallback(function(event){if(event.key==='Enter'){handleEnterPress();}},[handleEnterPress,fieldMode]);var handleDelete=useCallback(function(value){if(disabled){return;}deleteValue(value);},[deleteValue]);return/*#__PURE__*/React__default.createElement(React__default.Fragment,null,/*#__PURE__*/React__default.createElement("div",{className:tagsListFieldClassName,tabIndex:1,onFocus:handleFocus},/*#__PURE__*/React__default.createElement("div",{className:styles.valuesList},values.map(function(value,i){return/*#__PURE__*/React__default.createElement(Chip,{key:"".concat(value,"-").concat(i),value:value,onDelete:function onDelete(){return handleDelete(value);},disabled:disabled,icon:icon});})),/*#__PURE__*/React__default.createElement("div",{className:styles.textFieldWrapper},/*#__PURE__*/React__default.createElement(TextField,{className:styles.textField,value:inputText,onChange:function onChange(e){return setInputText(e.target.value);},placeholder:placeholder,enabled:!disabled,ref:textFieldRef,onKeyPress:handleKeyPress}))),fieldMode==='error'&&/*#__PURE__*/React__default.createElement(Text$1,{variant:"tag",className:styles.errorMsg},errorMessage));};var useStyles$2$1=createUseStyles(function(theme){return {root:function root(props){return {padding:8,display:'flex',flexWrap:'wrap',alignItems:'center',border:"1px solid ".concat(props.isError?theme.palette.error.color:theme.palette.grey.extraLight),borderRadius:theme.shape.borderRadiusLight,cursor:props.disabled?'not-allowed':'default',opacity:props.disabled?0.7:1,'& > .CyoloUI-Chip':{cursor:props.disabled?'not-allowed':'default'}};},valuesList:{display:'flex',flexWrap:'wrap',alignItems:'center',gap:8},textFieldWrapper:{flex:1},textField:{border:'none',outline:'none',backgroundColor:'transparent'},errorMsg:function errorMsg(props){return {transition:theme.transitions.fast,margin:[[0,-8,0,0]],color:[theme.palette.error.color,'!important'],display:props.isError?'flex':'none',width:0,minWidth:'100%'};}};});var useStyles$1$1=createUseStyles(function(theme){return {root:{display:'grid',rowGap:6,gridColumn:'auto',gridRow:'28px auto'},container:function container(props){return {borderRadius:theme.shape.borderRadiusLight,display:'flex',width:'100%',boxSizing:'border-box',WebkitBoxSizing:'border-box',MozBoxSizing:'border-box',backgroundColor:theme.palette.backgroundDisabled.color,border:"1px solid ".concat(props.showBorder?props.borderColor:'transparent')};},textArea:{border:'none',lineHeight:'100%',margin:[[2,8,2,8]],fontSize:theme.typography.fontBaseSize,color:theme.palette.black.color,outline:'none',width:'100%',background:'none',resize:'none'},text:{fontSize:theme.typography.fontBaseSize,marginLeft:8,width:0,minWidth:'100%'}};});var TextArea=/*#__PURE__*/React__default.forwardRef(function(_a,forwardedRef){var value=_a.value,_a$rows=_a.rows,rows=_a$rows===void 0?3:_a$rows,_a$placeholder=_a.placeholder,placeholder=_a$placeholder===void 0?'':_a$placeholder,focusedBorderColor=_a.focusedBorderColor,className=_a.className,errorMessage=_a.errorMessage,onChange=_a.onChange,onValidate=_a.onValidate,rest=__rest$1(_a,["value","rows","placeholder","focusedBorderColor","className","errorMessage","onChange","onValidate"]);var _useState=useState('regular'),_useState2=_slicedToArray(_useState,2),fieldMode=_useState2[0],setFieldMode=_useState2[1];var _useState3=useState(false),_useState4=_slicedToArray(_useState3,2),inFocus=_useState4[0],setInFocus=_useState4[1];var theme=useThemeSafe();var focusedBorder=useMemo(function(){return focusedBorderColor||theme.palette.black.color;},[focusedBorderColor,theme]);// show border if the field is in focus or its in error mode
var showBorder=useMemo(function(){return inFocus||fieldMode==='error';},[inFocus,fieldMode]);// define the shown border color
var borderColor=useMemo(function(){return fieldMode==='error'?theme.palette.error.color:focusedBorder;},[fieldMode,focusedBorder]);var styles=useStyles$1$1({theme:theme,showBorder:showBorder,borderColor:borderColor});var handleOnChange=useCallback(function(e){// on change remove the error state of a field
// if its in one
if(fieldMode==='error'){setFieldMode('regular');}// if onChange is undefined return early
if(!onChange)return;// call the given field onChange func
onChange(e);},[fieldMode,onChange]);var validateValue=useCallback(function(){// if onValidate is not defined return early
if(!onValidate)return;// if value is empty return early
if(!value)return;// if the value is valid return early
if(onValidate(value))return;// value is invalid, set mode to error
setFieldMode('error');},[value,onValidate]);var handleHideDropdown=useCallback(function(e){if(e.key==='Escape'){setInFocus(false);}},[]);var handleBlur=useCallback(function(){setInFocus(false);validateValue();},[validateValue]);useEffect(function(){document.addEventListener('keydown',handleHideDropdown,true);document.addEventListener('blur',handleBlur,true);return function(){document.removeEventListener('keydown',handleHideDropdown,true);document.removeEventListener('blur',handleBlur,true);};},[handleHideDropdown,handleBlur]);var handleFocus=useCallback(function(){setInFocus(true);},[]);return/*#__PURE__*/React__default.createElement("div",{className:styles.root},/*#__PURE__*/React__default.createElement("div",{className:clsx$1(styles.container,className)},/*#__PURE__*/React__default.createElement("textarea",Object.assign({ref:forwardedRef,rows:rows,placeholder:placeholder,value:value,onFocus:handleFocus,onChange:handleOnChange,className:styles.textArea},rest))),fieldMode==='error'?/*#__PURE__*/React__default.createElement(Text$1,{variant:"body",color:theme.palette.error.color,className:styles.text},errorMessage):null);});TextArea.displayName='TextArea';var useStyles$D=createUseStyles(function(theme){return {toggle:{justifyContent:'center',position:'relative',height:16,width:'fit-content',cursor:'pointer'},bar:{height:12,width:24,borderRadius:theme.shape.borderRadius,top:2,left:1,right:1,position:'absolute',backgroundColor:theme.palette.grey.extraLight,'&.enabled':{backgroundColor:theme.palette.grey.light,'&.active':{backgroundColor:theme.palette.primary.color}}},circle:{height:16,width:16,boxSizing:'border-box',boxShadow:theme.shadows[0],borderRadius:theme.shape.borderRadiusHeavy,background:theme.palette.white.color,position:'absolute',display:'flex',justifyContent:'center',alignItems:'center',border:{width:1,style:'solid',color:theme.palette.grey.light},'&.enabled':{'&:hover':{boxShadow:'0px 0px 0px 2px rgba(200, 204, 217, 0.5)'}},'&.active':{left:11,'&.enabled':{borderColor:theme.palette.primary.color,'&:hover':{boxShadow:"0px 0px 0px 2px rgba(18, 59, 229, 0.3)"}}}},text:{marginLeft:32}};});var Toggle=function Toggle(_ref){var active=_ref.active,children=_ref.children,_ref$enabled=_ref.enabled,enabled=_ref$enabled===void 0?true:_ref$enabled,className=_ref.className,onClick=_ref.onClick;var theme=useThemeSafe();var styles=useStyles$D({theme:theme});var icon=getIconId(active,enabled);var handleOnClick=useCallback(function(e){if(enabled&&onClick){onClick&&onClick(e);}},[onClick,enabled]);return/*#__PURE__*/React__default.createElement("div",{className:clsx$1(styles.toggle,className),onClick:handleOnClick},/*#__PURE__*/React__default.createElement("div",{className:clsx$1(styles.bar,{active:active,enabled:enabled})}),/*#__PURE__*/React__default.createElement("div",{className:clsx$1(styles.circle,{active:active,enabled:enabled})},/*#__PURE__*/React__default.createElement(Icon,{id:icon,size:active?7:6})),/*#__PURE__*/React__default.createElement("div",{className:styles.text},/*#__PURE__*/React__default.createElement(Text$1,{variant:"body",color:active?theme.palette.primary.color:theme.palette.grey.light},children)));};function getIconId(active,enabled){if(active&&enabled){return 'v-sign-blue';}if(active&&!enabled){return 'v-sign-grey';}if(!active&&enabled){return 'x-inactive-icon';}return 'x-inactive-icon';}

var Anchor = function Anchor(_ref) {
  var url = _ref.url,
      children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React__default.createElement("a", {
    href: url,
    target: "_blank",
    rel: "noreferrer",
    className: className
  }, children);
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */
function debounce$2(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  }
  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  debounced.flush = function() {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
}
// Adds compatibility for ES modules
debounce$2.debounce = debounce$2;

var debounce_1$1 = debounce$2;

var iconSwitchButtonWrap = {
  border: 'none',
  backgroundColor: 'inherit',
  outline: 'none',
  height: '20px',
  cursor: 'pointer',
  padding: 0
};
var styles = {
  iconSwitchButtonWrap: iconSwitchButtonWrap
};

var IconSwitch = function IconSwitch(_ref) {
  var style = _ref.style,
      icons = _ref.icons,
      enabled = _ref.enabled,
      onClick = _ref.onClick,
      className = _ref.className;
  return /*#__PURE__*/React__default.createElement("button", {
    className: className,
    style: Object.assign(Object.assign({}, styles.iconSwitchButtonWrap), style),
    type: "button",
    onClick: onClick
  }, enabled ? icons[0] : icons[1]);
};

var adminPlaceHolder = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzkiIGhlaWdodD0iNTEiIHZpZXdCb3g9IjAgMCA3OSA1MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CjxwYXRoIGQ9Ik0xMC44NCAwLjVINjcuODRDNjkuMTY2IDAuNSA3MC40Mzc4IDEuMDI2NzggNzEuMzc1NSAxLjk2NDQ3QzcyLjMxMzIgMi45MDIxNSA3Mi44NCA0LjE3MzkyIDcyLjg0IDUuNVY0NS42NUg1LjgzOTk3VjUuNUM1LjgzOTk3IDQuMTczOTIgNi4zNjY3NSAyLjkwMjE1IDcuMzA0NDMgMS45NjQ0N0M4LjI0MjExIDEuMDI2NzggOS41MTM4OCAwLjUgMTAuODQgMC41VjAuNVoiIHN0cm9rZT0iIzA1NzdCNiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+CjxwYXRoIGQ9Ik0xMi4zMyAzLjY0OTlINjYuMzNDNjcuMTI1NiAzLjY0OTkgNjcuODg4NyAzLjk2NTk3IDY4LjQ1MTMgNC41Mjg1OEM2OS4wMTM5IDUuMDkxMTkgNjkuMzMgNS44NTQyNSA2OS4zMyA2LjY0OTlWNDIuNjQ5OUg5LjMyOTk2VjYuNjQ5OUM5LjMyOTk2IDUuODU0MjUgOS42NDYwMyA1LjA5MTE5IDEwLjIwODYgNC41Mjg1OEMxMC43NzEyIDMuOTY1OTcgMTEuNTM0MyAzLjY0OTkgMTIuMzMgMy42NDk5WiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyKSIvPgo8cGF0aCBvcGFjaXR5PSIwLjEiIGQ9Ik05LjMyOTk2IDQyLjY0OTlWNi42NDk5QzkuMzI5OTYgNS44NTQyNSA5LjY0NjAzIDUuMDkxMTkgMTAuMjA4NiA0LjUyODU4QzEwLjc3MTIgMy45NjU5NyAxMS41MzQzIDMuNjQ5OSAxMi4zMyAzLjY0OTlINjYuMzNDNjcuMDk0NyAzLjc4MTY4IDY3LjgyMTYgNC4wNzg1NyA2OC40NiA0LjUxOTlMOS4zMjk5NiA0Mi42NDk5WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTAuNSA0NS42NDk5SDc4LjE3Qzc4LjE3IDQ2LjkzNjIgNzcuNjU5IDQ4LjE2OTggNzYuNzQ5NSA0OS4wNzk0Qzc1LjgzOTkgNDkuOTg4OSA3NC42MDYzIDUwLjQ5OTkgNzMuMzIgNTAuNDk5OUg1LjMyQzQuMDM4OTEgNTAuNDkyIDIuODEyOTggNDkuOTc3NSAxLjkwOTkxIDQ5LjA2ODhDMS4wMDY4NCA0OC4xNjAxIDAuNDk5OTc1IDQ2LjkzMSAwLjUgNDUuNjQ5OVY0NS42NDk5WiIgc3Ryb2tlPSIjMDU3N0I2IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPHBhdGggZD0iTTI5LjYzIDQ1LjY0OTlINDlDNDkgNDYuMjk0NCA0OC43NDQgNDYuOTEyNSA0OC4yODgzIDQ3LjM2ODJDNDcuODMyNSA0Ny44MjM5IDQ3LjIxNDUgNDguMDc5OSA0Ni41NyA0OC4wNzk5SDMyLjA1QzMxLjQwNTUgNDguMDc5OSAzMC43ODc0IDQ3LjgyMzkgMzAuMzMxNyA0Ny4zNjgyQzI5Ljg3NiA0Ni45MTI1IDI5LjYyIDQ2LjI5NDQgMjkuNjIgNDUuNjQ5OVY0NS42NDk5SDI5LjYzWiIgc3Ryb2tlPSIjMDU3N0I2IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPHBhdGggZD0iTTMyLjU1IDM0LjA0OTlMMzIuMSAzNC4zMTk5QzMyLjAwNjQgMzQuMzk3OSAzMS44OTc4IDM0LjQ1NiAzMS43ODA5IDM0LjQ5MDNDMzEuNjY0IDM0LjUyNDcgMzEuNTQxMiAzNC41MzQ3IDMxLjQyMDMgMzQuNTE5N0MzMS4yOTkzIDM0LjUwNDcgMzEuMTgyOCAzNC40NjUgMzEuMDc3OCAzNC40MDMxQzMwLjk3MjggMzQuMzQxMiAzMC44ODE3IDM0LjI1ODQgMzAuODEgMzQuMTU5OUwyOC43NCAzMi4wODk5QzI4LjY0MzIgMzIuMDE5MSAyOC41NjE5IDMxLjkyOTQgMjguNTAxMSAzMS44MjYxQzI4LjQ0MDIgMzEuNzIyOSAyOC40MDExIDMxLjYwODMgMjguMzg2MSAzMS40ODk0QzI4LjM3MTEgMzEuMzcwNSAyOC4zODA2IDMxLjI0OTcgMjguNDEzOSAzMS4xMzQ2QzI4LjQ0NzMgMzEuMDE5NSAyOC41MDM4IDMwLjkxMjQgMjguNTggMzAuODE5OUMyOC45OSAzMC4xMzk5IDI5LjQgMjkuNDQ5OSAyOS44MiAyOC43Njk5QzI5Ljg1NDMgMjguNzEyNCAyOS44NzI1IDI4LjY0NjggMjkuODcyNSAyOC41Nzk5QzI5Ljg3MjUgMjguNTEyOSAyOS44NTQzIDI4LjQ0NzMgMjkuODIgMjguMzg5OUMyOS42MSAyNy45Mzk5IDI5LjQyIDI3LjQ3OTkgMjkuMjQgMjcuMDA5OUMyOS4yMTg0IDI2LjkzNzggMjkuMTc2OSAyNi44NzMzIDI5LjEyMDMgMjYuODIzOEMyOS4wNjM3IDI2Ljc3NDMgMjguOTk0MyAyNi43NDE3IDI4LjkyIDI2LjcyOTlMMjYuMSAyNS45OTk5QzI1Ljk4MjggMjUuOTg3OCAyNS44Njk0IDI1Ljk1MTkgMjUuNzY2NyAyNS44OTQyQzI1LjY2NDEgMjUuODM2NiAyNS41NzQzIDI1Ljc1ODUgMjUuNTAzMSAyNS42NjQ3QzI1LjQzMTggMjUuNTcxIDI1LjM4MDYgMjUuNDYzNiAyNS4zNTI1IDI1LjM0OTJDMjUuMzI0NSAyNS4yMzQ5IDI1LjMyMDIgMjUuMTE1OSAyNS4zNCAyNC45OTk5QzI1LjM0IDIzLjk5OTkgMjUuMzQgMjIuOTk5OSAyNS4zNCAyMS45OTk5QzI1LjMyMTcgMjEuODgzMiAyNS4zMjc0IDIxLjc2NDEgMjUuMzU2NiAyMS42NDk3QzI1LjM4NTkgMjEuNTM1MyAyNS40MzgxIDIxLjQyOCAyNS41MTAyIDIxLjMzNDVDMjUuNTgyMiAyMS4yNDA5IDI1LjY3MjUgMjEuMTYzIDI1Ljc3NTcgMjEuMTA1NUMyNS44Nzg4IDIxLjA0NzkgMjUuOTkyNSAyMS4wMTIgMjYuMTEgMjAuOTk5OUwyOC45NCAyMC4yOTk5QzI5LjAxMDkgMjAuMjkwMSAyOS4wNzc2IDIwLjI2MDUgMjkuMTMyNSAyMC4yMTQ1QzI5LjE4NzMgMjAuMTY4NiAyOS4yMjggMjAuMTA4IDI5LjI1IDIwLjAzOTlDMjkuMzkgMTkuNjM5OSAyOS41NiAxOS4yMzk5IDI5LjczIDE4Ljg0OTlDMjkuNzY0NSAxOC43OTQzIDI5Ljc4MjkgMTguNzMwMyAyOS43ODI5IDE4LjY2NDlDMjkuNzgyOSAxOC41OTk1IDI5Ljc2NDUgMTguNTM1NCAyOS43MyAxOC40Nzk5TDI4LjMgMTYuMjI5OUMyOC4xNjM4IDE2LjA0MzQgMjguMTA0NSAxNS44MTE4IDI4LjEzNDMgMTUuNTgyOUMyOC4xNjQgMTUuMzU0IDI4LjI4MDcgMTUuMTQ1MiAyOC40NiAxNC45OTk5TDMwLjUzIDEyLjkzOTlDMzAuNjAwNyAxMi44NDAxIDMwLjY5MTQgMTIuNzU2MSAzMC43OTY0IDEyLjY5MzNDMzAuOTAxNCAxMi42MzA2IDMxLjAxODMgMTIuNTkwNCAzMS4xMzk3IDEyLjU3NTNDMzEuMjYxMSAxMi41NjAzIDMxLjM4NDMgMTIuNTcwNyAzMS41MDE0IDEyLjYwNTlDMzEuNjE4NSAxMi42NDExIDMxLjcyNyAxMi43MDA0IDMxLjgyIDEyLjc3OTlDMzIuNTcgMTMuMjI5OSAzMy4zMSAxMy42Nzk5IDM0LjA3IDE0LjExOTlDMzQuMTI4NCAxNC4xNDQ5IDM0LjE5MTQgMTQuMTU3OCAzNC4yNTUgMTQuMTU3OEMzNC4zMTg2IDE0LjE1NzggMzQuMzgxNSAxNC4xNDQ5IDM0LjQ0IDE0LjExOTlDMzQuOTMgMTMuOTI5OSAzNS40NCAxMy42OTk5IDM1LjkgMTMuNTA5OUMzNS45NzAzIDEzLjQ4NCAzNi4wMzI1IDEzLjQzOTcgMzYuMDggMTMuMzgxN0MzNi4xMjc1IDEzLjMyMzYgMzYuMTU4NSAxMy4yNTQgMzYuMTcgMTMuMTc5OUMzNi40IDEyLjIzOTkgMzYuNjMgMTEuMjg5OSAzNi44NyAxMC4zNDk5QzM2Ljg4MiAxMC4yMzI3IDM2LjkxOCAxMC4xMTkzIDM2Ljk3NTYgMTAuMDE2NkMzNy4wMzMyIDkuOTEzOTQgMzcuMTExNCA5LjgyNDE5IDM3LjIwNTEgOS43NTI5NEMzNy4yOTg5IDkuNjgxNjkgMzcuNDA2MyA5LjYzMDQ1IDM3LjUyMDYgOS42MDIzOUMzNy42MzUgOS41NzQzNCAzNy43NTM5IDkuNTcwMDggMzcuODcgOS41ODk4Nkg0MC44N0M0MC45ODE3IDkuNTc1OTMgNDEuMDk1MSA5LjU4NDM0IDQxLjIwMzYgOS42MTQ2MUM0MS4zMTIxIDkuNjQ0ODggNDEuNDEzNCA5LjY5NjQgNDEuNTAxOCA5Ljc2NjE4QzQxLjU5MDIgOS44MzU5NiA0MS42NjM5IDkuOTIyNjEgNDEuNzE4NSAxMC4wMjExQzQxLjc3MzEgMTAuMTE5NiA0MS44MDc2IDEwLjIyNzkgNDEuODIgMTAuMzM5OUM0Mi4wNiAxMS4zMzk5IDQyLjMgMTIuMjQ5OSA0Mi41MiAxMy4yMDk5QzQyLjUzMzMgMTMuMjc5NyA0Mi41NjU2IDEzLjM0NDYgNDIuNjEzMiAxMy4zOTc1QzQyLjY2MDcgMTMuNDUwNCA0Mi43MjE5IDEzLjQ4OTIgNDIuNzkgMTMuNTA5OUM0My4yMyAxMy42Nzk5IDQzLjY3IDEzLjg1OTkgNDQuMSAxNC4wNDk5QzQ0LjE2NjggMTQuMDkzNyA0NC4yNDUgMTQuMTE3MSA0NC4zMjUgMTQuMTE3MUM0NC40MDQ5IDE0LjExNzEgNDQuNDgzMSAxNC4wOTM3IDQ0LjU1IDE0LjA0OTlDNDUuMjUgMTMuNjE5OSA0NS45NSAxMy4yMDk5IDQ2LjY2IDEyLjc4OTlDNDYuNzUyNiAxMi43MDY1IDQ2Ljg2MiAxMi42NDM3IDQ2Ljk4MDcgMTIuNjA1N0M0Ny4wOTk1IDEyLjU2NzggNDcuMjI0OSAxMi41NTU1IDQ3LjM0ODggMTIuNTY5N0M0Ny40NzI2IDEyLjU4MzkgNDcuNTkyMSAxMi42MjQyIDQ3LjY5OTIgMTIuNjg4QzQ3LjgwNjMgMTIuNzUxOCA0Ny44OTg2IDEyLjgzNzcgNDcuOTcgMTIuOTM5OUw0OS45NyAxNC45Mzk5QzUwLjA2OTggMTUuMDEwNiA1MC4xNTM3IDE1LjEwMTMgNTAuMjE2NSAxNS4yMDYzQzUwLjI3OTMgMTUuMzExMyA1MC4zMTk1IDE1LjQyODIgNTAuMzM0NSAxNS41NDk2QzUwLjM0OTYgMTUuNjcxIDUwLjMzOTIgMTUuNzk0MSA1MC4zMDM5IDE1LjkxMTNDNTAuMjY4NyAxNi4wMjg0IDUwLjIwOTUgMTYuMTM2OSA1MC4xMyAxNi4yMjk5QzQ5LjcgMTYuOTQ5OSA0OS4yNyAxNy42NTk5IDQ4Ljg1IDE4LjM4OTlDNDguODI0OSAxOC40NDgzIDQ4LjgxMiAxOC41MTEzIDQ4LjgxMiAxOC41NzQ5QzQ4LjgxMiAxOC42Mzg1IDQ4LjgyNDkgMTguNzAxNCA0OC44NSAxOC43NTk5QzQ5LjAyIDE5LjIxOTkgNDkuMjMgMTkuNjU5OSA0OS40MSAyMC4xMTk5QzQ5LjQzMTYgMjAuMTkxOSA0OS40NzMxIDIwLjI1NjQgNDkuNTI5NyAyMC4zMDU5QzQ5LjU4NjMgMjAuMzU1NCA0OS42NTU3IDIwLjM4OCA0OS43MyAyMC4zOTk5QzUwLjY1IDIwLjYwOTkgNTEuNTcgMjAuODU5OSA1Mi40OSAyMS4wNjk5QzUyLjY3OTggMjEuMDkzNCA1Mi44NTkgMjEuMTcxIDUzLjAwNjEgMjEuMjkzM0M1My4xNTMyIDIxLjQxNTYgNTMuMjYyMSAyMS41Nzc1IDUzLjMyIDIxLjc1OTlWMjUuMzY5OUM1My4yNjA1IDI1LjU1MDQgNTMuMTUwOSAyNS43MTAyIDUzLjAwMzkgMjUuODMwNkM1Mi44NTY5IDI1Ljk1MSA1Mi42Nzg2IDI2LjAyNzEgNTIuNDkgMjYuMDQ5OUw0OS43MyAyNi43Mjk5QzQ5LjY1NjUgMjYuNzM5OCA0OS41ODc0IDI2Ljc3MDUgNDkuNTMwNyAyNi44MTgzQzQ5LjQ3NCAyNi44NjYxIDQ5LjQzMjEgMjYuOTI5MSA0OS40MSAyNi45OTk5QzQ5LjI0IDI3LjQzOTkgNDkuMDUgMjcuODc5OSA0OC44NiAyOC4zMDk5QzQ4LjgyMDQgMjguMzY5MSA0OC43OTkzIDI4LjQzODcgNDguNzk5MyAyOC41MDk5QzQ4Ljc5OTMgMjguNTgxMSA0OC44MjA0IDI4LjY1MDcgNDguODYgMjguNzA5OUw1MC4xNCAzMC44Mzk5QzUwLjIxNDEgMzAuOTMwNiA1MC4yNjkzIDMxLjAzNTMgNTAuMzAyNCAzMS4xNDc2QzUwLjMzNTUgMzEuMjYgNTAuMzQ1OSAzMS4zNzc5IDUwLjMzMjggMzEuNDk0M0M1MC4zMTk4IDMxLjYxMDcgNTAuMjgzNiAzMS43MjM0IDUwLjIyNjUgMzEuODI1NkM1MC4xNjkzIDMxLjkyNzkgNTAuMDkyMyAzMi4wMTc3IDUwIDMyLjA4OTlMNDcuOTEgMzQuMTY5OUM0Ny44Mzg0IDM0LjI2NTUgNDcuNzQ4MiAzNC4zNDU3IDQ3LjY0NSAzNC40MDU3QzQ3LjU0MTcgMzQuNDY1NyA0Ny40Mjc0IDM0LjUwNDQgNDcuMzA4OSAzNC41MTkzQzQ3LjE5MDQgMzQuNTM0MiA0Ny4wNzAxIDM0LjUyNTEgNDYuOTU1MiAzNC40OTI2QzQ2Ljg0MDMgMzQuNDYwMSA0Ni43MzMxIDM0LjQwNDcgNDYuNjQgMzQuMzI5OUw0Ni4yNyAzNC4wOTk5IiBzdHJva2U9IndoaXRlIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPHBhdGggZD0iTTM5LjM0IDE3LjgxOThWMTguODE5OEM0MC4yNzY2IDE4LjgyMTggNDEuMTkxNyAxOS4xMDEyIDQxLjk2OTYgMTkuNjIyOEM0Mi43NDc2IDIwLjE0NDQgNDMuMzUzNSAyMC44ODQ4IDQzLjcxMTEgMjEuNzUwNUM0NC4wNjg2IDIyLjYxNjIgNDQuMTYxNiAyMy41Njg1IDQzLjk3ODQgMjQuNDg3QzQzLjc5NTIgMjUuNDA1NSA0My4zNDQgMjYuMjQ5MiA0Mi42ODE3IDI2LjkxMTVDNDIuMDE5NCAyNy41NzM4IDQxLjE3NTcgMjguMDI1IDQwLjI1NzEgMjguMjA4MkMzOS4zMzg2IDI4LjM5MTUgMzguMzg2NCAyOC4yOTg0IDM3LjUyMDcgMjcuOTQwOUMzNi42NTUgMjcuNTgzNCAzNS45MTQ2IDI2Ljk3NzQgMzUuMzkzIDI2LjE5OTVDMzQuODcxNCAyNS40MjE1IDM0LjU5MiAyNC41MDY1IDM0LjU5IDIzLjU2OThDMzQuNTkgMjIuMzEgMzUuMDkwNCAyMS4xMDE5IDM1Ljk4MTIgMjAuMjExMUMzNi44NzIgMTkuMzIwMyAzOC4wODAyIDE4LjgxOTggMzkuMzQgMTguODE5OFYxNy44MTk4Wk0zOS4zNCAxNy44MTk4QzM3LjgxNzYgMTcuODE5OCAzNi4zNTc2IDE4LjQyNDYgMzUuMjgxMiAxOS41MDFDMzQuMjA0NyAyMC41Nzc1IDMzLjYgMjIuMDM3NSAzMy42IDIzLjU1OThDMzMuNiAyNS4wODIyIDM0LjIwNDcgMjYuNTQyMiAzNS4yODEyIDI3LjYxODZDMzYuMzU3NiAyOC42OTUxIDM3LjgxNzYgMjkuMjk5OCAzOS4zNCAyOS4yOTk4QzQwLjg2MjMgMjkuMjk5OCA0Mi4zMjIzIDI4LjY5NTEgNDMuMzk4OCAyNy42MTg2QzQ0LjQ3NTIgMjYuNTQyMiA0NS4wOCAyNS4wODIyIDQ1LjA4IDIzLjU1OThDNDUuMDggMjIuMDM3NSA0NC40NzUyIDIwLjU3NzUgNDMuMzk4OCAxOS41MDFDNDIuMzIyMyAxOC40MjQ2IDQwLjg2MjMgMTcuODE5OCAzOS4zNCAxNy44MTk4WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTM5LjMzIDI5LjMzMDFDNDEuMDU0NyAyOS4zMzMzIDQyLjcxMjIgMjkuOTk5NCA0My45NTkzIDMxLjE5MDhDNDUuMjA2NSAzMi4zODIxIDQ1Ljk0NzkgMzQuMDA3MyA0Ni4wMyAzNS43MzAxSDMyLjY0QzMyLjcxOTYgMzQuMDA4MiAzMy40NTg5IDMyLjM4MyAzNC43MDQ0IDMxLjE5MTVDMzUuOTUgMjkuOTk5OSAzNy42MDYzIDI5LjMzMzQgMzkuMzMgMjkuMzMwMVpNMzkuMzMgMjguMzMwMUMzNy4yODc4IDI4LjMzMDEgMzUuMzI5MyAyOS4xNDEzIDMzLjg4NTMgMzAuNTg1NEMzMi40NDEzIDMyLjAyOTQgMzEuNjMgMzMuOTg3OSAzMS42MyAzNi4wMzAxQzMxLjYzIDM2LjI3MDEgMzEuNjMgMzYuNTAwMSAzMS42MyAzNi43MzAxSDQ3QzQ3IDM2LjUwMDEgNDcgMzYuMjcwMSA0NyAzNi4wMzAxQzQ3IDMzLjk4NzkgNDYuMTg4OCAzMi4wMjk0IDQ0Ljc0NDcgMzAuNTg1NEM0My4zMDA3IDI5LjE0MTMgNDEuMzQyMiAyOC4zMzAxIDM5LjMgMjguMzMwMUgzOS4zM1oiIGZpbGw9IndoaXRlIi8+CjwvZz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhciIgeDE9IjE1LjAyIiB5MT0iNDguMzI5OSIgeDI9IjYzLjY1IiB5Mj0iLTAuMjkwMDk2IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiM2NzZGRjIiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMEE4QUVDIi8+CjwvbGluZWFyR3JhZGllbnQ+CjxjbGlwUGF0aCBpZD0iY2xpcDAiPgo8cmVjdCB3aWR0aD0iNzguNjciIGhlaWdodD0iNTEiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+';

var httpsPlaceHolder = 'data:image/svg+xml;base64,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';

var desktopPlaceHolder = 'data:image/svg+xml;base64,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';

var rdpPlaceHolder = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNSAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjcgMUgyLjNDMS41ODIwMyAxIDEgMS41NzcyNyAxIDIuMjg5MzhWOC43MzYyNkMxIDkuNDQ4MzcgMS41ODIwMyAxMC4wMjU2IDIuMyAxMC4wMjU2SDEyLjdDMTMuNDE4IDEwLjAyNTYgMTQgOS40NDgzNyAxNCA4LjczNjI2VjIuMjg5MzhDMTQgMS41NzcyNyAxMy40MTggMSAxMi43IDFaIiBzdHJva2U9IiMwMDA4NTAiIHN0cm9rZS13aWR0aD0iMS4xMTM4NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00LjkwMDE1IDEzSDEwLjEwMDEiIHN0cm9rZT0iIzAwMDg1MCIgc3Ryb2tlLXdpZHRoPSIxLjExMzg1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTcuNDk5NzYgMTAuNDIxNFYxMy4wMDAxIiBzdHJva2U9IiMwMDA4NTAiIHN0cm9rZS13aWR0aD0iMS4xMTM4NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik05LjYwMDEgNkw4LjEwMDEgNC41TDkuNjAwMSAzIiBzdHJva2U9IiMwMDA4NTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNS42MDAxIDVMNy4xMDAxIDYuNUw1LjYwMDEgOCIgc3Ryb2tlPSIjMDAwODUwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+';

var recordingsPlaceHolder = 'data:image/svg+xml;base64,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';

var smbPlaceHolder = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNyAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjUgMUgyLjVDMS42NzE1NyAxIDEgMS43Njc1MSAxIDIuNzE0MjlWMTEuMjg1N0MxIDEyLjIzMjUgMS42NzE1NyAxMyAyLjUgMTNIMTQuNUMxNS4zMjg0IDEzIDE2IDEyLjIzMjUgMTYgMTEuMjg1N1YyLjcxNDI5QzE2IDEuNzY3NTEgMTUuMzI4NCAxIDE0LjUgMVoiIHN0cm9rZT0iIzAwMDg1MCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNCAxMC4yTDE0IDMuOEMxNCAzLjM1ODE3IDEzLjY2NDIgMyAxMy4yNSAzTDExLjc1IDNDMTEuMzM1OCAzIDExIDMuMzU4MTcgMTEgMy44TDExIDEwLjJDMTEgMTAuNjQxOCAxMS4zMzU4IDExIDExLjc1IDExTDEzLjI1IDExQzEzLjY2NDIgMTEgMTQgMTAuNjQxOCAxNCAxMC4yWiIgc3Ryb2tlPSIjMDAwODUwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTkgMTAuMkw5IDMuOEM5IDMuMzU4MTcgOC42NjQyMSAzIDguMjUgM0w2Ljc1IDNDNi4zMzU3OSAzIDYgMy4zNTgxNyA2IDMuOEw2IDEwLjJDNiAxMC42NDE4IDYuMzM1NzkgMTEgNi43NSAxMUw4LjI1IDExQzguNjY0MjEgMTEgOSAxMC42NDE4IDkgMTAuMloiIHN0cm9rZT0iIzAwMDg1MCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00IDQuOUw0IDQuMUM0IDQuMDQ0NzcgMy44ODgwNyA0IDMuNzUgNEwzLjI1IDRDMy4xMTE5MyA0IDMgNC4wNDQ3NyAzIDQuMUwzIDQuOUMzIDQuOTU1MjMgMy4xMTE5MyA1IDMuMjUgNUwzLjc1IDVDMy44ODgwNyA1IDQgNC45NTUyMyA0IDQuOVoiIHN0cm9rZT0iIzAwMDg1MCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00IDcuOUw0IDcuMUM0IDcuMDQ0NzcgMy44ODgwNyA3IDMuNzUgN0wzLjI1IDdDMy4xMTE5MyA3IDMgNy4wNDQ3NyAzIDcuMUwzIDcuOUMzIDcuOTU1MjMgMy4xMTE5MyA4IDMuMjUgOEwzLjc1IDhDMy44ODgwNyA4IDQgNy45NTUyMyA0IDcuOVoiIHN0cm9rZT0iIzAwMDg1MCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==';

var sshPlaceHolder = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjQgNEgzLjZDMi43MTYzNCA0IDIgNC43NTQ5NSAyIDUuNjg2MjRWMTQuMTE3NEMyIDE1LjA0ODcgMi43MTYzNCAxNS44MDM2IDMuNiAxNS44MDM2SDE2LjRDMTcuMjgzNyAxNS44MDM2IDE4IDE1LjA0ODcgMTggMTQuMTE3NFY1LjY4NjI0QzE4IDQuNzU0OTUgMTcuMjgzNyA0IDE2LjQgNFoiIHN0cm9rZT0iIzAwMDg1MCIgc3Ryb2tlLXdpZHRoPSIxLjExMzg1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTUuOTU3MDMgMTEuOTUwNEw4LjMwOTk3IDkuNDkxMzJMNS45NTcwMyA3LjAzMjIzIiBzdHJva2U9IiMwMDA4NTAiIHN0cm9rZS13aWR0aD0iMS4xMTM4NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMC4wOTQyIDEyLjc3MDVIMTMuMjMxNSIgc3Ryb2tlPSIjMDAwODUwIiBzdHJva2Utd2lkdGg9IjEuMTEzODUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';

var supervisorPlaceHolder = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzkiIGhlaWdodD0iNTEiIHZpZXdCb3g9IjAgMCA3OSA1MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CjxwYXRoIGQ9Ik0xMC44NCAwLjVINjcuODRDNjkuMTY2IDAuNSA3MC40Mzc4IDEuMDI2NzggNzEuMzc1NSAxLjk2NDQ3QzcyLjMxMzIgMi45MDIxNSA3Mi44NCA0LjE3MzkyIDcyLjg0IDUuNVY0NS42NUg1LjgzOTk3VjUuNUM1LjgzOTk3IDQuMTczOTIgNi4zNjY3NSAyLjkwMjE1IDcuMzA0NDMgMS45NjQ0N0M4LjI0MjExIDEuMDI2NzggOS41MTM4OCAwLjUgMTAuODQgMC41VjAuNVoiIHN0cm9rZT0iIzA1NzdCNiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+CjxwYXRoIGQ9Ik0xMi4zMyAzLjY0OTlINjYuMzNDNjcuMTI1NiAzLjY0OTkgNjcuODg4NyAzLjk2NTk3IDY4LjQ1MTMgNC41Mjg1OEM2OS4wMTM5IDUuMDkxMTkgNjkuMzMgNS44NTQyNSA2OS4zMyA2LjY0OTlWNDIuNjQ5OUg5LjMyOTk2VjYuNjQ5OUM5LjMyOTk2IDUuODU0MjUgOS42NDYwMyA1LjA5MTE5IDEwLjIwODYgNC41Mjg1OEMxMC43NzEyIDMuOTY1OTcgMTEuNTM0MyAzLjY0OTkgMTIuMzMgMy42NDk5WiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyKSIvPgo8cGF0aCBvcGFjaXR5PSIwLjEiIGQ9Ik05LjMyOTk2IDQyLjY0OTlWNi42NDk5QzkuMzI5OTYgNS44NTQyNSA5LjY0NjAzIDUuMDkxMTkgMTAuMjA4NiA0LjUyODU4QzEwLjc3MTIgMy45NjU5NyAxMS41MzQzIDMuNjQ5OSAxMi4zMyAzLjY0OTlINjYuMzNDNjcuMDk0NyAzLjc4MTY4IDY3LjgyMTYgNC4wNzg1NyA2OC40NiA0LjUxOTlMOS4zMjk5NiA0Mi42NDk5WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTAuNSA0NS42NDk5SDc4LjE3Qzc4LjE3IDQ2LjkzNjIgNzcuNjU5IDQ4LjE2OTggNzYuNzQ5NSA0OS4wNzk0Qzc1LjgzOTkgNDkuOTg4OSA3NC42MDYzIDUwLjQ5OTkgNzMuMzIgNTAuNDk5OUg1LjMyQzQuMDM4OTEgNTAuNDkyIDIuODEyOTggNDkuOTc3NSAxLjkwOTkxIDQ5LjA2ODhDMS4wMDY4NCA0OC4xNjAxIDAuNDk5OTc1IDQ2LjkzMSAwLjUgNDUuNjQ5OVY0NS42NDk5WiIgc3Ryb2tlPSIjMDU3N0I2IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPHBhdGggZD0iTTI5LjYzMDEgNDUuNjQ5OUg0OS4wMDAxQzQ5LjAwMDEgNDYuMjk0NCA0OC43NDQxIDQ2LjkxMjUgNDguMjg4NCA0Ny4zNjgyQzQ3LjgzMjcgNDcuODIzOSA0Ny4yMTQ2IDQ4LjA3OTkgNDYuNTcwMSA0OC4wNzk5SDMyLjA1MDFDMzEuNDA1NiA0OC4wNzk5IDMwLjc4NzYgNDcuODIzOSAzMC4zMzE4IDQ3LjM2ODJDMjkuODc2MSA0Ni45MTI1IDI5LjYyMDEgNDYuMjk0NCAyOS42MjAxIDQ1LjY0OTlWNDUuNjQ5OUgyOS42MzAxWiIgc3Ryb2tlPSIjMDU3N0I2IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPHBhdGggZD0iTTI0LjMzMDEgMjguNTc5OEMyNS41OTUxIDI1LjY1MTcgMjcuNjg5NSAyMy4xNTc4IDMwLjM1NDkgMjEuNDA1OEMzMy4wMjA0IDE5LjY1MzggMzYuMTQwNCAxOC43MjAyIDM5LjMzMDEgMTguNzIwMkM0Mi41MTk4IDE4LjcyMDIgNDUuNjM5NyAxOS42NTM4IDQ4LjMwNTIgMjEuNDA1OEM1MC45NzA3IDIzLjE1NzggNTMuMDY1MSAyNS42NTE3IDU0LjMzMDEgMjguNTc5OCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTM5Ljg4MDEgMTMuMjdWMTAiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNi44ODAxIDE4LjIyOTlMMjQuNTgwMSAxNS45MTk5IiBzdHJva2U9IndoaXRlIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNNTEuNzkgMTguMjI5OUw1NC4xIDE1LjkxOTkiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0zOS4zNDAyIDMzLjQwOTlDNDIuMDQ2NCAzMy40MDk5IDQ0LjI0MDIgMzEuMjE2MSA0NC4yNDAyIDI4LjUwOTlDNDQuMjQwMiAyNS44MDM3IDQyLjA0NjQgMjMuNjA5OSAzOS4zNDAyIDIzLjYwOTlDMzYuNjM0IDIzLjYwOTkgMzQuNDQwMiAyNS44MDM3IDM0LjQ0MDIgMjguNTA5OUMzNC40NDAyIDMxLjIxNjEgMzYuNjM0IDMzLjQwOTkgMzkuMzQwMiAzMy40MDk5WiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9nPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyIiB4MT0iMTUuMDIiIHkxPSI0OC4zMjk5IiB4Mj0iNjMuNjUiIHkyPSItMC4yOTAwOTYiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzY3NkZGMiIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMwQThBRUMiLz4KPC9saW5lYXJHcmFkaWVudD4KPGNsaXBQYXRoIGlkPSJjbGlwMCI+CjxyZWN0IHdpZHRoPSI3OC42NyIgaGVpZ2h0PSI1MSIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4=';

var vncPlaceHolder = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxNCAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjk2NTYgMC44NjY2OTlIMi4xMDcyOUMxLjQyNjcxIDAuODY2Njk5IDAuODc1IDEuNDA4NjkgMC44NzUgMi4wNzcyOFY4LjEzMDE4QzAuODc1IDguNzk4NzYgMS40MjY3MSA5LjM0MDc2IDIuMTA3MjkgOS4zNDA3NkgxMS45NjU2QzEyLjY0NjIgOS4zNDA3NiAxMy4xOTc5IDguNzk4NzYgMTMuMTk3OSA4LjEzMDE4VjIuMDc3MjhDMTMuMTk3OSAxLjQwODY5IDEyLjY0NjIgMC44NjY2OTkgMTEuOTY1NiAwLjg2NjY5OVoiIHN0cm9rZT0iIzAwMDg1MCIgc3Ryb2tlLXdpZHRoPSIxLjExMzg1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTQuNTcyMDIgMTIuMTMzM0g5LjUwMTE4IiBzdHJva2U9IiMwMDA4NTAiIHN0cm9rZS13aWR0aD0iMS4xMTM4NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik03LjAzNjEzIDkuNzEyNFYxMi4xMzM2IiBzdHJva2U9IiMwMDA4NTAiIHN0cm9rZS13aWR0aD0iMS4xMTM4NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==';

var protocols = {
  HTTP: 'http',
  HTTPS: 'https',
  SSH: 'ssh',
  TELNET: 'telnet',
  RDP: 'rdp',
  VNC: 'vnc',
  SMB: 'smb'
};

var placeholderGetter = function placeholderGetter(protocol, name) {
  var lowercaseName = name.toLowerCase(); // handle specific apps

  switch (lowercaseName) {
    case 'desktop':
      return desktopPlaceHolder;

    case 'console':
      return adminPlaceHolder;

    case 'supervisor':
      return supervisorPlaceHolder;

    case 'recordings':
      return recordingsPlaceHolder;
  }

  var lowercaseProtocol = protocol.toLowerCase();

  switch (lowercaseProtocol) {
    case protocols.HTTP:
      return httpsPlaceHolder;

    case protocols.HTTPS:
      return httpsPlaceHolder;

    case protocols.SSH:
      return sshPlaceHolder;

    case protocols.TELNET:
      return sshPlaceHolder;

    case protocols.RDP:
      return rdpPlaceHolder;

    case protocols.VNC:
      return vncPlaceHolder;

    case protocols.SMB:
      return smbPlaceHolder;

    default:
      return httpsPlaceHolder;
  }
};

var Ratio = {
  Text: 0.085,
  PinIcon: 0.09,
  Image: 0.22,
  Height: 0.7142857143
};

var AppCard = /*#__PURE__*/function (_Component) {
  _inherits$1(AppCard, _Component);

  var _super = _createSuper$1(AppCard);

  function AppCard(props) {
    var _this;

    _classCallCheck$4(this, AppCard);

    _this = _super.call(this, props); // added seemless debounce for performance

    _this.handleWindowResize = debounce_1$1(function () {
      var _a;

      _this.setState({
        computedCardWidth: (_a = _this.inputRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth
      });
    }, 10);
    _this.state = {
      computedCardWidth: 0
    };
    _this.inputRef = /*#__PURE__*/createRef();
    return _this;
  }

  _createClass$1(AppCard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _a;

      this.setState({
        computedCardWidth: (_a = this.inputRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth
      });
      window.addEventListener('resize', this.handleWindowResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleWindowResize);
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          protocol = _a.protocol,
          name = _a.name,
          _a$iconUrl = _a.iconUrl,
          iconUrl = _a$iconUrl === void 0 ? '' : _a$iconUrl,
          _a$pinned = _a.pinned,
          pinned = _a$pinned === void 0 ? false : _a$pinned,
          showPin = _a.showPin,
          onPinClick = _a.onPinClick,
          className = _a.className,
          style = _a.style,
          rest = __rest(_a, ["protocol", "name", "iconUrl", "pinned", "showPin", "onPinClick", "className", "style"]);

      var computedCardWidth = this.state.computedCardWidth;
      var icon = iconUrl || placeholderGetter(protocol, name);
      return /*#__PURE__*/React__default.createElement("div", Object.assign({}, rest, {
        style: Object.assign({
          width: 182,
          height: 'fit-content'
        }, style),
        className: className,
        ref: this.inputRef
      }), /*#__PURE__*/React__default.createElement(Card, {
        style: Object.assign(Object.assign({}, cardStyle$1), {
          width: '100%',
          height: computedCardWidth * Ratio.Height
        })
      }, showPin && /*#__PURE__*/React__default.createElement(IconSwitch, {
        style: {
          position: 'absolute',
          right: '5%',
          top: '6%'
        },
        icons: [/*#__PURE__*/React__default.createElement(Icon, {
          size: computedCardWidth * Ratio.PinIcon,
          id: "pin-active",
          key: "pin-active"
        }), /*#__PURE__*/React__default.createElement(Icon, {
          size: computedCardWidth * Ratio.PinIcon,
          id: "pin-inactive",
          key: "pin-inactive"
        })],
        enabled: pinned,
        onClick: function onClick(e) {
          e.stopPropagation();
          onPinClick();
        }
      }), /*#__PURE__*/React__default.createElement(Image, {
        src: icon,
        style: {
          height: computedCardWidth * Ratio.Image,
          width: computedCardWidth * Ratio.Image,
          marginBottom: '7%',
          marginTop: '3%'
        },
        alt: ""
      }), /*#__PURE__*/React__default.createElement(Text$1, {
        variant: "header-2",
        style: {
          fontSize: computedCardWidth * Ratio.Text
        }
      }, name)));
    }
  }]);

  return AppCard;
}(Component);

var cardStyle$1 = {
  padding: 'none',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
  boxShadow: '0px 6.77214px 14.5117px rgba(0, 41, 146, 0.07)',
  cursor: 'pointer'
};

var ContextMenu = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children,
      refElement = _ref.refElement;

  var _useState = useState(null),
      _useState2 = _slicedToArray$1(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$1(_useState3, 2),
      contextMenuOpened = _useState4[0],
      setContextMenuOpened = _useState4[1];

  var styles = useStyles$C();

  var _useDropdownPopper = useDropdownPopper$1({
    parentRefElement: anchorEl,
    visible: contextMenuOpened,
    offsetValue: 0,
    placement: 'bottom-start',
    sameWidth: false,
    onVisibilityChange: function onVisibilityChange(isVisible) {
      setContextMenuOpened(isVisible);
    },
    enableEventListeners: false
  }),
      attributes = _useDropdownPopper.attributes,
      setPopperElement = _useDropdownPopper.setPopperElement,
      popperStyles = _useDropdownPopper.styles;

  var handleOnContext = useCallback(function (e) {
    e.preventDefault();
    var clientX = e.clientX,
        clientY = e.clientY;
    setContextMenuOpened(true);
    var virtualElement = {
      getBoundingClientRect: function getBoundingClientRect() {
        return {
          width: 0,
          height: 0,
          top: clientY,
          right: clientX,
          bottom: clientY,
          left: clientX,
          x: clientX,
          y: clientY,
          toJSON: function toJSON() {}
        };
      }
    };
    setAnchorEl(virtualElement);
  }, [refElement]);
  useImperativeHandle(forwardedRef, function () {
    return {
      close: function close() {
        return setContextMenuOpened(false);
      }
    };
  });
  useEffect(function () {
    refElement === null || refElement === void 0 ? void 0 : refElement.addEventListener('contextmenu', handleOnContext);
    return function () {
      refElement === null || refElement === void 0 ? void 0 : refElement.removeEventListener('contextmenu', handleOnContext);
    };
  }, [handleOnContext, refElement]);

  if (!contextMenuOpened) {
    return null;
  }

  return refElement && /*#__PURE__*/createPortal( /*#__PURE__*/React__default.createElement(Card, Object.assign({
    className: styles.card,
    style: popperStyles.popper,
    ref: setPopperElement
  }, attributes.popper), children), document.body);
});
ContextMenu.displayName = 'ContextMenu';
var useStyles$C = createUseStyles(function (theme) {
  return {
    card: {
      minWidth: 160,
      padding: '16px 24px',
      zIndex: theme.zIndex.max
    }
  };
});

var useStyles$B = createUseStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '16px',
      marginTop: '16px',
      marginBottom: '16px'
    },
    icon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '53px',
      height: '53px',
      background: theme.palette.white.color,
      boxShadow: '0px 1px 15px rgba(0, 41, 146, 0.07)',
      borderRadius: '4px'
    }
  };
});

var DeleteModal = function DeleteModal(_ref) {
  var title = _ref.title,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? '' : _ref$icon,
      name = _ref.name,
      acceptButtonText = _ref.acceptButtonText,
      cancelButtonText = _ref.cancelButtonText,
      onAccept = _ref.onAccept,
      onCancel = _ref.onCancel;
  var theme = useThemeSafe();
  var styles = useStyles$B({
    theme: theme
  });
  return /*#__PURE__*/React__default.createElement(Dialog, {
    title: title,
    acceptButtonText: acceptButtonText,
    onAccept: onAccept,
    cancelButtonText: cancelButtonText,
    onCancel: onCancel
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.root
  }, icon && /*#__PURE__*/React__default.createElement("div", {
    className: styles.icon
  }, /*#__PURE__*/React__default.createElement("img", {
    src: icon,
    height: 35,
    width: 35,
    alt: "icon"
  })), /*#__PURE__*/React__default.createElement(Text$1, {
    variant: "subnav-header"
  }, name)));
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

function createCommonjsModule$1(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var mapToZero_1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;
exports['default'] = mapToZero;

function mapToZero(obj) {
  var ret = {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      ret[key] = 0;
    }
  }
  return ret;
}

module.exports = exports['default'];
});

var stripStyle_1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;
exports['default'] = stripStyle;

function stripStyle(style) {
  var ret = {};
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }
    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
  }
  return ret;
}

module.exports = exports['default'];
});

var stepper_1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;
exports["default"] = stepper;

var reusedTuple = [0, 0];

function stepper(secondPerFrame, x, v, destX, k, b, precision) {
  // Spring stiffness, in kg / s^2

  // for animations, destX is really spring length (spring at rest). initial
  // position is considered as the stretched/compressed position of a spring
  var Fspring = -k * (x - destX);

  // Damping, in kg / s
  var Fdamper = -b * v;

  // usually we put mass here, but for animation purposes, specifying mass is a
  // bit redundant. you could simply adjust k and b accordingly
  // let a = (Fspring + Fdamper) / mass;
  var a = Fspring + Fdamper;

  var newV = v + a * secondPerFrame;
  var newX = x + newV * secondPerFrame;

  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
    reusedTuple[0] = destX;
    reusedTuple[1] = 0;
    return reusedTuple;
  }

  reusedTuple[0] = newX;
  reusedTuple[1] = newV;
  return reusedTuple;
}

module.exports = exports["default"];
// array reference around.
});

var performanceNow$1 = createCommonjsModule$1(function (module) {
// Generated by CoffeeScript 1.7.1
(function() {
  var getNanoSeconds, hrtime, loadTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - loadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    loadTime = getNanoSeconds();
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(commonjsGlobal);
});

var performanceNow = createCommonjsModule$1(function (module) {
// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(commonjsGlobal);


});

var root$1 = typeof window === 'undefined' ? commonjsGlobal : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root$1['request' + suffix]
  , caf = root$1['cancel' + suffix] || root$1['cancelRequest' + suffix];

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root$1[vendors[i] + 'Request' + suffix];
  caf = root$1[vendors[i] + 'Cancel' + suffix]
      || root$1[vendors[i] + 'CancelRequest' + suffix];
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id$1 = 0
    , queue = []
    , frameDuration = 1000 / 60;

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = performanceNow()
        , next = Math.max(0, frameDuration - (_now - last));
      last = next + _now;
      setTimeout(function() {
        var cp = queue.slice(0);
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0;
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last);
            } catch(e) {
              setTimeout(function() { throw e }, 0);
            }
          }
        }
      }, Math.round(next));
    }
    queue.push({
      handle: ++id$1,
      callback: callback,
      cancelled: false
    });
    return id$1
  };

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true;
      }
    }
  };
}

var raf_1 = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root$1, fn)
};
var cancel = function() {
  caf.apply(root$1, arguments);
};
var polyfill$1 = function(object) {
  if (!object) {
    object = root$1;
  }
  object.requestAnimationFrame = raf;
  object.cancelAnimationFrame = caf;
};
raf_1.cancel = cancel;
raf_1.polyfill = polyfill$1;

var shouldStopAnimation_1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;
exports['default'] = shouldStopAnimation;

function shouldStopAnimation(currentStyle, style, currentVelocity) {
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }

    if (currentVelocity[key] !== 0) {
      return false;
    }

    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
    // stepper will have already taken care of rounding precision errors, so
    // won't have such thing as 0.9999 !=== 1
    if (currentStyle[key] !== styleValue) {
      return false;
    }
  }

  return true;
}

module.exports = exports['default'];
});

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d$1=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g$3=b?Symbol.for("react.profiler"):60114,h$2=b?Symbol.for("react.provider"):60109,k$1=b?Symbol.for("react.context"):60110,l$1=b?Symbol.for("react.async_mode"):60111,m$5=b?Symbol.for("react.concurrent_mode"):60111,n$3=b?Symbol.for("react.forward_ref"):60112,p$7=b?Symbol.for("react.suspense"):60113,q$8=b?
Symbol.for("react.suspense_list"):60120,r$a=b?Symbol.for("react.memo"):60115,t$8=b?Symbol.for("react.lazy"):60116,v$7=b?Symbol.for("react.block"):60121,w$7=b?Symbol.for("react.fundamental"):60117,x$4=b?Symbol.for("react.responder"):60118,y$6=b?Symbol.for("react.scope"):60119;
function z$8(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l$1:case m$5:case e:case g$3:case f:case p$7:return a;default:switch(a=a&&a.$$typeof,a){case k$1:case n$3:case t$8:case r$a:case h$2:return a;default:return u}}case d$1:return u}}}function A$6(a){return z$8(a)===m$5}var AsyncMode=l$1;var ConcurrentMode=m$5;var ContextConsumer=k$1;var ContextProvider=h$2;var Element$1=c;var ForwardRef=n$3;var Fragment=e;var Lazy=t$8;var Memo=r$a;var Portal=d$1;
var Profiler=g$3;var StrictMode=f;var Suspense=p$7;var isAsyncMode=function(a){return A$6(a)||z$8(a)===l$1};var isConcurrentMode=A$6;var isContextConsumer=function(a){return z$8(a)===k$1};var isContextProvider=function(a){return z$8(a)===h$2};var isElement$1=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z$8(a)===n$3};var isFragment=function(a){return z$8(a)===e};var isLazy=function(a){return z$8(a)===t$8};
var isMemo=function(a){return z$8(a)===r$a};var isPortal=function(a){return z$8(a)===d$1};var isProfiler=function(a){return z$8(a)===g$3};var isStrictMode=function(a){return z$8(a)===f};var isSuspense=function(a){return z$8(a)===p$7};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m$5||a===g$3||a===f||a===p$7||a===q$8||"object"===typeof a&&null!==a&&(a.$$typeof===t$8||a.$$typeof===r$a||a.$$typeof===h$2||a.$$typeof===k$1||a.$$typeof===n$3||a.$$typeof===w$7||a.$$typeof===x$4||a.$$typeof===y$6||a.$$typeof===v$7)};var typeOf=z$8;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element$1,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement$1,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var reactIs_development = createCommonjsModule$1(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});

var reactIs = createCommonjsModule$1(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$9 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty$9.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$2 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$2;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;

var has$1 = has$2;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$2 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = ReactPropTypesSecret$1;
  var loggedTypeFailures = {};
  var has = has$1;

  printWarning$2 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$2(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$2(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

var checkPropTypes = checkPropTypes_1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */








var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$1(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has$1(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has$1(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret$1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var require$$1 = factoryWithTypeCheckers;

var require$$2 = factoryWithThrowingShims;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var propTypes = createCommonjsModule$1(function (module) {
if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require$$1(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = require$$2();
}
});

var _propTypes = propTypes;

var Motion_1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var _mapToZero2 = _interopRequireDefault(mapToZero_1);



var _stripStyle2 = _interopRequireDefault(stripStyle_1);



var _stepper4 = _interopRequireDefault(stepper_1);



var _performanceNow2 = _interopRequireDefault(performanceNow$1);



var _raf2 = _interopRequireDefault(raf_1);



var _shouldStopAnimation2 = _interopRequireDefault(shouldStopAnimation_1);



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

var Motion = (function (_React$Component) {
  _inherits(Motion, _React$Component);

  _createClass(Motion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
      children: _propTypes2['default'].func.isRequired,
      onRest: _propTypes2['default'].func
    },
    enumerable: true
  }]);

  function Motion(props) {
    var _this = this;

    _classCallCheck(this, Motion);

    _React$Component.call(this, props);
    this.wasAnimating = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyle = null;

    this.clearUnreadPropStyle = function (destStyle) {
      var dirty = false;
      var _state = _this.state;
      var currentStyle = _state.currentStyle;
      var currentVelocity = _state.currentVelocity;
      var lastIdealStyle = _state.lastIdealStyle;
      var lastIdealVelocity = _state.lastIdealVelocity;

      for (var key in destStyle) {
        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
          continue;
        }

        var styleValue = destStyle[key];
        if (typeof styleValue === 'number') {
          if (!dirty) {
            dirty = true;
            currentStyle = _extends({}, currentStyle);
            currentVelocity = _extends({}, currentVelocity);
            lastIdealStyle = _extends({}, lastIdealStyle);
            lastIdealVelocity = _extends({}, lastIdealVelocity);
          }

          currentStyle[key] = styleValue;
          currentVelocity[key] = 0;
          lastIdealStyle[key] = styleValue;
          lastIdealVelocity[key] = 0;
        }
      }

      if (dirty) {
        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // check if we need to animate in the first place
        var propsStyle = _this.props.style;
        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
          if (_this.wasAnimating && _this.props.onRest) {
            _this.props.onRest();
          }

          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.wasAnimating = false;
          _this.accumulatedTime = 0;
          return;
        }

        _this.wasAnimating = true;

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyle = {};
        var newLastIdealVelocity = {};
        var newCurrentStyle = {};
        var newCurrentVelocity = {};

        for (var key in propsStyle) {
          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
            continue;
          }

          var styleValue = propsStyle[key];
          if (typeof styleValue === 'number') {
            newCurrentStyle[key] = styleValue;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = styleValue;
            newLastIdealVelocity[key] = 0;
          } else {
            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
            for (var i = 0; i < framesToCatchUp; i++) {
              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              newLastIdealStyleValue = _stepper[0];
              newLastIdealVelocityValue = _stepper[1];
            }

            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            var nextIdealX = _stepper2[0];
            var nextIdealV = _stepper2[1];

            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
          }
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyle: newCurrentStyle,
          currentVelocity: newCurrentVelocity,
          lastIdealStyle: newLastIdealStyle,
          lastIdealVelocity: newLastIdealVelocity
        });

        _this.unreadPropStyle = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  Motion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyle = _props.defaultStyle;
    var style = _props.style;

    var currentStyle = defaultStyle || _stripStyle2['default'](style);
    var currentVelocity = _mapToZero2['default'](currentStyle);
    return {
      currentStyle: currentStyle,
      currentVelocity: currentVelocity,
      lastIdealStyle: currentStyle,
      lastIdealVelocity: currentVelocity
    };
  };

  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400

  Motion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyle != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyle);
    }

    this.unreadPropStyle = props.style;
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  Motion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyle);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return Motion;
})(_react2['default'].Component);

exports['default'] = Motion;
module.exports = exports['default'];

// after checking for unreadPropStyle != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)
});

var StaggeredMotion_1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var _mapToZero2 = _interopRequireDefault(mapToZero_1);



var _stripStyle2 = _interopRequireDefault(stripStyle_1);



var _stepper4 = _interopRequireDefault(stepper_1);



var _performanceNow2 = _interopRequireDefault(performanceNow$1);



var _raf2 = _interopRequireDefault(raf_1);



var _shouldStopAnimation2 = _interopRequireDefault(shouldStopAnimation_1);



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
  for (var i = 0; i < currentStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
      return false;
    }
  }
  return true;
}

var StaggeredMotion = (function (_React$Component) {
  _inherits(StaggeredMotion, _React$Component);

  _createClass(StaggeredMotion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
      styles: _propTypes2['default'].func.isRequired,
      children: _propTypes2['default'].func.isRequired
    },
    enumerable: true
  }]);

  function StaggeredMotion(props) {
    var _this = this;

    _classCallCheck(this, StaggeredMotion);

    _React$Component.call(this, props);
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _state = _this.state;
      var currentStyles = _state.currentStyles;
      var currentVelocities = _state.currentVelocities;
      var lastIdealStyles = _state.lastIdealStyles;
      var lastIdealVelocities = _state.lastIdealVelocities;

      var someDirty = false;
      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i];
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              someDirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
          }
        }
      }

      if (someDirty) {
        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        var destStyles = _this.props.styles(_this.state.lastIdealStyles);

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyles = [];
        var newLastIdealVelocities = [];
        var newCurrentStyles = [];
        var newCurrentVelocities = [];

        for (var i = 0; i < destStyles.length; i++) {
          var destStyle = destStyles[i];
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in destStyle) {
            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
              continue;
            }

            var styleValue = destStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  StaggeredMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;

    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
    var currentVelocities = currentStyles.map(function (currentStyle) {
      return _mapToZero2['default'](currentStyle);
    });
    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: currentStyles,
      lastIdealVelocities: currentVelocities
    };
  };

  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  StaggeredMotion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return StaggeredMotion;
})(_react2['default'].Component);

exports['default'] = StaggeredMotion;
module.exports = exports['default'];

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

// after checking for unreadPropStyles != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)
});

var mergeDiff_1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;
exports['default'] = mergeDiff;

function mergeDiff(prev, next, onRemove) {
  // bookkeeping for easier access of a key's index below. This is 2 allocations +
  // potentially triggering chrome hash map mode for objs (so it might be faster

  var prevKeyIndex = {};
  for (var i = 0; i < prev.length; i++) {
    prevKeyIndex[prev[i].key] = i;
  }
  var nextKeyIndex = {};
  for (var i = 0; i < next.length; i++) {
    nextKeyIndex[next[i].key] = i;
  }

  // first, an overly elaborate way of merging prev and next, eliminating
  // duplicates (in terms of keys). If there's dupe, keep the item in next).
  // This way of writing it saves allocations
  var ret = [];
  for (var i = 0; i < next.length; i++) {
    ret[i] = next[i];
  }
  for (var i = 0; i < prev.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
      // merge in keys that the user desires to kill
      var fill = onRemove(i, prev[i]);
      if (fill != null) {
        ret.push(fill);
      }
    }
  }

  // now all the items all present. Core sorting logic to have the right order
  return ret.sort(function (a, b) {
    var nextOrderA = nextKeyIndex[a.key];
    var nextOrderB = nextKeyIndex[b.key];
    var prevOrderA = prevKeyIndex[a.key];
    var prevOrderB = prevKeyIndex[b.key];

    if (nextOrderA != null && nextOrderB != null) {
      // both keys in next
      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
    } else if (prevOrderA != null && prevOrderB != null) {
      // both keys in prev
      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
    } else if (nextOrderA != null) {
      // key a in next, key b in prev

      // how to determine the order between a and b? We find a "pivot" (term
      // abuse), a key present in both prev and next, that is sandwiched between
      // a and b. In the context of our above example, if we're comparing a and
      // d, b's (the only) pivot
      for (var i = 0; i < next.length; i++) {
        var pivot = next[i].key;
        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
          continue;
        }

        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
          return -1;
        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
          return 1;
        }
      }
      // pluggable. default to: next bigger than prev
      return 1;
    }
    // prevOrderA, nextOrderB
    for (var i = 0; i < next.length; i++) {
      var pivot = next[i].key;
      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
        continue;
      }
      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
        return 1;
      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
        return -1;
      }
    }
    // pluggable. default to: next bigger than prev
    return -1;
  });
}

module.exports = exports['default'];
// to loop through and find a key's index each time), but I no longer care
});

var TransitionMotion_1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var _mapToZero2 = _interopRequireDefault(mapToZero_1);



var _stripStyle2 = _interopRequireDefault(stripStyle_1);



var _stepper4 = _interopRequireDefault(stepper_1);



var _mergeDiff2 = _interopRequireDefault(mergeDiff_1);



var _performanceNow2 = _interopRequireDefault(performanceNow$1);



var _raf2 = _interopRequireDefault(raf_1);



var _shouldStopAnimation2 = _interopRequireDefault(shouldStopAnimation_1);



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
  // Copy the value to a `const` so that Flow understands that the const won't
  // change and will be non-nullable in the callback below.
  var cUnreadPropStyles = unreadPropStyles;
  if (cUnreadPropStyles == null) {
    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
      return {
        key: mergedPropsStyle.key,
        data: mergedPropsStyle.data,
        style: plainStyles[i]
      };
    });
  }
  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
    for (var j = 0; j < cUnreadPropStyles.length; j++) {
      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
        return {
          key: cUnreadPropStyles[j].key,
          data: cUnreadPropStyles[j].data,
          style: plainStyles[i]
        };
      }
    }
    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
  });
}

function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
  if (mergedPropsStyles.length !== destStyles.length) {
    return false;
  }

  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (mergedPropsStyles[i].key !== destStyles[i].key) {
      return false;
    }
  }

  // we have the invariant that mergedPropsStyles and
  // currentStyles/currentVelocities/last* are synced in terms of cells, see
  // mergeAndSync comment for more info
  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
      return false;
    }
  }

  return true;
}

// core key merging logic

// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key

// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
    var leavingStyle = willLeave(oldMergedPropsStyle);
    if (leavingStyle == null) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
  });

  var newCurrentStyles = [];
  var newCurrentVelocities = [];
  var newLastIdealStyles = [];
  var newLastIdealVelocities = [];
  for (var i = 0; i < newMergedPropsStyles.length; i++) {
    var newMergedPropsStyleCell = newMergedPropsStyles[i];
    var foundOldIndex = null;
    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
        foundOldIndex = j;
        break;
      }
    }
    // TODO: key search code
    if (foundOldIndex == null) {
      var plainStyle = willEnter(newMergedPropsStyleCell);
      newCurrentStyles[i] = plainStyle;
      newLastIdealStyles[i] = plainStyle;

      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
      newCurrentVelocities[i] = velocity;
      newLastIdealVelocities[i] = velocity;
    } else {
      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
    }
  }

  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
}

var TransitionMotion = (function (_React$Component) {
  _inherits(TransitionMotion, _React$Component);

  _createClass(TransitionMotion, null, [{
    key: 'propTypes',
    value: {
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
      })),
      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
      }))]).isRequired,
      children: _propTypes2['default'].func.isRequired,
      willEnter: _propTypes2['default'].func,
      willLeave: _propTypes2['default'].func,
      didLeave: _propTypes2['default'].func
    },
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      willEnter: function willEnter(styleThatEntered) {
        return _stripStyle2['default'](styleThatEntered.style);
      },
      // recall: returning null makes the current unmounting TransitionStyle
      // disappear immediately
      willLeave: function willLeave() {
        return null;
      },
      didLeave: function didLeave() {}
    },
    enumerable: true
  }]);

  function TransitionMotion(props) {
    var _this = this;

    _classCallCheck(this, TransitionMotion);

    _React$Component.call(this, props);
    this.unmounting = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

      var mergedPropsStyles = _mergeAndSync[0];
      var currentStyles = _mergeAndSync[1];
      var currentVelocities = _mergeAndSync[2];
      var lastIdealStyles = _mergeAndSync[3];
      var lastIdealVelocities = _mergeAndSync[4];

      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i].style;
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
              mergedPropsStyles[i] = {
                key: mergedPropsStyles[i].key,
                data: mergedPropsStyles[i].data,
                style: _extends({}, mergedPropsStyles[i].style)
              };
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
            mergedPropsStyles[i].style[key] = styleValue;
          }
        }
      }

      // unlike the other 2 components, we can't detect staleness and optionally
      // opt out of setState here. each style object's data might contain new
      // stuff we're not/cannot compare
      _this.setState({
        currentStyles: currentStyles,
        currentVelocities: currentVelocities,
        mergedPropsStyles: mergedPropsStyles,
        lastIdealStyles: lastIdealStyles,
        lastIdealVelocities: lastIdealVelocities
      });
    };

    this.startAnimationIfNecessary = function () {
      if (_this.unmounting) {
        return;
      }

      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // https://github.com/chenglou/react-motion/pull/420
        // > if execution passes the conditional if (this.unmounting), then
        // executes async defaultRaf and after that component unmounts and after
        // that the callback of defaultRaf is called, then setState will be called
        // on unmounted component.
        if (_this.unmounting) {
          return;
        }

        var propStyles = _this.props.styles;
        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

        var newMergedPropsStyles = _mergeAndSync2[0];
        var newCurrentStyles = _mergeAndSync2[1];
        var newCurrentVelocities = _mergeAndSync2[2];
        var newLastIdealStyles = _mergeAndSync2[3];
        var newLastIdealVelocities = _mergeAndSync2[4];

        for (var i = 0; i < newMergedPropsStyles.length; i++) {
          var newMergedPropsStyle = newMergedPropsStyles[i].style;
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in newMergedPropsStyle) {
            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
              continue;
            }

            var styleValue = newMergedPropsStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = newLastIdealStyles[i][key];
              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities,
          mergedPropsStyles: newMergedPropsStyles
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  TransitionMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;
    var willEnter = _props.willEnter;
    var willLeave = _props.willLeave;
    var didLeave = _props.didLeave;

    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;

    // this is special. for the first time around, we don't have a comparison
    // between last (no last) and current merged props. we'll compute last so:
    // say default is {a, b} and styles (dest style) is {b, c}, we'll
    // fabricate last as {a, b}
    var oldMergedPropsStyles = undefined;
    if (defaultStyles == null) {
      oldMergedPropsStyles = destStyles;
    } else {
      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
        // TODO: key search code
        for (var i = 0; i < destStyles.length; i++) {
          if (destStyles[i].key === defaultStyleCell.key) {
            return destStyles[i];
          }
        }
        return defaultStyleCell;
      });
    }
    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    });
    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    });

    var _mergeAndSync3 = mergeAndSync(
    // Because this is an old-style createReactClass component, Flow doesn't
    // understand that the willEnter and willLeave props have default values
    // and will always be present.
    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
    oldCurrentVelocities);

    var mergedPropsStyles = _mergeAndSync3[0];
    var currentStyles = _mergeAndSync3[1];
    var currentVelocities = _mergeAndSync3[2];
    var lastIdealStyles = _mergeAndSync3[3];
    var lastIdealVelocities = _mergeAndSync3[4];
    // oldLastIdealVelocities really

    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: lastIdealStyles,
      lastIdealVelocities: lastIdealVelocities,
      mergedPropsStyles: mergedPropsStyles
    };
  };

  // after checking for unreadPropStyles != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)

  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    var styles = props.styles;
    if (typeof styles === 'function') {
      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
    } else {
      this.unreadPropStyles = styles;
    }

    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounting = true;
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  TransitionMotion.prototype.render = function render() {
    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
    var renderedChildren = this.props.children(hydratedStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return TransitionMotion;
})(_react2['default'].Component);

exports['default'] = TransitionMotion;
module.exports = exports['default'];

// list of styles, each containing interpolating values. Part of what's passed
// to children function. Notice that this is
// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
// contains the key & data info (so that we only have a single source of truth
// for these, and to save space). Check the comment for `rehydrateStyles` to
// see how we regenerate the entirety of what's passed to children function

// the array that keeps track of currently rendered stuff! Including stuff
// that you've unmounted but that's still animating. This is where it lives

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400
});

var presets = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;
exports["default"] = {
  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
  gentle: { stiffness: 120, damping: 14 },
  wobbly: { stiffness: 180, damping: 12 },
  stiff: { stiffness: 210, damping: 20 }
};
module.exports = exports["default"];
});

var spring_1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = spring;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }



var _presets2 = _interopRequireDefault(presets);

var defaultConfig = _extends({}, _presets2['default'].noWobble, {
  precision: 0.01
});

function spring(val, config) {
  return _extends({}, defaultConfig, config, { val: val });
}

module.exports = exports['default'];
});

var reorderKeys_1 = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;
exports['default'] = reorderKeys;

var hasWarned = false;

function reorderKeys() {
  if (process.env.NODE_ENV === 'development') {
    if (!hasWarned) {
      hasWarned = true;
      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
    }
  }
}

module.exports = exports['default'];
});

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }



var Motion = _interopRequire(Motion_1);



_interopRequire(StaggeredMotion_1);



_interopRequire(TransitionMotion_1);



var spring = _interopRequire(spring_1);



_interopRequire(presets);



_interopRequire(stripStyle_1);

// deprecated, dummy warning function



_interopRequire(reorderKeys_1);

var EmptyDropdown = /*#__PURE__*/function (_Component) {
  _inherits$1(EmptyDropdown, _Component);

  var _super = _createSuper$1(EmptyDropdown);

  function EmptyDropdown(props) {
    var _this;

    _classCallCheck$4(this, EmptyDropdown);

    _this = _super.call(this, props);
    _this.ref = /*#__PURE__*/createRef();

    _this.handleHideDropdown = function (event) {
      // if component is not visible return
      if (!_this.props.visible) return;

      if (event.key === 'Escape') {
        _this.props.setVisible(false);
      }
    };

    _this.handleClickOutside = function (event) {
      // if component is not visible return
      if (!_this.props.visible) return;

      if (_this.ref.current && !_this.ref.current.contains(event.target)) {
        _this.props.setVisible(false);
      }
    };

    _this.componentDidMount = function () {
      document.addEventListener('keydown', _this.handleHideDropdown, true);
      document.addEventListener('click', _this.handleClickOutside, true);
    };

    _this.componentWillUnmount = function () {
      document.removeEventListener('keydown', _this.handleHideDropdown, true);
      document.removeEventListener('click', _this.handleClickOutside, true);
    };

    _this.onHeaderClickHandler = function () {
      _this.props.setVisible(!_this.props.visible);
    };

    return _this;
  }

  _createClass$1(EmptyDropdown, [{
    key: "render",
    value: function render() {
      var visible = this.props.visible;
      var _this$props = this.props,
          component = _this$props.component,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          _this$props$cardStyle = _this$props.cardStyle,
          cardStyle = _this$props$cardStyle === void 0 ? {} : _this$props$cardStyle,
          children = _this$props.children; // react to variant on card style

      var fadeTopMargin = 0;
      return /*#__PURE__*/React__default.createElement("div", {
        ref: this.ref,
        style: style,
        className: "CyoloUI-EmptyDropdown-root"
      }, /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: 'fit-content',
          height: 'fit-content'
        },
        onClick: this.onHeaderClickHandler
      }, component), /*#__PURE__*/React__default.createElement(Motion, {
        style: {
          opacity: spring(visible ? 1 : 0),
          yPos: spring(visible ? fadeTopMargin + 5 : fadeTopMargin, {
            damping: 20,
            stiffness: 300
          })
        }
      }, function (_ref) {
        var opacity = _ref.opacity,
            yPos = _ref.yPos;
        return /*#__PURE__*/React__default.createElement("div", {
          style: {
            zIndex: 1,
            position: 'absolute',
            top: yPos,
            // left: 0,
            // right: 0,
            marginLeft: '100%',
            opacity: opacity
          }
        }, opacity !== 0 && /*#__PURE__*/React__default.createElement(Card, {
          addPadding: false,
          style: Object.assign({
            overflow: 'hidden'
          }, cardStyle)
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "CyoloUI-EmptyDropdown-bottomCard",
          style: {
            pointerEvents: visible ? 'auto' : 'none',
            maxHeight: 160,
            overflowY: 'scroll'
          }
        }, children)));
      }));
    }
  }]);

  return EmptyDropdown;
}(Component);

function r$9(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r$9(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r$9(e))&&(n&&(n+=" "),n+=t);return n}

var FieldView = function FieldView(_ref) {
  var title = _ref.title,
      label = _ref.label,
      style = _ref.style,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  var styles = useStyles$A();
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(styles.root, className),
    style: style
  }, title && /*#__PURE__*/React__default.createElement("div", {
    className: styles.title
  }, /*#__PURE__*/React__default.createElement(Text$1, {
    variant: "header-3"
  }, title), label && /*#__PURE__*/React__default.createElement(Text$1, {
    variant: "console-app-body"
  }, label)), children);
};
var useStyles$A = createUseStyles({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },
  title: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: 6,
    marginBottom: 8
  }
});

var useArrowKeysNavigation = function useArrowKeysNavigation(optionsSize, onOutOfBound) {
  var NO_SELECTION_INDEX = -1;
  var MAX_SIZE = optionsSize;

  var _useState = useState(NO_SELECTION_INDEX),
      _useState2 = _slicedToArray$1(_useState, 2),
      cursor = _useState2[0],
      setCursor = _useState2[1];

  var resetCursor = function resetCursor() {
    setCursor(NO_SELECTION_INDEX);
  };
  /**
   * next (down\right in a list)
   */


  var next = function next() {
    var nextPos = cursor + 1;

    if (nextPos >= MAX_SIZE) {
      return;
    }

    setCursor(nextPos);
  };
  /**
   * prev (up\left in a list)
   */


  var prev = function prev() {
    var nextPos = cursor - 1;

    if (nextPos < 0) {
      // onOutOfBound supports back to parent focus
      onOutOfBound();
      resetCursor();
      return;
    }

    setCursor(nextPos);
  };

  return {
    cursor: cursor,
    next: next,
    prev: prev,
    resetCursor: resetCursor
  };
};

/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

var lodash = createCommonjsModule$1(function (module, exports) {
(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined$1;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined$1 : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined$1 : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined$1) {
        result = result === undefined$1 ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined$1 : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined$1,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined$1,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined$1,
        symIterator = Symbol ? Symbol.iterator : undefined$1,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined$1;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined$1,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined$1,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1,
        symbolToString = symbolProto ? symbolProto.toString : undefined$1;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined$1;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined$1;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined$1 : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined$1;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined$1) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined$1) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined$1 : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined$1;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined$1 && !eq(object[key], value)) ||
          (value === undefined$1 && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined$1 && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined$1 : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined$1) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined$1) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined$1) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined$1 : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined$1 && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined$1, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined$1
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined$1 || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined$1;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined$1 ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined$1;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined$1 : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined$1 && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined$1
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined$1 && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined$1;

          if (newValue === undefined$1) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined$1;

      var isCommon = newValue === undefined$1;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined$1;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
          if (newValue === undefined$1) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined$1;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined$1,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined$1;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined$1 ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined$1,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined$1,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined$1;

        if (newValue === undefined$1) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined$1,
            guard = length > 2 ? sources[2] : undefined$1;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined$1;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined$1 : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined$1;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined$1,
            args, holders, undefined$1, undefined$1, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined$1;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined$1;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined$1 : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined$1 && other === undefined$1) {
          return defaultValue;
        }
        if (value !== undefined$1) {
          result = value;
        }
        if (other !== undefined$1) {
          if (result === undefined$1) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined$1 ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined$1;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined$1) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined$1 ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined$1,
          newHoldersRight = isCurry ? undefined$1 : holders,
          newPartials = isCurry ? partials : undefined$1,
          newPartialsRight = isCurry ? undefined$1 : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined$1, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined$1;
      }
      ary = ary === undefined$1 ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined$1 ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined$1;
      }
      var data = isBindKey ? undefined$1 : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined$1
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined$1, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined$1 ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined$1 : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined$1;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined$1) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined$1
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined$1, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined$1;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined$1;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined$1,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined$1 || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined$1 ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined$1;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined$1, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined$1 ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined$1)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined$1;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined$1, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined$1) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined$1 ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined$1;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined$1;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined$1, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined$1;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined$1) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined$1;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined$1, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined$1 ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return (array && array.length) ? baseUniq(array, undefined$1, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined$1, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined$1;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined$1;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined$1
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined$1);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined$1) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined$1 : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined$1;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined$1
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined$1;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined$1 ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined$1 : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined$1)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined$1;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined$1 : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined$1;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined$1 : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined$1 : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined$1;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined$1 || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined$1;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined$1;
        return result;
      }

      function cancel() {
        if (timerId !== undefined$1) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined$1;
      }

      function flush() {
        return timerId === undefined$1 ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined$1) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined$1) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined$1 ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      var result = customizer ? customizer(value, other) : undefined$1;
      return result === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined$1;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined$1;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined$1 ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined$1, customDefaultsMerge);
      return apply(mergeWith, undefined$1, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined$1 : baseGet(object, path);
      return result === undefined$1 ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined$1;
      }
      while (++index < length) {
        var value = object == null ? undefined$1 : object[toKey(path[index])];
        if (value === undefined$1) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined$1) {
        upper = lower;
        lower = undefined$1;
      }
      if (upper !== undefined$1) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined$1) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined$1) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined$1;
      }
      if (floating === undefined$1) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined$1;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined$1;
        }
      }
      if (lower === undefined$1 && upper === undefined$1) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined$1) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined$1
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined$1)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined$1;
      }
      limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined$1;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined$1, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined$1) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined$1 ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined$1 : pattern;

      if (pattern === undefined$1) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined$1, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined$1 : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined$1;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined$1;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined$1;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined$1;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined$1 ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined$1) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined$1 });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined$1
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(commonjsGlobal));
});

/**
 * debounce given function with delay
 */

function useDebounce(fn) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
  var dependency = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var debouncedFn = useCallback(lodash.debounce(fn, delay), _toConsumableArray$1(dependency));
  useEffect(function () {
    return function () {
      debouncedFn.cancel();
    };
  }, [debouncedFn]);
  return debouncedFn;
}

/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect$1 = typeof window !== 'undefined' && window.document && window.document.createElement ? React.useLayoutEffect : React.useEffect;

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow$1(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement(node) {
  var OwnElement = getWindow$1(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement$2(node) {
  var OwnElement = getWindow$1(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow$1(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement$2(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement$2(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

var max$1 = Math.max;
var min$1 = Math.min;
var round = Math.round;

function getBoundingClientRect(element, includeScale) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  var rect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (isHTMLElement$2(element) && includeScale) {
    var offsetHeight = element.offsetHeight;
    var offsetWidth = element.offsetWidth; // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
    // Fallback to 1 in case both values are `0`

    if (offsetWidth > 0) {
      scaleX = round(rect.width) / offsetWidth || 1;
    }

    if (offsetHeight > 0) {
      scaleY = round(rect.height) / offsetHeight || 1;
    }
  }

  return {
    width: rect.width / scaleX,
    height: rect.height / scaleY,
    top: rect.top / scaleY,
    right: rect.right / scaleX,
    bottom: rect.bottom / scaleY,
    left: rect.left / scaleX,
    x: rect.left / scaleX,
    y: rect.top / scaleY
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getComputedStyle$1(element) {
  return getWindow$1(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement$2(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
  var isIE = navigator.userAgent.indexOf('Trident') !== -1;

  if (isIE && isHTMLElement$2(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle$1(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement$2(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow$1(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min, value, max) {
  return max$1(min, min$1(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (process.env.NODE_ENV !== "production") {
    if (!isHTMLElement$2(arrowElement)) {
      console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', 'To use an SVG arrow, wrap it in an HTMLElement that will be used as', 'the arrow.'].join(' '));
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
    }

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow$1(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle$1(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  if (process.env.NODE_ENV !== "production") {
    var transitionProperty = getComputedStyle$1(state.elements.popper).transitionProperty || '';

    if (adaptive && ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
      return transitionProperty.indexOf(property) >= 0;
    })) {
      console.warn(['Popper: Detected CSS transitions on at least one of the following', 'CSS properties: "transform", "top", "right", "bottom", "left".', '\n\n', 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', 'for smooth transitions, or remove these properties from the CSS', 'transition declaration on the popper element if only transitioning', 'opacity or background-color for example.', '\n\n', 'We recommend using the popper element as a wrapper around an inner', 'element that can have any CSS property transitioned for animations.'].join(' '));
    }
  }

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow$1(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow$1(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element) {
  var win = getWindow$1(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
  // can be obscured underneath it.
  // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
  // if it isn't open, so if this isn't available, the popper will be detected
  // to overflow the bottom of the screen too early.

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
    // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
    // errors due to floating point numbers, so we need to check precision.
    // Safari returns a number <= 0, usually < -1 when pinch-zoomed
    // Feature detection fails in mobile emulation mode in Chrome.
    // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
    // 0.001
    // Fallback here: "Not Safari" userAgent

    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max$1(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max$1(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle$1(body || html).direction === 'rtl') {
    x += max$1(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle$1(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement$2(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow$1(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element) {
  var rect = getBoundingClientRect(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement$2(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = max$1(rect.top, accRect.top);
    accRect.right = min$1(rect.right, accRect.right);
    accRect.bottom = min$1(rect.bottom, accRect.bottom);
    accRect.left = max$1(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;

    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: The `allowedAutoPlacements` option did not allow any', 'placements. Ensure the `placement` option matches the variation', 'of the allowed placements.', 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(' '));
    }
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide$1(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$2 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide$1
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min$1(min, tetherMin) : min, offset, tether ? max$1(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow$1(node) || !isHTMLElement$2(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement$2(offsetParent);
  var offsetParentIsScaled = isHTMLElement$2(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement$2(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce$1(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function format$2(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return [].concat(args).reduce(function (p, c) {
    return p.replace(/%s/, c);
  }, str);
}

var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];
function validateModifiers(modifiers) {
  modifiers.forEach(function (modifier) {
    [].concat(Object.keys(modifier), VALID_PROPERTIES) // IE11-compatible replacement for `new Set(iterable)`
    .filter(function (value, index, self) {
      return self.indexOf(value) === index;
    }).forEach(function (key) {
      switch (key) {
        case 'name':
          if (typeof modifier.name !== 'string') {
            console.error(format$2(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"" + String(modifier.name) + "\""));
          }

          break;

        case 'enabled':
          if (typeof modifier.enabled !== 'boolean') {
            console.error(format$2(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"" + String(modifier.enabled) + "\""));
          }

          break;

        case 'phase':
          if (modifierPhases.indexOf(modifier.phase) < 0) {
            console.error(format$2(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(', '), "\"" + String(modifier.phase) + "\""));
          }

          break;

        case 'fn':
          if (typeof modifier.fn !== 'function') {
            console.error(format$2(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'effect':
          if (modifier.effect != null && typeof modifier.effect !== 'function') {
            console.error(format$2(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'requires':
          if (modifier.requires != null && !Array.isArray(modifier.requires)) {
            console.error(format$2(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"" + String(modifier.requires) + "\""));
          }

          break;

        case 'requiresIfExists':
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(format$2(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"" + String(modifier.requiresIfExists) + "\""));
          }

          break;

        case 'options':
        case 'data':
          break;

        default:
          console.error("PopperJS: an invalid property has been provided to the \"" + modifier.name + "\" modifier, valid properties are " + VALID_PROPERTIES.map(function (s) {
            return "\"" + s + "\"";
          }).join(', ') + "; but \"" + key + "\" was provided.");
      }

      modifier.requires && modifier.requires.forEach(function (requirement) {
        if (modifiers.find(function (mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(format$2(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}

function uniqueBy(arr, fn) {
  var identifiers = new Set();
  return arr.filter(function (item) {
    var identifier = fn(item);

    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (process.env.NODE_ENV !== "production") {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);

          if (getBasePlacement(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function (_ref2) {
              var name = _ref2.name;
              return name === 'flip';
            });

            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '));
            }
          }

          var _getComputedStyle = getComputedStyle$1(popper),
              marginTop = _getComputedStyle.marginTop,
              marginRight = _getComputedStyle.marginRight,
              marginBottom = _getComputedStyle.marginBottom,
              marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
          // cause bugs with positioning, so we'll warn the consumer


          if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', 'between the popper and its reference element or boundary.', 'To replicate margin, use the `offset` modifier, as well as', 'the `padding` option in the `preventOverflow` and `flip`', 'modifiers.'].join(' '));
          }
        }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (process.env.NODE_ENV !== "production") {
            console.error(INVALID_ELEMENT_ERROR);
          }

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (process.env.NODE_ENV !== "production") {
            __debug_loops__ += 1;

            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce$1(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      if (process.env.NODE_ENV !== "production") {
        console.error(INVALID_ELEMENT_ERROR);
      }

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$2];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */
var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};

var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }

  var prevOptions = React.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };

  var _React$useState = React.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: '0',
        top: '0'
      },
      arrow: {
        position: 'absolute'
      }
    },
    attributes: {}
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var updateStateModifier = React.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        reactDom.flushSync(function () {
          setState({
            styles: fromEntries(elements.map(function (element) {
              return [element, state.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function (element) {
              return [element, state.attributes[element]];
            }))
          });
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = React.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };

    if (reactFastCompare(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = React.useRef();
  useIsomorphicLayoutEffect$1(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect$1(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }

    var createPopper$1 = options.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

var warning_1 = warning;

/**
 * clickoutside custom hook
 * @param ref ref to traget element
 * @param handler callback handler on outside click event
 * @param watchList optional list. if other states varible depend and need to be watched
 */

function useOutsideClick(ref, handler) {
  var watchList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var matcher = arguments.length > 3 ? arguments[3] : undefined;
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (matcher) {
        if (matcher(event)) {
          return;
        }

        handler();
        return;
      }

      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler();
    }; // register event listener


    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    return function () {
      // Unregister the event listener
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [ref, handler, matcher].concat(watchList));
}

var useDropdownPopper = function useDropdownPopper(_ref) {
  var parentRefElement = _ref.parentRefElement,
      visible = _ref.visible,
      onVisibilityChange = _ref.onVisibilityChange,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement,
      _ref$sameWidth = _ref.sameWidth,
      sameWidth = _ref$sameWidth === void 0 ? true : _ref$sameWidth,
      _ref$offsetValue = _ref.offsetValue,
      offsetValue = _ref$offsetValue === void 0 ? 8 : _ref$offsetValue,
      _ref$flip = _ref.flip,
      flip = _ref$flip === void 0 ? true : _ref$flip,
      _ref$enableEventListe = _ref.enableEventListeners,
      enableEventListeners = _ref$enableEventListe === void 0 ? true : _ref$enableEventListe;

  var _useState = useState(null),
      _useState2 = _slicedToArray$1(_useState, 2),
      popperElement = _useState2[0],
      setPopperElement = _useState2[1];

  var modifiers = useMemo(function () {
    return [{
      name: 'flip',
      enabled: flip
    }, {
      name: 'offset',
      options: {
        offset: [0, offsetValue]
      }
    }, {
      name: 'sameWidth',
      enabled: sameWidth,
      fn: function fn(_ref2) {
        var state = _ref2.state;
        state.styles.popper.width = "".concat(state.rects.reference.width, "px");
      },
      effect: function effect(_ref3) {
        var state = _ref3.state;
        state.elements.popper.style.minWidth = "".concat(state.elements.reference.offsetWidth, "px");
      },
      phase: 'beforeWrite',
      requires: ['computeStyles']
    }, {
      name: 'eventListeners',
      enabled: enableEventListeners
    }];
  }, [sameWidth, enableEventListeners, flip]);
  var popperInstance = usePopper(parentRefElement, popperElement, {
    modifiers: modifiers,
    placement: placement
  });
  useOutsideClick({
    current: null
  }, function () {
    visible && onVisibilityChange(false);
  }, [], function (event) {
    if (popperElement) {
      return popperElement.contains(event.target);
    }

    if (parentRefElement && parentRefElement instanceof Element) {
      return parentRefElement.contains(event.target);
    }

    return false;
  });
  return Object.assign(Object.assign({}, popperInstance), {
    setPopperElement: setPopperElement
  });
};

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;

/** Detect free variable `global` from Node.js. */

var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return _root.Date.now();
};

var now_1 = now;

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

var _trimmedEndIndex = trimmedEndIndex;

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, _trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

var _baseTrim = baseTrim;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$b.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$b.toString;

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$8.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$a.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$1(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$1;

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag$1);
}

var isSymbol_1 = isSymbol;

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol_1(value)) {
    return NAN;
  }
  if (isObject_1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject_1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = _baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var toNumber_1 = toNumber;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber_1(wait) || 0;
  if (isObject_1(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber_1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now_1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now_1());
  }

  function debounced() {
    var time = now_1(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

var debounce_1 = debounce;

/**
 * hook that handles hover over element
 * @returns `isHovering` boolean
 */

function useHover(refElement) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      isHovering = _useState2[0],
      setIsHovering = _useState2[1];

  var handleMouseOver = useCallback(debounce_1(function () {
    setIsHovering(true);
  }, delay), [delay]);
  var handleMouseLeave = useCallback(debounce_1(function () {
    setIsHovering(false);
  }, delay), [delay]);
  useEffect(function () {
    return function () {
      handleMouseOver.cancel();
      handleMouseLeave.cancel();
    };
  }, [handleMouseOver, handleMouseLeave]);
  useEffect(function () {
    if (refElement) {
      refElement.addEventListener('mouseover', handleMouseOver);
      refElement.addEventListener('mouseleave', handleMouseLeave);
      return function () {
        refElement.removeEventListener('mouseover', handleMouseOver);
        refElement.removeEventListener('mouseleave', handleMouseLeave);
      };
    }
  }, [refElement, handleMouseOver, handleMouseLeave]);
  return isHovering;
}

var useRegisterListener = function useRegisterListener(_ref) {
  var handler = _ref.handler,
      listener = _ref.listener;

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      isReady = _useState2[0],
      setIsReady = _useState2[1];

  useEffect(function () {
    if (!listener) {
      return;
    }

    listener.current = handler();
    setIsReady(true);
  }, [listener, handler]);
  return isReady;
};

var Initials = function Initials(str) {
  if (!str) {
    return str;
  }

  return str.trim().charAt(0).toUpperCase();
};
var getInitials = function getInitials(_ref) {
  var firstName = _ref.firstName,
      lastName = _ref.lastName,
      username = _ref.username;

  if (firstName && lastName) {
    return "".concat(Initials(firstName)).concat(Initials(lastName));
  }

  if (firstName) {
    return Initials(firstName);
  }

  if (lastName) {
    return Initials(lastName);
  }

  return Initials(username);
};

var ProfileMenu = function ProfileMenu(_ref2) {
  var username = _ref2.username,
      firstName = _ref2.firstName,
      lastName = _ref2.lastName;
  var theme = useThemeSafe();
  var styles = useStyles$z({
    theme: theme
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx('CyoloUI-ProfileMenu', styles.root)
  }, /*#__PURE__*/React__default.createElement(Text$1, {
    variant: "tag",
    className: styles.text
  }, getInitials({
    firstName: firstName,
    lastName: lastName,
    username: username
  })));
};
var useStyles$z = createUseStyles(function (theme) {
  return {
    root: _defineProperty$1({
      borderRadius: theme.shape.borderRadiusCircle,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: theme.palette.primary.color,
      boxSizing: 'border-box',
      height: 32,
      width: 32,
      cursor: 'pointer'
    }, '&:hover', {
      boxShadow: "0px 0px 0px 3px ".concat(theme.palette.primary.dark)
    }),
    text: {
      fontSize: theme.typography.fontBaseSize
    },
    '@media only screen and (max-width: 750px)': {
      root: {
        width: 24,
        height: 24
      },
      text: {
        fontSize: theme.typography.fontBaseSize
      }
    }
  };
});

var UserDropdownSection = function UserDropdownSection(_ref) {
  var buttons = _ref.buttons,
      onClick = _ref.onClick;
  var theme = useThemeSafe();
  var styles = useStyles$y();
  var handleClick = useCallback(function (button) {
    return function (e) {
      onClick(button);
      button.onClick(e);
    };
  }, [onClick]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Divider$1, {
    thickness: "1px",
    orientation: "horizontal",
    color: theme.palette.background.color
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles.buttonSection
  }, buttons.map(function (button) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: button.text
    }, /*#__PURE__*/React__default.createElement(ActionIcon, {
      iconName: button.iconName,
      text: button.text,
      onClick: handleClick(button)
    }));
  })));
};
var useStyles$y = createUseStyles({
  buttonSection: {
    display: 'flex',
    flexDirection: 'column',
    padding: 16,
    gap: 16,
    '& .CyoloUI-ActionIcon': {
      height: 'unset'
    },
    '& .CyoloUI-ActionIcon-Text': {
      marginLeft: 0
    }
  }
});

var getNameTitle = function getNameTitle(_ref) {
  var firstName = _ref.firstName,
      lastName = _ref.lastName,
      userName = _ref.userName;

  if (firstName && lastName) {
    return "".concat(firstName, " ").concat(lastName);
  } else if (firstName || lastName) {
    return firstName || lastName;
  }

  return userName || '';
};

var UserInfoSection = function UserInfoSection(_ref2) {
  var userName = _ref2.userName,
      firstName = _ref2.firstName,
      lastName = _ref2.lastName,
      userEmail = _ref2.userEmail;
  var theme = useThemeSafe();
  var styles = useStyles$x();
  var isEmailVisible = useMemo(function () {
    return Boolean(userEmail);
  }, [userEmail]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.nameIcon
  }, /*#__PURE__*/React__default.createElement(ProfileMenu, {
    username: userName,
    firstName: firstName,
    lastName: lastName
  })), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: styles.userSection
  }, /*#__PURE__*/React__default.createElement(Text$1, {
    variant: "body"
  }, getNameTitle({
    firstName: firstName,
    lastName: lastName,
    userName: userName
  })), isEmailVisible && /*#__PURE__*/React__default.createElement(Text$1, {
    variant: "tag",
    color: theme.palette.grey.color
  }, userEmail))));
};
var useStyles$x = createUseStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  userSection: {
    display: 'flex',
    flexDirection: 'column',
    padding: 16,
    gap: 0
  },
  nameIcon: {
    padding: [8, 0, 8, 16]
  }
});

var UserDropDown = function UserDropDown(_ref) {
  var sections = _ref.sections,
      userInfo = _ref.userInfo;

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      dropdownVisible = _useState2[0],
      setDropdownVisible = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray$1(_useState3, 2),
      referenceElement = _useState4[0],
      setReferenceElement = _useState4[1];

  var theme = useThemeSafe();
  var styles = useStyles$w({
    theme: theme
  });
  var handleVisibilityChange = useCallback(function (isVisible) {
    setDropdownVisible(isVisible);
  }, []);

  var _useDropdownPopper = useDropdownPopper({
    parentRefElement: referenceElement,
    visible: dropdownVisible,
    onVisibilityChange: handleVisibilityChange,
    placement: 'bottom-end',
    sameWidth: false
  }),
      attributes = _useDropdownPopper.attributes,
      setPopperElement = _useDropdownPopper.setPopperElement,
      popperStyles = _useDropdownPopper.styles;

  var toggleVisibility = useCallback(function () {
    setDropdownVisible(function (prev) {
      return !prev;
    });
  }, []);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: clsx(styles.holderDiv, 'Cyolo-UI-UserDropdown'),
    ref: setReferenceElement
  }, /*#__PURE__*/React__default.createElement("button", {
    className: styles.buttonWrapForTitle,
    onClick: toggleVisibility
  }, /*#__PURE__*/React__default.createElement(ProfileMenu, {
    username: userInfo.userName,
    firstName: userInfo.firstName,
    lastName: userInfo.lastName
  }))), dropdownVisible && /*#__PURE__*/createPortal( /*#__PURE__*/React__default.createElement(Card, Object.assign({
    ref: setPopperElement,
    style: popperStyles.popper,
    className: styles.dropDownDiv
  }, attributes.popper), /*#__PURE__*/React__default.createElement(UserInfoSection, {
    userName: userInfo.userName,
    userEmail: userInfo.userEmail,
    firstName: userInfo.firstName,
    lastName: userInfo.lastName
  }), Boolean(sections === null || sections === void 0 ? void 0 : sections.length) && sections.map(function (buttons, index) {
    return Boolean(buttons.length) && /*#__PURE__*/React__default.createElement(UserDropdownSection, {
      key: index,
      buttons: buttons,
      onClick: function onClick() {
        return setDropdownVisible(false);
      }
    });
  })), document.body));
};
var useStyles$w = createUseStyles(function (theme) {
  return {
    holderDiv: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end'
    },
    buttonWrapForTitle: {
      border: 'none',
      backgroundColor: 'inherit',
      outline: 'none',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      padding: 0,
      height: 'fit-content'
    },
    dropDownDiv: {
      minWidth: 200,
      boxShadow: theme.shadows[0],
      zIndex: theme.zIndex.high,
      padding: 0
    },
    dropDownIconTextDiv: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center'
    }
  };
});

var helpButton = 'data:image/svg+xml;base64,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';

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate$1(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  return !isNaN(date);
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
function formatDistance(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
}

function buildFormatLongFn(args) {
  return function (dirtyOptions) {
    var options = dirtyOptions || {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var formatLong$1 = formatLong;

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
}

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter'] // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.

};
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

function ordinalNumber(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
}

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1 = localize;

function buildMatchPatternFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var matchResult = string.match(args.matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);

    if (!parseResult) {
      return null;
    }

    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

function buildMatchFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var value;

    if (Object.prototype.toString.call(parsePatterns) === '[object Array]') {
      value = findIndex(parsePatterns, function (pattern) {
        return pattern.test(matchedString);
      });
    } else {
      value = findKey(parsePatterns, function (pattern) {
        return pattern.test(matchedString);
      });
    }

    value = args.valueCallback ? args.valueCallback(value) : value;
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var match$1 = match;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */

var locale = {
  code: 'en-US',
  formatDistance: formatDistance,
  formatLong: formatLong$1,
  formatRelative: formatRelative,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var defaultLocale = locale;

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate$1(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

function addLeadingZeros$1(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters$4 = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros$1(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros$1(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return addLeadingZeros$1(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return addLeadingZeros$1(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return addLeadingZeros$1(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return addLeadingZeros$1(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return addLeadingZeros$1(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros$1(fractionalSeconds, token.length);
  }
};
var lightFormatters = formatters$4;

var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate$1(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate$1(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate$1(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
  /*
   * |     | Unit                           |     | Unit                           |
   * |-----|--------------------------------|-----|--------------------------------|
   * |  a  | AM, PM                         |  A* | Milliseconds in day            |
   * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
   * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
   * |  d  | Day of month                   |  D  | Day of year                    |
   * |  e  | Local day of week              |  E  | Day of week                    |
   * |  f  |                                |  F* | Day of week in month           |
   * |  g* | Modified Julian day            |  G  | Era                            |
   * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
   * |  i! | ISO day of week                |  I! | ISO week of year               |
   * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
   * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
   * |  l* | (deprecated)                   |  L  | Stand-alone month              |
   * |  m  | Minute                         |  M  | Month                          |
   * |  n  |                                |  N  |                                |
   * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
   * |  p! | Long localized time            |  P! | Long localized date            |
   * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
   * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
   * |  s  | Second                         |  S  | Fraction of second             |
   * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
   * |  u  | Extended year                  |  U* | Cyclic year                    |
   * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
   * |  w  | Local week of year             |  W* | Week of month                  |
   * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
   * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
   * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
   *
   * Letters marked by * are not implemented but reserved by Unicode standard.
   *
   * Letters marked by ! are non-standard, but implemented by date-fns:
   * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
   * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
   *   i.e. 7 for Sunday, 1 for Monday, etc.
   * - `I` is ISO week of year, as opposed to `w` which is local week of year.
   * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
   *   `R` is supposed to be used in conjunction with `I` and `i`
   *   for universal ISO week-numbering date, whereas
   *   `Y` is supposed to be used in conjunction with `w` and `e`
   *   for week-numbering date specific to the locale.
   * - `P` is long localized date format
   * - `p` is long localized time format
   */

};
var formatters$2 = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros$1(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros$1(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros$1(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros$1(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros$1(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros$1(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros$1(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros$1(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros$1(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros$1(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros$1(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros$1(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros$1(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros$1(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros$1(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return lightFormatters.m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes$1(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone$1(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone$1(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes$1(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone$1(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone$1(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort$1(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone$1(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort$1(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone$1(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros$1(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros$1(timestamp, token.length);
  }
};

function formatTimezoneShort$1(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros$1(minutes, 2);
}

function formatTimezoneWithOptionalMinutes$1(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros$1(Math.abs(offset) / 60, 2);
  }

  return formatTimezone$1(offset, dirtyDelimiter);
}

function formatTimezone$1(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros$1(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros$1(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

var formatters$3 = formatters$2;

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/);
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var longFormatters$1 = longFormatters;

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 0001, ..., 999               |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format$1(dirtyDate, dirtyFormatStr, dirtyOptions) {
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale = options.locale || defaultLocale;
  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = toDate$1(dirtyDate);

  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = formatters$3[firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */
function tzIntlTimeZoneName(length, date, options) {
  var dtf = getDTF(length, options.timeZone, options.locale);
  return dtf.formatToParts ? partsTimeZone(dtf, date) : hackyTimeZone(dtf, date)
}

function partsTimeZone(dtf, date) {
  var formatted = dtf.formatToParts(date);
  return formatted[formatted.length - 1].value
}

function hackyTimeZone(dtf, date) {
  var formatted = dtf.format(date).replace(/\u200E/g, '');
  var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
  return tzNameMatch ? tzNameMatch[0].substr(1) : ''
}

// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function getDTF(length, timeZone, locale) {
  if (locale && !locale.code) {
    throw new Error(
      "date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`"
    )
  }
  return new Intl.DateTimeFormat(locale ? [locale.code, 'en-US'] : undefined, {
    timeZone: timeZone,
    timeZoneName: length,
  })
}

/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */
function tzTokenizeDate(date, timeZone) {
  var dtf = getDateTimeFormat(timeZone);
  return dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date)
}

var typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5,
};

function partsOffset(dtf, date) {
  var formatted = dtf.formatToParts(date);
  var filled = [];
  for (var i = 0; i < formatted.length; i++) {
    var pos = typeToPos[formatted[i].type];

    if (pos >= 0) {
      filled[pos] = parseInt(formatted[i].value, 10);
    }
  }
  return filled
}

function hackyOffset(dtf, date) {
  var formatted = dtf.format(date).replace(/\u200E/g, '');
  var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
  // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
  // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
  return [parsed[3], parsed[1], parsed[2], parsed[4], parsed[5], parsed[6]]
}

// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var dtfCache = {};
function getDateTimeFormat(timeZone) {
  if (!dtfCache[timeZone]) {
    // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
    var testDateFormatted = new Intl.DateTimeFormat('en-US', {
      hour12: false,
      timeZone: 'America/New_York',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }).format(new Date('2014-06-25T04:00:00.123Z'));
    var hourCycleSupported =
      testDateFormatted === '06/25/2014, 00:00:00' ||
      testDateFormatted === '‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00';

    dtfCache[timeZone] = hourCycleSupported
      ? new Intl.DateTimeFormat('en-US', {
          hour12: false,
          timeZone: timeZone,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        })
      : new Intl.DateTimeFormat('en-US', {
          hourCycle: 'h23',
          timeZone: timeZone,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        });
  }
  return dtfCache[timeZone]
}

var MILLISECONDS_IN_HOUR$1 = 3600000;
var MILLISECONDS_IN_MINUTE$2 = 60000;

var patterns$1 = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-])(\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/,
};

// Parse various time zone offset formats to an offset in milliseconds
function tzParseTimezone(timezoneString, date, isUtcDate) {
  var token;
  var absoluteOffset;

  // Empty string
  if (timezoneString === '') {
    return 0
  }

  // Z
  token = patterns$1.timezoneZ.exec(timezoneString);
  if (token) {
    return 0
  }

  var hours;

  // ±hh
  token = patterns$1.timezoneHH.exec(timezoneString);
  if (token) {
    hours = parseInt(token[2], 10);

    if (!validateTimezone()) {
      return NaN
    }

    absoluteOffset = hours * MILLISECONDS_IN_HOUR$1;
    return token[1] === '+' ? -absoluteOffset : absoluteOffset
  }

  // ±hh:mm or ±hhmm
  token = patterns$1.timezoneHHMM.exec(timezoneString);
  if (token) {
    hours = parseInt(token[2], 10);
    var minutes = parseInt(token[3], 10);

    if (!validateTimezone(hours, minutes)) {
      return NaN
    }

    absoluteOffset = hours * MILLISECONDS_IN_HOUR$1 + minutes * MILLISECONDS_IN_MINUTE$2;
    return token[1] === '+' ? -absoluteOffset : absoluteOffset
  }

  // IANA time zone
  if (isValidTimezoneIANAString(timezoneString)) {
    date = new Date(date || Date.now());
    var utcDate = isUtcDate ? date : toUtcDate(date);

    var offset = calcOffset(utcDate, timezoneString);

    var fixedOffset = isUtcDate ? offset : fixOffset(date, offset, timezoneString);

    return -fixedOffset
  }

  return NaN
}

function toUtcDate(date) {
  return new Date(
    Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
      date.getMilliseconds()
    )
  )
}

function calcOffset(date, timezoneString) {
  var tokens = tzTokenizeDate(date, timezoneString);

  var asUTC = Date.UTC(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5]);

  var asTS = date.getTime();
  var over = asTS % 1000;
  asTS -= over >= 0 ? over : 1000 + over;
  return asUTC - asTS
}

function fixOffset(date, offset, timezoneString) {
  var localTS = date.getTime();

  // Our UTC time is just a guess because our offset is just a guess
  var utcGuess = localTS - offset;

  // Test whether the zone matches the offset for this ts
  var o2 = calcOffset(new Date(utcGuess), timezoneString);

  // If so, offset didn't change, and we're done
  if (offset === o2) {
    return offset
  }

  // If not, change the ts by the difference in the offset
  utcGuess -= o2 - offset;

  // If that gives us the local time we want, we're done
  var o3 = calcOffset(new Date(utcGuess), timezoneString);
  if (o2 === o3) {
    return o2
  }

  // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
  return Math.max(o2, o3)
}

function validateTimezone(hours, minutes) {
  return !(minutes != null && (minutes < 0 || minutes > 59))
}

var validIANATimezoneCache = {};
function isValidTimezoneIANAString(timeZoneString) {
  if (validIANATimezoneCache[timeZoneString]) return true
  try {
    Intl.DateTimeFormat(undefined, { timeZone: timeZoneString });
    validIANATimezoneCache[timeZoneString] = true;
    return true
  } catch (error) {
    return false
  }
}

var MILLISECONDS_IN_MINUTE$1 = 60 * 1000;

var formatters = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = options.timeZone
      ? tzParseTimezone(options.timeZone, originalDate, true) / MILLISECONDS_IN_MINUTE$1
      : originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z'
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset)

      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX': // Hours and minutes without `:` delimeter
        return formatTimezone(timezoneOffset)

      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimeter
      default:
        return formatTimezone(timezoneOffset, ':')
    }
  },

  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = options.timeZone
      ? tzParseTimezone(options.timeZone, originalDate, true) / MILLISECONDS_IN_MINUTE$1
      : originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset)

      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx': // Hours and minutes without `:` delimeter
        return formatTimezone(timezoneOffset)

      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimeter
      default:
        return formatTimezone(timezoneOffset, ':')
    }
  },

  // Timezone (GMT)
  O: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = options.timeZone
      ? tzParseTimezone(options.timeZone, originalDate, true) / MILLISECONDS_IN_MINUTE$1
      : originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':')
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':')
    }
  },

  // Timezone (specific non-location)
  z: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return tzIntlTimeZoneName('short', originalDate, options)
      // Long
      case 'zzzz':
      default:
        return tzIntlTimeZoneName('long', originalDate, options)
    }
  },
};

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output
}

function formatTimezone(offset, dirtyDelimeter) {
  var delimeter = dirtyDelimeter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimeter + minutes
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2)
  }
  return formatTimezone(offset, dirtyDelimeter)
}

function formatTimezoneShort(offset, dirtyDelimeter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours)
  }
  var delimeter = dirtyDelimeter || '';
  return sign + String(hours) + delimeter + addLeadingZeros(minutes, 2)
}

var formatters$1 = formatters;

/** Regex to identify the presence of a time zone specifier in a date string */
var tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;

var tzPattern$1 = tzPattern;

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;

var patterns = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,

  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/, // 0 additional digits
    /^([+-]\d{3})$/, // 1 additional digit
    /^([+-]\d{4})$/, // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/, // 0 additional digits
    /^([+-]\d{5})/, // 1 additional digit
    /^([+-]\d{6})/, // 2 additional digits
  ],

  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,

  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,

  // time zone tokens (to identify the presence of a tz)
  timeZone: tzPattern$1,
};

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 * If the function cannot parse the string or the values are invalid, it returns Invalid Date.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 * All *date-fns* functions will throw `RangeError` if `options.additionalDigits` is not 0, 1, 2 or undefined.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @param {String} [options.timeZone=''] - used to specify the IANA time zone offset of a date String.
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = toDate('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * var result = toDate('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function toDate(argument, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  if (argument === null) {
    return new Date(NaN)
  }

  var options = dirtyOptions || {};

  var additionalDigits =
    options.additionalDigits == null
      ? DEFAULT_ADDITIONAL_DIGITS
      : toInteger(options.additionalDigits);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2')
  }

  // Clone the date
  if (
    argument instanceof Date ||
    (typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]')
  ) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime())
  } else if (
    typeof argument === 'number' ||
    Object.prototype.toString.call(argument) === '[object Number]'
  ) {
    return new Date(argument)
  } else if (
    !(
      typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]'
    )
  ) {
    return new Date(NaN)
  }

  var dateStrings = splitDateString(argument);

  var parseYearResult = parseYear(dateStrings.date, additionalDigits);
  var year = parseYearResult.year;
  var restDateString = parseYearResult.restDateString;

  var date = parseDate(restDateString, year);

  if (isNaN(date)) {
    return new Date(NaN)
  }

  if (date) {
    var timestamp = date.getTime();
    var time = 0;
    var offset;

    if (dateStrings.time) {
      time = parseTime(dateStrings.time);

      if (isNaN(time)) {
        return new Date(NaN)
      }
    }

    if (dateStrings.timeZone || options.timeZone) {
      offset = tzParseTimezone(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
      if (isNaN(offset)) {
        return new Date(NaN)
      }
    } else {
      // get offset accurate to hour in time zones that change offset
      offset = getTimezoneOffsetInMilliseconds(new Date(timestamp + time));
      offset = getTimezoneOffsetInMilliseconds(new Date(timestamp + time + offset));
    }

    return new Date(timestamp + time + offset)
  } else {
    return new Date(NaN)
  }
}

function splitDateString(dateString) {
  var dateStrings = {};
  var parts = patterns.dateTimePattern.exec(dateString);
  var timeString;

  if (!parts) {
    parts = patterns.datePattern.exec(dateString);
    if (parts) {
      dateStrings.date = parts[1];
      timeString = parts[2];
    } else {
      dateStrings.date = null;
      timeString = dateString;
    }
  } else {
    dateStrings.date = parts[1];
    timeString = parts[3];
  }

  if (timeString) {
    var token = patterns.timeZone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timeZone = token[1].trim();
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings
}

function parseYear(dateString, additionalDigits) {
  var patternYYY = patterns.YYY[additionalDigits];
  var patternYYYYY = patterns.YYYYY[additionalDigits];

  var token;

  // YYYY or ±YYYYY
  token = patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
  if (token) {
    var yearString = token[1];
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length),
    }
  }

  // YY or ±YYY
  token = patterns.YY.exec(dateString) || patternYYY.exec(dateString);
  if (token) {
    var centuryString = token[1];
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length),
    }
  }

  // Invalid ISO-formatted year
  return {
    year: null,
  }
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null
  }

  var token;
  var date;
  var month;
  var week;

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0);
    date.setUTCFullYear(year);
    return date
  }

  // YYYY-MM
  token = patterns.MM.exec(dateString);
  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;

    if (!validateDate(year, month)) {
      return new Date(NaN)
    }

    date.setUTCFullYear(year, month);
    return date
  }

  // YYYY-DDD or YYYYDDD
  token = patterns.DDD.exec(dateString);
  if (token) {
    date = new Date(0);
    var dayOfYear = parseInt(token[1], 10);

    if (!validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN)
    }

    date.setUTCFullYear(year, 0, dayOfYear);
    return date
  }

  // yyyy-MM-dd or YYYYMMDD
  token = patterns.MMDD.exec(dateString);
  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;
    var day = parseInt(token[2], 10);

    if (!validateDate(year, month, day)) {
      return new Date(NaN)
    }

    date.setUTCFullYear(year, month, day);
    return date
  }

  // YYYY-Www or YYYYWww
  token = patterns.Www.exec(dateString);
  if (token) {
    week = parseInt(token[1], 10) - 1;

    if (!validateWeekDate(year, week)) {
      return new Date(NaN)
    }

    return dayOfISOWeekYear(year, week)
  }

  // YYYY-Www-D or YYYYWwwD
  token = patterns.WwwD.exec(dateString);
  if (token) {
    week = parseInt(token[1], 10) - 1;
    var dayOfWeek = parseInt(token[2], 10) - 1;

    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN)
    }

    return dayOfISOWeekYear(year, week, dayOfWeek)
  }

  // Invalid ISO-formatted date
  return null
}

function parseTime(timeString) {
  var token;
  var hours;
  var minutes;

  // hh
  token = patterns.HH.exec(timeString);
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'));

    if (!validateTime(hours)) {
      return NaN
    }

    return (hours % 24) * MILLISECONDS_IN_HOUR
  }

  // hh:mm or hhmm
  token = patterns.HHMM.exec(timeString);
  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseFloat(token[2].replace(',', '.'));

    if (!validateTime(hours, minutes)) {
      return NaN
    }

    return (hours % 24) * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE
  }

  // hh:mm:ss or hhmmss
  token = patterns.HHMMSS.exec(timeString);
  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseInt(token[2], 10);
    var seconds = parseFloat(token[3].replace(',', '.'));

    if (!validateTime(hours, minutes, seconds)) {
      return NaN
    }

    return (hours % 24) * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000
  }

  // Invalid ISO-formatted time
  return null
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  week = week || 0;
  day = day || 0;
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date
}

// Validation functions

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0)
}

function validateDate(year, month, date) {
  if (month < 0 || month > 11) {
    return false
  }

  if (date != null) {
    if (date < 1) {
      return false
    }

    var isLeapYear = isLeapYearIndex(year);
    if (isLeapYear && date > DAYS_IN_MONTH_LEAP_YEAR[month]) {
      return false
    }
    if (!isLeapYear && date > DAYS_IN_MONTH[month]) {
      return false
    }
  }

  return true
}

function validateDayOfYearDate(year, dayOfYear) {
  if (dayOfYear < 1) {
    return false
  }

  var isLeapYear = isLeapYearIndex(year);
  if (isLeapYear && dayOfYear > 366) {
    return false
  }
  if (!isLeapYear && dayOfYear > 365) {
    return false
  }

  return true
}

function validateWeekDate(year, week, day) {
  if (week < 0 || week > 52) {
    return false
  }

  if (day != null && (day < 0 || day > 6)) {
    return false
  }

  return true
}

function validateTime(hours, minutes, seconds) {
  if (hours != null && (hours < 0 || hours >= 25)) {
    return false
  }

  if (minutes != null && (minutes < 0 || minutes >= 60)) {
    return false
  }

  if (seconds != null && (seconds < 0 || seconds >= 60)) {
    return false
  }

  return true
}

var tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 8     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 8     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Su            | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aaa  | AM, PM                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 1, 2, ..., 11, 0                  |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 0001, ..., 999               |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | PDT, EST, CEST                    | 6     |
 * |                                 | zzzz    | Pacific Daylight Time             | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 05/29/1453                        | 7     |
 * |                                 | PP      | May 29, 1453                      | 7     |
 * |                                 | PPP     | May 29th, 1453                    | 7     |
 * |                                 | PPPP    | Sunday, May 29th, 1453            | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 05/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | May 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | May 29th, 1453 at ...             | 7     |
 * |                                 | PPPPpppp| Sunday, May 29th, 1453 at ...     | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are created using the Intl browser API. The output is determined by the
 *    preferred standard of the current locale (en-US by default) which may not always give the expected result.
 *    For this reason it is recommended to supply a `locale` in the format options when formatting a time zone name.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. These tokens are often confused with others. See: https://git.io/fxCyr
 *
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole
 *   library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard
 *   #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table). See [this
 *   post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|String|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link
 *   https://date-fns.org/docs/toDate}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See
 *   [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {Boolean} [options.awareOfUnicodeTokens=false] - if true, allows usage of Unicode tokens causes confusion:
 *   - Some of the day of year tokens (`D`, `DD`) that are confused with the day of month tokens (`d`, `dd`).
 *   - Some of the local week-numbering year tokens (`YY`, `YYYY`) that are confused with the calendar year tokens
 *   (`yy`, `yyyy`). See: https://git.io/fxCyr
 * @param {String} [options.timeZone=''] - used to specify the IANA time zone offset of a date String.
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.awareOfUnicodeTokens` must be set to `true` to use `XX` token; see:
 *   https://git.io/fxCyr
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/esm/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */
function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};

  var matches = formatStr.match(tzFormattingTokensRegExp);
  if (matches) {
    var date = toDate(dirtyDate, options);
    // Work through each match and replace the tz token in the format string with the quoted
    // formatted time zone so the remaining tokens can be filled in by date-fns#format.
    formatStr = matches.reduce(function (result, token) {
      if (token[0] === "'") {
        return result // This is a quoted portion, matched only to ensure we don't match inside it
      }
      var pos = result.indexOf(token);
      var precededByQuotedSection = result[pos - 1] === "'";
      var replaced = result.replace(
        token,
        "'" + formatters$1[token[0]](date, token, null, options) + "'"
      );
      // If the replacement results in two adjoining quoted strings, the back to back quotes
      // are removed so it doesn't look like an escaped quote.
      return precededByQuotedSection
        ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1)
        : replaced
    }, formatStr);
  }

  return format$1(dirtyDate, formatStr, options)
}

var NotificationLevel;

(function (NotificationLevel) {
  NotificationLevel["Action"] = "action";
})(NotificationLevel || (NotificationLevel = {}));

var NotificationItem = function NotificationItem(_ref) {
  var ctime = _ref.ctime,
      level = _ref.level,
      message = _ref.message,
      link = _ref.link,
      link_display_text = _ref.link_display_text;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "notification-item-root"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "flex-row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "action-type-root"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "dot-outer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "dot-inner"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "action-type-text"
  }, /*#__PURE__*/React__default.createElement(Text$1, {
    variant: "card-header-big"
  }, level))), /*#__PURE__*/React__default.createElement("div", {
    className: "date"
  }, /*#__PURE__*/React__default.createElement(Text$1, {
    variant: "default-tab"
  }, format(new Date(ctime), 'dd/MM/yyyy HH:mm')))), /*#__PURE__*/React__default.createElement("div", {
    className: "message"
  }, /*#__PURE__*/React__default.createElement(Text$1, {
    variant: "header-2"
  }, message)), /*#__PURE__*/React__default.createElement("div", {
    className: "link"
  }, /*#__PURE__*/React__default.createElement(Text$1, {
    variant: "body",
    component: "a",
    href: link
  }, link_display_text)));
};

var Bell = function Bell() {
  var theme = useThemeSafe();
  var bellColor = theme.palette.white.color;
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "18",
    height: "19",
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M13.5 6.5C13.5 5.30653 13.0259 4.16193 12.182 3.31802C11.3381 2.47411 10.1935 2 9 2C7.80653 2 6.66193 2.47411 5.81802 3.31802C4.97411 4.16193 4.5 5.30653 4.5 6.5C4.5 11.75 2.25 13.25 2.25 13.25H15.75C15.75 13.25 13.5 11.75 13.5 6.5Z",
    fill: bellColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M11 15.5C10.7968 15.8042 10.505 16.0566 10.154 16.2321C9.80302 16.4076 9.40506 16.5 9 16.5C8.59494 16.5 8.19698 16.4076 7.84598 16.2321C7.49498 16.0566 7.20325 15.8042 7 15.5",
    fill: bellColor
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M11 15.5C10.7968 15.8042 10.505 16.0566 10.154 16.2321C9.80302 16.4076 9.40506 16.5 9 16.5C8.59494 16.5 8.19698 16.4076 7.84598 16.2321C7.49498 16.0566 7.20325 15.8042 7 15.5H10.5414",
    stroke: bellColor,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var NotificationView = function NotificationView(_ref) {
  var notificationList = _ref.notificationList;

  var _useState = useState(null),
      _useState2 = _slicedToArray$1(_useState, 2),
      popoverRefEl = _useState2[0],
      setPopoverRefEl = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$1(_useState3, 2),
      popoverVisible = _useState4[0],
      setPopoverVisible = _useState4[1];

  var theme = useThemeSafe();
  var styles = useStyles$v({
    theme: theme
  });
  var isBellActive = useMemo(function () {
    return Boolean(notificationList.length);
  }, [notificationList]);
  var handlePopover = useCallback(function () {
    if (!isBellActive) {
      return;
    }

    setPopoverVisible(function (prev) {
      return !prev;
    });
  }, [isBellActive]);
  var tooltipElement = /*#__PURE__*/React__default.createElement("div", {
    className: styles.tooltipRoot
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.notificationListHeader
  }, /*#__PURE__*/React__default.createElement(Text$1, {
    variant: "subnav-header-light"
  }, "Notifications (", notificationList.length, ")")), /*#__PURE__*/React__default.createElement("div", {
    className: styles.notificationList
  }, notificationList.sort(function (prevNotification, nextNotification) {
    return new Date(nextNotification.ctime).getTime() - new Date(prevNotification.ctime).getTime();
  }).map(function (notification) {
    return /*#__PURE__*/React__default.createElement(NotificationItem, Object.assign({}, notification, {
      key: notification.id
    }));
  })));
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.root,
    ref: setPopoverRefEl,
    onClick: handlePopover
  }, isBellActive && /*#__PURE__*/React__default.createElement("div", {
    className: styles.numberCircle
  }, /*#__PURE__*/React__default.createElement(Text$1, {
    variant: "body",
    color: "white",
    style: {
      fontSize: 9
    }
  }, notificationList.length)), /*#__PURE__*/React__default.createElement(Bell, null), /*#__PURE__*/React__default.createElement(Popover, {
    visible: popoverVisible,
    onVisibilityChange: function onVisibilityChange(isVisible) {
      return setPopoverVisible(isVisible);
    },
    target: popoverRefEl,
    className: styles.popover
  }, tooltipElement));
};
var useStyles$v = createUseStyles(function (theme) {
  return {
    root: {
      position: 'relative',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    numberCircle: {
      backgroundColor: theme.palette.error.color,
      width: 12,
      height: 12,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
      position: 'absolute',
      top: -2,
      right: -2
    },
    tooltipRoot: {
      width: 360,
      display: 'flex',
      flexDirection: 'column'
    },
    notificationListHeader: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyItems: 'center',
      height: 48,
      padding: '0 28px',
      boxShadow: theme.shadows[1]
    },
    notificationList: {
      padding: '0 28px 16px 28px',
      display: 'flex',
      flexDirection: 'column',
      maxHeight: 400,
      minHeight: 100,
      overflowY: 'auto',
      overflowX: 'hidden'
    },
    popover: {
      width: 360,
      maxWidth: 360,
      padding: 0
    }
  };
});

var MinimalNavBar = function MinimalNavBar(_ref) {
  var title = _ref.title,
      userName = _ref.userName,
      firstName = _ref.firstName,
      lastName = _ref.lastName,
      userEmail = _ref.userEmail,
      userDropdownSections = _ref.userDropdownSections,
      logo = _ref.logo,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'user-nav' : _ref$variant,
      _ref$showNotification = _ref.showNotification,
      showNotification = _ref$showNotification === void 0 ? false : _ref$showNotification,
      _ref$notifications = _ref.notifications,
      notifications = _ref$notifications === void 0 ? [] : _ref$notifications,
      _ref$showBanner = _ref.showBanner,
      showBanner = _ref$showBanner === void 0 ? true : _ref$showBanner,
      bannerText = _ref.bannerText,
      _ref$onBannerClick = _ref.onBannerClick,
      onBannerClick = _ref$onBannerClick === void 0 ? undefined : _ref$onBannerClick,
      _ref$bannerVariant = _ref.bannerVariant,
      bannerVariant = _ref$bannerVariant === void 0 ? 'license' : _ref$bannerVariant,
      _ref$showHelpIcon = _ref.showHelpIcon,
      showHelpIcon = _ref$showHelpIcon === void 0 ? variant === 'admin-nav' : _ref$showHelpIcon;
  var theme = useThemeSafe();
  var styles = useStyles$u({
    theme: theme
  });
  var shouldRenderUserDropDown = Boolean(userName) && Boolean(userDropdownSections === null || userDropdownSections === void 0 ? void 0 : userDropdownSections.some(function (buttons) {
    return Boolean(buttons.length);
  }));
  var pageHeaderColor = theme.palette.white.color; // left parts of the navbar

  var leftParts = [/*#__PURE__*/React__default.cloneElement(logo, {
    key: 'logo-key'
  })];

  if (title) {
    leftParts.push( /*#__PURE__*/React__default.createElement("div", {
      className: styles.title,
      key: "title"
    }, /*#__PURE__*/React__default.createElement(Text$1, {
      variant: "subnav-header-light",
      color: pageHeaderColor
    }, title)));
  } // right parts of the navbar


  var rightParts = []; // check that we need to show the banner
  // and that the text is not empty

  if (showBanner && bannerText !== '' && variant === 'admin-nav') {
    rightParts.push( /*#__PURE__*/React__default.createElement("div", {
      onClick: onBannerClick,
      className: styles.banner,
      key: "".concat(bannerVariant, "-banner")
    }, /*#__PURE__*/React__default.createElement(Banner, {
      variant: bannerVariant
    }, bannerText)));
  }

  if (showHelpIcon) {
    rightParts.push( /*#__PURE__*/React__default.createElement("div", {
      key: "help-center-link",
      className: styles.help,
      onClick: function onClick() {
        return window.open('https://support.cyolo.io/hc/en-us');
      }
    }, /*#__PURE__*/React__default.createElement(Image, {
      alt: "help center link",
      src: helpButton,
      size: 20
    })));
  }

  if (showNotification) {
    rightParts.push( /*#__PURE__*/React__default.createElement(NotificationView, {
      notificationList: notifications,
      key: "notifications-view"
    }));
  }

  if (shouldRenderUserDropDown) {
    rightParts.push( /*#__PURE__*/React__default.createElement(UserDropDown, {
      key: "dropdown",
      userInfo: {
        userName: userName,
        firstName: firstName,
        lastName: lastName,
        userEmail: userEmail
      },
      sections: userDropdownSections
    }));
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx('CyoloUI-NavBar', styles.root)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.grid
  }, leftParts, /*#__PURE__*/React__default.createElement("div", {
    key: "navbar-right-part",
    className: styles.userDropdown
  }, rightParts)));
};
var useStyles$u = createUseStyles(function (theme) {
  return {
    root: {
      position: 'fixed',
      height: 56,
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      zIndex: theme.zIndex.high,
      background: theme.palette.secondary.color
    },
    grid: {
      display: 'grid',
      paddingLeft: 32,
      paddingRight: 32,
      height: '100%',
      gridTemplateColumns: '100px auto max-content',
      alignItems: 'center'
    },
    title: {
      textAlign: 'center'
    },
    userDropdown: {
      minWidth: 100,
      gridColumnStart: 3,
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: 16
    },
    banner: {
      cursor: 'pointer'
    },
    help: _defineProperty$1({
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%'
    }, '&:hover', {
      cursor: 'pointer'
    }),
    '@media only screen and (max-width: 600px)': {
      title: {
        gridRowStart: 2,
        gridColumnStart: 1,
        gridColumnEnd: 4
      }
    }
  };
});

var MinimalNavBarMobile = function MinimalNavBarMobile(_ref) {
  var title = _ref.title,
      userName = _ref.userName,
      firstName = _ref.firstName,
      lastName = _ref.lastName,
      userEmail = _ref.userEmail,
      userDropdownSections = _ref.userDropdownSections,
      onMenuClick = _ref.onMenuClick;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "CyoloUI-MinimalNavbarMobile-Root"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "CyoloUI-MinimalNavbarMobile-Menu"
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    iconID: "hamburger-menu-icon",
    onClick: onMenuClick
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "CyoloUI-MinimalNavbarMobile-Title"
  }, /*#__PURE__*/React__default.createElement(Text$1, {
    variant: "user-name"
  }, title)), /*#__PURE__*/React__default.createElement("div", {
    className: "CyoloUI-MinimalNavbarMobile-Profile"
  }, /*#__PURE__*/React__default.createElement(UserDropDown, {
    userInfo: {
      userName: userName,
      firstName: firstName,
      lastName: lastName,
      userEmail: userEmail
    },
    sections: userDropdownSections
  })));
};

var NoDataView = function NoDataView(_a) {
  var title = _a.title,
      subTitle = _a.subTitle,
      _a$buttonText = _a.buttonText,
      buttonText = _a$buttonText === void 0 ? '' : _a$buttonText,
      _a$showButton = _a.showButton,
      showButton = _a$showButton === void 0 ? true : _a$showButton,
      _a$onClick = _a.onClick,
      onClick = _a$onClick === void 0 ? function () {} : _a$onClick,
      illustration = _a.illustration,
      rest = __rest(_a, ["title", "subTitle", "buttonText", "showButton", "onClick", "illustration"]);

  return /*#__PURE__*/React__default.createElement("div", Object.assign({
    className: "NoDataView-Root"
  }, rest), title && /*#__PURE__*/React__default.createElement(Text$1, {
    variant: "page-header"
  }, title), subTitle && /*#__PURE__*/React__default.createElement(Text$1, {
    style: {
      marginTop: 12
    },
    variant: "body"
  }, subTitle), showButton && /*#__PURE__*/React__default.createElement(Button, {
    style: {
      marginTop: 18,
      width: 'fit-content',
      height: 27
    },
    variant: "primary",
    onClick: onClick
  }, buttonText), /*#__PURE__*/React__default.createElement(Image, {
    alt: "illustration",
    src: illustration,
    className: "NoDataView-illustration"
  }));
};

var useAutoScroller = function useAutoScroller(scrollableElement) {
  var timesToScrollDownAndUp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  useEffect(function () {
    if (scrollableElement) {
      var y = 0;
      var max = scrollableElement.scrollHeight;
      var min = 0;

      var scrollDown = function scrollDown() {
        return new Promise(function (resolve, reject) {
          console.log('SCROLLING DOWN');
          var interval = setInterval(function () {
            if (y < max) {
              y = y + 150;
              scrollableElement.scrollTo(0, y);
            } else {
              clearInterval(interval);
              resolve('Done');
            }
          }, 100);
        });
      };

      var scrollUp = function scrollUp() {
        return new Promise(function (resolve) {
          console.log('SCROLLING UP');
          var interval = setInterval(function () {
            if (y > min) {
              y = y - 150;
              scrollableElement.scrollTo(0, y);
            } else {
              clearInterval(interval);
              resolve('Done');
            }
          }, 100);
        });
      };

      var scroller = function scroller() {
        return __awaiter(void 0, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var i;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  i = 0;

                case 1:
                  if (!(i < timesToScrollDownAndUp)) {
                    _context.next = 9;
                    break;
                  }

                  _context.next = 4;
                  return scrollDown();

                case 4:
                  _context.next = 6;
                  return scrollUp();

                case 6:
                  i++;
                  _context.next = 1;
                  break;

                case 9:
                  console.log('DONE');

                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
      };

      scroller();
    }
  }, [scrollableElement, timesToScrollDownAndUp]);
};

var ComponentBenchmarkWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits$1(ComponentBenchmarkWrapper, _React$Component);

  var _super = _createSuper$1(ComponentBenchmarkWrapper);

  // @ts-ignore
  function ComponentBenchmarkWrapper(props) {
    var _this;

    _classCallCheck$4(this, ComponentBenchmarkWrapper);

    _this = _super.call(this, props);
    _this.tsStart = performance.now();
    return _this;
  }

  _createClass$1(ComponentBenchmarkWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      console.log("".concat(this.props.tag, ": did mount time: ").concat(performance.now() - this.tsStart, "ms"));
    }
  }, {
    key: "render",
    value: function render() {
      console.log("".concat(this.props.tag, ": render time: ").concat(performance.now() - this.tsStart, "ms"));

      var _a = this.props,
          WrappedComponent = _a.component,
          rest = __rest(_a, ["component"]); // @ts-ignore


      return /*#__PURE__*/React__default.createElement(WrappedComponent, Object.assign({}, rest));
    }
  }]);

  return ComponentBenchmarkWrapper;
}(React__default.Component);

/**
 * usePageRedirectBeanchMark
 */

function usePageRedirectBeanchMark(sourcePath, destPath, redirectsMax, pauseTime) {
  var history = useHistory$1();

  var _useLocation = useLocation(),
      pathname = _useLocation.pathname;

  var _useState = useState(0),
      _useState2 = _slicedToArray$1(_useState, 2),
      redirectCount = _useState2[0],
      setRedirectCount = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray$1(_useState3, 2),
      isPending = _useState4[0],
      setIsPending = _useState4[1];

  var WAIT_TIME = 10 * 1000;
  useEffect(function () {
    history.push(sourcePath);
    console.log('[PageRedirectBeanchMark] waiting', WAIT_TIME, 'ms to start');
    var timer = setTimeout(function () {
      console.log('[PageRedirectBeanchMark] Starting');
      setIsPending(false);
    }, WAIT_TIME);
    return function () {
      clearTimeout(timer);
    };
  }, []);
  useEffect(function () {
    if (isPending) {
      return;
    }

    if (redirectCount < redirectsMax * 2) {
      var timer = setTimeout(function () {
        if (pathname == sourcePath) {
          history.push(destPath);
          console.log('[PageRedirectBeanchMark] redirect to', destPath);
        } else {
          history.push(sourcePath);
        }

        setRedirectCount(redirectCount + 1);
      }, pauseTime);
      return function () {
        clearTimeout(timer);
      };
    }
  }, [redirectCount, redirectsMax, isPending]);
  return redirectCount;
}

var FREE_TEXT_KEY = '_all';
var INCLUDES_OP = '.*';
var OP_VALUE_CONNECTOR = '~';
/**
 * query holds the labels of all the part keys (keyName, operator, values)
 * the resolver return all the matched value for this labels
 */

var defaultResolver = function defaultResolver(operatorList, keyNameList) {
  return function (query) {
    var forceRegex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var regexOperator = {
      value: 're'
    };
    return query.reduce(function (list, part) {
      var _a;

      if (part.isFreeSearch && ((_a = part.valueList[0]) === null || _a === void 0 ? void 0 : _a.length)) {
        return [].concat(_toConsumableArray$1(list), [{
          key: FREE_TEXT_KEY,
          op: part.operator,
          value: "contains~".concat(part.valueList[0]),
          isFreeSearch: part.isFreeSearch
        }]);
      }

      var keyName = keyNameList.find(function (k) {
        return k.label.toLowerCase() === part.keyName.toLowerCase();
      });
      var operator = forceRegex ? regexOperator : operatorList.find(function (o) {
        return o.label.toLowerCase() === part.operator.toLowerCase();
      });

      if (!Boolean(keyName) || !Boolean(operator)) {
        console.error('[defaultResolver] no find for query part. part=', part);
        return list;
      }

      var targetValue = "".concat(operator.value).concat(OP_VALUE_CONNECTOR).concat(part.valueList.join(',')); // support regex

      if (operator.value === regexOperator.value) {
        targetValue = "".concat(operator.value).concat(OP_VALUE_CONNECTOR).concat(INCLUDES_OP).concat(part.valueList.join(',')).concat(INCLUDES_OP);
      }

      return [].concat(_toConsumableArray$1(list), [{
        key: keyName.value,
        value: targetValue
      }]);
    }, []);
  };
};

var opToFnMap = new Map([['eq', function (a, b) {
  return a === b;
}], ['neq', function (a, b) {
  return a !== b;
}], ['re', function (a, b) {
  return a.toString().includes(b.toString());
}]]);

var getObjectValues = function getObjectValues(entity) {
  if (entity.id) {
    // we ignore id value if exists
    var cloned = Object.assign({}, entity);

    if (cloned.id) {
      delete cloned.id;
    }

    return Object.values(cloned).flat(2);
  }

  return Object.values(entity).flat(2);
};

var FILTER_CONCAT_SYMBOL = '_$$_';
var nonApiFilter = function nonApiFilter(searchQuery) {
  return function (entity) {
    var isMatch = searchQuery.reduce(function (res, q) {
      if (res === false) {
        return res;
      }

      if (q.isFreeSearch && q.values) {
        var match = getObjectValues(entity).map(function (val) {
          if (typeof val !== 'string' && typeof val !== 'number') {
            return '';
          }

          return String(val).toLowerCase();
        }).filter(function (s) {
          return s !== '';
        }).join(FILTER_CONCAT_SYMBOL).includes(q.values[0]);
        return Boolean(match);
      }

      if (!entity.hasOwnProperty(q.key)) {
        console.error('[nonApiFilter] entity is missing key. key=', q.key, 'entity=', entity);
        return res;
      }

      var compFn = opToFnMap.get(q.op);

      if (!compFn) {
        console.error('[nonApiFilter] no compFn found for op-keyword. op=', q.op);
        return res;
      }

      var entityVal = entity[q.key];
      var queryVal = q.values[0]; // currently support single value

      switch (_typeof(entityVal)) {
        case 'boolean':
          return compFn(entityVal.toString(), queryVal);

        case 'number':
          return compFn(entityVal, parseInt(queryVal));

        case 'string':
        default:
          return compFn(entityVal.toLowerCase(), queryVal.toLowerCase());
      }
    }, true);
    return isMatch;
  };
};

var uniqeStrList = function uniqeStrList(str, idx, list) {
  return list.indexOf(str) === idx;
};

var emptyStr = function emptyStr(str) {
  return str !== '';
};

var nonApiSuggestions = function nonApiSuggestions(suggestionQueryPart, entityList) {
  if (!suggestionQueryPart) {
    return [];
  }

  var suggestionKey = suggestionQueryPart.key;
  var suggetions = entityList.map(function (u) {
    return String(u[suggestionKey]);
  }).filter(uniqeStrList).filter(emptyStr);
  return suggetions;
};

var nonApiResolver = function nonApiResolver(opList, keyNameList) {
  return function (q) {
    var forceRegex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var regexOperator = {
      value: 're'
    };
    return q.reduce(function (list, part) {
      var _a;

      if (part.isFreeSearch && ((_a = part.valueList[0]) === null || _a === void 0 ? void 0 : _a.length)) {
        return [].concat(_toConsumableArray$1(list), [{
          key: part.keyName,
          op: part.operator,
          values: part.valueList,
          isFreeSearch: part.isFreeSearch
        }]);
      }

      var keyName = keyNameList.find(function (k) {
        return k.label.toLowerCase() === part.keyName.toLowerCase();
      });
      var operator = forceRegex ? regexOperator : opList.find(function (o) {
        return o.label.toLowerCase() === part.operator.toLowerCase();
      });

      if (!Boolean(keyName) || !Boolean(operator)) {
        console.error('[nonApiResolver] no match found for query part. part=', part);
        return list;
      }

      var newQuery = {
        key: keyName.value,
        op: operator.value,
        values: part.valueList
      };
      return [].concat(_toConsumableArray$1(list), [newQuery]);
    }, []);
  };
};

var FREE_SEARCH_INDICATOR = '~';
var FREE_SEARCH_LABEL = 'Text';
var FREE_SEARCH_KEY = '*';
var Operators = {
  EQUAL: {
    label: '=',
    value: 'eq'
  },
  INCLUDE: {
    label: 'INCLUDES',
    value: 're'
  },
  NOT_EQUAL: {
    label: '!=',
    value: 'neq'
  },
  GREATER: {
    label: '>',
    value: 'gte'
  },
  SMALLER: {
    label: '<',
    value: 'lte'
  },
  FREE_SEARCH: {
    label: FREE_SEARCH_KEY,
    value: FREE_SEARCH_KEY
  }
};
var firstQueryPartIdx = 1;
var freeSearchItem = {
  label: FREE_SEARCH_LABEL,
  value: FREE_SEARCH_INDICATOR,
  allowedOperator: [{
    label: FREE_SEARCH_INDICATOR,
    value: FREE_SEARCH_INDICATOR
  }]
};
var DefaultOperatorList = [Operators.EQUAL, Operators.NOT_EQUAL, Operators.INCLUDE];

/**
 * this is the input-text active-part phase.
 * we use this to display the phase suggestion, apply the user text to the active-part etc...
 */
var InputPhase;

(function (InputPhase) {
  InputPhase[InputPhase["KEY_NAME"] = 1] = "KEY_NAME";
  InputPhase[InputPhase["OPERATOR"] = 2] = "OPERATOR";
  InputPhase[InputPhase["VALUES"] = 3] = "VALUES";
})(InputPhase || (InputPhase = {}));

var InputPhase$1 = InputPhase;

var useInput = function useInput() {
  var _useState = useState(''),
      _useState2 = _slicedToArray$1(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var _useState3 = useState(InputPhase$1.KEY_NAME),
      _useState4 = _slicedToArray$1(_useState3, 2),
      inputPhase = _useState4[0],
      setInputPhase = _useState4[1];

  var inputRef = useRef(null);
  var focusInput = useCallback(function () {
    var _a;

    (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.textFieldRef.current.focus();
  }, []);
  var blurInput = useCallback(function () {
    var _a;

    (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.textFieldRef.current.blur();
  }, []);
  var changeInputValue = useCallback(function (value) {
    setInputValue(value);
  }, []);
  var changeInputPhase = useCallback(function (phase) {
    setInputPhase(phase);
  }, []);
  var resetInputValue = useCallback(function () {
    setInputValue('');
  }, []);
  return {
    inputValue: inputValue,
    inputPhase: inputPhase,
    inputRef: inputRef,
    blurInput: blurInput,
    changeInputPhase: changeInputPhase,
    focusInput: focusInput,
    changeInputValue: changeInputValue,
    resetInputValue: resetInputValue
  };
};

var useLiveSearch = function useLiveSearch(_ref) {
  var activeQueryItem = _ref.activeQueryItem,
      inputPhase = _ref.inputPhase,
      inputText = _ref.inputText,
      isInFreeSearch = _ref.isInFreeSearch,
      queryList = _ref.queryList,
      onValueInputChange = _ref.onValueInputChange,
      defaultResolverCarry = _ref.defaultResolverCarry;
  var prevValueRef = useRef(null);
  useEffect(function () {
    var _a;

    var inputValue = isInFreeSearch ? inputText.substring(1) : inputText;
    var trimmedValue = inputValue.trim();

    if (!trimmedValue.length && !((_a = prevValueRef.current) === null || _a === void 0 ? void 0 : _a.length)) {
      return;
    }

    if (prevValueRef.current === trimmedValue) {
      return;
    }

    var queriesToFetch = _toConsumableArray$1(queryList);

    if (isInFreeSearch || inputPhase === InputPhase$1.VALUES) {
      var keyName = activeQueryItem.keyName,
          operator = activeQueryItem.operator;
      trimmedValue.length && queriesToFetch.push({
        keyName: isInFreeSearch ? FREE_SEARCH_KEY : keyName,
        operator: isInFreeSearch ? Operators.INCLUDE.value : operator,
        valueList: [trimmedValue.toLowerCase()],
        isFreeSearch: isInFreeSearch
      });
      onValueInputChange === null || onValueInputChange === void 0 ? void 0 : onValueInputChange(defaultResolverCarry(queriesToFetch));
      prevValueRef.current = trimmedValue;
    }
  }, [inputText]);
};

var inputEscapeRegex = /[^0-9|a-z|A-Z|\/|\-| |.|:]/gi;

var getNewQueryPart = function getNewQueryPart() {
  return {
    keyName: '',
    operator: '',
    valueList: [],
    order: -1
  };
};

var getNextPhase = function getNextPhase(currentPhase) {
  var isLastPhase = currentPhase + 1 > InputPhase$1.VALUES;
  var firstPhase = InputPhase$1.KEY_NAME;
  return isLastPhase ? firstPhase : currentPhase + 1;
};

var sortQueryPartsByOrder = function sortQueryPartsByOrder(a, b) {
  if (a.order === b.order) {
    return -1;
  }

  return a.order < b.order ? -1 : 1;
}; // name is shitty.. :/


var matchTextToPartKey = function matchTextToPartKey(matchText) {
  return function (targetPart) {
    var validateMatchText = matchText.replace(inputEscapeRegex, '');
    var matchRegex = new RegExp(validateMatchText, 'i');
    return Boolean(targetPart.label.match(matchRegex));
  };
};

var getSuggestionList = function getSuggestionList(operatorList, keyNameList, valueList) {
  return function () {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var phase = arguments.length > 1 ? arguments[1] : undefined;
    var newSuggetion = [];

    switch (phase) {
      case InputPhase$1.KEY_NAME:
        newSuggetion = keyNameList.filter(matchTextToPartKey(text));
        break;

      case InputPhase$1.OPERATOR:
        newSuggetion = operatorList.filter(matchTextToPartKey(text));
        break;

      case InputPhase$1.VALUES:
        newSuggetion = valueList.filter(matchTextToPartKey(text));
        break;
    }

    return newSuggetion;
  };
};

var isSameQueryPart = function isSameQueryPart(a, b) {
  return Boolean(a.order === b.order && a.keyName === b.keyName);
};

var getQueryMaxOrderPart = function getQueryMaxOrderPart(query) {
  if (!Boolean(query.length)) {
    return;
  }

  return query.reduce(function (a, b) {
    return a.order > b.order ? a : b;
  });
};

var isFreeSearchPartExists = function isFreeSearchPartExists(query) {
  var foundFreeSearchPart = query.find(function (item) {
    return item.isFreeSearch;
  });
  return !!foundFreeSearchPart;
};

var isAddKeyCode = function isAddKeyCode(keyCode) {
  var enterCode = 13;
  return [enterCode].includes(keyCode);
};

var isRemoveKeyCode = function isRemoveKeyCode(keyCode) {
  var backspaceCode = 8;
  return keyCode === backspaceCode;
};

var isArrowSelectionKeyCode = function isArrowSelectionKeyCode(keyCode) {
  var upArrowCode = 40;
  var downArrowCode = 38;
  return [upArrowCode, downArrowCode].includes(keyCode);
};

var isPartValid = function isPartValid(operatorList, keyNameList) {
  return function (part) {
    var _a;

    var keyNameValid = function keyNameValid() {
      return !Boolean(part.keyName) || keyNameList.map(function (k) {
        return k.label.toLowerCase();
      }).includes(part.keyName.toLowerCase());
    };

    var allowedOperatorList = ((_a = findPartKeyByLabel(keyNameList, part.keyName)) === null || _a === void 0 ? void 0 : _a.allowedOperator) || operatorList;

    var operatorValid = function operatorValid() {
      return !Boolean(part.operator) || allowedOperatorList.map(function (k) {
        return k.label.toLowerCase();
      }).includes(part.operator.toLowerCase());
    };

    return Boolean(keyNameValid() && operatorValid());
  };
};

var valueListToPartKeyList = function valueListToPartKeyList(valueSuggestionList, activePart) {
  if (!Boolean(activePart.operator)) {
    return [];
  }

  var partKeyList = valueSuggestionList.map(function (val) {
    if (!Boolean(val)) {
      console.error('[valueListToPartKeyList] empty value found');
      return;
    }

    return {
      label: val,
      value: val
    };
  });
  return partKeyList.filter(Boolean);
};
/**
 * test if query and the activePart has no data.
 * @param query IQueryPart[] the list of parts
 * @param activePart IQueryPart. the active part
 * @returns boolean
 */


var isQueryEmpty = function isQueryEmpty(query, activePart) {
  return !Boolean(query.length) && !Boolean(activePart.keyName);
};

var findPartKeyByLabel = function findPartKeyByLabel(partKeyList, label) {
  return partKeyList.find(function (key) {
    return key.label.toLowerCase() === label.toLowerCase();
  });
};

var getQueryPartByKey = function getQueryPartByKey(keyName, query) {
  var match = query.find(function (part) {
    return part.keyName.toLowerCase() === keyName.toLowerCase();
  });
  return match || null;
};

var freeTextSearchWithOperator = function freeTextSearchWithOperator(value) {
  return "".concat(FREE_SEARCH_INDICATOR).concat(value);
};

var util = {
  getNextPhase: getNextPhase,
  sortQueryPartsByOrder: sortQueryPartsByOrder,
  getSuggestionList: getSuggestionList,
  isSameQueryPart: isSameQueryPart,
  getQueryMaxOrderPart: getQueryMaxOrderPart,
  getNewQueryPart: getNewQueryPart,
  isAddKeyCode: isAddKeyCode,
  isRemoveKeyCode: isRemoveKeyCode,
  isArrowSelectionKeyCode: isArrowSelectionKeyCode,
  isPartValid: isPartValid,
  isFreeSearchPartExists: isFreeSearchPartExists,
  valueListToPartKeyList: valueListToPartKeyList,
  isQueryEmpty: isQueryEmpty,
  findPartKeyByLabel: findPartKeyByLabel,
  getQueryPartByKey: getQueryPartByKey,
  freeTextSearchWithOperator: freeTextSearchWithOperator,
  inputEscapeRegex: inputEscapeRegex
};

var partKeyToUrlKeyMap = new Map([['keyName', 'k'], ['operator', 'op'], ['valueList', 'v'], ['order', 'or'], ['isFreeSearch', 'fr']]);

var urlKeyToPartKeyMap = function () {
  var map = new Map();

  var _iterator = _createForOfIteratorHelper(partKeyToUrlKeyMap.entries()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray$1(_step.value, 2),
          k = _step$value[0],
          v = _step$value[1];

      map.set(v, k);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return map;
}();

var valuesSeperator = ',';
var partEntrySeperator = ',,';
var partsSeperator = '__';
var paramKey = 'qb';
var useQueryList = function useQueryList(_ref) {
  var inputPhase = _ref.inputPhase,
      shouldSyncUrl = _ref.shouldSyncUrl,
      changeInputPhase = _ref.changeInputPhase,
      onAddQueryPart = _ref.onAddQueryItemPart,
      onInvalid = _ref.onInvalid,
      onChange = _ref.onChange,
      queryResolver = _ref.queryResolver;
  var history = useHistory$1();
  var location = useLocation();

  var _useState = useState(function () {
    if (!shouldSyncUrl) {
      return [];
    }

    var urlQueryStr = new URLSearchParams(location.search).get(paramKey);

    if (urlQueryStr === null) {
      return [];
    }

    return urlToQuery(urlQueryStr);
  }),
      _useState2 = _slicedToArray$1(_useState, 2),
      queryItemList = _useState2[0],
      setQueryList = _useState2[1];

  var _useState3 = useState(util.getNewQueryPart()),
      _useState4 = _slicedToArray$1(_useState3, 2),
      activeQueryItem = _useState4[0],
      setActiveQueryItem = _useState4[1];

  useEffect(function () {
    if (!shouldSyncUrl) {
      return;
    }

    var path = history.location.pathname;
    var urlData = queryToUrl(queryItemList);
    history.push({
      pathname: path,
      search: "?".concat(paramKey, "=").concat(urlData)
    });
  }, [queryItemList]);

  var changeActiveQueryItem = function changeActiveQueryItem(query) {
    setActiveQueryItem(query);
  };

  var removeQuery = function removeQuery(query) {
    var list = queryItemList.filter(function (part) {
      return !util.isSameQueryPart(query, part);
    });
    setQueryList(list);
    onChange(queryResolver(list));
  };

  var resetActiveQuery = function resetActiveQuery() {
    var newItem = util.getNewQueryPart();
    setActiveQueryItem(newItem);
    changeInputPhase(InputPhase$1.KEY_NAME);
  };

  var backspaceQuery = function backspaceQuery(inputValue, setInputValue) {
    if (inputValue.length) {
      return;
    }

    var isActivePartWithData = Boolean(activeQueryItem.keyName);

    if (isActivePartWithData) {
      var clonePart = Object.assign({}, activeQueryItem);
      var currentInputPhase = inputPhase - 1;

      switch (currentInputPhase) {
        case InputPhase$1.KEY_NAME:
          setInputValue(clonePart.keyName);
          resetActiveQuery();
          changeInputPhase(InputPhase$1.KEY_NAME);
          break;

        case InputPhase$1.OPERATOR:
          setInputValue(clonePart.operator);
          changeActiveQueryItem(Object.assign(Object.assign({}, clonePart), {
            operator: ''
          }));
          changeInputPhase(InputPhase$1.OPERATOR);
          break;

        case InputPhase$1.VALUES:
          setInputValue(clonePart.valueList[0]);
          changeActiveQueryItem(Object.assign(Object.assign({}, clonePart), {
            valueList: []
          }));
          changeInputPhase(InputPhase$1.VALUES);
          break;
      }

      return;
    }

    var lastQuery = util.getQueryMaxOrderPart(queryItemList);

    if (Boolean(!lastQuery)) {
      return;
    }

    var clonedQuery = Object.assign({}, lastQuery);

    if (lastQuery.isFreeSearch) {
      removeQuery(lastQuery);
      setInputValue("".concat(FREE_SEARCH_INDICATOR).concat(clonedQuery.valueList[0]));
      return;
    }

    var newQuery = Object.assign(Object.assign({}, clonedQuery), {
      valueList: []
    });
    removeQuery(lastQuery);
    changeInputPhase(InputPhase$1.VALUES);
    setInputValue(clonedQuery.valueList[0]);
    changeActiveQueryItem(newQuery);
  };

  var getNextOrder = function getNextOrder() {
    var lastPart = util.getQueryMaxOrderPart(queryItemList);
    var maxOrder = Boolean(lastPart) ? lastPart.order : firstQueryPartIdx;
    return maxOrder + 1;
  };

  var addFreeSearchQueryItem = function addFreeSearchQueryItem(text, liveSearchEnabled) {
    var newQuery = {
      keyName: FREE_SEARCH_KEY,
      operator: Operators.INCLUDE.value,
      valueList: [text.toLocaleLowerCase()],
      isFreeSearch: true,
      order: getNextOrder()
    };
    var queryListWithoutFreeSearch = queryItemList.filter(function (item) {
      return !item.isFreeSearch;
    });
    var newQueryList = [].concat(_toConsumableArray$1(queryListWithoutFreeSearch), [newQuery]);
    setQueryList(newQueryList);

    if (!liveSearchEnabled) {
      onChange(queryResolver(newQueryList));
    }

    setActiveQueryItem(util.getNewQueryPart());
  };

  var addQueryItemPart = function addQueryItemPart(value, keyNameList, operatorList, liveSearchEnabled) {
    var val = value.trim();

    if (!val.trim().length) {
      return;
    }

    var getIsValid = util.isPartValid(operatorList, keyNameList);

    switch (inputPhase) {
      case InputPhase$1.KEY_NAME:
        setActiveQueryItem(function (prev) {
          return Object.assign(Object.assign({}, prev), {
            keyName: val
          });
        });
        changeInputPhase(InputPhase$1.OPERATOR);
        break;

      case InputPhase$1.OPERATOR:
        if (!getIsValid(activeQueryItem)) {
          onInvalid();
          return;
        }

        setActiveQueryItem(function (prev) {
          return Object.assign(Object.assign({}, prev), {
            operator: val
          });
        });
        changeInputPhase(InputPhase$1.VALUES);
        break;

      case InputPhase$1.VALUES:
        changeInputPhase(InputPhase$1.KEY_NAME);
        var newQueryList = [].concat(_toConsumableArray$1(queryItemList), [Object.assign(Object.assign({}, activeQueryItem), {
          valueList: [val],
          order: getNextOrder()
        })]);
        setQueryList(newQueryList);

        if (!liveSearchEnabled) {
          onChange(queryResolver(newQueryList));
        }

        setActiveQueryItem(util.getNewQueryPart());
        break;
    }

    onAddQueryPart(inputPhase);
  }; // we mimic user input by using the label


  var addExternalQueryItemPart = function addExternalQueryItemPart(query, keyNameList, operatorList) {
    var _a;

    var keyName = (_a = keyNameList.find(function (k) {
      return k.value === query.keyName;
    })) === null || _a === void 0 ? void 0 : _a.label;
    var newQuery = Object.assign(Object.assign({}, query), {
      keyName: keyName
    }); //  return if invalid

    if (!keyName || !util.isPartValid(operatorList, keyNameList)(newQuery)) {
      return;
    } // remove old filter for the key


    var existingQuery = util.getQueryPartByKey(newQuery.keyName, queryItemList);

    if (existingQuery) {
      removeQuery(existingQuery);
    }

    setActiveQueryItem(newQuery);
    changeInputPhase(InputPhase$1.VALUES);
    onAddQueryPart(inputPhase);
  };

  var resetQueryItemList = useCallback(function () {
    var emptyList = [];
    setQueryList(emptyList);
    onChange(queryResolver(emptyList));
  }, []);

  var editQueryItem = function editQueryItem(query, setInputText) {
    if (!query.valueList.length) {
      return;
    }

    var clonedQuery = Object.assign({}, query);

    if (query.isFreeSearch) {
      removeQuery(query);
      setInputText("".concat(FREE_SEARCH_INDICATOR).concat(clonedQuery.valueList[0]));
      return;
    }

    var newQuery = Object.assign(Object.assign({}, clonedQuery), {
      valueList: []
    });
    removeQuery(query);
    changeInputPhase(InputPhase$1.VALUES);
    setInputText(clonedQuery.valueList[0]);
    setActiveQueryItem(newQuery);
  };

  return {
    queryItemList: queryItemList,
    addQueryItemPart: addQueryItemPart,
    addExternalQueryItemPart: addExternalQueryItemPart,
    removeQuery: removeQuery,
    resetQueryItemList: resetQueryItemList,
    activeQueryItem: activeQueryItem,
    editQueryItem: editQueryItem,
    resetActiveQuery: resetActiveQuery,
    backspaceQuery: backspaceQuery,
    addFreeSearchQueryItem: addFreeSearchQueryItem
  };
};
var queryToUrl = function queryToUrl(query) {
  // queryToUrl returns '&q=k:name,,op:re,,v:yossi,moshe,elyaho,,fr:1,,or:2__k:age,,op:eq,,v:3,,fr:0,,or:2'
  var qUrl = query.sort(function (a, b) {
    return a.order - b.order;
  }).map(function (i, idx) {
    return _toConsumableArray$1(partKeyToUrlKeyMap.keys()).map(function (k) {
      var urlKey = partKeyToUrlKeyMap.get(k);

      switch (k) {
        case 'valueList':
          return "".concat(urlKey, ":").concat(i[k].join(valuesSeperator));

        case 'order':
          var order = typeof i[k] === 'number' ? i[k] : idx;
          return "".concat(urlKey, ":").concat(order);

        case 'isFreeSearch':
          var freeSearchFlag = Boolean(i[k]) ? '1' : '0';
          return "".concat(urlKey, ":").concat(freeSearchFlag);

        default:
          return "".concat(urlKey, ":").concat(i[k]);
      }
    }).join(partEntrySeperator);
  });
  return encodeURIComponent(qUrl.join(partsSeperator));
};

var urlToQuery = function urlToQuery(url) {
  var query = [];

  if (!Boolean(url)) {
    return query;
  }

  query = decodeURI(url).split(partsSeperator).map(function (partString) {
    var part = {
      keyName: '',
      operator: '',
      valueList: [],
      order: 0,
      isFreeSearch: false
    };
    var keyValueStrList = partString.split(partEntrySeperator);
    keyValueStrList.forEach(function (keyValueStr) {
      var _keyValueStr$split = keyValueStr.split(':'),
          _keyValueStr$split2 = _slicedToArray$1(_keyValueStr$split, 2),
          urlKeyName = _keyValueStr$split2[0],
          urlValue = _keyValueStr$split2[1];

      var partKeyName = urlKeyToPartKeyMap.get(urlKeyName);

      switch (partKeyName) {
        case 'valueList':
          var valueList = urlValue.split(valuesSeperator);
          part[partKeyName] = valueList;
          return part;

        case 'order':
          var order = Boolean(urlValue) ? parseInt(urlValue) : 0;
          part[partKeyName] = order;
          return part;

        case 'isFreeSearch':
          var freeSearchFlag = urlValue === '1';
          part[partKeyName] = freeSearchFlag;
          return part;

        default:
          part[partKeyName] = urlValue;
          return part;
      }
    });
    return part;
  });
  return query;
};

var useSuggestions = function useSuggestions(_ref) {
  var valueSuggestionList = _ref.valueSuggestionList,
      isFreeSearchEnabled = _ref.isFreeSearchEnabled,
      inputPhase = _ref.inputPhase,
      keyNameList = _ref.keyNameList,
      operatorList = _ref.operatorList;

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      showSuggestionPanel = _useState2[0],
      setShowSuggestionPanel = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray$1(_useState3, 2),
      suggestionList = _useState4[0],
      setSuggestionList = _useState4[1];

  var getIsTextWithFreeSearch = useCallback(function (value) {
    return value.startsWith(FREE_SEARCH_INDICATOR);
  }, []);
  var getIsInFreeSearch = useCallback(function (value) {
    return getIsTextWithFreeSearch(value) && isFreeSearchEnabled;
  }, [isFreeSearchEnabled, getIsTextWithFreeSearch]);
  var hasFreeSearchPart = useCallback(function (queryList) {
    return util.isFreeSearchPartExists(queryList);
  }, []);
  var canSelectFreeSearch = useCallback(function (queryList, value) {
    return inputPhase === InputPhase$1.KEY_NAME && isFreeSearchEnabled && !getIsTextWithFreeSearch(value) && !hasFreeSearchPart(queryList);
  }, [inputPhase, isFreeSearchEnabled]);

  var updateSuggestionList = function updateSuggestionList(activePart, queryList) {
    var text = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    var _a;

    var valuePartKeyList = util.valueListToPartKeyList(valueSuggestionList, activePart); // remove keyName options that are in the query

    var usedKeyName = queryList.map(function (part) {
      return part.keyName.toLowerCase();
    });
    var keyNameListFiltered = [].concat(_toConsumableArray$1(canSelectFreeSearch(queryList, text) ? [freeSearchItem] : []), _toConsumableArray$1(keyNameList)).filter(function (key) {
      return !usedKeyName.includes(key.label.toLowerCase());
    });
    var allowedOperatorList = ((_a = util.findPartKeyByLabel(keyNameList, activePart.keyName)) === null || _a === void 0 ? void 0 : _a.allowedOperator) || operatorList;
    var newSuggestion = util.getSuggestionList(allowedOperatorList, keyNameListFiltered, valuePartKeyList)(text, inputPhase);
    setSuggestionList(newSuggestion);
  };

  var toggleShowSuggestionPanel = useCallback(function (show) {
    setShowSuggestionPanel(show);
  }, []);
  return {
    showSuggestionPanel: showSuggestionPanel,
    suggestionList: suggestionList,
    toggleShowSuggestionPanel: toggleShowSuggestionPanel,
    updateSuggestionList: updateSuggestionList,
    getIsTextWithFreeSearch: getIsTextWithFreeSearch,
    getIsInFreeSearch: getIsInFreeSearch
  };
};

var useStyles$t = createUseStyles(function (theme) {
  var _invalid, _activeQueryPart, _queryPart, _removeBtn, _suggestionItem;

  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      transition: "".concat(theme.transitions.fast, " all"),
      border: "1px solid ".concat(theme.palette.grey.extraLight),
      borderRadius: theme.shape.borderRadiusLight,
      marginRight: 24,
      '&:focus-within': {
        border: "1px solid ".concat(theme.palette.primary.light),
        flex: 'auto 1 1'
      }
    },
    activeInput: {
      border: "1px solid ".concat(theme.palette.primary.light),
      flex: 'auto 1 1'
    },
    queryInputComboPlaceholder: _defineProperty$1({
      boxSizing: 'border-box',
      padding: 4,
      display: 'flex',
      alignItems: 'center',
      minWidth: 240,
      minHeight: 28,
      backgroundColor: theme.palette.white.color,
      borderRadius: theme.shape.borderRadiusLight,
      boxShadow: theme.shadows[0],
      overflowX: 'auto'
    }, '&:hover', {
      cursor: 'text'
    }),
    queryPartsList: {
      display: 'inline-flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      rowGap: 2
    },
    activeQueryPart: (_activeQueryPart = {}, _defineProperty$1(_activeQueryPart, '& $queryPartRoot', {
      marginRight: 0
    }), _defineProperty$1(_activeQueryPart, '&.invalid', (_invalid = {}, _defineProperty$1(_invalid, '& $queryPartRoot', {
      backgroundColor: theme.palette.error.color
    }), _defineProperty$1(_invalid, '&.gesture-invalid', _defineProperty$1({
      zIndex: 1
    }, '& $queryPartRoot', {
      animation: "$shake ".concat(theme.transitions.fast, " 2")
    })), _invalid)), _activeQueryPart),
    queryPartRoot: _defineProperty$1({
      marginRight: 8,
      flex: 'auto 0 0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 24,
      borderRadius: theme.shape.borderRadiusLight,
      backgroundColor: theme.palette.primary.light,
      padding: '0 8px',
      gap: 8
    }, '&:hover', _defineProperty$1({}, '& $removeBtn', _defineProperty$1({}, '& img', {
      opacity: 1
    }))),
    queryPartRootBody: {
      display: 'flex',
      gap: 4
    },
    queryPart: (_queryPart = {
      flex: 'auto 0 0',
      color: theme.palette.white.color,
      letterSpacing: 0.23,
      transition: "".concat(theme.transitions.fast, " all"),
      fontSize: 12,
      lineHeight: '20px',
      fontFamily: theme.typography.p.fontFamily
    }, _defineProperty$1(_queryPart, '&.key-name', {
      borderRadius: "".concat(theme.shape.borderRadiusLight, "px 0 0 ").concat(theme.shape.borderRadiusLight, "px"),
      textTransform: 'capitalize'
    }), _defineProperty$1(_queryPart, '&.operator', {
      textTransform: 'uppercase'
    }), _queryPart),
    removeBtn: (_removeBtn = {}, _defineProperty$1(_removeBtn, '& img', {
      transition: "".concat(theme.transitions.fast, " all"),
      height: 10,
      opacity: 0.5
    }), _defineProperty$1(_removeBtn, '&:hover', {
      transform: 'scale(1.1)',
      cursor: 'pointer'
    }), _defineProperty$1(_removeBtn, '&.active', {
      transform: 'scale(1)'
    }), _removeBtn),
    inputText: {
      flex: 'auto 0 0',
      width: 200,
      display: 'flex',
      alignItems: 'center',
      height: 24
    },
    searchIcon: {
      padding: '4px 4px 0 2px'
    },
    textFieldContainer: _defineProperty$1({
      backgroundColor: theme.palette.white.color,
      border: 'none !important'
    }, '&:focus', {
      border: 'none !important'
    }),
    textField: _defineProperty$1({
      backgroundColor: 'inherit'
    }, '&:focus', {
      border: 'none !important'
    }),
    suggestionRoot: {
      position: 'relative',
      display: 'flex',
      zIndex: 2
    },
    suggestionPanel: _defineProperty$1({
      position: 'absolute',
      display: 'flex',
      flexDirection: 'column',
      minHeight: 0,
      maxWidth: 600,
      left: 0,
      right: 0,
      top: 4,
      padding: '8px 0',
      borderRadius: theme.shape.borderRadiusLight,
      background: theme.palette.white.color,
      boxShadow: theme.shadows[0],
      transition: "".concat(theme.transitions.fast, " all"),
      maxHeight: 244,
      height: 0,
      overflowY: 'auto',
      opacity: 0
    }, '&.show', {
      opacity: 1,
      height: 'auto',
      minHeight: 26
    }),
    suggestionPanelList: {
      display: 'flex',
      flexDirection: 'column'
    },
    suggestionItem: (_suggestionItem = {
      display: 'flex',
      flexWrap: 'nowrap',
      flex: 'auto 1 1',
      fontFamily: theme.typography.p.fontFamily,
      fontSize: 14,
      letterSpacing: 0.23,
      justifyContent: 'flex-start !important',
      boxShadow: 'none !important',
      border: '1px solid transparent !important',
      borderRadius: '0px !important',
      height: 'auto !important'
    }, _defineProperty$1(_suggestionItem, '&:active', {
      opacity: 1
    }), _defineProperty$1(_suggestionItem, '&:focus, &:active, &.active', {
      backgroundColor: "".concat(theme.palette.background.color, " !important")
    }), _defineProperty$1(_suggestionItem, '&:hover', {
      opacity: 0.9,
      backgroundColor: "".concat(theme.palette.background.color, " !important"),
      cursor: 'pointer'
    }), _defineProperty$1(_suggestionItem, '& .CyoloUI-Text', {
      display: 'flex',
      flex: 'auto 1 1'
    }), _suggestionItem),
    labelDesc: {
      display: 'flex',
      flexWrap: 'nowrap',
      flex: 'auto 1 1'
    },
    suggestionItemLabel: {
      flex: 'auto 1 1',
      textTransform: 'capitalize',
      color: theme.palette.grey,
      textAlign: 'left'
    },
    suggestionItemDesc: {
      minWidth: 80,
      color: theme.palette.grey.light,
      display: 'flex',
      gap: 8,
      justifyContent: 'flex-end',
      '& i': {
        fontStyle: 'normal'
      }
    },
    noFoundMsg: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row-reverse',
      paddingTop: 6
    },
    spinnerContainer: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      paddingRight: 16
    },
    '@keyframes shake': {
      '20%': {
        transform: 'translateX(-2px)'
      },
      '40%': {
        transform: 'translateX(0)'
      },
      '60%': {
        transform: 'translateX(2px)'
      },
      '80%': {
        transform: 'translateX(0)'
      }
    },
    suggestionNotificationText: {
      paddingLeft: 24,
      marginTop: 8
    },
    clearIcon: {
      marginLeft: 'auto'
    }
  };
});

var QueryItem = function QueryItem(_ref) {
  var query = _ref.query,
      onClick = _ref.onClick,
      onRemove = _ref.onRemove;
  var theme = useThemeSafe();
  var style = useStyles$t({
    theme: theme
  });

  if (!Boolean(query.keyName)) {
    return null;
  }

  var keyName = query.keyName,
      operator = query.operator,
      valueList = query.valueList;

  var handleRemove = function handleRemove(e) {
    e.stopPropagation();
    onRemove(query);
  };

  var handleClick = function handleClick() {
    onClick === null || onClick === void 0 ? void 0 : onClick(query);
  };

  if (query.isFreeSearch) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: style.queryPartRoot,
      onClick: handleClick
    }, /*#__PURE__*/React__default.createElement("div", {
      className: clsx(style.queryPart, 'value-list')
    }, valueList), /*#__PURE__*/React__default.createElement("div", {
      className: style.removeBtn
    }, /*#__PURE__*/React__default.createElement(IconButton, {
      iconID: "x-icon-white",
      onClick: handleRemove
    })));
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: style.queryPartRoot,
    onClick: handleClick
  }, /*#__PURE__*/React__default.createElement("div", {
    className: style.queryPartRootBody
  }, /*#__PURE__*/React__default.createElement("div", {
    className: clsx(style.queryPart, 'key-name')
  }, keyName), operator && /*#__PURE__*/React__default.createElement("div", {
    className: clsx(style.queryPart, 'operator')
  }, operator), valueList.length > 0 && /*#__PURE__*/React__default.createElement("div", {
    className: clsx(style.queryPart, 'value-list')
  }, valueList)), keyName && /*#__PURE__*/React__default.createElement("div", {
    className: style.removeBtn
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    iconID: "x-icon-white",
    onClick: handleRemove
  })));
};

var LONG_PRESS_INTERVAL_MS = 150;

var useKeyboardPress = function useKeyboardPress(targetCode) {
  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      keyPressed = _useState2[0],
      setKeyPressed = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$1(_useState3, 2),
      inTimeout = _useState4[0],
      setInTimeout = _useState4[1];

  var timeoutRef = useRef(null);
  /**
   * on keydown press
   */

  function handlerDownKey(e) {
    if (e.keyCode === targetCode) {
      // support long press
      if (keyPressed && !inTimeout) {
        setInTimeout(true);
        timeoutRef.current = window.setTimeout(function () {
          setInTimeout(false);
          setKeyPressed(false);
        }, LONG_PRESS_INTERVAL_MS);
      }

      setKeyPressed(true);
    }
  }
  /**
   * on keyup press
   */


  function handlerUpKey(e) {
    if (e.keyCode === targetCode) {
      setKeyPressed(false);
    }
  }

  useEffect(function () {
    window.addEventListener('keydown', handlerDownKey);
    window.addEventListener('keyup', handlerUpKey);
    return function () {
      window.removeEventListener('keydown', handlerDownKey);
      window.removeEventListener('keyup', handlerUpKey);
      timeoutRef.current && window.clearTimeout(timeoutRef.current);
    };
  }, []);
  return keyPressed;
};

var KEY_CODES = {
  ARROW_UP: 38,
  ARROW_DOWN: 40,
  ENTER: 13
};

var MAX_SUGGESTION_COUNT = 25;

var QuerySuggestion = function QuerySuggestion(_ref) {
  var onSuggestionSelect = _ref.onSuggestionSelect,
      onQuerySelect = _ref.onQuerySelect,
      _ref$show = _ref.show,
      show = _ref$show === void 0 ? false : _ref$show,
      _ref$suggestionList = _ref.suggestionList,
      suggestionList = _ref$suggestionList === void 0 ? [] : _ref$suggestionList,
      _ref$showSpinner = _ref.showSpinner,
      showSpinner = _ref$showSpinner === void 0 ? false : _ref$showSpinner,
      _ref$queryList = _ref.queryList,
      queryList = _ref$queryList === void 0 ? [] : _ref$queryList,
      _ref$onFocusOut = _ref.onFocusOut,
      onFocusOut = _ref$onFocusOut === void 0 ? function () {} : _ref$onFocusOut;
  // arrow selection
  var arrowDownKeyCode = KEY_CODES.ARROW_DOWN;
  var arrowUpKeyCode = KEY_CODES.ARROW_UP;
  var enterKeyCode = KEY_CODES.ENTER;
  var NO_SELECTION_INDEX = -1;
  var theme = useThemeSafe();
  var style = useStyles$t({
    theme: theme
  });

  var _useState = useState(suggestionList.slice(0, MAX_SUGGESTION_COUNT)),
      _useState2 = _slicedToArray$1(_useState, 2),
      suggestionListDisaply = _useState2[0],
      setSuggestionListDisaply = _useState2[1];

  useEffect(function () {
    setSuggestionListDisaply(suggestionList.slice(0, MAX_SUGGESTION_COUNT));
  }, [suggestionList]);
  var isDownPress = useKeyboardPress(arrowDownKeyCode);
  var isUpPress = useKeyboardPress(arrowUpKeyCode);
  var addKeyPress = useKeyboardPress(enterKeyCode);

  var _useArrowKeysNavigati = useArrowKeysNavigation$1(suggestionListDisaply.length, onFocusOut.bind(true)),
      cursor = _useArrowKeysNavigati.cursor,
      next = _useArrowKeysNavigati.next,
      prev = _useArrowKeysNavigati.prev,
      resetCursor = _useArrowKeysNavigati.resetCursor;
  /**
   * init cursor for arrow-up/down keyPress
   */


  useEffect(function () {
    if (!Boolean(show) && Boolean(suggestionListDisaply.length)) {
      return;
    }

    resetCursor();
  }, [show, suggestionListDisaply]);
  /**
   * up handler
   */

  useEffect(function () {
    if (!isUpPress) {
      return;
    }

    prev();
  }, [isUpPress]);
  /**
   * down handler
   */

  useEffect(function () {
    if (!isDownPress) {
      return;
    }

    next();
  }, [isDownPress]);
  var isFreeSearchSuggestion = useCallback(function (suggestion) {
    return suggestion.value === FREE_SEARCH_INDICATOR;
  }, []);

  var handleSelect = function handleSelect(suggestion) {
    var valueToSelect = isFreeSearchSuggestion(suggestion) ? FREE_SEARCH_INDICATOR : suggestion.label;
    onSuggestionSelect(valueToSelect);
  };
  /**
   * apply item in cursor index
   */


  useEffect(function () {
    if (addKeyPress) {
      if (cursor !== NO_SELECTION_INDEX) {
        var target = suggestionListDisaply[cursor];

        if (!target) {
          return;
        }

        handleSelect(target);
        resetCursor();
      }
    }
  }, [addKeyPress]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(style.suggestionPanel, {
      show: show
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: style.suggestionPanelList
  }, queryList.map(function (query, index) {
    return /*#__PURE__*/React__default.createElement(Button, {
      variant: "secondary",
      className: style.suggestionItem,
      tabIndex: index + 2,
      key: query.label,
      onClick: function onClick() {
        onQuerySelect(query);
      }
    }, /*#__PURE__*/React__default.createElement("span", {
      className: style.suggestionItem
    }, /*#__PURE__*/React__default.createElement("span", null, query.label), /*#__PURE__*/React__default.createElement("span", {
      className: style.suggestionItemDesc
    }, "RUN")));
  })), /*#__PURE__*/React__default.createElement("div", {
    className: style.suggestionPanelList
  }, showSpinner ? /*#__PURE__*/React__default.createElement("div", {
    className: style.noFoundMsg
  }, /*#__PURE__*/React__default.createElement("div", {
    className: style.spinnerContainer
  }, /*#__PURE__*/React__default.createElement(StandaloneLoadingIndicator, {
    size: 16,
    color: "blue"
  }))) : suggestionListDisaply.map(function (suggestion, index) {
    var _a;

    return /*#__PURE__*/React__default.createElement(Fragment$2, {
      key: suggestion.label
    }, /*#__PURE__*/React__default.createElement(Button, {
      variant: "secondary",
      tabIndex: index + 1,
      className: clsx(style.suggestionItem, {
        active: index === cursor
      }),
      onClick: function onClick() {
        handleSelect(suggestion);
      }
    }, /*#__PURE__*/React__default.createElement("span", {
      className: style.labelDesc
    }, /*#__PURE__*/React__default.createElement("span", {
      className: style.suggestionItemLabel
    }, suggestion.label), /*#__PURE__*/React__default.createElement("span", {
      className: style.suggestionItemDesc
    }, (_a = suggestion === null || suggestion === void 0 ? void 0 : suggestion.allowedOperator) === null || _a === void 0 ? void 0 : _a.map(function (op) {
      return op === null || op === void 0 ? void 0 : op.label;
    }).sort().map(function (op) {
      return /*#__PURE__*/React__default.createElement("i", {
        key: op
      }, op);
    })))), isFreeSearchSuggestion(suggestion) && /*#__PURE__*/React__default.createElement(Divider$1, {
      orientation: "horizontal",
      thickness: 2,
      color: theme.palette.background.color
    }));
  }), suggestionList.length > MAX_SUGGESTION_COUNT && /*#__PURE__*/React__default.createElement(Text$1, {
    className: style.suggestionNotificationText,
    variant: "header-1",
    component: "div"
  }, "Too many results. use filter to find more")));
};

var QueryBuilderSearch = function QueryBuilderSearch(_ref) {
  var keyNameList = _ref.keyNameList,
      _ref$operatorList = _ref.operatorList,
      operatorList = _ref$operatorList === void 0 ? DefaultOperatorList : _ref$operatorList,
      _ref$valueSuggestionL = _ref.valueSuggestionList,
      valueSuggestionList = _ref$valueSuggestionL === void 0 ? [] : _ref$valueSuggestionL,
      onValueSuggestionFeed = _ref.onValueSuggestionFeed,
      _ref$isSuggestionInPr = _ref.isSuggestionInProgress,
      isSuggestionInProgress = _ref$isSuggestionInPr === void 0 ? false : _ref$isSuggestionInPr,
      onChange = _ref.onChange,
      _ref$resolver = _ref.resolver,
      resolver = _ref$resolver === void 0 ? defaultResolver : _ref$resolver,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Write a search query' : _ref$placeholder,
      className = _ref.className,
      _ref$enableFreeSearch = _ref.enableFreeSearch,
      enableFreeSearch = _ref$enableFreeSearch === void 0 ? false : _ref$enableFreeSearch,
      addPartsListener = _ref.addPartsListener,
      _ref$syncUrl = _ref.syncUrl,
      syncUrl = _ref$syncUrl === void 0 ? false : _ref$syncUrl,
      onValueInputChange = _ref.onValueInputChange;
  var isLiveSearchEnabled = !!onValueInputChange;

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      showInvalidGesture = _useState2[0],
      setShowInvalidGesture = _useState2[1];

  var theme = useThemeSafe();
  var style = useStyles$t({
    theme: theme
  });
  var queryBuilderRef = useRef(null);
  var querySuggestionRef = useRef(null);
  var timeoutRef = useRef(null);
  var isInitialMountRef = useRef(true);
  var queryResolver = useMemo(function () {
    return resolver(operatorList, keyNameList);
  }, [operatorList, keyNameList, resolver]); //handling input

  var _useInput = useInput(),
      inputValue = _useInput.inputValue,
      changeInputValue = _useInput.changeInputValue,
      inputRef = _useInput.inputRef,
      inputPhase = _useInput.inputPhase,
      changeInputPhase = _useInput.changeInputPhase,
      blurInput = _useInput.blurInput,
      focusInput = _useInput.focusInput,
      resetInputValue = _useInput.resetInputValue;

  var handleAddQueryPart = useCallback(function (phase) {
    resetInputValue();

    if (phase === InputPhase$1.VALUES) {
      blurInput();
      toggleShowSuggestionPanel(false);
      return;
    }

    focusInput();
  }, [resetInputValue, focusInput, blurInput]);
  var triggerInvalidGesture = useCallback(function () {
    setShowInvalidGesture(true);
    timeoutRef.current = window.setTimeout(function () {
      setShowInvalidGesture(false);
    }, 250);
  }, []); //handling queries

  var _useQueryList = useQueryList({
    inputPhase: inputPhase,
    changeInputPhase: changeInputPhase,
    onChange: onChange,
    queryResolver: queryResolver,
    shouldSyncUrl: syncUrl,
    onAddQueryItemPart: handleAddQueryPart,
    onInvalid: triggerInvalidGesture
  }),
      activeQueryItem = _useQueryList.activeQueryItem,
      queryItemList = _useQueryList.queryItemList,
      addQueryItemPart = _useQueryList.addQueryItemPart,
      addExternalQueryItemPart = _useQueryList.addExternalQueryItemPart,
      addFreeSearchQueryItem = _useQueryList.addFreeSearchQueryItem,
      removeQuery = _useQueryList.removeQuery,
      resetQueryItemList = _useQueryList.resetQueryItemList,
      editQueryItem = _useQueryList.editQueryItem,
      resetActiveQuery = _useQueryList.resetActiveQuery,
      backspaceQuery = _useQueryList.backspaceQuery; //handling suggestions


  var _useSuggestions = useSuggestions({
    inputPhase: inputPhase,
    keyNameList: keyNameList,
    operatorList: operatorList,
    valueSuggestionList: valueSuggestionList,
    isFreeSearchEnabled: enableFreeSearch
  }),
      showSuggestionPanel = _useSuggestions.showSuggestionPanel,
      suggestionList = _useSuggestions.suggestionList,
      toggleShowSuggestionPanel = _useSuggestions.toggleShowSuggestionPanel,
      updateSuggestionList = _useSuggestions.updateSuggestionList,
      getIsInFreeSearch = _useSuggestions.getIsInFreeSearch,
      getIsTextWithFreeSearch = _useSuggestions.getIsTextWithFreeSearch;

  useLiveSearch({
    activeQueryItem: activeQueryItem,
    inputPhase: inputPhase,
    queryList: queryItemList,
    inputText: inputValue,
    onValueInputChange: onValueInputChange,
    defaultResolverCarry: queryResolver,
    isInFreeSearch: getIsInFreeSearch(inputValue)
  });

  var handleRef = function handleRef(query) {
    addExternalQueryItemPart(query, keyNameList, operatorList);
  }; // setup listener for updating remote query state


  useRegisterListener$1({
    listener: addPartsListener,
    handler: function handler() {
      return handleRef;
    }
  });

  var handleOutsideClick = function handleOutsideClick() {
    blurInput();
    toggleShowSuggestionPanel(false);

    if (inputPhase !== InputPhase$1.VALUES && !inputValue.trim().length) {
      return;
    }

    handleSubmit();
  };

  useOutsideClick(queryBuilderRef, handleOutsideClick);
  var isKeyNameListProvided = useMemo(function () {
    return !!keyNameList.length;
  }, [keyNameList]);
  var isOperatorListProvided = useMemo(function () {
    return !!operatorList.length;
  }, [operatorList]); //call onChange only on mount

  useEffect(function () {
    if (isKeyNameListProvided && isOperatorListProvided && isInitialMountRef.current) {
      onChange(queryResolver(queryItemList));
      isInitialMountRef.current = false;
    }
  }, [queryItemList, isKeyNameListProvided, isOperatorListProvided]);
  useEffect(function () {
    updateSuggestionList(activeQueryItem, queryItemList, inputValue);
  }, [inputPhase, valueSuggestionList, inputValue, queryItemList]);
  useEffect(function () {
    if (!onValueSuggestionFeed) {
      return;
    }

    if (inputPhase !== InputPhase$1.VALUES) {
      return;
    }

    onValueSuggestionFeed(queryResolver([Object.assign(Object.assign({}, activeQueryItem), {
      valueList: [inputValue]
    })], true));
  }, [inputPhase, inputValue, activeQueryItem]);
  useEffect(function () {
    return function () {
      timeoutRef.current && clearTimeout(timeoutRef.current);
    };
  }, []);
  var isActivePartValid = util.isPartValid(operatorList, keyNameList)(activeQueryItem);

  var handleSubmit = function handleSubmit() {
    if (inputValue.trim() === FREE_SEARCH_INDICATOR) {
      return;
    }

    var isWithFreeSearch = getIsTextWithFreeSearch(inputValue);

    if (isWithFreeSearch && inputPhase === InputPhase$1.KEY_NAME) {
      var valueWithNoIndicator = inputValue.substring(1);
      addFreeSearchQueryItem(valueWithNoIndicator, isLiveSearchEnabled);
      resetInputValue();
      blurInput();
      toggleShowSuggestionPanel(false);
      return;
    }

    addQueryItemPart(inputValue, keyNameList, operatorList, isLiveSearchEnabled);
    resetInputValue();
  };

  var handleKeyUp = function handleKeyUp(e) {
    switch (e.key) {
      case 'Enter':
        handleSubmit();
        break;

      case 'Backspace':
        backspaceQuery(inputValue, changeInputValue);
        break;

      case 'Escape':
        handleOutsideClick();
        break;
    }
  };

  var handleInputChange = useCallback(function (e) {
    var value = e.target.value;
    changeInputValue(value);
  }, []);

  var handleInputFocus = function handleInputFocus() {
    toggleShowSuggestionPanel(true);
  };

  var handleQueryEdit = function handleQueryEdit(query) {
    editQueryItem(query, changeInputValue);
  };

  var resolvePlaceholder = useCallback(function () {
    return enableFreeSearch ? 'Use ~ for text search' : placeholder;
  }, [enableFreeSearch, placeholder]);
  var handleWrapperFocus = useCallback(function () {
    focusInput();
  }, [focusInput]);

  var handleSuggestionSelect = function handleSuggestionSelect(selectedValue) {
    if (selectedValue === FREE_SEARCH_INDICATOR) {
      changeInputValue(FREE_SEARCH_INDICATOR);
      return;
    }

    addQueryItemPart(selectedValue, keyNameList, operatorList);
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(style.root, _defineProperty$1({}, style.activeInput, queryItemList.length > 0), className),
    ref: queryBuilderRef,
    onFocus: handleWrapperFocus,
    tabIndex: 0
  }, /*#__PURE__*/React__default.createElement("div", {
    className: style.queryInputComboPlaceholder,
    onClick: focusInput
  }, /*#__PURE__*/React__default.createElement("div", {
    className: style.searchIcon
  }, /*#__PURE__*/React__default.createElement(Icon, {
    id: "search-icon"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: style.queryPartsList
  }, _toConsumableArray$1(queryItemList).sort(util.sortQueryPartsByOrder).map(function (query) {
    return /*#__PURE__*/React__default.createElement(QueryItem, {
      query: query,
      onRemove: removeQuery,
      key: query.order,
      onClick: handleQueryEdit
    });
  }), /*#__PURE__*/React__default.createElement("div", {
    className: clsx(style.activeQueryPart, {
      invalid: !isActivePartValid,
      'gesture-invalid': showInvalidGesture
    })
  }, /*#__PURE__*/React__default.createElement(QueryItem, {
    query: activeQueryItem,
    onRemove: resetActiveQuery,
    key: activeQueryItem.order
  })), /*#__PURE__*/React__default.createElement("div", {
    className: style.inputText
  }, /*#__PURE__*/React__default.createElement(TextField, {
    className: style.textField,
    ref: inputRef,
    tabIndex: 1,
    value: inputValue,
    onKeyUp: handleKeyUp,
    onChange: handleInputChange,
    onFocus: handleInputFocus,
    focusedBorderColor: "transparent",
    placeholder: util.isQueryEmpty(queryItemList, activeQueryItem) ? resolvePlaceholder() : ''
  }))), queryItemList.length > 0 && /*#__PURE__*/React__default.createElement(IconButton, {
    className: style.clearIcon,
    iconID: "clear-icon",
    onClick: resetQueryItemList
  })), !getIsInFreeSearch(inputValue) && /*#__PURE__*/React__default.createElement("div", {
    className: style.suggestionRoot,
    ref: querySuggestionRef
  }, /*#__PURE__*/React__default.createElement(QuerySuggestion, {
    suggestionList: suggestionList,
    show: showSuggestionPanel,
    onSuggestionSelect: handleSuggestionSelect,
    showSpinner: isSuggestionInProgress,
    onFocusOut: focusInput
  })));
};

var RetryTextAndButton = function RetryTextAndButton(_ref) {
  var action = _ref.action;
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: 8,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center'
    }
  }, /*#__PURE__*/React__default.createElement(Text$1, {
    variant: "header-2"
  }, "An unexpected error occurred."), /*#__PURE__*/React__default.createElement(Text$1, {
    variant: "header-2"
  }, "Please try again in a few moments"), action && /*#__PURE__*/React__default.createElement(Button, {
    style: {
      marginTop: 12
    },
    variant: "primary",
    onClick: action
  }, "Retry"));
};

var prism = createCommonjsModule$1(function (module) {
/* **********************************************
     Begin prism-core.js
********************************************** */

/// <reference lib="WebWorker"/>

var _self = (typeof window !== 'undefined')
	? window   // if in browser
	: (
		(typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope)
			? self // if in worker
			: {}   // if in node js
	);

/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */
var Prism = (function (_self) {

	// Private helper vars
	var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
	var uniqueId = 0;

	// The grammar object for plaintext
	var plainTextGrammar = {};


	var _ = {
		/**
		 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
		 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
		 * additional languages or plugins yourself.
		 *
		 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
		 *
		 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.manual = true;
		 * // add a new <script> to load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */
		manual: _self.Prism && _self.Prism.manual,
		/**
		 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
		 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
		 * own worker, you don't want it to do this.
		 *
		 * By setting this value to `true`, Prism will not add its own listeners to the worker.
		 *
		 * You obviously have to change this value before Prism executes. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.disableWorkerMessageHandler = true;
		 * // Load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */
		disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,

		/**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */
		util: {
			encode: function encode(tokens) {
				if (tokens instanceof Token) {
					return new Token(tokens.type, encode(tokens.content), tokens.alias);
				} else if (Array.isArray(tokens)) {
					return tokens.map(encode);
				} else {
					return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
				}
			},

			/**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */
			type: function (o) {
				return Object.prototype.toString.call(o).slice(8, -1);
			},

			/**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */
			objId: function (obj) {
				if (!obj['__id']) {
					Object.defineProperty(obj, '__id', { value: ++uniqueId });
				}
				return obj['__id'];
			},

			/**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */
			clone: function deepClone(o, visited) {
				visited = visited || {};

				var clone; var id;
				switch (_.util.type(o)) {
					case 'Object':
						id = _.util.objId(o);
						if (visited[id]) {
							return visited[id];
						}
						clone = /** @type {Record<string, any>} */ ({});
						visited[id] = clone;

						for (var key in o) {
							if (o.hasOwnProperty(key)) {
								clone[key] = deepClone(o[key], visited);
							}
						}

						return /** @type {any} */ (clone);

					case 'Array':
						id = _.util.objId(o);
						if (visited[id]) {
							return visited[id];
						}
						clone = [];
						visited[id] = clone;

						(/** @type {Array} */(/** @type {any} */(o))).forEach(function (v, i) {
							clone[i] = deepClone(v, visited);
						});

						return /** @type {any} */ (clone);

					default:
						return o;
				}
			},

			/**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */
			getLanguage: function (element) {
				while (element) {
					var m = lang.exec(element.className);
					if (m) {
						return m[1].toLowerCase();
					}
					element = element.parentElement;
				}
				return 'none';
			},

			/**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */
			setLanguage: function (element, language) {
				// remove all `language-xxxx` classes
				// (this might leave behind a leading space)
				element.className = element.className.replace(RegExp(lang, 'gi'), '');

				// add the new `language-xxxx` class
				// (using `classList` will automatically clean up spaces for us)
				element.classList.add('language-' + language);
			},

			/**
			 * Returns the script element that is currently executing.
			 *
			 * This does __not__ work for line script element.
			 *
			 * @returns {HTMLScriptElement | null}
			 */
			currentScript: function () {
				if (typeof document === 'undefined') {
					return null;
				}
				if ('currentScript' in document && 1 < 2 /* hack to trip TS' flow analysis */) {
					return /** @type {any} */ (document.currentScript);
				}

				// IE11 workaround
				// we'll get the src of the current script by parsing IE11's error stack trace
				// this will not work for inline scripts

				try {
					throw new Error();
				} catch (err) {
					// Get file src url from stack. Specifically works with the format of stack traces in IE.
					// A stack will look like this:
					//
					// Error
					//    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
					//    at Global code (http://localhost/components/prism-core.js:606:1)

					var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
					if (src) {
						var scripts = document.getElementsByTagName('script');
						for (var i in scripts) {
							if (scripts[i].src == src) {
								return scripts[i];
							}
						}
					}
					return null;
				}
			},

			/**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */
			isActive: function (element, className, defaultActivation) {
				var no = 'no-' + className;

				while (element) {
					var classList = element.classList;
					if (classList.contains(className)) {
						return true;
					}
					if (classList.contains(no)) {
						return false;
					}
					element = element.parentElement;
				}
				return !!defaultActivation;
			}
		},

		/**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */
		languages: {
			/**
			 * The grammar for plain, unformatted text.
			 */
			plain: plainTextGrammar,
			plaintext: plainTextGrammar,
			text: plainTextGrammar,
			txt: plainTextGrammar,

			/**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */
			extend: function (id, redef) {
				var lang = _.util.clone(_.languages[id]);

				for (var key in redef) {
					lang[key] = redef[key];
				}

				return lang;
			},

			/**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */
			insertBefore: function (inside, before, insert, root) {
				root = root || /** @type {any} */ (_.languages);
				var grammar = root[inside];
				/** @type {Grammar} */
				var ret = {};

				for (var token in grammar) {
					if (grammar.hasOwnProperty(token)) {

						if (token == before) {
							for (var newToken in insert) {
								if (insert.hasOwnProperty(newToken)) {
									ret[newToken] = insert[newToken];
								}
							}
						}

						// Do not insert token which also occur in insert. See #1525
						if (!insert.hasOwnProperty(token)) {
							ret[token] = grammar[token];
						}
					}
				}

				var old = root[inside];
				root[inside] = ret;

				// Update references in other language definitions
				_.languages.DFS(_.languages, function (key, value) {
					if (value === old && key != inside) {
						this[key] = ret;
					}
				});

				return ret;
			},

			// Traverse a language definition with Depth First Search
			DFS: function DFS(o, callback, type, visited) {
				visited = visited || {};

				var objId = _.util.objId;

				for (var i in o) {
					if (o.hasOwnProperty(i)) {
						callback.call(o, i, o[i], type || i);

						var property = o[i];
						var propertyType = _.util.type(property);

						if (propertyType === 'Object' && !visited[objId(property)]) {
							visited[objId(property)] = true;
							DFS(property, callback, null, visited);
						} else if (propertyType === 'Array' && !visited[objId(property)]) {
							visited[objId(property)] = true;
							DFS(property, callback, i, visited);
						}
					}
				}
			}
		},

		plugins: {},

		/**
		 * This is the most high-level function in Prism’s API.
		 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
		 * each one of them.
		 *
		 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
		 *
		 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
		 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
		 * @memberof Prism
		 * @public
		 */
		highlightAll: function (async, callback) {
			_.highlightAllUnder(document, async, callback);
		},

		/**
		 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
		 * {@link Prism.highlightElement} on each one of them.
		 *
		 * The following hooks will be run:
		 * 1. `before-highlightall`
		 * 2. `before-all-elements-highlight`
		 * 3. All hooks of {@link Prism.highlightElement} for each element.
		 *
		 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
		 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
		 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
		 * @memberof Prism
		 * @public
		 */
		highlightAllUnder: function (container, async, callback) {
			var env = {
				callback: callback,
				container: container,
				selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
			};

			_.hooks.run('before-highlightall', env);

			env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));

			_.hooks.run('before-all-elements-highlight', env);

			for (var i = 0, element; (element = env.elements[i++]);) {
				_.highlightElement(element, async === true, env.callback);
			}
		},

		/**
		 * Highlights the code inside a single element.
		 *
		 * The following hooks will be run:
		 * 1. `before-sanity-check`
		 * 2. `before-highlight`
		 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
		 * 4. `before-insert`
		 * 5. `after-highlight`
		 * 6. `complete`
		 *
		 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
		 * the element's language.
		 *
		 * @param {Element} element The element containing the code.
		 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
		 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
		 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
		 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
		 *
		 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
		 * asynchronous highlighting to work. You can build your own bundle on the
		 * [Download page](https://prismjs.com/download.html).
		 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
		 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
		 * @memberof Prism
		 * @public
		 */
		highlightElement: function (element, async, callback) {
			// Find language
			var language = _.util.getLanguage(element);
			var grammar = _.languages[language];

			// Set language on the element, if not present
			_.util.setLanguage(element, language);

			// Set language on the parent, for styling
			var parent = element.parentElement;
			if (parent && parent.nodeName.toLowerCase() === 'pre') {
				_.util.setLanguage(parent, language);
			}

			var code = element.textContent;

			var env = {
				element: element,
				language: language,
				grammar: grammar,
				code: code
			};

			function insertHighlightedCode(highlightedCode) {
				env.highlightedCode = highlightedCode;

				_.hooks.run('before-insert', env);

				env.element.innerHTML = env.highlightedCode;

				_.hooks.run('after-highlight', env);
				_.hooks.run('complete', env);
				callback && callback.call(env.element);
			}

			_.hooks.run('before-sanity-check', env);

			// plugins may change/add the parent/element
			parent = env.element.parentElement;
			if (parent && parent.nodeName.toLowerCase() === 'pre' && !parent.hasAttribute('tabindex')) {
				parent.setAttribute('tabindex', '0');
			}

			if (!env.code) {
				_.hooks.run('complete', env);
				callback && callback.call(env.element);
				return;
			}

			_.hooks.run('before-highlight', env);

			if (!env.grammar) {
				insertHighlightedCode(_.util.encode(env.code));
				return;
			}

			if (async && _self.Worker) {
				var worker = new Worker(_.filename);

				worker.onmessage = function (evt) {
					insertHighlightedCode(evt.data);
				};

				worker.postMessage(JSON.stringify({
					language: env.language,
					code: env.code,
					immediateClose: true
				}));
			} else {
				insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
			}
		},

		/**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */
		highlight: function (text, grammar, language) {
			var env = {
				code: text,
				grammar: grammar,
				language: language
			};
			_.hooks.run('before-tokenize', env);
			if (!env.grammar) {
				throw new Error('The language "' + env.language + '" has no grammar.');
			}
			env.tokens = _.tokenize(env.code, env.grammar);
			_.hooks.run('after-tokenize', env);
			return Token.stringify(_.util.encode(env.tokens), env.language);
		},

		/**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */
		tokenize: function (text, grammar) {
			var rest = grammar.rest;
			if (rest) {
				for (var token in rest) {
					grammar[token] = rest[token];
				}

				delete grammar.rest;
			}

			var tokenList = new LinkedList();
			addAfter(tokenList, tokenList.head, text);

			matchGrammar(text, tokenList, grammar, tokenList.head, 0);

			return toArray(tokenList);
		},

		/**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */
		hooks: {
			all: {},

			/**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */
			add: function (name, callback) {
				var hooks = _.hooks.all;

				hooks[name] = hooks[name] || [];

				hooks[name].push(callback);
			},

			/**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */
			run: function (name, env) {
				var callbacks = _.hooks.all[name];

				if (!callbacks || !callbacks.length) {
					return;
				}

				for (var i = 0, callback; (callback = callbacks[i++]);) {
					callback(env);
				}
			}
		},

		Token: Token
	};
	_self.Prism = _;


	// Typescript note:
	// The following can be used to import the Token type in JSDoc:
	//
	//   @typedef {InstanceType<import("./prism-core")["Token"]>} Token

	/**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */
	function Token(type, content, alias, matchedStr) {
		/**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */
		this.type = type;
		/**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */
		this.content = content;
		/**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */
		this.alias = alias;
		// Copy of the full string this token was created from
		this.length = (matchedStr || '').length | 0;
	}

	/**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */

	/**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */
	Token.stringify = function stringify(o, language) {
		if (typeof o == 'string') {
			return o;
		}
		if (Array.isArray(o)) {
			var s = '';
			o.forEach(function (e) {
				s += stringify(e, language);
			});
			return s;
		}

		var env = {
			type: o.type,
			content: stringify(o.content, language),
			tag: 'span',
			classes: ['token', o.type],
			attributes: {},
			language: language
		};

		var aliases = o.alias;
		if (aliases) {
			if (Array.isArray(aliases)) {
				Array.prototype.push.apply(env.classes, aliases);
			} else {
				env.classes.push(aliases);
			}
		}

		_.hooks.run('wrap', env);

		var attributes = '';
		for (var name in env.attributes) {
			attributes += ' ' + name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
		}

		return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + attributes + '>' + env.content + '</' + env.tag + '>';
	};

	/**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */
	function matchPattern(pattern, pos, text, lookbehind) {
		pattern.lastIndex = pos;
		var match = pattern.exec(text);
		if (match && lookbehind && match[1]) {
			// change the match to remove the text matched by the Prism lookbehind group
			var lookbehindLength = match[1].length;
			match.index += lookbehindLength;
			match[0] = match[0].slice(lookbehindLength);
		}
		return match;
	}

	/**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */
	function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
		for (var token in grammar) {
			if (!grammar.hasOwnProperty(token) || !grammar[token]) {
				continue;
			}

			var patterns = grammar[token];
			patterns = Array.isArray(patterns) ? patterns : [patterns];

			for (var j = 0; j < patterns.length; ++j) {
				if (rematch && rematch.cause == token + ',' + j) {
					return;
				}

				var patternObj = patterns[j];
				var inside = patternObj.inside;
				var lookbehind = !!patternObj.lookbehind;
				var greedy = !!patternObj.greedy;
				var alias = patternObj.alias;

				if (greedy && !patternObj.pattern.global) {
					// Without the global flag, lastIndex won't work
					var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
					patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
				}

				/** @type {RegExp} */
				var pattern = patternObj.pattern || patternObj;

				for ( // iterate the token list and keep track of the current token/string position
					var currentNode = startNode.next, pos = startPos;
					currentNode !== tokenList.tail;
					pos += currentNode.value.length, currentNode = currentNode.next
				) {

					if (rematch && pos >= rematch.reach) {
						break;
					}

					var str = currentNode.value;

					if (tokenList.length > text.length) {
						// Something went terribly wrong, ABORT, ABORT!
						return;
					}

					if (str instanceof Token) {
						continue;
					}

					var removeCount = 1; // this is the to parameter of removeBetween
					var match;

					if (greedy) {
						match = matchPattern(pattern, pos, text, lookbehind);
						if (!match || match.index >= text.length) {
							break;
						}

						var from = match.index;
						var to = match.index + match[0].length;
						var p = pos;

						// find the node that contains the match
						p += currentNode.value.length;
						while (from >= p) {
							currentNode = currentNode.next;
							p += currentNode.value.length;
						}
						// adjust pos (and p)
						p -= currentNode.value.length;
						pos = p;

						// the current node is a Token, then the match starts inside another Token, which is invalid
						if (currentNode.value instanceof Token) {
							continue;
						}

						// find the last node which is affected by this match
						for (
							var k = currentNode;
							k !== tokenList.tail && (p < to || typeof k.value === 'string');
							k = k.next
						) {
							removeCount++;
							p += k.value.length;
						}
						removeCount--;

						// replace with the new match
						str = text.slice(pos, p);
						match.index -= pos;
					} else {
						match = matchPattern(pattern, 0, str, lookbehind);
						if (!match) {
							continue;
						}
					}

					// eslint-disable-next-line no-redeclare
					var from = match.index;
					var matchStr = match[0];
					var before = str.slice(0, from);
					var after = str.slice(from + matchStr.length);

					var reach = pos + str.length;
					if (rematch && reach > rematch.reach) {
						rematch.reach = reach;
					}

					var removeFrom = currentNode.prev;

					if (before) {
						removeFrom = addAfter(tokenList, removeFrom, before);
						pos += before.length;
					}

					removeRange(tokenList, removeFrom, removeCount);

					var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
					currentNode = addAfter(tokenList, removeFrom, wrapped);

					if (after) {
						addAfter(tokenList, currentNode, after);
					}

					if (removeCount > 1) {
						// at least one Token object was removed, so we have to do some rematching
						// this can only happen if the current pattern is greedy

						/** @type {RematchOptions} */
						var nestedRematch = {
							cause: token + ',' + j,
							reach: reach
						};
						matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);

						// the reach might have been extended because of the rematching
						if (rematch && nestedRematch.reach > rematch.reach) {
							rematch.reach = nestedRematch.reach;
						}
					}
				}
			}
		}
	}

	/**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */

	/**
	 * @template T
	 * @private
	 */
	function LinkedList() {
		/** @type {LinkedListNode<T>} */
		var head = { value: null, prev: null, next: null };
		/** @type {LinkedListNode<T>} */
		var tail = { value: null, prev: head, next: null };
		head.next = tail;

		/** @type {LinkedListNode<T>} */
		this.head = head;
		/** @type {LinkedListNode<T>} */
		this.tail = tail;
		this.length = 0;
	}

	/**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */
	function addAfter(list, node, value) {
		// assumes that node != list.tail && values.length >= 0
		var next = node.next;

		var newNode = { value: value, prev: node, next: next };
		node.next = newNode;
		next.prev = newNode;
		list.length++;

		return newNode;
	}
	/**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */
	function removeRange(list, node, count) {
		var next = node.next;
		for (var i = 0; i < count && next !== list.tail; i++) {
			next = next.next;
		}
		node.next = next;
		next.prev = node;
		list.length -= i;
	}
	/**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */
	function toArray(list) {
		var array = [];
		var node = list.head.next;
		while (node !== list.tail) {
			array.push(node.value);
			node = node.next;
		}
		return array;
	}


	if (!_self.document) {
		if (!_self.addEventListener) {
			// in Node.js
			return _;
		}

		if (!_.disableWorkerMessageHandler) {
			// In worker
			_self.addEventListener('message', function (evt) {
				var message = JSON.parse(evt.data);
				var lang = message.language;
				var code = message.code;
				var immediateClose = message.immediateClose;

				_self.postMessage(_.highlight(code, _.languages[lang], lang));
				if (immediateClose) {
					_self.close();
				}
			}, false);
		}

		return _;
	}

	// Get current script and highlight
	var script = _.util.currentScript();

	if (script) {
		_.filename = script.src;

		if (script.hasAttribute('data-manual')) {
			_.manual = true;
		}
	}

	function highlightAutomaticallyCallback() {
		if (!_.manual) {
			_.highlightAll();
		}
	}

	if (!_.manual) {
		// If the document state is "loading", then we'll use DOMContentLoaded.
		// If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
		// DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
		// might take longer one animation frame to execute which can create a race condition where only some plugins have
		// been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
		// See https://github.com/PrismJS/prism/issues/2102
		var readyState = document.readyState;
		if (readyState === 'loading' || readyState === 'interactive' && script && script.defer) {
			document.addEventListener('DOMContentLoaded', highlightAutomaticallyCallback);
		} else {
			if (window.requestAnimationFrame) {
				window.requestAnimationFrame(highlightAutomaticallyCallback);
			} else {
				window.setTimeout(highlightAutomaticallyCallback, 16);
			}
		}
	}

	return _;

}(_self));

if (module.exports) {
	module.exports = Prism;
}

// hack for components to work correctly in node.js
if (typeof commonjsGlobal !== 'undefined') {
	commonjsGlobal.Prism = Prism;
}

// some additional documentation/types

/**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */

/**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */

/**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */

/**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */


/* **********************************************
     Begin prism-markup.js
********************************************** */

Prism.languages.markup = {
	'comment': {
		pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
		greedy: true
	},
	'prolog': {
		pattern: /<\?[\s\S]+?\?>/,
		greedy: true
	},
	'doctype': {
		// https://www.w3.org/TR/xml/#NT-doctypedecl
		pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
		greedy: true,
		inside: {
			'internal-subset': {
				pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
				lookbehind: true,
				greedy: true,
				inside: null // see below
			},
			'string': {
				pattern: /"[^"]*"|'[^']*'/,
				greedy: true
			},
			'punctuation': /^<!|>$|[[\]]/,
			'doctype-tag': /^DOCTYPE/i,
			'name': /[^\s<>'"]+/
		}
	},
	'cdata': {
		pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
		greedy: true
	},
	'tag': {
		pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
		greedy: true,
		inside: {
			'tag': {
				pattern: /^<\/?[^\s>\/]+/,
				inside: {
					'punctuation': /^<\/?/,
					'namespace': /^[^\s>\/:]+:/
				}
			},
			'special-attr': [],
			'attr-value': {
				pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
				inside: {
					'punctuation': [
						{
							pattern: /^=/,
							alias: 'attr-equals'
						},
						/"|'/
					]
				}
			},
			'punctuation': /\/?>/,
			'attr-name': {
				pattern: /[^\s>\/]+/,
				inside: {
					'namespace': /^[^\s>\/:]+:/
				}
			}

		}
	},
	'entity': [
		{
			pattern: /&[\da-z]{1,8};/i,
			alias: 'named-entity'
		},
		/&#x?[\da-f]{1,8};/i
	]
};

Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] =
	Prism.languages.markup['entity'];
Prism.languages.markup['doctype'].inside['internal-subset'].inside = Prism.languages.markup;

// Plugin to make entity title show the real entity, idea by Roman Komarov
Prism.hooks.add('wrap', function (env) {

	if (env.type === 'entity') {
		env.attributes['title'] = env.content.replace(/&amp;/, '&');
	}
});

Object.defineProperty(Prism.languages.markup.tag, 'addInlined', {
	/**
	 * Adds an inlined language to markup.
	 *
	 * An example of an inlined language is CSS with `<style>` tags.
	 *
	 * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addInlined('style', 'css');
	 */
	value: function addInlined(tagName, lang) {
		var includedCdataInside = {};
		includedCdataInside['language-' + lang] = {
			pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
			lookbehind: true,
			inside: Prism.languages[lang]
		};
		includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;

		var inside = {
			'included-cdata': {
				pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
				inside: includedCdataInside
			}
		};
		inside['language-' + lang] = {
			pattern: /[\s\S]+/,
			inside: Prism.languages[lang]
		};

		var def = {};
		def[tagName] = {
			pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function () { return tagName; }), 'i'),
			lookbehind: true,
			greedy: true,
			inside: inside
		};

		Prism.languages.insertBefore('markup', 'cdata', def);
	}
});
Object.defineProperty(Prism.languages.markup.tag, 'addAttribute', {
	/**
	 * Adds an pattern to highlight languages embedded in HTML attributes.
	 *
	 * An example of an inlined language is CSS with `style` attributes.
	 *
	 * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addAttribute('style', 'css');
	 */
	value: function (attrName, lang) {
		Prism.languages.markup.tag.inside['special-attr'].push({
			pattern: RegExp(
				/(^|["'\s])/.source + '(?:' + attrName + ')' + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,
				'i'
			),
			lookbehind: true,
			inside: {
				'attr-name': /^[^\s=]+/,
				'attr-value': {
					pattern: /=[\s\S]+/,
					inside: {
						'value': {
							pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
							lookbehind: true,
							alias: [lang, 'language-' + lang],
							inside: Prism.languages[lang]
						},
						'punctuation': [
							{
								pattern: /^=/,
								alias: 'attr-equals'
							},
							/"|'/
						]
					}
				}
			}
		});
	}
});

Prism.languages.html = Prism.languages.markup;
Prism.languages.mathml = Prism.languages.markup;
Prism.languages.svg = Prism.languages.markup;

Prism.languages.xml = Prism.languages.extend('markup', {});
Prism.languages.ssml = Prism.languages.xml;
Prism.languages.atom = Prism.languages.xml;
Prism.languages.rss = Prism.languages.xml;


/* **********************************************
     Begin prism-css.js
********************************************** */

(function (Prism) {

	var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;

	Prism.languages.css = {
		'comment': /\/\*[\s\S]*?\*\//,
		'atrule': {
			pattern: /@[\w-](?:[^;{\s]|\s+(?![\s{]))*(?:;|(?=\s*\{))/,
			inside: {
				'rule': /^@[\w-]+/,
				'selector-function-argument': {
					pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
					lookbehind: true,
					alias: 'selector'
				},
				'keyword': {
					pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
					lookbehind: true
				}
				// See rest below
			}
		},
		'url': {
			// https://drafts.csswg.org/css-values-3/#urls
			pattern: RegExp('\\burl\\((?:' + string.source + '|' + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ')\\)', 'i'),
			greedy: true,
			inside: {
				'function': /^url/i,
				'punctuation': /^\(|\)$/,
				'string': {
					pattern: RegExp('^' + string.source + '$'),
					alias: 'url'
				}
			}
		},
		'selector': {
			pattern: RegExp('(^|[{}\\s])[^{}\\s](?:[^{};"\'\\s]|\\s+(?![\\s{])|' + string.source + ')*(?=\\s*\\{)'),
			lookbehind: true
		},
		'string': {
			pattern: string,
			greedy: true
		},
		'property': {
			pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
			lookbehind: true
		},
		'important': /!important\b/i,
		'function': {
			pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
			lookbehind: true
		},
		'punctuation': /[(){};:,]/
	};

	Prism.languages.css['atrule'].inside.rest = Prism.languages.css;

	var markup = Prism.languages.markup;
	if (markup) {
		markup.tag.addInlined('style', 'css');
		markup.tag.addAttribute('style', 'css');
	}

}(Prism));


/* **********************************************
     Begin prism-clike.js
********************************************** */

Prism.languages.clike = {
	'comment': [
		{
			pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
			lookbehind: true,
			greedy: true
		},
		{
			pattern: /(^|[^\\:])\/\/.*/,
			lookbehind: true,
			greedy: true
		}
	],
	'string': {
		pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
		greedy: true
	},
	'class-name': {
		pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
		lookbehind: true,
		inside: {
			'punctuation': /[.\\]/
		}
	},
	'keyword': /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
	'boolean': /\b(?:false|true)\b/,
	'function': /\b\w+(?=\()/,
	'number': /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
	'operator': /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
	'punctuation': /[{}[\];(),.:]/
};


/* **********************************************
     Begin prism-javascript.js
********************************************** */

Prism.languages.javascript = Prism.languages.extend('clike', {
	'class-name': [
		Prism.languages.clike['class-name'],
		{
			pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
			lookbehind: true
		}
	],
	'keyword': [
		{
			pattern: /((?:^|\})\s*)catch\b/,
			lookbehind: true
		},
		{
			pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
			lookbehind: true
		},
	],
	// Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
	'function': /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
	'number': {
		pattern: RegExp(
			/(^|[^\w$])/.source +
			'(?:' +
			(
				// constant
				/NaN|Infinity/.source +
				'|' +
				// binary integer
				/0[bB][01]+(?:_[01]+)*n?/.source +
				'|' +
				// octal integer
				/0[oO][0-7]+(?:_[0-7]+)*n?/.source +
				'|' +
				// hexadecimal integer
				/0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source +
				'|' +
				// decimal bigint
				/\d+(?:_\d+)*n/.source +
				'|' +
				// decimal number (integer or float) but no bigint
				/(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source
			) +
			')' +
			/(?![\w$])/.source
		),
		lookbehind: true
	},
	'operator': /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});

Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;

Prism.languages.insertBefore('javascript', 'keyword', {
	'regex': {
		pattern: RegExp(
			// lookbehind
			// eslint-disable-next-line regexp/no-dupe-characters-character-class
			/((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source +
			// Regex pattern:
			// There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
			// classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
			// with the only syntax, so we have to define 2 different regex patterns.
			/\//.source +
			'(?:' +
			/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source +
			'|' +
			// `v` flag syntax. This supports 3 levels of nested character classes.
			/(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source +
			')' +
			// lookahead
			/(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source
		),
		lookbehind: true,
		greedy: true,
		inside: {
			'regex-source': {
				pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
				lookbehind: true,
				alias: 'language-regex',
				inside: Prism.languages.regex
			},
			'regex-delimiter': /^\/|\/$/,
			'regex-flags': /^[a-z]+$/,
		}
	},
	// This must be declared before keyword because we use "function" inside the look-forward
	'function-variable': {
		pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
		alias: 'function'
	},
	'parameter': [
		{
			pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
			lookbehind: true,
			inside: Prism.languages.javascript
		}
	],
	'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});

Prism.languages.insertBefore('javascript', 'string', {
	'hashbang': {
		pattern: /^#!.*/,
		greedy: true,
		alias: 'comment'
	},
	'template-string': {
		pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
		greedy: true,
		inside: {
			'template-punctuation': {
				pattern: /^`|`$/,
				alias: 'string'
			},
			'interpolation': {
				pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
				lookbehind: true,
				inside: {
					'interpolation-punctuation': {
						pattern: /^\$\{|\}$/,
						alias: 'punctuation'
					},
					rest: Prism.languages.javascript
				}
			},
			'string': /[\s\S]+/
		}
	},
	'string-property': {
		pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
		lookbehind: true,
		greedy: true,
		alias: 'property'
	}
});

Prism.languages.insertBefore('javascript', 'operator', {
	'literal-property': {
		pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
		lookbehind: true,
		alias: 'property'
	},
});

if (Prism.languages.markup) {
	Prism.languages.markup.tag.addInlined('script', 'javascript');

	// add attribute support for all DOM events.
	// https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
	Prism.languages.markup.tag.addAttribute(
		/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
		'javascript'
	);
}

Prism.languages.js = Prism.languages.javascript;


/* **********************************************
     Begin prism-file-highlight.js
********************************************** */

(function () {

	if (typeof Prism === 'undefined' || typeof document === 'undefined') {
		return;
	}

	// https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill
	if (!Element.prototype.matches) {
		Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
	}

	var LOADING_MESSAGE = 'Loading…';
	var FAILURE_MESSAGE = function (status, message) {
		return '✖ Error ' + status + ' while fetching file: ' + message;
	};
	var FAILURE_EMPTY_MESSAGE = '✖ Error: File does not exist or is empty';

	var EXTENSIONS = {
		'js': 'javascript',
		'py': 'python',
		'rb': 'ruby',
		'ps1': 'powershell',
		'psm1': 'powershell',
		'sh': 'bash',
		'bat': 'batch',
		'h': 'c',
		'tex': 'latex'
	};

	var STATUS_ATTR = 'data-src-status';
	var STATUS_LOADING = 'loading';
	var STATUS_LOADED = 'loaded';
	var STATUS_FAILED = 'failed';

	var SELECTOR = 'pre[data-src]:not([' + STATUS_ATTR + '="' + STATUS_LOADED + '"])'
		+ ':not([' + STATUS_ATTR + '="' + STATUS_LOADING + '"])';

	/**
	 * Loads the given file.
	 *
	 * @param {string} src The URL or path of the source file to load.
	 * @param {(result: string) => void} success
	 * @param {(reason: string) => void} error
	 */
	function loadFile(src, success, error) {
		var xhr = new XMLHttpRequest();
		xhr.open('GET', src, true);
		xhr.onreadystatechange = function () {
			if (xhr.readyState == 4) {
				if (xhr.status < 400 && xhr.responseText) {
					success(xhr.responseText);
				} else {
					if (xhr.status >= 400) {
						error(FAILURE_MESSAGE(xhr.status, xhr.statusText));
					} else {
						error(FAILURE_EMPTY_MESSAGE);
					}
				}
			}
		};
		xhr.send(null);
	}

	/**
	 * Parses the given range.
	 *
	 * This returns a range with inclusive ends.
	 *
	 * @param {string | null | undefined} range
	 * @returns {[number, number | undefined] | undefined}
	 */
	function parseRange(range) {
		var m = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(range || '');
		if (m) {
			var start = Number(m[1]);
			var comma = m[2];
			var end = m[3];

			if (!comma) {
				return [start, start];
			}
			if (!end) {
				return [start, undefined];
			}
			return [start, Number(end)];
		}
		return undefined;
	}

	Prism.hooks.add('before-highlightall', function (env) {
		env.selector += ', ' + SELECTOR;
	});

	Prism.hooks.add('before-sanity-check', function (env) {
		var pre = /** @type {HTMLPreElement} */ (env.element);
		if (pre.matches(SELECTOR)) {
			env.code = ''; // fast-path the whole thing and go to complete

			pre.setAttribute(STATUS_ATTR, STATUS_LOADING); // mark as loading

			// add code element with loading message
			var code = pre.appendChild(document.createElement('CODE'));
			code.textContent = LOADING_MESSAGE;

			var src = pre.getAttribute('data-src');

			var language = env.language;
			if (language === 'none') {
				// the language might be 'none' because there is no language set;
				// in this case, we want to use the extension as the language
				var extension = (/\.(\w+)$/.exec(src) || [, 'none'])[1];
				language = EXTENSIONS[extension] || extension;
			}

			// set language classes
			Prism.util.setLanguage(code, language);
			Prism.util.setLanguage(pre, language);

			// preload the language
			var autoloader = Prism.plugins.autoloader;
			if (autoloader) {
				autoloader.loadLanguages(language);
			}

			// load file
			loadFile(
				src,
				function (text) {
					// mark as loaded
					pre.setAttribute(STATUS_ATTR, STATUS_LOADED);

					// handle data-range
					var range = parseRange(pre.getAttribute('data-range'));
					if (range) {
						var lines = text.split(/\r\n?|\n/g);

						// the range is one-based and inclusive on both ends
						var start = range[0];
						var end = range[1] == null ? lines.length : range[1];

						if (start < 0) { start += lines.length; }
						start = Math.max(0, Math.min(start - 1, lines.length));
						if (end < 0) { end += lines.length; }
						end = Math.max(0, Math.min(end, lines.length));

						text = lines.slice(start, end).join('\n');

						// add data-start for line numbers
						if (!pre.hasAttribute('data-start')) {
							pre.setAttribute('data-start', String(start + 1));
						}
					}

					// highlight code
					code.textContent = text;
					Prism.highlightElement(code);
				},
				function (error) {
					// mark as failed
					pre.setAttribute(STATUS_ATTR, STATUS_FAILED);

					code.textContent = error;
				}
			);
		}
	});

	Prism.plugins.fileHighlight = {
		/**
		 * Executes the File Highlight plugin for all matching `pre` elements under the given container.
		 *
		 * Note: Elements which are already loaded or currently loading will not be touched by this method.
		 *
		 * @param {ParentNode} [container=document]
		 */
		highlight: function highlight(container) {
			var elements = (container || document).querySelectorAll(SELECTOR);

			for (var i = 0, element; (element = elements[i++]);) {
				Prism.highlightElement(element);
			}
		}
	};

	var logged = false;
	/** @deprecated Use `Prism.plugins.fileHighlight.highlight` instead. */
	Prism.fileHighlight = function () {
		if (!logged) {
			console.warn('Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead.');
			logged = true;
		}
		Prism.plugins.fileHighlight.highlight.apply(this, arguments);
	};

}());
});

Prism.languages.clike = {
	'comment': [
		{
			pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
			lookbehind: true,
			greedy: true
		},
		{
			pattern: /(^|[^\\:])\/\/.*/,
			lookbehind: true,
			greedy: true
		}
	],
	'string': {
		pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
		greedy: true
	},
	'class-name': {
		pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
		lookbehind: true,
		inside: {
			'punctuation': /[.\\]/
		}
	},
	'keyword': /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
	'boolean': /\b(?:false|true)\b/,
	'function': /\b\w+(?=\()/,
	'number': /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
	'operator': /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
	'punctuation': /[{}[\];(),.:]/
};

Prism.languages.javascript = Prism.languages.extend('clike', {
	'class-name': [
		Prism.languages.clike['class-name'],
		{
			pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
			lookbehind: true
		}
	],
	'keyword': [
		{
			pattern: /((?:^|\})\s*)catch\b/,
			lookbehind: true
		},
		{
			pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
			lookbehind: true
		},
	],
	// Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
	'function': /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
	'number': {
		pattern: RegExp(
			/(^|[^\w$])/.source +
			'(?:' +
			(
				// constant
				/NaN|Infinity/.source +
				'|' +
				// binary integer
				/0[bB][01]+(?:_[01]+)*n?/.source +
				'|' +
				// octal integer
				/0[oO][0-7]+(?:_[0-7]+)*n?/.source +
				'|' +
				// hexadecimal integer
				/0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source +
				'|' +
				// decimal bigint
				/\d+(?:_\d+)*n/.source +
				'|' +
				// decimal number (integer or float) but no bigint
				/(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source
			) +
			')' +
			/(?![\w$])/.source
		),
		lookbehind: true
	},
	'operator': /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});

Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;

Prism.languages.insertBefore('javascript', 'keyword', {
	'regex': {
		pattern: RegExp(
			// lookbehind
			// eslint-disable-next-line regexp/no-dupe-characters-character-class
			/((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source +
			// Regex pattern:
			// There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
			// classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
			// with the only syntax, so we have to define 2 different regex patterns.
			/\//.source +
			'(?:' +
			/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source +
			'|' +
			// `v` flag syntax. This supports 3 levels of nested character classes.
			/(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source +
			')' +
			// lookahead
			/(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source
		),
		lookbehind: true,
		greedy: true,
		inside: {
			'regex-source': {
				pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
				lookbehind: true,
				alias: 'language-regex',
				inside: Prism.languages.regex
			},
			'regex-delimiter': /^\/|\/$/,
			'regex-flags': /^[a-z]+$/,
		}
	},
	// This must be declared before keyword because we use "function" inside the look-forward
	'function-variable': {
		pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
		alias: 'function'
	},
	'parameter': [
		{
			pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
			lookbehind: true,
			inside: Prism.languages.javascript
		}
	],
	'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});

Prism.languages.insertBefore('javascript', 'string', {
	'hashbang': {
		pattern: /^#!.*/,
		greedy: true,
		alias: 'comment'
	},
	'template-string': {
		pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
		greedy: true,
		inside: {
			'template-punctuation': {
				pattern: /^`|`$/,
				alias: 'string'
			},
			'interpolation': {
				pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
				lookbehind: true,
				inside: {
					'interpolation-punctuation': {
						pattern: /^\$\{|\}$/,
						alias: 'punctuation'
					},
					rest: Prism.languages.javascript
				}
			},
			'string': /[\s\S]+/
		}
	},
	'string-property': {
		pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
		lookbehind: true,
		greedy: true,
		alias: 'property'
	}
});

Prism.languages.insertBefore('javascript', 'operator', {
	'literal-property': {
		pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
		lookbehind: true,
		alias: 'property'
	},
});

if (Prism.languages.markup) {
	Prism.languages.markup.tag.addInlined('script', 'javascript');

	// add attribute support for all DOM events.
	// https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
	Prism.languages.markup.tag.addAttribute(
		/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
		'javascript'
	);
}

Prism.languages.js = Prism.languages.javascript;

Prism.languages.markup = {
	'comment': {
		pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
		greedy: true
	},
	'prolog': {
		pattern: /<\?[\s\S]+?\?>/,
		greedy: true
	},
	'doctype': {
		// https://www.w3.org/TR/xml/#NT-doctypedecl
		pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
		greedy: true,
		inside: {
			'internal-subset': {
				pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
				lookbehind: true,
				greedy: true,
				inside: null // see below
			},
			'string': {
				pattern: /"[^"]*"|'[^']*'/,
				greedy: true
			},
			'punctuation': /^<!|>$|[[\]]/,
			'doctype-tag': /^DOCTYPE/i,
			'name': /[^\s<>'"]+/
		}
	},
	'cdata': {
		pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
		greedy: true
	},
	'tag': {
		pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
		greedy: true,
		inside: {
			'tag': {
				pattern: /^<\/?[^\s>\/]+/,
				inside: {
					'punctuation': /^<\/?/,
					'namespace': /^[^\s>\/:]+:/
				}
			},
			'special-attr': [],
			'attr-value': {
				pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
				inside: {
					'punctuation': [
						{
							pattern: /^=/,
							alias: 'attr-equals'
						},
						/"|'/
					]
				}
			},
			'punctuation': /\/?>/,
			'attr-name': {
				pattern: /[^\s>\/]+/,
				inside: {
					'namespace': /^[^\s>\/:]+:/
				}
			}

		}
	},
	'entity': [
		{
			pattern: /&[\da-z]{1,8};/i,
			alias: 'named-entity'
		},
		/&#x?[\da-f]{1,8};/i
	]
};

Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] =
	Prism.languages.markup['entity'];
Prism.languages.markup['doctype'].inside['internal-subset'].inside = Prism.languages.markup;

// Plugin to make entity title show the real entity, idea by Roman Komarov
Prism.hooks.add('wrap', function (env) {

	if (env.type === 'entity') {
		env.attributes['title'] = env.content.replace(/&amp;/, '&');
	}
});

Object.defineProperty(Prism.languages.markup.tag, 'addInlined', {
	/**
	 * Adds an inlined language to markup.
	 *
	 * An example of an inlined language is CSS with `<style>` tags.
	 *
	 * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addInlined('style', 'css');
	 */
	value: function addInlined(tagName, lang) {
		var includedCdataInside = {};
		includedCdataInside['language-' + lang] = {
			pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
			lookbehind: true,
			inside: Prism.languages[lang]
		};
		includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;

		var inside = {
			'included-cdata': {
				pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
				inside: includedCdataInside
			}
		};
		inside['language-' + lang] = {
			pattern: /[\s\S]+/,
			inside: Prism.languages[lang]
		};

		var def = {};
		def[tagName] = {
			pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function () { return tagName; }), 'i'),
			lookbehind: true,
			greedy: true,
			inside: inside
		};

		Prism.languages.insertBefore('markup', 'cdata', def);
	}
});
Object.defineProperty(Prism.languages.markup.tag, 'addAttribute', {
	/**
	 * Adds an pattern to highlight languages embedded in HTML attributes.
	 *
	 * An example of an inlined language is CSS with `style` attributes.
	 *
	 * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addAttribute('style', 'css');
	 */
	value: function (attrName, lang) {
		Prism.languages.markup.tag.inside['special-attr'].push({
			pattern: RegExp(
				/(^|["'\s])/.source + '(?:' + attrName + ')' + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,
				'i'
			),
			lookbehind: true,
			inside: {
				'attr-name': /^[^\s=]+/,
				'attr-value': {
					pattern: /=[\s\S]+/,
					inside: {
						'value': {
							pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
							lookbehind: true,
							alias: [lang, 'language-' + lang],
							inside: Prism.languages[lang]
						},
						'punctuation': [
							{
								pattern: /^=/,
								alias: 'attr-equals'
							},
							/"|'/
						]
					}
				}
			}
		});
	}
});

Prism.languages.html = Prism.languages.markup;
Prism.languages.mathml = Prism.languages.markup;
Prism.languages.svg = Prism.languages.markup;

Prism.languages.xml = Prism.languages.extend('markup', {});
Prism.languages.ssml = Prism.languages.xml;
Prism.languages.atom = Prism.languages.xml;
Prism.languages.rss = Prism.languages.xml;

(function (Prism) {

	// Allow only one line break
	var inner = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;

	/**
	 * This function is intended for the creation of the bold or italic pattern.
	 *
	 * This also adds a lookbehind group to the given pattern to ensure that the pattern is not backslash-escaped.
	 *
	 * _Note:_ Keep in mind that this adds a capturing group.
	 *
	 * @param {string} pattern
	 * @returns {RegExp}
	 */
	function createInline(pattern) {
		pattern = pattern.replace(/<inner>/g, function () { return inner; });
		return RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + '(?:' + pattern + ')');
	}


	var tableCell = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source;
	var tableRow = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function () { return tableCell; });
	var tableLine = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;


	Prism.languages.markdown = Prism.languages.extend('markup', {});
	Prism.languages.insertBefore('markdown', 'prolog', {
		'front-matter-block': {
			pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
			lookbehind: true,
			greedy: true,
			inside: {
				'punctuation': /^---|---$/,
				'front-matter': {
					pattern: /\S+(?:\s+\S+)*/,
					alias: ['yaml', 'language-yaml'],
					inside: Prism.languages.yaml
				}
			}
		},
		'blockquote': {
			// > ...
			pattern: /^>(?:[\t ]*>)*/m,
			alias: 'punctuation'
		},
		'table': {
			pattern: RegExp('^' + tableRow + tableLine + '(?:' + tableRow + ')*', 'm'),
			inside: {
				'table-data-rows': {
					pattern: RegExp('^(' + tableRow + tableLine + ')(?:' + tableRow + ')*$'),
					lookbehind: true,
					inside: {
						'table-data': {
							pattern: RegExp(tableCell),
							inside: Prism.languages.markdown
						},
						'punctuation': /\|/
					}
				},
				'table-line': {
					pattern: RegExp('^(' + tableRow + ')' + tableLine + '$'),
					lookbehind: true,
					inside: {
						'punctuation': /\||:?-{3,}:?/
					}
				},
				'table-header-row': {
					pattern: RegExp('^' + tableRow + '$'),
					inside: {
						'table-header': {
							pattern: RegExp(tableCell),
							alias: 'important',
							inside: Prism.languages.markdown
						},
						'punctuation': /\|/
					}
				}
			}
		},
		'code': [
			{
				// Prefixed by 4 spaces or 1 tab and preceded by an empty line
				pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
				lookbehind: true,
				alias: 'keyword'
			},
			{
				// ```optional language
				// code block
				// ```
				pattern: /^```[\s\S]*?^```$/m,
				greedy: true,
				inside: {
					'code-block': {
						pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
						lookbehind: true
					},
					'code-language': {
						pattern: /^(```).+/,
						lookbehind: true
					},
					'punctuation': /```/
				}
			}
		],
		'title': [
			{
				// title 1
				// =======

				// title 2
				// -------
				pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
				alias: 'important',
				inside: {
					punctuation: /==+$|--+$/
				}
			},
			{
				// # title 1
				// ###### title 6
				pattern: /(^\s*)#.+/m,
				lookbehind: true,
				alias: 'important',
				inside: {
					punctuation: /^#+|#+$/
				}
			}
		],
		'hr': {
			// ***
			// ---
			// * * *
			// -----------
			pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
			lookbehind: true,
			alias: 'punctuation'
		},
		'list': {
			// * item
			// + item
			// - item
			// 1. item
			pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
			lookbehind: true,
			alias: 'punctuation'
		},
		'url-reference': {
			// [id]: http://example.com "Optional title"
			// [id]: http://example.com 'Optional title'
			// [id]: http://example.com (Optional title)
			// [id]: <http://example.com> "Optional title"
			pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
			inside: {
				'variable': {
					pattern: /^(!?\[)[^\]]+/,
					lookbehind: true
				},
				'string': /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
				'punctuation': /^[\[\]!:]|[<>]/
			},
			alias: 'url'
		},
		'bold': {
			// **strong**
			// __strong__

			// allow one nested instance of italic text using the same delimiter
			pattern: createInline(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source),
			lookbehind: true,
			greedy: true,
			inside: {
				'content': {
					pattern: /(^..)[\s\S]+(?=..$)/,
					lookbehind: true,
					inside: {} // see below
				},
				'punctuation': /\*\*|__/
			}
		},
		'italic': {
			// *em*
			// _em_

			// allow one nested instance of bold text using the same delimiter
			pattern: createInline(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source),
			lookbehind: true,
			greedy: true,
			inside: {
				'content': {
					pattern: /(^.)[\s\S]+(?=.$)/,
					lookbehind: true,
					inside: {} // see below
				},
				'punctuation': /[*_]/
			}
		},
		'strike': {
			// ~~strike through~~
			// ~strike~
			// eslint-disable-next-line regexp/strict
			pattern: createInline(/(~~?)(?:(?!~)<inner>)+\2/.source),
			lookbehind: true,
			greedy: true,
			inside: {
				'content': {
					pattern: /(^~~?)[\s\S]+(?=\1$)/,
					lookbehind: true,
					inside: {} // see below
				},
				'punctuation': /~~?/
			}
		},
		'code-snippet': {
			// `code`
			// ``code``
			pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
			lookbehind: true,
			greedy: true,
			alias: ['code', 'keyword']
		},
		'url': {
			// [example](http://example.com "Optional title")
			// [example][id]
			// [example] [id]
			pattern: createInline(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source),
			lookbehind: true,
			greedy: true,
			inside: {
				'operator': /^!/,
				'content': {
					pattern: /(^\[)[^\]]+(?=\])/,
					lookbehind: true,
					inside: {} // see below
				},
				'variable': {
					pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
					lookbehind: true
				},
				'url': {
					pattern: /(^\]\()[^\s)]+/,
					lookbehind: true
				},
				'string': {
					pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
					lookbehind: true
				}
			}
		}
	});

	['url', 'bold', 'italic', 'strike'].forEach(function (token) {
		['url', 'bold', 'italic', 'strike', 'code-snippet'].forEach(function (inside) {
			if (token !== inside) {
				Prism.languages.markdown[token].inside.content.inside[inside] = Prism.languages.markdown[inside];
			}
		});
	});

	Prism.hooks.add('after-tokenize', function (env) {
		if (env.language !== 'markdown' && env.language !== 'md') {
			return;
		}

		function walkTokens(tokens) {
			if (!tokens || typeof tokens === 'string') {
				return;
			}

			for (var i = 0, l = tokens.length; i < l; i++) {
				var token = tokens[i];

				if (token.type !== 'code') {
					walkTokens(token.content);
					continue;
				}

				/*
				 * Add the correct `language-xxxx` class to this code block. Keep in mind that the `code-language` token
				 * is optional. But the grammar is defined so that there is only one case we have to handle:
				 *
				 * token.content = [
				 *     <span class="punctuation">```</span>,
				 *     <span class="code-language">xxxx</span>,
				 *     '\n', // exactly one new lines (\r or \n or \r\n)
				 *     <span class="code-block">...</span>,
				 *     '\n', // exactly one new lines again
				 *     <span class="punctuation">```</span>
				 * ];
				 */

				var codeLang = token.content[1];
				var codeBlock = token.content[3];

				if (codeLang && codeBlock &&
					codeLang.type === 'code-language' && codeBlock.type === 'code-block' &&
					typeof codeLang.content === 'string') {

					// this might be a language that Prism does not support

					// do some replacements to support C++, C#, and F#
					var lang = codeLang.content.replace(/\b#/g, 'sharp').replace(/\b\+\+/g, 'pp');
					// only use the first word
					lang = (/[a-z][\w-]*/i.exec(lang) || [''])[0].toLowerCase();
					var alias = 'language-' + lang;

					// add alias
					if (!codeBlock.alias) {
						codeBlock.alias = [alias];
					} else if (typeof codeBlock.alias === 'string') {
						codeBlock.alias = [codeBlock.alias, alias];
					} else {
						codeBlock.alias.push(alias);
					}
				}
			}
		}

		walkTokens(env.tokens);
	});

	Prism.hooks.add('wrap', function (env) {
		if (env.type !== 'code-block') {
			return;
		}

		var codeLang = '';
		for (var i = 0, l = env.classes.length; i < l; i++) {
			var cls = env.classes[i];
			var match = /language-(.+)/.exec(cls);
			if (match) {
				codeLang = match[1];
				break;
			}
		}

		var grammar = Prism.languages[codeLang];

		if (!grammar) {
			if (codeLang && codeLang !== 'none' && Prism.plugins.autoloader) {
				var id = 'md-' + new Date().valueOf() + '-' + Math.floor(Math.random() * 1e16);
				env.attributes['id'] = id;

				Prism.plugins.autoloader.loadLanguages(codeLang, function () {
					var ele = document.getElementById(id);
					if (ele) {
						ele.innerHTML = Prism.highlight(ele.textContent, Prism.languages[codeLang], codeLang);
					}
				});
			}
		} else {
			env.content = Prism.highlight(textContent(env.content), grammar, codeLang);
		}
	});

	var tagPattern = RegExp(Prism.languages.markup.tag.pattern.source, 'gi');

	/**
	 * A list of known entity names.
	 *
	 * This will always be incomplete to save space. The current list is the one used by lowdash's unescape function.
	 *
	 * @see {@link https://github.com/lodash/lodash/blob/2da024c3b4f9947a48517639de7560457cd4ec6c/unescape.js#L2}
	 */
	var KNOWN_ENTITY_NAMES = {
		'amp': '&',
		'lt': '<',
		'gt': '>',
		'quot': '"',
	};

	// IE 11 doesn't support `String.fromCodePoint`
	var fromCodePoint = String.fromCodePoint || String.fromCharCode;

	/**
	 * Returns the text content of a given HTML source code string.
	 *
	 * @param {string} html
	 * @returns {string}
	 */
	function textContent(html) {
		// remove all tags
		var text = html.replace(tagPattern, '');

		// decode known entities
		text = text.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function (m, code) {
			code = code.toLowerCase();

			if (code[0] === '#') {
				var value;
				if (code[1] === 'x') {
					value = parseInt(code.slice(2), 16);
				} else {
					value = Number(code.slice(1));
				}

				return fromCodePoint(value);
			} else {
				var known = KNOWN_ENTITY_NAMES[code];
				if (known) {
					return known;
				}

				// unable to decode
				return m;
			}
		});

		return text;
	}

	Prism.languages.md = Prism.languages.markdown;

}(Prism));

Prism.languages.c = Prism.languages.extend('clike', {
	'comment': {
		pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
		greedy: true
	},
	'string': {
		// https://en.cppreference.com/w/c/language/string_literal
		pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
		greedy: true
	},
	'class-name': {
		pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
		lookbehind: true
	},
	'keyword': /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/,
	'function': /\b[a-z_]\w*(?=\s*\()/i,
	'number': /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
	'operator': />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
});

Prism.languages.insertBefore('c', 'string', {
	'char': {
		// https://en.cppreference.com/w/c/language/character_constant
		pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/,
		greedy: true
	}
});

Prism.languages.insertBefore('c', 'string', {
	'macro': {
		// allow for multiline macro definitions
		// spaces after the # character compile fine with gcc
		pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
		lookbehind: true,
		greedy: true,
		alias: 'property',
		inside: {
			'string': [
				{
					// highlight the path of the include statement as a string
					pattern: /^(#\s*include\s*)<[^>]+>/,
					lookbehind: true
				},
				Prism.languages.c['string']
			],
			'char': Prism.languages.c['char'],
			'comment': Prism.languages.c['comment'],
			'macro-name': [
				{
					pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
					lookbehind: true
				},
				{
					pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
					lookbehind: true,
					alias: 'function'
				}
			],
			// highlight macro directives as keywords
			'directive': {
				pattern: /^(#\s*)[a-z]+/,
				lookbehind: true,
				alias: 'keyword'
			},
			'directive-hash': /^#/,
			'punctuation': /##|\\(?=[\r\n])/,
			'expression': {
				pattern: /\S[\s\S]*/,
				inside: Prism.languages.c
			}
		}
	}
});

Prism.languages.insertBefore('c', 'function', {
	// highlight predefined macros as constants
	'constant': /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/
});

delete Prism.languages.c['boolean'];

(function (Prism) {

	var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;

	Prism.languages.css = {
		'comment': /\/\*[\s\S]*?\*\//,
		'atrule': {
			pattern: /@[\w-](?:[^;{\s]|\s+(?![\s{]))*(?:;|(?=\s*\{))/,
			inside: {
				'rule': /^@[\w-]+/,
				'selector-function-argument': {
					pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
					lookbehind: true,
					alias: 'selector'
				},
				'keyword': {
					pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
					lookbehind: true
				}
				// See rest below
			}
		},
		'url': {
			// https://drafts.csswg.org/css-values-3/#urls
			pattern: RegExp('\\burl\\((?:' + string.source + '|' + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ')\\)', 'i'),
			greedy: true,
			inside: {
				'function': /^url/i,
				'punctuation': /^\(|\)$/,
				'string': {
					pattern: RegExp('^' + string.source + '$'),
					alias: 'url'
				}
			}
		},
		'selector': {
			pattern: RegExp('(^|[{}\\s])[^{}\\s](?:[^{};"\'\\s]|\\s+(?![\\s{])|' + string.source + ')*(?=\\s*\\{)'),
			lookbehind: true
		},
		'string': {
			pattern: string,
			greedy: true
		},
		'property': {
			pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
			lookbehind: true
		},
		'important': /!important\b/i,
		'function': {
			pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
			lookbehind: true
		},
		'punctuation': /[(){};:,]/
	};

	Prism.languages.css['atrule'].inside.rest = Prism.languages.css;

	var markup = Prism.languages.markup;
	if (markup) {
		markup.tag.addInlined('style', 'css');
		markup.tag.addAttribute('style', 'css');
	}

}(Prism));

Prism.languages.objectivec = Prism.languages.extend('c', {
	'string': {
		pattern: /@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
		greedy: true
	},
	'keyword': /\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/,
	'operator': /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/
});

delete Prism.languages.objectivec['class-name'];

Prism.languages.objc = Prism.languages.objectivec;

Prism.languages.sql = {
	'comment': {
		pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
		lookbehind: true
	},
	'variable': [
		{
			pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
			greedy: true
		},
		/@[\w.$]+/
	],
	'string': {
		pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,
		greedy: true,
		lookbehind: true
	},
	'identifier': {
		pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/,
		greedy: true,
		lookbehind: true,
		inside: {
			'punctuation': /^`|`$/
		}
	},
	'function': /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i, // Should we highlight user defined functions too?
	'keyword': /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
	'boolean': /\b(?:FALSE|NULL|TRUE)\b/i,
	'number': /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
	'operator': /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
	'punctuation': /[;[\]()`,.]/
};

Prism.languages.python = {
	'comment': {
		pattern: /(^|[^\\])#.*/,
		lookbehind: true,
		greedy: true
	},
	'string-interpolation': {
		pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
		greedy: true,
		inside: {
			'interpolation': {
				// "{" <expression> <optional "!s", "!r", or "!a"> <optional ":" format specifier> "}"
				pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
				lookbehind: true,
				inside: {
					'format-spec': {
						pattern: /(:)[^:(){}]+(?=\}$)/,
						lookbehind: true
					},
					'conversion-option': {
						pattern: /![sra](?=[:}]$)/,
						alias: 'punctuation'
					},
					rest: null
				}
			},
			'string': /[\s\S]+/
		}
	},
	'triple-quoted-string': {
		pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
		greedy: true,
		alias: 'string'
	},
	'string': {
		pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
		greedy: true
	},
	'function': {
		pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
		lookbehind: true
	},
	'class-name': {
		pattern: /(\bclass\s+)\w+/i,
		lookbehind: true
	},
	'decorator': {
		pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
		lookbehind: true,
		alias: ['annotation', 'punctuation'],
		inside: {
			'punctuation': /\./
		}
	},
	'keyword': /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
	'builtin': /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
	'boolean': /\b(?:False|None|True)\b/,
	'number': /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
	'operator': /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
	'punctuation': /[{}[\];(),.:]/
};

Prism.languages.python['string-interpolation'].inside['interpolation'].inside.rest = Prism.languages.python;

Prism.languages.py = Prism.languages.python;

(function (Prism) {

	var multilineComment = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source;
	for (var i = 0; i < 2; i++) {
		// support 4 levels of nested comments
		multilineComment = multilineComment.replace(/<self>/g, function () { return multilineComment; });
	}
	multilineComment = multilineComment.replace(/<self>/g, function () { return /[^\s\S]/.source; });


	Prism.languages.rust = {
		'comment': [
			{
				pattern: RegExp(/(^|[^\\])/.source + multilineComment),
				lookbehind: true,
				greedy: true
			},
			{
				pattern: /(^|[^\\:])\/\/.*/,
				lookbehind: true,
				greedy: true
			}
		],
		'string': {
			pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,
			greedy: true
		},
		'char': {
			pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,
			greedy: true
		},
		'attribute': {
			pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,
			greedy: true,
			alias: 'attr-name',
			inside: {
				'string': null // see below
			}
		},

		// Closure params should not be confused with bitwise OR |
		'closure-params': {
			pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,
			lookbehind: true,
			greedy: true,
			inside: {
				'closure-punctuation': {
					pattern: /^\||\|$/,
					alias: 'punctuation'
				},
				rest: null // see below
			}
		},

		'lifetime-annotation': {
			pattern: /'\w+/,
			alias: 'symbol'
		},

		'fragment-specifier': {
			pattern: /(\$\w+:)[a-z]+/,
			lookbehind: true,
			alias: 'punctuation'
		},
		'variable': /\$\w+/,

		'function-definition': {
			pattern: /(\bfn\s+)\w+/,
			lookbehind: true,
			alias: 'function'
		},
		'type-definition': {
			pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/,
			lookbehind: true,
			alias: 'class-name'
		},
		'module-declaration': [
			{
				pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,
				lookbehind: true,
				alias: 'namespace'
			},
			{
				pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,
				lookbehind: true,
				alias: 'namespace',
				inside: {
					'punctuation': /::/
				}
			}
		],
		'keyword': [
			// https://github.com/rust-lang/reference/blob/master/src/keywords.md
			/\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,
			// primitives and str
			// https://doc.rust-lang.org/stable/rust-by-example/primitives.html
			/\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/
		],

		// functions can technically start with an upper-case letter, but this will introduce a lot of false positives
		// and Rust's naming conventions recommend snake_case anyway.
		// https://doc.rust-lang.org/1.0.0/style/style/naming/README.html
		'function': /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,
		'macro': {
			pattern: /\b\w+!/,
			alias: 'property'
		},
		'constant': /\b[A-Z_][A-Z_\d]+\b/,
		'class-name': /\b[A-Z]\w*\b/,

		'namespace': {
			pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,
			inside: {
				'punctuation': /::/
			}
		},

		// Hex, oct, bin, dec numbers with visual separators and type suffix
		'number': /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,
		'boolean': /\b(?:false|true)\b/,
		'punctuation': /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,
		'operator': /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/
	};

	Prism.languages.rust['closure-params'].inside.rest = Prism.languages.rust;
	Prism.languages.rust['attribute'].inside['string'] = Prism.languages.rust['string'];

}(Prism));

Prism.languages.swift = {
	'comment': {
		// Nested comments are supported up to 2 levels
		pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/,
		lookbehind: true,
		greedy: true
	},
	'string-literal': [
		// https://docs.swift.org/swift-book/LanguageGuide/StringsAndCharacters.html
		{
			pattern: RegExp(
				/(^|[^"#])/.source
				+ '(?:'
				// single-line string
				+ /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source
				+ '|'
				// multi-line string
				+ /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source
				+ ')'
				+ /(?!["#])/.source
			),
			lookbehind: true,
			greedy: true,
			inside: {
				'interpolation': {
					pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/,
					lookbehind: true,
					inside: null // see below
				},
				'interpolation-punctuation': {
					pattern: /^\)|\\\($/,
					alias: 'punctuation'
				},
				'punctuation': /\\(?=[\r\n])/,
				'string': /[\s\S]+/
			}
		},
		{
			pattern: RegExp(
				/(^|[^"#])(#+)/.source
				+ '(?:'
				// single-line string
				+ /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source
				+ '|'
				// multi-line string
				+ /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source
				+ ')'
				+ '\\2'
			),
			lookbehind: true,
			greedy: true,
			inside: {
				'interpolation': {
					pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/,
					lookbehind: true,
					inside: null // see below
				},
				'interpolation-punctuation': {
					pattern: /^\)|\\#+\($/,
					alias: 'punctuation'
				},
				'string': /[\s\S]+/
			}
		},
	],

	'directive': {
		// directives with conditions
		pattern: RegExp(
			/#/.source
			+ '(?:'
			+ (
				/(?:elseif|if)\b/.source
				+ '(?:[ \t]*'
				// This regex is a little complex. It's equivalent to this:
				//   (?:![ \t]*)?(?:\b\w+\b(?:[ \t]*<round>)?|<round>)(?:[ \t]*(?:&&|\|\|))?
				// where <round> is a general parentheses expression.
				+ /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source
				+ ')+'
			)
			+ '|'
			+ /(?:else|endif)\b/.source
			+ ')'
		),
		alias: 'property',
		inside: {
			'directive-name': /^#\w+/,
			'boolean': /\b(?:false|true)\b/,
			'number': /\b\d+(?:\.\d+)*\b/,
			'operator': /!|&&|\|\||[<>]=?/,
			'punctuation': /[(),]/
		}
	},
	'literal': {
		pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/,
		alias: 'constant'
	},
	'other-directive': {
		pattern: /#\w+\b/,
		alias: 'property'
	},

	'attribute': {
		pattern: /@\w+/,
		alias: 'atrule'
	},

	'function-definition': {
		pattern: /(\bfunc\s+)\w+/,
		lookbehind: true,
		alias: 'function'
	},
	'label': {
		// https://docs.swift.org/swift-book/LanguageGuide/ControlFlow.html#ID141
		pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/,
		lookbehind: true,
		alias: 'important'
	},

	'keyword': /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/,
	'boolean': /\b(?:false|true)\b/,
	'nil': {
		pattern: /\bnil\b/,
		alias: 'constant'
	},

	'short-argument': /\$\d+\b/,
	'omit': {
		pattern: /\b_\b/,
		alias: 'keyword'
	},
	'number': /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,

	// A class name must start with an upper-case letter and be either 1 letter long or contain a lower-case letter.
	'class-name': /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/,
	'function': /\b[a-z_]\w*(?=\s*\()/i,
	'constant': /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,

	// Operators are generic in Swift. Developers can even create new operators (e.g. +++).
	// https://docs.swift.org/swift-book/ReferenceManual/zzSummaryOfTheGrammar.html#ID481
	// This regex only supports ASCII operators.
	'operator': /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/,
	'punctuation': /[{}[\]();,.:\\]/
};

Prism.languages.swift['string-literal'].forEach(function (rule) {
	rule.inside['interpolation'].inside = Prism.languages.swift;
});

(function (Prism) {

	Prism.languages.typescript = Prism.languages.extend('javascript', {
		'class-name': {
			pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
			lookbehind: true,
			greedy: true,
			inside: null // see below
		},
		'builtin': /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/,
	});

	// The keywords TypeScript adds to JavaScript
	Prism.languages.typescript.keyword.push(
		/\b(?:abstract|declare|is|keyof|readonly|require)\b/,
		// keywords that have to be followed by an identifier
		/\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/,
		// This is for `import type *, {}`
		/\btype\b(?=\s*(?:[\{*]|$))/
	);

	// doesn't work with TS because TS is too complex
	delete Prism.languages.typescript['parameter'];
	delete Prism.languages.typescript['literal-property'];

	// a version of typescript specifically for highlighting types
	var typeInside = Prism.languages.extend('typescript', {});
	delete typeInside['class-name'];

	Prism.languages.typescript['class-name'].inside = typeInside;

	Prism.languages.insertBefore('typescript', 'function', {
		'decorator': {
			pattern: /@[$\w\xA0-\uFFFF]+/,
			inside: {
				'at': {
					pattern: /^@/,
					alias: 'operator'
				},
				'function': /^[\s\S]+/
			}
		},
		'generic-function': {
			// e.g. foo<T extends "bar" | "baz">( ...
			pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
			greedy: true,
			inside: {
				'function': /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
				'generic': {
					pattern: /<[\s\S]+/, // everything after the first <
					alias: 'class-name',
					inside: typeInside
				}
			}
		}
	});

	Prism.languages.ts = Prism.languages.typescript;

}(Prism));

(function (Prism) {

	var keywords = /\b(?:abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|exports|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|module|native|new|non-sealed|null|open|opens|package|permits|private|protected|provides|public|record(?!\s*[(){}[\]<>=%~.:,;?+\-*/&|^])|requires|return|sealed|short|static|strictfp|super|switch|synchronized|this|throw|throws|to|transient|transitive|try|uses|var|void|volatile|while|with|yield)\b/;

	// full package (optional) + parent classes (optional)
	var classNamePrefix = /(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source;

	// based on the java naming conventions
	var className = {
		pattern: RegExp(/(^|[^\w.])/.source + classNamePrefix + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
		lookbehind: true,
		inside: {
			'namespace': {
				pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
				inside: {
					'punctuation': /\./
				}
			},
			'punctuation': /\./
		}
	};

	Prism.languages.java = Prism.languages.extend('clike', {
		'string': {
			pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"/,
			lookbehind: true,
			greedy: true
		},
		'class-name': [
			className,
			{
				// variables, parameters, and constructor references
				// this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
				pattern: RegExp(/(^|[^\w.])/.source + classNamePrefix + /[A-Z]\w*(?=\s+\w+\s*[;,=()]|\s*(?:\[[\s,]*\]\s*)?::\s*new\b)/.source),
				lookbehind: true,
				inside: className.inside
			},
			{
				// class names based on keyword
				// this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
				pattern: RegExp(/(\b(?:class|enum|extends|implements|instanceof|interface|new|record|throws)\s+)/.source + classNamePrefix + /[A-Z]\w*\b/.source),
				lookbehind: true,
				inside: className.inside
			}
		],
		'keyword': keywords,
		'function': [
			Prism.languages.clike.function,
			{
				pattern: /(::\s*)[a-z_]\w*/,
				lookbehind: true
			}
		],
		'number': /\b0b[01][01_]*L?\b|\b0x(?:\.[\da-f_p+-]+|[\da-f_]+(?:\.[\da-f_p+-]+)?)\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i,
		'operator': {
			pattern: /(^|[^.])(?:<<=?|>>>?=?|->|--|\+\+|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?)/m,
			lookbehind: true
		}
	});

	Prism.languages.insertBefore('java', 'string', {
		'triple-quoted-string': {
			// http://openjdk.java.net/jeps/355#Description
			pattern: /"""[ \t]*[\r\n](?:(?:"|"")?(?:\\.|[^"\\]))*"""/,
			greedy: true,
			alias: 'string'
		},
		'char': {
			pattern: /'(?:\\.|[^'\\\r\n]){1,6}'/,
			greedy: true
		}
	});

	Prism.languages.insertBefore('java', 'class-name', {
		'annotation': {
			pattern: /(^|[^.])@\w+(?:\s*\.\s*\w+)*/,
			lookbehind: true,
			alias: 'punctuation'
		},
		'generics': {
			pattern: /<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&))*>)*>)*>)*>/,
			inside: {
				'class-name': className,
				'keyword': keywords,
				'punctuation': /[<>(),.:]/,
				'operator': /[?&|]/
			}
		},
		'import': [
			{
				pattern: RegExp(/(\bimport\s+)/.source + classNamePrefix + /(?:[A-Z]\w*|\*)(?=\s*;)/.source),
				lookbehind: true,
				inside: {
					'namespace': className.inside.namespace,
					'punctuation': /\./,
					'operator': /\*/,
					'class-name': /\w+/
				}
			},
			{
				pattern: RegExp(/(\bimport\s+static\s+)/.source + classNamePrefix + /(?:\w+|\*)(?=\s*;)/.source),
				lookbehind: true,
				alias: 'static',
				inside: {
					'namespace': className.inside.namespace,
					'static': /\b\w+$/,
					'punctuation': /\./,
					'operator': /\*/,
					'class-name': /\w+/
				}
			}
		],
		'namespace': {
			pattern: RegExp(
				/(\b(?:exports|import(?:\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\s+)(?!<keyword>)[a-z]\w*(?:\.[a-z]\w*)*\.?/
					.source.replace(/<keyword>/g, function () { return keywords.source; })),
			lookbehind: true,
			inside: {
				'punctuation': /\./,
			}
		}
	});
}(Prism));

(function (Prism) {

	var keyword = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/;
	var modName = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g, function () { return keyword.source; });

	Prism.languages.cpp = Prism.languages.extend('c', {
		'class-name': [
			{
				pattern: RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source
					.replace(/<keyword>/g, function () { return keyword.source; })),
				lookbehind: true
			},
			// This is intended to capture the class name of method implementations like:
			//   void foo::bar() const {}
			// However! The `foo` in the above example could also be a namespace, so we only capture the class name if
			// it starts with an uppercase letter. This approximation should give decent results.
			/\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/,
			// This will capture the class name before destructors like:
			//   Foo::~Foo() {}
			/\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i,
			// This also intends to capture the class name of method implementations but here the class has template
			// parameters, so it can't be a namespace (until C++ adds generic namespaces).
			/\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/
		],
		'keyword': keyword,
		'number': {
			pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i,
			greedy: true
		},
		'operator': />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,
		'boolean': /\b(?:false|true)\b/
	});

	Prism.languages.insertBefore('cpp', 'string', {
		'module': {
			// https://en.cppreference.com/w/cpp/language/modules
			pattern: RegExp(
				/(\b(?:import|module)\s+)/.source +
				'(?:' +
				// header-name
				/"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source +
				'|' +
				// module name or partition or both
				/<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g, function () { return modName; }) +
				')'
			),
			lookbehind: true,
			greedy: true,
			inside: {
				'string': /^[<"][\s\S]+/,
				'operator': /:/,
				'punctuation': /\./
			}
		},
		'raw-string': {
			pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,
			alias: 'string',
			greedy: true
		}
	});

	Prism.languages.insertBefore('cpp', 'keyword', {
		'generic-function': {
			pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i,
			inside: {
				'function': /^\w+/,
				'generic': {
					pattern: /<[\s\S]+/,
					alias: 'class-name',
					inside: Prism.languages.cpp
				}
			}
		}
	});

	Prism.languages.insertBefore('cpp', 'operator', {
		'double-colon': {
			pattern: /::/,
			alias: 'punctuation'
		}
	});

	Prism.languages.insertBefore('cpp', 'class-name', {
		// the base clause is an optional list of parent classes
		// https://en.cppreference.com/w/cpp/language/class
		'base-clause': {
			pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/,
			lookbehind: true,
			greedy: true,
			inside: Prism.languages.extend('cpp', {})
		}
	});

	Prism.languages.insertBefore('inside', 'double-colon', {
		// All untokenized words that are not namespaces should be class names
		'class-name': /\b[a-z_]\w*\b(?!\s*::)/i
	}, Prism.languages.cpp['base-clause']);

}(Prism));

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
function createCommand$1(type) {
  return {
    type
  } ;
}
const SELECTION_CHANGE_COMMAND$1 = createCommand$1('SELECTION_CHANGE_COMMAND');
const CLICK_COMMAND$1 = createCommand$1('CLICK_COMMAND');
const DELETE_CHARACTER_COMMAND$1 = createCommand$1('DELETE_CHARACTER_COMMAND');
const INSERT_LINE_BREAK_COMMAND$1 = createCommand$1('INSERT_LINE_BREAK_COMMAND');
const INSERT_PARAGRAPH_COMMAND$1 = createCommand$1('INSERT_PARAGRAPH_COMMAND');
const CONTROLLED_TEXT_INSERTION_COMMAND$1 = createCommand$1('CONTROLLED_TEXT_INSERTION_COMMAND');
const PASTE_COMMAND$1 = createCommand$1('PASTE_COMMAND');
const REMOVE_TEXT_COMMAND$1 = createCommand$1('REMOVE_TEXT_COMMAND');
const DELETE_WORD_COMMAND$1 = createCommand$1('DELETE_WORD_COMMAND');
const DELETE_LINE_COMMAND$1 = createCommand$1('DELETE_LINE_COMMAND');
const FORMAT_TEXT_COMMAND$1 = createCommand$1('FORMAT_TEXT_COMMAND');
const UNDO_COMMAND$1 = createCommand$1('UNDO_COMMAND');
const REDO_COMMAND$1 = createCommand$1('REDO_COMMAND');
const KEY_DOWN_COMMAND$1 = createCommand$1('KEYDOWN_COMMAND');
const KEY_ARROW_RIGHT_COMMAND$1 = createCommand$1('KEY_ARROW_RIGHT_COMMAND');
const MOVE_TO_END$1 = createCommand$1('MOVE_TO_END');
const KEY_ARROW_LEFT_COMMAND$1 = createCommand$1('KEY_ARROW_LEFT_COMMAND');
const MOVE_TO_START$1 = createCommand$1('MOVE_TO_START');
const KEY_ARROW_UP_COMMAND$1 = createCommand$1('KEY_ARROW_UP_COMMAND');
const KEY_ARROW_DOWN_COMMAND$1 = createCommand$1('KEY_ARROW_DOWN_COMMAND');
const KEY_ENTER_COMMAND$1 = createCommand$1('KEY_ENTER_COMMAND');
const KEY_SPACE_COMMAND$1 = createCommand$1('KEY_SPACE_COMMAND');
const KEY_BACKSPACE_COMMAND$1 = createCommand$1('KEY_BACKSPACE_COMMAND');
const KEY_ESCAPE_COMMAND$1 = createCommand$1('KEY_ESCAPE_COMMAND');
const KEY_DELETE_COMMAND$1 = createCommand$1('KEY_DELETE_COMMAND');
const KEY_TAB_COMMAND$1 = createCommand$1('KEY_TAB_COMMAND');
const INDENT_CONTENT_COMMAND$1 = createCommand$1('INDENT_CONTENT_COMMAND');
const OUTDENT_CONTENT_COMMAND$1 = createCommand$1('OUTDENT_CONTENT_COMMAND');
const DROP_COMMAND$1 = createCommand$1('DROP_COMMAND');
const FORMAT_ELEMENT_COMMAND$1 = createCommand$1('FORMAT_ELEMENT_COMMAND');
const DRAGSTART_COMMAND$1 = createCommand$1('DRAGSTART_COMMAND');
const DRAGOVER_COMMAND$1 = createCommand$1('DRAGOVER_COMMAND');
const DRAGEND_COMMAND$1 = createCommand$1('DRAGEND_COMMAND');
const COPY_COMMAND$1 = createCommand$1('COPY_COMMAND');
const CUT_COMMAND$1 = createCommand$1('CUT_COMMAND');
const CLEAR_EDITOR_COMMAND$1 = createCommand$1('CLEAR_EDITOR_COMMAND');
const CLEAR_HISTORY_COMMAND$1 = createCommand$1('CLEAR_HISTORY_COMMAND');
const CAN_REDO_COMMAND$1 = createCommand$1('CAN_REDO_COMMAND');
const CAN_UNDO_COMMAND$1 = createCommand$1('CAN_UNDO_COMMAND');
const FOCUS_COMMAND$1 = createCommand$1('FOCUS_COMMAND');
const BLUR_COMMAND$1 = createCommand$1('BLUR_COMMAND');
const KEY_MODIFIER_COMMAND$1 = createCommand$1('KEY_MODIFIER_COMMAND');

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const CAN_USE_DOM$7 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const documentMode$2 = CAN_USE_DOM$7 && 'documentMode' in document ? document.documentMode : null;
const IS_APPLE = CAN_USE_DOM$7 && /Mac|iPod|iPhone|iPad/.test(navigator.platform);
const IS_FIREFOX = CAN_USE_DOM$7 && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent);
const CAN_USE_BEFORE_INPUT$1 = CAN_USE_DOM$7 && 'InputEvent' in window && !documentMode$2 ? 'getTargetRanges' in new window.InputEvent('input') : false;
const IS_SAFARI$2 = CAN_USE_DOM$7 && /Version\/[\d.]+.*Safari/.test(navigator.userAgent);
const IS_IOS$2 = CAN_USE_DOM$7 && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream; // Keep these in case we need to use them in the future.
// export const IS_WINDOWS: boolean = CAN_USE_DOM && /Win/.test(navigator.platform);

const IS_CHROME$2 = CAN_USE_DOM$7 && /^(?=.*Chrome).*/i.test(navigator.userAgent); // export const canUseTextInputEvent: boolean = CAN_USE_DOM && 'TextEvent' in window && !documentMode;

const IS_APPLE_WEBKIT$2 = CAN_USE_DOM$7 && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !IS_CHROME$2;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

const DOM_ELEMENT_TYPE = 1;
const DOM_TEXT_TYPE = 3; // Reconciling

const NO_DIRTY_NODES = 0;
const HAS_DIRTY_NODES = 1;
const FULL_RECONCILE = 2; // Text node modes

const IS_NORMAL = 0;
const IS_TOKEN = 1;
const IS_SEGMENTED = 2; // IS_INERT = 3
// Text node formatting

const IS_BOLD = 1;
const IS_ITALIC = 1 << 1;
const IS_STRIKETHROUGH = 1 << 2;
const IS_UNDERLINE = 1 << 3;
const IS_CODE = 1 << 4;
const IS_SUBSCRIPT = 1 << 5;
const IS_SUPERSCRIPT = 1 << 6;
const IS_HIGHLIGHT = 1 << 7;
const IS_ALL_FORMATTING = IS_BOLD | IS_ITALIC | IS_STRIKETHROUGH | IS_UNDERLINE | IS_CODE | IS_SUBSCRIPT | IS_SUPERSCRIPT | IS_HIGHLIGHT; // Text node details

const IS_DIRECTIONLESS = 1;
const IS_UNMERGEABLE = 1 << 1; // Element node formatting

const IS_ALIGN_LEFT = 1;
const IS_ALIGN_CENTER = 2;
const IS_ALIGN_RIGHT = 3;
const IS_ALIGN_JUSTIFY = 4;
const IS_ALIGN_START = 5;
const IS_ALIGN_END = 6; // Reconciliation

const NON_BREAKING_SPACE = '\u00A0';
const ZERO_WIDTH_SPACE = '\u200b'; // For iOS/Safari we use a non breaking space, otherwise the cursor appears
// overlapping the composed text.

const COMPOSITION_SUFFIX = IS_SAFARI$2 || IS_IOS$2 || IS_APPLE_WEBKIT$2 ? NON_BREAKING_SPACE : ZERO_WIDTH_SPACE;
const DOUBLE_LINE_BREAK = '\n\n'; // For FF, we need to use a non-breaking space, or it gets composition
// in a stuck state.

const COMPOSITION_START_CHAR = IS_FIREFOX ? NON_BREAKING_SPACE : COMPOSITION_SUFFIX;
const RTL = '\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC';
const LTR = 'A-Za-z\u00C0-\u00D6\u00D8-\u00F6' + '\u00F8-\u02B8\u0300-\u0590\u0800-\u1FFF\u200E\u2C00-\uFB1C' + '\uFE00-\uFE6F\uFEFD-\uFFFF'; // eslint-disable-next-line no-misleading-character-class

const RTL_REGEX = new RegExp('^[^' + LTR + ']*[' + RTL + ']'); // eslint-disable-next-line no-misleading-character-class

const LTR_REGEX = new RegExp('^[^' + RTL + ']*[' + LTR + ']');
const TEXT_TYPE_TO_FORMAT = {
  bold: IS_BOLD,
  code: IS_CODE,
  highlight: IS_HIGHLIGHT,
  italic: IS_ITALIC,
  strikethrough: IS_STRIKETHROUGH,
  subscript: IS_SUBSCRIPT,
  superscript: IS_SUPERSCRIPT,
  underline: IS_UNDERLINE
};
const DETAIL_TYPE_TO_DETAIL = {
  directionless: IS_DIRECTIONLESS,
  unmergeable: IS_UNMERGEABLE
};
const ELEMENT_TYPE_TO_FORMAT = {
  center: IS_ALIGN_CENTER,
  end: IS_ALIGN_END,
  justify: IS_ALIGN_JUSTIFY,
  left: IS_ALIGN_LEFT,
  right: IS_ALIGN_RIGHT,
  start: IS_ALIGN_START
};
const ELEMENT_FORMAT_TO_TYPE = {
  [IS_ALIGN_CENTER]: 'center',
  [IS_ALIGN_END]: 'end',
  [IS_ALIGN_JUSTIFY]: 'justify',
  [IS_ALIGN_LEFT]: 'left',
  [IS_ALIGN_RIGHT]: 'right',
  [IS_ALIGN_START]: 'start'
};
const TEXT_MODE_TO_TYPE = {
  normal: IS_NORMAL,
  segmented: IS_SEGMENTED,
  token: IS_TOKEN
};
const TEXT_TYPE_TO_MODE = {
  [IS_NORMAL]: 'normal',
  [IS_SEGMENTED]: 'segmented',
  [IS_TOKEN]: 'token'
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

const TEXT_MUTATION_VARIANCE = 100;
let isProcessingMutations = false;
let lastTextEntryTimeStamp = 0;
function getIsProcesssingMutations() {
  return isProcessingMutations;
}

function updateTimeStamp(event) {
  lastTextEntryTimeStamp = event.timeStamp;
}

function initTextEntryListener(editor) {
  if (lastTextEntryTimeStamp === 0) {
    getWindow(editor).addEventListener('textInput', updateTimeStamp, true);
  }
}

function isManagedLineBreak(dom, target, editor) {
  return (// @ts-expect-error: internal field
    target.__lexicalLineBreak === dom || // @ts-ignore We intentionally add this to the Node.
    dom[`__lexicalKey_${editor._key}`] !== undefined
  );
}

function getLastSelection(editor) {
  return editor.getEditorState().read(() => {
    const selection = $getSelection$1();
    return selection !== null ? selection.clone() : null;
  });
}

function handleTextMutation(target, node, editor) {
  const domSelection = getDOMSelection(editor._window);
  let anchorOffset = null;
  let focusOffset = null;

  if (domSelection !== null && domSelection.anchorNode === target) {
    anchorOffset = domSelection.anchorOffset;
    focusOffset = domSelection.focusOffset;
  }

  const text = target.nodeValue;

  if (text !== null) {
    $updateTextNodeFromDOMContent(node, text, anchorOffset, focusOffset, false);
  }
}

function shouldUpdateTextNodeFromMutation(selection, targetDOM, targetNode) {
  if ($isRangeSelection$1(selection)) {
    const anchorNode = selection.anchor.getNode();

    if (anchorNode.is(targetNode) && selection.format !== anchorNode.getFormat()) {
      return false;
    }
  }

  return targetDOM.nodeType === DOM_TEXT_TYPE && targetNode.isAttached();
}

function $flushMutations$1(editor, mutations, observer) {
  isProcessingMutations = true;
  const shouldFlushTextMutations = performance.now() - lastTextEntryTimeStamp > TEXT_MUTATION_VARIANCE;

  try {
    updateEditor(editor, () => {
      const selection = $getSelection$1() || getLastSelection(editor);
      const badDOMTargets = new Map();
      const rootElement = editor.getRootElement(); // We use the current editor state, as that reflects what is
      // actually "on screen".

      const currentEditorState = editor._editorState;
      const blockCursorElement = editor._blockCursorElement;
      let shouldRevertSelection = false;
      let possibleTextForFirefoxPaste = '';

      for (let i = 0; i < mutations.length; i++) {
        const mutation = mutations[i];
        const type = mutation.type;
        const targetDOM = mutation.target;
        let targetNode = $getNearestNodeFromDOMNode$1(targetDOM, currentEditorState);

        if (targetNode === null && targetDOM !== rootElement || $isDecoratorNode$1(targetNode)) {
          continue;
        }

        if (type === 'characterData') {
          // Text mutations are deferred and passed to mutation listeners to be
          // processed outside of the Lexical engine.
          if (shouldFlushTextMutations && $isTextNode$1(targetNode) && shouldUpdateTextNodeFromMutation(selection, targetDOM, targetNode)) {
            handleTextMutation( // nodeType === DOM_TEXT_TYPE is a Text DOM node
            targetDOM, targetNode, editor);
          }
        } else if (type === 'childList') {
          shouldRevertSelection = true; // We attempt to "undo" any changes that have occurred outside
          // of Lexical. We want Lexical's editor state to be source of truth.
          // To the user, these will look like no-ops.

          const addedDOMs = mutation.addedNodes;

          for (let s = 0; s < addedDOMs.length; s++) {
            const addedDOM = addedDOMs[s];
            const node = getNodeFromDOMNode(addedDOM);
            const parentDOM = addedDOM.parentNode;

            if (parentDOM != null && addedDOM !== blockCursorElement && node === null && (addedDOM.nodeName !== 'BR' || !isManagedLineBreak(addedDOM, parentDOM, editor))) {
              if (IS_FIREFOX) {
                const possibleText = addedDOM.innerText || addedDOM.nodeValue;

                if (possibleText) {
                  possibleTextForFirefoxPaste += possibleText;
                }
              }

              parentDOM.removeChild(addedDOM);
            }
          }

          const removedDOMs = mutation.removedNodes;
          const removedDOMsLength = removedDOMs.length;

          if (removedDOMsLength > 0) {
            let unremovedBRs = 0;

            for (let s = 0; s < removedDOMsLength; s++) {
              const removedDOM = removedDOMs[s];

              if (removedDOM.nodeName === 'BR' && isManagedLineBreak(removedDOM, targetDOM, editor) || blockCursorElement === removedDOM) {
                targetDOM.appendChild(removedDOM);
                unremovedBRs++;
              }
            }

            if (removedDOMsLength !== unremovedBRs) {
              if (targetDOM === rootElement) {
                targetNode = internalGetRoot(currentEditorState);
              }

              badDOMTargets.set(targetDOM, targetNode);
            }
          }
        }
      } // Now we process each of the unique target nodes, attempting
      // to restore their contents back to the source of truth, which
      // is Lexical's "current" editor state. This is basically like
      // an internal revert on the DOM.


      if (badDOMTargets.size > 0) {
        for (const [targetDOM, targetNode] of badDOMTargets) {
          if ($isElementNode$1(targetNode)) {
            const childKeys = targetNode.getChildrenKeys();
            let currentDOM = targetDOM.firstChild;

            for (let s = 0; s < childKeys.length; s++) {
              const key = childKeys[s];
              const correctDOM = editor.getElementByKey(key);

              if (correctDOM === null) {
                continue;
              }

              if (currentDOM == null) {
                targetDOM.appendChild(correctDOM);
                currentDOM = correctDOM;
              } else if (currentDOM !== correctDOM) {
                targetDOM.replaceChild(correctDOM, currentDOM);
              }

              currentDOM = currentDOM.nextSibling;
            }
          } else if ($isTextNode$1(targetNode)) {
            targetNode.markDirty();
          }
        }
      } // Capture all the mutations made during this function. This
      // also prevents us having to process them on the next cycle
      // of onMutation, as these mutations were made by us.


      const records = observer.takeRecords(); // Check for any random auto-added <br> elements, and remove them.
      // These get added by the browser when we undo the above mutations
      // and this can lead to a broken UI.

      if (records.length > 0) {
        for (let i = 0; i < records.length; i++) {
          const record = records[i];
          const addedNodes = record.addedNodes;
          const target = record.target;

          for (let s = 0; s < addedNodes.length; s++) {
            const addedDOM = addedNodes[s];
            const parentDOM = addedDOM.parentNode;

            if (parentDOM != null && addedDOM.nodeName === 'BR' && !isManagedLineBreak(addedDOM, target, editor)) {
              parentDOM.removeChild(addedDOM);
            }
          }
        } // Clear any of those removal mutations


        observer.takeRecords();
      }

      if (selection !== null) {
        if (shouldRevertSelection) {
          selection.dirty = true;
          $setSelection$1(selection);
        }

        if (IS_FIREFOX && isFirefoxClipboardEvents(editor)) {
          selection.insertRawText(possibleTextForFirefoxPaste);
        }
      }
    });
  } finally {
    isProcessingMutations = false;
  }
}
function flushRootMutations(editor) {
  const observer = editor._observer;

  if (observer !== null) {
    const mutations = observer.takeRecords();
    $flushMutations$1(editor, mutations, observer);
  }
}
function initMutationObserver(editor) {
  initTextEntryListener(editor);
  editor._observer = new MutationObserver((mutations, observer) => {
    $flushMutations$1(editor, mutations, observer);
  });
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
let keyCounter = 1;
function generateRandomKey() {
  return '' + keyCounter++;
}
function getRegisteredNodeOrThrow(editor, nodeType) {
  const registeredNode = editor._nodes.get(nodeType);

  if (registeredNode === undefined) {
    {
      throw Error(`registeredNode: Type ${nodeType} not found`);
    }
  }

  return registeredNode;
}
const scheduleMicroTask = typeof queueMicrotask === 'function' ? queueMicrotask : fn => {
  // No window prefix intended (#1400)
  Promise.resolve().then(fn);
};
function $isSelectionCapturedInDecorator(node) {
  return $isDecoratorNode$1($getNearestNodeFromDOMNode$1(node));
}
function isSelectionCapturedInDecoratorInput$1(anchorDOM) {
  const activeElement = document.activeElement;

  if (activeElement === null) {
    return false;
  }

  const nodeName = activeElement.nodeName;
  return $isDecoratorNode$1($getNearestNodeFromDOMNode$1(anchorDOM)) && (nodeName === 'INPUT' || nodeName === 'TEXTAREA' || activeElement.contentEditable === 'true' && // @ts-ignore iternal field
  activeElement.__lexicalEditor == null);
}
function isSelectionWithinEditor$1(editor, anchorDOM, focusDOM) {
  const rootElement = editor.getRootElement();

  try {
    return rootElement !== null && rootElement.contains(anchorDOM) && rootElement.contains(focusDOM) && // Ignore if selection is within nested editor
    anchorDOM !== null && !isSelectionCapturedInDecoratorInput$1(anchorDOM) && getNearestEditorFromDOMNode$1(anchorDOM) === editor;
  } catch (error) {
    return false;
  }
}
function getNearestEditorFromDOMNode$1(node) {
  let currentNode = node;

  while (currentNode != null) {
    // @ts-expect-error: internal field
    const editor = currentNode.__lexicalEditor;

    if (editor != null) {
      return editor;
    }

    currentNode = getParentElement(currentNode);
  }

  return null;
}
function getTextDirection(text) {
  if (RTL_REGEX.test(text)) {
    return 'rtl';
  }

  if (LTR_REGEX.test(text)) {
    return 'ltr';
  }

  return null;
}
function $isTokenOrSegmented(node) {
  return node.isToken() || node.isSegmented();
}

function isDOMNodeLexicalTextNode(node) {
  return node.nodeType === DOM_TEXT_TYPE;
}

function getDOMTextNode$1(element) {
  let node = element;

  while (node != null) {
    if (isDOMNodeLexicalTextNode(node)) {
      return node;
    }

    node = node.firstChild;
  }

  return null;
}
function toggleTextFormatType(format, type, alignWithFormat) {
  const activeFormat = TEXT_TYPE_TO_FORMAT[type];
  const isStateFlagPresent = format & activeFormat;

  if (isStateFlagPresent && (alignWithFormat === null || (alignWithFormat & activeFormat) === 0)) {
    // Remove the state flag.
    return format ^ activeFormat;
  }

  if (alignWithFormat === null || alignWithFormat & activeFormat) {
    // Add the state flag.
    return format | activeFormat;
  }

  return format;
}
function $isLeafNode$1(node) {
  return $isTextNode$1(node) || $isLineBreakNode$1(node) || $isDecoratorNode$1(node);
}
function $setNodeKey(node, existingKey) {
  if (existingKey != null) {
    node.__key = existingKey;
    return;
  }

  errorOnReadOnly();
  errorOnInfiniteTransforms();
  const editor = getActiveEditor();
  const editorState = getActiveEditorState();
  const key = generateRandomKey();

  editorState._nodeMap.set(key, node); // TODO Split this function into leaf/element


  if ($isElementNode$1(node)) {
    editor._dirtyElements.set(key, true);
  } else {
    editor._dirtyLeaves.add(key);
  }

  editor._cloneNotNeeded.add(key);

  editor._dirtyType = HAS_DIRTY_NODES;
  node.__key = key;
}

function internalMarkParentElementsAsDirty(parentKey, nodeMap, dirtyElements) {
  let nextParentKey = parentKey;

  while (nextParentKey !== null) {
    if (dirtyElements.has(nextParentKey)) {
      return;
    }

    const node = nodeMap.get(nextParentKey);

    if (node === undefined) {
      break;
    }

    dirtyElements.set(nextParentKey, false);
    nextParentKey = node.__parent;
  }
}

function removeFromParent(node) {
  const oldParent = node.getParent();

  if (oldParent !== null) {
    const writableNode = node.getWritable();
    const writableParent = oldParent.getWritable();
    const prevSibling = node.getPreviousSibling();
    const nextSibling = node.getNextSibling(); // TODO: this function duplicates a bunch of operations, can be simplified.

    if (prevSibling === null) {
      if (nextSibling !== null) {
        const writableNextSibling = nextSibling.getWritable();
        writableParent.__first = nextSibling.__key;
        writableNextSibling.__prev = null;
      } else {
        writableParent.__first = null;
      }
    } else {
      const writablePrevSibling = prevSibling.getWritable();

      if (nextSibling !== null) {
        const writableNextSibling = nextSibling.getWritable();
        writableNextSibling.__prev = writablePrevSibling.__key;
        writablePrevSibling.__next = writableNextSibling.__key;
      } else {
        writablePrevSibling.__next = null;
      }

      writableNode.__prev = null;
    }

    if (nextSibling === null) {
      if (prevSibling !== null) {
        const writablePrevSibling = prevSibling.getWritable();
        writableParent.__last = prevSibling.__key;
        writablePrevSibling.__next = null;
      } else {
        writableParent.__last = null;
      }
    } else {
      const writableNextSibling = nextSibling.getWritable();

      if (prevSibling !== null) {
        const writablePrevSibling = prevSibling.getWritable();
        writablePrevSibling.__next = writableNextSibling.__key;
        writableNextSibling.__prev = writablePrevSibling.__key;
      } else {
        writableNextSibling.__prev = null;
      }

      writableNode.__next = null;
    }

    writableParent.__size--;
    writableNode.__parent = null;
  }
} // Never use this function directly! It will break
// the cloning heuristic. Instead use node.getWritable().

function internalMarkNodeAsDirty(node) {
  errorOnInfiniteTransforms();
  const latest = node.getLatest();
  const parent = latest.__parent;
  const editorState = getActiveEditorState();
  const editor = getActiveEditor();
  const nodeMap = editorState._nodeMap;
  const dirtyElements = editor._dirtyElements;

  if (parent !== null) {
    internalMarkParentElementsAsDirty(parent, nodeMap, dirtyElements);
  }

  const key = latest.__key;
  editor._dirtyType = HAS_DIRTY_NODES;

  if ($isElementNode$1(node)) {
    dirtyElements.set(key, true);
  } else {
    // TODO split internally MarkNodeAsDirty into two dedicated Element/leave functions
    editor._dirtyLeaves.add(key);
  }
}
function internalMarkSiblingsAsDirty(node) {
  const previousNode = node.getPreviousSibling();
  const nextNode = node.getNextSibling();

  if (previousNode !== null) {
    internalMarkNodeAsDirty(previousNode);
  }

  if (nextNode !== null) {
    internalMarkNodeAsDirty(nextNode);
  }
}
function $setCompositionKey$1(compositionKey) {
  errorOnReadOnly();
  const editor = getActiveEditor();
  const previousCompositionKey = editor._compositionKey;

  if (compositionKey !== previousCompositionKey) {
    editor._compositionKey = compositionKey;

    if (previousCompositionKey !== null) {
      const node = $getNodeByKey$1(previousCompositionKey);

      if (node !== null) {
        node.getWritable();
      }
    }

    if (compositionKey !== null) {
      const node = $getNodeByKey$1(compositionKey);

      if (node !== null) {
        node.getWritable();
      }
    }
  }
}
function $getCompositionKey() {
  if (isCurrentlyReadOnlyMode()) {
    return null;
  }

  const editor = getActiveEditor();
  return editor._compositionKey;
}
function $getNodeByKey$1(key, _editorState) {
  const editorState = _editorState || getActiveEditorState();

  const node = editorState._nodeMap.get(key);

  if (node === undefined) {
    return null;
  }

  return node;
}
function getNodeFromDOMNode(dom, editorState) {
  const editor = getActiveEditor(); // @ts-ignore We intentionally add this to the Node.

  const key = dom[`__lexicalKey_${editor._key}`];

  if (key !== undefined) {
    return $getNodeByKey$1(key, editorState);
  }

  return null;
}
function $getNearestNodeFromDOMNode$1(startingDOM, editorState) {
  let dom = startingDOM;

  while (dom != null) {
    const node = getNodeFromDOMNode(dom, editorState);

    if (node !== null) {
      return node;
    }

    dom = getParentElement(dom);
  }

  return null;
}
function cloneDecorators(editor) {
  const currentDecorators = editor._decorators;
  const pendingDecorators = Object.assign({}, currentDecorators);
  editor._pendingDecorators = pendingDecorators;
  return pendingDecorators;
}
function getEditorStateTextContent(editorState) {
  return editorState.read(() => $getRoot$1().getTextContent());
}
function markAllNodesAsDirty(editor, type) {
  // Mark all existing text nodes as dirty
  updateEditor(editor, () => {
    const editorState = getActiveEditorState();

    if (editorState.isEmpty()) {
      return;
    }

    if (type === 'root') {
      $getRoot$1().markDirty();
      return;
    }

    const nodeMap = editorState._nodeMap;

    for (const [, node] of nodeMap) {
      node.markDirty();
    }
  }, editor._pendingEditorState === null ? {
    tag: 'history-merge'
  } : undefined);
}
function $getRoot$1() {
  return internalGetRoot(getActiveEditorState());
}
function internalGetRoot(editorState) {
  return editorState._nodeMap.get('root');
}
function $setSelection$1(selection) {
  errorOnReadOnly();
  const editorState = getActiveEditorState();

  if (selection !== null) {
    {
      if (Object.isFrozen(selection)) {
        {
          throw Error(`$setSelection called on frozen selection object. Ensure selection is cloned before passing in.`);
        }
      }
    }

    selection.dirty = true;
    selection._cachedNodes = null;
  }

  editorState._selection = selection;
}
function $flushMutations() {
  errorOnReadOnly();
  const editor = getActiveEditor();
  flushRootMutations(editor);
}
function getNodeFromDOM(dom) {
  const editor = getActiveEditor();
  const nodeKey = getNodeKeyFromDOM(dom, editor);

  if (nodeKey === null) {
    const rootElement = editor.getRootElement();

    if (dom === rootElement) {
      return $getNodeByKey$1('root');
    }

    return null;
  }

  return $getNodeByKey$1(nodeKey);
}
function getTextNodeOffset(node, moveSelectionToEnd) {
  return moveSelectionToEnd ? node.getTextContentSize() : 0;
}

function getNodeKeyFromDOM( // Note that node here refers to a DOM Node, not an Lexical Node
dom, editor) {
  let node = dom;

  while (node != null) {
    // @ts-ignore We intentionally add this to the Node.
    const key = node[`__lexicalKey_${editor._key}`];

    if (key !== undefined) {
      return key;
    }

    node = getParentElement(node);
  }

  return null;
}

function doesContainGrapheme(str) {
  return /[\uD800-\uDBFF][\uDC00-\uDFFF]/g.test(str);
}
function getEditorsToPropagate(editor) {
  const editorsToPropagate = [];
  let currentEditor = editor;

  while (currentEditor !== null) {
    editorsToPropagate.push(currentEditor);
    currentEditor = currentEditor._parentEditor;
  }

  return editorsToPropagate;
}
function createUID() {
  return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
}
function getAnchorTextFromDOM(anchorNode) {
  if (anchorNode.nodeType === DOM_TEXT_TYPE) {
    return anchorNode.nodeValue;
  }

  return null;
}
function $updateSelectedTextFromDOM(isCompositionEnd, editor, data) {
  // Update the text content with the latest composition text
  const domSelection = getDOMSelection(editor._window);

  if (domSelection === null) {
    return;
  }

  const anchorNode = domSelection.anchorNode;
  let {
    anchorOffset,
    focusOffset
  } = domSelection;

  if (anchorNode !== null) {
    let textContent = getAnchorTextFromDOM(anchorNode);
    const node = $getNearestNodeFromDOMNode$1(anchorNode);

    if (textContent !== null && $isTextNode$1(node)) {
      if (node.canContainTabs()) {
        const hasTabCharacter = textContent.includes('\t'); // At present, this condition is primarily used for code highlights when
        // grouped together in lines (divs). If a code highlight includes a tab,
        // the newly typed character may be missing from the DOM's textContent.
        // Let's take an example. If a LinedCodeNode looked roughly like this:
        // <code><div><codeHighlight /><codeHighlight /></div></code>,
        // the following could occur when using tabs:
        // a. /tconst --type--> 'd' at offset 1 --get--> /tconst
        //    - Missing 'd'
        // b. /tconst --type--> 'd' at offset 3 --get--> /tcondst
        //    --type--> 'd' at offset 3 --get--> /tcondst
        //    - Missing second 'd'
        // In these cases, we can fix the problem by manually inserting the
        // newly typed character where we know it should have been.

        if (data && data.length > 0 && hasTabCharacter) {
          const selectionOffset = data.length;
          const insertionOffset = anchorOffset + selectionOffset - 1;
          const beforeInsertion = textContent.slice(0, insertionOffset);
          const afterInsertion = textContent.slice(insertionOffset, textContent.length);
          textContent = `${beforeInsertion}${data}${afterInsertion}`;
          anchorOffset += selectionOffset;
          focusOffset += selectionOffset;
        }
      } // Data is intentionally truthy, as we check for boolean, null and empty string.


      if (textContent === COMPOSITION_SUFFIX && data) {
        const offset = data.length;
        textContent = data;
        anchorOffset = offset;
        focusOffset = offset;
      }

      if (textContent !== null) {
        $updateTextNodeFromDOMContent(node, textContent, anchorOffset, focusOffset, isCompositionEnd);
      }
    }
  }
}
function $updateTextNodeFromDOMContent(textNode, textContent, anchorOffset, focusOffset, compositionEnd) {
  let node = textNode;

  if (node.isAttached() && (compositionEnd || !node.isDirty())) {
    const isComposing = node.isComposing();
    let normalizedTextContent = textContent;

    if ((isComposing || compositionEnd) && textContent[textContent.length - 1] === COMPOSITION_SUFFIX) {
      normalizedTextContent = textContent.slice(0, -1);
    }

    const prevTextContent = node.getTextContent();

    if (compositionEnd || normalizedTextContent !== prevTextContent) {
      if (normalizedTextContent === '') {
        $setCompositionKey$1(null);

        if (!IS_SAFARI$2 && !IS_IOS$2 && !IS_APPLE_WEBKIT$2) {
          // For composition (mainly Android), we have to remove the node on a later update
          const editor = getActiveEditor();
          setTimeout(() => {
            editor.update(() => {
              if (node.isAttached()) {
                node.remove();
              }
            });
          }, 20);
        } else {
          node.remove();
        }

        return;
      }

      const parent = node.getParent();
      const prevSelection = $getPreviousSelection$1();
      const compositionKey = $getCompositionKey();
      const nodeKey = node.getKey();

      if (node.isToken() || compositionKey !== null && nodeKey === compositionKey && !isComposing || // Check if character was added at the start, and we need
      // to clear this input from occurring as that action wasn't
      // permitted.
      parent !== null && $isRangeSelection$1(prevSelection) && !parent.canInsertTextBefore() && prevSelection.anchor.offset === 0) {
        node.markDirty();
        return;
      }

      const selection = $getSelection$1();

      if (!$isRangeSelection$1(selection) || anchorOffset === null || focusOffset === null) {
        node.setTextContent(normalizedTextContent);
        return;
      }

      selection.setTextNodeRange(node, anchorOffset, node, focusOffset);

      if (node.isSegmented()) {
        const originalTextContent = node.getTextContent();
        const replacement = $createTextNode$1(originalTextContent);
        node.replace(replacement);
        node = replacement;
      }

      node.setTextContent(normalizedTextContent);
    }
  }
}

function $previousSiblingDoesNotAcceptText(node) {
  const previousSibling = node.getPreviousSibling();
  return ($isTextNode$1(previousSibling) || $isElementNode$1(previousSibling) && previousSibling.isInline()) && !previousSibling.canInsertTextAfter();
} // This function is connected to $shouldPreventDefaultAndInsertText and determines whether the
// TextNode boundaries are writable or we should use the previous/next sibling instead. For example,
// in the case of a LinkNode, boundaries are not writable.


function $shouldInsertTextAfterOrBeforeTextNode(selection, node) {
  if (node.isSegmented()) {
    return true;
  }

  if (!selection.isCollapsed()) {
    return false;
  }

  const offset = selection.anchor.offset;
  const parent = node.getParentOrThrow();
  const isToken = node.isToken();

  if (offset === 0) {
    return !node.canInsertTextBefore() || !parent.canInsertTextBefore() || isToken || $previousSiblingDoesNotAcceptText(node);
  } else if (offset === node.getTextContentSize()) {
    return !node.canInsertTextAfter() || !parent.canInsertTextAfter() || isToken;
  } else {
    return false;
  }
}
function isTab(keyCode, altKey, ctrlKey, metaKey) {
  return keyCode === 9 && !altKey && !ctrlKey && !metaKey;
}
function isBold(keyCode, altKey, metaKey, ctrlKey) {
  return keyCode === 66 && !altKey && controlOrMeta(metaKey, ctrlKey);
}
function isItalic(keyCode, altKey, metaKey, ctrlKey) {
  return keyCode === 73 && !altKey && controlOrMeta(metaKey, ctrlKey);
}
function isUnderline(keyCode, altKey, metaKey, ctrlKey) {
  return keyCode === 85 && !altKey && controlOrMeta(metaKey, ctrlKey);
}
function isParagraph(keyCode, shiftKey) {
  return isReturn(keyCode) && !shiftKey;
}
function isLineBreak(keyCode, shiftKey) {
  return isReturn(keyCode) && shiftKey;
} // Inserts a new line after the selection

function isOpenLineBreak(keyCode, ctrlKey) {
  // 79 = KeyO
  return IS_APPLE && ctrlKey && keyCode === 79;
}
function isDeleteWordBackward(keyCode, altKey, ctrlKey) {
  return isBackspace(keyCode) && (IS_APPLE ? altKey : ctrlKey);
}
function isDeleteWordForward(keyCode, altKey, ctrlKey) {
  return isDelete(keyCode) && (IS_APPLE ? altKey : ctrlKey);
}
function isDeleteLineBackward(keyCode, metaKey) {
  return IS_APPLE && metaKey && isBackspace(keyCode);
}
function isDeleteLineForward(keyCode, metaKey) {
  return IS_APPLE && metaKey && isDelete(keyCode);
}
function isDeleteBackward(keyCode, altKey, metaKey, ctrlKey) {
  if (IS_APPLE) {
    if (altKey || metaKey) {
      return false;
    }

    return isBackspace(keyCode) || keyCode === 72 && ctrlKey;
  }

  if (ctrlKey || altKey || metaKey) {
    return false;
  }

  return isBackspace(keyCode);
}
function isDeleteForward(keyCode, ctrlKey, shiftKey, altKey, metaKey) {
  if (IS_APPLE) {
    if (shiftKey || altKey || metaKey) {
      return false;
    }

    return isDelete(keyCode) || keyCode === 68 && ctrlKey;
  }

  if (ctrlKey || altKey || metaKey) {
    return false;
  }

  return isDelete(keyCode);
}
function isUndo(keyCode, shiftKey, metaKey, ctrlKey) {
  return keyCode === 90 && !shiftKey && controlOrMeta(metaKey, ctrlKey);
}
function isRedo(keyCode, shiftKey, metaKey, ctrlKey) {
  if (IS_APPLE) {
    return keyCode === 90 && metaKey && shiftKey;
  }

  return keyCode === 89 && ctrlKey || keyCode === 90 && ctrlKey && shiftKey;
}
function isCopy(keyCode, shiftKey, metaKey, ctrlKey) {
  if (shiftKey) {
    return false;
  }

  if (keyCode === 67) {
    return IS_APPLE ? metaKey : ctrlKey;
  }

  return false;
}
function isCut(keyCode, shiftKey, metaKey, ctrlKey) {
  if (shiftKey) {
    return false;
  }

  if (keyCode === 88) {
    return IS_APPLE ? metaKey : ctrlKey;
  }

  return false;
}

function isArrowLeft(keyCode) {
  return keyCode === 37;
}

function isArrowRight(keyCode) {
  return keyCode === 39;
}

function isArrowUp(keyCode) {
  return keyCode === 38;
}

function isArrowDown(keyCode) {
  return keyCode === 40;
}

function isMoveBackward(keyCode, ctrlKey, altKey, metaKey) {
  return isArrowLeft(keyCode) && !ctrlKey && !metaKey && !altKey;
}
function isMoveToStart(keyCode, ctrlKey, shiftKey, altKey, metaKey) {
  return isArrowLeft(keyCode) && !altKey && !shiftKey && (ctrlKey || metaKey);
}
function isMoveForward(keyCode, ctrlKey, altKey, metaKey) {
  return isArrowRight(keyCode) && !ctrlKey && !metaKey && !altKey;
}
function isMoveToEnd(keyCode, ctrlKey, shiftKey, altKey, metaKey) {
  return isArrowRight(keyCode) && !altKey && !shiftKey && (ctrlKey || metaKey);
}
function isMoveUp(keyCode, ctrlKey, metaKey) {
  return isArrowUp(keyCode) && !ctrlKey && !metaKey;
}
function isMoveDown(keyCode, ctrlKey, metaKey) {
  return isArrowDown(keyCode) && !ctrlKey && !metaKey;
}
function isModifier(ctrlKey, shiftKey, altKey, metaKey) {
  return ctrlKey || shiftKey || altKey || metaKey;
}
function isSpace(keyCode) {
  return keyCode === 32;
}
function controlOrMeta(metaKey, ctrlKey) {
  if (IS_APPLE) {
    return metaKey;
  }

  return ctrlKey;
}
function isReturn(keyCode) {
  return keyCode === 13;
}
function isBackspace(keyCode) {
  return keyCode === 8;
}
function isEscape(keyCode) {
  return keyCode === 27;
}
function isDelete(keyCode) {
  return keyCode === 46;
}
function isSelectAll(keyCode, metaKey, ctrlKey) {
  return keyCode === 65 && controlOrMeta(metaKey, ctrlKey);
}
function getCachedClassNameArray(classNamesTheme, classNameThemeType) {
  const classNames = classNamesTheme[classNameThemeType]; // As we're using classList, we need
  // to handle className tokens that have spaces.
  // The easiest way to do this to convert the
  // className tokens to an array that can be
  // applied to classList.add()/remove().

  if (typeof classNames === 'string') {
    const classNamesArr = classNames.split(' ');
    classNamesTheme[classNameThemeType] = classNamesArr;
    return classNamesArr;
  }

  return classNames;
}
function setMutatedNode(mutatedNodes, registeredNodes, mutationListeners, node, mutation) {
  if (mutationListeners.size === 0) {
    return;
  }

  const nodeType = node.__type;
  const nodeKey = node.__key;
  const registeredNode = registeredNodes.get(nodeType);

  if (registeredNode === undefined) {
    {
      throw Error(`Type ${nodeType} not in registeredNodes`);
    }
  }

  const klass = registeredNode.klass;
  let mutatedNodesByType = mutatedNodes.get(klass);

  if (mutatedNodesByType === undefined) {
    mutatedNodesByType = new Map();
    mutatedNodes.set(klass, mutatedNodesByType);
  }

  const prevMutation = mutatedNodesByType.get(nodeKey); // If the node has already been "destroyed", yet we are
  // re-making it, then this means a move likely happened.
  // We should change the mutation to be that of "updated"
  // instead.

  const isMove = prevMutation === 'destroyed' && mutation === 'created';

  if (prevMutation === undefined || isMove) {
    mutatedNodesByType.set(nodeKey, isMove ? 'updated' : mutation);
  }
}
function $nodesOfType$1(klass) {
  const editorState = getActiveEditorState();
  const readOnly = editorState._readOnly;
  const klassType = klass.getType();
  const nodes = editorState._nodeMap;
  const nodesOfType = [];

  for (const [, node] of nodes) {
    if (node instanceof klass && node.__type === klassType && (readOnly || node.isAttached())) {
      nodesOfType.push(node);
    }
  }

  return nodesOfType;
}

function resolveElement(element, isBackward, focusOffset) {
  const parent = element.getParent();
  let offset = focusOffset;
  let block = element;

  if (parent !== null) {
    if (isBackward && focusOffset === 0) {
      offset = block.getIndexWithinParent();
      block = parent;
    } else if (!isBackward && focusOffset === block.getChildrenSize()) {
      offset = block.getIndexWithinParent() + 1;
      block = parent;
    }
  }

  return block.getChildAtIndex(isBackward ? offset - 1 : offset);
}

function $getAdjacentNode$1(focus, isBackward) {
  const focusOffset = focus.offset;

  if (focus.type === 'element') {
    const block = focus.getNode();
    return resolveElement(block, isBackward, focusOffset);
  } else {
    const focusNode = focus.getNode();

    if (isBackward && focusOffset === 0 || !isBackward && focusOffset === focusNode.getTextContentSize()) {
      const possibleNode = isBackward ? focusNode.getPreviousSibling() : focusNode.getNextSibling();

      if (possibleNode === null) {
        return resolveElement(focusNode.getParentOrThrow(), isBackward, focusNode.getIndexWithinParent() + (isBackward ? 0 : 1));
      }

      return possibleNode;
    }
  }

  return null;
}
function isFirefoxClipboardEvents(editor) {
  const event = getWindow(editor).event;
  const inputType = event && event.inputType;
  return inputType === 'insertFromPaste' || inputType === 'insertFromPasteAsQuotation';
}
function dispatchCommand(editor, command, payload) {
  return triggerCommandListeners(editor, command, payload);
}
function $textContentRequiresDoubleLinebreakAtEnd(node) {
  return !$isRootNode$1(node) && !node.isLastChild() && !node.isInline();
}
function getElementByKeyOrThrow(editor, key) {
  const element = editor._keyToDOMMap.get(key);

  if (element === undefined) {
    {
      throw Error(`Reconciliation: could not find DOM element for node key ${key}`);
    }
  }

  return element;
}
function getParentElement(node) {
  const parentElement = node.assignedSlot || node.parentElement;
  return parentElement !== null && parentElement.nodeType === 11 ? parentElement.host : parentElement;
}
function scrollIntoViewIfNeeded(editor, selectionRect, rootElement) {
  const doc = rootElement.ownerDocument;
  const defaultView = doc.defaultView;

  if (defaultView === null) {
    return;
  }

  let {
    top: currentTop,
    bottom: currentBottom
  } = selectionRect;
  let targetTop = 0;
  let targetBottom = 0;
  let element = rootElement;

  while (element !== null) {
    const isBodyElement = element === doc.body;

    if (isBodyElement) {
      targetTop = 0;
      targetBottom = getWindow(editor).innerHeight;
    } else {
      const targetRect = element.getBoundingClientRect();
      targetTop = targetRect.top;
      targetBottom = targetRect.bottom;
    }

    let diff = 0;

    if (currentTop < targetTop) {
      diff = -(targetTop - currentTop);
    } else if (currentBottom > targetBottom) {
      diff = currentBottom - targetBottom;
    }

    if (diff !== 0) {
      if (isBodyElement) {
        // Only handles scrolling of Y axis
        defaultView.scrollBy(0, diff);
      } else {
        const scrollTop = element.scrollTop;
        element.scrollTop += diff;
        const yOffset = element.scrollTop - scrollTop;
        currentTop -= yOffset;
        currentBottom -= yOffset;
      }
    }

    if (isBodyElement) {
      break;
    }

    element = getParentElement(element);
  }
}
function $hasUpdateTag$1(tag) {
  const editor = getActiveEditor();
  return editor._updateTags.has(tag);
}
function $addUpdateTag$1(tag) {
  errorOnReadOnly();
  const editor = getActiveEditor();

  editor._updateTags.add(tag);
}
function $maybeMoveChildrenSelectionToParent(parentNode, offset = 0) {
  if (offset !== 0) {
    {
      throw Error(`TODO`);
    }
  }

  const selection = $getSelection$1();

  if (!$isRangeSelection$1(selection) || !$isElementNode$1(parentNode)) {
    return selection;
  }

  const {
    anchor,
    focus
  } = selection;
  const anchorNode = anchor.getNode();
  const focusNode = focus.getNode();

  if ($hasAncestor$1(anchorNode, parentNode)) {
    anchor.set(parentNode.__key, 0, 'element');
  }

  if ($hasAncestor$1(focusNode, parentNode)) {
    focus.set(parentNode.__key, 0, 'element');
  }

  return selection;
}
function $hasAncestor$1(child, targetNode) {
  let parent = child.getParent();

  while (parent !== null) {
    if (parent.is(targetNode)) {
      return true;
    }

    parent = parent.getParent();
  }

  return false;
}
function getDefaultView(domElem) {
  const ownerDoc = domElem.ownerDocument;
  return ownerDoc && ownerDoc.defaultView || null;
}
function getWindow(editor) {
  const windowObj = editor._window;

  if (windowObj === null) {
    {
      throw Error(`window object not found`);
    }
  }

  return windowObj;
}
function $isInlineElementOrDecoratorNode$1(node) {
  return $isElementNode$1(node) && node.isInline() || $isDecoratorNode$1(node) && node.isInline();
}
function $getNearestRootOrShadowRoot$1(node) {
  let parent = node.getParentOrThrow();

  while (parent !== null) {
    if ($isRootOrShadowRoot$1(parent)) {
      return parent;
    }

    parent = parent.getParentOrThrow();
  }

  return parent;
}
function $isRootOrShadowRoot$1(node) {
  return $isRootNode$1(node) || $isElementNode$1(node) && node.isShadowRoot();
}
function $copyNode$1(node) {
  // @ts-ignore
  const copy = node.constructor.clone(node);
  $setNodeKey(copy, null);
  return copy;
}
function $applyNodeReplacement$1(node) {
  const editor = getActiveEditor();
  const nodeType = node.constructor.getType();

  const registeredNode = editor._nodes.get(nodeType);

  if (registeredNode === undefined) {
    {
      throw Error(`$initializeNode failed. Ensure node has been registered to the editor. You can do this by passing the node class via the "nodes" array in the editor config.`);
    }
  }

  const replaceFunc = registeredNode.replace;

  if (replaceFunc !== null) {
    const replacementNode = replaceFunc(node);

    if (!(replacementNode instanceof node.constructor)) {
      {
        throw Error(`$initializeNode failed. Ensure replacement node is a subclass of the original node.`);
      }
    }

    return replacementNode;
  }

  return node;
}
function errorOnInsertTextNodeOnRoot(node, insertNode) {
  const parentNode = node.getParent();

  if ($isRootNode$1(parentNode) && !$isElementNode$1(insertNode) && !$isDecoratorNode$1(insertNode)) {
    {
      throw Error(`Only element or decorator nodes can be inserted in to the root node`);
    }
  }
}

function createBlockCursorElement(editorConfig) {
  const theme = editorConfig.theme;
  const element = document.createElement('div');
  element.contentEditable = 'false';
  element.setAttribute('data-lexical-cursor', 'true');
  let blockCursorTheme = theme.blockCursor;

  if (blockCursorTheme !== undefined) {
    if (typeof blockCursorTheme === 'string') {
      const classNamesArr = blockCursorTheme.split(' '); // @ts-expect-error: intentional

      blockCursorTheme = theme.blockCursor = classNamesArr;
    }

    if (blockCursorTheme !== undefined) {
      element.classList.add(...blockCursorTheme);
    }
  }

  return element;
}

function needsBlockCursor(node) {
  return ($isDecoratorNode$1(node) || $isElementNode$1(node) && !node.canBeEmpty()) && !node.isInline();
}

function removeDOMBlockCursorElement(blockCursorElement, editor, rootElement) {
  rootElement.style.removeProperty('caret-color');
  editor._blockCursorElement = null;
  const parentElement = blockCursorElement.parentElement;

  if (parentElement !== null) {
    parentElement.removeChild(blockCursorElement);
  }
}
function updateDOMBlockCursorElement(editor, rootElement, nextSelection) {
  let blockCursorElement = editor._blockCursorElement;

  if ($isRangeSelection$1(nextSelection) && nextSelection.isCollapsed() && nextSelection.anchor.type === 'element' && rootElement.contains(document.activeElement)) {
    const anchor = nextSelection.anchor;
    const elementNode = anchor.getNode();
    const offset = anchor.offset;
    const elementNodeSize = elementNode.getChildrenSize();
    let isBlockCursor = false;
    let insertBeforeElement = null;

    if (offset === elementNodeSize) {
      const child = elementNode.getChildAtIndex(offset - 1);

      if (needsBlockCursor(child)) {
        isBlockCursor = true;
      }
    } else {
      const child = elementNode.getChildAtIndex(offset);

      if (needsBlockCursor(child)) {
        const sibling = child.getPreviousSibling();

        if (sibling === null || needsBlockCursor(sibling)) {
          isBlockCursor = true;
          insertBeforeElement = editor.getElementByKey(child.__key);
        }
      }
    }

    if (isBlockCursor) {
      const elementDOM = editor.getElementByKey(elementNode.__key);

      if (blockCursorElement === null) {
        editor._blockCursorElement = blockCursorElement = createBlockCursorElement(editor._config);
      }

      rootElement.style.caretColor = 'transparent';

      if (insertBeforeElement === null) {
        elementDOM.appendChild(blockCursorElement);
      } else {
        elementDOM.insertBefore(blockCursorElement, insertBeforeElement);
      }

      return;
    }
  } // Remove cursor


  if (blockCursorElement !== null) {
    removeDOMBlockCursorElement(blockCursorElement, editor, rootElement);
  }
}
function getDOMSelection(targetWindow) {
  return !CAN_USE_DOM$7 ? null : (targetWindow || window).getSelection();
}
function $splitNode$3(node, offset) {
  let startNode = node.getChildAtIndex(offset);

  if (startNode == null) {
    startNode = node;
  }

  if (!!$isRootOrShadowRoot$1(node)) {
    throw Error(`Can not call $splitNode() on root element`);
  }

  const recurse = currentNode => {
    const parent = currentNode.getParentOrThrow();
    const isParentRoot = $isRootOrShadowRoot$1(parent); // The node we start split from (leaf) is moved, but its recursive
    // parents are copied to create separate tree

    const nodeToMove = currentNode === startNode && !isParentRoot ? currentNode : $copyNode$1(currentNode);

    if (isParentRoot) {
      currentNode.insertAfter(nodeToMove);
      return [currentNode, nodeToMove, nodeToMove];
    } else {
      const [leftTree, rightTree, newParent] = recurse(parent);
      const nextSiblings = currentNode.getNextSiblings();
      newParent.append(nodeToMove, ...nextSiblings);
      return [leftTree, rightTree, nodeToMove];
    }
  };

  const [leftTree, rightTree] = recurse(startNode);
  return [leftTree, rightTree];
}
function $findMatchingParent$2(startingNode, findFn) {
  let curr = startingNode;

  while (curr !== $getRoot$1() && curr != null) {
    if (findFn(curr)) {
      return curr;
    }

    curr = curr.getParent();
  }

  return null;
}
function $getChildrenRecursively(node) {
  const nodes = [];
  const stack = [node];

  while (stack.length > 0) {
    const currentNode = stack.pop();

    if (!(currentNode !== undefined)) {
      throw Error(`Stack.length > 0; can't be undefined`);
    }

    if ($isElementNode$1(currentNode)) {
      stack.unshift(...currentNode.getChildren());
    }

    if (currentNode !== node) {
      nodes.push(currentNode);
    }
  }

  return nodes;
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
function $garbageCollectDetachedDecorators(editor, pendingEditorState) {
  const currentDecorators = editor._decorators;
  const pendingDecorators = editor._pendingDecorators;
  let decorators = pendingDecorators || currentDecorators;
  const nodeMap = pendingEditorState._nodeMap;
  let key;

  for (key in decorators) {
    if (!nodeMap.has(key)) {
      if (decorators === currentDecorators) {
        decorators = cloneDecorators(editor);
      }

      delete decorators[key];
    }
  }
}

function $garbageCollectDetachedDeepChildNodes(node, parentKey, prevNodeMap, nodeMap, dirtyNodes) {
  let child = node.getFirstChild();

  while (child !== null) {
    const childKey = child.__key;

    if (child !== undefined && child.__parent === parentKey) {
      if ($isElementNode$1(child)) {
        $garbageCollectDetachedDeepChildNodes(child, childKey, prevNodeMap, nodeMap, dirtyNodes);
      } // If we have created a node and it was dereferenced, then also
      // remove it from out dirty nodes Set.


      if (!prevNodeMap.has(childKey)) {
        dirtyNodes.delete(childKey);
      }

      nodeMap.delete(childKey);
    }

    child = child.isAttached() ? child.getNextSibling() : null;
  }
}

function $garbageCollectDetachedNodes(prevEditorState, editorState, dirtyLeaves, dirtyElements) {
  const prevNodeMap = prevEditorState._nodeMap;
  const nodeMap = editorState._nodeMap;

  for (const nodeKey of dirtyLeaves) {
    const node = nodeMap.get(nodeKey);

    if (node !== undefined && !node.isAttached()) {
      if (!prevNodeMap.has(nodeKey)) {
        dirtyLeaves.delete(nodeKey);
      }

      nodeMap.delete(nodeKey);
    }
  }

  for (const [nodeKey] of dirtyElements) {
    const node = nodeMap.get(nodeKey);

    if (node !== undefined) {
      // Garbage collect node and its children if they exist
      if (!node.isAttached()) {
        if ($isElementNode$1(node)) {
          $garbageCollectDetachedDeepChildNodes(node, nodeKey, prevNodeMap, nodeMap, dirtyElements);
        } // If we have created a node and it was dereferenced, then also
        // remove it from out dirty nodes Set.


        if (!prevNodeMap.has(nodeKey)) {
          dirtyElements.delete(nodeKey);
        }

        nodeMap.delete(nodeKey);
      }
    }
  }
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

function $canSimpleTextNodesBeMerged(node1, node2) {
  const node1Mode = node1.__mode;
  const node1Format = node1.__format;
  const node1Style = node1.__style;
  const node2Mode = node2.__mode;
  const node2Format = node2.__format;
  const node2Style = node2.__style;
  return (node1Mode === null || node1Mode === node2Mode) && (node1Format === null || node1Format === node2Format) && (node1Style === null || node1Style === node2Style);
}

function $mergeTextNodes(node1, node2) {
  const writableNode1 = node1.mergeWithSibling(node2);

  const normalizedNodes = getActiveEditor()._normalizedNodes;

  normalizedNodes.add(node1.__key);
  normalizedNodes.add(node2.__key);
  return writableNode1;
}

function $normalizeTextNode(textNode) {
  let node = textNode;

  if (node.__text === '' && node.isSimpleText() && !node.isUnmergeable()) {
    node.remove();
    return;
  } // Backward


  let previousNode;

  while ((previousNode = node.getPreviousSibling()) !== null && $isTextNode$1(previousNode) && previousNode.isSimpleText() && !previousNode.isUnmergeable()) {
    if (previousNode.__text === '') {
      previousNode.remove();
    } else if ($canSimpleTextNodesBeMerged(previousNode, node)) {
      node = $mergeTextNodes(previousNode, node);
      break;
    } else {
      break;
    }
  } // Forward


  let nextNode;

  while ((nextNode = node.getNextSibling()) !== null && $isTextNode$1(nextNode) && nextNode.isSimpleText() && !nextNode.isUnmergeable()) {
    if (nextNode.__text === '') {
      nextNode.remove();
    } else if ($canSimpleTextNodesBeMerged(node, nextNode)) {
      node = $mergeTextNodes(node, nextNode);
      break;
    } else {
      break;
    }
  }
}
function $normalizeSelection(selection) {
  $normalizePoint(selection.anchor);
  $normalizePoint(selection.focus);
  return selection;
}

function $normalizePoint(point) {
  while (point.type === 'element') {
    const node = point.getNode();
    const offset = point.offset;
    let nextNode;
    let nextOffsetAtEnd;

    if (offset === node.getChildrenSize()) {
      nextNode = node.getChildAtIndex(offset - 1);
      nextOffsetAtEnd = true;
    } else {
      nextNode = node.getChildAtIndex(offset);
      nextOffsetAtEnd = false;
    }

    if ($isTextNode$1(nextNode)) {
      point.set(nextNode.__key, nextOffsetAtEnd ? nextNode.getTextContentSize() : 0, 'text');
      break;
    } else if (!$isElementNode$1(nextNode)) {
      break;
    }

    point.set(nextNode.__key, nextOffsetAtEnd ? nextNode.getChildrenSize() : 0, 'element');
  }
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
let subTreeTextContent = '';
let subTreeDirectionedTextContent = '';
let editorTextContent = '';
let activeEditorConfig;
let activeEditor$1;
let activeEditorNodes;
let treatAllNodesAsDirty = false;
let activeEditorStateReadOnly = false;
let activeMutationListeners;
let activeTextDirection = null;
let activeDirtyElements;
let activeDirtyLeaves;
let activePrevNodeMap;
let activeNextNodeMap;
let activePrevKeyToDOMMap;
let mutatedNodes;

function destroyNode(key, parentDOM) {
  const node = activePrevNodeMap.get(key);

  if (parentDOM !== null) {
    const dom = getPrevElementByKeyOrThrow(key);

    if (dom.parentNode === parentDOM) {
      parentDOM.removeChild(dom);
    }
  } // This logic is really important, otherwise we will leak DOM nodes
  // when their corresponding LexicalNodes are removed from the editor state.


  if (!activeNextNodeMap.has(key)) {
    activeEditor$1._keyToDOMMap.delete(key);
  }

  if ($isElementNode$1(node)) {
    const children = createChildrenArray(node, activePrevNodeMap);
    destroyChildren(children, 0, children.length - 1, null);
  }

  if (node !== undefined) {
    setMutatedNode(mutatedNodes, activeEditorNodes, activeMutationListeners, node, 'destroyed');
  }
}

function destroyChildren(children, _startIndex, endIndex, dom) {
  let startIndex = _startIndex;

  for (; startIndex <= endIndex; ++startIndex) {
    const child = children[startIndex];

    if (child !== undefined) {
      destroyNode(child, dom);
    }
  }
}

function setTextAlign(domStyle, value) {
  domStyle.setProperty('text-align', value);
}

const DEFAULT_INDENT_VALUE = '40px';

function setElementIndent(dom, indent) {
  const indentClassName = activeEditorConfig.theme.indent;

  if (typeof indentClassName === 'string') {
    const elementHasClassName = dom.classList.contains(indentClassName);

    if (indent > 0 && !elementHasClassName) {
      dom.classList.add(indentClassName);
    } else if (indent < 1 && elementHasClassName) {
      dom.classList.remove(indentClassName);
    }
  }

  const indentationBaseValue = getComputedStyle(dom).getPropertyValue('--lexical-indent-base-value') || DEFAULT_INDENT_VALUE;
  dom.style.setProperty('padding-inline-start', indent === 0 ? '' : `calc(${indent} * ${indentationBaseValue})`);
}

function setElementFormat(dom, format) {
  const domStyle = dom.style;

  if (format === 0) {
    setTextAlign(domStyle, '');
  } else if (format === IS_ALIGN_LEFT) {
    setTextAlign(domStyle, 'left');
  } else if (format === IS_ALIGN_CENTER) {
    setTextAlign(domStyle, 'center');
  } else if (format === IS_ALIGN_RIGHT) {
    setTextAlign(domStyle, 'right');
  } else if (format === IS_ALIGN_JUSTIFY) {
    setTextAlign(domStyle, 'justify');
  } else if (format === IS_ALIGN_START) {
    setTextAlign(domStyle, 'start');
  } else if (format === IS_ALIGN_END) {
    setTextAlign(domStyle, 'end');
  }
}

function createNode(key, parentDOM, insertDOM) {
  const node = activeNextNodeMap.get(key);

  if (node === undefined) {
    {
      throw Error(`createNode: node does not exist in nodeMap`);
    }
  }

  const dom = node.createDOM(activeEditorConfig, activeEditor$1);
  storeDOMWithKey(key, dom, activeEditor$1); // This helps preserve the text, and stops spell check tools from
  // merging or break the spans (which happens if they are missing
  // this attribute).

  if ($isTextNode$1(node)) {
    dom.setAttribute('data-lexical-text', 'true');
  } else if ($isDecoratorNode$1(node)) {
    dom.setAttribute('data-lexical-decorator', 'true');
  }

  if ($isElementNode$1(node)) {
    const indent = node.__indent;
    const childrenSize = node.__size;

    if (indent !== 0) {
      setElementIndent(dom, indent);
    }

    if (childrenSize !== 0) {
      const endIndex = childrenSize - 1;
      const children = createChildrenArray(node, activeNextNodeMap);
      createChildrenWithDirection(children, endIndex, node, dom);
    }

    const format = node.__format;

    if (format !== 0) {
      setElementFormat(dom, format);
    }

    if (!node.isInline()) {
      reconcileElementTerminatingLineBreak(null, node, dom);
    }

    if ($textContentRequiresDoubleLinebreakAtEnd(node)) {
      subTreeTextContent += DOUBLE_LINE_BREAK;
      editorTextContent += DOUBLE_LINE_BREAK;
    }
  } else {
    const text = node.getTextContent();

    if ($isDecoratorNode$1(node)) {
      const decorator = node.decorate(activeEditor$1, activeEditorConfig);

      if (decorator !== null) {
        reconcileDecorator(key, decorator);
      } // Decorators are always non editable


      dom.contentEditable = 'false';
    } else if ($isTextNode$1(node)) {
      if (!node.isDirectionless()) {
        subTreeDirectionedTextContent += text;
      }
    }

    subTreeTextContent += text;
    editorTextContent += text;
  }

  if (parentDOM !== null) {
    if (insertDOM != null) {
      parentDOM.insertBefore(dom, insertDOM);
    } else {
      // @ts-expect-error: internal field
      const possibleLineBreak = parentDOM.__lexicalLineBreak;

      if (possibleLineBreak != null) {
        parentDOM.insertBefore(dom, possibleLineBreak);
      } else {
        parentDOM.appendChild(dom);
      }
    }
  }

  {
    // Freeze the node in DEV to prevent accidental mutations
    Object.freeze(node);
  }

  setMutatedNode(mutatedNodes, activeEditorNodes, activeMutationListeners, node, 'created');
  return dom;
}

function createChildrenWithDirection(children, endIndex, element, dom) {
  const previousSubTreeDirectionedTextContent = subTreeDirectionedTextContent;
  subTreeDirectionedTextContent = '';
  createChildren(children, element, 0, endIndex, dom, null);
  reconcileBlockDirection(element, dom);
  subTreeDirectionedTextContent = previousSubTreeDirectionedTextContent;
}

function createChildren(children, element, _startIndex, endIndex, dom, insertDOM) {
  const previousSubTreeTextContent = subTreeTextContent;
  subTreeTextContent = '';
  let startIndex = _startIndex;

  for (; startIndex <= endIndex; ++startIndex) {
    createNode(children[startIndex], dom, insertDOM);
  }

  if ($textContentRequiresDoubleLinebreakAtEnd(element)) {
    subTreeTextContent += DOUBLE_LINE_BREAK;
  } // @ts-expect-error: internal field


  dom.__lexicalTextContent = subTreeTextContent;
  subTreeTextContent = previousSubTreeTextContent + subTreeTextContent;
}

function isLastChildLineBreakOrDecorator(childKey, nodeMap) {
  const node = nodeMap.get(childKey);
  return $isLineBreakNode$1(node) || $isDecoratorNode$1(node) && node.isInline();
} // If we end an element with a LineBreakNode, then we need to add an additional <br>


function reconcileElementTerminatingLineBreak(prevElement, nextElement, dom) {
  const prevLineBreak = prevElement !== null && (prevElement.__size === 0 || isLastChildLineBreakOrDecorator(prevElement.__last, activePrevNodeMap));
  const nextLineBreak = nextElement.__size === 0 || isLastChildLineBreakOrDecorator(nextElement.__last, activeNextNodeMap);

  if (prevLineBreak) {
    if (!nextLineBreak) {
      // @ts-expect-error: internal field
      const element = dom.__lexicalLineBreak;

      if (element != null) {
        dom.removeChild(element);
      } // @ts-expect-error: internal field


      dom.__lexicalLineBreak = null;
    }
  } else if (nextLineBreak) {
    const element = document.createElement('br'); // @ts-expect-error: internal field

    dom.__lexicalLineBreak = element;
    dom.appendChild(element);
  }
}

function reconcileBlockDirection(element, dom) {
  const previousSubTreeDirectionTextContent = // @ts-expect-error: internal field
  dom.__lexicalDirTextContent; // @ts-expect-error: internal field

  const previousDirection = dom.__lexicalDir;

  if (previousSubTreeDirectionTextContent !== subTreeDirectionedTextContent || previousDirection !== activeTextDirection) {
    const hasEmptyDirectionedTextContent = subTreeDirectionedTextContent === '';
    const direction = hasEmptyDirectionedTextContent ? activeTextDirection : getTextDirection(subTreeDirectionedTextContent);

    if (direction !== previousDirection) {
      const classList = dom.classList;
      const theme = activeEditorConfig.theme;
      let previousDirectionTheme = previousDirection !== null ? theme[previousDirection] : undefined;
      let nextDirectionTheme = direction !== null ? theme[direction] : undefined; // Remove the old theme classes if they exist

      if (previousDirectionTheme !== undefined) {
        if (typeof previousDirectionTheme === 'string') {
          const classNamesArr = previousDirectionTheme.split(' ');
          previousDirectionTheme = theme[previousDirection] = classNamesArr;
        } // @ts-ignore: intentional


        classList.remove(...previousDirectionTheme);
      }

      if (direction === null || hasEmptyDirectionedTextContent && direction === 'ltr') {
        // Remove direction
        dom.removeAttribute('dir');
      } else {
        // Apply the new theme classes if they exist
        if (nextDirectionTheme !== undefined) {
          if (typeof nextDirectionTheme === 'string') {
            const classNamesArr = nextDirectionTheme.split(' '); // @ts-expect-error: intentional

            nextDirectionTheme = theme[direction] = classNamesArr;
          }

          if (nextDirectionTheme !== undefined) {
            classList.add(...nextDirectionTheme);
          }
        } // Update direction


        dom.dir = direction;
      }

      if (!activeEditorStateReadOnly) {
        const writableNode = element.getWritable();
        writableNode.__dir = direction;
      }
    }

    activeTextDirection = direction; // @ts-expect-error: internal field

    dom.__lexicalDirTextContent = subTreeDirectionedTextContent; // @ts-expect-error: internal field

    dom.__lexicalDir = direction;
  }
}

function reconcileChildrenWithDirection(prevElement, nextElement, dom) {
  const previousSubTreeDirectionTextContent = subTreeDirectionedTextContent;
  subTreeDirectionedTextContent = '';
  reconcileChildren(prevElement, nextElement, dom);
  reconcileBlockDirection(nextElement, dom);
  subTreeDirectionedTextContent = previousSubTreeDirectionTextContent;
}

function createChildrenArray(element, nodeMap) {
  const children = [];
  let nodeKey = element.__first;

  while (nodeKey !== null) {
    const node = nodeMap.get(nodeKey);

    if (node === undefined) {
      {
        throw Error(`createChildrenArray: node does not exist in nodeMap`);
      }
    }

    children.push(nodeKey);
    nodeKey = node.__next;
  }

  return children;
}

function reconcileChildren(prevElement, nextElement, dom) {
  const previousSubTreeTextContent = subTreeTextContent;
  const prevChildrenSize = prevElement.__size;
  const nextChildrenSize = nextElement.__size;
  subTreeTextContent = '';

  if (prevChildrenSize === 1 && nextChildrenSize === 1) {
    const prevFirstChildKey = prevElement.__first;
    const nextFrstChildKey = nextElement.__first;

    if (prevFirstChildKey === nextFrstChildKey) {
      reconcileNode(prevFirstChildKey, dom);
    } else {
      const lastDOM = getPrevElementByKeyOrThrow(prevFirstChildKey);
      const replacementDOM = createNode(nextFrstChildKey, null, null);
      dom.replaceChild(replacementDOM, lastDOM);
      destroyNode(prevFirstChildKey, null);
    }
  } else {
    const prevChildren = createChildrenArray(prevElement, activePrevNodeMap);
    const nextChildren = createChildrenArray(nextElement, activeNextNodeMap);

    if (prevChildrenSize === 0) {
      if (nextChildrenSize !== 0) {
        createChildren(nextChildren, nextElement, 0, nextChildrenSize - 1, dom, null);
      }
    } else if (nextChildrenSize === 0) {
      if (prevChildrenSize !== 0) {
        // @ts-expect-error: internal field
        const lexicalLineBreak = dom.__lexicalLineBreak;
        const canUseFastPath = lexicalLineBreak == null;
        destroyChildren(prevChildren, 0, prevChildrenSize - 1, canUseFastPath ? null : dom);

        if (canUseFastPath) {
          // Fast path for removing DOM nodes
          dom.textContent = '';
        }
      }
    } else {
      reconcileNodeChildren(nextElement, prevChildren, nextChildren, prevChildrenSize, nextChildrenSize, dom);
    }
  }

  if ($textContentRequiresDoubleLinebreakAtEnd(nextElement)) {
    subTreeTextContent += DOUBLE_LINE_BREAK;
  } // @ts-expect-error: internal field


  dom.__lexicalTextContent = subTreeTextContent;
  subTreeTextContent = previousSubTreeTextContent + subTreeTextContent;
}

function reconcileNode(key, parentDOM) {
  const prevNode = activePrevNodeMap.get(key);
  let nextNode = activeNextNodeMap.get(key);

  if (prevNode === undefined || nextNode === undefined) {
    {
      throw Error(`reconcileNode: prevNode or nextNode does not exist in nodeMap`);
    }
  }

  const isDirty = treatAllNodesAsDirty || activeDirtyLeaves.has(key) || activeDirtyElements.has(key);
  const dom = getElementByKeyOrThrow(activeEditor$1, key); // If the node key points to the same instance in both states
  // and isn't dirty, we just update the text content cache
  // and return the existing DOM Node.

  if (prevNode === nextNode && !isDirty) {
    if ($isElementNode$1(prevNode)) {
      // @ts-expect-error: internal field
      const previousSubTreeTextContent = dom.__lexicalTextContent;

      if (previousSubTreeTextContent !== undefined) {
        subTreeTextContent += previousSubTreeTextContent;
        editorTextContent += previousSubTreeTextContent;
      } // @ts-expect-error: internal field


      const previousSubTreeDirectionTextContent = dom.__lexicalDirTextContent;

      if (previousSubTreeDirectionTextContent !== undefined) {
        subTreeDirectionedTextContent += previousSubTreeDirectionTextContent;
      }
    } else {
      const text = prevNode.getTextContent();

      if ($isTextNode$1(prevNode) && !prevNode.isDirectionless()) {
        subTreeDirectionedTextContent += text;
      }

      editorTextContent += text;
      subTreeTextContent += text;
    }

    return dom;
  } // If the node key doesn't point to the same instance in both maps,
  // it means it were cloned. If they're also dirty, we mark them as mutated.


  if (prevNode !== nextNode && isDirty) {
    setMutatedNode(mutatedNodes, activeEditorNodes, activeMutationListeners, nextNode, 'updated');
  } // Update node. If it returns true, we need to unmount and re-create the node


  if (nextNode.updateDOM(prevNode, dom, activeEditorConfig)) {
    const replacementDOM = createNode(key, null, null);

    if (parentDOM === null) {
      {
        throw Error(`reconcileNode: parentDOM is null`);
      }
    }

    parentDOM.replaceChild(replacementDOM, dom);
    destroyNode(key, null);
    return replacementDOM;
  }

  if ($isElementNode$1(prevNode) && $isElementNode$1(nextNode)) {
    // Reconcile element children
    const nextIndent = nextNode.__indent;

    if (nextIndent !== prevNode.__indent) {
      setElementIndent(dom, nextIndent);
    }

    const nextFormat = nextNode.__format;

    if (nextFormat !== prevNode.__format) {
      setElementFormat(dom, nextFormat);
    }

    if (isDirty) {
      reconcileChildrenWithDirection(prevNode, nextNode, dom);

      if (!$isRootNode$1(nextNode) && !nextNode.isInline()) {
        reconcileElementTerminatingLineBreak(prevNode, nextNode, dom);
      }
    }

    if ($textContentRequiresDoubleLinebreakAtEnd(nextNode)) {
      subTreeTextContent += DOUBLE_LINE_BREAK;
      editorTextContent += DOUBLE_LINE_BREAK;
    }
  } else {
    const text = nextNode.getTextContent();

    if ($isDecoratorNode$1(nextNode)) {
      const decorator = nextNode.decorate(activeEditor$1, activeEditorConfig);

      if (decorator !== null) {
        reconcileDecorator(key, decorator);
      }
    } else if ($isTextNode$1(nextNode) && !nextNode.isDirectionless()) {
      // Handle text content, for LTR, LTR cases.
      subTreeDirectionedTextContent += text;
    }

    subTreeTextContent += text;
    editorTextContent += text;
  }

  if (!activeEditorStateReadOnly && $isRootNode$1(nextNode) && nextNode.__cachedText !== editorTextContent) {
    // Cache the latest text content.
    nextNode = nextNode.getWritable();
    nextNode.__cachedText = editorTextContent;
  }

  {
    // Freeze the node in DEV to prevent accidental mutations
    Object.freeze(nextNode);
  }

  return dom;
}

function reconcileDecorator(key, decorator) {
  let pendingDecorators = activeEditor$1._pendingDecorators;
  const currentDecorators = activeEditor$1._decorators;

  if (pendingDecorators === null) {
    if (currentDecorators[key] === decorator) {
      return;
    }

    pendingDecorators = cloneDecorators(activeEditor$1);
  }

  pendingDecorators[key] = decorator;
}

function getFirstChild(element) {
  return element.firstChild;
}

function getNextSibling(element) {
  let nextSibling = element.nextSibling;

  if (nextSibling !== null && nextSibling === activeEditor$1._blockCursorElement) {
    nextSibling = nextSibling.nextSibling;
  }

  return nextSibling;
}

function reconcileNodeChildren(nextElement, prevChildren, nextChildren, prevChildrenLength, nextChildrenLength, dom) {
  const prevEndIndex = prevChildrenLength - 1;
  const nextEndIndex = nextChildrenLength - 1;
  let prevChildrenSet;
  let nextChildrenSet;
  let siblingDOM = getFirstChild(dom);
  let prevIndex = 0;
  let nextIndex = 0;

  while (prevIndex <= prevEndIndex && nextIndex <= nextEndIndex) {
    const prevKey = prevChildren[prevIndex];
    const nextKey = nextChildren[nextIndex];

    if (prevKey === nextKey) {
      siblingDOM = getNextSibling(reconcileNode(nextKey, dom));
      prevIndex++;
      nextIndex++;
    } else {
      if (prevChildrenSet === undefined) {
        prevChildrenSet = new Set(prevChildren);
      }

      if (nextChildrenSet === undefined) {
        nextChildrenSet = new Set(nextChildren);
      }

      const nextHasPrevKey = nextChildrenSet.has(prevKey);
      const prevHasNextKey = prevChildrenSet.has(nextKey);

      if (!nextHasPrevKey) {
        // Remove prev
        siblingDOM = getNextSibling(getPrevElementByKeyOrThrow(prevKey));
        destroyNode(prevKey, dom);
        prevIndex++;
      } else if (!prevHasNextKey) {
        // Create next
        createNode(nextKey, dom, siblingDOM);
        nextIndex++;
      } else {
        // Move next
        const childDOM = getElementByKeyOrThrow(activeEditor$1, nextKey);

        if (childDOM === siblingDOM) {
          siblingDOM = getNextSibling(reconcileNode(nextKey, dom));
        } else {
          if (siblingDOM != null) {
            dom.insertBefore(childDOM, siblingDOM);
          } else {
            dom.appendChild(childDOM);
          }

          reconcileNode(nextKey, dom);
        }

        prevIndex++;
        nextIndex++;
      }
    }
  }

  const appendNewChildren = prevIndex > prevEndIndex;
  const removeOldChildren = nextIndex > nextEndIndex;

  if (appendNewChildren && !removeOldChildren) {
    const previousNode = nextChildren[nextEndIndex + 1];
    const insertDOM = previousNode === undefined ? null : activeEditor$1.getElementByKey(previousNode);
    createChildren(nextChildren, nextElement, nextIndex, nextEndIndex, dom, insertDOM);
  } else if (removeOldChildren && !appendNewChildren) {
    destroyChildren(prevChildren, prevIndex, prevEndIndex, dom);
  }
}

function reconcileRoot(prevEditorState, nextEditorState, editor, dirtyType, dirtyElements, dirtyLeaves) {
  // We cache text content to make retrieval more efficient.
  // The cache must be rebuilt during reconciliation to account for any changes.
  subTreeTextContent = '';
  editorTextContent = '';
  subTreeDirectionedTextContent = ''; // Rather than pass around a load of arguments through the stack recursively
  // we instead set them as bindings within the scope of the module.

  treatAllNodesAsDirty = dirtyType === FULL_RECONCILE;
  activeTextDirection = null;
  activeEditor$1 = editor;
  activeEditorConfig = editor._config;
  activeEditorNodes = editor._nodes;
  activeMutationListeners = activeEditor$1._listeners.mutation;
  activeDirtyElements = dirtyElements;
  activeDirtyLeaves = dirtyLeaves;
  activePrevNodeMap = prevEditorState._nodeMap;
  activeNextNodeMap = nextEditorState._nodeMap;
  activeEditorStateReadOnly = nextEditorState._readOnly;
  activePrevKeyToDOMMap = new Map(editor._keyToDOMMap); // We keep track of mutated nodes so we can trigger mutation
  // listeners later in the update cycle.

  const currentMutatedNodes = new Map();
  mutatedNodes = currentMutatedNodes;
  reconcileNode('root', null); // We don't want a bunch of void checks throughout the scope
  // so instead we make it seem that these values are always set.
  // We also want to make sure we clear them down, otherwise we
  // can leak memory.
  // @ts-ignore

  activeEditor$1 = undefined; // @ts-ignore

  activeEditorNodes = undefined; // @ts-ignore

  activeDirtyElements = undefined; // @ts-ignore

  activeDirtyLeaves = undefined; // @ts-ignore

  activePrevNodeMap = undefined; // @ts-ignore

  activeNextNodeMap = undefined; // @ts-ignore

  activeEditorConfig = undefined; // @ts-ignore

  activePrevKeyToDOMMap = undefined; // @ts-ignore

  mutatedNodes = undefined;
  return currentMutatedNodes;
}
function storeDOMWithKey(key, dom, editor) {
  const keyToDOMMap = editor._keyToDOMMap; // @ts-ignore We intentionally add this to the Node.

  dom['__lexicalKey_' + editor._key] = key;
  keyToDOMMap.set(key, dom);
}

function getPrevElementByKeyOrThrow(key) {
  const element = activePrevKeyToDOMMap.get(key);

  if (element === undefined) {
    {
      throw Error(`Reconciliation: could not find DOM element for node key ${key}`);
    }
  }

  return element;
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const PASS_THROUGH_COMMAND = Object.freeze({});
const ANDROID_COMPOSITION_LATENCY = 30;
const rootElementEvents = [['keydown', onKeyDown], ['pointerdown', onPointerDown], ['compositionstart', onCompositionStart], ['compositionend', onCompositionEnd], ['input', onInput], ['click', onClick], ['cut', PASS_THROUGH_COMMAND], ['copy', PASS_THROUGH_COMMAND], ['dragstart', PASS_THROUGH_COMMAND], ['dragover', PASS_THROUGH_COMMAND], ['dragend', PASS_THROUGH_COMMAND], ['paste', PASS_THROUGH_COMMAND], ['focus', PASS_THROUGH_COMMAND], ['blur', PASS_THROUGH_COMMAND], ['drop', PASS_THROUGH_COMMAND]];

if (CAN_USE_BEFORE_INPUT$1) {
  rootElementEvents.push(['beforeinput', (event, editor) => onBeforeInput(event, editor)]);
}

let lastKeyDownTimeStamp = 0;
let lastKeyCode = 0;
let lastBeforeInputInsertTextTimeStamp = 0;
let unprocessedBeforeInputData = null;
let rootElementsRegistered = 0;
let isSelectionChangeFromDOMUpdate = false;
let isSelectionChangeFromMouseDown = false;
let isInsertLineBreak = false;
let isFirefoxEndingComposition = false;
let collapsedSelectionFormat = [0, '', 0, 'root', 0]; // This function is used to determine if Lexical should attempt to override
// the default browser behavior for insertion of text and use its own internal
// heuristics. This is an extremely important function, and makes much of Lexical
// work as intended between different browsers and across word, line and character
// boundary/formats. It also is important for text replacement, node schemas and
// composition mechanics.

function $shouldPreventDefaultAndInsertText(selection, domTargetRange, text, timeStamp, isBeforeInput) {
  const anchor = selection.anchor;
  const focus = selection.focus;
  const anchorNode = anchor.getNode();
  const editor = getActiveEditor();
  const domSelection = getDOMSelection(editor._window);
  const domAnchorNode = domSelection !== null ? domSelection.anchorNode : null;
  const anchorKey = anchor.key;
  const backingAnchorElement = editor.getElementByKey(anchorKey);
  const textLength = text.length;
  return anchorKey !== focus.key || // If we're working with a non-text node.
  !$isTextNode$1(anchorNode) || // If we are replacing a range with a single character or grapheme, and not composing.
  (!isBeforeInput && (!CAN_USE_BEFORE_INPUT$1 || // We check to see if there has been
  // a recent beforeinput event for "textInput". If there has been one in the last
  // 50ms then we proceed as normal. However, if there is not, then this is likely
  // a dangling `input` event caused by execCommand('insertText').
  lastBeforeInputInsertTextTimeStamp < timeStamp + 50) || anchorNode.isDirty() && textLength < 2 || doesContainGrapheme(text)) && anchor.offset !== focus.offset && !anchorNode.isComposing() || // Any non standard text node.
  $isTokenOrSegmented(anchorNode) || // If the text length is more than a single character and we're either
  // dealing with this in "beforeinput" or where the node has already recently
  // been changed (thus is dirty).
  anchorNode.isDirty() && textLength > 1 || // If the DOM selection element is not the same as the backing node during beforeinput.
  (isBeforeInput || !CAN_USE_BEFORE_INPUT$1) && backingAnchorElement !== null && !anchorNode.isComposing() && domAnchorNode !== getDOMTextNode$1(backingAnchorElement) || // If TargetRange is not the same as the DOM selection; browser trying to edit random parts
  // of the editor.
  domSelection !== null && domTargetRange !== null && (!domTargetRange.collapsed || domTargetRange.startContainer !== domSelection.anchorNode || domTargetRange.startOffset !== domSelection.anchorOffset) || // Check if we're changing from bold to italics, or some other format.
  anchorNode.getFormat() !== selection.format || anchorNode.getStyle() !== selection.style || // One last set of heuristics to check against.
  $shouldInsertTextAfterOrBeforeTextNode(selection, anchorNode);
}

function shouldSkipSelectionChange(domNode, offset) {
  return domNode !== null && domNode.nodeValue !== null && domNode.nodeType === DOM_TEXT_TYPE && offset !== 0 && offset !== domNode.nodeValue.length;
}

function onSelectionChange(domSelection, editor, isActive) {
  const {
    anchorNode: anchorDOM,
    anchorOffset,
    focusNode: focusDOM,
    focusOffset
  } = domSelection;

  if (isSelectionChangeFromDOMUpdate) {
    isSelectionChangeFromDOMUpdate = false; // If native DOM selection is on a DOM element, then
    // we should continue as usual, as Lexical's selection
    // may have normalized to a better child. If the DOM
    // element is a text node, we can safely apply this
    // optimization and skip the selection change entirely.
    // We also need to check if the offset is at the boundary,
    // because in this case, we might need to normalize to a
    // sibling instead.

    if (shouldSkipSelectionChange(anchorDOM, anchorOffset) && shouldSkipSelectionChange(focusDOM, focusOffset)) {
      return;
    }
  }

  updateEditor(editor, () => {
    // Non-active editor don't need any extra logic for selection, it only needs update
    // to reconcile selection (set it to null) to ensure that only one editor has non-null selection.
    if (!isActive) {
      $setSelection$1(null);
      return;
    }

    if (!isSelectionWithinEditor$1(editor, anchorDOM, focusDOM)) {
      return;
    }

    const selection = $getSelection$1(); // Update the selection format

    if ($isRangeSelection$1(selection)) {
      const anchor = selection.anchor;
      const anchorNode = anchor.getNode();

      if (selection.isCollapsed()) {
        // Badly interpreted range selection when collapsed - #1482
        if (domSelection.type === 'Range' && domSelection.anchorNode === domSelection.focusNode) {
          selection.dirty = true;
        } // If we have marked a collapsed selection format, and we're
        // within the given time range – then attempt to use that format
        // instead of getting the format from the anchor node.


        const windowEvent = getWindow(editor).event;
        const currentTimeStamp = windowEvent ? windowEvent.timeStamp : performance.now();
        const [lastFormat, lastStyle, lastOffset, lastKey, timeStamp] = collapsedSelectionFormat;

        if (currentTimeStamp < timeStamp + 200 && anchor.offset === lastOffset && anchor.key === lastKey) {
          selection.format = lastFormat;
          selection.style = lastStyle;
        } else {
          if (anchor.type === 'text') {
            selection.format = anchorNode.getFormat();
            selection.style = anchorNode.getStyle();
          } else if (anchor.type === 'element') {
            selection.format = 0;
            selection.style = '';
          }
        }
      } else {
        let combinedFormat = IS_ALL_FORMATTING;
        let hasTextNodes = false;
        const nodes = selection.getNodes();
        const nodesLength = nodes.length;

        for (let i = 0; i < nodesLength; i++) {
          const node = nodes[i];

          if ($isTextNode$1(node)) {
            // TODO: what about style?
            hasTextNodes = true;
            combinedFormat &= node.getFormat();

            if (combinedFormat === 0) {
              break;
            }
          }
        }

        selection.format = hasTextNodes ? combinedFormat : 0;
      }
    }

    dispatchCommand(editor, SELECTION_CHANGE_COMMAND$1, undefined);
  });
} // This is a work-around is mainly Chrome specific bug where if you select
// the contents of an empty block, you cannot easily unselect anything.
// This results in a tiny selection box that looks buggy/broken. This can
// also help other browsers when selection might "appear" lost, when it
// really isn't.


function onClick(event, editor) {
  updateEditor(editor, () => {
    const selection = $getSelection$1();
    const domSelection = getDOMSelection(editor._window);
    const lastSelection = $getPreviousSelection$1();

    if ($isRangeSelection$1(selection)) {
      const anchor = selection.anchor;
      const anchorNode = anchor.getNode();

      if (domSelection && anchor.type === 'element' && anchor.offset === 0 && selection.isCollapsed() && !$isRootNode$1(anchorNode) && $getRoot$1().getChildrenSize() === 1 && anchorNode.getTopLevelElementOrThrow().isEmpty() && lastSelection !== null && selection.is(lastSelection)) {
        domSelection.removeAllRanges();
        selection.dirty = true;
      }
    }

    dispatchCommand(editor, CLICK_COMMAND$1, event);
  });
}

function onPointerDown(event, editor) {
  // TODO implement text drag & drop
  const target = event.target;
  const pointerType = event.pointerType;

  if (target instanceof Node && pointerType !== 'touch') {
    updateEditor(editor, () => {
      // Drag & drop should not recompute selection until mouse up; otherwise the initially
      // selected content is lost.
      if (!$isSelectionCapturedInDecorator(target)) {
        isSelectionChangeFromMouseDown = true;
      }
    });
  }
}

function getTargetRange(event) {
  if (!event.getTargetRanges) {
    return null;
  }

  const targetRanges = event.getTargetRanges();

  if (targetRanges.length === 0) {
    return null;
  }

  return targetRanges[0];
}

function $canRemoveText(anchorNode, focusNode) {
  return anchorNode !== focusNode || $isElementNode$1(anchorNode) || $isElementNode$1(focusNode) || !anchorNode.isToken() || !focusNode.isToken();
}

function isPossiblyAndroidKeyPress(timeStamp) {
  return lastKeyCode === 229 && timeStamp < lastKeyDownTimeStamp + ANDROID_COMPOSITION_LATENCY;
}

function onBeforeInput(event, editor) {
  const inputType = event.inputType;
  const targetRange = getTargetRange(event); // We let the browser do its own thing for composition.

  if (inputType === 'deleteCompositionText' || // If we're pasting in FF, we shouldn't get this event
  // as the `paste` event should have triggered, unless the
  // user has dom.event.clipboardevents.enabled disabled in
  // about:config. In that case, we need to process the
  // pasted content in the DOM mutation phase.
  IS_FIREFOX && isFirefoxClipboardEvents(editor)) {
    return;
  } else if (inputType === 'insertCompositionText') {
    return;
  }

  updateEditor(editor, () => {
    const selection = $getSelection$1();

    if (inputType === 'deleteContentBackward') {
      if (selection === null) {
        // Use previous selection
        const prevSelection = $getPreviousSelection$1();

        if (!$isRangeSelection$1(prevSelection)) {
          return;
        }

        $setSelection$1(prevSelection.clone());
      }

      if ($isRangeSelection$1(selection)) {
        // Used for handling backspace in Android.
        if (isPossiblyAndroidKeyPress(event.timeStamp) && editor.isComposing() && selection.anchor.key === selection.focus.key) {
          $setCompositionKey$1(null);
          lastKeyDownTimeStamp = 0; // Fixes an Android bug where selection flickers when backspacing

          setTimeout(() => {
            updateEditor(editor, () => {
              $setCompositionKey$1(null);
            });
          }, ANDROID_COMPOSITION_LATENCY);

          if ($isRangeSelection$1(selection)) {
            const anchorNode = selection.anchor.getNode();
            anchorNode.markDirty();
            selection.format = anchorNode.getFormat();
            selection.style = anchorNode.getStyle();
          }
        } else {
          event.preventDefault();
          dispatchCommand(editor, DELETE_CHARACTER_COMMAND$1, true);
        }

        return;
      }
    }

    if (!$isRangeSelection$1(selection)) {
      return;
    }

    const data = event.data; // This represents the case when two beforeinput events are triggered at the same time (without a
    // full event loop ending at input). This happens with MacOS with the default keyboard settings,
    // a combination of autocorrection + autocapitalization.
    // Having Lexical run everything in controlled mode would fix the issue without additional code
    // but this would kill the massive performance win from the most common typing event.
    // Alternatively, when this happens we can prematurely update our EditorState based on the DOM
    // content, a job that would usually be the input event's responsibility.

    if (unprocessedBeforeInputData !== null) {
      $updateSelectedTextFromDOM(false, editor, unprocessedBeforeInputData);
    }

    if ((!selection.dirty || unprocessedBeforeInputData !== null) && selection.isCollapsed() && !$isRootNode$1(selection.anchor.getNode()) && targetRange !== null) {
      selection.applyDOMRange(targetRange);
    }

    unprocessedBeforeInputData = null;
    const anchor = selection.anchor;
    const focus = selection.focus;
    const anchorNode = anchor.getNode();
    const focusNode = focus.getNode();

    if (inputType === 'insertText' || inputType === 'insertTranspose') {
      if (data === '\n') {
        event.preventDefault();
        dispatchCommand(editor, INSERT_LINE_BREAK_COMMAND$1, false);
      } else if (data === DOUBLE_LINE_BREAK) {
        event.preventDefault();
        dispatchCommand(editor, INSERT_PARAGRAPH_COMMAND$1, undefined);
      } else if (data == null && event.dataTransfer) {
        // Gets around a Safari text replacement bug.
        const text = event.dataTransfer.getData('text/plain');
        event.preventDefault();
        selection.insertRawText(text);
      } else if (data != null && $shouldPreventDefaultAndInsertText(selection, targetRange, data, event.timeStamp, true)) {
        event.preventDefault();
        dispatchCommand(editor, CONTROLLED_TEXT_INSERTION_COMMAND$1, data);
      } else {
        unprocessedBeforeInputData = data;
      }

      lastBeforeInputInsertTextTimeStamp = event.timeStamp;
      return;
    } // Prevent the browser from carrying out
    // the input event, so we can control the
    // output.


    event.preventDefault();

    switch (inputType) {
      case 'insertFromYank':
      case 'insertFromDrop':
      case 'insertReplacementText':
        {
          dispatchCommand(editor, CONTROLLED_TEXT_INSERTION_COMMAND$1, event);
          break;
        }

      case 'insertFromComposition':
        {
          // This is the end of composition
          $setCompositionKey$1(null);
          dispatchCommand(editor, CONTROLLED_TEXT_INSERTION_COMMAND$1, event);
          break;
        }

      case 'insertLineBreak':
        {
          // Used for Android
          $setCompositionKey$1(null);
          dispatchCommand(editor, INSERT_LINE_BREAK_COMMAND$1, false);
          break;
        }

      case 'insertParagraph':
        {
          // Used for Android
          $setCompositionKey$1(null); // Some browsers do not provide the type "insertLineBreak".
          // So instead, we need to infer it from the keyboard event.

          if (isInsertLineBreak) {
            isInsertLineBreak = false;
            dispatchCommand(editor, INSERT_LINE_BREAK_COMMAND$1, false);
          } else {
            dispatchCommand(editor, INSERT_PARAGRAPH_COMMAND$1, undefined);
          }

          break;
        }

      case 'insertFromPaste':
      case 'insertFromPasteAsQuotation':
        {
          dispatchCommand(editor, PASTE_COMMAND$1, event);
          break;
        }

      case 'deleteByComposition':
        {
          if ($canRemoveText(anchorNode, focusNode)) {
            dispatchCommand(editor, REMOVE_TEXT_COMMAND$1, undefined);
          }

          break;
        }

      case 'deleteByDrag':
      case 'deleteByCut':
        {
          dispatchCommand(editor, REMOVE_TEXT_COMMAND$1, undefined);
          break;
        }

      case 'deleteContent':
        {
          dispatchCommand(editor, DELETE_CHARACTER_COMMAND$1, false);
          break;
        }

      case 'deleteWordBackward':
        {
          dispatchCommand(editor, DELETE_WORD_COMMAND$1, true);
          break;
        }

      case 'deleteWordForward':
        {
          dispatchCommand(editor, DELETE_WORD_COMMAND$1, false);
          break;
        }

      case 'deleteHardLineBackward':
      case 'deleteSoftLineBackward':
        {
          dispatchCommand(editor, DELETE_LINE_COMMAND$1, true);
          break;
        }

      case 'deleteContentForward':
      case 'deleteHardLineForward':
      case 'deleteSoftLineForward':
        {
          dispatchCommand(editor, DELETE_LINE_COMMAND$1, false);
          break;
        }

      case 'formatStrikeThrough':
        {
          dispatchCommand(editor, FORMAT_TEXT_COMMAND$1, 'strikethrough');
          break;
        }

      case 'formatBold':
        {
          dispatchCommand(editor, FORMAT_TEXT_COMMAND$1, 'bold');
          break;
        }

      case 'formatItalic':
        {
          dispatchCommand(editor, FORMAT_TEXT_COMMAND$1, 'italic');
          break;
        }

      case 'formatUnderline':
        {
          dispatchCommand(editor, FORMAT_TEXT_COMMAND$1, 'underline');
          break;
        }

      case 'historyUndo':
        {
          dispatchCommand(editor, UNDO_COMMAND$1, undefined);
          break;
        }

      case 'historyRedo':
        {
          dispatchCommand(editor, REDO_COMMAND$1, undefined);
          break;
        }

    }
  });
}

function onInput(event, editor) {
  // We don't want the onInput to bubble, in the case of nested editors.
  event.stopPropagation();
  updateEditor(editor, () => {
    const selection = $getSelection$1();
    const data = event.data;
    const targetRange = getTargetRange(event);

    if (data != null && $isRangeSelection$1(selection) && $shouldPreventDefaultAndInsertText(selection, targetRange, data, event.timeStamp, false)) {
      // Given we're over-riding the default behavior, we will need
      // to ensure to disable composition before dispatching the
      // insertText command for when changing the sequence for FF.
      if (isFirefoxEndingComposition) {
        onCompositionEndImpl(editor, data);
        isFirefoxEndingComposition = false;
      }

      const anchor = selection.anchor;
      const anchorNode = anchor.getNode();
      const domSelection = getDOMSelection(editor._window);

      if (domSelection === null) {
        return;
      }

      const offset = anchor.offset; // If the content is the same as inserted, then don't dispatch an insertion.
      // Given onInput doesn't take the current selection (it uses the previous)
      // we can compare that against what the DOM currently says.

      if (!CAN_USE_BEFORE_INPUT$1 || selection.isCollapsed() || !$isTextNode$1(anchorNode) || domSelection.anchorNode === null || anchorNode.getTextContent().slice(0, offset) + data + anchorNode.getTextContent().slice(offset + selection.focus.offset) !== getAnchorTextFromDOM(domSelection.anchorNode)) {
        dispatchCommand(editor, CONTROLLED_TEXT_INSERTION_COMMAND$1, data);
      }

      const textLength = data.length; // Another hack for FF, as it's possible that the IME is still
      // open, even though compositionend has already fired (sigh).

      if (IS_FIREFOX && textLength > 1 && event.inputType === 'insertCompositionText' && !editor.isComposing()) {
        selection.anchor.offset -= textLength;
      } // This ensures consistency on Android.


      if (!IS_SAFARI$2 && !IS_IOS$2 && !IS_APPLE_WEBKIT$2 && editor.isComposing()) {
        lastKeyDownTimeStamp = 0;
        $setCompositionKey$1(null);
      }
    } else {
      const characterData = data !== null ? data : undefined;
      $updateSelectedTextFromDOM(false, editor, characterData); // onInput always fires after onCompositionEnd for FF.

      if (isFirefoxEndingComposition) {
        onCompositionEndImpl(editor, data || undefined);
        isFirefoxEndingComposition = false;
      }
    } // Also flush any other mutations that might have occurred
    // since the change.


    $flushMutations();
  });
  unprocessedBeforeInputData = null;
}

function onCompositionStart(event, editor) {
  updateEditor(editor, () => {
    const selection = $getSelection$1();

    if ($isRangeSelection$1(selection) && !editor.isComposing()) {
      const anchor = selection.anchor;
      const node = selection.anchor.getNode();
      $setCompositionKey$1(anchor.key);

      if ( // If it has been 30ms since the last keydown, then we should
      // apply the empty space heuristic. We can't do this for Safari,
      // as the keydown fires after composition start.
      event.timeStamp < lastKeyDownTimeStamp + ANDROID_COMPOSITION_LATENCY || // FF has issues around composing multibyte characters, so we also
      // need to invoke the empty space heuristic below.
      anchor.type === 'element' || !selection.isCollapsed() || node.getFormat() !== selection.format || node.getStyle() !== selection.style) {
        // We insert a zero width character, ready for the composition
        // to get inserted into the new node we create. If
        // we don't do this, Safari will fail on us because
        // there is no text node matching the selection.
        dispatchCommand(editor, CONTROLLED_TEXT_INSERTION_COMMAND$1, COMPOSITION_START_CHAR);
      }
    }
  });
}

function onCompositionEndImpl(editor, data) {
  const compositionKey = editor._compositionKey;
  $setCompositionKey$1(null); // Handle termination of composition.

  if (compositionKey !== null && data != null) {
    // Composition can sometimes move to an adjacent DOM node when backspacing.
    // So check for the empty case.
    if (data === '') {
      const node = $getNodeByKey$1(compositionKey);
      const textNode = getDOMTextNode$1(editor.getElementByKey(compositionKey));

      if (textNode !== null && textNode.nodeValue !== null && $isTextNode$1(node)) {
        $updateTextNodeFromDOMContent(node, textNode.nodeValue, null, null, true);
      }

      return;
    } // Composition can sometimes be that of a new line. In which case, we need to
    // handle that accordingly.


    if (data[data.length - 1] === '\n') {
      const selection = $getSelection$1();

      if ($isRangeSelection$1(selection)) {
        // If the last character is a line break, we also need to insert
        // a line break.
        const focus = selection.focus;
        selection.anchor.set(focus.key, focus.offset, focus.type);
        dispatchCommand(editor, KEY_ENTER_COMMAND$1, null);
        return;
      }
    }
  }

  $updateSelectedTextFromDOM(true, editor, data);
}

function onCompositionEnd(event, editor) {
  // Firefox fires onCompositionEnd before onInput, but Chrome/Webkit,
  // fire onInput before onCompositionEnd. To ensure the sequence works
  // like Chrome/Webkit we use the isFirefoxEndingComposition flag to
  // defer handling of onCompositionEnd in Firefox till we have processed
  // the logic in onInput.
  if (IS_FIREFOX) {
    isFirefoxEndingComposition = true;
  } else {
    updateEditor(editor, () => {
      onCompositionEndImpl(editor, event.data);
    });
  }
}

function onKeyDown(event, editor) {
  lastKeyDownTimeStamp = event.timeStamp;
  lastKeyCode = event.keyCode;

  if (editor.isComposing()) {
    return;
  }

  const {
    keyCode,
    shiftKey,
    ctrlKey,
    metaKey,
    altKey
  } = event;

  if (dispatchCommand(editor, KEY_DOWN_COMMAND$1, event)) {
    return;
  }

  if (isMoveForward(keyCode, ctrlKey, altKey, metaKey)) {
    dispatchCommand(editor, KEY_ARROW_RIGHT_COMMAND$1, event);
  } else if (isMoveToEnd(keyCode, ctrlKey, shiftKey, altKey, metaKey)) {
    dispatchCommand(editor, MOVE_TO_END$1, event);
  } else if (isMoveBackward(keyCode, ctrlKey, altKey, metaKey)) {
    dispatchCommand(editor, KEY_ARROW_LEFT_COMMAND$1, event);
  } else if (isMoveToStart(keyCode, ctrlKey, shiftKey, altKey, metaKey)) {
    dispatchCommand(editor, MOVE_TO_START$1, event);
  } else if (isMoveUp(keyCode, ctrlKey, metaKey)) {
    dispatchCommand(editor, KEY_ARROW_UP_COMMAND$1, event);
  } else if (isMoveDown(keyCode, ctrlKey, metaKey)) {
    dispatchCommand(editor, KEY_ARROW_DOWN_COMMAND$1, event);
  } else if (isLineBreak(keyCode, shiftKey)) {
    isInsertLineBreak = true;
    dispatchCommand(editor, KEY_ENTER_COMMAND$1, event);
  } else if (isSpace(keyCode)) {
    dispatchCommand(editor, KEY_SPACE_COMMAND$1, event);
  } else if (isOpenLineBreak(keyCode, ctrlKey)) {
    event.preventDefault();
    isInsertLineBreak = true;
    dispatchCommand(editor, INSERT_LINE_BREAK_COMMAND$1, true);
  } else if (isParagraph(keyCode, shiftKey)) {
    isInsertLineBreak = false;
    dispatchCommand(editor, KEY_ENTER_COMMAND$1, event);
  } else if (isDeleteBackward(keyCode, altKey, metaKey, ctrlKey)) {
    if (isBackspace(keyCode)) {
      dispatchCommand(editor, KEY_BACKSPACE_COMMAND$1, event);
    } else {
      event.preventDefault();
      dispatchCommand(editor, DELETE_CHARACTER_COMMAND$1, true);
    }
  } else if (isEscape(keyCode)) {
    dispatchCommand(editor, KEY_ESCAPE_COMMAND$1, event);
  } else if (isDeleteForward(keyCode, ctrlKey, shiftKey, altKey, metaKey)) {
    if (isDelete(keyCode)) {
      dispatchCommand(editor, KEY_DELETE_COMMAND$1, event);
    } else {
      event.preventDefault();
      dispatchCommand(editor, DELETE_CHARACTER_COMMAND$1, false);
    }
  } else if (isDeleteWordBackward(keyCode, altKey, ctrlKey)) {
    event.preventDefault();
    dispatchCommand(editor, DELETE_WORD_COMMAND$1, true);
  } else if (isDeleteWordForward(keyCode, altKey, ctrlKey)) {
    event.preventDefault();
    dispatchCommand(editor, DELETE_WORD_COMMAND$1, false);
  } else if (isDeleteLineBackward(keyCode, metaKey)) {
    event.preventDefault();
    dispatchCommand(editor, DELETE_LINE_COMMAND$1, true);
  } else if (isDeleteLineForward(keyCode, metaKey)) {
    event.preventDefault();
    dispatchCommand(editor, DELETE_LINE_COMMAND$1, false);
  } else if (isBold(keyCode, altKey, metaKey, ctrlKey)) {
    event.preventDefault();
    dispatchCommand(editor, FORMAT_TEXT_COMMAND$1, 'bold');
  } else if (isUnderline(keyCode, altKey, metaKey, ctrlKey)) {
    event.preventDefault();
    dispatchCommand(editor, FORMAT_TEXT_COMMAND$1, 'underline');
  } else if (isItalic(keyCode, altKey, metaKey, ctrlKey)) {
    event.preventDefault();
    dispatchCommand(editor, FORMAT_TEXT_COMMAND$1, 'italic');
  } else if (isTab(keyCode, altKey, ctrlKey, metaKey)) {
    dispatchCommand(editor, KEY_TAB_COMMAND$1, event);
  } else if (isUndo(keyCode, shiftKey, metaKey, ctrlKey)) {
    event.preventDefault();
    dispatchCommand(editor, UNDO_COMMAND$1, undefined);
  } else if (isRedo(keyCode, shiftKey, metaKey, ctrlKey)) {
    event.preventDefault();
    dispatchCommand(editor, REDO_COMMAND$1, undefined);
  } else {
    const prevSelection = editor._editorState._selection;

    if ($isNodeSelection$1(prevSelection)) {
      if (isCopy(keyCode, shiftKey, metaKey, ctrlKey)) {
        event.preventDefault();
        dispatchCommand(editor, COPY_COMMAND$1, event);
      } else if (isCut(keyCode, shiftKey, metaKey, ctrlKey)) {
        event.preventDefault();
        dispatchCommand(editor, CUT_COMMAND$1, event);
      } else if (isSelectAll(keyCode, metaKey, ctrlKey)) {
        event.preventDefault();
        editor.update(() => {
          const root = $getRoot$1();
          root.select(0, root.getChildrenSize());
        });
      }
    }
  }

  if (isModifier(ctrlKey, shiftKey, altKey, metaKey)) {
    dispatchCommand(editor, KEY_MODIFIER_COMMAND$1, event);
  }
}

function getRootElementRemoveHandles(rootElement) {
  // @ts-expect-error: internal field
  let eventHandles = rootElement.__lexicalEventHandles;

  if (eventHandles === undefined) {
    eventHandles = []; // @ts-expect-error: internal field

    rootElement.__lexicalEventHandles = eventHandles;
  }

  return eventHandles;
} // Mapping root editors to their active nested editors, contains nested editors
// mapping only, so if root editor is selected map will have no reference to free up memory


const activeNestedEditorsMap = new Map();

function onDocumentSelectionChange(event) {
  const target = event.target;
  const targetWindow = target == null ? null : target.nodeType === 9 ? target.defaultView : target.ownerDocument.defaultView;
  const domSelection = getDOMSelection(targetWindow);

  if (domSelection === null) {
    return;
  }

  const nextActiveEditor = getNearestEditorFromDOMNode$1(domSelection.anchorNode);

  if (nextActiveEditor === null) {
    return;
  }

  if (isSelectionChangeFromMouseDown) {
    isSelectionChangeFromMouseDown = false;
    updateEditor(nextActiveEditor, () => {
      const lastSelection = $getPreviousSelection$1();
      const domAnchorNode = domSelection.anchorNode;

      if (domAnchorNode === null) {
        return;
      }

      const nodeType = domAnchorNode.nodeType; // If the user is attempting to click selection back onto text, then
      // we should attempt create a range selection.
      // When we click on an empty paragraph node or the end of a paragraph that ends
      // with an image/poll, the nodeType will be ELEMENT_NODE

      if (nodeType !== DOM_ELEMENT_TYPE && nodeType !== DOM_TEXT_TYPE) {
        return;
      }

      const newSelection = internalCreateRangeSelection(lastSelection, domSelection, nextActiveEditor);
      $setSelection$1(newSelection);
    });
  } // When editor receives selection change event, we're checking if
  // it has any sibling editors (within same parent editor) that were active
  // before, and trigger selection change on it to nullify selection.


  const editors = getEditorsToPropagate(nextActiveEditor);
  const rootEditor = editors[editors.length - 1];
  const rootEditorKey = rootEditor._key;
  const activeNestedEditor = activeNestedEditorsMap.get(rootEditorKey);
  const prevActiveEditor = activeNestedEditor || rootEditor;

  if (prevActiveEditor !== nextActiveEditor) {
    onSelectionChange(domSelection, prevActiveEditor, false);
  }

  onSelectionChange(domSelection, nextActiveEditor, true); // If newly selected editor is nested, then add it to the map, clean map otherwise

  if (nextActiveEditor !== rootEditor) {
    activeNestedEditorsMap.set(rootEditorKey, nextActiveEditor);
  } else if (activeNestedEditor) {
    activeNestedEditorsMap.delete(rootEditorKey);
  }
}

function stopLexicalPropagation(event) {
  // We attach a special property to ensure the same event doesn't re-fire
  // for parent editors.
  // @ts-ignore
  event._lexicalHandled = true;
}

function hasStoppedLexicalPropagation(event) {
  // @ts-ignore
  const stopped = event._lexicalHandled === true;
  return stopped;
}

function addRootElementEvents(rootElement, editor) {
  // We only want to have a single global selectionchange event handler, shared
  // between all editor instances.
  if (rootElementsRegistered === 0) {
    const doc = rootElement.ownerDocument;
    doc.addEventListener('selectionchange', onDocumentSelectionChange);
  }

  rootElementsRegistered++; // @ts-expect-error: internal field

  rootElement.__lexicalEditor = editor;
  const removeHandles = getRootElementRemoveHandles(rootElement);

  for (let i = 0; i < rootElementEvents.length; i++) {
    const [eventName, onEvent] = rootElementEvents[i];
    const eventHandler = typeof onEvent === 'function' ? event => {
      if (hasStoppedLexicalPropagation(event)) {
        return;
      }

      stopLexicalPropagation(event);

      if (editor.isEditable()) {
        onEvent(event, editor);
      }
    } : event => {
      if (hasStoppedLexicalPropagation(event)) {
        return;
      }

      stopLexicalPropagation(event);

      if (editor.isEditable()) {
        switch (eventName) {
          case 'cut':
            return dispatchCommand(editor, CUT_COMMAND$1, event);

          case 'copy':
            return dispatchCommand(editor, COPY_COMMAND$1, event);

          case 'paste':
            return dispatchCommand(editor, PASTE_COMMAND$1, event);

          case 'dragstart':
            return dispatchCommand(editor, DRAGSTART_COMMAND$1, event);

          case 'dragover':
            return dispatchCommand(editor, DRAGOVER_COMMAND$1, event);

          case 'dragend':
            return dispatchCommand(editor, DRAGEND_COMMAND$1, event);

          case 'focus':
            return dispatchCommand(editor, FOCUS_COMMAND$1, event);

          case 'blur':
            {
              return dispatchCommand(editor, BLUR_COMMAND$1, event);
            }

          case 'drop':
            return dispatchCommand(editor, DROP_COMMAND$1, event);
        }
      }
    };
    rootElement.addEventListener(eventName, eventHandler);
    removeHandles.push(() => {
      rootElement.removeEventListener(eventName, eventHandler);
    });
  }
}
function removeRootElementEvents(rootElement) {
  if (rootElementsRegistered !== 0) {
    rootElementsRegistered--; // We only want to have a single global selectionchange event handler, shared
    // between all editor instances.

    if (rootElementsRegistered === 0) {
      const doc = rootElement.ownerDocument;
      doc.removeEventListener('selectionchange', onDocumentSelectionChange);
    }
  } // @ts-expect-error: internal field


  const editor = rootElement.__lexicalEditor;

  if (editor !== null && editor !== undefined) {
    cleanActiveNestedEditorsMap(editor); // @ts-expect-error: internal field

    rootElement.__lexicalEditor = null;
  }

  const removeHandles = getRootElementRemoveHandles(rootElement);

  for (let i = 0; i < removeHandles.length; i++) {
    removeHandles[i]();
  } // @ts-expect-error: internal field


  rootElement.__lexicalEventHandles = [];
}

function cleanActiveNestedEditorsMap(editor) {
  if (editor._parentEditor !== null) {
    // For nested editor cleanup map if this editor was marked as active
    const editors = getEditorsToPropagate(editor);
    const rootEditor = editors[editors.length - 1];
    const rootEditorKey = rootEditor._key;

    if (activeNestedEditorsMap.get(rootEditorKey) === editor) {
      activeNestedEditorsMap.delete(rootEditorKey);
    }
  } else {
    // For top-level editors cleanup map
    activeNestedEditorsMap.delete(editor._key);
  }
}

function markSelectionChangeFromDOMUpdate() {
  isSelectionChangeFromDOMUpdate = true;
}
function markCollapsedSelectionFormat(format, style, offset, key, timeStamp) {
  collapsedSelectionFormat = [format, style, offset, key, timeStamp];
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
function removeNode(nodeToRemove, restoreSelection, preserveEmptyParent) {
  errorOnReadOnly();
  const key = nodeToRemove.__key;
  const parent = nodeToRemove.getParent();

  if (parent === null) {
    return;
  }

  const selection = $maybeMoveChildrenSelectionToParent(nodeToRemove);
  let selectionMoved = false;

  if ($isRangeSelection$1(selection) && restoreSelection) {
    const anchor = selection.anchor;
    const focus = selection.focus;

    if (anchor.key === key) {
      moveSelectionPointToSibling(anchor, nodeToRemove, parent, nodeToRemove.getPreviousSibling(), nodeToRemove.getNextSibling());
      selectionMoved = true;
    }

    if (focus.key === key) {
      moveSelectionPointToSibling(focus, nodeToRemove, parent, nodeToRemove.getPreviousSibling(), nodeToRemove.getNextSibling());
      selectionMoved = true;
    }
  }

  if ($isRangeSelection$1(selection) && restoreSelection && !selectionMoved) {
    // Doing this is O(n) so lets avoid it unless we need to do it
    const index = nodeToRemove.getIndexWithinParent();
    removeFromParent(nodeToRemove);
    $updateElementSelectionOnCreateDeleteNode(selection, parent, index, -1);
  } else {
    removeFromParent(nodeToRemove);
  }

  if (!preserveEmptyParent && !$isRootOrShadowRoot$1(parent) && !parent.canBeEmpty() && parent.isEmpty()) {
    removeNode(parent, restoreSelection);
  }

  if (restoreSelection && $isRootNode$1(parent) && parent.isEmpty()) {
    parent.selectEnd();
  }
}
class LexicalNode {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // Flow doesn't support abstract classes unfortunately, so we can't _force_
  // subclasses of Node to implement statics. All subclasses of Node should have
  // a static getType and clone method though. We define getType and clone here so we can call it
  // on any  Node, and we throw this error by default since the subclass should provide
  // their own implementation.

  /**
   * Returns the string type of this node. Every node must
   * implement this and it MUST BE UNIQUE amongst nodes registered
   * on the editor.
   *
   */
  static getType() {
    {
      throw Error(`LexicalNode: Node ${this.name} does not implement .getType().`);
    }
  }
  /**
   * Clones this node, creating a new node with a different key
   * and adding it to the EditorState (but not attaching it anywhere!). All nodes must
   * implement this method.
   *
   */


  static clone(_data) {
    {
      throw Error(`LexicalNode: Node ${this.name} does not implement .clone().`);
    }
  }

  constructor(key) {
    // @ts-expect-error
    this.__type = this.constructor.getType();
    this.__parent = null;
    this.__prev = null;
    this.__next = null;
    $setNodeKey(this, key);

    {
      if (this.__type !== 'root') {
        errorOnReadOnly();
        errorOnTypeKlassMismatch(this.__type, // @ts-expect-error
        this.constructor);
      }
    }
  } // Getters and Traversers

  /**
   * Returns the string type of this node.
   */


  getType() {
    return this.__type;
  }
  /**
   * Returns true if there is a path between this node and the RootNode, false otherwise.
   * This is a way of determining if the node is "attached" EditorState. Unattached nodes
   * won't be reconciled and will ultimatelt be cleaned up by the Lexical GC.
   */


  isAttached() {
    let nodeKey = this.__key;

    while (nodeKey !== null) {
      if (nodeKey === 'root') {
        return true;
      }

      const node = $getNodeByKey$1(nodeKey);

      if (node === null) {
        break;
      }

      nodeKey = node.__parent;
    }

    return false;
  }
  /**
   * Returns true if this node is contained within the provided Selection., false otherwise.
   * Relies on the algorithms implemented in {@link BaseSelection.getNodes} to determine
   * what's included.
   *
   * @param selection - The selection that we want to determine if the node is in.
   */


  isSelected(selection) {
    const targetSelection = selection || $getSelection$1();

    if (targetSelection == null) {
      return false;
    }

    const isSelected = targetSelection.getNodes().some(n => n.__key === this.__key);

    if ($isTextNode$1(this)) {
      return isSelected;
    } // For inline images inside of element nodes.
    // Without this change the image will be selected if the cursor is before or after it.


    if ($isRangeSelection$1(targetSelection) && targetSelection.anchor.type === 'element' && targetSelection.focus.type === 'element' && targetSelection.anchor.key === targetSelection.focus.key && targetSelection.anchor.offset === targetSelection.focus.offset) {
      return false;
    }

    return isSelected;
  }
  /**
   * Returns this nodes key.
   */


  getKey() {
    // Key is stable between copies
    return this.__key;
  }
  /**
   * Returns the zero-based index of this node within the parent.
   */


  getIndexWithinParent() {
    const parent = this.getParent();

    if (parent === null) {
      return -1;
    }

    let node = parent.getFirstChild();
    let index = 0;

    while (node !== null) {
      if (this.is(node)) {
        return index;
      }

      index++;
      node = node.getNextSibling();
    }

    return -1;
  }
  /**
   * Returns the parent of this node, or null if none is found.
   */


  getParent() {
    const parent = this.getLatest().__parent;

    if (parent === null) {
      return null;
    }

    return $getNodeByKey$1(parent);
  }
  /**
   * Returns the parent of this node, or throws if none is found.
   */


  getParentOrThrow() {
    const parent = this.getParent();

    if (parent === null) {
      {
        throw Error(`Expected node ${this.__key} to have a parent.`);
      }
    }

    return parent;
  }
  /**
   * Returns the highest (in the EditorState tree)
   * non-root ancestor of this node, or null if none is found. See {@link lexical!$isRootOrShadowRoot}
   * for more information on which Elements comprise "roots".
   */


  getTopLevelElement() {
    let node = this;

    while (node !== null) {
      const parent = node.getParent();

      if ($isRootOrShadowRoot$1(parent)) {
        return node;
      }

      node = parent;
    }

    return null;
  }
  /**
   * Returns the highest (in the EditorState tree)
   * non-root ancestor of this node, or throws if none is found. See {@link lexical!$isRootOrShadowRoot}
   * for more information on which Elements comprise "roots".
   */


  getTopLevelElementOrThrow() {
    const parent = this.getTopLevelElement();

    if (parent === null) {
      {
        throw Error(`Expected node ${this.__key} to have a top parent element.`);
      }
    }

    return parent;
  }
  /**
   * Returns a list of the every ancestor of this node,
   * all the way up to the RootNode.
   *
   */


  getParents() {
    const parents = [];
    let node = this.getParent();

    while (node !== null) {
      parents.push(node);
      node = node.getParent();
    }

    return parents;
  }
  /**
   * Returns a list of the keys of every ancestor of this node,
   * all the way up to the RootNode.
   *
   */


  getParentKeys() {
    const parents = [];
    let node = this.getParent();

    while (node !== null) {
      parents.push(node.__key);
      node = node.getParent();
    }

    return parents;
  }
  /**
   * Returns the "previous" siblings - that is, the node that comes
   * before this one in the same parent.
   *
   */


  getPreviousSibling() {
    const self = this.getLatest();
    const prevKey = self.__prev;
    return prevKey === null ? null : $getNodeByKey$1(prevKey);
  }
  /**
   * Returns the "previous" siblings - that is, the nodes that come between
   * this one and the first child of it's parent, inclusive.
   *
   */


  getPreviousSiblings() {
    const siblings = [];
    const parent = this.getParent();

    if (parent === null) {
      return siblings;
    }

    let node = parent.getFirstChild();

    while (node !== null) {
      if (node.is(this)) {
        break;
      }

      siblings.push(node);
      node = node.getNextSibling();
    }

    return siblings;
  }
  /**
   * Returns the "next" siblings - that is, the node that comes
   * after this one in the same parent
   *
   */


  getNextSibling() {
    const self = this.getLatest();
    const nextKey = self.__next;
    return nextKey === null ? null : $getNodeByKey$1(nextKey);
  }
  /**
   * Returns all "next" siblings - that is, the nodes that come between this
   * one and the last child of it's parent, inclusive.
   *
   */


  getNextSiblings() {
    const siblings = [];
    let node = this.getNextSibling();

    while (node !== null) {
      siblings.push(node);
      node = node.getNextSibling();
    }

    return siblings;
  }
  /**
   * Returns the closest common ancestor of this node and the provided one or null
   * if one cannot be found.
   *
   * @param node - the other node to find the common ancestor of.
   */


  getCommonAncestor(node) {
    const a = this.getParents();
    const b = node.getParents();

    if ($isElementNode$1(this)) {
      a.unshift(this);
    }

    if ($isElementNode$1(node)) {
      b.unshift(node);
    }

    const aLength = a.length;
    const bLength = b.length;

    if (aLength === 0 || bLength === 0 || a[aLength - 1] !== b[bLength - 1]) {
      return null;
    }

    const bSet = new Set(b);

    for (let i = 0; i < aLength; i++) {
      const ancestor = a[i];

      if (bSet.has(ancestor)) {
        return ancestor;
      }
    }

    return null;
  }
  /**
   * Returns true if the provided node is the exact same one as this node, from Lexical's perspective.
   * Always use this instead of referential equality.
   *
   * @param object - the node to perform the equality comparison on.
   */


  is(object) {
    if (object == null) {
      return false;
    }

    return this.__key === object.__key;
  }
  /**
   * Returns true if this node logical precedes the target node in the editor state.
   *
   * @param targetNode - the node we're testing to see if it's after this one.
   */


  isBefore(targetNode) {
    if (this === targetNode) {
      return false;
    }

    if (targetNode.isParentOf(this)) {
      return true;
    }

    if (this.isParentOf(targetNode)) {
      return false;
    }

    const commonAncestor = this.getCommonAncestor(targetNode);
    let indexA = 0;
    let indexB = 0;
    let node = this;

    while (true) {
      const parent = node.getParentOrThrow();

      if (parent === commonAncestor) {
        indexA = node.getIndexWithinParent();
        break;
      }

      node = parent;
    }

    node = targetNode;

    while (true) {
      const parent = node.getParentOrThrow();

      if (parent === commonAncestor) {
        indexB = node.getIndexWithinParent();
        break;
      }

      node = parent;
    }

    return indexA < indexB;
  }
  /**
   * Returns true if this node is the parent of the target node, false otherwise.
   *
   * @param targetNode - the would-be child node.
   */


  isParentOf(targetNode) {
    const key = this.__key;

    if (key === targetNode.__key) {
      return false;
    }

    let node = targetNode;

    while (node !== null) {
      if (node.__key === key) {
        return true;
      }

      node = node.getParent();
    }

    return false;
  } // TO-DO: this function can be simplified a lot

  /**
   * Returns a list of nodes that are between this node and
   * the target node in the EditorState.
   *
   * @param targetNode - the node that marks the other end of the range of nodes to be returned.
   */


  getNodesBetween(targetNode) {
    const isBefore = this.isBefore(targetNode);
    const nodes = [];
    const visited = new Set();
    let node = this;

    while (true) {
      const key = node.__key;

      if (!visited.has(key)) {
        visited.add(key);
        nodes.push(node);
      }

      if (node === targetNode) {
        break;
      }

      const child = $isElementNode$1(node) ? isBefore ? node.getFirstChild() : node.getLastChild() : null;

      if (child !== null) {
        node = child;
        continue;
      }

      const nextSibling = isBefore ? node.getNextSibling() : node.getPreviousSibling();

      if (nextSibling !== null) {
        node = nextSibling;
        continue;
      }

      const parent = node.getParentOrThrow();

      if (!visited.has(parent.__key)) {
        nodes.push(parent);
      }

      if (parent === targetNode) {
        break;
      }

      let parentSibling = null;
      let ancestor = parent;

      do {
        if (ancestor === null) {
          {
            throw Error(`getNodesBetween: ancestor is null`);
          }
        }

        parentSibling = isBefore ? ancestor.getNextSibling() : ancestor.getPreviousSibling();
        ancestor = ancestor.getParent();

        if (ancestor !== null) {
          if (parentSibling === null && !visited.has(ancestor.__key)) {
            nodes.push(ancestor);
          }
        }
      } while (parentSibling === null);

      node = parentSibling;
    }

    if (!isBefore) {
      nodes.reverse();
    }

    return nodes;
  }
  /**
   * Returns true if this node has been marked dirty during this update cycle.
   *
   */


  isDirty() {
    const editor = getActiveEditor();
    const dirtyLeaves = editor._dirtyLeaves;
    return dirtyLeaves !== null && dirtyLeaves.has(this.__key);
  }
  /**
   * Returns the latest version of the node from the active EditorState.
   * This is used to avoid getting values from stale node references.
   *
   */


  getLatest() {
    const latest = $getNodeByKey$1(this.__key);

    if (latest === null) {
      {
        throw Error(`Lexical node does not exist in active editor state. Avoid using the same node references between nested closures from editorState.read/editor.update.`);
      }
    }

    return latest;
  }
  /**
   * Returns a mutable version of the node. Will throw an error if
   * called outside of a Lexical Editor {@link LexicalEditor.update} callback.
   *
   */


  getWritable() {
    errorOnReadOnly();
    const editorState = getActiveEditorState();
    const editor = getActiveEditor();
    const nodeMap = editorState._nodeMap;
    const key = this.__key; // Ensure we get the latest node from pending state

    const latestNode = this.getLatest();
    const parent = latestNode.__parent;
    const cloneNotNeeded = editor._cloneNotNeeded;
    const selection = $getSelection$1();

    if (selection !== null) {
      selection._cachedNodes = null;
    }

    if (cloneNotNeeded.has(key)) {
      // Transforms clear the dirty node set on each iteration to keep track on newly dirty nodes
      internalMarkNodeAsDirty(latestNode);
      return latestNode;
    }

    const constructor = latestNode.constructor; // @ts-expect-error

    const mutableNode = constructor.clone(latestNode);
    mutableNode.__parent = parent;
    mutableNode.__next = latestNode.__next;
    mutableNode.__prev = latestNode.__prev;

    if ($isElementNode$1(latestNode) && $isElementNode$1(mutableNode)) {
      mutableNode.__first = latestNode.__first;
      mutableNode.__last = latestNode.__last;
      mutableNode.__size = latestNode.__size;
      mutableNode.__indent = latestNode.__indent;
      mutableNode.__format = latestNode.__format;
      mutableNode.__dir = latestNode.__dir;
    } else if ($isTextNode$1(latestNode) && $isTextNode$1(mutableNode)) {
      mutableNode.__format = latestNode.__format;
      mutableNode.__style = latestNode.__style;
      mutableNode.__mode = latestNode.__mode;
      mutableNode.__detail = latestNode.__detail;
    }

    cloneNotNeeded.add(key);
    mutableNode.__key = key;
    internalMarkNodeAsDirty(mutableNode); // Update reference in node map

    nodeMap.set(key, mutableNode);
    return mutableNode;
  }
  /**
   * Returns the text content of the node. Override this for
   * custom nodes that should have a representation in plain text
   * format (for copy + paste, for example)
   *
   */


  getTextContent() {
    return '';
  }
  /**
   * Returns the length of the string produced by calling getTextContent on this node.
   *
   */


  getTextContentSize() {
    return this.getTextContent().length;
  } // View

  /**
   * Called during the reconciliation process to determine which nodes
   * to insert into the DOM for this Lexical Node.
   *
   * This method must return exactly one HTMLElement. Nested elements are not supported.
   *
   * Do not attempt to update the Lexical EditorState during this phase of the update lifecyle.
   *
   * @param _config - allows access to things like the EditorTheme (to apply classes) during reconciliation.
   * @param _editor - allows access to the editor for context during reconciliation.
   *
   * */


  createDOM(_config, _editor) {
    {
      throw Error(`createDOM: base method not extended`);
    }
  }
  /**
   * Called when a node changes and should update the DOM
   * in whatever way is necessary to make it align with any changes that might
   * have happened during the update.
   *
   * Returning "true" here will cause lexical to unmount and recreate the DOM node
   * (by calling createDOM). You would need to do this if the element tag changes,
   * for instance.
   *
   * */


  updateDOM(_prevNode, _dom, _config) {
    {
      throw Error(`updateDOM: base method not extended`);
    }
  }
  /**
   * Controls how the this node is serialized to HTML. This is important for
   * copy and paste between Lexical and non-Lexical editors, or Lexical editors with different namespaces,
   * in which case the primary transfer format is HTML. It's also important if you're serializing
   * to HTML for any other reason via {@link @lexical/html!$generateHtmlFromNodes}. You could
   * also use this method to build your own HTML renderer.
   *
   * */


  exportDOM(editor) {
    const element = this.createDOM(editor._config, editor);
    return {
      element
    };
  }
  /**
   * Controls how the this node is serialized to JSON. This is important for
   * copy and paste between Lexical editors sharing the same namespace. It's also important
   * if you're serializing to JSON for persistent storage somewhere.
   * See [Serialization & Deserialization](https://lexical.dev/docs/concepts/serialization#lexical---html).
   *
   * */


  exportJSON() {
    {
      throw Error(`exportJSON: base method not extended`);
    }
  }
  /**
   * Controls how the this node is deserialized from JSON. This is usually boilerplate,
   * but provides an abstraction between the node implementation and serialized interface that can
   * be important if you ever make breaking changes to a node schema (by adding or removing properties).
   * See [Serialization & Deserialization](https://lexical.dev/docs/concepts/serialization#lexical---html).
   *
   * */


  static importJSON(_serializedNode) {
    {
      throw Error(`LexicalNode: Node ${this.name} does not implement .importJSON().`);
    }
  }
  /**
   * @experimental
   *
   * Registers the returned function as a transform on the node during
   * Editor initialization. Most such use cases should be addressed via
   * the {@link LexicalEditor.registerNodeTransform} API.
   *
   * Experimental - use at your own risk.
   */


  static transform() {
    return null;
  } // Setters and mutators

  /**
   * Removes this LexicalNode from the EditorState. If the node isn't re-inserted
   * somewhere, the Lexical garbage collector will eventually clean it up.
   *
   * @param preserveEmptyParent - If falsy, the node's parent will be removed if
   * it's empty after the removal operation. This is the default behavior, subject to
   * other node heuristics such as {@link ElementNode#canBeEmpty}
   * */


  remove(preserveEmptyParent) {
    removeNode(this, true, preserveEmptyParent);
  }
  /**
   * Replaces this LexicalNode with the provided node, optionally transferring the children
   * of the replaced node to the replacing node.
   *
   * @param replaceWith - The node to replace this one with.
   * @param includeChildren - Whether or not to transfer the children of this node to the replacing node.
   * */


  replace(replaceWith, includeChildren) {
    errorOnReadOnly();
    let selection = $getSelection$1();
    if (selection !== null) selection = selection.clone();
    errorOnInsertTextNodeOnRoot(this, replaceWith);
    const self = this.getLatest();
    const toReplaceKey = this.__key;
    const key = replaceWith.__key;
    const writableReplaceWith = replaceWith.getWritable();
    const writableParent = this.getParentOrThrow().getWritable();
    const size = writableParent.__size;
    removeFromParent(writableReplaceWith);
    const prevSibling = self.getPreviousSibling();
    const nextSibling = self.getNextSibling();
    const prevKey = self.__prev;
    const nextKey = self.__next;
    const parentKey = self.__parent;
    removeNode(self, false, true);

    if (prevSibling === null) {
      writableParent.__first = key;
    } else {
      const writablePrevSibling = prevSibling.getWritable();
      writablePrevSibling.__next = key;
    }

    writableReplaceWith.__prev = prevKey;

    if (nextSibling === null) {
      writableParent.__last = key;
    } else {
      const writableNextSibling = nextSibling.getWritable();
      writableNextSibling.__prev = key;
    }

    writableReplaceWith.__next = nextKey;
    writableReplaceWith.__parent = parentKey;
    writableParent.__size = size;

    if (includeChildren) {
      this.getChildren().forEach(child => {
        writableReplaceWith.append(child);
      });
    }

    if ($isRangeSelection$1(selection)) {
      $setSelection$1(selection);
      const anchor = selection.anchor;
      const focus = selection.focus;

      if (anchor.key === toReplaceKey) {
        $moveSelectionPointToEnd(anchor, writableReplaceWith);
      }

      if (focus.key === toReplaceKey) {
        $moveSelectionPointToEnd(focus, writableReplaceWith);
      }
    }

    if ($getCompositionKey() === toReplaceKey) {
      $setCompositionKey$1(key);
    }

    return writableReplaceWith;
  }
  /**
   * Inserts a node after this LexicalNode (as the next sibling).
   *
   * @param nodeToInsert - The node to insert after this one.
   * @param restoreSelection - Whether or not to attempt to resolve the
   * selection to the appropriate place after the operation is complete.
   * */


  insertAfter(nodeToInsert, restoreSelection = true) {
    errorOnReadOnly();
    errorOnInsertTextNodeOnRoot(this, nodeToInsert);
    const writableSelf = this.getWritable();
    const writableNodeToInsert = nodeToInsert.getWritable();
    const oldParent = writableNodeToInsert.getParent();
    const selection = $getSelection$1();
    let elementAnchorSelectionOnNode = false;
    let elementFocusSelectionOnNode = false;

    if (oldParent !== null) {
      // TODO: this is O(n), can we improve?
      const oldIndex = nodeToInsert.getIndexWithinParent();
      removeFromParent(writableNodeToInsert);

      if ($isRangeSelection$1(selection)) {
        const oldParentKey = oldParent.__key;
        const anchor = selection.anchor;
        const focus = selection.focus;
        elementAnchorSelectionOnNode = anchor.type === 'element' && anchor.key === oldParentKey && anchor.offset === oldIndex + 1;
        elementFocusSelectionOnNode = focus.type === 'element' && focus.key === oldParentKey && focus.offset === oldIndex + 1;
      }
    }

    const nextSibling = this.getNextSibling();
    const writableParent = this.getParentOrThrow().getWritable();
    const insertKey = writableNodeToInsert.__key;
    const nextKey = writableSelf.__next;

    if (nextSibling === null) {
      writableParent.__last = insertKey;
    } else {
      const writableNextSibling = nextSibling.getWritable();
      writableNextSibling.__prev = insertKey;
    }

    writableParent.__size++;
    writableSelf.__next = insertKey;
    writableNodeToInsert.__next = nextKey;
    writableNodeToInsert.__prev = writableSelf.__key;
    writableNodeToInsert.__parent = writableSelf.__parent;

    if (restoreSelection && $isRangeSelection$1(selection)) {
      const index = this.getIndexWithinParent();
      $updateElementSelectionOnCreateDeleteNode(selection, writableParent, index + 1);
      const writableParentKey = writableParent.__key;

      if (elementAnchorSelectionOnNode) {
        selection.anchor.set(writableParentKey, index + 2, 'element');
      }

      if (elementFocusSelectionOnNode) {
        selection.focus.set(writableParentKey, index + 2, 'element');
      }
    }

    return nodeToInsert;
  }
  /**
   * Inserts a node before this LexicalNode (as the previous sibling).
   *
   * @param nodeToInsert - The node to insert after this one.
   * @param restoreSelection - Whether or not to attempt to resolve the
   * selection to the appropriate place after the operation is complete.
   * */


  insertBefore(nodeToInsert, restoreSelection = true) {
    errorOnReadOnly();
    errorOnInsertTextNodeOnRoot(this, nodeToInsert);
    const writableSelf = this.getWritable();
    const writableNodeToInsert = nodeToInsert.getWritable();
    const insertKey = writableNodeToInsert.__key;
    removeFromParent(writableNodeToInsert);
    const prevSibling = this.getPreviousSibling();
    const writableParent = this.getParentOrThrow().getWritable();
    const prevKey = writableSelf.__prev; // TODO: this is O(n), can we improve?

    const index = this.getIndexWithinParent();

    if (prevSibling === null) {
      writableParent.__first = insertKey;
    } else {
      const writablePrevSibling = prevSibling.getWritable();
      writablePrevSibling.__next = insertKey;
    }

    writableParent.__size++;
    writableSelf.__prev = insertKey;
    writableNodeToInsert.__prev = prevKey;
    writableNodeToInsert.__next = writableSelf.__key;
    writableNodeToInsert.__parent = writableSelf.__parent;
    const selection = $getSelection$1();

    if (restoreSelection && $isRangeSelection$1(selection)) {
      const parent = this.getParentOrThrow();
      $updateElementSelectionOnCreateDeleteNode(selection, parent, index);
    }

    return nodeToInsert;
  }
  /**
   * Whether or not this node has a required parent. Used during copy + paste operations
   * to normalize nodes that would otherwise be orphaned. For example, ListItemNodes without
   * a ListNode parent or TextNodes with a ParagraphNode parent.
   *
   * */


  isParentRequired() {
    return false;
  }
  /**
   * The creation logic for any required parent. Should be implemented if {@link isParentRequired} returns true.
   *
   * */


  createParentElementNode() {
    return $createParagraphNode$1();
  }
  /**
   * Moves selection to the previous sibling of this node, at the specified offsets.
   *
   * @param anchorOffset - The anchor offset for selection.
   * @param focusOffset -  The focus offset for selection
   * */


  selectPrevious(anchorOffset, focusOffset) {
    errorOnReadOnly();
    const prevSibling = this.getPreviousSibling();
    const parent = this.getParentOrThrow();

    if (prevSibling === null) {
      return parent.select(0, 0);
    }

    if ($isElementNode$1(prevSibling)) {
      return prevSibling.select();
    } else if (!$isTextNode$1(prevSibling)) {
      const index = prevSibling.getIndexWithinParent() + 1;
      return parent.select(index, index);
    }

    return prevSibling.select(anchorOffset, focusOffset);
  }
  /**
   * Moves selection to the next sibling of this node, at the specified offsets.
   *
   * @param anchorOffset - The anchor offset for selection.
   * @param focusOffset -  The focus offset for selection
   * */


  selectNext(anchorOffset, focusOffset) {
    errorOnReadOnly();
    const nextSibling = this.getNextSibling();
    const parent = this.getParentOrThrow();

    if (nextSibling === null) {
      return parent.select();
    }

    if ($isElementNode$1(nextSibling)) {
      return nextSibling.select(0, 0);
    } else if (!$isTextNode$1(nextSibling)) {
      const index = nextSibling.getIndexWithinParent();
      return parent.select(index, index);
    }

    return nextSibling.select(anchorOffset, focusOffset);
  }
  /**
   * Marks a node dirty, triggering transforms and
   * forcing it to be reconciled during the update cycle.
   *
   * */


  markDirty() {
    this.getWritable();
  }

}

function errorOnTypeKlassMismatch(type, klass) {
  const registeredNode = getActiveEditor()._nodes.get(type); // Common error - split in its own invariant


  if (registeredNode === undefined) {
    {
      throw Error(`Create node: Attempted to create node ${klass.name} that was not configured to be used on the editor.`);
    }
  }

  const editorKlass = registeredNode.klass;

  if (editorKlass !== klass) {
    {
      throw Error(`Create node: Type ${type} in node ${klass.name} does not match registered node ${editorKlass.name} with the same type`);
    }
  }
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
class Point {
  constructor(key, offset, type) {
    this._selection = null;
    this.key = key;
    this.offset = offset;
    this.type = type;
  }

  is(point) {
    return this.key === point.key && this.offset === point.offset && this.type === point.type;
  }

  isBefore(b) {
    let aNode = this.getNode();
    let bNode = b.getNode();
    const aOffset = this.offset;
    const bOffset = b.offset;

    if ($isElementNode$1(aNode)) {
      const aNodeDescendant = aNode.getDescendantByIndex(aOffset);
      aNode = aNodeDescendant != null ? aNodeDescendant : aNode;
    }

    if ($isElementNode$1(bNode)) {
      const bNodeDescendant = bNode.getDescendantByIndex(bOffset);
      bNode = bNodeDescendant != null ? bNodeDescendant : bNode;
    }

    if (aNode === bNode) {
      return aOffset < bOffset;
    }

    return aNode.isBefore(bNode);
  }

  getNode() {
    const key = this.key;
    const node = $getNodeByKey$1(key);

    if (node === null) {
      {
        throw Error(`Point.getNode: node not found`);
      }
    }

    return node;
  }

  set(key, offset, type) {
    const selection = this._selection;
    const oldKey = this.key;
    this.key = key;
    this.offset = offset;
    this.type = type;

    if (!isCurrentlyReadOnlyMode()) {
      if ($getCompositionKey() === oldKey) {
        $setCompositionKey$1(key);
      }

      if (selection !== null) {
        selection._cachedNodes = null;
        selection.dirty = true;
      }
    }
  }

}

function $createPoint(key, offset, type) {
  // @ts-expect-error: intentionally cast as we use a class for perf reasons
  return new Point(key, offset, type);
}

function selectPointOnNode(point, node) {
  let key = node.__key;
  let offset = point.offset;
  let type = 'element';

  if ($isTextNode$1(node)) {
    type = 'text';
    const textContentLength = node.getTextContentSize();

    if (offset > textContentLength) {
      offset = textContentLength;
    }
  } else if (!$isElementNode$1(node)) {
    const nextSibling = node.getNextSibling();

    if ($isTextNode$1(nextSibling)) {
      key = nextSibling.__key;
      offset = 0;
      type = 'text';
    } else {
      const parentNode = node.getParent();

      if (parentNode) {
        key = parentNode.__key;
        offset = node.getIndexWithinParent() + 1;
      }
    }
  }

  point.set(key, offset, type);
}

function $moveSelectionPointToEnd(point, node) {
  if ($isElementNode$1(node)) {
    const lastNode = node.getLastDescendant();

    if ($isElementNode$1(lastNode) || $isTextNode$1(lastNode)) {
      selectPointOnNode(point, lastNode);
    } else {
      selectPointOnNode(point, node);
    }
  } else {
    selectPointOnNode(point, node);
  }
}

function $transferStartingElementPointToTextPoint(start, end, format, style) {
  const element = start.getNode();
  const placementNode = element.getChildAtIndex(start.offset);
  const textNode = $createTextNode$1();
  const target = $isRootNode$1(element) ? $createParagraphNode$1().append(textNode) : textNode;
  textNode.setFormat(format);
  textNode.setStyle(style);

  if (placementNode === null) {
    element.append(target);
  } else {
    placementNode.insertBefore(target);
  } // Transfer the element point to a text point.


  if (start.is(end)) {
    end.set(textNode.__key, 0, 'text');
  }

  start.set(textNode.__key, 0, 'text');
}

function $setPointValues(point, key, offset, type) {
  point.key = key;
  point.offset = offset;
  point.type = type;
}

class NodeSelection {
  constructor(objects) {
    this.dirty = false;
    this._nodes = objects;
    this._cachedNodes = null;
  }

  is(selection) {
    if (!$isNodeSelection$1(selection)) {
      return false;
    }

    const a = this._nodes;
    const b = selection._nodes;
    return a.size === b.size && Array.from(a).every(key => b.has(key));
  }

  add(key) {
    this.dirty = true;

    this._nodes.add(key);

    this._cachedNodes = null;
  }

  delete(key) {
    this.dirty = true;

    this._nodes.delete(key);

    this._cachedNodes = null;
  }

  clear() {
    this.dirty = true;

    this._nodes.clear();

    this._cachedNodes = null;
  }

  has(key) {
    return this._nodes.has(key);
  }

  clone() {
    return new NodeSelection(new Set(this._nodes));
  }

  extract() {
    return this.getNodes();
  }

  insertRawText(text) {// Do nothing?
  }

  insertText() {// Do nothing?
  }

  insertNodes(nodes, selectStart) {
    const selectedNodes = this.getNodes();
    const selectedNodesLength = selectedNodes.length;
    const lastSelectedNode = selectedNodes[selectedNodesLength - 1];
    let selectionAtEnd; // Insert nodes

    if ($isTextNode$1(lastSelectedNode)) {
      selectionAtEnd = lastSelectedNode.select();
    } else {
      const index = lastSelectedNode.getIndexWithinParent() + 1;
      selectionAtEnd = lastSelectedNode.getParentOrThrow().select(index, index);
    }

    selectionAtEnd.insertNodes(nodes, selectStart); // Remove selected nodes

    for (let i = 0; i < selectedNodesLength; i++) {
      selectedNodes[i].remove();
    }

    return true;
  }

  getNodes() {
    const cachedNodes = this._cachedNodes;

    if (cachedNodes !== null) {
      return cachedNodes;
    }

    const objects = this._nodes;
    const nodes = [];

    for (const object of objects) {
      const node = $getNodeByKey$1(object);

      if (node !== null) {
        nodes.push(node);
      }
    }

    if (!isCurrentlyReadOnlyMode()) {
      this._cachedNodes = nodes;
    }

    return nodes;
  }

  getTextContent() {
    const nodes = this.getNodes();
    let textContent = '';

    for (let i = 0; i < nodes.length; i++) {
      textContent += nodes[i].getTextContent();
    }

    return textContent;
  }

}
function $isRangeSelection$1(x) {
  return x instanceof RangeSelection;
}
class GridSelection {
  constructor(gridKey, anchor, focus) {
    this.gridKey = gridKey;
    this.anchor = anchor;
    this.focus = focus;
    this.dirty = false;
    this._cachedNodes = null;
    anchor._selection = this;
    focus._selection = this;
  }

  is(selection) {
    if (!DEPRECATED_$isGridSelection$1(selection)) {
      return false;
    }

    return this.gridKey === selection.gridKey && this.anchor.is(selection.anchor) && this.focus.is(selection.focus);
  }

  set(gridKey, anchorCellKey, focusCellKey) {
    this.dirty = true;
    this.gridKey = gridKey;
    this.anchor.key = anchorCellKey;
    this.focus.key = focusCellKey;
    this._cachedNodes = null;
  }

  clone() {
    return new GridSelection(this.gridKey, this.anchor, this.focus);
  }

  isCollapsed() {
    return false;
  }

  isBackward() {
    return this.focus.isBefore(this.anchor);
  }

  getCharacterOffsets() {
    return getCharacterOffsets(this);
  }

  extract() {
    return this.getNodes();
  }

  insertRawText(text) {// Do nothing?
  }

  insertText() {// Do nothing?
  }

  insertNodes(nodes, selectStart) {
    const focusNode = this.focus.getNode();
    const selection = $normalizeSelection(focusNode.select(0, focusNode.getChildrenSize()));
    return selection.insertNodes(nodes, selectStart);
  } // TODO Deprecate this method. It's confusing when used with colspan|rowspan


  getShape() {
    const anchorCellNode = $getNodeByKey$1(this.anchor.key);

    if (!(anchorCellNode !== null)) {
      throw Error(`getNodes: expected to find AnchorNode`);
    }

    const anchorCellNodeIndex = anchorCellNode.getIndexWithinParent();
    const anchorCelRoweIndex = anchorCellNode.getParentOrThrow().getIndexWithinParent();
    const focusCellNode = $getNodeByKey$1(this.focus.key);

    if (!(focusCellNode !== null)) {
      throw Error(`getNodes: expected to find FocusNode`);
    }

    const focusCellNodeIndex = focusCellNode.getIndexWithinParent();
    const focusCellRowIndex = focusCellNode.getParentOrThrow().getIndexWithinParent();
    const startX = Math.min(anchorCellNodeIndex, focusCellNodeIndex);
    const stopX = Math.max(anchorCellNodeIndex, focusCellNodeIndex);
    const startY = Math.min(anchorCelRoweIndex, focusCellRowIndex);
    const stopY = Math.max(anchorCelRoweIndex, focusCellRowIndex);
    return {
      fromX: Math.min(startX, stopX),
      fromY: Math.min(startY, stopY),
      toX: Math.max(startX, stopX),
      toY: Math.max(startY, stopY)
    };
  }

  getNodes() {
    const cachedNodes = this._cachedNodes;

    if (cachedNodes !== null) {
      return cachedNodes;
    }

    const anchorNode = this.anchor.getNode();
    const focusNode = this.focus.getNode();
    const anchorCell = $findMatchingParent$2(anchorNode, DEPRECATED_$isGridCellNode$1); // todo replace with triplet

    const focusCell = $findMatchingParent$2(focusNode, DEPRECATED_$isGridCellNode$1);

    if (!DEPRECATED_$isGridCellNode$1(anchorCell)) {
      throw Error(`Expected GridSelection anchor to be (or a child of) GridCellNode`);
    }

    if (!DEPRECATED_$isGridCellNode$1(focusCell)) {
      throw Error(`Expected GridSelection focus to be (or a child of) GridCellNode`);
    }

    const anchorRow = anchorCell.getParent();

    if (!DEPRECATED_$isGridRowNode$1(anchorRow)) {
      throw Error(`Expected anchorCell to have a parent GridRowNode`);
    }

    const gridNode = anchorRow.getParent();

    if (!DEPRECATED_$isGridNode$1(gridNode)) {
      throw Error(`Expected tableNode to have a parent GridNode`);
    } // TODO Mapping the whole Grid every time not efficient. We need to compute the entire state only
    // once (on load) and iterate on it as updates occur. However, to do this we need to have the
    // ability to store a state. Killing GridSelection and moving the logic to the plugin would make
    // this possible.


    const [map, cellAMap, cellBMap] = DEPRECATED_$computeGridMap$1(gridNode, anchorCell, focusCell);
    let minColumn = Math.min(cellAMap.startColumn, cellBMap.startColumn);
    let minRow = Math.min(cellAMap.startRow, cellBMap.startRow);
    let maxColumn = Math.max(cellAMap.startColumn + cellAMap.cell.__colSpan - 1, cellBMap.startColumn + cellBMap.cell.__colSpan - 1);
    let maxRow = Math.max(cellAMap.startRow + cellAMap.cell.__rowSpan - 1, cellBMap.startRow + cellBMap.cell.__rowSpan - 1);
    let exploredMinColumn = minColumn;
    let exploredMinRow = minRow;
    let exploredMaxColumn = minColumn;
    let exploredMaxRow = minRow;

    function expandBoundary(mapValue) {
      const {
        cell,
        startColumn: cellStartColumn,
        startRow: cellStartRow
      } = mapValue;
      minColumn = Math.min(minColumn, cellStartColumn);
      minRow = Math.min(minRow, cellStartRow);
      maxColumn = Math.max(maxColumn, cellStartColumn + cell.__colSpan - 1);
      maxRow = Math.max(maxRow, cellStartRow + cell.__rowSpan - 1);
    }

    while (minColumn < exploredMinColumn || minRow < exploredMinRow || maxColumn > exploredMaxColumn || maxRow > exploredMaxRow) {
      if (minColumn < exploredMinColumn) {
        // Expand on the left
        const rowDiff = exploredMaxRow - exploredMinRow;
        const previousColumn = exploredMinColumn - 1;

        for (let i = 0; i <= rowDiff; i++) {
          expandBoundary(map[exploredMinRow + i][previousColumn]);
        }

        exploredMinColumn = previousColumn;
      }

      if (minRow < exploredMinRow) {
        // Expand on top
        const columnDiff = exploredMaxColumn - exploredMinColumn;
        const previousRow = exploredMinRow - 1;

        for (let i = 0; i <= columnDiff; i++) {
          expandBoundary(map[previousRow][exploredMinColumn + i]);
        }

        exploredMinRow = previousRow;
      }

      if (maxColumn > exploredMaxColumn) {
        // Expand on the right
        const rowDiff = exploredMaxRow - exploredMinRow;
        const nextColumn = exploredMaxColumn + 1;

        for (let i = 0; i <= rowDiff; i++) {
          expandBoundary(map[exploredMinRow + i][nextColumn]);
        }

        exploredMaxColumn = nextColumn;
      }

      if (maxRow > exploredMaxRow) {
        // Expand on the bottom
        const columnDiff = exploredMaxColumn - exploredMinColumn;
        const nextRow = exploredMaxRow + 1;

        for (let i = 0; i <= columnDiff; i++) {
          expandBoundary(map[nextRow][exploredMinColumn + i]);
        }

        exploredMaxRow = nextRow;
      }
    }

    const nodes = [gridNode];
    let lastRow = null;

    for (let i = minRow; i <= maxRow; i++) {
      for (let j = minColumn; j <= maxColumn; j++) {
        const {
          cell
        } = map[i][j];
        const currentRow = cell.getParent();

        if (!DEPRECATED_$isGridRowNode$1(currentRow)) {
          throw Error(`Expected GridCellNode parent to be a GridRowNode`);
        }

        if (currentRow !== lastRow) {
          nodes.push(currentRow);
        }

        nodes.push(cell, ...$getChildrenRecursively(cell));
        lastRow = currentRow;
      }
    }

    if (!isCurrentlyReadOnlyMode()) {
      this._cachedNodes = nodes;
    }

    return nodes;
  }

  getTextContent() {
    const nodes = this.getNodes();
    let textContent = '';

    for (let i = 0; i < nodes.length; i++) {
      textContent += nodes[i].getTextContent();
    }

    return textContent;
  }

}
function DEPRECATED_$isGridSelection$1(x) {
  return x instanceof GridSelection;
}
class RangeSelection {
  constructor(anchor, focus, format, style) {
    this.anchor = anchor;
    this.focus = focus;
    this.dirty = false;
    this.format = format;
    this.style = style;
    this._cachedNodes = null;
    anchor._selection = this;
    focus._selection = this;
  }

  is(selection) {
    if (!$isRangeSelection$1(selection)) {
      return false;
    }

    return this.anchor.is(selection.anchor) && this.focus.is(selection.focus) && this.format === selection.format && this.style === selection.style;
  }

  isBackward() {
    return this.focus.isBefore(this.anchor);
  }

  isCollapsed() {
    return this.anchor.is(this.focus);
  }

  getNodes() {
    const cachedNodes = this._cachedNodes;

    if (cachedNodes !== null) {
      return cachedNodes;
    }

    const anchor = this.anchor;
    const focus = this.focus;
    const isBefore = anchor.isBefore(focus);
    const firstPoint = isBefore ? anchor : focus;
    const lastPoint = isBefore ? focus : anchor;
    let firstNode = firstPoint.getNode();
    let lastNode = lastPoint.getNode();
    const startOffset = firstPoint.offset;
    const endOffset = lastPoint.offset;

    if ($isElementNode$1(firstNode)) {
      const firstNodeDescendant = firstNode.getDescendantByIndex(startOffset);
      firstNode = firstNodeDescendant != null ? firstNodeDescendant : firstNode;
    }

    if ($isElementNode$1(lastNode)) {
      let lastNodeDescendant = lastNode.getDescendantByIndex(endOffset); // We don't want to over-select, as node selection infers the child before
      // the last descendant, not including that descendant.

      if (lastNodeDescendant !== null && lastNodeDescendant !== firstNode && lastNode.getChildAtIndex(endOffset) === lastNodeDescendant) {
        lastNodeDescendant = lastNodeDescendant.getPreviousSibling();
      }

      lastNode = lastNodeDescendant != null ? lastNodeDescendant : lastNode;
    }

    let nodes;

    if (firstNode.is(lastNode)) {
      if ($isElementNode$1(firstNode) && firstNode.getChildrenSize() > 0) {
        nodes = [];
      } else {
        nodes = [firstNode];
      }
    } else {
      nodes = firstNode.getNodesBetween(lastNode);
    }

    if (!isCurrentlyReadOnlyMode()) {
      this._cachedNodes = nodes;
    }

    return nodes;
  }

  setTextNodeRange(anchorNode, anchorOffset, focusNode, focusOffset) {
    $setPointValues(this.anchor, anchorNode.__key, anchorOffset, 'text');
    $setPointValues(this.focus, focusNode.__key, focusOffset, 'text');
    this._cachedNodes = null;
    this.dirty = true;
  }

  getTextContent() {
    const nodes = this.getNodes();

    if (nodes.length === 0) {
      return '';
    }

    const firstNode = nodes[0];
    const lastNode = nodes[nodes.length - 1];
    const anchor = this.anchor;
    const focus = this.focus;
    const isBefore = anchor.isBefore(focus);
    const [anchorOffset, focusOffset] = getCharacterOffsets(this);
    let textContent = '';
    let prevWasElement = true;

    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i];

      if ($isElementNode$1(node) && !node.isInline()) {
        if (!prevWasElement) {
          textContent += '\n';
        }

        if (node.isEmpty()) {
          prevWasElement = false;
        } else {
          prevWasElement = true;
        }
      } else {
        prevWasElement = false;

        if ($isTextNode$1(node)) {
          let text = node.getTextContent();

          if (node === firstNode) {
            if (node === lastNode) {
              if (anchor.type !== 'element' || focus.type !== 'element' || focus.offset === anchor.offset) {
                text = anchorOffset < focusOffset ? text.slice(anchorOffset, focusOffset) : text.slice(focusOffset, anchorOffset);
              }
            } else {
              text = isBefore ? text.slice(anchorOffset) : text.slice(focusOffset);
            }
          } else if (node === lastNode) {
            text = isBefore ? text.slice(0, focusOffset) : text.slice(0, anchorOffset);
          }

          textContent += text;
        } else if (($isDecoratorNode$1(node) || $isLineBreakNode$1(node)) && (node !== lastNode || !this.isCollapsed())) {
          textContent += node.getTextContent();
        }
      }
    }

    return textContent;
  }

  applyDOMRange(range) {
    const editor = getActiveEditor();
    const currentEditorState = editor.getEditorState();
    const lastSelection = currentEditorState._selection;
    const resolvedSelectionPoints = internalResolveSelectionPoints(range.startContainer, range.startOffset, range.endContainer, range.endOffset, editor, lastSelection);

    if (resolvedSelectionPoints === null) {
      return;
    }

    const [anchorPoint, focusPoint] = resolvedSelectionPoints;
    $setPointValues(this.anchor, anchorPoint.key, anchorPoint.offset, anchorPoint.type);
    $setPointValues(this.focus, focusPoint.key, focusPoint.offset, focusPoint.type);
    this._cachedNodes = null;
  }

  clone() {
    const anchor = this.anchor;
    const focus = this.focus;
    const selection = new RangeSelection($createPoint(anchor.key, anchor.offset, anchor.type), $createPoint(focus.key, focus.offset, focus.type), this.format, this.style);
    return selection;
  }

  toggleFormat(format) {
    this.format = toggleTextFormatType(this.format, format, null);
    this.dirty = true;
  }

  setStyle(style) {
    this.style = style;
    this.dirty = true;
  }

  hasFormat(type) {
    const formatFlag = TEXT_TYPE_TO_FORMAT[type];
    return (this.format & formatFlag) !== 0;
  }

  insertRawText(text) {
    const parts = text.split(/\r?\n/);

    if (parts.length === 1) {
      this.insertText(text);
    } else {
      const nodes = [];
      const length = parts.length;

      for (let i = 0; i < length; i++) {
        const part = parts[i];

        if (part !== '') {
          nodes.push($createTextNode$1(part));
        }

        if (i !== length - 1) {
          nodes.push($createLineBreakNode$1());
        }
      }

      this.insertNodes(nodes);
    }
  }

  insertText(text) {
    const anchor = this.anchor;
    const focus = this.focus;
    const isBefore = this.isCollapsed() || anchor.isBefore(focus);
    const format = this.format;
    const style = this.style;

    if (isBefore && anchor.type === 'element') {
      $transferStartingElementPointToTextPoint(anchor, focus, format, style);
    } else if (!isBefore && focus.type === 'element') {
      $transferStartingElementPointToTextPoint(focus, anchor, format, style);
    }

    const selectedNodes = this.getNodes();
    const selectedNodesLength = selectedNodes.length;
    const firstPoint = isBefore ? anchor : focus;
    const endPoint = isBefore ? focus : anchor;
    const startOffset = firstPoint.offset;
    const endOffset = endPoint.offset;
    let firstNode = selectedNodes[0];

    if (!$isTextNode$1(firstNode)) {
      {
        throw Error(`insertText: first node is not a text node`);
      }
    }

    const firstNodeText = firstNode.getTextContent();
    const firstNodeTextLength = firstNodeText.length;
    const firstNodeParent = firstNode.getParentOrThrow();
    const lastIndex = selectedNodesLength - 1;
    let lastNode = selectedNodes[lastIndex];

    if (this.isCollapsed() && startOffset === firstNodeTextLength && (firstNode.isSegmented() || firstNode.isToken() || !firstNode.canInsertTextAfter() || !firstNodeParent.canInsertTextAfter() && firstNode.getNextSibling() === null)) {
      let nextSibling = firstNode.getNextSibling();

      if (!$isTextNode$1(nextSibling) || $isTokenOrSegmented(nextSibling)) {
        nextSibling = $createTextNode$1();
        nextSibling.setFormat(format);

        if (!firstNodeParent.canInsertTextAfter()) {
          firstNodeParent.insertAfter(nextSibling);
        } else {
          firstNode.insertAfter(nextSibling);
        }
      }

      nextSibling.select(0, 0);
      firstNode = nextSibling;

      if (text !== '') {
        this.insertText(text);
        return;
      }
    } else if (this.isCollapsed() && startOffset === 0 && (firstNode.isSegmented() || firstNode.isToken() || !firstNode.canInsertTextBefore() || !firstNodeParent.canInsertTextBefore() && firstNode.getPreviousSibling() === null)) {
      let prevSibling = firstNode.getPreviousSibling();

      if (!$isTextNode$1(prevSibling) || $isTokenOrSegmented(prevSibling)) {
        prevSibling = $createTextNode$1();
        prevSibling.setFormat(format);

        if (!firstNodeParent.canInsertTextBefore()) {
          firstNodeParent.insertBefore(prevSibling);
        } else {
          firstNode.insertBefore(prevSibling);
        }
      }

      prevSibling.select();
      firstNode = prevSibling;

      if (text !== '') {
        this.insertText(text);
        return;
      }
    } else if (firstNode.isSegmented() && startOffset !== firstNodeTextLength) {
      const textNode = $createTextNode$1(firstNode.getTextContent());
      textNode.setFormat(format);
      firstNode.replace(textNode);
      firstNode = textNode;
    } else if (!this.isCollapsed() && text !== '') {
      // When the firstNode or lastNode parents are elements that
      // do not allow text to be inserted before or after, we first
      // clear the content. Then we normalize selection, then insert
      // the new content.
      const lastNodeParent = lastNode.getParent();

      if (!firstNodeParent.canInsertTextBefore() || !firstNodeParent.canInsertTextAfter() || $isElementNode$1(lastNodeParent) && (!lastNodeParent.canInsertTextBefore() || !lastNodeParent.canInsertTextAfter())) {
        this.insertText('');
        normalizeSelectionPointsForBoundaries(this.anchor, this.focus, null);
        this.insertText(text);
        return;
      }
    }

    if (selectedNodesLength === 1) {
      if (firstNode.isToken()) {
        const textNode = $createTextNode$1(text);
        textNode.select();
        firstNode.replace(textNode);
        return;
      }

      const firstNodeFormat = firstNode.getFormat();
      const firstNodeStyle = firstNode.getStyle();

      if (startOffset === endOffset && (firstNodeFormat !== format || firstNodeStyle !== style)) {
        if (firstNode.getTextContent() === '') {
          firstNode.setFormat(format);
          firstNode.setStyle(style);
        } else {
          const textNode = $createTextNode$1(text);
          textNode.setFormat(format);
          textNode.setStyle(style);
          textNode.select();

          if (startOffset === 0) {
            firstNode.insertBefore(textNode, false);
          } else {
            const [targetNode] = firstNode.splitText(startOffset);
            targetNode.insertAfter(textNode, false);
          } // When composing, we need to adjust the anchor offset so that
          // we correctly replace that right range.


          if (textNode.isComposing() && this.anchor.type === 'text') {
            this.anchor.offset -= text.length;
          }

          return;
        }
      }

      const delCount = endOffset - startOffset;
      firstNode = firstNode.spliceText(startOffset, delCount, text, true);

      if (firstNode.getTextContent() === '') {
        firstNode.remove();
      } else if (this.anchor.type === 'text') {
        if (firstNode.isComposing()) {
          // When composing, we need to adjust the anchor offset so that
          // we correctly replace that right range.
          this.anchor.offset -= text.length;
        } else {
          this.format = firstNodeFormat;
          this.style = firstNodeStyle;
        }
      }
    } else {
      const markedNodeKeysForKeep = new Set([...firstNode.getParentKeys(), ...lastNode.getParentKeys()]); // We have to get the parent elements before the next section,
      // as in that section we might mutate the lastNode.

      const firstElement = $isElementNode$1(firstNode) ? firstNode : firstNode.getParentOrThrow();
      let lastElement = $isElementNode$1(lastNode) ? lastNode : lastNode.getParentOrThrow();
      let lastElementChild = lastNode; // If the last element is inline, we should instead look at getting
      // the nodes of its parent, rather than itself. This behavior will
      // then better match how text node insertions work. We will need to
      // also update the last element's child accordingly as we do this.

      if (!firstElement.is(lastElement) && lastElement.isInline()) {
        // Keep traversing till we have a non-inline element parent.
        do {
          lastElementChild = lastElement;
          lastElement = lastElement.getParentOrThrow();
        } while (lastElement.isInline());
      } // Handle mutations to the last node.


      if (endPoint.type === 'text' && (endOffset !== 0 || lastNode.getTextContent() === '') || endPoint.type === 'element' && lastNode.getIndexWithinParent() < endOffset) {
        if ($isTextNode$1(lastNode) && !lastNode.isToken() && endOffset !== lastNode.getTextContentSize()) {
          if (lastNode.isSegmented()) {
            const textNode = $createTextNode$1(lastNode.getTextContent());
            lastNode.replace(textNode);
            lastNode = textNode;
          }

          lastNode = lastNode.spliceText(0, endOffset, '');
          markedNodeKeysForKeep.add(lastNode.__key);
        } else {
          const lastNodeParent = lastNode.getParentOrThrow();

          if (!lastNodeParent.canBeEmpty() && lastNodeParent.getChildrenSize() === 1) {
            lastNodeParent.remove();
          } else {
            lastNode.remove();
          }
        }
      } else {
        markedNodeKeysForKeep.add(lastNode.__key);
      } // Either move the remaining nodes of the last parent to after
      // the first child, or remove them entirely. If the last parent
      // is the same as the first parent, this logic also works.


      const lastNodeChildren = lastElement.getChildren();
      const selectedNodesSet = new Set(selectedNodes);
      const firstAndLastElementsAreEqual = firstElement.is(lastElement); // We choose a target to insert all nodes after. In the case of having
      // and inline starting parent element with a starting node that has no
      // siblings, we should insert after the starting parent element, otherwise
      // we will incorrectly merge into the starting parent element.
      // TODO: should we keep on traversing parents if we're inside another
      // nested inline element?

      const insertionTarget = firstElement.isInline() && firstNode.getNextSibling() === null ? firstElement : firstNode;

      for (let i = lastNodeChildren.length - 1; i >= 0; i--) {
        const lastNodeChild = lastNodeChildren[i];

        if (lastNodeChild.is(firstNode) || $isElementNode$1(lastNodeChild) && lastNodeChild.isParentOf(firstNode)) {
          break;
        }

        if (lastNodeChild.isAttached()) {
          if (!selectedNodesSet.has(lastNodeChild) || lastNodeChild.is(lastElementChild)) {
            if (!firstAndLastElementsAreEqual) {
              insertionTarget.insertAfter(lastNodeChild, false);
            }
          } else {
            lastNodeChild.remove();
          }
        }
      }

      if (!firstAndLastElementsAreEqual) {
        // Check if we have already moved out all the nodes of the
        // last parent, and if so, traverse the parent tree and mark
        // them all as being able to deleted too.
        let parent = lastElement;
        let lastRemovedParent = null;

        while (parent !== null) {
          const children = parent.getChildren();
          const childrenLength = children.length;

          if (childrenLength === 0 || children[childrenLength - 1].is(lastRemovedParent)) {
            markedNodeKeysForKeep.delete(parent.__key);
            lastRemovedParent = parent;
          }

          parent = parent.getParent();
        }
      } // Ensure we do splicing after moving of nodes, as splicing
      // can have side-effects (in the case of hashtags).


      if (!firstNode.isToken()) {
        firstNode = firstNode.spliceText(startOffset, firstNodeTextLength - startOffset, text, true);

        if (firstNode.getTextContent() === '') {
          firstNode.remove();
        } else if (firstNode.isComposing() && this.anchor.type === 'text') {
          // When composing, we need to adjust the anchor offset so that
          // we correctly replace that right range.
          this.anchor.offset -= text.length;
        }
      } else if (startOffset === firstNodeTextLength) {
        firstNode.select();
      } else {
        const textNode = $createTextNode$1(text);
        textNode.select();
        firstNode.replace(textNode);
      } // Remove all selected nodes that haven't already been removed.


      for (let i = 1; i < selectedNodesLength; i++) {
        const selectedNode = selectedNodes[i];
        const key = selectedNode.__key;

        if (!markedNodeKeysForKeep.has(key)) {
          selectedNode.remove();
        }
      }
    }
  }

  removeText() {
    this.insertText('');
  }

  formatText(formatType) {
    if (this.isCollapsed()) {
      this.toggleFormat(formatType); // When changing format, we should stop composition

      $setCompositionKey$1(null);
      return;
    }

    const selectedNodes = this.getNodes();
    const selectedTextNodes = [];

    for (const selectedNode of selectedNodes) {
      if ($isTextNode$1(selectedNode)) {
        selectedTextNodes.push(selectedNode);
      }
    }

    const selectedTextNodesLength = selectedTextNodes.length;

    if (selectedTextNodesLength === 0) {
      this.toggleFormat(formatType); // When changing format, we should stop composition

      $setCompositionKey$1(null);
      return;
    }

    const anchor = this.anchor;
    const focus = this.focus;
    const isBackward = this.isBackward();
    const startPoint = isBackward ? focus : anchor;
    const endPoint = isBackward ? anchor : focus;
    let firstIndex = 0;
    let firstNode = selectedTextNodes[0];
    let startOffset = startPoint.type === 'element' ? 0 : startPoint.offset; // In case selection started at the end of text node use next text node

    if (startPoint.type === 'text' && startOffset === firstNode.getTextContentSize()) {
      firstIndex = 1;
      firstNode = selectedTextNodes[1];
      startOffset = 0;
    }

    if (firstNode == null) {
      return;
    }

    const firstNextFormat = firstNode.getFormatFlags(formatType, null);
    const lastIndex = selectedTextNodesLength - 1;
    let lastNode = selectedTextNodes[lastIndex];
    const endOffset = endPoint.type === 'text' ? endPoint.offset : lastNode.getTextContentSize(); // Single node selected

    if (firstNode.is(lastNode)) {
      // No actual text is selected, so do nothing.
      if (startOffset === endOffset) {
        return;
      } // The entire node is selected, so just format it


      if (startOffset === 0 && endOffset === firstNode.getTextContentSize()) {
        firstNode.setFormat(firstNextFormat);
      } else {
        // Node is partially selected, so split it into two nodes
        // add style the selected one.
        const splitNodes = firstNode.splitText(startOffset, endOffset);
        const replacement = startOffset === 0 ? splitNodes[0] : splitNodes[1];
        replacement.setFormat(firstNextFormat); // Update selection only if starts/ends on text node

        if (startPoint.type === 'text') {
          startPoint.set(replacement.__key, 0, 'text');
        }

        if (endPoint.type === 'text') {
          endPoint.set(replacement.__key, endOffset - startOffset, 'text');
        }
      }

      this.format = firstNextFormat;
      return;
    } // Multiple nodes selected
    // The entire first node isn't selected, so split it


    if (startOffset !== 0) {
      [, firstNode] = firstNode.splitText(startOffset);
      startOffset = 0;
    }

    firstNode.setFormat(firstNextFormat);
    const lastNextFormat = lastNode.getFormatFlags(formatType, firstNextFormat); // If the offset is 0, it means no actual characters are selected,
    // so we skip formatting the last node altogether.

    if (endOffset > 0) {
      if (endOffset !== lastNode.getTextContentSize()) {
        [lastNode] = lastNode.splitText(endOffset);
      }

      lastNode.setFormat(lastNextFormat);
    } // Process all text nodes in between


    for (let i = firstIndex + 1; i < lastIndex; i++) {
      const textNode = selectedTextNodes[i];

      if (!textNode.isToken()) {
        const nextFormat = textNode.getFormatFlags(formatType, lastNextFormat);
        textNode.setFormat(nextFormat);
      }
    } // Update selection only if starts/ends on text node


    if (startPoint.type === 'text') {
      startPoint.set(firstNode.__key, startOffset, 'text');
    }

    if (endPoint.type === 'text') {
      endPoint.set(lastNode.__key, endOffset, 'text');
    }

    this.format = firstNextFormat | lastNextFormat;
  }

  insertNodes(nodes, selectStart) {
    // If there is a range selected remove the text in it
    if (!this.isCollapsed()) {
      const selectionEnd = this.isBackward() ? this.anchor : this.focus;
      const nextSibling = selectionEnd.getNode().getNextSibling();
      const nextSiblingKey = nextSibling ? nextSibling.getKey() : null;
      const prevSibling = selectionEnd.getNode().getPreviousSibling();
      const prevSiblingKey = prevSibling ? prevSibling.getKey() : null;
      this.removeText(); // If the selection has been moved to an adjacent inline element, create
      // a temporary text node that we can insert the nodes after.

      if (this.isCollapsed() && this.focus.type === 'element') {
        let textNode;

        if (this.focus.key === nextSiblingKey && this.focus.offset === 0) {
          textNode = $createTextNode$1();
          this.focus.getNode().insertBefore(textNode);
        } else if (this.focus.key === prevSiblingKey && this.focus.offset === this.focus.getNode().getChildrenSize()) {
          textNode = $createTextNode$1();
          this.focus.getNode().insertAfter(textNode);
        }

        if (textNode) {
          this.focus.set(textNode.__key, 0, 'text');
          this.anchor.set(textNode.__key, 0, 'text');
        }
      }
    }

    const anchor = this.anchor;
    const anchorOffset = anchor.offset;
    const anchorNode = anchor.getNode();
    let target = anchorNode;

    if (anchor.type === 'element') {
      const element = anchor.getNode();
      const placementNode = element.getChildAtIndex(anchorOffset - 1);

      if (placementNode === null) {
        target = element;
      } else {
        target = placementNode;
      }
    }

    const siblings = []; // Get all remaining text node siblings in this element so we can
    // append them after the last node we're inserting.

    const nextSiblings = anchorNode.getNextSiblings();
    const topLevelElement = $isRootOrShadowRoot$1(anchorNode) ? null : anchorNode.getTopLevelElementOrThrow();

    if ($isTextNode$1(anchorNode)) {
      const textContent = anchorNode.getTextContent();
      const textContentLength = textContent.length;

      if (anchorOffset === 0 && textContentLength !== 0) {
        const prevSibling = anchorNode.getPreviousSibling();

        if (prevSibling !== null) {
          target = prevSibling;
        } else {
          target = anchorNode.getParentOrThrow();
        }

        siblings.push(anchorNode);
      } else if (anchorOffset === textContentLength) {
        target = anchorNode;
      } else if (anchorNode.isToken()) {
        // Do nothing if we're inside a token node
        return false;
      } else {
        // If we started with a range selected grab the danglingText after the
        // end of the selection and put it on our siblings array so we can
        // append it after the last node we're inserting
        let danglingText;
        [target, danglingText] = anchorNode.splitText(anchorOffset);
        siblings.push(danglingText);
      }
    }

    const startingNode = target;
    siblings.push(...nextSiblings);
    const firstNode = nodes[0];
    let didReplaceOrMerge = false;
    let lastNode = null; // Time to insert the nodes!

    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i];

      if (!$isRootOrShadowRoot$1(target) && !$isDecoratorNode$1(target) && $isElementNode$1(node) && !node.isInline()) {
        // -----
        // Heuristics for the replacement or merging of elements
        // -----
        // If we have an incoming element node as the first node, then we'll need
        // see if we can merge any descendant leaf nodes into our existing target.
        // We can do this by finding the first descendant in our node and then we can
        // pluck it and its parent (siblings included) out and insert them directly
        // into our target. We only do this for the first node, as we are only
        // interested in merging with the anchor, which is our target.
        //
        // If we apply either the replacement or merging heuristics, we need to be
        // careful that we're not trying to insert a non-element node into a root node,
        // so we check if the target's parent after this logic is the root node and if
        // so we trigger an invariant to ensure this problem is caught in development
        // and fixed accordingly.
        if (node.is(firstNode)) {
          if ($isElementNode$1(target) && target.isEmpty() && target.canReplaceWith(node)) {
            target.replace(node);
            target = node;
            didReplaceOrMerge = true;
            continue;
          } // We may have a node tree where there are many levels, for example with
          // lists and tables. So let's find the first descendant to try and merge
          // with. So if we have the target:
          //
          // Paragraph (1)
          //   Text (2)
          //
          // and we are trying to insert:
          //
          // ListNode (3)
          //   ListItemNode (4)
          //     Text (5)
          //   ListItemNode (6)
          //
          // The result would be:
          //
          // Paragraph (1)
          //   Text (2)
          //   Text (5)
          //


          const firstDescendant = node.getFirstDescendant();

          if ($isLeafNode$1(firstDescendant)) {
            let element = firstDescendant.getParentOrThrow();

            while (element.isInline()) {
              element = element.getParentOrThrow();
            }

            const children = element.getChildren();
            const childrenLength = children.length;

            if ($isElementNode$1(target)) {
              let firstChild = target.getFirstChild();

              for (let s = 0; s < childrenLength; s++) {
                const child = children[s];

                if (firstChild === null) {
                  target.append(child);
                } else {
                  firstChild.insertAfter(child);
                }

                firstChild = child;
              }
            } else {
              for (let s = childrenLength - 1; s >= 0; s--) {
                target.insertAfter(children[s]);
              }

              target = target.getParentOrThrow();
            }

            lastNode = children[childrenLength - 1];
            element.remove();
            didReplaceOrMerge = true;

            if (element.is(node)) {
              continue;
            }
          }
        }

        if ($isTextNode$1(target)) {
          if (topLevelElement === null) {
            {
              throw Error(`insertNode: topLevelElement is root node`);
            }
          }

          target = topLevelElement;
        }
      } else if (didReplaceOrMerge && !$isElementNode$1(node) && !$isDecoratorNode$1(node) && $isRootOrShadowRoot$1(target.getParent())) {
        {
          throw Error(`insertNodes: cannot insert a non-element into a root node`);
        }
      }

      didReplaceOrMerge = false;

      if ($isElementNode$1(target) && !target.isInline()) {
        lastNode = node;

        if ($isDecoratorNode$1(node) && !node.isInline()) {
          target = target.insertAfter(node, false);
        } else if (!$isElementNode$1(node)) {
          const firstChild = target.getFirstChild();

          if (firstChild !== null) {
            firstChild.insertBefore(node);
          } else {
            target.append(node);
          }

          target = node;
        } else {
          if (!node.canBeEmpty() && node.isEmpty()) {
            continue;
          }

          if ($isRootNode$1(target)) {
            const placementNode = target.getChildAtIndex(anchorOffset);

            if (placementNode !== null) {
              placementNode.insertBefore(node);
            } else {
              target.append(node);
            }

            target = node;
          } else if (node.isInline()) {
            target.append(node);
            target = node;
          } else {
            target = target.insertAfter(node, false);
          }
        }
      } else if (!$isElementNode$1(node) || $isElementNode$1(node) && node.isInline() || $isDecoratorNode$1(target) && !target.isInline()) {
        lastNode = node; // when pasting top level node in the middle of paragraph
        // we need to split paragraph instead of placing it inline

        if ($isRangeSelection$1(this) && $isDecoratorNode$1(node) && ($isElementNode$1(target) || $isTextNode$1(target)) && !node.isInline()) {
          let splitNode;
          let splitOffset;

          if ($isTextNode$1(target)) {
            splitNode = target.getParentOrThrow();
            const [textNode] = target.splitText(anchorOffset);
            splitOffset = textNode.getIndexWithinParent() + 1;
          } else {
            splitNode = target;
            splitOffset = anchorOffset;
          }

          const [, rightTree] = $splitNode$3(splitNode, splitOffset);
          target = rightTree.insertBefore(node);
        } else {
          target = target.insertAfter(node, false);
        }
      } else {
        const nextTarget = target.getParentOrThrow(); // if we're inserting an Element after a LineBreak, we want to move the target to the parent
        // and remove the LineBreak so we don't have empty space.

        if ($isLineBreakNode$1(target)) {
          target.remove();
        }

        target = nextTarget; // Re-try again with the target being the parent

        i--;
        continue;
      }
    }

    if (selectStart) {
      // Handle moving selection to start for all nodes
      if ($isTextNode$1(startingNode)) {
        startingNode.select();
      } else {
        const prevSibling = target.getPreviousSibling();

        if ($isTextNode$1(prevSibling)) {
          prevSibling.select();
        } else {
          const index = target.getIndexWithinParent();
          target.getParentOrThrow().select(index, index);
        }
      }
    }

    if ($isElementNode$1(target)) {
      // If the last node to be inserted was a text node,
      // then we should attempt to move selection to that.
      const lastChild = $isTextNode$1(lastNode) ? lastNode : $isElementNode$1(lastNode) && lastNode.isInline() ? lastNode.getLastDescendant() : target.getLastDescendant();

      if (!selectStart) {
        // Handle moving selection to end for elements
        if (lastChild === null) {
          target.select();
        } else if ($isTextNode$1(lastChild)) {
          if (lastChild.getTextContent() === '') {
            lastChild.selectPrevious();
          } else {
            lastChild.select();
          }
        } else {
          lastChild.selectNext();
        }
      }

      if (siblings.length !== 0) {
        const originalTarget = target;

        for (let i = siblings.length - 1; i >= 0; i--) {
          const sibling = siblings[i];
          const prevParent = sibling.getParentOrThrow();

          if ($isElementNode$1(target) && !$isBlockElementNode(sibling) && !($isDecoratorNode$1(sibling) && ( // Note: We are only looking for decorators that are inline and not isolated.
          !sibling.isInline() || sibling.isIsolated()))) {
            if (originalTarget === target) {
              target.append(sibling);
            } else {
              target.insertBefore(sibling);
            }

            target = sibling;
          } else if (!$isElementNode$1(target) && !$isBlockElementNode(sibling)) {
            target.insertBefore(sibling);
            target = sibling;
          } else {
            if ($isElementNode$1(sibling) && !sibling.canInsertAfter(target)) {
              // @ts-ignore The clone method does exist on the constructor.
              const prevParentClone = prevParent.constructor.clone(prevParent);

              if (!$isElementNode$1(prevParentClone)) {
                {
                  throw Error(`insertNodes: cloned parent clone is not an element`);
                }
              }

              prevParentClone.append(sibling);
              target.insertAfter(prevParentClone);
            } else {
              target.insertAfter(sibling);
            }
          } // Check if the prev parent is empty, as it might need
          // removing.


          if (prevParent.isEmpty() && !prevParent.canBeEmpty()) {
            prevParent.remove();
          }
        }
      }
    } else if (!selectStart) {
      // Handle moving selection to end for other nodes
      if ($isTextNode$1(target)) {
        target.select();
      } else {
        const element = target.getParentOrThrow();
        const index = target.getIndexWithinParent() + 1;
        element.select(index, index);
      }
    }

    return true;
  }

  insertParagraph() {
    if (!this.isCollapsed()) {
      this.removeText();
    }

    const anchor = this.anchor;
    const anchorOffset = anchor.offset;
    let currentElement;
    let nodesToMove = [];
    let siblingsToMove = [];

    if (anchor.type === 'text') {
      const anchorNode = anchor.getNode();
      nodesToMove = anchorNode.getNextSiblings().reverse();
      currentElement = anchorNode.getParentOrThrow();
      const isInline = currentElement.isInline();
      const textContentLength = isInline ? currentElement.getTextContentSize() : anchorNode.getTextContentSize();

      if (anchorOffset === 0) {
        nodesToMove.push(anchorNode);
      } else {
        if (isInline) {
          // For inline nodes, we want to move all the siblings to the new paragraph
          // if selection is at the end, we just move the siblings. Otherwise, we also
          // split the text node and add that and it's siblings below.
          siblingsToMove = currentElement.getNextSiblings();
        }

        if (anchorOffset !== textContentLength) {
          if (!isInline || anchorOffset !== anchorNode.getTextContentSize()) {
            const [, splitNode] = anchorNode.splitText(anchorOffset);
            nodesToMove.push(splitNode);
          }
        }
      }
    } else {
      currentElement = anchor.getNode();

      if ($isRootOrShadowRoot$1(currentElement)) {
        const paragraph = $createParagraphNode$1();
        const child = currentElement.getChildAtIndex(anchorOffset);
        paragraph.select();

        if (child !== null) {
          child.insertBefore(paragraph, false);
        } else {
          currentElement.append(paragraph);
        }

        return;
      }

      nodesToMove = currentElement.getChildren().slice(anchorOffset).reverse();
    }

    const nodesToMoveLength = nodesToMove.length;

    if (anchorOffset === 0 && nodesToMoveLength > 0 && currentElement.isInline()) {
      const parent = currentElement.getParentOrThrow();
      const newElement = parent.insertNewAfter(this, false);

      if ($isElementNode$1(newElement)) {
        const children = parent.getChildren();

        for (let i = 0; i < children.length; i++) {
          newElement.append(children[i]);
        }
      }

      return;
    }

    const newElement = currentElement.insertNewAfter(this, false);

    if (newElement === null) {
      // Handle as a line break insertion
      this.insertLineBreak();
    } else if ($isElementNode$1(newElement)) {
      // If we're at the beginning of the current element, move the new element to be before the current element
      const currentElementFirstChild = currentElement.getFirstChild();
      const isBeginning = anchorOffset === 0 && (currentElement.is(anchor.getNode()) || currentElementFirstChild && currentElementFirstChild.is(anchor.getNode()));

      if (isBeginning && nodesToMoveLength > 0) {
        currentElement.insertBefore(newElement);
        return;
      }

      let firstChild = null;
      const siblingsToMoveLength = siblingsToMove.length;
      const parent = newElement.getParentOrThrow(); // For inline elements, we append the siblings to the parent.

      if (siblingsToMoveLength > 0) {
        for (let i = 0; i < siblingsToMoveLength; i++) {
          const siblingToMove = siblingsToMove[i];
          parent.append(siblingToMove);
        }
      }

      if (nodesToMoveLength !== 0) {
        for (let i = 0; i < nodesToMoveLength; i++) {
          const nodeToMove = nodesToMove[i];

          if (firstChild === null) {
            newElement.append(nodeToMove);
          } else {
            firstChild.insertBefore(nodeToMove);
          }

          firstChild = nodeToMove;
        }
      }

      if (!newElement.canBeEmpty() && newElement.getChildrenSize() === 0) {
        newElement.selectPrevious();
        newElement.remove();
      } else {
        newElement.selectStart();
      }
    }
  }

  insertLineBreak(selectStart) {
    const lineBreakNode = $createLineBreakNode$1();
    const anchor = this.anchor;

    if (anchor.type === 'element') {
      const element = anchor.getNode();

      if ($isRootNode$1(element)) {
        this.insertParagraph();
      }
    }

    if (selectStart) {
      this.insertNodes([lineBreakNode], true);
    } else {
      if (this.insertNodes([lineBreakNode])) {
        lineBreakNode.selectNext(0, 0);
      }
    }
  }

  getCharacterOffsets() {
    return getCharacterOffsets(this);
  }

  extract() {
    const selectedNodes = this.getNodes();
    const selectedNodesLength = selectedNodes.length;
    const lastIndex = selectedNodesLength - 1;
    const anchor = this.anchor;
    const focus = this.focus;
    let firstNode = selectedNodes[0];
    let lastNode = selectedNodes[lastIndex];
    const [anchorOffset, focusOffset] = getCharacterOffsets(this);

    if (selectedNodesLength === 0) {
      return [];
    } else if (selectedNodesLength === 1) {
      if ($isTextNode$1(firstNode) && !this.isCollapsed()) {
        const startOffset = anchorOffset > focusOffset ? focusOffset : anchorOffset;
        const endOffset = anchorOffset > focusOffset ? anchorOffset : focusOffset;
        const splitNodes = firstNode.splitText(startOffset, endOffset);
        const node = startOffset === 0 ? splitNodes[0] : splitNodes[1];
        return node != null ? [node] : [];
      }

      return [firstNode];
    }

    const isBefore = anchor.isBefore(focus);

    if ($isTextNode$1(firstNode)) {
      const startOffset = isBefore ? anchorOffset : focusOffset;

      if (startOffset === firstNode.getTextContentSize()) {
        selectedNodes.shift();
      } else if (startOffset !== 0) {
        [, firstNode] = firstNode.splitText(startOffset);
        selectedNodes[0] = firstNode;
      }
    }

    if ($isTextNode$1(lastNode)) {
      const lastNodeText = lastNode.getTextContent();
      const lastNodeTextLength = lastNodeText.length;
      const endOffset = isBefore ? focusOffset : anchorOffset;

      if (endOffset === 0) {
        selectedNodes.pop();
      } else if (endOffset !== lastNodeTextLength) {
        [lastNode] = lastNode.splitText(endOffset);
        selectedNodes[lastIndex] = lastNode;
      }
    }

    return selectedNodes;
  }

  modify(alter, isBackward, granularity) {
    const focus = this.focus;
    const anchor = this.anchor;
    const collapse = alter === 'move'; // Handle the selection movement around decorators.

    const possibleNode = $getAdjacentNode$1(focus, isBackward);

    if ($isDecoratorNode$1(possibleNode) && !possibleNode.isIsolated()) {
      // Make it possible to move selection from range selection to
      // node selection on the node.
      if (collapse && possibleNode.isKeyboardSelectable()) {
        const nodeSelection = $createNodeSelection$1();
        nodeSelection.add(possibleNode.__key);
        $setSelection$1(nodeSelection);
        return;
      }

      const sibling = isBackward ? possibleNode.getPreviousSibling() : possibleNode.getNextSibling();

      if (!$isTextNode$1(sibling)) {
        const parent = possibleNode.getParentOrThrow();
        let offset;
        let elementKey;

        if ($isElementNode$1(sibling)) {
          elementKey = sibling.__key;
          offset = isBackward ? sibling.getChildrenSize() : 0;
        } else {
          offset = possibleNode.getIndexWithinParent();
          elementKey = parent.__key;

          if (!isBackward) {
            offset++;
          }
        }

        focus.set(elementKey, offset, 'element');

        if (collapse) {
          anchor.set(elementKey, offset, 'element');
        }

        return;
      } else {
        const siblingKey = sibling.__key;
        const offset = isBackward ? sibling.getTextContent().length : 0;
        focus.set(siblingKey, offset, 'text');

        if (collapse) {
          anchor.set(siblingKey, offset, 'text');
        }

        return;
      }
    }

    const editor = getActiveEditor();
    const domSelection = getDOMSelection(editor._window);

    if (!domSelection) {
      return;
    }

    const blockCursorElement = editor._blockCursorElement;
    const rootElement = editor._rootElement; // Remove the block cursor element if it exists. This will ensure selection
    // works as intended. If we leave it in the DOM all sorts of strange bugs
    // occur. :/

    if (rootElement !== null && blockCursorElement !== null && $isElementNode$1(possibleNode) && !possibleNode.isInline() && !possibleNode.canBeEmpty()) {
      removeDOMBlockCursorElement(blockCursorElement, editor, rootElement);
    } // We use the DOM selection.modify API here to "tell" us what the selection
    // will be. We then use it to update the Lexical selection accordingly. This
    // is much more reliable than waiting for a beforeinput and using the ranges
    // from getTargetRanges(), and is also better than trying to do it ourselves
    // using Intl.Segmenter or other workarounds that struggle with word segments
    // and line segments (especially with word wrapping and non-Roman languages).


    moveNativeSelection(domSelection, alter, isBackward ? 'backward' : 'forward', granularity); // Guard against no ranges

    if (domSelection.rangeCount > 0) {
      const range = domSelection.getRangeAt(0); // Apply the DOM selection to our Lexical selection.

      const anchorNode = this.anchor.getNode();
      const root = $isRootNode$1(anchorNode) ? anchorNode : $getNearestRootOrShadowRoot$1(anchorNode);
      this.applyDOMRange(range);
      this.dirty = true;

      if (!collapse) {
        // Validate selection; make sure that the new extended selection respects shadow roots
        const nodes = this.getNodes();
        const validNodes = [];
        let shrinkSelection = false;

        for (let i = 0; i < nodes.length; i++) {
          const nextNode = nodes[i];

          if ($hasAncestor$1(nextNode, root)) {
            validNodes.push(nextNode);
          } else {
            shrinkSelection = true;
          }
        }

        if (shrinkSelection && validNodes.length > 0) {
          // validNodes length check is a safeguard against an invalid selection; as getNodes()
          // will return an empty array in this case
          if (isBackward) {
            const firstValidNode = validNodes[0];

            if ($isElementNode$1(firstValidNode)) {
              firstValidNode.selectStart();
            } else {
              firstValidNode.getParentOrThrow().selectStart();
            }
          } else {
            const lastValidNode = validNodes[validNodes.length - 1];

            if ($isElementNode$1(lastValidNode)) {
              lastValidNode.selectEnd();
            } else {
              lastValidNode.getParentOrThrow().selectEnd();
            }
          }
        } // Because a range works on start and end, we might need to flip
        // the anchor and focus points to match what the DOM has, not what
        // the range has specifically.


        if (domSelection.anchorNode !== range.startContainer || domSelection.anchorOffset !== range.startOffset) {
          $swapPoints(this);
        }
      }
    }
  }

  deleteCharacter(isBackward) {
    if (this.isCollapsed()) {
      const anchor = this.anchor;
      const focus = this.focus;
      let anchorNode = anchor.getNode();

      if (!isBackward && ( // Delete forward handle case
      anchor.type === 'element' && $isElementNode$1(anchorNode) && anchor.offset === anchorNode.getChildrenSize() || anchor.type === 'text' && anchor.offset === anchorNode.getTextContentSize())) {
        const parent = anchorNode.getParent();
        const nextSibling = anchorNode.getNextSibling() || (parent === null ? null : parent.getNextSibling());

        if ($isElementNode$1(nextSibling) && nextSibling.isShadowRoot()) {
          return;
        }
      } // Handle the deletion around decorators.


      const possibleNode = $getAdjacentNode$1(focus, isBackward);

      if ($isDecoratorNode$1(possibleNode) && !possibleNode.isIsolated()) {
        // Make it possible to move selection from range selection to
        // node selection on the node.
        if (possibleNode.isKeyboardSelectable() && $isElementNode$1(anchorNode) && anchorNode.getChildrenSize() === 0) {
          anchorNode.remove();
          const nodeSelection = $createNodeSelection$1();
          nodeSelection.add(possibleNode.__key);
          $setSelection$1(nodeSelection);
        } else {
          possibleNode.remove();
        }

        return;
      }

      this.modify('extend', isBackward, 'character');

      if (!this.isCollapsed()) {
        const focusNode = focus.type === 'text' ? focus.getNode() : null;
        anchorNode = anchor.type === 'text' ? anchor.getNode() : null;

        if (focusNode !== null && focusNode.isSegmented()) {
          const offset = focus.offset;
          const textContentSize = focusNode.getTextContentSize();

          if (focusNode.is(anchorNode) || isBackward && offset !== textContentSize || !isBackward && offset !== 0) {
            $removeSegment(focusNode, isBackward, offset);
            return;
          }
        } else if (anchorNode !== null && anchorNode.isSegmented()) {
          const offset = anchor.offset;
          const textContentSize = anchorNode.getTextContentSize();

          if (anchorNode.is(focusNode) || isBackward && offset !== 0 || !isBackward && offset !== textContentSize) {
            $removeSegment(anchorNode, isBackward, offset);
            return;
          }
        }

        $updateCaretSelectionForUnicodeCharacter(this, isBackward);
      } else if (isBackward && anchor.offset === 0) {
        // Special handling around rich text nodes
        const element = anchor.type === 'element' ? anchor.getNode() : anchor.getNode().getParentOrThrow();

        if (element.collapseAtStart(this)) {
          return;
        }
      }
    }

    const wasCollapsed = this.isCollapsed();
    this.removeText();

    if (isBackward && !wasCollapsed && this.isCollapsed() && this.anchor.type === 'element' && this.anchor.offset === 0) {
      const anchorNode = this.anchor.getNode();

      if (anchorNode.isEmpty() && $isRootNode$1(anchorNode.getParent()) && anchorNode.getIndexWithinParent() === 0) {
        anchorNode.collapseAtStart(this);
      }
    }
  }

  deleteLine(isBackward) {
    if (this.isCollapsed()) {
      if (this.anchor.type === 'text') {
        this.modify('extend', isBackward, 'lineboundary');
      } // If selection is extended to cover text edge then extend it one character more
      // to delete its parent element. Otherwise text content will be deleted but empty
      // parent node will remain


      const endPoint = isBackward ? this.focus : this.anchor;

      if (endPoint.offset === 0) {
        this.modify('extend', isBackward, 'character');
      }
    }

    this.removeText();
  }

  deleteWord(isBackward) {
    if (this.isCollapsed()) {
      this.modify('extend', isBackward, 'word');
    }

    this.removeText();
  }

}
function $isNodeSelection$1(x) {
  return x instanceof NodeSelection;
}

function getCharacterOffset(point) {
  const offset = point.offset;

  if (point.type === 'text') {
    return offset;
  }

  const parent = point.getNode();
  return offset === parent.getChildrenSize() ? parent.getTextContent().length : 0;
}

function getCharacterOffsets(selection) {
  const anchor = selection.anchor;
  const focus = selection.focus;

  if (anchor.type === 'element' && focus.type === 'element' && anchor.key === focus.key && anchor.offset === focus.offset) {
    return [0, 0];
  }

  return [getCharacterOffset(anchor), getCharacterOffset(focus)];
}

function $swapPoints(selection) {
  const focus = selection.focus;
  const anchor = selection.anchor;
  const anchorKey = anchor.key;
  const anchorOffset = anchor.offset;
  const anchorType = anchor.type;
  $setPointValues(anchor, focus.key, focus.offset, focus.type);
  $setPointValues(focus, anchorKey, anchorOffset, anchorType);
  selection._cachedNodes = null;
}

function moveNativeSelection(domSelection, alter, direction, granularity) {
  // @ts-expect-error Selection.modify() method applies a change to the current selection or cursor position,
  // but is still non-standard in some browsers.
  domSelection.modify(alter, direction, granularity);
}

function $updateCaretSelectionForUnicodeCharacter(selection, isBackward) {
  const anchor = selection.anchor;
  const focus = selection.focus;
  const anchorNode = anchor.getNode();
  const focusNode = focus.getNode();

  if (anchorNode === focusNode && anchor.type === 'text' && focus.type === 'text') {
    // Handling of multibyte characters
    const anchorOffset = anchor.offset;
    const focusOffset = focus.offset;
    const isBefore = anchorOffset < focusOffset;
    const startOffset = isBefore ? anchorOffset : focusOffset;
    const endOffset = isBefore ? focusOffset : anchorOffset;
    const characterOffset = endOffset - 1;

    if (startOffset !== characterOffset) {
      const text = anchorNode.getTextContent().slice(startOffset, endOffset);

      if (!doesContainGrapheme(text)) {
        if (isBackward) {
          focus.offset = characterOffset;
        } else {
          anchor.offset = characterOffset;
        }
      }
    }
  }
}

function $removeSegment(node, isBackward, offset) {
  const textNode = node;
  const textContent = textNode.getTextContent();
  const split = textContent.split(/(?=\s)/g);
  const splitLength = split.length;
  let segmentOffset = 0;
  let restoreOffset = 0;

  for (let i = 0; i < splitLength; i++) {
    const text = split[i];
    const isLast = i === splitLength - 1;
    restoreOffset = segmentOffset;
    segmentOffset += text.length;

    if (isBackward && segmentOffset === offset || segmentOffset > offset || isLast) {
      split.splice(i, 1);

      if (isLast) {
        restoreOffset = undefined;
      }

      break;
    }
  }

  const nextTextContent = split.join('').trim();

  if (nextTextContent === '') {
    textNode.remove();
  } else {
    textNode.setTextContent(nextTextContent);
    textNode.select(restoreOffset, restoreOffset);
  }
}

function shouldResolveAncestor(resolvedElement, resolvedOffset, lastPoint) {
  const parent = resolvedElement.getParent();
  return lastPoint === null || parent === null || !parent.canBeEmpty() || parent !== lastPoint.getNode();
}

function internalResolveSelectionPoint(dom, offset, lastPoint, editor) {
  let resolvedOffset = offset;
  let resolvedNode; // If we have selection on an element, we will
  // need to figure out (using the offset) what text
  // node should be selected.

  if (dom.nodeType === DOM_ELEMENT_TYPE) {
    // Resolve element to a ElementNode, or TextNode, or null
    let moveSelectionToEnd = false; // Given we're moving selection to another node, selection is
    // definitely dirty.
    // We use the anchor to find which child node to select

    const childNodes = dom.childNodes;
    const childNodesLength = childNodes.length; // If the anchor is the same as length, then this means we
    // need to select the very last text node.

    if (resolvedOffset === childNodesLength) {
      moveSelectionToEnd = true;
      resolvedOffset = childNodesLength - 1;
    }

    let childDOM = childNodes[resolvedOffset];
    let hasBlockCursor = false;

    if (childDOM === editor._blockCursorElement) {
      childDOM = childNodes[resolvedOffset + 1];
      hasBlockCursor = true;
    } else if (editor._blockCursorElement !== null) {
      resolvedOffset--;
    }

    resolvedNode = getNodeFromDOM(childDOM);

    if ($isTextNode$1(resolvedNode)) {
      resolvedOffset = getTextNodeOffset(resolvedNode, moveSelectionToEnd);
    } else {
      let resolvedElement = getNodeFromDOM(dom); // Ensure resolvedElement is actually a element.

      if (resolvedElement === null) {
        return null;
      }

      if ($isElementNode$1(resolvedElement)) {
        let child = resolvedElement.getChildAtIndex(resolvedOffset);

        if ($isElementNode$1(child) && shouldResolveAncestor(child, resolvedOffset, lastPoint)) {
          const descendant = moveSelectionToEnd ? child.getLastDescendant() : child.getFirstDescendant();

          if (descendant === null) {
            resolvedElement = child;
            resolvedOffset = 0;
          } else {
            child = descendant;
            resolvedElement = $isElementNode$1(child) ? child : child.getParentOrThrow();
          }
        }

        if ($isTextNode$1(child)) {
          resolvedNode = child;
          resolvedElement = null;
          resolvedOffset = getTextNodeOffset(child, moveSelectionToEnd);
        } else if (child !== resolvedElement && moveSelectionToEnd && !hasBlockCursor) {
          resolvedOffset++;
        }
      } else {
        const index = resolvedElement.getIndexWithinParent(); // When selecting decorators, there can be some selection issues when using resolvedOffset,
        // and instead we should be checking if we're using the offset

        if (offset === 0 && $isDecoratorNode$1(resolvedElement) && getNodeFromDOM(dom) === resolvedElement) {
          resolvedOffset = index;
        } else {
          resolvedOffset = index + 1;
        }

        resolvedElement = resolvedElement.getParentOrThrow();
      }

      if ($isElementNode$1(resolvedElement)) {
        return $createPoint(resolvedElement.__key, resolvedOffset, 'element');
      }
    }
  } else {
    // TextNode or null
    resolvedNode = getNodeFromDOM(dom);
  }

  if (!$isTextNode$1(resolvedNode)) {
    return null;
  }

  return $createPoint(resolvedNode.__key, resolvedOffset, 'text');
}

function resolveSelectionPointOnBoundary(point, isBackward, isCollapsed) {
  const offset = point.offset;
  const node = point.getNode();

  if (offset === 0) {
    const prevSibling = node.getPreviousSibling();
    const parent = node.getParent();

    if (!isBackward) {
      if ($isElementNode$1(prevSibling) && !isCollapsed && prevSibling.isInline()) {
        point.key = prevSibling.__key;
        point.offset = prevSibling.getChildrenSize(); // @ts-expect-error: intentional

        point.type = 'element';
      } else if ($isTextNode$1(prevSibling)) {
        point.key = prevSibling.__key;
        point.offset = prevSibling.getTextContent().length;
      }
    } else if ((isCollapsed || !isBackward) && prevSibling === null && $isElementNode$1(parent) && parent.isInline()) {
      const parentSibling = parent.getPreviousSibling();

      if ($isTextNode$1(parentSibling)) {
        point.key = parentSibling.__key;
        point.offset = parentSibling.getTextContent().length;
      }
    }
  } else if (offset === node.getTextContent().length) {
    const nextSibling = node.getNextSibling();
    const parent = node.getParent();

    if (isBackward && $isElementNode$1(nextSibling) && nextSibling.isInline()) {
      point.key = nextSibling.__key;
      point.offset = 0; // @ts-expect-error: intentional

      point.type = 'element';
    } else if ((isCollapsed || isBackward) && nextSibling === null && $isElementNode$1(parent) && parent.isInline() && !parent.canInsertTextAfter()) {
      const parentSibling = parent.getNextSibling();

      if ($isTextNode$1(parentSibling)) {
        point.key = parentSibling.__key;
        point.offset = 0;
      }
    }
  }
}

function normalizeSelectionPointsForBoundaries(anchor, focus, lastSelection) {
  if (anchor.type === 'text' && focus.type === 'text') {
    const isBackward = anchor.isBefore(focus);
    const isCollapsed = anchor.is(focus); // Attempt to normalize the offset to the previous sibling if we're at the
    // start of a text node and the sibling is a text node or inline element.

    resolveSelectionPointOnBoundary(anchor, isBackward, isCollapsed);
    resolveSelectionPointOnBoundary(focus, !isBackward, isCollapsed);

    if (isCollapsed) {
      focus.key = anchor.key;
      focus.offset = anchor.offset;
      focus.type = anchor.type;
    }

    const editor = getActiveEditor();

    if (editor.isComposing() && editor._compositionKey !== anchor.key && $isRangeSelection$1(lastSelection)) {
      const lastAnchor = lastSelection.anchor;
      const lastFocus = lastSelection.focus;
      $setPointValues(anchor, lastAnchor.key, lastAnchor.offset, lastAnchor.type);
      $setPointValues(focus, lastFocus.key, lastFocus.offset, lastFocus.type);
    }
  }
}

function internalResolveSelectionPoints(anchorDOM, anchorOffset, focusDOM, focusOffset, editor, lastSelection) {
  if (anchorDOM === null || focusDOM === null || !isSelectionWithinEditor$1(editor, anchorDOM, focusDOM)) {
    return null;
  }

  const resolvedAnchorPoint = internalResolveSelectionPoint(anchorDOM, anchorOffset, $isRangeSelection$1(lastSelection) ? lastSelection.anchor : null, editor);

  if (resolvedAnchorPoint === null) {
    return null;
  }

  const resolvedFocusPoint = internalResolveSelectionPoint(focusDOM, focusOffset, $isRangeSelection$1(lastSelection) ? lastSelection.focus : null, editor);

  if (resolvedFocusPoint === null) {
    return null;
  }

  if (resolvedAnchorPoint.type === 'element' && resolvedFocusPoint.type === 'element') {
    const anchorNode = getNodeFromDOM(anchorDOM);
    const focusNode = getNodeFromDOM(focusDOM); // Ensure if we're selecting the content of a decorator that we
    // return null for this point, as it's not in the controlled scope
    // of Lexical.

    if ($isDecoratorNode$1(anchorNode) && $isDecoratorNode$1(focusNode)) {
      return null;
    }
  } // Handle normalization of selection when it is at the boundaries.


  normalizeSelectionPointsForBoundaries(resolvedAnchorPoint, resolvedFocusPoint, lastSelection);
  return [resolvedAnchorPoint, resolvedFocusPoint];
}

function $isBlockElementNode(node) {
  return $isElementNode$1(node) && !node.isInline();
} // This is used to make a selection when the existing
// selection is null, i.e. forcing selection on the editor
// when it current exists outside the editor.


function internalMakeRangeSelection(anchorKey, anchorOffset, focusKey, focusOffset, anchorType, focusType) {
  const editorState = getActiveEditorState();
  const selection = new RangeSelection($createPoint(anchorKey, anchorOffset, anchorType), $createPoint(focusKey, focusOffset, focusType), 0, '');
  selection.dirty = true;
  editorState._selection = selection;
  return selection;
}
function $createRangeSelection$1() {
  const anchor = $createPoint('root', 0, 'element');
  const focus = $createPoint('root', 0, 'element');
  return new RangeSelection(anchor, focus, 0, '');
}
function $createNodeSelection$1() {
  return new NodeSelection(new Set());
}
function DEPRECATED_$createGridSelection$1() {
  const anchor = $createPoint('root', 0, 'element');
  const focus = $createPoint('root', 0, 'element');
  return new GridSelection('root', anchor, focus);
}
function internalCreateSelection(editor) {
  const currentEditorState = editor.getEditorState();
  const lastSelection = currentEditorState._selection;
  const domSelection = getDOMSelection(editor._window);

  if ($isNodeSelection$1(lastSelection) || DEPRECATED_$isGridSelection$1(lastSelection)) {
    return lastSelection.clone();
  }

  return internalCreateRangeSelection(lastSelection, domSelection, editor);
}
function internalCreateRangeSelection(lastSelection, domSelection, editor) {
  const windowObj = editor._window;

  if (windowObj === null) {
    return null;
  } // When we create a selection, we try to use the previous
  // selection where possible, unless an actual user selection
  // change has occurred. When we do need to create a new selection
  // we validate we can have text nodes for both anchor and focus
  // nodes. If that holds true, we then return that selection
  // as a mutable object that we use for the editor state for this
  // update cycle. If a selection gets changed, and requires a
  // update to native DOM selection, it gets marked as "dirty".
  // If the selection changes, but matches with the existing
  // DOM selection, then we only need to sync it. Otherwise,
  // we generally bail out of doing an update to selection during
  // reconciliation unless there are dirty nodes that need
  // reconciling.


  const windowEvent = windowObj.event;
  const eventType = windowEvent ? windowEvent.type : undefined;
  const isSelectionChange = eventType === 'selectionchange';
  const useDOMSelection = !getIsProcesssingMutations() && (isSelectionChange || eventType === 'beforeinput' || eventType === 'compositionstart' || eventType === 'compositionend' || eventType === 'click' && windowEvent && windowEvent.detail === 3 || eventType === 'drop' || eventType === undefined);
  let anchorDOM, focusDOM, anchorOffset, focusOffset;

  if (!$isRangeSelection$1(lastSelection) || useDOMSelection) {
    if (domSelection === null) {
      return null;
    }

    anchorDOM = domSelection.anchorNode;
    focusDOM = domSelection.focusNode;
    anchorOffset = domSelection.anchorOffset;
    focusOffset = domSelection.focusOffset;

    if (isSelectionChange && $isRangeSelection$1(lastSelection) && !isSelectionWithinEditor$1(editor, anchorDOM, focusDOM)) {
      return lastSelection.clone();
    }
  } else {
    return lastSelection.clone();
  } // Let's resolve the text nodes from the offsets and DOM nodes we have from
  // native selection.


  const resolvedSelectionPoints = internalResolveSelectionPoints(anchorDOM, anchorOffset, focusDOM, focusOffset, editor, lastSelection);

  if (resolvedSelectionPoints === null) {
    return null;
  }

  const [resolvedAnchorPoint, resolvedFocusPoint] = resolvedSelectionPoints;
  return new RangeSelection(resolvedAnchorPoint, resolvedFocusPoint, !$isRangeSelection$1(lastSelection) ? 0 : lastSelection.format, !$isRangeSelection$1(lastSelection) ? '' : lastSelection.style);
}
function $getSelection$1() {
  const editorState = getActiveEditorState();
  return editorState._selection;
}
function $getPreviousSelection$1() {
  const editor = getActiveEditor();
  return editor._editorState._selection;
}
function $updateElementSelectionOnCreateDeleteNode(selection, parentNode, nodeOffset, times = 1) {
  const anchor = selection.anchor;
  const focus = selection.focus;
  const anchorNode = anchor.getNode();
  const focusNode = focus.getNode();

  if (!parentNode.is(anchorNode) && !parentNode.is(focusNode)) {
    return;
  }

  const parentKey = parentNode.__key; // Single node. We shift selection but never redimension it

  if (selection.isCollapsed()) {
    const selectionOffset = anchor.offset;

    if (nodeOffset <= selectionOffset && times > 0 || nodeOffset < selectionOffset && times < 0) {
      const newSelectionOffset = Math.max(0, selectionOffset + times);
      anchor.set(parentKey, newSelectionOffset, 'element');
      focus.set(parentKey, newSelectionOffset, 'element'); // The new selection might point to text nodes, try to resolve them

      $updateSelectionResolveTextNodes(selection);
    }
  } else {
    // Multiple nodes selected. We shift or redimension selection
    const isBackward = selection.isBackward();
    const firstPoint = isBackward ? focus : anchor;
    const firstPointNode = firstPoint.getNode();
    const lastPoint = isBackward ? anchor : focus;
    const lastPointNode = lastPoint.getNode();

    if (parentNode.is(firstPointNode)) {
      const firstPointOffset = firstPoint.offset;

      if (nodeOffset <= firstPointOffset && times > 0 || nodeOffset < firstPointOffset && times < 0) {
        firstPoint.set(parentKey, Math.max(0, firstPointOffset + times), 'element');
      }
    }

    if (parentNode.is(lastPointNode)) {
      const lastPointOffset = lastPoint.offset;

      if (nodeOffset <= lastPointOffset && times > 0 || nodeOffset < lastPointOffset && times < 0) {
        lastPoint.set(parentKey, Math.max(0, lastPointOffset + times), 'element');
      }
    }
  } // The new selection might point to text nodes, try to resolve them


  $updateSelectionResolveTextNodes(selection);
}

function $updateSelectionResolveTextNodes(selection) {
  const anchor = selection.anchor;
  const anchorOffset = anchor.offset;
  const focus = selection.focus;
  const focusOffset = focus.offset;
  const anchorNode = anchor.getNode();
  const focusNode = focus.getNode();

  if (selection.isCollapsed()) {
    if (!$isElementNode$1(anchorNode)) {
      return;
    }

    const childSize = anchorNode.getChildrenSize();
    const anchorOffsetAtEnd = anchorOffset >= childSize;
    const child = anchorOffsetAtEnd ? anchorNode.getChildAtIndex(childSize - 1) : anchorNode.getChildAtIndex(anchorOffset);

    if ($isTextNode$1(child)) {
      let newOffset = 0;

      if (anchorOffsetAtEnd) {
        newOffset = child.getTextContentSize();
      }

      anchor.set(child.__key, newOffset, 'text');
      focus.set(child.__key, newOffset, 'text');
    }

    return;
  }

  if ($isElementNode$1(anchorNode)) {
    const childSize = anchorNode.getChildrenSize();
    const anchorOffsetAtEnd = anchorOffset >= childSize;
    const child = anchorOffsetAtEnd ? anchorNode.getChildAtIndex(childSize - 1) : anchorNode.getChildAtIndex(anchorOffset);

    if ($isTextNode$1(child)) {
      let newOffset = 0;

      if (anchorOffsetAtEnd) {
        newOffset = child.getTextContentSize();
      }

      anchor.set(child.__key, newOffset, 'text');
    }
  }

  if ($isElementNode$1(focusNode)) {
    const childSize = focusNode.getChildrenSize();
    const focusOffsetAtEnd = focusOffset >= childSize;
    const child = focusOffsetAtEnd ? focusNode.getChildAtIndex(childSize - 1) : focusNode.getChildAtIndex(focusOffset);

    if ($isTextNode$1(child)) {
      let newOffset = 0;

      if (focusOffsetAtEnd) {
        newOffset = child.getTextContentSize();
      }

      focus.set(child.__key, newOffset, 'text');
    }
  }
}

function applySelectionTransforms(nextEditorState, editor) {
  const prevEditorState = editor.getEditorState();
  const prevSelection = prevEditorState._selection;
  const nextSelection = nextEditorState._selection;

  if ($isRangeSelection$1(nextSelection)) {
    const anchor = nextSelection.anchor;
    const focus = nextSelection.focus;
    let anchorNode;

    if (anchor.type === 'text') {
      anchorNode = anchor.getNode();
      anchorNode.selectionTransform(prevSelection, nextSelection);
    }

    if (focus.type === 'text') {
      const focusNode = focus.getNode();

      if (anchorNode !== focusNode) {
        focusNode.selectionTransform(prevSelection, nextSelection);
      }
    }
  }
}
function moveSelectionPointToSibling(point, node, parent, prevSibling, nextSibling) {
  let siblingKey = null;
  let offset = 0;
  let type = null;

  if (prevSibling !== null) {
    siblingKey = prevSibling.__key;

    if ($isTextNode$1(prevSibling)) {
      offset = prevSibling.getTextContentSize();
      type = 'text';
    } else if ($isElementNode$1(prevSibling)) {
      offset = prevSibling.getChildrenSize();
      type = 'element';
    }
  } else {
    if (nextSibling !== null) {
      siblingKey = nextSibling.__key;

      if ($isTextNode$1(nextSibling)) {
        type = 'text';
      } else if ($isElementNode$1(nextSibling)) {
        type = 'element';
      }
    }
  }

  if (siblingKey !== null && type !== null) {
    point.set(siblingKey, offset, type);
  } else {
    offset = node.getIndexWithinParent();

    if (offset === -1) {
      // Move selection to end of parent
      offset = parent.getChildrenSize();
    }

    point.set(parent.__key, offset, 'element');
  }
}
function adjustPointOffsetForMergedSibling(point, isBefore, key, target, textLength) {
  if (point.type === 'text') {
    point.key = key;

    if (!isBefore) {
      point.offset += textLength;
    }
  } else if (point.offset > target.getIndexWithinParent()) {
    point.offset -= 1;
  }
}
function updateDOMSelection(prevSelection, nextSelection, editor, domSelection, tags, rootElement, nodeCount) {
  const anchorDOMNode = domSelection.anchorNode;
  const focusDOMNode = domSelection.focusNode;
  const anchorOffset = domSelection.anchorOffset;
  const focusOffset = domSelection.focusOffset;
  const activeElement = document.activeElement; // TODO: make this not hard-coded, and add another config option
  // that makes this configurable.

  if (tags.has('collaboration') && activeElement !== rootElement || activeElement !== null && isSelectionCapturedInDecoratorInput$1(activeElement)) {
    return;
  }

  if (!$isRangeSelection$1(nextSelection)) {
    // We don't remove selection if the prevSelection is null because
    // of editor.setRootElement(). If this occurs on init when the
    // editor is already focused, then this can cause the editor to
    // lose focus.
    if (prevSelection !== null && isSelectionWithinEditor$1(editor, anchorDOMNode, focusDOMNode)) {
      domSelection.removeAllRanges();
    }

    return;
  }

  const anchor = nextSelection.anchor;
  const focus = nextSelection.focus;
  const anchorKey = anchor.key;
  const focusKey = focus.key;
  const anchorDOM = getElementByKeyOrThrow(editor, anchorKey);
  const focusDOM = getElementByKeyOrThrow(editor, focusKey);
  const nextAnchorOffset = anchor.offset;
  const nextFocusOffset = focus.offset;
  const nextFormat = nextSelection.format;
  const nextStyle = nextSelection.style;
  const isCollapsed = nextSelection.isCollapsed();
  let nextAnchorNode = anchorDOM;
  let nextFocusNode = focusDOM;
  let anchorFormatOrStyleChanged = false;

  if (anchor.type === 'text') {
    nextAnchorNode = getDOMTextNode$1(anchorDOM);
    const anchorNode = anchor.getNode();
    anchorFormatOrStyleChanged = anchorNode.getFormat() !== nextFormat || anchorNode.getStyle() !== nextStyle;
  } else if ($isRangeSelection$1(prevSelection) && prevSelection.anchor.type === 'text') {
    anchorFormatOrStyleChanged = true;
  }

  if (focus.type === 'text') {
    nextFocusNode = getDOMTextNode$1(focusDOM);
  } // If we can't get an underlying text node for selection, then
  // we should avoid setting selection to something incorrect.


  if (nextAnchorNode === null || nextFocusNode === null) {
    return;
  }

  if (isCollapsed && (prevSelection === null || anchorFormatOrStyleChanged || $isRangeSelection$1(prevSelection) && (prevSelection.format !== nextFormat || prevSelection.style !== nextStyle))) {
    markCollapsedSelectionFormat(nextFormat, nextStyle, nextAnchorOffset, anchorKey, performance.now());
  } // Diff against the native DOM selection to ensure we don't do
  // an unnecessary selection update. We also skip this check if
  // we're moving selection to within an element, as this can
  // sometimes be problematic around scrolling.


  if (anchorOffset === nextAnchorOffset && focusOffset === nextFocusOffset && anchorDOMNode === nextAnchorNode && focusDOMNode === nextFocusNode && // Badly interpreted range selection when collapsed - #1482
  !(domSelection.type === 'Range' && isCollapsed)) {
    // If the root element does not have focus, ensure it has focus
    if (activeElement === null || !rootElement.contains(activeElement)) {
      rootElement.focus({
        preventScroll: true
      });
    }

    if (anchor.type !== 'element') {
      return;
    }
  } // Apply the updated selection to the DOM. Note: this will trigger
  // a "selectionchange" event, although it will be asynchronous.


  try {
    domSelection.setBaseAndExtent(nextAnchorNode, nextAnchorOffset, nextFocusNode, nextFocusOffset);
  } catch (error) {// If we encounter an error, continue. This can sometimes
    // occur with FF and there's no good reason as to why it
    // should happen.
  }

  if (!tags.has('skip-scroll-into-view') && nextSelection.isCollapsed() && rootElement !== null && rootElement === document.activeElement) {
    const selectionTarget = nextSelection instanceof RangeSelection && nextSelection.anchor.type === 'element' ? nextAnchorNode.childNodes[nextAnchorOffset] || null : domSelection.rangeCount > 0 ? domSelection.getRangeAt(0) : null;

    if (selectionTarget !== null) {
      let selectionRect;

      if (selectionTarget instanceof Text) {
        const range = document.createRange();
        range.selectNode(selectionTarget);
        selectionRect = range.getBoundingClientRect();
      } else {
        selectionRect = selectionTarget.getBoundingClientRect();
      }

      scrollIntoViewIfNeeded(editor, selectionRect, rootElement);
    }
  }

  markSelectionChangeFromDOMUpdate();
}
function $insertNodes$1(nodes, selectStart) {
  let selection = $getSelection$1();

  if (selection === null) {
    selection = $getRoot$1().selectEnd();
  }

  return selection.insertNodes(nodes, selectStart);
}
function $getTextContent$1() {
  const selection = $getSelection$1();

  if (selection === null) {
    return '';
  }

  return selection.getTextContent();
}
function DEPRECATED_$computeGridMap$1(grid, cellA, cellB) {
  const tableMap = [];
  let cellAValue = null;
  let cellBValue = null;

  function write(startRow, startColumn, cell) {
    const value = {
      cell,
      startColumn,
      startRow
    };
    const rowSpan = cell.__rowSpan;
    const colSpan = cell.__colSpan;

    for (let i = 0; i < rowSpan; i++) {
      if (tableMap[startRow + i] === undefined) {
        tableMap[startRow + i] = [];
      }

      for (let j = 0; j < colSpan; j++) {
        tableMap[startRow + i][startColumn + j] = value;
      }
    }

    if (cellA.is(cell)) {
      cellAValue = value;
    }

    if (cellB.is(cell)) {
      cellBValue = value;
    }
  }

  function isEmpty(row, column) {
    return tableMap[row] === undefined || tableMap[row][column] === undefined;
  }

  const gridChildren = grid.getChildren();

  for (let i = 0; i < gridChildren.length; i++) {
    const row = gridChildren[i];

    if (!DEPRECATED_$isGridRowNode$1(row)) {
      throw Error(`Expected GridNode children to be GridRowNode`);
    }

    const rowChildren = row.getChildren();
    let j = 0;

    for (const cell of rowChildren) {
      if (!DEPRECATED_$isGridCellNode$1(cell)) {
        throw Error(`Expected GridRowNode children to be GridCellNode`);
      }

      while (!isEmpty(i, j)) {
        j++;
      }

      write(i, j, cell);
      j += cell.__colSpan;
    }
  }

  if (!(cellAValue !== null)) {
    throw Error(`Anchor not found in Grid`);
  }

  if (!(cellBValue !== null)) {
    throw Error(`Focus not found in Grid`);
  }

  return [tableMap, cellAValue, cellBValue];
}
function DEPRECATED_$getNodeTriplet$1(source) {
  let cell;

  if (source instanceof DEPRECATED_GridCellNode$1) {
    cell = source;
  } else if (source instanceof LexicalNode) {
    const cell_ = $findMatchingParent$2(source, DEPRECATED_$isGridCellNode$1);

    if (!DEPRECATED_$isGridCellNode$1(cell_)) {
      throw Error(`Expected to find a parent GridCellNode`);
    }

    cell = cell_;
  } else {
    const cell_ = $findMatchingParent$2(source.getNode(), DEPRECATED_$isGridCellNode$1);

    if (!DEPRECATED_$isGridCellNode$1(cell_)) {
      throw Error(`Expected to find a parent GridCellNode`);
    }

    cell = cell_;
  }

  const row = cell.getParent();

  if (!DEPRECATED_$isGridRowNode$1(row)) {
    throw Error(`Expected GridCellNode to have a parent GridRowNode`);
  }

  const grid = row.getParent();

  if (!DEPRECATED_$isGridNode$1(grid)) {
    throw Error(`Expected GridRowNode to have a parent GridNode`);
  }

  return [cell, row, grid];
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
let activeEditorState = null;
let activeEditor = null;
let isReadOnlyMode = false;
let isAttemptingToRecoverFromReconcilerError = false;
let infiniteTransformCount = 0;
const observerOptions = {
  characterData: true,
  childList: true,
  subtree: true
};
function isCurrentlyReadOnlyMode() {
  return isReadOnlyMode || activeEditorState !== null && activeEditorState._readOnly;
}
function errorOnReadOnly() {
  if (isReadOnlyMode) {
    {
      throw Error(`Cannot use method in read-only mode.`);
    }
  }
}
function errorOnInfiniteTransforms() {
  if (infiniteTransformCount > 99) {
    {
      throw Error(`One or more transforms are endlessly triggering additional transforms. May have encountered infinite recursion caused by transforms that have their preconditions too lose and/or conflict with each other.`);
    }
  }
}
function getActiveEditorState() {
  if (activeEditorState === null) {
    {
      throw Error(`Unable to find an active editor state. State helpers or node methods can only be used synchronously during the callback of editor.update() or editorState.read().`);
    }
  }

  return activeEditorState;
}
function getActiveEditor() {
  if (activeEditor === null) {
    {
      throw Error(`Unable to find an active editor. This method can only be used synchronously during the callback of editor.update().`);
    }
  }

  return activeEditor;
}
function internalGetActiveEditor() {
  return activeEditor;
}
function $applyTransforms(editor, node, transformsCache) {
  const type = node.__type;
  const registeredNode = getRegisteredNodeOrThrow(editor, type);
  let transformsArr = transformsCache.get(type);

  if (transformsArr === undefined) {
    transformsArr = Array.from(registeredNode.transforms);
    transformsCache.set(type, transformsArr);
  }

  const transformsArrLength = transformsArr.length;

  for (let i = 0; i < transformsArrLength; i++) {
    transformsArr[i](node);

    if (!node.isAttached()) {
      break;
    }
  }
}

function $isNodeValidForTransform(node, compositionKey) {
  return node !== undefined && // We don't want to transform nodes being composed
  node.__key !== compositionKey && node.isAttached();
}

function $normalizeAllDirtyTextNodes(editorState, editor) {
  const dirtyLeaves = editor._dirtyLeaves;
  const nodeMap = editorState._nodeMap;

  for (const nodeKey of dirtyLeaves) {
    const node = nodeMap.get(nodeKey);

    if ($isTextNode$1(node) && node.isAttached() && node.isSimpleText() && !node.isUnmergeable()) {
      $normalizeTextNode(node);
    }
  }
}
/**
 * Transform heuristic:
 * 1. We transform leaves first. If transforms generate additional dirty nodes we repeat step 1.
 * The reasoning behind this is that marking a leaf as dirty marks all its parent elements as dirty too.
 * 2. We transform elements. If element transforms generate additional dirty nodes we repeat step 1.
 * If element transforms only generate additional dirty elements we only repeat step 2.
 *
 * Note that to keep track of newly dirty nodes and subtrees we leverage the editor._dirtyNodes and
 * editor._subtrees which we reset in every loop.
 */


function $applyAllTransforms(editorState, editor) {
  const dirtyLeaves = editor._dirtyLeaves;
  const dirtyElements = editor._dirtyElements;
  const nodeMap = editorState._nodeMap;
  const compositionKey = $getCompositionKey();
  const transformsCache = new Map();
  let untransformedDirtyLeaves = dirtyLeaves;
  let untransformedDirtyLeavesLength = untransformedDirtyLeaves.size;
  let untransformedDirtyElements = dirtyElements;
  let untransformedDirtyElementsLength = untransformedDirtyElements.size;

  while (untransformedDirtyLeavesLength > 0 || untransformedDirtyElementsLength > 0) {
    if (untransformedDirtyLeavesLength > 0) {
      // We leverage editor._dirtyLeaves to track the new dirty leaves after the transforms
      editor._dirtyLeaves = new Set();

      for (const nodeKey of untransformedDirtyLeaves) {
        const node = nodeMap.get(nodeKey);

        if ($isTextNode$1(node) && node.isAttached() && node.isSimpleText() && !node.isUnmergeable()) {
          $normalizeTextNode(node);
        }

        if (node !== undefined && $isNodeValidForTransform(node, compositionKey)) {
          $applyTransforms(editor, node, transformsCache);
        }

        dirtyLeaves.add(nodeKey);
      }

      untransformedDirtyLeaves = editor._dirtyLeaves;
      untransformedDirtyLeavesLength = untransformedDirtyLeaves.size; // We want to prioritize node transforms over element transforms

      if (untransformedDirtyLeavesLength > 0) {
        infiniteTransformCount++;
        continue;
      }
    } // All dirty leaves have been processed. Let's do elements!
    // We have previously processed dirty leaves, so let's restart the editor leaves Set to track
    // new ones caused by element transforms


    editor._dirtyLeaves = new Set();
    editor._dirtyElements = new Map();

    for (const currentUntransformedDirtyElement of untransformedDirtyElements) {
      const nodeKey = currentUntransformedDirtyElement[0];
      const intentionallyMarkedAsDirty = currentUntransformedDirtyElement[1];

      if (nodeKey !== 'root' && !intentionallyMarkedAsDirty) {
        continue;
      }

      const node = nodeMap.get(nodeKey);

      if (node !== undefined && $isNodeValidForTransform(node, compositionKey)) {
        $applyTransforms(editor, node, transformsCache);
      }

      dirtyElements.set(nodeKey, intentionallyMarkedAsDirty);
    }

    untransformedDirtyLeaves = editor._dirtyLeaves;
    untransformedDirtyLeavesLength = untransformedDirtyLeaves.size;
    untransformedDirtyElements = editor._dirtyElements;
    untransformedDirtyElementsLength = untransformedDirtyElements.size;
    infiniteTransformCount++;
  }

  editor._dirtyLeaves = dirtyLeaves;
  editor._dirtyElements = dirtyElements;
}

function $parseSerializedNode$1(serializedNode) {
  const internalSerializedNode = serializedNode;
  return $parseSerializedNodeImpl(internalSerializedNode, getActiveEditor()._nodes);
}

function $parseSerializedNodeImpl(serializedNode, registeredNodes) {
  const type = serializedNode.type;
  const registeredNode = registeredNodes.get(type);

  if (registeredNode === undefined) {
    {
      throw Error(`parseEditorState: type "${type}" + not found`);
    }
  }

  const nodeClass = registeredNode.klass;

  if (serializedNode.type !== nodeClass.getType()) {
    {
      throw Error(`LexicalNode: Node ${nodeClass.name} does not implement .importJSON().`);
    }
  }

  const node = nodeClass.importJSON(serializedNode);
  const children = serializedNode.children;

  if ($isElementNode$1(node) && Array.isArray(children)) {
    for (let i = 0; i < children.length; i++) {
      const serializedJSONChildNode = children[i];
      const childNode = $parseSerializedNodeImpl(serializedJSONChildNode, registeredNodes);
      node.append(childNode);
    }
  }

  return node;
}

function parseEditorState(serializedEditorState, editor, updateFn) {
  const editorState = createEmptyEditorState();
  const previousActiveEditorState = activeEditorState;
  const previousReadOnlyMode = isReadOnlyMode;
  const previousActiveEditor = activeEditor;
  const previousDirtyElements = editor._dirtyElements;
  const previousDirtyLeaves = editor._dirtyLeaves;
  const previousCloneNotNeeded = editor._cloneNotNeeded;
  const previousDirtyType = editor._dirtyType;
  editor._dirtyElements = new Map();
  editor._dirtyLeaves = new Set();
  editor._cloneNotNeeded = new Set();
  editor._dirtyType = 0;
  activeEditorState = editorState;
  isReadOnlyMode = false;
  activeEditor = editor;

  try {
    const registeredNodes = editor._nodes;
    const serializedNode = serializedEditorState.root;
    $parseSerializedNodeImpl(serializedNode, registeredNodes);

    if (updateFn) {
      updateFn();
    } // Make the editorState immutable


    editorState._readOnly = true;

    {
      handleDEVOnlyPendingUpdateGuarantees(editorState);
    }
  } catch (error) {
    if (error instanceof Error) {
      editor._onError(error);
    }
  } finally {
    editor._dirtyElements = previousDirtyElements;
    editor._dirtyLeaves = previousDirtyLeaves;
    editor._cloneNotNeeded = previousCloneNotNeeded;
    editor._dirtyType = previousDirtyType;
    activeEditorState = previousActiveEditorState;
    isReadOnlyMode = previousReadOnlyMode;
    activeEditor = previousActiveEditor;
  }

  return editorState;
} // This technically isn't an update but given we need
// exposure to the module's active bindings, we have this
// function here

function readEditorState(editorState, callbackFn) {
  const previousActiveEditorState = activeEditorState;
  const previousReadOnlyMode = isReadOnlyMode;
  const previousActiveEditor = activeEditor;
  activeEditorState = editorState;
  isReadOnlyMode = true;
  activeEditor = null;

  try {
    return callbackFn();
  } finally {
    activeEditorState = previousActiveEditorState;
    isReadOnlyMode = previousReadOnlyMode;
    activeEditor = previousActiveEditor;
  }
}

function handleDEVOnlyPendingUpdateGuarantees(pendingEditorState) {
  // Given we can't Object.freeze the nodeMap as it's a Map,
  // we instead replace its set, clear and delete methods.
  const nodeMap = pendingEditorState._nodeMap;

  nodeMap.set = () => {
    throw new Error('Cannot call set() on a frozen Lexical node map');
  };

  nodeMap.clear = () => {
    throw new Error('Cannot call clear() on a frozen Lexical node map');
  };

  nodeMap.delete = () => {
    throw new Error('Cannot call delete() on a frozen Lexical node map');
  };
}

function commitPendingUpdates(editor) {
  const pendingEditorState = editor._pendingEditorState;
  const rootElement = editor._rootElement;
  const shouldSkipDOM = editor._headless || rootElement === null;

  if (pendingEditorState === null) {
    return;
  } // ======
  // Reconciliation has started.
  // ======


  const currentEditorState = editor._editorState;
  const currentSelection = currentEditorState._selection;
  const pendingSelection = pendingEditorState._selection;
  const needsUpdate = editor._dirtyType !== NO_DIRTY_NODES;
  const previousActiveEditorState = activeEditorState;
  const previousReadOnlyMode = isReadOnlyMode;
  const previousActiveEditor = activeEditor;
  const previouslyUpdating = editor._updating;
  const observer = editor._observer;
  let mutatedNodes = null;
  editor._pendingEditorState = null;
  editor._editorState = pendingEditorState;

  if (!shouldSkipDOM && needsUpdate && observer !== null) {
    activeEditor = editor;
    activeEditorState = pendingEditorState;
    isReadOnlyMode = false; // We don't want updates to sync block the reconciliation.

    editor._updating = true;

    try {
      const dirtyType = editor._dirtyType;
      const dirtyElements = editor._dirtyElements;
      const dirtyLeaves = editor._dirtyLeaves;
      observer.disconnect();
      mutatedNodes = reconcileRoot(currentEditorState, pendingEditorState, editor, dirtyType, dirtyElements, dirtyLeaves);
    } catch (error) {
      // Report errors
      if (error instanceof Error) {
        editor._onError(error);
      } // Reset editor and restore incoming editor state to the DOM


      if (!isAttemptingToRecoverFromReconcilerError) {
        resetEditor(editor, null, rootElement, pendingEditorState);
        initMutationObserver(editor);
        editor._dirtyType = FULL_RECONCILE;
        isAttemptingToRecoverFromReconcilerError = true;
        commitPendingUpdates(editor);
        isAttemptingToRecoverFromReconcilerError = false;
      } else {
        // To avoid a possible situation of infinite loops, lets throw
        throw error;
      }

      return;
    } finally {
      observer.observe(rootElement, observerOptions);
      editor._updating = previouslyUpdating;
      activeEditorState = previousActiveEditorState;
      isReadOnlyMode = previousReadOnlyMode;
      activeEditor = previousActiveEditor;
    }
  }

  if (!pendingEditorState._readOnly) {
    pendingEditorState._readOnly = true;

    {
      handleDEVOnlyPendingUpdateGuarantees(pendingEditorState);

      if ($isRangeSelection$1(pendingSelection)) {
        Object.freeze(pendingSelection.anchor);
        Object.freeze(pendingSelection.focus);
      }

      Object.freeze(pendingSelection);
    }
  }

  const dirtyLeaves = editor._dirtyLeaves;
  const dirtyElements = editor._dirtyElements;
  const normalizedNodes = editor._normalizedNodes;
  const tags = editor._updateTags;
  const deferred = editor._deferred;

  if (needsUpdate) {
    editor._dirtyType = NO_DIRTY_NODES;

    editor._cloneNotNeeded.clear();

    editor._dirtyLeaves = new Set();
    editor._dirtyElements = new Map();
    editor._normalizedNodes = new Set();
    editor._updateTags = new Set();
  }

  $garbageCollectDetachedDecorators(editor, pendingEditorState); // ======
  // Reconciliation has finished. Now update selection and trigger listeners.
  // ======

  const domSelection = shouldSkipDOM ? null : getDOMSelection(editor._window); // Attempt to update the DOM selection, including focusing of the root element,
  // and scroll into view if needed.

  if (editor._editable && // domSelection will be null in headless
  domSelection !== null && (needsUpdate || pendingSelection === null || pendingSelection.dirty)) {
    activeEditor = editor;
    activeEditorState = pendingEditorState;

    try {
      if (observer !== null) {
        observer.disconnect();
      }

      if (needsUpdate || pendingSelection === null || pendingSelection.dirty) {
        const blockCursorElement = editor._blockCursorElement;

        if (blockCursorElement !== null) {
          removeDOMBlockCursorElement(blockCursorElement, editor, rootElement);
        }

        updateDOMSelection(currentSelection, pendingSelection, editor, domSelection, tags, rootElement);
      }

      updateDOMBlockCursorElement(editor, rootElement, pendingSelection);

      if (observer !== null) {
        observer.observe(rootElement, observerOptions);
      }
    } finally {
      activeEditor = previousActiveEditor;
      activeEditorState = previousActiveEditorState;
    }
  }

  if (mutatedNodes !== null) {
    triggerMutationListeners(editor, currentEditorState, pendingEditorState, mutatedNodes, tags, dirtyLeaves);
  }

  if (!$isRangeSelection$1(pendingSelection) && pendingSelection !== null && (currentSelection === null || !currentSelection.is(pendingSelection))) {
    editor.dispatchCommand(SELECTION_CHANGE_COMMAND$1, undefined);
  }
  /**
   * Capture pendingDecorators after garbage collecting detached decorators
   */


  const pendingDecorators = editor._pendingDecorators;

  if (pendingDecorators !== null) {
    editor._decorators = pendingDecorators;
    editor._pendingDecorators = null;
    triggerListeners('decorator', editor, true, pendingDecorators);
  }

  triggerTextContentListeners(editor, currentEditorState, pendingEditorState);
  triggerListeners('update', editor, true, {
    dirtyElements,
    dirtyLeaves,
    editorState: pendingEditorState,
    normalizedNodes,
    prevEditorState: currentEditorState,
    tags
  });
  triggerDeferredUpdateCallbacks(editor, deferred);
  triggerEnqueuedUpdates(editor);
}

function triggerTextContentListeners(editor, currentEditorState, pendingEditorState) {
  const currentTextContent = getEditorStateTextContent(currentEditorState);
  const latestTextContent = getEditorStateTextContent(pendingEditorState);

  if (currentTextContent !== latestTextContent) {
    triggerListeners('textcontent', editor, true, latestTextContent);
  }
}

function triggerMutationListeners(editor, currentEditorState, pendingEditorState, mutatedNodes, updateTags, dirtyLeaves) {
  const listeners = Array.from(editor._listeners.mutation);
  const listenersLength = listeners.length;

  for (let i = 0; i < listenersLength; i++) {
    const [listener, klass] = listeners[i];
    const mutatedNodesByType = mutatedNodes.get(klass);

    if (mutatedNodesByType !== undefined) {
      listener(mutatedNodesByType, {
        dirtyLeaves,
        updateTags
      });
    }
  }
}

function triggerListeners(type, editor, isCurrentlyEnqueuingUpdates, ...payload) {
  const previouslyUpdating = editor._updating;
  editor._updating = isCurrentlyEnqueuingUpdates;

  try {
    const listeners = Array.from(editor._listeners[type]);

    for (let i = 0; i < listeners.length; i++) {
      // @ts-ignore
      listeners[i].apply(null, payload);
    }
  } finally {
    editor._updating = previouslyUpdating;
  }
}
function triggerCommandListeners(editor, type, payload) {
  if (editor._updating === false || activeEditor !== editor) {
    let returnVal = false;
    editor.update(() => {
      returnVal = triggerCommandListeners(editor, type, payload);
    });
    return returnVal;
  }

  const editors = getEditorsToPropagate(editor);

  for (let i = 4; i >= 0; i--) {
    for (let e = 0; e < editors.length; e++) {
      const currentEditor = editors[e];
      const commandListeners = currentEditor._commands;
      const listenerInPriorityOrder = commandListeners.get(type);

      if (listenerInPriorityOrder !== undefined) {
        const listenersSet = listenerInPriorityOrder[i];

        if (listenersSet !== undefined) {
          const listeners = Array.from(listenersSet);
          const listenersLength = listeners.length;

          for (let j = 0; j < listenersLength; j++) {
            if (listeners[j](payload, editor) === true) {
              return true;
            }
          }
        }
      }
    }
  }

  return false;
}

function triggerEnqueuedUpdates(editor) {
  const queuedUpdates = editor._updates;

  if (queuedUpdates.length !== 0) {
    const queuedUpdate = queuedUpdates.shift();

    if (queuedUpdate) {
      const [updateFn, options] = queuedUpdate;
      beginUpdate(editor, updateFn, options);
    }
  }
}

function triggerDeferredUpdateCallbacks(editor, deferred) {
  editor._deferred = [];

  if (deferred.length !== 0) {
    const previouslyUpdating = editor._updating;
    editor._updating = true;

    try {
      for (let i = 0; i < deferred.length; i++) {
        deferred[i]();
      }
    } finally {
      editor._updating = previouslyUpdating;
    }
  }
}

function processNestedUpdates(editor, initialSkipTransforms) {
  const queuedUpdates = editor._updates;
  let skipTransforms = initialSkipTransforms || false; // Updates might grow as we process them, we so we'll need
  // to handle each update as we go until the updates array is
  // empty.

  while (queuedUpdates.length !== 0) {
    const queuedUpdate = queuedUpdates.shift();

    if (queuedUpdate) {
      const [nextUpdateFn, options] = queuedUpdate;
      let onUpdate;
      let tag;

      if (options !== undefined) {
        onUpdate = options.onUpdate;
        tag = options.tag;

        if (options.skipTransforms) {
          skipTransforms = true;
        }

        if (onUpdate) {
          editor._deferred.push(onUpdate);
        }

        if (tag) {
          editor._updateTags.add(tag);
        }
      }

      nextUpdateFn();
    }
  }

  return skipTransforms;
}

function beginUpdate(editor, updateFn, options) {
  const updateTags = editor._updateTags;
  let onUpdate;
  let tag;
  let skipTransforms = false;
  let discrete = false;

  if (options !== undefined) {
    onUpdate = options.onUpdate;
    tag = options.tag;

    if (tag != null) {
      updateTags.add(tag);
    }

    skipTransforms = options.skipTransforms || false;
    discrete = options.discrete || false;
  }

  if (onUpdate) {
    editor._deferred.push(onUpdate);
  }

  const currentEditorState = editor._editorState;
  let pendingEditorState = editor._pendingEditorState;
  let editorStateWasCloned = false;

  if (pendingEditorState === null || pendingEditorState._readOnly) {
    pendingEditorState = editor._pendingEditorState = cloneEditorState(pendingEditorState || currentEditorState);
    editorStateWasCloned = true;
  }

  pendingEditorState._flushSync = discrete;
  const previousActiveEditorState = activeEditorState;
  const previousReadOnlyMode = isReadOnlyMode;
  const previousActiveEditor = activeEditor;
  const previouslyUpdating = editor._updating;
  activeEditorState = pendingEditorState;
  isReadOnlyMode = false;
  editor._updating = true;
  activeEditor = editor;

  try {
    if (editorStateWasCloned) {
      if (editor._headless) {
        if (currentEditorState._selection != null) {
          pendingEditorState._selection = currentEditorState._selection.clone();
        }
      } else {
        pendingEditorState._selection = internalCreateSelection(editor);
      }
    }

    const startingCompositionKey = editor._compositionKey;
    updateFn();
    skipTransforms = processNestedUpdates(editor, skipTransforms);
    applySelectionTransforms(pendingEditorState, editor);

    if (editor._dirtyType !== NO_DIRTY_NODES) {
      if (skipTransforms) {
        $normalizeAllDirtyTextNodes(pendingEditorState, editor);
      } else {
        $applyAllTransforms(pendingEditorState, editor);
      }

      processNestedUpdates(editor);
      $garbageCollectDetachedNodes(currentEditorState, pendingEditorState, editor._dirtyLeaves, editor._dirtyElements);
    }

    const endingCompositionKey = editor._compositionKey;

    if (startingCompositionKey !== endingCompositionKey) {
      pendingEditorState._flushSync = true;
    }

    const pendingSelection = pendingEditorState._selection;

    if ($isRangeSelection$1(pendingSelection)) {
      const pendingNodeMap = pendingEditorState._nodeMap;
      const anchorKey = pendingSelection.anchor.key;
      const focusKey = pendingSelection.focus.key;

      if (pendingNodeMap.get(anchorKey) === undefined || pendingNodeMap.get(focusKey) === undefined) {
        {
          throw Error(`updateEditor: selection has been lost because the previously selected nodes have been removed and selection wasn't moved to another node. Ensure selection changes after removing/replacing a selected node.`);
        }
      }
    } else if ($isNodeSelection$1(pendingSelection)) {
      // TODO: we should also validate node selection?
      if (pendingSelection._nodes.size === 0) {
        pendingEditorState._selection = null;
      }
    }
  } catch (error) {
    // Report errors
    if (error instanceof Error) {
      editor._onError(error);
    } // Restore existing editor state to the DOM


    editor._pendingEditorState = currentEditorState;
    editor._dirtyType = FULL_RECONCILE;

    editor._cloneNotNeeded.clear();

    editor._dirtyLeaves = new Set();

    editor._dirtyElements.clear();

    commitPendingUpdates(editor);
    return;
  } finally {
    activeEditorState = previousActiveEditorState;
    isReadOnlyMode = previousReadOnlyMode;
    activeEditor = previousActiveEditor;
    editor._updating = previouslyUpdating;
    infiniteTransformCount = 0;
  }

  const shouldUpdate = editor._dirtyType !== NO_DIRTY_NODES || editorStateHasDirtySelection(pendingEditorState, editor);

  if (shouldUpdate) {
    if (pendingEditorState._flushSync) {
      pendingEditorState._flushSync = false;
      commitPendingUpdates(editor);
    } else if (editorStateWasCloned) {
      scheduleMicroTask(() => {
        commitPendingUpdates(editor);
      });
    }
  } else {
    pendingEditorState._flushSync = false;

    if (editorStateWasCloned) {
      updateTags.clear();
      editor._deferred = [];
      editor._pendingEditorState = null;
    }
  }
}

function updateEditor(editor, updateFn, options) {
  if (editor._updating) {
    editor._updates.push([updateFn, options]);
  } else {
    beginUpdate(editor, updateFn, options);
  }
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
/** @noInheritDoc */

class DecoratorNode$1 extends LexicalNode {
  constructor(key) {
    super(key);
  }

  decorate(editor, config) {
    {
      throw Error(`decorate: base method not extended`);
    }
  }

  isIsolated() {
    return false;
  }

  isInline() {
    return true;
  }

  isKeyboardSelectable() {
    return true;
  }

}
function $isDecoratorNode$1(node) {
  return node instanceof DecoratorNode$1;
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/** @noInheritDoc */
class ElementNode$1 extends LexicalNode {
  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */
  constructor(key) {
    super(key);
    this.__first = null;
    this.__last = null;
    this.__size = 0;
    this.__format = 0;
    this.__indent = 0;
    this.__dir = null;
  }

  getFormat() {
    const self = this.getLatest();
    return self.__format;
  }

  getFormatType() {
    const format = this.getFormat();
    return ELEMENT_FORMAT_TO_TYPE[format] || '';
  }

  getIndent() {
    const self = this.getLatest();
    return self.__indent;
  }

  getChildren() {
    const children = [];
    let child = this.getFirstChild();

    while (child !== null) {
      children.push(child);
      child = child.getNextSibling();
    }

    return children;
  }

  getChildrenKeys() {
    const children = [];
    let child = this.getFirstChild();

    while (child !== null) {
      children.push(child.__key);
      child = child.getNextSibling();
    }

    return children;
  }

  getChildrenSize() {
    const self = this.getLatest();
    return self.__size;
  }

  isEmpty() {
    return this.getChildrenSize() === 0;
  }

  isDirty() {
    const editor = getActiveEditor();
    const dirtyElements = editor._dirtyElements;
    return dirtyElements !== null && dirtyElements.has(this.__key);
  }

  isLastChild() {
    const self = this.getLatest();
    const parentLastChild = this.getParentOrThrow().getLastChild();
    return parentLastChild !== null && parentLastChild.is(self);
  }

  getAllTextNodes() {
    const textNodes = [];
    let child = this.getFirstChild();

    while (child !== null) {
      if ($isTextNode$1(child)) {
        textNodes.push(child);
      }

      if ($isElementNode$1(child)) {
        const subChildrenNodes = child.getAllTextNodes();
        textNodes.push(...subChildrenNodes);
      }

      child = child.getNextSibling();
    }

    return textNodes;
  }

  getFirstDescendant() {
    let node = this.getFirstChild();

    while (node !== null) {
      if ($isElementNode$1(node)) {
        const child = node.getFirstChild();

        if (child !== null) {
          node = child;
          continue;
        }
      }

      break;
    }

    return node;
  }

  getLastDescendant() {
    let node = this.getLastChild();

    while (node !== null) {
      if ($isElementNode$1(node)) {
        const child = node.getLastChild();

        if (child !== null) {
          node = child;
          continue;
        }
      }

      break;
    }

    return node;
  }

  getDescendantByIndex(index) {
    const children = this.getChildren();
    const childrenLength = children.length; // For non-empty element nodes, we resolve its descendant
    // (either a leaf node or the bottom-most element)

    if (index >= childrenLength) {
      const resolvedNode = children[childrenLength - 1];
      return $isElementNode$1(resolvedNode) && resolvedNode.getLastDescendant() || resolvedNode || null;
    }

    const resolvedNode = children[index];
    return $isElementNode$1(resolvedNode) && resolvedNode.getFirstDescendant() || resolvedNode || null;
  }

  getFirstChild() {
    const self = this.getLatest();
    const firstKey = self.__first;
    return firstKey === null ? null : $getNodeByKey$1(firstKey);
  }

  getFirstChildOrThrow() {
    const firstChild = this.getFirstChild();

    if (firstChild === null) {
      {
        throw Error(`Expected node ${this.__key} to have a first child.`);
      }
    }

    return firstChild;
  }

  getLastChild() {
    const self = this.getLatest();
    const lastKey = self.__last;
    return lastKey === null ? null : $getNodeByKey$1(lastKey);
  }

  getLastChildOrThrow() {
    const lastChild = this.getLastChild();

    if (lastChild === null) {
      {
        throw Error(`Expected node ${this.__key} to have a last child.`);
      }
    }

    return lastChild;
  }

  getChildAtIndex(index) {
    const size = this.getChildrenSize();
    let node;
    let i;

    if (index < size / 2) {
      node = this.getFirstChild();
      i = 0;

      while (node !== null && i <= index) {
        if (i === index) {
          return node;
        }

        node = node.getNextSibling();
        i++;
      }

      return null;
    }

    node = this.getLastChild();
    i = size - 1;

    while (node !== null && i >= index) {
      if (i === index) {
        return node;
      }

      node = node.getPreviousSibling();
      i--;
    }

    return null;
  }

  getTextContent() {
    let textContent = '';
    const children = this.getChildren();
    const childrenLength = children.length;

    for (let i = 0; i < childrenLength; i++) {
      const child = children[i];
      textContent += child.getTextContent();

      if ($isElementNode$1(child) && i !== childrenLength - 1 && !child.isInline()) {
        textContent += DOUBLE_LINE_BREAK;
      }
    }

    return textContent;
  }

  getTextContentSize() {
    let textContentSize = 0;
    const children = this.getChildren();
    const childrenLength = children.length;

    for (let i = 0; i < childrenLength; i++) {
      const child = children[i];
      textContentSize += child.getTextContentSize();

      if ($isElementNode$1(child) && i !== childrenLength - 1 && !child.isInline()) {
        textContentSize += DOUBLE_LINE_BREAK.length;
      }
    }

    return textContentSize;
  }

  getDirection() {
    const self = this.getLatest();
    return self.__dir;
  }

  hasFormat(type) {
    if (type !== '') {
      const formatFlag = ELEMENT_TYPE_TO_FORMAT[type];
      return (this.getFormat() & formatFlag) !== 0;
    }

    return false;
  } // Mutators


  select(_anchorOffset, _focusOffset) {
    errorOnReadOnly();
    const selection = $getSelection$1();
    let anchorOffset = _anchorOffset;
    let focusOffset = _focusOffset;
    const childrenCount = this.getChildrenSize();

    if (!this.canBeEmpty()) {
      if (_anchorOffset === 0 && _focusOffset === 0) {
        const firstChild = this.getFirstChild();

        if ($isTextNode$1(firstChild) || $isElementNode$1(firstChild)) {
          return firstChild.select(0, 0);
        }
      } else if ((_anchorOffset === undefined || _anchorOffset === childrenCount) && (_focusOffset === undefined || _focusOffset === childrenCount)) {
        const lastChild = this.getLastChild();

        if ($isTextNode$1(lastChild) || $isElementNode$1(lastChild)) {
          return lastChild.select();
        }
      }
    }

    if (anchorOffset === undefined) {
      anchorOffset = childrenCount;
    }

    if (focusOffset === undefined) {
      focusOffset = childrenCount;
    }

    const key = this.__key;

    if (!$isRangeSelection$1(selection)) {
      return internalMakeRangeSelection(key, anchorOffset, key, focusOffset, 'element', 'element');
    } else {
      selection.anchor.set(key, anchorOffset, 'element');
      selection.focus.set(key, focusOffset, 'element');
      selection.dirty = true;
    }

    return selection;
  }

  selectStart() {
    const firstNode = this.getFirstDescendant();

    if ($isElementNode$1(firstNode) || $isTextNode$1(firstNode)) {
      return firstNode.select(0, 0);
    } // Decorator or LineBreak


    if (firstNode !== null) {
      return firstNode.selectPrevious();
    }

    return this.select(0, 0);
  }

  selectEnd() {
    const lastNode = this.getLastDescendant();

    if ($isElementNode$1(lastNode) || $isTextNode$1(lastNode)) {
      return lastNode.select();
    } // Decorator or LineBreak


    if (lastNode !== null) {
      return lastNode.selectNext();
    }

    return this.select();
  }

  clear() {
    const writableSelf = this.getWritable();
    const children = this.getChildren();
    children.forEach(child => child.remove());
    return writableSelf;
  }

  append(...nodesToAppend) {
    return this.splice(this.getChildrenSize(), 0, nodesToAppend);
  }

  setDirection(direction) {
    const self = this.getWritable();
    self.__dir = direction;
    return self;
  }

  setFormat(type) {
    const self = this.getWritable();
    self.__format = type !== '' ? ELEMENT_TYPE_TO_FORMAT[type] : 0;
    return this;
  }

  setIndent(indentLevel) {
    const self = this.getWritable();
    self.__indent = indentLevel;
    return this;
  }

  splice(start, deleteCount, nodesToInsert) {
    const nodesToInsertLength = nodesToInsert.length;
    const oldSize = this.getChildrenSize();
    const writableSelf = this.getWritable();
    const writableSelfKey = writableSelf.__key;
    const nodesToInsertKeys = [];
    const nodesToRemoveKeys = [];
    const nodeAfterRange = this.getChildAtIndex(start + deleteCount);
    let nodeBeforeRange = null;
    let newSize = oldSize - deleteCount + nodesToInsertLength;

    if (start !== 0) {
      if (start === oldSize) {
        nodeBeforeRange = this.getLastChild();
      } else {
        const node = this.getChildAtIndex(start);

        if (node !== null) {
          nodeBeforeRange = node.getPreviousSibling();
        }
      }
    }

    if (deleteCount > 0) {
      let nodeToDelete = nodeBeforeRange === null ? this.getFirstChild() : nodeBeforeRange.getNextSibling();

      for (let i = 0; i < deleteCount; i++) {
        if (nodeToDelete === null) {
          {
            throw Error(`splice: sibling not found`);
          }
        }

        const nextSibling = nodeToDelete.getNextSibling();
        const nodeKeyToDelete = nodeToDelete.__key;
        const writableNodeToDelete = nodeToDelete.getWritable();
        removeFromParent(writableNodeToDelete);
        nodesToRemoveKeys.push(nodeKeyToDelete);
        nodeToDelete = nextSibling;
      }
    }

    let prevNode = nodeBeforeRange;

    for (let i = 0; i < nodesToInsertLength; i++) {
      const nodeToInsert = nodesToInsert[i];

      if (prevNode !== null && nodeToInsert.is(prevNode)) {
        nodeBeforeRange = prevNode = prevNode.getPreviousSibling();
      }

      const writableNodeToInsert = nodeToInsert.getWritable();

      if (writableNodeToInsert.__parent === writableSelfKey) {
        newSize--;
      }

      removeFromParent(writableNodeToInsert);
      const nodeKeyToInsert = nodeToInsert.__key;

      if (prevNode === null) {
        writableSelf.__first = nodeKeyToInsert;
        writableNodeToInsert.__prev = null;
      } else {
        const writablePrevNode = prevNode.getWritable();
        writablePrevNode.__next = nodeKeyToInsert;
        writableNodeToInsert.__prev = writablePrevNode.__key;
      }

      if (nodeToInsert.__key === writableSelfKey) {
        {
          throw Error(`append: attempting to append self`);
        }
      } // Set child parent to self


      writableNodeToInsert.__parent = writableSelfKey;
      nodesToInsertKeys.push(nodeKeyToInsert);
      prevNode = nodeToInsert;
    }

    if (start + deleteCount === oldSize) {
      if (prevNode !== null) {
        const writablePrevNode = prevNode.getWritable();
        writablePrevNode.__next = null;
        writableSelf.__last = prevNode.__key;
      }
    } else if (nodeAfterRange !== null) {
      const writableNodeAfterRange = nodeAfterRange.getWritable();

      if (prevNode !== null) {
        const writablePrevNode = prevNode.getWritable();
        writableNodeAfterRange.__prev = prevNode.__key;
        writablePrevNode.__next = nodeAfterRange.__key;
      } else {
        writableNodeAfterRange.__prev = null;
      }
    }

    writableSelf.__size = newSize; // In case of deletion we need to adjust selection, unlink removed nodes
    // and clean up node itself if it becomes empty. None of these needed
    // for insertion-only cases

    if (nodesToRemoveKeys.length) {
      // Adjusting selection, in case node that was anchor/focus will be deleted
      const selection = $getSelection$1();

      if ($isRangeSelection$1(selection)) {
        const nodesToRemoveKeySet = new Set(nodesToRemoveKeys);
        const nodesToInsertKeySet = new Set(nodesToInsertKeys);
        const {
          anchor,
          focus
        } = selection;

        if (isPointRemoved(anchor, nodesToRemoveKeySet, nodesToInsertKeySet)) {
          moveSelectionPointToSibling(anchor, anchor.getNode(), this, nodeBeforeRange, nodeAfterRange);
        }

        if (isPointRemoved(focus, nodesToRemoveKeySet, nodesToInsertKeySet)) {
          moveSelectionPointToSibling(focus, focus.getNode(), this, nodeBeforeRange, nodeAfterRange);
        } // Cleanup if node can't be empty


        if (newSize === 0 && !this.canBeEmpty() && !$isRootOrShadowRoot$1(this)) {
          this.remove();
        }
      }
    }

    return writableSelf;
  } // JSON serialization


  exportJSON() {
    return {
      children: [],
      direction: this.getDirection(),
      format: this.getFormatType(),
      indent: this.getIndent(),
      type: 'element',
      version: 1
    };
  } // These are intended to be extends for specific element heuristics.


  insertNewAfter(selection, restoreSelection) {
    return null;
  }

  canInsertTab() {
    return false;
  }

  canIndent() {
    return true;
  }
  /*
   * This method controls the behavior of a the node during backwards
   * deletion (i.e., backspace) when selection is at the beginning of
   * the node (offset 0)
   */


  collapseAtStart(selection) {
    return false;
  }

  excludeFromCopy(destination) {
    return false;
  } // TODO 0.10 deprecate


  canExtractContents() {
    return true;
  }

  canReplaceWith(replacement) {
    return true;
  }

  canInsertAfter(node) {
    return true;
  }

  canBeEmpty() {
    return true;
  }

  canInsertTextBefore() {
    return true;
  }

  canInsertTextAfter() {
    return true;
  }

  isInline() {
    return false;
  } // A shadow root is a Node that behaves like RootNode. The shadow root (and RootNode) mark the
  // end of the hiercharchy, most implementations should treat it as there's nothing (upwards)
  // beyond this point. For example, node.getTopLevelElement(), when performed inside a TableCellNode
  // will return the immediate first child underneath TableCellNode instead of RootNode.


  isShadowRoot() {
    return false;
  }

  canMergeWith(node) {
    return false;
  }

  extractWithChild(child, selection, destination) {
    return false;
  }

}
function $isElementNode$1(node) {
  return node instanceof ElementNode$1;
}

function isPointRemoved(point, nodesToRemoveKeySet, nodesToInsertKeySet) {
  let node = point.getNode();

  while (node) {
    const nodeKey = node.__key;

    if (nodesToRemoveKeySet.has(nodeKey) && !nodesToInsertKeySet.has(nodeKey)) {
      return true;
    }

    node = node.getParent();
  }

  return false;
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/** @noInheritDoc */
class RootNode$1 extends ElementNode$1 {
  /** @internal */
  static getType() {
    return 'root';
  }

  static clone() {
    return new RootNode$1();
  }

  constructor() {
    super('root');
    this.__cachedText = null;
  }

  getTopLevelElementOrThrow() {
    {
      throw Error(`getTopLevelElementOrThrow: root nodes are not top level elements`);
    }
  }

  getTextContent() {
    const cachedText = this.__cachedText;

    if (isCurrentlyReadOnlyMode() || getActiveEditor()._dirtyType === NO_DIRTY_NODES) {
      if (cachedText !== null) {
        return cachedText;
      }
    }

    return super.getTextContent();
  }

  remove() {
    {
      throw Error(`remove: cannot be called on root nodes`);
    }
  }

  replace(node) {
    {
      throw Error(`replace: cannot be called on root nodes`);
    }
  }

  insertBefore(nodeToInsert) {
    {
      throw Error(`insertBefore: cannot be called on root nodes`);
    }
  }

  insertAfter(nodeToInsert) {
    {
      throw Error(`insertAfter: cannot be called on root nodes`);
    }
  } // View


  updateDOM(prevNode, dom) {
    return false;
  } // Mutate


  append(...nodesToAppend) {
    for (let i = 0; i < nodesToAppend.length; i++) {
      const node = nodesToAppend[i];

      if (!$isElementNode$1(node) && !$isDecoratorNode$1(node)) {
        {
          throw Error(`rootNode.append: Only element or decorator nodes can be appended to the root node`);
        }
      }
    }

    return super.append(...nodesToAppend);
  }

  static importJSON(serializedNode) {
    // We don't create a root, and instead use the existing root.
    const node = $getRoot$1();
    node.setFormat(serializedNode.format);
    node.setIndent(serializedNode.indent);
    node.setDirection(serializedNode.direction);
    return node;
  }

  exportJSON() {
    return {
      children: [],
      direction: this.getDirection(),
      format: this.getFormatType(),
      indent: this.getIndent(),
      type: 'root',
      version: 1
    };
  }

  collapseAtStart() {
    return true;
  }

}
function $createRootNode() {
  return new RootNode$1();
}
function $isRootNode$1(node) {
  return node instanceof RootNode$1;
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
function editorStateHasDirtySelection(editorState, editor) {
  const currentSelection = editor.getEditorState()._selection;

  const pendingSelection = editorState._selection; // Check if we need to update because of changes in selection

  if (pendingSelection !== null) {
    if (pendingSelection.dirty || !pendingSelection.is(currentSelection)) {
      return true;
    }
  } else if (currentSelection !== null) {
    return true;
  }

  return false;
}
function cloneEditorState(current) {
  return new EditorState(new Map(current._nodeMap));
}
function createEmptyEditorState() {
  return new EditorState(new Map([['root', $createRootNode()]]));
}

function exportNodeToJSON$1(node) {
  const serializedNode = node.exportJSON();
  const nodeClass = node.constructor; // @ts-expect-error TODO Replace Class utility type with InstanceType

  if (serializedNode.type !== nodeClass.getType()) {
    {
      throw Error(`LexicalNode: Node ${nodeClass.name} does not implement .exportJSON().`);
    }
  } // @ts-expect-error TODO Replace Class utility type with InstanceType


  const serializedChildren = serializedNode.children;

  if ($isElementNode$1(node)) {
    if (!Array.isArray(serializedChildren)) {
      {
        throw Error(`LexicalNode: Node ${nodeClass.name} is an element but .exportJSON() does not have a children array.`);
      }
    }

    const children = node.getChildren();

    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      const serializedChildNode = exportNodeToJSON$1(child);
      serializedChildren.push(serializedChildNode);
    }
  } // @ts-expect-error


  return serializedNode;
}

class EditorState {
  constructor(nodeMap, selection) {
    this._nodeMap = nodeMap;
    this._selection = selection || null;
    this._flushSync = false;
    this._readOnly = false;
  }

  isEmpty() {
    return this._nodeMap.size === 1 && this._selection === null;
  }

  read(callbackFn) {
    return readEditorState(this, callbackFn);
  }

  clone(selection) {
    const editorState = new EditorState(this._nodeMap, selection === undefined ? this._selection : selection);
    editorState._readOnly = true;
    return editorState;
  }

  toJSON() {
    return readEditorState(this, () => ({
      root: exportNodeToJSON$1($getRoot$1())
    }));
  }

}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/** @noInheritDoc */
class LineBreakNode$1 extends LexicalNode {
  static getType() {
    return 'linebreak';
  }

  static clone(node) {
    return new LineBreakNode$1(node.__key);
  }

  constructor(key) {
    super(key);
  }

  getTextContent() {
    return '\n';
  }

  createDOM() {
    return document.createElement('br');
  }

  updateDOM() {
    return false;
  }

  static importDOM() {
    return {
      br: node => {
        const parentElement = node.parentElement; // If the <br> is the only child, then skip including it

        if (parentElement != null && parentElement.firstChild === node && parentElement.lastChild === node) {
          return null;
        }

        return {
          conversion: convertLineBreakElement,
          priority: 0
        };
      }
    };
  }

  static importJSON(serializedLineBreakNode) {
    return $createLineBreakNode$1();
  }

  exportJSON() {
    return {
      type: 'linebreak',
      version: 1
    };
  }

}

function convertLineBreakElement(node) {
  return {
    node: $createLineBreakNode$1()
  };
}

function $createLineBreakNode$1() {
  return $applyNodeReplacement$1(new LineBreakNode$1());
}
function $isLineBreakNode$1(node) {
  return node instanceof LineBreakNode$1;
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

function getElementOuterTag(node, format) {
  if (format & IS_CODE) {
    return 'code';
  }

  if (format & IS_HIGHLIGHT) {
    return 'mark';
  }

  if (format & IS_SUBSCRIPT) {
    return 'sub';
  }

  if (format & IS_SUPERSCRIPT) {
    return 'sup';
  }

  return null;
}

function getElementInnerTag(node, format) {
  if (format & IS_BOLD) {
    return 'strong';
  }

  if (format & IS_ITALIC) {
    return 'em';
  }

  return 'span';
}

function setTextThemeClassNames(tag, prevFormat, nextFormat, dom, textClassNames) {
  const domClassList = dom.classList; // Firstly we handle the base theme.

  let classNames = getCachedClassNameArray(textClassNames, 'base');

  if (classNames !== undefined) {
    domClassList.add(...classNames);
  } // Secondly we handle the special case: underline + strikethrough.
  // We have to do this as we need a way to compose the fact that
  // the same CSS property will need to be used: text-decoration.
  // In an ideal world we shouldn't have to do this, but there's no
  // easy workaround for many atomic CSS systems today.


  classNames = getCachedClassNameArray(textClassNames, 'underlineStrikethrough');
  let hasUnderlineStrikethrough = false;
  const prevUnderlineStrikethrough = prevFormat & IS_UNDERLINE && prevFormat & IS_STRIKETHROUGH;
  const nextUnderlineStrikethrough = nextFormat & IS_UNDERLINE && nextFormat & IS_STRIKETHROUGH;

  if (classNames !== undefined) {
    if (nextUnderlineStrikethrough) {
      hasUnderlineStrikethrough = true;

      if (!prevUnderlineStrikethrough) {
        domClassList.add(...classNames);
      }
    } else if (prevUnderlineStrikethrough) {
      domClassList.remove(...classNames);
    }
  }

  for (const key in TEXT_TYPE_TO_FORMAT) {
    const format = key;
    const flag = TEXT_TYPE_TO_FORMAT[format];
    classNames = getCachedClassNameArray(textClassNames, key);

    if (classNames !== undefined) {
      if (nextFormat & flag) {
        if (hasUnderlineStrikethrough && (key === 'underline' || key === 'strikethrough')) {
          if (prevFormat & flag) {
            domClassList.remove(...classNames);
          }

          continue;
        }

        if ((prevFormat & flag) === 0 || prevUnderlineStrikethrough && key === 'underline' || key === 'strikethrough') {
          domClassList.add(...classNames);
        }
      } else if (prevFormat & flag) {
        domClassList.remove(...classNames);
      }
    }
  }
}

function diffComposedText(a, b) {
  const aLength = a.length;
  const bLength = b.length;
  let left = 0;
  let right = 0;

  while (left < aLength && left < bLength && a[left] === b[left]) {
    left++;
  }

  while (right + left < aLength && right + left < bLength && a[aLength - right - 1] === b[bLength - right - 1]) {
    right++;
  }

  return [left, aLength - left - right, b.slice(left, bLength - right)];
}

function setTextContent(nextText, dom, node) {
  const firstChild = dom.firstChild;
  const isComposing = node.isComposing(); // Always add a suffix if we're composing a node

  const suffix = isComposing ? COMPOSITION_SUFFIX : '';
  const text = nextText + suffix;

  if (firstChild == null) {
    dom.textContent = text;
  } else {
    const nodeValue = firstChild.nodeValue;

    if (nodeValue !== text) {
      if (isComposing || IS_FIREFOX) {
        // We also use the diff composed text for general text in FF to avoid
        // the spellcheck red line from flickering.
        const [index, remove, insert] = diffComposedText(nodeValue, text);

        if (remove !== 0) {
          // @ts-expect-error
          firstChild.deleteData(index, remove);
        } // @ts-expect-error


        firstChild.insertData(index, insert);
      } else {
        firstChild.nodeValue = text;
      }
    }
  }
}

function createTextInnerDOM(innerDOM, node, innerTag, format, text, config) {
  setTextContent(text, innerDOM, node);
  const theme = config.theme; // Apply theme class names

  const textClassNames = theme.text;

  if (textClassNames !== undefined) {
    setTextThemeClassNames(innerTag, 0, format, innerDOM, textClassNames);
  }
}

function wrapElementWith(element, tag) {
  const el = document.createElement(tag);
  el.appendChild(element);
  return el;
}
/** @noInheritDoc */


class TextNode$1 extends LexicalNode {
  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */
  static getType() {
    return 'text';
  }

  static clone(node) {
    return new TextNode$1(node.__text, node.__key);
  }

  constructor(text, key) {
    super(key);
    this.__text = text;
    this.__format = 0;
    this.__style = '';
    this.__mode = 0;
    this.__detail = 0;
  }

  getFormat() {
    const self = this.getLatest();
    return self.__format;
  }

  getDetail() {
    const self = this.getLatest();
    return self.__detail;
  }

  getMode() {
    const self = this.getLatest();
    return TEXT_TYPE_TO_MODE[self.__mode];
  }

  getStyle() {
    const self = this.getLatest();
    return self.__style;
  }

  isToken() {
    const self = this.getLatest();
    return self.__mode === IS_TOKEN;
  }

  isComposing() {
    return this.__key === $getCompositionKey();
  }

  isSegmented() {
    const self = this.getLatest();
    return self.__mode === IS_SEGMENTED;
  }

  isDirectionless() {
    const self = this.getLatest();
    return (self.__detail & IS_DIRECTIONLESS) !== 0;
  }

  isUnmergeable() {
    const self = this.getLatest();
    return (self.__detail & IS_UNMERGEABLE) !== 0;
  }

  hasFormat(type) {
    const formatFlag = TEXT_TYPE_TO_FORMAT[type];
    return (this.getFormat() & formatFlag) !== 0;
  }

  isSimpleText() {
    return this.__type === 'text' && this.__mode === 0;
  }

  getTextContent() {
    const self = this.getLatest();
    return self.__text;
  }

  getFormatFlags(type, alignWithFormat) {
    const self = this.getLatest();
    const format = self.__format;
    return toggleTextFormatType(format, type, alignWithFormat);
  } // View


  createDOM(config) {
    const format = this.__format;
    const outerTag = getElementOuterTag(this, format);
    const innerTag = getElementInnerTag(this, format);
    const tag = outerTag === null ? innerTag : outerTag;
    const dom = document.createElement(tag);
    let innerDOM = dom;

    if (outerTag !== null) {
      innerDOM = document.createElement(innerTag);
      dom.appendChild(innerDOM);
    }

    const text = this.__text;
    createTextInnerDOM(innerDOM, this, innerTag, format, text, config);
    const style = this.__style;

    if (style !== '') {
      dom.style.cssText = style;
    }

    return dom;
  }

  updateDOM(prevNode, dom, config) {
    const nextText = this.__text;
    const prevFormat = prevNode.__format;
    const nextFormat = this.__format;
    const prevOuterTag = getElementOuterTag(this, prevFormat);
    const nextOuterTag = getElementOuterTag(this, nextFormat);
    const prevInnerTag = getElementInnerTag(this, prevFormat);
    const nextInnerTag = getElementInnerTag(this, nextFormat);
    const prevTag = prevOuterTag === null ? prevInnerTag : prevOuterTag;
    const nextTag = nextOuterTag === null ? nextInnerTag : nextOuterTag;

    if (prevTag !== nextTag) {
      return true;
    }

    if (prevOuterTag === nextOuterTag && prevInnerTag !== nextInnerTag) {
      // should always be an element
      const prevInnerDOM = dom.firstChild;

      if (prevInnerDOM == null) {
        {
          throw Error(`updateDOM: prevInnerDOM is null or undefined`);
        }
      }

      const nextInnerDOM = document.createElement(nextInnerTag);
      createTextInnerDOM(nextInnerDOM, this, nextInnerTag, nextFormat, nextText, config);
      dom.replaceChild(nextInnerDOM, prevInnerDOM);
      return false;
    }

    let innerDOM = dom;

    if (nextOuterTag !== null) {
      if (prevOuterTag !== null) {
        innerDOM = dom.firstChild;

        if (innerDOM == null) {
          {
            throw Error(`updateDOM: innerDOM is null or undefined`);
          }
        }
      }
    }

    setTextContent(nextText, innerDOM, this);
    const theme = config.theme; // Apply theme class names

    const textClassNames = theme.text;

    if (textClassNames !== undefined && prevFormat !== nextFormat) {
      setTextThemeClassNames(nextInnerTag, prevFormat, nextFormat, innerDOM, textClassNames);
    }

    const prevStyle = prevNode.__style;
    const nextStyle = this.__style;

    if (prevStyle !== nextStyle) {
      dom.style.cssText = nextStyle;
    }

    return false;
  }

  static importDOM() {
    return {
      '#text': () => ({
        conversion: convertTextDOMNode,
        priority: 0
      }),
      b: () => ({
        conversion: convertBringAttentionToElement,
        priority: 0
      }),
      br: () => ({
        conversion: convertLineBreakToElement,
        priority: 0
      }),
      code: () => ({
        conversion: convertTextFormatElement,
        priority: 0
      }),
      em: () => ({
        conversion: convertTextFormatElement,
        priority: 0
      }),
      i: () => ({
        conversion: convertTextFormatElement,
        priority: 0
      }),
      s: () => ({
        conversion: convertTextFormatElement,
        priority: 0
      }),
      span: () => ({
        conversion: convertSpanElement,
        priority: 0
      }),
      strong: () => ({
        conversion: convertTextFormatElement,
        priority: 0
      }),
      sub: () => ({
        conversion: convertTextFormatElement,
        priority: 0
      }),
      sup: () => ({
        conversion: convertTextFormatElement,
        priority: 0
      }),
      u: () => ({
        conversion: convertTextFormatElement,
        priority: 0
      })
    };
  }

  static importJSON(serializedNode) {
    const node = $createTextNode$1(serializedNode.text);
    node.setFormat(serializedNode.format);
    node.setDetail(serializedNode.detail);
    node.setMode(serializedNode.mode);
    node.setStyle(serializedNode.style);
    return node;
  } // This improves Lexical's basic text output in copy+paste plus
  // for headless mode where people might use Lexical to generate
  // HTML content and not have the ability to use CSS classes.


  exportDOM(editor) {
    let {
      element
    } = super.exportDOM(editor); // This is the only way to properly add support for most clients,
    // even if it's semantically incorrect to have to resort to using
    // <b>, <u>, <s>, <i> elements.

    if (element !== null) {
      if (this.hasFormat('bold')) {
        element = wrapElementWith(element, 'b');
      }

      if (this.hasFormat('italic')) {
        element = wrapElementWith(element, 'i');
      }

      if (this.hasFormat('strikethrough')) {
        element = wrapElementWith(element, 's');
      }

      if (this.hasFormat('underline')) {
        element = wrapElementWith(element, 'u');
      }
    }

    return {
      element
    };
  }

  exportJSON() {
    return {
      detail: this.getDetail(),
      format: this.getFormat(),
      mode: this.getMode(),
      style: this.getStyle(),
      text: this.getTextContent(),
      type: 'text',
      version: 1
    };
  } // Mutators


  selectionTransform(prevSelection, nextSelection) {
    return;
  } // TODO 0.5 This should just be a `string`.


  setFormat(format) {
    const self = this.getWritable();
    self.__format = typeof format === 'string' ? TEXT_TYPE_TO_FORMAT[format] : format;
    return self;
  } // TODO 0.5 This should just be a `string`.


  setDetail(detail) {
    const self = this.getWritable();
    self.__detail = typeof detail === 'string' ? DETAIL_TYPE_TO_DETAIL[detail] : detail;
    return self;
  }

  setStyle(style) {
    const self = this.getWritable();
    self.__style = style;
    return self;
  }

  toggleFormat(type) {
    const formatFlag = TEXT_TYPE_TO_FORMAT[type];
    return this.setFormat(this.getFormat() ^ formatFlag);
  }

  toggleDirectionless() {
    const self = this.getWritable();
    self.__detail ^= IS_DIRECTIONLESS;
    return self;
  }

  toggleUnmergeable() {
    const self = this.getWritable();
    self.__detail ^= IS_UNMERGEABLE;
    return self;
  }

  setMode(type) {
    const mode = TEXT_MODE_TO_TYPE[type];

    if (this.__mode === mode) {
      return this;
    }

    const self = this.getWritable();
    self.__mode = mode;
    return self;
  }

  setTextContent(text) {
    if (this.__text === text) {
      return this;
    }

    const self = this.getWritable();
    self.__text = text;
    return self;
  }

  select(_anchorOffset, _focusOffset) {
    errorOnReadOnly();
    let anchorOffset = _anchorOffset;
    let focusOffset = _focusOffset;
    const selection = $getSelection$1();
    const text = this.getTextContent();
    const key = this.__key;

    if (typeof text === 'string') {
      const lastOffset = text.length;

      if (anchorOffset === undefined) {
        anchorOffset = lastOffset;
      }

      if (focusOffset === undefined) {
        focusOffset = lastOffset;
      }
    } else {
      anchorOffset = 0;
      focusOffset = 0;
    }

    if (!$isRangeSelection$1(selection)) {
      return internalMakeRangeSelection(key, anchorOffset, key, focusOffset, 'text', 'text');
    } else {
      const compositionKey = $getCompositionKey();

      if (compositionKey === selection.anchor.key || compositionKey === selection.focus.key) {
        $setCompositionKey$1(key);
      }

      selection.setTextNodeRange(this, anchorOffset, this, focusOffset);
    }

    return selection;
  }

  spliceText(offset, delCount, newText, moveSelection) {
    const writableSelf = this.getWritable();
    const text = writableSelf.__text;
    const handledTextLength = newText.length;
    let index = offset;

    if (index < 0) {
      index = handledTextLength + index;

      if (index < 0) {
        index = 0;
      }
    }

    const selection = $getSelection$1();

    if (moveSelection && $isRangeSelection$1(selection)) {
      const newOffset = offset + handledTextLength;
      selection.setTextNodeRange(writableSelf, newOffset, writableSelf, newOffset);
    }

    const updatedText = text.slice(0, index) + newText + text.slice(index + delCount);
    writableSelf.__text = updatedText;
    return writableSelf;
  }

  canInsertTextBefore() {
    return true;
  }

  canInsertTextAfter() {
    return true;
  }

  canContainTabs() {
    return false;
  }

  splitText(...splitOffsets) {
    errorOnReadOnly();
    const self = this.getLatest();
    const textContent = self.getTextContent();
    const key = self.__key;
    const compositionKey = $getCompositionKey();
    const offsetsSet = new Set(splitOffsets);
    const parts = [];
    const textLength = textContent.length;
    let string = '';

    for (let i = 0; i < textLength; i++) {
      if (string !== '' && offsetsSet.has(i)) {
        parts.push(string);
        string = '';
      }

      string += textContent[i];
    }

    if (string !== '') {
      parts.push(string);
    }

    const partsLength = parts.length;

    if (partsLength === 0) {
      return [];
    } else if (parts[0] === textContent) {
      return [self];
    }

    const firstPart = parts[0];
    const parent = self.getParentOrThrow();
    let writableNode;
    const format = self.getFormat();
    const style = self.getStyle();
    const detail = self.__detail;
    let hasReplacedSelf = false;

    if (self.isSegmented()) {
      // Create a new TextNode
      writableNode = $createTextNode$1(firstPart);
      writableNode.__format = format;
      writableNode.__style = style;
      writableNode.__detail = detail;
      hasReplacedSelf = true;
    } else {
      // For the first part, update the existing node
      writableNode = self.getWritable();
      writableNode.__text = firstPart;
    } // Handle selection


    const selection = $getSelection$1(); // Then handle all other parts

    const splitNodes = [writableNode];
    let textSize = firstPart.length;

    for (let i = 1; i < partsLength; i++) {
      const part = parts[i];
      const partSize = part.length;
      const sibling = $createTextNode$1(part).getWritable();
      sibling.__format = format;
      sibling.__style = style;
      sibling.__detail = detail;
      const siblingKey = sibling.__key;
      const nextTextSize = textSize + partSize;

      if ($isRangeSelection$1(selection)) {
        const anchor = selection.anchor;
        const focus = selection.focus;

        if (anchor.key === key && anchor.type === 'text' && anchor.offset > textSize && anchor.offset <= nextTextSize) {
          anchor.key = siblingKey;
          anchor.offset -= textSize;
          selection.dirty = true;
        }

        if (focus.key === key && focus.type === 'text' && focus.offset > textSize && focus.offset <= nextTextSize) {
          focus.key = siblingKey;
          focus.offset -= textSize;
          selection.dirty = true;
        }
      }

      if (compositionKey === key) {
        $setCompositionKey$1(siblingKey);
      }

      textSize = nextTextSize;
      splitNodes.push(sibling);
    } // Insert the nodes into the parent's children


    internalMarkSiblingsAsDirty(this);
    const writableParent = parent.getWritable();
    const insertionIndex = this.getIndexWithinParent();

    if (hasReplacedSelf) {
      writableParent.splice(insertionIndex, 0, splitNodes);
      this.remove();
    } else {
      writableParent.splice(insertionIndex, 1, splitNodes);
    }

    if ($isRangeSelection$1(selection)) {
      $updateElementSelectionOnCreateDeleteNode(selection, parent, insertionIndex, partsLength - 1);
    }

    return splitNodes;
  }

  mergeWithSibling(target) {
    const isBefore = target === this.getPreviousSibling();

    if (!isBefore && target !== this.getNextSibling()) {
      {
        throw Error(`mergeWithSibling: sibling must be a previous or next sibling`);
      }
    }

    const key = this.__key;
    const targetKey = target.__key;
    const text = this.__text;
    const textLength = text.length;
    const compositionKey = $getCompositionKey();

    if (compositionKey === targetKey) {
      $setCompositionKey$1(key);
    }

    const selection = $getSelection$1();

    if ($isRangeSelection$1(selection)) {
      const anchor = selection.anchor;
      const focus = selection.focus;

      if (anchor !== null && anchor.key === targetKey) {
        adjustPointOffsetForMergedSibling(anchor, isBefore, key, target, textLength);
        selection.dirty = true;
      }

      if (focus !== null && focus.key === targetKey) {
        adjustPointOffsetForMergedSibling(focus, isBefore, key, target, textLength);
        selection.dirty = true;
      }
    }

    const targetText = target.__text;
    const newText = isBefore ? targetText + text : text + targetText;
    this.setTextContent(newText);
    const writableSelf = this.getWritable();
    target.remove();
    return writableSelf;
  }

  isTextEntity() {
    return false;
  }

}

function convertSpanElement(domNode) {
  // domNode is a <span> since we matched it by nodeName
  const span = domNode; // Google Docs uses span tags + font-weight for bold text

  const hasBoldFontWeight = span.style.fontWeight === '700'; // Google Docs uses span tags + text-decoration: line-through for strikethrough text

  const hasLinethroughTextDecoration = span.style.textDecoration === 'line-through'; // Google Docs uses span tags + font-style for italic text

  const hasItalicFontStyle = span.style.fontStyle === 'italic'; // Google Docs uses span tags + text-decoration: underline for underline text

  const hasUnderlineTextDecoration = span.style.textDecoration === 'underline'; // Google Docs uses span tags + vertical-align to specify subscript and superscript

  const verticalAlign = span.style.verticalAlign;
  return {
    forChild: lexicalNode => {
      if (!$isTextNode$1(lexicalNode)) {
        return lexicalNode;
      }

      if (hasBoldFontWeight) {
        lexicalNode.toggleFormat('bold');
      }

      if (hasLinethroughTextDecoration) {
        lexicalNode.toggleFormat('strikethrough');
      }

      if (hasItalicFontStyle) {
        lexicalNode.toggleFormat('italic');
      }

      if (hasUnderlineTextDecoration) {
        lexicalNode.toggleFormat('underline');
      }

      if (verticalAlign === 'sub') {
        lexicalNode.toggleFormat('subscript');
      }

      if (verticalAlign === 'super') {
        lexicalNode.toggleFormat('superscript');
      }

      return lexicalNode;
    },
    node: null
  };
}

function convertLineBreakToElement() {
  return {
    node: $createLineBreakNode$1()
  };
}

function convertBringAttentionToElement(domNode) {
  // domNode is a <b> since we matched it by nodeName
  const b = domNode; // Google Docs wraps all copied HTML in a <b> with font-weight normal

  const hasNormalFontWeight = b.style.fontWeight === 'normal';
  return {
    forChild: lexicalNode => {
      if ($isTextNode$1(lexicalNode) && !hasNormalFontWeight) {
        lexicalNode.toggleFormat('bold');
      }

      return lexicalNode;
    },
    node: null
  };
}

function convertTextDOMNode(domNode, _parent, preformatted) {
  let textContent = domNode.textContent || '';

  if (!preformatted && /\n/.test(textContent)) {
    textContent = textContent.replace(/\r?\n/gm, ' ');

    if (textContent.trim().length === 0) {
      return {
        node: null
      };
    }
  }

  return {
    node: $createTextNode$1(textContent)
  };
}

const nodeNameToTextFormat = {
  code: 'code',
  em: 'italic',
  i: 'italic',
  s: 'strikethrough',
  strong: 'bold',
  sub: 'subscript',
  sup: 'superscript',
  u: 'underline'
};

function convertTextFormatElement(domNode) {
  const format = nodeNameToTextFormat[domNode.nodeName.toLowerCase()];

  if (format === undefined) {
    return {
      node: null
    };
  }

  return {
    forChild: lexicalNode => {
      if ($isTextNode$1(lexicalNode) && !lexicalNode.hasFormat(format)) {
        lexicalNode.toggleFormat(format);
      }

      return lexicalNode;
    },
    node: null
  };
}

function $createTextNode$1(text = '') {
  return $applyNodeReplacement$1(new TextNode$1(text));
}
function $isTextNode$1(node) {
  return node instanceof TextNode$1;
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/** @noInheritDoc */
class ParagraphNode$1 extends ElementNode$1 {
  static getType() {
    return 'paragraph';
  }

  static clone(node) {
    return new ParagraphNode$1(node.__key);
  } // View


  createDOM(config) {
    const dom = document.createElement('p');
    const classNames = getCachedClassNameArray(config.theme, 'paragraph');

    if (classNames !== undefined) {
      const domClassList = dom.classList;
      domClassList.add(...classNames);
    }

    return dom;
  }

  updateDOM(prevNode, dom, config) {
    return false;
  }

  static importDOM() {
    return {
      p: node => ({
        conversion: convertParagraphElement,
        priority: 0
      })
    };
  }

  exportDOM(editor) {
    const {
      element
    } = super.exportDOM(editor);

    if (element && this.isEmpty()) {
      element.append(document.createElement('br'));
    }

    if (element) {
      const formatType = this.getFormatType();
      element.style.textAlign = formatType;
      const direction = this.getDirection();

      if (direction) {
        element.dir = direction;
      }

      const indent = this.getIndent();

      if (indent > 0) {
        // padding-inline-start is not widely supported in email HTML, but
        // Lexical Reconciler uses padding-inline-start. Using text-indent instead.
        element.style.textIndent = `${indent * 20}px`;
      }
    }

    return {
      element
    };
  }

  static importJSON(serializedNode) {
    const node = $createParagraphNode$1();
    node.setFormat(serializedNode.format);
    node.setIndent(serializedNode.indent);
    node.setDirection(serializedNode.direction);
    return node;
  }

  exportJSON() {
    return { ...super.exportJSON(),
      type: 'paragraph',
      version: 1
    };
  } // Mutation


  insertNewAfter(_, restoreSelection) {
    const newElement = $createParagraphNode$1();
    const direction = this.getDirection();
    newElement.setDirection(direction);
    this.insertAfter(newElement, restoreSelection);
    return newElement;
  }

  collapseAtStart() {
    const children = this.getChildren(); // If we have an empty (trimmed) first paragraph and try and remove it,
    // delete the paragraph as long as we have another sibling to go to

    if (children.length === 0 || $isTextNode$1(children[0]) && children[0].getTextContent().trim() === '') {
      const nextSibling = this.getNextSibling();

      if (nextSibling !== null) {
        this.selectNext();
        this.remove();
        return true;
      }

      const prevSibling = this.getPreviousSibling();

      if (prevSibling !== null) {
        this.selectPrevious();
        this.remove();
        return true;
      }
    }

    return false;
  }

}

function convertParagraphElement(element) {
  const node = $createParagraphNode$1();

  if (element.style) {
    node.setFormat(element.style.textAlign);
    const indent = parseInt(element.style.textIndent, 10) / 20;

    if (indent > 0) {
      node.setIndent(indent);
    }
  }

  return {
    node
  };
}

function $createParagraphNode$1() {
  return $applyNodeReplacement$1(new ParagraphNode$1());
}
function $isParagraphNode$1(node) {
  return node instanceof ParagraphNode$1;
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const COMMAND_PRIORITY_EDITOR$1 = 0;
const COMMAND_PRIORITY_LOW$1 = 1;
const COMMAND_PRIORITY_NORMAL$1 = 2;
const COMMAND_PRIORITY_HIGH$1 = 3;
const COMMAND_PRIORITY_CRITICAL$1 = 4; // eslint-disable-next-line @typescript-eslint/no-unused-vars

function resetEditor(editor, prevRootElement, nextRootElement, pendingEditorState) {
  const keyNodeMap = editor._keyToDOMMap;
  keyNodeMap.clear();
  editor._editorState = createEmptyEditorState();
  editor._pendingEditorState = pendingEditorState;
  editor._compositionKey = null;
  editor._dirtyType = NO_DIRTY_NODES;

  editor._cloneNotNeeded.clear();

  editor._dirtyLeaves = new Set();

  editor._dirtyElements.clear();

  editor._normalizedNodes = new Set();
  editor._updateTags = new Set();
  editor._updates = [];
  editor._blockCursorElement = null;
  const observer = editor._observer;

  if (observer !== null) {
    observer.disconnect();
    editor._observer = null;
  } // Remove all the DOM nodes from the root element


  if (prevRootElement !== null) {
    prevRootElement.textContent = '';
  }

  if (nextRootElement !== null) {
    nextRootElement.textContent = '';
    keyNodeMap.set('root', nextRootElement);
  }
}

function initializeConversionCache(nodes) {
  const conversionCache = new Map();
  const handledConversions = new Set();
  nodes.forEach(node => {
    const importDOM = node.klass.importDOM != null ? node.klass.importDOM.bind(node.klass) : null;

    if (importDOM == null || handledConversions.has(importDOM)) {
      return;
    }

    handledConversions.add(importDOM);
    const map = importDOM();

    if (map !== null) {
      Object.keys(map).forEach(key => {
        let currentCache = conversionCache.get(key);

        if (currentCache === undefined) {
          currentCache = [];
          conversionCache.set(key, currentCache);
        }

        currentCache.push(map[key]);
      });
    }
  });
  return conversionCache;
}
/**
 * Creates a new LexicalEditor attached to a single contentEditable (provided in the config). This is
 * the lowest-level initialization API for a LexicalEditor. If you're using React or another framework,
 * consider using the appropriate abstractions, such as LexicalComposer
 * @param editorConfig - the editor configuration.
 * @returns a LexicalEditor instance
 */


function createEditor$1(editorConfig) {
  const config = editorConfig || {};
  const activeEditor = internalGetActiveEditor();
  const theme = config.theme || {};
  const parentEditor = editorConfig === undefined ? activeEditor : config.parentEditor || null;
  const disableEvents = config.disableEvents || false;
  const editorState = createEmptyEditorState();
  const namespace = config.namespace || (parentEditor !== null ? parentEditor._config.namespace : createUID());
  const initialEditorState = config.editorState;
  const nodes = [RootNode$1, TextNode$1, LineBreakNode$1, ParagraphNode$1, ...(config.nodes || [])];
  const onError = config.onError;
  const isEditable = config.editable !== undefined ? config.editable : true;
  let registeredNodes;

  if (editorConfig === undefined && activeEditor !== null) {
    registeredNodes = activeEditor._nodes;
  } else {
    registeredNodes = new Map();

    for (let i = 0; i < nodes.length; i++) {
      let klass = nodes[i];
      let replacementClass = null;
      let replacementKlass = null;

      if (typeof klass !== 'function') {
        const options = klass;
        klass = options.replace;
        replacementClass = options.with;
        replacementKlass = options.withKlass ? options.withKlass : null;
      } // Ensure custom nodes implement required methods.


      {
        const name = klass.name;

        if (name !== 'RootNode') {
          const proto = klass.prototype;
          ['getType', 'clone'].forEach(method => {
            // eslint-disable-next-line no-prototype-builtins
            if (!klass.hasOwnProperty(method)) {
              console.warn(`${name} must implement static "${method}" method`);
            }
          });

          if ( // eslint-disable-next-line no-prototype-builtins
          !klass.hasOwnProperty('importDOM') && // eslint-disable-next-line no-prototype-builtins
          klass.hasOwnProperty('exportDOM')) {
            console.warn(`${name} should implement "importDOM" if using a custom "exportDOM" method to ensure HTML serialization (important for copy & paste) works as expected`);
          }

          if (proto instanceof DecoratorNode$1) {
            // eslint-disable-next-line no-prototype-builtins
            if (!proto.hasOwnProperty('decorate')) {
              console.warn(`${proto.constructor.name} must implement "decorate" method`);
            }
          }

          if ( // eslint-disable-next-line no-prototype-builtins
          !klass.hasOwnProperty('importJSON')) {
            console.warn(`${name} should implement "importJSON" method to ensure JSON and default HTML serialization works as expected`);
          }

          if ( // eslint-disable-next-line no-prototype-builtins
          !proto.hasOwnProperty('exportJSON')) {
            console.warn(`${name} should implement "exportJSON" method to ensure JSON and default HTML serialization works as expected`);
          }
        }
      }

      const type = klass.getType();
      const transform = klass.transform();
      const transforms = new Set();

      if (transform !== null) {
        transforms.add(transform);
      }

      registeredNodes.set(type, {
        klass,
        replace: replacementClass,
        replaceWithKlass: replacementKlass,
        transforms
      });
    }
  }

  const editor = new LexicalEditor(editorState, parentEditor, registeredNodes, {
    disableEvents,
    namespace,
    theme
  }, onError ? onError : console.error, initializeConversionCache(registeredNodes), isEditable);

  if (initialEditorState !== undefined) {
    editor._pendingEditorState = initialEditorState;
    editor._dirtyType = FULL_RECONCILE;
  }

  return editor;
}
class LexicalEditor {
  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */
  constructor(editorState, parentEditor, nodes, config, onError, htmlConversions, editable) {
    this._parentEditor = parentEditor; // The root element associated with this editor

    this._rootElement = null; // The current editor state

    this._editorState = editorState; // Handling of drafts and updates

    this._pendingEditorState = null; // Used to help co-ordinate selection and events

    this._compositionKey = null;
    this._deferred = []; // Used during reconciliation

    this._keyToDOMMap = new Map();
    this._updates = [];
    this._updating = false; // Listeners

    this._listeners = {
      decorator: new Set(),
      editable: new Set(),
      mutation: new Map(),
      root: new Set(),
      textcontent: new Set(),
      update: new Set()
    }; // Commands

    this._commands = new Map(); // Editor configuration for theme/context.

    this._config = config; // Mapping of types to their nodes

    this._nodes = nodes; // React node decorators for portals

    this._decorators = {};
    this._pendingDecorators = null; // Used to optimize reconciliation

    this._dirtyType = NO_DIRTY_NODES;
    this._cloneNotNeeded = new Set();
    this._dirtyLeaves = new Set();
    this._dirtyElements = new Map();
    this._normalizedNodes = new Set();
    this._updateTags = new Set(); // Handling of DOM mutations

    this._observer = null; // Used for identifying owning editors

    this._key = createUID();
    this._onError = onError;
    this._htmlConversions = htmlConversions;
    this._editable = editable;
    this._headless = parentEditor !== null && parentEditor._headless;
    this._window = null;
    this._blockCursorElement = null;
  }
  /**
   *
   * @returns true if the editor is currently in "composition" mode due to receiving input
   * through an IME, or 3P extension, for example. Returns false otherwise.
   */


  isComposing() {
    return this._compositionKey != null;
  }
  /**
   * Registers a listener for Editor update event. Will trigger the provided callback
   * each time the editor goes through an update (via {@link LexicalEditor.update}) until the
   * teardown function is called.
   *
   * @returns a teardown function that can be used to cleanup the listener.
   */


  registerUpdateListener(listener) {
    const listenerSetOrMap = this._listeners.update;
    listenerSetOrMap.add(listener);
    return () => {
      listenerSetOrMap.delete(listener);
    };
  }
  /**
   * Registers a listener for for when the editor changes between editable and non-editable states.
   * Will trigger the provided callback each time the editor transitions between these states until the
   * teardown function is called.
   *
   * @returns a teardown function that can be used to cleanup the listener.
   */


  registerEditableListener(listener) {
    const listenerSetOrMap = this._listeners.editable;
    listenerSetOrMap.add(listener);
    return () => {
      listenerSetOrMap.delete(listener);
    };
  }
  /**
   * Registers a listener for when the editor's decorator object changes. The decorator object contains
   * all DecoratorNode keys -> their decorated value. This is primarily used with external UI frameworks.
   *
   * Will trigger the provided callback each time the editor transitions between these states until the
   * teardown function is called.
   *
   * @returns a teardown function that can be used to cleanup the listener.
   */


  registerDecoratorListener(listener) {
    const listenerSetOrMap = this._listeners.decorator;
    listenerSetOrMap.add(listener);
    return () => {
      listenerSetOrMap.delete(listener);
    };
  }
  /**
   * Registers a listener for when Lexical commits an update to the DOM and the text content of
   * the editor changes from the previous state of the editor. If the text content is the
   * same between updates, no notifications to the listeners will happen.
   *
   * Will trigger the provided callback each time the editor transitions between these states until the
   * teardown function is called.
   *
   * @returns a teardown function that can be used to cleanup the listener.
   */


  registerTextContentListener(listener) {
    const listenerSetOrMap = this._listeners.textcontent;
    listenerSetOrMap.add(listener);
    return () => {
      listenerSetOrMap.delete(listener);
    };
  }
  /**
   * Registers a listener for when the editor's root DOM element (the content editable
   * Lexical attaches to) changes. This is primarily used to attach event listeners to the root
   *  element. The root listener function is executed directly upon registration and then on
   * any subsequent update.
   *
   * Will trigger the provided callback each time the editor transitions between these states until the
   * teardown function is called.
   *
   * @returns a teardown function that can be used to cleanup the listener.
   */


  registerRootListener(listener) {
    const listenerSetOrMap = this._listeners.root;
    listener(this._rootElement, null);
    listenerSetOrMap.add(listener);
    return () => {
      listener(null, this._rootElement);
      listenerSetOrMap.delete(listener);
    };
  }
  /**
   * Registers a listener that will trigger anytime the provided command
   * is dispatched, subject to priority. Listeners that run at a higher priority can "intercept"
   * commands and prevent them from propagating to other handlers by returning true.
   *
   * Listeners registered at the same priority level will run deterministically in the order of registration.
   *
   * @param command - the command that will trigger the callback.
   * @param listener - the function that will execute when the command is dispatched.
   * @param priority - the relative priority of the listener. 0 | 1 | 2 | 3 | 4
   * @returns a teardown function that can be used to cleanup the listener.
   */


  registerCommand(command, listener, priority) {
    if (priority === undefined) {
      {
        throw Error(`Listener for type "command" requires a "priority".`);
      }
    }

    const commandsMap = this._commands;

    if (!commandsMap.has(command)) {
      commandsMap.set(command, [new Set(), new Set(), new Set(), new Set(), new Set()]);
    }

    const listenersInPriorityOrder = commandsMap.get(command);

    if (listenersInPriorityOrder === undefined) {
      {
        throw Error(`registerCommand: Command ${String(command)} not found in command map`);
      }
    }

    const listeners = listenersInPriorityOrder[priority];
    listeners.add(listener);
    return () => {
      listeners.delete(listener);

      if (listenersInPriorityOrder.every(listenersSet => listenersSet.size === 0)) {
        commandsMap.delete(command);
      }
    };
  }
  /**
   * Registers a listener that will run when a Lexical node of the provided class is
   * mutated. The listener will receive a list of nodes along with the type of mutation
   * that was performed on each: created, destroyed, or updated.
   *
   * One common use case for this is to attach DOM event listeners to the underlying DOM nodes as Lexical nodes are created.
   * {@link LexicalEditor.getElementByKey} can be used for this.
   *
   * @param klass - The class of the node that you want to listen to mutations on.
   * @param listener - The logic you want to run when the node is mutated.
   * @returns a teardown function that can be used to cleanup the listener.
   */


  registerMutationListener(klass, listener) {
    const registeredNode = this._nodes.get(klass.getType());

    if (registeredNode === undefined) {
      {
        throw Error(`Node ${klass.name} has not been registered. Ensure node has been passed to createEditor.`);
      }
    }

    const mutations = this._listeners.mutation;
    mutations.set(listener, klass);
    return () => {
      mutations.delete(listener);
    };
  }
  /** @internal */


  registerNodeTransformToKlass(klass, listener) {
    const type = klass.getType();

    const registeredNode = this._nodes.get(type);

    if (registeredNode === undefined) {
      {
        throw Error(`Node ${klass.name} has not been registered. Ensure node has been passed to createEditor.`);
      }
    }

    const transforms = registeredNode.transforms;
    transforms.add(listener);
    return registeredNode;
  }
  /**
   * Registers a listener that will run when a Lexical node of the provided class is
   * marked dirty during an update. The listener will continue to run as long as the node
   * is marked dirty. There are no guarantees around the order of transform execution!
   *
   * Watch out for infinite loops. See [Node Transforms](https://lexical.dev/docs/concepts/transforms)
   * @param klass - The class of the node that you want to run transforms on.
   * @param listener - The logic you want to run when the node is updated.
   * @returns a teardown function that can be used to cleanup the listener.
   */


  registerNodeTransform(klass, listener) {
    const registeredNode = this.registerNodeTransformToKlass(klass, listener);
    const registeredNodes = [registeredNode];
    const replaceWithKlass = registeredNode.replaceWithKlass;

    if (replaceWithKlass != null) {
      const registeredReplaceWithNode = this.registerNodeTransformToKlass(replaceWithKlass, listener);
      registeredNodes.push(registeredReplaceWithNode);
    }

    markAllNodesAsDirty(this, klass.getType());
    return () => {
      registeredNodes.forEach(node => node.transforms.delete(listener));
    };
  }
  /**
   * Used to assert that certain nodes are registered, usually by plugins to ensure nodes that they
   * depend on have been registered.
   * @returns True if the editor has registered all of the provided node types, false otherwise.
   */


  hasNodes(nodes) {
    for (let i = 0; i < nodes.length; i++) {
      const klass = nodes[i];
      const type = klass.getType();

      if (!this._nodes.has(type)) {
        return false;
      }
    }

    return true;
  }
  /**
   * Dispatches a command of the specified type with the specified payload.
   * This triggers all command listeners (set by {@link LexicalEditor.registerCommand})
   * for this type, passing them the provided payload.
   * @param type - the type of command listeners to trigger.
   * @param payload - the data to pass as an argument to the command listeners.
   */


  dispatchCommand(type, payload) {
    return dispatchCommand(this, type, payload);
  }
  /**
   * Gets a map of all decorators in the editor.
   * @returns A mapping of call decorator keys to their decorated content
   */


  getDecorators() {
    return this._decorators;
  }
  /**
   *
   * @returns the current root element of the editor. If you want to register
   * an event listener, do it via {@link LexicalEditor.registerRootListener}, since
   * this reference may not be stable.
   */


  getRootElement() {
    return this._rootElement;
  }
  /**
   * Gets the key of the editor
   * @returns The editor key
   */


  getKey() {
    return this._key;
  }
  /**
   * Imperatively set the root contenteditable element that Lexical listens
   * for events on.
   */


  setRootElement(nextRootElement) {
    const prevRootElement = this._rootElement;

    if (nextRootElement !== prevRootElement) {
      const classNames = getCachedClassNameArray(this._config.theme, 'root');
      const pendingEditorState = this._pendingEditorState || this._editorState;
      this._rootElement = nextRootElement;
      resetEditor(this, prevRootElement, nextRootElement, pendingEditorState);

      if (prevRootElement !== null) {
        // TODO: remove this flag once we no longer use UEv2 internally
        if (!this._config.disableEvents) {
          removeRootElementEvents(prevRootElement);
        }

        if (classNames != null) {
          prevRootElement.classList.remove(...classNames);
        }
      }

      if (nextRootElement !== null) {
        const windowObj = getDefaultView(nextRootElement);
        const style = nextRootElement.style;
        style.userSelect = 'text';
        style.whiteSpace = 'pre-wrap';
        style.wordBreak = 'break-word';
        nextRootElement.setAttribute('data-lexical-editor', 'true');
        this._window = windowObj;
        this._dirtyType = FULL_RECONCILE;
        initMutationObserver(this);

        this._updateTags.add('history-merge');

        commitPendingUpdates(this); // TODO: remove this flag once we no longer use UEv2 internally

        if (!this._config.disableEvents) {
          addRootElementEvents(nextRootElement, this);
        }

        if (classNames != null) {
          nextRootElement.classList.add(...classNames);
        }
      } else {
        this._window = null;
      }

      triggerListeners('root', this, false, nextRootElement, prevRootElement);
    }
  }
  /**
   * Gets the underlying HTMLElement associated with the LexicalNode for the given key.
   * @returns the HTMLElement rendered by the LexicalNode associated with the key.
   * @param key - the key of the LexicalNode.
   */


  getElementByKey(key) {
    return this._keyToDOMMap.get(key) || null;
  }
  /**
   * Gets the active editor state.
   * @returns The editor state
   */


  getEditorState() {
    return this._editorState;
  }
  /**
   * Imperatively set the EditorState. Triggers reconciliation like an update.
   * @param editorState - the state to set the editor
   * @param options - options for the update.
   */


  setEditorState(editorState, options) {
    if (editorState.isEmpty()) {
      {
        throw Error(`setEditorState: the editor state is empty. Ensure the editor state's root node never becomes empty.`);
      }
    }

    flushRootMutations(this);
    const pendingEditorState = this._pendingEditorState;
    const tags = this._updateTags;
    const tag = options !== undefined ? options.tag : null;

    if (pendingEditorState !== null && !pendingEditorState.isEmpty()) {
      if (tag != null) {
        tags.add(tag);
      }

      commitPendingUpdates(this);
    }

    this._pendingEditorState = editorState;
    this._dirtyType = FULL_RECONCILE;

    this._dirtyElements.set('root', false);

    this._compositionKey = null;

    if (tag != null) {
      tags.add(tag);
    }

    commitPendingUpdates(this);
  }
  /**
   * Parses a SerializedEditorState (usually produced by {@link EditorState.toJSON}) and returns
   * and EditorState object that can be, for example, passed to {@link LexicalEditor.setEditorState}. Typically,
   * deserliazation from JSON stored in a database uses this method.
   * @param maybeStringifiedEditorState
   * @param updateFn
   * @returns
   */


  parseEditorState(maybeStringifiedEditorState, updateFn) {
    const serializedEditorState = typeof maybeStringifiedEditorState === 'string' ? JSON.parse(maybeStringifiedEditorState) : maybeStringifiedEditorState;
    return parseEditorState(serializedEditorState, this, updateFn);
  }
  /**
   * Executes an update to the editor state. The updateFn callback is the ONLY place
   * where Lexical editor state can be safely mutated.
   * @param updateFn - A function that has access to writable editor state.
   * @param options - A bag of options to control the behavior of the update.
   * @param options.onUpdate - A function to run once the update is complete.
   * Useful for synchronizing updates in some cases.
   * @param options.skipTransforms - Setting this to true will suppress all node
   * transforms for this update cycle.
   * @param options.tag - A tag to identify this update, in an update listener, for instance.
   * Some tags are reserved by the core and control update behavior in different ways.
   * @param options.discrete - If true, prevents this update from being batched, forcing it to
   * run synchronously.
   */


  update(updateFn, options) {
    updateEditor(this, updateFn, options);
  }
  /**
   * Focuses the editor
   * @param callbackFn - A function to run after the editor is focused.
   * @param options - A bag of options
   * @param options.defaultSelection - Where to move selection when the editor is
   * focused. Can be rootStart, rootEnd, or undefined. Defaults to rootEnd.
   */


  focus(callbackFn, options = {}) {
    const rootElement = this._rootElement;

    if (rootElement !== null) {
      // This ensures that iOS does not trigger caps lock upon focus
      rootElement.setAttribute('autocapitalize', 'off');
      updateEditor(this, () => {
        const selection = $getSelection$1();
        const root = $getRoot$1();

        if (selection !== null) {
          // Marking the selection dirty will force the selection back to it
          selection.dirty = true;
        } else if (root.getChildrenSize() !== 0) {
          if (options.defaultSelection === 'rootStart') {
            root.selectStart();
          } else {
            root.selectEnd();
          }
        }
      }, {
        onUpdate: () => {
          rootElement.removeAttribute('autocapitalize');

          if (callbackFn) {
            callbackFn();
          }
        },
        tag: 'focus'
      }); // In the case where onUpdate doesn't fire (due to the focus update not
      // occuring).

      if (this._pendingEditorState === null) {
        rootElement.removeAttribute('autocapitalize');
      }
    }
  }
  /**
   * Removes focus from the editor.
   */


  blur() {
    const rootElement = this._rootElement;

    if (rootElement !== null) {
      rootElement.blur();
    }

    const domSelection = getDOMSelection(this._window);

    if (domSelection !== null) {
      domSelection.removeAllRanges();
    }
  }
  /**
   * Returns true if the editor is editable, false otherwise.
   * @returns True if the editor is editable, false otherwise.
   */


  isEditable() {
    return this._editable;
  }
  /**
   * Sets the editable property of the editor. When false, the
   * editor will not listen for user events on the underling contenteditable.
   * @param editable - the value to set the editable mode to.
   */


  setEditable(editable) {
    if (this._editable !== editable) {
      this._editable = editable;
      triggerListeners('editable', this, true, editable);
    }
  }
  /**
   * Returns a JSON-serializable javascript object NOT a JSON string.
   * You still must call JSON.stringify (or something else) to turn the
   * state into a string you can transfer over the wire and store in a database.
   *
   * See {@link LexicalNode.exportJSON}
   *
   * @returns A JSON-serializable javascript object
   */


  toJSON() {
    return {
      editorState: this._editorState.toJSON()
    };
  }

}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/** @noInheritDoc */
class DEPRECATED_GridCellNode$1 extends ElementNode$1 {
  /** @internal */
  constructor(colSpan, key) {
    super(key);
    this.__colSpan = colSpan;
    this.__rowSpan = 1;
  }

  exportJSON() {
    return { ...super.exportJSON(),
      colSpan: this.__colSpan,
      rowSpan: this.__rowSpan
    };
  }

  getColSpan() {
    return this.__colSpan;
  }

  setColSpan(colSpan) {
    this.getWritable().__colSpan = colSpan;
    return this;
  }

  getRowSpan() {
    return this.__rowSpan;
  }

  setRowSpan(rowSpan) {
    this.getWritable().__rowSpan = rowSpan;
    return this;
  }

}
function DEPRECATED_$isGridCellNode$1(node) {
  return node instanceof DEPRECATED_GridCellNode$1;
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
class DEPRECATED_GridNode$1 extends ElementNode$1 {}
function DEPRECATED_$isGridNode$1(node) {
  return node instanceof DEPRECATED_GridNode$1;
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
class DEPRECATED_GridRowNode$1 extends ElementNode$1 {}
function DEPRECATED_$isGridRowNode$1(node) {
  return node instanceof DEPRECATED_GridRowNode$1;
}

var $addUpdateTag_1 = $addUpdateTag$1;
var $applyNodeReplacement_1 = $applyNodeReplacement$1;
var $copyNode_1 = $copyNode$1;
var $createLineBreakNode_1 = $createLineBreakNode$1;
var $createNodeSelection_1 = $createNodeSelection$1;
var $createParagraphNode_1 = $createParagraphNode$1;
var $createRangeSelection_1 = $createRangeSelection$1;
var $createTextNode_1 = $createTextNode$1;
var $getAdjacentNode_1 = $getAdjacentNode$1;
var $getNearestNodeFromDOMNode_1 = $getNearestNodeFromDOMNode$1;
var $getNearestRootOrShadowRoot_1 = $getNearestRootOrShadowRoot$1;
var $getNodeByKey_1 = $getNodeByKey$1;
var $getPreviousSelection_1 = $getPreviousSelection$1;
var $getRoot_1 = $getRoot$1;
var $getSelection_1 = $getSelection$1;
var $getTextContent_1 = $getTextContent$1;
var $hasAncestor_1 = $hasAncestor$1;
var $hasUpdateTag_1 = $hasUpdateTag$1;
var $insertNodes_1 = $insertNodes$1;
var $isDecoratorNode_1 = $isDecoratorNode$1;
var $isElementNode_1 = $isElementNode$1;
var $isInlineElementOrDecoratorNode_1 = $isInlineElementOrDecoratorNode$1;
var $isLeafNode_1 = $isLeafNode$1;
var $isLineBreakNode_1 = $isLineBreakNode$1;
var $isNodeSelection_1 = $isNodeSelection$1;
var $isParagraphNode_1 = $isParagraphNode$1;
var $isRangeSelection_1 = $isRangeSelection$1;
var $isRootNode_1 = $isRootNode$1;
var $isRootOrShadowRoot_1 = $isRootOrShadowRoot$1;
var $isTextNode_1 = $isTextNode$1;
var $nodesOfType_1 = $nodesOfType$1;
var $normalizeSelection__EXPERIMENTAL$1 = $normalizeSelection;
var $parseSerializedNode_1 = $parseSerializedNode$1;
var $setCompositionKey_1 = $setCompositionKey$1;
var $setSelection_1 = $setSelection$1;
var $splitNode_1 = $splitNode$3;
var BLUR_COMMAND_1 = BLUR_COMMAND$1;
var CAN_REDO_COMMAND_1 = CAN_REDO_COMMAND$1;
var CAN_UNDO_COMMAND_1 = CAN_UNDO_COMMAND$1;
var CLEAR_EDITOR_COMMAND_1 = CLEAR_EDITOR_COMMAND$1;
var CLEAR_HISTORY_COMMAND_1 = CLEAR_HISTORY_COMMAND$1;
var CLICK_COMMAND_1 = CLICK_COMMAND$1;
var COMMAND_PRIORITY_CRITICAL_1 = COMMAND_PRIORITY_CRITICAL$1;
var COMMAND_PRIORITY_EDITOR_1 = COMMAND_PRIORITY_EDITOR$1;
var COMMAND_PRIORITY_HIGH_1 = COMMAND_PRIORITY_HIGH$1;
var COMMAND_PRIORITY_LOW_1 = COMMAND_PRIORITY_LOW$1;
var COMMAND_PRIORITY_NORMAL_1 = COMMAND_PRIORITY_NORMAL$1;
var CONTROLLED_TEXT_INSERTION_COMMAND_1 = CONTROLLED_TEXT_INSERTION_COMMAND$1;
var COPY_COMMAND_1 = COPY_COMMAND$1;
var CUT_COMMAND_1 = CUT_COMMAND$1;
var DELETE_CHARACTER_COMMAND_1 = DELETE_CHARACTER_COMMAND$1;
var DELETE_LINE_COMMAND_1 = DELETE_LINE_COMMAND$1;
var DELETE_WORD_COMMAND_1 = DELETE_WORD_COMMAND$1;
var DEPRECATED_$computeGridMap_1 = DEPRECATED_$computeGridMap$1;
var DEPRECATED_$createGridSelection_1 = DEPRECATED_$createGridSelection$1;
var DEPRECATED_$getNodeTriplet_1 = DEPRECATED_$getNodeTriplet$1;
var DEPRECATED_$isGridCellNode_1 = DEPRECATED_$isGridCellNode$1;
var DEPRECATED_$isGridNode_1 = DEPRECATED_$isGridNode$1;
var DEPRECATED_$isGridRowNode_1 = DEPRECATED_$isGridRowNode$1;
var DEPRECATED_$isGridSelection_1 = DEPRECATED_$isGridSelection$1;
var DEPRECATED_GridCellNode_1 = DEPRECATED_GridCellNode$1;
var DEPRECATED_GridNode_1 = DEPRECATED_GridNode$1;
var DEPRECATED_GridRowNode_1 = DEPRECATED_GridRowNode$1;
var DRAGEND_COMMAND_1 = DRAGEND_COMMAND$1;
var DRAGOVER_COMMAND_1 = DRAGOVER_COMMAND$1;
var DRAGSTART_COMMAND_1 = DRAGSTART_COMMAND$1;
var DROP_COMMAND_1 = DROP_COMMAND$1;
var DecoratorNode_1 = DecoratorNode$1;
var ElementNode_1 = ElementNode$1;
var FOCUS_COMMAND_1 = FOCUS_COMMAND$1;
var FORMAT_ELEMENT_COMMAND_1 = FORMAT_ELEMENT_COMMAND$1;
var FORMAT_TEXT_COMMAND_1 = FORMAT_TEXT_COMMAND$1;
var INDENT_CONTENT_COMMAND_1 = INDENT_CONTENT_COMMAND$1;
var INSERT_LINE_BREAK_COMMAND_1 = INSERT_LINE_BREAK_COMMAND$1;
var INSERT_PARAGRAPH_COMMAND_1 = INSERT_PARAGRAPH_COMMAND$1;
var KEY_ARROW_DOWN_COMMAND_1 = KEY_ARROW_DOWN_COMMAND$1;
var KEY_ARROW_LEFT_COMMAND_1 = KEY_ARROW_LEFT_COMMAND$1;
var KEY_ARROW_RIGHT_COMMAND_1 = KEY_ARROW_RIGHT_COMMAND$1;
var KEY_ARROW_UP_COMMAND_1 = KEY_ARROW_UP_COMMAND$1;
var KEY_BACKSPACE_COMMAND_1 = KEY_BACKSPACE_COMMAND$1;
var KEY_DELETE_COMMAND_1 = KEY_DELETE_COMMAND$1;
var KEY_DOWN_COMMAND_1 = KEY_DOWN_COMMAND$1;
var KEY_ENTER_COMMAND_1 = KEY_ENTER_COMMAND$1;
var KEY_ESCAPE_COMMAND_1 = KEY_ESCAPE_COMMAND$1;
var KEY_MODIFIER_COMMAND_1 = KEY_MODIFIER_COMMAND$1;
var KEY_SPACE_COMMAND_1 = KEY_SPACE_COMMAND$1;
var KEY_TAB_COMMAND_1 = KEY_TAB_COMMAND$1;
var LineBreakNode_1 = LineBreakNode$1;
var MOVE_TO_END_1 = MOVE_TO_END$1;
var MOVE_TO_START_1 = MOVE_TO_START$1;
var OUTDENT_CONTENT_COMMAND_1 = OUTDENT_CONTENT_COMMAND$1;
var PASTE_COMMAND_1 = PASTE_COMMAND$1;
var ParagraphNode_1 = ParagraphNode$1;
var REDO_COMMAND_1 = REDO_COMMAND$1;
var REMOVE_TEXT_COMMAND_1 = REMOVE_TEXT_COMMAND$1;
var RootNode_1 = RootNode$1;
var SELECTION_CHANGE_COMMAND_1 = SELECTION_CHANGE_COMMAND$1;
var TextNode_1 = TextNode$1;
var UNDO_COMMAND_1 = UNDO_COMMAND$1;
var createCommand_1 = createCommand$1;
var createEditor_1 = createEditor$1;
var getNearestEditorFromDOMNode_1 = getNearestEditorFromDOMNode$1;
var isSelectionCapturedInDecoratorInput_1 = isSelectionCapturedInDecoratorInput$1;
var isSelectionWithinEditor_1 = isSelectionWithinEditor$1;

var Lexical_dev = {
	$addUpdateTag: $addUpdateTag_1,
	$applyNodeReplacement: $applyNodeReplacement_1,
	$copyNode: $copyNode_1,
	$createLineBreakNode: $createLineBreakNode_1,
	$createNodeSelection: $createNodeSelection_1,
	$createParagraphNode: $createParagraphNode_1,
	$createRangeSelection: $createRangeSelection_1,
	$createTextNode: $createTextNode_1,
	$getAdjacentNode: $getAdjacentNode_1,
	$getNearestNodeFromDOMNode: $getNearestNodeFromDOMNode_1,
	$getNearestRootOrShadowRoot: $getNearestRootOrShadowRoot_1,
	$getNodeByKey: $getNodeByKey_1,
	$getPreviousSelection: $getPreviousSelection_1,
	$getRoot: $getRoot_1,
	$getSelection: $getSelection_1,
	$getTextContent: $getTextContent_1,
	$hasAncestor: $hasAncestor_1,
	$hasUpdateTag: $hasUpdateTag_1,
	$insertNodes: $insertNodes_1,
	$isDecoratorNode: $isDecoratorNode_1,
	$isElementNode: $isElementNode_1,
	$isInlineElementOrDecoratorNode: $isInlineElementOrDecoratorNode_1,
	$isLeafNode: $isLeafNode_1,
	$isLineBreakNode: $isLineBreakNode_1,
	$isNodeSelection: $isNodeSelection_1,
	$isParagraphNode: $isParagraphNode_1,
	$isRangeSelection: $isRangeSelection_1,
	$isRootNode: $isRootNode_1,
	$isRootOrShadowRoot: $isRootOrShadowRoot_1,
	$isTextNode: $isTextNode_1,
	$nodesOfType: $nodesOfType_1,
	$normalizeSelection__EXPERIMENTAL: $normalizeSelection__EXPERIMENTAL$1,
	$parseSerializedNode: $parseSerializedNode_1,
	$setCompositionKey: $setCompositionKey_1,
	$setSelection: $setSelection_1,
	$splitNode: $splitNode_1,
	BLUR_COMMAND: BLUR_COMMAND_1,
	CAN_REDO_COMMAND: CAN_REDO_COMMAND_1,
	CAN_UNDO_COMMAND: CAN_UNDO_COMMAND_1,
	CLEAR_EDITOR_COMMAND: CLEAR_EDITOR_COMMAND_1,
	CLEAR_HISTORY_COMMAND: CLEAR_HISTORY_COMMAND_1,
	CLICK_COMMAND: CLICK_COMMAND_1,
	COMMAND_PRIORITY_CRITICAL: COMMAND_PRIORITY_CRITICAL_1,
	COMMAND_PRIORITY_EDITOR: COMMAND_PRIORITY_EDITOR_1,
	COMMAND_PRIORITY_HIGH: COMMAND_PRIORITY_HIGH_1,
	COMMAND_PRIORITY_LOW: COMMAND_PRIORITY_LOW_1,
	COMMAND_PRIORITY_NORMAL: COMMAND_PRIORITY_NORMAL_1,
	CONTROLLED_TEXT_INSERTION_COMMAND: CONTROLLED_TEXT_INSERTION_COMMAND_1,
	COPY_COMMAND: COPY_COMMAND_1,
	CUT_COMMAND: CUT_COMMAND_1,
	DELETE_CHARACTER_COMMAND: DELETE_CHARACTER_COMMAND_1,
	DELETE_LINE_COMMAND: DELETE_LINE_COMMAND_1,
	DELETE_WORD_COMMAND: DELETE_WORD_COMMAND_1,
	DEPRECATED_$computeGridMap: DEPRECATED_$computeGridMap_1,
	DEPRECATED_$createGridSelection: DEPRECATED_$createGridSelection_1,
	DEPRECATED_$getNodeTriplet: DEPRECATED_$getNodeTriplet_1,
	DEPRECATED_$isGridCellNode: DEPRECATED_$isGridCellNode_1,
	DEPRECATED_$isGridNode: DEPRECATED_$isGridNode_1,
	DEPRECATED_$isGridRowNode: DEPRECATED_$isGridRowNode_1,
	DEPRECATED_$isGridSelection: DEPRECATED_$isGridSelection_1,
	DEPRECATED_GridCellNode: DEPRECATED_GridCellNode_1,
	DEPRECATED_GridNode: DEPRECATED_GridNode_1,
	DEPRECATED_GridRowNode: DEPRECATED_GridRowNode_1,
	DRAGEND_COMMAND: DRAGEND_COMMAND_1,
	DRAGOVER_COMMAND: DRAGOVER_COMMAND_1,
	DRAGSTART_COMMAND: DRAGSTART_COMMAND_1,
	DROP_COMMAND: DROP_COMMAND_1,
	DecoratorNode: DecoratorNode_1,
	ElementNode: ElementNode_1,
	FOCUS_COMMAND: FOCUS_COMMAND_1,
	FORMAT_ELEMENT_COMMAND: FORMAT_ELEMENT_COMMAND_1,
	FORMAT_TEXT_COMMAND: FORMAT_TEXT_COMMAND_1,
	INDENT_CONTENT_COMMAND: INDENT_CONTENT_COMMAND_1,
	INSERT_LINE_BREAK_COMMAND: INSERT_LINE_BREAK_COMMAND_1,
	INSERT_PARAGRAPH_COMMAND: INSERT_PARAGRAPH_COMMAND_1,
	KEY_ARROW_DOWN_COMMAND: KEY_ARROW_DOWN_COMMAND_1,
	KEY_ARROW_LEFT_COMMAND: KEY_ARROW_LEFT_COMMAND_1,
	KEY_ARROW_RIGHT_COMMAND: KEY_ARROW_RIGHT_COMMAND_1,
	KEY_ARROW_UP_COMMAND: KEY_ARROW_UP_COMMAND_1,
	KEY_BACKSPACE_COMMAND: KEY_BACKSPACE_COMMAND_1,
	KEY_DELETE_COMMAND: KEY_DELETE_COMMAND_1,
	KEY_DOWN_COMMAND: KEY_DOWN_COMMAND_1,
	KEY_ENTER_COMMAND: KEY_ENTER_COMMAND_1,
	KEY_ESCAPE_COMMAND: KEY_ESCAPE_COMMAND_1,
	KEY_MODIFIER_COMMAND: KEY_MODIFIER_COMMAND_1,
	KEY_SPACE_COMMAND: KEY_SPACE_COMMAND_1,
	KEY_TAB_COMMAND: KEY_TAB_COMMAND_1,
	LineBreakNode: LineBreakNode_1,
	MOVE_TO_END: MOVE_TO_END_1,
	MOVE_TO_START: MOVE_TO_START_1,
	OUTDENT_CONTENT_COMMAND: OUTDENT_CONTENT_COMMAND_1,
	PASTE_COMMAND: PASTE_COMMAND_1,
	ParagraphNode: ParagraphNode_1,
	REDO_COMMAND: REDO_COMMAND_1,
	REMOVE_TEXT_COMMAND: REMOVE_TEXT_COMMAND_1,
	RootNode: RootNode_1,
	SELECTION_CHANGE_COMMAND: SELECTION_CHANGE_COMMAND_1,
	TextNode: TextNode_1,
	UNDO_COMMAND: UNDO_COMMAND_1,
	createCommand: createCommand_1,
	createEditor: createEditor_1,
	getNearestEditorFromDOMNode: getNearestEditorFromDOMNode_1,
	isSelectionCapturedInDecoratorInput: isSelectionCapturedInDecoratorInput_1,
	isSelectionWithinEditor: isSelectionWithinEditor_1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
let ca$3={},da$3={},ea$3={},fa$3={},ja$1={},ka$1={},la$1={},na$1={},qa$1={},ra$1={},sa$1={},ta$1={},ua={},wa$1={},xa$1={},ya$1={},za$1={},Aa$1={},Ba$1={},Ca$1={},Da$1={},Ga={},Ha={},Ia={},Ja={},Ka={},La={},Ma={},Na={},Oa={},Pa={},Qa={},Ra={},Sa={},Ta={};function q$7(a){throw Error(`Minified Lexical error #${a}; visit https://lexical.dev/docs/error?code=${a} for the full message or `+"use the non-minified dev environment for full errors and additional helpful warnings.");}
let Ua="undefined"!==typeof window&&"undefined"!==typeof window.document&&"undefined"!==typeof window.document.createElement,Va=Ua&&"documentMode"in document?document.documentMode:null,t$7=Ua&&/Mac|iPod|iPhone|iPad/.test(navigator.platform),Wa=Ua&&/^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent),Xa=Ua&&"InputEvent"in window&&!Va?"getTargetRanges"in new window.InputEvent("input"):!1,Ya=Ua&&/Version\/[\d.]+.*Safari/.test(navigator.userAgent),Za=Ua&&/iPad|iPhone|iPod/.test(navigator.userAgent)&&
!window.MSStream,$a=Ua&&/^(?=.*Chrome).*/i.test(navigator.userAgent),ab=Ua&&/AppleWebKit\/[\d.]+/.test(navigator.userAgent)&&!$a,bb=Ya||Za||ab?"\u00a0":"\u200b",cb=Wa?"\u00a0":bb,db=/^[^A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02b8\u0300-\u0590\u0800-\u1fff\u200e\u2c00-\ufb1c\ufe00-\ufe6f\ufefd-\uffff]*[\u0591-\u07ff\ufb1d-\ufdfd\ufe70-\ufefc]/,eb=/^[^\u0591-\u07ff\ufb1d-\ufdfd\ufe70-\ufefc]*[A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02b8\u0300-\u0590\u0800-\u1fff\u200e\u2c00-\ufb1c\ufe00-\ufe6f\ufefd-\uffff]/,
fb={bold:1,code:16,highlight:128,italic:2,strikethrough:4,subscript:32,superscript:64,underline:8},gb={directionless:1,unmergeable:2},kb={center:2,end:6,justify:4,left:1,right:3,start:5},lb={2:"center",6:"end",4:"justify",1:"left",3:"right",5:"start"},mb={normal:0,segmented:2,token:1},nb={0:"normal",2:"segmented",1:"token"},ob=!1,pb=0;function qb(a){pb=a.timeStamp;}function rb(a,b,c){return b.__lexicalLineBreak===a||void 0!==a[`__lexicalKey_${c._key}`]}
function sb(a){return a.getEditorState().read(()=>{let b=v$6();return null!==b?b.clone():null})}
function tb(a,b,c){ob=!0;let d=100<performance.now()-pb;try{w$6(a,()=>{let e=v$6()||sb(a);var f=new Map,g=a.getRootElement(),h=a._editorState,k=a._blockCursorElement;let n=!1,m="";for(var p=0;p<b.length;p++){var l=b[p],r=l.type,u=l.target,x=ub(u,h);if(!(null===x&&u!==g||z$7(x)))if("characterData"===r){if(l=d&&B$7(x))a:{l=e;r=u;var y=x;if(C$5(l)){var A=l.anchor.getNode();if(A.is(y)&&l.format!==A.getFormat()){l=!1;break a}}l=3===r.nodeType&&y.isAttached();}l&&(y=E$6(a._window),r=l=null,null!==y&&y.anchorNode===
u&&(l=y.anchorOffset,r=y.focusOffset),u=u.nodeValue,null!==u&&vb(x,u,l,r,!1));}else if("childList"===r){n=!0;r=l.addedNodes;for(y=0;y<r.length;y++){A=r[y];var aa=wb(A),ba=A.parentNode;null==ba||A===k||null!==aa||"BR"===A.nodeName&&rb(A,ba,a)||(Wa&&(aa=A.innerText||A.nodeValue)&&(m+=aa),ba.removeChild(A));}l=l.removedNodes;r=l.length;if(0<r){y=0;for(A=0;A<r;A++)if(ba=l[A],"BR"===ba.nodeName&&rb(ba,u,a)||k===ba)u.appendChild(ba),y++;r!==y&&(u===g&&(x=h._nodeMap.get("root")),f.set(u,x));}}}if(0<f.size)for(let [oa,
pa]of f)if(F$5(pa))for(f=pa.getChildrenKeys(),g=oa.firstChild,h=0;h<f.length;h++)k=a.getElementByKey(f[h]),null!==k&&(null==g?(oa.appendChild(k),g=k):g!==k&&oa.replaceChild(k,g),g=g.nextSibling);else B$7(pa)&&pa.markDirty();f=c.takeRecords();if(0<f.length){for(g=0;g<f.length;g++)for(k=f[g],h=k.addedNodes,k=k.target,p=0;p<h.length;p++)x=h[p],u=x.parentNode,null==u||"BR"!==x.nodeName||rb(x,k,a)||u.removeChild(x);c.takeRecords();}null!==e&&(n&&(e.dirty=!0,xb(e)),Wa&&yb(a)&&e.insertRawText(m));});}finally{ob=
!1;}}function zb(a){let b=a._observer;if(null!==b){let c=b.takeRecords();tb(a,c,b);}}function Ab(a){0===pb&&Bb(a).addEventListener("textInput",qb,!0);a._observer=new MutationObserver((b,c)=>{tb(a,b,c);});}let Cb=1,Db="function"===typeof queueMicrotask?queueMicrotask:a=>{Promise.resolve().then(a);};function Eb(a){let b=document.activeElement;if(null===b)return !1;let c=b.nodeName;return z$7(ub(a))&&("INPUT"===c||"TEXTAREA"===c||"true"===b.contentEditable&&null==b.__lexicalEditor)}
function Fb(a,b,c){let d=a.getRootElement();try{return null!==d&&d.contains(b)&&d.contains(c)&&null!==b&&!Eb(b)&&Gb(b)===a}catch(e){return !1}}function Gb(a){for(;null!=a;){let b=a.__lexicalEditor;if(null!=b)return b;a=Hb(a);}return null}function Ib(a){return a.isToken()||a.isSegmented()}function Pb(a){for(;null!=a;){if(3===a.nodeType)return a;a=a.firstChild;}return null}function Qb(a,b,c){b=fb[b];return a&b&&(null===c||0===(c&b))?a^b:null===c||c&b?a|b:a}function Rb(a){return B$7(a)||Sb(a)||z$7(a)}
function Tb(a,b){if(null!=b)a.__key=b;else {G$4();99<Ub&&q$7(14);b=H$6();var c=Vb(),d=""+Cb++;c._nodeMap.set(d,a);F$5(a)?b._dirtyElements.set(d,!0):b._dirtyLeaves.add(d);b._cloneNotNeeded.add(d);b._dirtyType=1;a.__key=d;}}
function Wb(a){var b=a.getParent();if(null!==b){let e=a.getWritable();b=b.getWritable();var c=a.getPreviousSibling();a=a.getNextSibling();if(null===c)if(null!==a){var d=a.getWritable();b.__first=a.__key;d.__prev=null;}else b.__first=null;else {d=c.getWritable();if(null!==a){let f=a.getWritable();f.__prev=d.__key;d.__next=f.__key;}else d.__next=null;e.__prev=null;}null===a?null!==c?(a=c.getWritable(),b.__last=c.__key,a.__next=null):b.__last=null:(a=a.getWritable(),null!==c?(c=c.getWritable(),c.__next=
a.__key,a.__prev=c.__key):a.__prev=null,e.__next=null);b.__size--;e.__parent=null;}}function Xb(a){99<Ub&&q$7(14);var b=a.getLatest(),c=b.__parent,d=Vb();let e=H$6(),f=d._nodeMap;d=e._dirtyElements;if(null!==c)a:for(;null!==c;){if(d.has(c))break a;let g=f.get(c);if(void 0===g)break;d.set(c,!1);c=g.__parent;}b=b.__key;e._dirtyType=1;F$5(a)?d.set(b,!0):e._dirtyLeaves.add(b);}
function I$5(a){G$4();var b=H$6();let c=b._compositionKey;a!==c&&(b._compositionKey=a,null!==c&&(b=J$5(c),null!==b&&b.getWritable()),null!==a&&(a=J$5(a),null!==a&&a.getWritable()));}function Yb(){return Zb()?null:H$6()._compositionKey}function J$5(a,b){a=(b||Vb())._nodeMap.get(a);return void 0===a?null:a}function wb(a,b){let c=H$6();a=a[`__lexicalKey_${c._key}`];return void 0!==a?J$5(a,b):null}function ub(a,b){for(;null!=a;){let c=wb(a,b);if(null!==c)return c;a=Hb(a);}return null}
function $b(a){let b=Object.assign({},a._decorators);return a._pendingDecorators=b}function ac(a){return a.read(()=>bc().getTextContent())}function cc(a,b){w$6(a,()=>{var c=Vb();if(!c.isEmpty())if("root"===b)bc().markDirty();else {c=c._nodeMap;for(let [,d]of c)d.markDirty();}},null===a._pendingEditorState?{tag:"history-merge"}:void 0);}function bc(){return Vb()._nodeMap.get("root")}function xb(a){G$4();let b=Vb();null!==a&&(a.dirty=!0,a._cachedNodes=null);b._selection=a;}
function dc(a){var b=H$6(),c;a:{for(c=a;null!=c;){let d=c[`__lexicalKey_${b._key}`];if(void 0!==d){c=d;break a}c=Hb(c);}c=null;}return null===c?(b=b.getRootElement(),a===b?J$5("root"):null):J$5(c)}function ec(a){return /[\uD800-\uDBFF][\uDC00-\uDFFF]/g.test(a)}function fc(a){let b=[];for(;null!==a;)b.push(a),a=a._parentEditor;return b}function gc(){return Math.random().toString(36).replace(/[^a-z]+/g,"").substr(0,5)}
function hc(a,b,c){b=E$6(b._window);if(null!==b){var d=b.anchorNode,{anchorOffset:e,focusOffset:f}=b;if(null!==d&&(b=3===d.nodeType?d.nodeValue:null,d=ub(d),null!==b&&B$7(d))){if(d.canContainTabs()){var g=b.includes("\t");if(c&&0<c.length&&g){g=c.length;let h=e+g-1,k=b.slice(0,h);b=b.slice(h,b.length);b=`${k}${c}${b}`;e+=g;f+=g;}}b===bb&&c&&(g=c.length,b=c,f=e=g);null!==b&&vb(d,b,e,f,a);}}}
function vb(a,b,c,d,e){let f=a;if(f.isAttached()&&(e||!f.isDirty())){var g=f.isComposing();a=b;(g||e)&&b[b.length-1]===bb&&(a=b.slice(0,-1));b=f.getTextContent();if(e||a!==b)if(""===a)if(I$5(null),Ya||Za||ab)f.remove();else {let n=H$6();setTimeout(()=>{n.update(()=>{f.isAttached()&&f.remove();});},20);}else {e=f.getParent();b=ic();var h=Yb(),k=f.getKey();f.isToken()||null!==h&&k===h&&!g||null!==e&&C$5(b)&&!e.canInsertTextBefore()&&0===b.anchor.offset?f.markDirty():(g=v$6(),C$5(g)&&null!==c&&null!==d&&(g.setTextNodeRange(f,
c,f,d),f.isSegmented()&&(c=f.getTextContent(),c=K$5(c),f.replace(c),f=c)),f.setTextContent(a));}}}function jc(a,b){if(b.isSegmented())return !0;if(!a.isCollapsed())return !1;a=a.anchor.offset;let c=b.getParentOrThrow(),d=b.isToken();return 0===a?((a=!b.canInsertTextBefore()||!c.canInsertTextBefore()||d)||(b=b.getPreviousSibling(),a=(B$7(b)||F$5(b)&&b.isInline())&&!b.canInsertTextAfter()),a):a===b.getTextContentSize()?!b.canInsertTextAfter()||!c.canInsertTextAfter()||d:!1}
function kc(a,b){var c=a[b];return "string"===typeof c?(c=c.split(" "),a[b]=c):c}function lc(a,b,c,d,e){0!==c.size&&(c=d.__key,b=b.get(d.__type),void 0===b&&q$7(33),d=b.klass,b=a.get(d),void 0===b&&(b=new Map,a.set(d,b)),a=b.get(c),d="destroyed"===a&&"created"===e,(void 0===a||d)&&b.set(c,d?"updated":e));}function mc(a,b,c){let d=a.getParent(),e=c;null!==d&&(b&&0===c?(e=a.getIndexWithinParent(),a=d):b||c!==a.getChildrenSize()||(e=a.getIndexWithinParent()+1,a=d));return a.getChildAtIndex(b?e-1:e)}
function nc(a,b){var c=a.offset;if("element"===a.type)return a=a.getNode(),mc(a,b,c);a=a.getNode();return b&&0===c||!b&&c===a.getTextContentSize()?(c=b?a.getPreviousSibling():a.getNextSibling(),null===c?mc(a.getParentOrThrow(),b,a.getIndexWithinParent()+(b?0:1)):c):null}function yb(a){a=(a=Bb(a).event)&&a.inputType;return "insertFromPaste"===a||"insertFromPasteAsQuotation"===a}function oc(a){return !L$5(a)&&!a.isLastChild()&&!a.isInline()}
function pc(a,b){a=a._keyToDOMMap.get(b);void 0===a&&q$7(75);return a}function Hb(a){a=a.assignedSlot||a.parentElement;return null!==a&&11===a.nodeType?a.host:a}function qc(a,b=0){0!==b&&q$7(1);b=v$6();if(!C$5(b)||!F$5(a))return b;let {anchor:c,focus:d}=b,e=c.getNode(),f=d.getNode();rc(e,a)&&c.set(a.__key,0,"element");rc(f,a)&&d.set(a.__key,0,"element");return b}function rc(a,b){for(a=a.getParent();null!==a;){if(a.is(b))return !0;a=a.getParent();}return !1}function Bb(a){a=a._window;null===a&&q$7(78);return a}
function sc(a){for(a=a.getParentOrThrow();null!==a&&!M$2(a);)a=a.getParentOrThrow();return a}function M$2(a){return L$5(a)||F$5(a)&&a.isShadowRoot()}function tc(a){a=a.constructor.clone(a);Tb(a,null);return a}function uc(a){var b=H$6();let c=a.constructor.getType();b=b._nodes.get(c);void 0===b&&q$7(97);b=b.replace;return null!==b?(b=b(a),b instanceof a.constructor||q$7(98),b):a}function vc(a,b){a=a.getParent();!L$5(a)||F$5(b)||z$7(b)||q$7(99);}function wc(a){return (z$7(a)||F$5(a)&&!a.canBeEmpty())&&!a.isInline()}
function xc(a,b,c){c.style.removeProperty("caret-color");b._blockCursorElement=null;b=a.parentElement;null!==b&&b.removeChild(a);}function E$6(a){return Ua?(a||window).getSelection():null}function yc(a,b){let c=a.getChildAtIndex(b);null==c&&(c=a);M$2(a)&&q$7(102);let d=g=>{const h=g.getParentOrThrow(),k=M$2(h),n=g!==c||k?tc(g):g;if(k)return g.insertAfter(n),[g,n,n];const [m,p,l]=d(h);g=g.getNextSiblings();l.append(n,...g);return [m,p,n]},[e,f]=d(c);return [e,f]}
function zc(a,b){for(;a!==bc()&&null!=a;){if(b(a))return a;a=a.getParent();}return null}function Ac(a){let b=[],c=[a];for(;0<c.length;){let d=c.pop();void 0===d&&q$7(112);F$5(d)&&c.unshift(...d.getChildren());d!==a&&b.push(d);}return b}function Bc(a,b,c,d,e){for(a=a.getFirstChild();null!==a;){let f=a.__key;void 0!==a&&a.__parent===b&&(F$5(a)&&Bc(a,f,c,d,e),c.has(f)||e.delete(f),d.delete(f));a=a.isAttached()?a.getNextSibling():null;}}
function Cc(a,b,c,d){a=a._nodeMap;b=b._nodeMap;for(let e of c){let f=b.get(e);void 0===f||f.isAttached()||(a.has(e)||c.delete(e),b.delete(e));}for(let [e]of d)c=b.get(e),void 0===c||c.isAttached()||(F$5(c)&&Bc(c,e,a,b,d),a.has(e)||d.delete(e),b.delete(e));}function Dc(a,b){let c=a.__mode,d=a.__format;a=a.__style;let e=b.__mode,f=b.__format;b=b.__style;return (null===c||c===e)&&(null===d||d===f)&&(null===a||a===b)}
function Ec(a,b){let c=a.mergeWithSibling(b),d=H$6()._normalizedNodes;d.add(a.__key);d.add(b.__key);return c}function Fc(a){if(""===a.__text&&a.isSimpleText()&&!a.isUnmergeable())a.remove();else {for(var b;null!==(b=a.getPreviousSibling())&&B$7(b)&&b.isSimpleText()&&!b.isUnmergeable();)if(""===b.__text)b.remove();else {Dc(b,a)&&(a=Ec(b,a));break}for(var c;null!==(c=a.getNextSibling())&&B$7(c)&&c.isSimpleText()&&!c.isUnmergeable();)if(""===c.__text)c.remove();else {Dc(a,c)&&Ec(a,c);break}}}
function Gc(a){Hc(a.anchor);Hc(a.focus);return a}function Hc(a){for(;"element"===a.type;){var b=a.getNode(),c=a.offset;c===b.getChildrenSize()?(b=b.getChildAtIndex(c-1),c=!0):(b=b.getChildAtIndex(c),c=!1);if(B$7(b)){a.set(b.__key,c?b.getTextContentSize():0,"text");break}else if(!F$5(b))break;a.set(b.__key,c?b.getChildrenSize():0,"element");}}let N$3="",O$4="",Ic="",Rc,R$4,Sc,Tc=!1,Uc=!1,Vc,Wc=null,Xc,Yc,Zc,$c,ad,bd;
function cd(a,b){let c=Zc.get(a);if(null!==b){let d=dd(a);d.parentNode===b&&b.removeChild(d);}$c.has(a)||R$4._keyToDOMMap.delete(a);F$5(c)&&(a=ed(c,Zc),fd(a,0,a.length-1,null));void 0!==c&&lc(bd,Sc,Vc,c,"destroyed");}function fd(a,b,c,d){for(;b<=c;++b){let e=a[b];void 0!==e&&cd(e,d);}}function gd(a,b){a.setProperty("text-align",b);}
function hd(a,b){var c=Rc.theme.indent;if("string"===typeof c){let d=a.classList.contains(c);0<b&&!d?a.classList.add(c):1>b&&d&&a.classList.remove(c);}c=getComputedStyle(a).getPropertyValue("--lexical-indent-base-value")||"40px";a.style.setProperty("padding-inline-start",0===b?"":`calc(${b} * ${c})`);}function id(a,b){a=a.style;0===b?gd(a,""):1===b?gd(a,"left"):2===b?gd(a,"center"):3===b?gd(a,"right"):4===b?gd(a,"justify"):5===b?gd(a,"start"):6===b&&gd(a,"end");}
function jd(a,b,c){let d=$c.get(a);void 0===d&&q$7(60);let e=d.createDOM(Rc,R$4);var f=R$4._keyToDOMMap;e["__lexicalKey_"+R$4._key]=a;f.set(a,e);B$7(d)?e.setAttribute("data-lexical-text","true"):z$7(d)&&e.setAttribute("data-lexical-decorator","true");if(F$5(d)){a=d.__indent;f=d.__size;0!==a&&hd(e,a);if(0!==f){--f;a=ed(d,$c);var g=O$4;O$4="";kd(a,d,0,f,e,null);ld(d,e);O$4=g;}a=d.__format;0!==a&&id(e,a);d.isInline()||md(null,d,e);oc(d)&&(N$3+="\n\n",Ic+="\n\n");}else f=d.getTextContent(),z$7(d)?(g=d.decorate(R$4,Rc),null!==g&&
nd(a,g),e.contentEditable="false"):B$7(d)&&(d.isDirectionless()||(O$4+=f)),N$3+=f,Ic+=f;null!==b&&(null!=c?b.insertBefore(e,c):(c=b.__lexicalLineBreak,null!=c?b.insertBefore(e,c):b.appendChild(e)));lc(bd,Sc,Vc,d,"created");return e}function kd(a,b,c,d,e,f){let g=N$3;for(N$3="";c<=d;++c)jd(a[c],e,f);oc(b)&&(N$3+="\n\n");e.__lexicalTextContent=N$3;N$3=g+N$3;}function od(a,b){a=b.get(a);return Sb(a)||z$7(a)&&a.isInline()}
function md(a,b,c){a=null!==a&&(0===a.__size||od(a.__last,Zc));b=0===b.__size||od(b.__last,$c);a?b||(b=c.__lexicalLineBreak,null!=b&&c.removeChild(b),c.__lexicalLineBreak=null):b&&(b=document.createElement("br"),c.__lexicalLineBreak=b,c.appendChild(b));}
function ld(a,b){var c=b.__lexicalDir;if(b.__lexicalDirTextContent!==O$4||c!==Wc){let f=""===O$4;if(f)var d=Wc;else d=O$4,d=db.test(d)?"rtl":eb.test(d)?"ltr":null;if(d!==c){let g=b.classList,h=Rc.theme;var e=null!==c?h[c]:void 0;let k=null!==d?h[d]:void 0;void 0!==e&&("string"===typeof e&&(e=e.split(" "),e=h[c]=e),g.remove(...e));null===d||f&&"ltr"===d?b.removeAttribute("dir"):(void 0!==k&&("string"===typeof k&&(c=k.split(" "),k=h[d]=c),void 0!==k&&g.add(...k)),b.dir=d);Uc||(a.getWritable().__dir=d);}Wc=
d;b.__lexicalDirTextContent=O$4;b.__lexicalDir=d;}}function ed(a,b){let c=[];for(a=a.__first;null!==a;){let d=b.get(a);void 0===d&&q$7(101);c.push(a);a=d.__next;}return c}
function pd(a,b){var c=Zc.get(a),d=$c.get(a);void 0!==c&&void 0!==d||q$7(61);var e=Tc||Yc.has(a)||Xc.has(a);let f=pc(R$4,a);if(c===d&&!e)return F$5(c)?(d=f.__lexicalTextContent,void 0!==d&&(N$3+=d,Ic+=d),d=f.__lexicalDirTextContent,void 0!==d&&(O$4+=d)):(d=c.getTextContent(),B$7(c)&&!c.isDirectionless()&&(O$4+=d),Ic+=d,N$3+=d),f;c!==d&&e&&lc(bd,Sc,Vc,d,"updated");if(d.updateDOM(c,f,Rc))return d=jd(a,null,null),null===b&&q$7(62),b.replaceChild(d,f),cd(a,null),d;if(F$5(c)&&F$5(d)){a=d.__indent;a!==c.__indent&&hd(f,a);a=
d.__format;a!==c.__format&&id(f,a);if(e){a=d;e=O$4;O$4="";b=N$3;var g=c.__size,h=a.__size;N$3="";if(1===g&&1===h){var k=c.__first,n=a.__first;if(k===n)pd(k,f);else {var m=dd(k);n=jd(n,null,null);f.replaceChild(n,m);cd(k,null);}}else {n=ed(c,Zc);var p=ed(a,$c);if(0===g)0!==h&&kd(p,a,0,h-1,f,null);else if(0===h)0!==g&&(k=null==f.__lexicalLineBreak,fd(n,0,g-1,k?null:f),k&&(f.textContent=""));else {var l=n;n=p;p=g-1;g=h-1;let u=f.firstChild,x=0;for(h=0;x<=p&&h<=g;){var r=l[x];let y=n[h];if(r===y)u=qd(pd(y,f)),x++,
h++;else {void 0===k&&(k=new Set(l));void 0===m&&(m=new Set(n));let A=m.has(r),aa=k.has(y);A?(aa?(r=pc(R$4,y),r===u?u=qd(pd(y,f)):(null!=u?f.insertBefore(r,u):f.appendChild(r),pd(y,f)),x++):jd(y,f,u),h++):(u=qd(dd(r)),cd(r,f),x++);}}k=x>p;m=h>g;k&&!m?(k=n[g+1],k=void 0===k?null:R$4.getElementByKey(k),kd(n,a,h,g,f,k)):m&&!k&&fd(l,x,p,f);}}oc(a)&&(N$3+="\n\n");f.__lexicalTextContent=N$3;N$3=b+N$3;ld(a,f);O$4=e;L$5(d)||d.isInline()||md(c,d,f);}oc(d)&&(N$3+="\n\n",Ic+="\n\n");}else c=d.getTextContent(),z$7(d)?(e=d.decorate(R$4,
Rc),null!==e&&nd(a,e)):B$7(d)&&!d.isDirectionless()&&(O$4+=c),N$3+=c,Ic+=c;!Uc&&L$5(d)&&d.__cachedText!==Ic&&(d=d.getWritable(),d.__cachedText=Ic);return f}function nd(a,b){let c=R$4._pendingDecorators,d=R$4._decorators;if(null===c){if(d[a]===b)return;c=$b(R$4);}c[a]=b;}function qd(a){a=a.nextSibling;null!==a&&a===R$4._blockCursorElement&&(a=a.nextSibling);return a}function dd(a){a=ad.get(a);void 0===a&&q$7(75);return a}
let rd=Object.freeze({}),yd=[["keydown",sd],["pointerdown",td],["compositionstart",ud],["compositionend",vd],["input",wd],["click",xd],["cut",rd],["copy",rd],["dragstart",rd],["dragover",rd],["dragend",rd],["paste",rd],["focus",rd],["blur",rd],["drop",rd]];Xa&&yd.push(["beforeinput",(a,b)=>zd(a,b)]);let Ad=0,Bd=0,Cd=0,Dd=null,Ed=0,Fd=!1,Gd=!1,Hd=!1,Id=!1,Jd=[0,"",0,"root",0];
function Kd(a,b,c,d,e){let f=a.anchor,g=a.focus,h=f.getNode();var k=H$6();let n=E$6(k._window),m=null!==n?n.anchorNode:null,p=f.key;k=k.getElementByKey(p);let l=c.length;return p!==g.key||!B$7(h)||(!e&&(!Xa||Cd<d+50)||h.isDirty()&&2>l||ec(c))&&f.offset!==g.offset&&!h.isComposing()||Ib(h)||h.isDirty()&&1<l||(e||!Xa)&&null!==k&&!h.isComposing()&&m!==Pb(k)||null!==n&&null!==b&&(!b.collapsed||b.startContainer!==n.anchorNode||b.startOffset!==n.anchorOffset)||h.getFormat()!==a.format||h.getStyle()!==a.style||
jc(a,h)}function Ld(a,b){return null!==a&&null!==a.nodeValue&&3===a.nodeType&&0!==b&&b!==a.nodeValue.length}
function Md(a,b,c){let {anchorNode:d,anchorOffset:e,focusNode:f,focusOffset:g}=a;if(Fd&&(Fd=!1,Ld(d,e)&&Ld(f,g)))return;w$6(b,()=>{if(!c)xb(null);else if(Fb(b,d,f)){var h=v$6();if(C$5(h)){var k=h.anchor,n=k.getNode();if(h.isCollapsed()){"Range"===a.type&&a.anchorNode===a.focusNode&&(h.dirty=!0);var m=Bb(b).event;m=m?m.timeStamp:performance.now();let [p,l,r,u,x]=Jd;m<x+200&&k.offset===r&&k.key===u?(h.format=p,h.style=l):"text"===k.type?(h.format=n.getFormat(),h.style=n.getStyle()):"element"===k.type&&(h.format=
0,h.style="");}else {k=255;n=!1;m=h.getNodes();let p=m.length;for(let l=0;l<p;l++){let r=m[l];if(B$7(r)&&(n=!0,k&=r.getFormat(),0===k))break}h.format=n?k:0;}}S$3(b,ca$3,void 0);}});}function xd(a,b){w$6(b,()=>{let c=v$6(),d=E$6(b._window),e=ic();if(C$5(c)){let f=c.anchor,g=f.getNode();d&&"element"===f.type&&0===f.offset&&c.isCollapsed()&&!L$5(g)&&1===bc().getChildrenSize()&&g.getTopLevelElementOrThrow().isEmpty()&&null!==e&&c.is(e)&&(d.removeAllRanges(),c.dirty=!0);}S$3(b,da$3,a);});}
function td(a,b){let c=a.target;a=a.pointerType;c instanceof Node&&"touch"!==a&&w$6(b,()=>{z$7(ub(c))||(Gd=!0);});}function Nd(a){if(!a.getTargetRanges)return null;a=a.getTargetRanges();return 0===a.length?null:a[0]}function Od(a,b){return a!==b||F$5(a)||F$5(b)||!a.isToken()||!b.isToken()}
function zd(a,b){let c=a.inputType,d=Nd(a);"deleteCompositionText"===c||Wa&&yb(b)||"insertCompositionText"!==c&&w$6(b,()=>{let e=v$6();if("deleteContentBackward"===c){if(null===e){var f=ic();if(!C$5(f))return;xb(f.clone());}if(C$5(e)){229===Bd&&a.timeStamp<Ad+30&&b.isComposing()&&e.anchor.key===e.focus.key?(I$5(null),Ad=0,setTimeout(()=>{w$6(b,()=>{I$5(null);});},30),C$5(e)&&(f=e.anchor.getNode(),f.markDirty(),e.format=f.getFormat(),e.style=f.getStyle())):(a.preventDefault(),S$3(b,ea$3,!0));return}}if(C$5(e)){f=a.data;null!==
Dd&&hc(!1,b,Dd);e.dirty&&null===Dd||!e.isCollapsed()||L$5(e.anchor.getNode())||null===d||e.applyDOMRange(d);Dd=null;var g=e.focus,h=e.anchor.getNode();g=g.getNode();if("insertText"===c||"insertTranspose"===c)"\n"===f?(a.preventDefault(),S$3(b,fa$3,!1)):"\n\n"===f?(a.preventDefault(),S$3(b,ja$1,void 0)):null==f&&a.dataTransfer?(f=a.dataTransfer.getData("text/plain"),a.preventDefault(),e.insertRawText(f)):null!=f&&Kd(e,d,f,a.timeStamp,!0)?(a.preventDefault(),S$3(b,ka$1,f)):Dd=f,Cd=a.timeStamp;else switch(a.preventDefault(),
c){case "insertFromYank":case "insertFromDrop":case "insertReplacementText":S$3(b,ka$1,a);break;case "insertFromComposition":I$5(null);S$3(b,ka$1,a);break;case "insertLineBreak":I$5(null);S$3(b,fa$3,!1);break;case "insertParagraph":I$5(null);Hd?(Hd=!1,S$3(b,fa$3,!1)):S$3(b,ja$1,void 0);break;case "insertFromPaste":case "insertFromPasteAsQuotation":S$3(b,la$1,a);break;case "deleteByComposition":Od(h,g)&&S$3(b,na$1,void 0);break;case "deleteByDrag":case "deleteByCut":S$3(b,na$1,void 0);break;case "deleteContent":S$3(b,ea$3,!1);break;case "deleteWordBackward":S$3(b,
qa$1,!0);break;case "deleteWordForward":S$3(b,qa$1,!1);break;case "deleteHardLineBackward":case "deleteSoftLineBackward":S$3(b,ra$1,!0);break;case "deleteContentForward":case "deleteHardLineForward":case "deleteSoftLineForward":S$3(b,ra$1,!1);break;case "formatStrikeThrough":S$3(b,sa$1,"strikethrough");break;case "formatBold":S$3(b,sa$1,"bold");break;case "formatItalic":S$3(b,sa$1,"italic");break;case "formatUnderline":S$3(b,sa$1,"underline");break;case "historyUndo":S$3(b,ta$1,void 0);break;case "historyRedo":S$3(b,ua,void 0);}}});}
function wd(a,b){a.stopPropagation();w$6(b,()=>{var c=v$6(),d=a.data,e=Nd(a);if(null!=d&&C$5(c)&&Kd(c,e,d,a.timeStamp,!1)){Id&&(Pd(b,d),Id=!1);var f=c.anchor,g=f.getNode();e=E$6(b._window);if(null===e)return;let h=f.offset;if(f=Xa&&!c.isCollapsed()&&B$7(g)&&null!==e.anchorNode)g=g.getTextContent().slice(0,h)+d+g.getTextContent().slice(h+c.focus.offset),e=e.anchorNode,f=g===(3===e.nodeType?e.nodeValue:null);f||S$3(b,ka$1,d);d=d.length;Wa&&1<d&&"insertCompositionText"===a.inputType&&!b.isComposing()&&(c.anchor.offset-=
d);Ya||Za||ab||!b.isComposing()||(Ad=0,I$5(null));}else hc(!1,b,null!==d?d:void 0),Id&&(Pd(b,d||void 0),Id=!1);G$4();c=H$6();zb(c);});Dd=null;}function ud(a,b){w$6(b,()=>{let c=v$6();if(C$5(c)&&!b.isComposing()){let d=c.anchor,e=c.anchor.getNode();I$5(d.key);(a.timeStamp<Ad+30||"element"===d.type||!c.isCollapsed()||e.getFormat()!==c.format||e.getStyle()!==c.style)&&S$3(b,ka$1,cb);}});}
function Pd(a,b){var c=a._compositionKey;I$5(null);if(null!==c&&null!=b){if(""===b){b=J$5(c);a=Pb(a.getElementByKey(c));null!==a&&null!==a.nodeValue&&B$7(b)&&vb(b,a.nodeValue,null,null,!0);return}if("\n"===b[b.length-1]&&(c=v$6(),C$5(c))){b=c.focus;c.anchor.set(b.key,b.offset,b.type);S$3(a,Da$1,null);return}}hc(!0,a,b);}function vd(a,b){Wa?Id=!0:w$6(b,()=>{Pd(b,a.data);});}
function sd(a,b){Ad=a.timeStamp;Bd=a.keyCode;if(!b.isComposing()){var {keyCode:c,shiftKey:d,ctrlKey:e,metaKey:f,altKey:g}=a;if(!S$3(b,wa$1,a)){if(39!==c||e||f||g)if(39!==c||g||d||!e&&!f)if(37!==c||e||f||g)if(37!==c||g||d||!e&&!f)if(38!==c||e||f)if(40!==c||e||f)if(13===c&&d)Hd=!0,S$3(b,Da$1,a);else if(32===c)S$3(b,Ga,a);else if(t$7&&e&&79===c)a.preventDefault(),Hd=!0,S$3(b,fa$3,!0);else if(13!==c||d)if(t$7?g||f?0:8===c||72===c&&e:e||g||f?0:8===c)8===c?S$3(b,Ha,a):(a.preventDefault(),S$3(b,ea$3,!0));else if(27===c)S$3(b,Ia,
a);else if(t$7?d||g||f?0:46===c||68===c&&e:e||g||f?0:46===c)46===c?S$3(b,Ja,a):(a.preventDefault(),S$3(b,ea$3,!1));else if(8===c&&(t$7?g:e))a.preventDefault(),S$3(b,qa$1,!0);else if(46===c&&(t$7?g:e))a.preventDefault(),S$3(b,qa$1,!1);else if(t$7&&f&&8===c)a.preventDefault(),S$3(b,ra$1,!0);else if(t$7&&f&&46===c)a.preventDefault(),S$3(b,ra$1,!1);else if(66===c&&!g&&(t$7?f:e))a.preventDefault(),S$3(b,sa$1,"bold");else if(85===c&&!g&&(t$7?f:e))a.preventDefault(),S$3(b,sa$1,"underline");else if(73===c&&!g&&(t$7?f:e))a.preventDefault(),S$3(b,sa$1,"italic");
else if(9!==c||g||e||f)if(90===c&&!d&&(t$7?f:e))a.preventDefault(),S$3(b,ta$1,void 0);else {var h=t$7?90===c&&f&&d:89===c&&e||90===c&&e&&d;h?(a.preventDefault(),S$3(b,ua,void 0)):Qd(b._editorState._selection)&&(h=d?!1:67===c?t$7?f:e:!1,h?(a.preventDefault(),S$3(b,Pa,a)):(h=d?!1:88===c?t$7?f:e:!1,h?(a.preventDefault(),S$3(b,Qa,a)):65===c&&(t$7?f:e)&&(a.preventDefault(),b.update(()=>{let k=bc();k.select(0,k.getChildrenSize());}))));}else S$3(b,Ka,a);else Hd=!1,S$3(b,Da$1,a);else S$3(b,Ca$1,a);else S$3(b,Ba$1,a);else S$3(b,Aa$1,a);else S$3(b,
za$1,a);else S$3(b,ya$1,a);else S$3(b,xa$1,a);(e||d||g||f)&&S$3(b,Ta,a);}}}function Rd(a){let b=a.__lexicalEventHandles;void 0===b&&(b=[],a.__lexicalEventHandles=b);return b}let Sd=new Map;
function Td(a){a=a.target;let b=E$6(null==a?null:9===a.nodeType?a.defaultView:a.ownerDocument.defaultView);if(null!==b){var c=Gb(b.anchorNode);if(null!==c){Gd&&(Gd=!1,w$6(c,()=>{var g=ic(),h=b.anchorNode;null!==h&&(h=h.nodeType,1===h||3===h)&&(g=Ud(g,b,c),xb(g));}));a=fc(c);a=a[a.length-1];var d=a._key,e=Sd.get(d),f=e||a;f!==c&&Md(b,f,!1);Md(b,c,!0);c!==a?Sd.set(d,c):e&&Sd.delete(d);}}}
function Vd(a,b){0===Ed&&a.ownerDocument.addEventListener("selectionchange",Td);Ed++;a.__lexicalEditor=b;let c=Rd(a);for(let d=0;d<yd.length;d++){let [e,f]=yd[d],g="function"===typeof f?h=>{!0!==h._lexicalHandled&&(h._lexicalHandled=!0,b.isEditable()&&f(h,b));}:h=>{if(!0!==h._lexicalHandled&&(h._lexicalHandled=!0,b.isEditable()))switch(e){case "cut":return S$3(b,Qa,h);case "copy":return S$3(b,Pa,h);case "paste":return S$3(b,la$1,h);case "dragstart":return S$3(b,Ma,h);case "dragover":return S$3(b,Na,h);case "dragend":return S$3(b,
Oa,h);case "focus":return S$3(b,Ra,h);case "blur":return S$3(b,Sa,h);case "drop":return S$3(b,La,h)}};a.addEventListener(e,g);c.push(()=>{a.removeEventListener(e,g);});}}
function Wd(a,b,c){G$4();var d=a.__key;let e=a.getParent();if(null!==e){var f=qc(a),g=!1;if(C$5(f)&&b){let h=f.anchor,k=f.focus;h.key===d&&(Xd(h,a,e,a.getPreviousSibling(),a.getNextSibling()),g=!0);k.key===d&&(Xd(k,a,e,a.getPreviousSibling(),a.getNextSibling()),g=!0);}C$5(f)&&b&&!g?(d=a.getIndexWithinParent(),Wb(a),Yd(f,e,d,-1)):Wb(a);c||M$2(e)||e.canBeEmpty()||!e.isEmpty()||Wd(e,b);b&&L$5(e)&&e.isEmpty()&&e.selectEnd();}}
class Zd{static getType(){q$7(64);}static clone(){q$7(65);}constructor(a){this.__type=this.constructor.getType();this.__next=this.__prev=this.__parent=null;Tb(this,a);}getType(){return this.__type}isAttached(){for(var a=this.__key;null!==a;){if("root"===a)return !0;a=J$5(a);if(null===a)break;a=a.__parent;}return !1}isSelected(a){a=a||v$6();if(null==a)return !1;let b=a.getNodes().some(c=>c.__key===this.__key);return B$7(this)?b:C$5(a)&&"element"===a.anchor.type&&"element"===a.focus.type&&a.anchor.key===a.focus.key&&
a.anchor.offset===a.focus.offset?!1:b}getKey(){return this.__key}getIndexWithinParent(){var a=this.getParent();if(null===a)return -1;a=a.getFirstChild();let b=0;for(;null!==a;){if(this.is(a))return b;b++;a=a.getNextSibling();}return -1}getParent(){let a=this.getLatest().__parent;return null===a?null:J$5(a)}getParentOrThrow(){let a=this.getParent();null===a&&q$7(66);return a}getTopLevelElement(){let a=this;for(;null!==a;){let b=a.getParent();if(M$2(b))return a;a=b;}return null}getTopLevelElementOrThrow(){let a=
this.getTopLevelElement();null===a&&q$7(67);return a}getParents(){let a=[],b=this.getParent();for(;null!==b;)a.push(b),b=b.getParent();return a}getParentKeys(){let a=[],b=this.getParent();for(;null!==b;)a.push(b.__key),b=b.getParent();return a}getPreviousSibling(){let a=this.getLatest().__prev;return null===a?null:J$5(a)}getPreviousSiblings(){let a=[];var b=this.getParent();if(null===b)return a;for(b=b.getFirstChild();null!==b&&!b.is(this);)a.push(b),b=b.getNextSibling();return a}getNextSibling(){let a=
this.getLatest().__next;return null===a?null:J$5(a)}getNextSiblings(){let a=[],b=this.getNextSibling();for(;null!==b;)a.push(b),b=b.getNextSibling();return a}getCommonAncestor(a){let b=this.getParents();var c=a.getParents();F$5(this)&&b.unshift(this);F$5(a)&&c.unshift(a);a=b.length;var d=c.length;if(0===a||0===d||b[a-1]!==c[d-1])return null;c=new Set(c);for(d=0;d<a;d++){let e=b[d];if(c.has(e))return e}return null}is(a){return null==a?!1:this.__key===a.__key}isBefore(a){if(this===a)return !1;if(a.isParentOf(this))return !0;
if(this.isParentOf(a))return !1;var b=this.getCommonAncestor(a);let c=this;for(;;){var d=c.getParentOrThrow();if(d===b){d=c.getIndexWithinParent();break}c=d;}for(c=a;;){a=c.getParentOrThrow();if(a===b){b=c.getIndexWithinParent();break}c=a;}return d<b}isParentOf(a){let b=this.__key;if(b===a.__key)return !1;for(;null!==a;){if(a.__key===b)return !0;a=a.getParent();}return !1}getNodesBetween(a){let b=this.isBefore(a),c=[],d=new Set;for(var e=this;;){var f=e.__key;d.has(f)||(d.add(f),c.push(e));if(e===a)break;
f=F$5(e)?b?e.getFirstChild():e.getLastChild():null;if(null!==f)e=f;else if(f=b?e.getNextSibling():e.getPreviousSibling(),null!==f)e=f;else {e=e.getParentOrThrow();d.has(e.__key)||c.push(e);if(e===a)break;f=e;do null===f&&q$7(68),e=b?f.getNextSibling():f.getPreviousSibling(),f=f.getParent(),null!==f&&(null!==e||d.has(f.__key)||c.push(f));while(null===e)}}b||c.reverse();return c}isDirty(){let a=H$6()._dirtyLeaves;return null!==a&&a.has(this.__key)}getLatest(){let a=J$5(this.__key);null===a&&q$7(113);return a}getWritable(){G$4();
var a=Vb(),b=H$6();a=a._nodeMap;let c=this.__key,d=this.getLatest(),e=d.__parent;b=b._cloneNotNeeded;var f=v$6();null!==f&&(f._cachedNodes=null);if(b.has(c))return Xb(d),d;f=d.constructor.clone(d);f.__parent=e;f.__next=d.__next;f.__prev=d.__prev;F$5(d)&&F$5(f)?(f.__first=d.__first,f.__last=d.__last,f.__size=d.__size,f.__indent=d.__indent,f.__format=d.__format,f.__dir=d.__dir):B$7(d)&&B$7(f)&&(f.__format=d.__format,f.__style=d.__style,f.__mode=d.__mode,f.__detail=d.__detail);b.add(c);f.__key=c;Xb(f);a.set(c,f);
return f}getTextContent(){return ""}getTextContentSize(){return this.getTextContent().length}createDOM(){q$7(70);}updateDOM(){q$7(71);}exportDOM(a){return {element:this.createDOM(a._config,a)}}exportJSON(){q$7(72);}static importJSON(){q$7(18);}static transform(){return null}remove(a){Wd(this,!0,a);}replace(a,b){G$4();var c=v$6();null!==c&&(c=c.clone());vc(this,a);let d=this.getLatest(),e=this.__key,f=a.__key,g=a.getWritable();a=this.getParentOrThrow().getWritable();let h=a.__size;Wb(g);let k=d.getPreviousSibling(),
n=d.getNextSibling(),m=d.__prev,p=d.__next,l=d.__parent;Wd(d,!1,!0);null===k?a.__first=f:k.getWritable().__next=f;g.__prev=m;null===n?a.__last=f:n.getWritable().__prev=f;g.__next=p;g.__parent=l;a.__size=h;b&&this.getChildren().forEach(r=>{g.append(r);});C$5(c)&&(xb(c),b=c.anchor,c=c.focus,b.key===e&&$d(b,g),c.key===e&&$d(c,g));Yb()===e&&I$5(f);return g}insertAfter(a,b=!0){G$4();vc(this,a);var c=this.getWritable();let d=a.getWritable();var e=d.getParent();let f=v$6();var g=!1,h=!1;if(null!==e){var k=a.getIndexWithinParent();
Wb(d);C$5(f)&&(h=e.__key,g=f.anchor,e=f.focus,g="element"===g.type&&g.key===h&&g.offset===k+1,h="element"===e.type&&e.key===h&&e.offset===k+1);}e=this.getNextSibling();k=this.getParentOrThrow().getWritable();let n=d.__key,m=c.__next;null===e?k.__last=n:e.getWritable().__prev=n;k.__size++;c.__next=n;d.__next=m;d.__prev=c.__key;d.__parent=c.__parent;b&&C$5(f)&&(b=this.getIndexWithinParent(),Yd(f,k,b+1),c=k.__key,g&&f.anchor.set(c,b+2,"element"),h&&f.focus.set(c,b+2,"element"));return a}insertBefore(a,b=
!0){G$4();vc(this,a);var c=this.getWritable();let d=a.getWritable(),e=d.__key;Wb(d);let f=this.getPreviousSibling(),g=this.getParentOrThrow().getWritable(),h=c.__prev,k=this.getIndexWithinParent();null===f?g.__first=e:f.getWritable().__next=e;g.__size++;c.__prev=e;d.__prev=h;d.__next=c.__key;d.__parent=c.__parent;c=v$6();b&&C$5(c)&&(b=this.getParentOrThrow(),Yd(c,b,k));return a}isParentRequired(){return !1}createParentElementNode(){return ae()}selectPrevious(a,b){G$4();let c=this.getPreviousSibling(),d=this.getParentOrThrow();
return null===c?d.select(0,0):F$5(c)?c.select():B$7(c)?c.select(a,b):(a=c.getIndexWithinParent()+1,d.select(a,a))}selectNext(a,b){G$4();let c=this.getNextSibling(),d=this.getParentOrThrow();return null===c?d.select():F$5(c)?c.select(0,0):B$7(c)?c.select(a,b):(a=c.getIndexWithinParent(),d.select(a,a))}markDirty(){this.getWritable();}}
class be{constructor(a,b,c){this._selection=null;this.key=a;this.offset=b;this.type=c;}is(a){return this.key===a.key&&this.offset===a.offset&&this.type===a.type}isBefore(a){let b=this.getNode(),c=a.getNode(),d=this.offset;a=a.offset;if(F$5(b)){var e=b.getDescendantByIndex(d);b=null!=e?e:b;}F$5(c)&&(e=c.getDescendantByIndex(a),c=null!=e?e:c);return b===c?d<a:b.isBefore(c)}getNode(){let a=J$5(this.key);null===a&&q$7(20);return a}set(a,b,c){let d=this._selection,e=this.key;this.key=a;this.offset=b;this.type=c;
Zb()||(Yb()===e&&I$5(a),null!==d&&(d._cachedNodes=null,d.dirty=!0));}}function ce(a,b){let c=b.__key,d=a.offset,e="element";if(B$7(b))e="text",b=b.getTextContentSize(),d>b&&(d=b);else if(!F$5(b)){var f=b.getNextSibling();if(B$7(f))c=f.__key,d=0,e="text";else if(f=b.getParent())c=f.__key,d=b.getIndexWithinParent()+1;}a.set(c,d,e);}function $d(a,b){if(F$5(b)){let c=b.getLastDescendant();F$5(c)||B$7(c)?ce(a,c):ce(a,b);}else ce(a,b);}
function de(a,b,c,d){let e=a.getNode(),f=e.getChildAtIndex(a.offset),g=K$5(),h=L$5(e)?ae().append(g):g;g.setFormat(c);g.setStyle(d);null===f?e.append(h):f.insertBefore(h);a.is(b)&&b.set(g.__key,0,"text");a.set(g.__key,0,"text");}function ee(a,b,c,d){a.key=b;a.offset=c;a.type=d;}
class fe{constructor(a){this.dirty=!1;this._nodes=a;this._cachedNodes=null;}is(a){if(!Qd(a))return !1;let b=this._nodes,c=a._nodes;return b.size===c.size&&Array.from(b).every(d=>c.has(d))}add(a){this.dirty=!0;this._nodes.add(a);this._cachedNodes=null;}delete(a){this.dirty=!0;this._nodes.delete(a);this._cachedNodes=null;}clear(){this.dirty=!0;this._nodes.clear();this._cachedNodes=null;}has(a){return this._nodes.has(a)}clone(){return new fe(new Set(this._nodes))}extract(){return this.getNodes()}insertRawText(){}insertText(){}insertNodes(a,
b){let c=this.getNodes(),d=c.length;var e=c[d-1];if(B$7(e))e=e.select();else {let f=e.getIndexWithinParent()+1;e=e.getParentOrThrow().select(f,f);}e.insertNodes(a,b);for(a=0;a<d;a++)c[a].remove();return !0}getNodes(){var a=this._cachedNodes;if(null!==a)return a;var b=this._nodes;a=[];for(let c of b)b=J$5(c),null!==b&&a.push(b);Zb()||(this._cachedNodes=a);return a}getTextContent(){let a=this.getNodes(),b="";for(let c=0;c<a.length;c++)b+=a[c].getTextContent();return b}}
function C$5(a){return a instanceof ge}
class he{constructor(a,b,c){this.gridKey=a;this.anchor=b;this.focus=c;this.dirty=!1;this._cachedNodes=null;b._selection=this;c._selection=this;}is(a){return ie(a)?this.gridKey===a.gridKey&&this.anchor.is(a.anchor)&&this.focus.is(a.focus):!1}set(a,b,c){this.dirty=!0;this.gridKey=a;this.anchor.key=b;this.focus.key=c;this._cachedNodes=null;}clone(){return new he(this.gridKey,this.anchor,this.focus)}isCollapsed(){return !1}isBackward(){return this.focus.isBefore(this.anchor)}getCharacterOffsets(){return je(this)}extract(){return this.getNodes()}insertRawText(){}insertText(){}insertNodes(a,b){let c=
this.focus.getNode();return Gc(c.select(0,c.getChildrenSize())).insertNodes(a,b)}getShape(){var a=J$5(this.anchor.key);null===a&&q$7(21);var b=a.getIndexWithinParent();a=a.getParentOrThrow().getIndexWithinParent();var c=J$5(this.focus.key);null===c&&q$7(22);var d=c.getIndexWithinParent();let e=c.getParentOrThrow().getIndexWithinParent();c=Math.min(b,d);b=Math.max(b,d);d=Math.min(a,e);a=Math.max(a,e);return {fromX:Math.min(c,b),fromY:Math.min(d,a),toX:Math.max(c,b),toY:Math.max(d,a)}}getNodes(){function a(x){let {cell:y,
startColumn:A,startRow:aa}=x;h=Math.min(h,A);k=Math.min(k,aa);n=Math.max(n,A+y.__colSpan-1);m=Math.max(m,aa+y.__rowSpan-1);}var b=this._cachedNodes;if(null!==b)return b;var c=this.anchor.getNode();b=this.focus.getNode();c=zc(c,ke);var d=zc(b,ke);ke(c)||q$7(103);ke(d)||q$7(104);b=c.getParent();le(b)||q$7(105);b=b.getParent();me(b)||q$7(106);let [e,f,g]=ne(b,c,d),h=Math.min(f.startColumn,g.startColumn),k=Math.min(f.startRow,g.startRow),n=Math.max(f.startColumn+f.cell.__colSpan-1,g.startColumn+g.cell.__colSpan-
1),m=Math.max(f.startRow+f.cell.__rowSpan-1,g.startRow+g.cell.__rowSpan-1);c=h;d=k;for(var p=h,l=k;h<c||k<d||n>p||m>l;){if(h<c){var r=l-d;--c;for(var u=0;u<=r;u++)a(e[d+u][c]);}if(k<d)for(r=p-c,--d,u=0;u<=r;u++)a(e[d][c+u]);if(n>p)for(r=l-d,p+=1,u=0;u<=r;u++)a(e[d+u][p]);if(m>l)for(r=p-c,l+=1,u=0;u<=r;u++)a(e[l][c+u]);}b=[b];c=null;for(d=k;d<=m;d++)for(p=h;p<=n;p++)(({cell:l}=e[d][p])),r=l.getParent(),le(r)||q$7(107),r!==c&&b.push(r),b.push(l,...Ac(l)),c=r;Zb()||(this._cachedNodes=b);return b}getTextContent(){let a=
this.getNodes(),b="";for(let c=0;c<a.length;c++)b+=a[c].getTextContent();return b}}function ie(a){return a instanceof he}
class ge{constructor(a,b,c,d){this.anchor=a;this.focus=b;this.dirty=!1;this.format=c;this.style=d;this._cachedNodes=null;a._selection=this;b._selection=this;}is(a){return C$5(a)?this.anchor.is(a.anchor)&&this.focus.is(a.focus)&&this.format===a.format&&this.style===a.style:!1}isBackward(){return this.focus.isBefore(this.anchor)}isCollapsed(){return this.anchor.is(this.focus)}getNodes(){var a=this._cachedNodes;if(null!==a)return a;a=this.anchor;var b=this.focus,c=a.isBefore(b),d=c?a:b;c=c?b:a;a=d.getNode();
b=c.getNode();let e=d.offset;d=c.offset;F$5(a)&&(c=a.getDescendantByIndex(e),a=null!=c?c:a);F$5(b)&&(c=b.getDescendantByIndex(d),null!==c&&c!==a&&b.getChildAtIndex(d)===c&&(c=c.getPreviousSibling()),b=null!=c?c:b);a=a.is(b)?F$5(a)&&0<a.getChildrenSize()?[]:[a]:a.getNodesBetween(b);Zb()||(this._cachedNodes=a);return a}setTextNodeRange(a,b,c,d){ee(this.anchor,a.__key,b,"text");ee(this.focus,c.__key,d,"text");this._cachedNodes=null;this.dirty=!0;}getTextContent(){let a=this.getNodes();if(0===a.length)return "";
let b=a[0],c=a[a.length-1],d=this.anchor,e=this.focus,f=d.isBefore(e),[g,h]=je(this),k="",n=!0;for(let m=0;m<a.length;m++){let p=a[m];if(F$5(p)&&!p.isInline())n||(k+="\n"),n=p.isEmpty()?!1:!0;else if(n=!1,B$7(p)){let l=p.getTextContent();if(p===b)if(p===c){if("element"!==d.type||"element"!==e.type||e.offset===d.offset)l=g<h?l.slice(g,h):l.slice(h,g);}else l=f?l.slice(g):l.slice(h);else p===c&&(l=f?l.slice(0,h):l.slice(0,g));k+=l;}else !z$7(p)&&!Sb(p)||p===c&&this.isCollapsed()||(k+=p.getTextContent());}return k}applyDOMRange(a){let b=
H$6(),c=b.getEditorState()._selection;a=oe(a.startContainer,a.startOffset,a.endContainer,a.endOffset,b,c);if(null!==a){var [d,e]=a;ee(this.anchor,d.key,d.offset,d.type);ee(this.focus,e.key,e.offset,e.type);this._cachedNodes=null;}}clone(){let a=this.anchor,b=this.focus;return new ge(new be(a.key,a.offset,a.type),new be(b.key,b.offset,b.type),this.format,this.style)}toggleFormat(a){this.format=Qb(this.format,a,null);this.dirty=!0;}setStyle(a){this.style=a;this.dirty=!0;}hasFormat(a){return 0!==(this.format&
fb[a])}insertRawText(a){let b=a.split(/\r?\n/);if(1===b.length)this.insertText(a);else {a=[];let c=b.length;for(let d=0;d<c;d++){let e=b[d];""!==e&&a.push(K$5(e));d!==c-1&&a.push(pe());}this.insertNodes(a);}}insertText(a){var b=this.anchor,c=this.focus,d=this.isCollapsed()||b.isBefore(c),e=this.format,f=this.style;d&&"element"===b.type?de(b,c,e,f):d||"element"!==c.type||de(c,b,e,f);var g=this.getNodes(),h=g.length,k=d?c:b;c=(d?b:c).offset;var n=k.offset;b=g[0];B$7(b)||q$7(26);d=b.getTextContent().length;var m=
b.getParentOrThrow(),p=g[h-1];if(this.isCollapsed()&&c===d&&(b.isSegmented()||b.isToken()||!b.canInsertTextAfter()||!m.canInsertTextAfter()&&null===b.getNextSibling())){var l=b.getNextSibling();if(!B$7(l)||Ib(l))l=K$5(),l.setFormat(e),m.canInsertTextAfter()?b.insertAfter(l):m.insertAfter(l);l.select(0,0);b=l;if(""!==a){this.insertText(a);return}}else if(this.isCollapsed()&&0===c&&(b.isSegmented()||b.isToken()||!b.canInsertTextBefore()||!m.canInsertTextBefore()&&null===b.getPreviousSibling())){l=b.getPreviousSibling();
if(!B$7(l)||Ib(l))l=K$5(),l.setFormat(e),m.canInsertTextBefore()?b.insertBefore(l):m.insertBefore(l);l.select();b=l;if(""!==a){this.insertText(a);return}}else if(b.isSegmented()&&c!==d)m=K$5(b.getTextContent()),m.setFormat(e),b.replace(m),b=m;else if(!(this.isCollapsed()||""===a||(l=p.getParent(),m.canInsertTextBefore()&&m.canInsertTextAfter()&&(!F$5(l)||l.canInsertTextBefore()&&l.canInsertTextAfter())))){this.insertText("");qe(this.anchor,this.focus,null);this.insertText(a);return}if(1===h)if(b.isToken())a=
K$5(a),a.select(),b.replace(a);else {g=b.getFormat();h=b.getStyle();if(c===n&&(g!==e||h!==f))if(""===b.getTextContent())b.setFormat(e),b.setStyle(f);else {g=K$5(a);g.setFormat(e);g.setStyle(f);g.select();0===c?b.insertBefore(g,!1):([h]=b.splitText(c),h.insertAfter(g,!1));g.isComposing()&&"text"===this.anchor.type&&(this.anchor.offset-=a.length);return}b=b.spliceText(c,n-c,a,!0);""===b.getTextContent()?b.remove():"text"===this.anchor.type&&(b.isComposing()?this.anchor.offset-=a.length:(this.format=g,this.style=
h));}else {e=new Set([...b.getParentKeys(),...p.getParentKeys()]);l=F$5(b)?b:b.getParentOrThrow();f=F$5(p)?p:p.getParentOrThrow();m=p;if(!l.is(f)&&f.isInline()){do m=f,f=f.getParentOrThrow();while(f.isInline())}"text"===k.type&&(0!==n||""===p.getTextContent())||"element"===k.type&&p.getIndexWithinParent()<n?B$7(p)&&!p.isToken()&&n!==p.getTextContentSize()?(p.isSegmented()&&(k=K$5(p.getTextContent()),p.replace(k),p=k),p=p.spliceText(0,n,""),e.add(p.__key)):(k=p.getParentOrThrow(),k.canBeEmpty()||1!==k.getChildrenSize()?
p.remove():k.remove()):e.add(p.__key);k=f.getChildren();n=new Set(g);p=l.is(f);l=l.isInline()&&null===b.getNextSibling()?l:b;for(let r=k.length-1;0<=r;r--){let u=k[r];if(u.is(b)||F$5(u)&&u.isParentOf(b))break;u.isAttached()&&(!n.has(u)||u.is(m)?p||l.insertAfter(u,!1):u.remove());}if(!p)for(k=f,n=null;null!==k;){f=k.getChildren();p=f.length;if(0===p||f[p-1].is(n))e.delete(k.__key),n=k;k=k.getParent();}b.isToken()?c===d?b.select():(a=K$5(a),a.select(),b.replace(a)):(b=b.spliceText(c,d-c,a,!0),""===b.getTextContent()?
b.remove():b.isComposing()&&"text"===this.anchor.type&&(this.anchor.offset-=a.length));for(a=1;a<h;a++)b=g[a],e.has(b.__key)||b.remove();}}removeText(){this.insertText("");}formatText(a){if(this.isCollapsed())this.toggleFormat(a),I$5(null);else {var b=this.getNodes(),c=[];for(var d of b)B$7(d)&&c.push(d);var e=c.length;if(0===e)this.toggleFormat(a),I$5(null);else {d=this.anchor;var f=this.focus,g=this.isBackward();b=g?f:d;d=g?d:f;var h=0,k=c[0];f="element"===b.type?0:b.offset;"text"===b.type&&f===k.getTextContentSize()&&
(h=1,k=c[1],f=0);if(null!=k){g=k.getFormatFlags(a,null);var n=e-1,m=c[n];e="text"===d.type?d.offset:m.getTextContentSize();if(k.is(m))f!==e&&(0===f&&e===k.getTextContentSize()?k.setFormat(g):(a=k.splitText(f,e),a=0===f?a[0]:a[1],a.setFormat(g),"text"===b.type&&b.set(a.__key,0,"text"),"text"===d.type&&d.set(a.__key,e-f,"text")),this.format=g);else {0!==f&&([,k]=k.splitText(f),f=0);k.setFormat(g);var p=m.getFormatFlags(a,g);0<e&&(e!==m.getTextContentSize()&&([m]=m.splitText(e)),m.setFormat(p));for(h+=
1;h<n;h++){let l=c[h];if(!l.isToken()){let r=l.getFormatFlags(a,p);l.setFormat(r);}}"text"===b.type&&b.set(k.__key,f,"text");"text"===d.type&&d.set(m.__key,e,"text");this.format=g|p;}}}}}insertNodes(a,b){if(!this.isCollapsed()){var c=this.isBackward()?this.anchor:this.focus,d=c.getNode().getNextSibling();d=d?d.getKey():null;c=(c=c.getNode().getPreviousSibling())?c.getKey():null;this.removeText();if(this.isCollapsed()&&"element"===this.focus.type){if(this.focus.key===d&&0===this.focus.offset){var e=
K$5();this.focus.getNode().insertBefore(e);}else this.focus.key===c&&this.focus.offset===this.focus.getNode().getChildrenSize()&&(e=K$5(),this.focus.getNode().insertAfter(e));e&&(this.focus.set(e.__key,0,"text"),this.anchor.set(e.__key,0,"text"));}}e=this.anchor;c=e.offset;var f=e.getNode();d=f;"element"===e.type&&(e=e.getNode(),d=e.getChildAtIndex(c-1),d=null===d?e:d);e=[];var g=f.getNextSiblings(),h=M$2(f)?null:f.getTopLevelElementOrThrow();if(B$7(f))if(d=f.getTextContent().length,0===c&&0!==d)d=f.getPreviousSibling(),
d=null!==d?d:f.getParentOrThrow(),e.push(f);else if(c===d)d=f;else {if(f.isToken())return !1;[d,f]=f.splitText(c);e.push(f);}f=d;e.push(...g);g=a[0];var k=!1,n=null;for(let r=0;r<a.length;r++){var m=a[r];if(M$2(d)||z$7(d)||!F$5(m)||m.isInline())k&&!F$5(m)&&!z$7(m)&&M$2(d.getParent())&&q$7(28);else {if(m.is(g)){if(F$5(d)&&d.isEmpty()&&d.canReplaceWith(m)){d.replace(m);d=m;k=!0;continue}k=m.getFirstDescendant();if(Rb(k)){for(var p=k.getParentOrThrow();p.isInline();)p=p.getParentOrThrow();n=p.getChildren();k=n.length;if(F$5(d)){var l=
d.getFirstChild();for(let u=0;u<k;u++){let x=n[u];null===l?d.append(x):l.insertAfter(x);l=x;}}else {for(l=k-1;0<=l;l--)d.insertAfter(n[l]);d=d.getParentOrThrow();}n=n[k-1];p.remove();k=!0;if(p.is(m))continue}}B$7(d)&&(null===h&&q$7(27),d=h);}k=!1;if(F$5(d)&&!d.isInline())if(n=m,z$7(m)&&!m.isInline())d=d.insertAfter(m,!1);else if(F$5(m)){if(m.canBeEmpty()||!m.isEmpty())L$5(d)?(p=d.getChildAtIndex(c),null!==p?p.insertBefore(m):d.append(m),d=m):m.isInline()?(d.append(m),d=m):d=d.insertAfter(m,!1);}else p=d.getFirstChild(),
null!==p?p.insertBefore(m):d.append(m),d=m;else !F$5(m)||F$5(m)&&m.isInline()||z$7(d)&&!d.isInline()?(n=m,C$5(this)&&z$7(m)&&(F$5(d)||B$7(d))&&!m.isInline()?(B$7(d)?(p=d.getParentOrThrow(),[d]=d.splitText(c),d=d.getIndexWithinParent()+1):(p=d,d=c),[,d]=yc(p,d),d=d.insertBefore(m)):d=d.insertAfter(m,!1)):(m=d.getParentOrThrow(),Sb(d)&&d.remove(),d=m,r--);}b&&(B$7(f)?f.select():(a=d.getPreviousSibling(),B$7(a)?a.select():(a=d.getIndexWithinParent(),d.getParentOrThrow().select(a,a))));if(F$5(d)){if(a=B$7(n)?n:F$5(n)&&n.isInline()?
n.getLastDescendant():d.getLastDescendant(),b||(null===a?d.select():B$7(a)?""===a.getTextContent()?a.selectPrevious():a.select():a.selectNext()),0!==e.length)for(b=d,a=e.length-1;0<=a;a--)c=e[a],h=c.getParentOrThrow(),!F$5(d)||re(c)||z$7(c)&&(!c.isInline()||c.isIsolated())?F$5(d)||re(c)?F$5(c)&&!c.canInsertAfter(d)?(f=h.constructor.clone(h),F$5(f)||q$7(29),f.append(c),d.insertAfter(f)):d.insertAfter(c):(d.insertBefore(c),d=c):(b===d?d.append(c):d.insertBefore(c),d=c),h.isEmpty()&&!h.canBeEmpty()&&h.remove();}else b||
(B$7(d)?d.select():(b=d.getParentOrThrow(),a=d.getIndexWithinParent()+1,b.select(a,a)));return !0}insertParagraph(){this.isCollapsed()||this.removeText();var a=this.anchor,b=a.offset,c=[];if("text"===a.type){var d=a.getNode();var e=d.getNextSiblings().reverse();var f=d.getParentOrThrow();var g=f.isInline(),h=g?f.getTextContentSize():d.getTextContentSize();0===b?e.push(d):(g&&(c=f.getNextSiblings()),b===h||g&&b===d.getTextContentSize()||([,d]=d.splitText(b),e.push(d)));}else {f=a.getNode();if(M$2(f)){e=ae();
c=f.getChildAtIndex(b);e.select();null!==c?c.insertBefore(e,!1):f.append(e);return}e=f.getChildren().slice(b).reverse();}d=e.length;if(0===b&&0<d&&f.isInline()){if(c=f.getParentOrThrow(),e=c.insertNewAfter(this,!1),F$5(e))for(c=c.getChildren(),f=0;f<c.length;f++)e.append(c[f]);}else if(g=f.insertNewAfter(this,!1),null===g)this.insertLineBreak();else if(F$5(g))if(h=f.getFirstChild(),0===b&&(f.is(a.getNode())||h&&h.is(a.getNode()))&&0<d)f.insertBefore(g);else {f=null;b=c.length;a=g.getParentOrThrow();if(0<
b)for(h=0;h<b;h++)a.append(c[h]);if(0!==d)for(c=0;c<d;c++)b=e[c],null===f?g.append(b):f.insertBefore(b),f=b;g.canBeEmpty()||0!==g.getChildrenSize()?g.selectStart():(g.selectPrevious(),g.remove());}}insertLineBreak(a){let b=pe();var c=this.anchor;"element"===c.type&&(c=c.getNode(),L$5(c)&&this.insertParagraph());a?this.insertNodes([b],!0):this.insertNodes([b])&&b.selectNext(0,0);}getCharacterOffsets(){return je(this)}extract(){var a=this.getNodes(),b=a.length,c=b-1,d=this.anchor;let e=this.focus;var f=
a[0];let g=a[c],[h,k]=je(this);if(0===b)return [];if(1===b)return B$7(f)&&!this.isCollapsed()?(a=h>k?k:h,c=f.splitText(a,h>k?h:k),a=0===a?c[0]:c[1],null!=a?[a]:[]):[f];b=d.isBefore(e);B$7(f)&&(d=b?h:k,d===f.getTextContentSize()?a.shift():0!==d&&([,f]=f.splitText(d),a[0]=f));B$7(g)&&(f=g.getTextContent().length,b=b?k:h,0===b?a.pop():b!==f&&([g]=g.splitText(b),a[c]=g));return a}modify(a,b,c){var d=this.focus,e=this.anchor,f="move"===a,g=nc(d,b);if(z$7(g)&&!g.isIsolated())f&&g.isKeyboardSelectable()?(b=se(),
b.add(g.__key),xb(b)):(a=b?g.getPreviousSibling():g.getNextSibling(),B$7(a)?(g=a.__key,b=b?a.getTextContent().length:0,d.set(g,b,"text"),f&&e.set(g,b,"text")):(c=g.getParentOrThrow(),F$5(a)?(c=a.__key,g=b?a.getChildrenSize():0):(g=g.getIndexWithinParent(),c=c.__key,b||g++),d.set(c,g,"element"),f&&e.set(c,g,"element")));else if(e=H$6(),d=E$6(e._window)){var h=e._blockCursorElement,k=e._rootElement;null===k||null===h||!F$5(g)||g.isInline()||g.canBeEmpty()||xc(h,e,k);d.modify(a,b?"backward":"forward",c);if(0<
d.rangeCount&&(g=d.getRangeAt(0),e=this.anchor.getNode(),e=L$5(e)?e:sc(e),this.applyDOMRange(g),this.dirty=!0,!f)){f=this.getNodes();a=[];c=!1;for(h=0;h<f.length;h++)k=f[h],rc(k,e)?a.push(k):c=!0;c&&0<a.length&&(b?(b=a[0],F$5(b)?b.selectStart():b.getParentOrThrow().selectStart()):(b=a[a.length-1],F$5(b)?b.selectEnd():b.getParentOrThrow().selectEnd()));if(d.anchorNode!==g.startContainer||d.anchorOffset!==g.startOffset)b=this.focus,f=this.anchor,d=f.key,g=f.offset,e=f.type,ee(f,b.key,b.offset,b.type),ee(b,
d,g,e),this._cachedNodes=null;}}}deleteCharacter(a){if(this.isCollapsed()){var b=this.anchor,c=this.focus,d=b.getNode();if(!a&&("element"===b.type&&F$5(d)&&b.offset===d.getChildrenSize()||"text"===b.type&&b.offset===d.getTextContentSize())){var e=d.getParent();e=d.getNextSibling()||(null===e?null:e.getNextSibling());if(F$5(e)&&e.isShadowRoot())return}e=nc(c,a);if(z$7(e)&&!e.isIsolated()){e.isKeyboardSelectable()&&F$5(d)&&0===d.getChildrenSize()?(d.remove(),a=se(),a.add(e.__key),xb(a)):e.remove();return}this.modify("extend",
a,"character");if(!this.isCollapsed()){e="text"===c.type?c.getNode():null;d="text"===b.type?b.getNode():null;if(null!==e&&e.isSegmented()){if(b=c.offset,c=e.getTextContentSize(),e.is(d)||a&&b!==c||!a&&0!==b){te(e,a,b);return}}else if(null!==d&&d.isSegmented()&&(b=b.offset,c=d.getTextContentSize(),d.is(e)||a&&0!==b||!a&&b!==c)){te(d,a,b);return}d=this.anchor;e=this.focus;b=d.getNode();c=e.getNode();if(b===c&&"text"===d.type&&"text"===e.type){var f=d.offset,g=e.offset;let h=f<g;c=h?f:g;g=h?g:f;f=g-
1;c!==f&&(b=b.getTextContent().slice(c,g),ec(b)||(a?e.offset=f:d.offset=f));}}else if(a&&0===b.offset&&("element"===b.type?b.getNode():b.getNode().getParentOrThrow()).collapseAtStart(this))return}d=this.isCollapsed();this.removeText();a&&!d&&this.isCollapsed()&&"element"===this.anchor.type&&0===this.anchor.offset&&(a=this.anchor.getNode(),a.isEmpty()&&L$5(a.getParent())&&0===a.getIndexWithinParent()&&a.collapseAtStart(this));}deleteLine(a){this.isCollapsed()&&("text"===this.anchor.type&&this.modify("extend",
a,"lineboundary"),0===(a?this.focus:this.anchor).offset&&this.modify("extend",a,"character"));this.removeText();}deleteWord(a){this.isCollapsed()&&this.modify("extend",a,"word");this.removeText();}}function Qd(a){return a instanceof fe}function ue(a){let b=a.offset;if("text"===a.type)return b;a=a.getNode();return b===a.getChildrenSize()?a.getTextContent().length:0}
function je(a){let b=a.anchor;a=a.focus;return "element"===b.type&&"element"===a.type&&b.key===a.key&&b.offset===a.offset?[0,0]:[ue(b),ue(a)]}function te(a,b,c){let d=a.getTextContent().split(/(?=\s)/g),e=d.length,f=0,g=0;for(let h=0;h<e;h++){let k=d[h],n=h===e-1;g=f;f+=k.length;if(b&&f===c||f>c||n){d.splice(h,1);n&&(g=void 0);break}}b=d.join("").trim();""===b?a.remove():(a.setTextContent(b),a.select(g,g));}
function Ee(a,b,c,d){var e=b;if(1===a.nodeType){let h=!1;var f=a.childNodes,g=f.length;e===g&&(h=!0,e=g-1);let k=f[e];g=!1;k===d._blockCursorElement?(k=f[e+1],g=!0):null!==d._blockCursorElement&&e--;d=dc(k);if(B$7(d))e=h?d.getTextContentSize():0;else {f=dc(a);if(null===f)return null;if(F$5(f)){a=f.getChildAtIndex(e);if(b=F$5(a))b=a.getParent(),b=null===c||null===b||!b.canBeEmpty()||b!==c.getNode();b&&(c=h?a.getLastDescendant():a.getFirstDescendant(),null===c?(f=a,e=0):(a=c,f=F$5(a)?a:a.getParentOrThrow()));
B$7(a)?(d=a,f=null,e=h?a.getTextContentSize():0):a!==f&&h&&!g&&e++;}else e=f.getIndexWithinParent(),e=0===b&&z$7(f)&&dc(a)===f?e:e+1,f=f.getParentOrThrow();if(F$5(f))return new be(f.__key,e,"element")}}else d=dc(a);return B$7(d)?new be(d.__key,e,"text"):null}
function Fe(a,b,c){var d=a.offset,e=a.getNode();0===d?(d=e.getPreviousSibling(),e=e.getParent(),b)?(c||!b)&&null===d&&F$5(e)&&e.isInline()&&(b=e.getPreviousSibling(),B$7(b)&&(a.key=b.__key,a.offset=b.getTextContent().length)):F$5(d)&&!c&&d.isInline()?(a.key=d.__key,a.offset=d.getChildrenSize(),a.type="element"):B$7(d)&&(a.key=d.__key,a.offset=d.getTextContent().length):d===e.getTextContent().length&&(d=e.getNextSibling(),e=e.getParent(),b&&F$5(d)&&d.isInline()?(a.key=d.__key,a.offset=0,a.type="element"):(c||
b)&&null===d&&F$5(e)&&e.isInline()&&!e.canInsertTextAfter()&&(b=e.getNextSibling(),B$7(b)&&(a.key=b.__key,a.offset=0)));}function qe(a,b,c){if("text"===a.type&&"text"===b.type){var d=a.isBefore(b);let e=a.is(b);Fe(a,d,e);Fe(b,!d,e);e&&(b.key=a.key,b.offset=a.offset,b.type=a.type);d=H$6();d.isComposing()&&d._compositionKey!==a.key&&C$5(c)&&(d=c.anchor,c=c.focus,ee(a,d.key,d.offset,d.type),ee(b,c.key,c.offset,c.type));}}
function oe(a,b,c,d,e,f){if(null===a||null===c||!Fb(e,a,c))return null;b=Ee(a,b,C$5(f)?f.anchor:null,e);if(null===b)return null;d=Ee(c,d,C$5(f)?f.focus:null,e);if(null===d||"element"===b.type&&"element"===d.type&&(a=dc(a),c=dc(c),z$7(a)&&z$7(c)))return null;qe(b,d,f);return [b,d]}function re(a){return F$5(a)&&!a.isInline()}function Ge(a,b,c,d,e,f){let g=Vb();a=new ge(new be(a,b,e),new be(c,d,f),0,"");a.dirty=!0;return g._selection=a}function se(){return new fe(new Set)}
function He(a){let b=a.getEditorState()._selection,c=E$6(a._window);return Qd(b)||ie(b)?b.clone():Ud(b,c,a)}
function Ud(a,b,c){var d=c._window;if(null===d)return null;var e=d.event,f=e?e.type:void 0;d="selectionchange"===f;e=!ob&&(d||"beforeinput"===f||"compositionstart"===f||"compositionend"===f||"click"===f&&e&&3===e.detail||"drop"===f||void 0===f);let g;if(!C$5(a)||e){if(null===b)return null;e=b.anchorNode;f=b.focusNode;g=b.anchorOffset;b=b.focusOffset;if(d&&C$5(a)&&!Fb(c,e,f))return a.clone()}else return a.clone();c=oe(e,g,f,b,c,a);if(null===c)return null;let [h,k]=c;return new ge(h,k,C$5(a)?a.format:0,C$5(a)?
a.style:"")}function v$6(){return Vb()._selection}function ic(){return H$6()._editorState._selection}
function Yd(a,b,c,d=1){var e=a.anchor,f=a.focus,g=e.getNode(),h=f.getNode();if(b.is(g)||b.is(h)){g=b.__key;if(a.isCollapsed()){if(b=e.offset,c<=b&&0<d||c<b&&0>d)c=Math.max(0,b+d),e.set(g,c,"element"),f.set(g,c,"element"),Ie(a);}else {let n=a.isBackward();h=n?f:e;var k=h.getNode();e=n?e:f;f=e.getNode();b.is(k)&&(k=h.offset,(c<=k&&0<d||c<k&&0>d)&&h.set(g,Math.max(0,k+d),"element"));b.is(f)&&(b=e.offset,(c<=b&&0<d||c<b&&0>d)&&e.set(g,Math.max(0,b+d),"element"));}Ie(a);}}
function Ie(a){var b=a.anchor,c=b.offset;let d=a.focus;var e=d.offset,f=b.getNode(),g=d.getNode();if(a.isCollapsed())F$5(f)&&(g=f.getChildrenSize(),g=(e=c>=g)?f.getChildAtIndex(g-1):f.getChildAtIndex(c),B$7(g)&&(c=0,e&&(c=g.getTextContentSize()),b.set(g.__key,c,"text"),d.set(g.__key,c,"text")));else {if(F$5(f)){let h=f.getChildrenSize();c=(a=c>=h)?f.getChildAtIndex(h-1):f.getChildAtIndex(c);B$7(c)&&(f=0,a&&(f=c.getTextContentSize()),b.set(c.__key,f,"text"));}F$5(g)&&(c=g.getChildrenSize(),e=(b=e>=c)?g.getChildAtIndex(c-
1):g.getChildAtIndex(e),B$7(e)&&(g=0,b&&(g=e.getTextContentSize()),d.set(e.__key,g,"text")));}}function Je(a,b){b=b.getEditorState()._selection;a=a._selection;if(C$5(a)){var c=a.anchor;let d=a.focus,e;"text"===c.type&&(e=c.getNode(),e.selectionTransform(b,a));"text"===d.type&&(c=d.getNode(),e!==c&&c.selectionTransform(b,a));}}
function Xd(a,b,c,d,e){let f=null,g=0,h=null;null!==d?(f=d.__key,B$7(d)?(g=d.getTextContentSize(),h="text"):F$5(d)&&(g=d.getChildrenSize(),h="element")):null!==e&&(f=e.__key,B$7(e)?h="text":F$5(e)&&(h="element"));null!==f&&null!==h?a.set(f,g,h):(g=b.getIndexWithinParent(),-1===g&&(g=c.getChildrenSize()),a.set(c.__key,g,"element"));}function Ke(a,b,c,d,e){"text"===a.type?(a.key=c,b||(a.offset+=e)):a.offset>d.getIndexWithinParent()&&--a.offset;}
function ne(a,b,c){let d=[],e=null,f=null;a=a.getChildren();for(let m=0;m<a.length;m++){var g=a[m];le(g)||q$7(108);var h=g.getChildren();g=0;for(let p of h){for(ke(p)||q$7(109);void 0!==d[m]&&void 0!==d[m][g];)g++;h=m;var k=g,n=p;let l={cell:n,startColumn:k,startRow:h},r=n.__rowSpan,u=n.__colSpan;for(let x=0;x<r;x++){void 0===d[h+x]&&(d[h+x]=[]);for(let y=0;y<u;y++)d[h+x][k+y]=l;}b.is(n)&&(e=l);c.is(n)&&(f=l);g+=p.__colSpan;}}null===e&&q$7(110);null===f&&q$7(111);return [d,e,f]}
let T$3=null,Y$3=null,Z$2=!1,Le=!1,Ub=0,Me={characterData:!0,childList:!0,subtree:!0};function Zb(){return Z$2||null!==T$3&&T$3._readOnly}function G$4(){Z$2&&q$7(13);}function Vb(){null===T$3&&q$7(15);return T$3}function H$6(){null===Y$3&&q$7(16);return Y$3}function Ne(a,b,c){var d=b.__type;let e=a._nodes.get(d);void 0===e&&q$7(30);a=c.get(d);void 0===a&&(a=Array.from(e.transforms),c.set(d,a));c=a.length;for(d=0;d<c&&(a[d](b),b.isAttached());d++);}
function Oe(a,b){b=b._dirtyLeaves;a=a._nodeMap;for(let c of b)b=a.get(c),B$7(b)&&b.isAttached()&&b.isSimpleText()&&!b.isUnmergeable()&&Fc(b);}
function Pe(a,b){let c=b._dirtyLeaves,d=b._dirtyElements;a=a._nodeMap;let e=Yb(),f=new Map;var g=c;let h=g.size;for(var k=d,n=k.size;0<h||0<n;){if(0<h){b._dirtyLeaves=new Set;for(let m of g)g=a.get(m),B$7(g)&&g.isAttached()&&g.isSimpleText()&&!g.isUnmergeable()&&Fc(g),void 0!==g&&void 0!==g&&g.__key!==e&&g.isAttached()&&Ne(b,g,f),c.add(m);g=b._dirtyLeaves;h=g.size;if(0<h){Ub++;continue}}b._dirtyLeaves=new Set;b._dirtyElements=new Map;for(let m of k)if(k=m[0],n=m[1],"root"===k||n)g=a.get(k),void 0!==
g&&void 0!==g&&g.__key!==e&&g.isAttached()&&Ne(b,g,f),d.set(k,n);g=b._dirtyLeaves;h=g.size;k=b._dirtyElements;n=k.size;Ub++;}b._dirtyLeaves=c;b._dirtyElements=d;}function Qe(a,b){var c=b.get(a.type);void 0===c&&q$7(17);c=c.klass;a.type!==c.getType()&&q$7(18);c=c.importJSON(a);a=a.children;if(F$5(c)&&Array.isArray(a))for(let d=0;d<a.length;d++){let e=Qe(a[d],b);c.append(e);}return c}function Re(a,b){let c=T$3,d=Z$2,e=Y$3;T$3=a;Z$2=!0;Y$3=null;try{return b()}finally{T$3=c,Z$2=d,Y$3=e;}}
function Se(a){let b=a._pendingEditorState,c=a._rootElement,d=a._headless||null===c;if(null!==b){var e=a._editorState,f=e._selection,g=b._selection,h=0!==a._dirtyType,k=T$3,n=Z$2,m=Y$3,p=a._updating,l=a._observer,r=null;a._pendingEditorState=null;a._editorState=b;if(!d&&h&&null!==l){Y$3=a;T$3=b;Z$2=!1;a._updating=!0;try{let D=a._dirtyType,P=a._dirtyElements,Q=a._dirtyLeaves;l.disconnect();var u=D,x=P,y=Q;O$4=Ic=N$3="";Tc=2===u;Wc=null;R$4=a;Rc=a._config;Sc=a._nodes;Vc=R$4._listeners.mutation;Xc=x;Yc=y;Zc=e._nodeMap;
$c=b._nodeMap;Uc=b._readOnly;ad=new Map(a._keyToDOMMap);let ha=new Map;bd=ha;pd("root",null);bd=ad=Rc=$c=Zc=Yc=Xc=Sc=R$4=void 0;r=ha;}catch(D){D instanceof Error&&a._onError(D);if(Le)throw D;Te(a,null,c,b);Ab(a);a._dirtyType=2;Le=!0;Se(a);Le=!1;return}finally{l.observe(c,Me),a._updating=p,T$3=k,Z$2=n,Y$3=m;}}b._readOnly||(b._readOnly=!0);var A=a._dirtyLeaves,aa=a._dirtyElements,ba=a._normalizedNodes,oa=a._updateTags,pa=a._deferred;h&&(a._dirtyType=0,a._cloneNotNeeded.clear(),a._dirtyLeaves=new Set,a._dirtyElements=
new Map,a._normalizedNodes=new Set,a._updateTags=new Set);var ve=a._decorators,Jb=a._pendingDecorators||ve,qf=b._nodeMap,Jc;for(Jc in Jb)qf.has(Jc)||(Jb===ve&&(Jb=$b(a)),delete Jb[Jc]);var ia=d?null:E$6(a._window);if(a._editable&&null!==ia&&(h||null===g||g.dirty)){Y$3=a;T$3=b;try{null!==l&&l.disconnect();if(h||null===g||g.dirty){let D=a._blockCursorElement;null!==D&&xc(D,a,c);a:{let P=ia.anchorNode,Q=ia.focusNode,ha=ia.anchorOffset,hb=ia.focusOffset,V=document.activeElement;if(!(oa.has("collaboration")&&
V!==c||null!==V&&Eb(V)))if(C$5(g)){var ib=g.anchor,Kc=g.focus,we=ib.key,rf=Kc.key,xe=pc(a,we),ye=pc(a,rf),Kb=ib.offset,ze=Kc.offset,Lc=g.format,Mc=g.style,Ae=g.isCollapsed(),jb=xe,Lb=ye,Nc=!1;if("text"===ib.type){jb=Pb(xe);let W=ib.getNode();Nc=W.getFormat()!==Lc||W.getStyle()!==Mc;}else C$5(f)&&"text"===f.anchor.type&&(Nc=!0);"text"===Kc.type&&(Lb=Pb(ye));if(null!==jb&&null!==Lb){if(Ae&&(null===f||Nc||C$5(f)&&(f.format!==Lc||f.style!==Mc))){var sf=performance.now();Jd=[Lc,Mc,Kb,we,sf];}if(ha===Kb&&hb===
ze&&P===jb&&Q===Lb&&("Range"!==ia.type||!Ae)&&(null!==V&&c.contains(V)||c.focus({preventScroll:!0}),"element"!==ib.type))break a;try{ia.setBaseAndExtent(jb,Kb,Lb,ze);}catch(W){}if(!oa.has("skip-scroll-into-view")&&g.isCollapsed()&&null!==c&&c===document.activeElement){let W=g instanceof ge&&"element"===g.anchor.type?jb.childNodes[Kb]||null:0<ia.rangeCount?ia.getRangeAt(0):null;if(null!==W){let X;if(W instanceof Text){let U=document.createRange();U.selectNode(W);X=U.getBoundingClientRect();}else X=W.getBoundingClientRect();
let va=c.ownerDocument,Ea=va.defaultView;if(null!==Ea)for(var {top:Oc,bottom:Pc}=X,Mb,Nb,ma=c;null!==ma;){let U=ma===va.body;if(U)Mb=0,Nb=Bb(a).innerHeight;else {let Ob=ma.getBoundingClientRect();Mb=Ob.top;Nb=Ob.bottom;}let Fa=0;Oc<Mb?Fa=-(Mb-Oc):Pc>Nb&&(Fa=Pc-Nb);if(0!==Fa)if(U)Ea.scrollBy(0,Fa);else {let Ob=ma.scrollTop;ma.scrollTop+=Fa;let Be=ma.scrollTop-Ob;Oc-=Be;Pc-=Be;}if(U)break;ma=Hb(ma);}}}Fd=!0;}}else null!==f&&Fb(a,P,Q)&&ia.removeAllRanges();}}a:{let D=a._blockCursorElement;if(C$5(g)&&g.isCollapsed()&&
"element"===g.anchor.type&&c.contains(document.activeElement)){let P=g.anchor,Q=P.getNode(),ha=P.offset,hb=Q.getChildrenSize(),V=!1,W=null;if(ha===hb){let X=Q.getChildAtIndex(ha-1);wc(X)&&(V=!0);}else {let X=Q.getChildAtIndex(ha);if(wc(X)){let va=X.getPreviousSibling();if(null===va||wc(va))V=!0,W=a.getElementByKey(X.__key);}}if(V){let X=a.getElementByKey(Q.__key);if(null===D){let va=a._config.theme,Ea=document.createElement("div");Ea.contentEditable="false";Ea.setAttribute("data-lexical-cursor","true");
let U=va.blockCursor;if(void 0!==U){if("string"===typeof U){let Fa=U.split(" ");U=va.blockCursor=Fa;}void 0!==U&&Ea.classList.add(...U);}a._blockCursorElement=D=Ea;}c.style.caretColor="transparent";null===W?X.appendChild(D):X.insertBefore(D,W);break a}}null!==D&&xc(D,a,c);}null!==l&&l.observe(c,Me);}finally{Y$3=m,T$3=k;}}if(null!==r){var tf=r;let D=Array.from(a._listeners.mutation),P=D.length;for(let Q=0;Q<P;Q++){let [ha,hb]=D[Q],V=tf.get(hb);void 0!==V&&ha(V,{dirtyLeaves:A,updateTags:oa});}}C$5(g)||null===g||
null!==f&&f.is(g)||a.dispatchCommand(ca$3,void 0);var Qc=a._pendingDecorators;null!==Qc&&(a._decorators=Qc,a._pendingDecorators=null,Ue("decorator",a,!0,Qc));var uf=ac(e),Ce=ac(b);uf!==Ce&&Ue("textcontent",a,!0,Ce);Ue("update",a,!0,{dirtyElements:aa,dirtyLeaves:A,editorState:b,normalizedNodes:ba,prevEditorState:e,tags:oa});a._deferred=[];if(0!==pa.length){let D=a._updating;a._updating=!0;try{for(let P=0;P<pa.length;P++)pa[P]();}finally{a._updating=D;}}var De=a._updates;if(0!==De.length){let D=De.shift();
if(D){let [P,Q]=D;Ve(a,P,Q);}}}}function Ue(a,b,c,...d){let e=b._updating;b._updating=c;try{let f=Array.from(b._listeners[a]);for(a=0;a<f.length;a++)f[a].apply(null,d);}finally{b._updating=e;}}function S$3(a,b,c){if(!1===a._updating||Y$3!==a){let f=!1;a.update(()=>{f=S$3(a,b,c);});return f}let d=fc(a);for(let f=4;0<=f;f--)for(let g=0;g<d.length;g++){var e=d[g]._commands.get(b);if(void 0!==e&&(e=e[f],void 0!==e)){e=Array.from(e);let h=e.length;for(let k=0;k<h;k++)if(!0===e[k](c,a))return !0}}return !1}
function We(a,b){let c=a._updates;for(b=b||!1;0!==c.length;){var d=c.shift();if(d){let [e,f]=d,g;void 0!==f&&(d=f.onUpdate,g=f.tag,f.skipTransforms&&(b=!0),d&&a._deferred.push(d),g&&a._updateTags.add(g));e();}}return b}
function Ve(a,b,c){let d=a._updateTags;var e,f=e=!1;if(void 0!==c){var g=c.onUpdate;e=c.tag;null!=e&&d.add(e);e=c.skipTransforms||!1;f=c.discrete||!1;}g&&a._deferred.push(g);c=a._editorState;g=a._pendingEditorState;let h=!1;if(null===g||g._readOnly)g=a._pendingEditorState=new Xe(new Map((g||c)._nodeMap)),h=!0;g._flushSync=f;f=T$3;let k=Z$2,n=Y$3,m=a._updating;T$3=g;Z$2=!1;a._updating=!0;Y$3=a;try{h&&(a._headless?null!=c._selection&&(g._selection=c._selection.clone()):g._selection=He(a));let p=a._compositionKey;
b();e=We(a,e);Je(g,a);0!==a._dirtyType&&(e?Oe(g,a):Pe(g,a),We(a),Cc(c,g,a._dirtyLeaves,a._dirtyElements));p!==a._compositionKey&&(g._flushSync=!0);let l=g._selection;if(C$5(l)){let r=g._nodeMap,u=l.focus.key;void 0!==r.get(l.anchor.key)&&void 0!==r.get(u)||q$7(19);}else Qd(l)&&0===l._nodes.size&&(g._selection=null);}catch(p){p instanceof Error&&a._onError(p);a._pendingEditorState=c;a._dirtyType=2;a._cloneNotNeeded.clear();a._dirtyLeaves=new Set;a._dirtyElements.clear();Se(a);return}finally{T$3=f,Z$2=k,Y$3=n,
a._updating=m,Ub=0;}0!==a._dirtyType||Ye(g,a)?g._flushSync?(g._flushSync=!1,Se(a)):h&&Db(()=>{Se(a);}):(g._flushSync=!1,h&&(d.clear(),a._deferred=[],a._pendingEditorState=null));}function w$6(a,b,c){a._updating?a._updates.push([b,c]):Ve(a,b,c);}class Ze extends Zd{constructor(a){super(a);}decorate(){q$7(47);}isIsolated(){return !1}isInline(){return !0}isKeyboardSelectable(){return !0}}function z$7(a){return a instanceof Ze}
class $e extends Zd{constructor(a){super(a);this.__last=this.__first=null;this.__indent=this.__format=this.__size=0;this.__dir=null;}getFormat(){return this.getLatest().__format}getFormatType(){let a=this.getFormat();return lb[a]||""}getIndent(){return this.getLatest().__indent}getChildren(){let a=[],b=this.getFirstChild();for(;null!==b;)a.push(b),b=b.getNextSibling();return a}getChildrenKeys(){let a=[],b=this.getFirstChild();for(;null!==b;)a.push(b.__key),b=b.getNextSibling();return a}getChildrenSize(){return this.getLatest().__size}isEmpty(){return 0===
this.getChildrenSize()}isDirty(){let a=H$6()._dirtyElements;return null!==a&&a.has(this.__key)}isLastChild(){let a=this.getLatest(),b=this.getParentOrThrow().getLastChild();return null!==b&&b.is(a)}getAllTextNodes(){let a=[],b=this.getFirstChild();for(;null!==b;){B$7(b)&&a.push(b);if(F$5(b)){let c=b.getAllTextNodes();a.push(...c);}b=b.getNextSibling();}return a}getFirstDescendant(){let a=this.getFirstChild();for(;null!==a;){if(F$5(a)){let b=a.getFirstChild();if(null!==b){a=b;continue}}break}return a}getLastDescendant(){let a=
this.getLastChild();for(;null!==a;){if(F$5(a)){let b=a.getLastChild();if(null!==b){a=b;continue}}break}return a}getDescendantByIndex(a){let b=this.getChildren(),c=b.length;if(a>=c)return a=b[c-1],F$5(a)&&a.getLastDescendant()||a||null;a=b[a];return F$5(a)&&a.getFirstDescendant()||a||null}getFirstChild(){let a=this.getLatest().__first;return null===a?null:J$5(a)}getFirstChildOrThrow(){let a=this.getFirstChild();null===a&&q$7(45);return a}getLastChild(){let a=this.getLatest().__last;return null===a?null:J$5(a)}getLastChildOrThrow(){let a=
this.getLastChild();null===a&&q$7(96);return a}getChildAtIndex(a){var b=this.getChildrenSize();let c;if(a<b/2){c=this.getFirstChild();for(b=0;null!==c&&b<=a;){if(b===a)return c;c=c.getNextSibling();b++;}return null}c=this.getLastChild();for(--b;null!==c&&b>=a;){if(b===a)return c;c=c.getPreviousSibling();b--;}return null}getTextContent(){let a="",b=this.getChildren(),c=b.length;for(let d=0;d<c;d++){let e=b[d];a+=e.getTextContent();F$5(e)&&d!==c-1&&!e.isInline()&&(a+="\n\n");}return a}getTextContentSize(){let a=
0,b=this.getChildren(),c=b.length;for(let d=0;d<c;d++){let e=b[d];a+=e.getTextContentSize();F$5(e)&&d!==c-1&&!e.isInline()&&(a+=2);}return a}getDirection(){return this.getLatest().__dir}hasFormat(a){return ""!==a?(a=kb[a],0!==(this.getFormat()&a)):!1}select(a,b){G$4();let c=v$6(),d=a,e=b;var f=this.getChildrenSize();if(!this.canBeEmpty())if(0===a&&0===b){if(a=this.getFirstChild(),B$7(a)||F$5(a))return a.select(0,0)}else if(!(void 0!==a&&a!==f||void 0!==b&&b!==f)&&(a=this.getLastChild(),B$7(a)||F$5(a)))return a.select();
void 0===d&&(d=f);void 0===e&&(e=f);f=this.__key;if(C$5(c))c.anchor.set(f,d,"element"),c.focus.set(f,e,"element"),c.dirty=!0;else return Ge(f,d,f,e,"element","element");return c}selectStart(){let a=this.getFirstDescendant();return F$5(a)||B$7(a)?a.select(0,0):null!==a?a.selectPrevious():this.select(0,0)}selectEnd(){let a=this.getLastDescendant();return F$5(a)||B$7(a)?a.select():null!==a?a.selectNext():this.select()}clear(){let a=this.getWritable();this.getChildren().forEach(b=>b.remove());return a}append(...a){return this.splice(this.getChildrenSize(),
0,a)}setDirection(a){let b=this.getWritable();b.__dir=a;return b}setFormat(a){this.getWritable().__format=""!==a?kb[a]:0;return this}setIndent(a){this.getWritable().__indent=a;return this}splice(a,b,c){let d=c.length,e=this.getChildrenSize(),f=this.getWritable(),g=f.__key;var h=[],k=[];let n=this.getChildAtIndex(a+b),m=null,p=e-b+d;if(0!==a)if(a===e)m=this.getLastChild();else {var l=this.getChildAtIndex(a);null!==l&&(m=l.getPreviousSibling());}if(0<b){var r=null===m?this.getFirstChild():m.getNextSibling();
for(l=0;l<b;l++){null===r&&q$7(100);var u=r.getNextSibling(),x=r.__key;r=r.getWritable();Wb(r);k.push(x);r=u;}}l=m;for(u=0;u<d;u++){x=c[u];null!==l&&x.is(l)&&(m=l=l.getPreviousSibling());r=x.getWritable();r.__parent===g&&p--;Wb(r);let y=x.__key;null===l?(f.__first=y,r.__prev=null):(l=l.getWritable(),l.__next=y,r.__prev=l.__key);x.__key===g&&q$7(76);r.__parent=g;h.push(y);l=x;}a+b===e?null!==l&&(l.getWritable().__next=null,f.__last=l.__key):null!==n&&(a=n.getWritable(),null!==l?(b=l.getWritable(),a.__prev=
l.__key,b.__next=n.__key):a.__prev=null);f.__size=p;if(k.length&&(a=v$6(),C$5(a))){k=new Set(k);h=new Set(h);let {anchor:y,focus:A}=a;af(y,k,h)&&Xd(y,y.getNode(),this,m,n);af(A,k,h)&&Xd(A,A.getNode(),this,m,n);0!==p||this.canBeEmpty()||M$2(this)||this.remove();}return f}exportJSON(){return {children:[],direction:this.getDirection(),format:this.getFormatType(),indent:this.getIndent(),type:"element",version:1}}insertNewAfter(){return null}canInsertTab(){return !1}canIndent(){return !0}collapseAtStart(){return !1}excludeFromCopy(){return !1}canExtractContents(){return !0}canReplaceWith(){return !0}canInsertAfter(){return !0}canBeEmpty(){return !0}canInsertTextBefore(){return !0}canInsertTextAfter(){return !0}isInline(){return !1}isShadowRoot(){return !1}canMergeWith(){return !1}extractWithChild(){return !1}}
function F$5(a){return a instanceof $e}function af(a,b,c){for(a=a.getNode();a;){let d=a.__key;if(b.has(d)&&!c.has(d))return !0;a=a.getParent();}return !1}
class bf extends $e{static getType(){return "root"}static clone(){return new bf}constructor(){super("root");this.__cachedText=null;}getTopLevelElementOrThrow(){q$7(51);}getTextContent(){let a=this.__cachedText;return !Zb()&&0!==H$6()._dirtyType||null===a?super.getTextContent():a}remove(){q$7(52);}replace(){q$7(53);}insertBefore(){q$7(54);}insertAfter(){q$7(55);}updateDOM(){return !1}append(...a){for(let b=0;b<a.length;b++){let c=a[b];F$5(c)||z$7(c)||q$7(56);}return super.append(...a)}static importJSON(a){let b=bc();b.setFormat(a.format);
b.setIndent(a.indent);b.setDirection(a.direction);return b}exportJSON(){return {children:[],direction:this.getDirection(),format:this.getFormatType(),indent:this.getIndent(),type:"root",version:1}}collapseAtStart(){return !0}}function L$5(a){return a instanceof bf}function Ye(a,b){b=b.getEditorState()._selection;a=a._selection;if(null!==a){if(a.dirty||!a.is(b))return !0}else if(null!==b)return !0;return !1}function cf(){return new Xe(new Map([["root",new bf]]))}
function df(a){let b=a.exportJSON();b.type!==a.constructor.getType()&&q$7(58);let c=b.children;if(F$5(a)){Array.isArray(c)||q$7(59);a=a.getChildren();for(let d=0;d<a.length;d++){let e=df(a[d]);c.push(e);}}return b}
class Xe{constructor(a,b){this._nodeMap=a;this._selection=b||null;this._readOnly=this._flushSync=!1;}isEmpty(){return 1===this._nodeMap.size&&null===this._selection}read(a){return Re(this,a)}clone(a){a=new Xe(this._nodeMap,void 0===a?this._selection:a);a._readOnly=!0;return a}toJSON(){return Re(this,()=>({root:df(bc())}))}}
class ef extends Zd{static getType(){return "linebreak"}static clone(a){return new ef(a.__key)}constructor(a){super(a);}getTextContent(){return "\n"}createDOM(){return document.createElement("br")}updateDOM(){return !1}static importDOM(){return {br:a=>{let b=a.parentElement;return null!=b&&b.firstChild===a&&b.lastChild===a?null:{conversion:ff,priority:0}}}}static importJSON(){return pe()}exportJSON(){return {type:"linebreak",version:1}}}function ff(){return {node:pe()}}function pe(){return uc(new ef)}
function Sb(a){return a instanceof ef}function gf(a,b){return b&16?"code":b&128?"mark":b&32?"sub":b&64?"sup":null}function hf(a,b){return b&1?"strong":b&2?"em":"span"}
function jf(a,b,c,d,e){a=d.classList;d=kc(e,"base");void 0!==d&&a.add(...d);d=kc(e,"underlineStrikethrough");let f=!1,g=b&8&&b&4;var h=c&8&&c&4;void 0!==d&&(h?(f=!0,g||a.add(...d)):g&&a.remove(...d));for(let k in fb)h=fb[k],d=kc(e,k),void 0!==d&&(c&h?!f||"underline"!==k&&"strikethrough"!==k?(0===(b&h)||g&&"underline"===k||"strikethrough"===k)&&a.add(...d):b&h&&a.remove(...d):b&h&&a.remove(...d));}
function kf(a,b,c){let d=b.firstChild;c=c.isComposing();a+=c?bb:"";if(null==d)b.textContent=a;else if(b=d.nodeValue,b!==a)if(c||Wa){c=b.length;let e=a.length,f=0,g=0;for(;f<c&&f<e&&b[f]===a[f];)f++;for(;g+f<c&&g+f<e&&b[c-g-1]===a[e-g-1];)g++;a=[f,c-f-g,a.slice(f,e-g)];let [h,k,n]=a;0!==k&&d.deleteData(h,k);d.insertData(h,n);}else d.nodeValue=a;}function lf(a,b){b=document.createElement(b);b.appendChild(a);return b}
class mf extends Zd{static getType(){return "text"}static clone(a){return new mf(a.__text,a.__key)}constructor(a,b){super(b);this.__text=a;this.__format=0;this.__style="";this.__detail=this.__mode=0;}getFormat(){return this.getLatest().__format}getDetail(){return this.getLatest().__detail}getMode(){let a=this.getLatest();return nb[a.__mode]}getStyle(){return this.getLatest().__style}isToken(){return 1===this.getLatest().__mode}isComposing(){return this.__key===Yb()}isSegmented(){return 2===this.getLatest().__mode}isDirectionless(){return 0!==
(this.getLatest().__detail&1)}isUnmergeable(){return 0!==(this.getLatest().__detail&2)}hasFormat(a){a=fb[a];return 0!==(this.getFormat()&a)}isSimpleText(){return "text"===this.__type&&0===this.__mode}getTextContent(){return this.getLatest().__text}getFormatFlags(a,b){let c=this.getLatest().__format;return Qb(c,a,b)}createDOM(a){var b=this.__format,c=gf(this,b);let d=hf(this,b),e=document.createElement(null===c?d:c),f=e;null!==c&&(f=document.createElement(d),e.appendChild(f));c=f;kf(this.__text,c,this);
a=a.theme.text;void 0!==a&&jf(d,0,b,c,a);b=this.__style;""!==b&&(e.style.cssText=b);return e}updateDOM(a,b,c){let d=this.__text;var e=a.__format,f=this.__format,g=gf(this,e);let h=gf(this,f);var k=hf(this,e);let n=hf(this,f);if((null===g?k:g)!==(null===h?n:h))return !0;if(g===h&&k!==n)return e=b.firstChild,null==e&&q$7(48),a=g=document.createElement(n),kf(d,a,this),c=c.theme.text,void 0!==c&&jf(n,0,f,a,c),b.replaceChild(g,e),!1;k=b;null!==h&&null!==g&&(k=b.firstChild,null==k&&q$7(49));kf(d,k,this);c=c.theme.text;
void 0!==c&&e!==f&&jf(n,e,f,k,c);f=this.__style;a.__style!==f&&(b.style.cssText=f);return !1}static importDOM(){return {"#text":()=>({conversion:nf,priority:0}),b:()=>({conversion:of,priority:0}),br:()=>({conversion:pf,priority:0}),code:()=>({conversion:vf,priority:0}),em:()=>({conversion:vf,priority:0}),i:()=>({conversion:vf,priority:0}),s:()=>({conversion:vf,priority:0}),span:()=>({conversion:wf,priority:0}),strong:()=>({conversion:vf,priority:0}),sub:()=>({conversion:vf,priority:0}),sup:()=>({conversion:vf,
priority:0}),u:()=>({conversion:vf,priority:0})}}static importJSON(a){let b=K$5(a.text);b.setFormat(a.format);b.setDetail(a.detail);b.setMode(a.mode);b.setStyle(a.style);return b}exportDOM(a){({element:a}=super.exportDOM(a));null!==a&&(this.hasFormat("bold")&&(a=lf(a,"b")),this.hasFormat("italic")&&(a=lf(a,"i")),this.hasFormat("strikethrough")&&(a=lf(a,"s")),this.hasFormat("underline")&&(a=lf(a,"u")));return {element:a}}exportJSON(){return {detail:this.getDetail(),format:this.getFormat(),mode:this.getMode(),
style:this.getStyle(),text:this.getTextContent(),type:"text",version:1}}selectionTransform(){}setFormat(a){let b=this.getWritable();b.__format="string"===typeof a?fb[a]:a;return b}setDetail(a){let b=this.getWritable();b.__detail="string"===typeof a?gb[a]:a;return b}setStyle(a){let b=this.getWritable();b.__style=a;return b}toggleFormat(a){a=fb[a];return this.setFormat(this.getFormat()^a)}toggleDirectionless(){let a=this.getWritable();a.__detail^=1;return a}toggleUnmergeable(){let a=this.getWritable();
a.__detail^=2;return a}setMode(a){a=mb[a];if(this.__mode===a)return this;let b=this.getWritable();b.__mode=a;return b}setTextContent(a){if(this.__text===a)return this;let b=this.getWritable();b.__text=a;return b}select(a,b){G$4();let c=v$6();var d=this.getTextContent();let e=this.__key;"string"===typeof d?(d=d.length,void 0===a&&(a=d),void 0===b&&(b=d)):b=a=0;if(C$5(c))d=Yb(),d!==c.anchor.key&&d!==c.focus.key||I$5(e),c.setTextNodeRange(this,a,this,b);else return Ge(e,a,e,b,"text","text");return c}spliceText(a,
b,c,d){let e=this.getWritable(),f=e.__text,g=c.length,h=a;0>h&&(h=g+h,0>h&&(h=0));let k=v$6();d&&C$5(k)&&(a+=g,k.setTextNodeRange(e,a,e,a));b=f.slice(0,h)+c+f.slice(h+b);e.__text=b;return e}canInsertTextBefore(){return !0}canInsertTextAfter(){return !0}canContainTabs(){return !1}splitText(...a){G$4();var b=this.getLatest(),c=b.getTextContent(),d=b.__key,e=Yb(),f=new Set(a);a=[];var g=c.length,h="";for(var k=0;k<g;k++)""!==h&&f.has(k)&&(a.push(h),h=""),h+=c[k];""!==h&&a.push(h);f=a.length;if(0===f)return [];
if(a[0]===c)return [b];var n=a[0];c=b.getParentOrThrow();k=b.getFormat();let m=b.getStyle(),p=b.__detail;g=!1;b.isSegmented()?(h=K$5(n),h.__format=k,h.__style=m,h.__detail=p,g=!0):(h=b.getWritable(),h.__text=n);b=v$6();h=[h];n=n.length;for(let u=1;u<f;u++){var l=a[u],r=l.length;l=K$5(l).getWritable();l.__format=k;l.__style=m;l.__detail=p;let x=l.__key;r=n+r;if(C$5(b)){let y=b.anchor,A=b.focus;y.key===d&&"text"===y.type&&y.offset>n&&y.offset<=r&&(y.key=x,y.offset-=n,b.dirty=!0);A.key===d&&"text"===A.type&&
A.offset>n&&A.offset<=r&&(A.key=x,A.offset-=n,b.dirty=!0);}e===d&&I$5(x);n=r;h.push(l);}d=this.getPreviousSibling();e=this.getNextSibling();null!==d&&Xb(d);null!==e&&Xb(e);d=c.getWritable();e=this.getIndexWithinParent();g?(d.splice(e,0,h),this.remove()):d.splice(e,1,h);C$5(b)&&Yd(b,c,e,f-1);return h}mergeWithSibling(a){var b=a===this.getPreviousSibling();b||a===this.getNextSibling()||q$7(50);var c=this.__key;let d=a.__key,e=this.__text,f=e.length;Yb()===d&&I$5(c);let g=v$6();if(C$5(g)){let h=g.anchor,k=g.focus;
null!==h&&h.key===d&&(Ke(h,b,c,a,f),g.dirty=!0);null!==k&&k.key===d&&(Ke(k,b,c,a,f),g.dirty=!0);}c=a.__text;this.setTextContent(b?c+e:e+c);b=this.getWritable();a.remove();return b}isTextEntity(){return !1}}
function wf(a){let b="700"===a.style.fontWeight,c="line-through"===a.style.textDecoration,d="italic"===a.style.fontStyle,e="underline"===a.style.textDecoration,f=a.style.verticalAlign;return {forChild:g=>{if(!B$7(g))return g;b&&g.toggleFormat("bold");c&&g.toggleFormat("strikethrough");d&&g.toggleFormat("italic");e&&g.toggleFormat("underline");"sub"===f&&g.toggleFormat("subscript");"super"===f&&g.toggleFormat("superscript");return g},node:null}}function pf(){return {node:pe()}}
function of(a){let b="normal"===a.style.fontWeight;return {forChild:c=>{B$7(c)&&!b&&c.toggleFormat("bold");return c},node:null}}function nf(a,b,c){a=a.textContent||"";return !c&&/\n/.test(a)&&(a=a.replace(/\r?\n/gm," "),0===a.trim().length)?{node:null}:{node:K$5(a)}}let xf={code:"code",em:"italic",i:"italic",s:"strikethrough",strong:"bold",sub:"subscript",sup:"superscript",u:"underline"};
function vf(a){let b=xf[a.nodeName.toLowerCase()];return void 0===b?{node:null}:{forChild:c=>{B$7(c)&&!c.hasFormat(b)&&c.toggleFormat(b);return c},node:null}}function K$5(a=""){return uc(new mf(a))}function B$7(a){return a instanceof mf}
class yf extends $e{static getType(){return "paragraph"}static clone(a){return new yf(a.__key)}createDOM(a){let b=document.createElement("p");a=kc(a.theme,"paragraph");void 0!==a&&b.classList.add(...a);return b}updateDOM(){return !1}static importDOM(){return {p:()=>({conversion:zf,priority:0})}}exportDOM(a){({element:a}=super.exportDOM(a));a&&this.isEmpty()&&a.append(document.createElement("br"));if(a){var b=this.getFormatType();a.style.textAlign=b;if(b=this.getDirection())a.dir=b;b=this.getIndent();
0<b&&(a.style.textIndent=`${20*b}px`);}return {element:a}}static importJSON(a){let b=ae();b.setFormat(a.format);b.setIndent(a.indent);b.setDirection(a.direction);return b}exportJSON(){return {...super.exportJSON(),type:"paragraph",version:1}}insertNewAfter(a,b){a=ae();let c=this.getDirection();a.setDirection(c);this.insertAfter(a,b);return a}collapseAtStart(){let a=this.getChildren();if(0===a.length||B$7(a[0])&&""===a[0].getTextContent().trim()){if(null!==this.getNextSibling())return this.selectNext(),
this.remove(),!0;if(null!==this.getPreviousSibling())return this.selectPrevious(),this.remove(),!0}return !1}}function zf(a){let b=ae();a.style&&(b.setFormat(a.style.textAlign),a=parseInt(a.style.textIndent,10)/20,0<a&&b.setIndent(a));return {node:b}}function ae(){return uc(new yf)}
function Te(a,b,c,d){let e=a._keyToDOMMap;e.clear();a._editorState=cf();a._pendingEditorState=d;a._compositionKey=null;a._dirtyType=0;a._cloneNotNeeded.clear();a._dirtyLeaves=new Set;a._dirtyElements.clear();a._normalizedNodes=new Set;a._updateTags=new Set;a._updates=[];a._blockCursorElement=null;d=a._observer;null!==d&&(d.disconnect(),a._observer=null);null!==b&&(b.textContent="");null!==c&&(c.textContent="",e.set("root",c));}
function Af(a){let b=new Map,c=new Set;a.forEach(d=>{d=null!=d.klass.importDOM?d.klass.importDOM.bind(d.klass):null;if(null!=d&&!c.has(d)){c.add(d);var e=d();null!==e&&Object.keys(e).forEach(f=>{let g=b.get(f);void 0===g&&(g=[],b.set(f,g));g.push(e[f]);});}});return b}
class Bf{constructor(a,b,c,d,e,f,g){this._parentEditor=b;this._rootElement=null;this._editorState=a;this._compositionKey=this._pendingEditorState=null;this._deferred=[];this._keyToDOMMap=new Map;this._updates=[];this._updating=!1;this._listeners={decorator:new Set,editable:new Set,mutation:new Map,root:new Set,textcontent:new Set,update:new Set};this._commands=new Map;this._config=d;this._nodes=c;this._decorators={};this._pendingDecorators=null;this._dirtyType=0;this._cloneNotNeeded=new Set;this._dirtyLeaves=
new Set;this._dirtyElements=new Map;this._normalizedNodes=new Set;this._updateTags=new Set;this._observer=null;this._key=gc();this._onError=e;this._htmlConversions=f;this._editable=g;this._headless=null!==b&&b._headless;this._blockCursorElement=this._window=null;}isComposing(){return null!=this._compositionKey}registerUpdateListener(a){let b=this._listeners.update;b.add(a);return ()=>{b.delete(a);}}registerEditableListener(a){let b=this._listeners.editable;b.add(a);return ()=>{b.delete(a);}}registerDecoratorListener(a){let b=
this._listeners.decorator;b.add(a);return ()=>{b.delete(a);}}registerTextContentListener(a){let b=this._listeners.textcontent;b.add(a);return ()=>{b.delete(a);}}registerRootListener(a){let b=this._listeners.root;a(this._rootElement,null);b.add(a);return ()=>{a(null,this._rootElement);b.delete(a);}}registerCommand(a,b,c){void 0===c&&q$7(35);let d=this._commands;d.has(a)||d.set(a,[new Set,new Set,new Set,new Set,new Set]);let e=d.get(a);void 0===e&&q$7(36);let f=e[c];f.add(b);return ()=>{f.delete(b);e.every(g=>
0===g.size)&&d.delete(a);}}registerMutationListener(a,b){void 0===this._nodes.get(a.getType())&&q$7(37);let c=this._listeners.mutation;c.set(b,a);return ()=>{c.delete(b);}}registerNodeTransformToKlass(a,b){a=a.getType();a=this._nodes.get(a);void 0===a&&q$7(37);a.transforms.add(b);return a}registerNodeTransform(a,b){var c=this.registerNodeTransformToKlass(a,b);let d=[c];c=c.replaceWithKlass;null!=c&&(c=this.registerNodeTransformToKlass(c,b),d.push(c));cc(this,a.getType());return ()=>{d.forEach(e=>e.transforms.delete(b));}}hasNodes(a){for(let b=
0;b<a.length;b++){let c=a[b].getType();if(!this._nodes.has(c))return !1}return !0}dispatchCommand(a,b){return S$3(this,a,b)}getDecorators(){return this._decorators}getRootElement(){return this._rootElement}getKey(){return this._key}setRootElement(a){let b=this._rootElement;if(a!==b){let e=kc(this._config.theme,"root");var c=this._pendingEditorState||this._editorState;this._rootElement=a;Te(this,b,a,c);if(null!==b){if(!this._config.disableEvents){0!==Ed&&(Ed--,0===Ed&&b.ownerDocument.removeEventListener("selectionchange",
Td));c=b.__lexicalEditor;if(null!==c&&void 0!==c){if(null!==c._parentEditor){var d=fc(c);d=d[d.length-1]._key;Sd.get(d)===c&&Sd.delete(d);}else Sd.delete(c._key);b.__lexicalEditor=null;}c=Rd(b);for(d=0;d<c.length;d++)c[d]();b.__lexicalEventHandles=[];}null!=e&&b.classList.remove(...e);}null!==a?(c=(c=a.ownerDocument)&&c.defaultView||null,d=a.style,d.userSelect="text",d.whiteSpace="pre-wrap",d.wordBreak="break-word",a.setAttribute("data-lexical-editor","true"),this._window=c,this._dirtyType=2,Ab(this),
this._updateTags.add("history-merge"),Se(this),this._config.disableEvents||Vd(a,this),null!=e&&a.classList.add(...e)):this._window=null;Ue("root",this,!1,a,b);}}getElementByKey(a){return this._keyToDOMMap.get(a)||null}getEditorState(){return this._editorState}setEditorState(a,b){a.isEmpty()&&q$7(38);zb(this);let c=this._pendingEditorState,d=this._updateTags;b=void 0!==b?b.tag:null;null===c||c.isEmpty()||(null!=b&&d.add(b),Se(this));this._pendingEditorState=a;this._dirtyType=2;this._dirtyElements.set("root",
!1);this._compositionKey=null;null!=b&&d.add(b);Se(this);}parseEditorState(a,b){a="string"===typeof a?JSON.parse(a):a;let c=cf(),d=T$3,e=Z$2,f=Y$3,g=this._dirtyElements,h=this._dirtyLeaves,k=this._cloneNotNeeded,n=this._dirtyType;this._dirtyElements=new Map;this._dirtyLeaves=new Set;this._cloneNotNeeded=new Set;this._dirtyType=0;T$3=c;Z$2=!1;Y$3=this;try{Qe(a.root,this._nodes),b&&b(),c._readOnly=!0;}catch(m){m instanceof Error&&this._onError(m);}finally{this._dirtyElements=g,this._dirtyLeaves=h,this._cloneNotNeeded=
k,this._dirtyType=n,T$3=d,Z$2=e,Y$3=f;}return c}update(a,b){w$6(this,a,b);}focus(a,b={}){let c=this._rootElement;null!==c&&(c.setAttribute("autocapitalize","off"),w$6(this,()=>{let d=v$6(),e=bc();null!==d?d.dirty=!0:0!==e.getChildrenSize()&&("rootStart"===b.defaultSelection?e.selectStart():e.selectEnd());},{onUpdate:()=>{c.removeAttribute("autocapitalize");a&&a();},tag:"focus"}),null===this._pendingEditorState&&c.removeAttribute("autocapitalize"));}blur(){var a=this._rootElement;null!==a&&a.blur();a=E$6(this._window);
null!==a&&a.removeAllRanges();}isEditable(){return this._editable}setEditable(a){this._editable!==a&&(this._editable=a,Ue("editable",this,!0,a));}toJSON(){return {editorState:this._editorState.toJSON()}}}
class Cf extends $e{constructor(a,b){super(b);this.__colSpan=a;this.__rowSpan=1;}exportJSON(){return {...super.exportJSON(),colSpan:this.__colSpan,rowSpan:this.__rowSpan}}getColSpan(){return this.__colSpan}setColSpan(a){this.getWritable().__colSpan=a;return this}getRowSpan(){return this.__rowSpan}setRowSpan(a){this.getWritable().__rowSpan=a;return this}}function ke(a){return a instanceof Cf}class Df extends $e{}function me(a){return a instanceof Df}class Ef extends $e{}
function le(a){return a instanceof Ef}var $addUpdateTag=function(a){G$4();H$6()._updateTags.add(a);};var $applyNodeReplacement=uc;var $copyNode=tc;var $createLineBreakNode=pe;var $createNodeSelection=se;var $createParagraphNode=ae;var $createRangeSelection=function(){let a=new be("root",0,"element"),b=new be("root",0,"element");return new ge(a,b,0,"")};var $createTextNode=K$5;var $getAdjacentNode=nc;var $getNearestNodeFromDOMNode=ub;
var $getNearestRootOrShadowRoot=sc;var $getNodeByKey=J$5;var $getPreviousSelection=ic;var $getRoot=bc;var $getSelection=v$6;var $getTextContent=function(){let a=v$6();return null===a?"":a.getTextContent()};var $hasAncestor=rc;var $hasUpdateTag=function(a){return H$6()._updateTags.has(a)};var $insertNodes=function(a,b){let c=v$6();null===c&&(c=bc().selectEnd());return c.insertNodes(a,b)};var $isDecoratorNode=z$7;var $isElementNode=F$5;
var $isInlineElementOrDecoratorNode=function(a){return F$5(a)&&a.isInline()||z$7(a)&&a.isInline()};var $isLeafNode=Rb;var $isLineBreakNode=Sb;var $isNodeSelection=Qd;var $isParagraphNode=function(a){return a instanceof yf};var $isRangeSelection=C$5;var $isRootNode=L$5;var $isRootOrShadowRoot=M$2;var $isTextNode=B$7;
var $nodesOfType=function(a){var b=Vb();let c=b._readOnly,d=a.getType();b=b._nodeMap;let e=[];for(let [,f]of b)f instanceof a&&f.__type===d&&(c||f.isAttached())&&e.push(f);return e};var $normalizeSelection__EXPERIMENTAL=Gc;var $parseSerializedNode=function(a){return Qe(a,H$6()._nodes)};var $setCompositionKey=I$5;var $setSelection=xb;var $splitNode$2=yc;var BLUR_COMMAND=Sa;var CAN_REDO_COMMAND={};var CAN_UNDO_COMMAND={};var CLEAR_EDITOR_COMMAND={};
var CLEAR_HISTORY_COMMAND={};var CLICK_COMMAND=da$3;var COMMAND_PRIORITY_CRITICAL=4;var COMMAND_PRIORITY_EDITOR=0;var COMMAND_PRIORITY_HIGH=3;var COMMAND_PRIORITY_LOW=1;var COMMAND_PRIORITY_NORMAL=2;var CONTROLLED_TEXT_INSERTION_COMMAND=ka$1;var COPY_COMMAND=Pa;var CUT_COMMAND=Qa;var DELETE_CHARACTER_COMMAND=ea$3;var DELETE_LINE_COMMAND=ra$1;var DELETE_WORD_COMMAND=qa$1;var DEPRECATED_$computeGridMap=ne;
var DEPRECATED_$createGridSelection=function(){let a=new be("root",0,"element"),b=new be("root",0,"element");return new he("root",a,b)};var DEPRECATED_$getNodeTriplet=function(a){a instanceof Cf||(a instanceof Zd?(a=zc(a,ke),ke(a)||q$7(114)):(a=zc(a.getNode(),ke),ke(a)||q$7(114)));let b=a.getParent();le(b)||q$7(115);let c=b.getParent();me(c)||q$7(116);return [a,b,c]};var DEPRECATED_$isGridCellNode=ke;var DEPRECATED_$isGridNode=me;var DEPRECATED_$isGridRowNode=le;
var DEPRECATED_$isGridSelection=ie;var DEPRECATED_GridCellNode=Cf;var DEPRECATED_GridNode=Df;var DEPRECATED_GridRowNode=Ef;var DRAGEND_COMMAND=Oa;var DRAGOVER_COMMAND=Na;var DRAGSTART_COMMAND=Ma;var DROP_COMMAND=La;var DecoratorNode=Ze;var ElementNode=$e;var FOCUS_COMMAND=Ra;var FORMAT_ELEMENT_COMMAND={};var FORMAT_TEXT_COMMAND=sa$1;var INDENT_CONTENT_COMMAND={};var INSERT_LINE_BREAK_COMMAND=fa$3;var INSERT_PARAGRAPH_COMMAND=ja$1;
var KEY_ARROW_DOWN_COMMAND=Ca$1;var KEY_ARROW_LEFT_COMMAND=za$1;var KEY_ARROW_RIGHT_COMMAND=xa$1;var KEY_ARROW_UP_COMMAND=Ba$1;var KEY_BACKSPACE_COMMAND=Ha;var KEY_DELETE_COMMAND=Ja;var KEY_DOWN_COMMAND=wa$1;var KEY_ENTER_COMMAND=Da$1;var KEY_ESCAPE_COMMAND=Ia;var KEY_MODIFIER_COMMAND=Ta;var KEY_SPACE_COMMAND=Ga;var KEY_TAB_COMMAND=Ka;var LineBreakNode=ef;var MOVE_TO_END=ya$1;var MOVE_TO_START=Aa$1;var OUTDENT_CONTENT_COMMAND={};
var PASTE_COMMAND=la$1;var ParagraphNode=yf;var REDO_COMMAND=ua;var REMOVE_TEXT_COMMAND=na$1;var RootNode=bf;var SELECTION_CHANGE_COMMAND=ca$3;var TextNode=mf;var UNDO_COMMAND=ta$1;var createCommand=function(){return {}};
var createEditor=function(a){var b=a||{},c=Y$3,d=b.theme||{};let e=void 0===a?c:b.parentEditor||null,f=b.disableEvents||!1,g=cf(),h=b.namespace||(null!==e?e._config.namespace:gc()),k=b.editorState,n=[bf,mf,ef,yf,...(b.nodes||[])],m=b.onError;b=void 0!==b.editable?b.editable:!0;if(void 0===a&&null!==c)a=c._nodes;else for(a=new Map,c=0;c<n.length;c++){let l=n[c],r=null;var p=null;"function"!==typeof l&&(p=l,l=p.replace,r=p.with,p=p.withKlass?p.withKlass:null);let u=l.getType(),x=l.transform(),y=new Set;
null!==x&&y.add(x);a.set(u,{klass:l,replace:r,replaceWithKlass:p,transforms:y});}d=new Bf(g,e,a,{disableEvents:f,namespace:h,theme:d},m?m:console.error,Af(a),b);void 0!==k&&(d._pendingEditorState=k,d._dirtyType=2);return d};var getNearestEditorFromDOMNode=Gb;var isSelectionCapturedInDecoratorInput=Eb;var isSelectionWithinEditor=Fb;

var Lexical_prod = {
	$addUpdateTag: $addUpdateTag,
	$applyNodeReplacement: $applyNodeReplacement,
	$copyNode: $copyNode,
	$createLineBreakNode: $createLineBreakNode,
	$createNodeSelection: $createNodeSelection,
	$createParagraphNode: $createParagraphNode,
	$createRangeSelection: $createRangeSelection,
	$createTextNode: $createTextNode,
	$getAdjacentNode: $getAdjacentNode,
	$getNearestNodeFromDOMNode: $getNearestNodeFromDOMNode,
	$getNearestRootOrShadowRoot: $getNearestRootOrShadowRoot,
	$getNodeByKey: $getNodeByKey,
	$getPreviousSelection: $getPreviousSelection,
	$getRoot: $getRoot,
	$getSelection: $getSelection,
	$getTextContent: $getTextContent,
	$hasAncestor: $hasAncestor,
	$hasUpdateTag: $hasUpdateTag,
	$insertNodes: $insertNodes,
	$isDecoratorNode: $isDecoratorNode,
	$isElementNode: $isElementNode,
	$isInlineElementOrDecoratorNode: $isInlineElementOrDecoratorNode,
	$isLeafNode: $isLeafNode,
	$isLineBreakNode: $isLineBreakNode,
	$isNodeSelection: $isNodeSelection,
	$isParagraphNode: $isParagraphNode,
	$isRangeSelection: $isRangeSelection,
	$isRootNode: $isRootNode,
	$isRootOrShadowRoot: $isRootOrShadowRoot,
	$isTextNode: $isTextNode,
	$nodesOfType: $nodesOfType,
	$normalizeSelection__EXPERIMENTAL: $normalizeSelection__EXPERIMENTAL,
	$parseSerializedNode: $parseSerializedNode,
	$setCompositionKey: $setCompositionKey,
	$setSelection: $setSelection,
	$splitNode: $splitNode$2,
	BLUR_COMMAND: BLUR_COMMAND,
	CAN_REDO_COMMAND: CAN_REDO_COMMAND,
	CAN_UNDO_COMMAND: CAN_UNDO_COMMAND,
	CLEAR_EDITOR_COMMAND: CLEAR_EDITOR_COMMAND,
	CLEAR_HISTORY_COMMAND: CLEAR_HISTORY_COMMAND,
	CLICK_COMMAND: CLICK_COMMAND,
	COMMAND_PRIORITY_CRITICAL: COMMAND_PRIORITY_CRITICAL,
	COMMAND_PRIORITY_EDITOR: COMMAND_PRIORITY_EDITOR,
	COMMAND_PRIORITY_HIGH: COMMAND_PRIORITY_HIGH,
	COMMAND_PRIORITY_LOW: COMMAND_PRIORITY_LOW,
	COMMAND_PRIORITY_NORMAL: COMMAND_PRIORITY_NORMAL,
	CONTROLLED_TEXT_INSERTION_COMMAND: CONTROLLED_TEXT_INSERTION_COMMAND,
	COPY_COMMAND: COPY_COMMAND,
	CUT_COMMAND: CUT_COMMAND,
	DELETE_CHARACTER_COMMAND: DELETE_CHARACTER_COMMAND,
	DELETE_LINE_COMMAND: DELETE_LINE_COMMAND,
	DELETE_WORD_COMMAND: DELETE_WORD_COMMAND,
	DEPRECATED_$computeGridMap: DEPRECATED_$computeGridMap,
	DEPRECATED_$createGridSelection: DEPRECATED_$createGridSelection,
	DEPRECATED_$getNodeTriplet: DEPRECATED_$getNodeTriplet,
	DEPRECATED_$isGridCellNode: DEPRECATED_$isGridCellNode,
	DEPRECATED_$isGridNode: DEPRECATED_$isGridNode,
	DEPRECATED_$isGridRowNode: DEPRECATED_$isGridRowNode,
	DEPRECATED_$isGridSelection: DEPRECATED_$isGridSelection,
	DEPRECATED_GridCellNode: DEPRECATED_GridCellNode,
	DEPRECATED_GridNode: DEPRECATED_GridNode,
	DEPRECATED_GridRowNode: DEPRECATED_GridRowNode,
	DRAGEND_COMMAND: DRAGEND_COMMAND,
	DRAGOVER_COMMAND: DRAGOVER_COMMAND,
	DRAGSTART_COMMAND: DRAGSTART_COMMAND,
	DROP_COMMAND: DROP_COMMAND,
	DecoratorNode: DecoratorNode,
	ElementNode: ElementNode,
	FOCUS_COMMAND: FOCUS_COMMAND,
	FORMAT_ELEMENT_COMMAND: FORMAT_ELEMENT_COMMAND,
	FORMAT_TEXT_COMMAND: FORMAT_TEXT_COMMAND,
	INDENT_CONTENT_COMMAND: INDENT_CONTENT_COMMAND,
	INSERT_LINE_BREAK_COMMAND: INSERT_LINE_BREAK_COMMAND,
	INSERT_PARAGRAPH_COMMAND: INSERT_PARAGRAPH_COMMAND,
	KEY_ARROW_DOWN_COMMAND: KEY_ARROW_DOWN_COMMAND,
	KEY_ARROW_LEFT_COMMAND: KEY_ARROW_LEFT_COMMAND,
	KEY_ARROW_RIGHT_COMMAND: KEY_ARROW_RIGHT_COMMAND,
	KEY_ARROW_UP_COMMAND: KEY_ARROW_UP_COMMAND,
	KEY_BACKSPACE_COMMAND: KEY_BACKSPACE_COMMAND,
	KEY_DELETE_COMMAND: KEY_DELETE_COMMAND,
	KEY_DOWN_COMMAND: KEY_DOWN_COMMAND,
	KEY_ENTER_COMMAND: KEY_ENTER_COMMAND,
	KEY_ESCAPE_COMMAND: KEY_ESCAPE_COMMAND,
	KEY_MODIFIER_COMMAND: KEY_MODIFIER_COMMAND,
	KEY_SPACE_COMMAND: KEY_SPACE_COMMAND,
	KEY_TAB_COMMAND: KEY_TAB_COMMAND,
	LineBreakNode: LineBreakNode,
	MOVE_TO_END: MOVE_TO_END,
	MOVE_TO_START: MOVE_TO_START,
	OUTDENT_CONTENT_COMMAND: OUTDENT_CONTENT_COMMAND,
	PASTE_COMMAND: PASTE_COMMAND,
	ParagraphNode: ParagraphNode,
	REDO_COMMAND: REDO_COMMAND,
	REMOVE_TEXT_COMMAND: REMOVE_TEXT_COMMAND,
	RootNode: RootNode,
	SELECTION_CHANGE_COMMAND: SELECTION_CHANGE_COMMAND,
	TextNode: TextNode,
	UNDO_COMMAND: UNDO_COMMAND,
	createCommand: createCommand,
	createEditor: createEditor,
	getNearestEditorFromDOMNode: getNearestEditorFromDOMNode,
	isSelectionCapturedInDecoratorInput: isSelectionCapturedInDecoratorInput,
	isSelectionWithinEditor: isSelectionWithinEditor
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const Lexical = process.env.NODE_ENV === 'development' ? Lexical_dev : Lexical_prod;
var Lexical_1 = Lexical;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const CSS_TO_STYLES = new Map();

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

function getDOMTextNode(element) {
  let node = element;

  while (node != null) {
    if (node.nodeType === Node.TEXT_NODE) {
      return node;
    }

    node = node.firstChild;
  }

  return null;
}

function getDOMIndexWithinParent(node) {
  const parent = node.parentNode;

  if (parent == null) {
    throw new Error('Should never happen');
  }

  return [parent, Array.from(parent.childNodes).indexOf(node)];
}
/**
 * Creates a selection range for the DOM.
 * @param editor - The lexical editor.
 * @param anchorNode - The anchor node of a selection.
 * @param _anchorOffset - The amount of space offset from the anchor to the focus.
 * @param focusNode - The current focus.
 * @param _focusOffset - The amount of space offset from the focus to the anchor.
 * @returns The range of selection for the DOM that was created.
 */


function createDOMRange$1(editor, anchorNode, _anchorOffset, focusNode, _focusOffset) {
  const anchorKey = anchorNode.getKey();
  const focusKey = focusNode.getKey();
  const range = document.createRange();
  let anchorDOM = editor.getElementByKey(anchorKey);
  let focusDOM = editor.getElementByKey(focusKey);
  let anchorOffset = _anchorOffset;
  let focusOffset = _focusOffset;

  if (Lexical_1.$isTextNode(anchorNode)) {
    anchorDOM = getDOMTextNode(anchorDOM);
  }

  if (Lexical_1.$isTextNode(focusNode)) {
    focusDOM = getDOMTextNode(focusDOM);
  }

  if (anchorNode === undefined || focusNode === undefined || anchorDOM === null || focusDOM === null) {
    return null;
  }

  if (anchorDOM.nodeName === 'BR') {
    [anchorDOM, anchorOffset] = getDOMIndexWithinParent(anchorDOM);
  }

  if (focusDOM.nodeName === 'BR') {
    [focusDOM, focusOffset] = getDOMIndexWithinParent(focusDOM);
  }

  const firstChild = anchorDOM.firstChild;

  if (anchorDOM === focusDOM && firstChild != null && firstChild.nodeName === 'BR' && anchorOffset === 0 && focusOffset === 0) {
    focusOffset = 1;
  }

  try {
    range.setStart(anchorDOM, anchorOffset);
    range.setEnd(focusDOM, focusOffset);
  } catch (e) {
    return null;
  }

  if (range.collapsed && (anchorOffset !== focusOffset || anchorKey !== focusKey)) {
    // Range is backwards, we need to reverse it
    range.setStart(focusDOM, focusOffset);
    range.setEnd(anchorDOM, anchorOffset);
  }

  return range;
}
/**
 * Creates DOMRects, generally used to help the editor find a specific location on the screen.
 * @param editor - The lexical editor
 * @param range - A fragment of a document that can contain nodes and parts of text nodes.
 * @returns The selectionRects as an array.
 */

function createRectsFromDOMRange$1(editor, range) {
  const rootElement = editor.getRootElement();

  if (rootElement === null) {
    return [];
  }

  const rootRect = rootElement.getBoundingClientRect();
  const computedStyle = getComputedStyle(rootElement);
  const rootPadding = parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);
  const selectionRects = Array.from(range.getClientRects());
  let selectionRectsLength = selectionRects.length;
  let prevRect;

  for (let i = 0; i < selectionRectsLength; i++) {
    const selectionRect = selectionRects[i]; // Exclude a rect that is the exact same as the last rect. getClientRects() can return
    // the same rect twice for some elements. A more sophisticated thing to do here is to
    // merge all the rects together into a set of rects that don't overlap, so we don't
    // generate backgrounds that are too dark.

    const isDuplicateRect = prevRect && prevRect.top === selectionRect.top && prevRect.left === selectionRect.left && prevRect.width === selectionRect.width && prevRect.height === selectionRect.height; // Exclude selections that span the entire element

    const selectionSpansElement = selectionRect.width + rootPadding === rootRect.width;

    if (isDuplicateRect || selectionSpansElement) {
      selectionRects.splice(i--, 1);
      selectionRectsLength--;
      continue;
    }

    prevRect = selectionRect;
  }

  return selectionRects;
}
/**
 * Creates an object containing all the styles and their values provided in the CSS string.
 * @param css - The CSS string of styles and their values.
 * @returns The styleObject containing all the styles and their values.
 */

function getStyleObjectFromRawCSS(css) {
  const styleObject = {};
  const styles = css.split(';');

  for (const style of styles) {
    if (style !== '') {
      const [key, value] = style.split(/:([^]+)/); // split on first colon

      styleObject[key.trim()] = value.trim();
    }
  }

  return styleObject;
}
/**
 * Given a CSS string, returns an object from the style cache.
 * @param css - The CSS property as a string.
 * @returns The value of the given CSS property.
 */

function getStyleObjectFromCSS$1(css) {
  let value = CSS_TO_STYLES.get(css);

  if (value === undefined) {
    value = getStyleObjectFromRawCSS(css);
    CSS_TO_STYLES.set(css, value);
  }

  return value;
}
/**
 * Gets the CSS styles from the style object.
 * @param styles - The style object containing the styles to get.
 * @returns A string containing the CSS styles and their values.
 */

function getCSSFromStyleObject(styles) {
  let css = '';

  for (const style in styles) {
    if (style) {
      css += `${style}: ${styles[style]};`;
    }
  }

  return css;
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

function $updateElementNodeProperties(target, source) {
  target.__first = source.__first;
  target.__last = source.__last;
  target.__size = source.__size;
  target.__format = source.__format;
  target.__indent = source.__indent;
  target.__dir = source.__dir;
  return target;
}

function $updateTextNodeProperties(target, source) {
  target.__format = source.__format;
  target.__style = source.__style;
  target.__mode = source.__mode;
  target.__detail = source.__detail;
  return target;
}
/**
 * Returns a copy of a node, but generates a new key for the copy.
 * @param node - The node to be cloned.
 * @returns The clone of the node.
 */


function $cloneWithProperties$1(node) {
  const latest = node.getLatest();
  const constructor = latest.constructor; // @ts-expect-error

  const clone = constructor.clone(latest);
  clone.__parent = latest.__parent;
  clone.__next = latest.__next;
  clone.__prev = latest.__prev;

  if (Lexical_1.$isElementNode(latest) && Lexical_1.$isElementNode(clone)) {
    return $updateElementNodeProperties(clone, latest);
  }

  if (Lexical_1.$isTextNode(latest) && Lexical_1.$isTextNode(clone)) {
    return $updateTextNodeProperties(clone, latest);
  }

  return clone;
}
/**
 * Generally used to append text content to HTML and JSON. Grabs the text content and "slices"
 * it to be generated into the new TextNode.
 * @param selection - The selection containing the node whose TextNode is to be edited.
 * @param textNode - The TextNode to be edited.
 * @returns The updated TextNode.
 */

function $sliceSelectedTextNodeContent$1(selection, textNode) {
  if (textNode.isSelected() && !textNode.isSegmented() && !textNode.isToken() && (Lexical_1.$isRangeSelection(selection) || Lexical_1.DEPRECATED_$isGridSelection(selection))) {
    const anchorNode = selection.anchor.getNode();
    const focusNode = selection.focus.getNode();
    const isAnchor = textNode.is(anchorNode);
    const isFocus = textNode.is(focusNode);

    if (isAnchor || isFocus) {
      const isBackward = selection.isBackward();
      const [anchorOffset, focusOffset] = selection.getCharacterOffsets();
      const isSame = anchorNode.is(focusNode);
      const isFirst = textNode.is(isBackward ? focusNode : anchorNode);
      const isLast = textNode.is(isBackward ? anchorNode : focusNode);
      let startOffset = 0;
      let endOffset = undefined;

      if (isSame) {
        startOffset = anchorOffset > focusOffset ? focusOffset : anchorOffset;
        endOffset = anchorOffset > focusOffset ? anchorOffset : focusOffset;
      } else if (isFirst) {
        const offset = isBackward ? focusOffset : anchorOffset;
        startOffset = offset;
        endOffset = undefined;
      } else if (isLast) {
        const offset = isBackward ? anchorOffset : focusOffset;
        startOffset = 0;
        endOffset = offset;
      }

      textNode.__text = textNode.__text.slice(startOffset, endOffset);
      return textNode;
    }
  }

  return textNode;
}
/**
 * Determines if the current selection is at the end of the node.
 * @param point - The point of the selection to test.
 * @returns true if the provided point offset is in the last possible position, false otherwise.
 */

function $isAtNodeEnd$1(point) {
  if (point.type === 'text') {
    return point.offset === point.getNode().getTextContentSize();
  }

  return point.offset === point.getNode().getChildrenSize();
}
/**
 * Trims text from a node in order to shorten it, eg. to enforce a text's max length. If it deletes text
 * that is an ancestor of the anchor then it will leave 2 indents, otherwise, if no text content exists, it deletes
 * the TextNode. It will move the focus to either the end of any left over text or beginning of a new TextNode.
 * @param editor - The lexical editor.
 * @param anchor - The anchor of the current selection, where the selection should be pointing.
 * @param delCount - The amount of characters to delete. Useful as a dynamic variable eg. textContentSize - maxLength;
 */

function trimTextContentFromAnchor$1(editor, anchor, delCount) {
  // Work from the current selection anchor point
  let currentNode = anchor.getNode();
  let remaining = delCount;

  if (Lexical_1.$isElementNode(currentNode)) {
    const descendantNode = currentNode.getDescendantByIndex(anchor.offset);

    if (descendantNode !== null) {
      currentNode = descendantNode;
    }
  }

  while (remaining > 0 && currentNode !== null) {
    let nextNode = currentNode.getPreviousSibling();
    let additionalElementWhitespace = 0;

    if (nextNode === null) {
      let parent = currentNode.getParentOrThrow();
      let parentSibling = parent.getPreviousSibling();

      while (parentSibling === null) {
        parent = parent.getParent();

        if (parent === null) {
          nextNode = null;
          break;
        }

        parentSibling = parent.getPreviousSibling();
      }

      if (parent !== null) {
        additionalElementWhitespace = parent.isInline() ? 0 : 2;

        if (Lexical_1.$isElementNode(parentSibling)) {
          nextNode = parentSibling.getLastDescendant();
        } else {
          nextNode = parentSibling;
        }
      }
    }

    let text = currentNode.getTextContent(); // If the text is empty, we need to consider adding in two line breaks to match
    // the content if we were to get it from its parent.

    if (text === '' && Lexical_1.$isElementNode(currentNode) && !currentNode.isInline()) {
      // TODO: should this be handled in core?
      text = '\n\n';
    }

    const currentNodeSize = currentNode.getTextContentSize();

    if (!Lexical_1.$isTextNode(currentNode) || remaining >= currentNodeSize) {
      const parent = currentNode.getParent();
      currentNode.remove();

      if (parent != null && parent.getChildrenSize() === 0 && !Lexical_1.$isRootNode(parent)) {
        parent.remove();
      }

      remaining -= currentNodeSize + additionalElementWhitespace;
      currentNode = nextNode;
    } else {
      const key = currentNode.getKey(); // See if we can just revert it to what was in the last editor state

      const prevTextContent = editor.getEditorState().read(() => {
        const prevNode = Lexical_1.$getNodeByKey(key);

        if (Lexical_1.$isTextNode(prevNode) && prevNode.isSimpleText()) {
          return prevNode.getTextContent();
        }

        return null;
      });
      const offset = currentNodeSize - remaining;
      const slicedText = text.slice(0, offset);

      if (prevTextContent !== null && prevTextContent !== text) {
        const prevSelection = Lexical_1.$getPreviousSelection();
        let target = currentNode;

        if (!currentNode.isSimpleText()) {
          const textNode = Lexical_1.$createTextNode(prevTextContent);
          currentNode.replace(textNode);
          target = textNode;
        } else {
          currentNode.setTextContent(prevTextContent);
        }

        if (Lexical_1.$isRangeSelection(prevSelection) && prevSelection.isCollapsed()) {
          const prevOffset = prevSelection.anchor.offset;
          target.select(prevOffset, prevOffset);
        }
      } else if (currentNode.isSimpleText()) {
        // Split text
        const isSelected = anchor.key === key;
        let anchorOffset = anchor.offset; // Move offset to end if it's less than the remaining number, otherwise
        // we'll have a negative splitStart.

        if (anchorOffset < remaining) {
          anchorOffset = currentNodeSize;
        }

        const splitStart = isSelected ? anchorOffset - remaining : 0;
        const splitEnd = isSelected ? anchorOffset : offset;

        if (isSelected && splitStart === 0) {
          const [excessNode] = currentNode.splitText(splitStart, splitEnd);
          excessNode.remove();
        } else {
          const [, excessNode] = currentNode.splitText(splitStart, splitEnd);
          excessNode.remove();
        }
      } else {
        const textNode = Lexical_1.$createTextNode(slicedText);
        currentNode.replace(textNode);
      }

      remaining = 0;
    }
  }
}
/**
 * Gets the TextNode's style object and adds the styles to the CSS.
 * @param node - The TextNode to add styles to.
 */

function $addNodeStyle$1(node) {
  const CSSText = node.getStyle();
  const styles = getStyleObjectFromRawCSS(CSSText);
  CSS_TO_STYLES.set(CSSText, styles);
}

function $patchStyle(target, patch) {
  const prevStyles = getStyleObjectFromCSS$1('getStyle' in target ? target.getStyle() : target.style);
  const newStyles = Object.entries(patch).reduce((styles, [key, value]) => {
    if (value === null) {
      delete styles[key];
    } else {
      styles[key] = value;
    }

    return styles;
  }, { ...prevStyles
  } || {});
  const newCSSText = getCSSFromStyleObject(newStyles);
  target.setStyle(newCSSText);
  CSS_TO_STYLES.set(newCSSText, newStyles);
}
/**
 * Applies the provided styles to the TextNodes in the provided Selection.
 * Will update partially selected TextNodes by splitting the TextNode and applying
 * the styles to the appropriate one.
 * @param selection - The selected node(s) to update.
 * @param patch - The patch to apply, which can include multiple styles. { CSSProperty: value }
 */


function $patchStyleText$1(selection, patch) {
  const selectedNodes = selection.getNodes();
  const selectedNodesLength = selectedNodes.length;
  const lastIndex = selectedNodesLength - 1;
  let firstNode = selectedNodes[0];
  let lastNode = selectedNodes[lastIndex];

  if (selection.isCollapsed()) {
    $patchStyle(selection, patch);
    return;
  }

  const anchor = selection.anchor;
  const focus = selection.focus;
  const firstNodeText = firstNode.getTextContent();
  const firstNodeTextLength = firstNodeText.length;
  const focusOffset = focus.offset;
  let anchorOffset = anchor.offset;
  const isBefore = anchor.isBefore(focus);
  let startOffset = isBefore ? anchorOffset : focusOffset;
  let endOffset = isBefore ? focusOffset : anchorOffset;
  const startType = isBefore ? anchor.type : focus.type;
  const endType = isBefore ? focus.type : anchor.type;
  const endKey = isBefore ? focus.key : anchor.key; // This is the case where the user only selected the very end of the
  // first node so we don't want to include it in the formatting change.

  if (Lexical_1.$isTextNode(firstNode) && startOffset === firstNodeTextLength) {
    const nextSibling = firstNode.getNextSibling();

    if (Lexical_1.$isTextNode(nextSibling)) {
      // we basically make the second node the firstNode, changing offsets accordingly
      anchorOffset = 0;
      startOffset = 0;
      firstNode = nextSibling;
    }
  } // This is the case where we only selected a single node


  if (selectedNodes.length === 1) {
    if (Lexical_1.$isTextNode(firstNode)) {
      startOffset = startType === 'element' ? 0 : anchorOffset > focusOffset ? focusOffset : anchorOffset;
      endOffset = endType === 'element' ? firstNodeTextLength : anchorOffset > focusOffset ? anchorOffset : focusOffset; // No actual text is selected, so do nothing.

      if (startOffset === endOffset) {
        return;
      } // The entire node is selected, so just format it


      if (startOffset === 0 && endOffset === firstNodeTextLength) {
        $patchStyle(firstNode, patch);
        firstNode.select(startOffset, endOffset);
      } else {
        // The node is partially selected, so split it into two nodes
        // and style the selected one.
        const splitNodes = firstNode.splitText(startOffset, endOffset);
        const replacement = startOffset === 0 ? splitNodes[0] : splitNodes[1];
        $patchStyle(replacement, patch);
        replacement.select(0, endOffset - startOffset);
      }
    } // multiple nodes selected.

  } else {
    if (Lexical_1.$isTextNode(firstNode) && startOffset < firstNode.getTextContentSize()) {
      if (startOffset !== 0) {
        // the entire first node isn't selected, so split it
        firstNode = firstNode.splitText(startOffset)[1];
        startOffset = 0;
      }

      $patchStyle(firstNode, patch);
    }

    if (Lexical_1.$isTextNode(lastNode)) {
      const lastNodeText = lastNode.getTextContent();
      const lastNodeTextLength = lastNodeText.length; // The last node might not actually be the end node
      //
      // If not, assume the last node is fully-selected unless the end offset is
      // zero.

      if (lastNode.__key !== endKey && endOffset !== 0) {
        endOffset = lastNodeTextLength;
      } // if the entire last node isn't selected, split it


      if (endOffset !== lastNodeTextLength) {
        [lastNode] = lastNode.splitText(endOffset);
      }

      if (endOffset !== 0) {
        $patchStyle(lastNode, patch);
      }
    } // style all the text nodes in between


    for (let i = 1; i < lastIndex; i++) {
      const selectedNode = selectedNodes[i];
      const selectedNodeKey = selectedNode.getKey();

      if (Lexical_1.$isTextNode(selectedNode) && selectedNodeKey !== firstNode.getKey() && selectedNodeKey !== lastNode.getKey() && !selectedNode.isToken()) {
        $patchStyle(selectedNode, patch);
      }
    }
  }
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
/**
 * Converts all nodes in the selection that are of one block type to another.
 * @param selection - The selected blocks to be converted.
 * @param createElement - The function that creates the node. eg. $createParagraphNode.
 */

function $setBlocksType$1(selection, createElement) {
  if (selection.anchor.key === 'root') {
    const element = createElement();
    const root = Lexical_1.$getRoot();
    const firstChild = root.getFirstChild();

    if (firstChild) {
      firstChild.replace(element, true);
    } else {
      root.append(element);
    }

    return;
  }

  const nodes = selection.getNodes();
  let maybeBlock = selection.anchor.getNode().getParentOrThrow();

  if (nodes.indexOf(maybeBlock) === -1) {
    nodes.push(maybeBlock);
  }

  if (maybeBlock.isInline()) {
    maybeBlock = maybeBlock.getParentOrThrow();

    if (nodes.indexOf(maybeBlock) === -1) {
      nodes.push(maybeBlock);
    }
  }

  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i];

    if (!isBlock(node)) {
      continue;
    }

    const targetElement = createElement();
    targetElement.setFormat(node.getFormatType());
    targetElement.setIndent(node.getIndent());
    node.replace(targetElement, true);
  }
}

function isBlock(node) {
  if (!Lexical_1.$isElementNode(node) || Lexical_1.$isRootOrShadowRoot(node)) {
    return false;
  }

  const firstChild = node.getFirstChild();
  const isLeafElement = firstChild === null || Lexical_1.$isTextNode(firstChild) || firstChild.isInline();
  return !node.isInline() && node.canBeEmpty() !== false && isLeafElement;
}

function isPointAttached(point) {
  return point.getNode().isAttached();
}

function $removeParentEmptyElements(startingNode) {
  let node = startingNode;

  while (node !== null && !Lexical_1.$isRootOrShadowRoot(node)) {
    const latest = node.getLatest();
    const parentNode = node.getParent();

    if (latest.getChildrenSize() === 0) {
      node.remove(true);
    }

    node = parentNode;
  }
}
/**
 * @deprecated
 * Wraps all nodes in the selection into another node of the type returned by createElement.
 * @param selection - The selection of nodes to be wrapped.
 * @param createElement - A function that creates the wrapping ElementNode. eg. $createParagraphNode.
 * @param wrappingElement - An element to append the wrapped selection and its children to.
 */


function $wrapNodes$1(selection, createElement, wrappingElement = null) {
  const nodes = selection.getNodes();
  const nodesLength = nodes.length;
  const anchor = selection.anchor;

  if (nodesLength === 0 || nodesLength === 1 && anchor.type === 'element' && anchor.getNode().getChildrenSize() === 0) {
    const target = anchor.type === 'text' ? anchor.getNode().getParentOrThrow() : anchor.getNode();
    const children = target.getChildren();
    let element = createElement();
    element.setFormat(target.getFormatType());
    element.setIndent(target.getIndent());
    children.forEach(child => element.append(child));

    if (wrappingElement) {
      element = wrappingElement.append(element);
    }

    target.replace(element);
    return;
  }

  let topLevelNode = null;
  let descendants = [];

  for (let i = 0; i < nodesLength; i++) {
    const node = nodes[i]; // Determine whether wrapping has to be broken down into multiple chunks. This can happen if the
    // user selected multiple Root-like nodes that have to be treated separately as if they are
    // their own branch. I.e. you don't want to wrap a whole table, but rather the contents of each
    // of each of the cell nodes.

    if (Lexical_1.$isRootOrShadowRoot(node)) {
      $wrapNodesImpl(selection, descendants, descendants.length, createElement, wrappingElement);
      descendants = [];
      topLevelNode = node;
    } else if (topLevelNode === null || topLevelNode !== null && Lexical_1.$hasAncestor(node, topLevelNode)) {
      descendants.push(node);
    } else {
      $wrapNodesImpl(selection, descendants, descendants.length, createElement, wrappingElement);
      descendants = [node];
    }
  }

  $wrapNodesImpl(selection, descendants, descendants.length, createElement, wrappingElement);
}
/**
 * Wraps each node into a new ElementNode.
 * @param selection - The selection of nodes to wrap.
 * @param nodes - An array of nodes, generally the descendants of the selection.
 * @param nodesLength - The length of nodes.
 * @param createElement - A function that creates the wrapping ElementNode. eg. $createParagraphNode.
 * @param wrappingElement - An element to wrap all the nodes into.
 * @returns
 */

function $wrapNodesImpl(selection, nodes, nodesLength, createElement, wrappingElement = null) {
  if (nodes.length === 0) {
    return;
  }

  const firstNode = nodes[0];
  const elementMapping = new Map();
  const elements = []; // The below logic is to find the right target for us to
  // either insertAfter/insertBefore/append the corresponding
  // elements to. This is made more complicated due to nested
  // structures.

  let target = Lexical_1.$isElementNode(firstNode) ? firstNode : firstNode.getParentOrThrow();

  if (target.isInline()) {
    target = target.getParentOrThrow();
  }

  let targetIsPrevSibling = false;

  while (target !== null) {
    const prevSibling = target.getPreviousSibling();

    if (prevSibling !== null) {
      target = prevSibling;
      targetIsPrevSibling = true;
      break;
    }

    target = target.getParentOrThrow();

    if (Lexical_1.$isRootOrShadowRoot(target)) {
      break;
    }
  }

  const emptyElements = new Set(); // Find any top level empty elements

  for (let i = 0; i < nodesLength; i++) {
    const node = nodes[i];

    if (Lexical_1.$isElementNode(node) && node.getChildrenSize() === 0) {
      emptyElements.add(node.getKey());
    }
  }

  const movedNodes = new Set(); // Move out all leaf nodes into our elements array.
  // If we find a top level empty element, also move make
  // an element for that.

  for (let i = 0; i < nodesLength; i++) {
    const node = nodes[i];
    let parent = node.getParent();

    if (parent !== null && parent.isInline()) {
      parent = parent.getParent();
    }

    if (parent !== null && Lexical_1.$isLeafNode(node) && !movedNodes.has(node.getKey())) {
      const parentKey = parent.getKey();

      if (elementMapping.get(parentKey) === undefined) {
        const targetElement = createElement();
        targetElement.setFormat(parent.getFormatType());
        targetElement.setIndent(parent.getIndent());
        elements.push(targetElement);
        elementMapping.set(parentKey, targetElement); // Move node and its siblings to the new
        // element.

        parent.getChildren().forEach(child => {
          targetElement.append(child);
          movedNodes.add(child.getKey());

          if (Lexical_1.$isElementNode(child)) {
            // Skip nested leaf nodes if the parent has already been moved
            child.getChildrenKeys().forEach(key => movedNodes.add(key));
          }
        });
        $removeParentEmptyElements(parent);
      }
    } else if (emptyElements.has(node.getKey())) {
      const targetElement = createElement();
      targetElement.setFormat(node.getFormatType());
      targetElement.setIndent(node.getIndent());
      elements.push(targetElement);
      node.remove(true);
    }
  }

  if (wrappingElement !== null) {
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      wrappingElement.append(element);
    }
  }

  let lastElement = null; // If our target is Root-like, let's see if we can re-adjust
  // so that the target is the first child instead.

  if (Lexical_1.$isRootOrShadowRoot(target)) {
    if (targetIsPrevSibling) {
      if (wrappingElement !== null) {
        target.insertAfter(wrappingElement);
      } else {
        for (let i = elements.length - 1; i >= 0; i--) {
          const element = elements[i];
          target.insertAfter(element);
        }
      }
    } else {
      const firstChild = target.getFirstChild();

      if (Lexical_1.$isElementNode(firstChild)) {
        target = firstChild;
      }

      if (firstChild === null) {
        if (wrappingElement) {
          target.append(wrappingElement);
        } else {
          for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            target.append(element);
            lastElement = element;
          }
        }
      } else {
        if (wrappingElement !== null) {
          firstChild.insertBefore(wrappingElement);
        } else {
          for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            firstChild.insertBefore(element);
            lastElement = element;
          }
        }
      }
    }
  } else {
    if (wrappingElement) {
      target.insertAfter(wrappingElement);
    } else {
      for (let i = elements.length - 1; i >= 0; i--) {
        const element = elements[i];
        target.insertAfter(element);
        lastElement = element;
      }
    }
  }

  const prevSelection = Lexical_1.$getPreviousSelection();

  if (Lexical_1.$isRangeSelection(prevSelection) && isPointAttached(prevSelection.anchor) && isPointAttached(prevSelection.focus)) {
    Lexical_1.$setSelection(prevSelection.clone());
  } else if (lastElement !== null) {
    lastElement.selectEnd();
  } else {
    selection.dirty = true;
  }
}
/**
 * Determines if the default character selection should be overridden. Used with DecoratorNodes
 * @param selection - The selection whose default character selection may need to be overridden.
 * @param isBackward - Is the selection backwards (the focus comes before the anchor)?
 * @returns true if it should be overridden, false if not.
 */

function $shouldOverrideDefaultCharacterSelection$1(selection, isBackward) {
  const possibleNode = Lexical_1.$getAdjacentNode(selection.focus, isBackward);
  return Lexical_1.$isDecoratorNode(possibleNode) && !possibleNode.isIsolated() || Lexical_1.$isElementNode(possibleNode) && !possibleNode.isInline() && !possibleNode.canBeEmpty();
}
/**
 * Moves the selection according to the arguments.
 * @param selection - The selected text or nodes.
 * @param isHoldingShift - Is the shift key being held down during the operation.
 * @param isBackward - Is the selection selected backwards (the focus comes before the anchor)?
 * @param granularity - The distance to adjust the current selection.
 */

function $moveCaretSelection$1(selection, isHoldingShift, isBackward, granularity) {
  selection.modify(isHoldingShift ? 'extend' : 'move', isBackward, granularity);
}
/**
 * Tests a parent element for right to left direction.
 * @param selection - The selection whose parent is to be tested.
 * @returns true if the selections' parent element has a direction of 'rtl' (right to left), false otherwise.
 */

function $isParentElementRTL$1(selection) {
  const anchorNode = selection.anchor.getNode();
  const parent = Lexical_1.$isRootNode(anchorNode) ? anchorNode : anchorNode.getParentOrThrow();
  return parent.getDirection() === 'rtl';
}
/**
 * Moves selection by character according to arguments.
 * @param selection - The selection of the characters to move.
 * @param isHoldingShift - Is the shift key being held down during the operation.
 * @param isBackward - Is the selection backward (the focus comes before the anchor)?
 */

function $moveCharacter$1(selection, isHoldingShift, isBackward) {
  const isRTL = $isParentElementRTL$1(selection);
  $moveCaretSelection$1(selection, isHoldingShift, isBackward ? !isRTL : isRTL, 'character');
}
/**
 * Expands the current Selection to cover all of the content in the editor.
 * @param selection - The current selection.
 */

function $selectAll$1(selection) {
  const anchor = selection.anchor;
  const focus = selection.focus;
  const anchorNode = anchor.getNode();
  const topParent = anchorNode.getTopLevelElementOrThrow();
  const root = topParent.getParentOrThrow();
  let firstNode = root.getFirstDescendant();
  let lastNode = root.getLastDescendant();
  let firstType = 'element';
  let lastType = 'element';
  let lastOffset = 0;

  if (Lexical_1.$isTextNode(firstNode)) {
    firstType = 'text';
  } else if (!Lexical_1.$isElementNode(firstNode) && firstNode !== null) {
    firstNode = firstNode.getParentOrThrow();
  }

  if (Lexical_1.$isTextNode(lastNode)) {
    lastType = 'text';
    lastOffset = lastNode.getTextContentSize();
  } else if (!Lexical_1.$isElementNode(lastNode) && lastNode !== null) {
    lastNode = lastNode.getParentOrThrow();
  }

  if (firstNode && lastNode) {
    anchor.set(firstNode.getKey(), 0, firstType);
    focus.set(lastNode.getKey(), lastOffset, lastType);
  }
}
/**
 * Returns the current value of a CSS property for Nodes, if set. If not set, it returns the defaultValue.
 * @param node - The node whose style value to get.
 * @param styleProperty - The CSS style property.
 * @param defaultValue - The default value for the property.
 * @returns The value of the property for node.
 */

function $getNodeStyleValueForProperty(node, styleProperty, defaultValue) {
  const css = node.getStyle();
  const styleObject = getStyleObjectFromCSS$1(css);

  if (styleObject !== null) {
    return styleObject[styleProperty] || defaultValue;
  }

  return defaultValue;
}
/**
 * Returns the current value of a CSS property for TextNodes in the Selection, if set. If not set, it returns the defaultValue.
 * If all TextNodes do not have the same value, it returns an empty string.
 * @param selection - The selection of TextNodes whose value to find.
 * @param styleProperty - The CSS style property.
 * @param defaultValue - The default value for the property, defaults to an empty string.
 * @returns The value of the property for the selected TextNodes.
 */


function $getSelectionStyleValueForProperty$1(selection, styleProperty, defaultValue = '') {
  let styleValue = null;
  const nodes = selection.getNodes();
  const anchor = selection.anchor;
  const focus = selection.focus;
  const isBackward = selection.isBackward();
  const endOffset = isBackward ? focus.offset : anchor.offset;
  const endNode = isBackward ? focus.getNode() : anchor.getNode();

  if (selection.style !== '') {
    const css = selection.style;
    const styleObject = getStyleObjectFromCSS$1(css);

    if (styleObject !== null && styleProperty in styleObject) {
      return styleObject[styleProperty];
    }
  }

  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i]; // if no actual characters in the end node are selected, we don't
    // include it in the selection for purposes of determining style
    // value

    if (i !== 0 && endOffset === 0 && node.is(endNode)) {
      continue;
    }

    if (Lexical_1.$isTextNode(node)) {
      const nodeStyleValue = $getNodeStyleValueForProperty(node, styleProperty, defaultValue);

      if (styleValue === null) {
        styleValue = nodeStyleValue;
      } else if (styleValue !== nodeStyleValue) {
        // multiple text nodes are in the selection and they don't all
        // have the same style.
        styleValue = '';
        break;
      }
    }
  }

  return styleValue === null ? defaultValue : styleValue;
}

var $addNodeStyle_1 = $addNodeStyle$1;
var $cloneWithProperties_1 = $cloneWithProperties$1;
var $getSelectionStyleValueForProperty_1 = $getSelectionStyleValueForProperty$1;
var $isAtNodeEnd_1 = $isAtNodeEnd$1;
var $isParentElementRTL_1 = $isParentElementRTL$1;
var $moveCaretSelection_1 = $moveCaretSelection$1;
var $moveCharacter_1 = $moveCharacter$1;
var $patchStyleText_1 = $patchStyleText$1;
var $selectAll_1 = $selectAll$1;
var $setBlocksType_1 = $setBlocksType$1;
var $shouldOverrideDefaultCharacterSelection_1 = $shouldOverrideDefaultCharacterSelection$1;
var $sliceSelectedTextNodeContent_1 = $sliceSelectedTextNodeContent$1;
var $wrapNodes_1 = $wrapNodes$1;
var createDOMRange_1 = createDOMRange$1;
var createRectsFromDOMRange_1 = createRectsFromDOMRange$1;
var getStyleObjectFromCSS_1 = getStyleObjectFromCSS$1;
var trimTextContentFromAnchor_1 = trimTextContentFromAnchor$1;

var LexicalSelection_dev = {
	$addNodeStyle: $addNodeStyle_1,
	$cloneWithProperties: $cloneWithProperties_1,
	$getSelectionStyleValueForProperty: $getSelectionStyleValueForProperty_1,
	$isAtNodeEnd: $isAtNodeEnd_1,
	$isParentElementRTL: $isParentElementRTL_1,
	$moveCaretSelection: $moveCaretSelection_1,
	$moveCharacter: $moveCharacter_1,
	$patchStyleText: $patchStyleText_1,
	$selectAll: $selectAll_1,
	$setBlocksType: $setBlocksType_1,
	$shouldOverrideDefaultCharacterSelection: $shouldOverrideDefaultCharacterSelection_1,
	$sliceSelectedTextNodeContent: $sliceSelectedTextNodeContent_1,
	$wrapNodes: $wrapNodes_1,
	createDOMRange: createDOMRange_1,
	createRectsFromDOMRange: createRectsFromDOMRange_1,
	getStyleObjectFromCSS: getStyleObjectFromCSS_1,
	trimTextContentFromAnchor: trimTextContentFromAnchor_1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
let u$7=new Map;function v$5(a){for(;null!=a;){if(a.nodeType===Node.TEXT_NODE)return a;a=a.firstChild;}return null}function w$5(a){let b=a.parentNode;if(null==b)throw Error("Should never happen");return [b,Array.from(b.childNodes).indexOf(a)]}function y$5(a){let b={};a=a.split(";");for(let c of a)if(""!==c){let [e,d]=c.split(/:([^]+)/);b[e.trim()]=d.trim();}return b}function z$6(a){let b=u$7.get(a);void 0===b&&(b=y$5(a),u$7.set(a,b));return b}
function A$5(a){let b="";for(let c in a)c&&(b+=`${c}: ${a[c]};`);return b}function B$6(a,b){var c=z$6("getStyle"in a?a.getStyle():a.style);b=Object.entries(b).reduce((e,[d,f])=>{null===f?delete e[d]:e[d]=f;return e},{...c});c=A$5(b);a.setStyle(c);u$7.set(c,b);}function C$4(a){for(;null!==a&&!Lexical_1.$isRootOrShadowRoot(a);){let b=a.getLatest(),c=a.getParent();0===b.getChildrenSize()&&a.remove(!0);a=c;}}
function D$4(a,b,c,e,d=null){if(0!==b.length){var f=b[0],h=new Map,g=[];f=Lexical_1.$isElementNode(f)?f:f.getParentOrThrow();f.isInline()&&(f=f.getParentOrThrow());for(var l=!1;null!==f;){var m=f.getPreviousSibling();if(null!==m){f=m;l=!0;break}f=f.getParentOrThrow();if(Lexical_1.$isRootOrShadowRoot(f))break}m=new Set;for(var q=0;q<c;q++){var p=b[q];Lexical_1.$isElementNode(p)&&0===p.getChildrenSize()&&m.add(p.getKey());}var n=new Set;for(q=0;q<c;q++){p=b[q];var r=p.getParent();null!==r&&r.isInline()&&(r=r.getParent());if(null!==
r&&Lexical_1.$isLeafNode(p)&&!n.has(p.getKey())){if(p=r.getKey(),void 0===h.get(p)){let t=e();t.setFormat(r.getFormatType());t.setIndent(r.getIndent());g.push(t);h.set(p,t);r.getChildren().forEach(x=>{t.append(x);n.add(x.getKey());Lexical_1.$isElementNode(x)&&x.getChildrenKeys().forEach(G=>n.add(G));});C$4(r);}}else m.has(p.getKey())&&(r=e(),r.setFormat(p.getFormatType()),r.setIndent(p.getIndent()),g.push(r),p.remove(!0));}if(null!==d)for(b=0;b<g.length;b++)d.append(g[b]);b=null;if(Lexical_1.$isRootOrShadowRoot(f))if(l)if(null!==
d)f.insertAfter(d);else for(d=g.length-1;0<=d;d--)f.insertAfter(g[d]);else if(l=f.getFirstChild(),Lexical_1.$isElementNode(l)&&(f=l),null===l)if(d)f.append(d);else for(d=0;d<g.length;d++)l=g[d],f.append(l),b=l;else if(null!==d)l.insertBefore(d);else for(f=0;f<g.length;f++)d=g[f],l.insertBefore(d),b=d;else if(d)f.insertAfter(d);else for(d=g.length-1;0<=d;d--)l=g[d],f.insertAfter(l),b=l;g=Lexical_1.$getPreviousSelection();Lexical_1.$isRangeSelection(g)&&g.anchor.getNode().isAttached()&&g.focus.getNode().isAttached()?Lexical_1.$setSelection(g.clone()):
null!==b?b.selectEnd():a.dirty=!0;}}function E$5(a,b,c,e){a.modify(b?"extend":"move",c,e);}function F$4(a){a=a.anchor.getNode();return "rtl"===(Lexical_1.$isRootNode(a)?a:a.getParentOrThrow()).getDirection()}var $addNodeStyle=function(a){a=a.getStyle();let b=y$5(a);u$7.set(a,b);};
var $cloneWithProperties=function(a){a=a.getLatest();let b=a.constructor.clone(a);b.__parent=a.__parent;b.__next=a.__next;b.__prev=a.__prev;if(Lexical_1.$isElementNode(a)&&Lexical_1.$isElementNode(b))return b.__first=a.__first,b.__last=a.__last,b.__size=a.__size,b.__format=a.__format,b.__indent=a.__indent,b.__dir=a.__dir,b;Lexical_1.$isTextNode(a)&&Lexical_1.$isTextNode(b)&&(b.__format=a.__format,b.__style=a.__style,b.__mode=a.__mode,b.__detail=a.__detail);return b};
var $getSelectionStyleValueForProperty=function(a,b,c=""){let e=null,d=a.getNodes();var f=a.anchor,h=a.focus,g=a.isBackward();let l=g?h.offset:f.offset;f=g?h.getNode():f.getNode();if(""!==a.style&&(a=z$6(a.style),null!==a&&b in a))return a[b];for(a=0;a<d.length;a++){var m=d[a];if((0===a||0!==l||!m.is(f))&&Lexical_1.$isTextNode(m))if(h=b,g=c,m=m.getStyle(),m=z$6(m),h=null!==m?m[h]||g:g,null===e)e=h;else if(e!==h){e="";break}}return null===e?c:e};
var $isAtNodeEnd=function(a){return "text"===a.type?a.offset===a.getNode().getTextContentSize():a.offset===a.getNode().getChildrenSize()};var $isParentElementRTL=F$4;var $moveCaretSelection=E$5;var $moveCharacter=function(a,b,c){let e=F$4(a);E$5(a,b,c?!e:e,"character");};
var $patchStyleText=function(a,b){var c=a.getNodes();let e=c.length-1,d=c[0],f=c[e];if(a.isCollapsed())B$6(a,b);else {var h=a.anchor,g=a.focus,l=d.getTextContent().length,m=g.offset,q=h.offset,p=h.isBefore(g),n=p?q:m;a=p?m:q;var r=p?h.type:g.type,t=p?g.type:h.type;h=p?g.key:h.key;Lexical_1.$isTextNode(d)&&n===l&&(g=d.getNextSibling(),Lexical_1.$isTextNode(g)&&(n=q=0,d=g));if(1===c.length)Lexical_1.$isTextNode(d)&&(n="element"===r?0:q>m?m:q,a="element"===t?l:q>m?q:m,n!==a&&(0===n&&a===l?(B$6(d,b),d.select(n,a)):(c=d.splitText(n,
a),c=0===n?c[0]:c[1],B$6(c,b),c.select(0,a-n))));else for(Lexical_1.$isTextNode(d)&&n<d.getTextContentSize()&&(0!==n&&(d=d.splitText(n)[1]),B$6(d,b)),Lexical_1.$isTextNode(f)&&(n=f.getTextContent().length,f.__key!==h&&0!==a&&(a=n),a!==n&&([f]=f.splitText(a)),0!==a&&B$6(f,b)),a=1;a<e;a++)n=c[a],l=n.getKey(),Lexical_1.$isTextNode(n)&&l!==d.getKey()&&l!==f.getKey()&&!n.isToken()&&B$6(n,b);}};
var $selectAll=function(a){let b=a.anchor;a=a.focus;var c=b.getNode().getTopLevelElementOrThrow().getParentOrThrow();let e=c.getFirstDescendant();c=c.getLastDescendant();let d="element",f="element",h=0;Lexical_1.$isTextNode(e)?d="text":Lexical_1.$isElementNode(e)||null===e||(e=e.getParentOrThrow());Lexical_1.$isTextNode(c)?(f="text",h=c.getTextContentSize()):Lexical_1.$isElementNode(c)||null===c||(c=c.getParentOrThrow());e&&c&&(b.set(e.getKey(),0,d),a.set(c.getKey(),h,f));};
var $setBlocksType=function(a,b){if("root"===a.anchor.key){b=b();var c=Lexical_1.$getRoot();(a=c.getFirstChild())?a.replace(b,!0):c.append(b);}else for(c=a.getNodes(),a=a.anchor.getNode().getParentOrThrow(),-1===c.indexOf(a)&&c.push(a),a.isInline()&&(a=a.getParentOrThrow(),-1===c.indexOf(a)&&c.push(a)),a=0;a<c.length;a++){let f=c[a];var e=f;if(!Lexical_1.$isElementNode(e)||Lexical_1.$isRootOrShadowRoot(e))e=!1;else {var d=e.getFirstChild();d=null===d||Lexical_1.$isTextNode(d)||d.isInline();e=!e.isInline()&&!1!==e.canBeEmpty()&&
d;}e&&(e=b(),e.setFormat(f.getFormatType()),e.setIndent(f.getIndent()),f.replace(e,!0));}};var $shouldOverrideDefaultCharacterSelection=function(a,b){a=Lexical_1.$getAdjacentNode(a.focus,b);return Lexical_1.$isDecoratorNode(a)&&!a.isIsolated()||Lexical_1.$isElementNode(a)&&!a.isInline()&&!a.canBeEmpty()};
var $sliceSelectedTextNodeContent=function(a,b){if(b.isSelected()&&!b.isSegmented()&&!b.isToken()&&(Lexical_1.$isRangeSelection(a)||Lexical_1.DEPRECATED_$isGridSelection(a))){var c=a.anchor.getNode(),e=a.focus.getNode(),d=b.is(c),f=b.is(e);if(d||f){d=a.isBackward();let [h,g]=a.getCharacterOffsets();a=c.is(e);f=b.is(d?e:c);e=b.is(d?c:e);c=0;let l=void 0;a?(c=h>g?g:h,l=h>g?h:g):f?(c=d?g:h,l=void 0):e&&(d=d?h:g,c=0,l=d);b.__text=b.__text.slice(c,l);}}return b};
var $wrapNodes=function(a,b,c=null){var e=a.getNodes();let d=e.length;var f=a.anchor;if(0===d||1===d&&"element"===f.type&&0===f.getNode().getChildrenSize()){a="text"===f.type?f.getNode().getParentOrThrow():f.getNode();e=a.getChildren();let g=b();g.setFormat(a.getFormatType());g.setIndent(a.getIndent());e.forEach(l=>g.append(l));c&&(g=c.append(g));a.replace(g);}else {f=null;var h=[];for(let g=0;g<d;g++){let l=e[g];Lexical_1.$isRootOrShadowRoot(l)?(D$4(a,h,h.length,b,c),h=[],f=l):null===f||null!==f&&Lexical_1.$hasAncestor(l,
f)?h.push(l):(D$4(a,h,h.length,b,c),h=[l]);}D$4(a,h,h.length,b,c);}};
var createDOMRange=function(a,b,c,e,d){let f=b.getKey(),h=e.getKey(),g=document.createRange(),l=a.getElementByKey(f);a=a.getElementByKey(h);Lexical_1.$isTextNode(b)&&(l=v$5(l));Lexical_1.$isTextNode(e)&&(a=v$5(a));if(void 0===b||void 0===e||null===l||null===a)return null;"BR"===l.nodeName&&([l,c]=w$5(l));"BR"===a.nodeName&&([a,d]=w$5(a));b=l.firstChild;l===a&&null!=b&&"BR"===b.nodeName&&0===c&&0===d&&(d=1);try{g.setStart(l,c),g.setEnd(a,d);}catch(m){return null}!g.collapsed||c===d&&f===h||(g.setStart(a,d),g.setEnd(l,
c));return g};var createRectsFromDOMRange=function(a,b){var c=a.getRootElement();if(null===c)return [];a=c.getBoundingClientRect();c=getComputedStyle(c);c=parseFloat(c.paddingLeft)+parseFloat(c.paddingRight);b=Array.from(b.getClientRects());let e=b.length,d;for(let f=0;f<e;f++){let h=b[f],g=h.width+c===a.width;d&&d.top===h.top&&d.left===h.left&&d.width===h.width&&d.height===h.height||g?(b.splice(f--,1),e--):d=h;}return b};var getStyleObjectFromCSS=z$6;
var trimTextContentFromAnchor=function(a,b,c){let e=b.getNode();if(Lexical_1.$isElementNode(e)){var d=e.getDescendantByIndex(b.offset);null!==d&&(e=d);}for(;0<c&&null!==e;){var f=e.getPreviousSibling(),h=0;if(null===f){d=e.getParentOrThrow();for(var g=d.getPreviousSibling();null===g;){d=d.getParent();if(null===d){f=null;break}g=d.getPreviousSibling();}null!==d&&(h=d.isInline()?0:2,f=Lexical_1.$isElementNode(g)?g.getLastDescendant():g);}g=e.getTextContent();""===g&&Lexical_1.$isElementNode(e)&&!e.isInline()&&(g="\n\n");
d=e.getTextContentSize();if(!Lexical_1.$isTextNode(e)||c>=d)g=e.getParent(),e.remove(),null==g||0!==g.getChildrenSize()||Lexical_1.$isRootNode(g)||g.remove(),c-=d+h,e=f;else {let l=e.getKey();h=a.getEditorState().read(()=>{const q=Lexical_1.$getNodeByKey(l);return Lexical_1.$isTextNode(q)&&q.isSimpleText()?q.getTextContent():null});f=d-c;let m=g.slice(0,f);null!==h&&h!==g?(c=Lexical_1.$getPreviousSelection(),d=e,e.isSimpleText()?e.setTextContent(h):(d=Lexical_1.$createTextNode(h),e.replace(d)),Lexical_1.$isRangeSelection(c)&&c.isCollapsed()&&(c=c.anchor.offset,
d.select(c,c))):e.isSimpleText()?(h=b.key===l,g=b.offset,g<c&&(g=d),c=h?g-c:0,d=h?g:f,h&&0===c?([c]=e.splitText(c,d),c.remove()):([,c]=e.splitText(c,d),c.remove())):(c=Lexical_1.$createTextNode(m),e.replace(c));c=0;}}};

var LexicalSelection_prod = {
	$addNodeStyle: $addNodeStyle,
	$cloneWithProperties: $cloneWithProperties,
	$getSelectionStyleValueForProperty: $getSelectionStyleValueForProperty,
	$isAtNodeEnd: $isAtNodeEnd,
	$isParentElementRTL: $isParentElementRTL,
	$moveCaretSelection: $moveCaretSelection,
	$moveCharacter: $moveCharacter,
	$patchStyleText: $patchStyleText,
	$selectAll: $selectAll,
	$setBlocksType: $setBlocksType,
	$shouldOverrideDefaultCharacterSelection: $shouldOverrideDefaultCharacterSelection,
	$sliceSelectedTextNodeContent: $sliceSelectedTextNodeContent,
	$wrapNodes: $wrapNodes,
	createDOMRange: createDOMRange,
	createRectsFromDOMRange: createRectsFromDOMRange,
	getStyleObjectFromCSS: getStyleObjectFromCSS,
	trimTextContentFromAnchor: trimTextContentFromAnchor
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const LexicalSelection = process.env.NODE_ENV === 'development' ? LexicalSelection_dev : LexicalSelection_prod;
var LexicalSelection_1 = LexicalSelection;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */




/** @module @lexical/utils */

/**
 * Takes an HTML element and adds the classNames passed within an array,
 * ignoring any non-string types. A space can be used to add multiple classes
 * eg. addClassNamesToElement(element, ['element-inner active', true, null])
 * will add both 'element-inner' and 'active' as classes to that element.
 * @param element - The element in which the classes are added
 * @param classNames - An array defining the class names to add to the element
 */
function addClassNamesToElement$1(element, ...classNames) {
  classNames.forEach(className => {
    if (typeof className === 'string') {
      const classesToAdd = className.split(' ').filter(n => n !== '');
      element.classList.add(...classesToAdd);
    }
  });
}
/**
 * Takes an HTML element and removes the classNames passed within an array,
 * ignoring any non-string types. A space can be used to remove multiple classes
 * eg. removeClassNamesFromElement(element, ['active small', true, null])
 * will remove both the 'active' and 'small' classes from that element.
 * @param element - The element in which the classes are removed
 * @param classNames - An array defining the class names to remove from the element
 */

function removeClassNamesFromElement$1(element, ...classNames) {
  classNames.forEach(className => {
    if (typeof className === 'string') {
      element.classList.remove(...className.split(' '));
    }
  });
}
/**
 * Returns true if the file type matches the types passed within the acceptableMimeTypes array, false otherwise.
 * The types passed must be strings and are CASE-SENSITIVE.
 * eg. if file is of type 'text' and acceptableMimeTypes = ['TEXT', 'IMAGE'] the function will return false.
 * @param file - The file you want to type check.
 * @param acceptableMimeTypes - An array of strings of types which the file is checked against.
 * @returns true if the file is an acceptable mime type, false otherwise.
 */

function isMimeType$1(file, acceptableMimeTypes) {
  for (const acceptableType of acceptableMimeTypes) {
    if (file.type.startsWith(acceptableType)) {
      return true;
    }
  }

  return false;
}
/**
 * Lexical File Reader with:
 *  1. MIME type support
 *  2. batched results (HistoryPlugin compatibility)
 *  3. Order aware (respects the order when multiple Files are passed)
 *
 * const filesResult = await mediaFileReader(files, ['image/']);
 * filesResult.forEach(file => editor.dispatchCommand('INSERT_IMAGE', {
 *   src: file.result,
 * }));
 */

function mediaFileReader$1(files, acceptableMimeTypes) {
  const filesIterator = files[Symbol.iterator]();
  return new Promise((resolve, reject) => {
    const processed = [];

    const handleNextFile = () => {
      const {
        done,
        value: file
      } = filesIterator.next();

      if (done) {
        return resolve(processed);
      }

      const fileReader = new FileReader();
      fileReader.addEventListener('error', reject);
      fileReader.addEventListener('load', () => {
        const result = fileReader.result;

        if (typeof result === 'string') {
          processed.push({
            file,
            result
          });
        }

        handleNextFile();
      });

      if (isMimeType$1(file, acceptableMimeTypes)) {
        fileReader.readAsDataURL(file);
      } else {
        handleNextFile();
      }
    };

    handleNextFile();
  });
}
/**
 * "Depth-First Search" starts at the root/top node of a tree and goes as far as it can down a branch end
 * before backtracking and finding a new path. Consider solving a maze by hugging either wall, moving down a
 * branch until you hit a dead-end (leaf) and backtracking to find the nearest branching path and repeat.
 * It will then return all the nodes found in the search in an array of objects.
 * @param startingNode - The node to start the search, if ommitted, it will start at the root node.
 * @param endingNode - The node to end the search, if ommitted, it will find all descendants of the startingNode.
 * @returns An array of objects of all the nodes found by the search, including their depth into the tree.
 * {depth: number, node: LexicalNode} It will always return at least 1 node (the ending node) so long as it exists
 */

function $dfs$1(startingNode, endingNode) {
  const nodes = [];
  const start = (startingNode || Lexical_1.$getRoot()).getLatest();
  const end = endingNode || (Lexical_1.$isElementNode(start) ? start.getLastDescendant() : start);
  let node = start;
  let depth = $getDepth(node);

  while (node !== null && !node.is(end)) {
    nodes.push({
      depth,
      node
    });

    if (Lexical_1.$isElementNode(node) && node.getChildrenSize() > 0) {
      node = node.getFirstChild();
      depth++;
    } else {
      // Find immediate sibling or nearest parent sibling
      let sibling = null;

      while (sibling === null && node !== null) {
        sibling = node.getNextSibling();

        if (sibling === null) {
          node = node.getParent();
          depth--;
        } else {
          node = sibling;
        }
      }
    }
  }

  if (node !== null && node.is(end)) {
    nodes.push({
      depth,
      node
    });
  }

  return nodes;
}

function $getDepth(node) {
  let innerNode = node;
  let depth = 0;

  while ((innerNode = innerNode.getParent()) !== null) {
    depth++;
  }

  return depth;
}
/**
 * Takes a node and traverses up its ancestors (toward the root node)
 * in order to find a specific type of node.
 * @param node - the node to begin searching.
 * @param klass - an instance of the type of node to look for.
 * @returns the node of type klass that was passed, or null if none exist.
 */


function $getNearestNodeOfType$1(node, klass) {
  let parent = node;

  while (parent != null) {
    if (parent instanceof klass) {
      return parent;
    }

    parent = parent.getParent();
  }

  return null;
}
/**
 *Returns the element node of the nearest ancestor, otherwise throws an error.
 * @param startNode - The starting node of the search
 * @returns The ancestor node found
 */

function $getNearestBlockElementAncestorOrThrow$1(startNode) {
  const blockNode = $findMatchingParent$1(startNode, node => Lexical_1.$isElementNode(node) && !node.isInline());

  if (!Lexical_1.$isElementNode(blockNode)) {
    {
      throw Error(`Expected node ${startNode.__key} to have closest block element node.`);
    }
  }

  return blockNode;
}

/**
 * Starts with a node and moves up the tree (toward the root node) to find a matching node based on
 * the search parameters of the findFn. (Consider JavaScripts' .find() function where a testing function must be
 * passed as an argument. eg. if( (node) => node.__type === 'div') ) return true; otherwise return false
 * @param startingNode - The node where the search starts.
 * @param findFn - A testing function that returns true if the current node satisfies the testing parameters.
 * @returns A parent node that matches the findFn parameters, or null if one wasn't found.
 */
function $findMatchingParent$1(startingNode, findFn) {
  let curr = startingNode;

  while (curr !== Lexical_1.$getRoot() && curr != null) {
    if (findFn(curr)) {
      return curr;
    }

    curr = curr.getParent();
  }

  return null;
}

/**
 * Returns a function that will execute all functions passed when called. It is generally used
 * to register multiple lexical listeners and then tear them down with a single function call, such
 * as React's useEffect hook.
 * @example
 * ```ts
 * useEffect(() => {
 *   return mergeRegister(
 *     editor.registerCommand(...registerCommand1 logic),
 *     editor.registerCommand(...registerCommand2 logic),
 *     editor.registerCommand(...registerCommand3 logic)
 *   )
 * }, [editor])
 * ```
 * In this case, useEffect is returning the function returned by mergeRegister as a cleanup
 * function to be executed after either the useEffect runs again (due to one of its dependencies
 * updating) or the compenent it resides in unmounts.
 * Note the functions don't neccesarily need to be in an array as all arguements
 * are considered to be the func argument and spread from there.
 * @param func - An array of functions meant to be executed by the returned function.
 * @returns the function which executes all the passed register command functions.
 */
function mergeRegister$1(...func) {
  return () => {
    func.forEach(f => f());
  };
}
/**
 * Attempts to resolve nested element nodes of the same type into a single node of that type.
 * It is generally used for marks/commenting
 * @param editor - The lexical editor
 * @param targetNode - The target for the nested element to be extracted from.
 * @param cloneNode - See {@link $createMarkNode}
 * @param handleOverlap - Handles any overlap between the node to extract and the targetNode
 * @returns The lexical editor
 */

function registerNestedElementResolver$1(editor, targetNode, cloneNode, handleOverlap) {
  const $isTargetNode = node => {
    return node instanceof targetNode;
  };

  const $findMatch = node => {
    // First validate we don't have any children that are of the target,
    // as we need to handle them first.
    const children = node.getChildren();

    for (let i = 0; i < children.length; i++) {
      const child = children[i];

      if ($isTargetNode(child)) {
        return null;
      }
    }

    let parentNode = node;
    let childNode = node;

    while (parentNode !== null) {
      childNode = parentNode;
      parentNode = parentNode.getParent();

      if ($isTargetNode(parentNode)) {
        return {
          child: childNode,
          parent: parentNode
        };
      }
    }

    return null;
  };

  const elementNodeTransform = node => {
    const match = $findMatch(node);

    if (match !== null) {
      const {
        child,
        parent
      } = match; // Simple path, we can move child out and siblings into a new parent.

      if (child.is(node)) {
        handleOverlap(parent, node);
        const nextSiblings = child.getNextSiblings();
        const nextSiblingsLength = nextSiblings.length;
        parent.insertAfter(child);

        if (nextSiblingsLength !== 0) {
          const newParent = cloneNode(parent);
          child.insertAfter(newParent);

          for (let i = 0; i < nextSiblingsLength; i++) {
            newParent.append(nextSiblings[i]);
          }
        }

        if (!parent.canBeEmpty() && parent.getChildrenSize() === 0) {
          parent.remove();
        }
      }
    }
  };

  return editor.registerNodeTransform(targetNode, elementNodeTransform);
}
/**
 * Clones the editor and marks it as dirty to be reconciled. If there was a selection,
 * it would be set back to its previous state, or null otherwise.
 * @param editor - The lexical editor
 * @param editorState - The editor's state
 */

function $restoreEditorState$1(editor, editorState) {
  const FULL_RECONCILE = 2;
  const nodeMap = new Map();
  const activeEditorState = editor._pendingEditorState;

  for (const [key, node] of editorState._nodeMap) {
    const clone = LexicalSelection_1.$cloneWithProperties(node);

    if (Lexical_1.$isTextNode(clone)) {
      clone.__text = node.__text;
    }

    nodeMap.set(key, clone);
  }

  if (activeEditorState) {
    activeEditorState._nodeMap = nodeMap;
  }

  editor._dirtyType = FULL_RECONCILE;
  const selection$1 = editorState._selection;
  Lexical_1.$setSelection(selection$1 === null ? null : selection$1.clone());
}
/**
 * If the selected insertion area is the root/shadow root node (see {@link lexical!$isRootOrShadowRoot}),
 * the node will be appended there, otherwise, it will be inserted before the insertion area.
 * If there is no selection where the node is to be inserted, it will be appended after any current nodes
 * within the tree, as a child of the root node. A paragraph node will then be added after the inserted node and selected.
 * @param node - The node to be inserted
 * @returns The node after its insertion
 */

function $insertNodeToNearestRoot$1(node) {
  const selection = Lexical_1.$getSelection();

  if (Lexical_1.$isRangeSelection(selection)) {
    const {
      focus
    } = selection;
    const focusNode = focus.getNode();
    const focusOffset = focus.offset;

    if (Lexical_1.$isRootOrShadowRoot(focusNode)) {
      const focusChild = focusNode.getChildAtIndex(focusOffset);

      if (focusChild == null) {
        focusNode.append(node);
      } else {
        focusChild.insertBefore(node);
      }

      node.selectNext();
    } else {
      let splitNode;
      let splitOffset;

      if (Lexical_1.$isTextNode(focusNode)) {
        splitNode = focusNode.getParentOrThrow();
        splitOffset = focusNode.getIndexWithinParent();

        if (focusOffset > 0) {
          splitOffset += 1;
          focusNode.splitText(focusOffset);
        }
      } else {
        splitNode = focusNode;
        splitOffset = focusOffset;
      }

      const [, rightTree] = Lexical_1.$splitNode(splitNode, splitOffset);
      rightTree.insertBefore(node);
      rightTree.selectStart();
    }
  } else {
    if (Lexical_1.$isNodeSelection(selection) || Lexical_1.DEPRECATED_$isGridSelection(selection)) {
      const nodes = selection.getNodes();
      nodes[nodes.length - 1].getTopLevelElementOrThrow().insertAfter(node);
    } else {
      const root = Lexical_1.$getRoot();
      root.append(node);
    }

    const paragraphNode = Lexical_1.$createParagraphNode();
    node.insertAfter(paragraphNode);
    paragraphNode.select();
  }

  return node.getLatest();
}
/**
 * Wraps the node into another node created from a createElementNode function, eg. $createParagraphNode
 * @param node - Node to be wrapped.
 * @param createElementNode - Creates a new lexcial element to wrap the to-be-wrapped node and returns it.
 * @returns A new lexcial element with the previous node appended within (as a child, including its children).
 */

function $wrapNodeInElement$1(node, createElementNode) {
  const elementNode = createElementNode();
  node.replace(elementNode);
  elementNode.append(node);
  return elementNode;
}
/**
 * @param x - The element being tested
 * @returns Returns true if x is an HTML anchor tag, false otherwise
 */

function isHTMLAnchorElement$1(x) {
  return isHTMLElement$1(x) && x.tagName === 'A';
}
/**
 * @param x - The element being testing
 * @returns Returns true if x is an HTML element, false otherwise.
 */

function isHTMLElement$1(x) {
  // @ts-ignore-next-line - strict check on nodeType here should filter out non-Element EventTarget implementors
  return x.nodeType === 1;
}

var $splitNode$1 = Lexical_1.$splitNode;
var $dfs_1 = $dfs$1;
var $findMatchingParent_1 = $findMatchingParent$1;
var $getNearestBlockElementAncestorOrThrow_1 = $getNearestBlockElementAncestorOrThrow$1;
var $getNearestNodeOfType_1 = $getNearestNodeOfType$1;
var $insertNodeToNearestRoot_1 = $insertNodeToNearestRoot$1;
var $restoreEditorState_1 = $restoreEditorState$1;
var $wrapNodeInElement_1 = $wrapNodeInElement$1;
var addClassNamesToElement_1 = addClassNamesToElement$1;
var isHTMLAnchorElement_1 = isHTMLAnchorElement$1;
var isHTMLElement_1 = isHTMLElement$1;
var isMimeType_1 = isMimeType$1;
var mediaFileReader_1 = mediaFileReader$1;
var mergeRegister_1 = mergeRegister$1;
var registerNestedElementResolver_1 = registerNestedElementResolver$1;
var removeClassNamesFromElement_1 = removeClassNamesFromElement$1;

var LexicalUtils_dev = {
	$splitNode: $splitNode$1,
	$dfs: $dfs_1,
	$findMatchingParent: $findMatchingParent_1,
	$getNearestBlockElementAncestorOrThrow: $getNearestBlockElementAncestorOrThrow_1,
	$getNearestNodeOfType: $getNearestNodeOfType_1,
	$insertNodeToNearestRoot: $insertNodeToNearestRoot_1,
	$restoreEditorState: $restoreEditorState_1,
	$wrapNodeInElement: $wrapNodeInElement_1,
	addClassNamesToElement: addClassNamesToElement_1,
	isHTMLAnchorElement: isHTMLAnchorElement_1,
	isHTMLElement: isHTMLElement_1,
	isMimeType: isMimeType_1,
	mediaFileReader: mediaFileReader_1,
	mergeRegister: mergeRegister_1,
	registerNestedElementResolver: registerNestedElementResolver_1,
	removeClassNamesFromElement: removeClassNamesFromElement_1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function p$6(a,b){for(let c of b)if(a.type.startsWith(c))return !0;return !1}function q$6(a,b){for(;a!==Lexical_1.$getRoot()&&null!=a;){if(b(a))return a;a=a.getParent();}return null}function t$6(a){return 1===a.nodeType}var $splitNode=Lexical_1.$splitNode;
var $dfs=function(a,b){let c=[];a=(a||Lexical_1.$getRoot()).getLatest();b=b||(Lexical_1.$isElementNode(a)?a.getLastDescendant():a);for(var f=a,d=0;null!==(f=f.getParent());)d++;for(f=d;null!==a&&!a.is(b);)if(c.push({depth:f,node:a}),Lexical_1.$isElementNode(a)&&0<a.getChildrenSize())a=a.getFirstChild(),f++;else for(d=null;null===d&&null!==a;)d=a.getNextSibling(),null===d?(a=a.getParent(),f--):a=d;null!==a&&a.is(b)&&c.push({depth:f,node:a});return c};var $findMatchingParent=q$6;
var $getNearestBlockElementAncestorOrThrow=function(a){a=q$6(a,b=>Lexical_1.$isElementNode(b)&&!b.isInline());if(!Lexical_1.$isElementNode(a))throw Error("Minified Lexical error #4; visit https://lexical.dev/docs/error?code=4 for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");return a};var $getNearestNodeOfType=function(a,b){for(;null!=a;){if(a instanceof b)return a;a=a.getParent();}return null};
var $insertNodeToNearestRoot=function(a){var b=Lexical_1.$getSelection();if(Lexical_1.$isRangeSelection(b)){var {focus:c}=b;b=c.getNode();c=c.offset;if(Lexical_1.$isRootOrShadowRoot(b))c=b.getChildAtIndex(c),null==c?b.append(a):c.insertBefore(a),a.selectNext();else {let f,d;Lexical_1.$isTextNode(b)?(f=b.getParentOrThrow(),d=b.getIndexWithinParent(),0<c&&(d+=1,b.splitText(c))):(f=b,d=c);[,b]=Lexical_1.$splitNode(f,d);b.insertBefore(a);b.selectStart();}}else Lexical_1.$isNodeSelection(b)||Lexical_1.DEPRECATED_$isGridSelection(b)?(b=b.getNodes(),b[b.length-
1].getTopLevelElementOrThrow().insertAfter(a)):Lexical_1.$getRoot().append(a),b=Lexical_1.$createParagraphNode(),a.insertAfter(b),b.select();return a.getLatest()};var $restoreEditorState=function(a,b){let c=new Map,f=a._pendingEditorState;for(let [d,e]of b._nodeMap){let h=LexicalSelection_1.$cloneWithProperties(e);Lexical_1.$isTextNode(h)&&(h.__text=e.__text);c.set(d,h);}f&&(f._nodeMap=c);a._dirtyType=2;a=b._selection;Lexical_1.$setSelection(null===a?null:a.clone());};var $wrapNodeInElement=function(a,b){b=b();a.replace(b);b.append(a);return b};
var addClassNamesToElement=function(a,...b){b.forEach(c=>{"string"===typeof c&&(c=c.split(" ").filter(f=>""!==f),a.classList.add(...c));});};var isHTMLAnchorElement=function(a){return t$6(a)&&"A"===a.tagName};var isHTMLElement=t$6;var isMimeType=p$6;
var mediaFileReader=function(a,b){let c=a[Symbol.iterator]();return new Promise((f,d)=>{let e=[],h=()=>{const {done:m,value:k}=c.next();if(m)return f(e);const l=new FileReader;l.addEventListener("error",d);l.addEventListener("load",()=>{const r=l.result;"string"===typeof r&&e.push({file:k,result:r});h();});p$6(k,b)?l.readAsDataURL(k):h();};h();})};var mergeRegister=function(...a){return ()=>{a.forEach(b=>b());}};
var registerNestedElementResolver=function(a,b,c,f){return a.registerNodeTransform(b,d=>{a:{var e=d.getChildren();for(var h=0;h<e.length;h++)if(e[h]instanceof b){e=null;break a}for(e=d;null!==e;)if(h=e,e=e.getParent(),e instanceof b){e={child:h,parent:e};break a}e=null;}if(null!==e){const {child:m,parent:k}=e;if(m.is(d)){f(k,d);d=m.getNextSiblings();e=d.length;k.insertAfter(m);if(0!==e){h=c(k);m.insertAfter(h);for(let l=0;l<e;l++)h.append(d[l]);}k.canBeEmpty()||0!==k.getChildrenSize()||k.remove();}}})};
var removeClassNamesFromElement=function(a,...b){b.forEach(c=>{"string"===typeof c&&a.classList.remove(...c.split(" "));});};

var LexicalUtils_prod = {
	$splitNode: $splitNode,
	$dfs: $dfs,
	$findMatchingParent: $findMatchingParent,
	$getNearestBlockElementAncestorOrThrow: $getNearestBlockElementAncestorOrThrow,
	$getNearestNodeOfType: $getNearestNodeOfType,
	$insertNodeToNearestRoot: $insertNodeToNearestRoot,
	$restoreEditorState: $restoreEditorState,
	$wrapNodeInElement: $wrapNodeInElement,
	addClassNamesToElement: addClassNamesToElement,
	isHTMLAnchorElement: isHTMLAnchorElement,
	isHTMLElement: isHTMLElement,
	isMimeType: isMimeType,
	mediaFileReader: mediaFileReader,
	mergeRegister: mergeRegister,
	registerNestedElementResolver: registerNestedElementResolver,
	removeClassNamesFromElement: removeClassNamesFromElement
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const LexicalUtils = process.env.NODE_ENV === 'development' ? LexicalUtils_dev : LexicalUtils_prod;
var LexicalUtils_1 = LexicalUtils;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



















/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

const mapToPrismLanguage = language => {
  // eslint-disable-next-line no-prototype-builtins
  return language != null && prism.languages.hasOwnProperty(language) ? language : undefined;
};

function hasChildDOMNodeTag(node, tagName) {
  for (const child of node.childNodes) {
    if (LexicalUtils_1.isHTMLElement(child) && child.tagName === tagName) {
      return true;
    }

    hasChildDOMNodeTag(child, tagName);
  }

  return false;
}

const LANGUAGE_DATA_ATTRIBUTE = 'data-highlight-language';
/** @noInheritDoc */

class CodeNode$1 extends Lexical_1.ElementNode {
  /** @internal */
  static getType() {
    return 'code';
  }

  static clone(node) {
    return new CodeNode$1(node.__language, node.__key);
  }

  constructor(language, key) {
    super(key);
    this.__language = mapToPrismLanguage(language);
  } // View


  createDOM(config) {
    const element = document.createElement('code');
    LexicalUtils_1.addClassNamesToElement(element, config.theme.code);
    element.setAttribute('spellcheck', 'false');
    const language = this.getLanguage();

    if (language) {
      element.setAttribute(LANGUAGE_DATA_ATTRIBUTE, language);
    }

    return element;
  }

  updateDOM(prevNode, dom, config) {
    const language = this.__language;
    const prevLanguage = prevNode.__language;

    if (language) {
      if (language !== prevLanguage) {
        dom.setAttribute(LANGUAGE_DATA_ATTRIBUTE, language);
      }
    } else if (prevLanguage) {
      dom.removeAttribute(LANGUAGE_DATA_ATTRIBUTE);
    }

    return false;
  }

  static importDOM() {
    return {
      // Typically <pre> is used for code blocks, and <code> for inline code styles
      // but if it's a multi line <code> we'll create a block. Pass through to
      // inline format handled by TextNode otherwise.
      code: node => {
        const isMultiLine = node.textContent != null && (/\r?\n/.test(node.textContent) || hasChildDOMNodeTag(node, 'BR'));
        return isMultiLine ? {
          conversion: convertPreElement,
          priority: 1
        } : null;
      },
      div: node => ({
        conversion: convertDivElement,
        priority: 1
      }),
      pre: node => ({
        conversion: convertPreElement,
        priority: 0
      }),
      table: node => {
        const table = node; // domNode is a <table> since we matched it by nodeName

        if (isGitHubCodeTable(table)) {
          return {
            conversion: convertTableElement,
            priority: 3
          };
        }

        return null;
      },
      td: node => {
        // element is a <td> since we matched it by nodeName
        const td = node;
        const table = td.closest('table');

        if (isGitHubCodeCell(td)) {
          return {
            conversion: convertTableCellElement,
            priority: 3
          };
        }

        if (table && isGitHubCodeTable(table)) {
          // Return a no-op if it's a table cell in a code table, but not a code line.
          // Otherwise it'll fall back to the T
          return {
            conversion: convertCodeNoop,
            priority: 3
          };
        }

        return null;
      },
      tr: node => {
        // element is a <tr> since we matched it by nodeName
        const tr = node;
        const table = tr.closest('table');

        if (table && isGitHubCodeTable(table)) {
          return {
            conversion: convertCodeNoop,
            priority: 3
          };
        }

        return null;
      }
    };
  }

  static importJSON(serializedNode) {
    const node = $createCodeNode$1(serializedNode.language);
    node.setFormat(serializedNode.format);
    node.setIndent(serializedNode.indent);
    node.setDirection(serializedNode.direction);
    return node;
  }

  exportJSON() {
    return { ...super.exportJSON(),
      language: this.getLanguage(),
      type: 'code',
      version: 1
    };
  } // Mutation


  insertNewAfter(selection, restoreSelection = true) {
    const children = this.getChildren();
    const childrenLength = children.length;

    if (childrenLength >= 2 && children[childrenLength - 1].getTextContent() === '\n' && children[childrenLength - 2].getTextContent() === '\n' && selection.isCollapsed() && selection.anchor.key === this.__key && selection.anchor.offset === childrenLength) {
      children[childrenLength - 1].remove();
      children[childrenLength - 2].remove();
      const newElement = Lexical_1.$createParagraphNode();
      this.insertAfter(newElement, restoreSelection);
      return newElement;
    } // If the selection is within the codeblock, find all leading tabs and
    // spaces of the current line. Create a new line that has all those
    // tabs and spaces, such that leading indentation is preserved.


    const anchor = selection.anchor.getNode();
    const firstNode = getFirstCodeHighlightNodeOfLine$1(anchor);

    if (firstNode != null) {
      let leadingWhitespace = 0;
      const firstNodeText = firstNode.getTextContent();

      while (leadingWhitespace < firstNodeText.length && /[\t ]/.test(firstNodeText[leadingWhitespace])) {
        leadingWhitespace += 1;
      }

      if (leadingWhitespace > 0) {
        const whitespace = firstNodeText.substring(0, leadingWhitespace);
        const indentedChild = $createCodeHighlightNode$1(whitespace);
        anchor.insertAfter(indentedChild);
        selection.insertNodes([Lexical_1.$createLineBreakNode()]);
        indentedChild.select();
        return indentedChild;
      }
    }

    return null;
  }

  canInsertTab() {
    const selection = Lexical_1.$getSelection();

    if (!Lexical_1.$isRangeSelection(selection) || !selection.isCollapsed()) {
      return false;
    }

    return true;
  }

  canIndent() {
    return false;
  }

  collapseAtStart() {
    const paragraph = Lexical_1.$createParagraphNode();
    const children = this.getChildren();
    children.forEach(child => paragraph.append(child));
    this.replace(paragraph);
    return true;
  }

  setLanguage(language) {
    const writable = this.getWritable();
    writable.__language = mapToPrismLanguage(language);
  }

  getLanguage() {
    return this.getLatest().__language;
  }

}
function $createCodeNode$1(language) {
  return Lexical_1.$applyNodeReplacement(new CodeNode$1(language));
}
function $isCodeNode$1(node) {
  return node instanceof CodeNode$1;
}

function convertPreElement(domNode) {
  return {
    node: $createCodeNode$1(),
    preformatted: true
  };
}

function convertDivElement(domNode) {
  // domNode is a <div> since we matched it by nodeName
  const div = domNode;
  const isCode = isCodeElement(div);

  if (!isCode && !isCodeChildElement(div)) {
    return {
      node: null
    };
  }

  return {
    after: childLexicalNodes => {
      const domParent = domNode.parentNode;

      if (domParent != null && domNode !== domParent.lastChild) {
        childLexicalNodes.push(Lexical_1.$createLineBreakNode());
      }

      return childLexicalNodes;
    },
    node: isCode ? $createCodeNode$1() : null,
    preformatted: isCode
  };
}

function convertTableElement() {
  return {
    node: $createCodeNode$1(),
    preformatted: true
  };
}

function convertCodeNoop() {
  return {
    node: null
  };
}

function convertTableCellElement(domNode) {
  // domNode is a <td> since we matched it by nodeName
  const cell = domNode;
  return {
    after: childLexicalNodes => {
      if (cell.parentNode && cell.parentNode.nextSibling) {
        // Append newline between code lines
        childLexicalNodes.push(Lexical_1.$createLineBreakNode());
      }

      return childLexicalNodes;
    },
    node: null
  };
}

function isCodeElement(div) {
  return div.style.fontFamily.match('monospace') !== null;
}

function isCodeChildElement(node) {
  let parent = node.parentElement;

  while (parent !== null) {
    if (isCodeElement(parent)) {
      return true;
    }

    parent = parent.parentElement;
  }

  return false;
}

function isGitHubCodeCell(cell) {
  return cell.classList.contains('js-file-line');
}

function isGitHubCodeTable(table) {
  return table.classList.contains('js-file-line-container');
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const DEFAULT_CODE_LANGUAGE$1 = 'javascript';
const CODE_LANGUAGE_FRIENDLY_NAME_MAP$1 = {
  c: 'C',
  clike: 'C-like',
  cpp: 'C++',
  css: 'CSS',
  html: 'HTML',
  java: 'Java',
  js: 'JavaScript',
  markdown: 'Markdown',
  objc: 'Objective-C',
  plain: 'Plain Text',
  py: 'Python',
  rust: 'Rust',
  sql: 'SQL',
  swift: 'Swift',
  typescript: 'TypeScript',
  xml: 'XML'
};
const CODE_LANGUAGE_MAP$1 = {
  cpp: 'cpp',
  java: 'java',
  javascript: 'js',
  md: 'markdown',
  plaintext: 'plain',
  python: 'py',
  text: 'plain',
  ts: 'typescript'
};
function normalizeCodeLang$1(lang) {
  return CODE_LANGUAGE_MAP$1[lang] || lang;
}
function getLanguageFriendlyName$1(lang) {
  const _lang = normalizeCodeLang$1(lang);

  return CODE_LANGUAGE_FRIENDLY_NAME_MAP$1[_lang] || _lang;
}
const getDefaultCodeLanguage$1 = () => DEFAULT_CODE_LANGUAGE$1;
const getCodeLanguages$1 = () => Object.keys(prism.languages).filter( // Prism has several language helpers mixed into languages object
// so filtering them out here to get langs list
language => typeof prism.languages[language] !== 'function').sort();
/** @noInheritDoc */

class CodeHighlightNode$1 extends Lexical_1.TextNode {
  /** @internal */
  constructor(text, highlightType, key) {
    super(text, key);
    this.__highlightType = highlightType;
  }

  static getType() {
    return 'code-highlight';
  }

  static clone(node) {
    return new CodeHighlightNode$1(node.__text, node.__highlightType || undefined, node.__key);
  }

  getHighlightType() {
    const self = this.getLatest();
    return self.__highlightType;
  }

  createDOM(config) {
    const element = super.createDOM(config);
    const className = getHighlightThemeClass(config.theme, this.__highlightType);
    LexicalUtils_1.addClassNamesToElement(element, className);
    return element;
  }

  updateDOM(prevNode, dom, config) {
    const update = super.updateDOM(prevNode, dom, config);
    const prevClassName = getHighlightThemeClass(config.theme, prevNode.__highlightType);
    const nextClassName = getHighlightThemeClass(config.theme, this.__highlightType);

    if (prevClassName !== nextClassName) {
      if (prevClassName) {
        LexicalUtils_1.removeClassNamesFromElement(dom, prevClassName);
      }

      if (nextClassName) {
        LexicalUtils_1.addClassNamesToElement(dom, nextClassName);
      }
    }

    return update;
  }

  static importJSON(serializedNode) {
    const node = $createCodeHighlightNode$1(serializedNode.text, serializedNode.highlightType);
    node.setFormat(serializedNode.format);
    node.setDetail(serializedNode.detail);
    node.setMode(serializedNode.mode);
    node.setStyle(serializedNode.style);
    return node;
  }

  exportJSON() {
    return { ...super.exportJSON(),
      highlightType: this.getHighlightType(),
      type: 'code-highlight',
      version: 1
    };
  } // Prevent formatting (bold, underline, etc)


  setFormat(format) {
    return this;
  }

  isParentRequired() {
    return true;
  }

  createParentElementNode() {
    return $createCodeNode$1();
  }

}

function getHighlightThemeClass(theme, highlightType) {
  return highlightType && theme && theme.codeHighlight && theme.codeHighlight[highlightType];
}

function $createCodeHighlightNode$1(text, highlightType) {
  return Lexical_1.$applyNodeReplacement(new CodeHighlightNode$1(text, highlightType));
}
function $isCodeHighlightNode$1(node) {
  return node instanceof CodeHighlightNode$1;
}
function getFirstCodeHighlightNodeOfLine$1(anchor) {
  let currentNode = null;
  const previousSiblings = anchor.getPreviousSiblings();
  previousSiblings.push(anchor);

  while (previousSiblings.length > 0) {
    const node = previousSiblings.pop();

    if ($isCodeHighlightNode$1(node)) {
      currentNode = node;
    }

    if (Lexical_1.$isLineBreakNode(node)) {
      break;
    }
  }

  return currentNode;
}
function getLastCodeHighlightNodeOfLine$1(anchor) {
  let currentNode = null;
  const nextSiblings = anchor.getNextSiblings();
  nextSiblings.unshift(anchor);

  while (nextSiblings.length > 0) {
    const node = nextSiblings.shift();

    if ($isCodeHighlightNode$1(node)) {
      currentNode = node;
    }

    if (Lexical_1.$isLineBreakNode(node)) {
      break;
    }
  }

  return currentNode;
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const PrismTokenizer$1 = {
  defaultLanguage: DEFAULT_CODE_LANGUAGE$1,

  tokenize(code, language) {
    return prism.tokenize(code, prism.languages[language || ''] || prism.languages[this.defaultLanguage]);
  }

};

function isSpaceOrTabChar(char) {
  return char === ' ' || char === '\t';
}

function findFirstNotSpaceOrTabCharAtText(text, isForward) {
  const length = text.length;
  let offset = -1;

  if (isForward) {
    for (let i = 0; i < length; i++) {
      const char = text[i];

      if (!isSpaceOrTabChar(char)) {
        offset = i;
        break;
      }
    }
  } else {
    for (let i = length - 1; i > -1; i--) {
      const char = text[i];

      if (!isSpaceOrTabChar(char)) {
        offset = i;
        break;
      }
    }
  }

  return offset;
}

function getStartOfCodeInLine$1(anchor) {
  let currentNode = null;
  let currentNodeOffset = -1;
  const previousSiblings = anchor.getPreviousSiblings();
  previousSiblings.push(anchor);

  while (previousSiblings.length > 0) {
    const node = previousSiblings.pop();

    if ($isCodeHighlightNode$1(node)) {
      const text = node.getTextContent();
      const offset = findFirstNotSpaceOrTabCharAtText(text, true);

      if (offset !== -1) {
        currentNode = node;
        currentNodeOffset = offset;
      }
    }

    if (Lexical_1.$isLineBreakNode(node)) {
      break;
    }
  }

  if (currentNode === null) {
    const nextSiblings = anchor.getNextSiblings();

    while (nextSiblings.length > 0) {
      const node = nextSiblings.shift();

      if ($isCodeHighlightNode$1(node)) {
        const text = node.getTextContent();
        const offset = findFirstNotSpaceOrTabCharAtText(text, true);

        if (offset !== -1) {
          currentNode = node;
          currentNodeOffset = offset;
          break;
        }
      }

      if (Lexical_1.$isLineBreakNode(node)) {
        break;
      }
    }
  }

  return {
    node: currentNode,
    offset: currentNodeOffset
  };
}
function getEndOfCodeInLine$1(anchor) {
  let currentNode = null;
  let currentNodeOffset = -1;
  const nextSiblings = anchor.getNextSiblings();
  nextSiblings.unshift(anchor);

  while (nextSiblings.length > 0) {
    const node = nextSiblings.shift();

    if ($isCodeHighlightNode$1(node)) {
      const text = node.getTextContent();
      const offset = findFirstNotSpaceOrTabCharAtText(text, false);

      if (offset !== -1) {
        currentNode = node;
        currentNodeOffset = offset + 1;
      }
    }

    if (Lexical_1.$isLineBreakNode(node)) {
      break;
    }
  }

  if (currentNode === null) {
    const previousSiblings = anchor.getPreviousSiblings();

    while (previousSiblings.length > 0) {
      const node = previousSiblings.pop();

      if ($isCodeHighlightNode$1(node)) {
        const text = node.getTextContent();
        const offset = findFirstNotSpaceOrTabCharAtText(text, false);

        if (offset !== -1) {
          currentNode = node;
          currentNodeOffset = offset + 1;
          break;
        }
      }

      if (Lexical_1.$isLineBreakNode(node)) {
        break;
      }
    }
  }

  return {
    node: currentNode,
    offset: currentNodeOffset
  };
}

function textNodeTransform(node, editor, tokenizer) {
  // Since CodeNode has flat children structure we only need to check
  // if node's parent is a code node and run highlighting if so
  const parentNode = node.getParent();

  if ($isCodeNode$1(parentNode)) {
    codeNodeTransform(parentNode, editor, tokenizer);
  } else if ($isCodeHighlightNode$1(node)) {
    // When code block converted into paragraph or other element
    // code highlight nodes converted back to normal text
    node.replace(Lexical_1.$createTextNode(node.__text));
  }
}

function updateCodeGutter(node, editor) {
  const codeElement = editor.getElementByKey(node.getKey());

  if (codeElement === null) {
    return;
  }

  const children = node.getChildren();
  const childrenLength = children.length; // @ts-ignore: internal field

  if (childrenLength === codeElement.__cachedChildrenLength) {
    // Avoid updating the attribute if the children length hasn't changed.
    return;
  } // @ts-ignore:: internal field


  codeElement.__cachedChildrenLength = childrenLength;
  let gutter = '1';
  let count = 1;

  for (let i = 0; i < childrenLength; i++) {
    if (Lexical_1.$isLineBreakNode(children[i])) {
      gutter += '\n' + ++count;
    }
  }

  codeElement.setAttribute('data-gutter', gutter);
} // Using `skipTransforms` to prevent extra transforms since reformatting the code
// will not affect code block content itself.
//
// Using extra cache (`nodesCurrentlyHighlighting`) since both CodeNode and CodeHighlightNode
// transforms might be called at the same time (e.g. new CodeHighlight node inserted) and
// in both cases we'll rerun whole reformatting over CodeNode, which is redundant.
// Especially when pasting code into CodeBlock.


const nodesCurrentlyHighlighting = new Set();

function codeNodeTransform(node, editor, tokenizer) {
  const nodeKey = node.getKey();

  if (nodesCurrentlyHighlighting.has(nodeKey)) {
    return;
  }

  nodesCurrentlyHighlighting.add(nodeKey); // When new code block inserted it might not have language selected

  if (node.getLanguage() === undefined) {
    node.setLanguage(tokenizer.defaultLanguage);
  } // Using nested update call to pass `skipTransforms` since we don't want
  // each individual codehighlight node to be transformed again as it's already
  // in its final state


  editor.update(() => {
    updateAndRetainSelection(nodeKey, () => {
      const currentNode = Lexical_1.$getNodeByKey(nodeKey);

      if (!$isCodeNode$1(currentNode) || !currentNode.isAttached()) {
        return false;
      }

      const code = currentNode.getTextContent();
      const tokens = tokenizer.tokenize(code, currentNode.getLanguage() || tokenizer.defaultLanguage);
      const highlightNodes = getHighlightNodes(tokens);
      const diffRange = getDiffRange(currentNode.getChildren(), highlightNodes);
      const {
        from,
        to,
        nodesForReplacement
      } = diffRange;

      if (from !== to || nodesForReplacement.length) {
        node.splice(from, to - from, nodesForReplacement);
        return true;
      }

      return false;
    });
  }, {
    onUpdate: () => {
      nodesCurrentlyHighlighting.delete(nodeKey);
    },
    skipTransforms: true
  });
}

function getHighlightNodes(tokens) {
  const nodes = [];
  tokens.forEach(token => {
    if (typeof token === 'string') {
      const partials = token.split('\n');

      for (let i = 0; i < partials.length; i++) {
        const text = partials[i];

        if (text.length) {
          nodes.push($createCodeHighlightNode$1(text));
        }

        if (i < partials.length - 1) {
          nodes.push(Lexical_1.$createLineBreakNode());
        }
      }
    } else {
      const {
        content
      } = token;

      if (typeof content === 'string') {
        nodes.push($createCodeHighlightNode$1(content, token.type));
      } else if (Array.isArray(content) && content.length === 1 && typeof content[0] === 'string') {
        nodes.push($createCodeHighlightNode$1(content[0], token.type));
      } else if (Array.isArray(content)) {
        nodes.push(...getHighlightNodes(content));
      }
    }
  });
  return nodes;
} // Wrapping update function into selection retainer, that tries to keep cursor at the same
// position as before.


function updateAndRetainSelection(nodeKey, updateFn) {
  const node = Lexical_1.$getNodeByKey(nodeKey);

  if (!$isCodeNode$1(node) || !node.isAttached()) {
    return;
  }

  const selection = Lexical_1.$getSelection(); // If it's not range selection (or null selection) there's no need to change it,
  // but we can still run highlighting logic

  if (!Lexical_1.$isRangeSelection(selection)) {
    updateFn();
    return;
  }

  const anchor = selection.anchor;
  const anchorOffset = anchor.offset;
  const isNewLineAnchor = anchor.type === 'element' && Lexical_1.$isLineBreakNode(node.getChildAtIndex(anchor.offset - 1));
  let textOffset = 0; // Calculating previous text offset (all text node prior to anchor + anchor own text offset)

  if (!isNewLineAnchor) {
    const anchorNode = anchor.getNode();
    textOffset = anchorOffset + anchorNode.getPreviousSiblings().reduce((offset, _node) => {
      return offset + _node.getTextContentSize();
    }, 0);
  }

  const hasChanges = updateFn();

  if (!hasChanges) {
    return;
  } // Non-text anchors only happen for line breaks, otherwise
  // selection will be within text node (code highlight node)


  if (isNewLineAnchor) {
    anchor.getNode().select(anchorOffset, anchorOffset);
    return;
  } // If it was non-element anchor then we walk through child nodes
  // and looking for a position of original text offset


  node.getChildren().some(_node => {
    const isText = Lexical_1.$isTextNode(_node);

    if (isText || Lexical_1.$isLineBreakNode(_node)) {
      const textContentSize = _node.getTextContentSize();

      if (isText && textContentSize >= textOffset) {
        _node.select(textOffset, textOffset);

        return true;
      }

      textOffset -= textContentSize;
    }

    return false;
  });
} // Finds minimal diff range between two nodes lists. It returns from/to range boundaries of prevNodes
// that needs to be replaced with `nodes` (subset of nextNodes) to make prevNodes equal to nextNodes.


function getDiffRange(prevNodes, nextNodes) {
  let leadingMatch = 0;

  while (leadingMatch < prevNodes.length) {
    if (!isEqual$1(prevNodes[leadingMatch], nextNodes[leadingMatch])) {
      break;
    }

    leadingMatch++;
  }

  const prevNodesLength = prevNodes.length;
  const nextNodesLength = nextNodes.length;
  const maxTrailingMatch = Math.min(prevNodesLength, nextNodesLength) - leadingMatch;
  let trailingMatch = 0;

  while (trailingMatch < maxTrailingMatch) {
    trailingMatch++;

    if (!isEqual$1(prevNodes[prevNodesLength - trailingMatch], nextNodes[nextNodesLength - trailingMatch])) {
      trailingMatch--;
      break;
    }
  }

  const from = leadingMatch;
  const to = prevNodesLength - trailingMatch;
  const nodesForReplacement = nextNodes.slice(leadingMatch, nextNodesLength - trailingMatch);
  return {
    from,
    nodesForReplacement,
    to
  };
}

function isEqual$1(nodeA, nodeB) {
  // Only checking for code higlight nodes and linebreaks. If it's regular text node
  // returning false so that it's transformed into code highlight node
  if ($isCodeHighlightNode$1(nodeA) && $isCodeHighlightNode$1(nodeB)) {
    return nodeA.__text === nodeB.__text && nodeA.__highlightType === nodeB.__highlightType;
  }

  if (Lexical_1.$isLineBreakNode(nodeA) && Lexical_1.$isLineBreakNode(nodeB)) {
    return true;
  }

  return false;
}

function handleMultilineIndent(type) {
  const selection = Lexical_1.$getSelection();

  if (!Lexical_1.$isRangeSelection(selection) || selection.isCollapsed()) {
    return false;
  } // Only run multiline indent logic on selections exclusively composed of code highlights and linebreaks


  const nodes = selection.getNodes();

  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i];

    if (!$isCodeHighlightNode$1(node) && !Lexical_1.$isLineBreakNode(node)) {
      return false;
    }
  }

  const startOfLine = getFirstCodeHighlightNodeOfLine$1(nodes[0]);

  if (startOfLine != null) {
    doIndent(startOfLine, type);
  }

  for (let i = 1; i < nodes.length; i++) {
    const node = nodes[i];

    if (Lexical_1.$isLineBreakNode(nodes[i - 1]) && $isCodeHighlightNode$1(node)) {
      doIndent(node, type);
    }
  }

  return true;
}

function doIndent(node, type) {
  const text = node.getTextContent();

  if (type === Lexical_1.INDENT_CONTENT_COMMAND) {
    // If the codeblock node doesn't start with whitespace, we don't want to
    // naively prepend a '\t'; Prism will then mangle all of our nodes when
    // it separates the whitespace from the first non-whitespace node. This
    // will lead to selection bugs when indenting lines that previously
    // didn't start with a whitespace character
    if (text.length > 0 && /\s/.test(text[0])) {
      node.setTextContent('\t' + text);
    } else {
      const indentNode = $createCodeHighlightNode$1('\t');
      node.insertBefore(indentNode);
    }
  } else {
    if (text.indexOf('\t') === 0) {
      // Same as above - if we leave empty text nodes lying around, the resulting
      // selection will be mangled
      if (text.length === 1) {
        node.remove();
      } else {
        node.setTextContent(text.substring(1));
      }
    }
  }
}

function handleShiftLines(type, event) {
  // We only care about the alt+arrow keys
  const selection = Lexical_1.$getSelection();

  if (!Lexical_1.$isRangeSelection(selection)) {
    return false;
  } // I'm not quite sure why, but it seems like calling anchor.getNode() collapses the selection here
  // So first, get the anchor and the focus, then get their nodes


  const {
    anchor,
    focus
  } = selection;
  const anchorOffset = anchor.offset;
  const focusOffset = focus.offset;
  const anchorNode = anchor.getNode();
  const focusNode = focus.getNode();
  const arrowIsUp = type === Lexical_1.KEY_ARROW_UP_COMMAND; // Ensure the selection is within the codeblock

  if (!$isCodeHighlightNode$1(anchorNode) || !$isCodeHighlightNode$1(focusNode)) {
    return false;
  }

  if (!event.altKey) {
    // Handle moving selection out of the code block, given there are no
    // sibling thats can natively take the selection.
    if (selection.isCollapsed()) {
      const codeNode = anchorNode.getParentOrThrow();

      if (arrowIsUp && anchorOffset === 0 && anchorNode.getPreviousSibling() === null) {
        const codeNodeSibling = codeNode.getPreviousSibling();

        if (codeNodeSibling === null) {
          codeNode.selectPrevious();
          event.preventDefault();
          return true;
        }
      } else if (!arrowIsUp && anchorOffset === anchorNode.getTextContentSize() && anchorNode.getNextSibling() === null) {
        const codeNodeSibling = codeNode.getNextSibling();

        if (codeNodeSibling === null) {
          codeNode.selectNext();
          event.preventDefault();
          return true;
        }
      }
    }

    return false;
  }

  const start = getFirstCodeHighlightNodeOfLine$1(anchorNode);
  const end = getLastCodeHighlightNodeOfLine$1(focusNode);

  if (start == null || end == null) {
    return false;
  }

  const range = start.getNodesBetween(end);

  for (let i = 0; i < range.length; i++) {
    const node = range[i];

    if (!$isCodeHighlightNode$1(node) && !Lexical_1.$isLineBreakNode(node)) {
      return false;
    }
  } // After this point, we know the selection is within the codeblock. We may not be able to
  // actually move the lines around, but we want to return true either way to prevent
  // the event's default behavior


  event.preventDefault();
  event.stopPropagation(); // required to stop cursor movement under Firefox

  const linebreak = arrowIsUp ? start.getPreviousSibling() : end.getNextSibling();

  if (!Lexical_1.$isLineBreakNode(linebreak)) {
    return true;
  }

  const sibling = arrowIsUp ? linebreak.getPreviousSibling() : linebreak.getNextSibling();

  if (sibling == null) {
    return true;
  }

  const maybeInsertionPoint = arrowIsUp ? getFirstCodeHighlightNodeOfLine$1(sibling) : getLastCodeHighlightNodeOfLine$1(sibling);
  let insertionPoint = maybeInsertionPoint != null ? maybeInsertionPoint : sibling;
  linebreak.remove();
  range.forEach(node => node.remove());

  if (type === Lexical_1.KEY_ARROW_UP_COMMAND) {
    range.forEach(node => insertionPoint.insertBefore(node));
    insertionPoint.insertBefore(linebreak);
  } else {
    insertionPoint.insertAfter(linebreak);
    insertionPoint = linebreak;
    range.forEach(node => {
      insertionPoint.insertAfter(node);
      insertionPoint = node;
    });
  }

  selection.setTextNodeRange(anchorNode, anchorOffset, focusNode, focusOffset);
  return true;
}

function handleMoveTo(type, event) {
  const selection = Lexical_1.$getSelection();

  if (!Lexical_1.$isRangeSelection(selection)) {
    return false;
  }

  const {
    anchor,
    focus
  } = selection;
  const anchorNode = anchor.getNode();
  const focusNode = focus.getNode();
  const isMoveToStart = type === Lexical_1.MOVE_TO_START;

  if (!$isCodeHighlightNode$1(anchorNode) || !$isCodeHighlightNode$1(focusNode)) {
    return false;
  }

  let node;
  let offset;

  if (isMoveToStart) {
    ({
      node,
      offset
    } = getStartOfCodeInLine$1(focusNode));
  } else {
    ({
      node,
      offset
    } = getEndOfCodeInLine$1(focusNode));
  }

  if (node !== null && offset !== -1) {
    selection.setTextNodeRange(node, offset, node, offset);
  }

  event.preventDefault();
  event.stopPropagation();
  return true;
}

function registerCodeHighlighting$1(editor, tokenizer) {
  if (!editor.hasNodes([CodeNode$1, CodeHighlightNode$1])) {
    throw new Error('CodeHighlightPlugin: CodeNode or CodeHighlightNode not registered on editor');
  }

  if (tokenizer == null) {
    tokenizer = PrismTokenizer$1;
  }

  return LexicalUtils_1.mergeRegister(editor.registerMutationListener(CodeNode$1, mutations => {
    editor.update(() => {
      for (const [key, type] of mutations) {
        if (type !== 'destroyed') {
          const node = Lexical_1.$getNodeByKey(key);

          if (node !== null) {
            updateCodeGutter(node, editor);
          }
        }
      }
    });
  }), editor.registerNodeTransform(CodeNode$1, node => codeNodeTransform(node, editor, tokenizer)), editor.registerNodeTransform(Lexical_1.TextNode, node => textNodeTransform(node, editor, tokenizer)), editor.registerNodeTransform(CodeHighlightNode$1, node => textNodeTransform(node, editor, tokenizer)), editor.registerCommand(Lexical_1.INDENT_CONTENT_COMMAND, payload => handleMultilineIndent(Lexical_1.INDENT_CONTENT_COMMAND), Lexical_1.COMMAND_PRIORITY_LOW), editor.registerCommand(Lexical_1.OUTDENT_CONTENT_COMMAND, payload => handleMultilineIndent(Lexical_1.OUTDENT_CONTENT_COMMAND), Lexical_1.COMMAND_PRIORITY_LOW), editor.registerCommand(Lexical_1.KEY_ARROW_UP_COMMAND, payload => handleShiftLines(Lexical_1.KEY_ARROW_UP_COMMAND, payload), Lexical_1.COMMAND_PRIORITY_LOW), editor.registerCommand(Lexical_1.KEY_ARROW_DOWN_COMMAND, payload => handleShiftLines(Lexical_1.KEY_ARROW_DOWN_COMMAND, payload), Lexical_1.COMMAND_PRIORITY_LOW), editor.registerCommand(Lexical_1.MOVE_TO_END, payload => handleMoveTo(Lexical_1.MOVE_TO_END, payload), Lexical_1.COMMAND_PRIORITY_LOW), editor.registerCommand(Lexical_1.MOVE_TO_START, payload => handleMoveTo(Lexical_1.MOVE_TO_START, payload), Lexical_1.COMMAND_PRIORITY_LOW));
}

var $createCodeHighlightNode_1 = $createCodeHighlightNode$1;
var $createCodeNode_1 = $createCodeNode$1;
var $isCodeHighlightNode_1 = $isCodeHighlightNode$1;
var $isCodeNode_1 = $isCodeNode$1;
var CODE_LANGUAGE_FRIENDLY_NAME_MAP_1 = CODE_LANGUAGE_FRIENDLY_NAME_MAP$1;
var CODE_LANGUAGE_MAP_1 = CODE_LANGUAGE_MAP$1;
var CodeHighlightNode_1 = CodeHighlightNode$1;
var CodeNode_1 = CodeNode$1;
var DEFAULT_CODE_LANGUAGE_1 = DEFAULT_CODE_LANGUAGE$1;
var PrismTokenizer_1 = PrismTokenizer$1;
var getCodeLanguages_1 = getCodeLanguages$1;
var getDefaultCodeLanguage_1 = getDefaultCodeLanguage$1;
var getEndOfCodeInLine_1 = getEndOfCodeInLine$1;
var getFirstCodeHighlightNodeOfLine_1 = getFirstCodeHighlightNodeOfLine$1;
var getLanguageFriendlyName_1 = getLanguageFriendlyName$1;
var getLastCodeHighlightNodeOfLine_1 = getLastCodeHighlightNodeOfLine$1;
var getStartOfCodeInLine_1 = getStartOfCodeInLine$1;
var normalizeCodeLang_1 = normalizeCodeLang$1;
var registerCodeHighlighting_1 = registerCodeHighlighting$1;

var LexicalCode_dev = {
	$createCodeHighlightNode: $createCodeHighlightNode_1,
	$createCodeNode: $createCodeNode_1,
	$isCodeHighlightNode: $isCodeHighlightNode_1,
	$isCodeNode: $isCodeNode_1,
	CODE_LANGUAGE_FRIENDLY_NAME_MAP: CODE_LANGUAGE_FRIENDLY_NAME_MAP_1,
	CODE_LANGUAGE_MAP: CODE_LANGUAGE_MAP_1,
	CodeHighlightNode: CodeHighlightNode_1,
	CodeNode: CodeNode_1,
	DEFAULT_CODE_LANGUAGE: DEFAULT_CODE_LANGUAGE_1,
	PrismTokenizer: PrismTokenizer_1,
	getCodeLanguages: getCodeLanguages_1,
	getDefaultCodeLanguage: getDefaultCodeLanguage_1,
	getEndOfCodeInLine: getEndOfCodeInLine_1,
	getFirstCodeHighlightNodeOfLine: getFirstCodeHighlightNodeOfLine_1,
	getLanguageFriendlyName: getLanguageFriendlyName_1,
	getLastCodeHighlightNodeOfLine: getLastCodeHighlightNodeOfLine_1,
	getStartOfCodeInLine: getStartOfCodeInLine_1,
	normalizeCodeLang: normalizeCodeLang_1,
	registerCodeHighlighting: registerCodeHighlighting_1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
let v$4=a=>null!=a&&prism.languages.hasOwnProperty(a)?a:void 0;function x$3(a,b){for(let c of a.childNodes){if(LexicalUtils_1.isHTMLElement(c)&&c.tagName===b)return !0;x$3(c,b);}return !1}
class y$4 extends Lexical_1.ElementNode{static getType(){return "code"}static clone(a){return new y$4(a.__language,a.__key)}constructor(a,b){super(b);this.__language=v$4(a);}createDOM(a){let b=document.createElement("code");LexicalUtils_1.addClassNamesToElement(b,a.theme.code);b.setAttribute("spellcheck","false");(a=this.getLanguage())&&b.setAttribute("data-highlight-language",a);return b}updateDOM(a,b){let c=this.__language;a=a.__language;c?c!==a&&b.setAttribute("data-highlight-language",c):a&&b.removeAttribute("data-highlight-language");
return !1}static importDOM(){return {code:a=>null!=a.textContent&&(/\r?\n/.test(a.textContent)||x$3(a,"BR"))?{conversion:z$5,priority:1}:null,div:()=>({conversion:aa$1,priority:1}),pre:()=>({conversion:z$5,priority:0}),table:a=>A$4(a)?{conversion:ba$2,priority:3}:null,td:a=>{let b=a.closest("table");return a.classList.contains("js-file-line")?{conversion:ca$2,priority:3}:b&&A$4(b)?{conversion:B$5,priority:3}:null},tr:a=>(a=a.closest("table"))&&A$4(a)?{conversion:B$5,priority:3}:null}}static importJSON(a){let b=C$3(a.language);
b.setFormat(a.format);b.setIndent(a.indent);b.setDirection(a.direction);return b}exportJSON(){return {...super.exportJSON(),language:this.getLanguage(),type:"code",version:1}}insertNewAfter(a,b=!0){var c=this.getChildren(),d=c.length;if(2<=d&&"\n"===c[d-1].getTextContent()&&"\n"===c[d-2].getTextContent()&&a.isCollapsed()&&a.anchor.key===this.__key&&a.anchor.offset===d)return c[d-1].remove(),c[d-2].remove(),a=Lexical_1.$createParagraphNode(),this.insertAfter(a,b),a;b=a.anchor.getNode();d=D$3(b);if(null!=d){c=
0;for(d=d.getTextContent();c<d.length&&/[\t ]/.test(d[c]);)c+=1;if(0<c)return c=d.substring(0,c),c=E$4(c),b.insertAfter(c),a.insertNodes([Lexical_1.$createLineBreakNode()]),c.select(),c}return null}canInsertTab(){let a=Lexical_1.$getSelection();return Lexical_1.$isRangeSelection(a)&&a.isCollapsed()?!0:!1}canIndent(){return !1}collapseAtStart(){let a=Lexical_1.$createParagraphNode();this.getChildren().forEach(b=>a.append(b));this.replace(a);return !0}setLanguage(a){this.getWritable().__language=v$4(a);}getLanguage(){return this.getLatest().__language}}
function C$3(a){return Lexical_1.$applyNodeReplacement(new y$4(a))}function F$3(a){return a instanceof y$4}function z$5(){return {node:C$3(),preformatted:!0}}function aa$1(a){let b=null!==a.style.fontFamily.match("monospace");return b||da$2(a)?{after:c=>{let d=a.parentNode;null!=d&&a!==d.lastChild&&c.push(Lexical_1.$createLineBreakNode());return c},node:b?C$3():null,preformatted:b}:{node:null}}function ba$2(){return {node:C$3(),preformatted:!0}}function B$5(){return {node:null}}
function ca$2(a){return {after:b=>{a.parentNode&&a.parentNode.nextSibling&&b.push(Lexical_1.$createLineBreakNode());return b},node:null}}function da$2(a){for(a=a.parentElement;null!==a;){if(null!==a.style.fontFamily.match("monospace"))return !0;a=a.parentElement;}return !1}function A$4(a){return a.classList.contains("js-file-line-container")}
let G$3={c:"C",clike:"C-like",cpp:"C++",css:"CSS",html:"HTML",java:"Java",js:"JavaScript",markdown:"Markdown",objc:"Objective-C",plain:"Plain Text",py:"Python",rust:"Rust",sql:"SQL",swift:"Swift",typescript:"TypeScript",xml:"XML"},H$5={cpp:"cpp",java:"java",javascript:"js",md:"markdown",plaintext:"plain",python:"py",text:"plain",ts:"typescript"};function I$4(a){return H$5[a]||a}
class J$4 extends Lexical_1.TextNode{constructor(a,b,c){super(a,c);this.__highlightType=b;}static getType(){return "code-highlight"}static clone(a){return new J$4(a.__text,a.__highlightType||void 0,a.__key)}getHighlightType(){return this.getLatest().__highlightType}createDOM(a){let b=super.createDOM(a);a=K$4(a.theme,this.__highlightType);LexicalUtils_1.addClassNamesToElement(b,a);return b}updateDOM(a,b,c){let d=super.updateDOM(a,b,c);a=K$4(c.theme,a.__highlightType);c=K$4(c.theme,this.__highlightType);a!==c&&(a&&LexicalUtils_1.removeClassNamesFromElement(b,
a),c&&LexicalUtils_1.addClassNamesToElement(b,c));return d}static importJSON(a){let b=E$4(a.text,a.highlightType);b.setFormat(a.format);b.setDetail(a.detail);b.setMode(a.mode);b.setStyle(a.style);return b}exportJSON(){return {...super.exportJSON(),highlightType:this.getHighlightType(),type:"code-highlight",version:1}}setFormat(){return this}isParentRequired(){return !0}createParentElementNode(){return C$3()}}function K$4(a,b){return b&&a&&a.codeHighlight&&a.codeHighlight[b]}
function E$4(a,b){return Lexical_1.$applyNodeReplacement(new J$4(a,b))}function L$4(a){return a instanceof J$4}function D$3(a){let b=null,c=a.getPreviousSiblings();for(c.push(a);0<c.length&&(a=c.pop(),L$4(a)&&(b=a),!Lexical_1.$isLineBreakNode(a)););return b}function M$1(a){let b=null,c=a.getNextSiblings();for(c.unshift(a);0<c.length&&(a=c.shift(),L$4(a)&&(b=a),!Lexical_1.$isLineBreakNode(a)););return b}let N$2={defaultLanguage:"javascript",tokenize(a,b){return prism.tokenize(a,prism.languages[b||""]||prism.languages[this.defaultLanguage])}};
function O$3(a,b){var c=a.length;let d=-1;if(b)for(b=0;b<c;b++){let f=a[b];if(" "!==f&&"\t"!==f){d=b;break}}else for(--c;-1<c;c--)if(b=a[c]," "!==b&&"\t"!==b){d=c;break}return d}
function P$3(a){let b=null,c=-1;var d=a.getPreviousSiblings();for(d.push(a);0<d.length;){var f=d.pop();if(L$4(f)){var g=f.getTextContent();g=O$3(g,!0);-1!==g&&(b=f,c=g);}if(Lexical_1.$isLineBreakNode(f))break}if(null===b)for(a=a.getNextSiblings();0<a.length;){d=a.shift();if(L$4(d)&&(f=d.getTextContent(),f=O$3(f,!0),-1!==f)){b=d;c=f;break}if(Lexical_1.$isLineBreakNode(d))break}return {node:b,offset:c}}
function Q$3(a){let b=null,c=-1;var d=a.getNextSiblings();for(d.unshift(a);0<d.length;){var f=d.shift();if(L$4(f)){var g=f.getTextContent();g=O$3(g,!1);-1!==g&&(b=f,c=g+1);}if(Lexical_1.$isLineBreakNode(f))break}if(null===b)for(a=a.getPreviousSiblings();0<a.length;){d=a.pop();if(L$4(d)&&(f=d.getTextContent(),f=O$3(f,!1),-1!==f)){b=d;c=f+1;break}if(Lexical_1.$isLineBreakNode(d))break}return {node:b,offset:c}}function R$3(a,b,c){let d=a.getParent();F$3(d)?S$2(d,b,c):L$4(a)&&a.replace(Lexical_1.$createTextNode(a.__text));}let T$2=new Set;
function S$2(a,b,c){let d=a.getKey();T$2.has(d)||(T$2.add(d),void 0===a.getLanguage()&&a.setLanguage(c.defaultLanguage),b.update(()=>{ea$2(d,()=>{var f=Lexical_1.$getNodeByKey(d);if(!F$3(f)||!f.isAttached())return !1;var g=f.getTextContent();g=c.tokenize(g,f.getLanguage()||c.defaultLanguage);g=U$3(g);var k=f.getChildren();for(f=0;f<k.length&&V$2(k[f],g[f]);)f++;var h=k.length;let l=g.length,p=Math.min(h,l)-f,m=0;for(;m<p;)if(m++,!V$2(k[h-m],g[l-m])){m--;break}k=f;h-=m;g=g.slice(f,l-m);let {from:w,to:t,nodesForReplacement:r}=
{from:k,nodesForReplacement:g,to:h};return w!==t||r.length?(a.splice(w,t-w,r),!0):!1});},{onUpdate:()=>{T$2.delete(d);},skipTransforms:!0}));}
function U$3(a){let b=[];a.forEach(c=>{if("string"===typeof c){c=c.split("\n");for(var d=0;d<c.length;d++){let f=c[d];f.length&&b.push(E$4(f));d<c.length-1&&b.push(Lexical_1.$createLineBreakNode());}}else (({content:d}=c)),"string"===typeof d?b.push(E$4(d,c.type)):Array.isArray(d)&&1===d.length&&"string"===typeof d[0]?b.push(E$4(d[0],c.type)):Array.isArray(d)&&b.push(...U$3(d));});return b}
function ea$2(a,b){a=Lexical_1.$getNodeByKey(a);if(F$3(a)&&a.isAttached()){var c=Lexical_1.$getSelection();if(Lexical_1.$isRangeSelection(c)){c=c.anchor;var d=c.offset,f="element"===c.type&&Lexical_1.$isLineBreakNode(a.getChildAtIndex(c.offset-1)),g=0;if(!f){let k=c.getNode();g=d+k.getPreviousSiblings().reduce((h,l)=>h+l.getTextContentSize(),0);}b()&&(f?c.getNode().select(d,d):a.getChildren().some(k=>{let h=Lexical_1.$isTextNode(k);if(h||Lexical_1.$isLineBreakNode(k)){let l=k.getTextContentSize();if(h&&l>=g)return k.select(g,g),!0;g-=l;}return !1}));}else b();}}
function V$2(a,b){return L$4(a)&&L$4(b)?a.__text===b.__text&&a.__highlightType===b.__highlightType:Lexical_1.$isLineBreakNode(a)&&Lexical_1.$isLineBreakNode(b)?!0:!1}function W$2(a){var b=Lexical_1.$getSelection();if(!Lexical_1.$isRangeSelection(b)||b.isCollapsed())return !1;b=b.getNodes();for(var c=0;c<b.length;c++){var d=b[c];if(!L$4(d)&&!Lexical_1.$isLineBreakNode(d))return !1}c=D$3(b[0]);null!=c&&X$2(c,a);for(c=1;c<b.length;c++)d=b[c],Lexical_1.$isLineBreakNode(b[c-1])&&L$4(d)&&X$2(d,a);return !0}
function X$2(a,b){let c=a.getTextContent();b===Lexical_1.INDENT_CONTENT_COMMAND?0<c.length&&/\s/.test(c[0])?a.setTextContent("\t"+c):(b=E$4("\t"),a.insertBefore(b)):0===c.indexOf("\t")&&(1===c.length?a.remove():a.setTextContent(c.substring(1)));}
function Y$2(a,b){let c=Lexical_1.$getSelection();if(!Lexical_1.$isRangeSelection(c))return !1;let {anchor:d,focus:f}=c,g=d.offset,k=f.offset,h=d.getNode(),l=f.getNode();var p=a===Lexical_1.KEY_ARROW_UP_COMMAND;if(!L$4(h)||!L$4(l))return !1;if(!b.altKey){if(c.isCollapsed())if(a=h.getParentOrThrow(),p&&0===g&&null===h.getPreviousSibling()){if(null===a.getPreviousSibling())return a.selectPrevious(),b.preventDefault(),!0}else if(!p&&g===h.getTextContentSize()&&null===h.getNextSibling()&&null===a.getNextSibling())return a.selectNext(),
b.preventDefault(),!0;return !1}var m=D$3(h);let w=M$1(l);if(null==m||null==w)return !1;let t=m.getNodesBetween(w);for(let q=0;q<t.length;q++){let Z=t[q];if(!L$4(Z)&&!Lexical_1.$isLineBreakNode(Z))return !1}b.preventDefault();b.stopPropagation();b=p?m.getPreviousSibling():w.getNextSibling();if(!Lexical_1.$isLineBreakNode(b))return !0;m=p?b.getPreviousSibling():b.getNextSibling();if(null==m)return !0;p=p?D$3(m):M$1(m);let r=null!=p?p:m;b.remove();t.forEach(q=>q.remove());a===Lexical_1.KEY_ARROW_UP_COMMAND?(t.forEach(q=>r.insertBefore(q)),
r.insertBefore(b)):(r.insertAfter(b),r=b,t.forEach(q=>{r.insertAfter(q);r=q;}));c.setTextNodeRange(h,g,l,k);return !0}function fa$2(a,b){let c=Lexical_1.$getSelection();if(!Lexical_1.$isRangeSelection(c))return !1;let {anchor:d,focus:f}=c,g=d.getNode(),k=f.getNode();a=a===Lexical_1.MOVE_TO_START;if(!L$4(g)||!L$4(k))return !1;let h,l;a?{node:h,offset:l}=P$3(k):{node:h,offset:l}=Q$3(k);null!==h&&-1!==l&&c.setTextNodeRange(h,l,h,l);b.preventDefault();b.stopPropagation();return !0}var $createCodeHighlightNode=E$4;
var $createCodeNode=C$3;var $isCodeHighlightNode=L$4;var $isCodeNode=F$3;var CODE_LANGUAGE_FRIENDLY_NAME_MAP=G$3;var CODE_LANGUAGE_MAP=H$5;var CodeHighlightNode=J$4;var CodeNode=y$4;var DEFAULT_CODE_LANGUAGE="javascript";var PrismTokenizer=N$2;var getCodeLanguages=()=>Object.keys(prism.languages).filter(a=>"function"!==typeof prism.languages[a]).sort();var getDefaultCodeLanguage=()=>"javascript";var getEndOfCodeInLine=Q$3;var getFirstCodeHighlightNodeOfLine=D$3;
var getLanguageFriendlyName=function(a){a=I$4(a);return G$3[a]||a};var getLastCodeHighlightNodeOfLine=M$1;var getStartOfCodeInLine=P$3;var normalizeCodeLang=I$4;
var registerCodeHighlighting=function(a,b){if(!a.hasNodes([y$4,J$4]))throw Error("CodeHighlightPlugin: CodeNode or CodeHighlightNode not registered on editor");null==b&&(b=N$2);return LexicalUtils_1.mergeRegister(a.registerMutationListener(y$4,c=>{a.update(()=>{for(let [g,k]of c)if("destroyed"!==k){var d=Lexical_1.$getNodeByKey(g);if(null!==d)a:{var f=d;d=a.getElementByKey(f.getKey());if(null===d)break a;f=f.getChildren();let h=f.length;if(h===d.__cachedChildrenLength)break a;d.__cachedChildrenLength=h;let l="1",p=1;for(let m=
0;m<h;m++)Lexical_1.$isLineBreakNode(f[m])&&(l+="\n"+ ++p);d.setAttribute("data-gutter",l);}}});}),a.registerNodeTransform(y$4,c=>S$2(c,a,b)),a.registerNodeTransform(Lexical_1.TextNode,c=>R$3(c,a,b)),a.registerNodeTransform(J$4,c=>R$3(c,a,b)),a.registerCommand(Lexical_1.INDENT_CONTENT_COMMAND,()=>W$2(Lexical_1.INDENT_CONTENT_COMMAND),Lexical_1.COMMAND_PRIORITY_LOW),a.registerCommand(Lexical_1.OUTDENT_CONTENT_COMMAND,()=>W$2(Lexical_1.OUTDENT_CONTENT_COMMAND),Lexical_1.COMMAND_PRIORITY_LOW),a.registerCommand(Lexical_1.KEY_ARROW_UP_COMMAND,c=>Y$2(Lexical_1.KEY_ARROW_UP_COMMAND,c),Lexical_1.COMMAND_PRIORITY_LOW),
a.registerCommand(Lexical_1.KEY_ARROW_DOWN_COMMAND,c=>Y$2(Lexical_1.KEY_ARROW_DOWN_COMMAND,c),Lexical_1.COMMAND_PRIORITY_LOW),a.registerCommand(Lexical_1.MOVE_TO_END,c=>fa$2(Lexical_1.MOVE_TO_END,c),Lexical_1.COMMAND_PRIORITY_LOW),a.registerCommand(Lexical_1.MOVE_TO_START,c=>fa$2(Lexical_1.MOVE_TO_START,c),Lexical_1.COMMAND_PRIORITY_LOW))};

var LexicalCode_prod = {
	$createCodeHighlightNode: $createCodeHighlightNode,
	$createCodeNode: $createCodeNode,
	$isCodeHighlightNode: $isCodeHighlightNode,
	$isCodeNode: $isCodeNode,
	CODE_LANGUAGE_FRIENDLY_NAME_MAP: CODE_LANGUAGE_FRIENDLY_NAME_MAP,
	CODE_LANGUAGE_MAP: CODE_LANGUAGE_MAP,
	CodeHighlightNode: CodeHighlightNode,
	CodeNode: CodeNode,
	DEFAULT_CODE_LANGUAGE: DEFAULT_CODE_LANGUAGE,
	PrismTokenizer: PrismTokenizer,
	getCodeLanguages: getCodeLanguages,
	getDefaultCodeLanguage: getDefaultCodeLanguage,
	getEndOfCodeInLine: getEndOfCodeInLine,
	getFirstCodeHighlightNodeOfLine: getFirstCodeHighlightNodeOfLine,
	getLanguageFriendlyName: getLanguageFriendlyName,
	getLastCodeHighlightNodeOfLine: getLastCodeHighlightNodeOfLine,
	getStartOfCodeInLine: getStartOfCodeInLine,
	normalizeCodeLang: normalizeCodeLang,
	registerCodeHighlighting: registerCodeHighlighting
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const LexicalCode = process.env.NODE_ENV === 'development' ? LexicalCode_dev : LexicalCode_prod;
var LexicalCode_1 = LexicalCode;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */




/** @module @lexical/link */
const SUPPORTED_URL_PROTOCOLS = new Set(['http:', 'https:', 'mailto:', 'sms:', 'tel:']);
/** @noInheritDoc */

class LinkNode$1 extends Lexical_1.ElementNode {
  /** @internal */

  /** @internal */

  /** @internal */

  /** @internal */
  static getType() {
    return 'link';
  }

  static clone(node) {
    return new LinkNode$1(node.__url, {
      rel: node.__rel,
      target: node.__target,
      title: node.__title
    }, node.__key);
  }

  constructor(url, attributes = {}, key) {
    super(key);
    const {
      target = null,
      rel = null,
      title = null
    } = attributes;
    this.__url = url;
    this.__target = target;
    this.__rel = rel;
    this.__title = title;
  }

  createDOM(config) {
    const element = document.createElement('a');
    element.href = this.sanitizeUrl(this.__url);

    if (this.__target !== null) {
      element.target = this.__target;
    }

    if (this.__rel !== null) {
      element.rel = this.__rel;
    }

    if (this.__title !== null) {
      element.title = this.__title;
    }

    LexicalUtils_1.addClassNamesToElement(element, config.theme.link);
    return element;
  }

  updateDOM(prevNode, anchor, config) {
    const url = this.__url;
    const target = this.__target;
    const rel = this.__rel;
    const title = this.__title;

    if (url !== prevNode.__url) {
      anchor.href = url;
    }

    if (target !== prevNode.__target) {
      if (target) {
        anchor.target = target;
      } else {
        anchor.removeAttribute('target');
      }
    }

    if (rel !== prevNode.__rel) {
      if (rel) {
        anchor.rel = rel;
      } else {
        anchor.removeAttribute('rel');
      }
    }

    if (title !== prevNode.__title) {
      if (title) {
        anchor.title = title;
      } else {
        anchor.removeAttribute('title');
      }
    }

    return false;
  }

  static importDOM() {
    return {
      a: node => ({
        conversion: convertAnchorElement,
        priority: 1
      })
    };
  }

  static importJSON(serializedNode) {
    const node = $createLinkNode$1(serializedNode.url, {
      rel: serializedNode.rel,
      target: serializedNode.target,
      title: serializedNode.title
    });
    node.setFormat(serializedNode.format);
    node.setIndent(serializedNode.indent);
    node.setDirection(serializedNode.direction);
    return node;
  }

  sanitizeUrl(url) {
    try {
      const parsedUrl = new URL(url); // eslint-disable-next-line no-script-url

      if (!SUPPORTED_URL_PROTOCOLS.has(parsedUrl.protocol)) {
        return 'about:blank';
      }
    } catch (e) {
      return 'https://';
    }

    return url;
  }

  exportJSON() {
    return { ...super.exportJSON(),
      rel: this.getRel(),
      target: this.getTarget(),
      title: this.getTitle(),
      type: 'link',
      url: this.getURL(),
      version: 1
    };
  }

  getURL() {
    return this.getLatest().__url;
  }

  setURL(url) {
    const writable = this.getWritable();
    writable.__url = url;
  }

  getTarget() {
    return this.getLatest().__target;
  }

  setTarget(target) {
    const writable = this.getWritable();
    writable.__target = target;
  }

  getRel() {
    return this.getLatest().__rel;
  }

  setRel(rel) {
    const writable = this.getWritable();
    writable.__rel = rel;
  }

  getTitle() {
    return this.getLatest().__title;
  }

  setTitle(title) {
    const writable = this.getWritable();
    writable.__title = title;
  }

  insertNewAfter(selection, restoreSelection = true) {
    const element = this.getParentOrThrow().insertNewAfter(selection, restoreSelection);

    if (Lexical_1.$isElementNode(element)) {
      const linkNode = $createLinkNode$1(this.__url, {
        rel: this.__rel,
        target: this.__target,
        title: this.__title
      });
      element.append(linkNode);
      return linkNode;
    }

    return null;
  }

  canInsertTextBefore() {
    return false;
  }

  canInsertTextAfter() {
    return false;
  }

  canBeEmpty() {
    return false;
  }

  isInline() {
    return true;
  }

  extractWithChild(child, selection, destination) {
    if (!Lexical_1.$isRangeSelection(selection)) {
      return false;
    }

    const anchorNode = selection.anchor.getNode();
    const focusNode = selection.focus.getNode();
    return this.isParentOf(anchorNode) && this.isParentOf(focusNode) && selection.getTextContent().length > 0;
  }

}

function convertAnchorElement(domNode) {
  let node = null;

  if (LexicalUtils_1.isHTMLAnchorElement(domNode)) {
    const content = domNode.textContent;

    if (content !== null && content !== '') {
      node = $createLinkNode$1(domNode.getAttribute('href') || '', {
        rel: domNode.getAttribute('rel'),
        target: domNode.getAttribute('target'),
        title: domNode.getAttribute('title')
      });
    }
  }

  return {
    node
  };
}
/**
 * Takes a URL and creates a LinkNode.
 * @param url - The URL the LinkNode should direct to.
 * @param attributes - Optional HTML a tag attributes { target, rel, title }
 * @returns The LinkNode.
 */


function $createLinkNode$1(url, attributes) {
  return Lexical_1.$applyNodeReplacement(new LinkNode$1(url, attributes));
}
/**
 * Determines if node is a LinkNode.
 * @param node - The node to be checked.
 * @returns true if node is a LinkNode, false otherwise.
 */

function $isLinkNode$1(node) {
  return node instanceof LinkNode$1;
}
// Custom node type to override `canInsertTextAfter` that will
// allow typing within the link
class AutoLinkNode$1 extends LinkNode$1 {
  static getType() {
    return 'autolink';
  }

  static clone(node) {
    return new AutoLinkNode$1(node.__url, {
      rel: node.__rel,
      target: node.__target,
      title: node.__title
    }, node.__key);
  }

  static importJSON(serializedNode) {
    const node = $createAutoLinkNode$1(serializedNode.url, {
      rel: serializedNode.rel,
      target: serializedNode.target,
      title: serializedNode.title
    });
    node.setFormat(serializedNode.format);
    node.setIndent(serializedNode.indent);
    node.setDirection(serializedNode.direction);
    return node;
  }

  static importDOM() {
    // TODO: Should link node should handle the import over autolink?
    return null;
  }

  exportJSON() {
    return { ...super.exportJSON(),
      type: 'autolink',
      version: 1
    };
  }

  insertNewAfter(selection, restoreSelection = true) {
    const element = this.getParentOrThrow().insertNewAfter(selection, restoreSelection);

    if (Lexical_1.$isElementNode(element)) {
      const linkNode = $createAutoLinkNode$1(this.__url, {
        rel: this._rel,
        target: this.__target,
        title: this.__title
      });
      element.append(linkNode);
      return linkNode;
    }

    return null;
  }

}
/**
 * Takes a URL and creates an AutoLinkNode. AutoLinkNodes are generally automatically generated
 * during typing, which is especially useful when a button to generate a LinkNode is not practical.
 * @param url - The URL the LinkNode should direct to.
 * @param attributes - Optional HTML a tag attributes. { target, rel, title }
 * @returns The LinkNode.
 */

function $createAutoLinkNode$1(url, attributes) {
  return Lexical_1.$applyNodeReplacement(new AutoLinkNode$1(url, attributes));
}
/**
 * Determines if node is an AutoLinkNode.
 * @param node - The node to be checked.
 * @returns true if node is an AutoLinkNode, false otherwise.
 */

function $isAutoLinkNode$1(node) {
  return node instanceof AutoLinkNode$1;
}
const TOGGLE_LINK_COMMAND$1 = Lexical_1.createCommand('TOGGLE_LINK_COMMAND');
/**
 * Generates or updates a LinkNode. It can also delete a LinkNode if the URL is null,
 * but saves any children and brings them up to the parent node.
 * @param url - The URL the link directs to.
 * @param attributes - Optional HTML a tag attributes. { target, rel, title }
 */

function toggleLink$1(url, attributes = {}) {
  const {
    target,
    title
  } = attributes;
  const rel = attributes.rel === undefined ? 'noopener' : attributes.rel;
  const selection = Lexical_1.$getSelection();

  if (!Lexical_1.$isRangeSelection(selection)) {
    return;
  }

  const nodes = selection.extract();

  if (url === null) {
    // Remove LinkNodes
    nodes.forEach(node => {
      const parent = node.getParent();

      if ($isLinkNode$1(parent)) {
        const children = parent.getChildren();

        for (let i = 0; i < children.length; i++) {
          parent.insertBefore(children[i]);
        }

        parent.remove();
      }
    });
  } else {
    // Add or merge LinkNodes
    if (nodes.length === 1) {
      const firstNode = nodes[0]; // if the first node is a LinkNode or if its
      // parent is a LinkNode, we update the URL, target and rel.

      const linkNode = $isLinkNode$1(firstNode) ? firstNode : $getLinkAncestor(firstNode);

      if (linkNode !== null) {
        linkNode.setURL(url);

        if (target !== undefined) {
          linkNode.setTarget(target);
        }

        if (rel !== null) {
          linkNode.setRel(rel);
        }

        if (title !== undefined) {
          linkNode.setTitle(title);
        }

        return;
      }
    }

    let prevParent = null;
    let linkNode = null;
    nodes.forEach(node => {
      const parent = node.getParent();

      if (parent === linkNode || parent === null || Lexical_1.$isElementNode(node) && !node.isInline()) {
        return;
      }

      if ($isLinkNode$1(parent)) {
        linkNode = parent;
        parent.setURL(url);

        if (target !== undefined) {
          parent.setTarget(target);
        }

        if (rel !== null) {
          linkNode.setRel(rel);
        }

        if (title !== undefined) {
          linkNode.setTitle(title);
        }

        return;
      }

      if (!parent.is(prevParent)) {
        prevParent = parent;
        linkNode = $createLinkNode$1(url, {
          rel,
          target
        });

        if ($isLinkNode$1(parent)) {
          if (node.getPreviousSibling() === null) {
            parent.insertBefore(linkNode);
          } else {
            parent.insertAfter(linkNode);
          }
        } else {
          node.insertBefore(linkNode);
        }
      }

      if ($isLinkNode$1(node)) {
        if (node.is(linkNode)) {
          return;
        }

        if (linkNode !== null) {
          const children = node.getChildren();

          for (let i = 0; i < children.length; i++) {
            linkNode.append(children[i]);
          }
        }

        node.remove();
        return;
      }

      if (linkNode !== null) {
        linkNode.append(node);
      }
    });
  }
}

function $getLinkAncestor(node) {
  return $getAncestor(node, $isLinkNode$1);
}

function $getAncestor(node, predicate) {
  let parent = node;

  while (parent !== null && (parent = parent.getParent()) !== null && !predicate(parent));

  return parent;
}

var $createAutoLinkNode_1 = $createAutoLinkNode$1;
var $createLinkNode_1 = $createLinkNode$1;
var $isAutoLinkNode_1 = $isAutoLinkNode$1;
var $isLinkNode_1 = $isLinkNode$1;
var AutoLinkNode_1 = AutoLinkNode$1;
var LinkNode_1 = LinkNode$1;
var TOGGLE_LINK_COMMAND_1 = TOGGLE_LINK_COMMAND$1;
var toggleLink_1 = toggleLink$1;

var LexicalLink_dev = {
	$createAutoLinkNode: $createAutoLinkNode_1,
	$createLinkNode: $createLinkNode_1,
	$isAutoLinkNode: $isAutoLinkNode_1,
	$isLinkNode: $isLinkNode_1,
	AutoLinkNode: AutoLinkNode_1,
	LinkNode: LinkNode_1,
	TOGGLE_LINK_COMMAND: TOGGLE_LINK_COMMAND_1,
	toggleLink: toggleLink_1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
let p$5=new Set(["http:","https:","mailto:","sms:","tel:"]);
class q$5 extends Lexical_1.ElementNode{static getType(){return "link"}static clone(a){return new q$5(a.__url,{rel:a.__rel,target:a.__target,title:a.__title},a.__key)}constructor(a,b={},d){super(d);let {target:l=null,rel:h=null,title:e=null}=b;this.__url=a;this.__target=l;this.__rel=h;this.__title=e;}createDOM(a){let b=document.createElement("a");b.href=this.sanitizeUrl(this.__url);null!==this.__target&&(b.target=this.__target);null!==this.__rel&&(b.rel=this.__rel);null!==this.__title&&(b.title=this.__title);LexicalUtils_1.addClassNamesToElement(b,
a.theme.link);return b}updateDOM(a,b){let d=this.__url,l=this.__target,h=this.__rel,e=this.__title;d!==a.__url&&(b.href=d);l!==a.__target&&(l?b.target=l:b.removeAttribute("target"));h!==a.__rel&&(h?b.rel=h:b.removeAttribute("rel"));e!==a.__title&&(e?b.title=e:b.removeAttribute("title"));return !1}static importDOM(){return {a:()=>({conversion:r$8,priority:1})}}static importJSON(a){let b=t$5(a.url,{rel:a.rel,target:a.target,title:a.title});b.setFormat(a.format);b.setIndent(a.indent);b.setDirection(a.direction);
return b}sanitizeUrl(a){try{let b=new URL(a);if(!p$5.has(b.protocol))return "about:blank"}catch(b){return "https://"}return a}exportJSON(){return {...super.exportJSON(),rel:this.getRel(),target:this.getTarget(),title:this.getTitle(),type:"link",url:this.getURL(),version:1}}getURL(){return this.getLatest().__url}setURL(a){this.getWritable().__url=a;}getTarget(){return this.getLatest().__target}setTarget(a){this.getWritable().__target=a;}getRel(){return this.getLatest().__rel}setRel(a){this.getWritable().__rel=
a;}getTitle(){return this.getLatest().__title}setTitle(a){this.getWritable().__title=a;}insertNewAfter(a,b=!0){a=this.getParentOrThrow().insertNewAfter(a,b);return Lexical_1.$isElementNode(a)?(b=t$5(this.__url,{rel:this.__rel,target:this.__target,title:this.__title}),a.append(b),b):null}canInsertTextBefore(){return !1}canInsertTextAfter(){return !1}canBeEmpty(){return !1}isInline(){return !0}extractWithChild(a,b){if(!Lexical_1.$isRangeSelection(b))return !1;a=b.anchor.getNode();let d=b.focus.getNode();return this.isParentOf(a)&&
this.isParentOf(d)&&0<b.getTextContent().length}}function r$8(a){let b=null;if(LexicalUtils_1.isHTMLAnchorElement(a)){let d=a.textContent;null!==d&&""!==d&&(b=t$5(a.getAttribute("href")||"",{rel:a.getAttribute("rel"),target:a.getAttribute("target"),title:a.getAttribute("title")}));}return {node:b}}function t$5(a,b){return Lexical_1.$applyNodeReplacement(new q$5(a,b))}function v$3(a){return a instanceof q$5}
class w$4 extends q$5{static getType(){return "autolink"}static clone(a){return new w$4(a.__url,{rel:a.__rel,target:a.__target,title:a.__title},a.__key)}static importJSON(a){let b=x$2(a.url,{rel:a.rel,target:a.target,title:a.title});b.setFormat(a.format);b.setIndent(a.indent);b.setDirection(a.direction);return b}static importDOM(){return null}exportJSON(){return {...super.exportJSON(),type:"autolink",version:1}}insertNewAfter(a,b=!0){a=this.getParentOrThrow().insertNewAfter(a,b);return Lexical_1.$isElementNode(a)?
(b=x$2(this.__url,{rel:this._rel,target:this.__target,title:this.__title}),a.append(b),b):null}}function x$2(a,b){return Lexical_1.$applyNodeReplacement(new w$4(a,b))}let y$3=Lexical_1.createCommand("TOGGLE_LINK_COMMAND");function z$4(a,b){for(;null!==a&&null!==(a=a.getParent())&&!b(a););return a}var $createAutoLinkNode=x$2;var $createLinkNode=t$5;var $isAutoLinkNode=function(a){return a instanceof w$4};var $isLinkNode=v$3;var AutoLinkNode=w$4;var LinkNode=q$5;var TOGGLE_LINK_COMMAND=y$3;
var toggleLink=function(a,b={}){let {target:d,title:l}=b,h=void 0===b.rel?"noopener":b.rel;b=Lexical_1.$getSelection();if(Lexical_1.$isRangeSelection(b))if(b=b.extract(),null===a)b.forEach(m=>{m=m.getParent();if(v$3(m)){let c=m.getChildren();for(let f=0;f<c.length;f++)m.insertBefore(c[f]);m.remove();}});else {if(1===b.length){var e=b[0];e=v$3(e)?e:z$4(e,v$3);if(null!==e){e.setURL(a);void 0!==d&&e.setTarget(d);null!==h&&e.setRel(h);void 0!==l&&e.setTitle(l);return}}let m=null,c=null;b.forEach(f=>{var g=f.getParent();if(g!==
c&&null!==g&&(!Lexical_1.$isElementNode(f)||f.isInline()))if(v$3(g))c=g,g.setURL(a),void 0!==d&&g.setTarget(d),null!==h&&c.setRel(h),void 0!==l&&c.setTitle(l);else if(g.is(m)||(m=g,c=t$5(a,{rel:h,target:d}),v$3(g)?null===f.getPreviousSibling()?g.insertBefore(c):g.insertAfter(c):f.insertBefore(c)),v$3(f)){if(!f.is(c)){if(null!==c){g=f.getChildren();for(let u=0;u<g.length;u++)c.append(g[u]);}f.remove();}}else null!==c&&c.append(f);});}};

var LexicalLink_prod = {
	$createAutoLinkNode: $createAutoLinkNode,
	$createLinkNode: $createLinkNode,
	$isAutoLinkNode: $isAutoLinkNode,
	$isLinkNode: $isLinkNode,
	AutoLinkNode: AutoLinkNode,
	LinkNode: LinkNode,
	TOGGLE_LINK_COMMAND: TOGGLE_LINK_COMMAND,
	toggleLink: toggleLink
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const LexicalLink = process.env.NODE_ENV === 'development' ? LexicalLink_dev : LexicalLink_prod;
var LexicalLink_1 = LexicalLink;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */




/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
/**
 * Checks the depth of listNode from the root node.
 * @param listNode - The ListNode to be checked.
 * @returns The depth of the ListNode.
 */

function $getListDepth$1(listNode) {
  let depth = 1;
  let parent = listNode.getParent();

  while (parent != null) {
    if ($isListItemNode$1(parent)) {
      const parentList = parent.getParent();

      if ($isListNode$1(parentList)) {
        depth++;
        parent = parentList.getParent();
        continue;
      }

      {
        throw Error(`A ListItemNode must have a ListNode for a parent.`);
      }
    }

    return depth;
  }

  return depth;
}
/**
 * Finds the nearest ancestral ListNode and returns it, throws an invariant if listItem is not a ListItemNode.
 * @param listItem - The node to be checked.
 * @returns The ListNode found.
 */

function $getTopListNode(listItem) {
  let list = listItem.getParent();

  if (!$isListNode$1(list)) {
    {
      throw Error(`A ListItemNode must have a ListNode for a parent.`);
    }
  }

  let parent = list;

  while (parent !== null) {
    parent = parent.getParent();

    if ($isListNode$1(parent)) {
      list = parent;
    }
  }

  return list;
}
/**
 * A recursive Depth-First Search (Postorder Traversal) that finds all of a node's children
 * that are of type ListItemNode and returns them in an array.
 * @param node - The ListNode to start the search.
 * @returns An array containing all nodes of type ListItemNode found.
 */
// This should probably be $getAllChildrenOfType

function $getAllListItems(node) {
  let listItemNodes = [];
  const listChildren = node.getChildren().filter($isListItemNode$1);

  for (let i = 0; i < listChildren.length; i++) {
    const listItemNode = listChildren[i];
    const firstChild = listItemNode.getFirstChild();

    if ($isListNode$1(firstChild)) {
      listItemNodes = listItemNodes.concat($getAllListItems(firstChild));
    } else {
      listItemNodes.push(listItemNode);
    }
  }

  return listItemNodes;
}
/**
 * Checks to see if the passed node is a ListItemNode and has a ListNode as a child.
 * @param node - The node to be checked.
 * @returns true if the node is a ListItemNode and has a ListNode child, false otherwise.
 */

function isNestedListNode(node) {
  return $isListItemNode$1(node) && $isListNode$1(node.getFirstChild());
}
/**
 * Takes a deeply nested ListNode or ListItemNode and traverses up the branch to delete the first
 * ancestral ListNode (which could be the root ListNode) or ListItemNode with siblings, essentially
 * bringing the deeply nested node up the branch once. Would remove sublist if it has siblings.
 * Should not break ListItem -> List -> ListItem chain as empty List/ItemNodes should be removed on .remove().
 * @param sublist - The nested ListNode or ListItemNode to be brought up the branch.
 */

function $removeHighestEmptyListParent(sublist) {
  // Nodes may be repeatedly indented, to create deeply nested lists that each
  // contain just one bullet.
  // Our goal is to remove these (empty) deeply nested lists. The easiest
  // way to do that is crawl back up the tree until we find a node that has siblings
  // (e.g. is actually part of the list contents) and delete that, or delete
  // the root of the list (if no list nodes have siblings.)
  let emptyListPtr = sublist;

  while (emptyListPtr.getNextSibling() == null && emptyListPtr.getPreviousSibling() == null) {
    const parent = emptyListPtr.getParent();

    if (parent == null || !($isListItemNode$1(emptyListPtr) || $isListNode$1(emptyListPtr))) {
      break;
    }

    emptyListPtr = parent;
  }

  emptyListPtr.remove();
}
/**
 * Wraps a node into a ListItemNode.
 * @param node - The node to be wrapped into a ListItemNode
 * @returns The ListItemNode which the passed node is wrapped in.
 */

function wrapInListItem(node) {
  const listItemWrapper = $createListItemNode$1();
  return listItemWrapper.append(node);
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

function $isSelectingEmptyListItem(anchorNode, nodes) {
  return $isListItemNode$1(anchorNode) && (nodes.length === 0 || nodes.length === 1 && anchorNode.is(nodes[0]) && anchorNode.getChildrenSize() === 0);
}

function $getListItemValue(listItem) {
  const list = listItem.getParent();
  let value = 1;

  if (list != null) {
    if (!$isListNode$1(list)) {
      {
        throw Error(`$getListItemValue: list node is not parent of list item node`);
      }
    } else {
      value = list.getStart();
    }
  }

  const siblings = listItem.getPreviousSiblings();

  for (let i = 0; i < siblings.length; i++) {
    const sibling = siblings[i];

    if ($isListItemNode$1(sibling) && !$isListNode$1(sibling.getFirstChild())) {
      value++;
    }
  }

  return value;
}
/**
 * Inserts a new ListNode. If the selection's anchor node is an empty ListItemNode and is a child of
 * the root/shadow root, it will replace the ListItemNode with a ListNode and the old ListItemNode.
 * Otherwise it will replace its parent with a new ListNode and re-insert the ListItemNode and any previous children.
 * If the selection's anchor node is not an empty ListItemNode, it will add a new ListNode or merge an existing ListNode,
 * unless the the node is a leaf node, in which case it will attempt to find a ListNode up the branch and replace it with
 * a new ListNode, or create a new ListNode at the nearest root/shadow root.
 * @param editor - The lexical editor.
 * @param listType - The type of list, "number" | "bullet" | "check".
 */


function insertList$1(editor, listType) {
  editor.update(() => {
    const selection = Lexical_1.$getSelection();

    if (Lexical_1.$isRangeSelection(selection) || Lexical_1.DEPRECATED_$isGridSelection(selection)) {
      const nodes = selection.getNodes();
      const anchor = selection.anchor;
      const anchorNode = anchor.getNode();
      const anchorNodeParent = anchorNode.getParent();

      if ($isSelectingEmptyListItem(anchorNode, nodes)) {
        const list = $createListNode$1(listType);

        if (Lexical_1.$isRootOrShadowRoot(anchorNodeParent)) {
          anchorNode.replace(list);
          const listItem = $createListItemNode$1();

          if (Lexical_1.$isElementNode(anchorNode)) {
            listItem.setFormat(anchorNode.getFormatType());
            listItem.setIndent(anchorNode.getIndent());
          }

          list.append(listItem);
        } else if ($isListItemNode$1(anchorNode)) {
          const parent = anchorNode.getParentOrThrow();
          append(list, parent.getChildren());
          parent.replace(list);
        }

        return;
      } else {
        const handled = new Set();

        for (let i = 0; i < nodes.length; i++) {
          const node = nodes[i];

          if (Lexical_1.$isElementNode(node) && node.isEmpty() && !handled.has(node.getKey())) {
            createListOrMerge(node, listType);
            continue;
          }

          if (Lexical_1.$isLeafNode(node)) {
            let parent = node.getParent();

            while (parent != null) {
              const parentKey = parent.getKey();

              if ($isListNode$1(parent)) {
                if (!handled.has(parentKey)) {
                  const newListNode = $createListNode$1(listType);
                  append(newListNode, parent.getChildren());
                  parent.replace(newListNode);
                  updateChildrenListItemValue(newListNode);
                  handled.add(parentKey);
                }

                break;
              } else {
                const nextParent = parent.getParent();

                if (Lexical_1.$isRootOrShadowRoot(nextParent) && !handled.has(parentKey)) {
                  handled.add(parentKey);
                  createListOrMerge(parent, listType);
                  break;
                }

                parent = nextParent;
              }
            }
          }
        }
      }
    }
  });
}

function append(node, nodesToAppend) {
  node.splice(node.getChildrenSize(), 0, nodesToAppend);
}

function createListOrMerge(node, listType) {
  if ($isListNode$1(node)) {
    return node;
  }

  const previousSibling = node.getPreviousSibling();
  const nextSibling = node.getNextSibling();
  const listItem = $createListItemNode$1();
  listItem.setFormat(node.getFormatType());
  listItem.setIndent(node.getIndent());
  append(listItem, node.getChildren());

  if ($isListNode$1(previousSibling) && listType === previousSibling.getListType()) {
    previousSibling.append(listItem);
    node.remove(); // if the same type of list is on both sides, merge them.

    if ($isListNode$1(nextSibling) && listType === nextSibling.getListType()) {
      append(previousSibling, nextSibling.getChildren());
      nextSibling.remove();
    }

    return previousSibling;
  } else if ($isListNode$1(nextSibling) && listType === nextSibling.getListType()) {
    nextSibling.getFirstChildOrThrow().insertBefore(listItem);
    node.remove();
    return nextSibling;
  } else {
    const list = $createListNode$1(listType);
    list.append(listItem);
    node.replace(list);
    updateChildrenListItemValue(list);
    return list;
  }
}
/**
 * A recursive function that goes through each list and their children, including nested lists,
 * appending list2 children after list1 children and updating ListItemNode values.
 * @param list1 - The first list to be merged.
 * @param list2 - The second list to be merged.
 */


function mergeLists(list1, list2) {
  const listItem1 = list1.getLastChild();
  const listItem2 = list2.getFirstChild();

  if (listItem1 && listItem2 && isNestedListNode(listItem1) && isNestedListNode(listItem2)) {
    mergeLists(listItem1.getFirstChild(), listItem2.getFirstChild());
    listItem2.remove();
  }

  const toMerge = list2.getChildren();

  if (toMerge.length > 0) {
    list1.append(...toMerge);
    updateChildrenListItemValue(list1);
  }

  list2.remove();
}
/**
 * Searches for the nearest ancestral ListNode and removes it. If selection is an empty ListItemNode
 * it will remove the whole list, including the ListItemNode. For each ListItemNode in the ListNode,
 * removeList will also generate new ParagraphNodes in the removed ListNode's place. Any child node
 * inside a ListItemNode will be appended to the new ParagraphNodes.
 * @param editor - The lexical editor.
 */

function removeList$1(editor) {
  editor.update(() => {
    const selection = Lexical_1.$getSelection();

    if (Lexical_1.$isRangeSelection(selection)) {
      const listNodes = new Set();
      const nodes = selection.getNodes();
      const anchorNode = selection.anchor.getNode();

      if ($isSelectingEmptyListItem(anchorNode, nodes)) {
        listNodes.add($getTopListNode(anchorNode));
      } else {
        for (let i = 0; i < nodes.length; i++) {
          const node = nodes[i];

          if (Lexical_1.$isLeafNode(node)) {
            const listItemNode = LexicalUtils_1.$getNearestNodeOfType(node, ListItemNode$1);

            if (listItemNode != null) {
              listNodes.add($getTopListNode(listItemNode));
            }
          }
        }
      }

      for (const listNode of listNodes) {
        let insertionPoint = listNode;
        const listItems = $getAllListItems(listNode);

        for (const listItemNode of listItems) {
          const paragraph = Lexical_1.$createParagraphNode();
          append(paragraph, listItemNode.getChildren());
          insertionPoint.insertAfter(paragraph);
          insertionPoint = paragraph; // When the anchor and focus fall on the textNode
          // we don't have to change the selection because the textNode will be appended to
          // the newly generated paragraph.
          // When selection is in empty nested list item, selection is actually on the listItemNode.
          // When the corresponding listItemNode is deleted and replaced by the newly generated paragraph
          // we should manually set the selection's focus and anchor to the newly generated paragraph.

          if (listItemNode.__key === selection.anchor.key) {
            selection.anchor.set(paragraph.getKey(), 0, 'element');
          }

          if (listItemNode.__key === selection.focus.key) {
            selection.focus.set(paragraph.getKey(), 0, 'element');
          }

          listItemNode.remove();
        }

        listNode.remove();
      }
    }
  });
}
/**
 * Takes the value of a child ListItemNode and makes it the value the ListItemNode
 * should be if it isn't already. If only certain children should be updated, they
 * can be passed optionally in an array.
 * @param list - The list whose children are updated.
 * @param children - An array of the children to be updated.
 */

function updateChildrenListItemValue(list, children) {
  const childrenOrExisting = children || list.getChildren();

  if (childrenOrExisting !== undefined) {
    for (let i = 0; i < childrenOrExisting.length; i++) {
      const child = childrenOrExisting[i];

      if ($isListItemNode$1(child)) {
        const prevValue = child.getValue();
        const nextValue = $getListItemValue(child);

        if (prevValue !== nextValue) {
          child.setValue(nextValue);
        }
      }
    }
  }
}
/**
 * Adds an empty ListNode/ListItemNode chain at listItemNode, so as to
 * create an indent effect. Won't indent ListItemNodes that have a ListNode as
 * a child, but does merge sibling ListItemNodes if one has a nested ListNode.
 * @param listItemNode - The ListItemNode to be indented.
 */

function $handleIndent(listItemNode) {
  // go through each node and decide where to move it.
  const removed = new Set();

  if (isNestedListNode(listItemNode) || removed.has(listItemNode.getKey())) {
    return;
  }

  const parent = listItemNode.getParent(); // We can cast both of the below `isNestedListNode` only returns a boolean type instead of a user-defined type guards

  const nextSibling = listItemNode.getNextSibling();
  const previousSibling = listItemNode.getPreviousSibling(); // if there are nested lists on either side, merge them all together.

  if (isNestedListNode(nextSibling) && isNestedListNode(previousSibling)) {
    const innerList = previousSibling.getFirstChild();

    if ($isListNode$1(innerList)) {
      innerList.append(listItemNode);
      const nextInnerList = nextSibling.getFirstChild();

      if ($isListNode$1(nextInnerList)) {
        const children = nextInnerList.getChildren();
        append(innerList, children);
        nextSibling.remove();
        removed.add(nextSibling.getKey());
      }

      updateChildrenListItemValue(innerList);
    }
  } else if (isNestedListNode(nextSibling)) {
    // if the ListItemNode is next to a nested ListNode, merge them
    const innerList = nextSibling.getFirstChild();

    if ($isListNode$1(innerList)) {
      const firstChild = innerList.getFirstChild();

      if (firstChild !== null) {
        firstChild.insertBefore(listItemNode);
      }

      updateChildrenListItemValue(innerList);
    }
  } else if (isNestedListNode(previousSibling)) {
    const innerList = previousSibling.getFirstChild();

    if ($isListNode$1(innerList)) {
      innerList.append(listItemNode);
      updateChildrenListItemValue(innerList);
    }
  } else {
    // otherwise, we need to create a new nested ListNode
    if ($isListNode$1(parent)) {
      const newListItem = $createListItemNode$1();
      const newList = $createListNode$1(parent.getListType());
      newListItem.append(newList);
      newList.append(listItemNode);

      if (previousSibling) {
        previousSibling.insertAfter(newListItem);
      } else if (nextSibling) {
        nextSibling.insertBefore(newListItem);
      } else {
        parent.append(newListItem);
      }

      updateChildrenListItemValue(newList);
    }
  }

  if ($isListNode$1(parent)) {
    updateChildrenListItemValue(parent);
  }
}
/**
 * Removes an indent by removing an empty ListNode/ListItemNode chain. An indented ListItemNode
 * has a great grandparent node of type ListNode, which is where the ListItemNode will reside
 * within as a child.
 * @param listItemNode - The ListItemNode to remove the indent (outdent).
 */

function $handleOutdent(listItemNode) {
  // go through each node and decide where to move it.
  if (isNestedListNode(listItemNode)) {
    return;
  }

  const parentList = listItemNode.getParent();
  const grandparentListItem = parentList ? parentList.getParent() : undefined;
  const greatGrandparentList = grandparentListItem ? grandparentListItem.getParent() : undefined; // If it doesn't have these ancestors, it's not indented.

  if ($isListNode$1(greatGrandparentList) && $isListItemNode$1(grandparentListItem) && $isListNode$1(parentList)) {
    // if it's the first child in it's parent list, insert it into the
    // great grandparent list before the grandparent
    const firstChild = parentList ? parentList.getFirstChild() : undefined;
    const lastChild = parentList ? parentList.getLastChild() : undefined;

    if (listItemNode.is(firstChild)) {
      grandparentListItem.insertBefore(listItemNode);

      if (parentList.isEmpty()) {
        grandparentListItem.remove();
      } // if it's the last child in it's parent list, insert it into the
      // great grandparent list after the grandparent.

    } else if (listItemNode.is(lastChild)) {
      grandparentListItem.insertAfter(listItemNode);

      if (parentList.isEmpty()) {
        grandparentListItem.remove();
      }
    } else {
      // otherwise, we need to split the siblings into two new nested lists
      const listType = parentList.getListType();
      const previousSiblingsListItem = $createListItemNode$1();
      const previousSiblingsList = $createListNode$1(listType);
      previousSiblingsListItem.append(previousSiblingsList);
      listItemNode.getPreviousSiblings().forEach(sibling => previousSiblingsList.append(sibling));
      const nextSiblingsListItem = $createListItemNode$1();
      const nextSiblingsList = $createListNode$1(listType);
      nextSiblingsListItem.append(nextSiblingsList);
      append(nextSiblingsList, listItemNode.getNextSiblings()); // put the sibling nested lists on either side of the grandparent list item in the great grandparent.

      grandparentListItem.insertBefore(previousSiblingsListItem);
      grandparentListItem.insertAfter(nextSiblingsListItem); // replace the grandparent list item (now between the siblings) with the outdented list item.

      grandparentListItem.replace(listItemNode);
    }

    updateChildrenListItemValue(parentList);
    updateChildrenListItemValue(greatGrandparentList);
  }
}
/**
 * Attempts to insert a ParagraphNode at selection and selects the new node. The selection must contain a ListItemNode
 * or a node that does not already contain text. If its grandparent is the root/shadow root, it will get the ListNode
 * (which should be the parent node) and insert the ParagraphNode as a sibling to the ListNode. If the ListNode is
 * nested in a ListItemNode instead, it will add the ParagraphNode after the grandparent ListItemNode.
 * Throws an invariant if the selection is not a child of a ListNode.
 * @returns true if a ParagraphNode was inserted succesfully, false if there is no selection
 * or the selection does not contain a ListItemNode or the node already holds text.
 */

function $handleListInsertParagraph$1() {
  const selection = Lexical_1.$getSelection();

  if (!Lexical_1.$isRangeSelection(selection) || !selection.isCollapsed()) {
    return false;
  } // Only run this code on empty list items


  const anchor = selection.anchor.getNode();

  if (!$isListItemNode$1(anchor) || anchor.getTextContent() !== '') {
    return false;
  }

  const topListNode = $getTopListNode(anchor);
  const parent = anchor.getParent();

  if (!$isListNode$1(parent)) {
    throw Error(`A ListItemNode must have a ListNode for a parent.`);
  }

  const grandparent = parent.getParent();
  let replacementNode;

  if (Lexical_1.$isRootOrShadowRoot(grandparent)) {
    replacementNode = Lexical_1.$createParagraphNode();
    topListNode.insertAfter(replacementNode);
  } else if ($isListItemNode$1(grandparent)) {
    replacementNode = $createListItemNode$1();
    grandparent.insertAfter(replacementNode);
  } else {
    return false;
  }

  replacementNode.select();
  const nextSiblings = anchor.getNextSiblings();

  if (nextSiblings.length > 0) {
    const newList = $createListNode$1(parent.getListType());

    if (Lexical_1.$isParagraphNode(replacementNode)) {
      replacementNode.insertAfter(newList);
    } else {
      const newListItem = $createListItemNode$1();
      newListItem.append(newList);
      replacementNode.insertAfter(newListItem);
    }

    nextSiblings.forEach(sibling => {
      sibling.remove();
      newList.append(sibling);
    });
  } // Don't leave hanging nested empty lists


  $removeHighestEmptyListParent(anchor);
  return true;
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/** @noInheritDoc */
class ListItemNode$1 extends Lexical_1.ElementNode {
  /** @internal */

  /** @internal */
  static getType() {
    return 'listitem';
  }

  static clone(node) {
    return new ListItemNode$1(node.__value, node.__checked, node.__key);
  }

  constructor(value, checked, key) {
    super(key);
    this.__value = value === undefined ? 1 : value;
    this.__checked = checked;
  }

  createDOM(config) {
    const element = document.createElement('li');
    const parent = this.getParent();

    if ($isListNode$1(parent) && parent.getListType() === 'check') {
      updateListItemChecked(element, this, null);
    }

    element.value = this.__value;
    $setListItemThemeClassNames(element, config.theme, this);
    return element;
  }

  updateDOM(prevNode, dom, config) {
    const parent = this.getParent();

    if ($isListNode$1(parent) && parent.getListType() === 'check') {
      updateListItemChecked(dom, this, prevNode);
    } // @ts-expect-error - this is always HTMLListItemElement


    dom.value = this.__value;
    $setListItemThemeClassNames(dom, config.theme, this);
    return false;
  }

  static transform() {
    return node => {
      const parent = node.getParent();

      if ($isListNode$1(parent)) {
        updateChildrenListItemValue(parent);

        if (parent.getListType() !== 'check' && node.getChecked() != null) {
          node.setChecked(undefined);
        }
      }
    };
  }

  static importDOM() {
    return {
      li: node => ({
        conversion: convertListItemElement,
        priority: 0
      })
    };
  }

  static importJSON(serializedNode) {
    const node = new ListItemNode$1(serializedNode.value, serializedNode.checked);
    node.setFormat(serializedNode.format);
    node.setDirection(serializedNode.direction);
    return node;
  }

  exportJSON() {
    return { ...super.exportJSON(),
      checked: this.getChecked(),
      type: 'listitem',
      value: this.getValue(),
      version: 1
    };
  }

  append(...nodes) {
    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i];

      if (Lexical_1.$isElementNode(node) && this.canMergeWith(node)) {
        const children = node.getChildren();
        this.append(...children);
        node.remove();
      } else {
        super.append(node);
      }
    }

    return this;
  }

  replace(replaceWithNode, includeChildren) {
    if ($isListItemNode$1(replaceWithNode)) {
      return super.replace(replaceWithNode);
    }

    this.setIndent(0);
    const list = this.getParentOrThrow();
    if (!$isListNode$1(list)) return replaceWithNode;

    if (list.__first === this.getKey()) {
      list.insertBefore(replaceWithNode);
    } else if (list.__last === this.getKey()) {
      list.insertAfter(replaceWithNode);
    } else {
      // Split the list
      const newList = $createListNode$1(list.getListType());
      let nextSibling = this.getNextSibling();

      while (nextSibling) {
        const nodeToAppend = nextSibling;
        nextSibling = nextSibling.getNextSibling();
        newList.append(nodeToAppend);
      }

      list.insertAfter(replaceWithNode);
      replaceWithNode.insertAfter(newList);
    }

    if (includeChildren) {
      this.getChildren().forEach(child => {
        replaceWithNode.append(child);
      });
    }

    this.remove();

    if (list.getChildrenSize() === 0) {
      list.remove();
    }

    return replaceWithNode;
  }

  insertAfter(node, restoreSelection = true) {
    const listNode = this.getParentOrThrow();

    if (!$isListNode$1(listNode)) {
      {
        throw Error(`insertAfter: list node is not parent of list item node`);
      }
    }

    const siblings = this.getNextSiblings();

    if ($isListItemNode$1(node)) {
      const after = super.insertAfter(node, restoreSelection);
      const afterListNode = node.getParentOrThrow();

      if ($isListNode$1(afterListNode)) {
        updateChildrenListItemValue(afterListNode);
      }

      return after;
    } // Attempt to merge if the list is of the same type.


    if ($isListNode$1(node) && node.getListType() === listNode.getListType()) {
      let child = node;
      const children = node.getChildren();

      for (let i = children.length - 1; i >= 0; i--) {
        child = children[i];
        this.insertAfter(child, restoreSelection);
      }

      return child;
    } // Otherwise, split the list
    // Split the lists and insert the node in between them


    listNode.insertAfter(node, restoreSelection);

    if (siblings.length !== 0) {
      const newListNode = $createListNode$1(listNode.getListType());
      siblings.forEach(sibling => newListNode.append(sibling));
      node.insertAfter(newListNode, restoreSelection);
    }

    return node;
  }

  remove(preserveEmptyParent) {
    const prevSibling = this.getPreviousSibling();
    const nextSibling = this.getNextSibling();
    super.remove(preserveEmptyParent);

    if (prevSibling && nextSibling && isNestedListNode(prevSibling) && isNestedListNode(nextSibling)) {
      mergeLists(prevSibling.getFirstChild(), nextSibling.getFirstChild());
      nextSibling.remove();
    } else if (nextSibling) {
      const parent = nextSibling.getParent();

      if ($isListNode$1(parent)) {
        updateChildrenListItemValue(parent);
      }
    }
  }

  insertNewAfter(_, restoreSelection = true) {
    const newElement = $createListItemNode$1(this.__checked == null ? undefined : false);
    this.insertAfter(newElement, restoreSelection);
    return newElement;
  }

  collapseAtStart(selection) {
    const paragraph = Lexical_1.$createParagraphNode();
    const children = this.getChildren();
    children.forEach(child => paragraph.append(child));
    const listNode = this.getParentOrThrow();
    const listNodeParent = listNode.getParentOrThrow();
    const isIndented = $isListItemNode$1(listNodeParent);

    if (listNode.getChildrenSize() === 1) {
      if (isIndented) {
        // if the list node is nested, we just want to remove it,
        // effectively unindenting it.
        listNode.remove();
        listNodeParent.select();
      } else {
        listNode.insertBefore(paragraph);
        listNode.remove(); // If we have selection on the list item, we'll need to move it
        // to the paragraph

        const anchor = selection.anchor;
        const focus = selection.focus;
        const key = paragraph.getKey();

        if (anchor.type === 'element' && anchor.getNode().is(this)) {
          anchor.set(key, anchor.offset, 'element');
        }

        if (focus.type === 'element' && focus.getNode().is(this)) {
          focus.set(key, focus.offset, 'element');
        }
      }
    } else {
      listNode.insertBefore(paragraph);
      this.remove();
    }

    return true;
  }

  getValue() {
    const self = this.getLatest();
    return self.__value;
  }

  setValue(value) {
    const self = this.getWritable();
    self.__value = value;
  }

  getChecked() {
    const self = this.getLatest();
    return self.__checked;
  }

  setChecked(checked) {
    const self = this.getWritable();
    self.__checked = checked;
  }

  toggleChecked() {
    this.setChecked(!this.__checked);
  }

  getIndent() {
    // If we don't have a parent, we are likely serializing
    const parent = this.getParent();

    if (parent === null) {
      return this.getLatest().__indent;
    } // ListItemNode should always have a ListNode for a parent.


    let listNodeParent = parent.getParentOrThrow();
    let indentLevel = 0;

    while ($isListItemNode$1(listNodeParent)) {
      listNodeParent = listNodeParent.getParentOrThrow().getParentOrThrow();
      indentLevel++;
    }

    return indentLevel;
  }

  setIndent(indent) {
    if (!(typeof indent === 'number' && indent > -1)) {
      throw Error(`Invalid indent value.`);
    }

    let currentIndent = this.getIndent();

    while (currentIndent !== indent) {
      if (currentIndent < indent) {
        $handleIndent(this);
        currentIndent++;
      } else {
        $handleOutdent(this);
        currentIndent--;
      }
    }

    return this;
  }

  insertBefore(nodeToInsert) {
    if ($isListItemNode$1(nodeToInsert)) {
      const parent = this.getParentOrThrow();

      if ($isListNode$1(parent)) {
        const siblings = this.getNextSiblings();
        updateChildrenListItemValue(parent, siblings);
      }
    }

    return super.insertBefore(nodeToInsert);
  }

  canInsertAfter(node) {
    return $isListItemNode$1(node);
  }

  canReplaceWith(replacement) {
    return $isListItemNode$1(replacement);
  }

  canMergeWith(node) {
    return Lexical_1.$isParagraphNode(node) || $isListItemNode$1(node);
  }

  extractWithChild(child, selection) {
    if (!Lexical_1.$isRangeSelection(selection)) {
      return false;
    }

    const anchorNode = selection.anchor.getNode();
    const focusNode = selection.focus.getNode();
    return this.isParentOf(anchorNode) && this.isParentOf(focusNode) && this.getTextContent().length === selection.getTextContent().length;
  }

  isParentRequired() {
    return true;
  }

  createParentElementNode() {
    return $createListNode$1('bullet');
  }

}

function $setListItemThemeClassNames(dom, editorThemeClasses, node) {
  const classesToAdd = [];
  const classesToRemove = [];
  const listTheme = editorThemeClasses.list;
  const listItemClassName = listTheme ? listTheme.listitem : undefined;
  let nestedListItemClassName;

  if (listTheme && listTheme.nested) {
    nestedListItemClassName = listTheme.nested.listitem;
  }

  if (listItemClassName !== undefined) {
    const listItemClasses = listItemClassName.split(' ');
    classesToAdd.push(...listItemClasses);
  }

  if (listTheme) {
    const parentNode = node.getParent();
    const isCheckList = $isListNode$1(parentNode) && parentNode.getListType() === 'check';
    const checked = node.getChecked();

    if (!isCheckList || checked) {
      classesToRemove.push(listTheme.listitemUnchecked);
    }

    if (!isCheckList || !checked) {
      classesToRemove.push(listTheme.listitemChecked);
    }

    if (isCheckList) {
      classesToAdd.push(checked ? listTheme.listitemChecked : listTheme.listitemUnchecked);
    }
  }

  if (nestedListItemClassName !== undefined) {
    const nestedListItemClasses = nestedListItemClassName.split(' ');

    if (node.getChildren().some(child => $isListNode$1(child))) {
      classesToAdd.push(...nestedListItemClasses);
    } else {
      classesToRemove.push(...nestedListItemClasses);
    }
  }

  if (classesToRemove.length > 0) {
    LexicalUtils_1.removeClassNamesFromElement(dom, ...classesToRemove);
  }

  if (classesToAdd.length > 0) {
    LexicalUtils_1.addClassNamesToElement(dom, ...classesToAdd);
  }
}

function updateListItemChecked(dom, listItemNode, prevListItemNode, listNode) {
  // Only add attributes for leaf list items
  if ($isListNode$1(listItemNode.getFirstChild())) {
    dom.removeAttribute('role');
    dom.removeAttribute('tabIndex');
    dom.removeAttribute('aria-checked');
  } else {
    dom.setAttribute('role', 'checkbox');
    dom.setAttribute('tabIndex', '-1');

    if (!prevListItemNode || listItemNode.__checked !== prevListItemNode.__checked) {
      dom.setAttribute('aria-checked', listItemNode.getChecked() ? 'true' : 'false');
    }
  }
}

function convertListItemElement(domNode) {
  const checked = LexicalUtils_1.isHTMLElement(domNode) && domNode.getAttribute('aria-checked') === 'true';
  return {
    node: $createListItemNode$1(checked)
  };
}
/**
 * Creates a new List Item node, passing true/false will convert it to a checkbox input.
 * @param checked - Is the List Item a checkbox and, if so, is it checked? undefined/null: not a checkbox, true/false is a checkbox and checked/unchecked, respectively.
 * @returns The new List Item.
 */


function $createListItemNode$1(checked) {
  return Lexical_1.$applyNodeReplacement(new ListItemNode$1(undefined, checked));
}
/**
 * Checks to see if the node is a ListItemNode.
 * @param node - The node to be checked.
 * @returns true if the node is a ListItemNode, false otherwise.
 */

function $isListItemNode$1(node) {
  return node instanceof ListItemNode$1;
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/** @noInheritDoc */
class ListNode$1 extends Lexical_1.ElementNode {
  /** @internal */

  /** @internal */

  /** @internal */
  static getType() {
    return 'list';
  }

  static clone(node) {
    const listType = node.__listType || TAG_TO_LIST_TYPE[node.__tag];
    return new ListNode$1(listType, node.__start, node.__key);
  }

  constructor(listType, start, key) {
    super(key);

    const _listType = TAG_TO_LIST_TYPE[listType] || listType;

    this.__listType = _listType;
    this.__tag = _listType === 'number' ? 'ol' : 'ul';
    this.__start = start;
  }

  getTag() {
    return this.__tag;
  }

  getListType() {
    return this.__listType;
  }

  getStart() {
    return this.__start;
  } // View


  createDOM(config, _editor) {
    const tag = this.__tag;
    const dom = document.createElement(tag);

    if (this.__start !== 1) {
      dom.setAttribute('start', String(this.__start));
    } // @ts-expect-error Internal field.


    dom.__lexicalListType = this.__listType;
    setListThemeClassNames(dom, config.theme, this);
    return dom;
  }

  updateDOM(prevNode, dom, config) {
    if (prevNode.__tag !== this.__tag) {
      return true;
    }

    setListThemeClassNames(dom, config.theme, this);
    return false;
  }

  static importDOM() {
    return {
      ol: node => ({
        conversion: convertListNode,
        priority: 0
      }),
      ul: node => ({
        conversion: convertListNode,
        priority: 0
      })
    };
  }

  static importJSON(serializedNode) {
    const node = $createListNode$1(serializedNode.listType, serializedNode.start);
    node.setFormat(serializedNode.format);
    node.setIndent(serializedNode.indent);
    node.setDirection(serializedNode.direction);
    return node;
  }

  exportDOM(editor) {
    const {
      element
    } = super.exportDOM(editor);

    if (element) {
      if (this.__start !== 1) {
        element.setAttribute('start', String(this.__start));
      }

      if (this.__listType === 'check') {
        element.setAttribute('__lexicalListType', 'check');
      }
    }

    return {
      element
    };
  }

  exportJSON() {
    return { ...super.exportJSON(),
      listType: this.getListType(),
      start: this.getStart(),
      tag: this.getTag(),
      type: 'list',
      version: 1
    };
  }

  canBeEmpty() {
    return false;
  }

  canIndent() {
    return false;
  }

  append(...nodesToAppend) {
    for (let i = 0; i < nodesToAppend.length; i++) {
      const currentNode = nodesToAppend[i];

      if ($isListItemNode$1(currentNode)) {
        super.append(currentNode);
      } else {
        const listItemNode = $createListItemNode$1();

        if ($isListNode$1(currentNode)) {
          listItemNode.append(currentNode);
        } else if (Lexical_1.$isElementNode(currentNode)) {
          const textNode = Lexical_1.$createTextNode(currentNode.getTextContent());
          listItemNode.append(textNode);
        } else {
          listItemNode.append(currentNode);
        }

        super.append(listItemNode);
      }
    }

    updateChildrenListItemValue(this);
    return this;
  }

  extractWithChild(child) {
    return $isListItemNode$1(child);
  }

}

function setListThemeClassNames(dom, editorThemeClasses, node) {
  const classesToAdd = [];
  const classesToRemove = [];
  const listTheme = editorThemeClasses.list;

  if (listTheme !== undefined) {
    const listLevelsClassNames = listTheme[`${node.__tag}Depth`] || [];
    const listDepth = $getListDepth$1(node) - 1;
    const normalizedListDepth = listDepth % listLevelsClassNames.length;
    const listLevelClassName = listLevelsClassNames[normalizedListDepth];
    const listClassName = listTheme[node.__tag];
    let nestedListClassName;
    const nestedListTheme = listTheme.nested;

    if (nestedListTheme !== undefined && nestedListTheme.list) {
      nestedListClassName = nestedListTheme.list;
    }

    if (listClassName !== undefined) {
      classesToAdd.push(listClassName);
    }

    if (listLevelClassName !== undefined) {
      const listItemClasses = listLevelClassName.split(' ');
      classesToAdd.push(...listItemClasses);

      for (let i = 0; i < listLevelsClassNames.length; i++) {
        if (i !== normalizedListDepth) {
          classesToRemove.push(node.__tag + i);
        }
      }
    }

    if (nestedListClassName !== undefined) {
      const nestedListItemClasses = nestedListClassName.split(' ');

      if (listDepth > 1) {
        classesToAdd.push(...nestedListItemClasses);
      } else {
        classesToRemove.push(...nestedListItemClasses);
      }
    }
  }

  if (classesToRemove.length > 0) {
    LexicalUtils_1.removeClassNamesFromElement(dom, ...classesToRemove);
  }

  if (classesToAdd.length > 0) {
    LexicalUtils_1.addClassNamesToElement(dom, ...classesToAdd);
  }
}
/*
 * This function normalizes the children of a ListNode after the conversion from HTML,
 * ensuring that they are all ListItemNodes and contain either a single nested ListNode
 * or some other inline content.
 */


function normalizeChildren(nodes) {
  const normalizedListItems = [];

  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i];

    if ($isListItemNode$1(node)) {
      normalizedListItems.push(node);
      const children = node.getChildren();

      if (children.length > 1) {
        children.forEach(child => {
          if ($isListNode$1(child)) {
            normalizedListItems.push(wrapInListItem(child));
          }
        });
      }
    } else {
      normalizedListItems.push(wrapInListItem(node));
    }
  }

  return normalizedListItems;
}

function convertListNode(domNode) {
  const nodeName = domNode.nodeName.toLowerCase();
  let node = null;

  if (nodeName === 'ol') {
    // @ts-ignore
    const start = domNode.start;
    node = $createListNode$1('number', start);
  } else if (nodeName === 'ul') {
    if (LexicalUtils_1.isHTMLElement(domNode) && domNode.getAttribute('__lexicallisttype') === 'check') {
      node = $createListNode$1('check');
    } else {
      node = $createListNode$1('bullet');
    }
  }

  return {
    after: normalizeChildren,
    node
  };
}

const TAG_TO_LIST_TYPE = {
  ol: 'number',
  ul: 'bullet'
};
/**
 * Creates a ListNode of listType.
 * @param listType - The type of list to be created. Can be 'number', 'bullet', or 'check'.
 * @param start - Where an ordered list starts its count, start = 1 if left undefined.
 * @returns The new ListNode
 */

function $createListNode$1(listType, start = 1) {
  return Lexical_1.$applyNodeReplacement(new ListNode$1(listType, start));
}
/**
 * Checks to see if the node is a ListNode.
 * @param node - The node to be checked.
 * @returns true if the node is a ListNode, false otherwise.
 */

function $isListNode$1(node) {
  return node instanceof ListNode$1;
}

/** @module @lexical/list */
const INSERT_UNORDERED_LIST_COMMAND$1 = Lexical_1.createCommand('INSERT_UNORDERED_LIST_COMMAND');
const INSERT_ORDERED_LIST_COMMAND$1 = Lexical_1.createCommand('INSERT_ORDERED_LIST_COMMAND');
const INSERT_CHECK_LIST_COMMAND$1 = Lexical_1.createCommand('INSERT_CHECK_LIST_COMMAND');
const REMOVE_LIST_COMMAND$1 = Lexical_1.createCommand('REMOVE_LIST_COMMAND');

var $createListItemNode_1 = $createListItemNode$1;
var $createListNode_1 = $createListNode$1;
var $getListDepth_1 = $getListDepth$1;
var $handleListInsertParagraph_1 = $handleListInsertParagraph$1;
var $isListItemNode_1 = $isListItemNode$1;
var $isListNode_1 = $isListNode$1;
var INSERT_CHECK_LIST_COMMAND_1 = INSERT_CHECK_LIST_COMMAND$1;
var INSERT_ORDERED_LIST_COMMAND_1 = INSERT_ORDERED_LIST_COMMAND$1;
var INSERT_UNORDERED_LIST_COMMAND_1 = INSERT_UNORDERED_LIST_COMMAND$1;
var ListItemNode_1 = ListItemNode$1;
var ListNode_1 = ListNode$1;
var REMOVE_LIST_COMMAND_1 = REMOVE_LIST_COMMAND$1;
var insertList_1 = insertList$1;
var removeList_1 = removeList$1;

var LexicalList_dev = {
	$createListItemNode: $createListItemNode_1,
	$createListNode: $createListNode_1,
	$getListDepth: $getListDepth_1,
	$handleListInsertParagraph: $handleListInsertParagraph_1,
	$isListItemNode: $isListItemNode_1,
	$isListNode: $isListNode_1,
	INSERT_CHECK_LIST_COMMAND: INSERT_CHECK_LIST_COMMAND_1,
	INSERT_ORDERED_LIST_COMMAND: INSERT_ORDERED_LIST_COMMAND_1,
	INSERT_UNORDERED_LIST_COMMAND: INSERT_UNORDERED_LIST_COMMAND_1,
	ListItemNode: ListItemNode_1,
	ListNode: ListNode_1,
	REMOVE_LIST_COMMAND: REMOVE_LIST_COMMAND_1,
	insertList: insertList_1,
	removeList: removeList_1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function m$4(a){throw Error(`Minified Lexical error #${a}; visit https://lexical.dev/docs/error?code=${a} for the full message or `+"use the non-minified dev environment for full errors and additional helpful warnings.");}function n$2(a){let b=1;for(a=a.getParent();null!=a;){if(p$4(a)){a=a.getParent();if(q$4(a)){b++;a=a.getParent();continue}m$4(40);}break}return b}
function r$7(a){a=a.getParent();q$4(a)||m$4(40);let b=a;for(;null!==b;)b=b.getParent(),q$4(b)&&(a=b);return a}function t$4(a){let b=[];a=a.getChildren().filter(p$4);for(let c=0;c<a.length;c++){let d=a[c],e=d.getFirstChild();q$4(e)?b=b.concat(t$4(e)):b.push(d);}return b}function u$6(a){return p$4(a)&&q$4(a.getFirstChild())}function v$2(a){for(;null==a.getNextSibling()&&null==a.getPreviousSibling();){let b=a.getParent();if(null==b||!p$4(a)&&!q$4(a))break;a=b;}a.remove();}function w$3(a){return y$2().append(a)}
function z$3(a,b){return p$4(a)&&(0===b.length||1===b.length&&a.is(b[0])&&0===a.getChildrenSize())}function B$4(a,b){a.splice(a.getChildrenSize(),0,b);}
function C$2(a,b){if(q$4(a))return a;let c=a.getPreviousSibling(),d=a.getNextSibling(),e=y$2();e.setFormat(a.getFormatType());e.setIndent(a.getIndent());B$4(e,a.getChildren());if(q$4(c)&&b===c.getListType())return c.append(e),a.remove(),q$4(d)&&b===d.getListType()&&(B$4(c,d.getChildren()),d.remove()),c;if(q$4(d)&&b===d.getListType())return d.getFirstChildOrThrow().insertBefore(e),a.remove(),d;b=D$2(b);b.append(e);a.replace(b);E$3(b);return b}
function F$2(a,b){var c=a.getLastChild();let d=b.getFirstChild();c&&d&&u$6(c)&&u$6(d)&&(F$2(c.getFirstChild(),d.getFirstChild()),d.remove());c=b.getChildren();0<c.length&&(a.append(...c),E$3(a));b.remove();}function E$3(a,b){a=b||a.getChildren();if(void 0!==a)for(b=0;b<a.length;b++){let f=a[b];if(p$4(f)){let g=f.getValue();var c=f,d=c.getParent(),e=1;null!=d&&(q$4(d)?e=d.getStart():m$4(44));c=c.getPreviousSiblings();for(d=0;d<c.length;d++){let l=c[d];p$4(l)&&!q$4(l.getFirstChild())&&e++;}g!==e&&f.setValue(e);}}}
function G$2(a){if(!u$6(a)){var b=a.getParent(),c=b?b.getParent():void 0,d=c?c.getParent():void 0;if(q$4(d)&&p$4(c)&&q$4(b)){var e=b?b.getFirstChild():void 0,f=b?b.getLastChild():void 0;if(a.is(e))c.insertBefore(a),b.isEmpty()&&c.remove();else if(a.is(f))c.insertAfter(a),b.isEmpty()&&c.remove();else {var g=b.getListType();e=y$2();let l=D$2(g);e.append(l);a.getPreviousSiblings().forEach(x=>l.append(x));f=y$2();g=D$2(g);f.append(g);B$4(g,a.getNextSiblings());c.insertBefore(e);c.insertAfter(f);c.replace(a);}E$3(b);E$3(d);}}}
class H$4 extends Lexical_1.ElementNode{static getType(){return "listitem"}static clone(a){return new H$4(a.__value,a.__checked,a.__key)}constructor(a,b,c){super(c);this.__value=void 0===a?1:a;this.__checked=b;}createDOM(a){let b=document.createElement("li"),c=this.getParent();q$4(c)&&"check"===c.getListType()&&I$3(b,this,null);b.value=this.__value;J$3(b,a.theme,this);return b}updateDOM(a,b,c){let d=this.getParent();q$4(d)&&"check"===d.getListType()&&I$3(b,this,a);b.value=this.__value;J$3(b,c.theme,this);return !1}static transform(){return a=>
{let b=a.getParent();q$4(b)&&(E$3(b),"check"!==b.getListType()&&null!=a.getChecked()&&a.setChecked(void 0));}}static importDOM(){return {li:()=>({conversion:K$3,priority:0})}}static importJSON(a){let b=new H$4(a.value,a.checked);b.setFormat(a.format);b.setDirection(a.direction);return b}exportJSON(){return {...super.exportJSON(),checked:this.getChecked(),type:"listitem",value:this.getValue(),version:1}}append(...a){for(let b=0;b<a.length;b++){let c=a[b];if(Lexical_1.$isElementNode(c)&&this.canMergeWith(c)){let d=c.getChildren();
this.append(...d);c.remove();}else super.append(c);}return this}replace(a,b){if(p$4(a))return super.replace(a);this.setIndent(0);let c=this.getParentOrThrow();if(!q$4(c))return a;if(c.__first===this.getKey())c.insertBefore(a);else if(c.__last===this.getKey())c.insertAfter(a);else {let d=D$2(c.getListType()),e=this.getNextSibling();for(;e;){let f=e;e=e.getNextSibling();d.append(f);}c.insertAfter(a);a.insertAfter(d);}b&&this.getChildren().forEach(d=>{a.append(d);});this.remove();0===c.getChildrenSize()&&c.remove();
return a}insertAfter(a,b=!0){var c=this.getParentOrThrow();q$4(c)||m$4(39);var d=this.getNextSiblings();if(p$4(a))return b=super.insertAfter(a,b),a=a.getParentOrThrow(),q$4(a)&&E$3(a),b;if(q$4(a)&&a.getListType()===c.getListType()){c=a;a=a.getChildren();for(d=a.length-1;0<=d;d--)c=a[d],this.insertAfter(c,b);return c}c.insertAfter(a,b);if(0!==d.length){let e=D$2(c.getListType());d.forEach(f=>e.append(f));a.insertAfter(e,b);}return a}remove(a){let b=this.getPreviousSibling(),c=this.getNextSibling();super.remove(a);
b&&c&&u$6(b)&&u$6(c)?(F$2(b.getFirstChild(),c.getFirstChild()),c.remove()):c&&(a=c.getParent(),q$4(a)&&E$3(a));}insertNewAfter(a,b=!0){a=y$2(null==this.__checked?void 0:!1);this.insertAfter(a,b);return a}collapseAtStart(a){let b=Lexical_1.$createParagraphNode();this.getChildren().forEach(f=>b.append(f));var c=this.getParentOrThrow(),d=c.getParentOrThrow();let e=p$4(d);1===c.getChildrenSize()?e?(c.remove(),d.select()):(c.insertBefore(b),c.remove(),c=a.anchor,a=a.focus,d=b.getKey(),"element"===c.type&&c.getNode().is(this)&&
c.set(d,c.offset,"element"),"element"===a.type&&a.getNode().is(this)&&a.set(d,a.offset,"element")):(c.insertBefore(b),this.remove());return !0}getValue(){return this.getLatest().__value}setValue(a){this.getWritable().__value=a;}getChecked(){return this.getLatest().__checked}setChecked(a){this.getWritable().__checked=a;}toggleChecked(){this.setChecked(!this.__checked);}getIndent(){var a=this.getParent();if(null===a)return this.getLatest().__indent;a=a.getParentOrThrow();let b=0;for(;p$4(a);)a=a.getParentOrThrow().getParentOrThrow(),
b++;return b}setIndent(a){"number"===typeof a&&-1<a||m$4(117);let b=this.getIndent();for(;b!==a;)if(b<a){a:{var c=new Set;if(u$6(this)||c.has(this.getKey()))break a;let g=this.getParent();var d=this.getNextSibling(),e=this.getPreviousSibling();if(u$6(d)&&u$6(e)){if(e=e.getFirstChild(),q$4(e)){e.append(this);var f=d.getFirstChild();q$4(f)&&(f=f.getChildren(),B$4(e,f),d.remove(),c.add(d.getKey()));E$3(e);}}else u$6(d)?(d=d.getFirstChild(),q$4(d)&&(c=d.getFirstChild(),null!==c&&c.insertBefore(this),E$3(d))):u$6(e)?(d=e.getFirstChild(),
q$4(d)&&(d.append(this),E$3(d))):q$4(g)&&(c=y$2(),f=D$2(g.getListType()),c.append(f),f.append(this),e?e.insertAfter(c):d?d.insertBefore(c):g.append(c),E$3(f));q$4(g)&&E$3(g);}b++;}else G$2(this),b--;return this}insertBefore(a){if(p$4(a)){let b=this.getParentOrThrow();if(q$4(b)){let c=this.getNextSiblings();E$3(b,c);}}return super.insertBefore(a)}canInsertAfter(a){return p$4(a)}canReplaceWith(a){return p$4(a)}canMergeWith(a){return Lexical_1.$isParagraphNode(a)||p$4(a)}extractWithChild(a,b){if(!Lexical_1.$isRangeSelection(b))return !1;a=b.anchor.getNode();
let c=b.focus.getNode();return this.isParentOf(a)&&this.isParentOf(c)&&this.getTextContent().length===b.getTextContent().length}isParentRequired(){return !0}createParentElementNode(){return D$2("bullet")}}
function J$3(a,b,c){let d=[],e=[];var f=(b=b.list)?b.listitem:void 0;if(b&&b.nested)var g=b.nested.listitem;void 0!==f&&(f=f.split(" "),d.push(...f));if(b){f=c.getParent();f=q$4(f)&&"check"===f.getListType();let l=c.getChecked();f&&!l||e.push(b.listitemUnchecked);f&&l||e.push(b.listitemChecked);f&&d.push(l?b.listitemChecked:b.listitemUnchecked);}void 0!==g&&(g=g.split(" "),c.getChildren().some(l=>q$4(l))?d.push(...g):e.push(...g));0<e.length&&LexicalUtils_1.removeClassNamesFromElement(a,...e);0<d.length&&LexicalUtils_1.addClassNamesToElement(a,
...d);}function I$3(a,b,c){q$4(b.getFirstChild())?(a.removeAttribute("role"),a.removeAttribute("tabIndex"),a.removeAttribute("aria-checked")):(a.setAttribute("role","checkbox"),a.setAttribute("tabIndex","-1"),c&&b.__checked===c.__checked||a.setAttribute("aria-checked",b.getChecked()?"true":"false"));}function K$3(a){a=LexicalUtils_1.isHTMLElement(a)&&"true"===a.getAttribute("aria-checked");return {node:y$2(a)}}function y$2(a){return Lexical_1.$applyNodeReplacement(new H$4(void 0,a))}function p$4(a){return a instanceof H$4}
class L$3 extends Lexical_1.ElementNode{static getType(){return "list"}static clone(a){return new L$3(a.__listType||N$1[a.__tag],a.__start,a.__key)}constructor(a,b,c){super(c);this.__listType=a=N$1[a]||a;this.__tag="number"===a?"ol":"ul";this.__start=b;}getTag(){return this.__tag}getListType(){return this.__listType}getStart(){return this.__start}createDOM(a){let b=document.createElement(this.__tag);1!==this.__start&&b.setAttribute("start",String(this.__start));b.__lexicalListType=this.__listType;O$2(b,a.theme,this);
return b}updateDOM(a,b,c){if(a.__tag!==this.__tag)return !0;O$2(b,c.theme,this);return !1}static importDOM(){return {ol:()=>({conversion:P$2,priority:0}),ul:()=>({conversion:P$2,priority:0})}}static importJSON(a){let b=D$2(a.listType,a.start);b.setFormat(a.format);b.setIndent(a.indent);b.setDirection(a.direction);return b}exportDOM(a){({element:a}=super.exportDOM(a));a&&(1!==this.__start&&a.setAttribute("start",String(this.__start)),"check"===this.__listType&&a.setAttribute("__lexicalListType","check"));return {element:a}}exportJSON(){return {...super.exportJSON(),
listType:this.getListType(),start:this.getStart(),tag:this.getTag(),type:"list",version:1}}canBeEmpty(){return !1}canIndent(){return !1}append(...a){for(let c=0;c<a.length;c++){var b=a[c];if(p$4(b))super.append(b);else {let d=y$2();q$4(b)?d.append(b):Lexical_1.$isElementNode(b)?(b=Lexical_1.$createTextNode(b.getTextContent()),d.append(b)):d.append(b);super.append(d);}}E$3(this);return this}extractWithChild(a){return p$4(a)}}
function O$2(a,b,c){let d=[],e=[];var f=b.list;if(void 0!==f){let l=f[`${c.__tag}Depth`]||[];b=n$2(c)-1;let x=b%l.length;var g=l[x];let M=f[c.__tag],A;f=f.nested;void 0!==f&&f.list&&(A=f.list);void 0!==M&&d.push(M);if(void 0!==g)for(g=g.split(" "),d.push(...g),g=0;g<l.length;g++)g!==x&&e.push(c.__tag+g);void 0!==A&&(c=A.split(" "),1<b?d.push(...c):e.push(...c));}0<e.length&&LexicalUtils_1.removeClassNamesFromElement(a,...e);0<d.length&&LexicalUtils_1.addClassNamesToElement(a,...d);}
function Q$2(a){let b=[];for(let d=0;d<a.length;d++){var c=a[d];p$4(c)?(b.push(c),c=c.getChildren(),1<c.length&&c.forEach(e=>{q$4(e)&&b.push(w$3(e));})):b.push(w$3(c));}return b}function P$2(a){let b=a.nodeName.toLowerCase(),c=null;"ol"===b?c=D$2("number",a.start):"ul"===b&&(c=LexicalUtils_1.isHTMLElement(a)&&"check"===a.getAttribute("__lexicallisttype")?D$2("check"):D$2("bullet"));return {after:Q$2,node:c}}let N$1={ol:"number",ul:"bullet"};function D$2(a,b=1){return Lexical_1.$applyNodeReplacement(new L$3(a,b))}
function q$4(a){return a instanceof L$3}let R$2=Lexical_1.createCommand("INSERT_UNORDERED_LIST_COMMAND"),S$1=Lexical_1.createCommand("INSERT_ORDERED_LIST_COMMAND"),T$1=Lexical_1.createCommand("INSERT_CHECK_LIST_COMMAND"),U$2=Lexical_1.createCommand("REMOVE_LIST_COMMAND");var $createListItemNode=y$2;var $createListNode=D$2;var $getListDepth=n$2;
var $handleListInsertParagraph=function(){var a=Lexical_1.$getSelection();if(!Lexical_1.$isRangeSelection(a)||!a.isCollapsed())return !1;a=a.anchor.getNode();if(!p$4(a)||""!==a.getTextContent())return !1;var b=r$7(a),c=a.getParent();q$4(c)||m$4(40);let d=c.getParent(),e;if(Lexical_1.$isRootOrShadowRoot(d))e=Lexical_1.$createParagraphNode(),b.insertAfter(e);else if(p$4(d))e=y$2(),d.insertAfter(e);else return !1;e.select();b=a.getNextSiblings();if(0<b.length){let f=D$2(c.getListType());Lexical_1.$isParagraphNode(e)?e.insertAfter(f):(c=y$2(),c.append(f),
e.insertAfter(c));b.forEach(g=>{g.remove();f.append(g);});}v$2(a);return !0};var $isListItemNode=p$4;var $isListNode=q$4;var INSERT_CHECK_LIST_COMMAND=T$1;var INSERT_ORDERED_LIST_COMMAND=S$1;var INSERT_UNORDERED_LIST_COMMAND=R$2;var ListItemNode=H$4;var ListNode=L$3;var REMOVE_LIST_COMMAND=U$2;
var insertList=function(a,b){a.update(()=>{var c=Lexical_1.$getSelection();if(Lexical_1.$isRangeSelection(c)||Lexical_1.DEPRECATED_$isGridSelection(c)){var d=c.getNodes();c=c.anchor.getNode();var e=c.getParent();if(z$3(c,d))d=D$2(b),Lexical_1.$isRootOrShadowRoot(e)?(c.replace(d),e=y$2(),Lexical_1.$isElementNode(c)&&(e.setFormat(c.getFormatType()),e.setIndent(c.getIndent())),d.append(e)):p$4(c)&&(c=c.getParentOrThrow(),B$4(d,c.getChildren()),c.replace(d));else for(c=new Set,e=0;e<d.length;e++){var f=d[e];if(Lexical_1.$isElementNode(f)&&f.isEmpty()&&!c.has(f.getKey()))C$2(f,
b);else if(Lexical_1.$isLeafNode(f))for(f=f.getParent();null!=f;){let l=f.getKey();if(q$4(f)){if(!c.has(l)){var g=D$2(b);B$4(g,f.getChildren());f.replace(g);E$3(g);c.add(l);}break}else {g=f.getParent();if(Lexical_1.$isRootOrShadowRoot(g)&&!c.has(l)){c.add(l);C$2(f,b);break}f=g;}}}}});};
var removeList=function(a){a.update(()=>{let b=Lexical_1.$getSelection();if(Lexical_1.$isRangeSelection(b)){var c=new Set,d=b.getNodes(),e=b.anchor.getNode();if(z$3(e,d))c.add(r$7(e));else for(e=0;e<d.length;e++){var f=d[e];Lexical_1.$isLeafNode(f)&&(f=LexicalUtils_1.$getNearestNodeOfType(f,H$4),null!=f&&c.add(r$7(f)));}for(let g of c){c=g;d=t$4(g);for(let l of d)d=Lexical_1.$createParagraphNode(),B$4(d,l.getChildren()),c.insertAfter(d),c=d,l.__key===b.anchor.key&&b.anchor.set(d.getKey(),0,"element"),l.__key===b.focus.key&&b.focus.set(d.getKey(),0,"element"),
l.remove();g.remove();}}});};

var LexicalList_prod = {
	$createListItemNode: $createListItemNode,
	$createListNode: $createListNode,
	$getListDepth: $getListDepth,
	$handleListInsertParagraph: $handleListInsertParagraph,
	$isListItemNode: $isListItemNode,
	$isListNode: $isListNode,
	INSERT_CHECK_LIST_COMMAND: INSERT_CHECK_LIST_COMMAND,
	INSERT_ORDERED_LIST_COMMAND: INSERT_ORDERED_LIST_COMMAND,
	INSERT_UNORDERED_LIST_COMMAND: INSERT_UNORDERED_LIST_COMMAND,
	ListItemNode: ListItemNode,
	ListNode: ListNode,
	REMOVE_LIST_COMMAND: REMOVE_LIST_COMMAND,
	insertList: insertList,
	removeList: removeList
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const LexicalList = process.env.NODE_ENV === 'development' ? LexicalList_dev : LexicalList_prod;
var LexicalList_1 = LexicalList;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */




/** @module @lexical/html */
/**
 * How you parse your html string to get a document is left up to you. In the browser you can use the native
 * DOMParser API to generate a document (see clipboard.ts), but to use in a headless environment you can use JSDom
 * or an equivilant library and pass in the document here.
 */

function $generateNodesFromDOM$1(editor, dom) {
  let lexicalNodes = [];
  const elements = dom.body ? dom.body.childNodes : [];

  for (let i = 0; i < elements.length; i++) {
    const element = elements[i];

    if (!IGNORE_TAGS.has(element.nodeName)) {
      const lexicalNode = $createNodesFromDOM(element, editor);

      if (lexicalNode !== null) {
        lexicalNodes = lexicalNodes.concat(lexicalNode);
      }
    }
  }

  return lexicalNodes;
}
function $generateHtmlFromNodes$1(editor, selection) {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    throw new Error('To use $generateHtmlFromNodes in headless mode please initialize a headless browser implementation such as JSDom before calling this function.');
  }

  const container = document.createElement('div');
  const root = Lexical_1.$getRoot();
  const topLevelChildren = root.getChildren();

  for (let i = 0; i < topLevelChildren.length; i++) {
    const topLevelNode = topLevelChildren[i];
    $appendNodesToHTML(editor, topLevelNode, container, selection);
  }

  return container.innerHTML;
}

function $appendNodesToHTML(editor, currentNode, parentElement, selection$1 = null) {
  let shouldInclude = selection$1 != null ? currentNode.isSelected() : true;
  const shouldExclude = Lexical_1.$isElementNode(currentNode) && currentNode.excludeFromCopy('html');
  let target = currentNode;

  if (selection$1 !== null) {
    let clone = LexicalSelection_1.$cloneWithProperties(currentNode);
    clone = Lexical_1.$isTextNode(clone) && selection$1 != null ? LexicalSelection_1.$sliceSelectedTextNodeContent(selection$1, clone) : clone;
    target = clone;
  }

  const children = Lexical_1.$isElementNode(target) ? target.getChildren() : [];
  const {
    element,
    after
  } = target.exportDOM(editor);

  if (!element) {
    return false;
  }

  const fragment = document.createDocumentFragment();

  for (let i = 0; i < children.length; i++) {
    const childNode = children[i];
    const shouldIncludeChild = $appendNodesToHTML(editor, childNode, fragment, selection$1);

    if (!shouldInclude && Lexical_1.$isElementNode(currentNode) && shouldIncludeChild && currentNode.extractWithChild(childNode, selection$1, 'html')) {
      shouldInclude = true;
    }
  }

  if (shouldInclude && !shouldExclude) {
    element.append(fragment);
    parentElement.append(element);

    if (after) {
      const newElement = after.call(target, element);
      if (newElement) element.replaceWith(newElement);
    }
  } else {
    parentElement.append(fragment);
  }

  return shouldInclude;
}

function getConversionFunction(domNode, editor) {
  const {
    nodeName
  } = domNode;

  const cachedConversions = editor._htmlConversions.get(nodeName.toLowerCase());

  let currentConversion = null;

  if (cachedConversions !== undefined) {
    for (const cachedConversion of cachedConversions) {
      const domConversion = cachedConversion(domNode);

      if (domConversion !== null && (currentConversion === null || currentConversion.priority < domConversion.priority)) {
        currentConversion = domConversion;
      }
    }
  }

  return currentConversion !== null ? currentConversion.conversion : null;
}

const IGNORE_TAGS = new Set(['STYLE', 'SCRIPT']);

function $createNodesFromDOM(node, editor, forChildMap = new Map(), parentLexicalNode, preformatted = false) {
  let lexicalNodes = [];

  if (IGNORE_TAGS.has(node.nodeName)) {
    return lexicalNodes;
  }

  let currentLexicalNode = null;
  const transformFunction = getConversionFunction(node, editor);
  const transformOutput = transformFunction ? transformFunction(node, undefined, preformatted) : null;
  let postTransform = null;

  if (transformOutput !== null) {
    postTransform = transformOutput.after;
    currentLexicalNode = transformOutput.node;

    if (currentLexicalNode !== null) {
      for (const [, forChildFunction] of forChildMap) {
        currentLexicalNode = forChildFunction(currentLexicalNode, parentLexicalNode);

        if (!currentLexicalNode) {
          break;
        }
      }

      if (currentLexicalNode) {
        lexicalNodes.push(currentLexicalNode);
      }
    }

    if (transformOutput.forChild != null) {
      forChildMap.set(node.nodeName, transformOutput.forChild);
    }
  } // If the DOM node doesn't have a transformer, we don't know what
  // to do with it but we still need to process any childNodes.


  const children = node.childNodes;
  let childLexicalNodes = [];

  for (let i = 0; i < children.length; i++) {
    childLexicalNodes.push(...$createNodesFromDOM(children[i], editor, new Map(forChildMap), currentLexicalNode, preformatted || (transformOutput && transformOutput.preformatted) === true));
  }

  if (postTransform != null) {
    childLexicalNodes = postTransform(childLexicalNodes);
  }

  if (currentLexicalNode == null) {
    // If it hasn't been converted to a LexicalNode, we hoist its children
    // up to the same level as it.
    lexicalNodes = lexicalNodes.concat(childLexicalNodes);
  } else {
    if (Lexical_1.$isElementNode(currentLexicalNode)) {
      // If the current node is a ElementNode after conversion,
      // we can append all the children to it.
      currentLexicalNode.append(...childLexicalNodes);
    }
  }

  return lexicalNodes;
}

var $generateHtmlFromNodes_1 = $generateHtmlFromNodes$1;
var $generateNodesFromDOM_1 = $generateNodesFromDOM$1;

var LexicalHtml_dev = {
	$generateHtmlFromNodes: $generateHtmlFromNodes_1,
	$generateNodesFromDOM: $generateNodesFromDOM_1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function r$6(c,d,h,a=null){let e=null!=a?d.isSelected():!0,m=Lexical_1.$isElementNode(d)&&d.excludeFromCopy("html");var b=d;null!==a&&(b=LexicalSelection_1.$cloneWithProperties(d),b=Lexical_1.$isTextNode(b)&&null!=a?LexicalSelection_1.$sliceSelectedTextNodeContent(a,b):b);let f=Lexical_1.$isElementNode(b)?b.getChildren():[],{element:k,after:g}=b.exportDOM(c);if(!k)return !1;let l=document.createDocumentFragment();for(let p=0;p<f.length;p++){let t=f[p],w=r$6(c,t,l,a);!e&&Lexical_1.$isElementNode(d)&&w&&d.extractWithChild(t,a,"html")&&(e=!0);}e&&!m?(k.append(l),h.append(k),
g&&(c=g.call(b,k))&&k.replaceWith(c)):h.append(l);return e}let u$5=new Set(["STYLE","SCRIPT"]);
function v$1(c,d,h=new Map,a,e=!1){let m=[];if(u$5.has(c.nodeName))return m;let b=null;var {nodeName:f}=c,k=d._htmlConversions.get(f.toLowerCase());f=null;if(void 0!==k)for(g of k)k=g(c),null!==k&&(null===f||f.priority<k.priority)&&(f=k);var g=(g=null!==f?f.conversion:null)?g(c,void 0,e):null;f=null;if(null!==g){f=g.after;b=g.node;if(null!==b){for(var [,l]of h)if(b=l(b,a),!b)break;b&&m.push(b);}null!=g.forChild&&h.set(c.nodeName,g.forChild);}c=c.childNodes;a=[];for(l=0;l<c.length;l++)a.push(...v$1(c[l],d,
new Map(h),b,e||!0===(g&&g.preformatted)));null!=f&&(a=f(a));null==b?m=m.concat(a):Lexical_1.$isElementNode(b)&&b.append(...a);return m}var $generateHtmlFromNodes=function(c,d){if("undefined"===typeof document||"undefined"===typeof window)throw Error("To use $generateHtmlFromNodes in headless mode please initialize a headless browser implementation such as JSDom before calling this function.");let h=document.createElement("div"),a=Lexical_1.$getRoot().getChildren();for(let e=0;e<a.length;e++)r$6(c,a[e],h,d);return h.innerHTML};
var $generateNodesFromDOM=function(c,d){let h=[];d=d.body?d.body.childNodes:[];for(let e=0;e<d.length;e++){var a=d[e];u$5.has(a.nodeName)||(a=v$1(a,c),null!==a&&(h=h.concat(a)));}return h};

var LexicalHtml_prod = {
	$generateHtmlFromNodes: $generateHtmlFromNodes,
	$generateNodesFromDOM: $generateNodesFromDOM
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const LexicalHtml = process.env.NODE_ENV === 'development' ? LexicalHtml_dev : LexicalHtml_prod;
var LexicalHtml_1 = LexicalHtml;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */






/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
function $getHtmlContent$1(editor) {
  const selection = Lexical_1.$getSelection();

  if (selection == null) {
    {
      throw Error(`Expected valid LexicalSelection`);
    }
  } // If we haven't selected anything


  if (Lexical_1.$isRangeSelection(selection) && selection.isCollapsed() || selection.getNodes().length === 0) {
    return '';
  }

  return LexicalHtml_1.$generateHtmlFromNodes(editor, selection);
} // TODO 0.6.0 Return a blank string instead
// TODO 0.6.0 Rename to $getJSON

function $getLexicalContent$1(editor) {
  const selection = Lexical_1.$getSelection();

  if (selection == null) {
    {
      throw Error(`Expected valid LexicalSelection`);
    }
  } // If we haven't selected anything


  if (Lexical_1.$isRangeSelection(selection) && selection.isCollapsed() || selection.getNodes().length === 0) {
    return null;
  }

  return JSON.stringify($generateJSONFromSelectedNodes$1(editor, selection));
}
function $insertDataTransferForPlainText$1(dataTransfer, selection) {
  const text = dataTransfer.getData('text/plain');

  if (text != null) {
    selection.insertRawText(text);
  }
}
function $insertDataTransferForRichText$1(dataTransfer, selection, editor) {
  const lexicalString = dataTransfer.getData('application/x-lexical-editor');

  if (lexicalString) {
    try {
      const payload = JSON.parse(lexicalString);

      if (payload.namespace === editor._config.namespace && Array.isArray(payload.nodes)) {
        const nodes = $generateNodesFromSerializedNodes$1(payload.nodes);
        return $insertGeneratedNodes$1(editor, nodes, selection);
      }
    } catch {// Fail silently.
    }
  }

  const htmlString = dataTransfer.getData('text/html');

  if (htmlString) {
    try {
      const parser = new DOMParser();
      const dom = parser.parseFromString(htmlString, 'text/html');
      const nodes = LexicalHtml_1.$generateNodesFromDOM(editor, dom);
      return $insertGeneratedNodes$1(editor, nodes, selection);
    } catch {// Fail silently.
    }
  } // Multi-line plain text in rich text mode pasted as separate paragraphs
  // instead of single paragraph with linebreaks.


  const text = dataTransfer.getData('text/plain');

  if (text != null) {
    if (Lexical_1.$isRangeSelection(selection)) {
      const lines = text.split(/\r?\n/);
      const linesLength = lines.length;

      for (let i = 0; i < linesLength; i++) {
        selection.insertText(lines[i]);

        if (i < linesLength - 1) {
          selection.insertParagraph();
        }
      }
    } else {
      selection.insertRawText(text);
    }
  }
}
function $insertGeneratedNodes$1(editor, nodes, selection) {
  const isSelectionInsideOfGrid = Lexical_1.DEPRECATED_$isGridSelection(selection) || LexicalUtils_1.$findMatchingParent(selection.anchor.getNode(), n => Lexical_1.DEPRECATED_$isGridCellNode(n)) !== null && LexicalUtils_1.$findMatchingParent(selection.focus.getNode(), n => Lexical_1.DEPRECATED_$isGridCellNode(n)) !== null;

  if (isSelectionInsideOfGrid && nodes.length === 1 && Lexical_1.DEPRECATED_$isGridNode(nodes[0])) {
    $mergeGridNodesStrategy(nodes, selection, false, editor);
    return;
  }

  $basicInsertStrategy(nodes, selection);
  return;
}

function $basicInsertStrategy(nodes, selection) {
  // Wrap text and inline nodes in paragraph nodes so we have all blocks at the top-level
  const topLevelBlocks = [];
  let currentBlock = null;

  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i];
    const isLineBreakNode = Lexical_1.$isLineBreakNode(node);

    if (isLineBreakNode || Lexical_1.$isDecoratorNode(node) && node.isInline() || Lexical_1.$isElementNode(node) && node.isInline() || Lexical_1.$isTextNode(node) || node.isParentRequired()) {
      if (currentBlock === null) {
        currentBlock = node.createParentElementNode();
        topLevelBlocks.push(currentBlock); // In the case of LineBreakNode, we just need to
        // add an empty ParagraphNode to the topLevelBlocks.

        if (isLineBreakNode) {
          continue;
        }
      }

      if (currentBlock !== null) {
        currentBlock.append(node);
      }
    } else {
      topLevelBlocks.push(node);
      currentBlock = null;
    }
  }

  if (Lexical_1.$isRangeSelection(selection)) {
    selection.insertNodes(topLevelBlocks);
  } else if (Lexical_1.DEPRECATED_$isGridSelection(selection)) {
    // If there's an active grid selection and a non grid is pasted, add to the anchor.
    const anchorCell = selection.anchor.getNode();

    if (!Lexical_1.DEPRECATED_$isGridCellNode(anchorCell)) {
      {
        throw Error(`Expected Grid Cell in Grid Selection`);
      }
    }

    anchorCell.append(...topLevelBlocks);
  }
}

function $mergeGridNodesStrategy(nodes, selection, isFromLexical, editor) {
  if (nodes.length !== 1 || !Lexical_1.DEPRECATED_$isGridNode(nodes[0])) {
    {
      throw Error(`$mergeGridNodesStrategy: Expected Grid insertion.`);
    }
  }

  const newGrid = nodes[0];
  const newGridRows = newGrid.getChildren();
  const newColumnCount = newGrid.getFirstChildOrThrow().getChildrenSize();
  const newRowCount = newGrid.getChildrenSize();
  const gridCellNode = LexicalUtils_1.$findMatchingParent(selection.anchor.getNode(), n => Lexical_1.DEPRECATED_$isGridCellNode(n));
  const gridRowNode = gridCellNode && LexicalUtils_1.$findMatchingParent(gridCellNode, n => Lexical_1.DEPRECATED_$isGridRowNode(n));
  const gridNode = gridRowNode && LexicalUtils_1.$findMatchingParent(gridRowNode, n => Lexical_1.DEPRECATED_$isGridNode(n));

  if (!Lexical_1.DEPRECATED_$isGridCellNode(gridCellNode) || !Lexical_1.DEPRECATED_$isGridRowNode(gridRowNode) || !Lexical_1.DEPRECATED_$isGridNode(gridNode)) {
    {
      throw Error(`$mergeGridNodesStrategy: Expected selection to be inside of a Grid.`);
    }
  }

  const startY = gridRowNode.getIndexWithinParent();
  const stopY = Math.min(gridNode.getChildrenSize() - 1, startY + newRowCount - 1);
  const startX = gridCellNode.getIndexWithinParent();
  const stopX = Math.min(gridRowNode.getChildrenSize() - 1, startX + newColumnCount - 1);
  const fromX = Math.min(startX, stopX);
  const fromY = Math.min(startY, stopY);
  const toX = Math.max(startX, stopX);
  const toY = Math.max(startY, stopY);
  const gridRowNodes = gridNode.getChildren();
  let newRowIdx = 0;
  let newAnchorCellKey;
  let newFocusCellKey;

  for (let r = fromY; r <= toY; r++) {
    const currentGridRowNode = gridRowNodes[r];

    if (!Lexical_1.DEPRECATED_$isGridRowNode(currentGridRowNode)) {
      {
        throw Error(`getNodes: expected to find GridRowNode`);
      }
    }

    const newGridRowNode = newGridRows[newRowIdx];

    if (!Lexical_1.DEPRECATED_$isGridRowNode(newGridRowNode)) {
      {
        throw Error(`getNodes: expected to find GridRowNode`);
      }
    }

    const gridCellNodes = currentGridRowNode.getChildren();
    const newGridCellNodes = newGridRowNode.getChildren();
    let newColumnIdx = 0;

    for (let c = fromX; c <= toX; c++) {
      const currentGridCellNode = gridCellNodes[c];

      if (!Lexical_1.DEPRECATED_$isGridCellNode(currentGridCellNode)) {
        {
          throw Error(`getNodes: expected to find GridCellNode`);
        }
      }

      const newGridCellNode = newGridCellNodes[newColumnIdx];

      if (!Lexical_1.DEPRECATED_$isGridCellNode(newGridCellNode)) {
        {
          throw Error(`getNodes: expected to find GridCellNode`);
        }
      }

      if (r === fromY && c === fromX) {
        newAnchorCellKey = currentGridCellNode.getKey();
      } else if (r === toY && c === toX) {
        newFocusCellKey = currentGridCellNode.getKey();
      }

      const originalChildren = currentGridCellNode.getChildren();
      newGridCellNode.getChildren().forEach(child => {
        if (Lexical_1.$isTextNode(child)) {
          const paragraphNode = Lexical_1.$createParagraphNode();
          paragraphNode.append(child);
          currentGridCellNode.append(child);
        } else {
          currentGridCellNode.append(child);
        }
      });
      originalChildren.forEach(n => n.remove());
      newColumnIdx++;
    }

    newRowIdx++;
  }

  if (newAnchorCellKey && newFocusCellKey) {
    const newGridSelection = Lexical_1.DEPRECATED_$createGridSelection();
    newGridSelection.set(gridNode.getKey(), newAnchorCellKey, newFocusCellKey);
    Lexical_1.$setSelection(newGridSelection);
    editor.dispatchCommand(Lexical_1.SELECTION_CHANGE_COMMAND, undefined);
  }
}

function exportNodeToJSON(node) {
  const serializedNode = node.exportJSON();
  const nodeClass = node.constructor; // @ts-expect-error TODO Replace Class utility type with InstanceType

  if (serializedNode.type !== nodeClass.getType()) {
    {
      throw Error(`LexicalNode: Node ${nodeClass.name} does not implement .exportJSON().`);
    }
  } // @ts-expect-error TODO Replace Class utility type with InstanceType


  const serializedChildren = serializedNode.children;

  if (Lexical_1.$isElementNode(node)) {
    if (!Array.isArray(serializedChildren)) {
      {
        throw Error(`LexicalNode: Node ${nodeClass.name} is an element but .exportJSON() does not have a children array.`);
      }
    }
  }

  return serializedNode;
}

function $appendNodesToJSON(editor, selection$1, currentNode, targetArray = []) {
  let shouldInclude = selection$1 != null ? currentNode.isSelected(selection$1) : true;
  const shouldExclude = Lexical_1.$isElementNode(currentNode) && currentNode.excludeFromCopy('html');
  let target = currentNode;

  if (selection$1 !== null) {
    let clone = LexicalSelection_1.$cloneWithProperties(currentNode);
    clone = Lexical_1.$isTextNode(clone) && selection$1 != null ? LexicalSelection_1.$sliceSelectedTextNodeContent(selection$1, clone) : clone;
    target = clone;
  }

  const children = Lexical_1.$isElementNode(target) ? target.getChildren() : [];
  const serializedNode = exportNodeToJSON(target); // TODO: TextNode calls getTextContent() (NOT node.__text) within it's exportJSON method
  // which uses getLatest() to get the text from the original node with the same key.
  // This is a deeper issue with the word "clone" here, it's still a reference to the
  // same node as far as the LexicalEditor is concerned since it shares a key.
  // We need a way to create a clone of a Node in memory with it's own key, but
  // until then this hack will work for the selected text extract use case.

  if (Lexical_1.$isTextNode(target)) {
    const text = target.__text; // If an uncollapsed selection ends or starts at the end of a line of specialized,
    // TextNodes, such as code tokens, we will get a 'blank' TextNode here, i.e., one
    // with text of length 0. We don't want this, it makes a confusing mess. Reset!

    if (text.length > 0) {
      serializedNode.text = text;
    } else {
      shouldInclude = false;
    }
  }

  for (let i = 0; i < children.length; i++) {
    const childNode = children[i];
    const shouldIncludeChild = $appendNodesToJSON(editor, selection$1, childNode, serializedNode.children);

    if (!shouldInclude && Lexical_1.$isElementNode(currentNode) && shouldIncludeChild && currentNode.extractWithChild(childNode, selection$1, 'clone')) {
      shouldInclude = true;
    }
  }

  if (shouldInclude && !shouldExclude) {
    targetArray.push(serializedNode);
  } else if (Array.isArray(serializedNode.children)) {
    for (let i = 0; i < serializedNode.children.length; i++) {
      const serializedChildNode = serializedNode.children[i];
      targetArray.push(serializedChildNode);
    }
  }

  return shouldInclude;
} // TODO why $ function with Editor instance?


function $generateJSONFromSelectedNodes$1(editor, selection) {
  const nodes = [];
  const root = Lexical_1.$getRoot();
  const topLevelChildren = root.getChildren();

  for (let i = 0; i < topLevelChildren.length; i++) {
    const topLevelNode = topLevelChildren[i];
    $appendNodesToJSON(editor, selection, topLevelNode, nodes);
  }

  return {
    namespace: editor._config.namespace,
    nodes
  };
}
function $generateNodesFromSerializedNodes$1(serializedNodes) {
  const nodes = [];

  for (let i = 0; i < serializedNodes.length; i++) {
    const serializedNode = serializedNodes[i];
    const node = Lexical_1.$parseSerializedNode(serializedNode);

    if (Lexical_1.$isTextNode(node)) {
      LexicalSelection_1.$addNodeStyle(node);
    }

    nodes.push(node);
  }

  return nodes;
}
const EVENT_LATENCY = 50;
let clipboardEventTimeout = null; // TODO custom selection
// TODO potentially have a node customizable version for plain text

async function copyToClipboard$1(editor, event) {
  if (clipboardEventTimeout !== null) {
    // Prevent weird race conditions that can happen when this function is run multiple times
    // synchronously. In the future, we can do better, we can cancel/override the previously running job.
    return false;
  }

  if (event !== null) {
    return new Promise((resolve, reject) => {
      editor.update(() => {
        resolve($copyToClipboardEvent(editor, event));
      });
    });
  }

  const rootElement = editor.getRootElement();
  const domSelection = document.getSelection();

  if (rootElement === null || domSelection === null) {
    return false;
  }

  const element = document.createElement('span');
  element.style.cssText = 'position: fixed; top: -1000px;';
  element.append(document.createTextNode('#'));
  rootElement.append(element);
  const range = new Range();
  range.setStart(element, 0);
  range.setEnd(element, 1);
  domSelection.removeAllRanges();
  domSelection.addRange(range);
  return new Promise((resolve, reject) => {
    const removeListener = editor.registerCommand(Lexical_1.COPY_COMMAND, secondEvent => {
      if (secondEvent instanceof ClipboardEvent) {
        removeListener();

        if (clipboardEventTimeout !== null) {
          window.clearTimeout(clipboardEventTimeout);
          clipboardEventTimeout = null;
        }

        resolve($copyToClipboardEvent(editor, secondEvent));
      } // Block the entire copy flow while we wait for the next ClipboardEvent


      return true;
    }, Lexical_1.COMMAND_PRIORITY_CRITICAL); // If the above hack execCommand hack works, this timeout code should never fire. Otherwise,
    // the listener will be quickly freed so that the user can reuse it again

    clipboardEventTimeout = window.setTimeout(() => {
      removeListener();
      clipboardEventTimeout = null;
      resolve(false);
    }, EVENT_LATENCY);
    document.execCommand('copy');
    element.remove();
  });
} // TODO shouldn't pass editor (pass namespace directly)

function $copyToClipboardEvent(editor, event) {
  const domSelection = window.getSelection();

  if (!domSelection) {
    return false;
  }

  const anchorDOM = domSelection.anchorNode;
  const focusDOM = domSelection.focusNode;

  if (anchorDOM !== null && focusDOM !== null && !Lexical_1.isSelectionWithinEditor(editor, anchorDOM, focusDOM)) {
    return false;
  }

  event.preventDefault();
  const clipboardData = event.clipboardData;
  const selection = Lexical_1.$getSelection();

  if (clipboardData === null || selection === null) {
    return false;
  }

  const htmlString = $getHtmlContent$1(editor);
  const lexicalString = $getLexicalContent$1(editor);
  let plainString = '';

  if (selection !== null) {
    plainString = selection.getTextContent();
  }

  if (htmlString !== null) {
    clipboardData.setData('text/html', htmlString);
  }

  if (lexicalString !== null) {
    clipboardData.setData('application/x-lexical-editor', lexicalString);
  }

  clipboardData.setData('text/plain', plainString);
  return true;
}

var $generateJSONFromSelectedNodes_1 = $generateJSONFromSelectedNodes$1;
var $generateNodesFromSerializedNodes_1 = $generateNodesFromSerializedNodes$1;
var $getHtmlContent_1 = $getHtmlContent$1;
var $getLexicalContent_1 = $getLexicalContent$1;
var $insertDataTransferForPlainText_1 = $insertDataTransferForPlainText$1;
var $insertDataTransferForRichText_1 = $insertDataTransferForRichText$1;
var $insertGeneratedNodes_1 = $insertGeneratedNodes$1;
var copyToClipboard_1 = copyToClipboard$1;

var LexicalClipboard_dev = {
	$generateJSONFromSelectedNodes: $generateJSONFromSelectedNodes_1,
	$generateNodesFromSerializedNodes: $generateNodesFromSerializedNodes_1,
	$getHtmlContent: $getHtmlContent_1,
	$getLexicalContent: $getLexicalContent_1,
	$insertDataTransferForPlainText: $insertDataTransferForPlainText_1,
	$insertDataTransferForRichText: $insertDataTransferForRichText_1,
	$insertGeneratedNodes: $insertGeneratedNodes_1,
	copyToClipboard: copyToClipboard_1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function z$2(a){throw Error(`Minified Lexical error #${a}; visit https://lexical.dev/docs/error?code=${a} for the full message or `+"use the non-minified dev environment for full errors and additional helpful warnings.");}
function A$3(a){let b=Lexical_1.$getSelection();if(null==b)throw Error("Expected valid LexicalSelection");return Lexical_1.$isRangeSelection(b)&&b.isCollapsed()||0===b.getNodes().length?"":LexicalHtml_1.$generateHtmlFromNodes(a,b)}function B$3(a){let b=Lexical_1.$getSelection();if(null==b)throw Error("Expected valid LexicalSelection");return Lexical_1.$isRangeSelection(b)&&b.isCollapsed()||0===b.getNodes().length?null:JSON.stringify(C$1(a,b))}
function D$1(a,b,c){(Lexical_1.DEPRECATED_$isGridSelection(c)||null!==LexicalUtils_1.$findMatchingParent(c.anchor.getNode(),f=>Lexical_1.DEPRECATED_$isGridCellNode(f))&&null!==LexicalUtils_1.$findMatchingParent(c.focus.getNode(),f=>Lexical_1.DEPRECATED_$isGridCellNode(f)))&&1===b.length&&Lexical_1.DEPRECATED_$isGridNode(b[0])?E$2(b,c,!1,a):H$3(b,c);}
function H$3(a,b){let c=[],f=null;for(let e=0;e<a.length;e++){let g=a[e],h=Lexical_1.$isLineBreakNode(g);if(h||Lexical_1.$isDecoratorNode(g)&&g.isInline()||Lexical_1.$isElementNode(g)&&g.isInline()||Lexical_1.$isTextNode(g)||g.isParentRequired()){if(null===f&&(f=g.createParentElementNode(),c.push(f),h))continue;null!==f&&f.append(g);}else c.push(g),f=null;}Lexical_1.$isRangeSelection(b)?b.insertNodes(c):Lexical_1.DEPRECATED_$isGridSelection(b)&&(a=b.anchor.getNode(),Lexical_1.DEPRECATED_$isGridCellNode(a)||z$2(41),a.append(...c));}
function E$2(a,b,c,f){1===a.length&&Lexical_1.DEPRECATED_$isGridNode(a[0])||z$2(42);var e=a[0];a=e.getChildren();c=e.getFirstChildOrThrow().getChildrenSize();var g=e.getChildrenSize(),h=LexicalUtils_1.$findMatchingParent(b.anchor.getNode(),l=>Lexical_1.DEPRECATED_$isGridCellNode(l));b=(e=h&&LexicalUtils_1.$findMatchingParent(h,l=>Lexical_1.DEPRECATED_$isGridRowNode(l)))&&LexicalUtils_1.$findMatchingParent(e,l=>Lexical_1.DEPRECATED_$isGridNode(l));Lexical_1.DEPRECATED_$isGridCellNode(h)&&Lexical_1.DEPRECATED_$isGridRowNode(e)&&Lexical_1.DEPRECATED_$isGridNode(b)||z$2(43);var k=e.getIndexWithinParent(),
p=Math.min(b.getChildrenSize()-1,k+g-1);g=h.getIndexWithinParent();h=Math.min(e.getChildrenSize()-1,g+c-1);c=Math.min(g,h);e=Math.min(k,p);g=Math.max(g,h);k=Math.max(k,p);p=b.getChildren();h=0;let m,q;for(let l=e;l<=k;l++){var x=p[l];Lexical_1.DEPRECATED_$isGridRowNode(x)||z$2(24);var y=a[h];Lexical_1.DEPRECATED_$isGridRowNode(y)||z$2(24);x=x.getChildren();y=y.getChildren();let F=0;for(let u=c;u<=g;u++){let v=x[u];Lexical_1.DEPRECATED_$isGridCellNode(v)||z$2(25);let G=y[F];Lexical_1.DEPRECATED_$isGridCellNode(G)||z$2(25);l===e&&u===c?m=
v.getKey():l===k&&u===g&&(q=v.getKey());let M=v.getChildren();G.getChildren().forEach(w=>{Lexical_1.$isTextNode(w)&&Lexical_1.$createParagraphNode().append(w);v.append(w);});M.forEach(w=>w.remove());F++;}h++;}m&&q&&(a=Lexical_1.DEPRECATED_$createGridSelection(),a.set(b.getKey(),m,q),Lexical_1.$setSelection(a),f.dispatchCommand(Lexical_1.SELECTION_CHANGE_COMMAND,void 0));}
function I$2(a,b,c,f=[]){let e=null!=b?c.isSelected(b):!0,g=Lexical_1.$isElementNode(c)&&c.excludeFromCopy("html");var h=c;if(null!==b){var k=LexicalSelection_1.$cloneWithProperties(c);h=k=Lexical_1.$isTextNode(k)&&null!=b?LexicalSelection_1.$sliceSelectedTextNodeContent(b,k):k;}let p=Lexical_1.$isElementNode(h)?h.getChildren():[];var m=h;k=m.exportJSON();k.type!==m.constructor.getType()&&z$2(58);var q=k.children;Lexical_1.$isElementNode(m)&&(Array.isArray(q)||z$2(59));Lexical_1.$isTextNode(h)&&(h=h.__text,0<h.length?k.text=h:e=!1);for(h=0;h<p.length;h++)m=p[h],q=I$2(a,b,m,k.children),
!e&&Lexical_1.$isElementNode(c)&&q&&c.extractWithChild(m,b,"clone")&&(e=!0);if(e&&!g)f.push(k);else if(Array.isArray(k.children))for(a=0;a<k.children.length;a++)f.push(k.children[a]);return e}function C$1(a,b){let c=[],f=Lexical_1.$getRoot().getChildren();for(let e=0;e<f.length;e++)I$2(a,b,f[e],c);return {namespace:a._config.namespace,nodes:c}}function J$2(a){let b=[];for(let c=0;c<a.length;c++){let f=Lexical_1.$parseSerializedNode(a[c]);Lexical_1.$isTextNode(f)&&LexicalSelection_1.$addNodeStyle(f);b.push(f);}return b}let K$2=null;
function L$2(a,b){var c=window.getSelection();if(!c)return !1;var f=c.anchorNode;c=c.focusNode;if(null!==f&&null!==c&&!Lexical_1.isSelectionWithinEditor(a,f,c))return !1;b.preventDefault();b=b.clipboardData;f=Lexical_1.$getSelection();if(null===b||null===f)return !1;c=A$3(a);a=B$3(a);let e="";null!==f&&(e=f.getTextContent());null!==c&&b.setData("text/html",c);null!==a&&b.setData("application/x-lexical-editor",a);b.setData("text/plain",e);return !0}var $generateJSONFromSelectedNodes=C$1;
var $generateNodesFromSerializedNodes=J$2;var $getHtmlContent=A$3;var $getLexicalContent=B$3;var $insertDataTransferForPlainText=function(a,b){a=a.getData("text/plain");null!=a&&b.insertRawText(a);};
var $insertDataTransferForRichText=function(a,b,c){var f=a.getData("application/x-lexical-editor");if(f)try{let g=JSON.parse(f);if(g.namespace===c._config.namespace&&Array.isArray(g.nodes)){let h=J$2(g.nodes);return D$1(c,h,b)}}catch{}if(f=a.getData("text/html"))try{var e=(new DOMParser).parseFromString(f,"text/html");let g=LexicalHtml_1.$generateNodesFromDOM(c,e);return D$1(c,g,b)}catch{}a=a.getData("text/plain");if(null!=a)if(Lexical_1.$isRangeSelection(b))for(a=a.split(/\r?\n/),c=a.length,e=0;e<c;e++)b.insertText(a[e]),
e<c-1&&b.insertParagraph();else b.insertRawText(a);};var $insertGeneratedNodes=D$1;
var copyToClipboard=async function(a,b){if(null!==K$2)return !1;if(null!==b)return new Promise(g=>{a.update(()=>{g(L$2(a,b));});});var c=a.getRootElement();let f=document.getSelection();if(null===c||null===f)return !1;let e=document.createElement("span");e.style.cssText="position: fixed; top: -1000px;";e.append(document.createTextNode("#"));c.append(e);c=new Range;c.setStart(e,0);c.setEnd(e,1);f.removeAllRanges();f.addRange(c);return new Promise(g=>{let h=a.registerCommand(Lexical_1.COPY_COMMAND,k=>{k instanceof
ClipboardEvent&&(h(),null!==K$2&&(window.clearTimeout(K$2),K$2=null),g(L$2(a,k)));return !0},Lexical_1.COMMAND_PRIORITY_CRITICAL);K$2=window.setTimeout(()=>{h();K$2=null;g(!1);},50);document.execCommand("copy");e.remove();})};

var LexicalClipboard_prod = {
	$generateJSONFromSelectedNodes: $generateJSONFromSelectedNodes,
	$generateNodesFromSerializedNodes: $generateNodesFromSerializedNodes,
	$getHtmlContent: $getHtmlContent,
	$getLexicalContent: $getLexicalContent,
	$insertDataTransferForPlainText: $insertDataTransferForPlainText,
	$insertDataTransferForRichText: $insertDataTransferForRichText,
	$insertGeneratedNodes: $insertGeneratedNodes,
	copyToClipboard: copyToClipboard
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const LexicalClipboard = process.env.NODE_ENV === 'development' ? LexicalClipboard_dev : LexicalClipboard_prod;
var LexicalClipboard_1 = LexicalClipboard;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */






/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
function caretFromPoint(x, y) {
  if (typeof document.caretRangeFromPoint !== 'undefined') {
    const range = document.caretRangeFromPoint(x, y);

    if (range === null) {
      return null;
    }

    return {
      node: range.startContainer,
      offset: range.startOffset
    }; // @ts-ignore
  } else if (document.caretPositionFromPoint !== 'undefined') {
    // @ts-ignore FF - no types
    const range = document.caretPositionFromPoint(x, y);

    if (range === null) {
      return null;
    }

    return {
      node: range.offsetNode,
      offset: range.offset
    };
  } else {
    // Gracefully handle IE
    return null;
  }
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const CAN_USE_DOM$6 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const documentMode$1 = CAN_USE_DOM$6 && 'documentMode' in document ? document.documentMode : null;
CAN_USE_DOM$6 && /Mac|iPod|iPhone|iPad/.test(navigator.platform);
CAN_USE_DOM$6 && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent);
const CAN_USE_BEFORE_INPUT = CAN_USE_DOM$6 && 'InputEvent' in window && !documentMode$1 ? 'getTargetRanges' in new window.InputEvent('input') : false;
const IS_SAFARI$1 = CAN_USE_DOM$6 && /Version\/[\d.]+.*Safari/.test(navigator.userAgent);
const IS_IOS$1 = CAN_USE_DOM$6 && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream; // Keep these in case we need to use them in the future.
// export const IS_WINDOWS: boolean = CAN_USE_DOM && /Win/.test(navigator.platform);

const IS_CHROME$1 = CAN_USE_DOM$6 && /^(?=.*Chrome).*/i.test(navigator.userAgent); // export const canUseTextInputEvent: boolean = CAN_USE_DOM && 'TextEvent' in window && !documentMode;

const IS_APPLE_WEBKIT$1 = CAN_USE_DOM$6 && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !IS_CHROME$1;

/** @module @lexical/rich-text */
const DRAG_DROP_PASTE$1 = Lexical_1.createCommand('DRAG_DROP_PASTE_FILE');

/** @noInheritDoc */
class QuoteNode$1 extends Lexical_1.ElementNode {
  static getType() {
    return 'quote';
  }

  static clone(node) {
    return new QuoteNode$1(node.__key);
  }

  constructor(key) {
    super(key);
  } // View


  createDOM(config) {
    const element = document.createElement('blockquote');
    LexicalUtils_1.addClassNamesToElement(element, config.theme.quote);
    return element;
  }

  updateDOM(prevNode, dom) {
    return false;
  }

  static importDOM() {
    return {
      blockquote: node => ({
        conversion: convertBlockquoteElement,
        priority: 0
      })
    };
  }

  static importJSON(serializedNode) {
    const node = $createQuoteNode$1();
    node.setFormat(serializedNode.format);
    node.setIndent(serializedNode.indent);
    node.setDirection(serializedNode.direction);
    return node;
  }

  exportJSON() {
    return { ...super.exportJSON(),
      type: 'quote'
    };
  } // Mutation


  insertNewAfter(_, restoreSelection) {
    const newBlock = Lexical_1.$createParagraphNode();
    const direction = this.getDirection();
    newBlock.setDirection(direction);
    this.insertAfter(newBlock, restoreSelection);
    return newBlock;
  }

  collapseAtStart() {
    const paragraph = Lexical_1.$createParagraphNode();
    const children = this.getChildren();
    children.forEach(child => paragraph.append(child));
    this.replace(paragraph);
    return true;
  }

}
function $createQuoteNode$1() {
  return Lexical_1.$applyNodeReplacement(new QuoteNode$1());
}
function $isQuoteNode$1(node) {
  return node instanceof QuoteNode$1;
}

/** @noInheritDoc */
class HeadingNode$1 extends Lexical_1.ElementNode {
  /** @internal */
  static getType() {
    return 'heading';
  }

  static clone(node) {
    return new HeadingNode$1(node.__tag, node.__key);
  }

  constructor(tag, key) {
    super(key);
    this.__tag = tag;
  }

  getTag() {
    return this.__tag;
  } // View


  createDOM(config) {
    const tag = this.__tag;
    const element = document.createElement(tag);
    const theme = config.theme;
    const classNames = theme.heading;

    if (classNames !== undefined) {
      const className = classNames[tag];
      LexicalUtils_1.addClassNamesToElement(element, className);
    }

    return element;
  }

  updateDOM(prevNode, dom) {
    return false;
  }

  static importDOM() {
    return {
      h1: node => ({
        conversion: convertHeadingElement,
        priority: 0
      }),
      h2: node => ({
        conversion: convertHeadingElement,
        priority: 0
      }),
      h3: node => ({
        conversion: convertHeadingElement,
        priority: 0
      }),
      h4: node => ({
        conversion: convertHeadingElement,
        priority: 0
      }),
      h5: node => ({
        conversion: convertHeadingElement,
        priority: 0
      }),
      h6: node => ({
        conversion: convertHeadingElement,
        priority: 0
      }),
      p: node => {
        // domNode is a <p> since we matched it by nodeName
        const paragraph = node;
        const firstChild = paragraph.firstChild;

        if (firstChild !== null && isGoogleDocsTitle(firstChild)) {
          return {
            conversion: () => ({
              node: null
            }),
            priority: 3
          };
        }

        return null;
      },
      span: node => {
        if (isGoogleDocsTitle(node)) {
          return {
            conversion: domNode => {
              return {
                node: $createHeadingNode$1('h1')
              };
            },
            priority: 3
          };
        }

        return null;
      }
    };
  }

  static importJSON(serializedNode) {
    const node = $createHeadingNode$1(serializedNode.tag);
    node.setFormat(serializedNode.format);
    node.setIndent(serializedNode.indent);
    node.setDirection(serializedNode.direction);
    return node;
  }

  exportJSON() {
    return { ...super.exportJSON(),
      tag: this.getTag(),
      type: 'heading',
      version: 1
    };
  } // Mutation


  insertNewAfter(selection, restoreSelection = true) {
    const anchorOffet = selection ? selection.anchor.offset : 0;
    const newElement = anchorOffet > 0 && anchorOffet < this.getTextContentSize() ? $createHeadingNode$1(this.getTag()) : Lexical_1.$createParagraphNode();
    const direction = this.getDirection();
    newElement.setDirection(direction);
    this.insertAfter(newElement, restoreSelection);
    return newElement;
  }

  collapseAtStart() {
    const newElement = !this.isEmpty() ? $createHeadingNode$1(this.getTag()) : Lexical_1.$createParagraphNode();
    const children = this.getChildren();
    children.forEach(child => newElement.append(child));
    this.replace(newElement);
    return true;
  }

  extractWithChild() {
    return true;
  }

}

function isGoogleDocsTitle(domNode) {
  if (domNode.nodeName.toLowerCase() === 'span') {
    return domNode.style.fontSize === '26pt';
  }

  return false;
}

function convertHeadingElement(domNode) {
  const nodeName = domNode.nodeName.toLowerCase();
  let node = null;

  if (nodeName === 'h1' || nodeName === 'h2' || nodeName === 'h3' || nodeName === 'h4' || nodeName === 'h5' || nodeName === 'h6') {
    node = $createHeadingNode$1(nodeName);
  }

  return {
    node
  };
}

function convertBlockquoteElement() {
  const node = $createQuoteNode$1();
  return {
    node
  };
}

function $createHeadingNode$1(headingTag) {
  return Lexical_1.$applyNodeReplacement(new HeadingNode$1(headingTag));
}
function $isHeadingNode$1(node) {
  return node instanceof HeadingNode$1;
}

function onPasteForRichText(event, editor) {
  event.preventDefault();
  editor.update(() => {
    const selection = Lexical_1.$getSelection();
    const clipboardData = event instanceof InputEvent || event instanceof KeyboardEvent ? null : event.clipboardData;

    if (clipboardData != null && (Lexical_1.$isRangeSelection(selection) || Lexical_1.DEPRECATED_$isGridSelection(selection))) {
      LexicalClipboard_1.$insertDataTransferForRichText(clipboardData, selection, editor);
    }
  }, {
    tag: 'paste'
  });
}

async function onCutForRichText(event, editor) {
  await LexicalClipboard_1.copyToClipboard(editor, event instanceof ClipboardEvent ? event : null);
  editor.update(() => {
    const selection = Lexical_1.$getSelection();

    if (Lexical_1.$isRangeSelection(selection)) {
      selection.removeText();
    } else if (Lexical_1.$isNodeSelection(selection)) {
      selection.getNodes().forEach(node => node.remove());
    }
  });
} // Clipboard may contain files that we aren't allowed to read. While the event is arguably useless,
// in certain ocassions, we want to know whether it was a file transfer, as opposed to text. We
// control this with the first boolean flag.


function eventFiles$1(event) {
  let dataTransfer = null;

  if (event instanceof DragEvent) {
    dataTransfer = event.dataTransfer;
  } else if (event instanceof ClipboardEvent) {
    dataTransfer = event.clipboardData;
  }

  if (dataTransfer === null) {
    return [false, [], false];
  }

  const types = dataTransfer.types;
  const hasFiles = types.includes('Files');
  const hasContent = types.includes('text/html') || types.includes('text/plain');
  return [hasFiles, Array.from(dataTransfer.files), hasContent];
}

function handleIndentAndOutdent(insertTab, indentOrOutdent) {
  const selection = Lexical_1.$getSelection();

  if (!Lexical_1.$isRangeSelection(selection)) {
    return;
  }

  const alreadyHandled = new Set();
  const nodes = selection.getNodes();

  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i];
    const key = node.getKey();

    if (alreadyHandled.has(key)) {
      continue;
    }

    const parentBlock = LexicalUtils_1.$getNearestBlockElementAncestorOrThrow(node);
    const parentKey = parentBlock.getKey();

    if (parentBlock.canInsertTab()) {
      insertTab(node);
      alreadyHandled.add(key);
    } else if (parentBlock.canIndent() && !alreadyHandled.has(parentKey)) {
      alreadyHandled.add(parentKey);
      indentOrOutdent(parentBlock);
    }
  }
}

function $isTargetWithinDecorator(target) {
  const node = Lexical_1.$getNearestNodeFromDOMNode(target);
  return Lexical_1.$isDecoratorNode(node);
}

function $isSelectionAtEndOfRoot(selection) {
  const focus = selection.focus;
  return focus.key === 'root' && focus.offset === Lexical_1.$getRoot().getChildrenSize();
}

function registerRichText$1(editor) {
  const removeListener = LexicalUtils_1.mergeRegister(editor.registerCommand(Lexical_1.CLICK_COMMAND, payload => {
    const selection = Lexical_1.$getSelection();

    if (Lexical_1.$isNodeSelection(selection)) {
      selection.clear();
      return true;
    }

    return false;
  }, 0), editor.registerCommand(Lexical_1.DELETE_CHARACTER_COMMAND, isBackward => {
    const selection = Lexical_1.$getSelection();

    if (!Lexical_1.$isRangeSelection(selection)) {
      return false;
    }

    selection.deleteCharacter(isBackward);
    return true;
  }, Lexical_1.COMMAND_PRIORITY_EDITOR), editor.registerCommand(Lexical_1.DELETE_WORD_COMMAND, isBackward => {
    const selection = Lexical_1.$getSelection();

    if (!Lexical_1.$isRangeSelection(selection)) {
      return false;
    }

    selection.deleteWord(isBackward);
    return true;
  }, Lexical_1.COMMAND_PRIORITY_EDITOR), editor.registerCommand(Lexical_1.DELETE_LINE_COMMAND, isBackward => {
    const selection = Lexical_1.$getSelection();

    if (!Lexical_1.$isRangeSelection(selection)) {
      return false;
    }

    selection.deleteLine(isBackward);
    return true;
  }, Lexical_1.COMMAND_PRIORITY_EDITOR), editor.registerCommand(Lexical_1.CONTROLLED_TEXT_INSERTION_COMMAND, eventOrText => {
    const selection = Lexical_1.$getSelection();

    if (typeof eventOrText === 'string') {
      if (Lexical_1.$isRangeSelection(selection)) {
        selection.insertText(eventOrText);
      }
    } else {
      if (!Lexical_1.$isRangeSelection(selection) && !Lexical_1.DEPRECATED_$isGridSelection(selection)) {
        return false;
      }

      const dataTransfer = eventOrText.dataTransfer;

      if (dataTransfer != null) {
        LexicalClipboard_1.$insertDataTransferForRichText(dataTransfer, selection, editor);
      } else if (Lexical_1.$isRangeSelection(selection)) {
        const data = eventOrText.data;

        if (data) {
          selection.insertText(data);
        }

        return true;
      }
    }

    return true;
  }, Lexical_1.COMMAND_PRIORITY_EDITOR), editor.registerCommand(Lexical_1.REMOVE_TEXT_COMMAND, () => {
    const selection = Lexical_1.$getSelection();

    if (!Lexical_1.$isRangeSelection(selection)) {
      return false;
    }

    selection.removeText();
    return true;
  }, Lexical_1.COMMAND_PRIORITY_EDITOR), editor.registerCommand(Lexical_1.FORMAT_TEXT_COMMAND, format => {
    const selection = Lexical_1.$getSelection();

    if (!Lexical_1.$isRangeSelection(selection)) {
      return false;
    }

    selection.formatText(format);
    return true;
  }, Lexical_1.COMMAND_PRIORITY_EDITOR), editor.registerCommand(Lexical_1.FORMAT_ELEMENT_COMMAND, format => {
    const selection = Lexical_1.$getSelection();

    if (!Lexical_1.$isRangeSelection(selection) && !Lexical_1.$isNodeSelection(selection)) {
      return false;
    }

    const nodes = selection.getNodes();

    for (const node of nodes) {
      const element = LexicalUtils_1.$getNearestBlockElementAncestorOrThrow(node);
      element.setFormat(format);
    }

    return true;
  }, Lexical_1.COMMAND_PRIORITY_EDITOR), editor.registerCommand(Lexical_1.INSERT_LINE_BREAK_COMMAND, selectStart => {
    const selection = Lexical_1.$getSelection();

    if (!Lexical_1.$isRangeSelection(selection)) {
      return false;
    }

    selection.insertLineBreak(selectStart);
    return true;
  }, Lexical_1.COMMAND_PRIORITY_EDITOR), editor.registerCommand(Lexical_1.INSERT_PARAGRAPH_COMMAND, () => {
    const selection = Lexical_1.$getSelection();

    if (!Lexical_1.$isRangeSelection(selection)) {
      return false;
    }

    selection.insertParagraph();
    return true;
  }, Lexical_1.COMMAND_PRIORITY_EDITOR), editor.registerCommand(Lexical_1.INDENT_CONTENT_COMMAND, () => {
    handleIndentAndOutdent(() => {
      editor.dispatchCommand(Lexical_1.CONTROLLED_TEXT_INSERTION_COMMAND, '\t');
    }, block => {
      const indent = block.getIndent();

      if (indent !== 10) {
        block.setIndent(indent + 1);
      }
    });
    return true;
  }, Lexical_1.COMMAND_PRIORITY_EDITOR), editor.registerCommand(Lexical_1.OUTDENT_CONTENT_COMMAND, () => {
    handleIndentAndOutdent(node => {
      if (Lexical_1.$isTextNode(node)) {
        const textContent = node.getTextContent();
        const character = textContent[textContent.length - 1];

        if (character === '\t') {
          editor.dispatchCommand(Lexical_1.DELETE_CHARACTER_COMMAND, true);
        }
      }
    }, block => {
      const indent = block.getIndent();

      if (indent !== 0) {
        block.setIndent(indent - 1);
      }
    });
    return true;
  }, Lexical_1.COMMAND_PRIORITY_EDITOR), editor.registerCommand(Lexical_1.KEY_ARROW_UP_COMMAND, event => {
    const selection = Lexical_1.$getSelection();

    if (Lexical_1.$isNodeSelection(selection) && !$isTargetWithinDecorator(event.target)) {
      // If selection is on a node, let's try and move selection
      // back to being a range selection.
      const nodes = selection.getNodes();

      if (nodes.length > 0) {
        nodes[0].selectPrevious();
        return true;
      }
    } else if (Lexical_1.$isRangeSelection(selection)) {
      const possibleNode = Lexical_1.$getAdjacentNode(selection.focus, true);

      if (Lexical_1.$isDecoratorNode(possibleNode) && !possibleNode.isIsolated() && !possibleNode.isInline()) {
        possibleNode.selectPrevious();
        event.preventDefault();
        return true;
      } else if (Lexical_1.$isElementNode(possibleNode) && !possibleNode.isInline() && !possibleNode.canBeEmpty()) {
        possibleNode.select();
        event.preventDefault();
        return true;
      }
    }

    return false;
  }, Lexical_1.COMMAND_PRIORITY_EDITOR), editor.registerCommand(Lexical_1.KEY_ARROW_DOWN_COMMAND, event => {
    const selection = Lexical_1.$getSelection();

    if (Lexical_1.$isNodeSelection(selection)) {
      // If selection is on a node, let's try and move selection
      // back to being a range selection.
      const nodes = selection.getNodes();

      if (nodes.length > 0) {
        nodes[0].selectNext(0, 0);
        return true;
      }
    } else if (Lexical_1.$isRangeSelection(selection)) {
      if ($isSelectionAtEndOfRoot(selection)) {
        event.preventDefault();
        return true;
      }

      const possibleNode = Lexical_1.$getAdjacentNode(selection.focus, false);

      if (Lexical_1.$isDecoratorNode(possibleNode) && !possibleNode.isIsolated() && !possibleNode.isInline()) {
        possibleNode.selectNext();
        event.preventDefault();
        return true;
      }
    }

    return false;
  }, Lexical_1.COMMAND_PRIORITY_EDITOR), editor.registerCommand(Lexical_1.KEY_ARROW_LEFT_COMMAND, event => {
    const selection$1 = Lexical_1.$getSelection();

    if (Lexical_1.$isNodeSelection(selection$1)) {
      // If selection is on a node, let's try and move selection
      // back to being a range selection.
      const nodes = selection$1.getNodes();

      if (nodes.length > 0) {
        event.preventDefault();
        nodes[0].selectPrevious();
        return true;
      }
    }

    if (!Lexical_1.$isRangeSelection(selection$1)) {
      return false;
    }

    if (LexicalSelection_1.$shouldOverrideDefaultCharacterSelection(selection$1, true)) {
      const isHoldingShift = event.shiftKey;
      event.preventDefault();
      LexicalSelection_1.$moveCharacter(selection$1, isHoldingShift, true);
      return true;
    }

    return false;
  }, Lexical_1.COMMAND_PRIORITY_EDITOR), editor.registerCommand(Lexical_1.KEY_ARROW_RIGHT_COMMAND, event => {
    const selection$1 = Lexical_1.$getSelection();

    if (Lexical_1.$isNodeSelection(selection$1) && !$isTargetWithinDecorator(event.target)) {
      // If selection is on a node, let's try and move selection
      // back to being a range selection.
      const nodes = selection$1.getNodes();

      if (nodes.length > 0) {
        event.preventDefault();
        nodes[0].selectNext(0, 0);
        return true;
      }
    }

    if (!Lexical_1.$isRangeSelection(selection$1)) {
      return false;
    }

    const isHoldingShift = event.shiftKey;

    if (LexicalSelection_1.$shouldOverrideDefaultCharacterSelection(selection$1, false)) {
      event.preventDefault();
      LexicalSelection_1.$moveCharacter(selection$1, isHoldingShift, false);
      return true;
    }

    return false;
  }, Lexical_1.COMMAND_PRIORITY_EDITOR), editor.registerCommand(Lexical_1.KEY_BACKSPACE_COMMAND, event => {
    if ($isTargetWithinDecorator(event.target)) {
      return false;
    }

    const selection = Lexical_1.$getSelection();

    if (!Lexical_1.$isRangeSelection(selection)) {
      return false;
    }

    event.preventDefault();
    const {
      anchor
    } = selection;
    const anchorNode = anchor.getNode();

    if (selection.isCollapsed() && anchor.offset === 0 && !Lexical_1.$isRootNode(anchorNode)) {
      const element = LexicalUtils_1.$getNearestBlockElementAncestorOrThrow(anchorNode);

      if (element.getIndent() > 0) {
        return editor.dispatchCommand(Lexical_1.OUTDENT_CONTENT_COMMAND, undefined);
      }
    }

    return editor.dispatchCommand(Lexical_1.DELETE_CHARACTER_COMMAND, true);
  }, Lexical_1.COMMAND_PRIORITY_EDITOR), editor.registerCommand(Lexical_1.KEY_DELETE_COMMAND, event => {
    if ($isTargetWithinDecorator(event.target)) {
      return false;
    }

    const selection = Lexical_1.$getSelection();

    if (!Lexical_1.$isRangeSelection(selection)) {
      return false;
    }

    event.preventDefault();
    return editor.dispatchCommand(Lexical_1.DELETE_CHARACTER_COMMAND, false);
  }, Lexical_1.COMMAND_PRIORITY_EDITOR), editor.registerCommand(Lexical_1.KEY_ENTER_COMMAND, event => {
    const selection = Lexical_1.$getSelection();

    if (!Lexical_1.$isRangeSelection(selection)) {
      return false;
    }

    if (event !== null) {
      // If we have beforeinput, then we can avoid blocking
      // the default behavior. This ensures that the iOS can
      // intercept that we're actually inserting a paragraph,
      // and autocomplete, autocapitalize etc work as intended.
      // This can also cause a strange performance issue in
      // Safari, where there is a noticeable pause due to
      // preventing the key down of enter.
      if ((IS_IOS$1 || IS_SAFARI$1 || IS_APPLE_WEBKIT$1) && CAN_USE_BEFORE_INPUT) {
        return false;
      }

      event.preventDefault();

      if (event.shiftKey) {
        return editor.dispatchCommand(Lexical_1.INSERT_LINE_BREAK_COMMAND, false);
      }
    }

    return editor.dispatchCommand(Lexical_1.INSERT_PARAGRAPH_COMMAND, undefined);
  }, Lexical_1.COMMAND_PRIORITY_EDITOR), editor.registerCommand(Lexical_1.KEY_ESCAPE_COMMAND, () => {
    const selection = Lexical_1.$getSelection();

    if (!Lexical_1.$isRangeSelection(selection)) {
      return false;
    }

    editor.blur();
    return true;
  }, Lexical_1.COMMAND_PRIORITY_EDITOR), editor.registerCommand(Lexical_1.DROP_COMMAND, event => {
    const [, files] = eventFiles$1(event);

    if (files.length > 0) {
      const x = event.clientX;
      const y = event.clientY;
      const eventRange = caretFromPoint(x, y);

      if (eventRange !== null) {
        const {
          offset: domOffset,
          node: domNode
        } = eventRange;
        const node = Lexical_1.$getNearestNodeFromDOMNode(domNode);

        if (node !== null) {
          const selection = Lexical_1.$createRangeSelection();

          if (Lexical_1.$isTextNode(node)) {
            selection.anchor.set(node.getKey(), domOffset, 'text');
            selection.focus.set(node.getKey(), domOffset, 'text');
          } else {
            const parentKey = node.getParentOrThrow().getKey();
            const offset = node.getIndexWithinParent() + 1;
            selection.anchor.set(parentKey, offset, 'element');
            selection.focus.set(parentKey, offset, 'element');
          }

          const normalizedSelection = Lexical_1.$normalizeSelection__EXPERIMENTAL(selection);
          Lexical_1.$setSelection(normalizedSelection);
        }

        editor.dispatchCommand(DRAG_DROP_PASTE$1, files);
      }

      event.preventDefault();
      return true;
    }

    const selection = Lexical_1.$getSelection();

    if (Lexical_1.$isRangeSelection(selection)) {
      return true;
    }

    return false;
  }, Lexical_1.COMMAND_PRIORITY_EDITOR), editor.registerCommand(Lexical_1.DRAGSTART_COMMAND, event => {
    const [isFileTransfer] = eventFiles$1(event);
    const selection = Lexical_1.$getSelection();

    if (isFileTransfer && !Lexical_1.$isRangeSelection(selection)) {
      return false;
    }

    return true;
  }, Lexical_1.COMMAND_PRIORITY_EDITOR), editor.registerCommand(Lexical_1.DRAGOVER_COMMAND, event => {
    const [isFileTransfer] = eventFiles$1(event);
    const selection = Lexical_1.$getSelection();

    if (isFileTransfer && !Lexical_1.$isRangeSelection(selection)) {
      return false;
    }

    const x = event.clientX;
    const y = event.clientY;
    const eventRange = caretFromPoint(x, y);

    if (eventRange !== null) {
      const node = Lexical_1.$getNearestNodeFromDOMNode(eventRange.node);

      if (Lexical_1.$isDecoratorNode(node)) {
        // Show browser caret as the user is dragging the media across the screen. Won't work
        // for DecoratorNode nor it's relevant.
        event.preventDefault();
      }
    }

    return true;
  }, Lexical_1.COMMAND_PRIORITY_EDITOR), editor.registerCommand(Lexical_1.COPY_COMMAND, event => {
    LexicalClipboard_1.copyToClipboard(editor, event instanceof ClipboardEvent ? event : null);
    return true;
  }, Lexical_1.COMMAND_PRIORITY_EDITOR), editor.registerCommand(Lexical_1.CUT_COMMAND, event => {
    onCutForRichText(event, editor);
    return true;
  }, Lexical_1.COMMAND_PRIORITY_EDITOR), editor.registerCommand(Lexical_1.PASTE_COMMAND, event => {
    const [, files, hasTextContent] = eventFiles$1(event);

    if (files.length > 0 && !hasTextContent) {
      editor.dispatchCommand(DRAG_DROP_PASTE$1, files);
      return true;
    } // if inputs then paste within the input ignore creating a new node on paste event


    if (Lexical_1.isSelectionCapturedInDecoratorInput(event.target)) {
      return false;
    }

    const selection = Lexical_1.$getSelection();

    if (Lexical_1.$isRangeSelection(selection) || Lexical_1.DEPRECATED_$isGridSelection(selection)) {
      onPasteForRichText(event, editor);
      return true;
    }

    return false;
  }, Lexical_1.COMMAND_PRIORITY_EDITOR));
  return removeListener;
}

var $createHeadingNode_1 = $createHeadingNode$1;
var $createQuoteNode_1 = $createQuoteNode$1;
var $isHeadingNode_1 = $isHeadingNode$1;
var $isQuoteNode_1 = $isQuoteNode$1;
var DRAG_DROP_PASTE_1 = DRAG_DROP_PASTE$1;
var HeadingNode_1 = HeadingNode$1;
var QuoteNode_1 = QuoteNode$1;
var eventFiles_1 = eventFiles$1;
var registerRichText_1 = registerRichText$1;

var LexicalRichText_dev = {
	$createHeadingNode: $createHeadingNode_1,
	$createQuoteNode: $createQuoteNode_1,
	$isHeadingNode: $isHeadingNode_1,
	$isQuoteNode: $isQuoteNode_1,
	DRAG_DROP_PASTE: DRAG_DROP_PASTE_1,
	HeadingNode: HeadingNode_1,
	QuoteNode: QuoteNode_1,
	eventFiles: eventFiles_1,
	registerRichText: registerRichText_1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function m$3(c,b){return "undefined"!==typeof document.caretRangeFromPoint?(c=document.caretRangeFromPoint(c,b),null===c?null:{node:c.startContainer,offset:c.startOffset}):"undefined"!==document.caretPositionFromPoint?(c=document.caretPositionFromPoint(c,b),null===c?null:{node:c.offsetNode,offset:c.offset}):null}
let p$3="undefined"!==typeof window&&"undefined"!==typeof window.document&&"undefined"!==typeof window.document.createElement,q$3=p$3&&"documentMode"in document?document.documentMode:null;p$3&&/Mac|iPod|iPhone|iPad/.test(navigator.platform);p$3&&/^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent);
let r$5=p$3&&"InputEvent"in window&&!q$3?"getTargetRanges"in new window.InputEvent("input"):!1,t$3=p$3&&/Version\/[\d.]+.*Safari/.test(navigator.userAgent),u$4=p$3&&/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,w$2=p$3&&/^(?=.*Chrome).*/i.test(navigator.userAgent),x$1=p$3&&/AppleWebKit\/[\d.]+/.test(navigator.userAgent)&&!w$2,y$1=Lexical_1.createCommand("DRAG_DROP_PASTE_FILE");
class z$1 extends Lexical_1.ElementNode{static getType(){return "quote"}static clone(c){return new z$1(c.__key)}constructor(c){super(c);}createDOM(c){let b=document.createElement("blockquote");LexicalUtils_1.addClassNamesToElement(b,c.theme.quote);return b}updateDOM(){return !1}static importDOM(){return {blockquote:()=>({conversion:A$2,priority:0})}}static importJSON(c){let b=B$2();b.setFormat(c.format);b.setIndent(c.indent);b.setDirection(c.direction);return b}exportJSON(){return {...super.exportJSON(),type:"quote"}}insertNewAfter(c,
b){c=Lexical_1.$createParagraphNode();let d=this.getDirection();c.setDirection(d);this.insertAfter(c,b);return c}collapseAtStart(){let c=Lexical_1.$createParagraphNode();this.getChildren().forEach(b=>c.append(b));this.replace(c);return !0}}function B$2(){return Lexical_1.$applyNodeReplacement(new z$1)}
class D extends Lexical_1.ElementNode{static getType(){return "heading"}static clone(c){return new D(c.__tag,c.__key)}constructor(c,b){super(b);this.__tag=c;}getTag(){return this.__tag}createDOM(c){let b=this.__tag,d=document.createElement(b);c=c.theme.heading;void 0!==c&&LexicalUtils_1.addClassNamesToElement(d,c[b]);return d}updateDOM(){return !1}static importDOM(){return {h1:()=>({conversion:E$1,priority:0}),h2:()=>({conversion:E$1,priority:0}),h3:()=>({conversion:E$1,priority:0}),h4:()=>({conversion:E$1,priority:0}),h5:()=>({conversion:E$1,
priority:0}),h6:()=>({conversion:E$1,priority:0}),p:c=>{c=c.firstChild;return null!==c&&F$1(c)?{conversion:()=>({node:null}),priority:3}:null},span:c=>F$1(c)?{conversion:()=>({node:G$1("h1")}),priority:3}:null}}static importJSON(c){let b=G$1(c.tag);b.setFormat(c.format);b.setIndent(c.indent);b.setDirection(c.direction);return b}exportJSON(){return {...super.exportJSON(),tag:this.getTag(),type:"heading",version:1}}insertNewAfter(c,b=!0){c=c?c.anchor.offset:0;c=0<c&&c<this.getTextContentSize()?G$1(this.getTag()):
Lexical_1.$createParagraphNode();let d=this.getDirection();c.setDirection(d);this.insertAfter(c,b);return c}collapseAtStart(){let c=this.isEmpty()?Lexical_1.$createParagraphNode():G$1(this.getTag());this.getChildren().forEach(b=>c.append(b));this.replace(c);return !0}extractWithChild(){return !0}}function F$1(c){return "span"===c.nodeName.toLowerCase()?"26pt"===c.style.fontSize:!1}function E$1(c){c=c.nodeName.toLowerCase();let b=null;if("h1"===c||"h2"===c||"h3"===c||"h4"===c||"h5"===c||"h6"===c)b=G$1(c);return {node:b}}
function A$2(){return {node:B$2()}}function G$1(c){return Lexical_1.$applyNodeReplacement(new D(c))}function H$2(c,b){c.preventDefault();b.update(()=>{let d=Lexical_1.$getSelection(),e=c instanceof InputEvent||c instanceof KeyboardEvent?null:c.clipboardData;null!=e&&(Lexical_1.$isRangeSelection(d)||Lexical_1.DEPRECATED_$isGridSelection(d))&&LexicalClipboard_1.$insertDataTransferForRichText(e,d,b);},{tag:"paste"});}
async function I$1(c,b){await LexicalClipboard_1.copyToClipboard(b,c instanceof ClipboardEvent?c:null);b.update(()=>{let d=Lexical_1.$getSelection();Lexical_1.$isRangeSelection(d)?d.removeText():Lexical_1.$isNodeSelection(d)&&d.getNodes().forEach(e=>e.remove());});}function J$1(c){let b=null;c instanceof DragEvent?b=c.dataTransfer:c instanceof ClipboardEvent&&(b=c.clipboardData);if(null===b)return [!1,[],!1];var d=b.types;c=d.includes("Files");d=d.includes("text/html")||d.includes("text/plain");return [c,Array.from(b.files),d]}
function K$1(c,b){var d=Lexical_1.$getSelection();if(Lexical_1.$isRangeSelection(d)){var e=new Set;d=d.getNodes();for(let f=0;f<d.length;f++){let n=d[f],v=n.getKey();if(e.has(v))continue;let h=LexicalUtils_1.$getNearestBlockElementAncestorOrThrow(n),C=h.getKey();h.canInsertTab()?(c(n),e.add(v)):h.canIndent()&&!e.has(C)&&(e.add(C),b(h));}}}function L$1(c){c=Lexical_1.$getNearestNodeFromDOMNode(c);return Lexical_1.$isDecoratorNode(c)}var $createHeadingNode=G$1;var $createQuoteNode=B$2;var $isHeadingNode=function(c){return c instanceof D};
var $isQuoteNode=function(c){return c instanceof z$1};var DRAG_DROP_PASTE=y$1;var HeadingNode=D;var QuoteNode=z$1;var eventFiles=J$1;
var registerRichText=function(c){return LexicalUtils_1.mergeRegister(c.registerCommand(Lexical_1.CLICK_COMMAND,()=>{const b=Lexical_1.$getSelection();return Lexical_1.$isNodeSelection(b)?(b.clear(),!0):!1},0),c.registerCommand(Lexical_1.DELETE_CHARACTER_COMMAND,b=>{const d=Lexical_1.$getSelection();if(!Lexical_1.$isRangeSelection(d))return !1;d.deleteCharacter(b);return !0},Lexical_1.COMMAND_PRIORITY_EDITOR),c.registerCommand(Lexical_1.DELETE_WORD_COMMAND,b=>{const d=Lexical_1.$getSelection();if(!Lexical_1.$isRangeSelection(d))return !1;d.deleteWord(b);return !0},Lexical_1.COMMAND_PRIORITY_EDITOR),
c.registerCommand(Lexical_1.DELETE_LINE_COMMAND,b=>{const d=Lexical_1.$getSelection();if(!Lexical_1.$isRangeSelection(d))return !1;d.deleteLine(b);return !0},Lexical_1.COMMAND_PRIORITY_EDITOR),c.registerCommand(Lexical_1.CONTROLLED_TEXT_INSERTION_COMMAND,b=>{const d=Lexical_1.$getSelection();if("string"===typeof b)Lexical_1.$isRangeSelection(d)?d.insertText(b):Lexical_1.DEPRECATED_$isGridSelection(d);else {if(!Lexical_1.$isRangeSelection(d)&&!Lexical_1.DEPRECATED_$isGridSelection(d))return !1;const e=b.dataTransfer;null!=e?LexicalClipboard_1.$insertDataTransferForRichText(e,d,c):Lexical_1.$isRangeSelection(d)&&
(b=b.data)&&d.insertText(b);}return !0},Lexical_1.COMMAND_PRIORITY_EDITOR),c.registerCommand(Lexical_1.REMOVE_TEXT_COMMAND,()=>{const b=Lexical_1.$getSelection();if(!Lexical_1.$isRangeSelection(b))return !1;b.removeText();return !0},Lexical_1.COMMAND_PRIORITY_EDITOR),c.registerCommand(Lexical_1.FORMAT_TEXT_COMMAND,b=>{const d=Lexical_1.$getSelection();if(!Lexical_1.$isRangeSelection(d))return !1;d.formatText(b);return !0},Lexical_1.COMMAND_PRIORITY_EDITOR),c.registerCommand(Lexical_1.FORMAT_ELEMENT_COMMAND,b=>{var d=Lexical_1.$getSelection();if(!Lexical_1.$isRangeSelection(d)&&!Lexical_1.$isNodeSelection(d))return !1;
d=d.getNodes();for(const e of d)LexicalUtils_1.$getNearestBlockElementAncestorOrThrow(e).setFormat(b);return !0},Lexical_1.COMMAND_PRIORITY_EDITOR),c.registerCommand(Lexical_1.INSERT_LINE_BREAK_COMMAND,b=>{const d=Lexical_1.$getSelection();if(!Lexical_1.$isRangeSelection(d))return !1;d.insertLineBreak(b);return !0},Lexical_1.COMMAND_PRIORITY_EDITOR),c.registerCommand(Lexical_1.INSERT_PARAGRAPH_COMMAND,()=>{const b=Lexical_1.$getSelection();if(!Lexical_1.$isRangeSelection(b))return !1;b.insertParagraph();return !0},Lexical_1.COMMAND_PRIORITY_EDITOR),c.registerCommand(Lexical_1.INDENT_CONTENT_COMMAND,
()=>{K$1(()=>{c.dispatchCommand(Lexical_1.CONTROLLED_TEXT_INSERTION_COMMAND,"\t");},b=>{const d=b.getIndent();10!==d&&b.setIndent(d+1);});return !0},Lexical_1.COMMAND_PRIORITY_EDITOR),c.registerCommand(Lexical_1.OUTDENT_CONTENT_COMMAND,()=>{K$1(b=>{Lexical_1.$isTextNode(b)&&(b=b.getTextContent(),"\t"===b[b.length-1]&&c.dispatchCommand(Lexical_1.DELETE_CHARACTER_COMMAND,!0));},b=>{const d=b.getIndent();0!==d&&b.setIndent(d-1);});return !0},Lexical_1.COMMAND_PRIORITY_EDITOR),c.registerCommand(Lexical_1.KEY_ARROW_UP_COMMAND,b=>{var d=Lexical_1.$getSelection();if(Lexical_1.$isNodeSelection(d)&&
!L$1(b.target)){if(b=d.getNodes(),0<b.length)return b[0].selectPrevious(),!0}else if(Lexical_1.$isRangeSelection(d)){d=Lexical_1.$getAdjacentNode(d.focus,!0);if(Lexical_1.$isDecoratorNode(d)&&!d.isIsolated()&&!d.isInline())return d.selectPrevious(),b.preventDefault(),!0;if(Lexical_1.$isElementNode(d)&&!d.isInline()&&!d.canBeEmpty())return d.select(),b.preventDefault(),!0}return !1},Lexical_1.COMMAND_PRIORITY_EDITOR),c.registerCommand(Lexical_1.KEY_ARROW_DOWN_COMMAND,b=>{var d=Lexical_1.$getSelection();if(Lexical_1.$isNodeSelection(d)){if(b=d.getNodes(),0<b.length)return b[0].selectNext(0,
0),!0}else if(Lexical_1.$isRangeSelection(d)){let e=d.focus;if("root"===e.key&&e.offset===Lexical_1.$getRoot().getChildrenSize())return b.preventDefault(),!0;d=Lexical_1.$getAdjacentNode(d.focus,!1);if(Lexical_1.$isDecoratorNode(d)&&!d.isIsolated()&&!d.isInline())return d.selectNext(),b.preventDefault(),!0}return !1},Lexical_1.COMMAND_PRIORITY_EDITOR),c.registerCommand(Lexical_1.KEY_ARROW_LEFT_COMMAND,b=>{const d=Lexical_1.$getSelection();if(Lexical_1.$isNodeSelection(d)){var e=d.getNodes();if(0<e.length)return b.preventDefault(),e[0].selectPrevious(),!0}return Lexical_1.$isRangeSelection(d)?
LexicalSelection_1.$shouldOverrideDefaultCharacterSelection(d,!0)?(e=b.shiftKey,b.preventDefault(),LexicalSelection_1.$moveCharacter(d,e,!0),!0):!1:!1},Lexical_1.COMMAND_PRIORITY_EDITOR),c.registerCommand(Lexical_1.KEY_ARROW_RIGHT_COMMAND,b=>{const d=Lexical_1.$getSelection();if(Lexical_1.$isNodeSelection(d)&&!L$1(b.target)){var e=d.getNodes();if(0<e.length)return b.preventDefault(),e[0].selectNext(0,0),!0}if(!Lexical_1.$isRangeSelection(d))return !1;e=b.shiftKey;return LexicalSelection_1.$shouldOverrideDefaultCharacterSelection(d,!1)?(b.preventDefault(),LexicalSelection_1.$moveCharacter(d,e,!1),!0):!1},Lexical_1.COMMAND_PRIORITY_EDITOR),
c.registerCommand(Lexical_1.KEY_BACKSPACE_COMMAND,b=>{if(L$1(b.target))return !1;const d=Lexical_1.$getSelection();if(!Lexical_1.$isRangeSelection(d))return !1;b.preventDefault();({anchor:b}=d);const e=b.getNode();return d.isCollapsed()&&0===b.offset&&!Lexical_1.$isRootNode(e)&&0<LexicalUtils_1.$getNearestBlockElementAncestorOrThrow(e).getIndent()?c.dispatchCommand(Lexical_1.OUTDENT_CONTENT_COMMAND,void 0):c.dispatchCommand(Lexical_1.DELETE_CHARACTER_COMMAND,!0)},Lexical_1.COMMAND_PRIORITY_EDITOR),c.registerCommand(Lexical_1.KEY_DELETE_COMMAND,b=>{if(L$1(b.target))return !1;const d=
Lexical_1.$getSelection();if(!Lexical_1.$isRangeSelection(d))return !1;b.preventDefault();return c.dispatchCommand(Lexical_1.DELETE_CHARACTER_COMMAND,!1)},Lexical_1.COMMAND_PRIORITY_EDITOR),c.registerCommand(Lexical_1.KEY_ENTER_COMMAND,b=>{const d=Lexical_1.$getSelection();if(!Lexical_1.$isRangeSelection(d))return !1;if(null!==b){if((u$4||t$3||x$1)&&r$5)return !1;b.preventDefault();if(b.shiftKey)return c.dispatchCommand(Lexical_1.INSERT_LINE_BREAK_COMMAND,!1)}return c.dispatchCommand(Lexical_1.INSERT_PARAGRAPH_COMMAND,void 0)},Lexical_1.COMMAND_PRIORITY_EDITOR),c.registerCommand(Lexical_1.KEY_ESCAPE_COMMAND,
()=>{const b=Lexical_1.$getSelection();if(!Lexical_1.$isRangeSelection(b))return !1;c.blur();return !0},Lexical_1.COMMAND_PRIORITY_EDITOR),c.registerCommand(Lexical_1.DROP_COMMAND,b=>{const [,d]=J$1(b);if(0<d.length){var e=m$3(b.clientX,b.clientY);if(null!==e){const {offset:n,node:v}=e;var f=Lexical_1.$getNearestNodeFromDOMNode(v);if(null!==f){e=Lexical_1.$createRangeSelection();if(Lexical_1.$isTextNode(f))e.anchor.set(f.getKey(),n,"text"),e.focus.set(f.getKey(),n,"text");else {const h=f.getParentOrThrow().getKey();f=f.getIndexWithinParent()+1;e.anchor.set(h,
f,"element");e.focus.set(h,f,"element");}e=Lexical_1.$normalizeSelection__EXPERIMENTAL(e);Lexical_1.$setSelection(e);}c.dispatchCommand(y$1,d);}b.preventDefault();return !0}b=Lexical_1.$getSelection();return Lexical_1.$isRangeSelection(b)?!0:!1},Lexical_1.COMMAND_PRIORITY_EDITOR),c.registerCommand(Lexical_1.DRAGSTART_COMMAND,b=>{[b]=J$1(b);const d=Lexical_1.$getSelection();return b&&!Lexical_1.$isRangeSelection(d)?!1:!0},Lexical_1.COMMAND_PRIORITY_EDITOR),c.registerCommand(Lexical_1.DRAGOVER_COMMAND,b=>{var [d]=J$1(b);const e=Lexical_1.$getSelection();if(d&&!Lexical_1.$isRangeSelection(e))return !1;d=
m$3(b.clientX,b.clientY);null!==d&&(d=Lexical_1.$getNearestNodeFromDOMNode(d.node),Lexical_1.$isDecoratorNode(d)&&b.preventDefault());return !0},Lexical_1.COMMAND_PRIORITY_EDITOR),c.registerCommand(Lexical_1.COPY_COMMAND,b=>{LexicalClipboard_1.copyToClipboard(c,b instanceof ClipboardEvent?b:null);return !0},Lexical_1.COMMAND_PRIORITY_EDITOR),c.registerCommand(Lexical_1.CUT_COMMAND,b=>{I$1(b,c);return !0},Lexical_1.COMMAND_PRIORITY_EDITOR),c.registerCommand(Lexical_1.PASTE_COMMAND,b=>{const [,d,e]=J$1(b);if(0<d.length&&!e)return c.dispatchCommand(y$1,d),!0;if(Lexical_1.isSelectionCapturedInDecoratorInput(b.target))return !1;
const f=Lexical_1.$getSelection();return Lexical_1.$isRangeSelection(f)||Lexical_1.DEPRECATED_$isGridSelection(f)?(H$2(b,c),!0):!1},Lexical_1.COMMAND_PRIORITY_EDITOR))};

var LexicalRichText_prod = {
	$createHeadingNode: $createHeadingNode,
	$createQuoteNode: $createQuoteNode,
	$isHeadingNode: $isHeadingNode,
	$isQuoteNode: $isQuoteNode,
	DRAG_DROP_PASTE: DRAG_DROP_PASTE,
	HeadingNode: HeadingNode,
	QuoteNode: QuoteNode,
	eventFiles: eventFiles,
	registerRichText: registerRichText
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const LexicalRichText = process.env.NODE_ENV === 'development' ? LexicalRichText_dev : LexicalRichText_prod;
var LexicalRichText_1 = LexicalRichText;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */








/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

function indexBy(list, callback) {
  const index = {};

  for (const item of list) {
    const key = callback(item);

    if (index[key]) {
      index[key].push(item);
    } else {
      index[key] = [item];
    }
  }

  return index;
}
function transformersByType(transformers) {
  const byType = indexBy(transformers, t => t.type);
  return {
    element: byType.element || [],
    textFormat: byType['text-format'] || [],
    textMatch: byType['text-match'] || []
  };
}
const PUNCTUATION_OR_SPACE$1 = /[!-/:-@[-`{-~\s]/;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
function createMarkdownExport(transformers) {
  const byType = transformersByType(transformers); // Export only uses text formats that are responsible for single format
  // e.g. it will filter out *** (bold, italic) and instead use separate ** and *

  const textFormatTransformers = byType.textFormat.filter(transformer => transformer.format.length === 1);
  return node => {
    const output = [];
    const children = (node || Lexical_1.$getRoot()).getChildren();

    for (const child of children) {
      const result = exportTopLevelElements(child, byType.element, textFormatTransformers, byType.textMatch);

      if (result != null) {
        output.push(result);
      }
    }

    return output.join('\n\n');
  };
}

function exportTopLevelElements(node, elementTransformers, textTransformersIndex, textMatchTransformers) {
  for (const transformer of elementTransformers) {
    const result = transformer.export(node, _node => exportChildren(_node, textTransformersIndex, textMatchTransformers));

    if (result != null) {
      return result;
    }
  }

  if (Lexical_1.$isElementNode(node)) {
    return exportChildren(node, textTransformersIndex, textMatchTransformers);
  } else if (Lexical_1.$isDecoratorNode(node)) {
    return node.getTextContent();
  } else {
    return null;
  }
}

function exportChildren(node, textTransformersIndex, textMatchTransformers) {
  const output = [];
  const children = node.getChildren();

  mainLoop: for (const child of children) {
    for (const transformer of textMatchTransformers) {
      const result = transformer.export(child, parentNode => exportChildren(parentNode, textTransformersIndex, textMatchTransformers), (textNode, textContent) => exportTextFormat(textNode, textContent, textTransformersIndex));

      if (result != null) {
        output.push(result);
        continue mainLoop;
      }
    }

    if (Lexical_1.$isLineBreakNode(child)) {
      output.push('\n');
    } else if (Lexical_1.$isTextNode(child)) {
      output.push(exportTextFormat(child, child.getTextContent(), textTransformersIndex));
    } else if (Lexical_1.$isElementNode(child)) {
      output.push(exportChildren(child, textTransformersIndex, textMatchTransformers));
    } else if (Lexical_1.$isDecoratorNode(child)) {
      output.push(child.getTextContent());
    }
  }

  return output.join('');
}

function exportTextFormat(node, textContent, textTransformers) {
  // This function handles the case of a string looking like this: "   foo   "
  // Where it would be invalid markdown to generate: "**   foo   **"
  // We instead want to trim the whitespace out, apply formatting, and then
  // bring the whitespace back. So our returned string looks like this: "   **foo**   "
  const frozenString = textContent.trim();
  let output = frozenString;
  const applied = new Set();

  for (const transformer of textTransformers) {
    const format = transformer.format[0];
    const tag = transformer.tag;

    if (hasFormat(node, format) && !applied.has(format)) {
      // Multiple tags might be used for the same format (*, _)
      applied.add(format); // Prevent adding opening tag is already opened by the previous sibling

      const previousNode = getTextSibling(node, true);

      if (!hasFormat(previousNode, format)) {
        output = tag + output;
      } // Prevent adding closing tag if next sibling will do it


      const nextNode = getTextSibling(node, false);

      if (!hasFormat(nextNode, format)) {
        output += tag;
      }
    }
  } // Replace trimmed version of textContent ensuring surrounding whitespace is not modified


  return textContent.replace(frozenString, output);
} // Get next or previous text sibling a text node, including cases
// when it's a child of inline element (e.g. link)


function getTextSibling(node, backward) {
  let sibling = backward ? node.getPreviousSibling() : node.getNextSibling();

  if (!sibling) {
    const parent = node.getParentOrThrow();

    if (parent.isInline()) {
      sibling = backward ? parent.getPreviousSibling() : parent.getNextSibling();
    }
  }

  while (sibling) {
    if (Lexical_1.$isElementNode(sibling)) {
      if (!sibling.isInline()) {
        break;
      }

      const descendant = backward ? sibling.getLastDescendant() : sibling.getFirstDescendant();

      if (Lexical_1.$isTextNode(descendant)) {
        return descendant;
      } else {
        sibling = backward ? sibling.getPreviousSibling() : sibling.getNextSibling();
      }
    }

    if (Lexical_1.$isTextNode(sibling)) {
      return sibling;
    }

    if (!Lexical_1.$isElementNode(sibling)) {
      return null;
    }
  }

  return null;
}

function hasFormat(node, format) {
  return Lexical_1.$isTextNode(node) && node.hasFormat(format);
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const CAN_USE_DOM$5 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const documentMode = CAN_USE_DOM$5 && 'documentMode' in document ? document.documentMode : null;
CAN_USE_DOM$5 && /Mac|iPod|iPhone|iPad/.test(navigator.platform);
CAN_USE_DOM$5 && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent);
CAN_USE_DOM$5 && 'InputEvent' in window && !documentMode ? 'getTargetRanges' in new window.InputEvent('input') : false;
const IS_SAFARI = CAN_USE_DOM$5 && /Version\/[\d.]+.*Safari/.test(navigator.userAgent);
const IS_IOS = CAN_USE_DOM$5 && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream; // Keep these in case we need to use them in the future.
// export const IS_WINDOWS: boolean = CAN_USE_DOM && /Win/.test(navigator.platform);

const IS_CHROME = CAN_USE_DOM$5 && /^(?=.*Chrome).*/i.test(navigator.userAgent); // export const canUseTextInputEvent: boolean = CAN_USE_DOM && 'TextEvent' in window && !documentMode;

const IS_APPLE_WEBKIT = CAN_USE_DOM$5 && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !IS_CHROME;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const MARKDOWN_EMPTY_LINE_REG_EXP = /^\s{0,3}$/;
const CODE_BLOCK_REG_EXP = /^```(\w{1,10})?\s?$/;
function createMarkdownImport(transformers) {
  const byType = transformersByType(transformers);
  const textFormatTransformersIndex = createTextFormatTransformersIndex(byType.textFormat);
  return (markdownString, node) => {
    const lines = markdownString.split('\n');
    const linesLength = lines.length;
    const root = node || Lexical_1.$getRoot();
    root.clear();

    for (let i = 0; i < linesLength; i++) {
      const lineText = lines[i]; // Codeblocks are processed first as anything inside such block
      // is ignored for further processing
      // TODO:
      // Abstract it to be dynamic as other transformers (add multiline match option)

      const [codeBlockNode, shiftedIndex] = importCodeBlock(lines, i, root);

      if (codeBlockNode != null) {
        i = shiftedIndex;
        continue;
      }

      importBlocks(lineText, root, byType.element, textFormatTransformersIndex, byType.textMatch);
    } // Removing empty paragraphs as md does not really
    // allow empty lines and uses them as dilimiter


    const children = root.getChildren();

    for (const child of children) {
      if (isEmptyParagraph(child)) {
        child.remove();
      }
    }

    if (Lexical_1.$getSelection() !== null) {
      root.selectEnd();
    }
  };
}

function isEmptyParagraph(node) {
  if (!Lexical_1.$isParagraphNode(node)) {
    return false;
  }

  const firstChild = node.getFirstChild();
  return firstChild == null || node.getChildrenSize() === 1 && Lexical_1.$isTextNode(firstChild) && MARKDOWN_EMPTY_LINE_REG_EXP.test(firstChild.getTextContent());
}

function importBlocks(lineText, rootNode, elementTransformers, textFormatTransformersIndex, textMatchTransformers) {
  const lineTextTrimmed = lineText.trim();
  const textNode = Lexical_1.$createTextNode(lineTextTrimmed);
  const elementNode = Lexical_1.$createParagraphNode();
  elementNode.append(textNode);
  rootNode.append(elementNode);

  for (const {
    regExp,
    replace
  } of elementTransformers) {
    const match = lineText.match(regExp);

    if (match) {
      textNode.setTextContent(lineText.slice(match[0].length));
      replace(elementNode, [textNode], match, true);
      break;
    }
  }

  importTextFormatTransformers(textNode, textFormatTransformersIndex, textMatchTransformers); // If no transformer found and we left with original paragraph node
  // can check if its content can be appended to the previous node
  // if it's a paragraph, quote or list

  if (elementNode.isAttached() && lineTextTrimmed.length > 0) {
    const previousNode = elementNode.getPreviousSibling();

    if (Lexical_1.$isParagraphNode(previousNode) || LexicalRichText_1.$isQuoteNode(previousNode) || LexicalList_1.$isListNode(previousNode)) {
      let targetNode = previousNode;

      if (LexicalList_1.$isListNode(previousNode)) {
        const lastDescendant = previousNode.getLastDescendant();

        if (lastDescendant == null) {
          targetNode = null;
        } else {
          targetNode = LexicalUtils_1.$findMatchingParent(lastDescendant, LexicalList_1.$isListItemNode);
        }
      }

      if (targetNode != null && targetNode.getTextContentSize() > 0) {
        targetNode.splice(targetNode.getChildrenSize(), 0, [Lexical_1.$createLineBreakNode(), ...elementNode.getChildren()]);
        elementNode.remove();
      }
    }
  }
}

function importCodeBlock(lines, startLineIndex, rootNode) {
  const openMatch = lines[startLineIndex].match(CODE_BLOCK_REG_EXP);

  if (openMatch) {
    let endLineIndex = startLineIndex;
    const linesLength = lines.length;

    while (++endLineIndex < linesLength) {
      const closeMatch = lines[endLineIndex].match(CODE_BLOCK_REG_EXP);

      if (closeMatch) {
        const codeBlockNode = LexicalCode_1.$createCodeNode(openMatch[1]);
        const textNode = Lexical_1.$createTextNode(lines.slice(startLineIndex + 1, endLineIndex).join('\n'));
        codeBlockNode.append(textNode);
        rootNode.append(codeBlockNode);
        return [codeBlockNode, endLineIndex];
      }
    }
  }

  return [null, startLineIndex];
} // Processing text content and replaces text format tags.
// It takes outermost tag match and its content, creates text node with
// format based on tag and then recursively executed over node's content
//
// E.g. for "*Hello **world**!*" string it will create text node with
// "Hello **world**!" content and italic format and run recursively over
// its content to transform "**world**" part


function importTextFormatTransformers(textNode, textFormatTransformersIndex, textMatchTransformers) {
  const textContent = textNode.getTextContent();
  const match = findOutermostMatch(textContent, textFormatTransformersIndex);

  if (!match) {
    // Once text format processing is done run text match transformers, as it
    // only can span within single text node (unline formats that can cover multiple nodes)
    importTextMatchTransformers(textNode, textMatchTransformers);
    return;
  }

  let currentNode, remainderNode, leadingNode; // If matching full content there's no need to run splitText and can reuse existing textNode
  // to update its content and apply format. E.g. for **_Hello_** string after applying bold
  // format (**) it will reuse the same text node to apply italic (_)

  if (match[0] === textContent) {
    currentNode = textNode;
  } else {
    const startIndex = match.index || 0;
    const endIndex = startIndex + match[0].length;

    if (startIndex === 0) {
      [currentNode, remainderNode] = textNode.splitText(endIndex);
    } else {
      [leadingNode, currentNode, remainderNode] = textNode.splitText(startIndex, endIndex);
    }
  }

  currentNode.setTextContent(match[2]);
  const transformer = textFormatTransformersIndex.transformersByTag[match[1]];

  if (transformer) {
    for (const format of transformer.format) {
      if (!currentNode.hasFormat(format)) {
        currentNode.toggleFormat(format);
      }
    }
  } // Recursively run over inner text if it's not inline code


  if (!currentNode.hasFormat('code')) {
    importTextFormatTransformers(currentNode, textFormatTransformersIndex, textMatchTransformers);
  } // Run over leading/remaining text if any


  if (leadingNode) {
    importTextFormatTransformers(leadingNode, textFormatTransformersIndex, textMatchTransformers);
  }

  if (remainderNode) {
    importTextFormatTransformers(remainderNode, textFormatTransformersIndex, textMatchTransformers);
  }
}

function importTextMatchTransformers(textNode_, textMatchTransformers) {
  let textNode = textNode_;

  mainLoop: while (textNode) {
    for (const transformer of textMatchTransformers) {
      const match = textNode.getTextContent().match(transformer.importRegExp);

      if (!match) {
        continue;
      }

      const startIndex = match.index || 0;
      const endIndex = startIndex + match[0].length;
      let replaceNode, leftTextNode, rightTextNode;

      if (startIndex === 0) {
        [replaceNode, textNode] = textNode.splitText(endIndex);
      } else {
        [leftTextNode, replaceNode, rightTextNode] = textNode.splitText(startIndex, endIndex);
      }

      if (leftTextNode) {
        importTextMatchTransformers(leftTextNode, textMatchTransformers);
      }

      if (rightTextNode) {
        textNode = rightTextNode;
      }

      transformer.replace(replaceNode, match);
      continue mainLoop;
    }

    break;
  }
} // Finds first "<tag>content<tag>" match that is not nested into another tag


function findOutermostMatch(textContent, textTransformersIndex) {
  const openTagsMatch = textContent.match(textTransformersIndex.openTagsRegExp);

  if (openTagsMatch == null) {
    return null;
  }

  for (const match of openTagsMatch) {
    // Open tags reg exp might capture leading space so removing it
    // before using match to find transformer
    const tag = match.replace(/^\s/, '');
    const fullMatchRegExp = textTransformersIndex.fullMatchRegExpByTag[tag];

    if (fullMatchRegExp == null) {
      continue;
    }

    const fullMatch = textContent.match(fullMatchRegExp);
    const transformer = textTransformersIndex.transformersByTag[tag];

    if (fullMatch != null && transformer != null) {
      if (transformer.intraword !== false) {
        return fullMatch;
      } // For non-intraword transformers checking if it's within a word
      // or surrounded with space/punctuation/newline


      const {
        index = 0
      } = fullMatch;
      const beforeChar = textContent[index - 1];
      const afterChar = textContent[index + fullMatch[0].length];

      if ((!beforeChar || PUNCTUATION_OR_SPACE$1.test(beforeChar)) && (!afterChar || PUNCTUATION_OR_SPACE$1.test(afterChar))) {
        return fullMatch;
      }
    }
  }

  return null;
}

function createTextFormatTransformersIndex(textTransformers) {
  const transformersByTag = {};
  const fullMatchRegExpByTag = {};
  const openTagsRegExp = [];
  const escapeRegExp = `(?<![\\\\])`;

  for (const transformer of textTransformers) {
    const {
      tag
    } = transformer;
    transformersByTag[tag] = transformer;
    const tagRegExp = tag.replace(/(\*|\^|\+)/g, '\\$1');
    openTagsRegExp.push(tagRegExp);

    if (IS_SAFARI || IS_IOS || IS_APPLE_WEBKIT) {
      fullMatchRegExpByTag[tag] = new RegExp(`(${tagRegExp})(?![${tagRegExp}\\s])(.*?[^${tagRegExp}\\s])${tagRegExp}(?!${tagRegExp})`);
    } else {
      fullMatchRegExpByTag[tag] = new RegExp(`(?<![\\\\${tagRegExp}])(${tagRegExp})((\\\\${tagRegExp})?.*?[^${tagRegExp}\\s](\\\\${tagRegExp})?)((?<!\\\\)|(?<=\\\\\\\\))(${tagRegExp})(?![\\\\${tagRegExp}])`);
    }
  }

  return {
    // Reg exp to find open tag + content + close tag
    fullMatchRegExpByTag,
    // Reg exp to find opening tags
    openTagsRegExp: new RegExp((IS_SAFARI || IS_IOS || IS_APPLE_WEBKIT ? '' : `${escapeRegExp}`) + '(' + openTagsRegExp.join('|') + ')', 'g'),
    transformersByTag
  };
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

function runElementTransformers(parentNode, anchorNode, anchorOffset, elementTransformers) {
  const grandParentNode = parentNode.getParent();

  if (!Lexical_1.$isRootOrShadowRoot(grandParentNode) || parentNode.getFirstChild() !== anchorNode) {
    return false;
  }

  const textContent = anchorNode.getTextContent(); // Checking for anchorOffset position to prevent any checks for cases when caret is too far
  // from a line start to be a part of block-level markdown trigger.
  //
  // TODO:
  // Can have a quick check if caret is close enough to the beginning of the string (e.g. offset less than 10-20)
  // since otherwise it won't be a markdown shortcut, but tables are exception

  if (textContent[anchorOffset - 1] !== ' ') {
    return false;
  }

  for (const {
    regExp,
    replace
  } of elementTransformers) {
    const match = textContent.match(regExp);

    if (match && match[0].length === anchorOffset) {
      const nextSiblings = anchorNode.getNextSiblings();
      const [leadingNode, remainderNode] = anchorNode.splitText(anchorOffset);
      leadingNode.remove();
      const siblings = remainderNode ? [remainderNode, ...nextSiblings] : nextSiblings;
      replace(parentNode, siblings, match, false);
      return true;
    }
  }

  return false;
}

function runTextMatchTransformers(anchorNode, anchorOffset, transformersByTrigger) {
  let textContent = anchorNode.getTextContent();
  const lastChar = textContent[anchorOffset - 1];
  const transformers = transformersByTrigger[lastChar];

  if (transformers == null) {
    return false;
  } // If typing in the middle of content, remove the tail to do
  // reg exp match up to a string end (caret position)


  if (anchorOffset < textContent.length) {
    textContent = textContent.slice(0, anchorOffset);
  }

  for (const transformer of transformers) {
    const match = textContent.match(transformer.regExp);

    if (match === null) {
      continue;
    }

    const startIndex = match.index || 0;
    const endIndex = startIndex + match[0].length;
    let replaceNode;

    if (startIndex === 0) {
      [replaceNode] = anchorNode.splitText(endIndex);
    } else {
      [, replaceNode] = anchorNode.splitText(startIndex, endIndex);
    }

    replaceNode.selectNext(0, 0);
    transformer.replace(replaceNode, match);
    return true;
  }

  return false;
}

function runTextFormatTransformers(anchorNode, anchorOffset, textFormatTransformers) {
  const textContent = anchorNode.getTextContent();
  const closeTagEndIndex = anchorOffset - 1;
  const closeChar = textContent[closeTagEndIndex]; // Quick check if we're possibly at the end of inline markdown style

  const matchers = textFormatTransformers[closeChar];

  if (!matchers) {
    return false;
  }

  for (const matcher of matchers) {
    const {
      tag
    } = matcher;
    const tagLength = tag.length;
    const closeTagStartIndex = closeTagEndIndex - tagLength + 1; // If tag is not single char check if rest of it matches with text content

    if (tagLength > 1) {
      if (!isEqualSubString(textContent, closeTagStartIndex, tag, 0, tagLength)) {
        continue;
      }
    } // Space before closing tag cancels inline markdown


    if (textContent[closeTagStartIndex - 1] === ' ') {
      continue;
    } // Some tags can not be used within words, hence should have newline/space/punctuation after it


    const afterCloseTagChar = textContent[closeTagEndIndex + 1];

    if (matcher.intraword === false && afterCloseTagChar && !PUNCTUATION_OR_SPACE$1.test(afterCloseTagChar)) {
      continue;
    }

    const closeNode = anchorNode;
    let openNode = closeNode;
    let openTagStartIndex = getOpenTagStartIndex(textContent, closeTagStartIndex, tag); // Go through text node siblings and search for opening tag
    // if haven't found it within the same text node as closing tag

    let sibling = openNode;

    while (openTagStartIndex < 0 && (sibling = sibling.getPreviousSibling())) {
      if (Lexical_1.$isLineBreakNode(sibling)) {
        break;
      }

      if (Lexical_1.$isTextNode(sibling)) {
        const siblingTextContent = sibling.getTextContent();
        openNode = sibling;
        openTagStartIndex = getOpenTagStartIndex(siblingTextContent, siblingTextContent.length, tag);
      }
    } // Opening tag is not found


    if (openTagStartIndex < 0) {
      continue;
    } // No content between opening and closing tag


    if (openNode === closeNode && openTagStartIndex + tagLength === closeTagStartIndex) {
      continue;
    } // Checking longer tags for repeating chars (e.g. *** vs **)


    const prevOpenNodeText = openNode.getTextContent();

    if (openTagStartIndex > 0 && prevOpenNodeText[openTagStartIndex - 1] === closeChar) {
      continue;
    } // Some tags can not be used within words, hence should have newline/space/punctuation before it


    const beforeOpenTagChar = prevOpenNodeText[openTagStartIndex - 1];

    if (matcher.intraword === false && beforeOpenTagChar && !PUNCTUATION_OR_SPACE$1.test(beforeOpenTagChar)) {
      continue;
    } // Clean text from opening and closing tags (starting from closing tag
    // to prevent any offset shifts if we start from opening one)


    const prevCloseNodeText = closeNode.getTextContent();
    const closeNodeText = prevCloseNodeText.slice(0, closeTagStartIndex) + prevCloseNodeText.slice(closeTagEndIndex + 1);
    closeNode.setTextContent(closeNodeText);
    const openNodeText = openNode === closeNode ? closeNodeText : prevOpenNodeText;
    openNode.setTextContent(openNodeText.slice(0, openTagStartIndex) + openNodeText.slice(openTagStartIndex + tagLength));
    const selection = Lexical_1.$getSelection();
    const nextSelection = Lexical_1.$createRangeSelection();
    Lexical_1.$setSelection(nextSelection); // Adjust offset based on deleted chars

    const newOffset = closeTagEndIndex - tagLength * (openNode === closeNode ? 2 : 1) + 1;
    nextSelection.anchor.set(openNode.__key, openTagStartIndex, 'text');
    nextSelection.focus.set(closeNode.__key, newOffset, 'text'); // Apply formatting to selected text

    for (const format of matcher.format) {
      if (!nextSelection.hasFormat(format)) {
        nextSelection.formatText(format);
      }
    } // Collapse selection up to the focus point


    nextSelection.anchor.set(nextSelection.focus.key, nextSelection.focus.offset, nextSelection.focus.type); // Remove formatting from collapsed selection

    for (const format of matcher.format) {
      if (nextSelection.hasFormat(format)) {
        nextSelection.toggleFormat(format);
      }
    }

    if (Lexical_1.$isRangeSelection(selection)) {
      nextSelection.format = selection.format;
    }

    return true;
  }

  return false;
}

function getOpenTagStartIndex(string, maxIndex, tag) {
  const tagLength = tag.length;

  for (let i = maxIndex; i >= tagLength; i--) {
    const startIndex = i - tagLength;

    if (isEqualSubString(string, startIndex, tag, 0, tagLength) && // Space after opening tag cancels transformation
    string[startIndex + tagLength] !== ' ') {
      return startIndex;
    }
  }

  return -1;
}

function isEqualSubString(stringA, aStart, stringB, bStart, length) {
  for (let i = 0; i < length; i++) {
    if (stringA[aStart + i] !== stringB[bStart + i]) {
      return false;
    }
  }

  return true;
}

function registerMarkdownShortcuts$1(editor, transformers = TRANSFORMERS$1) {
  const byType = transformersByType(transformers);
  const textFormatTransformersIndex = indexBy(byType.textFormat, ({
    tag
  }) => tag[tag.length - 1]);
  const textMatchTransformersIndex = indexBy(byType.textMatch, ({
    trigger
  }) => trigger);

  for (const transformer of transformers) {
    const type = transformer.type;

    if (type === 'element' || type === 'text-match') {
      const dependencies = transformer.dependencies;

      if (!editor.hasNodes(dependencies)) {
        {
          throw Error(`MarkdownShortcuts: missing dependency for transformer. Ensure node dependency is included in editor initial config.`);
        }
      }
    }
  }

  const transform = (parentNode, anchorNode, anchorOffset) => {
    if (runElementTransformers(parentNode, anchorNode, anchorOffset, byType.element)) {
      return;
    }

    if (runTextMatchTransformers(anchorNode, anchorOffset, textMatchTransformersIndex)) {
      return;
    }

    runTextFormatTransformers(anchorNode, anchorOffset, textFormatTransformersIndex);
  };

  return editor.registerUpdateListener(({
    tags,
    dirtyLeaves,
    editorState,
    prevEditorState
  }) => {
    // Ignore updates from undo/redo (as changes already calculated)
    if (tags.has('historic')) {
      return;
    }

    const selection = editorState.read(Lexical_1.$getSelection);
    const prevSelection = prevEditorState.read(Lexical_1.$getSelection);

    if (!Lexical_1.$isRangeSelection(prevSelection) || !Lexical_1.$isRangeSelection(selection) || !selection.isCollapsed()) {
      return;
    }

    const anchorKey = selection.anchor.key;
    const anchorOffset = selection.anchor.offset;

    const anchorNode = editorState._nodeMap.get(anchorKey);

    if (!Lexical_1.$isTextNode(anchorNode) || !dirtyLeaves.has(anchorKey) || anchorOffset !== 1 && anchorOffset !== prevSelection.anchor.offset + 1) {
      return;
    }

    editor.update(() => {
      // Markdown is not available inside code
      if (anchorNode.hasFormat('code')) {
        return;
      }

      const parentNode = anchorNode.getParent();

      if (parentNode === null || LexicalCode_1.$isCodeNode(parentNode)) {
        return;
      }

      transform(parentNode, anchorNode, selection.anchor.offset);
    });
  });
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

const createBlockNode = createNode => {
  return (parentNode, children, match) => {
    const node = createNode(match);
    node.append(...children);
    parentNode.replace(node);
    node.select(0, 0);
  };
}; // Amount of spaces that define indentation level
// TODO: should be an option


const LIST_INDENT_SIZE = 4;

const listReplace = listType => {
  return (parentNode, children, match) => {
    const previousNode = parentNode.getPreviousSibling();
    const listItem = LexicalList_1.$createListItemNode(listType === 'check' ? match[3] === 'x' : undefined);

    if (LexicalList_1.$isListNode(previousNode) && previousNode.getListType() === listType) {
      previousNode.append(listItem);
      parentNode.remove();
    } else {
      const list$1 = LexicalList_1.$createListNode(listType, listType === 'number' ? Number(match[2]) : undefined);
      list$1.append(listItem);
      parentNode.replace(list$1);
    }

    listItem.append(...children);
    listItem.select(0, 0);
    const indent = Math.floor(match[1].length / LIST_INDENT_SIZE);

    if (indent) {
      listItem.setIndent(indent);
    }
  };
};

const listExport = (listNode, exportChildren, depth) => {
  const output = [];
  const children = listNode.getChildren();
  let index = 0;

  for (const listItemNode of children) {
    if (LexicalList_1.$isListItemNode(listItemNode)) {
      if (listItemNode.getChildrenSize() === 1) {
        const firstChild = listItemNode.getFirstChild();

        if (LexicalList_1.$isListNode(firstChild)) {
          output.push(listExport(firstChild, exportChildren, depth + 1));
          continue;
        }
      }

      const indent = ' '.repeat(depth * LIST_INDENT_SIZE);
      const listType = listNode.getListType();
      const prefix = listType === 'number' ? `${listNode.getStart() + index}. ` : listType === 'check' ? `- [${listItemNode.getChecked() ? 'x' : ' '}] ` : '- ';
      output.push(indent + prefix + exportChildren(listItemNode));
      index++;
    }
  }

  return output.join('\n');
};

const HEADING$1 = {
  dependencies: [LexicalRichText_1.HeadingNode],
  export: (node, exportChildren) => {
    if (!LexicalRichText_1.$isHeadingNode(node)) {
      return null;
    }

    const level = Number(node.getTag().slice(1));
    return '#'.repeat(level) + ' ' + exportChildren(node);
  },
  regExp: /^(#{1,6})\s/,
  replace: createBlockNode(match => {
    const tag = 'h' + match[1].length;
    return LexicalRichText_1.$createHeadingNode(tag);
  }),
  type: 'element'
};
const QUOTE$1 = {
  dependencies: [LexicalRichText_1.QuoteNode],
  export: (node, exportChildren) => {
    if (!LexicalRichText_1.$isQuoteNode(node)) {
      return null;
    }

    const lines = exportChildren(node).split('\n');
    const output = [];

    for (const line of lines) {
      output.push('> ' + line);
    }

    return output.join('\n');
  },
  regExp: /^>\s/,
  replace: (parentNode, children, _match, isImport) => {
    if (isImport) {
      const previousNode = parentNode.getPreviousSibling();

      if (LexicalRichText_1.$isQuoteNode(previousNode)) {
        previousNode.splice(previousNode.getChildrenSize(), 0, [Lexical_1.$createLineBreakNode(), ...children]);
        previousNode.select(0, 0);
        parentNode.remove();
        return;
      }
    }

    const node = LexicalRichText_1.$createQuoteNode();
    node.append(...children);
    parentNode.replace(node);
    node.select(0, 0);
  },
  type: 'element'
};
const CODE$1 = {
  dependencies: [LexicalCode_1.CodeNode],
  export: node => {
    if (!LexicalCode_1.$isCodeNode(node)) {
      return null;
    }

    const textContent = node.getTextContent();
    return '```' + (node.getLanguage() || '') + (textContent ? '\n' + textContent : '') + '\n' + '```';
  },
  regExp: /^```(\w{1,10})?\s/,
  replace: createBlockNode(match => {
    return LexicalCode_1.$createCodeNode(match ? match[1] : undefined);
  }),
  type: 'element'
};
const UNORDERED_LIST$1 = {
  dependencies: [LexicalList_1.ListNode, LexicalList_1.ListItemNode],
  export: (node, exportChildren) => {
    return LexicalList_1.$isListNode(node) ? listExport(node, exportChildren, 0) : null;
  },
  regExp: /^(\s*)[-*+]\s/,
  replace: listReplace('bullet'),
  type: 'element'
};
const CHECK_LIST$1 = {
  dependencies: [LexicalList_1.ListNode, LexicalList_1.ListItemNode],
  export: (node, exportChildren) => {
    return LexicalList_1.$isListNode(node) ? listExport(node, exportChildren, 0) : null;
  },
  regExp: /^(\s*)(?:-\s)?\s?(\[(\s|x)?\])\s/i,
  replace: listReplace('check'),
  type: 'element'
};
const ORDERED_LIST$1 = {
  dependencies: [LexicalList_1.ListNode, LexicalList_1.ListItemNode],
  export: (node, exportChildren) => {
    return LexicalList_1.$isListNode(node) ? listExport(node, exportChildren, 0) : null;
  },
  regExp: /^(\s*)(\d{1,})\.\s/,
  replace: listReplace('number'),
  type: 'element'
};
const INLINE_CODE$1 = {
  format: ['code'],
  tag: '`',
  type: 'text-format'
};
const HIGHLIGHT$1 = {
  format: ['highlight'],
  tag: '==',
  type: 'text-format'
};
const BOLD_ITALIC_STAR$1 = {
  format: ['bold', 'italic'],
  tag: '***',
  type: 'text-format'
};
const BOLD_ITALIC_UNDERSCORE$1 = {
  format: ['bold', 'italic'],
  intraword: false,
  tag: '___',
  type: 'text-format'
};
const BOLD_STAR$1 = {
  format: ['bold'],
  tag: '**',
  type: 'text-format'
};
const BOLD_UNDERSCORE$1 = {
  format: ['bold'],
  intraword: false,
  tag: '__',
  type: 'text-format'
};
const STRIKETHROUGH$1 = {
  format: ['strikethrough'],
  tag: '~~',
  type: 'text-format'
};
const ITALIC_STAR$1 = {
  format: ['italic'],
  tag: '*',
  type: 'text-format'
};
const ITALIC_UNDERSCORE$1 = {
  format: ['italic'],
  intraword: false,
  tag: '_',
  type: 'text-format'
}; // Order of text transformers matters:
//
// - code should go first as it prevents any transformations inside
// - then longer tags match (e.g. ** or __ should go before * or _)

const LINK$1 = {
  dependencies: [LexicalLink_1.LinkNode],
  export: (node, exportChildren, exportFormat) => {
    if (!LexicalLink_1.$isLinkNode(node)) {
      return null;
    }

    const title = node.getTitle();
    const linkContent = title ? `[${node.getTextContent()}](${node.getURL()} "${title}")` : `[${node.getTextContent()}](${node.getURL()})`;
    const firstChild = node.getFirstChild(); // Add text styles only if link has single text node inside. If it's more
    // then one we ignore it as markdown does not support nested styles for links

    if (node.getChildrenSize() === 1 && Lexical_1.$isTextNode(firstChild)) {
      return exportFormat(firstChild, linkContent);
    } else {
      return linkContent;
    }
  },
  importRegExp: /(?:\[([^[]+)\])(?:\((?:([^()\s]+)(?:\s"((?:[^"]*\\")*[^"]*)"\s*)?)\))/,
  regExp: /(?:\[([^[]+)\])(?:\((?:([^()\s]+)(?:\s"((?:[^"]*\\")*[^"]*)"\s*)?)\))$/,
  replace: (textNode, match) => {
    const [, linkText, linkUrl, linkTitle] = match;
    const linkNode = LexicalLink_1.$createLinkNode(linkUrl, {
      title: linkTitle
    });
    const linkTextNode = Lexical_1.$createTextNode(linkText);
    linkTextNode.setFormat(textNode.getFormat());
    linkNode.append(linkTextNode);
    textNode.replace(linkNode);
  },
  trigger: ')',
  type: 'text-match'
};

/** @module @lexical/markdown */
const ELEMENT_TRANSFORMERS$1 = [HEADING$1, QUOTE$1, CODE$1, UNORDERED_LIST$1, ORDERED_LIST$1]; // Order of text format transformers matters:
//
// - code should go first as it prevents any transformations inside
// - then longer tags match (e.g. ** or __ should go before * or _)

const TEXT_FORMAT_TRANSFORMERS$1 = [INLINE_CODE$1, BOLD_ITALIC_STAR$1, BOLD_ITALIC_UNDERSCORE$1, BOLD_STAR$1, BOLD_UNDERSCORE$1, HIGHLIGHT$1, ITALIC_STAR$1, ITALIC_UNDERSCORE$1, STRIKETHROUGH$1];
const TEXT_MATCH_TRANSFORMERS$1 = [LINK$1];
const TRANSFORMERS$1 = [...ELEMENT_TRANSFORMERS$1, ...TEXT_FORMAT_TRANSFORMERS$1, ...TEXT_MATCH_TRANSFORMERS$1];

function $convertFromMarkdownString$1(markdown, transformers = TRANSFORMERS$1, node) {
  const importMarkdown = createMarkdownImport(transformers);
  return importMarkdown(markdown, node);
}

function $convertToMarkdownString$1(transformers = TRANSFORMERS$1, node) {
  const exportMarkdown = createMarkdownExport(transformers);
  return exportMarkdown(node);
}

var $convertFromMarkdownString_1 = $convertFromMarkdownString$1;
var $convertToMarkdownString_1 = $convertToMarkdownString$1;
var BOLD_ITALIC_STAR_1 = BOLD_ITALIC_STAR$1;
var BOLD_ITALIC_UNDERSCORE_1 = BOLD_ITALIC_UNDERSCORE$1;
var BOLD_STAR_1 = BOLD_STAR$1;
var BOLD_UNDERSCORE_1 = BOLD_UNDERSCORE$1;
var CHECK_LIST_1 = CHECK_LIST$1;
var CODE_1 = CODE$1;
var ELEMENT_TRANSFORMERS_1 = ELEMENT_TRANSFORMERS$1;
var HEADING_1 = HEADING$1;
var HIGHLIGHT_1 = HIGHLIGHT$1;
var INLINE_CODE_1 = INLINE_CODE$1;
var ITALIC_STAR_1 = ITALIC_STAR$1;
var ITALIC_UNDERSCORE_1 = ITALIC_UNDERSCORE$1;
var LINK_1 = LINK$1;
var ORDERED_LIST_1 = ORDERED_LIST$1;
var QUOTE_1 = QUOTE$1;
var STRIKETHROUGH_1 = STRIKETHROUGH$1;
var TEXT_FORMAT_TRANSFORMERS_1 = TEXT_FORMAT_TRANSFORMERS$1;
var TEXT_MATCH_TRANSFORMERS_1 = TEXT_MATCH_TRANSFORMERS$1;
var TRANSFORMERS_1 = TRANSFORMERS$1;
var UNORDERED_LIST_1 = UNORDERED_LIST$1;
var registerMarkdownShortcuts_1 = registerMarkdownShortcuts$1;

var LexicalMarkdown_dev = {
	$convertFromMarkdownString: $convertFromMarkdownString_1,
	$convertToMarkdownString: $convertToMarkdownString_1,
	BOLD_ITALIC_STAR: BOLD_ITALIC_STAR_1,
	BOLD_ITALIC_UNDERSCORE: BOLD_ITALIC_UNDERSCORE_1,
	BOLD_STAR: BOLD_STAR_1,
	BOLD_UNDERSCORE: BOLD_UNDERSCORE_1,
	CHECK_LIST: CHECK_LIST_1,
	CODE: CODE_1,
	ELEMENT_TRANSFORMERS: ELEMENT_TRANSFORMERS_1,
	HEADING: HEADING_1,
	HIGHLIGHT: HIGHLIGHT_1,
	INLINE_CODE: INLINE_CODE_1,
	ITALIC_STAR: ITALIC_STAR_1,
	ITALIC_UNDERSCORE: ITALIC_UNDERSCORE_1,
	LINK: LINK_1,
	ORDERED_LIST: ORDERED_LIST_1,
	QUOTE: QUOTE_1,
	STRIKETHROUGH: STRIKETHROUGH_1,
	TEXT_FORMAT_TRANSFORMERS: TEXT_FORMAT_TRANSFORMERS_1,
	TEXT_MATCH_TRANSFORMERS: TEXT_MATCH_TRANSFORMERS_1,
	TRANSFORMERS: TRANSFORMERS_1,
	UNORDERED_LIST: UNORDERED_LIST_1,
	registerMarkdownShortcuts: registerMarkdownShortcuts_1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function H$1(a,b){let c={};for(let d of a)a=b(d),c[a]?c[a].push(d):c[a]=[d];return c}function I(a){a=H$1(a,b=>b.type);return {element:a.element||[],textFormat:a["text-format"]||[],textMatch:a["text-match"]||[]}}let J=/[!-/:-@[-`{-~\s]/;
function ba$1(a){let b=I(a),c=b.textFormat.filter(d=>1===d.format.length);return d=>{let e=[];d=(d||Lexical_1.$getRoot()).getChildren();for(let f of d)d=ca$1(f,b.element,c,b.textMatch),null!=d&&e.push(d);return e.join("\n\n")}}function ca$1(a,b,c,d){for(let e of b)if(b=e.export(a,f=>K(f,c,d)),null!=b)return b;return Lexical_1.$isElementNode(a)?K(a,c,d):Lexical_1.$isDecoratorNode(a)?a.getTextContent():null}
function K(a,b,c){let d=[];a=a.getChildren();a:for(let e of a){for(let f of c)if(a=f.export(e,l=>K(l,b,c),(l,k)=>L(l,k,b)),null!=a){d.push(a);continue a}Lexical_1.$isLineBreakNode(e)?d.push("\n"):Lexical_1.$isTextNode(e)?d.push(L(e,e.getTextContent(),b)):Lexical_1.$isElementNode(e)?d.push(K(e,b,c)):Lexical_1.$isDecoratorNode(e)&&d.push(e.getTextContent());}return d.join("")}
function L(a,b,c){let d=b.trim(),e=d,f=new Set;for(let k of c){c=k.format[0];let p=k.tag;if(M(a,c)&&!f.has(c)){f.add(c);var l=N(a,!0);M(l,c)||(e=p+e);l=N(a,!1);M(l,c)||(e+=p);}}return b.replace(d,e)}
function N(a,b){let c=b?a.getPreviousSibling():a.getNextSibling();c||(a=a.getParentOrThrow(),a.isInline()&&(c=b?a.getPreviousSibling():a.getNextSibling()));for(;c;){if(Lexical_1.$isElementNode(c)){if(!c.isInline())break;a=b?c.getLastDescendant():c.getFirstDescendant();if(Lexical_1.$isTextNode(a))return a;c=b?c.getPreviousSibling():c.getNextSibling();}if(Lexical_1.$isTextNode(c))return c;if(!Lexical_1.$isElementNode(c))break}return null}function M(a,b){return Lexical_1.$isTextNode(a)&&a.hasFormat(b)}
let O$1="undefined"!==typeof window&&"undefined"!==typeof window.document&&"undefined"!==typeof window.document.createElement,da$1=O$1&&"documentMode"in document?document.documentMode:null;O$1&&/Mac|iPod|iPhone|iPad/.test(navigator.platform);O$1&&/^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent);O$1&&"InputEvent"in window&&!da$1?"getTargetRanges"in new window.InputEvent("input"):!1;
let P$1=O$1&&/Version\/[\d.]+.*Safari/.test(navigator.userAgent),Q$1=O$1&&/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,ea$1=O$1&&/^(?=.*Chrome).*/i.test(navigator.userAgent),R$1=O$1&&/AppleWebKit\/[\d.]+/.test(navigator.userAgent)&&!ea$1,fa$1=/^\s{0,3}$/,S=/^```(\w{1,10})?\s?$/;
function ha(a){let b=I(a),c=ia(b.textFormat);return (d,e)=>{d=d.split("\n");var f=d.length;e=e||Lexical_1.$getRoot();e.clear();for(let g=0;g<f;g++){var l=d[g];a:{var k=d,p=g;var r=e;var y=k[p].match(S);if(y)for(var q=p,m=k.length;++q<m;)if(k[q].match(S)){y=LexicalCode_1.$createCodeNode(y[1]);k=Lexical_1.$createTextNode(k.slice(p+1,q).join("\n"));y.append(k);r.append(y);r=[y,q];break a}r=[null,p];}let [n,v]=r;if(null!=n)g=v;else {r=l;m=e;var w=b.element;q=c;k=b.textMatch;p=r.trim();y=Lexical_1.$createTextNode(p);l=Lexical_1.$createParagraphNode();
l.append(y);m.append(l);for(let {regExp:x,replace:u}of w)if(m=r.match(x)){y.setTextContent(r.slice(m[0].length));u(l,[y],m,!0);break}T(y,q,k);l.isAttached()&&0<p.length&&(r=l.getPreviousSibling(),Lexical_1.$isParagraphNode(r)||LexicalRichText_1.$isQuoteNode(r)||LexicalList_1.$isListNode(r))&&(q=r,LexicalList_1.$isListNode(r)&&(r=r.getLastDescendant(),q=null==r?null:LexicalUtils_1.$findMatchingParent(r,LexicalList_1.$isListItemNode)),null!=q&&0<q.getTextContentSize()&&(q.splice(q.getChildrenSize(),0,[Lexical_1.$createLineBreakNode(),...l.getChildren()]),l.remove()));}}d=e.getChildren();
for(let g of d)d=g,Lexical_1.$isParagraphNode(d)?(f=d.getFirstChild(),d=null==f||1===d.getChildrenSize()&&Lexical_1.$isTextNode(f)&&fa$1.test(f.getTextContent())):d=!1,d&&g.remove();null!==Lexical_1.$getSelection()&&e.selectEnd();}}
function T(a,b,c){var d=a.getTextContent();let e=ja(d,b);if(e){var f,l;if(e[0]===d)var k=a;else {d=e.index||0;let p=d+e[0].length;0===d?[k,f]=a.splitText(p):[l,k,f]=a.splitText(d,p);}k.setTextContent(e[2]);if(a=b.transformersByTag[e[1]])for(let p of a.format)k.hasFormat(p)||k.toggleFormat(p);k.hasFormat("code")||T(k,b,c);l&&T(l,b,c);f&&T(f,b,c);}else U$1(a,c);}
function U$1(a,b){a:for(;a;){for(let c of b){let d=a.getTextContent().match(c.importRegExp);if(!d)continue;let e=d.index||0,f=e+d[0].length,l,k,p;0===e?[l,a]=a.splitText(f):[k,l,p]=a.splitText(e,f);k&&U$1(k,b);p&&(a=p);c.replace(l,d);continue a}break}}
function ja(a,b){var c=a.match(b.openTagsRegExp);if(null==c)return null;for(let f of c){var d=f.replace(/^\s/,"");c=b.fullMatchRegExpByTag[d];if(null!=c&&(c=a.match(c),d=b.transformersByTag[d],null!=c&&null!=d)){if(!1!==d.intraword)return c;var {index:e=0}=c;d=a[e-1];e=a[e+c[0].length];if(!(d&&!J.test(d)||e&&!J.test(e)))return c}}return null}
function ia(a){let b={},c={},d=[];for(let e of a){({tag:a}=e);b[a]=e;let f=a.replace(/(\*|\^|\+)/g,"\\$1");d.push(f);c[a]=P$1||Q$1||R$1?new RegExp(`(${f})(?![${f}\\s])(.*?[^${f}\\s])${f}(?!${f})`):new RegExp(`(?<![\\\\${f}])(${f})((\\\\${f})?.*?[^${f}\\s](\\\\${f})?)((?<!\\\\)|(?<=\\\\\\\\))(${f})(?![\\\\${f}])`);}return {fullMatchRegExpByTag:c,openTagsRegExp:new RegExp((P$1||Q$1||R$1?"":"(?<![\\\\])")+"("+d.join("|")+")","g"),transformersByTag:b}}
function V$1(a,b,c){let d=c.length;for(;b>=d;b--){let e=b-d;if(W$1(a,e,c,0,d)&&" "!==a[e+d])return e}return -1}function W$1(a,b,c,d,e){for(let f=0;f<e;f++)if(a[b+f]!==c[d+f])return !1;return !0}
let ka=a=>(b,c,d)=>{d=a(d);d.append(...c);b.replace(d);d.select(0,0);},X$1=a=>(b,c,d)=>{var e=b.getPreviousSibling();const f=LexicalList_1.$createListItemNode("check"===a?"x"===d[3]:void 0);LexicalList_1.$isListNode(e)&&e.getListType()===a?(e.append(f),b.remove()):(e=LexicalList_1.$createListNode(a,"number"===a?Number(d[2]):void 0),e.append(f),b.replace(e));f.append(...c);f.select(0,0);(b=Math.floor(d[1].length/4))&&f.setIndent(b);},Y$1=(a,b,c)=>{const d=[];var e=a.getChildren();let f=0;for(const k of e)if(LexicalList_1.$isListItemNode(k)){if(1===k.getChildrenSize()&&
(e=k.getFirstChild(),LexicalList_1.$isListNode(e))){d.push(Y$1(e,b,c+1));continue}e=" ".repeat(4*c);var l=a.getListType();l="number"===l?`${a.getStart()+f}. `:"check"===l?`- [${k.getChecked()?"x":" "}] `:"- ";d.push(e+l+b(k));f++;}return d.join("\n")},la={dependencies:[LexicalRichText_1.HeadingNode],export:(a,b)=>{if(!LexicalRichText_1.$isHeadingNode(a))return null;const c=Number(a.getTag().slice(1));return "#".repeat(c)+" "+b(a)},regExp:/^(#{1,6})\s/,replace:ka(a=>LexicalRichText_1.$createHeadingNode("h"+a[1].length)),type:"element"},ma={dependencies:[LexicalRichText_1.QuoteNode],
export:(a,b)=>{if(!LexicalRichText_1.$isQuoteNode(a))return null;a=b(a).split("\n");b=[];for(const c of a)b.push("> "+c);return b.join("\n")},regExp:/^>\s/,replace:(a,b,c,d)=>{if(d&&(c=a.getPreviousSibling(),LexicalRichText_1.$isQuoteNode(c))){c.splice(c.getChildrenSize(),0,[Lexical_1.$createLineBreakNode(),...b]);c.select(0,0);a.remove();return}c=LexicalRichText_1.$createQuoteNode();c.append(...b);a.replace(c);c.select(0,0);},type:"element"},na={dependencies:[LexicalCode_1.CodeNode],export:a=>{if(!LexicalCode_1.$isCodeNode(a))return null;const b=a.getTextContent();return "```"+
(a.getLanguage()||"")+(b?"\n"+b:"")+"\n```"},regExp:/^```(\w{1,10})?\s/,replace:ka(a=>LexicalCode_1.$createCodeNode(a?a[1]:void 0)),type:"element"},oa={dependencies:[LexicalList_1.ListNode,LexicalList_1.ListItemNode],export:(a,b)=>LexicalList_1.$isListNode(a)?Y$1(a,b,0):null,regExp:/^(\s*)[-*+]\s/,replace:X$1("bullet"),type:"element"},pa={dependencies:[LexicalList_1.ListNode,LexicalList_1.ListItemNode],export:(a,b)=>LexicalList_1.$isListNode(a)?Y$1(a,b,0):null,regExp:/^(\s*)(?:-\s)?\s?(\[(\s|x)?\])\s/i,replace:X$1("check"),type:"element"},qa={dependencies:[LexicalList_1.ListNode,LexicalList_1.ListItemNode],export:(a,
b)=>LexicalList_1.$isListNode(a)?Y$1(a,b,0):null,regExp:/^(\s*)(\d{1,})\.\s/,replace:X$1("number"),type:"element"},ra={format:["code"],tag:"`",type:"text-format"},sa={format:["highlight"],tag:"==",type:"text-format"},ta={format:["bold","italic"],tag:"***",type:"text-format"},va={format:["bold","italic"],intraword:!1,tag:"___",type:"text-format"},wa={format:["bold"],tag:"**",type:"text-format"},xa={format:["bold"],intraword:!1,tag:"__",type:"text-format"},ya={format:["strikethrough"],tag:"~~",type:"text-format"},
za={format:["italic"],tag:"*",type:"text-format"},Aa={format:["italic"],intraword:!1,tag:"_",type:"text-format"},Ba={dependencies:[LexicalLink_1.LinkNode],export:(a,b,c)=>{if(!LexicalLink_1.$isLinkNode(a))return null;b=(b=a.getTitle())?`[${a.getTextContent()}](${a.getURL()} "${b}")`:`[${a.getTextContent()}](${a.getURL()})`;const d=a.getFirstChild();return 1===a.getChildrenSize()&&Lexical_1.$isTextNode(d)?c(d,b):b},importRegExp:/(?:\[([^[]+)\])(?:\((?:([^()\s]+)(?:\s"((?:[^"]*\\")*[^"]*)"\s*)?)\))/,regExp:/(?:\[([^[]+)\])(?:\((?:([^()\s]+)(?:\s"((?:[^"]*\\")*[^"]*)"\s*)?)\))$/,
replace:(a,b)=>{const [,c,d,e]=b;b=LexicalLink_1.$createLinkNode(d,{title:e});const f=Lexical_1.$createTextNode(c);f.setFormat(a.getFormat());b.append(f);a.replace(b);},trigger:")",type:"text-match"},Ca=[la,ma,na,oa,qa],Da=[ra,ta,va,wa,xa,sa,za,Aa,ya],Ea=[Ba],Z$1=[...Ca,...Da,...Ea];var $convertFromMarkdownString=function(a,b=Z$1,c){return ha(b)(a,c)};var $convertToMarkdownString=function(a=Z$1,b){return ba$1(a)(b)};var BOLD_ITALIC_STAR=ta;var BOLD_ITALIC_UNDERSCORE=va;var BOLD_STAR=wa;
var BOLD_UNDERSCORE=xa;var CHECK_LIST=pa;var CODE=na;var ELEMENT_TRANSFORMERS=Ca;var HEADING=la;var HIGHLIGHT=sa;var INLINE_CODE=ra;var ITALIC_STAR=za;var ITALIC_UNDERSCORE=Aa;var LINK=Ba;var ORDERED_LIST=qa;var QUOTE=ma;var STRIKETHROUGH=ya;var TEXT_FORMAT_TRANSFORMERS=Da;var TEXT_MATCH_TRANSFORMERS=Ea;var TRANSFORMERS=Z$1;var UNORDERED_LIST=oa;
var registerMarkdownShortcuts=function(a,b=Z$1){let c=I(b),d=H$1(c.textFormat,({tag:f})=>f[f.length-1]),e=H$1(c.textMatch,({trigger:f})=>f);for(let f of b)if(b=f.type,("element"===b||"text-match"===b)&&!a.hasNodes(f.dependencies))throw Error("Minified Lexical error #79; visit https://lexical.dev/docs/error?code=79 for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");return a.registerUpdateListener(({tags:f,dirtyLeaves:l,editorState:k,prevEditorState:p})=>
{if(!f.has("historic")){var r=k.read(Lexical_1.$getSelection);f=p.read(Lexical_1.$getSelection);if(Lexical_1.$isRangeSelection(f)&&Lexical_1.$isRangeSelection(r)&&r.isCollapsed()){p=r.anchor.key;var y=r.anchor.offset,q=k._nodeMap.get(p);Lexical_1.$isTextNode(q)&&l.has(p)&&(1===y||y===f.anchor.offset+1)&&a.update(()=>{if(!q.hasFormat("code")){var m=q.getParent();if(null!==m&&!LexicalCode_1.$isCodeNode(m)){var w=r.anchor.offset;b:{var g=c.element,n=m.getParent();if(Lexical_1.$isRootOrShadowRoot(n)&&m.getFirstChild()===q&&(n=q.getTextContent()," "===n[w-1]))for(let {regExp:D,
replace:E}of g)if((g=n.match(D))&&g[0].length===w){n=q.getNextSiblings();let [F,ua]=q.splitText(w);F.remove();n=ua?[ua,...n]:n;E(m,n,g,!1);m=!0;break b}m=!1;}if(!m){b:{g=q.getTextContent();m=e[g[w-1]];if(null!=m){w<g.length&&(g=g.slice(0,w));for(x of m)if(m=g.match(x.regExp),null!==m){g=m.index||0;n=g+m[0].length;var v=void 0;0===g?[v]=q.splitText(n):[,v]=q.splitText(g,n);v.selectNext(0,0);x.replace(v,m);var x=!0;break b}}x=!1;}if(!x)b:{n=q.getTextContent();--w;var u=n[w];if(x=d[u])for(let D of x){var {tag:C}=
D;x=C.length;let E=w-x+1;if(!(1<x&&!W$1(n,E,C,0,x)||" "===n[E-1])&&(v=n[w+1],!1!==D.intraword||!v||J.test(v))){m=v=q;g=V$1(n,E,C);for(var z=m;0>g&&(z=z.getPreviousSibling())&&!Lexical_1.$isLineBreakNode(z);)Lexical_1.$isTextNode(z)&&(g=z.getTextContent(),m=z,g=V$1(g,g.length,C));if(!(0>g||m===v&&g+x===E||(C=m.getTextContent(),0<g&&C[g-1]===u||(z=C[g-1],!1===D.intraword&&z&&!J.test(z))))){n=v.getTextContent();n=n.slice(0,E)+n.slice(w+1);v.setTextContent(n);n=m===v?n:C;m.setTextContent(n.slice(0,g)+n.slice(g+x));n=Lexical_1.$getSelection();
u=Lexical_1.$createRangeSelection();Lexical_1.$setSelection(u);w=w-x*(m===v?2:1)+1;u.anchor.set(m.__key,g,"text");u.focus.set(v.__key,w,"text");for(let F of D.format)u.hasFormat(F)||u.formatText(F);u.anchor.set(u.focus.key,u.focus.offset,u.focus.type);for(let F of D.format)u.hasFormat(F)&&u.toggleFormat(F);Lexical_1.$isRangeSelection(n)&&(u.format=n.format);break b}}}}}}}});}}})};

var LexicalMarkdown_prod = {
	$convertFromMarkdownString: $convertFromMarkdownString,
	$convertToMarkdownString: $convertToMarkdownString,
	BOLD_ITALIC_STAR: BOLD_ITALIC_STAR,
	BOLD_ITALIC_UNDERSCORE: BOLD_ITALIC_UNDERSCORE,
	BOLD_STAR: BOLD_STAR,
	BOLD_UNDERSCORE: BOLD_UNDERSCORE,
	CHECK_LIST: CHECK_LIST,
	CODE: CODE,
	ELEMENT_TRANSFORMERS: ELEMENT_TRANSFORMERS,
	HEADING: HEADING,
	HIGHLIGHT: HIGHLIGHT,
	INLINE_CODE: INLINE_CODE,
	ITALIC_STAR: ITALIC_STAR,
	ITALIC_UNDERSCORE: ITALIC_UNDERSCORE,
	LINK: LINK,
	ORDERED_LIST: ORDERED_LIST,
	QUOTE: QUOTE,
	STRIKETHROUGH: STRIKETHROUGH,
	TEXT_FORMAT_TRANSFORMERS: TEXT_FORMAT_TRANSFORMERS,
	TEXT_MATCH_TRANSFORMERS: TEXT_MATCH_TRANSFORMERS,
	TRANSFORMERS: TRANSFORMERS,
	UNORDERED_LIST: UNORDERED_LIST,
	registerMarkdownShortcuts: registerMarkdownShortcuts
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const LexicalMarkdown = process.env.NODE_ENV === 'development' ? LexicalMarkdown_dev : LexicalMarkdown_prod;
var LexicalMarkdown_1 = LexicalMarkdown;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const LexicalComposerContext$2 = /*#__PURE__*/React__default.createContext(null);
function createLexicalComposerContext$1(parent, theme) {
  let parentContext = null;

  if (parent != null) {
    parentContext = parent[1];
  }

  function getTheme() {
    if (theme != null) {
      return theme;
    }

    return parentContext != null ? parentContext.getTheme() : null;
  }

  return {
    getTheme
  };
}
function useLexicalComposerContext$1() {
  const composerContext = React__default.useContext(LexicalComposerContext$2);

  if (composerContext == null) {
    {
      throw Error(`LexicalComposerContext.useLexicalComposerContext: cannot find a LexicalComposerContext`);
    }
  }

  return composerContext;
}

var LexicalComposerContext_1$1 = LexicalComposerContext$2;
var createLexicalComposerContext_1 = createLexicalComposerContext$1;
var useLexicalComposerContext_1 = useLexicalComposerContext$1;

var LexicalComposerContext_dev = {
	LexicalComposerContext: LexicalComposerContext_1$1,
	createLexicalComposerContext: createLexicalComposerContext_1,
	useLexicalComposerContext: useLexicalComposerContext_1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
let d=React__default.createContext(null);var LexicalComposerContext$1=d;var createLexicalComposerContext=function(a,e){let b=null;null!=a&&(b=a[1]);return {getTheme:function(){return null!=e?e:null!=b?b.getTheme():null}}};
var useLexicalComposerContext=function(){let a=React__default.useContext(d);if(null==a)throw Error("Minified Lexical error #8; visit https://lexical.dev/docs/error?code=8 for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");return a};

var LexicalComposerContext_prod = {
	LexicalComposerContext: LexicalComposerContext$1,
	createLexicalComposerContext: createLexicalComposerContext,
	useLexicalComposerContext: useLexicalComposerContext
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const LexicalComposerContext = process.env.NODE_ENV === 'development' ? LexicalComposerContext_dev : LexicalComposerContext_prod;
var LexicalComposerContext_1 = LexicalComposerContext;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */




/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
function AutoFocusPlugin$1({
  defaultSelection
}) {
  const [editor] = LexicalComposerContext_1.useLexicalComposerContext();
  React__default.useEffect(() => {
    editor.focus(() => {
      // If we try and move selection to the same point with setBaseAndExtent, it won't
      // trigger a re-focus on the element. So in the case this occurs, we'll need to correct it.
      // Normally this is fine, Selection API !== Focus API, but fore the intents of the naming
      // of this plugin, which should preserve focus too.
      const activeElement = document.activeElement;
      const rootElement = editor.getRootElement();

      if (rootElement !== null && (activeElement === null || !rootElement.contains(activeElement))) {
        // Note: preventScroll won't work in Webkit.
        rootElement.focus({
          preventScroll: true
        });
      }
    }, {
      defaultSelection
    });
  }, [defaultSelection, editor]);
  return null;
}

var AutoFocusPlugin_1 = AutoFocusPlugin$1;

var LexicalAutoFocusPlugin_dev = {
	AutoFocusPlugin: AutoFocusPlugin_1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var AutoFocusPlugin=function({defaultSelection:c}){let [a]=LexicalComposerContext_1.useLexicalComposerContext();React__default.useEffect(()=>{a.focus(()=>{let d=document.activeElement,b=a.getRootElement();null===b||null!==d&&b.contains(d)||b.focus({preventScroll:!0});},{defaultSelection:c});},[c,a]);return null};

var LexicalAutoFocusPlugin_prod = {
	AutoFocusPlugin: AutoFocusPlugin
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const LexicalAutoFocusPlugin = process.env.NODE_ENV === 'development' ? LexicalAutoFocusPlugin_dev : LexicalAutoFocusPlugin_prod;
var LexicalAutoFocusPlugin_1 = LexicalAutoFocusPlugin;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */







/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

function domGetParent(node, predicate) {
  let parent = node.parentNode;

  while (parent != null) {
    if (predicate(parent)) {
      return parent;
    }

    parent = parent.parentNode;
  }

  return null;
}

function LexicalClickableLinkPlugin$1({
  newTab = true
}) {
  const [editor] = LexicalComposerContext_1.useLexicalComposerContext();
  React__default.useEffect(() => {
    const onClick = event => {
      const target = event.target;

      if (!(target instanceof Node)) {
        return;
      }

      const nearestEditor = Lexical_1.getNearestEditorFromDOMNode(target);

      if (nearestEditor === null) {
        return;
      }

      let url = null;
      let urlTarget = null;
      nearestEditor.update(() => {
        const clickedNode = Lexical_1.$getNearestNodeFromDOMNode(target);

        if (clickedNode !== null) {
          const maybeLinkNode = LexicalUtils_1.$findMatchingParent(clickedNode, Lexical_1.$isElementNode);

          if (LexicalLink_1.$isLinkNode(maybeLinkNode)) {
            url = maybeLinkNode.getURL();
            urlTarget = maybeLinkNode.getTarget();
          } else {
            const a = LexicalUtils_1.isHTMLAnchorElement(target) ? target : domGetParent(target, LexicalUtils_1.isHTMLAnchorElement);
            url = a.href;
            urlTarget = a.target;
          }
        }
      });

      if (url === null || url === '') {
        return;
      } // Allow user to select link text without follwing url


      const selection = editor.getEditorState().read(Lexical_1.$getSelection);

      if (Lexical_1.$isRangeSelection(selection) && !selection.isCollapsed()) {
        event.preventDefault();
        return;
      }

      const isMiddle = event.type === 'auxclick' && event.button === 1;
      window.open(url, newTab || isMiddle || event.metaKey || event.ctrlKey || urlTarget === '_blank' ? '_blank' : '_self');
      event.preventDefault();
    };

    const onMouseUp = event => {
      if (event.button === 1 && editor.isEditable()) {
        onClick(event);
      }
    };

    return editor.registerRootListener((rootElement, prevRootElement) => {
      if (prevRootElement !== null) {
        prevRootElement.removeEventListener('click', onClick);
        prevRootElement.removeEventListener('mouseup', onMouseUp);
      }

      if (rootElement !== null) {
        rootElement.addEventListener('click', onClick);
        rootElement.addEventListener('mouseup', onMouseUp);
      }
    });
  }, [editor, newTab]);
  return null;
}

var LexicalClickableLinkPlugin_dev = LexicalClickableLinkPlugin$1;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var LexicalClickableLinkPlugin_prod=function({newTab:n=!0}){let [h]=LexicalComposerContext_1.useLexicalComposerContext();React__default.useEffect(()=>{let m=a=>{const c=a.target;if(c instanceof Node){var d=Lexical_1.getNearestEditorFromDOMNode(c);if(null!==d){var f=null,l=null;d.update(()=>{var b=Lexical_1.$getNearestNodeFromDOMNode(c);if(null!==b)if(b=LexicalUtils_1.$findMatchingParent(b,Lexical_1.$isElementNode),LexicalLink_1.$isLinkNode(b))f=b.getURL(),l=b.getTarget();else {if(LexicalUtils_1.isHTMLAnchorElement(c))b=c;else a:{b=LexicalUtils_1.isHTMLAnchorElement;let g=c.parentNode;for(;null!=g;){if(b(g)){b=g;break a}g=g.parentNode;}b=
null;}f=b.href;l=b.target;}});if(null!==f&&""!==f){d=h.getEditorState().read(Lexical_1.$getSelection);if(!Lexical_1.$isRangeSelection(d)||d.isCollapsed())d="auxclick"===a.type&&1===a.button,window.open(f,n||d||a.metaKey||a.ctrlKey||"_blank"===l?"_blank":"_self");a.preventDefault();}}}},p=a=>{1===a.button&&h.isEditable()&&m(a);};return h.registerRootListener((a,c)=>{null!==c&&(c.removeEventListener("click",m),c.removeEventListener("mouseup",p));null!==a&&(a.addEventListener("click",m),a.addEventListener("mouseup",p));})},
[h,n]);return null};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const LexicalClickableLinkPlugin = process.env.NODE_ENV === 'development' ? LexicalClickableLinkPlugin_dev : LexicalClickableLinkPlugin_prod;
var LexicalClickableLinkPlugin_1 = LexicalClickableLinkPlugin;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */





/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const CAN_USE_DOM$4 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const useLayoutEffectImpl$4 = CAN_USE_DOM$4 ? React__default.useLayoutEffect : React__default.useEffect;
var useLayoutEffect$4 = useLayoutEffectImpl$4;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const HISTORY_MERGE_OPTIONS = {
  tag: 'history-merge'
};
function LexicalComposer$2({
  initialConfig,
  children
}) {
  const composerContext = React__default.useMemo(() => {
    const {
      theme,
      namespace,
      editor__DEPRECATED: initialEditor,
      nodes,
      onError,
      editorState: initialEditorState
    } = initialConfig;
    const context = LexicalComposerContext_1.createLexicalComposerContext(null, theme);
    let editor = initialEditor || null;

    if (editor === null) {
      const newEditor = Lexical_1.createEditor({
        editable: initialConfig.editable,
        namespace,
        nodes,
        onError: error => onError(error, newEditor),
        theme
      });
      initializeEditor(newEditor, initialEditorState);
      editor = newEditor;
    }

    return [editor, context];
  }, // We only do this for init
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  useLayoutEffect$4(() => {
    const isEditable = initialConfig.editable;
    const [editor] = composerContext;
    editor.setEditable(isEditable !== undefined ? isEditable : true); // We only do this for init
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React__default.createElement(LexicalComposerContext_1.LexicalComposerContext.Provider, {
    value: composerContext
  }, children);
}

function initializeEditor(editor, initialEditorState) {
  if (initialEditorState === null) {
    return;
  } else if (initialEditorState === undefined) {
    editor.update(() => {
      const root = Lexical_1.$getRoot();

      if (root.isEmpty()) {
        const paragraph = Lexical_1.$createParagraphNode();
        root.append(paragraph);
        const activeElement = CAN_USE_DOM$4 ? document.activeElement : null;

        if (Lexical_1.$getSelection() !== null || activeElement !== null && activeElement === editor.getRootElement()) {
          paragraph.select();
        }
      }
    }, HISTORY_MERGE_OPTIONS);
  } else if (initialEditorState !== null) {
    switch (typeof initialEditorState) {
      case 'string':
        {
          const parsedEditorState = editor.parseEditorState(initialEditorState);
          editor.setEditorState(parsedEditorState, HISTORY_MERGE_OPTIONS);
          break;
        }

      case 'object':
        {
          editor.setEditorState(initialEditorState, HISTORY_MERGE_OPTIONS);
          break;
        }

      case 'function':
        {
          editor.update(() => {
            const root = Lexical_1.$getRoot();

            if (root.isEmpty()) {
              initialEditorState(editor);
            }
          }, HISTORY_MERGE_OPTIONS);
          break;
        }
    }
  }
}

var LexicalComposer_1$1 = LexicalComposer$2;

var LexicalComposer_dev = {
	LexicalComposer: LexicalComposer_1$1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
let m$2="undefined"!==typeof window&&"undefined"!==typeof window.document&&"undefined"!==typeof window.document.createElement;var n$1=m$2?React__default.useLayoutEffect:React__default.useEffect;let p$2={tag:"history-merge"};
function q$2(a,c){if(null!==c)if(void 0===c)a.update(()=>{var b=Lexical_1.$getRoot();if(b.isEmpty()){let d=Lexical_1.$createParagraphNode();b.append(d);b=m$2?document.activeElement:null;(null!==Lexical_1.$getSelection()||null!==b&&b===a.getRootElement())&&d.select();}},p$2);else if(null!==c)switch(typeof c){case "string":let b=a.parseEditorState(c);a.setEditorState(b,p$2);break;case "object":a.setEditorState(c,p$2);break;case "function":a.update(()=>{Lexical_1.$getRoot().isEmpty()&&c(a);},p$2);}}
var LexicalComposer$1=function({initialConfig:a,children:c}){let b=React__default.useMemo(()=>{const {theme:d,namespace:h,editor__DEPRECATED:r,nodes:t,onError:u,editorState:v}=a,w=LexicalComposerContext_1.createLexicalComposerContext(null,d);let k=r||null;if(null===k){const l=Lexical_1.createEditor({editable:a.editable,namespace:h,nodes:t,onError:x=>u(x,l),theme:d});q$2(l,v);k=l;}return [k,w]},[]);n$1(()=>{let d=a.editable,[h]=b;h.setEditable(void 0!==d?d:!0);},[]);return React__default.createElement(LexicalComposerContext_1.LexicalComposerContext.Provider,{value:b},c)};

var LexicalComposer_prod = {
	LexicalComposer: LexicalComposer$1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const LexicalComposer = process.env.NODE_ENV === 'development' ? LexicalComposer_dev : LexicalComposer_prod;
var LexicalComposer_1 = LexicalComposer;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */




/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const CAN_USE_DOM$3 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const useLayoutEffectImpl$3 = CAN_USE_DOM$3 ? React__default.useLayoutEffect : React__default.useEffect;
var useLayoutEffect$3 = useLayoutEffectImpl$3;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
function ContentEditable$1({
  ariaActiveDescendant,
  ariaAutoComplete,
  ariaControls,
  ariaDescribedBy,
  ariaExpanded,
  ariaLabel,
  ariaLabelledBy,
  ariaMultiline,
  ariaOwns,
  ariaRequired,
  autoCapitalize,
  className,
  id,
  role = 'textbox',
  spellCheck = true,
  style,
  tabIndex,
  'data-testid': testid
}) {
  const [editor] = LexicalComposerContext_1.useLexicalComposerContext();
  const [isEditable, setEditable] = React__default.useState(false);
  const ref = React__default.useCallback(rootElement => {
    editor.setRootElement(rootElement);
  }, [editor]);
  useLayoutEffect$3(() => {
    setEditable(editor.isEditable());
    return editor.registerEditableListener(currentIsEditable => {
      setEditable(currentIsEditable);
    });
  }, [editor]);
  return /*#__PURE__*/React__default.createElement("div", {
    "aria-activedescendant": !isEditable ? undefined : ariaActiveDescendant,
    "aria-autocomplete": !isEditable ? 'none' : ariaAutoComplete,
    "aria-controls": !isEditable ? undefined : ariaControls,
    "aria-describedby": ariaDescribedBy,
    "aria-expanded": !isEditable ? undefined : role === 'combobox' ? !!ariaExpanded : undefined,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    "aria-multiline": ariaMultiline,
    "aria-owns": !isEditable ? undefined : ariaOwns,
    "aria-required": ariaRequired,
    autoCapitalize: autoCapitalize,
    className: className,
    contentEditable: isEditable,
    "data-testid": testid,
    id: id,
    ref: ref,
    role: !isEditable ? undefined : role,
    spellCheck: spellCheck,
    style: style,
    tabIndex: tabIndex
  });
}

var ContentEditable_1 = ContentEditable$1;

var LexicalContentEditable_dev = {
	ContentEditable: ContentEditable_1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var h$1="undefined"!==typeof window&&"undefined"!==typeof window.document&&"undefined"!==typeof window.document.createElement?React__default.useLayoutEffect:React__default.useEffect;
var ContentEditable=function({ariaActiveDescendant:k,ariaAutoComplete:l,ariaControls:m,ariaDescribedBy:n,ariaExpanded:p,ariaLabel:q,ariaLabelledBy:r,ariaMultiline:t,ariaOwns:u,ariaRequired:v,autoCapitalize:w,className:x,id:y,role:e="textbox",spellCheck:z=!0,style:A,tabIndex:B,"data-testid":C}){let [c]=LexicalComposerContext_1.useLexicalComposerContext(),[a,f]=React__default.useState(!1),D=React__default.useCallback(d=>{c.setRootElement(d);},[c]);h$1(()=>{f(c.isEditable());return c.registerEditableListener(d=>{f(d);})},[c]);return React__default.createElement("div",
{"aria-activedescendant":a?k:void 0,"aria-autocomplete":a?l:"none","aria-controls":a?m:void 0,"aria-describedby":n,"aria-expanded":a?"combobox"===e?!!p:void 0:void 0,"aria-label":q,"aria-labelledby":r,"aria-multiline":t,"aria-owns":a?u:void 0,"aria-required":v,autoCapitalize:w,className:x,contentEditable:a,"data-testid":C,id:y,ref:D,role:a?e:void 0,spellCheck:z,style:A,tabIndex:B})};

var LexicalContentEditable_prod = {
	ContentEditable: ContentEditable
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const LexicalContentEditable = process.env.NODE_ENV === 'development' ? LexicalContentEditable_dev : LexicalContentEditable_prod;
var LexicalContentEditable_1 = LexicalContentEditable;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

var changedArray = function changedArray(a, b) {
  if (a === void 0) {
    a = [];
  }

  if (b === void 0) {
    b = [];
  }

  return a.length !== b.length || a.some(function (item, index) {
    return !Object.is(item, b[index]);
  });
};

var initialState = {
  error: null
};

var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ErrorBoundary, _React$Component);

  function ErrorBoundary() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
    _this.state = initialState;

    _this.resetErrorBoundary = function () {
      var _this$props;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      _this.props.onReset == null ? void 0 : (_this$props = _this.props).onReset.apply(_this$props, args);

      _this.reset();
    };

    return _this;
  }

  ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
    return {
      error: error
    };
  };

  var _proto = ErrorBoundary.prototype;

  _proto.reset = function reset() {
    this.setState(initialState);
  };

  _proto.componentDidCatch = function componentDidCatch(error, info) {
    var _this$props$onError, _this$props2;

    (_this$props$onError = (_this$props2 = this.props).onError) == null ? void 0 : _this$props$onError.call(_this$props2, error, info);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var error = this.state.error;
    var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
    // happens to *also* be in the resetKeys array, we'd end up resetting
    // the error boundary immediately. This would likely trigger a second
    // error to be thrown.
    // So we make sure that we don't check the resetKeys on the first call
    // of cDU after the error is set

    if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
      var _this$props$onResetKe, _this$props3;

      (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null ? void 0 : _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
      this.reset();
    }
  };

  _proto.render = function render() {
    var error = this.state.error;
    var _this$props4 = this.props,
        fallbackRender = _this$props4.fallbackRender,
        FallbackComponent = _this$props4.FallbackComponent,
        fallback = _this$props4.fallback;

    if (error !== null) {
      var _props = {
        error: error,
        resetErrorBoundary: this.resetErrorBoundary
      };

      if ( /*#__PURE__*/React__default.isValidElement(fallback)) {
        return fallback;
      } else if (typeof fallbackRender === 'function') {
        return fallbackRender(_props);
      } else if (FallbackComponent) {
        return /*#__PURE__*/React__default.createElement(FallbackComponent, _props);
      } else {
        throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
      }
    }

    return this.props.children;
  };

  return ErrorBoundary;
}(React__default.Component);

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
function LexicalErrorBoundary$1({
  children,
  onError
}) {
  return /*#__PURE__*/React__default.createElement(ErrorBoundary, {
    fallback: /*#__PURE__*/React__default.createElement("div", {
      style: {
        border: '1px solid #f00',
        color: '#f00',
        padding: '8px'
      }
    }, "An error was thrown."),
    onError: onError
  }, children);
}

var LexicalErrorBoundary_dev = LexicalErrorBoundary$1;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function m$1(b,c){m$1=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(g,a){g.__proto__=a;return g};return m$1(b,c)}function n(b,c){b.prototype=Object.create(c.prototype);b.prototype.constructor=b;m$1(b,c);}function r$4(b,c){void 0===b&&(b=[]);void 0===c&&(c=[]);return b.length!==c.length||b.some(function(g,a){return !Object.is(g,c[a])})}
var t$2={error:null},u$3=function(b){function c(){for(var a,d=arguments.length,f=Array(d),e=0;e<d;e++)f[e]=arguments[e];a=b.call.apply(b,[this].concat(f))||this;a.state=t$2;a.resetErrorBoundary=function(){for(var k,p=arguments.length,q=Array(p),l=0;l<p;l++)q[l]=arguments[l];null==a.props.onReset?void 0:(k=a.props).onReset.apply(k,q);a.reset();};return a}n(c,b);c.getDerivedStateFromError=function(a){return {error:a}};var g=c.prototype;g.reset=function(){this.setState(t$2);};g.componentDidCatch=function(a,d){var f,
e;null==(f=(e=this.props).onError)?void 0:f.call(e,a,d);};g.componentDidUpdate=function(a,d){var f=this.props.resetKeys;if(null!==this.state.error&&null!==d.error&&r$4(a.resetKeys,f)){var e,k;null==(e=(k=this.props).onResetKeysChange)?void 0:e.call(k,a.resetKeys,f);this.reset();}};g.render=function(){var a=this.state.error,d=this.props,f=d.fallbackRender,e=d.FallbackComponent;d=d.fallback;if(null!==a){a={error:a,resetErrorBoundary:this.resetErrorBoundary};if(React__default.isValidElement(d))return d;if("function"===
typeof f)return f(a);if(e)return React__default.createElement(e,a);throw Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");}return this.props.children};return c}(React__default.Component);var LexicalErrorBoundary_prod=function({children:b,onError:c}){return React__default.createElement(u$3,{fallback:React__default.createElement("div",{style:{border:"1px solid #f00",color:"#f00",padding:"8px"}},"An error was thrown."),onError:c},b)};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const LexicalErrorBoundary = process.env.NODE_ENV === 'development' ? LexicalErrorBoundary_dev : LexicalErrorBoundary_prod;
var LexicalErrorBoundary_1 = LexicalErrorBoundary;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */




/** @module @lexical/history */
const HISTORY_MERGE = 0;
const HISTORY_PUSH = 1;
const DISCARD_HISTORY_CANDIDATE = 2;
const OTHER = 0;
const COMPOSING_CHARACTER = 1;
const INSERT_CHARACTER_AFTER_SELECTION = 2;
const DELETE_CHARACTER_BEFORE_SELECTION = 3;
const DELETE_CHARACTER_AFTER_SELECTION = 4;

function getDirtyNodes(editorState, dirtyLeaves, dirtyElements) {
  const nodeMap = editorState._nodeMap;
  const nodes = [];

  for (const dirtyLeafKey of dirtyLeaves) {
    const dirtyLeaf = nodeMap.get(dirtyLeafKey);

    if (dirtyLeaf !== undefined) {
      nodes.push(dirtyLeaf);
    }
  }

  for (const [dirtyElementKey, intentionallyMarkedAsDirty] of dirtyElements) {
    if (!intentionallyMarkedAsDirty) {
      continue;
    }

    const dirtyElement = nodeMap.get(dirtyElementKey);

    if (dirtyElement !== undefined && !Lexical_1.$isRootNode(dirtyElement)) {
      nodes.push(dirtyElement);
    }
  }

  return nodes;
}

function getChangeType(prevEditorState, nextEditorState, dirtyLeavesSet, dirtyElementsSet, isComposing) {
  if (prevEditorState === null || dirtyLeavesSet.size === 0 && dirtyElementsSet.size === 0 && !isComposing) {
    return OTHER;
  }

  const nextSelection = nextEditorState._selection;
  const prevSelection = prevEditorState._selection;

  if (isComposing) {
    return COMPOSING_CHARACTER;
  }

  if (!Lexical_1.$isRangeSelection(nextSelection) || !Lexical_1.$isRangeSelection(prevSelection) || !prevSelection.isCollapsed() || !nextSelection.isCollapsed()) {
    return OTHER;
  }

  const dirtyNodes = getDirtyNodes(nextEditorState, dirtyLeavesSet, dirtyElementsSet);

  if (dirtyNodes.length === 0) {
    return OTHER;
  } // Catching the case when inserting new text node into an element (e.g. first char in paragraph/list),
  // or after existing node.


  if (dirtyNodes.length > 1) {
    const nextNodeMap = nextEditorState._nodeMap;
    const nextAnchorNode = nextNodeMap.get(nextSelection.anchor.key);
    const prevAnchorNode = nextNodeMap.get(prevSelection.anchor.key);

    if (nextAnchorNode && prevAnchorNode && !prevEditorState._nodeMap.has(nextAnchorNode.__key) && Lexical_1.$isTextNode(nextAnchorNode) && nextAnchorNode.__text.length === 1 && nextSelection.anchor.offset === 1) {
      return INSERT_CHARACTER_AFTER_SELECTION;
    }

    return OTHER;
  }

  const nextDirtyNode = dirtyNodes[0];

  const prevDirtyNode = prevEditorState._nodeMap.get(nextDirtyNode.__key);

  if (!Lexical_1.$isTextNode(prevDirtyNode) || !Lexical_1.$isTextNode(nextDirtyNode) || prevDirtyNode.__mode !== nextDirtyNode.__mode) {
    return OTHER;
  }

  const prevText = prevDirtyNode.__text;
  const nextText = nextDirtyNode.__text;

  if (prevText === nextText) {
    return OTHER;
  }

  const nextAnchor = nextSelection.anchor;
  const prevAnchor = prevSelection.anchor;

  if (nextAnchor.key !== prevAnchor.key || nextAnchor.type !== 'text') {
    return OTHER;
  }

  const nextAnchorOffset = nextAnchor.offset;
  const prevAnchorOffset = prevAnchor.offset;
  const textDiff = nextText.length - prevText.length;

  if (textDiff === 1 && prevAnchorOffset === nextAnchorOffset - 1) {
    return INSERT_CHARACTER_AFTER_SELECTION;
  }

  if (textDiff === -1 && prevAnchorOffset === nextAnchorOffset + 1) {
    return DELETE_CHARACTER_BEFORE_SELECTION;
  }

  if (textDiff === -1 && prevAnchorOffset === nextAnchorOffset) {
    return DELETE_CHARACTER_AFTER_SELECTION;
  }

  return OTHER;
}

function isTextNodeUnchanged(key, prevEditorState, nextEditorState) {
  const prevNode = prevEditorState._nodeMap.get(key);

  const nextNode = nextEditorState._nodeMap.get(key);

  const prevSelection = prevEditorState._selection;
  const nextSelection = nextEditorState._selection;
  let isDeletingLine = false;

  if (Lexical_1.$isRangeSelection(prevSelection) && Lexical_1.$isRangeSelection(nextSelection)) {
    isDeletingLine = prevSelection.anchor.type === 'element' && prevSelection.focus.type === 'element' && nextSelection.anchor.type === 'text' && nextSelection.focus.type === 'text';
  }

  if (!isDeletingLine && Lexical_1.$isTextNode(prevNode) && Lexical_1.$isTextNode(nextNode)) {
    return prevNode.__type === nextNode.__type && prevNode.__text === nextNode.__text && prevNode.__mode === nextNode.__mode && prevNode.__detail === nextNode.__detail && prevNode.__style === nextNode.__style && prevNode.__format === nextNode.__format && prevNode.__parent === nextNode.__parent;
  }

  return false;
}

function createMergeActionGetter(editor, delay) {
  let prevChangeTime = Date.now();
  let prevChangeType = OTHER;
  return (prevEditorState, nextEditorState, currentHistoryEntry, dirtyLeaves, dirtyElements, tags) => {
    const changeTime = Date.now(); // If applying changes from history stack there's no need
    // to run history logic again, as history entries already calculated

    if (tags.has('historic')) {
      prevChangeType = OTHER;
      prevChangeTime = changeTime;
      return DISCARD_HISTORY_CANDIDATE;
    }

    const changeType = getChangeType(prevEditorState, nextEditorState, dirtyLeaves, dirtyElements, editor.isComposing());

    const mergeAction = (() => {
      const isSameEditor = currentHistoryEntry === null || currentHistoryEntry.editor === editor;
      const shouldPushHistory = tags.has('history-push');
      const shouldMergeHistory = !shouldPushHistory && isSameEditor && tags.has('history-merge');

      if (shouldMergeHistory) {
        return HISTORY_MERGE;
      }

      if (prevEditorState === null) {
        return HISTORY_PUSH;
      }

      const selection = nextEditorState._selection;
      const hasDirtyNodes = dirtyLeaves.size > 0 || dirtyElements.size > 0;

      if (!hasDirtyNodes) {
        if (selection !== null) {
          return HISTORY_MERGE;
        }

        return DISCARD_HISTORY_CANDIDATE;
      }

      if (shouldPushHistory === false && changeType !== OTHER && changeType === prevChangeType && changeTime < prevChangeTime + delay && isSameEditor) {
        return HISTORY_MERGE;
      } // A single node might have been marked as dirty, but not have changed
      // due to some node transform reverting the change.


      if (dirtyLeaves.size === 1) {
        const dirtyLeafKey = Array.from(dirtyLeaves)[0];

        if (isTextNodeUnchanged(dirtyLeafKey, prevEditorState, nextEditorState)) {
          return HISTORY_MERGE;
        }
      }

      return HISTORY_PUSH;
    })();

    prevChangeTime = changeTime;
    prevChangeType = changeType;
    return mergeAction;
  };
}

function redo(editor, historyState) {
  const redoStack = historyState.redoStack;
  const undoStack = historyState.undoStack;

  if (redoStack.length !== 0) {
    const current = historyState.current;

    if (current !== null) {
      undoStack.push(current);
      editor.dispatchCommand(Lexical_1.CAN_UNDO_COMMAND, true);
    }

    const historyStateEntry = redoStack.pop();

    if (redoStack.length === 0) {
      editor.dispatchCommand(Lexical_1.CAN_REDO_COMMAND, false);
    }

    historyState.current = historyStateEntry || null;

    if (historyStateEntry) {
      historyStateEntry.editor.setEditorState(historyStateEntry.editorState, {
        tag: 'historic'
      });
    }
  }
}

function undo(editor, historyState) {
  const redoStack = historyState.redoStack;
  const undoStack = historyState.undoStack;
  const undoStackLength = undoStack.length;

  if (undoStackLength !== 0) {
    const current = historyState.current;
    const historyStateEntry = undoStack.pop();

    if (current !== null) {
      redoStack.push(current);
      editor.dispatchCommand(Lexical_1.CAN_REDO_COMMAND, true);
    }

    if (undoStack.length === 0) {
      editor.dispatchCommand(Lexical_1.CAN_UNDO_COMMAND, false);
    }

    historyState.current = historyStateEntry || null;

    if (historyStateEntry) {
      historyStateEntry.editor.setEditorState(historyStateEntry.editorState.clone(historyStateEntry.undoSelection), {
        tag: 'historic'
      });
    }
  }
}

function clearHistory(historyState) {
  historyState.undoStack = [];
  historyState.redoStack = [];
  historyState.current = null;
}
/**
 * Registers necessary listeners to manage undo/redo history stack and related editor commands.
 * It returns `unregister` callback that cleans up all listeners and should be called on editor unmount.
 * @param editor - The lexical editor.
 * @param historyState - The history state, containing the current state and the undo/redo stack.
 * @param delay - The time (in milliseconds) the editor should delay generating a new history stack,
 * instead of merging the current changes with the current stack.
 * @returns The listeners cleanup callback function.
 */


function registerHistory$1(editor, historyState, delay) {
  const getMergeAction = createMergeActionGetter(editor, delay);

  const applyChange = ({
    editorState,
    prevEditorState,
    dirtyLeaves,
    dirtyElements,
    tags
  }) => {
    const current = historyState.current;
    const redoStack = historyState.redoStack;
    const undoStack = historyState.undoStack;
    const currentEditorState = current === null ? null : current.editorState;

    if (current !== null && editorState === currentEditorState) {
      return;
    }

    const mergeAction = getMergeAction(prevEditorState, editorState, current, dirtyLeaves, dirtyElements, tags);

    if (mergeAction === HISTORY_PUSH) {
      if (redoStack.length !== 0) {
        historyState.redoStack = [];
        editor.dispatchCommand(Lexical_1.CAN_REDO_COMMAND, false);
      }

      if (current !== null) {
        undoStack.push({ ...current,
          undoSelection: prevEditorState.read(Lexical_1.$getSelection)
        });
        editor.dispatchCommand(Lexical_1.CAN_UNDO_COMMAND, true);
      }
    } else if (mergeAction === DISCARD_HISTORY_CANDIDATE) {
      return;
    } // Else we merge


    historyState.current = {
      editor,
      editorState
    };
  };

  const unregisterCommandListener = LexicalUtils_1.mergeRegister(editor.registerCommand(Lexical_1.UNDO_COMMAND, () => {
    undo(editor, historyState);
    return true;
  }, Lexical_1.COMMAND_PRIORITY_EDITOR), editor.registerCommand(Lexical_1.REDO_COMMAND, () => {
    redo(editor, historyState);
    return true;
  }, Lexical_1.COMMAND_PRIORITY_EDITOR), editor.registerCommand(Lexical_1.CLEAR_EDITOR_COMMAND, () => {
    clearHistory(historyState);
    return false;
  }, Lexical_1.COMMAND_PRIORITY_EDITOR), editor.registerCommand(Lexical_1.CLEAR_HISTORY_COMMAND, () => {
    clearHistory(historyState);
    editor.dispatchCommand(Lexical_1.CAN_REDO_COMMAND, false);
    editor.dispatchCommand(Lexical_1.CAN_UNDO_COMMAND, false);
    return true;
  }, Lexical_1.COMMAND_PRIORITY_EDITOR), editor.registerUpdateListener(applyChange));
  const unregisterUpdateListener = editor.registerUpdateListener(applyChange);
  return () => {
    unregisterCommandListener();
    unregisterUpdateListener();
  };
}
/**
 * Creates an empty history state.
 * @returns - The empty history state, as an object.
 */

function createEmptyHistoryState$3() {
  return {
    current: null,
    redoStack: [],
    undoStack: []
  };
}

var createEmptyHistoryState_1 = createEmptyHistoryState$3;
var registerHistory_1 = registerHistory$1;

var LexicalHistory_dev = {
	createEmptyHistoryState: createEmptyHistoryState_1,
	registerHistory: registerHistory_1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function y(b,a,m,k,p){if(null===b||0===m.size&&0===k.size&&!p)return 0;var f=a._selection,d=b._selection;if(p)return 1;if(!(Lexical_1.$isRangeSelection(f)&&Lexical_1.$isRangeSelection(d)&&d.isCollapsed()&&f.isCollapsed()))return 0;p=a._nodeMap;let e=[];for(let g of m)m=p.get(g),void 0!==m&&e.push(m);for(let [g,n]of k)n&&(k=p.get(g),void 0===k||Lexical_1.$isRootNode(k)||e.push(k));if(0===e.length)return 0;if(1<e.length)return k=a._nodeMap,a=k.get(f.anchor.key),d=k.get(d.anchor.key),a&&d&&!b._nodeMap.has(a.__key)&&Lexical_1.$isTextNode(a)&&
1===a.__text.length&&1===f.anchor.offset?2:0;a=e[0];b=b._nodeMap.get(a.__key);if(!Lexical_1.$isTextNode(b)||!Lexical_1.$isTextNode(a)||b.__mode!==a.__mode)return 0;b=b.__text;a=a.__text;if(b===a)return 0;f=f.anchor;d=d.anchor;if(f.key!==d.key||"text"!==f.type)return 0;f=f.offset;d=d.offset;b=a.length-b.length;return 1===b&&d===f-1?2:-1===b&&d===f+1?3:-1===b&&d===f?4:0}
function z(b,a){let m=Date.now(),k=0;return (p,f,d,e,g,n)=>{let r=Date.now();if(n.has("historic"))return k=0,m=r,2;let q=y(p,f,e,g,b.isComposing()),v=(()=>{var l=null===d||d.editor===b,h=n.has("history-push");if(!h&&l&&n.has("history-merge"))return 0;if(null===p)return 1;var t=f._selection;if(!(0<e.size||0<g.size))return null!==t?0:2;if(!1===h&&0!==q&&q===k&&r<m+a&&l)return 0;if(1===e.size){{h=Array.from(e)[0];l=p._nodeMap.get(h);h=f._nodeMap.get(h);t=p._selection;let u=f._selection,w=!1;Lexical_1.$isRangeSelection(t)&&
Lexical_1.$isRangeSelection(u)&&(w="element"===t.anchor.type&&"element"===t.focus.type&&"text"===u.anchor.type&&"text"===u.focus.type);l=!w&&Lexical_1.$isTextNode(l)&&Lexical_1.$isTextNode(h)?l.__type===h.__type&&l.__text===h.__text&&l.__mode===h.__mode&&l.__detail===h.__detail&&l.__style===h.__style&&l.__format===h.__format&&l.__parent===h.__parent:!1;}if(l)return 0}return 1})();m=r;k=q;return v}}var createEmptyHistoryState$2=function(){return {current:null,redoStack:[],undoStack:[]}};
var registerHistory=function(b,a,m){let k=z(b,m);m=({editorState:d,prevEditorState:e,dirtyLeaves:g,dirtyElements:n,tags:r})=>{const q=a.current,v=a.redoStack,l=a.undoStack,h=null===q?null:q.editorState;if(null===q||d!==h){g=k(e,d,q,g,n,r);if(1===g)0!==v.length&&(a.redoStack=[],b.dispatchCommand(Lexical_1.CAN_REDO_COMMAND,!1)),null!==q&&(l.push({...q,undoSelection:e.read(Lexical_1.$getSelection)}),b.dispatchCommand(Lexical_1.CAN_UNDO_COMMAND,!0));else if(2===g)return;a.current={editor:b,editorState:d};}};let p=LexicalUtils_1.mergeRegister(b.registerCommand(Lexical_1.UNDO_COMMAND,
()=>{let d=a.redoStack,e=a.undoStack;if(0!==e.length){let g=a.current,n=e.pop();null!==g&&(d.push(g),b.dispatchCommand(Lexical_1.CAN_REDO_COMMAND,!0));0===e.length&&b.dispatchCommand(Lexical_1.CAN_UNDO_COMMAND,!1);a.current=n||null;n&&n.editor.setEditorState(n.editorState.clone(n.undoSelection),{tag:"historic"});}return !0},Lexical_1.COMMAND_PRIORITY_EDITOR),b.registerCommand(Lexical_1.REDO_COMMAND,()=>{let d=a.redoStack;var e=a.undoStack;if(0!==d.length){let g=a.current;null!==g&&(e.push(g),b.dispatchCommand(Lexical_1.CAN_UNDO_COMMAND,!0));
e=d.pop();0===d.length&&b.dispatchCommand(Lexical_1.CAN_REDO_COMMAND,!1);a.current=e||null;e&&e.editor.setEditorState(e.editorState,{tag:"historic"});}return !0},Lexical_1.COMMAND_PRIORITY_EDITOR),b.registerCommand(Lexical_1.CLEAR_EDITOR_COMMAND,()=>{a.undoStack=[];a.redoStack=[];a.current=null;return !1},Lexical_1.COMMAND_PRIORITY_EDITOR),b.registerCommand(Lexical_1.CLEAR_HISTORY_COMMAND,()=>{a.undoStack=[];a.redoStack=[];a.current=null;b.dispatchCommand(Lexical_1.CAN_REDO_COMMAND,!1);b.dispatchCommand(Lexical_1.CAN_UNDO_COMMAND,!1);return !0},Lexical_1.COMMAND_PRIORITY_EDITOR),
b.registerUpdateListener(m)),f=b.registerUpdateListener(m);return ()=>{p();f();}};

var LexicalHistory_prod = {
	createEmptyHistoryState: createEmptyHistoryState$2,
	registerHistory: registerHistory
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const LexicalHistory = process.env.NODE_ENV === 'development' ? LexicalHistory_dev : LexicalHistory_prod;
var LexicalHistory_1 = LexicalHistory;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */





/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
function useHistory(editor, externalHistoryState, delay = 1000) {
  const historyState = React__default.useMemo(() => externalHistoryState || LexicalHistory_1.createEmptyHistoryState(), [externalHistoryState]);
  React__default.useEffect(() => {
    return LexicalHistory_1.registerHistory(editor, historyState, delay);
  }, [delay, editor, historyState]);
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
function HistoryPlugin$1({
  externalHistoryState
}) {
  const [editor] = LexicalComposerContext_1.useLexicalComposerContext();
  useHistory(editor, externalHistoryState);
  return null;
}

var createEmptyHistoryState$1 = LexicalHistory_1.createEmptyHistoryState;
var HistoryPlugin_1 = HistoryPlugin$1;

var LexicalHistoryPlugin_dev = {
	createEmptyHistoryState: createEmptyHistoryState$1,
	HistoryPlugin: HistoryPlugin_1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function g$2(a,b,d=1E3){let e=React__default.useMemo(()=>b||LexicalHistory_1.createEmptyHistoryState(),[b]);React__default.useEffect(()=>LexicalHistory_1.registerHistory(a,e,d),[d,a,e]);}var createEmptyHistoryState=LexicalHistory_1.createEmptyHistoryState;var HistoryPlugin=function({externalHistoryState:a}){let [b]=LexicalComposerContext_1.useLexicalComposerContext();g$2(b,a);return null};

var LexicalHistoryPlugin_prod = {
	createEmptyHistoryState: createEmptyHistoryState,
	HistoryPlugin: HistoryPlugin
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const LexicalHistoryPlugin = process.env.NODE_ENV === 'development' ? LexicalHistoryPlugin_dev : LexicalHistoryPlugin_prod;
var LexicalHistoryPlugin_1 = LexicalHistoryPlugin;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */







/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
function LinkPlugin$1({
  validateUrl
}) {
  const [editor] = LexicalComposerContext_1.useLexicalComposerContext();
  React__default.useEffect(() => {
    if (!editor.hasNodes([LexicalLink_1.LinkNode])) {
      throw new Error('LinkPlugin: LinkNode not registered on editor');
    }

    return LexicalUtils_1.mergeRegister(editor.registerCommand(LexicalLink_1.TOGGLE_LINK_COMMAND, payload => {
      if (payload === null) {
        LexicalLink_1.toggleLink(payload);
        return true;
      } else if (typeof payload === 'string') {
        if (validateUrl === undefined || validateUrl(payload)) {
          LexicalLink_1.toggleLink(payload);
          return true;
        }

        return false;
      } else {
        const {
          url,
          target,
          rel,
          title
        } = payload;
        LexicalLink_1.toggleLink(url, {
          rel,
          target,
          title
        });
        return true;
      }
    }, Lexical_1.COMMAND_PRIORITY_LOW), validateUrl !== undefined ? editor.registerCommand(Lexical_1.PASTE_COMMAND, event => {
      const selection = Lexical_1.$getSelection();

      if (!Lexical_1.$isRangeSelection(selection) || selection.isCollapsed() || !(event instanceof ClipboardEvent) || event.clipboardData == null) {
        return false;
      }

      const clipboardText = event.clipboardData.getData('text');

      if (!validateUrl(clipboardText)) {
        return false;
      } // If we select nodes that are elements then avoid applying the link.


      if (!selection.getNodes().some(node => Lexical_1.$isElementNode(node))) {
        editor.dispatchCommand(LexicalLink_1.TOGGLE_LINK_COMMAND, clipboardText);
        event.preventDefault();
        return true;
      }

      return false;
    }, Lexical_1.COMMAND_PRIORITY_LOW) : () => {// Don't paste arbritrary text as a link when there's no validate function
    });
  }, [editor, validateUrl]);
  return null;
}

var LinkPlugin_1 = LinkPlugin$1;

var LexicalLinkPlugin_dev = {
	LinkPlugin: LinkPlugin_1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var LinkPlugin=function({validateUrl:d}){let [e]=LexicalComposerContext_1.useLexicalComposerContext();React__default.useEffect(()=>{if(!e.hasNodes([LexicalLink_1.LinkNode]))throw Error("LinkPlugin: LinkNode not registered on editor");return LexicalUtils_1.mergeRegister(e.registerCommand(LexicalLink_1.TOGGLE_LINK_COMMAND,a=>{if(null===a)return LexicalLink_1.toggleLink(a),!0;if("string"===typeof a)return void 0===d||d(a)?(LexicalLink_1.toggleLink(a),!0):!1;let {url:f,target:g,rel:h,title:n}=a;LexicalLink_1.toggleLink(f,{rel:h,target:g,title:n});return !0},Lexical_1.COMMAND_PRIORITY_LOW),void 0!==d?e.registerCommand(Lexical_1.PASTE_COMMAND,
a=>{let f=Lexical_1.$getSelection();if(!Lexical_1.$isRangeSelection(f)||f.isCollapsed()||!(a instanceof ClipboardEvent)||null==a.clipboardData)return !1;let g=a.clipboardData.getData("text");return d(g)?f.getNodes().some(h=>Lexical_1.$isElementNode(h))?!1:(e.dispatchCommand(LexicalLink_1.TOGGLE_LINK_COMMAND,g),a.preventDefault(),!0):!1},Lexical_1.COMMAND_PRIORITY_LOW):()=>{})},[e,d]);return null};

var LexicalLinkPlugin_prod = {
	LinkPlugin: LinkPlugin
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const LexicalLinkPlugin = process.env.NODE_ENV === 'development' ? LexicalLinkPlugin_dev : LexicalLinkPlugin_prod;
var LexicalLinkPlugin_1 = LexicalLinkPlugin;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */







/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
function useList(editor) {
  React__default.useEffect(() => {
    return LexicalUtils_1.mergeRegister(editor.registerCommand(LexicalList_1.INSERT_ORDERED_LIST_COMMAND, () => {
      LexicalList_1.insertList(editor, 'number');
      return true;
    }, Lexical_1.COMMAND_PRIORITY_LOW), editor.registerCommand(LexicalList_1.INSERT_UNORDERED_LIST_COMMAND, () => {
      LexicalList_1.insertList(editor, 'bullet');
      return true;
    }, Lexical_1.COMMAND_PRIORITY_LOW), editor.registerCommand(LexicalList_1.REMOVE_LIST_COMMAND, () => {
      LexicalList_1.removeList(editor);
      return true;
    }, Lexical_1.COMMAND_PRIORITY_LOW), editor.registerCommand(Lexical_1.INSERT_PARAGRAPH_COMMAND, () => {
      const hasHandledInsertParagraph = LexicalList_1.$handleListInsertParagraph();

      if (hasHandledInsertParagraph) {
        return true;
      }

      return false;
    }, Lexical_1.COMMAND_PRIORITY_LOW));
  }, [editor]);
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
function ListPlugin$1() {
  const [editor] = LexicalComposerContext_1.useLexicalComposerContext();
  React__default.useEffect(() => {
    if (!editor.hasNodes([LexicalList_1.ListNode, LexicalList_1.ListItemNode])) {
      throw new Error('ListPlugin: ListNode and/or ListItemNode not registered on editor');
    }
  }, [editor]);
  useList(editor);
  return null;
}

var ListPlugin_1 = ListPlugin$1;

var LexicalListPlugin_dev = {
	ListPlugin: ListPlugin_1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function g$1(a){React__default.useEffect(()=>LexicalUtils_1.mergeRegister(a.registerCommand(LexicalList_1.INSERT_ORDERED_LIST_COMMAND,()=>{LexicalList_1.insertList(a,"number");return !0},Lexical_1.COMMAND_PRIORITY_LOW),a.registerCommand(LexicalList_1.INSERT_UNORDERED_LIST_COMMAND,()=>{LexicalList_1.insertList(a,"bullet");return !0},Lexical_1.COMMAND_PRIORITY_LOW),a.registerCommand(LexicalList_1.REMOVE_LIST_COMMAND,()=>{LexicalList_1.removeList(a);return !0},Lexical_1.COMMAND_PRIORITY_LOW),a.registerCommand(Lexical_1.INSERT_PARAGRAPH_COMMAND,()=>LexicalList_1.$handleListInsertParagraph()?!0:!1,Lexical_1.COMMAND_PRIORITY_LOW)),[a]);}
var ListPlugin=function(){let [a]=LexicalComposerContext_1.useLexicalComposerContext();React__default.useEffect(()=>{if(!a.hasNodes([LexicalList_1.ListNode,LexicalList_1.ListItemNode]))throw Error("ListPlugin: ListNode and/or ListItemNode not registered on editor");},[a]);g$1(a);return null};

var LexicalListPlugin_prod = {
	ListPlugin: ListPlugin
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const LexicalListPlugin = process.env.NODE_ENV === 'development' ? LexicalListPlugin_dev : LexicalListPlugin_prod;
var LexicalListPlugin_1 = LexicalListPlugin;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */





/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

function isNodeSelected(editor, key) {
  return editor.getEditorState().read(() => {
    const node = Lexical_1.$getNodeByKey(key);

    if (node === null) {
      return false;
    }

    return node.isSelected();
  });
}

function useLexicalNodeSelection$2(key) {
  const [editor] = LexicalComposerContext_1.useLexicalComposerContext();
  const [isSelected, setIsSelected] = React__default.useState(() => isNodeSelected(editor, key));
  React__default.useEffect(() => {
    let isMounted = true;
    const unregister = editor.registerUpdateListener(() => {
      if (isMounted) {
        setIsSelected(isNodeSelected(editor, key));
      }
    });
    return () => {
      isMounted = false;
      unregister();
    };
  }, [editor, key]);
  const setSelected = React__default.useCallback(selected => {
    editor.update(() => {
      let selection = Lexical_1.$getSelection();

      if (!Lexical_1.$isNodeSelection(selection)) {
        selection = Lexical_1.$createNodeSelection();
        Lexical_1.$setSelection(selection);
      }

      if (selected) {
        selection.add(key);
      } else {
        selection.delete(key);
      }
    });
  }, [editor, key]);
  const clearSelected = React__default.useCallback(() => {
    editor.update(() => {
      const selection = Lexical_1.$getSelection();

      if (Lexical_1.$isNodeSelection(selection)) {
        selection.clear();
      }
    });
  }, [editor]);
  return [isSelected, setSelected, clearSelected];
}

var useLexicalNodeSelection_1$1 = useLexicalNodeSelection$2;

var useLexicalNodeSelection_dev = {
	useLexicalNodeSelection: useLexicalNodeSelection_1$1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function k(b,a){return b.getEditorState().read(()=>{let g=Lexical_1.$getNodeByKey(a);return null===g?!1:g.isSelected()})}
var useLexicalNodeSelection$1=function(b){let [a]=LexicalComposerContext_1.useLexicalComposerContext(),[g,l]=React__default.useState(()=>k(a,b));React__default.useEffect(()=>{let d=!0,e=a.registerUpdateListener(()=>{d&&l(k(a,b));});return ()=>{d=!1;e();}},[a,b]);let m=React__default.useCallback(d=>{a.update(()=>{let e=Lexical_1.$getSelection();Lexical_1.$isNodeSelection(e)||(e=Lexical_1.$createNodeSelection(),Lexical_1.$setSelection(e));d?e.add(b):e.delete(b);});},[a,b]),n=React__default.useCallback(()=>{a.update(()=>{const d=Lexical_1.$getSelection();Lexical_1.$isNodeSelection(d)&&d.clear();});},[a]);return [g,m,n]};

var useLexicalNodeSelection_prod = {
	useLexicalNodeSelection: useLexicalNodeSelection$1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const useLexicalNodeSelection = process.env.NODE_ENV === 'development' ? useLexicalNodeSelection_dev : useLexicalNodeSelection_prod;
var useLexicalNodeSelection_1 = useLexicalNodeSelection;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */







/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const INSERT_HORIZONTAL_RULE_COMMAND$1 = Lexical_1.createCommand('INSERT_HORIZONTAL_RULE_COMMAND');

function HorizontalRuleComponent({
  nodeKey
}) {
  const [editor] = LexicalComposerContext_1.useLexicalComposerContext();
  const [isSelected, setSelected, clearSelection] = useLexicalNodeSelection_1.useLexicalNodeSelection(nodeKey);
  const onDelete = React__default.useCallback(payload => {
    if (isSelected && Lexical_1.$isNodeSelection(Lexical_1.$getSelection())) {
      const event = payload;
      event.preventDefault();
      const node = Lexical_1.$getNodeByKey(nodeKey);

      if ($isHorizontalRuleNode$1(node)) {
        node.remove();
      }

      setSelected(false);
    }

    return false;
  }, [isSelected, nodeKey, setSelected]);
  React__default.useEffect(() => {
    return LexicalUtils_1.mergeRegister(editor.registerCommand(Lexical_1.CLICK_COMMAND, event => {
      const hrElem = editor.getElementByKey(nodeKey);

      if (event.target === hrElem) {
        if (!event.shiftKey) {
          clearSelection();
        }

        setSelected(!isSelected);
        return true;
      }

      return false;
    }, Lexical_1.COMMAND_PRIORITY_LOW), editor.registerCommand(Lexical_1.KEY_DELETE_COMMAND, onDelete, Lexical_1.COMMAND_PRIORITY_LOW), editor.registerCommand(Lexical_1.KEY_BACKSPACE_COMMAND, onDelete, Lexical_1.COMMAND_PRIORITY_LOW));
  }, [clearSelection, editor, isSelected, nodeKey, onDelete, setSelected]);
  React__default.useEffect(() => {
    const hrElem = editor.getElementByKey(nodeKey);

    if (hrElem !== null) {
      hrElem.className = isSelected ? 'selected' : '';
    }
  }, [editor, isSelected, nodeKey]);
  return null;
}

class HorizontalRuleNode$1 extends Lexical_1.DecoratorNode {
  static getType() {
    return 'horizontalrule';
  }

  static clone(node) {
    return new HorizontalRuleNode$1(node.__key);
  }

  static importJSON(serializedNode) {
    return $createHorizontalRuleNode$1();
  }

  static importDOM() {
    return {
      hr: () => ({
        conversion: convertHorizontalRuleElement,
        priority: 0
      })
    };
  }

  exportJSON() {
    return {
      type: 'horizontalrule',
      version: 1
    };
  }

  exportDOM() {
    return {
      element: document.createElement('hr')
    };
  }

  createDOM() {
    return document.createElement('hr');
  }

  getTextContent() {
    return '\n';
  }

  isInline() {
    return false;
  }

  updateDOM() {
    return false;
  }

  decorate() {
    return /*#__PURE__*/React__default.createElement(HorizontalRuleComponent, {
      nodeKey: this.__key
    });
  }

}

function convertHorizontalRuleElement() {
  return {
    node: $createHorizontalRuleNode$1()
  };
}

function $createHorizontalRuleNode$1() {
  return Lexical_1.$applyNodeReplacement(new HorizontalRuleNode$1());
}
function $isHorizontalRuleNode$1(node) {
  return node instanceof HorizontalRuleNode$1;
}

var $createHorizontalRuleNode_1 = $createHorizontalRuleNode$1;
var $isHorizontalRuleNode_1 = $isHorizontalRuleNode$1;
var HorizontalRuleNode_1 = HorizontalRuleNode$1;
var INSERT_HORIZONTAL_RULE_COMMAND_1 = INSERT_HORIZONTAL_RULE_COMMAND$1;

var LexicalHorizontalRuleNode_dev = {
	$createHorizontalRuleNode: $createHorizontalRuleNode_1,
	$isHorizontalRuleNode: $isHorizontalRuleNode_1,
	HorizontalRuleNode: HorizontalRuleNode_1,
	INSERT_HORIZONTAL_RULE_COMMAND: INSERT_HORIZONTAL_RULE_COMMAND_1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
let p$1=Lexical_1.createCommand("INSERT_HORIZONTAL_RULE_COMMAND");
function q$1({nodeKey:b}){let [d]=LexicalComposerContext_1.useLexicalComposerContext(),[e,g,m]=useLexicalNodeSelection_1.useLexicalNodeSelection(b),k=React__default.useCallback(c=>{e&&Lexical_1.$isNodeSelection(Lexical_1.$getSelection())&&(c.preventDefault(),c=Lexical_1.$getNodeByKey(b),r$3(c)&&c.remove(),g(!1));return !1},[e,b,g]);React__default.useEffect(()=>LexicalUtils_1.mergeRegister(d.registerCommand(Lexical_1.CLICK_COMMAND,c=>{let v=d.getElementByKey(b);return c.target===v?(c.shiftKey||m(),g(!e),!0):!1},Lexical_1.COMMAND_PRIORITY_LOW),d.registerCommand(Lexical_1.KEY_DELETE_COMMAND,k,Lexical_1.COMMAND_PRIORITY_LOW),d.registerCommand(Lexical_1.KEY_BACKSPACE_COMMAND,
k,Lexical_1.COMMAND_PRIORITY_LOW)),[m,d,e,b,k,g]);React__default.useEffect(()=>{let c=d.getElementByKey(b);null!==c&&(c.className=e?"selected":"");},[d,e,b]);return null}
class t$1 extends Lexical_1.DecoratorNode{static getType(){return "horizontalrule"}static clone(b){return new t$1(b.__key)}static importJSON(){return u$2()}static importDOM(){return {hr:()=>({conversion:w$1,priority:0})}}exportJSON(){return {type:"horizontalrule",version:1}}exportDOM(){return {element:document.createElement("hr")}}createDOM(){return document.createElement("hr")}getTextContent(){return "\n"}isInline(){return !1}updateDOM(){return !1}decorate(){return React__default.createElement(q$1,{nodeKey:this.__key})}}
function w$1(){return {node:u$2()}}function u$2(){return Lexical_1.$applyNodeReplacement(new t$1)}function r$3(b){return b instanceof t$1}var $createHorizontalRuleNode=u$2;var $isHorizontalRuleNode=r$3;var HorizontalRuleNode=t$1;var INSERT_HORIZONTAL_RULE_COMMAND=p$1;

var LexicalHorizontalRuleNode_prod = {
	$createHorizontalRuleNode: $createHorizontalRuleNode,
	$isHorizontalRuleNode: $isHorizontalRuleNode,
	HorizontalRuleNode: HorizontalRuleNode,
	INSERT_HORIZONTAL_RULE_COMMAND: INSERT_HORIZONTAL_RULE_COMMAND
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const LexicalHorizontalRuleNode = process.env.NODE_ENV === 'development' ? LexicalHorizontalRuleNode_dev : LexicalHorizontalRuleNode_prod;
var LexicalHorizontalRuleNode_1 = LexicalHorizontalRuleNode;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */






/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const HR = {
  dependencies: [LexicalHorizontalRuleNode_1.HorizontalRuleNode],
  export: node => {
    return LexicalHorizontalRuleNode_1.$isHorizontalRuleNode(node) ? '***' : null;
  },
  regExp: /^(---|\*\*\*|___)\s?$/,
  replace: (parentNode, _1, _2, isImport) => {
    const line = LexicalHorizontalRuleNode_1.$createHorizontalRuleNode(); // TODO: Get rid of isImport flag

    if (isImport || parentNode.getNextSibling() != null) {
      parentNode.replace(line);
    } else {
      parentNode.insertBefore(line);
    }

    line.selectNext();
  },
  type: 'element'
};
const DEFAULT_TRANSFORMERS$1 = [HR, ...LexicalMarkdown_1.TRANSFORMERS];
function MarkdownShortcutPlugin$1({
  transformers = DEFAULT_TRANSFORMERS$1
}) {
  const [editor] = LexicalComposerContext_1.useLexicalComposerContext();
  React__default.useEffect(() => {
    return LexicalMarkdown_1.registerMarkdownShortcuts(editor, transformers);
  }, [editor, transformers]);
  return null;
}

var DEFAULT_TRANSFORMERS_1 = DEFAULT_TRANSFORMERS$1;
var MarkdownShortcutPlugin_1 = MarkdownShortcutPlugin$1;

var LexicalMarkdownShortcutPlugin_dev = {
	DEFAULT_TRANSFORMERS: DEFAULT_TRANSFORMERS_1,
	MarkdownShortcutPlugin: MarkdownShortcutPlugin_1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
let g=[{dependencies:[LexicalHorizontalRuleNode_1.HorizontalRuleNode],export:a=>LexicalHorizontalRuleNode_1.$isHorizontalRuleNode(a)?"***":null,regExp:/^(---|\*\*\*|___)\s?$/,replace:(a,b,k,h)=>{b=LexicalHorizontalRuleNode_1.$createHorizontalRuleNode();h||null!=a.getNextSibling()?a.replace(b):a.insertBefore(b);b.selectNext();},type:"element"},...LexicalMarkdown_1.TRANSFORMERS];var DEFAULT_TRANSFORMERS=g;
var MarkdownShortcutPlugin=function({transformers:a=g}){let [b]=LexicalComposerContext_1.useLexicalComposerContext();React__default.useEffect(()=>LexicalMarkdown_1.registerMarkdownShortcuts(b,a),[b,a]);return null};

var LexicalMarkdownShortcutPlugin_prod = {
	DEFAULT_TRANSFORMERS: DEFAULT_TRANSFORMERS,
	MarkdownShortcutPlugin: MarkdownShortcutPlugin
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const LexicalMarkdownShortcutPlugin = process.env.NODE_ENV === 'development' ? LexicalMarkdownShortcutPlugin_dev : LexicalMarkdownShortcutPlugin_prod;
var LexicalMarkdownShortcutPlugin_1 = LexicalMarkdownShortcutPlugin;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */




/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const CAN_USE_DOM$2 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const useLayoutEffectImpl$2 = CAN_USE_DOM$2 ? React__default.useLayoutEffect : React__default.useEffect;
var useLayoutEffect$2 = useLayoutEffectImpl$2;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
function OnChangePlugin$1({
  ignoreHistoryMergeTagChange = true,
  ignoreSelectionChange = false,
  onChange
}) {
  const [editor] = LexicalComposerContext_1.useLexicalComposerContext();
  useLayoutEffect$2(() => {
    if (onChange) {
      return editor.registerUpdateListener(({
        editorState,
        dirtyElements,
        dirtyLeaves,
        prevEditorState,
        tags
      }) => {
        if (ignoreSelectionChange && dirtyElements.size === 0 && dirtyLeaves.size === 0 || ignoreHistoryMergeTagChange && tags.has('history-merge') || prevEditorState.isEmpty()) {
          return;
        }

        onChange(editorState, editor, tags);
      });
    }
  }, [editor, ignoreHistoryMergeTagChange, ignoreSelectionChange, onChange]);
  return null;
}

var OnChangePlugin_1 = OnChangePlugin$1;

var LexicalOnChangePlugin_dev = {
	OnChangePlugin: OnChangePlugin_1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var h="undefined"!==typeof window&&"undefined"!==typeof window.document&&"undefined"!==typeof window.document.createElement?React__default.useLayoutEffect:React__default.useEffect;
var OnChangePlugin=function({ignoreHistoryMergeTagChange:d=!0,ignoreSelectionChange:e=!1,onChange:a}){let [b]=LexicalComposerContext_1.useLexicalComposerContext();h(()=>{if(a)return b.registerUpdateListener(({editorState:k,dirtyElements:l,dirtyLeaves:m,prevEditorState:n,tags:f})=>{e&&0===l.size&&0===m.size||d&&f.has("history-merge")||n.isEmpty()||a(k,b,f);})},[b,d,e,a]);return null};

var LexicalOnChangePlugin_prod = {
	OnChangePlugin: OnChangePlugin
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const LexicalOnChangePlugin = process.env.NODE_ENV === 'development' ? LexicalOnChangePlugin_dev : LexicalOnChangePlugin_prod;
var LexicalOnChangePlugin_1 = LexicalOnChangePlugin;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */




/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const CAN_USE_DOM$1 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const useLayoutEffectImpl$1 = CAN_USE_DOM$1 ? React__default.useLayoutEffect : React__default.useEffect;
var useLayoutEffect$1 = useLayoutEffectImpl$1;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * Shortcut to Lexical subscriptions when values are used for render.
 */
function useLexicalSubscription(subscription) {
  const [editor] = LexicalComposerContext_1.useLexicalComposerContext();
  const initializedSubscription = React__default.useMemo(() => subscription(editor), [editor, subscription]);
  const valueRef = React__default.useRef(initializedSubscription.initialValueFn());
  const [value, setValue] = React__default.useState(valueRef.current);
  useLayoutEffect$1(() => {
    const {
      initialValueFn,
      subscribe
    } = initializedSubscription;
    const currentValue = initialValueFn();

    if (valueRef.current !== currentValue) {
      valueRef.current = currentValue;
      setValue(currentValue);
    }

    return subscribe(newValue => {
      valueRef.current = newValue;
      setValue(newValue);
    });
  }, [initializedSubscription, subscription]);
  return value;
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

function subscription(editor) {
  return {
    initialValueFn: () => editor.isEditable(),
    subscribe: callback => {
      return editor.registerEditableListener(callback);
    }
  };
}

function useLexicalEditable$1() {
  return useLexicalSubscription(subscription);
}

var useLexicalEditable_dev = useLexicalEditable$1;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var l="undefined"!==typeof window&&"undefined"!==typeof window.document&&"undefined"!==typeof window.document.createElement?React__default.useLayoutEffect:React__default.useEffect;
function m(a){let [c]=LexicalComposerContext_1.useLexicalComposerContext(),e=React__default.useMemo(()=>a(c),[c,a]),d=React__default.useRef(e.initialValueFn()),[n,g]=React__default.useState(d.current);l(()=>{let {initialValueFn:p,subscribe:q}=e,f=p();d.current!==f&&(d.current=f,g(f));return q(h=>{d.current=h;g(h);})},[e,a]);return n}function r$2(a){return {initialValueFn:()=>a.isEditable(),subscribe:c=>a.registerEditableListener(c)}}var useLexicalEditable_prod=function(){return m(r$2)};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const useLexicalEditable = process.env.NODE_ENV === 'development' ? useLexicalEditable_dev : useLexicalEditable_prod;
var useLexicalEditable_1 = useLexicalEditable;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/** @module @lexical/text */

/**
 * Finds a TextNode with a size larger than targetCharacters and returns
 * the node along with the remaining length of the text.
 * @param root - The RootNode.
 * @param targetCharacters - The number of characters whose TextNode must be larger than.
 * @returns The TextNode and the intersections offset, or null if no TextNode is found.
 */
function $findTextIntersectionFromCharacters$1(root, targetCharacters) {
  let node = root.getFirstChild();
  let currentCharacters = 0;

  mainLoop: while (node !== null) {
    if (Lexical_1.$isElementNode(node)) {
      const child = node.getFirstChild();

      if (child !== null) {
        node = child;
        continue;
      }
    } else if (Lexical_1.$isTextNode(node)) {
      const characters = node.getTextContentSize();

      if (currentCharacters + characters > targetCharacters) {
        return {
          node,
          offset: targetCharacters - currentCharacters
        };
      }

      currentCharacters += characters;
    }

    const sibling = node.getNextSibling();

    if (sibling !== null) {
      node = sibling;
      continue;
    }

    let parent = node.getParent();

    while (parent !== null) {
      const parentSibling = parent.getNextSibling();

      if (parentSibling !== null) {
        node = parentSibling;
        continue mainLoop;
      }

      parent = parent.getParent();
    }

    break;
  }

  return null;
}
/**
 * Determines if the root has any text content and can trim any whitespace if it does.
 * @param isEditorComposing - Is the editor in composition mode due to an active Input Method Editor?
 * @param trim - Should the root text have its whitespaced trimmed? Defaults to true.
 * @returns true if text content is empty, false if there is text or isEditorComposing is true.
 */

function $isRootTextContentEmpty$1(isEditorComposing, trim = true) {
  if (isEditorComposing) {
    return false;
  }

  let text = $rootTextContent$1();

  if (trim) {
    text = text.trim();
  }

  return text === '';
}
/**
 * Returns a function that executes {@link $isRootTextContentEmpty}
 * @param isEditorComposing - Is the editor in composition mode due to an active Input Method Editor?
 * @param trim - Should the root text have its whitespaced trimmed? Defaults to true.
 * @returns A function that executes $isRootTextContentEmpty based on arguments.
 */

function $isRootTextContentEmptyCurry$1(isEditorComposing, trim) {
  return () => $isRootTextContentEmpty$1(isEditorComposing, trim);
}
/**
 * Returns the root's text content.
 * @returns The root's text content.
 */

function $rootTextContent$1() {
  const root = Lexical_1.$getRoot();
  return root.getTextContent();
}
/**
 * Determines if the input should show the placeholder. If anything is in
 * in the root the placeholder should not be shown.
 * @param isComposing - Is the editor in composition mode due to an active Input Method Editor?
 * @returns true if the input should show the placeholder, false otherwise.
 */

function $canShowPlaceholder$1(isComposing) {
  if (!$isRootTextContentEmpty$1(isComposing, false)) {
    return false;
  }

  const root = Lexical_1.$getRoot();
  const children = root.getChildren();
  const childrenLength = children.length;

  if (childrenLength > 1) {
    return false;
  }

  for (let i = 0; i < childrenLength; i++) {
    const topBlock = children[i];

    if (Lexical_1.$isDecoratorNode(topBlock)) {
      return false;
    }

    if (Lexical_1.$isElementNode(topBlock)) {
      if (!Lexical_1.$isParagraphNode(topBlock)) {
        return false;
      }

      if (topBlock.__indent !== 0) {
        return false;
      }

      const topBlockChildren = topBlock.getChildren();
      const topBlockChildrenLength = topBlockChildren.length;

      for (let s = 0; s < topBlockChildrenLength; s++) {
        const child = topBlockChildren[i];

        if (!Lexical_1.$isTextNode(child)) {
          return false;
        }
      }
    }
  }

  return true;
}
/**
 * Returns a function that executes {@link $canShowPlaceholder}
 * @param isEditorComposing - Is the editor in composition mode due to an active Input Method Editor?
 * @returns A function that executes $canShowPlaceholder with arguments.
 */

function $canShowPlaceholderCurry$1(isEditorComposing) {
  return () => $canShowPlaceholder$1(isEditorComposing);
}

/**
 * Returns a touple that can be rested (...) into mergeRegister to clean up
 * node transforms listeners that transforms text into another node, eg. a HashtagNode.
 * @example
 * ```ts
 *   useEffect(() => {
    return mergeRegister(
      ...registerLexicalTextEntity(editor, getMatch, targetNode, createNode),
    );
  }, [createNode, editor, getMatch, targetNode]);
 * ```
 * Where targetNode is the type of node containing the text you want to transform (like a text input),
 * then getMatch uses a regex to find a matching text and creates the proper node to include the matching text.
 * @param editor - The lexical editor.
 * @param getMatch - Finds a matching string that satisfies a regex expression.
 * @param targetNode - The node type that contains text to match with. eg. HashtagNode
 * @param createNode - A function that creates a new node to contain the matched text. eg createHashtagNode
 * @returns An array containing the plain text and reverse node transform listeners.
 */
function registerLexicalTextEntity$1(editor, getMatch, targetNode, createNode) {
  const isTargetNode = node => {
    return node instanceof targetNode;
  };

  const replaceWithSimpleText = node => {
    const textNode = Lexical_1.$createTextNode(node.getTextContent());
    textNode.setFormat(node.getFormat());
    node.replace(textNode);
  };

  const getMode = node => {
    return node.getLatest().__mode;
  };

  const textNodeTransform = node => {
    if (!node.isSimpleText()) {
      return;
    }

    const prevSibling = node.getPreviousSibling();
    let text = node.getTextContent();
    let currentNode = node;
    let match;

    if (Lexical_1.$isTextNode(prevSibling)) {
      const previousText = prevSibling.getTextContent();
      const combinedText = previousText + text;
      const prevMatch = getMatch(combinedText);

      if (isTargetNode(prevSibling)) {
        if (prevMatch === null || getMode(prevSibling) !== 0) {
          replaceWithSimpleText(prevSibling);
          return;
        } else {
          const diff = prevMatch.end - previousText.length;

          if (diff > 0) {
            const concatText = text.slice(0, diff);
            const newTextContent = previousText + concatText;
            prevSibling.select();
            prevSibling.setTextContent(newTextContent);

            if (diff === text.length) {
              node.remove();
            } else {
              const remainingText = text.slice(diff);
              node.setTextContent(remainingText);
            }

            return;
          }
        }
      } else if (prevMatch === null || prevMatch.start < previousText.length) {
        return;
      }
    } // eslint-disable-next-line no-constant-condition


    while (true) {
      match = getMatch(text);
      let nextText = match === null ? '' : text.slice(match.end);
      text = nextText;

      if (nextText === '') {
        const nextSibling = currentNode.getNextSibling();

        if (Lexical_1.$isTextNode(nextSibling)) {
          nextText = currentNode.getTextContent() + nextSibling.getTextContent();
          const nextMatch = getMatch(nextText);

          if (nextMatch === null) {
            if (isTargetNode(nextSibling)) {
              replaceWithSimpleText(nextSibling);
            } else {
              nextSibling.markDirty();
            }

            return;
          } else if (nextMatch.start !== 0) {
            return;
          }
        }
      } else {
        const nextMatch = getMatch(nextText);

        if (nextMatch !== null && nextMatch.start === 0) {
          return;
        }
      }

      if (match === null) {
        return;
      }

      if (match.start === 0 && Lexical_1.$isTextNode(prevSibling) && prevSibling.isTextEntity()) {
        continue;
      }

      let nodeToReplace;

      if (match.start === 0) {
        [nodeToReplace, currentNode] = currentNode.splitText(match.end);
      } else {
        [, nodeToReplace, currentNode] = currentNode.splitText(match.start, match.end);
      }

      const replacementNode = createNode(nodeToReplace);
      nodeToReplace.replace(replacementNode);

      if (currentNode == null) {
        return;
      }
    }
  };

  const reverseNodeTransform = node => {
    const text = node.getTextContent();
    const match = getMatch(text);

    if (match === null || match.start !== 0) {
      replaceWithSimpleText(node);
      return;
    }

    if (text.length > match.end) {
      // This will split out the rest of the text as simple text
      node.splitText(match.end);
      return;
    }

    const prevSibling = node.getPreviousSibling();

    if (Lexical_1.$isTextNode(prevSibling) && prevSibling.isTextEntity()) {
      replaceWithSimpleText(prevSibling);
      replaceWithSimpleText(node);
    }

    const nextSibling = node.getNextSibling();

    if (Lexical_1.$isTextNode(nextSibling) && nextSibling.isTextEntity()) {
      replaceWithSimpleText(nextSibling); // This may have already been converted in the previous block

      if (isTargetNode(node)) {
        replaceWithSimpleText(node);
      }
    }
  };

  const removePlainTextTransform = editor.registerNodeTransform(Lexical_1.TextNode, textNodeTransform);
  const removeReverseNodeTransform = editor.registerNodeTransform(targetNode, reverseNodeTransform);
  return [removePlainTextTransform, removeReverseNodeTransform];
}

var $canShowPlaceholder_1 = $canShowPlaceholder$1;
var $canShowPlaceholderCurry_1 = $canShowPlaceholderCurry$1;
var $findTextIntersectionFromCharacters_1 = $findTextIntersectionFromCharacters$1;
var $isRootTextContentEmpty_1 = $isRootTextContentEmpty$1;
var $isRootTextContentEmptyCurry_1 = $isRootTextContentEmptyCurry$1;
var $rootTextContent_1 = $rootTextContent$1;
var registerLexicalTextEntity_1 = registerLexicalTextEntity$1;

var LexicalText_dev = {
	$canShowPlaceholder: $canShowPlaceholder_1,
	$canShowPlaceholderCurry: $canShowPlaceholderCurry_1,
	$findTextIntersectionFromCharacters: $findTextIntersectionFromCharacters_1,
	$isRootTextContentEmpty: $isRootTextContentEmpty_1,
	$isRootTextContentEmptyCurry: $isRootTextContentEmptyCurry_1,
	$rootTextContent: $rootTextContent_1,
	registerLexicalTextEntity: registerLexicalTextEntity_1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function r$1(c,h=!0){if(c)return !1;c=t();h&&(c=c.trim());return ""===c}function t(){return Lexical_1.$getRoot().getTextContent()}function u$1(c){if(!r$1(c,!1))return !1;c=Lexical_1.$getRoot().getChildren();let h=c.length;if(1<h)return !1;for(let e=0;e<h;e++){var a=c[e];if(Lexical_1.$isDecoratorNode(a))return !1;if(Lexical_1.$isElementNode(a)){if(!Lexical_1.$isParagraphNode(a)||0!==a.__indent)return !1;a=a.getChildren();let n=a.length;for(let p=0;p<n;p++)if(!Lexical_1.$isTextNode(a[e]))return !1}}return !0}
var $canShowPlaceholder=u$1;var $canShowPlaceholderCurry=function(c){return ()=>u$1(c)};var $findTextIntersectionFromCharacters=function(c,h){var a=c.getFirstChild();c=0;a:for(;null!==a;){if(Lexical_1.$isElementNode(a)){var e=a.getFirstChild();if(null!==e){a=e;continue}}else if(Lexical_1.$isTextNode(a)){e=a.getTextContentSize();if(c+e>h)return {node:a,offset:h-c};c+=e;}e=a.getNextSibling();if(null!==e)a=e;else {for(a=a.getParent();null!==a;){e=a.getNextSibling();if(null!==e){a=e;continue a}a=a.getParent();}break}}return null};
var $isRootTextContentEmpty=r$1;var $isRootTextContentEmptyCurry=function(c,h){return ()=>r$1(c,h)};var $rootTextContent=t;
var registerLexicalTextEntity=function(c,h,a,e){let n=b=>{const d=Lexical_1.$createTextNode(b.getTextContent());d.setFormat(b.getFormat());b.replace(d);},p=c.registerNodeTransform(Lexical_1.TextNode,b=>{if(b.isSimpleText()){var d=b.getPreviousSibling(),l=b.getTextContent(),m=b;if(Lexical_1.$isTextNode(d)){var k=d.getTextContent(),f=h(k+l);if(d instanceof a){if(null===f||0!==d.getLatest().__mode){n(d);return}f=f.end-k.length;if(0<f){m=l.slice(0,f);m=k+m;d.select();d.setTextContent(m);f===l.length?b.remove():(d=l.slice(f),
b.setTextContent(d));return}}else if(null===f||f.start<k.length)return}for(;;){b=h(l);l=f=null===b?"":l.slice(b.end);if(""===f){if(k=m.getNextSibling(),Lexical_1.$isTextNode(k))if(f=m.getTextContent()+k.getTextContent(),f=h(f),null===f){k instanceof a?n(k):k.markDirty();break}else if(0!==f.start)break}else if(k=h(f),null!==k&&0===k.start)break;if(null===b)break;if(0===b.start&&Lexical_1.$isTextNode(d)&&d.isTextEntity())continue;let q;0===b.start?[q,m]=m.splitText(b.end):[,q,m]=m.splitText(b.start,b.end);b=e(q);q.replace(b);
if(null==m)break}}});c=c.registerNodeTransform(a,b=>{var d=b.getTextContent();const l=h(d);null===l||0!==l.start?n(b):d.length>l.end?b.splitText(l.end):(d=b.getPreviousSibling(),Lexical_1.$isTextNode(d)&&d.isTextEntity()&&(n(d),n(b)),d=b.getNextSibling(),Lexical_1.$isTextNode(d)&&d.isTextEntity()&&(n(d),b instanceof a&&n(b)));});return [p,c]};

var LexicalText_prod = {
	$canShowPlaceholder: $canShowPlaceholder,
	$canShowPlaceholderCurry: $canShowPlaceholderCurry,
	$findTextIntersectionFromCharacters: $findTextIntersectionFromCharacters,
	$isRootTextContentEmpty: $isRootTextContentEmpty,
	$isRootTextContentEmptyCurry: $isRootTextContentEmptyCurry,
	$rootTextContent: $rootTextContent,
	registerLexicalTextEntity: registerLexicalTextEntity
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const LexicalText = process.env.NODE_ENV === 'development' ? LexicalText_dev : LexicalText_prod;
var LexicalText_1 = LexicalText;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/** @module @lexical/dragon */
function registerDragonSupport$1(editor) {
  const origin = window.location.origin;

  const handler = event => {
    if (event.origin !== origin) {
      return;
    }

    const rootElement = editor.getRootElement();

    if (document.activeElement !== rootElement) {
      return;
    }

    const data = event.data;

    if (typeof data === 'string') {
      let parsedData;

      try {
        parsedData = JSON.parse(data);
      } catch (e) {
        return;
      }

      if (parsedData && parsedData.protocol === 'nuanria_messaging' && parsedData.type === 'request') {
        const payload = parsedData.payload;

        if (payload && payload.functionId === 'makeChanges') {
          const args = payload.args;

          if (args) {
            const [elementStart, elementLength, text, selStart, selLength, formatCommand] = args; // TODO: we should probably handle formatCommand somehow?
            editor.update(() => {
              const selection = Lexical_1.$getSelection();

              if (Lexical_1.$isRangeSelection(selection)) {
                const anchor = selection.anchor;
                let anchorNode = anchor.getNode();
                let setSelStart = 0;
                let setSelEnd = 0;

                if (Lexical_1.$isTextNode(anchorNode)) {
                  // set initial selection
                  if (elementStart >= 0 && elementLength >= 0) {
                    setSelStart = elementStart;
                    setSelEnd = elementStart + elementLength; // If the offset is more than the end, make it the end

                    selection.setTextNodeRange(anchorNode, setSelStart, anchorNode, setSelEnd);
                  }
                }

                if (setSelStart !== setSelEnd || text !== '') {
                  selection.insertRawText(text);
                  anchorNode = anchor.getNode();
                }

                if (Lexical_1.$isTextNode(anchorNode)) {
                  // set final selection
                  setSelStart = selStart;
                  setSelEnd = selStart + selLength;
                  const anchorNodeTextLength = anchorNode.getTextContentSize(); // If the offset is more than the end, make it the end

                  setSelStart = setSelStart > anchorNodeTextLength ? anchorNodeTextLength : setSelStart;
                  setSelEnd = setSelEnd > anchorNodeTextLength ? anchorNodeTextLength : setSelEnd;
                  selection.setTextNodeRange(anchorNode, setSelStart, anchorNode, setSelEnd);
                } // block the chrome extension from handling this event


                event.stopImmediatePropagation();
              }
            });
          }
        }
      }
    }
  };

  window.addEventListener('message', handler, true);
  return () => {
    window.removeEventListener('message', handler, true);
  };
}

var registerDragonSupport_1 = registerDragonSupport$1;

var LexicalDragon_dev = {
	registerDragonSupport: registerDragonSupport_1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var registerDragonSupport=function(m){let t=window.location.origin,r=l=>{if(l.origin===t){var h=m.getRootElement();if(document.activeElement===h&&(h=l.data,"string"===typeof h)){try{var a=JSON.parse(h);}catch(k){return}if(a&&"nuanria_messaging"===a.protocol&&"request"===a.type&&(a=a.payload)&&"makeChanges"===a.functionId&&(a=a.args)){const [k,n,p,q,u]=a;m.update(()=>{const f=Lexical_1.$getSelection();if(Lexical_1.$isRangeSelection(f)){var e=f.anchor;let b=e.getNode(),c=0,d=0;Lexical_1.$isTextNode(b)&&0<=k&&0<=n&&(c=k,
d=k+n,f.setTextNodeRange(b,c,b,d));if(c!==d||""!==p)f.insertRawText(p),b=e.getNode();Lexical_1.$isTextNode(b)&&(c=q,d=q+u,e=b.getTextContentSize(),c=c>e?e:c,d=d>e?e:d,f.setTextNodeRange(b,c,b,d));l.stopImmediatePropagation();}});}}}};window.addEventListener("message",r,!0);return ()=>{window.removeEventListener("message",r,!0);}};

var LexicalDragon_prod = {
	registerDragonSupport: registerDragonSupport
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const LexicalDragon = process.env.NODE_ENV === 'development' ? LexicalDragon_dev : LexicalDragon_prod;
var LexicalDragon_1 = LexicalDragon;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */










/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const CAN_USE_DOM = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const useLayoutEffectImpl = CAN_USE_DOM ? React__default.useLayoutEffect : React__default.useEffect;
var useLayoutEffect = useLayoutEffectImpl;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

function canShowPlaceholderFromCurrentEditorState(editor) {
  const currentCanShowPlaceholder = editor.getEditorState().read(LexicalText_1.$canShowPlaceholderCurry(editor.isComposing()));
  return currentCanShowPlaceholder;
}

function useCanShowPlaceholder(editor) {
  const [canShowPlaceholder, setCanShowPlaceholder] = React__default.useState(() => canShowPlaceholderFromCurrentEditorState(editor));
  useLayoutEffect(() => {
    function resetCanShowPlaceholder() {
      const currentCanShowPlaceholder = canShowPlaceholderFromCurrentEditorState(editor);
      setCanShowPlaceholder(currentCanShowPlaceholder);
    }

    resetCanShowPlaceholder();
    return LexicalUtils_1.mergeRegister(editor.registerUpdateListener(() => {
      resetCanShowPlaceholder();
    }), editor.registerEditableListener(() => {
      resetCanShowPlaceholder();
    }));
  }, [editor]);
  return canShowPlaceholder;
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
function useDecorators(editor, ErrorBoundary) {
  const [decorators, setDecorators] = React__default.useState(() => editor.getDecorators()); // Subscribe to changes

  useLayoutEffect(() => {
    return editor.registerDecoratorListener(nextDecorators => {
      reactDom__default.flushSync(() => {
        setDecorators(nextDecorators);
      });
    });
  }, [editor]);
  React__default.useEffect(() => {
    // If the content editable mounts before the subscription is added, then
    // nothing will be rendered on initial pass. We can get around that by
    // ensuring that we set the value.
    setDecorators(editor.getDecorators());
  }, [editor]); // Return decorators defined as React Portals

  return React__default.useMemo(() => {
    const decoratedPortals = [];
    const decoratorKeys = Object.keys(decorators);

    for (let i = 0; i < decoratorKeys.length; i++) {
      const nodeKey = decoratorKeys[i];
      const reactDecorator = /*#__PURE__*/React__default.createElement(ErrorBoundary, {
        onError: e => editor._onError(e)
      }, /*#__PURE__*/React__default.createElement(React__default.Suspense, {
        fallback: null
      }, decorators[nodeKey]));
      const element = editor.getElementByKey(nodeKey);

      if (element !== null) {
        decoratedPortals.push( /*#__PURE__*/reactDom__default.createPortal(reactDecorator, element));
      }
    }

    return decoratedPortals;
  }, [ErrorBoundary, decorators, editor]);
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
function useRichTextSetup(editor) {
  useLayoutEffect(() => {
    return LexicalUtils_1.mergeRegister(LexicalRichText_1.registerRichText(editor), LexicalDragon_1.registerDragonSupport(editor)); // We only do this for init
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editor]);
}

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
function RichTextPlugin$1({
  contentEditable,
  placeholder,
  ErrorBoundary
}) {
  const [editor] = LexicalComposerContext_1.useLexicalComposerContext();
  const decorators = useDecorators(editor, ErrorBoundary);
  useRichTextSetup(editor);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, contentEditable, /*#__PURE__*/React__default.createElement(Placeholder$1, {
    content: placeholder
  }), decorators);
}

function Placeholder$1({
  content
}) {
  const [editor] = LexicalComposerContext_1.useLexicalComposerContext();
  const showPlaceholder = useCanShowPlaceholder(editor);
  const editable = useLexicalEditable_1();

  if (!showPlaceholder) {
    return null;
  }

  if (typeof content === 'function') {
    return content(editable);
  } else {
    return content;
  }
}

var RichTextPlugin_1 = RichTextPlugin$1;

var LexicalRichTextPlugin_dev = {
	RichTextPlugin: RichTextPlugin_1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var u="undefined"!==typeof window&&"undefined"!==typeof window.document&&"undefined"!==typeof window.document.createElement?React__default.useLayoutEffect:React__default.useEffect;
function v(a){return a.getEditorState().read(LexicalText_1.$canShowPlaceholderCurry(a.isComposing()))}function w(a){let [d,c]=React__default.useState(()=>v(a));u(()=>{function e(){let f=v(a);c(f);}e();return LexicalUtils_1.mergeRegister(a.registerUpdateListener(()=>{e();}),a.registerEditableListener(()=>{e();}))},[a]);return d}
function x(a,d){let [c,e]=React__default.useState(()=>a.getDecorators());u(()=>a.registerDecoratorListener(f=>{reactDom__default.flushSync(()=>{e(f);});}),[a]);React__default.useEffect(()=>{e(a.getDecorators());},[a]);return React__default.useMemo(()=>{let f=[],q=Object.keys(c);for(let k=0;k<q.length;k++){var g=q[k];let z=React__default.createElement(d,{onError:y=>a._onError(y)},React__default.createElement(React__default.Suspense,{fallback:null},c[g]));g=a.getElementByKey(g);null!==g&&f.push(reactDom__default.createPortal(z,g));}return f},[d,c,a])}
function A$1(a){u(()=>LexicalUtils_1.mergeRegister(LexicalRichText_1.registerRichText(a),LexicalDragon_1.registerDragonSupport(a)),[a]);}function B$1({content:a}){var [d]=LexicalComposerContext_1.useLexicalComposerContext();d=w(d);let c=useLexicalEditable_1();return d?"function"===typeof a?a(c):a:null}var RichTextPlugin=function({contentEditable:a,placeholder:d,ErrorBoundary:c}){let [e]=LexicalComposerContext_1.useLexicalComposerContext();c=x(e,c);A$1(e);return React__default.createElement(React__default.Fragment,null,a,React__default.createElement(B$1,{content:d}),c)};

var LexicalRichTextPlugin_prod = {
	RichTextPlugin: RichTextPlugin
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const LexicalRichTextPlugin = process.env.NODE_ENV === 'development' ? LexicalRichTextPlugin_dev : LexicalRichTextPlugin_prod;
var LexicalRichTextPlugin_1 = LexicalRichTextPlugin;

var Placeholder = function Placeholder() {
  var theme = useThemeSafe();
  var styles = useStyles$s({
    theme: theme
  });
  return /*#__PURE__*/React__default.createElement(Text$1, {
    variant: "body",
    className: styles.placeholder
  }, "Enter text here");
};
var useStyles$s = createUseStyles(function (theme) {
  return {
    placeholder: {
      color: theme.palette.grey.color,
      overflow: 'hidden',
      position: 'absolute',
      textOverflow: 'ellipsis',
      top: 16,
      left: 8,
      userSelect: 'none',
      display: 'inline-block',
      pointerEvents: 'none'
    }
  };
});

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */







/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
function createLinkMatcherWithRegExp$1(regExp, urlTransformer = text => text) {
  return text => {
    const match = regExp.exec(text);
    if (match === null) return null;
    return {
      index: match.index,
      length: match[0].length,
      text: match[0],
      url: urlTransformer(text)
    };
  };
}

function findFirstMatch(text, matchers) {
  for (let i = 0; i < matchers.length; i++) {
    const match = matchers[i](text);

    if (match) {
      return match;
    }
  }

  return null;
}

const PUNCTUATION_OR_SPACE = /[.,;\s]/;

function isSeparator(char) {
  return PUNCTUATION_OR_SPACE.test(char);
}

function endsWithSeparator(textContent) {
  return isSeparator(textContent[textContent.length - 1]);
}

function startsWithSeparator(textContent) {
  return isSeparator(textContent[0]);
}

function isPreviousNodeValid(node) {
  let previousNode = node.getPreviousSibling();

  if (Lexical_1.$isElementNode(previousNode)) {
    previousNode = previousNode.getLastDescendant();
  }

  return previousNode === null || Lexical_1.$isLineBreakNode(previousNode) || Lexical_1.$isTextNode(previousNode) && endsWithSeparator(previousNode.getTextContent());
}

function isNextNodeValid(node) {
  let nextNode = node.getNextSibling();

  if (Lexical_1.$isElementNode(nextNode)) {
    nextNode = nextNode.getFirstDescendant();
  }

  return nextNode === null || Lexical_1.$isLineBreakNode(nextNode) || Lexical_1.$isTextNode(nextNode) && startsWithSeparator(nextNode.getTextContent());
}

function isContentAroundIsValid(matchStart, matchEnd, text, node) {
  const contentBeforeIsValid = matchStart > 0 ? isSeparator(text[matchStart - 1]) : isPreviousNodeValid(node);

  if (!contentBeforeIsValid) {
    return false;
  }

  const contentAfterIsValid = matchEnd < text.length ? isSeparator(text[matchEnd]) : isNextNodeValid(node);
  return contentAfterIsValid;
}

function handleLinkCreation(node, matchers, onChange) {
  const nodeText = node.getTextContent();
  let text = nodeText;
  let invalidMatchEnd = 0;
  let remainingTextNode = node;
  let match;

  while ((match = findFirstMatch(text, matchers)) && match !== null) {
    const matchStart = match.index;
    const matchLength = match.length;
    const matchEnd = matchStart + matchLength;
    const isValid = isContentAroundIsValid(invalidMatchEnd + matchStart, invalidMatchEnd + matchEnd, nodeText, node);

    if (isValid) {
      let linkTextNode;

      if (invalidMatchEnd + matchStart === 0) {
        [linkTextNode, remainingTextNode] = remainingTextNode.splitText(invalidMatchEnd + matchLength);
      } else {
        [, linkTextNode, remainingTextNode] = remainingTextNode.splitText(invalidMatchEnd + matchStart, invalidMatchEnd + matchStart + matchLength);
      }

      const linkNode = LexicalLink_1.$createAutoLinkNode(match.url, match.attributes);
      const textNode = Lexical_1.$createTextNode(match.text);
      textNode.setFormat(linkTextNode.getFormat());
      textNode.setDetail(linkTextNode.getDetail());
      linkNode.append(textNode);
      linkTextNode.replace(linkNode);
      onChange(match.url, null);
      invalidMatchEnd = 0;
    } else {
      invalidMatchEnd += matchEnd;
    }

    text = text.substring(matchEnd);
  }
}

function handleLinkEdit(linkNode, matchers, onChange) {
  // Check children are simple text
  const children = linkNode.getChildren();
  const childrenLength = children.length;

  for (let i = 0; i < childrenLength; i++) {
    const child = children[i];

    if (!Lexical_1.$isTextNode(child) || !child.isSimpleText()) {
      replaceWithChildren(linkNode);
      onChange(null, linkNode.getURL());
      return;
    }
  } // Check text content fully matches


  const text = linkNode.getTextContent();
  const match = findFirstMatch(text, matchers);

  if (match === null || match.text !== text) {
    replaceWithChildren(linkNode);
    onChange(null, linkNode.getURL());
    return;
  } // Check neighbors


  if (!isPreviousNodeValid(linkNode) || !isNextNodeValid(linkNode)) {
    replaceWithChildren(linkNode);
    onChange(null, linkNode.getURL());
    return;
  }

  const url = linkNode.getURL();

  if (url !== match.url) {
    linkNode.setURL(match.url);
    onChange(match.url, url);
  }

  if (match.attributes) {
    const rel = linkNode.getRel();

    if (rel !== match.attributes.rel) {
      linkNode.setRel(match.attributes.rel || null);
      onChange(match.attributes.rel || null, rel);
    }

    const target = linkNode.getTarget();

    if (target !== match.attributes.target) {
      linkNode.setTarget(match.attributes.target || null);
      onChange(match.attributes.target || null, target);
    }
  }
} // Bad neighbours are edits in neighbor nodes that make AutoLinks incompatible.
// Given the creation preconditions, these can only be simple text nodes.


function handleBadNeighbors(textNode, matchers, onChange) {
  const previousSibling = textNode.getPreviousSibling();
  const nextSibling = textNode.getNextSibling();
  const text = textNode.getTextContent();

  if (LexicalLink_1.$isAutoLinkNode(previousSibling) && !startsWithSeparator(text)) {
    previousSibling.append(textNode);
    handleLinkEdit(previousSibling, matchers, onChange);
    onChange(null, previousSibling.getURL());
  }

  if (LexicalLink_1.$isAutoLinkNode(nextSibling) && !endsWithSeparator(text)) {
    replaceWithChildren(nextSibling);
    handleLinkEdit(nextSibling, matchers, onChange);
    onChange(null, nextSibling.getURL());
  }
}

function replaceWithChildren(node) {
  const children = node.getChildren();
  const childrenLength = children.length;

  for (let j = childrenLength - 1; j >= 0; j--) {
    node.insertAfter(children[j]);
  }

  node.remove();
  return children.map(child => child.getLatest());
}

function useAutoLink(editor, matchers, onChange) {
  React__default.useEffect(() => {
    if (!editor.hasNodes([LexicalLink_1.AutoLinkNode])) {
      {
        throw Error(`LexicalAutoLinkPlugin: AutoLinkNode not registered on editor`);
      }
    }

    const onChangeWrapped = (url, prevUrl) => {
      if (onChange) {
        onChange(url, prevUrl);
      }
    };

    return LexicalUtils_1.mergeRegister(editor.registerNodeTransform(Lexical_1.TextNode, textNode => {
      const parent = textNode.getParentOrThrow();
      const previous = textNode.getPreviousSibling();

      if (LexicalLink_1.$isAutoLinkNode(parent)) {
        handleLinkEdit(parent, matchers, onChangeWrapped);
      } else if (!LexicalLink_1.$isLinkNode(parent)) {
        if (textNode.isSimpleText() && (startsWithSeparator(textNode.getTextContent()) || !LexicalLink_1.$isAutoLinkNode(previous))) {
          handleLinkCreation(textNode, matchers, onChangeWrapped);
        }

        handleBadNeighbors(textNode, matchers, onChangeWrapped);
      }
    }));
  }, [editor, matchers, onChange]);
}

function AutoLinkPlugin$2({
  matchers,
  onChange
}) {
  const [editor] = LexicalComposerContext_1.useLexicalComposerContext();
  useAutoLink(editor, matchers, onChange);
  return null;
}

var AutoLinkPlugin_1 = AutoLinkPlugin$2;
var createLinkMatcherWithRegExp_1 = createLinkMatcherWithRegExp$1;

var LexicalAutoLinkPlugin_dev = {
	AutoLinkPlugin: AutoLinkPlugin_1,
	createLinkMatcherWithRegExp: createLinkMatcherWithRegExp_1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function A(a,b){for(let c=0;c<b.length;c++){let d=b[c](a);if(d)return d}return null}let B=/[.,;\s]/;function C(a){a=a.getPreviousSibling();Lexical_1.$isElementNode(a)&&(a=a.getLastDescendant());var b;!(b=null===a||Lexical_1.$isLineBreakNode(a))&&(b=Lexical_1.$isTextNode(a))&&(a=a.getTextContent(),b=B.test(a[a.length-1]));return b}
function E(a){a=a.getNextSibling();Lexical_1.$isElementNode(a)&&(a=a.getFirstDescendant());return null===a||Lexical_1.$isLineBreakNode(a)||Lexical_1.$isTextNode(a)&&B.test(a.getTextContent()[0])}
function F(a,b,c){var d=a.getChildren();let e=d.length;for(let f=0;f<e;f++){let l=d[f];if(!Lexical_1.$isTextNode(l)||!l.isSimpleText()){G(a);c(null,a.getURL());return}}d=a.getTextContent();b=A(d,b);null===b||b.text!==d?(G(a),c(null,a.getURL())):C(a)&&E(a)?(d=a.getURL(),d!==b.url&&(a.setURL(b.url),c(b.url,d)),b.attributes&&(d=a.getRel(),d!==b.attributes.rel&&(a.setRel(b.attributes.rel||null),c(b.attributes.rel||null,d)),d=a.getTarget(),d!==b.attributes.target&&(a.setTarget(b.attributes.target||null),c(b.attributes.target||
null,d)))):(G(a),c(null,a.getURL()));}function G(a){let b=a.getChildren();var c=b.length;for(--c;0<=c;c--)a.insertAfter(b[c]);a.remove();return b.map(d=>d.getLatest())}
function H(a,b,c){React__default.useEffect(()=>{if(!a.hasNodes([LexicalLink_1.AutoLinkNode]))throw Error("Minified Lexical error #77; visit https://lexical.dev/docs/error?code=77 for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");let d=(e,f)=>{c&&c(e,f);};return LexicalUtils_1.mergeRegister(a.registerNodeTransform(Lexical_1.TextNode,e=>{var f=e.getParentOrThrow(),l=e.getPreviousSibling();if(LexicalLink_1.$isAutoLinkNode(f))F(f,b,d);else if(!LexicalLink_1.$isLinkNode(f)){if(e.isSimpleText()&&(B.test(e.getTextContent()[0])||
!LexicalLink_1.$isAutoLinkNode(l))){l=f=e.getTextContent();let m=0,v=e;for(var g;(g=A(l,b))&&null!==g;){let r=g.index,x=g.length,y=r+x;var t=m+r,q=m+y,z=f,D=e;if((0<t?B.test(z[t-1]):C(D))&&(q<z.length?B.test(z[q]):E(D))){var k=void 0;0===m+r?[k,v]=v.splitText(m+x):[,k,v]=v.splitText(m+r,m+r+x);t=LexicalLink_1.$createAutoLinkNode(g.url,g.attributes);q=Lexical_1.$createTextNode(g.text);q.setFormat(k.getFormat());q.setDetail(k.getDetail());t.append(q);k.replace(t);c&&c(g.url,null);m=0;}else m+=y;l=l.substring(y);}}f=e.getPreviousSibling();
g=e.getNextSibling();k=e.getTextContent();LexicalLink_1.$isAutoLinkNode(f)&&!B.test(k[0])&&(f.append(e),F(f,b,d),e=f.getURL(),c&&c(null,e));LexicalLink_1.$isAutoLinkNode(g)&&!B.test(k[k.length-1])&&(G(g),F(g,b,d),e=g.getURL(),c&&c(null,e));}}))},[a,b,c]);}var AutoLinkPlugin$1=function({matchers:a,onChange:b}){let [c]=LexicalComposerContext_1.useLexicalComposerContext();H(c,a,b);return null};var createLinkMatcherWithRegExp=function(a,b=c=>c){return c=>{let d=a.exec(c);return null===d?null:{index:d.index,length:d[0].length,text:d[0],url:b(c)}}};

var LexicalAutoLinkPlugin_prod = {
	AutoLinkPlugin: AutoLinkPlugin$1,
	createLinkMatcherWithRegExp: createLinkMatcherWithRegExp
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const LexicalAutoLinkPlugin = process.env.NODE_ENV === 'development' ? LexicalAutoLinkPlugin_dev : LexicalAutoLinkPlugin_prod;
var LexicalAutoLinkPlugin_1 = LexicalAutoLinkPlugin;

var getSelectedNode = function getSelectedNode(selection) {
  var anchor = selection.anchor,
      focus = selection.focus;
  var anchorNode = selection.anchor.getNode();
  var focusNode = selection.focus.getNode();

  if (anchorNode === focusNode) {
    return anchorNode;
  }

  if (selection.isBackward()) {
    return LexicalSelection_1.$isAtNodeEnd(focus) ? anchorNode : focusNode;
  } else {
    return LexicalSelection_1.$isAtNodeEnd(anchor) ? focusNode : anchorNode;
  }
};
var URL_MATCHER = RegExp(/((https?:\/\/(www\.)?)|(www\.))[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/);
var EMAIL_MATCHER = RegExp(/(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/);

var MATCHERS = [LexicalAutoLinkPlugin_1.createLinkMatcherWithRegExp(URL_MATCHER, function (text) {
  return text.startsWith('http') ? text : "https://".concat(text);
}), LexicalAutoLinkPlugin_1.createLinkMatcherWithRegExp(EMAIL_MATCHER, function (text) {
  return "mailto:".concat(text);
})];

var AutoLinkPlugin = function AutoLinkPlugin() {
  return /*#__PURE__*/React__default.createElement(LexicalAutoLinkPlugin_1.AutoLinkPlugin, {
    matchers: MATCHERS
  });
};

var AlignLeft = function AlignLeft() {
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "14",
    height: "13",
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.999996 0.419983H13C13.5143 0.419983 13.8571 0.76284 13.8571 1.27713C13.8571 1.79141 13.5143 2.13427 13 2.13427H0.999996C0.772667 2.13427 0.55465 2.04396 0.393904 1.88322C0.233159 1.72247 0.142853 1.50445 0.142853 1.27713C0.142853 1.0498 0.233159 0.83178 0.393904 0.671034C0.55465 0.510289 0.772667 0.419983 0.999996 0.419983ZM0.999996 3.84855H7.85714C8.37142 3.84855 8.71428 4.19141 8.71428 4.7057C8.71428 5.21998 8.37142 5.56284 7.85714 5.56284H0.999996C0.772667 5.56284 0.55465 5.47253 0.393904 5.31179C0.233159 5.15104 0.142853 4.93303 0.142853 4.7057C0.142853 4.47837 0.233159 4.26035 0.393904 4.09961C0.55465 3.93886 0.772667 3.84855 0.999996 3.84855ZM0.999996 10.7057H7.85714C8.37142 10.7057 8.71428 11.0486 8.71428 11.5628C8.71428 12.0771 8.37142 12.42 7.85714 12.42H0.999996C0.772667 12.42 0.55465 12.3297 0.393904 12.1689C0.233159 12.0082 0.142853 11.7902 0.142853 11.5628C0.142853 11.3355 0.233159 11.1175 0.393904 10.9567C0.55465 10.796 0.772667 10.7057 0.999996 10.7057ZM0.999996 7.27713H13C13.5143 7.27713 13.8571 7.61998 13.8571 8.13427C13.8571 8.64855 13.5143 8.99141 13 8.99141H0.999996C0.772667 8.99141 0.55465 8.90111 0.393904 8.74036C0.233159 8.57961 0.142853 8.3616 0.142853 8.13427C0.142853 7.90694 0.233159 7.68892 0.393904 7.52818C0.55465 7.36743 0.772667 7.27713 0.999996 7.27713Z",
    fill: "#4F4F4F"
  }));
};

var AlignRight = function AlignRight() {
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "14",
    height: "13",
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0.419983H1C0.485719 0.419983 0.142861 0.76284 0.142861 1.27713C0.142861 1.79141 0.485719 2.13427 1 2.13427H13C13.2273 2.13427 13.4454 2.04396 13.6061 1.88322C13.7668 1.72247 13.8571 1.50445 13.8571 1.27713C13.8571 1.0498 13.7668 0.83178 13.6061 0.671034C13.4454 0.510289 13.2273 0.419983 13 0.419983ZM13 3.84855H6.14286C5.62858 3.84855 5.28572 4.19141 5.28572 4.7057C5.28572 5.21998 5.62858 5.56284 6.14286 5.56284H13C13.2273 5.56284 13.4454 5.47253 13.6061 5.31179C13.7668 5.15104 13.8571 4.93303 13.8571 4.7057C13.8571 4.47837 13.7668 4.26035 13.6061 4.09961C13.4454 3.93886 13.2273 3.84855 13 3.84855ZM13 10.7057H6.14286C5.62858 10.7057 5.28572 11.0486 5.28572 11.5628C5.28572 12.0771 5.62858 12.42 6.14286 12.42H13C13.2273 12.42 13.4454 12.3297 13.6061 12.1689C13.7668 12.0082 13.8571 11.7902 13.8571 11.5628C13.8571 11.3355 13.7668 11.1175 13.6061 10.9567C13.4454 10.796 13.2273 10.7057 13 10.7057ZM13 7.27713H1C0.485719 7.27713 0.142861 7.61998 0.142861 8.13427C0.142861 8.64855 0.485719 8.99141 1 8.99141H13C13.2273 8.99141 13.4454 8.90111 13.6061 8.74036C13.7668 8.57961 13.8571 8.3616 13.8571 8.13427C13.8571 7.90694 13.7668 7.68892 13.6061 7.52818C13.4454 7.36743 13.2273 7.27713 13 7.27713Z",
    fill: "#4F4F4F"
  }));
};

var Bold = function Bold() {
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "10",
    height: "13",
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.971428 12.42C0.714285 12.42 0.542856 12.42 0.457142 12.2486L0.285713 11.82V1.01998C0.285713 0.848554 0.285713 0.677126 0.457142 0.591411L0.971428 0.419983H5.25714C6.54286 0.419983 7.57143 0.677126 8.25714 1.27713C8.85714 1.79141 9.2 2.47713 9.2 3.41998C9.21911 4.00558 9.03767 4.58014 8.68571 5.04855C8.34286 5.56284 7.82857 5.9057 7.31428 6.07713C7.65714 6.16284 8.08571 6.33427 8.42857 6.59141C8.77143 6.84855 9.11428 7.19141 9.28571 7.61998C9.62857 7.96284 9.71428 8.47713 9.71428 8.99141C9.71428 10.1057 9.37143 10.9628 8.6 11.5628C7.91429 12.1628 6.8 12.42 5.34286 12.42H0.971428ZM5.25714 5.3057C5.77143 5.3057 6.28571 5.21998 6.62857 4.87713C6.97143 4.61998 7.14286 4.27713 7.14286 3.76284C7.14286 2.81998 6.45714 2.3057 5.17143 2.3057H2.25714V5.3057H5.17143H5.25714ZM5.68571 10.4486C6.28571 10.4486 6.8 10.3628 7.14286 10.1057C7.48571 9.76284 7.65714 9.33427 7.65714 8.81998C7.65714 8.3057 7.48571 7.96284 7.05714 7.61998C6.71428 7.36284 6.2 7.27713 5.34286 7.27713H2.34286V10.5343H5.77143L5.68571 10.4486Z",
    fill: "#4F4F4F"
  }));
};

var BulletList = function BulletList() {
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "12",
    height: "13",
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.61998C0 0.957583 0.444 0.419983 1 0.419983C1.552 0.419983 2 0.952783 2 1.61998C2 2.28238 1.556 2.81998 1 2.81998C0.448 2.81998 0 2.28718 0 1.61998ZM5 0.419983H11C11.2652 0.419983 11.5196 0.546411 11.7071 0.771455C11.8946 0.996499 12 1.30172 12 1.61998C12 1.93824 11.8946 2.24347 11.7071 2.46851C11.5196 2.69355 11.2652 2.81998 11 2.81998H5C4.73478 2.81998 4.48043 2.69355 4.29289 2.46851C4.10536 2.24347 4 1.93824 4 1.61998C4 1.30172 4.10536 0.996499 4.29289 0.771455C4.48043 0.546411 4.73478 0.419983 5 0.419983ZM0 6.41998C0 5.75758 0.444 5.21998 1 5.21998C1.552 5.21998 2 5.75278 2 6.41998C2 7.08238 1.556 7.61998 1 7.61998C0.448 7.61998 0 7.08718 0 6.41998ZM5 5.21998H11C11.2652 5.21998 11.5196 5.34641 11.7071 5.57146C11.8946 5.7965 12 6.10172 12 6.41998C12 6.73824 11.8946 7.04347 11.7071 7.26851C11.5196 7.49355 11.2652 7.61998 11 7.61998H5C4.73478 7.61998 4.48043 7.49355 4.29289 7.26851C4.10536 7.04347 4 6.73824 4 6.41998C4 6.10172 4.10536 5.7965 4.29289 5.57146C4.48043 5.34641 4.73478 5.21998 5 5.21998ZM0 11.22C0 10.5576 0.444 10.02 1 10.02C1.552 10.02 2 10.5528 2 11.22C2 11.8824 1.556 12.42 1 12.42C0.448 12.42 0 11.8872 0 11.22ZM5 10.02H11C11.2652 10.02 11.5196 10.1464 11.7071 10.3715C11.8946 10.5965 12 10.9017 12 11.22C12 11.5382 11.8946 11.8435 11.7071 12.0685C11.5196 12.2936 11.2652 12.42 11 12.42H5C4.73478 12.42 4.48043 12.2936 4.29289 12.0685C4.10536 11.8435 4 11.5382 4 11.22C4 10.9017 4.10536 10.5965 4.29289 10.3715C4.48043 10.1464 4.73478 10.02 5 10.02Z",
    fill: "#4F4F4F"
  }));
};

var ChevronDown = function ChevronDown() {
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "10",
    height: "6",
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M1 1.41998L5 5.41998L9 1.41998",
    stroke: "#4F4F4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var Italic = function Italic() {
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "8",
    height: "13",
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.60839 0.419983L7.52448 1.17523H7.27273C6.76923 1.17523 6.43357 1.17523 6.0979 1.42698C5.84615 1.67872 5.76224 1.93047 5.67832 2.35005L3.91609 10.5738V11.0773C3.91609 11.4969 4.25175 11.7487 5.09091 11.7487H5.25874L5.09091 12.42H0.307693L0.475525 11.7487H0.643357C1.56643 11.7487 2.15385 11.3291 2.32168 10.4899L4 2.26614L4.08392 1.84656C4.08392 1.34306 3.74825 1.17523 2.90909 1.17523H2.65734L2.82518 0.419983H7.69231H7.60839Z",
    fill: "#4F4F4F"
  }));
};

var Link = function Link() {
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "13",
    height: "13",
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M6.35902 3.54433C6.21487 3.68131 6.02292 3.75654 5.82409 3.75401C5.62526 3.75147 5.43529 3.67136 5.29468 3.53075C5.15408 3.39014 5.07396 3.20017 5.07142 3.00134C5.06889 2.80251 5.14413 2.61056 5.2811 2.46641L6.35991 1.3876C6.66664 1.08083 7.03079 0.837484 7.43156 0.67146C7.83234 0.505435 8.2619 0.419983 8.69571 0.419983C9.12951 0.419983 9.55907 0.505435 9.95985 0.67146C10.3606 0.837484 10.7248 1.08083 11.0315 1.3876C11.3388 1.6941 11.5826 2.05821 11.749 2.45906C11.9153 2.85991 12.001 3.28965 12.0011 3.72366C12.0012 4.15767 11.9157 4.58743 11.7495 4.98835C11.5832 5.38927 11.3396 5.75346 11.0324 6.06008L9.95358 7.1389L9.23911 7.85336C8.9324 8.16091 8.56809 8.40499 8.167 8.57167C7.76591 8.73835 7.33591 8.82435 6.90157 8.82476C6.46723 8.82518 6.03706 8.73999 5.63566 8.57407C5.23425 8.40816 4.86948 8.16477 4.56218 7.85781C4.41913 7.71475 4.33876 7.52072 4.33876 7.3184C4.33876 7.11608 4.41913 6.92205 4.56218 6.779C4.70524 6.63594 4.89927 6.55557 5.10159 6.55557C5.30391 6.55557 5.49794 6.63594 5.641 6.779C6.33503 7.47391 7.46272 7.47214 8.16119 6.77455L8.87566 6.06097L9.95447 4.98216C10.12 4.81714 10.2513 4.62106 10.3409 4.40518C10.4305 4.18929 10.4765 3.95783 10.4765 3.7241C10.4764 3.49037 10.4302 3.25895 10.3404 3.04312C10.2507 2.8273 10.1192 2.63131 9.95358 2.46641C9.78852 2.30116 9.59251 2.17007 9.37675 2.08063C9.16099 1.99119 8.92972 1.94516 8.69615 1.94516C8.46259 1.94516 8.23132 1.99119 8.01556 2.08063C7.7998 2.17007 7.60378 2.30116 7.43872 2.46641L6.35902 3.54433ZM5.641 9.29563C5.78514 9.15866 5.9771 9.08342 6.17593 9.08596C6.37476 9.0885 6.56473 9.16861 6.70534 9.30922C6.84594 9.44982 6.92606 9.63979 6.92859 9.83862C6.93113 10.0375 6.85589 10.2294 6.71892 10.3736L5.64011 11.4524C5.33338 11.7591 4.96923 12.0025 4.56845 12.1685C4.16767 12.3345 3.73812 12.42 3.30431 12.42C2.8705 12.42 2.44095 12.3345 2.04017 12.1685C1.63939 12.0025 1.27524 11.7591 0.968512 11.4524C0.661234 11.1459 0.417426 10.7818 0.251047 10.3809C0.0846674 9.98005 -0.00101603 9.55032 -0.00109857 9.11631C-0.00118112 8.6823 0.0843389 8.25253 0.250566 7.85162C0.416793 7.4507 0.660462 7.08651 0.967623 6.77988L2.04644 5.70107L2.7609 4.9866C3.06761 4.67906 3.43193 4.43497 3.83301 4.2683C4.2341 4.10162 4.66411 4.01562 5.09845 4.0152C5.53279 4.01479 5.96296 4.09998 6.36436 4.26589C6.76577 4.43181 7.13054 4.6752 7.43783 4.98216C7.58089 5.12522 7.66126 5.31925 7.66126 5.52157C7.66126 5.72388 7.58089 5.91791 7.43783 6.06097C7.29477 6.20403 7.10074 6.2844 6.89843 6.2844C6.69611 6.2844 6.50208 6.20403 6.35902 6.06097C6.19327 5.89575 5.9966 5.7648 5.78023 5.6756C5.56386 5.5864 5.33204 5.5407 5.098 5.54111C4.86397 5.54152 4.63231 5.58804 4.41626 5.678C4.20021 5.76796 4.00399 5.89961 3.83883 6.06541L3.12436 6.779L2.04555 7.85781C1.88001 8.02282 1.74869 8.2189 1.65912 8.43479C1.56954 8.65068 1.52347 8.88213 1.52355 9.11587C1.52364 9.3496 1.56987 9.58102 1.6596 9.79685C1.74933 10.0127 1.88079 10.2087 2.04644 10.3736C2.2115 10.5388 2.40751 10.6699 2.62327 10.7593C2.83903 10.8488 3.0703 10.8948 3.30387 10.8948C3.53743 10.8948 3.7687 10.8488 3.98446 10.7593C4.20022 10.6699 4.39623 10.5388 4.5613 10.3736L5.641 9.29563Z",
    fill: "#4F4F4F"
  }));
};

var OrderedList = function OrderedList() {
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "14",
    height: "13",
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9091 0.419983H12.4546C12.7439 0.419983 13.0214 0.534918 13.2259 0.739503C13.4305 0.944088 13.5455 1.22156 13.5455 1.51089C13.5455 1.80022 13.4305 2.0777 13.2259 2.28228C13.0214 2.48687 12.7439 2.6018 12.4546 2.6018H5.9091C5.61978 2.6018 5.3423 2.48687 5.13772 2.28228C4.93313 2.0777 4.8182 1.80022 4.8182 1.51089C4.8182 1.22156 4.93313 0.944088 5.13772 0.739503C5.3423 0.534918 5.61978 0.419983 5.9091 0.419983ZM5.9091 4.78362H12.4546C12.7439 4.78362 13.0214 4.89855 13.2259 5.10314C13.4305 5.30772 13.5455 5.5852 13.5455 5.87453C13.5455 6.16386 13.4305 6.44133 13.2259 6.64592C13.0214 6.8505 12.7439 6.96544 12.4546 6.96544H5.9091C5.61978 6.96544 5.3423 6.8505 5.13772 6.64592C4.93313 6.44133 4.8182 6.16386 4.8182 5.87453C4.8182 5.5852 4.93313 5.30772 5.13772 5.10314C5.3423 4.89855 5.61978 4.78362 5.9091 4.78362ZM5.9091 9.14726H12.4546C12.7439 9.14726 13.0214 9.26219 13.2259 9.46678C13.4305 9.67136 13.5455 9.94884 13.5455 10.2382C13.5455 10.5275 13.4305 10.805 13.2259 11.0096C13.0214 11.2141 12.7439 11.3291 12.4546 11.3291H5.9091C5.61978 11.3291 5.3423 11.2141 5.13772 11.0096C4.93313 10.805 4.8182 10.5275 4.8182 10.2382C4.8182 9.94884 4.93313 9.67136 5.13772 9.46678C5.3423 9.26219 5.61978 9.14726 5.9091 9.14726ZM0.454559 9.14726H3.72729V10.2382H0.454559V9.14726ZM0.454559 11.3291H3.72729V12.42H0.454559V11.3291ZM1.54547 1.51089H0.454559V0.419983H2.63638V3.69271H1.54547V1.51089ZM0.454559 4.78362H3.72729V6.2378H3.07274V6.96544H1.76365V6.2378H0.454559V4.78362ZM0.454559 6.96544H3.72729V8.05635H0.454559V6.96544ZM2.63638 10.2382H4.8182V11.3291H2.63638V10.2382Z",
    fill: "#4F4F4F"
  }));
};

var Redo = function Redo() {
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "12",
    height: "13",
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M9.25621 3.8932H5.28682C2.66419 3.8932 0.892139 5.31084 0.466848 7.50818C0.0415564 9.42199 0.750375 11.4776 2.09713 12.3281C2.18091 12.3747 2.27303 12.4043 2.36824 12.4152C2.46345 12.4262 2.55988 12.4182 2.65203 12.3919C2.74417 12.3656 2.83023 12.3214 2.90529 12.2618C2.98035 12.2022 3.04294 12.1284 3.08948 12.0446C3.13602 11.9608 3.16561 11.8687 3.17655 11.7735C3.18748 11.6783 3.17956 11.5819 3.15324 11.4897C3.12691 11.3976 3.08269 11.3115 3.0231 11.2365C2.96351 11.1614 2.88973 11.0988 2.80595 11.0523C2.02625 10.627 1.53008 9.13846 1.8136 7.7917C2.16801 6.30318 3.30212 5.31084 5.28682 5.31084H9.25621L6.9171 7.64994C6.83586 7.71087 6.76866 7.78855 6.72005 7.87772C6.67144 7.96688 6.64256 8.06545 6.63536 8.16675C6.62816 8.26805 6.64281 8.36971 6.67832 8.46485C6.71383 8.55999 6.76937 8.6464 6.84118 8.71821C6.91299 8.79002 6.99939 8.84556 7.09454 8.88107C7.18968 8.91658 7.29134 8.93123 7.39264 8.92403C7.49394 8.91683 7.59251 8.88795 7.68167 8.83934C7.77084 8.79073 7.84852 8.72353 7.90945 8.64229L11.4535 5.09819C11.5834 4.96569 11.6562 4.78755 11.6562 4.60202C11.6562 4.41648 11.5834 4.23834 11.4535 4.10584L7.90945 0.561748C7.77295 0.459374 7.6041 0.409672 7.43391 0.421767C7.26372 0.433862 7.1036 0.506943 6.98295 0.627592C6.8623 0.748241 6.78922 0.908361 6.77712 1.07856C6.76503 1.24875 6.81473 1.4176 6.9171 1.55409L9.25621 3.8932Z",
    fill: "#4F4F4F"
  }));
};

var Undo = function Undo() {
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "12",
    height: "13",
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M2.74375 3.8932H6.71314C9.33577 3.8932 11.1078 5.31084 11.5331 7.50818C11.9584 9.42199 11.2496 11.4776 9.90282 12.3281C9.81905 12.3747 9.72693 12.4043 9.63172 12.4152C9.53651 12.4262 9.44008 12.4182 9.34793 12.3919C9.25578 12.3656 9.16972 12.3214 9.09466 12.2618C9.0196 12.2022 8.95702 12.1284 8.91048 12.0446C8.86393 11.9608 8.83435 11.8687 8.82341 11.7735C8.81247 11.6783 8.82039 11.5819 8.84672 11.4897C8.87305 11.3976 8.91727 11.3115 8.97685 11.2365C9.03644 11.1614 9.11023 11.0988 9.194 11.0523C9.9737 10.627 10.4699 9.13846 10.1863 7.7917C9.83194 6.30318 8.69783 5.31084 6.71314 5.31084H2.74375L5.08285 7.64994C5.16409 7.71087 5.2313 7.78855 5.27991 7.87772C5.32852 7.96688 5.3574 8.06545 5.3646 8.16675C5.3718 8.26805 5.35714 8.36971 5.32163 8.46485C5.28612 8.55999 5.23058 8.6464 5.15877 8.71821C5.08696 8.79002 5.00056 8.84556 4.90542 8.88107C4.81027 8.91658 4.70861 8.93123 4.60731 8.92403C4.50601 8.91683 4.40745 8.88795 4.31828 8.83934C4.22912 8.79073 4.15144 8.72353 4.09051 8.64229L0.546409 5.09819C0.416534 4.96569 0.343788 4.78755 0.343788 4.60202C0.343788 4.41648 0.416534 4.23834 0.546409 4.10584L4.09051 0.561748C4.227 0.459374 4.39585 0.409672 4.56604 0.421767C4.73624 0.433862 4.89636 0.506943 5.01701 0.627592C5.13766 0.748241 5.21074 0.908361 5.22283 1.07856C5.23493 1.24875 5.18523 1.4176 5.08285 1.55409L2.74375 3.8932Z",
    fill: "#4F4F4F"
  }));
};

var BlockTypeOptions = function BlockTypeOptions(_ref) {
  var selectedBlockType = _ref.selectedBlockType,
      onClose = _ref.onClose;

  var _useLexicalComposerCo = LexicalComposerContext_1.useLexicalComposerContext(),
      _useLexicalComposerCo2 = _slicedToArray$1(_useLexicalComposerCo, 1),
      editor = _useLexicalComposerCo2[0];

  var dropdownRef = useRef(null);
  var theme = useThemeSafe();
  var styles = useStyles$r({
    theme: theme
  });
  useOutsideClick(dropdownRef, onClose);

  var formatParagraph = function formatParagraph() {
    if (selectedBlockType !== 'paragraph') {
      editor.update(function () {
        var selection = Lexical_1.$getSelection();

        if (Lexical_1.$isRangeSelection(selection)) {
          LexicalSelection_1.$setBlocksType(selection, function () {
            return Lexical_1.$createParagraphNode();
          });
        }
      });
    }

    onClose();
  };

  var formatHeadline = function formatHeadline() {
    if (selectedBlockType !== 'h1') {
      editor.update(function () {
        var selection = Lexical_1.$getSelection();

        if (Lexical_1.$isRangeSelection(selection)) {
          LexicalSelection_1.$setBlocksType(selection, function () {
            return LexicalRichText_1.$createHeadingNode('h1');
          });
        }
      });
    }

    onClose();
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.dropdown,
    ref: dropdownRef
  }, /*#__PURE__*/React__default.createElement("button", {
    className: styles.dropdownItem,
    onClick: formatParagraph
  }, /*#__PURE__*/React__default.createElement(Text$1, {
    variant: "body",
    className: styles.itemText
  }, "Paragraph")), /*#__PURE__*/React__default.createElement("button", {
    className: styles.dropdownItem,
    onClick: formatHeadline
  }, /*#__PURE__*/React__default.createElement(Text$1, {
    variant: "body",
    className: styles.itemText
  }, "Headline")));
};
var useStyles$r = createUseStyles(function (_ref2) {
  var palette = _ref2.palette,
      shape = _ref2.shape,
      shadows = _ref2.shadows,
      zIndex = _ref2.zIndex;
  return {
    dropdown: {
      top: 40,
      left: 80,
      zIndex: zIndex.high,
      display: 'block',
      position: 'absolute',
      boxShadow: shadows[0],
      borderRadius: shape.borderRadiusLight,
      backgroundColor: palette.white.color,
      padding: '12px 40px 12px 20px',
      width: 70,
      height: 48,
      '& > :first-child': {
        marginBottom: 12
      }
    },
    dropdownItem: {
      cursor: 'pointer',
      display: 'flex',
      alignContent: 'center',
      flexDirection: 'row',
      flexShrink: '0',
      justifyContent: 'space-between',
      backgroundColor: palette.white.color,
      border: '0'
    },
    itemText: {
      color: palette.grey.color
    }
  };
});

var Divider = function Divider() {
  var theme = useThemeSafe();
  return /*#__PURE__*/React__default.createElement(Divider$1, {
    orientation: "vertical",
    thickness: 1,
    color: theme.palette.background.color
  });
};

var OnlyLinkEditor = function OnlyLinkEditor(_ref) {
  var isOpen = _ref.isOpen,
      toggleIsOpen = _ref.toggleIsOpen;
      _ref.targetElement;

  var _useLexicalComposerCo = LexicalComposerContext_1.useLexicalComposerContext(),
      _useLexicalComposerCo2 = _slicedToArray$1(_useLexicalComposerCo, 1),
      editor = _useLexicalComposerCo2[0];

  var _useState = useState(''),
      _useState2 = _slicedToArray$1(_useState, 2),
      linkURL = _useState2[0],
      setLinkURL = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray$1(_useState3, 2),
      lastSelection = _useState4[0],
      setLastSelection = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray$1(_useState5, 2),
      popoverTargetElement = _useState6[0],
      setPopoverTargetElement = _useState6[1];

  var theme = useThemeSafe();
  var styles = useStyles$q({
    theme: theme
  });
  var updateLinkEditor = useCallback(function () {
    var selection = Lexical_1.$getSelection();

    if (Lexical_1.$isRangeSelection(selection)) {
      var node = getSelectedNode(selection);
      var elementKey = node.getKey();
      setPopoverTargetElement(editor.getElementByKey(elementKey));
      var parent = node.getParent();

      if (LexicalLink_1.$isLinkNode(parent)) {
        setLinkURL(parent.getURL());
      } else if (LexicalLink_1.$isLinkNode(node)) {
        setLinkURL(node.getURL());
      } else {
        setLinkURL('');
      }
    }

    var rootElement = editor.getRootElement();

    if (selection !== null && rootElement !== null) {
      setLastSelection(selection);
    } else if (!document.activeElement) {
      setLastSelection(null);
    }

    return true;
  }, [editor]);
  useEffect(function () {
    return LexicalUtils_1.mergeRegister(editor.registerUpdateListener(function (_ref2) {
      var editorState = _ref2.editorState;
      editorState.read(function () {
        updateLinkEditor();
      });
    }), editor.registerCommand(Lexical_1.SELECTION_CHANGE_COMMAND, function () {
      updateLinkEditor();
      return true;
    }, Lexical_1.COMMAND_PRIORITY_LOW));
  }, [editor.registerUpdateListener, editor.registerCommand, updateLinkEditor]);
  useEffect(function () {
    editor.getEditorState().read(function () {
      updateLinkEditor();
    });
  }, [editor.getEditorState, updateLinkEditor]);

  var handleLinkURLChange = function handleLinkURLChange(e) {
    setLinkURL(e.target.value);
  };

  var handlePopoverVisibilityChange = function handlePopoverVisibilityChange() {
    setLinkURL('');
    toggleIsOpen();
  };

  var handleCancelClick = function handleCancelClick() {
    handlePopoverVisibilityChange();
  };

  var handleApplyClick = function handleApplyClick() {
    if (lastSelection !== null && linkURL !== '') {
      editor.dispatchCommand(LexicalLink_1.TOGGLE_LINK_COMMAND, linkURL);
    }

    handlePopoverVisibilityChange();
  };

  var handleLinkValidate = function handleLinkValidate(url) {
    return URL_MATCHER.test(url);
  };

  return /*#__PURE__*/React__default.createElement(Popover, {
    visible: isOpen,
    onVisibilityChange: handlePopoverVisibilityChange,
    target: popoverTargetElement,
    placement: "bottom-start",
    className: styles.popover
  }, /*#__PURE__*/React__default.createElement(FieldView, {
    title: "Insert link"
  }, /*#__PURE__*/React__default.createElement(TextField, {
    placeholder: "Insert link",
    className: styles.linkInput,
    value: linkURL,
    onChange: handleLinkURLChange,
    onValidate: handleLinkValidate,
    errorMessage: "Link must be a valid URL"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: styles.buttonsWrapper
  }, /*#__PURE__*/React__default.createElement(Button, {
    variant: "secondary",
    onClick: handleCancelClick
  }, "Cancel"), /*#__PURE__*/React__default.createElement(Button, {
    variant: "primary",
    onClick: handleApplyClick,
    disabled: !linkURL || !handleLinkValidate(linkURL)
  }, "Apply")));
};
var useStyles$q = createUseStyles(function (_ref3) {
  var palette = _ref3.palette;
  return {
    popover: {
      width: 448,
      height: 128,
      padding: 16
    },
    linkInput: {
      display: 'flex'
    },
    inputIconWrapper: {
      marginRight: 8
    },
    link: {
      color: palette.primary.color,
      textDecoration: 'none',
      display: 'block',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      marginRight: 32,
      textOverflow: 'ellipsis',
      '&:hover': {
        textDecoration: 'underline'
      }
    },
    buttonsWrapper: {
      display: 'flex',
      justifyContent: 'end',
      marginTop: 8,
      gap: 16
    }
  };
});

var supportedBlockTypes = new Set(['h1', 'paragraph', 'ol', 'ul']);
var blockTypeToBlockName = {
  h1: 'Headline',
  paragraph: 'Paragraph',
  ol: 'Paragraph',
  ul: 'Paragraph'
};
var PARAGRAPH = 'paragraph';

var ToolbarPlugin = function ToolbarPlugin() {
  var _useLexicalComposerCo = LexicalComposerContext_1.useLexicalComposerContext(),
      _useLexicalComposerCo2 = _slicedToArray$1(_useLexicalComposerCo, 1),
      editor = _useLexicalComposerCo2[0];

  var toolbarRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      canUndo = _useState2[0],
      setCanUndo = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$1(_useState3, 2),
      canRedo = _useState4[0],
      setCanRedo = _useState4[1];

  var _useState5 = useState(PARAGRAPH),
      _useState6 = _slicedToArray$1(_useState5, 2),
      selectedBlockType = _useState6[0],
      setSelectedBlockType = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray$1(_useState7, 2),
      showBlockTypeOptions = _useState8[0],
      setShowBlockTypeOptions = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray$1(_useState9, 2),
      setIsRTL = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray$1(_useState11, 2),
      isBold = _useState12[0],
      setIsBold = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray$1(_useState13, 2),
      isItalic = _useState14[0],
      setIsItalic = _useState14[1];

  var _useState15 = useState(''),
      _useState16 = _slicedToArray$1(_useState15, 2),
      align = _useState16[0],
      setAlign = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray$1(_useState17, 2),
      isLinkEditorOpen = _useState18[0],
      setIsLinkEditorOpen = _useState18[1];

  var theme = useThemeSafe();
  var styles = useStyles$p({
    theme: theme
  });
  var updateToolbar = useCallback(function () {
    var selection = Lexical_1.$getSelection();

    if (!Lexical_1.$isRangeSelection(selection)) {
      return;
    }

    var anchorNode = selection.anchor.getNode();
    var element = anchorNode.getKey() === 'root' ? anchorNode : anchorNode.getTopLevelElementOrThrow();
    var blockType = LexicalRichText_1.$isHeadingNode(element) ? element.getTag() : element.getType();

    if (LexicalList_1.$isListNode(element)) {
      var parentList = LexicalUtils_1.$getNearestNodeOfType(anchorNode, LexicalList_1.ListNode);
      blockType = parentList ? parentList.getTag() : element.getTag();
    }

    setSelectedBlockType(blockType);

    if (Lexical_1.$isElementNode(element)) {
      var formatType = element.getFormatType();
      setAlign(formatType || 'left');
    }

    setIsBold(selection.hasFormat('bold'));
    setIsItalic(selection.hasFormat('italic'));
    setIsRTL(LexicalSelection_1.$isParentElementRTL(selection));
  }, [editor]);
  useEffect(function () {
    return LexicalUtils_1.mergeRegister(editor.registerUpdateListener(function (_ref) {
      var editorState = _ref.editorState;
      editorState.read(function () {
        updateToolbar();
      });
    }), editor.registerCommand(Lexical_1.SELECTION_CHANGE_COMMAND, function (_payload) {
      updateToolbar();
      return false;
    }, Lexical_1.COMMAND_PRIORITY_LOW), editor.registerCommand(Lexical_1.CAN_UNDO_COMMAND, function (payload) {
      setCanUndo(payload);
      return false;
    }, Lexical_1.COMMAND_PRIORITY_LOW), editor.registerCommand(Lexical_1.CAN_REDO_COMMAND, function (payload) {
      setCanRedo(payload);
      return false;
    }, Lexical_1.COMMAND_PRIORITY_LOW));
  }, [editor, updateToolbar]);

  var handleBlockTypeClick = function handleBlockTypeClick() {
    if (selectedBlockType === 'ul' || selectedBlockType === 'ol') {
      return;
    }

    setShowBlockTypeOptions(function (prev) {
      return !prev;
    });
  };

  var handleUndoClick = function handleUndoClick() {
    editor.dispatchCommand(Lexical_1.UNDO_COMMAND, undefined);
  };

  var handleRedoClick = function handleRedoClick() {
    editor.dispatchCommand(Lexical_1.REDO_COMMAND, undefined);
  };

  var handleBoldClick = function handleBoldClick() {
    editor.dispatchCommand(Lexical_1.FORMAT_TEXT_COMMAND, 'bold');
  };

  var handleItalicClick = function handleItalicClick() {
    editor.dispatchCommand(Lexical_1.FORMAT_TEXT_COMMAND, 'italic');
  };

  var handleLeftAlignClick = function handleLeftAlignClick() {
    editor.dispatchCommand(Lexical_1.FORMAT_ELEMENT_COMMAND, 'left');
  };

  var handleRightAlignClick = function handleRightAlignClick() {
    editor.dispatchCommand(Lexical_1.FORMAT_ELEMENT_COMMAND, 'right');
  };

  var handleBulletListClick = function handleBulletListClick() {
    if (selectedBlockType === 'h1') {
      return;
    }

    if (selectedBlockType !== 'ul') {
      editor.dispatchCommand(LexicalList_1.INSERT_UNORDERED_LIST_COMMAND, undefined);
    } else {
      editor.dispatchCommand(LexicalList_1.REMOVE_LIST_COMMAND, undefined);
    }
  };

  var handleOrderedListClick = function handleOrderedListClick() {
    if (selectedBlockType === 'h1') {
      return;
    }

    if (selectedBlockType !== 'ol') {
      editor.dispatchCommand(LexicalList_1.INSERT_ORDERED_LIST_COMMAND, undefined);
    } else {
      editor.dispatchCommand(LexicalList_1.REMOVE_LIST_COMMAND, undefined);
    }
  };

  var handleLinkClick = function handleLinkClick() {
    setIsLinkEditorOpen(function (prev) {
      return !prev;
    });
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: styles.toolbar,
    ref: toolbarRef
  }, /*#__PURE__*/React__default.createElement("button", {
    disabled: !canUndo,
    onClick: handleUndoClick,
    className: styles.toolbarItem,
    "aria-label": "Undo"
  }, /*#__PURE__*/React__default.createElement(Undo, null)), /*#__PURE__*/React__default.createElement("button", {
    disabled: !canRedo,
    onClick: handleRedoClick,
    className: styles.toolbarItem,
    "aria-label": "Redo"
  }, /*#__PURE__*/React__default.createElement(Redo, null)), /*#__PURE__*/React__default.createElement(Divider, null), supportedBlockTypes.has(selectedBlockType) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("button", {
    className: clsx(styles.toolbarItem, styles.headerSelection, (selectedBlockType === 'ul' || selectedBlockType === 'ol') && styles.disabledItem),
    onClick: handleBlockTypeClick,
    "aria-label": "Formatting Options"
  }, /*#__PURE__*/React__default.createElement(Text$1, {
    variant: "body",
    className: styles.headerText
  }, blockTypeToBlockName[selectedBlockType]), /*#__PURE__*/React__default.createElement("span", {
    className: styles.chevronWrapper
  }, /*#__PURE__*/React__default.createElement(ChevronDown, null))), showBlockTypeOptions && /*#__PURE__*/React__default.createElement(BlockTypeOptions, {
    selectedBlockType: selectedBlockType,
    onClose: function onClose() {
      return setShowBlockTypeOptions(false);
    }
  }), /*#__PURE__*/React__default.createElement(Divider, null)), /*#__PURE__*/React__default.createElement("button", {
    onClick: handleBoldClick,
    className: clsx(styles.toolbarItem, isBold && styles.activeItem),
    "aria-label": "Format Bold"
  }, /*#__PURE__*/React__default.createElement(Bold, null)), /*#__PURE__*/React__default.createElement("button", {
    onClick: handleItalicClick,
    className: clsx(styles.toolbarItem, isItalic && styles.activeItem),
    "aria-label": "Format Italics"
  }, /*#__PURE__*/React__default.createElement(Italic, null)), /*#__PURE__*/React__default.createElement(Divider, null), /*#__PURE__*/React__default.createElement("button", {
    onClick: handleLeftAlignClick,
    className: clsx(styles.toolbarItem, align === 'left' && styles.activeItem),
    "aria-label": "Left Align"
  }, /*#__PURE__*/React__default.createElement(AlignLeft, null)), /*#__PURE__*/React__default.createElement("button", {
    onClick: handleRightAlignClick,
    className: clsx(styles.toolbarItem, align === 'right' && styles.activeItem),
    "aria-label": "Right Align"
  }, /*#__PURE__*/React__default.createElement(AlignRight, null)), /*#__PURE__*/React__default.createElement(Divider, null), /*#__PURE__*/React__default.createElement("button", {
    onClick: handleBulletListClick,
    className: clsx(styles.toolbarItem, selectedBlockType === 'ul' && styles.activeItem || selectedBlockType === 'h1' && styles.disabledItem),
    "aria-label": "Bullet List"
  }, /*#__PURE__*/React__default.createElement(BulletList, null)), /*#__PURE__*/React__default.createElement("button", {
    onClick: handleOrderedListClick,
    className: clsx(styles.toolbarItem, selectedBlockType === 'ol' && styles.activeItem || selectedBlockType === 'h1' && styles.disabledItem),
    "aria-label": "Ordered List"
  }, /*#__PURE__*/React__default.createElement(OrderedList, null)), /*#__PURE__*/React__default.createElement(Divider, null), /*#__PURE__*/React__default.createElement("button", {
    onClick: handleLinkClick,
    className: styles.toolbarItem,
    "aria-label": "Insert Link"
  }, /*#__PURE__*/React__default.createElement(Link, null)), /*#__PURE__*/React__default.createElement(Divider, null)), /*#__PURE__*/React__default.createElement(OnlyLinkEditor, {
    isOpen: isLinkEditorOpen,
    toggleIsOpen: handleLinkClick,
    targetElement: toolbarRef.current
  }));
};
var useStyles$p = createUseStyles(function (_ref2) {
  var palette = _ref2.palette,
      shape = _ref2.shape;
  return {
    toolbar: {
      display: 'flex',
      background: palette.white.color,
      height: 40,
      alignItems: 'center'
    },
    toolbarItem: {
      display: 'flex',
      width: 32,
      height: 32,
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: shape.borderRadiusLight,
      border: 0,
      margin: 4,
      background: 'none',
      '&:hover': {
        backgroundColor: palette.background.color
      }
    },
    activeItem: {
      backgroundColor: palette.secondary.color,
      '&:hover': {
        backgroundColor: palette.secondary.color
      },
      '& path': {
        fill: palette.white.color
      }
    },
    disabledItem: {
      opacity: '0.5',
      cursor: 'not-allowed',
      '&:hover': {
        backgroundColor: 'initial'
      }
    },
    headerSelection: {
      width: 120,
      height: 32,
      justifyContent: 'space-between'
    },
    headerText: {
      color: palette.grey.color
    },
    chevronWrapper: {
      display: 'flex'
    }
  };
});

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */




/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/** @noInheritDoc */
class MarkNode$1 extends Lexical_1.ElementNode {
  /** @internal */
  static getType() {
    return 'mark';
  }

  static clone(node) {
    return new MarkNode$1(Array.from(node.__ids), node.__key);
  }

  static importDOM() {
    return null;
  }

  static importJSON(serializedNode) {
    const node = $createMarkNode$1(serializedNode.ids);
    node.setFormat(serializedNode.format);
    node.setIndent(serializedNode.indent);
    node.setDirection(serializedNode.direction);
    return node;
  }

  exportJSON() {
    return { ...super.exportJSON(),
      ids: this.getIDs(),
      type: 'mark',
      version: 1
    };
  }

  constructor(ids, key) {
    super(key);
    this.__ids = ids || [];
  }

  createDOM(config) {
    const element = document.createElement('mark');
    LexicalUtils_1.addClassNamesToElement(element, config.theme.mark);

    if (this.__ids.length > 1) {
      LexicalUtils_1.addClassNamesToElement(element, config.theme.markOverlap);
    }

    return element;
  }

  updateDOM(prevNode, element, config) {
    const prevIDs = prevNode.__ids;
    const nextIDs = this.__ids;
    const prevIDsCount = prevIDs.length;
    const nextIDsCount = nextIDs.length;
    const overlapTheme = config.theme.markOverlap;

    if (prevIDsCount !== nextIDsCount) {
      if (prevIDsCount === 1) {
        if (nextIDsCount === 2) {
          LexicalUtils_1.addClassNamesToElement(element, overlapTheme);
        }
      } else if (nextIDsCount === 1) {
        LexicalUtils_1.removeClassNamesFromElement(element, overlapTheme);
      }
    }

    return false;
  }

  hasID(id) {
    const ids = this.getIDs();

    for (let i = 0; i < ids.length; i++) {
      if (id === ids[i]) {
        return true;
      }
    }

    return false;
  }

  getIDs() {
    const self = this.getLatest();
    return $isMarkNode$1(self) ? self.__ids : [];
  }

  addID(id) {
    const self = this.getWritable();

    if ($isMarkNode$1(self)) {
      const ids = self.__ids;
      self.__ids = ids;

      for (let i = 0; i < ids.length; i++) {
        // If we already have it, don't add again
        if (id === ids[i]) return;
      }

      ids.push(id);
    }
  }

  deleteID(id) {
    const self = this.getWritable();

    if ($isMarkNode$1(self)) {
      const ids = self.__ids;
      self.__ids = ids;

      for (let i = 0; i < ids.length; i++) {
        if (id === ids[i]) {
          ids.splice(i, 1);
          return;
        }
      }
    }
  }

  insertNewAfter(selection, restoreSelection = true) {
    const element = this.getParentOrThrow().insertNewAfter(selection, restoreSelection);

    if (Lexical_1.$isElementNode(element)) {
      const markNode = $createMarkNode$1(this.__ids);
      element.append(markNode);
      return markNode;
    }

    return null;
  }

  canInsertTextBefore() {
    return false;
  }

  canInsertTextAfter() {
    return false;
  }

  canBeEmpty() {
    return false;
  }

  isInline() {
    return true;
  }

  extractWithChild(child, selection, destination) {
    if (!Lexical_1.$isRangeSelection(selection) || destination === 'html') {
      return false;
    }

    const anchor = selection.anchor;
    const focus = selection.focus;
    const anchorNode = anchor.getNode();
    const focusNode = focus.getNode();
    const isBackward = selection.isBackward();
    const selectionLength = isBackward ? anchor.offset - focus.offset : focus.offset - anchor.offset;
    return this.isParentOf(anchorNode) && this.isParentOf(focusNode) && this.getTextContent().length === selectionLength;
  }

  excludeFromCopy(destination) {
    return destination !== 'clone';
  }

}
function $createMarkNode$1(ids) {
  return Lexical_1.$applyNodeReplacement(new MarkNode$1(ids));
}
function $isMarkNode$1(node) {
  return node instanceof MarkNode$1;
}

/** @module @lexical/mark */
function $unwrapMarkNode$1(node) {
  const children = node.getChildren();
  let target = null;

  for (let i = 0; i < children.length; i++) {
    const child = children[i];

    if (target === null) {
      node.insertBefore(child);
    } else {
      target.insertAfter(child);
    }

    target = child;
  }

  node.remove();
}
function $wrapSelectionInMarkNode$1(selection, isBackward, id, createNode) {
  const nodes = selection.getNodes();
  const anchorOffset = selection.anchor.offset;
  const focusOffset = selection.focus.offset;
  const nodesLength = nodes.length;
  const startOffset = isBackward ? focusOffset : anchorOffset;
  const endOffset = isBackward ? anchorOffset : focusOffset;
  let currentNodeParent;
  let lastCreatedMarkNode; // We only want wrap adjacent text nodes, line break nodes
  // and inline element nodes. For decorator nodes and block
  // element nodes, we step out of their boundary and start
  // again after, if there are more nodes.

  for (let i = 0; i < nodesLength; i++) {
    const node = nodes[i];

    if (Lexical_1.$isElementNode(lastCreatedMarkNode) && lastCreatedMarkNode.isParentOf(node)) {
      // If the current node is a child of the last created mark node, there is nothing to do here
      continue;
    }

    const isFirstNode = i === 0;
    const isLastNode = i === nodesLength - 1;
    let targetNode = null;

    if (Lexical_1.$isTextNode(node)) {
      // Case 1: The node is a text node and we can split it
      const textContentSize = node.getTextContentSize();
      const startTextOffset = isFirstNode ? startOffset : 0;
      const endTextOffset = isLastNode ? endOffset : textContentSize;

      if (startTextOffset === 0 && endTextOffset === 0) {
        continue;
      }

      const splitNodes = node.splitText(startTextOffset, endTextOffset);
      targetNode = splitNodes.length > 1 && (splitNodes.length === 3 || isFirstNode && !isLastNode || endTextOffset === textContentSize) ? splitNodes[1] : splitNodes[0];
    } else if ($isMarkNode$1(node)) {
      // Case 2: the node is a mark node and we can ignore it as a target,
      // moving on to its children. Note that when we make a mark inside
      // another mark, it may utlimately be unnested by a call to
      // `registerNestedElementResolver<MarkNode>` somewhere else in the
      // codebase.
      continue;
    } else if (Lexical_1.$isElementNode(node) && node.isInline()) {
      // Case 3: inline element nodes can be added in their entirety to the new
      // mark
      targetNode = node;
    }

    if (targetNode !== null) {
      // Now that we have a target node for wrapping with a mark, we can run
      // through special cases.
      if (targetNode && targetNode.is(currentNodeParent)) {
        // The current node is a child of the target node to be wrapped, there
        // is nothing to do here.
        continue;
      }

      const parentNode = targetNode.getParent();

      if (parentNode == null || !parentNode.is(currentNodeParent)) {
        // If the parent node is not the current node's parent node, we can
        // clear the last created mark node.
        lastCreatedMarkNode = undefined;
      }

      currentNodeParent = parentNode;

      if (lastCreatedMarkNode === undefined) {
        // If we don't have a created mark node, we can make one
        const createMarkNode = createNode || $createMarkNode$1;
        lastCreatedMarkNode = createMarkNode([id]);
        targetNode.insertBefore(lastCreatedMarkNode);
      } // Add the target node to be wrapped in the latest created mark node


      lastCreatedMarkNode.append(targetNode);
    } else {
      // If we don't have a target node to wrap we can clear our state and
      // continue on with the next node
      currentNodeParent = undefined;
      lastCreatedMarkNode = undefined;
    }
  } // Make selection collapsed at the end


  if (Lexical_1.$isElementNode(lastCreatedMarkNode)) {
    // eslint-disable-next-line no-unused-expressions
    isBackward ? lastCreatedMarkNode.selectStart() : lastCreatedMarkNode.selectEnd();
  }
}
function $getMarkIDs$1(node, offset) {
  let currentNode = node;

  while (currentNode !== null) {
    if ($isMarkNode$1(currentNode)) {
      return currentNode.getIDs();
    } else if (Lexical_1.$isTextNode(currentNode) && offset === currentNode.getTextContentSize()) {
      const nextSibling = currentNode.getNextSibling();

      if ($isMarkNode$1(nextSibling)) {
        return nextSibling.getIDs();
      }
    }

    currentNode = currentNode.getParent();
  }

  return null;
}

var $createMarkNode_1 = $createMarkNode$1;
var $getMarkIDs_1 = $getMarkIDs$1;
var $isMarkNode_1 = $isMarkNode$1;
var $unwrapMarkNode_1 = $unwrapMarkNode$1;
var $wrapSelectionInMarkNode_1 = $wrapSelectionInMarkNode$1;
var MarkNode_1 = MarkNode$1;

var LexicalMark_dev = {
	$createMarkNode: $createMarkNode_1,
	$getMarkIDs: $getMarkIDs_1,
	$isMarkNode: $isMarkNode_1,
	$unwrapMarkNode: $unwrapMarkNode_1,
	$wrapSelectionInMarkNode: $wrapSelectionInMarkNode_1,
	MarkNode: MarkNode_1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
class p extends Lexical_1.ElementNode{static getType(){return "mark"}static clone(a){return new p(Array.from(a.__ids),a.__key)}static importDOM(){return null}static importJSON(a){let b=q(a.ids);b.setFormat(a.format);b.setIndent(a.indent);b.setDirection(a.direction);return b}exportJSON(){return {...super.exportJSON(),ids:this.getIDs(),type:"mark",version:1}}constructor(a,b){super(b);this.__ids=a||[];}createDOM(a){let b=document.createElement("mark");LexicalUtils_1.addClassNamesToElement(b,a.theme.mark);1<this.__ids.length&&
LexicalUtils_1.addClassNamesToElement(b,a.theme.markOverlap);return b}updateDOM(a,b,c){a=a.__ids.length;let d=this.__ids.length;c=c.theme.markOverlap;a!==d&&(1===a?2===d&&LexicalUtils_1.addClassNamesToElement(b,c):1===d&&LexicalUtils_1.removeClassNamesFromElement(b,c));return !1}hasID(a){let b=this.getIDs();for(let c=0;c<b.length;c++)if(a===b[c])return !0;return !1}getIDs(){let a=this.getLatest();return r(a)?a.__ids:[]}addID(a){var b=this.getWritable();if(r(b)){let c=b.__ids;b.__ids=c;for(b=0;b<c.length;b++)if(a===c[b])return;c.push(a);}}deleteID(a){var b=
this.getWritable();if(r(b)){let c=b.__ids;b.__ids=c;for(b=0;b<c.length;b++)if(a===c[b]){c.splice(b,1);break}}}insertNewAfter(a,b=!0){a=this.getParentOrThrow().insertNewAfter(a,b);return Lexical_1.$isElementNode(a)?(b=q(this.__ids),a.append(b),b):null}canInsertTextBefore(){return !1}canInsertTextAfter(){return !1}canBeEmpty(){return !1}isInline(){return !0}extractWithChild(a,b,c){if(!Lexical_1.$isRangeSelection(b)||"html"===c)return !1;let d=b.anchor,h=b.focus;a=d.getNode();c=h.getNode();b=b.isBackward()?d.offset-h.offset:
h.offset-d.offset;return this.isParentOf(a)&&this.isParentOf(c)&&this.getTextContent().length===b}excludeFromCopy(a){return "clone"!==a}}function q(a){return Lexical_1.$applyNodeReplacement(new p(a))}function r(a){return a instanceof p}var $createMarkNode=q;var $getMarkIDs=function(a,b){for(;null!==a;){if(r(a))return a.getIDs();if(Lexical_1.$isTextNode(a)&&b===a.getTextContentSize()){let c=a.getNextSibling();if(r(c))return c.getIDs()}a=a.getParent();}return null};var $isMarkNode=r;
var $unwrapMarkNode=function(a){let b=a.getChildren(),c=null;for(let d=0;d<b.length;d++){let h=b[d];null===c?a.insertBefore(h):c.insertAfter(h);c=h;}a.remove();};
var $wrapSelectionInMarkNode=function(a,b,c,d){let h=a.getNodes();var t=a.anchor.offset,l=a.focus.offset;a=h.length;let y=b?l:t;t=b?t:l;let u,f;for(l=0;l<a;l++){var e=h[l];if(Lexical_1.$isElementNode(f)&&f.isParentOf(e))continue;var n=0===l;let w=l===a-1;var g=null;if(Lexical_1.$isTextNode(e)){g=e.getTextContentSize();let x=n?y:0,v=w?t:g;if(0===x&&0===v)continue;e=e.splitText(x,v);g=1<e.length&&(3===e.length||n&&!w||v===g)?e[1]:e[0];}else if(r(e))continue;else Lexical_1.$isElementNode(e)&&e.isInline()&&(g=e);null!==g?
g&&g.is(u)||(n=g.getParent(),null!=n&&n.is(u)||(f=void 0),u=n,void 0===f&&(f=(d||q)([c]),g.insertBefore(f)),f.append(g)):f=u=void 0;}Lexical_1.$isElementNode(f)&&(b?f.selectStart():f.selectEnd());};var MarkNode=p;

var LexicalMark_prod = {
	$createMarkNode: $createMarkNode,
	$getMarkIDs: $getMarkIDs,
	$isMarkNode: $isMarkNode,
	$unwrapMarkNode: $unwrapMarkNode,
	$wrapSelectionInMarkNode: $wrapSelectionInMarkNode,
	MarkNode: MarkNode
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const LexicalMark = process.env.NODE_ENV === 'development' ? LexicalMark_dev : LexicalMark_prod;
var LexicalMark_1 = LexicalMark;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */








/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const NON_SINGLE_WIDTH_CHARS_REPLACEMENT = Object.freeze({
  '\t': '\\t',
  '\n': '\\n'
});
const NON_SINGLE_WIDTH_CHARS_REGEX = new RegExp(Object.keys(NON_SINGLE_WIDTH_CHARS_REPLACEMENT).join('|'), 'g');
const SYMBOLS = Object.freeze({
  ancestorHasNextSibling: '|',
  ancestorIsLastChild: ' ',
  hasNextSibling: '├',
  isLastChild: '└',
  selectedChar: '^',
  selectedLine: '>'
});
function TreeView$1({
  treeTypeButtonClassName,
  timeTravelButtonClassName,
  timeTravelPanelSliderClassName,
  timeTravelPanelButtonClassName,
  viewClassName,
  timeTravelPanelClassName,
  editor
}) {
  const [timeStampedEditorStates, setTimeStampedEditorStates] = React__default.useState([]);
  const [content, setContent] = React__default.useState('');
  const [timeTravelEnabled, setTimeTravelEnabled] = React__default.useState(false);
  const [showExportDOM, setShowExportDOM] = React__default.useState(false);
  const playingIndexRef = React__default.useRef(0);
  const treeElementRef = React__default.useRef(null);
  const inputRef = React__default.useRef(null);
  const [isPlaying, setIsPlaying] = React__default.useState(false);
  const [isLimited, setIsLimited] = React__default.useState(false);
  const [showLimited, setShowLimited] = React__default.useState(false);
  const lastEditorStateRef = React__default.useRef(null);
  const commandsLog = useLexicalCommandsLog(editor);
  const generateTree = React__default.useCallback(editorState => {
    const treeText = generateContent(editor, commandsLog, showExportDOM);
    setContent(treeText);

    if (!timeTravelEnabled) {
      setTimeStampedEditorStates(currentEditorStates => [...currentEditorStates, [Date.now(), editorState]]);
    }
  }, [commandsLog, editor, timeTravelEnabled, showExportDOM]);
  React__default.useEffect(() => {
    const editorState = editor.getEditorState();

    if (!showLimited && editorState._nodeMap.size < 1000) {
      setContent(generateContent(editor, commandsLog, showExportDOM));
    }
  }, [commandsLog, editor, showLimited, showExportDOM]);
  React__default.useEffect(() => {
    return LexicalUtils_1.mergeRegister(editor.registerUpdateListener(({
      editorState
    }) => {
      if (!showLimited && editorState._nodeMap.size > 1000) {
        lastEditorStateRef.current = editorState;
        setIsLimited(true);

        if (!showLimited) {
          return;
        }
      }

      generateTree(editorState);
    }), editor.registerEditableListener(() => {
      const treeText = generateContent(editor, commandsLog, showExportDOM);
      setContent(treeText);
    }));
  }, [commandsLog, editor, showExportDOM, isLimited, generateTree, showLimited]);
  const totalEditorStates = timeStampedEditorStates.length;
  React__default.useEffect(() => {
    if (isPlaying) {
      let timeoutId;

      const play = () => {
        const currentIndex = playingIndexRef.current;

        if (currentIndex === totalEditorStates - 1) {
          setIsPlaying(false);
          return;
        }

        const currentTime = timeStampedEditorStates[currentIndex][0];
        const nextTime = timeStampedEditorStates[currentIndex + 1][0];
        const timeDiff = nextTime - currentTime;
        timeoutId = setTimeout(() => {
          playingIndexRef.current++;
          const index = playingIndexRef.current;
          const input = inputRef.current;

          if (input !== null) {
            input.value = String(index);
          }

          editor.setEditorState(timeStampedEditorStates[index][1]);
          play();
        }, timeDiff);
      };

      play();
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [timeStampedEditorStates, isPlaying, editor, totalEditorStates]);
  React__default.useEffect(() => {
    const element = treeElementRef.current;

    if (element !== null) {
      // @ts-ignore Internal field
      element.__lexicalEditor = editor;
      return () => {
        // @ts-ignore Internal field
        element.__lexicalEditor = null;
      };
    }
  }, [editor]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: viewClassName
  }, !showLimited && isLimited ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: 20
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginRight: 20
    }
  }, "Detected large EditorState, this can impact debugging performance."), /*#__PURE__*/React__default.createElement("button", {
    onClick: () => {
      setShowLimited(true);
      const editorState = lastEditorStateRef.current;

      if (editorState !== null) {
        lastEditorStateRef.current = null;
        generateTree(editorState);
      }
    },
    style: {
      background: 'transparent',
      border: '1px solid white',
      color: 'white',
      cursor: 'pointer',
      padding: 5
    }
  }, "Show full tree")) : null, !showLimited ? /*#__PURE__*/React__default.createElement("button", {
    onClick: () => setShowExportDOM(!showExportDOM),
    className: treeTypeButtonClassName,
    type: "button"
  }, showExportDOM ? 'Tree' : 'Export DOM') : null, !timeTravelEnabled && (showLimited || !isLimited) && totalEditorStates > 2 && /*#__PURE__*/React__default.createElement("button", {
    onClick: () => {
      const rootElement = editor.getRootElement();

      if (rootElement !== null) {
        rootElement.contentEditable = 'false';
        playingIndexRef.current = totalEditorStates - 1;
        setTimeTravelEnabled(true);
      }
    },
    className: timeTravelButtonClassName,
    type: "button"
  }, "Time Travel"), (showLimited || !isLimited) && /*#__PURE__*/React__default.createElement("pre", {
    ref: treeElementRef
  }, content), timeTravelEnabled && (showLimited || !isLimited) && /*#__PURE__*/React__default.createElement("div", {
    className: timeTravelPanelClassName
  }, /*#__PURE__*/React__default.createElement("button", {
    className: timeTravelPanelButtonClassName,
    onClick: () => {
      if (playingIndexRef.current === totalEditorStates - 1) {
        playingIndexRef.current = 1;
      }

      setIsPlaying(!isPlaying);
    },
    type: "button"
  }, isPlaying ? 'Pause' : 'Play'), /*#__PURE__*/React__default.createElement("input", {
    className: timeTravelPanelSliderClassName,
    ref: inputRef,
    onChange: event => {
      const editorStateIndex = Number(event.target.value);
      const timeStampedEditorState = timeStampedEditorStates[editorStateIndex];

      if (timeStampedEditorState) {
        playingIndexRef.current = editorStateIndex;
        editor.setEditorState(timeStampedEditorState[1]);
      }
    },
    type: "range",
    min: "1",
    max: totalEditorStates - 1
  }), /*#__PURE__*/React__default.createElement("button", {
    className: timeTravelPanelButtonClassName,
    onClick: () => {
      const rootElement = editor.getRootElement();

      if (rootElement !== null) {
        rootElement.contentEditable = 'true';
        const index = timeStampedEditorStates.length - 1;
        const timeStampedEditorState = timeStampedEditorStates[index];
        editor.setEditorState(timeStampedEditorState[1]);
        const input = inputRef.current;

        if (input !== null) {
          input.value = String(index);
        }

        setTimeTravelEnabled(false);
        setIsPlaying(false);
      }
    },
    type: "button"
  }, "Exit")));
}

function useLexicalCommandsLog(editor) {
  const [loggedCommands, setLoggedCommands] = React__default.useState([]);
  React__default.useEffect(() => {
    const unregisterCommandListeners = new Set();

    for (const [command] of editor._commands) {
      unregisterCommandListeners.add(editor.registerCommand(command, payload => {
        setLoggedCommands(state => {
          const newState = [...state];
          newState.push({
            payload,
            type: command.type ? command.type : 'UNKNOWN'
          });

          if (newState.length > 10) {
            newState.shift();
          }

          return newState;
        });
        return false;
      }, Lexical_1.COMMAND_PRIORITY_HIGH));
    }

    return () => unregisterCommandListeners.forEach(unregister => unregister());
  }, [editor]);
  return React__default.useMemo(() => loggedCommands, [loggedCommands]);
}

function printRangeSelection(selection) {
  let res = '';
  const formatText = printFormatProperties(selection);
  res += `: range ${formatText !== '' ? `{ ${formatText} }` : ''} ${selection.style !== '' ? `{ style: ${selection.style} } ` : ''}`;
  const anchor = selection.anchor;
  const focus = selection.focus;
  const anchorOffset = anchor.offset;
  const focusOffset = focus.offset;
  res += `\n  ├ anchor { key: ${anchor.key}, offset: ${anchorOffset === null ? 'null' : anchorOffset}, type: ${anchor.type} }`;
  res += `\n  └ focus { key: ${focus.key}, offset: ${focusOffset === null ? 'null' : focusOffset}, type: ${focus.type} }`;
  return res;
}

function printNodeSelection(selection) {
  return `: node\n  └ [${Array.from(selection._nodes).join(', ')}]`;
}

function printGridSelection(selection) {
  return `: grid\n  └ { grid: ${selection.gridKey}, anchorCell: ${selection.anchor.key}, focusCell: ${selection.focus.key} }`;
}

function generateContent(editor, commandsLog, exportDOM) {
  const editorState = editor.getEditorState();
  const editorConfig = editor._config;
  const compositionKey = editor._compositionKey;
  const editable = editor._editable;

  if (exportDOM) {
    let htmlString = '';
    editorState.read(() => {
      htmlString = printPrettyHTML(LexicalHtml_1.$generateHtmlFromNodes(editor));
    });
    return htmlString;
  }

  let res = ' root\n';
  const selectionString = editorState.read(() => {
    const selection = Lexical_1.$getSelection();
    visitTree(Lexical_1.$getRoot(), (node, indent) => {
      const nodeKey = node.getKey();
      const nodeKeyDisplay = `(${nodeKey})`;
      const typeDisplay = node.getType() || '';
      const isSelected = node.isSelected();
      const idsDisplay = LexicalMark_1.$isMarkNode(node) ? ` id: [ ${node.getIDs().join(', ')} ] ` : '';
      res += `${isSelected ? SYMBOLS.selectedLine : ' '} ${indent.join(' ')} ${nodeKeyDisplay} ${typeDisplay} ${idsDisplay} ${printNode(node)}\n`;
      res += printSelectedCharsLine({
        indent,
        isSelected,
        node,
        nodeKeyDisplay,
        selection,
        typeDisplay
      });
    });
    return selection === null ? ': null' : Lexical_1.$isRangeSelection(selection) ? printRangeSelection(selection) : Lexical_1.DEPRECATED_$isGridSelection(selection) ? printGridSelection(selection) : printNodeSelection(selection);
  });
  res += '\n selection' + selectionString;
  res += '\n\n commands:';

  if (commandsLog.length) {
    for (const {
      type,
      payload
    } of commandsLog) {
      res += `\n  └ { type: ${type}, payload: ${payload instanceof Event ? payload.constructor.name : payload} }`;
    }
  } else {
    res += '\n  └ None dispatched.';
  }

  res += '\n\n editor:';
  res += `\n  └ namespace ${editorConfig.namespace}`;

  if (compositionKey !== null) {
    res += `\n  └ compositionKey ${compositionKey}`;
  }

  res += `\n  └ editable ${String(editable)}`;
  return res;
}

function visitTree(currentNode, visitor, indent = []) {
  const childNodes = currentNode.getChildren();
  const childNodesLength = childNodes.length;
  childNodes.forEach((childNode, i) => {
    visitor(childNode, indent.concat(i === childNodesLength - 1 ? SYMBOLS.isLastChild : SYMBOLS.hasNextSibling));

    if (Lexical_1.$isElementNode(childNode)) {
      visitTree(childNode, visitor, indent.concat(i === childNodesLength - 1 ? SYMBOLS.ancestorIsLastChild : SYMBOLS.ancestorHasNextSibling));
    }
  });
}

function normalize(text) {
  return Object.entries(NON_SINGLE_WIDTH_CHARS_REPLACEMENT).reduce((acc, [key, value]) => acc.replace(new RegExp(key, 'g'), String(value)), text);
} // TODO Pass via props to allow customizability


function printNode(node) {
  if (Lexical_1.$isTextNode(node)) {
    const text = node.getTextContent();
    const title = text.length === 0 ? '(empty)' : `"${normalize(text)}"`;
    const properties = printAllTextNodeProperties(node);
    return [title, properties.length !== 0 ? `{ ${properties} }` : null].filter(Boolean).join(' ').trim();
  } else if (LexicalLink_1.$isLinkNode(node)) {
    const link = node.getURL();
    const title = link.length === 0 ? '(empty)' : `"${normalize(link)}"`;
    const properties = printAllLinkNodeProperties(node);
    return [title, properties.length !== 0 ? `{ ${properties} }` : null].filter(Boolean).join(' ').trim();
  } else {
    return '';
  }
}

const FORMAT_PREDICATES = [node => node.hasFormat('bold') && 'Bold', node => node.hasFormat('code') && 'Code', node => node.hasFormat('italic') && 'Italic', node => node.hasFormat('strikethrough') && 'Strikethrough', node => node.hasFormat('subscript') && 'Subscript', node => node.hasFormat('superscript') && 'Superscript', node => node.hasFormat('underline') && 'Underline'];
const DETAIL_PREDICATES = [node => node.isDirectionless() && 'Directionless', node => node.isUnmergeable() && 'Unmergeable'];
const MODE_PREDICATES = [node => node.isToken() && 'Token', node => node.isSegmented() && 'Segmented'];

function printAllTextNodeProperties(node) {
  return [printFormatProperties(node), printDetailProperties(node), printModeProperties(node)].filter(Boolean).join(', ');
}

function printAllLinkNodeProperties(node) {
  return [printTargetProperties(node), printRelProperties(node), printTitleProperties(node)].filter(Boolean).join(', ');
}

function printDetailProperties(nodeOrSelection) {
  let str = DETAIL_PREDICATES.map(predicate => predicate(nodeOrSelection)).filter(Boolean).join(', ').toLocaleLowerCase();

  if (str !== '') {
    str = 'detail: ' + str;
  }

  return str;
}

function printModeProperties(nodeOrSelection) {
  let str = MODE_PREDICATES.map(predicate => predicate(nodeOrSelection)).filter(Boolean).join(', ').toLocaleLowerCase();

  if (str !== '') {
    str = 'mode: ' + str;
  }

  return str;
}

function printFormatProperties(nodeOrSelection) {
  let str = FORMAT_PREDICATES.map(predicate => predicate(nodeOrSelection)).filter(Boolean).join(', ').toLocaleLowerCase();

  if (str !== '') {
    str = 'format: ' + str;
  }

  return str;
}

function printTargetProperties(node) {
  let str = node.getTarget(); // TODO Fix nullish on LinkNode

  if (str != null) {
    str = 'target: ' + str;
  }

  return str;
}

function printRelProperties(node) {
  let str = node.getRel(); // TODO Fix nullish on LinkNode

  if (str != null) {
    str = 'rel: ' + str;
  }

  return str;
}

function printTitleProperties(node) {
  let str = node.getTitle(); // TODO Fix nullish on LinkNode

  if (str != null) {
    str = 'title: ' + str;
  }

  return str;
}

function printSelectedCharsLine({
  indent,
  isSelected,
  node,
  nodeKeyDisplay,
  selection,
  typeDisplay
}) {
  // No selection or node is not selected.
  if (!Lexical_1.$isTextNode(node) || !Lexical_1.$isRangeSelection(selection) || !isSelected || Lexical_1.$isElementNode(node)) {
    return '';
  } // No selected characters.


  const anchor = selection.anchor;
  const focus = selection.focus;

  if (node.getTextContent() === '' || anchor.getNode() === selection.focus.getNode() && anchor.offset === focus.offset) {
    return '';
  }

  const [start, end] = $getSelectionStartEnd(node, selection);

  if (start === end) {
    return '';
  }

  const selectionLastIndent = indent[indent.length - 1] === SYMBOLS.hasNextSibling ? SYMBOLS.ancestorHasNextSibling : SYMBOLS.ancestorIsLastChild;
  const indentionChars = [...indent.slice(0, indent.length - 1), selectionLastIndent];
  const unselectedChars = Array(start + 1).fill(' ');
  const selectedChars = Array(end - start).fill(SYMBOLS.selectedChar);
  const paddingLength = typeDisplay.length + 3; // 2 for the spaces around + 1 for the double quote.

  const nodePrintSpaces = Array(nodeKeyDisplay.length + paddingLength).fill(' ');
  return [SYMBOLS.selectedLine, indentionChars.join(' '), [...nodePrintSpaces, ...unselectedChars, ...selectedChars].join('')].join(' ') + '\n';
}

function printPrettyHTML(str) {
  const div = document.createElement('div');
  div.innerHTML = str.trim();
  return prettifyHTML(div, 0).innerHTML;
}

function prettifyHTML(node, level) {
  const indentBefore = new Array(level++ + 1).join('  ');
  const indentAfter = new Array(level - 1).join('  ');
  let textNode;

  for (let i = 0; i < node.children.length; i++) {
    textNode = document.createTextNode('\n' + indentBefore);
    node.insertBefore(textNode, node.children[i]);
    prettifyHTML(node.children[i], level);

    if (node.lastElementChild === node.children[i]) {
      textNode = document.createTextNode('\n' + indentAfter);
      node.appendChild(textNode);
    }
  }

  return node;
}

function $getSelectionStartEnd(node, selection) {
  const anchor = selection.anchor;
  const focus = selection.focus;
  const textContent = node.getTextContent();
  const textLength = textContent.length;
  let start = -1;
  let end = -1; // Only one node is being selected.

  if (anchor.type === 'text' && focus.type === 'text') {
    const anchorNode = anchor.getNode();
    const focusNode = focus.getNode();

    if (anchorNode === focusNode && node === anchorNode && anchor.offset !== focus.offset) {
      [start, end] = anchor.offset < focus.offset ? [anchor.offset, focus.offset] : [focus.offset, anchor.offset];
    } else if (node === anchorNode) {
      [start, end] = anchorNode.isBefore(focusNode) ? [anchor.offset, textLength] : [0, anchor.offset];
    } else if (node === focusNode) {
      [start, end] = focusNode.isBefore(anchorNode) ? [focus.offset, textLength] : [0, focus.offset];
    } else {
      // Node is within selection but not the anchor nor focus.
      [start, end] = [0, textLength];
    }
  } // Account for non-single width characters.


  const numNonSingleWidthCharBeforeSelection = (textContent.slice(0, start).match(NON_SINGLE_WIDTH_CHARS_REGEX) || []).length;
  const numNonSingleWidthCharInSelection = (textContent.slice(start, end).match(NON_SINGLE_WIDTH_CHARS_REGEX) || []).length;
  return [start + numNonSingleWidthCharBeforeSelection, end + numNonSingleWidthCharBeforeSelection + numNonSingleWidthCharInSelection];
}

var TreeView_1 = TreeView$1;

var LexicalTreeView_dev = {
	TreeView: TreeView_1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
let O=Object.freeze({"\t":"\\t","\n":"\\n"}),P=new RegExp(Object.keys(O).join("|"),"g"),Q=Object.freeze({ancestorHasNextSibling:"|",ancestorIsLastChild:" ",hasNextSibling:"\u251c",isLastChild:"\u2514",selectedChar:"^",selectedLine:">"});
function R(a){let [b,c]=React__default.useState([]);React__default.useEffect(()=>{let l=new Set;for(let [e]of a._commands)l.add(a.registerCommand(e,p=>{c(d=>{d=[...d];d.push({payload:p,type:e.type?e.type:"UNKNOWN"});10<d.length&&d.shift();return d});return !1},Lexical_1.COMMAND_PRIORITY_HIGH));return ()=>l.forEach(e=>e())},[a]);return React__default.useMemo(()=>b,[b])}
function U(a){let b="";var c=V(a);b+=`: range ${""!==c?`{ ${c} }`:""} ${""!==a.style?`{ style: ${a.style} } `:""}`;c=a.anchor;a=a.focus;let l=c.offset,e=a.offset;b+=`\n  \u251c anchor { key: ${c.key}, offset: ${null===l?"null":l}, type: ${c.type} }`;return b+=`\n  \u2514 focus { key: ${a.key}, offset: ${null===e?"null":e}, type: ${a.type} }`}
function W(a,b,c){let l=a.getEditorState(),e=a._config,p=a._compositionKey,d=a._editable;if(c){let m="";l.read(()=>{var k=LexicalHtml_1.$generateHtmlFromNodes(a);let t=document.createElement("div");t.innerHTML=k.trim();m=X(t,0).innerHTML;});return m}let h=" root\n";c=l.read(()=>{const m=Lexical_1.$getSelection();Y(Lexical_1.$getRoot(),(k,t)=>{const y=`(${k.getKey()})`,v=k.getType()||"",q=k.isSelected(),J=LexicalMark_1.$isMarkNode(k)?` id: [ ${k.getIDs().join(", ")} ] `:"";var A=h,H=q?Q.selectedLine:" ",F=t.join(" ");if(Lexical_1.$isTextNode(k)){var n=
k.getTextContent();var u=0===n.length?"(empty)":`"${Z(n)}"`;n=[V(k),aa(k),ba(k)].filter(Boolean).join(", ");n=[u,0!==n.length?`{ ${n} }`:null].filter(Boolean).join(" ").trim();}else if(LexicalLink_1.$isLinkNode(k)){n=k.getURL();n=0===n.length?"(empty)":`"${Z(n)}"`;u=k.getTarget();null!=u&&(u="target: "+u);var B=Boolean;var C=k.getRel();null!=C&&(C="rel: "+C);let r=k.getTitle();null!=r&&(r="title: "+r);u=[u,C,r].filter(B).join(", ");n=[n,0!==u.length?`{ ${u} }`:null].filter(Boolean).join(" ").trim();}else n="";
h=A+`${H} ${F} ${y} ${v} ${J} ${n}\n`;h+=ca({indent:t,isSelected:q,node:k,nodeKeyDisplay:y,selection:m,typeDisplay:v});});return null===m?": null":Lexical_1.$isRangeSelection(m)?U(m):Lexical_1.DEPRECATED_$isGridSelection(m)?`: grid\n  \u2514 { grid: ${m.gridKey}, anchorCell: ${m.anchor.key}, focusCell: ${m.focus.key} }`:`: node\n  \u2514 [${Array.from(m._nodes).join(", ")}]`});h+="\n selection"+c;h+="\n\n commands:";if(b.length)for(let {type:m,payload:k}of b)h+=`\n  \u2514 { type: ${m}, payload: ${k instanceof Event?
k.constructor.name:k} }`;else h+="\n  \u2514 None dispatched.";h+="\n\n editor:";h+=`\n  \u2514 namespace ${e.namespace}`;null!==p&&(h+=`\n  \u2514 compositionKey ${p}`);return h+=`\n  \u2514 editable ${String(d)}`}function Y(a,b,c=[]){a=a.getChildren();let l=a.length;a.forEach((e,p)=>{b(e,c.concat(p===l-1?Q.isLastChild:Q.hasNextSibling));Lexical_1.$isElementNode(e)&&Y(e,b,c.concat(p===l-1?Q.ancestorIsLastChild:Q.ancestorHasNextSibling));});}
function Z(a){return Object.entries(O).reduce((b,[c,l])=>b.replace(new RegExp(c,"g"),String(l)),a)}
let da=[a=>a.hasFormat("bold")&&"Bold",a=>a.hasFormat("code")&&"Code",a=>a.hasFormat("italic")&&"Italic",a=>a.hasFormat("strikethrough")&&"Strikethrough",a=>a.hasFormat("subscript")&&"Subscript",a=>a.hasFormat("superscript")&&"Superscript",a=>a.hasFormat("underline")&&"Underline"],ea=[a=>a.isDirectionless()&&"Directionless",a=>a.isUnmergeable()&&"Unmergeable"],fa=[a=>a.isToken()&&"Token",a=>a.isSegmented()&&"Segmented"];
function aa(a){let b=ea.map(c=>c(a)).filter(Boolean).join(", ").toLocaleLowerCase();""!==b&&(b="detail: "+b);return b}function ba(a){let b=fa.map(c=>c(a)).filter(Boolean).join(", ").toLocaleLowerCase();""!==b&&(b="mode: "+b);return b}function V(a){let b=da.map(c=>c(a)).filter(Boolean).join(", ").toLocaleLowerCase();""!==b&&(b="format: "+b);return b}
function ca({indent:a,isSelected:b,node:c,nodeKeyDisplay:l,selection:e,typeDisplay:p}){if(!Lexical_1.$isTextNode(c)||!Lexical_1.$isRangeSelection(e)||!b||Lexical_1.$isElementNode(c))return "";b=e.anchor;var d=e.focus;if(""===c.getTextContent()||b.getNode()===e.focus.getNode()&&b.offset===d.offset)return "";d=e.anchor;let h=e.focus,m=c.getTextContent(),k=m.length;b=e=-1;if("text"===d.type&&"text"===h.type){let v=d.getNode(),q=h.getNode();v===q&&c===v&&d.offset!==h.offset?[e,b]=d.offset<h.offset?[d.offset,h.offset]:[h.offset,
d.offset]:c===v?[e,b]=v.isBefore(q)?[d.offset,k]:[0,d.offset]:c===q?[e,b]=q.isBefore(v)?[h.offset,k]:[0,h.offset]:[e,b]=[0,k];}c=(m.slice(0,e).match(P)||[]).length;d=(m.slice(e,b).match(P)||[]).length;let [t,y]=[e+c,b+c+d];if(t===y)return "";c=a[a.length-1]===Q.hasNextSibling?Q.ancestorHasNextSibling:Q.ancestorIsLastChild;a=[...a.slice(0,a.length-1),c];c=Array(t+1).fill(" ");e=Array(y-t).fill(Q.selectedChar);l=Array(l.length+(p.length+3)).fill(" ");return [Q.selectedLine,a.join(" "),[...l,...c,...e].join("")].join(" ")+
"\n"}function X(a,b){let c=Array(b++ +1).join("  "),l=Array(b-1).join("  "),e;for(let p=0;p<a.children.length;p++)e=document.createTextNode("\n"+c),a.insertBefore(e,a.children[p]),X(a.children[p],b),a.lastElementChild===a.children[p]&&(e=document.createTextNode("\n"+l),a.appendChild(e));return a}
var TreeView=function({treeTypeButtonClassName:a,timeTravelButtonClassName:b,timeTravelPanelSliderClassName:c,timeTravelPanelButtonClassName:l,viewClassName:e,timeTravelPanelClassName:p,editor:d}){let [h,m]=React__default.useState([]),[k,t]=React__default.useState(""),[y,v]=React__default.useState(!1),[q,J]=React__default.useState(!1),A=React__default.useRef(0),H=React__default.useRef(null),F=React__default.useRef(null),[n,u]=React__default.useState(!1),[B,C]=React__default.useState(!1),[r,ha]=React__default.useState(!1),K=React__default.useRef(null),D=R(d),L=React__default.useCallback(f=>{const z=W(d,D,q);t(z);y||m(G=>[...G,[Date.now(),f]]);},[D,
d,y,q]);React__default.useEffect(()=>{let f=d.getEditorState();!r&&1E3>f._nodeMap.size&&t(W(d,D,q));},[D,d,r,q]);React__default.useEffect(()=>LexicalUtils_1.mergeRegister(d.registerUpdateListener(({editorState:f})=>{if(!r&&1E3<f._nodeMap.size&&(K.current=f,C(!0),!r))return;L(f);}),d.registerEditableListener(()=>{let f=W(d,D,q);t(f);})),[D,d,q,B,L,r]);let E=h.length;React__default.useEffect(()=>{if(n){let f,z=()=>{const G=A.current;G===E-1?u(!1):f=setTimeout(()=>{A.current++;const S=A.current,T=F.current;null!==T&&(T.value=String(S));d.setEditorState(h[S][1]);
z();},h[G+1][0]-h[G][0]);};z();return ()=>{clearTimeout(f);}}},[h,n,d,E]);React__default.useEffect(()=>{let f=H.current;if(null!==f)return f.__lexicalEditor=d,()=>{f.__lexicalEditor=null;}},[d]);return React__default.createElement("div",{className:e},!r&&B?React__default.createElement("div",{style:{padding:20}},React__default.createElement("span",{style:{marginRight:20}},"Detected large EditorState, this can impact debugging performance."),React__default.createElement("button",{onClick:()=>{ha(!0);let f=K.current;null!==f&&(K.current=null,L(f));},style:{background:"transparent",
border:"1px solid white",color:"white",cursor:"pointer",padding:5}},"Show full tree")):null,r?null:React__default.createElement("button",{onClick:()=>J(!q),className:a,type:"button"},q?"Tree":"Export DOM"),!y&&(r||!B)&&2<E&&React__default.createElement("button",{onClick:()=>{let f=d.getRootElement();null!==f&&(f.contentEditable="false",A.current=E-1,v(!0));},className:b,type:"button"},"Time Travel"),(r||!B)&&React__default.createElement("pre",{ref:H},k),y&&(r||!B)&&React__default.createElement("div",{className:p},React__default.createElement("button",{className:l,
onClick:()=>{A.current===E-1&&(A.current=1);u(!n);},type:"button"},n?"Pause":"Play"),React__default.createElement("input",{className:c,ref:F,onChange:f=>{f=Number(f.target.value);let z=h[f];z&&(A.current=f,d.setEditorState(z[1]));},type:"range",min:"1",max:E-1}),React__default.createElement("button",{className:l,onClick:()=>{var f=d.getRootElement();if(null!==f){f.contentEditable="true";f=h.length-1;d.setEditorState(h[f][1]);let z=F.current;null!==z&&(z.value=String(f));v(!1);u(!1);}},type:"button"},"Exit")))};

var LexicalTreeView_prod = {
	TreeView: TreeView
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
process.env.NODE_ENV === 'development' ? LexicalTreeView_dev : LexicalTreeView_prod;

createUseStyles(function (_ref) {
  var palette = _ref.palette,
      shape = _ref.shape;
  return {
    treeViewOutput: {
      display: 'block',
      background: palette.black.color,
      color: palette.white.color,
      padding: 8,
      whiteSpace: 'pre-wrap',
      maxHeight: 280,
      position: 'relative',
      borderBottomLeftRadius: shape.borderRadiusLight,
      borderBottomRightRadius: shape.borderRadiusLight,
      overflow: 'auto'
    },
    debugTimeTravelPanel: {
      overflow: 'hidden',
      padding: '0 0 8px 0',
      margin: 'auto',
      display: 'flex'
    },
    debugTimeTravelButton: {
      border: 0,
      padding: 0,
      top: 8,
      right: 16,
      position: 'absolute',
      background: 'none',
      color: palette.white.color,
      '&:hover': {
        textDecoration: 'underline'
      }
    },
    debugTimeTravelPanelSlider: {
      padding: 0,
      flex: 8
    },
    debugTimeTravelPanelButton: {
      padding: 0,
      border: 0,
      background: 'none',
      flex: 1,
      color: palette.white.color,
      '&:hover': {
        textDecoration: 'underline'
      }
    }
  };
});

var defaultTheme = {
  ltr: 'ltr',
  rtl: 'rtl',
  placeholder: 'editor-placeholder',
  paragraph: 'editor-paragraph',
  heading: {
    h1: 'editor-heading-h1'
  },
  list: {
    nested: {
      listitem: 'editor-nested-listitem'
    },
    ol: 'editor-list-ol',
    ul: 'editor-list-ul',
    listitem: 'editor-listitem'
  },
  image: 'editor-image',
  link: 'editor-link',
  text: {
    bold: 'editor-text-bold',
    italic: 'editor-text-italic'
  }
};

/**
 * Use this boolean to toggle the Tree View plugin when in need to locally debug the Editor state changes etc
 */

var isDebug = false;

var getInitialConfig = function getInitialConfig(_ref) {
  var initialState = _ref.initialState,
      readOnly = _ref.readOnly,
      theme = _ref.theme;
  return {
    namespace: 'CyoloRichTextEditor',
    editable: !readOnly,
    editorState: initialState ? function () {
      return LexicalMarkdown_1.$convertFromMarkdownString(initialState, LexicalMarkdown_1.TRANSFORMERS);
    } : undefined,
    theme: theme,
    onError: function onError(error) {
      throw error;
    },
    nodes: [LexicalRichText_1.HeadingNode, LexicalList_1.ListNode, LexicalList_1.ListItemNode, LexicalRichText_1.QuoteNode, LexicalCode_1.CodeNode, LexicalLink_1.AutoLinkNode, LexicalLink_1.LinkNode]
  };
};

var RichTextEditor = function RichTextEditor(_ref2) {
  var value = _ref2.value,
      _ref2$onChange = _ref2.onChange,
      onChange = _ref2$onChange === void 0 ? function () {} : _ref2$onChange,
      _ref2$readOnly = _ref2.readOnly,
      readOnly = _ref2$readOnly === void 0 ? false : _ref2$readOnly,
      _ref2$editorTheme = _ref2.editorTheme,
      editorTheme = _ref2$editorTheme === void 0 ? {} : _ref2$editorTheme;
  var theme = useThemeSafe();
  var styles = useStyles$o({
    theme: Object.assign(Object.assign({}, theme), {
      readOnly: readOnly
    })
  });
  var initialConfig = useMemo(function () {
    return getInitialConfig({
      initialState: value,
      readOnly: readOnly,
      theme: Object.assign(Object.assign({}, defaultTheme), editorTheme)
    });
  }, []);

  var handleStateChange = function handleStateChange(state) {
    state.read(function () {
      var markdown = LexicalMarkdown_1.$convertToMarkdownString(LexicalMarkdown_1.TRANSFORMERS);
      onChange(markdown);
    });
  };

  return /*#__PURE__*/React__default.createElement(LexicalComposer_1.LexicalComposer, {
    initialConfig: initialConfig
  }, /*#__PURE__*/React__default.createElement("div", {
    className: clsx('CyoloUI-RichTextEditorContainer', styles.editorContainer)
  }, !readOnly && /*#__PURE__*/React__default.createElement(ToolbarPlugin, null), /*#__PURE__*/React__default.createElement("div", {
    className: clsx('CyoloUI-RichTextEditorInner', styles.editorInner)
  }, /*#__PURE__*/React__default.createElement(LexicalRichTextPlugin_1.RichTextPlugin, {
    contentEditable: /*#__PURE__*/React__default.createElement(LexicalContentEditable_1.ContentEditable, {
      className: clsx('CyoloUI-RichTextEditorInput', styles.editorInput)
    }),
    placeholder: /*#__PURE__*/React__default.createElement(Placeholder, null),
    ErrorBoundary: LexicalErrorBoundary_1
  }), /*#__PURE__*/React__default.createElement(LexicalHistoryPlugin_1.HistoryPlugin, null), isDebug , /*#__PURE__*/React__default.createElement(LexicalAutoFocusPlugin_1.AutoFocusPlugin, null), /*#__PURE__*/React__default.createElement(LexicalListPlugin_1.ListPlugin, null), /*#__PURE__*/React__default.createElement(LexicalLinkPlugin_1.LinkPlugin, {
    validateUrl: function validateUrl(url) {
      return URL_MATCHER.test(url);
    }
  }), /*#__PURE__*/React__default.createElement(AutoLinkPlugin, null), readOnly && /*#__PURE__*/React__default.createElement(LexicalClickableLinkPlugin_1, null), /*#__PURE__*/React__default.createElement(LexicalMarkdownShortcutPlugin_1.MarkdownShortcutPlugin, {
    transformers: LexicalMarkdown_1.TRANSFORMERS
  }), /*#__PURE__*/React__default.createElement(LexicalOnChangePlugin_1.OnChangePlugin, {
    onChange: handleStateChange
  }))));
};
var useStyles$o = createUseStyles(function (_ref3) {
  var palette = _ref3.palette,
      shape = _ref3.shape,
      readOnly = _ref3.readOnly;
  return {
    editorContainer: {
      width: '100%',
      maxWidth: 640,
      color: palette.black.color,
      position: 'relative',
      lineHeight: '20px',
      textAlign: 'left',
      border: "1px solid ".concat(palette.background.color),
      borderRadius: shape.borderRadiusLight
    },
    editorInner: {
      backgroundColor: palette.white.color,
      position: 'relative'
    },
    editorInput: Object.assign({
      minHeight: '166px',
      resize: 'none',
      position: 'relative',
      tabSize: '1',
      outline: '0',
      padding: '16px 8px',
      borderTop: "1px solid ".concat(palette.background.color)
    }, readOnly ? {
      borderTop: 'none'
    } : {})
  };
});

var useStyles$n = createUseStyles(function (theme) {
  return {
    button: {
      border: 'none',
      backgroundColor: 'inherit',
      outline: 'none',
      padding: 0,
      cursor: 'pointer',
      margin: 0
    },
    card: function card(_ref) {
      var style = _ref.style,
          borderSize = _ref.borderSize,
          height = _ref.height,
          width = _ref.width,
          borderColor = _ref.borderColor,
          active = _ref.active;
      return Object.assign({
        width: width,
        height: height,
        border: {
          width: borderSize,
          style: 'solid',
          color: active ? borderColor || theme.palette.primary.color : 'transparent'
        },
        boxSizing: 'border-box',
        backgroundClip: 'padding-box',
        WebkitBackgroundClip: 'padding-box',
        MozBackgroundClip: 'padding-box',
        WebkitBorderRadius: theme.shape.borderRadiusLight,
        borderRadius: theme.shape.borderRadiusLight,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative'
      }, style);
    },
    img: {
      pointerEvents: 'none',
      userSelect: 'none',
      WebkitUserSelect: 'none',
      msUserSelect: 'none',
      MozUserSelect: 'none'
    },
    checkmark: {
      position: 'absolute',
      right: 9,
      top: 9,
      height: 15,
      width: 15,
      pointerEvents: 'none',
      userSelect: 'none',
      WebkitUserSelect: 'none',
      msUserSelect: 'none',
      MozUserSelect: 'none'
    }
  };
});

var SelectableCard = function SelectableCard(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      style = _ref.style,
      borderColor = _ref.borderColor,
      onClick = _ref.onClick,
      className = _ref.className,
      children = _ref.children,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 132 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 76 : _ref$height,
      _ref$borderSize = _ref.borderSize,
      borderSize = _ref$borderSize === void 0 ? 2 : _ref$borderSize,
      _ref$addPadding = _ref.addPadding,
      addPadding = _ref$addPadding === void 0 ? false : _ref$addPadding;
  var theme = useThemeSafe();
  var styles = useStyles$n({
    theme: theme,
    style: style,
    borderSize: borderSize,
    height: height,
    width: width,
    borderColor: borderColor,
    active: active
  });
  return /*#__PURE__*/React__default.createElement("button", {
    className: clsx(styles.button, className),
    type: "button",
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement(Card, {
    className: clsx(styles.card, {
      active: active
    }),
    addPadding: addPadding
  }, active && /*#__PURE__*/React__default.createElement("div", {
    className: styles.checkmark
  }, /*#__PURE__*/React__default.createElement(Icon, {
    id: "checkmark",
    size: 15
  })), children));
};

var NAVBAR_DESKTOP_PEEK_WIDTH = 60;
var NAVBAR_OPEN_WIDTH = 184;
var NAVBAR_CLOSED_WIDTH = 0;
var useStyles$m = createUseStyles(function (theme) {
  return {
    overlay: {
      width: function width(_ref) {
        var mobile = _ref.mobile,
            open = _ref.open;
        return mobile && open ? '100%' : 'fit-content';
      },
      height: function height(_ref2) {
        var mobile = _ref2.mobile,
            open = _ref2.open;
        return mobile && open ? '100%' : 'fit-content';
      },
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      background: 'rgba(0, 0, 0, 0.4)',
      position: 'absolute',
      zIndex: theme.zIndex.high
    },
    navbar: {
      background: "linear-gradient(180deg, ".concat(theme.palette.secondary.light, " 0%, ").concat(theme.palette.secondary.dark, " 70%)"),
      boxShadow: '4px 0px 12px #b9bbcf',
      borderTopRightRadius: theme.shape.borderRadiusHeavy,
      borderBottomRightRadius: theme.shape.borderRadiusHeavy,
      width: '184px',
      position: 'fixed',
      left: 0,
      bottom: function bottom(_ref3) {
        var mobile = _ref3.mobile;
        return mobile ? 0 : 12;
      },
      top: function top(_ref4) {
        var mobile = _ref4.mobile;
        return mobile ? 0 : 72;
      },
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      zIndex: theme.zIndex.high,
      overflow: 'hidden'
    },
    sidenavListRoot: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      width: '100%',
      overflow: 'hidden',
      paddingTop: '8px'
    }
  };
});

var calculateNavbarWidth = function calculateNavbarWidth(mobile, open, collapsable, hover) {
  if (mobile && !open) {
    return NAVBAR_CLOSED_WIDTH;
  }

  if (collapsable && !hover) {
    return NAVBAR_DESKTOP_PEEK_WIDTH;
  }

  return NAVBAR_OPEN_WIDTH;
};

var MutableSideNav = function MutableSideNav(_ref5) {
  var _ref5$top = _ref5.top,
      top = _ref5$top === void 0 ? 0 : _ref5$top,
      _ref5$collapsable = _ref5.collapsable,
      collapsable = _ref5$collapsable === void 0 ? false : _ref5$collapsable,
      children = _ref5.children,
      _ref5$mobile = _ref5.mobile,
      mobile = _ref5$mobile === void 0 ? false : _ref5$mobile,
      _ref5$open = _ref5.open,
      open = _ref5$open === void 0 ? true : _ref5$open,
      onBlur = _ref5.onBlur;

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      hover = _useState2[0],
      setHover = _useState2[1];

  var theme = useThemeSafe();
  var styles = useStyles$m({
    open: open,
    mobile: mobile,
    theme: theme
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.overlay,
    onClick: onBlur
  }, /*#__PURE__*/React__default.createElement(Motion, {
    style: {
      y: spring(calculateNavbarWidth(mobile, open, collapsable, hover), {
        stiffness: 160
      })
    }
  }, function (_ref6) {
    var y = _ref6.y;
    return /*#__PURE__*/React__default.createElement("div", {
      className: styles.navbar,
      style: {
        marginTop: top,
        width: y
      },
      onMouseEnter: function onMouseEnter() {
        setHover(true);
      },
      onMouseLeave: function onMouseLeave() {
        setHover(false);
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles.sidenavListRoot
    }, children));
  }));
};

var subNavItemHeight = 28;
var useStyles$l = createUseStyles(function (theme) {
  return {
    subRoutesContainerRoot: {
      display: 'flex',
      paddingBottom: 12,
      backgroundColor: theme.palette.secondary.dark,
      width: '100%',
      marginTop: 8
    },
    subRoutesContainerItem: {
      lineHeight: "".concat(subNavItemHeight, "px"),
      outline: 'none',
      textDecoration: 'none',
      cursor: 'pointer',
      marginLeft: 14,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      display: 'flex',
      gap: 4,
      alignItems: 'center'
    },
    subRoutesContainerItemsHolder: {
      display: 'flex',
      flexDirection: 'column'
    },
    subRoutesContainerVerticalLine: {
      position: 'relative',
      width: 1,
      backgroundColor: theme.palette.grey.extraLight,
      height: '100%',
      marginLeft: 32
    },
    subRoutesContainerActiveIndicatorCaret: {
      position: 'absolute',
      width: 3,
      height: 14,
      backgroundColor: theme.palette.white.color,
      borderRadius: 8,
      transform: 'translateX(-1px)'
    }
  };
});

var SubRoutesContainer = function SubRoutesContainer(_ref) {
  var subRoutes = _ref.subRoutes,
      active = _ref.active,
      activeSubRouteId = _ref.activeSubRouteId,
      _onClick = _ref.onClick;
  var theme = useThemeSafe();
  var styles = useStyles$l({
    theme: theme
  }); // if there are no routes, dont render anything

  var shouldBeShown = useMemo(function () {
    return subRoutes.length > 0 && active;
  }, [active]);
  var viewHeight = useMemo(function () {
    return shouldBeShown ? subNavItemHeight * subRoutes.length : 0;
  }, [shouldBeShown, subRoutes]);
  var viewPadding = useMemo(function () {
    return shouldBeShown ? 12 : 0;
  }, [shouldBeShown]);
  var activeSubRouteIndex = subRoutes.findIndex(function (route) {
    return route.id === activeSubRouteId;
  });
  var caretOpacity = activeSubRouteIndex !== -1 ? 1 : 0;
  var caretYOffset = 6 + activeSubRouteIndex * subNavItemHeight;

  var renderItem = function renderItem(_ref2) {
    var name = _ref2.name,
        path = _ref2.path,
        isBeta = _ref2.isBeta;
    return /*#__PURE__*/React__default.createElement("div", {
      key: path,
      className: styles.subRoutesContainerItem,
      onClick: function onClick() {
        return _onClick(path);
      }
    }, /*#__PURE__*/React__default.createElement(Text$1, {
      variant: "sidenav-sub-option",
      title: name
    }, name), isBeta && /*#__PURE__*/React__default.createElement("svg", {
      width: "32",
      height: "16",
      viewBox: "0 0 32 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React__default.createElement("path", {
      d: "M5.5625 8.16992L5.55273 7.42285H7.18359C7.58724 7.42285 7.91276 7.32194 8.16016 7.12012C8.40755 6.91829 8.53125 6.63672 8.53125 6.27539C8.53125 5.88477 8.41732 5.60156 8.18945 5.42578C7.96484 5.24674 7.62142 5.15723 7.15918 5.15723H5.77246V11.5H4.8252V4.39062H7.15918C7.88509 4.39062 8.45312 4.54199 8.86328 4.84473C9.27344 5.14421 9.47852 5.62435 9.47852 6.28516C9.47852 6.57812 9.40365 6.84342 9.25391 7.08105C9.10417 7.31543 8.89421 7.50749 8.62402 7.65723C8.3571 7.80697 8.04622 7.90299 7.69141 7.94531L7.35938 8.16992H5.5625ZM5.18652 11.5L5.72852 10.7383H7.31543C7.76139 10.7383 8.10645 10.6227 8.35059 10.3916C8.59473 10.1605 8.7168 9.84961 8.7168 9.45898C8.7168 9.19531 8.6696 8.96745 8.5752 8.77539C8.48079 8.58008 8.33431 8.43034 8.13574 8.32617C7.93717 8.22201 7.67839 8.16992 7.35938 8.16992H6.0166L6.02637 7.42285H7.8623L8.0625 7.69629C8.4043 7.72559 8.69401 7.82161 8.93164 7.98438C9.16927 8.14714 9.34993 8.35547 9.47363 8.60938C9.60059 8.86328 9.66406 9.14323 9.66406 9.44922C9.66406 10.1165 9.44922 10.626 9.01953 10.9775C8.5931 11.3258 8.02507 11.5 7.31543 11.5H5.18652ZM15.5723 11.5H11.8174V10.7383H15.5723V11.5ZM12.0029 11.5H11.0557V4.39062H12.0029V11.5ZM15.0742 8.20898H11.8174V7.44727H15.0742V8.20898ZM15.5234 5.15723H11.8174V4.39062H15.5234V5.15723ZM19.4688 11.5H18.5312V4.39062H19.4688V11.5ZM21.749 5.15723H16.2559V4.39062H21.749V5.15723ZM22.5254 11.5H21.5488L24.2637 4.39062H24.8887L24.874 5.01562L22.5254 11.5ZM24.4834 5.01562L24.4736 4.39062H25.0938L27.8135 11.5H26.8418L24.4834 5.01562ZM26.7246 9.63965H22.7256V8.87305H26.7246V9.63965Z",
      fill: "white"
    }), /*#__PURE__*/React__default.createElement("rect", {
      x: "0.5",
      y: "1",
      width: "31",
      height: "14",
      rx: "1.5",
      stroke: "white"
    })));
  };

  return /*#__PURE__*/React__default.createElement(Motion, {
    style: {
      caretYOffset: spring(caretYOffset),
      caretOpacity: spring(caretOpacity),
      viewHeight: spring(viewHeight),
      viewPadding: spring(viewPadding)
    }
  }, function (_ref3) {
    var caretYOffset = _ref3.caretYOffset,
        viewHeight = _ref3.viewHeight,
        viewPadding = _ref3.viewPadding,
        caretOpacity = _ref3.caretOpacity;
    return /*#__PURE__*/React__default.createElement("div", {
      className: styles.subRoutesContainerRoot,
      style: {
        height: viewHeight,
        paddingTop: viewPadding,
        paddingBottom: viewPadding
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles.subRoutesContainerVerticalLine
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles.subRoutesContainerActiveIndicatorCaret,
      style: {
        top: caretYOffset,
        opacity: caretOpacity
      }
    })), /*#__PURE__*/React__default.createElement("div", {
      className: styles.subRoutesContainerItemsHolder
    }, shouldBeShown && subRoutes.map(renderItem)));
  });
};

var useStyles$k = createUseStyles(function (theme) {
  return {
    sidenavItemRoot: {
      flex: '0 0 auto',
      padding: '12px 0 4px 0',
      minHeight: '40px'
    },
    sideNavContainerBtn: {
      width: 150,
      border: 'none',
      outline: 'none',
      backgroundColor: 'inherit',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      textDecoration: 'none',
      cursor: 'pointer',
      paddingLeft: 17
    },
    sideNavContainerBtnIcon: {
      width: 28,
      height: 28,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: function boxShadow(_ref) {
        var active = _ref.active;
        return active ? '0px 1px 6px rgba(0, 0, 0, 0.1)' : 'none';
      },
      borderRadius: function borderRadius(_ref2) {
        var active = _ref2.active;
        return active ? 4 : 0;
      },
      background: function background(_ref3) {
        var active = _ref3.active;
        return active ? theme.palette.white.color : 'inherit';
      }
    },
    sideNavContainerBtnText: {
      marginLeft: 15
    }
  };
});

var SideNavOption = function SideNavOption(_ref4) {
  var id = _ref4.id,
      _ref4$active = _ref4.active,
      active = _ref4$active === void 0 ? false : _ref4$active,
      iconDefault = _ref4.iconDefault,
      iconHover = _ref4.iconHover,
      iconClick = _ref4.iconClick,
      name = _ref4.name,
      path = _ref4.path,
      _ref4$subRoutes = _ref4.subRoutes,
      subRoutes = _ref4$subRoutes === void 0 ? [] : _ref4$subRoutes,
      activeSubRouteId = _ref4.activeSubRouteId,
      _onClick = _ref4.onClick;
  var theme = useThemeSafe();
  var styles = useStyles$k({
    active: active,
    theme: theme
  });

  var _useState = useState(iconDefault),
      _useState2 = _slicedToArray$1(_useState, 2),
      icon = _useState2[0],
      setIcon = _useState2[1];

  var _useState3 = useState(colors.unselectedGrey),
      _useState4 = _slicedToArray$1(_useState3, 2),
      textColor = _useState4[0],
      setTextColor = _useState4[1];

  useEffect(function () {
    setIcon(active ? iconClick : iconDefault);
    setTextColor(active ? theme.palette.white.color : colors.unselectedGrey);
  }, [active]); // routePath should be "path" if exists, and "id" otherwise

  var routePath = path ? path : id;

  if (subRoutes.length > 0) {
    // if there are existing sub-routes reroute the father
    // to the first child
    routePath = subRoutes[0].path;
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.sidenavItemRoot
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.sideNavContainerBtn,
    onMouseEnter: function onMouseEnter() {
      if (!active) {
        setIcon(iconHover);
        setTextColor(theme.palette.white.color);
      }
    },
    onMouseLeave: function onMouseLeave() {
      if (!active) {
        setIcon(iconDefault);
        setTextColor(colors.unselectedGrey);
      }
    },
    onClick: function onClick() {
      return _onClick(routePath);
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.sideNavContainerBtnIcon
  }, /*#__PURE__*/React__default.createElement("img", {
    src: icon,
    alt: ""
  })), /*#__PURE__*/React__default.createElement("div", {
    className: styles.sideNavContainerBtnText
  }, /*#__PURE__*/React__default.createElement(Text$1, {
    variant: "body",
    color: textColor
  }, name))), /*#__PURE__*/React__default.createElement(SubRoutesContainer, {
    subRoutes: subRoutes,
    active: active,
    activeSubRouteId: activeSubRouteId,
    onClick: _onClick
  }));
};

var SideNav = function SideNav(_ref) {
  var appRoutes = _ref.appRoutes,
      activeRootRouteId = _ref.activeRootRouteId,
      activeSubRouteId = _ref.activeSubRouteId,
      onClick = _ref.onClick;
  var theme = useThemeSafe();
  var styles = useStyles$j({
    theme: theme
  });
  return /*#__PURE__*/React__default.createElement(MutableSideNav, null, /*#__PURE__*/React__default.createElement("div", {
    className: styles.scrollable
  }, appRoutes === null || appRoutes === void 0 ? void 0 : appRoutes.map(function (_ref2) {
    var icon = _ref2.icon,
        name = _ref2.name,
        path = _ref2.path,
        subRoutes = _ref2.subRoutes,
        id = _ref2.id;
    return /*#__PURE__*/React__default.createElement(SideNavOption, {
      id: id,
      iconDefault: icon["default"],
      iconHover: icon.onHover,
      iconClick: icon.onClick,
      key: name,
      name: name,
      path: path,
      active: activeRootRouteId === id,
      activeSubRouteId: activeSubRouteId,
      subRoutes: subRoutes,
      onClick: onClick
    });
  })));
};
var useStyles$j = createUseStyles(function (theme) {
  return {
    scrollable: {
      flex: '0 0 auto',
      height: 'calc(100% - 60px)',
      width: '100%',
      borderBottomRightRadius: theme.shape.borderRadiusHeavy,
      overflow: 'auto'
    }
  };
});

var SnippetCard = function SnippetCard(_ref) {
  var onCopy = _ref.onCopy,
      content = _ref.content,
      className = _ref.className;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "CyoloUI-SnippetCard-root"
  }, /*#__PURE__*/React__default.createElement(Card, {
    className: className,
    style: {
      position: 'relative',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: '0 32px 0 32px',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  }, /*#__PURE__*/React__default.createElement("code", {
    className: "CyoloUI-SnippetCard-code"
  }, content)), /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: 'absolute',
      right: 4,
      top: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexFlow: 'column'
    }
  }, onCopy && /*#__PURE__*/React__default.createElement(ActionIcon, {
    iconName: "copy",
    onClick: onCopy
  }))));
};

var StatusBanner = function StatusBanner(_ref) {
  var variant = _ref.variant,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? '' : _ref$text;
  var theme = useThemeSafe();
  var styles = useStyles$i({
    theme: theme,
    variant: variant
  });

  if (!text) {
    text = variant.toUpperCase();
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.circle
  }), /*#__PURE__*/React__default.createElement(Text$1, {
    className: styles.text,
    variant: "status-banner"
  }, text));
};

var useStyles$i = createUseStyles(function (_ref2) {
  var shape = _ref2.shape;
  return {
    root: {
      border: '1px solid transparent',
      boxSizing: 'border-box',
      borderRadius: shape.borderRadiusLight,
      width: 'fit-content',
      padding: '4px 9px 3px 9px',
      height: '20px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'default',
      backgroundColor: function backgroundColor(_ref3) {
        var variant = _ref3.variant;
        return variant === 'online' ? colors.connectedGreenBackGround : colors.labelHighriskBackground;
      }
    },
    circle: {
      marginBottom: '1px',
      borderRadius: '100px',
      width: '6px',
      height: '6px',
      marginRight: '3px',
      backgroundColor: function backgroundColor(_ref4) {
        var variant = _ref4.variant;
        return variant === 'online' ? colors.connectedGreen : colors.labelHighriskText;
      }
    },
    text: {
      color: function color(_ref5) {
        var variant = _ref5.variant;
        return variant === 'online' ? colors.connectedGreen : colors.labelHighriskText;
      }
    }
  };
});

var StatusIconStyles = {
  success: {
    display: 'flex',
    alignItems: 'center'
  },
  failed: {
    display: 'flex',
    alignItems: 'center'
  }
};

var renderApproved = function renderApproved() {
  return /*#__PURE__*/React__default.createElement(Icon, {
    size: 24,
    id: "status-icon-approved"
  });
};

var renderRefused = function renderRefused() {
  return /*#__PURE__*/React__default.createElement(Icon, {
    size: 24,
    id: "status-icon-not-approved"
  });
};

var renderSuccess = function renderSuccess() {
  return /*#__PURE__*/React__default.createElement("div", {
    style: StatusIconStyles.success
  }, /*#__PURE__*/React__default.createElement(Icon, {
    id: "status-icon-success"
  }), /*#__PURE__*/React__default.createElement(Text$1, {
    variant: "body",
    style: {
      marginLeft: 8,
      marginTop: 2
    },
    color: colors.successGreen
  }, "Success"));
};

var renderFailed = function renderFailed() {
  return /*#__PURE__*/React__default.createElement("div", {
    style: StatusIconStyles.failed
  }, /*#__PURE__*/React__default.createElement(Icon, {
    id: "status-icon-failed"
  }), /*#__PURE__*/React__default.createElement(Text$1, {
    style: {
      marginLeft: 8,
      marginTop: 2
    },
    variant: "body",
    color: colors.failureRed
  }, "Fail"));
};

var StatusIcon = function StatusIcon(_ref) {
  var type = _ref.type;

  switch (type) {
    case 'approved':
      return renderApproved();

    case 'refused':
      return renderRefused();

    case 'failed':
      return renderFailed();

    case 'success':
      return renderSuccess();

    default:
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  }
};

var gapSize = 4;

var ShowMore = function ShowMore(_ref) {
  _ref.itemSeparator;
      var children = _ref.children,
      popoverClassName = _ref.popoverClassName;

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      popoverVisible = _useState2[0],
      setPopoverVisible = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$1(_useState3, 2),
      allowedToRender = _useState4[0],
      setAllowedToRender = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray$1(_useState5, 2),
      hiddenKeys = _useState6[0],
      setHiddenKeys = _useState6[1];

  var showMoreCount = hiddenKeys.length;
  var wrapperRef = useRef(null);
  var btnRef = useRef(null);
  var theme = useThemeSafe();
  var styles = useStyles$h({
    theme: theme
  }); // reference needed for popper

  var _useState7 = useState(null),
      _useState8 = _slicedToArray$1(_useState7, 2),
      referenceElement = _useState8[0],
      setReferenceElement = _useState8[1];

  var visibilityChange = useCallback(function (isVisible) {
    setPopoverVisible(isVisible);

    if (!isVisible) {
      setAllowedToRender(false);
    }
  }, []);

  var _useDropdownPopper = useDropdownPopper({
    visible: popoverVisible,
    parentRefElement: referenceElement,
    onVisibilityChange: visibilityChange,
    placement: 'bottom-end'
  }),
      attributes = _useDropdownPopper.attributes,
      setPopperElement = _useDropdownPopper.setPopperElement,
      update = _useDropdownPopper.update,
      popperStyles = _useDropdownPopper.styles;

  var splitElements = useCallback(function () {
    var _a, _b, _c; // wrapperWidth is the total cell width


    var wrapperWidth = Math.floor((_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width); // btnWidth is the hidden items counter elem width

    var btnWidth = Math.floor((_c = (_b = btnRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().width) !== null && _c !== void 0 ? _c : 0); // availableWidth is the dispalyed items container elem width.

    var availableWidth = wrapperWidth - btnWidth;
    var childrenArr = Array.from(wrapperRef.current.children).filter(function (child) {
      return child.tagName.toLowerCase() !== 'button';
    });
    var childrenCount = childrenArr.length;

    if (!childrenCount) {
      return;
    }

    var elementsToShow = [];
    var _hiddenKeys = [];
    childrenArr.forEach(function (el) {
      // reset hidden class from prev state
      el.classList.remove(styles.hiddenClassName);
      var alreadyTakenWidth = elementsToShow.reduce(function (total, elementToShow) {
        return total + elementToShow.getBoundingClientRect().width + gapSize * 2;
      }, 0); // widthToTake is the avilable width left in the dispalyed items container elem width.

      var widthToTake = alreadyTakenWidth + el.getBoundingClientRect().width;

      if (availableWidth > widthToTake) {
        elementsToShow.push(el);
        return;
      } else {
        var elKey = el.getAttribute('data-key');
        el.classList.add(styles.hiddenClassName);

        _hiddenKeys.push(elKey);
      }
    });
    setHiddenKeys(_hiddenKeys);
  }, []);
  useLayoutEffect$5(function () {
    var resizeObserver = new ResizeObserver(function () {
      splitElements();
    });
    wrapperRef.current && resizeObserver.observe(wrapperRef.current);
    return function () {
      resizeObserver.unobserve(wrapperRef.current);
      resizeObserver.disconnect();
    };
  }, [splitElements]);
  var updatePopper = useCallback(function () {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(popoverVisible && !allowedToRender && update !== null)) {
                _context.next = 4;
                break;
              }

              _context.next = 3;
              return update();

            case 3:
              setAllowedToRender(true);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  }, [popoverVisible, allowedToRender, update]);
  useEffect(function () {
    updatePopper();
  }, [updatePopper]);

  var handleButtonClick = function handleButtonClick(e) {
    e.stopPropagation();

    if (!showMoreCount) {
      return;
    }

    setPopoverVisible(function (prev) {
      return !prev;
    });
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.root,
    ref: setReferenceElement
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.elementsWrapper,
    ref: wrapperRef
  }, React__default.Children.map(children, function (child) {
    if ( /*#__PURE__*/React__default.isValidElement(child)) {
      return /*#__PURE__*/React__default.cloneElement(child, Object.assign(Object.assign({}, child.props), {
        'data-key': child.key
      }));
    }

    return child;
  }), /*#__PURE__*/React__default.createElement("button", {
    className: clsx(styles.button, _defineProperty$1({}, styles.hideButton, !showMoreCount)),
    ref: btnRef,
    onClick: handleButtonClick
  }, /*#__PURE__*/React__default.createElement(Text$1, {
    variant: "body"
  }, "+", showMoreCount))), popoverVisible && /*#__PURE__*/createPortal( /*#__PURE__*/React__default.createElement("div", Object.assign({
    className: clsx(popoverClassName, styles.popover, _defineProperty$1({}, styles.popoverVisible, allowedToRender)),
    style: popperStyles.popper,
    ref: setPopperElement
  }, attributes.popper), /*#__PURE__*/React__default.createElement("div", {
    className: styles.popoverBody
  }, React__default.Children.map(children, function (child) {
    if ( /*#__PURE__*/React__default.isValidElement(child)) {
      if (!hiddenKeys.includes(String(child.key))) {
        return null;
      }

      return /*#__PURE__*/React__default.cloneElement(child, Object.assign(Object.assign({}, child.props), {
        'data-key': child.key
      }));
    }
  }))), document.body));
};
var useStyles$h = createUseStyles(function (theme) {
  var _popover;

  return {
    root: {
      width: '100%',
      display: 'flex',
      gap: gapSize,
      alignItems: 'center'
    },
    elementsWrapper: {
      display: 'flex',
      gap: gapSize,
      flexGrow: 1,
      maxWidth: '100%'
    },
    button: _defineProperty$1({
      border: 'none',
      background: 'transparent',
      cursor: 'pointer'
    }, '& p', {
      color: theme.palette.primary.color
    }),
    hideButton: {
      visibility: 'hidden'
    },
    popover: (_popover = {
      position: 'relative',
      zIndex: theme.zIndex.normal,
      backgroundColor: theme.palette.white.color,
      boxShadow: "".concat(theme.shadows[1], ", ").concat(theme.shadows[0]),
      borderRadius: theme.shape.borderRadiusLight,
      maxHeight: 120,
      overflowY: 'auto',
      display: 'none',
      fontSize: theme.typography.fontBaseSize,
      fontFamily: theme.typography.p.fontFamily,
      color: theme.palette.grey.color
    }, _defineProperty$1(_popover, '&::before', {
      content: '""',
      position: 'sticky',
      width: '100%',
      top: 0,
      left: 0,
      display: 'block',
      height: 8,
      margin: '0 0 -8px',
      background: 'linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 70%)'
    }), _defineProperty$1(_popover, '&::after', {
      content: '""',
      position: 'sticky',
      bottom: 0,
      left: 0,
      display: 'block',
      height: 8,
      margin: '-8px 0 0',
      background: 'linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 70%)'
    }), _popover),
    popoverVisible: {
      display: 'block'
    },
    popoverBody: {
      display: 'flex',
      gap: gapSize,
      flexWrap: 'wrap',
      padding: 8
    },
    itemWrapper: {
      display: 'flex',
      alignItems: 'center'
    },
    hiddenClassName: {
      display: 'none'
    }
  };
});

var ListCell = function ListCell(_ref) {
  var listItems = _ref.listItems,
      renderItem = _ref.renderItem,
      itemKeyResolver = _ref.itemKeyResolver,
      itemSeparator = _ref.itemSeparator,
      noDataView = _ref.noDataView,
      itemWrapperClassName = _ref.itemWrapperClassName,
      popoverClassName = _ref.popoverClassName;

  if (!listItems || listItems.length === 0) {
    return noDataView || null;
  }

  var renderShowMoreItem = function renderShowMoreItem(item, index) {
    var _a;

    var Item = renderItem(item);

    if (Item === null || Item === undefined) {
      return null;
    }

    return /*#__PURE__*/React__default.createElement("div", {
      key: (_a = itemKeyResolver === null || itemKeyResolver === void 0 ? void 0 : itemKeyResolver(item)) !== null && _a !== void 0 ? _a : index,
      className: itemWrapperClassName
    }, Item);
  };

  return /*#__PURE__*/React__default.createElement(ShowMore, {
    itemSeparator: itemSeparator,
    popoverClassName: popoverClassName
  }, listItems.map(renderShowMoreItem));
};

var RenderCell = function RenderCell(viewFn) {
  // eslint-disable-next-line react/display-name
  return function (_ref) {
    var row = _ref.row,
        getValue = _ref.getValue;
    var value = getValue();
    var rowData = row.original;
    var idx = row.index;
    return viewFn(value, rowData, idx);
  };
};

var RenderGroupByCell = function RenderGroupByCell(viewFn) {
  // eslint-disable-next-line react/display-name
  return function (_ref) {
    var row = _ref.row,
        getValue = _ref.getValue;
    var value = getValue();
    var rowData = row.original;
    return /*#__PURE__*/React__default.createElement("div", null, viewFn(value, rowData, row.toggleExpanded, row.getIsExpanded()));
  };
};

var TextCell = function TextCell(_ref) {
  var val = _ref.val,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'body' : _ref$variant;
  var styles = useStyles$g({
    variant: variant
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.textCell,
    title: val
  }, val);
};
var useStyles$g = createUseStyles({
  textCell: function textCell(_ref2) {
    var variant = _ref2.variant;
    return Object.assign({
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      width: '100%'
    }, styles$1[variant]);
  }
});

var ToggleCell = function ToggleCell(_a) {
  var value = _a.value,
      props = __rest(_a, ["value"]);

  var isStringVal = typeof value === 'string';
  var isActive = isStringVal ? value.toLowerCase() === 'true' : Boolean(value);
  return /*#__PURE__*/React__default.createElement(Toggle, Object.assign({
    active: isActive
  }, props));
};

var ColumnSize;

(function (ColumnSize) {
  ColumnSize[ColumnSize["XSM"] = 36] = "XSM";
  ColumnSize[ColumnSize["SM"] = 64] = "SM";
  ColumnSize[ColumnSize["MD"] = 172] = "MD";
  ColumnSize[ColumnSize["LG"] = 224] = "LG";
  ColumnSize[ColumnSize["XLG"] = 336] = "XLG";
  ColumnSize[ColumnSize["PLACE_HOLDER"] = 16] = "PLACE_HOLDER";
})(ColumnSize || (ColumnSize = {}));

var textFilter = {
  EQUAL: {
    label: '=',
    value: 'eq'
  },
  INCLUDE: {
    label: 'INCLUDES',
    value: 're'
  },
  NOT_EQUAL: {
    label: '!=',
    value: 'neq'
  }
};
var numberFilter = {
  EQUAL: {
    label: '=',
    value: 'eq'
  },
  NOT_EQUAL: {
    label: '!=',
    value: 'neq'
  },
  GREATER: {
    label: '>',
    value: 'gte'
  },
  SMALLER: {
    label: '<',
    value: 'lte'
  }
};
var boolFilter = {
  EQUAL: {
    label: '=',
    value: 'eq'
  },
  NOT_EQUAL: {
    label: '!=',
    value: 'neq'
  }
}; // TODO phase2 support

var dateFilter = {
  FROM: {
    label: 'FROM',
    value: 'gte'
  },
  TO: {
    label: 'TO',
    value: 'lte'
  }
};

var Column = function Column(_props) {
  return null;
};

var reorderColumn = function reorderColumn(columnId, targetColumnId, columnOrder) {
  if (!targetColumnId) {
    return columnOrder;
  }

  var newOrder = _toConsumableArray$1(columnOrder);

  newOrder.splice(newOrder.indexOf(targetColumnId), 0, newOrder.splice(newOrder.indexOf(columnId), 1)[0]);
  return _toConsumableArray$1(newOrder);
};
/**
 *  wrap value as event
 */

function eventWrapper(value) {
  var useChecked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (useChecked) {
    return {
      target: {
        checked: value
      }
    };
  }

  return {
    target: {
      value: value
    }
  };
}
var groupedKeyPrefix = '__grouped__';
var toGroupedKey = function toGroupedKey(str) {
  return "".concat(groupedKeyPrefix).concat(str);
};
var fromGroupedKey = function fromGroupedKey(str) {
  var idx = str.indexOf(groupedKeyPrefix);

  if (idx == -1) {
    return str;
  }

  return str.substring(idx + groupedKeyPrefix.length);
};
var isShadowGroupedKey = function isShadowGroupedKey(key) {
  if (!key) {
    return false;
  }

  return key.indexOf(groupedKeyPrefix) === 0;
};
var isShadowColumn = function isShadowColumn(column) {
  return (// @ts-ignore
    isShadowGroupedKey(column.columnDef.accessorKey) && !column.getIsGrouped()
  );
};
function getGroupByTargetToSubRows(data, shadowColumn) {
  var originColumn = fromGroupedKey(shadowColumn);
  return data.reduce(function (map, row) {
    if (!map.has(row[originColumn])) {
      map.set(row[originColumn], []);
    }

    var old = map.get(row[originColumn]);
    var rowWithShadow = Object.assign(Object.assign({}, row), _defineProperty$1({}, shadowColumn, row[originColumn]));
    map.set(row[originColumn], [].concat(_toConsumableArray$1(old), [rowWithShadow]));
    return map;
  }, new Map());
} // TODO move to object for performance

function getGroupedRows(data, shadowColumn) {
  var originColumn = fromGroupedKey(shadowColumn);
  var dataSample = resetItem(data[0]);
  return data.reduce(function (acc, i) {
    var val = i[originColumn];

    if (acc.includes(val)) {
      return acc;
    }

    acc.push(val);
    return acc;
  }, []).map(function (tc) {
    var _Object$assign2;

    return Object.assign(Object.assign({}, dataSample), (_Object$assign2 = {
      kind: data[0].kind
    }, _defineProperty$1(_Object$assign2, shadowColumn, tc), _defineProperty$1(_Object$assign2, "id", tc), _Object$assign2));
  });
}
function getGroupedRowsForList(data, originColumn, resolveId) {
  var shadowColumn = toGroupedKey(originColumn);
  var dataSample = resetItem(data[0]);
  return data.reduce(function (acc, dataItem) {
    var list = dataItem[originColumn];
    list.forEach(function (i) {
      var id = resolveId ? resolveId(i) : i;

      if (acc.includes(id)) {
        return;
      }

      acc.push(id);
    });
    return acc;
  }, []).map(function (tc) {
    var _Object$assign3;

    return Object.assign(Object.assign({}, dataSample), (_Object$assign3 = {}, _defineProperty$1(_Object$assign3, shadowColumn, tc), _defineProperty$1(_Object$assign3, "id", tc), _defineProperty$1(_Object$assign3, "kind", data[0].kind), _Object$assign3));
  });
}
function resetItem(source) {
  // @ts-ignore
  var target = {};

  for (var key in source) {
    if (source.hasOwnProperty(key)) {
      if (Array.isArray(source[key])) {
        target[key] = [];
        continue;
      }

      switch (_typeof(source[key])) {
        case 'boolean':
          target[key] = false;
          continue;

        case 'string':
          {
            target[key] = '';
            continue;
          }

        case 'number':
          {
            target[key] = 0;
            continue;
          }

        case 'function':
          {
            target[key] = function () {};

            continue;
          }

        case 'object':
          {
            target[key] = {};
            continue;
          }

        default:
          target[key] = undefined;
      }
    }
  }

  return target;
}
function getGroupByTargetToSubRowsForList(data, originColumn, resolveId) {
  var shadowColumn = toGroupedKey(originColumn);
  return data.reduce(function (map, row) {
    var list = row[originColumn];
    list.forEach(function (i) {
      var id = resolveId ? resolveId(i) : i;

      if (!map.has(id)) {
        map.set(id, []);
      }

      var prev = map.get(id);
      var nextWithShadow = Object.assign(Object.assign({}, row), _defineProperty$1({}, shadowColumn, id));
      map.set(id, [].concat(_toConsumableArray$1(prev), [nextWithShadow]));
    });
    return map;
  }, new Map());
}
function isRowGroupByParent(row) {
  return Boolean(row.subRows.length);
}

var getTableColumns = function getTableColumns(children) {
  var childrenArr = Children.toArray(children);
  var columns = [];
  var columnProps = [];
  var columnSizeConf = {};

  for (var idx = 0; idx < childrenArr.length; idx++) {
    var child = childrenArr[idx];
    var isValidColumn = /*#__PURE__*/isValidElement(child);

    if (!isValidColumn) {
      console.error('found invalid columns in table. aborting');
      return [[], [], {}];
    }

    if (Boolean(child.props.groupbyView)) {
      // create shadow columns replica for grouping case
      var columnDefinition = getColumnDefinition(child);

      var _shahdowColumnDefinition = getShadowColumn(columnDefinition);

      columns.push(_shahdowColumnDefinition);
      var columnProp = getColumnProp(child);

      var _shahdowColumnProp = getShadowColumnProps(columnProp);

      columnProps.push(_shahdowColumnProp);
    }

    var _column = getColumnDefinition(child);

    columns.push(_column);
    columnProps.push(getColumnProp(child));
    columnSizeConf[_column.id] = child.props.size || _column.minSize;
  }

  return [columns, columnProps, columnSizeConf];
}; // shadow column are column-replica for view purpose for a grouped use-case
// they have no size, sort, resize, filter, rowActions etc
// they have a unique ID marking them as group column


function getShadowColumn(column) {
  var shadowColumn = Object.assign({}, column);
  shadowColumn.id = toGroupedKey(column.id);
  shadowColumn.enableGrouping = true;
  shadowColumn.enableSorting = false;
  shadowColumn.enableResizing = false;
  shadowColumn.header = '';
  shadowColumn.filterFn = null; // @ts-ignore

  shadowColumn.accessorKey = toGroupedKey(column.accessorKey.toString());

  shadowColumn.cell = function (cell) {
    // @ts-ignore
    if (cell.column.columnDef.groupbyView) {
      // @ts-ignore
      return cell.column.columnDef.groupbyView({
        getValue: cell.getValue,
        row: cell.row
      });
    }

    return cell.getValue();
  };

  return shadowColumn;
} // shadow column are column-replica for view purpose for a grouped use-case
// they have no size, sort, resize, filter, rowActions etc
// they have a unique ID marking them as group column


function getShadowColumnProps(columnProp) {
  if (!columnProp.groupbyView) {
    console.error('missing groupbyView renderer');
  }

  var shadowColumnProp = Object.assign({}, columnProp);
  shadowColumnProp.id = toGroupedKey(columnProp.id);
  shadowColumnProp.enableSorting = false;
  shadowColumnProp.isShadowColumn = true;
  shadowColumnProp.groupbyView = columnProp.groupbyView;
  shadowColumnProp.filterOp = null;
  shadowColumnProp.size = 0; // @ts-ignore - lib typing bug

  shadowColumnProp.accessor = toGroupedKey(columnProp.accessor.toString());
  return shadowColumnProp;
}

function getColumnProp(child) {
  // eslint-disable-next-line
  var _a = child.props;
      _a.cell;
      var _props = __rest(_a, ["cell"]);

  return _props;
}

function getColumnDefinition(child) {
  var _a, _b;

  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    header: child.props.title,
    id: child.props.id || child.props.accessor,
    enableSorting: (_a = child.props.enableSorting) !== null && _a !== void 0 ? _a : true,
    sortingFn: 'text',
    minSize: (_b = child.props.size) !== null && _b !== void 0 ? _b : ColumnSize.MD,
    enableGrouping: Boolean(child.props.groupbyView),
    enableColumnFilter: Boolean(child.props.filterOp)
  }, child.props.accessor ? {
    accessorKey: child.props.accessor
  } : {}), child.props.accessorFn ? {
    accessorFn: child.props.accessorFn
  } : {}), child.props.cell ? {
    cell: child.props.cell
  } : {}), child.props.sortingFn ? {
    sortingFn: child.props.sortingFn
  } : {}), child.props.groupbyView ? {
    groupbyView: child.props.groupbyView
  } : {});
}

var Arrow$1 = function Arrow(_ref) {
  var direction = _ref.direction,
      disabled = _ref.disabled;
  var theme = useThemeSafe();
  var styles = useStyles$f({
    direction: direction
  });
  return /*#__PURE__*/React__default.createElement("svg", {
    className: styles.svg,
    width: "7",
    height: "12",
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M6.3999 0.719971L0.639903 5.99997L6.3999 11.28",
    stroke: disabled ? theme.palette.grey.extraLight : theme.palette.secondary.color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var ArrowEnd = function ArrowEnd(_ref2) {
  var direction = _ref2.direction,
      disabled = _ref2.disabled;
  var theme = useThemeSafe();
  var styles = useStyles$f({
    direction: direction
  });
  return /*#__PURE__*/React__default.createElement("svg", {
    className: styles.svg,
    width: "14",
    height: "13",
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M13 1.43994L7.24 6.71994L13 11.9999",
    stroke: disabled ? theme.palette.grey.extraLight : theme.palette.secondary.color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M7 1.43994L1.24 6.71994L7 11.9999",
    stroke: disabled ? theme.palette.grey.extraLight : theme.palette.secondary.color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var useStyles$f = createUseStyles({
  svg: {
    transform: function transform(props) {
      return props.direction === 'right' && 'rotate(180deg)';
    }
  }
});

function getCurrentItemsCount(page, itemsPerPage, totalItems) {
  var startItem = (page - 1) * itemsPerPage + 1;
  var endItem = page * itemsPerPage;

  if (endItem > totalItems) {
    endItem = totalItems;
  }

  return "".concat(startItem, "-").concat(endItem, " of ").concat(totalItems);
}

var pagesSlicer = function pagesSlicer(pagesArray, currentPageIndex) {
  var totalPages = pagesArray.length;
  var visiblePages = 5;
  var startPageIndex = Math.max(currentPageIndex - Math.floor(visiblePages / 2), 0);
  var endPageIndex = Math.min(startPageIndex + visiblePages - 1, totalPages - 1);

  if (endPageIndex - startPageIndex + 1 < visiblePages) {
    // Adjust start and end indices if the number of visible pages is less than desired
    startPageIndex = Math.max(endPageIndex - visiblePages + 1, 0);
  }

  return pagesArray.slice(startPageIndex, endPageIndex + 1);
};

var SHOW_ITEMS_OPTIONS = [20, 50, 100];

var TablePagination = function TablePagination(_ref) {
  var pageSize = _ref.pageSize,
      pageCount = _ref.pageCount,
      currentPageIndex = _ref.currentPageIndex,
      onPageSizeChange = _ref.onPageSizeChange,
      onChangePageIndex = _ref.onChangePageIndex,
      canGoPreviousPage = _ref.canGoPreviousPage,
      onPreviousPage = _ref.onPreviousPage,
      canGoNextPage = _ref.canGoNextPage,
      onNextPage = _ref.onNextPage,
      totalItems = _ref.totalItems,
      options = _ref.options,
      _ref$showCurrentCount = _ref.showCurrentCount,
      showCurrentCount = _ref$showCurrentCount === void 0 ? true : _ref$showCurrentCount;
  var theme = useThemeSafe();
  var styles = useStyles$e({
    theme: theme,
    isCounterShown: showCurrentCount
  });
  var pageItems = Array.from({
    length: pageCount
  }).map(function (_, index) {
    return index;
  });
  var visiblePages = pagesSlicer(pageItems, currentPageIndex);
  var itemsCount = getCurrentItemsCount(currentPageIndex + 1, pageSize, totalItems);
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx('Cyolo-UI-TablePagination', styles.root)
  }, showCurrentCount && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Text$1, {
    variant: "body",
    color: theme.palette.grey.color
  }, itemsCount)), /*#__PURE__*/React__default.createElement("div", {
    className: styles.buttonsWrapper
  }, /*#__PURE__*/React__default.createElement(DropdownMenu, {
    items: options,
    activeId: String(pageSize),
    itemStringResolver: function itemStringResolver(item) {
      return String(item);
    },
    itemIdResolver: function itemIdResolver(item) {
      return String(item);
    },
    type: "single",
    onValueChange: function onValueChange(value) {
      return onPageSizeChange(value);
    },
    style: {
      width: 104
    }
  }), /*#__PURE__*/React__default.createElement(Button, {
    variant: "secondary",
    className: clsx(styles.button, styles.prevNextButton),
    onClick: function onClick() {
      return onChangePageIndex(0);
    },
    disabled: !canGoPreviousPage
  }, /*#__PURE__*/React__default.createElement(ArrowEnd, {
    direction: "left",
    disabled: !canGoPreviousPage
  })), /*#__PURE__*/React__default.createElement(Button, {
    variant: "secondary",
    className: clsx(styles.button, styles.prevNextButton),
    onClick: function onClick() {
      return onPreviousPage();
    },
    disabled: !canGoPreviousPage
  }, /*#__PURE__*/React__default.createElement(Arrow$1, {
    direction: "left",
    disabled: !canGoPreviousPage
  })), /*#__PURE__*/React__default.createElement("div", {
    className: styles.pagesWrapper
  }, visiblePages.map(function (val) {
    return /*#__PURE__*/React__default.createElement(Button, {
      variant: "secondary",
      className: clsx(styles.button, _defineProperty$1({}, styles.active, val === currentPageIndex)),
      key: val,
      onClick: function onClick() {
        return onChangePageIndex(val);
      }
    }, val + 1);
  })), /*#__PURE__*/React__default.createElement(Button, {
    variant: "secondary",
    className: clsx(styles.button, styles.prevNextButton),
    onClick: function onClick() {
      return onNextPage();
    },
    disabled: !canGoNextPage
  }, /*#__PURE__*/React__default.createElement(Arrow$1, {
    direction: "right",
    disabled: !canGoNextPage
  })), /*#__PURE__*/React__default.createElement(Button, {
    variant: "secondary",
    className: clsx(styles.button, styles.prevNextButton),
    onClick: function onClick() {
      return onChangePageIndex(pageCount - 1);
    },
    disabled: !canGoNextPage
  }, /*#__PURE__*/React__default.createElement(ArrowEnd, {
    direction: "right",
    disabled: !canGoNextPage
  }))));
};
var useStyles$e = createUseStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      justifyContent: function justifyContent(props) {
        return props.isCounterShown ? 'space-between' : 'flex-end';
      },
      alignItems: 'center',
      marginTop: 24
    },
    buttonsWrapper: {
      display: 'flex',
      gap: 8,
      alignItems: 'center'
    },
    pagesWrapper: {
      display: 'flex',
      gap: 8,
      alignItems: 'center'
    },
    button: {
      width: '24px !important',
      height: '24px !important',
      padding: '0 !important',
      '&:not([disabled]):hover': {
        border: "1px solid ".concat(theme.palette.primary.color, " !important")
      },
      '&[disabled]': {
        backgroundColor: "".concat(theme.palette.white.color, " !important")
      }
    },
    active: {
      background: "".concat(theme.palette.primary.color, " !important"),
      '& .CyoloUI-Text': {
        color: "".concat(theme.palette.white.color, " !important")
      }
    },
    prevNextButton: {
      lineHeight: '0 !important'
    }
  };
});

/**
 * persists data to local storage
 * @param key
 * @param initialValue
 * @returns
 */

function useLocalStorage(key, initialValue) {
  var _useState = useState(function () {
    if (typeof window === 'undefined') {
      return initialValue;
    }

    try {
      // Get from local storage by key
      var item = window.localStorage.getItem(key); // Parse stored json or if none return initialValue

      // Parse stored json or if none return initialValue
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      // If error also return initialValue
      console.log(error);
      return initialValue;
    }
  }),
      _useState2 = _slicedToArray$1(_useState, 2),
      storedValue = _useState2[0],
      setStoredValue = _useState2[1];

  useEffect(function () {
    localStorage.setItem(key, JSON.stringify(storedValue));
  }, [storedValue, key]);
  var setValue = useCallback(function (value) {
    setStoredValue(value);
  }, []);
  return [storedValue, setValue];
}

var SYSTEM_CHECKBOX_ID = 'selection';

var Sort;

(function (Sort) {
  Sort["ASC"] = "asc";
  Sort["DESC"] = "desc";
  Sort["NONE"] = "";
})(Sort || (Sort = {}));

var TableContext = /*#__PURE__*/createContext({
  isReady: false,
  searchQuery: {
    submitFilterRef: null,
    setFilter: function setFilter() {},
    handleQuickFilter: function handleQuickFilter() {
      return function () {};
    },
    keyNameList: []
  },
  table: {
    //row selection
    rowSelectionState: {},
    setRowSelection: function setRowSelection() {
      console.warn('setRowSelectionState is not initialized');
    },
    selectedRowsState: [],
    //column visibility
    columnVisibilityState: {},
    setColumnVisibility: function setColumnVisibility() {
      console.warn('setColumnVisibility is not initialized');
    },
    toggleColumnVisibility: function toggleColumnVisibility() {
      console.warn('toggleColumnVisibility is not initialized');
    },
    //sorting
    sortingState: [],
    setSorting: function setSorting() {
      console.warn('setSorting is not initialized');
    },
    //columnOrder
    columnOrderState: [],
    setColumnOrder: function setColumnOrder() {
      console.warn('setColumnOrder is not initialized');
    },
    handleChangeColumnOrder: function handleChangeColumnOrder() {
      console.warn('handleChangeColumnOrder is not initialized');
    },
    //columnSizing
    initColumnSizing: function initColumnSizing() {
      console.warn('initColumnSizing is not initialized');
    },
    resetColumnSizing: function resetColumnSizing() {
      console.warn('initColumnSizing is not initialized');
    },
    columnSizing: {},
    setColumnSizing: function setColumnSizing() {
      console.warn('setColumnSizing is not initialized');
    },
    //column list
    columnListState: [],
    setColumnList: function setColumnList() {
      console.warn('setColumnList is not initialized');
    },
    // columnGrouping
    columnGroupBy: undefined,
    columnGroupingState: [],
    setColumnGroupBy: function setColumnGroupBy() {
      console.warn('setColumnGroupBy is not initialized');
    },
    resetColumnGroupBy: function resetColumnGroupBy() {
      console.warn('resetColumnGroupBy is not initialized');
    },
    columnGroupByList: []
  },
  pagination: {
    pageSize: 0,
    setPageSize: function setPageSize() {
      console.warn('setPageSize is not initialized');
    }
  }
});

var getTableIdByPath = function getTableIdByPath(pathname) {
  return "table-".concat(pathname.replace(/\//g, '-')); // TODO need to sync table id from table
};

var ORDER_COLUMN_LS = 'orderColumns';
var VISIBLE_COLUMN_LS = "visibleColumns";
var SORT_COLUMN_LS = "sortColumns";
var PAGE_SIZE_LS = 'page_size';
var SIZING_COLUMN_LS = 'sizingColumns';
var TableViewProvider = function TableViewProvider(_ref) {
  var children = _ref.children;
  //---------local-storage---------
  var location = useLocation();
  var TABLE_ID = getTableIdByPath(location.pathname); //---------row selection---------

  var _useState = useState({}),
      _useState2 = _slicedToArray$1(_useState, 2),
      rowSelectionState = _useState2[0],
      setRowSelection = _useState2[1];

  var selectedRowsState = useMemo(function () {
    return Object.keys(rowSelectionState);
  }, [rowSelectionState]); //-------------------------------
  //---------columnList---------

  var _useState3 = useState([]),
      _useState4 = _slicedToArray$1(_useState3, 2),
      columnListState = _useState4[0],
      _setColumnList = _useState4[1]; //-------------------------------
  //---------column visibility---------


  var _useLocalStorage = useLocalStorage([TABLE_ID, VISIBLE_COLUMN_LS].join('_'), {}),
      _useLocalStorage2 = _slicedToArray$1(_useLocalStorage, 2),
      persistVisibleColumn = _useLocalStorage2[0],
      setPersistVisibleColumn = _useLocalStorage2[1];

  var _useState5 = useState(persistVisibleColumn),
      _useState6 = _slicedToArray$1(_useState5, 2),
      columnVisibilityState = _useState6[0],
      setColumnVisibility = _useState6[1];

  useEffect(function () {
    setPersistVisibleColumn(columnVisibilityState);
  }, [columnVisibilityState]);

  var toggleColumnVisibility = function toggleColumnVisibility(accessor) {
    if (!columnVisibilityState.hasOwnProperty(accessor)) {
      setColumnVisibility(function (prev) {
        return Object.assign(Object.assign({}, prev), _defineProperty$1({}, accessor, false));
      });
      return;
    }

    setColumnVisibility(function (prev) {
      return Object.assign(Object.assign({}, prev), _defineProperty$1({}, accessor, !prev[accessor]));
    });
  }; //-------------------------------
  //---------sorting---------


  var _useLocalStorage3 = useLocalStorage([TABLE_ID, SORT_COLUMN_LS].join('_'), {}),
      _useLocalStorage4 = _slicedToArray$1(_useLocalStorage3, 2),
      persistSortColumn = _useLocalStorage4[0],
      setPersistSortColumn = _useLocalStorage4[1];

  var _useState7 = useState(sortMapToList(persistSortColumn)),
      _useState8 = _slicedToArray$1(_useState7, 2),
      sortingState = _useState8[0],
      setSorting = _useState8[1];

  useEffect(function () {
    setPersistSortColumn(sortListToMap(sortingState));
  }, [sortingState]); //-------------------------------
  //---------column order---------

  var _useLocalStorage5 = useLocalStorage([TABLE_ID, ORDER_COLUMN_LS].join('_'), []),
      _useLocalStorage6 = _slicedToArray$1(_useLocalStorage5, 2),
      persistOrderColumn = _useLocalStorage6[0],
      setPersistOrderColumn = _useLocalStorage6[1];

  var _useState9 = useState([SYSTEM_CHECKBOX_ID].concat(_toConsumableArray$1(persistOrderColumn))),
      _useState10 = _slicedToArray$1(_useState9, 2),
      columnOrderState = _useState10[0],
      setColumnOrder = _useState10[1]; //check if new columns were added


  useEffect(function () {
    var orderWithoutSelection = columnListState.map(function (column) {
      return column.accessor;
    });
    var newColumns = orderWithoutSelection.filter(function (item) {
      return !persistOrderColumn.includes(item);
    });

    if (newColumns.length) {
      setColumnOrder([SYSTEM_CHECKBOX_ID].concat(_toConsumableArray$1(columnListState.map(function (col) {
        return col.accessor;
      }))));
    }
  }, [columnListState, persistOrderColumn, columnOrderState]);
  useEffect(function () {
    setPersistOrderColumn(columnOrderState.filter(function (columnOrder) {
      return columnOrder !== SYSTEM_CHECKBOX_ID;
    }));
  }, [columnOrderState]);
  var handleChangeColumnOrder = useCallback(function (accessor, targetAccessor) {
    var orderWithoutSelection = columnOrderState.filter(function (columnOrder) {
      return columnOrder !== SYSTEM_CHECKBOX_ID;
    });
    var order = orderWithoutSelection.length ? orderWithoutSelection : columnListState.map(function (col) {
      return col.accessor;
    });
    var newColumnOrder = reorderColumn(accessor, targetAccessor, order);
    setColumnOrder([SYSTEM_CHECKBOX_ID].concat(_toConsumableArray$1(newColumnOrder)));
  }, [columnOrderState, columnListState, persistOrderColumn]); //-------------------------------
  // column sizing

  var _useLocalStorage7 = useLocalStorage([TABLE_ID, SIZING_COLUMN_LS].join('_'), {}),
      _useLocalStorage8 = _slicedToArray$1(_useLocalStorage7, 2),
      persistSizingColumn = _useLocalStorage8[0],
      setPersistSizingColumn = _useLocalStorage8[1]; //---------pagination------------


  var _useLocalStorage9 = useLocalStorage([TABLE_ID, PAGE_SIZE_LS].join('_'), 0),
      _useLocalStorage10 = _slicedToArray$1(_useLocalStorage9, 2),
      persistPageSize = _useLocalStorage10[0],
      setPersistPageSize = _useLocalStorage10[1];

  var _useState11 = useState(persistPageSize),
      _useState12 = _slicedToArray$1(_useState11, 2),
      pageSize = _useState12[0],
      setPageSize = _useState12[1];

  useEffect(function () {
    setPersistPageSize(pageSize);
  }, [pageSize]); //---------columnGroupBy---------

  var _useState13 = useState([]),
      _useState14 = _slicedToArray$1(_useState13, 2),
      columnGroupingState = _useState14[0],
      setColumnGroupingState = _useState14[1];

  var _useState15 = useState([]),
      _useState16 = _slicedToArray$1(_useState15, 2),
      columnGroupByList = _useState16[0],
      setColumnGroupByOptions = _useState16[1];

  var columnGroupBy = useMemo(function () {
    if (columnGroupingState.length === 0) {
      return '';
    }

    return fromGroupedKey(columnGroupingState[0]);
  }, [columnGroupingState]);

  var setColumnGroupBy = function setColumnGroupBy(columnId) {
    var next = Boolean(columnId) ? [toGroupedKey(columnId)] : [];
    setColumnGroupingState(next);
  }; //---------QueryBuilderSearch---------


  var setFilter = useCallback(function (part) {
    submitFilterRef.current(part);
  }, []);
  var submitFilterRef = useRef();
  var handleQuickFilter = useCallback(function (c) {
    return function () {
      setFilter({
        keyName: c.id,
        operator: '=',
        valueList: []
      });
    };
  }, [setFilter]);
  var setColumnList = useCallback(function (columns) {
    var accesorSet = new Set();
    columns.forEach(function (c) {
      accesorSet.add(c.accessor);
    });
    var _groupBySelectors = [];
    var _columns = [];
    columns.forEach(function (c) {
      if (c.isShadowColumn) {
        var originAccesor = fromGroupedKey(c.accessor);
        if (originAccesor) _groupBySelectors.push({
          id: originAccesor,
          title: c.title,
          value: false
        });
        return;
      }

      _columns.push(Object.assign({}, c));
    });

    _setColumnList(_columns);

    setColumnGroupByOptions(_groupBySelectors);
  }, []);
  var initColumnSizing = useCallback(function (confState) {
    var nextPersistState = Object.assign({}, persistSizingColumn);
    Object.keys(confState).forEach(function (id) {
      if (nextPersistState[id]) {
        return;
      }

      nextPersistState[id] = confState[id];
    });
    setPersistSizingColumn(nextPersistState);
  }, [persistSizingColumn]);
  var resetColumnSizing = useCallback(function () {
    var newSizeState = columnListState.reduce(function (obj, c) {
      obj[c.id] = c.size || ColumnSize.MD;
      return obj;
    }, {});
    setPersistSizingColumn(newSizeState);
  }, [columnListState, persistSizingColumn, setPersistSizingColumn]);
  var handleChangeColumnSizing = useCallback(function (state) {
    var nextState = Object.assign({}, persistSizingColumn);
    Object.keys(state).forEach(function (id) {
      if (nextState[id] === state[id]) {
        return;
      }

      nextState[id] = Math.max(state[id], ColumnSize.SM);
    });
    setPersistSizingColumn(nextState);
  }, [persistSizingColumn]);
  var keyNameList = useMemo(function () {
    return columnListState.filter(function (c) {
      return c.filterOp !== undefined && c.filterOp !== null;
    }).map(function (c) {
      return {
        label: c.title,
        value: c.accessor,
        allowedOperator: c.filterOp && Object.values(c.filterOp)
      };
    });
  }, [columnListState]);
  var resetColumnGroupBy = useCallback(function () {
    setColumnGroupingState([]);
  }, []);
  return /*#__PURE__*/React__default.createElement(TableContext.Provider, {
    value: {
      isReady: true,
      searchQuery: {
        setFilter: setFilter,
        submitFilterRef: submitFilterRef,
        handleQuickFilter: handleQuickFilter,
        keyNameList: keyNameList
      },
      table: {
        //row selection
        rowSelectionState: rowSelectionState,
        setRowSelection: setRowSelection,
        selectedRowsState: selectedRowsState,
        //column visibility
        columnVisibilityState: columnVisibilityState,
        setColumnVisibility: setColumnVisibility,
        toggleColumnVisibility: toggleColumnVisibility,
        // sorting
        sortingState: sortingState,
        setSorting: setSorting,
        // column order
        columnOrderState: columnOrderState,
        setColumnOrder: setColumnOrder,
        handleChangeColumnOrder: handleChangeColumnOrder,
        // columnList
        columnListState: columnListState,
        setColumnList: setColumnList,
        // column sizing
        initColumnSizing: initColumnSizing,
        setColumnSizing: handleChangeColumnSizing,
        columnSizing: persistSizingColumn,
        resetColumnSizing: resetColumnSizing,
        // column grouping
        columnGroupBy: columnGroupBy,
        columnGroupingState: columnGroupingState,
        setColumnGroupBy: setColumnGroupBy,
        resetColumnGroupBy: resetColumnGroupBy,
        columnGroupByList: columnGroupByList
      },
      pagination: {
        pageSize: pageSize,
        setPageSize: setPageSize
      }
    }
  }, children);
};

function sortListToMap(list) {
  return list.reduce(function (map, columnSort) {
    var key = columnSort.id;

    if (!map[key]) {
      map[key] = null;
    }

    map[key] = columnSort.desc ? Sort.DESC : Sort.ASC;
    return map;
  }, {});
}

function sortMapToList(map) {
  return Object.keys(map).map(function (key) {
    return {
      id: key,
      desc: map[key] === Sort.DESC
    };
  });
}

var useTableViewContext = function useTableViewContext() {
  return useContext(TableContext);
};
function withTableContextProvider(Component) {
  return function WithContextProvider(props) {
    return /*#__PURE__*/React__default.createElement(TableViewProvider, null, /*#__PURE__*/React__default.createElement(Component, Object.assign({}, props)));
  };
}

var ActionBarProvider = function ActionBarProvider(_ref) {
  var children = _ref.children;
  var ctx = useTableViewContext();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children(ctx));
};

var ColumnGroupByToggler = function ColumnGroupByToggler(_ref) {
  var onGroupByChange = _ref.onGroupByChange,
      resetButton = _ref.resetButton;

  var _useTableViewContext = useTableViewContext(),
      columnGroupByList = _useTableViewContext.table.columnGroupByList;

  var _useState = useState([]),
      _useState2 = _slicedToArray$1(_useState, 2),
      columnList = _useState2[0],
      setColumnList = _useState2[1];

  useEffect(function () {
    setColumnList(columnGroupByList);
  }, [columnGroupByList]);

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$1(_useState3, 2),
      isDropdownVisible = _useState4[0],
      setIsDropdownVisible = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray$1(_useState5, 2),
      targetEl = _useState6[0],
      setTargetEl = _useState6[1];

  var theme = useThemeSafe();
  var styles = useStyles$d();
  var toggleVisible = useCallback(function () {
    setIsDropdownVisible(function (prev) {
      return !prev;
    });
  }, []);
  var resetBtn = useMemo(function () {
    if (resetButton) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: styles.resetWrapper,
        onClick: function onClick() {
          toggleVisible();
          onGroupByChange('');
        }
      }, resetButton);
    }

    return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Divider$1, {
      orientation: "horizontal",
      thickness: 1,
      color: theme.palette.background.color
    }), /*#__PURE__*/React__default.createElement(Button, {
      variant: "secondary",
      onClick: function onClick() {
        toggleVisible();
        onGroupByChange('');
      },
      className: styles.resetButton
    }, "Restore default"));
  }, [resetButton, onGroupByChange]);
  return /*#__PURE__*/React__default.createElement("div", {
    ref: setTargetEl
  }, /*#__PURE__*/React__default.createElement(ActionIcon, {
    iconName: "view-by",
    onClick: toggleVisible
  }), /*#__PURE__*/React__default.createElement(Popover, {
    onVisibilityChange: toggleVisible,
    visible: isDropdownVisible,
    target: targetEl,
    anchor: targetEl,
    placement: "bottom-end",
    className: styles.popover
  }, columnList.map(function (c) {
    return /*#__PURE__*/React__default.createElement(ActionIcon, {
      key: c.id,
      text: c.title,
      onClick: function onClick() {
        toggleVisible();
        onGroupByChange(c.id);
      },
      className: clsx([styles.sectionItem])
    });
  }), resetBtn));
};
var useStyles$d = createUseStyles(function (theme) {
  return {
    popover: {
      padding: 16,
      gap: 24
    },
    sectionItem: {
      width: '100%',
      height: 'unset',
      '& .CyoloUI-ActionIcon-Text': {
        marginLeft: 0
      }
    },
    resetButton: {
      padding: '8px !important',
      boxShadow: 'none !important',
      justifyContent: 'flex-start !important',
      height: 'auto !important',
      '& .CyoloUI-Text': {
        color: "".concat(theme.palette.primary.color, " !important")
      }
    },
    active: {
      color: "".concat(theme.palette.primary.extraDark, " !important"),
      '& .CyoloUI-ActionIcon-Text': {
        color: "".concat(theme.palette.primary.extraDark, " !important")
      }
    },
    resetWrapper: _defineProperty$1({
      display: 'flex',
      flex: 'auto 0 0',
      alignItems: 'center'
    }, '&:hover', {
      cursor: 'pointer'
    })
  };
});

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

var _ListCache = ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

var _stackClear = stackClear;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag$1 = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$1(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction$1;

/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];

var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$9 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty$7).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;

/* Built-in method references that are verified to be native. */
var Map$1 = _getNative(_root, 'Map');

var _Map = Map$1;

/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

var _nativeCreate = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }
  return hasOwnProperty$6.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$5.call(data, key);
}

var _hashHas = hashHas;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

var _Hash = Hash;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

var _mapCacheClear = mapCacheClear;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

var _MapCache = MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

var _Stack = Stack;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

var _setCacheAdd = setCacheAdd;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new _MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd;
SetCache.prototype.has = _setCacheHas;

var _SetCache = SetCache;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG$1) ? new _SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!_arraySome(other, function(othValue, othIndex) {
            if (!_cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays;

/** Built-in value references. */
var Uint8Array = _root.Uint8Array;

var _Uint8Array = Uint8Array;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag$1 = '[object Error]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$2 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$2:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag$1:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new _Uint8Array(object), new _Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag$1:
    case dateTag$1:
    case numberTag$1:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq_1(+object, +other);

    case errorTag$1:
      return object.name == other.name && object.message == other.message;

    case regexpTag$1:
    case stringTag$1:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag$2:
      var convert = _mapToArray;

    case setTag$2:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2;
      convert || (convert = _setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = _equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray$1 = Array.isArray;

var isArray_1 = isArray$1;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

var stubArray_1 = stubArray;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray_1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};

var _getSymbols = getSymbols;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag$2;
}

var _baseIsArguments = baseIsArguments;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$5.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return isObjectLike_1(value) && hasOwnProperty$4.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

var isArguments_1 = isArguments;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

var isBuffer_1 = createCommonjsModule$1(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse_1;

module.exports = isBuffer;
});

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

var isLength_1 = isLength;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag$1 = '[object Map]',
    numberTag = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag = '[object String]',
    weakMapTag$1 = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag$1] = typedArrayTags[numberTag] =
typedArrayTags[objectTag$2] = typedArrayTags[regexpTag] =
typedArrayTags[setTag$1] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag$1] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike_1(value) &&
    isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule$1(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
});

/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

var isTypedArray_1 = isTypedArray;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
      isArg = !isArr && isArguments_1(value),
      isBuff = !isArr && !isArg && isBuffer_1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$3.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$3;

  return value === proto;
}

var _isPrototype = isPrototype;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

var _nativeKeys = nativeKeys;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$2.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

var keys_1 = keys;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return _baseGetAllKeys(object, keys_1, _getSymbols);
}

var _getAllKeys = getAllKeys;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1,
      objProps = _getAllKeys(object),
      objLength = objProps.length,
      othProps = _getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$1.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects;

/* Built-in method references that are verified to be native. */
var DataView = _getNative(_root, 'DataView');

var _DataView = DataView;

/* Built-in method references that are verified to be native. */
var Promise$1 = _getNative(_root, 'Promise');

var _Promise = Promise$1;

/* Built-in method references that are verified to be native. */
var Set$1 = _getNative(_root, 'Set');

var _Set = Set$1;

/* Built-in method references that are verified to be native. */
var WeakMap = _getNative(_root, 'WeakMap');

var _WeakMap = WeakMap;

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$1 = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag$1(new _DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (_Map && getTag$1(new _Map) != mapTag) ||
    (_Promise && getTag$1(_Promise.resolve()) != promiseTag) ||
    (_Set && getTag$1(new _Set) != setTag) ||
    (_WeakMap && getTag$1(new _WeakMap) != weakMapTag)) {
  getTag$1 = function(value) {
    var result = _baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

var _getTag = getTag$1;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray_1(object),
      othIsArr = isArray_1(other),
      objTag = objIsArr ? arrayTag : _getTag(object),
      othTag = othIsArr ? arrayTag : _getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer_1(object)) {
    if (!isBuffer_1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new _Stack);
    return (objIsArr || isTypedArray_1(object))
      ? _equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : _equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new _Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new _Stack);
  return _equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike_1(value) && !isObjectLike_1(other))) {
    return value !== value && other !== other;
  }
  return _baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

var _baseIsEqual = baseIsEqual;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return _baseIsEqual(value, other);
}

var isEqual_1 = isEqual;

var ColumnToggler = function ColumnToggler(_ref) {
  var _ref$defaultHiddenCol = _ref.defaultHiddenColumns,
      defaultHiddenColumns = _ref$defaultHiddenCol === void 0 ? [] : _ref$defaultHiddenCol;

  var _useTableViewContext = useTableViewContext(),
      _useTableViewContext$ = _useTableViewContext.table,
      columnVisibilityState = _useTableViewContext$.columnVisibilityState,
      columnOrderState = _useTableViewContext$.columnOrderState,
      columnListState = _useTableViewContext$.columnListState,
      handleChangeColumnOrder = _useTableViewContext$.handleChangeColumnOrder,
      toggleColumnVisibility = _useTableViewContext$.toggleColumnVisibility,
      setColumnVisibility = _useTableViewContext$.setColumnVisibility,
      setColumnOrder = _useTableViewContext$.setColumnOrder,
      resetColumnSizing = _useTableViewContext$.resetColumnSizing;

  var theme = useThemeSafe();
  var styles = useStyles$c({
    theme: theme
  });

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1]; // reference needed for popper


  var _useState3 = useState(null),
      _useState4 = _slicedToArray$1(_useState3, 2),
      referenceElement = _useState4[0],
      setReferenceElement = _useState4[1];

  var isVisibilityEmpty = !Object.keys(columnVisibilityState).length;

  var hideDefaultColumns = function hideDefaultColumns() {
    var initState = {};
    setColumnVisibility(defaultHiddenColumns.reduce(function (newState, column) {
      newState[column] = false;
      return newState;
    }, initState));
  };

  useEffect(function () {
    if (!isVisibilityEmpty) {
      return;
    }

    if (!defaultHiddenColumns.length) {
      return;
    }

    hideDefaultColumns();
  }, [columnVisibilityState, defaultHiddenColumns]);
  var visibilityChange = useCallback(function (isVisible) {
    setVisible(isVisible);
  }, []);
  var sortedColumns = useMemo(function () {
    return _toConsumableArray$1(columnListState).sort(function (a, b) {
      return columnOrderState.indexOf(a.accessor) - columnOrderState.indexOf(b.accessor);
    });
  }, [columnListState, columnOrderState]);

  var _useDropdownPopper = useDropdownPopper$1({
    visible: visible,
    parentRefElement: referenceElement,
    onVisibilityChange: visibilityChange,
    placement: 'bottom-end',
    sameWidth: false
  }),
      attributes = _useDropdownPopper.attributes,
      setPopperElement = _useDropdownPopper.setPopperElement,
      popperStyles = _useDropdownPopper.styles;

  var handleButtonClick = useCallback(function (e) {
    e.preventDefault();
    setVisible(function (prev) {
      return !prev;
    });
  }, []);
  var defaultColumnOrder = [SYSTEM_CHECKBOX_ID].concat(_toConsumableArray$1(columnListState.map(function (column) {
    return column.accessor;
  })));
  var hiddenItems = Object.entries(columnVisibilityState).filter(function (_ref2) {
    var _ref3 = _slicedToArray$1(_ref2, 2),
        isVisible = _ref3[1];

    return !isVisible;
  }).map(function (_ref4) {
    var _ref5 = _slicedToArray$1(_ref4, 1),
        accessor = _ref5[0];

    return accessor;
  });
  var areThereAnyChanges = !isEqual_1(hiddenItems, defaultHiddenColumns) || !isEqual_1(columnOrderState, defaultColumnOrder);

  var getIsVisible = function getIsVisible(accessor) {
    var isInObjectState = columnVisibilityState.hasOwnProperty(accessor);

    if (isInObjectState) {
      return columnVisibilityState[accessor];
    }

    return true;
  };

  var handleRestore = function handleRestore() {
    hideDefaultColumns();
    setColumnOrder(defaultColumnOrder);
    resetColumnSizing();
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: styles.buttonWrapper,
    ref: setReferenceElement
  }, /*#__PURE__*/React__default.createElement("button", {
    onClick: handleButtonClick,
    className: styles.button
  }, /*#__PURE__*/React__default.createElement(Icon, {
    id: "columns"
  })), areThereAnyChanges && /*#__PURE__*/React__default.createElement("div", {
    className: styles.activeDot
  })), visible && /*#__PURE__*/createPortal( /*#__PURE__*/React__default.createElement("div", Object.assign({
    className: styles.card,
    style: popperStyles.popper,
    ref: setPopperElement
  }, attributes.popper), /*#__PURE__*/React__default.createElement("div", {
    className: styles.list
  }, sortedColumns.map(function (column, index, list) {
    var _a;

    return /*#__PURE__*/React__default.createElement("div", {
      key: (_a = column.accessor) !== null && _a !== void 0 ? _a : index,
      className: styles.listItem
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles.arrows
    }, /*#__PURE__*/React__default.createElement(IconButton, {
      iconID: "arrow_up",
      size: 12,
      key: index,
      disabled: index === 0,
      className: styles.sortButton,
      onClick: function onClick() {
        return handleChangeColumnOrder(column.accessor, list[index - 1].accessor);
      }
    }), /*#__PURE__*/React__default.createElement(IconButton, {
      iconID: "arrow_down",
      size: 12,
      disabled: index >= list.length - 1,
      className: styles.sortButton,
      onClick: function onClick() {
        return handleChangeColumnOrder(column.accessor, list[index + 1].accessor);
      }
    })), /*#__PURE__*/React__default.createElement("label", {
      className: styles.checkboxItem
    }, /*#__PURE__*/React__default.createElement("input", {
      className: styles.checkbox,
      type: "checkbox",
      checked: getIsVisible(column.accessor),
      onChange: function onChange() {
        toggleColumnVisibility(column.accessor);
      }
    }), /*#__PURE__*/React__default.createElement(Text$1, {
      variant: "body",
      color: theme.palette.grey.color
    }, column.title || column.accessor)));
  })), /*#__PURE__*/React__default.createElement("div", {
    className: styles.bottomPart
  }, /*#__PURE__*/React__default.createElement(Divider$1, {
    orientation: "horizontal",
    thickness: 1,
    color: theme.palette.background.color
  }), /*#__PURE__*/React__default.createElement(Button, {
    variant: "secondary",
    className: styles.restoreButton,
    onClick: handleRestore
  }, "Restore default"))), document.body));
};
var useStyles$c = createUseStyles(function (theme) {
  var _sortButton;

  return {
    card: {
      backgroundColor: theme.palette.white.color,
      borderRadius: theme.shape.borderRadiusLight,
      padding: 8,
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
      boxShadow: "".concat(theme.shadows[1], ", ").concat(theme.shadows[0]),
      zIndex: theme.zIndex.medium
    },
    list: {
      display: 'flex',
      flexDirection: 'column',
      maxHeight: 320,
      overflow: 'auto'
    },
    listItem: {
      display: 'flex',
      gap: 8,
      padding: 8
    },
    checkboxItem: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      cursor: 'pointer'
    },
    checkbox: {
      margin: 0
    },
    buttonWrapper: {
      position: 'relative'
    },
    button: {
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 4,
      backgroundColor: theme.palette.white.color,
      border: 'none',
      borderRadius: theme.shape.borderRadiusLight,
      boxShadow: theme.shadows[1]
    },
    activeDot: {
      position: 'absolute',
      background: theme.palette.primary.color,
      width: 8,
      height: 8,
      borderRadius: '50%',
      top: -2,
      left: -1
    },
    arrows: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    },
    sortButton: (_sortButton = {
      opacity: 0.2,
      width: '8px !important',
      height: '8px !important',
      transition: theme.transitions.fast
    }, _defineProperty$1(_sortButton, '&:not([disabled]):hover', {
      opacity: '0.8 !important'
    }), _defineProperty$1(_sortButton, '&:not([disabled]):active', {
      opacity: '0.6 !important'
    }), _sortButton),
    bottomPart: {
      display: 'flex',
      flexDirection: 'column'
    },
    restoreButton: {
      padding: '8px !important',
      boxShadow: 'none !important',
      justifyContent: 'flex-start !important',
      height: 'auto !important',
      '& .CyoloUI-Text': {
        color: "".concat(theme.palette.primary.color, " !important")
      }
    }
  };
});

/**
 *
 * @param currentData the data subset that is being used to filter-by
 * @param enableFreeSearch flag to enable free typing global search
 * @param onChange trigger call on each valid filter change. @function (query: NonApiQueryPart[]) => void
 * @function nonApiFilter should be used in state-store as a helper for filtring data
 * @type NonApiQueryPart
 */

var TViewQueryBuilder = function TViewQueryBuilder(_ref) {
  var handleChange = _ref.onChange,
      currentData = _ref.currentData,
      _ref$enableFreeSearch = _ref.enableFreeSearch,
      enableFreeSearch = _ref$enableFreeSearch === void 0 ? true : _ref$enableFreeSearch,
      onValueInputChange = _ref.onValueInputChange;
  // sync with ctx:
  var viewCtx = useTableViewContext();

  var _useState = useState([]),
      _useState2 = _slicedToArray$1(_useState, 2),
      suggestions = _useState2[0],
      setSuggestions = _useState2[1];

  var handleValueSuggestionFeed = useCallback(function (q) {
    var suggestions = nonApiSuggestions(q[0], currentData);
    setSuggestions(suggestions);
  }, [currentData]);
  var SuggestionFeedDebounceMS = 300;
  var handleValueSuggestionFeedDebounce = useDebounce(function () {
    var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    handleValueSuggestionFeed(query);
  }, SuggestionFeedDebounceMS, [handleValueSuggestionFeed]); // don't call query build until we have columns

  if (!viewCtx.searchQuery.keyNameList.length) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement(QueryBuilderSearch, {
    keyNameList: viewCtx.searchQuery.keyNameList,
    valueSuggestionList: suggestions,
    onValueSuggestionFeed: handleValueSuggestionFeedDebounce,
    onChange: handleChange,
    resolver: nonApiResolver,
    placeholder: "Search",
    enableFreeSearch: enableFreeSearch,
    addPartsListener: viewCtx.searchQuery.submitFilterRef,
    onValueInputChange: onValueInputChange,
    syncUrl: true
  });
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var props = ['bottom', 'height', 'left', 'right', 'top', 'width'];

var rectChanged = function rectChanged(a, b) {
  if (a === void 0) {
    a = {};
  }

  if (b === void 0) {
    b = {};
  }

  return props.some(function (prop) {
    return a[prop] !== b[prop];
  });
};

var observedNodes = /*#__PURE__*/new Map();
var rafId;

var run = function run() {
  var changedStates = [];
  observedNodes.forEach(function (state, node) {
    var newRect = node.getBoundingClientRect();

    if (rectChanged(newRect, state.rect)) {
      state.rect = newRect;
      changedStates.push(state);
    }
  });
  changedStates.forEach(function (state) {
    state.callbacks.forEach(function (cb) {
      return cb(state.rect);
    });
  });
  rafId = window.requestAnimationFrame(run);
};

function observeRect(node, cb) {
  return {
    observe: function observe() {
      var wasEmpty = observedNodes.size === 0;

      if (observedNodes.has(node)) {
        observedNodes.get(node).callbacks.push(cb);
      } else {
        observedNodes.set(node, {
          rect: undefined,
          hasRectChanged: false,
          callbacks: [cb]
        });
      }

      if (wasEmpty) run();
    },
    unobserve: function unobserve() {
      var state = observedNodes.get(node);

      if (state) {
        // Remove the callback
        var index = state.callbacks.indexOf(cb);
        if (index >= 0) state.callbacks.splice(index, 1); // Remove the node reference

        if (!state.callbacks.length) observedNodes["delete"](node); // Stop the loop

        if (!observedNodes.size) cancelAnimationFrame(rafId);
      }
    }
  };
}

var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? React__default.useLayoutEffect : React__default.useEffect;

function useRect(nodeRef, initialRect) {
  if (initialRect === void 0) {
    initialRect = {
      width: 0,
      height: 0
    };
  }

  var _React$useState = React__default.useState(nodeRef.current),
      element = _React$useState[0],
      setElement = _React$useState[1];

  var _React$useReducer = React__default.useReducer(rectReducer, initialRect),
      rect = _React$useReducer[0],
      dispatch = _React$useReducer[1];

  var initialRectSet = React__default.useRef(false);
  useIsomorphicLayoutEffect(function () {
    if (nodeRef.current !== element) {
      setElement(nodeRef.current);
    }
  });
  useIsomorphicLayoutEffect(function () {
    if (element && !initialRectSet.current) {
      initialRectSet.current = true;

      var _rect = element.getBoundingClientRect();

      dispatch({
        rect: _rect
      });
    }
  }, [element]);
  React__default.useEffect(function () {
    if (!element) {
      return;
    }

    var observer = observeRect(element, function (rect) {
      dispatch({
        rect: rect
      });
    });
    observer.observe();
    return function () {
      observer.unobserve();
    };
  }, [element]);
  return rect;
}

function rectReducer(state, action) {
  var rect = action.rect;

  if (state.height !== rect.height || state.width !== rect.width) {
    return rect;
  }

  return state;
}

var defaultEstimateSize = function defaultEstimateSize() {
  return 50;
};

var defaultKeyExtractor = function defaultKeyExtractor(index) {
  return index;
};

var defaultMeasureSize = function defaultMeasureSize(el, horizontal) {
  var key = horizontal ? 'offsetWidth' : 'offsetHeight';
  return el[key];
};

var defaultRangeExtractor = function defaultRangeExtractor(range) {
  var start = Math.max(range.start - range.overscan, 0);
  var end = Math.min(range.end + range.overscan, range.size - 1);
  var arr = [];

  for (var i = start; i <= end; i++) {
    arr.push(i);
  }

  return arr;
};
function useVirtual(_ref) {
  var _measurements;

  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 0 : _ref$size,
      _ref$estimateSize = _ref.estimateSize,
      estimateSize = _ref$estimateSize === void 0 ? defaultEstimateSize : _ref$estimateSize,
      _ref$overscan = _ref.overscan,
      overscan = _ref$overscan === void 0 ? 1 : _ref$overscan,
      _ref$paddingStart = _ref.paddingStart,
      paddingStart = _ref$paddingStart === void 0 ? 0 : _ref$paddingStart,
      _ref$paddingEnd = _ref.paddingEnd,
      paddingEnd = _ref$paddingEnd === void 0 ? 0 : _ref$paddingEnd,
      parentRef = _ref.parentRef,
      horizontal = _ref.horizontal,
      scrollToFn = _ref.scrollToFn,
      useObserver = _ref.useObserver,
      initialRect = _ref.initialRect,
      onScrollElement = _ref.onScrollElement,
      scrollOffsetFn = _ref.scrollOffsetFn,
      _ref$keyExtractor = _ref.keyExtractor,
      keyExtractor = _ref$keyExtractor === void 0 ? defaultKeyExtractor : _ref$keyExtractor,
      _ref$measureSize = _ref.measureSize,
      measureSize = _ref$measureSize === void 0 ? defaultMeasureSize : _ref$measureSize,
      _ref$rangeExtractor = _ref.rangeExtractor,
      rangeExtractor = _ref$rangeExtractor === void 0 ? defaultRangeExtractor : _ref$rangeExtractor;
  var sizeKey = horizontal ? 'width' : 'height';
  var scrollKey = horizontal ? 'scrollLeft' : 'scrollTop';
  var latestRef = React__default.useRef({
    scrollOffset: 0,
    measurements: []
  });

  var _React$useState = React__default.useState(0),
      scrollOffset = _React$useState[0],
      setScrollOffset = _React$useState[1];

  latestRef.current.scrollOffset = scrollOffset;
  var useMeasureParent = useObserver || useRect;

  var _useMeasureParent = useMeasureParent(parentRef, initialRect),
      outerSize = _useMeasureParent[sizeKey];

  latestRef.current.outerSize = outerSize;
  var defaultScrollToFn = React__default.useCallback(function (offset) {
    if (parentRef.current) {
      parentRef.current[scrollKey] = offset;
    }
  }, [parentRef, scrollKey]);
  var resolvedScrollToFn = scrollToFn || defaultScrollToFn;
  scrollToFn = React__default.useCallback(function (offset) {
    resolvedScrollToFn(offset, defaultScrollToFn);
  }, [defaultScrollToFn, resolvedScrollToFn]);

  var _React$useState2 = React__default.useState({}),
      measuredCache = _React$useState2[0],
      setMeasuredCache = _React$useState2[1];

  var measure = React__default.useCallback(function () {
    return setMeasuredCache({});
  }, []);
  var pendingMeasuredCacheIndexesRef = React__default.useRef([]);
  var measurements = React__default.useMemo(function () {
    var min = pendingMeasuredCacheIndexesRef.current.length > 0 ? Math.min.apply(Math, pendingMeasuredCacheIndexesRef.current) : 0;
    pendingMeasuredCacheIndexesRef.current = [];
    var measurements = latestRef.current.measurements.slice(0, min);

    for (var i = min; i < size; i++) {
      var key = keyExtractor(i);
      var measuredSize = measuredCache[key];

      var _start = measurements[i - 1] ? measurements[i - 1].end : paddingStart;

      var _size = typeof measuredSize === 'number' ? measuredSize : estimateSize(i);

      var _end = _start + _size;

      measurements[i] = {
        index: i,
        start: _start,
        size: _size,
        end: _end,
        key: key
      };
    }

    return measurements;
  }, [estimateSize, measuredCache, paddingStart, size, keyExtractor]);
  var totalSize = (((_measurements = measurements[size - 1]) == null ? void 0 : _measurements.end) || paddingStart) + paddingEnd;
  latestRef.current.measurements = measurements;
  latestRef.current.totalSize = totalSize;
  var element = onScrollElement ? onScrollElement.current : parentRef.current;
  var scrollOffsetFnRef = React__default.useRef(scrollOffsetFn);
  scrollOffsetFnRef.current = scrollOffsetFn;
  useIsomorphicLayoutEffect(function () {
    if (!element) {
      setScrollOffset(0);
      return;
    }

    var onScroll = function onScroll(event) {
      var offset = scrollOffsetFnRef.current ? scrollOffsetFnRef.current(event) : element[scrollKey];
      setScrollOffset(offset);
    };

    onScroll();
    element.addEventListener('scroll', onScroll, {
      capture: false,
      passive: true
    });
    return function () {
      element.removeEventListener('scroll', onScroll);
    };
  }, [element, scrollKey]);

  var _calculateRange = calculateRange(latestRef.current),
      start = _calculateRange.start,
      end = _calculateRange.end;

  var indexes = React__default.useMemo(function () {
    return rangeExtractor({
      start: start,
      end: end,
      overscan: overscan,
      size: measurements.length
    });
  }, [start, end, overscan, measurements.length, rangeExtractor]);
  var measureSizeRef = React__default.useRef(measureSize);
  measureSizeRef.current = measureSize;
  var virtualItems = React__default.useMemo(function () {
    var virtualItems = [];

    var _loop = function _loop(k, len) {
      var i = indexes[k];
      var measurement = measurements[i];

      var item = _extends(_extends({}, measurement), {}, {
        measureRef: function measureRef(el) {
          if (el) {
            var measuredSize = measureSizeRef.current(el, horizontal);

            if (measuredSize !== item.size) {
              var _scrollOffset = latestRef.current.scrollOffset;

              if (item.start < _scrollOffset) {
                defaultScrollToFn(_scrollOffset + (measuredSize - item.size));
              }

              pendingMeasuredCacheIndexesRef.current.push(i);
              setMeasuredCache(function (old) {
                var _extends2;

                return _extends(_extends({}, old), {}, (_extends2 = {}, _extends2[item.key] = measuredSize, _extends2));
              });
            }
          }
        }
      });

      virtualItems.push(item);
    };

    for (var k = 0, len = indexes.length; k < len; k++) {
      _loop(k);
    }

    return virtualItems;
  }, [indexes, defaultScrollToFn, horizontal, measurements]);
  var mountedRef = React__default.useRef(false);
  useIsomorphicLayoutEffect(function () {
    if (mountedRef.current) {
      setMeasuredCache({});
    }

    mountedRef.current = true;
  }, [estimateSize]);
  var scrollToOffset = React__default.useCallback(function (toOffset, _temp) {
    var _ref2 = _temp === void 0 ? {} : _temp,
        _ref2$align = _ref2.align,
        align = _ref2$align === void 0 ? 'start' : _ref2$align;

    var _latestRef$current = latestRef.current,
        scrollOffset = _latestRef$current.scrollOffset,
        outerSize = _latestRef$current.outerSize;

    if (align === 'auto') {
      if (toOffset <= scrollOffset) {
        align = 'start';
      } else if (toOffset >= scrollOffset + outerSize) {
        align = 'end';
      } else {
        align = 'start';
      }
    }

    if (align === 'start') {
      scrollToFn(toOffset);
    } else if (align === 'end') {
      scrollToFn(toOffset - outerSize);
    } else if (align === 'center') {
      scrollToFn(toOffset - outerSize / 2);
    }
  }, [scrollToFn]);
  var tryScrollToIndex = React__default.useCallback(function (index, _temp2) {
    var _ref3 = _temp2 === void 0 ? {} : _temp2,
        _ref3$align = _ref3.align,
        align = _ref3$align === void 0 ? 'auto' : _ref3$align,
        rest = _objectWithoutPropertiesLoose(_ref3, ["align"]);

    var _latestRef$current2 = latestRef.current,
        measurements = _latestRef$current2.measurements,
        scrollOffset = _latestRef$current2.scrollOffset,
        outerSize = _latestRef$current2.outerSize;
    var measurement = measurements[Math.max(0, Math.min(index, size - 1))];

    if (!measurement) {
      return;
    }

    if (align === 'auto') {
      if (measurement.end >= scrollOffset + outerSize) {
        align = 'end';
      } else if (measurement.start <= scrollOffset) {
        align = 'start';
      } else {
        return;
      }
    }

    var toOffset = align === 'center' ? measurement.start + measurement.size / 2 : align === 'end' ? measurement.end : measurement.start;
    scrollToOffset(toOffset, _extends({
      align: align
    }, rest));
  }, [scrollToOffset, size]);
  var scrollToIndex = React__default.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // We do a double request here because of
    // dynamic sizes which can cause offset shift
    // and end up in the wrong spot. Unfortunately,
    // we can't know about those dynamic sizes until
    // we try and render them. So double down!
    tryScrollToIndex.apply(void 0, args);
    requestAnimationFrame(function () {
      tryScrollToIndex.apply(void 0, args);
    });
  }, [tryScrollToIndex]);
  return {
    virtualItems: virtualItems,
    totalSize: totalSize,
    scrollToOffset: scrollToOffset,
    scrollToIndex: scrollToIndex,
    measure: measure
  };
}

var findNearestBinarySearch = function findNearestBinarySearch(low, high, getCurrentValue, value) {
  while (low <= high) {
    var middle = (low + high) / 2 | 0;
    var currentValue = getCurrentValue(middle);

    if (currentValue < value) {
      low = middle + 1;
    } else if (currentValue > value) {
      high = middle - 1;
    } else {
      return middle;
    }
  }

  if (low > 0) {
    return low - 1;
  } else {
    return 0;
  }
};

function calculateRange(_ref4) {
  var measurements = _ref4.measurements,
      outerSize = _ref4.outerSize,
      scrollOffset = _ref4.scrollOffset;
  var size = measurements.length - 1;

  var getOffset = function getOffset(index) {
    return measurements[index].start;
  };

  var start = findNearestBinarySearch(0, size, getOffset, scrollOffset);
  var end = start;

  while (end < size && measurements[end].end < scrollOffset + outerSize) {
    end++;
  }

  return {
    start: start,
    end: end
  };
}

/**
 * react-table
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */

/**
 * table-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
// Is this type a tuple?
// If this type is a tuple, what indices are allowed?
///
function functionalUpdate(updater, input) {
  return typeof updater === 'function' ? updater(input) : updater;
}
function makeStateUpdater(key, instance) {
  return updater => {
    instance.setState(old => {
      return { ...old,
        [key]: functionalUpdate(updater, old[key])
      };
    });
  };
}
function isFunction(d) {
  return d instanceof Function;
}
function flattenBy(arr, getChildren) {
  const flat = [];

  const recurse = subArr => {
    subArr.forEach(item => {
      flat.push(item);
      const children = getChildren(item);

      if (children != null && children.length) {
        recurse(children);
      }
    });
  };

  recurse(arr);
  return flat;
}
function memo(getDeps, fn, opts) {
  let deps = [];
  let result;
  return () => {
    let depTime;
    if (opts.key && opts.debug) depTime = Date.now();
    const newDeps = getDeps();
    const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index) => deps[index] !== dep);

    if (!depsChanged) {
      return result;
    }

    deps = newDeps;
    let resultTime;
    if (opts.key && opts.debug) resultTime = Date.now();
    result = fn(...newDeps);
    opts == null ? void 0 : opts.onChange == null ? void 0 : opts.onChange(result);

    if (opts.key && opts.debug) {
      if (opts != null && opts.debug()) {
        const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
        const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
        const resultFpsPercentage = resultEndTime / 16;

        const pad = (str, num) => {
          str = String(str);

          while (str.length < num) {
            str = ' ' + str;
          }

          return str;
        };

        console.info("%c\u23F1 " + pad(resultEndTime, 5) + " /" + pad(depEndTime, 5) + " ms", "\n            font-size: .6rem;\n            font-weight: bold;\n            color: hsl(" + Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120)) + "deg 100% 31%);", opts == null ? void 0 : opts.key);
      }
    }

    return result;
  };
}

function createColumn(table, columnDef, depth, parent) {
  var _ref, _resolvedColumnDef$id;

  const defaultColumn = table._getDefaultColumnDef();

  const resolvedColumnDef = { ...defaultColumn,
    ...columnDef
  };
  const accessorKey = resolvedColumnDef.accessorKey;
  let id = (_ref = (_resolvedColumnDef$id = resolvedColumnDef.id) != null ? _resolvedColumnDef$id : accessorKey ? accessorKey.replace('.', '_') : undefined) != null ? _ref : typeof resolvedColumnDef.header === 'string' ? resolvedColumnDef.header : undefined;
  let accessorFn;

  if (resolvedColumnDef.accessorFn) {
    accessorFn = resolvedColumnDef.accessorFn;
  } else if (accessorKey) {
    // Support deep accessor keys
    if (accessorKey.includes('.')) {
      accessorFn = originalRow => {
        let result = originalRow;

        for (const key of accessorKey.split('.')) {
          result = result[key];
        }

        return result;
      };
    } else {
      accessorFn = originalRow => originalRow[resolvedColumnDef.accessorKey];
    }
  }

  if (!id) {
    if (process.env.NODE_ENV !== 'production') {
      throw new Error(resolvedColumnDef.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header");
    }

    throw new Error();
  }

  let column = {
    id: "" + String(id),
    accessorFn,
    parent: parent,
    depth,
    columnDef: resolvedColumnDef,
    columns: [],
    getFlatColumns: memo(() => [true], () => {
      var _column$columns;

      return [column, ...((_column$columns = column.columns) == null ? void 0 : _column$columns.flatMap(d => d.getFlatColumns()))];
    }, {
      key: process.env.NODE_ENV === 'production' && 'column.getFlatColumns',
      debug: () => {
        var _table$options$debugA;

        return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugColumns;
      }
    }),
    getLeafColumns: memo(() => [table._getOrderColumnsFn()], orderColumns => {
      var _column$columns2;

      if ((_column$columns2 = column.columns) != null && _column$columns2.length) {
        let leafColumns = column.columns.flatMap(column => column.getLeafColumns());
        return orderColumns(leafColumns);
      }

      return [column];
    }, {
      key: process.env.NODE_ENV === 'production' && 'column.getLeafColumns',
      debug: () => {
        var _table$options$debugA2;

        return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugColumns;
      }
    })
  };
  column = table._features.reduce((obj, feature) => {
    return Object.assign(obj, feature.createColumn == null ? void 0 : feature.createColumn(column, table));
  }, column); // Yes, we have to convert table to uknown, because we know more than the compiler here.

  return column;
}

//
function createHeader(table, column, options) {
  var _options$id;

  const id = (_options$id = options.id) != null ? _options$id : column.id;
  let header = {
    id,
    column,
    index: options.index,
    isPlaceholder: !!options.isPlaceholder,
    placeholderId: options.placeholderId,
    depth: options.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const leafHeaders = [];

      const recurseHeader = h => {
        if (h.subHeaders && h.subHeaders.length) {
          h.subHeaders.map(recurseHeader);
        }

        leafHeaders.push(h);
      };

      recurseHeader(header);
      return leafHeaders;
    },
    getContext: () => ({
      table,
      header: header,
      column
    })
  };

  table._features.forEach(feature => {
    Object.assign(header, feature.createHeader == null ? void 0 : feature.createHeader(header, table));
  });

  return header;
}

const Headers = {
  createTable: table => {
    return {
      // Header Groups
      getHeaderGroups: memo(() => [table.getAllColumns(), table.getVisibleLeafColumns(), table.getState().columnPinning.left, table.getState().columnPinning.right], (allColumns, leafColumns, left, right) => {
        var _left$map$filter, _right$map$filter;

        const leftColumns = (_left$map$filter = left == null ? void 0 : left.map(columnId => leafColumns.find(d => d.id === columnId)).filter(Boolean)) != null ? _left$map$filter : [];
        const rightColumns = (_right$map$filter = right == null ? void 0 : right.map(columnId => leafColumns.find(d => d.id === columnId)).filter(Boolean)) != null ? _right$map$filter : [];
        const centerColumns = leafColumns.filter(column => !(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
        const headerGroups = buildHeaderGroups(allColumns, [...leftColumns, ...centerColumns, ...rightColumns], table);
        return headerGroups;
      }, {
        key: process.env.NODE_ENV === 'development' && 'getHeaderGroups',
        debug: () => {
          var _table$options$debugA;

          return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugHeaders;
        }
      }),
      getCenterHeaderGroups: memo(() => [table.getAllColumns(), table.getVisibleLeafColumns(), table.getState().columnPinning.left, table.getState().columnPinning.right], (allColumns, leafColumns, left, right) => {
        leafColumns = leafColumns.filter(column => !(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
        return buildHeaderGroups(allColumns, leafColumns, table, 'center');
      }, {
        key: process.env.NODE_ENV === 'development' && 'getCenterHeaderGroups',
        debug: () => {
          var _table$options$debugA2;

          return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugHeaders;
        }
      }),
      getLeftHeaderGroups: memo(() => [table.getAllColumns(), table.getVisibleLeafColumns(), table.getState().columnPinning.left], (allColumns, leafColumns, left) => {
        var _left$map$filter2;

        const orderedLeafColumns = (_left$map$filter2 = left == null ? void 0 : left.map(columnId => leafColumns.find(d => d.id === columnId)).filter(Boolean)) != null ? _left$map$filter2 : [];
        return buildHeaderGroups(allColumns, orderedLeafColumns, table, 'left');
      }, {
        key: process.env.NODE_ENV === 'development' && 'getLeftHeaderGroups',
        debug: () => {
          var _table$options$debugA3;

          return (_table$options$debugA3 = table.options.debugAll) != null ? _table$options$debugA3 : table.options.debugHeaders;
        }
      }),
      getRightHeaderGroups: memo(() => [table.getAllColumns(), table.getVisibleLeafColumns(), table.getState().columnPinning.right], (allColumns, leafColumns, right) => {
        var _right$map$filter2;

        const orderedLeafColumns = (_right$map$filter2 = right == null ? void 0 : right.map(columnId => leafColumns.find(d => d.id === columnId)).filter(Boolean)) != null ? _right$map$filter2 : [];
        return buildHeaderGroups(allColumns, orderedLeafColumns, table, 'right');
      }, {
        key: process.env.NODE_ENV === 'development' && 'getRightHeaderGroups',
        debug: () => {
          var _table$options$debugA4;

          return (_table$options$debugA4 = table.options.debugAll) != null ? _table$options$debugA4 : table.options.debugHeaders;
        }
      }),
      // Footer Groups
      getFooterGroups: memo(() => [table.getHeaderGroups()], headerGroups => {
        return [...headerGroups].reverse();
      }, {
        key: process.env.NODE_ENV === 'development' && 'getFooterGroups',
        debug: () => {
          var _table$options$debugA5;

          return (_table$options$debugA5 = table.options.debugAll) != null ? _table$options$debugA5 : table.options.debugHeaders;
        }
      }),
      getLeftFooterGroups: memo(() => [table.getLeftHeaderGroups()], headerGroups => {
        return [...headerGroups].reverse();
      }, {
        key: process.env.NODE_ENV === 'development' && 'getLeftFooterGroups',
        debug: () => {
          var _table$options$debugA6;

          return (_table$options$debugA6 = table.options.debugAll) != null ? _table$options$debugA6 : table.options.debugHeaders;
        }
      }),
      getCenterFooterGroups: memo(() => [table.getCenterHeaderGroups()], headerGroups => {
        return [...headerGroups].reverse();
      }, {
        key: process.env.NODE_ENV === 'development' && 'getCenterFooterGroups',
        debug: () => {
          var _table$options$debugA7;

          return (_table$options$debugA7 = table.options.debugAll) != null ? _table$options$debugA7 : table.options.debugHeaders;
        }
      }),
      getRightFooterGroups: memo(() => [table.getRightHeaderGroups()], headerGroups => {
        return [...headerGroups].reverse();
      }, {
        key: process.env.NODE_ENV === 'development' && 'getRightFooterGroups',
        debug: () => {
          var _table$options$debugA8;

          return (_table$options$debugA8 = table.options.debugAll) != null ? _table$options$debugA8 : table.options.debugHeaders;
        }
      }),
      // Flat Headers
      getFlatHeaders: memo(() => [table.getHeaderGroups()], headerGroups => {
        return headerGroups.map(headerGroup => {
          return headerGroup.headers;
        }).flat();
      }, {
        key: process.env.NODE_ENV === 'development' && 'getFlatHeaders',
        debug: () => {
          var _table$options$debugA9;

          return (_table$options$debugA9 = table.options.debugAll) != null ? _table$options$debugA9 : table.options.debugHeaders;
        }
      }),
      getLeftFlatHeaders: memo(() => [table.getLeftHeaderGroups()], left => {
        return left.map(headerGroup => {
          return headerGroup.headers;
        }).flat();
      }, {
        key: process.env.NODE_ENV === 'development' && 'getLeftFlatHeaders',
        debug: () => {
          var _table$options$debugA10;

          return (_table$options$debugA10 = table.options.debugAll) != null ? _table$options$debugA10 : table.options.debugHeaders;
        }
      }),
      getCenterFlatHeaders: memo(() => [table.getCenterHeaderGroups()], left => {
        return left.map(headerGroup => {
          return headerGroup.headers;
        }).flat();
      }, {
        key: process.env.NODE_ENV === 'development' && 'getCenterFlatHeaders',
        debug: () => {
          var _table$options$debugA11;

          return (_table$options$debugA11 = table.options.debugAll) != null ? _table$options$debugA11 : table.options.debugHeaders;
        }
      }),
      getRightFlatHeaders: memo(() => [table.getRightHeaderGroups()], left => {
        return left.map(headerGroup => {
          return headerGroup.headers;
        }).flat();
      }, {
        key: process.env.NODE_ENV === 'development' && 'getRightFlatHeaders',
        debug: () => {
          var _table$options$debugA12;

          return (_table$options$debugA12 = table.options.debugAll) != null ? _table$options$debugA12 : table.options.debugHeaders;
        }
      }),
      // Leaf Headers
      getCenterLeafHeaders: memo(() => [table.getCenterFlatHeaders()], flatHeaders => {
        return flatHeaders.filter(header => {
          var _header$subHeaders;

          return !((_header$subHeaders = header.subHeaders) != null && _header$subHeaders.length);
        });
      }, {
        key: process.env.NODE_ENV === 'development' && 'getCenterLeafHeaders',
        debug: () => {
          var _table$options$debugA13;

          return (_table$options$debugA13 = table.options.debugAll) != null ? _table$options$debugA13 : table.options.debugHeaders;
        }
      }),
      getLeftLeafHeaders: memo(() => [table.getLeftFlatHeaders()], flatHeaders => {
        return flatHeaders.filter(header => {
          var _header$subHeaders2;

          return !((_header$subHeaders2 = header.subHeaders) != null && _header$subHeaders2.length);
        });
      }, {
        key: process.env.NODE_ENV === 'development' && 'getLeftLeafHeaders',
        debug: () => {
          var _table$options$debugA14;

          return (_table$options$debugA14 = table.options.debugAll) != null ? _table$options$debugA14 : table.options.debugHeaders;
        }
      }),
      getRightLeafHeaders: memo(() => [table.getRightFlatHeaders()], flatHeaders => {
        return flatHeaders.filter(header => {
          var _header$subHeaders3;

          return !((_header$subHeaders3 = header.subHeaders) != null && _header$subHeaders3.length);
        });
      }, {
        key: process.env.NODE_ENV === 'development' && 'getRightLeafHeaders',
        debug: () => {
          var _table$options$debugA15;

          return (_table$options$debugA15 = table.options.debugAll) != null ? _table$options$debugA15 : table.options.debugHeaders;
        }
      }),
      getLeafHeaders: memo(() => [table.getLeftHeaderGroups(), table.getCenterHeaderGroups(), table.getRightHeaderGroups()], (left, center, right) => {
        var _left$0$headers, _left$, _center$0$headers, _center$, _right$0$headers, _right$;

        return [...((_left$0$headers = (_left$ = left[0]) == null ? void 0 : _left$.headers) != null ? _left$0$headers : []), ...((_center$0$headers = (_center$ = center[0]) == null ? void 0 : _center$.headers) != null ? _center$0$headers : []), ...((_right$0$headers = (_right$ = right[0]) == null ? void 0 : _right$.headers) != null ? _right$0$headers : [])].map(header => {
          return header.getLeafHeaders();
        }).flat();
      }, {
        key: process.env.NODE_ENV === 'development' && 'getLeafHeaders',
        debug: () => {
          var _table$options$debugA16;

          return (_table$options$debugA16 = table.options.debugAll) != null ? _table$options$debugA16 : table.options.debugHeaders;
        }
      })
    };
  }
};
function buildHeaderGroups(allColumns, columnsToGroup, table, headerFamily) {
  var _headerGroups$0$heade, _headerGroups$;

  // Find the max depth of the columns:
  // build the leaf column row
  // build each buffer row going up
  //    placeholder for non-existent level
  //    real column for existing level
  let maxDepth = 0;

  const findMaxDepth = function (columns, depth) {
    if (depth === void 0) {
      depth = 1;
    }

    maxDepth = Math.max(maxDepth, depth);
    columns.filter(column => column.getIsVisible()).forEach(column => {
      var _column$columns;

      if ((_column$columns = column.columns) != null && _column$columns.length) {
        findMaxDepth(column.columns, depth + 1);
      }
    }, 0);
  };

  findMaxDepth(allColumns);
  let headerGroups = [];

  const createHeaderGroup = (headersToGroup, depth) => {
    // The header group we are creating
    const headerGroup = {
      depth,
      id: [headerFamily, "" + depth].filter(Boolean).join('_'),
      headers: []
    }; // The parent columns we're going to scan next

    const pendingParentHeaders = []; // Scan each column for parents

    headersToGroup.forEach(headerToGroup => {
      // What is the latest (last) parent column?
      const latestPendingParentHeader = [...pendingParentHeaders].reverse()[0];
      const isLeafHeader = headerToGroup.column.depth === headerGroup.depth;
      let column;
      let isPlaceholder = false;

      if (isLeafHeader && headerToGroup.column.parent) {
        // The parent header is new
        column = headerToGroup.column.parent;
      } else {
        // The parent header is repeated
        column = headerToGroup.column;
        isPlaceholder = true;
      }

      if (latestPendingParentHeader && (latestPendingParentHeader == null ? void 0 : latestPendingParentHeader.column) === column) {
        // This column is repeated. Add it as a sub header to the next batch
        latestPendingParentHeader.subHeaders.push(headerToGroup);
      } else {
        // This is a new header. Let's create it
        const header = createHeader(table, column, {
          id: [headerFamily, depth, column.id, headerToGroup == null ? void 0 : headerToGroup.id].filter(Boolean).join('_'),
          isPlaceholder,
          placeholderId: isPlaceholder ? "" + pendingParentHeaders.filter(d => d.column === column).length : undefined,
          depth,
          index: pendingParentHeaders.length
        }); // Add the headerToGroup as a subHeader of the new header

        header.subHeaders.push(headerToGroup); // Add the new header to the pendingParentHeaders to get grouped
        // in the next batch

        pendingParentHeaders.push(header);
      }

      headerGroup.headers.push(headerToGroup);
      headerToGroup.headerGroup = headerGroup;
    });
    headerGroups.push(headerGroup);

    if (depth > 0) {
      createHeaderGroup(pendingParentHeaders, depth - 1);
    }
  };

  const bottomHeaders = columnsToGroup.map((column, index) => createHeader(table, column, {
    depth: maxDepth,
    index
  }));
  createHeaderGroup(bottomHeaders, maxDepth - 1);
  headerGroups.reverse(); // headerGroups = headerGroups.filter(headerGroup => {
  //   return !headerGroup.headers.every(header => header.isPlaceholder)
  // })

  const recurseHeadersForSpans = headers => {
    const filteredHeaders = headers.filter(header => header.column.getIsVisible());
    return filteredHeaders.map(header => {
      let colSpan = 0;
      let rowSpan = 0;
      let childRowSpans = [0];

      if (header.subHeaders && header.subHeaders.length) {
        childRowSpans = [];
        recurseHeadersForSpans(header.subHeaders).forEach(_ref => {
          let {
            colSpan: childColSpan,
            rowSpan: childRowSpan
          } = _ref;
          colSpan += childColSpan;
          childRowSpans.push(childRowSpan);
        });
      } else {
        colSpan = 1;
      }

      const minChildRowSpan = Math.min(...childRowSpans);
      rowSpan = rowSpan + minChildRowSpan;
      header.colSpan = colSpan;
      header.rowSpan = rowSpan;
      return {
        colSpan,
        rowSpan
      };
    });
  };

  recurseHeadersForSpans((_headerGroups$0$heade = (_headerGroups$ = headerGroups[0]) == null ? void 0 : _headerGroups$.headers) != null ? _headerGroups$0$heade : []);
  return headerGroups;
}

//
const defaultColumnSizing = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
};

const getDefaultColumnSizingInfoState = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: false,
  columnSizingStart: []
});

const ColumnSizing = {
  getDefaultColumnDef: () => {
    return defaultColumnSizing;
  },
  getInitialState: state => {
    return {
      columnSizing: {},
      columnSizingInfo: getDefaultColumnSizingInfoState(),
      ...state
    };
  },
  getDefaultOptions: table => {
    return {
      columnResizeMode: 'onEnd',
      onColumnSizingChange: makeStateUpdater('columnSizing', table),
      onColumnSizingInfoChange: makeStateUpdater('columnSizingInfo', table)
    };
  },
  createColumn: (column, table) => {
    return {
      getSize: () => {
        var _column$columnDef$min, _ref, _column$columnDef$max;

        const columnSize = table.getState().columnSizing[column.id];
        return Math.min(Math.max((_column$columnDef$min = column.columnDef.minSize) != null ? _column$columnDef$min : defaultColumnSizing.minSize, (_ref = columnSize != null ? columnSize : column.columnDef.size) != null ? _ref : defaultColumnSizing.size), (_column$columnDef$max = column.columnDef.maxSize) != null ? _column$columnDef$max : defaultColumnSizing.maxSize);
      },
      getStart: position => {
        const columns = !position ? table.getVisibleLeafColumns() : position === 'left' ? table.getLeftVisibleLeafColumns() : table.getRightVisibleLeafColumns();
        const index = columns.findIndex(d => d.id === column.id);

        if (index > 0) {
          const prevSiblingColumn = columns[index - 1];
          return prevSiblingColumn.getStart(position) + prevSiblingColumn.getSize();
        }

        return 0;
      },
      resetSize: () => {
        table.setColumnSizing(_ref2 => {
          let {
            [column.id]: _,
            ...rest
          } = _ref2;
          return rest;
        });
      },
      getCanResize: () => {
        var _column$columnDef$ena, _table$options$enable;

        return ((_column$columnDef$ena = column.columnDef.enableResizing) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnResizing) != null ? _table$options$enable : true);
      },
      getIsResizing: () => {
        return table.getState().columnSizingInfo.isResizingColumn === column.id;
      }
    };
  },
  createHeader: (header, table) => {
    return {
      getSize: () => {
        let sum = 0;

        const recurse = header => {
          if (header.subHeaders.length) {
            header.subHeaders.forEach(recurse);
          } else {
            var _header$column$getSiz;

            sum += (_header$column$getSiz = header.column.getSize()) != null ? _header$column$getSiz : 0;
          }
        };

        recurse(header);
        return sum;
      },
      getStart: () => {
        if (header.index > 0) {
          const prevSiblingHeader = header.headerGroup.headers[header.index - 1];
          return prevSiblingHeader.getStart() + prevSiblingHeader.getSize();
        }

        return 0;
      },
      getResizeHandler: () => {
        const column = table.getColumn(header.column.id);
        const canResize = column.getCanResize();
        return e => {
          if (!canResize) {
            return;
          }
          e.persist == null ? void 0 : e.persist();

          if (isTouchStartEvent(e)) {
            // lets not respond to multiple touches (e.g. 2 or 3 fingers)
            if (e.touches && e.touches.length > 1) {
              return;
            }
          }

          const startSize = header.getSize();
          const columnSizingStart = header ? header.getLeafHeaders().map(d => [d.column.id, d.column.getSize()]) : [[column.id, column.getSize()]];
          const clientX = isTouchStartEvent(e) ? Math.round(e.touches[0].clientX) : e.clientX;

          const updateOffset = (eventType, clientXPos) => {
            if (typeof clientXPos !== 'number') {
              return;
            }

            let newColumnSizing = {};
            table.setColumnSizingInfo(old => {
              var _old$startOffset, _old$startSize;

              const deltaOffset = clientXPos - ((_old$startOffset = old == null ? void 0 : old.startOffset) != null ? _old$startOffset : 0);
              const deltaPercentage = Math.max(deltaOffset / ((_old$startSize = old == null ? void 0 : old.startSize) != null ? _old$startSize : 0), -0.999999);
              old.columnSizingStart.forEach(_ref3 => {
                let [columnId, headerSize] = _ref3;
                newColumnSizing[columnId] = Math.round(Math.max(headerSize + headerSize * deltaPercentage, 0) * 100) / 100;
              });
              return { ...old,
                deltaOffset,
                deltaPercentage
              };
            });

            if (table.options.columnResizeMode === 'onChange' || eventType === 'end') {
              table.setColumnSizing(old => ({ ...old,
                ...newColumnSizing
              }));
            }
          };

          const onMove = clientXPos => updateOffset('move', clientXPos);

          const onEnd = clientXPos => {
            updateOffset('end', clientXPos);
            table.setColumnSizingInfo(old => ({ ...old,
              isResizingColumn: false,
              startOffset: null,
              startSize: null,
              deltaOffset: null,
              deltaPercentage: null,
              columnSizingStart: []
            }));
          };

          const mouseEvents = {
            moveHandler: e => onMove(e.clientX),
            upHandler: e => {
              document.removeEventListener('mousemove', mouseEvents.moveHandler);
              document.removeEventListener('mouseup', mouseEvents.upHandler);
              onEnd(e.clientX);
            }
          };
          const passiveIfSupported = passiveEventSupported() ? {
            passive: false
          } : false;

          if (isTouchStartEvent(e)) ; else {
            document.addEventListener('mousemove', mouseEvents.moveHandler, passiveIfSupported);
            document.addEventListener('mouseup', mouseEvents.upHandler, passiveIfSupported);
          }

          table.setColumnSizingInfo(old => ({ ...old,
            startOffset: clientX,
            startSize,
            deltaOffset: 0,
            deltaPercentage: 0,
            columnSizingStart,
            isResizingColumn: column.id
          }));
        };
      }
    };
  },
  createTable: table => {
    return {
      setColumnSizing: updater => table.options.onColumnSizingChange == null ? void 0 : table.options.onColumnSizingChange(updater),
      setColumnSizingInfo: updater => table.options.onColumnSizingInfoChange == null ? void 0 : table.options.onColumnSizingInfoChange(updater),
      resetColumnSizing: defaultState => {
        var _table$initialState$c;

        table.setColumnSizing(defaultState ? {} : (_table$initialState$c = table.initialState.columnSizing) != null ? _table$initialState$c : {});
      },
      resetHeaderSizeInfo: defaultState => {
        var _table$initialState$c2;

        table.setColumnSizingInfo(defaultState ? getDefaultColumnSizingInfoState() : (_table$initialState$c2 = table.initialState.columnSizingInfo) != null ? _table$initialState$c2 : getDefaultColumnSizingInfoState());
      },
      getTotalSize: () => {
        var _table$getHeaderGroup, _table$getHeaderGroup2;

        return (_table$getHeaderGroup = (_table$getHeaderGroup2 = table.getHeaderGroups()[0]) == null ? void 0 : _table$getHeaderGroup2.headers.reduce((sum, header) => {
          return sum + header.getSize();
        }, 0)) != null ? _table$getHeaderGroup : 0;
      },
      getLeftTotalSize: () => {
        var _table$getLeftHeaderG, _table$getLeftHeaderG2;

        return (_table$getLeftHeaderG = (_table$getLeftHeaderG2 = table.getLeftHeaderGroups()[0]) == null ? void 0 : _table$getLeftHeaderG2.headers.reduce((sum, header) => {
          return sum + header.getSize();
        }, 0)) != null ? _table$getLeftHeaderG : 0;
      },
      getCenterTotalSize: () => {
        var _table$getCenterHeade, _table$getCenterHeade2;

        return (_table$getCenterHeade = (_table$getCenterHeade2 = table.getCenterHeaderGroups()[0]) == null ? void 0 : _table$getCenterHeade2.headers.reduce((sum, header) => {
          return sum + header.getSize();
        }, 0)) != null ? _table$getCenterHeade : 0;
      },
      getRightTotalSize: () => {
        var _table$getRightHeader, _table$getRightHeader2;

        return (_table$getRightHeader = (_table$getRightHeader2 = table.getRightHeaderGroups()[0]) == null ? void 0 : _table$getRightHeader2.headers.reduce((sum, header) => {
          return sum + header.getSize();
        }, 0)) != null ? _table$getRightHeader : 0;
      }
    };
  }
};
let passiveSupported = null;
function passiveEventSupported() {
  if (typeof passiveSupported === 'boolean') return passiveSupported;
  let supported = false;

  try {
    const options = {
      get passive() {
        supported = true;
        return false;
      }

    };

    const noop = () => {};

    window.addEventListener('test', noop, options);
    window.removeEventListener('test', noop);
  } catch (err) {
    supported = false;
  }

  passiveSupported = supported;
  return passiveSupported;
}

function isTouchStartEvent(e) {
  return e.type === 'touchstart';
}

//
const Expanding = {
  getInitialState: state => {
    return {
      expanded: {},
      ...state
    };
  },
  getDefaultOptions: table => {
    return {
      onExpandedChange: makeStateUpdater('expanded', table),
      paginateExpandedRows: true
    };
  },
  createTable: table => {
    let registered = false;
    let queued = false;
    return {
      _autoResetExpanded: () => {
        var _ref, _table$options$autoRe;

        if (!registered) {
          table._queue(() => {
            registered = true;
          });

          return;
        }

        if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetExpanded) != null ? _ref : !table.options.manualExpanding) {
          if (queued) return;
          queued = true;

          table._queue(() => {
            table.resetExpanded();
            queued = false;
          });
        }
      },
      setExpanded: updater => table.options.onExpandedChange == null ? void 0 : table.options.onExpandedChange(updater),
      toggleAllRowsExpanded: expanded => {
        if (expanded != null ? expanded : !table.getIsAllRowsExpanded()) {
          table.setExpanded(true);
        } else {
          table.setExpanded({});
        }
      },
      resetExpanded: defaultState => {
        var _table$initialState$e, _table$initialState;

        table.setExpanded(defaultState ? {} : (_table$initialState$e = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.expanded) != null ? _table$initialState$e : {});
      },
      getCanSomeRowsExpand: () => {
        return table.getRowModel().flatRows.some(row => row.getCanExpand());
      },
      getToggleAllRowsExpandedHandler: () => {
        return e => {
          e.persist == null ? void 0 : e.persist();
          table.toggleAllRowsExpanded();
        };
      },
      getIsSomeRowsExpanded: () => {
        const expanded = table.getState().expanded;
        return expanded === true || Object.values(expanded).some(Boolean);
      },
      getIsAllRowsExpanded: () => {
        const expanded = table.getState().expanded; // If expanded is true, save some cycles and return true

        if (typeof expanded === 'boolean') {
          return expanded === true;
        }

        if (!Object.keys(expanded).length) {
          return false;
        } // If any row is not expanded, return false


        if (table.getRowModel().flatRows.some(row => row.getIsExpanded())) {
          return false;
        } // They must all be expanded :shrug:


        return true;
      },
      getExpandedDepth: () => {
        let maxDepth = 0;
        const rowIds = table.getState().expanded === true ? Object.keys(table.getRowModel().rowsById) : Object.keys(table.getState().expanded);
        rowIds.forEach(id => {
          const splitId = id.split('.');
          maxDepth = Math.max(maxDepth, splitId.length);
        });
        return maxDepth;
      },
      getPreExpandedRowModel: () => table.getSortedRowModel(),
      getExpandedRowModel: () => {
        if (!table._getExpandedRowModel && table.options.getExpandedRowModel) {
          table._getExpandedRowModel = table.options.getExpandedRowModel(table);
        }

        if (table.options.manualExpanding || !table._getExpandedRowModel) {
          return table.getPreExpandedRowModel();
        }

        return table._getExpandedRowModel();
      }
    };
  },
  createRow: (row, table) => {
    return {
      toggleExpanded: expanded => {
        table.setExpanded(old => {
          var _expanded;

          const exists = old === true ? true : !!(old != null && old[row.id]);
          let oldExpanded = {};

          if (old === true) {
            Object.keys(table.getRowModel().rowsById).forEach(rowId => {
              oldExpanded[rowId] = true;
            });
          } else {
            oldExpanded = old;
          }

          expanded = (_expanded = expanded) != null ? _expanded : !exists;

          if (!exists && expanded) {
            return { ...oldExpanded,
              [row.id]: true
            };
          }

          if (exists && !expanded) {
            const {
              [row.id]: _,
              ...rest
            } = oldExpanded;
            return rest;
          }

          return old;
        });
      },
      getIsExpanded: () => {
        var _table$options$getIsR;

        const expanded = table.getState().expanded;
        return !!((_table$options$getIsR = table.options.getIsRowExpanded == null ? void 0 : table.options.getIsRowExpanded(row)) != null ? _table$options$getIsR : expanded === true || (expanded == null ? void 0 : expanded[row.id]));
      },
      getCanExpand: () => {
        var _table$options$getRow, _table$options$enable, _row$subRows;

        return (_table$options$getRow = table.options.getRowCanExpand == null ? void 0 : table.options.getRowCanExpand(row)) != null ? _table$options$getRow : ((_table$options$enable = table.options.enableExpanding) != null ? _table$options$enable : true) && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
      },
      getToggleExpandedHandler: () => {
        const canExpand = row.getCanExpand();
        return () => {
          if (!canExpand) return;
          row.toggleExpanded();
        };
      }
    };
  }
};

const includesString = (row, columnId, filterValue) => {
  var _row$getValue;

  const search = filterValue.toLowerCase();
  return (_row$getValue = row.getValue(columnId)) == null ? void 0 : _row$getValue.toLowerCase().includes(search);
};

includesString.autoRemove = val => testFalsey(val);

const includesStringSensitive = (row, columnId, filterValue) => {
  var _row$getValue2;

  return (_row$getValue2 = row.getValue(columnId)) == null ? void 0 : _row$getValue2.includes(filterValue);
};

includesStringSensitive.autoRemove = val => testFalsey(val);

const equalsString = (row, columnId, filterValue) => {
  var _row$getValue3;

  return ((_row$getValue3 = row.getValue(columnId)) == null ? void 0 : _row$getValue3.toLowerCase()) === filterValue.toLowerCase();
};

equalsString.autoRemove = val => testFalsey(val);

const arrIncludes = (row, columnId, filterValue) => {
  var _row$getValue4;

  return (_row$getValue4 = row.getValue(columnId)) == null ? void 0 : _row$getValue4.includes(filterValue);
};

arrIncludes.autoRemove = val => testFalsey(val) || !(val != null && val.length);

const arrIncludesAll = (row, columnId, filterValue) => {
  return !filterValue.some(val => {
    var _row$getValue5;

    return !((_row$getValue5 = row.getValue(columnId)) != null && _row$getValue5.includes(val));
  });
};

arrIncludesAll.autoRemove = val => testFalsey(val) || !(val != null && val.length);

const arrIncludesSome = (row, columnId, filterValue) => {
  return filterValue.some(val => {
    var _row$getValue6;

    return (_row$getValue6 = row.getValue(columnId)) == null ? void 0 : _row$getValue6.includes(val);
  });
};

arrIncludesSome.autoRemove = val => testFalsey(val) || !(val != null && val.length);

const equals = (row, columnId, filterValue) => {
  return row.getValue(columnId) === filterValue;
};

equals.autoRemove = val => testFalsey(val);

const weakEquals = (row, columnId, filterValue) => {
  return row.getValue(columnId) == filterValue;
};

weakEquals.autoRemove = val => testFalsey(val);

const inNumberRange = (row, columnId, filterValue) => {
  let [min, max] = filterValue;
  const rowValue = row.getValue(columnId);
  return rowValue >= min && rowValue <= max;
};

inNumberRange.resolveFilterValue = val => {
  let [unsafeMin, unsafeMax] = val;
  let parsedMin = typeof unsafeMin !== 'number' ? parseFloat(unsafeMin) : unsafeMin;
  let parsedMax = typeof unsafeMax !== 'number' ? parseFloat(unsafeMax) : unsafeMax;
  let min = unsafeMin === null || Number.isNaN(parsedMin) ? -Infinity : parsedMin;
  let max = unsafeMax === null || Number.isNaN(parsedMax) ? Infinity : parsedMax;

  if (min > max) {
    const temp = min;
    min = max;
    max = temp;
  }

  return [min, max];
};

inNumberRange.autoRemove = val => testFalsey(val) || testFalsey(val[0]) && testFalsey(val[1]); // Export


const filterFns = {
  includesString,
  includesStringSensitive,
  equalsString,
  arrIncludes,
  arrIncludesAll,
  arrIncludesSome,
  equals,
  weakEquals,
  inNumberRange
};

// Utils
function testFalsey(val) {
  return val === undefined || val === null || val === '';
}

//
const Filters = {
  getDefaultColumnDef: () => {
    return {
      filterFn: 'auto'
    };
  },
  getInitialState: state => {
    return {
      columnFilters: [],
      globalFilter: undefined,
      // filtersProgress: 1,
      // facetProgress: {},
      ...state
    };
  },
  getDefaultOptions: table => {
    return {
      onColumnFiltersChange: makeStateUpdater('columnFilters', table),
      onGlobalFilterChange: makeStateUpdater('globalFilter', table),
      filterFromLeafRows: false,
      globalFilterFn: 'auto',
      getColumnCanGlobalFilter: column => {
        var _table$getCoreRowMode, _table$getCoreRowMode2;

        const value = (_table$getCoreRowMode = table.getCoreRowModel().flatRows[0]) == null ? void 0 : (_table$getCoreRowMode2 = _table$getCoreRowMode._getAllCellsByColumnId()[column.id]) == null ? void 0 : _table$getCoreRowMode2.getValue();
        return typeof value === 'string' || typeof value === 'number';
      }
    };
  },
  createColumn: (column, table) => {
    return {
      getAutoFilterFn: () => {
        const firstRow = table.getCoreRowModel().flatRows[0];
        const value = firstRow == null ? void 0 : firstRow.getValue(column.id);

        if (typeof value === 'string') {
          return filterFns.includesString;
        }

        if (typeof value === 'number') {
          return filterFns.inNumberRange;
        }

        if (typeof value === 'boolean') {
          return filterFns.equals;
        }

        if (value !== null && typeof value === 'object') {
          return filterFns.equals;
        }

        if (Array.isArray(value)) {
          return filterFns.arrIncludes;
        }

        return filterFns.weakEquals;
      },
      getFilterFn: () => {
        var _table$options$filter, _table$options$filter2;

        return isFunction(column.columnDef.filterFn) ? column.columnDef.filterFn : column.columnDef.filterFn === 'auto' ? column.getAutoFilterFn() : (_table$options$filter = (_table$options$filter2 = table.options.filterFns) == null ? void 0 : _table$options$filter2[column.columnDef.filterFn]) != null ? _table$options$filter : filterFns[column.columnDef.filterFn];
      },
      getCanFilter: () => {
        var _column$columnDef$ena, _table$options$enable, _table$options$enable2;

        return ((_column$columnDef$ena = column.columnDef.enableColumnFilter) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnFilters) != null ? _table$options$enable : true) && ((_table$options$enable2 = table.options.enableFilters) != null ? _table$options$enable2 : true) && !!column.accessorFn;
      },
      getCanGlobalFilter: () => {
        var _column$columnDef$ena2, _table$options$enable3, _table$options$enable4, _table$options$getCol;

        return ((_column$columnDef$ena2 = column.columnDef.enableGlobalFilter) != null ? _column$columnDef$ena2 : true) && ((_table$options$enable3 = table.options.enableGlobalFilter) != null ? _table$options$enable3 : true) && ((_table$options$enable4 = table.options.enableFilters) != null ? _table$options$enable4 : true) && ((_table$options$getCol = table.options.getColumnCanGlobalFilter == null ? void 0 : table.options.getColumnCanGlobalFilter(column)) != null ? _table$options$getCol : true) && !!column.accessorFn;
      },
      getIsFiltered: () => column.getFilterIndex() > -1,
      getFilterValue: () => {
        var _table$getState$colum, _table$getState$colum2;

        return (_table$getState$colum = table.getState().columnFilters) == null ? void 0 : (_table$getState$colum2 = _table$getState$colum.find(d => d.id === column.id)) == null ? void 0 : _table$getState$colum2.value;
      },
      getFilterIndex: () => {
        var _table$getState$colum3, _table$getState$colum4;

        return (_table$getState$colum3 = (_table$getState$colum4 = table.getState().columnFilters) == null ? void 0 : _table$getState$colum4.findIndex(d => d.id === column.id)) != null ? _table$getState$colum3 : -1;
      },
      setFilterValue: value => {
        table.setColumnFilters(old => {
          const filterFn = column.getFilterFn();
          const previousfilter = old == null ? void 0 : old.find(d => d.id === column.id);
          const newFilter = functionalUpdate(value, previousfilter ? previousfilter.value : undefined); //

          if (shouldAutoRemoveFilter(filterFn, newFilter, column)) {
            var _old$filter;

            return (_old$filter = old == null ? void 0 : old.filter(d => d.id !== column.id)) != null ? _old$filter : [];
          }

          const newFilterObj = {
            id: column.id,
            value: newFilter
          };

          if (previousfilter) {
            var _old$map;

            return (_old$map = old == null ? void 0 : old.map(d => {
              if (d.id === column.id) {
                return newFilterObj;
              }

              return d;
            })) != null ? _old$map : [];
          }

          if (old != null && old.length) {
            return [...old, newFilterObj];
          }

          return [newFilterObj];
        });
      },
      _getFacetedRowModel: table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, column.id),
      getFacetedRowModel: () => {
        if (!column._getFacetedRowModel) {
          return table.getPreFilteredRowModel();
        }

        return column._getFacetedRowModel();
      },
      _getFacetedUniqueValues: table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, column.id),
      getFacetedUniqueValues: () => {
        if (!column._getFacetedUniqueValues) {
          return new Map();
        }

        return column._getFacetedUniqueValues();
      },
      _getFacetedMinMaxValues: table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, column.id),
      getFacetedMinMaxValues: () => {
        if (!column._getFacetedMinMaxValues) {
          return undefined;
        }

        return column._getFacetedMinMaxValues();
      } // () => [column.getFacetedRowModel()],
      // facetedRowModel => getRowModelMinMaxValues(facetedRowModel, column.id),

    };
  },
  createRow: (row, table) => {
    return {
      columnFilters: {},
      columnFiltersMeta: {}
    };
  },
  createTable: table => {
    return {
      getGlobalAutoFilterFn: () => {
        return filterFns.includesString;
      },
      getGlobalFilterFn: () => {
        var _table$options$filter3, _table$options$filter4;

        const {
          globalFilterFn: globalFilterFn
        } = table.options;
        return isFunction(globalFilterFn) ? globalFilterFn : globalFilterFn === 'auto' ? table.getGlobalAutoFilterFn() : (_table$options$filter3 = (_table$options$filter4 = table.options.filterFns) == null ? void 0 : _table$options$filter4[globalFilterFn]) != null ? _table$options$filter3 : filterFns[globalFilterFn];
      },
      setColumnFilters: updater => {
        const leafColumns = table.getAllLeafColumns();

        const updateFn = old => {
          var _functionalUpdate;

          return (_functionalUpdate = functionalUpdate(updater, old)) == null ? void 0 : _functionalUpdate.filter(filter => {
            const column = leafColumns.find(d => d.id === filter.id);

            if (column) {
              const filterFn = column.getFilterFn();

              if (shouldAutoRemoveFilter(filterFn, filter.value, column)) {
                return false;
              }
            }

            return true;
          });
        };

        table.options.onColumnFiltersChange == null ? void 0 : table.options.onColumnFiltersChange(updateFn);
      },
      setGlobalFilter: updater => {
        table.options.onGlobalFilterChange == null ? void 0 : table.options.onGlobalFilterChange(updater);
      },
      resetGlobalFilter: defaultState => {
        table.setGlobalFilter(defaultState ? undefined : table.initialState.globalFilter);
      },
      resetColumnFilters: defaultState => {
        var _table$initialState$c, _table$initialState;

        table.setColumnFilters(defaultState ? [] : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnFilters) != null ? _table$initialState$c : []);
      },
      getPreFilteredRowModel: () => table.getCoreRowModel(),
      getFilteredRowModel: () => {
        if (!table._getFilteredRowModel && table.options.getFilteredRowModel) {
          table._getFilteredRowModel = table.options.getFilteredRowModel(table);
        }

        if (table.options.manualFiltering || !table._getFilteredRowModel) {
          return table.getPreFilteredRowModel();
        }

        return table._getFilteredRowModel();
      },
      _getGlobalFacetedRowModel: table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, '__global__'),
      getGlobalFacetedRowModel: () => {
        if (table.options.manualFiltering || !table._getGlobalFacetedRowModel) {
          return table.getPreFilteredRowModel();
        }

        return table._getGlobalFacetedRowModel();
      },
      _getGlobalFacetedUniqueValues: table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, '__global__'),
      getGlobalFacetedUniqueValues: () => {
        if (!table._getGlobalFacetedUniqueValues) {
          return new Map();
        }

        return table._getGlobalFacetedUniqueValues();
      },
      _getGlobalFacetedMinMaxValues: table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, '__global__'),
      getGlobalFacetedMinMaxValues: () => {
        if (!table._getGlobalFacetedMinMaxValues) {
          return;
        }

        return table._getGlobalFacetedMinMaxValues();
      }
    };
  }
};
function shouldAutoRemoveFilter(filterFn, value, column) {
  return (filterFn && filterFn.autoRemove ? filterFn.autoRemove(value, column) : false) || typeof value === 'undefined' || typeof value === 'string' && !value;
}

const sum = (columnId, _leafRows, childRows) => {
  // It's faster to just add the aggregations together instead of
  // process leaf nodes individually
  return childRows.reduce((sum, next) => {
    const nextValue = next.getValue(columnId);
    return sum + (typeof nextValue === 'number' ? nextValue : 0);
  }, 0);
};

const min = (columnId, _leafRows, childRows) => {
  let min;
  childRows.forEach(row => {
    const value = row.getValue(columnId);

    if (value != null && (min > value || min === undefined && value >= value)) {
      min = value;
    }
  });
  return min;
};

const max = (columnId, _leafRows, childRows) => {
  let max;
  childRows.forEach(row => {
    const value = row.getValue(columnId);

    if (value != null && (max < value || max === undefined && value >= value)) {
      max = value;
    }
  });
  return max;
};

const extent = (columnId, _leafRows, childRows) => {
  let min;
  let max;
  childRows.forEach(row => {
    const value = row.getValue(columnId);

    if (value != null) {
      if (min === undefined) {
        if (value >= value) min = max = value;
      } else {
        if (min > value) min = value;
        if (max < value) max = value;
      }
    }
  });
  return [min, max];
};

const mean = (columnId, leafRows) => {
  let count = 0;
  let sum = 0;
  leafRows.forEach(row => {
    let value = row.getValue(columnId);

    if (value != null && (value = +value) >= value) {
      ++count, sum += value;
    }
  });
  if (count) return sum / count;
  return;
};

const median = (columnId, leafRows) => {
  if (!leafRows.length) {
    return;
  }

  let min = 0;
  let max = 0;
  leafRows.forEach(row => {
    let value = row.getValue(columnId);

    if (typeof value === 'number') {
      min = Math.min(min, value);
      max = Math.max(max, value);
    }
  });
  return (min + max) / 2;
};

const unique = (columnId, leafRows) => {
  return Array.from(new Set(leafRows.map(d => d.getValue(columnId))).values());
};

const uniqueCount = (columnId, leafRows) => {
  return new Set(leafRows.map(d => d.getValue(columnId))).size;
};

const count = (_columnId, leafRows) => {
  return leafRows.length;
};

const aggregationFns = {
  sum,
  min,
  max,
  extent,
  mean,
  median,
  unique,
  uniqueCount,
  count
};

//
const Grouping = {
  getDefaultColumnDef: () => {
    return {
      aggregatedCell: props => {
        var _toString, _props$getValue;

        return (_toString = (_props$getValue = props.getValue()) == null ? void 0 : _props$getValue.toString == null ? void 0 : _props$getValue.toString()) != null ? _toString : null;
      },
      aggregationFn: 'auto'
    };
  },
  getInitialState: state => {
    return {
      grouping: [],
      ...state
    };
  },
  getDefaultOptions: table => {
    return {
      onGroupingChange: makeStateUpdater('grouping', table),
      groupedColumnMode: 'reorder'
    };
  },
  createColumn: (column, table) => {
    return {
      toggleGrouping: () => {
        table.setGrouping(old => {
          // Find any existing grouping for this column
          if (old != null && old.includes(column.id)) {
            return old.filter(d => d !== column.id);
          }

          return [...(old != null ? old : []), column.id];
        });
      },
      getCanGroup: () => {
        var _ref, _ref2, _ref3, _column$columnDef$ena;

        return (_ref = (_ref2 = (_ref3 = (_column$columnDef$ena = column.columnDef.enableGrouping) != null ? _column$columnDef$ena : true) != null ? _ref3 : table.options.enableGrouping) != null ? _ref2 : true) != null ? _ref : !!column.accessorFn;
      },
      getIsGrouped: () => {
        var _table$getState$group;

        return (_table$getState$group = table.getState().grouping) == null ? void 0 : _table$getState$group.includes(column.id);
      },
      getGroupedIndex: () => {
        var _table$getState$group2;

        return (_table$getState$group2 = table.getState().grouping) == null ? void 0 : _table$getState$group2.indexOf(column.id);
      },
      getToggleGroupingHandler: () => {
        const canGroup = column.getCanGroup();
        return () => {
          if (!canGroup) return;
          column.toggleGrouping();
        };
      },
      getAutoAggregationFn: () => {
        const firstRow = table.getCoreRowModel().flatRows[0];
        const value = firstRow == null ? void 0 : firstRow.getValue(column.id);

        if (typeof value === 'number') {
          return aggregationFns.sum;
        }

        if (Object.prototype.toString.call(value) === '[object Date]') {
          return aggregationFns.extent;
        }
      },
      getAggregationFn: () => {
        var _table$options$aggreg, _table$options$aggreg2;

        if (!column) {
          throw new Error();
        }

        return isFunction(column.columnDef.aggregationFn) ? column.columnDef.aggregationFn : column.columnDef.aggregationFn === 'auto' ? column.getAutoAggregationFn() : (_table$options$aggreg = (_table$options$aggreg2 = table.options.aggregationFns) == null ? void 0 : _table$options$aggreg2[column.columnDef.aggregationFn]) != null ? _table$options$aggreg : aggregationFns[column.columnDef.aggregationFn];
      }
    };
  },
  createTable: table => {
    return {
      setGrouping: updater => table.options.onGroupingChange == null ? void 0 : table.options.onGroupingChange(updater),
      resetGrouping: defaultState => {
        var _table$initialState$g, _table$initialState;

        table.setGrouping(defaultState ? [] : (_table$initialState$g = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.grouping) != null ? _table$initialState$g : []);
      },
      getPreGroupedRowModel: () => table.getFilteredRowModel(),
      getGroupedRowModel: () => {
        if (!table._getGroupedRowModel && table.options.getGroupedRowModel) {
          table._getGroupedRowModel = table.options.getGroupedRowModel(table);
        }

        if (table.options.manualGrouping || !table._getGroupedRowModel) {
          return table.getPreGroupedRowModel();
        }

        return table._getGroupedRowModel();
      }
    };
  },
  createRow: row => {
    return {
      getIsGrouped: () => !!row.groupingColumnId,
      _groupingValuesCache: {}
    };
  },
  createCell: (cell, column, row, table) => {

    return {
      getIsGrouped: () => column.getIsGrouped() && column.id === row.groupingColumnId,
      getIsPlaceholder: () => !cell.getIsGrouped() && column.getIsGrouped(),
      getIsAggregated: () => {
        var _row$subRows;

        return !cell.getIsGrouped() && !cell.getIsPlaceholder() && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
      }
    };
  }
};
function orderColumns(leafColumns, grouping, groupedColumnMode) {
  if (!(grouping != null && grouping.length) || !groupedColumnMode) {
    return leafColumns;
  }

  const nonGroupingColumns = leafColumns.filter(col => !grouping.includes(col.id));

  if (groupedColumnMode === 'remove') {
    return nonGroupingColumns;
  }

  const groupingColumns = grouping.map(g => leafColumns.find(col => col.id === g)).filter(Boolean);
  return [...groupingColumns, ...nonGroupingColumns];
}

//
const Ordering = {
  getInitialState: state => {
    return {
      columnOrder: [],
      ...state
    };
  },
  getDefaultOptions: table => {
    return {
      onColumnOrderChange: makeStateUpdater('columnOrder', table)
    };
  },
  createTable: table => {
    return {
      setColumnOrder: updater => table.options.onColumnOrderChange == null ? void 0 : table.options.onColumnOrderChange(updater),
      resetColumnOrder: defaultState => {
        var _table$initialState$c;

        table.setColumnOrder(defaultState ? [] : (_table$initialState$c = table.initialState.columnOrder) != null ? _table$initialState$c : []);
      },
      _getOrderColumnsFn: memo(() => [table.getState().columnOrder, table.getState().grouping, table.options.groupedColumnMode], (columnOrder, grouping, groupedColumnMode) => columns => {
        // Sort grouped columns to the start of the column list
        // before the headers are built
        let orderedColumns = []; // If there is no order, return the normal columns

        if (!(columnOrder != null && columnOrder.length)) {
          orderedColumns = columns;
        } else {
          const columnOrderCopy = [...columnOrder]; // If there is an order, make a copy of the columns

          const columnsCopy = [...columns]; // And make a new ordered array of the columns
          // Loop over the columns and place them in order into the new array

          while (columnsCopy.length && columnOrderCopy.length) {
            const targetColumnId = columnOrderCopy.shift();
            const foundIndex = columnsCopy.findIndex(d => d.id === targetColumnId);

            if (foundIndex > -1) {
              orderedColumns.push(columnsCopy.splice(foundIndex, 1)[0]);
            }
          } // If there are any columns left, add them to the end


          orderedColumns = [...orderedColumns, ...columnsCopy];
        }

        return orderColumns(orderedColumns, grouping, groupedColumnMode);
      }, {
        key: process.env.NODE_ENV === 'development' && 'getOrderColumnsFn' // debug: () => table.options.debugAll ?? table.options.debugTable,

      })
    };
  }
};

//
const defaultPageIndex = 0;
const defaultPageSize = 10;

const getDefaultPaginationState = () => ({
  pageIndex: defaultPageIndex,
  pageSize: defaultPageSize
});

const Pagination = {
  getInitialState: state => {
    return { ...state,
      pagination: { ...getDefaultPaginationState(),
        ...(state == null ? void 0 : state.pagination)
      }
    };
  },
  getDefaultOptions: table => {
    return {
      onPaginationChange: makeStateUpdater('pagination', table)
    };
  },
  createTable: table => {
    let registered = false;
    let queued = false;
    return {
      _autoResetPageIndex: () => {
        var _ref, _table$options$autoRe;

        if (!registered) {
          table._queue(() => {
            registered = true;
          });

          return;
        }

        if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetPageIndex) != null ? _ref : !table.options.manualPagination) {
          if (queued) return;
          queued = true;

          table._queue(() => {
            table.resetPageIndex();
            queued = false;
          });
        }
      },
      setPagination: updater => {
        const safeUpdater = old => {
          let newState = functionalUpdate(updater, old);
          return newState;
        };

        return table.options.onPaginationChange == null ? void 0 : table.options.onPaginationChange(safeUpdater);
      },
      resetPagination: defaultState => {
        var _table$initialState$p;

        table.setPagination(defaultState ? getDefaultPaginationState() : (_table$initialState$p = table.initialState.pagination) != null ? _table$initialState$p : getDefaultPaginationState());
      },
      setPageIndex: updater => {
        table.setPagination(old => {
          let pageIndex = functionalUpdate(updater, old.pageIndex);
          const maxPageIndex = typeof table.options.pageCount === 'undefined' || table.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : table.options.pageCount - 1;
          pageIndex = Math.min(Math.max(0, pageIndex), maxPageIndex);
          return { ...old,
            pageIndex
          };
        });
      },
      resetPageIndex: defaultState => {
        var _table$initialState$p2, _table$initialState, _table$initialState$p3;

        table.setPageIndex(defaultState ? defaultPageIndex : (_table$initialState$p2 = (_table$initialState = table.initialState) == null ? void 0 : (_table$initialState$p3 = _table$initialState.pagination) == null ? void 0 : _table$initialState$p3.pageIndex) != null ? _table$initialState$p2 : defaultPageIndex);
      },
      resetPageSize: defaultState => {
        var _table$initialState$p4, _table$initialState2, _table$initialState2$;

        table.setPageSize(defaultState ? defaultPageSize : (_table$initialState$p4 = (_table$initialState2 = table.initialState) == null ? void 0 : (_table$initialState2$ = _table$initialState2.pagination) == null ? void 0 : _table$initialState2$.pageSize) != null ? _table$initialState$p4 : defaultPageSize);
      },
      setPageSize: updater => {
        table.setPagination(old => {
          const pageSize = Math.max(1, functionalUpdate(updater, old.pageSize));
          const topRowIndex = old.pageSize * old.pageIndex;
          const pageIndex = Math.floor(topRowIndex / pageSize);
          return { ...old,
            pageIndex,
            pageSize
          };
        });
      },
      setPageCount: updater => table.setPagination(old => {
        var _table$options$pageCo;

        let newPageCount = functionalUpdate(updater, (_table$options$pageCo = table.options.pageCount) != null ? _table$options$pageCo : -1);

        if (typeof newPageCount === 'number') {
          newPageCount = Math.max(-1, newPageCount);
        }

        return { ...old,
          pageCount: newPageCount
        };
      }),
      getPageOptions: memo(() => [table.getPageCount()], pageCount => {
        let pageOptions = [];

        if (pageCount && pageCount > 0) {
          pageOptions = [...new Array(pageCount)].fill(null).map((_, i) => i);
        }

        return pageOptions;
      }, {
        key: process.env.NODE_ENV === 'development' && 'getPageOptions',
        debug: () => {
          var _table$options$debugA;

          return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
        }
      }),
      getCanPreviousPage: () => table.getState().pagination.pageIndex > 0,
      getCanNextPage: () => {
        const {
          pageIndex
        } = table.getState().pagination;
        const pageCount = table.getPageCount();

        if (pageCount === -1) {
          return true;
        }

        if (pageCount === 0) {
          return false;
        }

        return pageIndex < pageCount - 1;
      },
      previousPage: () => {
        return table.setPageIndex(old => old - 1);
      },
      nextPage: () => {
        return table.setPageIndex(old => {
          return old + 1;
        });
      },
      getPrePaginationRowModel: () => table.getExpandedRowModel(),
      getPaginationRowModel: () => {
        if (!table._getPaginationRowModel && table.options.getPaginationRowModel) {
          table._getPaginationRowModel = table.options.getPaginationRowModel(table);
        }

        if (table.options.manualPagination || !table._getPaginationRowModel) {
          return table.getPrePaginationRowModel();
        }

        return table._getPaginationRowModel();
      },
      getPageCount: () => {
        var _table$options$pageCo2;

        return (_table$options$pageCo2 = table.options.pageCount) != null ? _table$options$pageCo2 : Math.ceil(table.getPrePaginationRowModel().rows.length / table.getState().pagination.pageSize);
      }
    };
  }
};

//
const getDefaultPinningState = () => ({
  left: [],
  right: []
});

const Pinning = {
  getInitialState: state => {
    return {
      columnPinning: getDefaultPinningState(),
      ...state
    };
  },
  getDefaultOptions: table => {
    return {
      onColumnPinningChange: makeStateUpdater('columnPinning', table)
    };
  },
  createColumn: (column, table) => {
    return {
      pin: position => {
        const columnIds = column.getLeafColumns().map(d => d.id).filter(Boolean);
        table.setColumnPinning(old => {
          var _old$left3, _old$right3;

          if (position === 'right') {
            var _old$left, _old$right;

            return {
              left: ((_old$left = old == null ? void 0 : old.left) != null ? _old$left : []).filter(d => !(columnIds != null && columnIds.includes(d))),
              right: [...((_old$right = old == null ? void 0 : old.right) != null ? _old$right : []).filter(d => !(columnIds != null && columnIds.includes(d))), ...columnIds]
            };
          }

          if (position === 'left') {
            var _old$left2, _old$right2;

            return {
              left: [...((_old$left2 = old == null ? void 0 : old.left) != null ? _old$left2 : []).filter(d => !(columnIds != null && columnIds.includes(d))), ...columnIds],
              right: ((_old$right2 = old == null ? void 0 : old.right) != null ? _old$right2 : []).filter(d => !(columnIds != null && columnIds.includes(d)))
            };
          }

          return {
            left: ((_old$left3 = old == null ? void 0 : old.left) != null ? _old$left3 : []).filter(d => !(columnIds != null && columnIds.includes(d))),
            right: ((_old$right3 = old == null ? void 0 : old.right) != null ? _old$right3 : []).filter(d => !(columnIds != null && columnIds.includes(d)))
          };
        });
      },
      getCanPin: () => {
        const leafColumns = column.getLeafColumns();
        return leafColumns.some(d => {
          var _d$columnDef$enablePi, _table$options$enable;

          return ((_d$columnDef$enablePi = d.columnDef.enablePinning) != null ? _d$columnDef$enablePi : true) && ((_table$options$enable = table.options.enablePinning) != null ? _table$options$enable : true);
        });
      },
      getIsPinned: () => {
        const leafColumnIds = column.getLeafColumns().map(d => d.id);
        const {
          left,
          right
        } = table.getState().columnPinning;
        const isLeft = leafColumnIds.some(d => left == null ? void 0 : left.includes(d));
        const isRight = leafColumnIds.some(d => right == null ? void 0 : right.includes(d));
        return isLeft ? 'left' : isRight ? 'right' : false;
      },
      getPinnedIndex: () => {
        var _table$getState$colum, _table$getState$colum2, _table$getState$colum3;

        const position = column.getIsPinned();
        return position ? (_table$getState$colum = (_table$getState$colum2 = table.getState().columnPinning) == null ? void 0 : (_table$getState$colum3 = _table$getState$colum2[position]) == null ? void 0 : _table$getState$colum3.indexOf(column.id)) != null ? _table$getState$colum : -1 : 0;
      }
    };
  },
  createRow: (row, table) => {
    return {
      getCenterVisibleCells: memo(() => [row._getAllVisibleCells(), table.getState().columnPinning.left, table.getState().columnPinning.right], (allCells, left, right) => {
        const leftAndRight = [...(left != null ? left : []), ...(right != null ? right : [])];
        return allCells.filter(d => !leftAndRight.includes(d.column.id));
      }, {
        key: process.env.NODE_ENV === 'production' && 'row.getCenterVisibleCells',
        debug: () => {
          var _table$options$debugA;

          return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugRows;
        }
      }),
      getLeftVisibleCells: memo(() => [row._getAllVisibleCells(), table.getState().columnPinning.left,,], (allCells, left) => {
        const cells = (left != null ? left : []).map(columnId => allCells.find(cell => cell.column.id === columnId)).filter(Boolean).map(d => ({ ...d,
          position: 'left'
        }));
        return cells;
      }, {
        key: process.env.NODE_ENV === 'production' && 'row.getLeftVisibleCells',
        debug: () => {
          var _table$options$debugA2;

          return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugRows;
        }
      }),
      getRightVisibleCells: memo(() => [row._getAllVisibleCells(), table.getState().columnPinning.right], (allCells, right) => {
        const cells = (right != null ? right : []).map(columnId => allCells.find(cell => cell.column.id === columnId)).filter(Boolean).map(d => ({ ...d,
          position: 'left'
        }));
        return cells;
      }, {
        key: process.env.NODE_ENV === 'production' && 'row.getRightVisibleCells',
        debug: () => {
          var _table$options$debugA3;

          return (_table$options$debugA3 = table.options.debugAll) != null ? _table$options$debugA3 : table.options.debugRows;
        }
      })
    };
  },
  createTable: table => {
    return {
      setColumnPinning: updater => table.options.onColumnPinningChange == null ? void 0 : table.options.onColumnPinningChange(updater),
      resetColumnPinning: defaultState => {
        var _table$initialState$c, _table$initialState;

        return table.setColumnPinning(defaultState ? getDefaultPinningState() : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnPinning) != null ? _table$initialState$c : getDefaultPinningState());
      },
      getIsSomeColumnsPinned: position => {
        var _pinningState$positio;

        const pinningState = table.getState().columnPinning;

        if (!position) {
          var _pinningState$left, _pinningState$right;

          return Boolean(((_pinningState$left = pinningState.left) == null ? void 0 : _pinningState$left.length) || ((_pinningState$right = pinningState.right) == null ? void 0 : _pinningState$right.length));
        }

        return Boolean((_pinningState$positio = pinningState[position]) == null ? void 0 : _pinningState$positio.length);
      },
      getLeftLeafColumns: memo(() => [table.getAllLeafColumns(), table.getState().columnPinning.left], (allColumns, left) => {
        return (left != null ? left : []).map(columnId => allColumns.find(column => column.id === columnId)).filter(Boolean);
      }, {
        key: process.env.NODE_ENV === 'development' && 'getLeftLeafColumns',
        debug: () => {
          var _table$options$debugA4;

          return (_table$options$debugA4 = table.options.debugAll) != null ? _table$options$debugA4 : table.options.debugColumns;
        }
      }),
      getRightLeafColumns: memo(() => [table.getAllLeafColumns(), table.getState().columnPinning.right], (allColumns, right) => {
        return (right != null ? right : []).map(columnId => allColumns.find(column => column.id === columnId)).filter(Boolean);
      }, {
        key: process.env.NODE_ENV === 'development' && 'getRightLeafColumns',
        debug: () => {
          var _table$options$debugA5;

          return (_table$options$debugA5 = table.options.debugAll) != null ? _table$options$debugA5 : table.options.debugColumns;
        }
      }),
      getCenterLeafColumns: memo(() => [table.getAllLeafColumns(), table.getState().columnPinning.left, table.getState().columnPinning.right], (allColumns, left, right) => {
        const leftAndRight = [...(left != null ? left : []), ...(right != null ? right : [])];
        return allColumns.filter(d => !leftAndRight.includes(d.id));
      }, {
        key: process.env.NODE_ENV === 'development' && 'getCenterLeafColumns',
        debug: () => {
          var _table$options$debugA6;

          return (_table$options$debugA6 = table.options.debugAll) != null ? _table$options$debugA6 : table.options.debugColumns;
        }
      })
    };
  }
};

//
const RowSelection = {
  getInitialState: state => {
    return {
      rowSelection: {},
      ...state
    };
  },
  getDefaultOptions: table => {
    return {
      onRowSelectionChange: makeStateUpdater('rowSelection', table),
      enableRowSelection: true,
      enableMultiRowSelection: true,
      enableSubRowSelection: true // enableGroupingRowSelection: false,
      // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
      // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,

    };
  },
  createTable: table => {
    return {
      setRowSelection: updater => table.options.onRowSelectionChange == null ? void 0 : table.options.onRowSelectionChange(updater),
      resetRowSelection: defaultState => {
        var _table$initialState$r;

        return table.setRowSelection(defaultState ? {} : (_table$initialState$r = table.initialState.rowSelection) != null ? _table$initialState$r : {});
      },
      toggleAllRowsSelected: value => {
        table.setRowSelection(old => {
          value = typeof value !== 'undefined' ? value : !table.getIsAllRowsSelected();
          const rowSelection = { ...old
          };
          const preGroupedFlatRows = table.getPreGroupedRowModel().flatRows; // We don't use `mutateRowIsSelected` here for performance reasons.
          // All of the rows are flat already, so it wouldn't be worth it

          if (value) {
            preGroupedFlatRows.forEach(row => {
              if (!row.getCanSelect()) {
                return;
              }

              rowSelection[row.id] = true;
            });
          } else {
            preGroupedFlatRows.forEach(row => {
              delete rowSelection[row.id];
            });
          }

          return rowSelection;
        });
      },
      toggleAllPageRowsSelected: value => table.setRowSelection(old => {
        const resolvedValue = typeof value !== 'undefined' ? value : !table.getIsAllPageRowsSelected();
        const rowSelection = { ...old
        };
        table.getRowModel().rows.forEach(row => {
          mutateRowIsSelected(rowSelection, row.id, resolvedValue, table);
        });
        return rowSelection;
      }),
      // addRowSelectionRange: rowId => {
      //   const {
      //     rows,
      //     rowsById,
      //     options: { selectGroupingRows, selectSubRows },
      //   } = table
      //   const findSelectedRow = (rows: Row[]) => {
      //     let found
      //     rows.find(d => {
      //       if (d.getIsSelected()) {
      //         found = d
      //         return true
      //       }
      //       const subFound = findSelectedRow(d.subRows || [])
      //       if (subFound) {
      //         found = subFound
      //         return true
      //       }
      //       return false
      //     })
      //     return found
      //   }
      //   const firstRow = findSelectedRow(rows) || rows[0]
      //   const lastRow = rowsById[rowId]
      //   let include = false
      //   const selectedRowIds = {}
      //   const addRow = (row: Row) => {
      //     mutateRowIsSelected(selectedRowIds, row.id, true, {
      //       rowsById,
      //       selectGroupingRows: selectGroupingRows!,
      //       selectSubRows: selectSubRows!,
      //     })
      //   }
      //   table.rows.forEach(row => {
      //     const isFirstRow = row.id === firstRow.id
      //     const isLastRow = row.id === lastRow.id
      //     if (isFirstRow || isLastRow) {
      //       if (!include) {
      //         include = true
      //       } else if (include) {
      //         addRow(row)
      //         include = false
      //       }
      //     }
      //     if (include) {
      //       addRow(row)
      //     }
      //   })
      //   table.setRowSelection(selectedRowIds)
      // },
      getPreSelectedRowModel: () => table.getCoreRowModel(),
      getSelectedRowModel: memo(() => [table.getState().rowSelection, table.getCoreRowModel()], (rowSelection, rowModel) => {
        if (!Object.keys(rowSelection).length) {
          return {
            rows: [],
            flatRows: [],
            rowsById: {}
          };
        }

        return selectRowsFn(table, rowModel);
      }, {
        key: process.env.NODE_ENV === 'development' && 'getSelectedRowModel',
        debug: () => {
          var _table$options$debugA;

          return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
        }
      }),
      getFilteredSelectedRowModel: memo(() => [table.getState().rowSelection, table.getFilteredRowModel()], (rowSelection, rowModel) => {
        if (!Object.keys(rowSelection).length) {
          return {
            rows: [],
            flatRows: [],
            rowsById: {}
          };
        }

        return selectRowsFn(table, rowModel);
      }, {
        key: process.env.NODE_ENV === 'production' && 'getFilteredSelectedRowModel',
        debug: () => {
          var _table$options$debugA2;

          return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugTable;
        }
      }),
      getGroupedSelectedRowModel: memo(() => [table.getState().rowSelection, table.getSortedRowModel()], (rowSelection, rowModel) => {
        if (!Object.keys(rowSelection).length) {
          return {
            rows: [],
            flatRows: [],
            rowsById: {}
          };
        }

        return selectRowsFn(table, rowModel);
      }, {
        key: process.env.NODE_ENV === 'production' && 'getGroupedSelectedRowModel',
        debug: () => {
          var _table$options$debugA3;

          return (_table$options$debugA3 = table.options.debugAll) != null ? _table$options$debugA3 : table.options.debugTable;
        }
      }),
      ///
      // getGroupingRowCanSelect: rowId => {
      //   const row = table.getRow(rowId)
      //   if (!row) {
      //     throw new Error()
      //   }
      //   if (typeof table.options.enableGroupingRowSelection === 'function') {
      //     return table.options.enableGroupingRowSelection(row)
      //   }
      //   return table.options.enableGroupingRowSelection ?? false
      // },
      getIsAllRowsSelected: () => {
        const preGroupedFlatRows = table.getFilteredRowModel().flatRows;
        const {
          rowSelection
        } = table.getState();
        let isAllRowsSelected = Boolean(preGroupedFlatRows.length && Object.keys(rowSelection).length);

        if (isAllRowsSelected) {
          if (preGroupedFlatRows.some(row => row.getCanSelect() && !rowSelection[row.id])) {
            isAllRowsSelected = false;
          }
        }

        return isAllRowsSelected;
      },
      getIsAllPageRowsSelected: () => {
        const paginationFlatRows = table.getPaginationRowModel().flatRows;
        const {
          rowSelection
        } = table.getState();
        let isAllPageRowsSelected = !!paginationFlatRows.length;

        if (isAllPageRowsSelected && paginationFlatRows.some(row => !rowSelection[row.id])) {
          isAllPageRowsSelected = false;
        }

        return isAllPageRowsSelected;
      },
      getIsSomeRowsSelected: () => {
        var _table$getState$rowSe;

        const totalSelected = Object.keys((_table$getState$rowSe = table.getState().rowSelection) != null ? _table$getState$rowSe : {}).length;
        return totalSelected > 0 && totalSelected < table.getFilteredRowModel().flatRows.length;
      },
      getIsSomePageRowsSelected: () => {
        const paginationFlatRows = table.getPaginationRowModel().flatRows;
        return table.getIsAllPageRowsSelected() ? false : paginationFlatRows.some(d => d.getIsSelected() || d.getIsSomeSelected());
      },
      getToggleAllRowsSelectedHandler: () => {
        return e => {
          table.toggleAllRowsSelected(e.target.checked);
        };
      },
      getToggleAllPageRowsSelectedHandler: () => {
        return e => {
          table.toggleAllPageRowsSelected(e.target.checked);
        };
      }
    };
  },
  createRow: (row, table) => {
    return {
      toggleSelected: value => {
        const isSelected = row.getIsSelected();
        table.setRowSelection(old => {
          value = typeof value !== 'undefined' ? value : !isSelected;

          if (isSelected === value) {
            return old;
          }

          const selectedRowIds = { ...old
          };
          mutateRowIsSelected(selectedRowIds, row.id, value, table);
          return selectedRowIds;
        });
      },
      getIsSelected: () => {
        const {
          rowSelection
        } = table.getState();
        return isRowSelected(row, rowSelection);
      },
      getIsSomeSelected: () => {
        const {
          rowSelection
        } = table.getState();
        return isSubRowSelected(row, rowSelection) === 'some';
      },
      getIsAllSubRowsSelected: () => {
        const {
          rowSelection
        } = table.getState();
        return isSubRowSelected(row, rowSelection) === 'all';
      },
      getCanSelect: () => {
        var _table$options$enable;

        if (typeof table.options.enableRowSelection === 'function') {
          return table.options.enableRowSelection(row);
        }

        return (_table$options$enable = table.options.enableRowSelection) != null ? _table$options$enable : true;
      },
      getCanSelectSubRows: () => {
        var _table$options$enable2;

        if (typeof table.options.enableSubRowSelection === 'function') {
          return table.options.enableSubRowSelection(row);
        }

        return (_table$options$enable2 = table.options.enableSubRowSelection) != null ? _table$options$enable2 : true;
      },
      getCanMultiSelect: () => {
        var _table$options$enable3;

        if (typeof table.options.enableMultiRowSelection === 'function') {
          return table.options.enableMultiRowSelection(row);
        }

        return (_table$options$enable3 = table.options.enableMultiRowSelection) != null ? _table$options$enable3 : true;
      },
      getToggleSelectedHandler: () => {
        const canSelect = row.getCanSelect();
        return e => {
          var _target;

          if (!canSelect) return;
          row.toggleSelected((_target = e.target) == null ? void 0 : _target.checked);
        };
      }
    };
  }
};

const mutateRowIsSelected = (selectedRowIds, id, value, table) => {
  var _row$subRows;

  const row = table.getRow(id); // const isGrouped = row.getIsGrouped()
  // if ( // TODO: enforce grouping row selection rules
  //   !isGrouped ||
  //   (isGrouped && table.options.enableGroupingRowSelection)
  // ) {

  if (value) {
    if (!row.getCanMultiSelect()) {
      Object.keys(selectedRowIds).forEach(key => delete selectedRowIds[key]);
    }

    if (row.getCanSelect()) {
      selectedRowIds[id] = true;
    }
  } else {
    delete selectedRowIds[id];
  } // }


  if ((_row$subRows = row.subRows) != null && _row$subRows.length && row.getCanSelectSubRows()) {
    row.subRows.forEach(row => mutateRowIsSelected(selectedRowIds, row.id, value, table));
  }
};

function selectRowsFn(table, rowModel) {
  const rowSelection = table.getState().rowSelection;
  const newSelectedFlatRows = [];
  const newSelectedRowsById = {}; // Filters top level and nested rows

  const recurseRows = function (rows, depth) {

    return rows.map(row => {
      var _row$subRows2;

      const isSelected = isRowSelected(row, rowSelection);

      if (isSelected) {
        newSelectedFlatRows.push(row);
        newSelectedRowsById[row.id] = row;
      }

      if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length) {
        row = { ...row,
          subRows: recurseRows(row.subRows)
        };
      }

      if (isSelected) {
        return row;
      }
    }).filter(Boolean);
  };

  return {
    rows: recurseRows(rowModel.rows),
    flatRows: newSelectedFlatRows,
    rowsById: newSelectedRowsById
  };
}
function isRowSelected(row, selection) {
  var _selection$row$id;

  return (_selection$row$id = selection[row.id]) != null ? _selection$row$id : false;
}
function isSubRowSelected(row, selection, table) {
  if (row.subRows && row.subRows.length) {
    let allChildrenSelected = true;
    let someSelected = false;
    row.subRows.forEach(subRow => {
      // Bail out early if we know both of these
      if (someSelected && !allChildrenSelected) {
        return;
      }

      if (isRowSelected(subRow, selection)) {
        someSelected = true;
      } else {
        allChildrenSelected = false;
      }
    });
    return allChildrenSelected ? 'all' : someSelected ? 'some' : false;
  }

  return false;
}

const reSplitAlphaNumeric = /([0-9]+)/gm;

const alphanumeric = (rowA, rowB, columnId) => {
  return compareAlphanumeric(toString$1(rowA.getValue(columnId)).toLowerCase(), toString$1(rowB.getValue(columnId)).toLowerCase());
};

const alphanumericCaseSensitive = (rowA, rowB, columnId) => {
  return compareAlphanumeric(toString$1(rowA.getValue(columnId)), toString$1(rowB.getValue(columnId)));
}; // The text filter is more basic (less numeric support)
// but is much faster


const text = (rowA, rowB, columnId) => {
  return compareBasic(toString$1(rowA.getValue(columnId)).toLowerCase(), toString$1(rowB.getValue(columnId)).toLowerCase());
}; // The text filter is more basic (less numeric support)
// but is much faster


const textCaseSensitive = (rowA, rowB, columnId) => {
  return compareBasic(toString$1(rowA.getValue(columnId)), toString$1(rowB.getValue(columnId)));
};

const datetime = (rowA, rowB, columnId) => {
  const a = rowA.getValue(columnId);
  const b = rowB.getValue(columnId); // Can handle nullish values
  // Use > and < because == (and ===) doesn't work with
  // Date objects (would require calling getTime()).

  return a > b ? 1 : a < b ? -1 : 0;
};

const basic = (rowA, rowB, columnId) => {
  return compareBasic(rowA.getValue(columnId), rowB.getValue(columnId));
}; // Utils


function compareBasic(a, b) {
  return a === b ? 0 : a > b ? 1 : -1;
}

function toString$1(a) {
  if (typeof a === 'number') {
    if (isNaN(a) || a === Infinity || a === -Infinity) {
      return '';
    }

    return String(a);
  }

  if (typeof a === 'string') {
    return a;
  }

  return '';
} // Mixed sorting is slow, but very inclusive of many edge cases.
// It handles numbers, mixed alphanumeric combinations, and even
// null, undefined, and Infinity


function compareAlphanumeric(aStr, bStr) {
  // Split on number groups, but keep the delimiter
  // Then remove falsey split values
  const a = aStr.split(reSplitAlphaNumeric).filter(Boolean);
  const b = bStr.split(reSplitAlphaNumeric).filter(Boolean); // While

  while (a.length && b.length) {
    const aa = a.shift();
    const bb = b.shift();
    const an = parseInt(aa, 10);
    const bn = parseInt(bb, 10);
    const combo = [an, bn].sort(); // Both are string

    if (isNaN(combo[0])) {
      if (aa > bb) {
        return 1;
      }

      if (bb > aa) {
        return -1;
      }

      continue;
    } // One is a string, one is a number


    if (isNaN(combo[1])) {
      return isNaN(an) ? -1 : 1;
    } // Both are numbers


    if (an > bn) {
      return 1;
    }

    if (bn > an) {
      return -1;
    }
  }

  return a.length - b.length;
} // Exports


const sortingFns = {
  alphanumeric,
  alphanumericCaseSensitive,
  text,
  textCaseSensitive,
  datetime,
  basic
};

//
const Sorting = {
  getInitialState: state => {
    return {
      sorting: [],
      ...state
    };
  },
  getDefaultColumnDef: () => {
    return {
      sortingFn: 'auto'
    };
  },
  getDefaultOptions: table => {
    return {
      onSortingChange: makeStateUpdater('sorting', table),
      isMultiSortEvent: e => {
        return e.shiftKey;
      }
    };
  },
  createColumn: (column, table) => {
    return {
      getAutoSortingFn: () => {
        const firstRows = table.getFilteredRowModel().flatRows.slice(10);
        let isString = false;

        for (const row of firstRows) {
          const value = row == null ? void 0 : row.getValue(column.id);

          if (Object.prototype.toString.call(value) === '[object Date]') {
            return sortingFns.datetime;
          }

          if (typeof value === 'string') {
            isString = true;

            if (value.split(reSplitAlphaNumeric).length > 1) {
              return sortingFns.alphanumeric;
            }
          }
        }

        if (isString) {
          return sortingFns.text;
        }

        return sortingFns.basic;
      },
      getAutoSortDir: () => {
        const firstRow = table.getFilteredRowModel().flatRows[0];
        const value = firstRow == null ? void 0 : firstRow.getValue(column.id);

        if (typeof value === 'string') {
          return 'asc';
        }

        return 'desc';
      },
      getSortingFn: () => {
        var _table$options$sortin, _table$options$sortin2;

        if (!column) {
          throw new Error();
        }

        return isFunction(column.columnDef.sortingFn) ? column.columnDef.sortingFn : column.columnDef.sortingFn === 'auto' ? column.getAutoSortingFn() : (_table$options$sortin = (_table$options$sortin2 = table.options.sortingFns) == null ? void 0 : _table$options$sortin2[column.columnDef.sortingFn]) != null ? _table$options$sortin : sortingFns[column.columnDef.sortingFn];
      },
      toggleSorting: (desc, multi) => {
        // if (column.columns.length) {
        //   column.columns.forEach((c, i) => {
        //     if (c.id) {
        //       table.toggleColumnSorting(c.id, undefined, multi || !!i)
        //     }
        //   })
        //   return
        // }
        // this needs to be outside of table.setSorting to be in sync with rerender
        const nextSortingOrder = column.getNextSortingOrder();
        const hasManualValue = typeof desc !== 'undefined' && desc !== null;
        table.setSorting(old => {
          // Find any existing sorting for this column
          const existingSorting = old == null ? void 0 : old.find(d => d.id === column.id);
          const existingIndex = old == null ? void 0 : old.findIndex(d => d.id === column.id);
          let newSorting = []; // What should we do with this sort action?

          let sortAction;
          let nextDesc = hasManualValue ? desc : nextSortingOrder === 'desc'; // Multi-mode

          if (old != null && old.length && column.getCanMultiSort() && multi) {
            if (existingSorting) {
              sortAction = 'toggle';
            } else {
              sortAction = 'add';
            }
          } else {
            // Normal mode
            if (old != null && old.length && existingIndex !== old.length - 1) {
              sortAction = 'replace';
            } else if (existingSorting) {
              sortAction = 'toggle';
            } else {
              sortAction = 'replace';
            }
          } // Handle toggle states that will remove the sorting


          if (sortAction === 'toggle') {
            // If we are "actually" toggling (not a manual set value), should we remove the sorting?
            if (!hasManualValue) {
              // Is our intention to remove?
              if (!nextSortingOrder) {
                sortAction = 'remove';
              }
            }
          }

          if (sortAction === 'add') {
            var _table$options$maxMul;

            newSorting = [...old, {
              id: column.id,
              desc: nextDesc
            }]; // Take latest n columns

            newSorting.splice(0, newSorting.length - ((_table$options$maxMul = table.options.maxMultiSortColCount) != null ? _table$options$maxMul : Number.MAX_SAFE_INTEGER));
          } else if (sortAction === 'toggle') {
            // This flips (or sets) the
            newSorting = old.map(d => {
              if (d.id === column.id) {
                return { ...d,
                  desc: nextDesc
                };
              }

              return d;
            });
          } else if (sortAction === 'remove') {
            newSorting = old.filter(d => d.id !== column.id);
          } else {
            newSorting = [{
              id: column.id,
              desc: nextDesc
            }];
          }

          return newSorting;
        });
      },
      getFirstSortDir: () => {
        var _ref, _column$columnDef$sor;

        const sortDescFirst = (_ref = (_column$columnDef$sor = column.columnDef.sortDescFirst) != null ? _column$columnDef$sor : table.options.sortDescFirst) != null ? _ref : column.getAutoSortDir() === 'desc';
        return sortDescFirst ? 'desc' : 'asc';
      },
      getNextSortingOrder: multi => {
        var _table$options$enable, _table$options$enable2;

        const firstSortDirection = column.getFirstSortDir();
        const isSorted = column.getIsSorted();

        if (!isSorted) {
          return firstSortDirection;
        }

        if (isSorted !== firstSortDirection && ((_table$options$enable = table.options.enableSortingRemoval) != null ? _table$options$enable : true) && ( // If enableSortRemove, enable in general
        multi ? (_table$options$enable2 = table.options.enableMultiRemove) != null ? _table$options$enable2 : true : true) // If multi, don't allow if enableMultiRemove))
        ) {
          return false;
        }

        return isSorted === 'desc' ? 'asc' : 'desc';
      },
      getCanSort: () => {
        var _column$columnDef$ena, _table$options$enable3;

        return ((_column$columnDef$ena = column.columnDef.enableSorting) != null ? _column$columnDef$ena : true) && ((_table$options$enable3 = table.options.enableSorting) != null ? _table$options$enable3 : true) && !!column.accessorFn;
      },
      getCanMultiSort: () => {
        var _ref2, _column$columnDef$ena2;

        return (_ref2 = (_column$columnDef$ena2 = column.columnDef.enableMultiSort) != null ? _column$columnDef$ena2 : table.options.enableMultiSort) != null ? _ref2 : !!column.accessorFn;
      },
      getIsSorted: () => {
        var _table$getState$sorti;

        const columnSort = (_table$getState$sorti = table.getState().sorting) == null ? void 0 : _table$getState$sorti.find(d => d.id === column.id);
        return !columnSort ? false : columnSort.desc ? 'desc' : 'asc';
      },
      getSortIndex: () => {
        var _table$getState$sorti2, _table$getState$sorti3;

        return (_table$getState$sorti2 = (_table$getState$sorti3 = table.getState().sorting) == null ? void 0 : _table$getState$sorti3.findIndex(d => d.id === column.id)) != null ? _table$getState$sorti2 : -1;
      },
      clearSorting: () => {
        //clear sorting for just 1 column
        table.setSorting(old => old != null && old.length ? old.filter(d => d.id !== column.id) : []);
      },
      getToggleSortingHandler: () => {
        const canSort = column.getCanSort();
        return e => {
          if (!canSort) return;
          e.persist == null ? void 0 : e.persist();
          column.toggleSorting == null ? void 0 : column.toggleSorting(undefined, column.getCanMultiSort() ? table.options.isMultiSortEvent == null ? void 0 : table.options.isMultiSortEvent(e) : false);
        };
      }
    };
  },
  createTable: table => {
    return {
      setSorting: updater => table.options.onSortingChange == null ? void 0 : table.options.onSortingChange(updater),
      resetSorting: defaultState => {
        var _table$initialState$s, _table$initialState;

        table.setSorting(defaultState ? [] : (_table$initialState$s = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.sorting) != null ? _table$initialState$s : []);
      },
      getPreSortedRowModel: () => table.getGroupedRowModel(),
      getSortedRowModel: () => {
        if (!table._getSortedRowModel && table.options.getSortedRowModel) {
          table._getSortedRowModel = table.options.getSortedRowModel(table);
        }

        if (table.options.manualSorting || !table._getSortedRowModel) {
          return table.getPreSortedRowModel();
        }

        return table._getSortedRowModel();
      }
    };
  }
};

//
const Visibility = {
  getInitialState: state => {
    return {
      columnVisibility: {},
      ...state
    };
  },
  getDefaultOptions: table => {
    return {
      onColumnVisibilityChange: makeStateUpdater('columnVisibility', table)
    };
  },
  createColumn: (column, table) => {
    return {
      toggleVisibility: value => {
        if (column.getCanHide()) {
          table.setColumnVisibility(old => ({ ...old,
            [column.id]: value != null ? value : !column.getIsVisible()
          }));
        }
      },
      getIsVisible: () => {
        var _table$getState$colum, _table$getState$colum2;

        return (_table$getState$colum = (_table$getState$colum2 = table.getState().columnVisibility) == null ? void 0 : _table$getState$colum2[column.id]) != null ? _table$getState$colum : true;
      },
      getCanHide: () => {
        var _column$columnDef$ena, _table$options$enable;

        return ((_column$columnDef$ena = column.columnDef.enableHiding) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableHiding) != null ? _table$options$enable : true);
      },
      getToggleVisibilityHandler: () => {
        return e => {
          column.toggleVisibility == null ? void 0 : column.toggleVisibility(e.target.checked);
        };
      }
    };
  },
  createRow: (row, table) => {
    return {
      _getAllVisibleCells: memo(() => [row.getAllCells(), table.getState().columnVisibility], cells => {
        return cells.filter(cell => cell.column.getIsVisible());
      }, {
        key: process.env.NODE_ENV === 'production' && 'row._getAllVisibleCells',
        debug: () => {
          var _table$options$debugA;

          return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugRows;
        }
      }),
      getVisibleCells: memo(() => [row.getLeftVisibleCells(), row.getCenterVisibleCells(), row.getRightVisibleCells()], (left, center, right) => [...left, ...center, ...right], {
        key: process.env.NODE_ENV === 'development' && 'row.getVisibleCells',
        debug: () => {
          var _table$options$debugA2;

          return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugRows;
        }
      })
    };
  },
  createTable: table => {
    const makeVisibleColumnsMethod = (key, getColumns) => {
      return memo(() => [getColumns(), getColumns().filter(d => d.getIsVisible()).map(d => d.id).join('_')], columns => {
        return columns.filter(d => d.getIsVisible == null ? void 0 : d.getIsVisible());
      }, {
        key,
        debug: () => {
          var _table$options$debugA3;

          return (_table$options$debugA3 = table.options.debugAll) != null ? _table$options$debugA3 : table.options.debugColumns;
        }
      });
    };

    return {
      getVisibleFlatColumns: makeVisibleColumnsMethod('getVisibleFlatColumns', () => table.getAllFlatColumns()),
      getVisibleLeafColumns: makeVisibleColumnsMethod('getVisibleLeafColumns', () => table.getAllLeafColumns()),
      getLeftVisibleLeafColumns: makeVisibleColumnsMethod('getLeftVisibleLeafColumns', () => table.getLeftLeafColumns()),
      getRightVisibleLeafColumns: makeVisibleColumnsMethod('getRightVisibleLeafColumns', () => table.getRightLeafColumns()),
      getCenterVisibleLeafColumns: makeVisibleColumnsMethod('getCenterVisibleLeafColumns', () => table.getCenterLeafColumns()),
      setColumnVisibility: updater => table.options.onColumnVisibilityChange == null ? void 0 : table.options.onColumnVisibilityChange(updater),
      resetColumnVisibility: defaultState => {
        var _table$initialState$c;

        table.setColumnVisibility(defaultState ? {} : (_table$initialState$c = table.initialState.columnVisibility) != null ? _table$initialState$c : {});
      },
      toggleAllColumnsVisible: value => {
        var _value;

        value = (_value = value) != null ? _value : !table.getIsAllColumnsVisible();
        table.setColumnVisibility(table.getAllLeafColumns().reduce((obj, column) => ({ ...obj,
          [column.id]: !value ? !(column.getCanHide != null && column.getCanHide()) : value
        }), {}));
      },
      getIsAllColumnsVisible: () => !table.getAllLeafColumns().some(column => !(column.getIsVisible != null && column.getIsVisible())),
      getIsSomeColumnsVisible: () => table.getAllLeafColumns().some(column => column.getIsVisible == null ? void 0 : column.getIsVisible()),
      getToggleAllColumnsVisibilityHandler: () => {
        return e => {
          var _target;

          table.toggleAllColumnsVisible((_target = e.target) == null ? void 0 : _target.checked);
        };
      }
    };
  }
};

const features = [Headers, Visibility, Ordering, Pinning, Filters, Sorting, Grouping, Expanding, Pagination, RowSelection, ColumnSizing]; //

function createTable$1(options) {
  var _options$initialState;

  if (options.debugAll || options.debugTable) {
    console.info('Creating Table Instance...');
  }

  let table = {
    _features: features
  };

  const defaultOptions = table._features.reduce((obj, feature) => {
    return Object.assign(obj, feature.getDefaultOptions == null ? void 0 : feature.getDefaultOptions(table));
  }, {});

  const mergeOptions = options => {
    if (table.options.mergeOptions) {
      return table.options.mergeOptions(defaultOptions, options);
    }

    return { ...defaultOptions,
      ...options
    };
  };

  const coreInitialState = {};
  let initialState = { ...coreInitialState,
    ...((_options$initialState = options.initialState) != null ? _options$initialState : {})
  };

  table._features.forEach(feature => {
    var _feature$getInitialSt;

    initialState = (_feature$getInitialSt = feature.getInitialState == null ? void 0 : feature.getInitialState(initialState)) != null ? _feature$getInitialSt : initialState;
  });

  const queued = [];
  let queuedTimeout = false;
  const coreInstance = {
    _features: features,
    options: { ...defaultOptions,
      ...options
    },
    initialState,
    _queue: cb => {
      queued.push(cb);

      if (!queuedTimeout) {
        queuedTimeout = true; // Schedule a microtask to run the queued callbacks after
        // the current call stack (render, etc) has finished.

        Promise.resolve().then(() => {
          while (queued.length) {
            queued.shift()();
          }

          queuedTimeout = false;
        }).catch(error => setTimeout(() => {
          throw error;
        }));
      }
    },
    reset: () => {
      table.setState(table.initialState);
    },
    setOptions: updater => {
      const newOptions = functionalUpdate(updater, table.options);
      table.options = mergeOptions(newOptions);
    },
    getState: () => {
      return table.options.state;
    },
    setState: updater => {
      table.options.onStateChange == null ? void 0 : table.options.onStateChange(updater);
    },
    _getRowId: (row, index, parent) => {
      var _table$options$getRow;

      return (_table$options$getRow = table.options.getRowId == null ? void 0 : table.options.getRowId(row, index, parent)) != null ? _table$options$getRow : "" + (parent ? [parent.id, index].join('.') : index);
    },
    getCoreRowModel: () => {
      if (!table._getCoreRowModel) {
        table._getCoreRowModel = table.options.getCoreRowModel(table);
      }

      return table._getCoreRowModel();
    },
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => {
      return table.getPaginationRowModel();
    },
    getRow: id => {
      const row = table.getRowModel().rowsById[id];

      if (!row) {
        if (process.env.NODE_ENV !== 'production') {
          throw new Error("getRow expected an ID, but got " + id);
        }

        throw new Error();
      }

      return row;
    },
    _getDefaultColumnDef: memo(() => [table.options.defaultColumn], defaultColumn => {
      var _defaultColumn;

      defaultColumn = (_defaultColumn = defaultColumn) != null ? _defaultColumn : {};
      return {
        header: props => {
          const resolvedColumnDef = props.header.column.columnDef;

          if (resolvedColumnDef.accessorKey) {
            return resolvedColumnDef.accessorKey;
          }

          if (resolvedColumnDef.accessorFn) {
            return resolvedColumnDef.id;
          }

          return null;
        },
        // footer: props => props.header.column.id,
        cell: props => {
          var _props$renderValue$to, _props$renderValue;

          return (_props$renderValue$to = (_props$renderValue = props.renderValue()) == null ? void 0 : _props$renderValue.toString == null ? void 0 : _props$renderValue.toString()) != null ? _props$renderValue$to : null;
        },
        ...table._features.reduce((obj, feature) => {
          return Object.assign(obj, feature.getDefaultColumnDef == null ? void 0 : feature.getDefaultColumnDef());
        }, {}),
        ...defaultColumn
      };
    }, {
      debug: () => {
        var _table$options$debugA;

        return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugColumns;
      },
      key: process.env.NODE_ENV === 'development' && 'getDefaultColumnDef'
    }),
    _getColumnDefs: () => table.options.columns,
    getAllColumns: memo(() => [table._getColumnDefs()], columnDefs => {
      const recurseColumns = function (columnDefs, parent, depth) {
        if (depth === void 0) {
          depth = 0;
        }

        return columnDefs.map(columnDef => {
          const column = createColumn(table, columnDef, depth, parent);
          const groupingColumnDef = columnDef;
          column.columns = groupingColumnDef.columns ? recurseColumns(groupingColumnDef.columns, column, depth + 1) : [];
          return column;
        });
      };

      return recurseColumns(columnDefs);
    }, {
      key: process.env.NODE_ENV === 'development' && 'getAllColumns',
      debug: () => {
        var _table$options$debugA2;

        return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugColumns;
      }
    }),
    getAllFlatColumns: memo(() => [table.getAllColumns()], allColumns => {
      return allColumns.flatMap(column => {
        return column.getFlatColumns();
      });
    }, {
      key: process.env.NODE_ENV === 'development' && 'getAllFlatColumns',
      debug: () => {
        var _table$options$debugA3;

        return (_table$options$debugA3 = table.options.debugAll) != null ? _table$options$debugA3 : table.options.debugColumns;
      }
    }),
    _getAllFlatColumnsById: memo(() => [table.getAllFlatColumns()], flatColumns => {
      return flatColumns.reduce((acc, column) => {
        acc[column.id] = column;
        return acc;
      }, {});
    }, {
      key: process.env.NODE_ENV === 'development' && 'getAllFlatColumnsById',
      debug: () => {
        var _table$options$debugA4;

        return (_table$options$debugA4 = table.options.debugAll) != null ? _table$options$debugA4 : table.options.debugColumns;
      }
    }),
    getAllLeafColumns: memo(() => [table.getAllColumns(), table._getOrderColumnsFn()], (allColumns, orderColumns) => {
      let leafColumns = allColumns.flatMap(column => column.getLeafColumns());
      return orderColumns(leafColumns);
    }, {
      key: process.env.NODE_ENV === 'development' && 'getAllLeafColumns',
      debug: () => {
        var _table$options$debugA5;

        return (_table$options$debugA5 = table.options.debugAll) != null ? _table$options$debugA5 : table.options.debugColumns;
      }
    }),
    getColumn: columnId => {
      const column = table._getAllFlatColumnsById()[columnId];

      if (!column) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn("[Table] Column with id " + columnId + " does not exist.");
        }

        throw new Error();
      }

      return column;
    }
  };
  Object.assign(table, coreInstance);

  table._features.forEach(feature => {
    return Object.assign(table, feature.createTable == null ? void 0 : feature.createTable(table));
  });

  return table;
}

function createCell(table, row, column, columnId) {
  const getRenderValue = () => {
    var _cell$getValue;

    return (_cell$getValue = cell.getValue()) != null ? _cell$getValue : table.options.renderFallbackValue;
  };

  const cell = {
    id: row.id + "_" + column.id,
    row,
    column,
    getValue: () => row.getValue(columnId),
    renderValue: getRenderValue,
    getContext: () => ({
      table,
      column,
      row,
      cell: cell,
      getValue: cell.getValue,
      renderValue: cell.renderValue
    })
  };

  table._features.forEach(feature => {
    Object.assign(cell, feature.createCell == null ? void 0 : feature.createCell(cell, column, row, table));
  }, {});

  return cell;
}

const createRow = (table, id, original, rowIndex, depth, subRows) => {
  let row = {
    id,
    index: rowIndex,
    original,
    depth,
    _valuesCache: {},
    getValue: columnId => {
      if (row._valuesCache.hasOwnProperty(columnId)) {
        return row._valuesCache[columnId];
      }

      const column = table.getColumn(columnId);

      if (!column.accessorFn) {
        return undefined;
      }

      row._valuesCache[columnId] = column.accessorFn(row.original, rowIndex);
      return row._valuesCache[columnId];
    },
    renderValue: columnId => {
      var _row$getValue;

      return (_row$getValue = row.getValue(columnId)) != null ? _row$getValue : table.options.renderFallbackValue;
    },
    subRows: subRows != null ? subRows : [],
    getLeafRows: () => flattenBy(row.subRows, d => d.subRows),
    getAllCells: memo(() => [table.getAllLeafColumns()], leafColumns => {
      return leafColumns.map(column => {
        return createCell(table, row, column, column.id);
      });
    }, {
      key: process.env.NODE_ENV === 'development' && 'row.getAllCells',
      debug: () => {
        var _table$options$debugA;

        return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugRows;
      }
    }),
    _getAllCellsByColumnId: memo(() => [row.getAllCells()], allCells => {
      return allCells.reduce((acc, cell) => {
        acc[cell.column.id] = cell;
        return acc;
      }, {});
    }, {
      key: process.env.NODE_ENV === 'production' && 'row.getAllCellsByColumnId',
      debug: () => {
        var _table$options$debugA2;

        return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugRows;
      }
    })
  };

  for (let i = 0; i < table._features.length; i++) {
    const feature = table._features[i];
    Object.assign(row, feature == null ? void 0 : feature.createRow == null ? void 0 : feature.createRow(row, table));
  }

  return row;
};

function getCoreRowModel() {
  return table => memo(() => [table.options.data], data => {
    const rowModel = {
      rows: [],
      flatRows: [],
      rowsById: {}
    };

    const accessRows = function (originalRows, depth, parent) {
      if (depth === void 0) {
        depth = 0;
      }

      const rows = [];

      for (let i = 0; i < originalRows.length; i++) {
        // This could be an expensive check at scale, so we should move it somewhere else, but where?
        // if (!id) {
        //   if (process.env.NODE_ENV !== 'production') {
        //     throw new Error(`getRowId expected an ID, but got ${id}`)
        //   }
        // }
        // Make the row
        const row = createRow(table, table._getRowId(originalRows[i], i, parent), originalRows[i], i, depth); // Keep track of every row in a flat array

        rowModel.flatRows.push(row); // Also keep track of every row by its ID

        rowModel.rowsById[row.id] = row; // Push table row into parent

        rows.push(row); // Get the original subrows

        if (table.options.getSubRows) {
          var _row$originalSubRows;

          row.originalSubRows = table.options.getSubRows(originalRows[i], i); // Then recursively access them

          if ((_row$originalSubRows = row.originalSubRows) != null && _row$originalSubRows.length) {
            row.subRows = accessRows(row.originalSubRows, depth + 1, row);
          }
        }
      }

      return rows;
    };

    rowModel.rows = accessRows(data);
    return rowModel;
  }, {
    key: process.env.NODE_ENV === 'development' && 'getRowModel',
    debug: () => {
      var _table$options$debugA;

      return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
    },
    onChange: () => {
      table._autoResetPageIndex();
    }
  });
}

function getSortedRowModel() {
  return table => memo(() => [table.getState().sorting, table.getPreSortedRowModel()], (sorting, rowModel) => {
    if (!rowModel.rows.length || !(sorting != null && sorting.length)) {
      return rowModel;
    }

    const sortingState = table.getState().sorting;
    const sortedFlatRows = []; // Filter out sortings that correspond to non existing columns

    const availableSorting = sortingState.filter(sort => table.getColumn(sort.id).getCanSort());
    const columnInfoById = {};
    availableSorting.forEach(sortEntry => {
      const column = table.getColumn(sortEntry.id);
      columnInfoById[sortEntry.id] = {
        sortUndefined: column.columnDef.sortUndefined,
        invertSorting: column.columnDef.invertSorting,
        sortingFn: column.getSortingFn()
      };
    });

    const sortData = rows => {
      // This will also perform a stable sorting using the row index
      // if needed.
      const sortedData = rows.slice();
      sortedData.sort((rowA, rowB) => {
        for (let i = 0; i < availableSorting.length; i += 1) {
          var _sortEntry$desc;

          const sortEntry = availableSorting[i];
          const columnInfo = columnInfoById[sortEntry.id];
          const isDesc = (_sortEntry$desc = sortEntry == null ? void 0 : sortEntry.desc) != null ? _sortEntry$desc : false;

          if (columnInfo.sortUndefined) {
            const aValue = rowA.getValue(sortEntry.id);
            const bValue = rowB.getValue(sortEntry.id);
            const aUndefined = typeof aValue === 'undefined';
            const bUndefined = typeof bValue === 'undefined';

            if (aUndefined || bUndefined) {
              return aUndefined && bUndefined ? 0 : aUndefined ? columnInfo.sortUndefined : -columnInfo.sortUndefined;
            }
          } // This function should always return in ascending order


          let sortInt = columnInfo.sortingFn(rowA, rowB, sortEntry.id);

          if (sortInt !== 0) {
            if (isDesc) {
              sortInt *= -1;
            }

            if (columnInfo.invertSorting) {
              sortInt *= -1;
            }

            return sortInt;
          }
        }

        return rowA.index - rowB.index;
      }); // If there are sub-rows, sort them

      sortedData.forEach(row => {
        sortedFlatRows.push(row);

        if (!row.subRows || row.subRows.length <= 1) {
          return;
        }

        row.subRows = sortData(row.subRows);
      });
      return sortedData;
    };

    return {
      rows: sortData(rowModel.rows),
      flatRows: sortedFlatRows,
      rowsById: rowModel.rowsById
    };
  }, {
    key: process.env.NODE_ENV === 'development' && 'getSortedRowModel',
    debug: () => {
      var _table$options$debugA;

      return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
    },
    onChange: () => {
      table._autoResetPageIndex();
    }
  });
}

function getExpandedRowModel() {
  return table => memo(() => [table.getState().expanded, table.getPreExpandedRowModel(), table.options.paginateExpandedRows], (expanded, rowModel, paginateExpandedRows) => {
    if (!rowModel.rows.length || expanded !== true && !Object.keys(expanded != null ? expanded : {}).length) {
      return rowModel;
    }

    if (!paginateExpandedRows) {
      // Only expand rows at this point if they are being paginated
      return rowModel;
    }

    return expandRows(rowModel);
  }, {
    key: process.env.NODE_ENV === 'development' && 'getExpandedRowModel',
    debug: () => {
      var _table$options$debugA;

      return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
    }
  });
}
function expandRows(rowModel) {
  const expandedRows = [];

  const handleRow = row => {
    var _row$subRows;

    expandedRows.push(row);

    if ((_row$subRows = row.subRows) != null && _row$subRows.length && row.getIsExpanded()) {
      row.subRows.forEach(handleRow);
    }
  };

  rowModel.rows.forEach(handleRow);
  return {
    rows: expandedRows,
    flatRows: rowModel.flatRows,
    rowsById: rowModel.rowsById
  };
}

function getPaginationRowModel(opts) {
  return table => memo(() => [table.getState().pagination, table.getPrePaginationRowModel(), table.options.paginateExpandedRows ? undefined : table.getState().expanded], (pagination, rowModel) => {
    if (!rowModel.rows.length) {
      return rowModel;
    }

    const {
      pageSize,
      pageIndex
    } = pagination;
    let {
      rows,
      flatRows,
      rowsById
    } = rowModel;
    const pageStart = pageSize * pageIndex;
    const pageEnd = pageStart + pageSize;
    rows = rows.slice(pageStart, pageEnd);
    let paginatedRowModel;

    if (!table.options.paginateExpandedRows) {
      paginatedRowModel = expandRows({
        rows,
        flatRows,
        rowsById
      });
    } else {
      paginatedRowModel = {
        rows,
        flatRows,
        rowsById
      };
    }

    paginatedRowModel.flatRows = [];

    const handleRow = row => {
      paginatedRowModel.flatRows.push(row);

      if (row.subRows.length) {
        row.subRows.forEach(handleRow);
      }
    };

    paginatedRowModel.rows.forEach(handleRow);
    return paginatedRowModel;
  }, {
    key: process.env.NODE_ENV === 'development' && 'getPaginationRowModel',
    debug: () => {
      var _table$options$debugA;

      return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
    }
  });
}

//
function flexRender(Comp, props) {
  return !Comp ? null : isReactComponent(Comp) ? /*#__PURE__*/React.createElement(Comp, props) : Comp;
}

function isReactComponent(component) {
  return isClassComponent(component) || typeof component === 'function' || isExoticComponent(component);
}

function isClassComponent(component) {
  return typeof component === 'function' && (() => {
    const proto = Object.getPrototypeOf(component);
    return proto.prototype && proto.prototype.isReactComponent;
  })();
}

function isExoticComponent(component) {
  return typeof component === 'object' && typeof component.$$typeof === 'symbol' && ['react.memo', 'react.forward_ref'].includes(component.$$typeof.description);
}

function useReactTable(options) {
  // Compose in the generic options to the user options
  const resolvedOptions = {
    state: {},
    // Dummy state
    onStateChange: () => {},
    // noop
    renderFallbackValue: null,
    ...options
  }; // Create a new table and store it in state

  const [tableRef] = React.useState(() => ({
    current: createTable$1(resolvedOptions)
  })); // By default, manage table state here using the table's initial state

  const [state, setState] = React.useState(() => tableRef.current.initialState); // Compose the default state above with any user state. This will allow the user
  // to only control a subset of the state if desired.

  tableRef.current.setOptions(prev => ({ ...prev,
    ...options,
    state: { ...state,
      ...options.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: updater => {
      setState(updater);
      options.onStateChange == null ? void 0 : options.onStateChange(updater);
    }
  }));
  return tableRef.current;
}

/**
 * getSystemUniqueID return a system unique id
 */


function getSystemUniqueID(target) {
  if (!target.kind || target.kind === '') {
    console.log('[getSystemUniqueID] found Identifiable entity with missing kind. entity=', target);
    return target.id;
  }

  return "".concat(target.kind, "-").concat(target.id);
}

var HttpResponse;

(function (HttpResponse) {
  HttpResponse[HttpResponse["HttpNotFound"] = 404] = "HttpNotFound";
})(HttpResponse || (HttpResponse = {}));

var OperatingSystem;

(function (OperatingSystem) {
  OperatingSystem["Windows"] = "windows";
  OperatingSystem["Linux"] = "linux";
  OperatingSystem["Darwin"] = "darwin";
  OperatingSystem["Mac"] = "mac";
  OperatingSystem["Etc"] = "etc";
})(OperatingSystem || (OperatingSystem = {}));
/**
 * Fuse.js v6.4.6 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2021 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */


function isArray(value) {
  return !Array.isArray ? getTag(value) === '[object Array]' : Array.isArray(value);
} // Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js


var INFINITY = 1 / 0;

function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

function toString(value) {
  return value == null ? '' : baseToString(value);
}

function isString$1(value) {
  return typeof value === 'string';
}

function isNumber(value) {
  return typeof value === 'number';
} // Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js


function isBoolean(value) {
  return value === true || value === false || isObjectLike(value) && getTag(value) == '[object Boolean]';
}

function isObject$1(value) {
  return _typeof(value) === 'object';
} // Checks if `value` is object-like.


function isObjectLike(value) {
  return isObject$1(value) && value !== null;
}

function isDefined(value) {
  return value !== undefined && value !== null;
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js


function getTag(value) {
  return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
}

var PATTERN_LENGTH_TOO_LARGE = function PATTERN_LENGTH_TOO_LARGE(max) {
  return "Pattern length exceeds max of ".concat(max, ".");
};

function get(obj, path) {
  var list = [];
  var arr = false;

  var deepGet = function deepGet(obj, path, index) {
    if (!isDefined(obj)) {
      return;
    }

    if (!path[index]) {
      // If there's no path left, we've arrived at the object we care about.
      list.push(obj);
    } else {
      var key = path[index];
      var value = obj[key];

      if (!isDefined(value)) {
        return;
      } // If we're at the last value in the path, and if it's a string/number/bool,
      // add it to the list


      if (index === path.length - 1 && (isString$1(value) || isNumber(value) || isBoolean(value))) {
        list.push(toString(value));
      } else if (isArray(value)) {
        arr = true; // Search each item in the array.

        for (var i = 0, len = value.length; i < len; i += 1) {
          deepGet(value[i], path, index + 1);
        }
      } else if (path.length) {
        // An object. Recurse further.
        deepGet(value, path, index + 1);
      }
    }
  }; // Backwards compatibility (since path used to be a string)


  deepGet(obj, isString$1(path) ? path.split('.') : path, 0);
  return arr ? list : list[0];
}

var MatchOptions = {
  // Whether the matches should be included in the result set. When `true`, each record in the result
  // set will include the indices of the matched characters.
  // These can consequently be used for highlighting purposes.
  includeMatches: false,
  // When `true`, the matching function will continue to the end of a search pattern even if
  // a perfect match has already been located in the string.
  findAllMatches: false,
  // Minimum number of characters that must be matched before a result is considered a match
  minMatchCharLength: 1
};
var BasicOptions = {
  // When `true`, the algorithm continues searching to the end of the input even if a perfect
  // match is found before the end of the same input.
  isCaseSensitive: false,
  // When true, the matching function will continue to the end of a search pattern even if
  includeScore: false,
  // List of properties that will be searched. This also supports nested properties.
  keys: [],
  // Whether to sort the result list, by score
  shouldSort: true,
  // Default sort function: sort by ascending score, ascending index
  sortFn: function sortFn(a, b) {
    return a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1;
  }
};
var FuzzyOptions = {
  // Approximately where in the text is the pattern expected to be found?
  location: 0,
  // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
  // (of both letters and location), a threshold of '1.0' would match anything.
  threshold: 0.6,
  // Determines how close the match must be to the fuzzy location (specified above).
  // An exact letter match which is 'distance' characters away from the fuzzy location
  // would score as a complete mismatch. A distance of '0' requires the match be at
  // the exact location specified, a threshold of '1000' would require a perfect match
  // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
  distance: 100
};
var AdvancedOptions = {
  // When `true`, it enables the use of unix-like search commands
  useExtendedSearch: false,
  // The get function to use when fetching an object's properties.
  // The default will search nested paths *ie foo.bar.baz*
  getFn: get,
  // When `true`, search will ignore `location` and `distance`, so it won't matter
  // where in the string the pattern appears.
  // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
  ignoreLocation: false,
  // When `true`, the calculation for the relevance score (used for sorting) will
  // ignore the field-length norm.
  // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
  ignoreFieldNorm: false
};

var Config = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, BasicOptions), MatchOptions), FuzzyOptions), AdvancedOptions);

function computeScore(pattern) {
  var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref6$errors = _ref6.errors,
      errors = _ref6$errors === void 0 ? 0 : _ref6$errors,
      _ref6$currentLocation = _ref6.currentLocation,
      currentLocation = _ref6$currentLocation === void 0 ? 0 : _ref6$currentLocation,
      _ref6$expectedLocatio = _ref6.expectedLocation,
      expectedLocation = _ref6$expectedLocatio === void 0 ? 0 : _ref6$expectedLocatio,
      _ref6$distance = _ref6.distance,
      distance = _ref6$distance === void 0 ? Config.distance : _ref6$distance,
      _ref6$ignoreLocation = _ref6.ignoreLocation,
      ignoreLocation = _ref6$ignoreLocation === void 0 ? Config.ignoreLocation : _ref6$ignoreLocation;

  var accuracy = errors / pattern.length;

  if (ignoreLocation) {
    return accuracy;
  }

  var proximity = Math.abs(expectedLocation - currentLocation);

  if (!distance) {
    // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
  }

  return accuracy + proximity / distance;
}

function convertMaskToIndices() {
  var matchmask = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var minMatchCharLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Config.minMatchCharLength;
  var indices = [];
  var start = -1;
  var end = -1;
  var i = 0;

  for (var len = matchmask.length; i < len; i += 1) {
    var match = matchmask[i];

    if (match && start === -1) {
      start = i;
    } else if (!match && start !== -1) {
      end = i - 1;

      if (end - start + 1 >= minMatchCharLength) {
        indices.push([start, end]);
      }

      start = -1;
    }
  } // (i-1 - start) + 1 => i - start


  if (matchmask[i - 1] && i - start >= minMatchCharLength) {
    indices.push([start, i - 1]);
  }

  return indices;
} // Machine word size


var MAX_BITS = 32;

function search(text, pattern, patternAlphabet) {
  var _ref7 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref7$location = _ref7.location,
      location = _ref7$location === void 0 ? Config.location : _ref7$location,
      _ref7$distance = _ref7.distance,
      distance = _ref7$distance === void 0 ? Config.distance : _ref7$distance,
      _ref7$threshold = _ref7.threshold,
      threshold = _ref7$threshold === void 0 ? Config.threshold : _ref7$threshold,
      _ref7$findAllMatches = _ref7.findAllMatches,
      findAllMatches = _ref7$findAllMatches === void 0 ? Config.findAllMatches : _ref7$findAllMatches,
      _ref7$minMatchCharLen = _ref7.minMatchCharLength,
      minMatchCharLength = _ref7$minMatchCharLen === void 0 ? Config.minMatchCharLength : _ref7$minMatchCharLen,
      _ref7$includeMatches = _ref7.includeMatches,
      includeMatches = _ref7$includeMatches === void 0 ? Config.includeMatches : _ref7$includeMatches,
      _ref7$ignoreLocation = _ref7.ignoreLocation,
      ignoreLocation = _ref7$ignoreLocation === void 0 ? Config.ignoreLocation : _ref7$ignoreLocation;

  if (pattern.length > MAX_BITS) {
    throw new Error(PATTERN_LENGTH_TOO_LARGE(MAX_BITS));
  }

  var patternLen = pattern.length; // Set starting location at beginning text and initialize the alphabet.

  var textLen = text.length; // Handle the case when location > text.length

  var expectedLocation = Math.max(0, Math.min(location, textLen)); // Highest score beyond which we give up.

  var currentThreshold = threshold; // Is there a nearby exact match? (speedup)

  var bestLocation = expectedLocation; // Performance: only computer matches when the minMatchCharLength > 1
  // OR if `includeMatches` is true.

  var computeMatches = minMatchCharLength > 1 || includeMatches; // A mask of the matches, used for building the indices

  var matchMask = computeMatches ? Array(textLen) : [];
  var index; // Get all exact matches, here for speed up

  while ((index = text.indexOf(pattern, bestLocation)) > -1) {
    var score = computeScore(pattern, {
      currentLocation: index,
      expectedLocation: expectedLocation,
      distance: distance,
      ignoreLocation: ignoreLocation
    });
    currentThreshold = Math.min(score, currentThreshold);
    bestLocation = index + patternLen;

    if (computeMatches) {
      var i = 0;

      while (i < patternLen) {
        matchMask[index + i] = 1;
        i += 1;
      }
    }
  } // Reset the best location


  bestLocation = -1;
  var lastBitArr = [];
  var finalScore = 1;
  var binMax = patternLen + textLen;
  var mask = 1 << patternLen - 1;

  for (var _i2 = 0; _i2 < patternLen; _i2 += 1) {
    // Scan for the best match; each iteration allows for one more error.
    // Run a binary search to determine how far from the match location we can stray
    // at this error level.
    var binMin = 0;
    var binMid = binMax;

    while (binMin < binMid) {
      var _score2 = computeScore(pattern, {
        errors: _i2,
        currentLocation: expectedLocation + binMid,
        expectedLocation: expectedLocation,
        distance: distance,
        ignoreLocation: ignoreLocation
      });

      if (_score2 <= currentThreshold) {
        binMin = binMid;
      } else {
        binMax = binMid;
      }

      binMid = Math.floor((binMax - binMin) / 2 + binMin);
    } // Use the result from this iteration as the maximum for the next.


    binMax = binMid;
    var start = Math.max(1, expectedLocation - binMid + 1);
    var finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen; // Initialize the bit array

    var bitArr = Array(finish + 2);
    bitArr[finish + 1] = (1 << _i2) - 1;

    for (var j = finish; j >= start; j -= 1) {
      var currentLocation = j - 1;
      var charMatch = patternAlphabet[text.charAt(currentLocation)];

      if (computeMatches) {
        // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
        matchMask[currentLocation] = +!!charMatch;
      } // First pass: exact match


      bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch; // Subsequent passes: fuzzy match

      if (_i2) {
        bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
      }

      if (bitArr[j] & mask) {
        finalScore = computeScore(pattern, {
          errors: _i2,
          currentLocation: currentLocation,
          expectedLocation: expectedLocation,
          distance: distance,
          ignoreLocation: ignoreLocation
        }); // This match will almost certainly be better than any existing match.
        // But check anyway.

        if (finalScore <= currentThreshold) {
          // Indeed it is
          currentThreshold = finalScore;
          bestLocation = currentLocation; // Already passed `loc`, downhill from here on in.

          if (bestLocation <= expectedLocation) {
            break;
          } // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.


          start = Math.max(1, 2 * expectedLocation - bestLocation);
        }
      }
    } // No hope for a (better) match at greater error levels.


    var _score = computeScore(pattern, {
      errors: _i2 + 1,
      currentLocation: expectedLocation,
      expectedLocation: expectedLocation,
      distance: distance,
      ignoreLocation: ignoreLocation
    });

    if (_score > currentThreshold) {
      break;
    }

    lastBitArr = bitArr;
  }

  var result = {
    isMatch: bestLocation >= 0,
    // Count exact matches (those with a score of 0) to be "almost" exact
    score: Math.max(0.001, finalScore)
  };

  if (computeMatches) {
    var indices = convertMaskToIndices(matchMask, minMatchCharLength);

    if (!indices.length) {
      result.isMatch = false;
    } else if (includeMatches) {
      result.indices = indices;
    }
  }

  return result;
}

function createPatternAlphabet(pattern) {
  var mask = {};

  for (var i = 0, len = pattern.length; i < len; i += 1) {
    var _char = pattern.charAt(i);

    mask[_char] = (mask[_char] || 0) | 1 << len - i - 1;
  }

  return mask;
}

var BitapSearch = /*#__PURE__*/function () {
  function BitapSearch(pattern) {
    var _this6 = this;

    var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref8$location = _ref8.location,
        location = _ref8$location === void 0 ? Config.location : _ref8$location,
        _ref8$threshold = _ref8.threshold,
        threshold = _ref8$threshold === void 0 ? Config.threshold : _ref8$threshold,
        _ref8$distance = _ref8.distance,
        distance = _ref8$distance === void 0 ? Config.distance : _ref8$distance,
        _ref8$includeMatches = _ref8.includeMatches,
        includeMatches = _ref8$includeMatches === void 0 ? Config.includeMatches : _ref8$includeMatches,
        _ref8$findAllMatches = _ref8.findAllMatches,
        findAllMatches = _ref8$findAllMatches === void 0 ? Config.findAllMatches : _ref8$findAllMatches,
        _ref8$minMatchCharLen = _ref8.minMatchCharLength,
        minMatchCharLength = _ref8$minMatchCharLen === void 0 ? Config.minMatchCharLength : _ref8$minMatchCharLen,
        _ref8$isCaseSensitive = _ref8.isCaseSensitive,
        isCaseSensitive = _ref8$isCaseSensitive === void 0 ? Config.isCaseSensitive : _ref8$isCaseSensitive,
        _ref8$ignoreLocation = _ref8.ignoreLocation,
        ignoreLocation = _ref8$ignoreLocation === void 0 ? Config.ignoreLocation : _ref8$ignoreLocation;

    _classCallCheck$4(this, BitapSearch);

    this.options = {
      location: location,
      threshold: threshold,
      distance: distance,
      includeMatches: includeMatches,
      findAllMatches: findAllMatches,
      minMatchCharLength: minMatchCharLength,
      isCaseSensitive: isCaseSensitive,
      ignoreLocation: ignoreLocation
    };
    this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
    this.chunks = [];

    if (!this.pattern.length) {
      return;
    }

    var addChunk = function addChunk(pattern, startIndex) {
      _this6.chunks.push({
        pattern: pattern,
        alphabet: createPatternAlphabet(pattern),
        startIndex: startIndex
      });
    };

    var len = this.pattern.length;

    if (len > MAX_BITS) {
      var i = 0;
      var remainder = len % MAX_BITS;
      var end = len - remainder;

      while (i < end) {
        addChunk(this.pattern.substr(i, MAX_BITS), i);
        i += MAX_BITS;
      }

      if (remainder) {
        var startIndex = len - MAX_BITS;
        addChunk(this.pattern.substr(startIndex), startIndex);
      }
    } else {
      addChunk(this.pattern, 0);
    }
  }

  _createClass$1(BitapSearch, [{
    key: "searchIn",
    value: function searchIn(text) {
      var _this$options = this.options,
          isCaseSensitive = _this$options.isCaseSensitive,
          includeMatches = _this$options.includeMatches;

      if (!isCaseSensitive) {
        text = text.toLowerCase();
      } // Exact match


      if (this.pattern === text) {
        var _result = {
          isMatch: true,
          score: 0
        };

        if (includeMatches) {
          _result.indices = [[0, text.length - 1]];
        }

        return _result;
      } // Otherwise, use Bitap algorithm


      var _this$options2 = this.options,
          location = _this$options2.location,
          distance = _this$options2.distance,
          threshold = _this$options2.threshold,
          findAllMatches = _this$options2.findAllMatches,
          minMatchCharLength = _this$options2.minMatchCharLength,
          ignoreLocation = _this$options2.ignoreLocation;
      var allIndices = [];
      var totalScore = 0;
      var hasMatches = false;
      this.chunks.forEach(function (_ref9) {
        var pattern = _ref9.pattern,
            alphabet = _ref9.alphabet,
            startIndex = _ref9.startIndex;

        var _search = search(text, pattern, alphabet, {
          location: location + startIndex,
          distance: distance,
          threshold: threshold,
          findAllMatches: findAllMatches,
          minMatchCharLength: minMatchCharLength,
          includeMatches: includeMatches,
          ignoreLocation: ignoreLocation
        }),
            isMatch = _search.isMatch,
            score = _search.score,
            indices = _search.indices;

        if (isMatch) {
          hasMatches = true;
        }

        totalScore += score;

        if (isMatch && indices) {
          allIndices = [].concat(_toConsumableArray$1(allIndices), _toConsumableArray$1(indices));
        }
      });
      var result = {
        isMatch: hasMatches,
        score: hasMatches ? totalScore / this.chunks.length : 1
      };

      if (hasMatches && includeMatches) {
        result.indices = allIndices;
      }

      return result;
    }
  }]);

  return BitapSearch;
}();

var BaseMatch = /*#__PURE__*/function () {
  function BaseMatch(pattern) {
    _classCallCheck$4(this, BaseMatch);

    this.pattern = pattern;
  }

  _createClass$1(BaseMatch, [{
    key: "search",
    value: function search() {}
  }], [{
    key: "isMultiMatch",
    value: function isMultiMatch(pattern) {
      return getMatch(pattern, this.multiRegex);
    }
  }, {
    key: "isSingleMatch",
    value: function isSingleMatch(pattern) {
      return getMatch(pattern, this.singleRegex);
    }
  }]);

  return BaseMatch;
}();

function getMatch(pattern, exp) {
  var matches = pattern.match(exp);
  return matches ? matches[1] : null;
} // Token: 'file


var ExactMatch = /*#__PURE__*/function (_BaseMatch) {
  _inherits$1(ExactMatch, _BaseMatch);

  var _super = _createSuper$1(ExactMatch);

  function ExactMatch(pattern) {
    _classCallCheck$4(this, ExactMatch);

    return _super.call(this, pattern);
  }

  _createClass$1(ExactMatch, [{
    key: "search",
    value: function search(text) {
      var isMatch = text === this.pattern;
      return {
        isMatch: isMatch,
        score: isMatch ? 0 : 1,
        indices: [0, this.pattern.length - 1]
      };
    }
  }], [{
    key: "type",
    get: function get() {
      return 'exact';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^="(.*)"$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^=(.*)$/;
    }
  }]);

  return ExactMatch;
}(BaseMatch); // Token: !fire


var InverseExactMatch = /*#__PURE__*/function (_BaseMatch2) {
  _inherits$1(InverseExactMatch, _BaseMatch2);

  var _super2 = _createSuper$1(InverseExactMatch);

  function InverseExactMatch(pattern) {
    _classCallCheck$4(this, InverseExactMatch);

    return _super2.call(this, pattern);
  }

  _createClass$1(InverseExactMatch, [{
    key: "search",
    value: function search(text) {
      var index = text.indexOf(this.pattern);
      var isMatch = index === -1;
      return {
        isMatch: isMatch,
        score: isMatch ? 0 : 1,
        indices: [0, text.length - 1]
      };
    }
  }], [{
    key: "type",
    get: function get() {
      return 'inverse-exact';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^!"(.*)"$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^!(.*)$/;
    }
  }]);

  return InverseExactMatch;
}(BaseMatch); // Token: ^file


var PrefixExactMatch = /*#__PURE__*/function (_BaseMatch3) {
  _inherits$1(PrefixExactMatch, _BaseMatch3);

  var _super3 = _createSuper$1(PrefixExactMatch);

  function PrefixExactMatch(pattern) {
    _classCallCheck$4(this, PrefixExactMatch);

    return _super3.call(this, pattern);
  }

  _createClass$1(PrefixExactMatch, [{
    key: "search",
    value: function search(text) {
      var isMatch = text.startsWith(this.pattern);
      return {
        isMatch: isMatch,
        score: isMatch ? 0 : 1,
        indices: [0, this.pattern.length - 1]
      };
    }
  }], [{
    key: "type",
    get: function get() {
      return 'prefix-exact';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^\^"(.*)"$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^\^(.*)$/;
    }
  }]);

  return PrefixExactMatch;
}(BaseMatch); // Token: !^fire


var InversePrefixExactMatch = /*#__PURE__*/function (_BaseMatch4) {
  _inherits$1(InversePrefixExactMatch, _BaseMatch4);

  var _super4 = _createSuper$1(InversePrefixExactMatch);

  function InversePrefixExactMatch(pattern) {
    _classCallCheck$4(this, InversePrefixExactMatch);

    return _super4.call(this, pattern);
  }

  _createClass$1(InversePrefixExactMatch, [{
    key: "search",
    value: function search(text) {
      var isMatch = !text.startsWith(this.pattern);
      return {
        isMatch: isMatch,
        score: isMatch ? 0 : 1,
        indices: [0, text.length - 1]
      };
    }
  }], [{
    key: "type",
    get: function get() {
      return 'inverse-prefix-exact';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^!\^"(.*)"$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^!\^(.*)$/;
    }
  }]);

  return InversePrefixExactMatch;
}(BaseMatch); // Token: .file$


var SuffixExactMatch = /*#__PURE__*/function (_BaseMatch5) {
  _inherits$1(SuffixExactMatch, _BaseMatch5);

  var _super5 = _createSuper$1(SuffixExactMatch);

  function SuffixExactMatch(pattern) {
    _classCallCheck$4(this, SuffixExactMatch);

    return _super5.call(this, pattern);
  }

  _createClass$1(SuffixExactMatch, [{
    key: "search",
    value: function search(text) {
      var isMatch = text.endsWith(this.pattern);
      return {
        isMatch: isMatch,
        score: isMatch ? 0 : 1,
        indices: [text.length - this.pattern.length, text.length - 1]
      };
    }
  }], [{
    key: "type",
    get: function get() {
      return 'suffix-exact';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^"(.*)"\$$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^(.*)\$$/;
    }
  }]);

  return SuffixExactMatch;
}(BaseMatch); // Token: !.file$


var InverseSuffixExactMatch = /*#__PURE__*/function (_BaseMatch6) {
  _inherits$1(InverseSuffixExactMatch, _BaseMatch6);

  var _super6 = _createSuper$1(InverseSuffixExactMatch);

  function InverseSuffixExactMatch(pattern) {
    _classCallCheck$4(this, InverseSuffixExactMatch);

    return _super6.call(this, pattern);
  }

  _createClass$1(InverseSuffixExactMatch, [{
    key: "search",
    value: function search(text) {
      var isMatch = !text.endsWith(this.pattern);
      return {
        isMatch: isMatch,
        score: isMatch ? 0 : 1,
        indices: [0, text.length - 1]
      };
    }
  }], [{
    key: "type",
    get: function get() {
      return 'inverse-suffix-exact';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^!"(.*)"\$$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^!(.*)\$$/;
    }
  }]);

  return InverseSuffixExactMatch;
}(BaseMatch);

var FuzzyMatch = /*#__PURE__*/function (_BaseMatch7) {
  _inherits$1(FuzzyMatch, _BaseMatch7);

  var _super7 = _createSuper$1(FuzzyMatch);

  function FuzzyMatch(pattern) {
    var _this7;

    var _ref10 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref10$location = _ref10.location,
        location = _ref10$location === void 0 ? Config.location : _ref10$location,
        _ref10$threshold = _ref10.threshold,
        threshold = _ref10$threshold === void 0 ? Config.threshold : _ref10$threshold,
        _ref10$distance = _ref10.distance,
        distance = _ref10$distance === void 0 ? Config.distance : _ref10$distance,
        _ref10$includeMatches = _ref10.includeMatches,
        includeMatches = _ref10$includeMatches === void 0 ? Config.includeMatches : _ref10$includeMatches,
        _ref10$findAllMatches = _ref10.findAllMatches,
        findAllMatches = _ref10$findAllMatches === void 0 ? Config.findAllMatches : _ref10$findAllMatches,
        _ref10$minMatchCharLe = _ref10.minMatchCharLength,
        minMatchCharLength = _ref10$minMatchCharLe === void 0 ? Config.minMatchCharLength : _ref10$minMatchCharLe,
        _ref10$isCaseSensitiv = _ref10.isCaseSensitive,
        isCaseSensitive = _ref10$isCaseSensitiv === void 0 ? Config.isCaseSensitive : _ref10$isCaseSensitiv,
        _ref10$ignoreLocation = _ref10.ignoreLocation,
        ignoreLocation = _ref10$ignoreLocation === void 0 ? Config.ignoreLocation : _ref10$ignoreLocation;

    _classCallCheck$4(this, FuzzyMatch);

    _this7 = _super7.call(this, pattern);
    _this7._bitapSearch = new BitapSearch(pattern, {
      location: location,
      threshold: threshold,
      distance: distance,
      includeMatches: includeMatches,
      findAllMatches: findAllMatches,
      minMatchCharLength: minMatchCharLength,
      isCaseSensitive: isCaseSensitive,
      ignoreLocation: ignoreLocation
    });
    return _this7;
  }

  _createClass$1(FuzzyMatch, [{
    key: "search",
    value: function search(text) {
      return this._bitapSearch.searchIn(text);
    }
  }], [{
    key: "type",
    get: function get() {
      return 'fuzzy';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^"(.*)"$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^(.*)$/;
    }
  }]);

  return FuzzyMatch;
}(BaseMatch); // Token: 'file


var IncludeMatch = /*#__PURE__*/function (_BaseMatch8) {
  _inherits$1(IncludeMatch, _BaseMatch8);

  var _super8 = _createSuper$1(IncludeMatch);

  function IncludeMatch(pattern) {
    _classCallCheck$4(this, IncludeMatch);

    return _super8.call(this, pattern);
  }

  _createClass$1(IncludeMatch, [{
    key: "search",
    value: function search(text) {
      var location = 0;
      var index;
      var indices = [];
      var patternLen = this.pattern.length; // Get all exact matches

      while ((index = text.indexOf(this.pattern, location)) > -1) {
        location = index + patternLen;
        indices.push([index, location - 1]);
      }

      var isMatch = !!indices.length;
      return {
        isMatch: isMatch,
        score: isMatch ? 0 : 1,
        indices: indices
      };
    }
  }], [{
    key: "type",
    get: function get() {
      return 'include';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^'"(.*)"$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^'(.*)$/;
    }
  }]);

  return IncludeMatch;
}(BaseMatch); // ❗Order is important. DO NOT CHANGE.


var searchers = [ExactMatch, IncludeMatch, PrefixExactMatch, InversePrefixExactMatch, InverseSuffixExactMatch, SuffixExactMatch, InverseExactMatch, FuzzyMatch];
var searchersLen = searchers.length; // Regex to split by spaces, but keep anything in quotes together

var SPACE_RE = / +(?=([^\"]*\"[^\"]*\")*[^\"]*$)/;
var OR_TOKEN = '|'; // Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]

function parseQuery(pattern) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return pattern.split(OR_TOKEN).map(function (item) {
    var query = item.trim().split(SPACE_RE).filter(function (item) {
      return item && !!item.trim();
    });
    var results = [];

    for (var i = 0, len = query.length; i < len; i += 1) {
      var queryItem = query[i]; // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)

      var found = false;
      var idx = -1;

      while (!found && ++idx < searchersLen) {
        var searcher = searchers[idx];
        var token = searcher.isMultiMatch(queryItem);

        if (token) {
          results.push(new searcher(token, options));
          found = true;
        }
      }

      if (found) {
        continue;
      } // 2. Handle single query matches (i.e, once that are *not* quoted)


      idx = -1;

      while (++idx < searchersLen) {
        var _searcher = searchers[idx];

        var _token = _searcher.isSingleMatch(queryItem);

        if (_token) {
          results.push(new _searcher(_token, options));
          break;
        }
      }
    }

    return results;
  });
} // These extended matchers can return an array of matches, as opposed
// to a singl match


var MultiMatchSet = new Set([FuzzyMatch.type, IncludeMatch.type]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */

var ExtendedSearch = /*#__PURE__*/function () {
  function ExtendedSearch(pattern) {
    var _ref11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref11$isCaseSensitiv = _ref11.isCaseSensitive,
        isCaseSensitive = _ref11$isCaseSensitiv === void 0 ? Config.isCaseSensitive : _ref11$isCaseSensitiv,
        _ref11$includeMatches = _ref11.includeMatches,
        includeMatches = _ref11$includeMatches === void 0 ? Config.includeMatches : _ref11$includeMatches,
        _ref11$minMatchCharLe = _ref11.minMatchCharLength,
        minMatchCharLength = _ref11$minMatchCharLe === void 0 ? Config.minMatchCharLength : _ref11$minMatchCharLe,
        _ref11$ignoreLocation = _ref11.ignoreLocation,
        ignoreLocation = _ref11$ignoreLocation === void 0 ? Config.ignoreLocation : _ref11$ignoreLocation,
        _ref11$findAllMatches = _ref11.findAllMatches,
        findAllMatches = _ref11$findAllMatches === void 0 ? Config.findAllMatches : _ref11$findAllMatches,
        _ref11$location = _ref11.location,
        location = _ref11$location === void 0 ? Config.location : _ref11$location,
        _ref11$threshold = _ref11.threshold,
        threshold = _ref11$threshold === void 0 ? Config.threshold : _ref11$threshold,
        _ref11$distance = _ref11.distance,
        distance = _ref11$distance === void 0 ? Config.distance : _ref11$distance;

    _classCallCheck$4(this, ExtendedSearch);

    this.query = null;
    this.options = {
      isCaseSensitive: isCaseSensitive,
      includeMatches: includeMatches,
      minMatchCharLength: minMatchCharLength,
      findAllMatches: findAllMatches,
      ignoreLocation: ignoreLocation,
      location: location,
      threshold: threshold,
      distance: distance
    };
    this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
    this.query = parseQuery(this.pattern, this.options);
  }

  _createClass$1(ExtendedSearch, [{
    key: "searchIn",
    value: function searchIn(text) {
      var query = this.query;

      if (!query) {
        return {
          isMatch: false,
          score: 1
        };
      }

      var _this$options3 = this.options,
          includeMatches = _this$options3.includeMatches,
          isCaseSensitive = _this$options3.isCaseSensitive;
      text = isCaseSensitive ? text : text.toLowerCase();
      var numMatches = 0;
      var allIndices = [];
      var totalScore = 0; // ORs

      for (var i = 0, qLen = query.length; i < qLen; i += 1) {
        var _searchers = query[i]; // Reset indices

        allIndices.length = 0;
        numMatches = 0; // ANDs

        for (var j = 0, pLen = _searchers.length; j < pLen; j += 1) {
          var searcher = _searchers[j];

          var _searcher$search = searcher.search(text),
              isMatch = _searcher$search.isMatch,
              indices = _searcher$search.indices,
              score = _searcher$search.score;

          if (isMatch) {
            numMatches += 1;
            totalScore += score;

            if (includeMatches) {
              var type = searcher.constructor.type;

              if (MultiMatchSet.has(type)) {
                allIndices = [].concat(_toConsumableArray$1(allIndices), _toConsumableArray$1(indices));
              } else {
                allIndices.push(indices);
              }
            }
          } else {
            totalScore = 0;
            numMatches = 0;
            allIndices.length = 0;
            break;
          }
        } // OR condition, so if TRUE, return


        if (numMatches) {
          var _result2 = {
            isMatch: true,
            score: totalScore / numMatches
          };

          if (includeMatches) {
            _result2.indices = allIndices;
          }

          return _result2;
        }
      } // Nothing was matched


      return {
        isMatch: false,
        score: 1
      };
    }
  }], [{
    key: "condition",
    value: function condition(_, options) {
      return options.useExtendedSearch;
    }
  }]);

  return ExtendedSearch;
}();

var registeredSearchers = [];

function register() {
  registeredSearchers.push.apply(registeredSearchers, arguments);
}
{
  register(ExtendedSearch);
}

var SortOrder;

(function (SortOrder) {
  SortOrder[SortOrder["ASC"] = 0] = "ASC";
  SortOrder[SortOrder["DESC"] = 1] = "DESC";
})(SortOrder || (SortOrder = {}));

var Stage;

(function (Stage) {
  Stage["Dev"] = "dev";
  Stage["Staging"] = "staging";
  Stage["Prod"] = "production";
})(Stage || (Stage = {}));
var AppPath;

(function (AppPath) {
  AppPath["USERS"] = "users";
  AppPath["RECORDINGS"] = "recordings";
  AppPath["LOGIN"] = "login";
  AppPath["AGENT"] = "agents";
  AppPath["ForwardProxy"] = "forward-proxy";
  AppPath["CONSOLE"] = "console";
  AppPath["SUPERVISOR"] = "supervisor";
})(AppPath || (AppPath = {}));

function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
} // https://stackoverflow.com/a/46971044/970769


var ParseError = function ParseError(code) {
  _classCallCheck$2(this, ParseError);

  this.name = this.constructor.name;
  this.message = code;
  this.stack = new Error(code).stack;
};

ParseError.prototype = Object.create(Error.prototype);
ParseError.prototype.constructor = ParseError; // The minimum length of the national significant number.

function createCommonjsModule(fn) {
  var module = {
    exports: {}
  };
  return fn(module, module.exports), module.exports;
}

createCommonjsModule(function (module) {
  (function (module) {
    module.exports.is_uri = is_iri;
    module.exports.is_http_uri = is_http_iri;
    module.exports.is_https_uri = is_https_iri;
    module.exports.is_web_uri = is_web_iri; // Create aliases

    module.exports.isUri = is_iri;
    module.exports.isHttpUri = is_http_iri;
    module.exports.isHttpsUri = is_https_iri;
    module.exports.isWebUri = is_web_iri; // private function
    // internal URI spitter method - direct from RFC 3986

    var splitUri = function splitUri(uri) {
      var splitted = uri.match(/(?:([^:\/?#]+):)?(?:\/\/([^\/?#]*))?([^?#]*)(?:\?([^#]*))?(?:#(.*))?/);
      return splitted;
    };

    function is_iri(value) {
      if (!value) {
        return;
      } // check for illegal characters


      if (/[^a-z0-9\:\/\?\#\[\]\@\!\$\&\'\(\)\*\+\,\;\=\.\-\_\~\%]/i.test(value)) return; // check for hex escapes that aren't complete

      if (/%[^0-9a-f]/i.test(value)) return;
      if (/%[0-9a-f](:?[^0-9a-f]|$)/i.test(value)) return;
      var splitted = [];
      var scheme = '';
      var authority = '';
      var path = '';
      var query = '';
      var fragment = '';
      var out = ''; // from RFC 3986

      splitted = splitUri(value);
      scheme = splitted[1];
      authority = splitted[2];
      path = splitted[3];
      query = splitted[4];
      fragment = splitted[5]; // scheme and path are required, though the path can be empty

      if (!(scheme && scheme.length && path.length >= 0)) return; // if authority is present, the path must be empty or begin with a /

      if (authority && authority.length) {
        if (!(path.length === 0 || /^\//.test(path))) return;
      } else {
        // if authority is not present, the path must not start with //
        if (/^\/\//.test(path)) return;
      } // scheme must begin with a letter, then consist of letters, digits, +, ., or -


      if (!/^[a-z][a-z0-9\+\-\.]*$/.test(scheme.toLowerCase())) return; // re-assemble the URL per section 5.3 in RFC 3986

      out += scheme + ':';

      if (authority && authority.length) {
        out += '//' + authority;
      }

      out += path;

      if (query && query.length) {
        out += '?' + query;
      }

      if (fragment && fragment.length) {
        out += '#' + fragment;
      }

      return out;
    }

    function is_http_iri(value, allowHttps) {
      if (!is_iri(value)) {
        return;
      }

      var splitted = [];
      var scheme = '';
      var authority = '';
      var path = '';
      var port = '';
      var query = '';
      var fragment = '';
      var out = ''; // from RFC 3986

      splitted = splitUri(value);
      scheme = splitted[1];
      authority = splitted[2];
      path = splitted[3];
      query = splitted[4];
      fragment = splitted[5];
      if (!scheme) return;

      if (allowHttps) {
        if (scheme.toLowerCase() != 'https') return;
      } else {
        if (scheme.toLowerCase() != 'http') return;
      } // fully-qualified URIs must have an authority section that is
      // a valid host


      if (!authority) {
        return;
      } // enable port component


      if (/:(\d+)$/.test(authority)) {
        port = authority.match(/:(\d+)$/)[0];
        authority = authority.replace(/:\d+$/, '');
      }

      out += scheme + ':';
      out += '//' + authority;

      if (port) {
        out += port;
      }

      out += path;

      if (query && query.length) {
        out += '?' + query;
      }

      if (fragment && fragment.length) {
        out += '#' + fragment;
      }

      return out;
    }

    function is_https_iri(value) {
      return is_http_iri(value, true);
    }

    function is_web_iri(value) {
      return is_http_iri(value) || is_https_iri(value);
    }
  })(module);
});

var useScrollDirection = function useScrollDirection(elemRef) {
  var prevPos = useRef(0);

  var _useState = useState(),
      _useState2 = _slicedToArray$1(_useState, 2),
      isScrollDown = _useState2[0],
      setIsScrollDown = _useState2[1];

  var cb = useCallback(function (e) {
    var scrollTop = elemRef.current.scrollTop;

    if (!scrollTop) {
      return;
    }

    var isDown = prevPos.current < scrollTop;

    if (isDown != isScrollDown) {
      setIsScrollDown(isDown);
      prevPos.current = scrollTop;
    }
  }, [prevPos, elemRef.current]);
  useEffect(function () {
    elemRef.current.addEventListener('scroll', cb);
    return function () {
      elemRef.current.removeEventListener('scroll', cb);
    };
  }, [cb]);
  return isScrollDown;
};

var useThrottle = function useThrottle(cb, timeoutMillisec) {
  var holdflagRef = useRef();
  var isOnHold = useCallback(function () {
    if (!holdflagRef.current) {
      return false;
    }

    return Date.now() < holdflagRef.current;
  }, []);
  var fn = useCallback(function (args) {
    if (isOnHold()) {
      return;
    }

    cb(args);
    holdflagRef.current = Date.now() + timeoutMillisec;
  }, [cb, timeoutMillisec]);
  return fn;
};

var CollapseAllBtn = function CollapseAllBtn(_ref) {
  var onClick = _ref.onClick,
      isExpanded = _ref.isExpanded;
  var theme = useThemeSafe();
  var styles = useStyles$b({
    theme: theme,
    isExpanded: isExpanded
  });

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      showArrow = _useState2[0],
      setShowArrow = _useState2[1];

  var timerId = useRef();
  useEffect(function () {
    if (!isExpanded) {
      timerId.current = window.setTimeout(function () {
        setShowArrow(false);
      }, 500);
      return;
    }

    setShowArrow(isExpanded);
    return function () {
      if (timerId.current) {
        clearTimeout(timerId.current);
      }
    };
  }, [isExpanded]);
  return /*#__PURE__*/React__default.createElement("div", {
    onClick: onClick,
    className: styles.collapseAllBtn
  }, showArrow && /*#__PURE__*/React__default.createElement(CollapseArrow, {
    opened: isExpanded,
    color: theme.palette.background.color,
    stroke: theme.palette.primary.color,
    showDoubleArrows: true
  }));
};
var useStyles$b = createUseStyles(function (theme) {
  return {
    collapseAllBtn: function collapseAllBtn(props) {
      return {
        opacity: props.isExpanded ? 1 : 0,
        transition: theme.transitions.slow,
        width: 42,
        cursor: 'pointer',
        display: 'flex',
        flexWrap: 'nowrap',
        justifyContent: 'flex-end'
      };
    }
  };
});

var FilterButton = function FilterButton(_ref) {
  var color = _ref.color,
      onClick = _ref.onClick,
      className = _ref.className;
  var theme = useThemeSafe();
  var strokeColor = color !== null && color !== void 0 ? color : theme.palette.grey.light;
  return /*#__PURE__*/React__default.createElement("div", {
    className: className,
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: "16",
    height: "14",
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M6.46635 14C6.29336 13.9986 6.12335 13.9554 5.97122 13.8741C5.80348 13.7866 5.66314 13.6555 5.56531 13.495C5.46748 13.3346 5.41588 13.1508 5.41606 12.9635V7.1888C5.41635 7.15319 5.40295 7.11879 5.37855 7.09255L0.442181 1.73243C0.302976 1.58485 0.211499 1.39968 0.179429 1.20056C0.147359 1.00144 0.176152 0.797403 0.262131 0.614505C0.34405 0.43084 0.478596 0.274817 0.649209 0.165639C0.819822 0.0564611 1.01906 -0.00110811 1.2224 1.61577e-05H14.111C14.3143 -0.00110811 14.5136 0.0564611 14.6842 0.165639C14.8548 0.274817 14.9893 0.43084 15.0712 0.614505C15.1572 0.797403 15.186 1.00144 15.1539 1.20056C15.1219 1.39968 15.0304 1.58485 14.8912 1.73243L9.95482 7.08515C9.93152 7.11491 9.91838 7.1512 9.91731 7.1888V11.3792C9.91823 11.5502 9.87624 11.7188 9.79508 11.87C9.71392 12.0211 9.59612 12.1501 9.45218 12.2454L7.05152 13.8223C6.87867 13.9376 6.67496 13.9994 6.46635 14ZM1.2224 0.888434C1.19317 0.886798 1.1642 0.894578 1.13985 0.910602C1.11549 0.926625 1.09707 0.950025 1.08736 0.977276C1.0727 1.00187 1.06694 1.03065 1.07103 1.0589C1.07512 1.08715 1.08881 1.11319 1.10987 1.13275L6.04624 6.49287C6.21996 6.68415 6.31612 6.93193 6.31631 7.1888V12.9635C6.31664 12.99 6.32457 13.0159 6.33917 13.0382C6.35377 13.0605 6.37445 13.0782 6.39883 13.0894C6.42178 13.1029 6.44828 13.1095 6.475 13.1082C6.50171 13.1068 6.52742 13.0977 6.54888 13.082L8.94954 11.505C8.97061 11.4913 8.98784 11.4726 8.99964 11.4506C9.01144 11.4286 9.01743 11.4041 9.01706 11.3792V7.1888C9.01726 6.93193 9.11342 6.68415 9.28714 6.49287L14.2235 1.13275C14.2446 1.11319 14.2583 1.08715 14.2623 1.0589C14.2664 1.03065 14.2607 1.00187 14.246 0.977276C14.2363 0.950025 14.2179 0.926625 14.1935 0.910602C14.1692 0.894578 14.1402 0.886798 14.111 0.888434H1.2224Z",
    fill: strokeColor
  })));
};

var Arrow = function Arrow(_ref) {
  var color = _ref.color,
      className = _ref.className;
  var theme = useThemeSafe();
  var strokeColor = color !== null && color !== void 0 ? color : theme.palette.secondary.color;
  return /*#__PURE__*/React__default.createElement("svg", {
    className: className,
    width: "12",
    height: "14",
    viewBox: "0 0 12 13",
    fill: strokeColor,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M2.76433 4.11389L5.78355 0.999965L8.80276 4.11389",
    stroke: strokeColor,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M5.78391 1.00033L5.78391 11.8991",
    stroke: strokeColor,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var SortArrows = function SortArrows(_ref) {
  var sort = _ref.sort,
      onClick = _ref.onClick,
      className = _ref.className;
  var theme = useThemeSafe();
  var styles = useStyles$a();
  var defaultColor = theme.palette.grey.light;
  var selectedColor = theme.palette.primary.color;
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(styles.sortArrows, className),
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement(Arrow, {
    color: sort === Sort.DESC ? selectedColor : defaultColor
  }), /*#__PURE__*/React__default.createElement(Arrow, {
    color: sort === Sort.ASC ? selectedColor : defaultColor,
    className: styles.arrowDown
  }));
};
var useStyles$a = createUseStyles({
  sortArrows: {
    display: 'flex',
    cursor: 'pointer'
  },
  arrowDown: {
    marginLeft: -4,
    transform: 'rotate(180deg)'
  }
});

var columnResizerId = 'column-resizer-id';

var HeaderCell = function HeaderCell(_a) {
  var title = _a.title,
      onClick = _a.onClick,
      onFilterClick = _a.onFilterClick,
      options = _a.options,
      rest = __rest(_a, ["title", "onClick", "onFilterClick", "options"]);

  var theme = useThemeSafe();
  var styles = useStyles$9({
    theme: theme,
    width: options.getSize(),
    anySortActive: options.getIsSorted() === Sort.ASC || options.getIsSorted() === Sort.DESC,
    enableSorting: options.enableSorting,
    isResizing: options.getIsResizing(),
    deltaOffset: options.deltaOffset
  });
  var showButtonsWrapper = options.enableSorting || options.quickFiltersEnabled;
  return /*#__PURE__*/React__default.createElement("th", Object.assign({
    className: styles.columnHeader,
    colSpan: options.colSpan,
    style: {
      position: 'relative'
    }
  }, rest), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'nowrap',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.headerWrapper,
    key: styles.headerWrapper
  }, /*#__PURE__*/React__default.createElement(Text$1, Object.assign({
    variant: "body",
    component: "div",
    className: styles.titleWrapper
  }, typeof title === 'string' ? {
    title: title
  } : {}), title), showButtonsWrapper && /*#__PURE__*/React__default.createElement("div", {
    className: styles.iconsWrapper
  }, options.enableSorting && /*#__PURE__*/React__default.createElement(SortArrows, {
    sort: options.getIsSorted(),
    onClick: onClick,
    className: styles.sortArrows
  }), options.quickFiltersEnabled && /*#__PURE__*/React__default.createElement(FilterButton, {
    onClick: onFilterClick,
    className: styles.filterBtn
  }))), options.enableResizing !== false && /*#__PURE__*/React__default.createElement("div", {
    onMouseDown: options.getResizeHandler(),
    onTouchStart: options.getResizeHandler(),
    className: styles.columnResizerContainer,
    id: columnResizerId
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.columnResizer
  }))));
};
var useStyles$9 = createUseStyles(function (theme) {
  return {
    columnHeader: {
      boxSizing: 'border-box',
      textAlign: 'start',
      display: 'table-cell',
      width: function width(props) {
        return props.width;
      },
      '&:hover $sortArrows': {
        opacity: 1
      },
      '&:hover $filterBtn': {
        opacity: 1
      },
      '&:active $sortArrows': {
        opacity: 0.7
      },
      '&:active $filterBtn': {
        opacity: 0.7
      }
    },
    headerWrapper: {
      display: 'flex',
      gap: 4,
      alignItems: 'center',
      padding: '16px 12px'
    },
    sortArrows: {
      opacity: function opacity(props) {
        return props.anySortActive ? 1 : 0;
      },
      transition: "all ".concat(theme.transitions.fast)
    },
    titleWrapper: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    iconsWrapper: {
      flex: 1,
      display: 'flex',
      gap: 4
    },
    filterBtn: {
      opacity: 0,
      cursor: 'pointer',
      transition: "all ".concat(theme.transitions.fast)
    },
    columnResizerContainer: {
      minHeight: 8,
      padding: '8px 4px',
      cursor: 'col-resize',
      '&:hover $columnResizer': {
        backgroundColor: theme.palette.primary.light
      }
    },
    columnResizer: {
      height: '100%',
      width: function width(_ref) {
        var isResizing = _ref.isResizing;
        return isResizing ? '4px' : '3px';
      },
      backgroundColor: function backgroundColor(_ref2) {
        var isResizing = _ref2.isResizing;
        return isResizing ? theme.palette.primary.light : theme.palette.grey.extraLight;
      },
      transition: "".concat(theme.transitions.fast, " background-color, ").concat(theme.transitions.fast, " width, ").concat(theme.transitions.fast, " opacity"),
      borderRadius: 8
    }
  };
});

var HeaderRow = function HeaderRow(_ref) {
  var id = _ref.id,
      children = _ref.children;
  var theme = useThemeSafe();
  var styles = useStyles$8({
    theme: theme
  });
  return /*#__PURE__*/React__default.createElement("tr", {
    key: id,
    className: styles.headerRow
  }, children);
};

var useStyles$8 = createUseStyles(function (theme) {
  var _th, _headerRow;

  return {
    headerRow: (_headerRow = {
      display: 'table-row',
      backgroundColor: theme.palette.background.color,
      position: 'sticky',
      top: 0,
      zIndex: theme.zIndex.medium
    }, _defineProperty$1(_headerRow, '&:hover', _defineProperty$1({}, "& #".concat(columnResizerId), {
      opacity: 1
    })), _defineProperty$1(_headerRow, '& th', (_th = {}, _defineProperty$1(_th, '&:last-child', {
      borderTopRightRadius: theme.shape.borderRadiusLight,
      width: '100%'
    }), _defineProperty$1(_th, '&:first-child', {
      borderTopLeftRadius: theme.shape.borderRadiusLight
    }), _defineProperty$1(_th, "& #".concat(columnResizerId), {
      opacity: 0
    }), _th)), _headerRow)
  };
});

var CellContainer = function CellContainer(_ref) {
  var children = _ref.children,
      width = _ref.width,
      style = _ref.style;
  var styles = useStyles$7({
    width: width
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.cellContainer,
    style: Object.assign({}, style)
  }, children);
};
var useStyles$7 = createUseStyles(function (theme) {
  return {
    cellContainer: function cellContainer(props) {
      return {
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        padding: '16px 12px',
        width: props.width
      };
    }
  };
});

var NoDataRow = function NoDataRow(_ref) {
  var colSpan = _ref.colSpan,
      children = _ref.children;
  var theme = useThemeSafe();
  var styles = useStyles$6({
    theme: theme
  });
  return /*#__PURE__*/React__default.createElement("tr", {
    className: styles.noDataRow
  }, /*#__PURE__*/React__default.createElement("td", {
    colSpan: colSpan
  }, /*#__PURE__*/React__default.createElement(CellContainer, null, children)));
};
var useStyles$6 = createUseStyles(function (theme) {
  return {
    noDataRow: {
      backgroundColor: theme.palette.white.color
    }
  };
});

var Cell = function Cell(_ref) {
  var cell = _ref.cell,
      onClick = _ref.onClick,
      style = _ref.style;
  var theme = useThemeSafe();
  var styles = useStyles$5({
    theme: theme
  });

  if (cell.getIsPlaceholder()) {
    return /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(CellContainer, {
      width: ColumnSize.PLACE_HOLDER
    }, /*#__PURE__*/React__default.createElement("p", null)));
  }

  if (isShadowColumn(cell.column)) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement("td", {
    className: styles.tableCell,
    key: cell.id,
    onClick: onClick,
    style: Object.assign({
      width: cell.column.getSize()
    }, style)
  }, /*#__PURE__*/React__default.createElement(CellContainer, {
    width: cell.column.getSize()
  }, flexRender(cell.column.columnDef.cell, cell.getContext())));
};
var useStyles$5 = createUseStyles(function (theme) {
  return {
    tableCell: {
      fontSize: theme.typography.fontBaseSize,
      fontFamily: theme.typography.p.fontFamily,
      color: theme.palette.grey.color
    }
  };
});

var RowActionSelector = 'row-action-selector';

var Row = function Row(_ref) {
  var row = _ref.row,
      renderRowDetailView = _ref.renderRowDetailView,
      renderRowActions = _ref.renderRowActions,
      renderContextMenu = _ref.renderContextMenu,
      rowActionPos = _ref.rowActionPos,
      tableTotalSize = _ref.tableTotalSize,
      trRef = _ref.trRef,
      contextMenuRef = _ref.contextMenuRef,
      isGroupedParent = _ref.isGroupedParent;
  var theme = useThemeSafe();

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      showRowActions = _useState2[0],
      setShowRowActions = _useState2[1];

  var styles = useStyles$4({
    theme: theme,
    showRowActions: showRowActions
  });

  var _useState3 = useState(null),
      _useState4 = _slicedToArray$1(_useState3, 2),
      contextMenuRefElement = _useState4[0],
      setContextMenuRefElement = _useState4[1];

  var handelShowRowActions = useCallback(debounce_1$1(function (shouldShow) {
    setShowRowActions(shouldShow);
  }, 200), []);
  useEffect(function () {
    return function () {
      handelShowRowActions.clear();
    };
  }, []);
  var groupedCell = useMemo(function () {
    return row.getVisibleCells()[0];
  }, [row.getVisibleCells]);

  if (isGroupedParent) {
    // should take all row width (sum only by visible cells)
    // do not display rowActions
    return /*#__PURE__*/React__default.createElement("tr", {
      style: {
        width: tableTotalSize
      },
      className: styles.tableGroupByRow
    }, /*#__PURE__*/React__default.createElement("td", {
      key: groupedCell.id,
      onClick: function onClick() {
        groupedCell.row.toggleExpanded(!groupedCell.row.getIsExpanded());
      }
    }, /*#__PURE__*/React__default.createElement(CellContainer, {
      width: ColumnSize.PLACE_HOLDER
    }, flexRender(groupedCell.column.columnDef.cell, groupedCell.getContext()))), row.getVisibleCells().filter(function (cell) {
      return !isShadowColumn(cell.column) || cell.column.getIsGrouped();
    }).map(function (cell, idx) {
      var firstCellIdx = idx === 0;

      if (firstCellIdx) {
        return;
      }

      return /*#__PURE__*/React__default.createElement("td", {
        colSpan: 1,
        key: cell.id
      }, /*#__PURE__*/React__default.createElement("div", {
        style: {
          width: cell.column.getSize()
        }
      }));
    }));
  }

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("tr", {
    ref: function ref(el) {
      trRef(el);
      setContextMenuRefElement(el);
    },
    onMouseEnter: function onMouseEnter() {
      handelShowRowActions(true);
    },
    onMouseLeave: function onMouseLeave() {
      handelShowRowActions(false);
    },
    className: clsx(styles.tableRow, _defineProperty$1({}, styles.expanded, row.getIsExpanded()))
  }, row.getVisibleCells().map(function (cell, index) {
    return /*#__PURE__*/React__default.createElement(Cell, {
      key: index,
      cell: cell
    });
  }), renderRowActions && /*#__PURE__*/React__default.createElement("td", {
    className: clsx(RowActionSelector, styles.rowActions),
    style: {
      left: rowActionPos
    }
  }, /*#__PURE__*/React__default.createElement("div", null, renderRowActions(row))), renderContextMenu && /*#__PURE__*/React__default.createElement(ContextMenu, {
    refElement: contextMenuRefElement,
    ref: contextMenuRef
  }, renderContextMenu(row))), row.getIsExpanded() && false && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    className: styles.detailedView,
    colSpan: row.getVisibleCells().length
  }, /*#__PURE__*/React__default.createElement(CellContainer, null, renderRowDetailView({
    row: row
  })))));
};
var useStyles$4 = createUseStyles(function (theme) {
  var _lastChild, _tableRow;

  return {
    tableRow: (_tableRow = {
      borderBottom: "1px solid ".concat(theme.palette.background.color),
      position: 'relative',
      backgroundColor: theme.palette.white.color,
      transition: "background-color ".concat(theme.transitions.fast)
    }, _defineProperty$1(_tableRow, '&:last-child', (_lastChild = {
      border: 'none'
    }, _defineProperty$1(_lastChild, '& td:last-child', {
      borderBottomRightRadius: theme.shape.borderRadiusLight
    }), _defineProperty$1(_lastChild, '& td:first-child', {
      borderBottomLeftRadius: theme.shape.borderRadiusLight
    }), _lastChild)), _defineProperty$1(_tableRow, '&:hover', _defineProperty$1({
      backgroundColor: theme.palette.background.color
    }, '& $rowActions', {
      backgroundColor: theme.palette.background.color,
      transitionDuration: theme.transitions.medium
    })), _tableRow),
    tableGroupByRow: {
      backgroundColor: theme.palette.white.color,
      borderBottom: "1px solid ".concat(theme.palette.background.color)
    },
    rowActions: function rowActions(_ref2) {
      var showRowActions = _ref2.showRowActions;
      return {
        boxSizing: 'border-box',
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        transition: "opacity 0",
        gap: 8,
        left: 0,
        top: 0,
        overflow: showRowActions ? 'unset' : 'hidden',
        height: showRowActions ? '100%' : '0%',
        opacity: showRowActions ? 1 : 0,
        padding: '0 16px 0 16px'
      };
    },
    expanded: _defineProperty$1({}, '& td', {
      backgroundColor: theme.palette.background.color
    }),
    detailedView: {
      background: theme.palette.white.color
    }
  };
});

/**
 * Using Table
 * for using the table in our main table-view please refer to TViewTable.tsx
 *
 * init:
 * @function createTable<T>() @returns <Table/> & <Column/> to be used
 *
 *
 * Table API:
 * @param dataList - Array of type T for the table to display
 * @optional @param showRowsSelection - Boolean to enable multiple row selection.
 * @optional @param handleSelection - Callback func for multiple row selection onSelect event
 * @optional @param renderRowActions - JSX element to draw as an in-row overlay.
 * @optional @param renderNoDataView - JSX element to display in the table body view on empty data cases
 *
 * Column API:
 * @param accessor - The column data key
 * @param title - The column title
 * @param cell render function (we expose utils function: @function RenderItem, @function RendererList)
 * @param size - ColumnSize enum for cell size. i.e ColumnSize.XL
 * @param enableSorting - Boolean to enable sorting. Default sorting is true.
 */

var endPageBuffer = 20;

var TableV2 = function TableV2(_ref) {
  var dataList = _ref.dataList,
      children = _ref.children,
      renderRowDetailView = _ref.renderRowDetailView,
      renderRowActions = _ref.renderRowActions,
      renderContextMenu = _ref.renderContextMenu,
      showRowsSelection = _ref.showRowsSelection,
      onRowSelectChange = _ref.onRowSelectChange,
      renderNoDataView = _ref.renderNoDataView,
      handleQuickFilter = _ref.handleQuickFilter,
      className = _ref.className,
      enablePagination = _ref.enablePagination,
      _ref$paginationOption = _ref.paginationOptions,
      paginationOptions = _ref$paginationOption === void 0 ? SHOW_ITEMS_OPTIONS : _ref$paginationOption,
      rowSelectionState = _ref.rowSelectionState,
      setRowSelection = _ref.setRowSelection,
      columnVisibility = _ref.columnVisibility,
      setColumnVisibility = _ref.setColumnVisibility,
      sorting = _ref.sorting,
      setSorting = _ref.setSorting,
      columnOrder = _ref.columnOrder,
      setColumnOrder = _ref.setColumnOrder,
      onColumnsInit = _ref.onColumnsInit,
      _ref$manualSorting = _ref.manualSorting,
      manualSorting = _ref$manualSorting === void 0 ? false : _ref$manualSorting,
      columnSizing = _ref.columnSizing,
      setColumnSizing = _ref.setColumnSizing,
      columnGroupingState = _ref.columnGroupingState;
      _ref.setColumnGroupBy;
      var _ref$getSubRows = _ref.getSubRows,
      getSubRows = _ref$getSubRows === void 0 ? function () {
    return [];
  } : _ref$getSubRows,
      onEndPageScroll = _ref.onEndPageScroll,
      contextMenuRef = _ref.contextMenuRef;

  var _a, _b;

  var _useMemo = useMemo(function () {
    return getTableColumns(children);
  }, []),
      _useMemo2 = _slicedToArray$1(_useMemo, 2),
      columns = _useMemo2[0],
      columnProps = _useMemo2[1];

  var onEndPageScrollTrottle = useThrottle(onEndPageScroll, 1000);
  useEffect(function () {
    onColumnsInit === null || onColumnsInit === void 0 ? void 0 : onColumnsInit(columnProps);
  }, [columnProps, onColumnsInit]);

  var _useState = useState({}),
      _useState2 = _slicedToArray$1(_useState, 2),
      _rowSelectionState = _useState2[0],
      _setRowSelection = _useState2[1];

  var _useState3 = useState({}),
      _useState4 = _slicedToArray$1(_useState3, 2),
      _columnVisibility = _useState4[0],
      _setColumnVisibility = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray$1(_useState5, 2),
      _sorting = _useState6[0],
      _setSorting = _useState6[1];

  var _useState7 = useState([SYSTEM_CHECKBOX_ID].concat(_toConsumableArray$1(columns.map(function (column) {
    return column.id;
  })))),
      _useState8 = _slicedToArray$1(_useState7, 2),
      _columnOrder = _useState8[0],
      _setColumnOrder = _useState8[1];

  var _useState9 = useState({}),
      _useState10 = _slicedToArray$1(_useState9, 2),
      _columnSize = _useState10[0],
      _setColumnSize = _useState10[1];

  var _useState11 = useState({
    pageIndex: 0,
    pageSize: SHOW_ITEMS_OPTIONS[0]
  }),
      _useState12 = _slicedToArray$1(_useState11, 2),
      _useState12$ = _useState12[0],
      pageIndex = _useState12$.pageIndex,
      pageSize = _useState12$.pageSize,
      setPagination = _useState12[1];

  var _useState13 = useState(dataList),
      _useState14 = _slicedToArray$1(_useState13, 2),
      data = _useState14[0],
      setData = _useState14[1];

  var scrollableRef = useRef(null);
  var tableRef = useRef(null);
  var theme = useThemeSafe();
  var styles = useStyles$3({
    theme: theme
  });
  useEffect(function () {
    setData(dataList);
  }, [dataList]);

  var defaultSort = function defaultSort(c) {
    return c.getToggleSortingHandler();
  };

  var selectionColumn = useMemo(function () {
    return {
      id: SYSTEM_CHECKBOX_ID,
      size: ColumnSize.XSM,
      enableHiding: false,
      enableSorting: false,
      enableGrouping: false,
      enableResizing: false,
      header: function header(_ref2) {
        var table = _ref2.table;
        return /*#__PURE__*/React__default.createElement(Checkbox, {
          className: styles.checkbox,
          variant: "multi",
          checked: table.getIsAllRowsSelected(),
          onChange: function onChange() {
            var isAllRowsSelected = table.getIsAllRowsSelected();
            var defaultHandler = table.getToggleAllRowsSelectedHandler();
            defaultHandler(eventWrapper(!isAllRowsSelected));
          }
        });
      },
      cell: function cell(_ref3) {
        var row = _ref3.row;
        return /*#__PURE__*/React__default.createElement(Checkbox, {
          className: styles.checkbox,
          checked: row.getIsSelected(),
          onChange: function onChange() {
            row.toggleSelected(!row.getIsSelected());
          }
        });
      }
    };
  }, []);

  var getRowId = function getRowId(originalRow, index, parent) {
    return originalRow.id;
  };

  var table = useReactTable(Object.assign(Object.assign({
    data: data,
    columns: showRowsSelection ? [selectionColumn].concat(_toConsumableArray$1(columns)) : columns,
    state: Object.assign({
      columnVisibility: columnVisibility !== null && columnVisibility !== void 0 ? columnVisibility : _columnVisibility,
      sorting: sorting !== null && sorting !== void 0 ? sorting : _sorting,
      columnOrder: columnOrder !== null && columnOrder !== void 0 ? columnOrder : _columnOrder,
      rowSelection: rowSelectionState !== null && rowSelectionState !== void 0 ? rowSelectionState : _rowSelectionState,
      columnSizing: columnSizing !== null && columnSizing !== void 0 ? columnSizing : _columnSize,
      grouping: columnGroupingState || []
    }, enablePagination ? {
      pagination: {
        pageIndex: pageIndex,
        pageSize: pageSize
      }
    } : {}),
    manualSorting: manualSorting,
    // column resizing
    enableColumnResizing: true,
    columnResizeMode: 'onChange',
    onColumnSizingChange: function onColumnSizingChange(updater) {
      if (!updater || typeof updater !== 'function') {
        return;
      }

      var colMap = updater(columnSizing !== null && columnSizing !== void 0 ? columnSizing : _columnSize);

      if (!colMap) {
        return;
      }

      calcRowActionPos();

      if (setColumnSizing) {
        setColumnSizing(colMap);
        return;
      }

      _setColumnSize(colMap);
    },
    getRowId: getRowId,
    getCoreRowModel: getCoreRowModel(),
    // column visibility
    onColumnVisibilityChange: setColumnVisibility !== null && setColumnVisibility !== void 0 ? setColumnVisibility : _setColumnVisibility,
    // column order
    onColumnOrderChange: setColumnOrder !== null && setColumnOrder !== void 0 ? setColumnOrder : _setColumnOrder,
    // sorting
    onSortingChange: setSorting !== null && setSorting !== void 0 ? setSorting : _setSorting,
    getSortedRowModel: getSortedRowModel(),
    // expanding
    getExpandedRowModel: getExpandedRowModel(),
    // grouping
    manualGrouping: true,
    getSubRows: getSubRows
  }, enablePagination ? {
    getPaginationRowModel: getPaginationRowModel(),
    onPaginationChange: setPagination
  } : {}), {
    //row selection
    onRowSelectionChange: setRowSelection !== null && setRowSelection !== void 0 ? setRowSelection : _setRowSelection
  }));
  var selectedRows = useMemo(function () {
    return table.getSelectedRowModel().flatRows;
  }, [_rowSelectionState]);
  useEffect(function () {
    if (onRowSelectChange) {
      onRowSelectChange(selectedRows);
    }
  }, [selectedRows, onRowSelectChange]);

  var _useState15 = useState(0),
      _useState16 = _slicedToArray$1(_useState15, 2),
      rowActionPos = _useState16[0],
      setRowActionPos = _useState16[1];

  var calcRowActionPos = useCallback(debounce_1$1(function () {
    var _a, _b, _c;

    var parentWidth = tableRef.current.parentElement.getBoundingClientRect().width;
    var tableWidth = tableRef.current.getBoundingClientRect().width;
    var tableContainerWidth = tableWidth;

    if (tableWidth > parentWidth) {
      tableContainerWidth = parentWidth;
    }

    var actionContainerSize = ((_b = (_a = scrollableRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("td.".concat(RowActionSelector))) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().width) || 0;
    var scrollLeft = (_c = scrollableRef.current) === null || _c === void 0 ? void 0 : _c.scrollLeft;
    var newPos = tableContainerWidth + scrollLeft - actionContainerSize;
    setRowActionPos(newPos);
  }, 200), []);
  useEffect(function () {
    var _a;

    window.addEventListener('resize', calcRowActionPos);
    (_a = scrollableRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('scroll', calcRowActionPos);
    var resizeObserver = new ResizeObserver(function () {
      if (scrollableRef.current) {
        calcRowActionPos();
      }
    });
    tableRef.current && resizeObserver.observe(tableRef.current);
    return function () {
      var _a;

      resizeObserver.disconnect();
      window.removeEventListener('resize', calcRowActionPos);
      (_a = scrollableRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('scroll', calcRowActionPos);
      calcRowActionPos.clear();
    };
  }, [calcRowActionPos]);
  var tableRows = table.getRowModel().rows;
  var virtualRowsOverscan = 10;
  var rowVirtualizer = useVirtual({
    parentRef: scrollableRef,
    size: table.getRowModel().rows.length,
    overscan: virtualRowsOverscan
  });
  var isScrollDown = useScrollDirection(scrollableRef);
  var isExpandedParentIdx = useCallback(function (parent) {
    return parent.startIdx !== parent.endIdx;
  }, []);
  var parentIndexs = useRef();

  var getParentIndexs = function getParentIndexs(rows) {
    var activeList = [];

    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];

      if (r.subRows.length) {
        // gorup parents
        if (r.getIsExpanded()) {
          activeList.push({
            id: r.original.id,
            startIdx: i,
            endIdx: i + r.subRows.length
          });
        } else {
          activeList.push({
            id: r.original.id,
            startIdx: i,
            endIdx: i
          });
        }
      }
    }

    return activeList;
  };

  useEffect(function () {
    if (!table.getIsSomeRowsExpanded()) {
      return;
    }

    parentIndexs.current = getParentIndexs(tableRows);
  }, [tableRows]);
  useEffect(function () {
    // handler for end of page / grouped section row reach
    if (!onEndPageScroll) {
      // no cb supplied...
      return;
    }

    if (!isScrollDown) {
      // scrolling up...
      return;
    }

    var virtualItems = rowVirtualizer.virtualItems;

    if (!(virtualItems === null || virtualItems === void 0 ? void 0 : virtualItems.length)) {
      // no data...
      return;
    }

    var isGroupingActive = columnGroupingState === null || columnGroupingState === void 0 ? void 0 : columnGroupingState.length;

    if (!isGroupingActive) {
      // flat rows case:
      if (table.getRowModel().rows.length - endPageBuffer < virtualItems[virtualItems.length - 1].index) {
        onEndPageScrollTrottle();
      }

      return;
    }

    if (isGroupingActive && table.getIsSomeRowsExpanded()) {
      // groups rows case:
      // fire between groupBy parents:
      var startView = virtualItems[0].index;
      var endView = virtualItems[virtualItems.length - 1].index;

      if (parentIndexs.current && startView !== undefined && endView) {
        var viewRowsParents = parentIndexs.current.reduce(function (activeParent, pIdx) {
          if (pIdx.startIdx < endView && pIdx.endIdx > startView) {
            // [*P r *P r | r *P r *P r | r P]
            if (pIdx.startIdx < startView && pIdx.endIdx > startView && pIdx.endIdx < endView) {
              // [*P r | r P r P r | r P]
              // only ends inside view
              activeParent.push(pIdx);
              return activeParent;
            }

            if (pIdx.startIdx >= startView && pIdx.endIdx <= endView) {
              // start & ends inside view
              // [P r | r *P r r P | r]
              activeParent.push(pIdx);
              return activeParent;
            }

            if (pIdx.startIdx < startView && pIdx.endIdx > startView && pIdx.endIdx <= endView) {
              // last group in table
              // [P r *P | r r |]
              // [P r *P | r r P P |]
              activeParent.push(pIdx);
              return activeParent;
            }
          }

          return activeParent;
        }, []);

        if (viewRowsParents.length) {
          var expandedTargets = viewRowsParents.filter(isExpandedParentIdx);

          if (!expandedTargets.length) {
            return;
          }

          onEndPageScrollTrottle(expandedTargets.map(function (p) {
            return p.id;
          }));
        }
      }

      return;
    }
  }, [rowVirtualizer.virtualItems, columnGroupingState]);
  var virtualRows = rowVirtualizer.virtualItems,
      totalSize = rowVirtualizer.totalSize;
  var paddingTop = virtualRows.length > 0 ? ((_a = virtualRows === null || virtualRows === void 0 ? void 0 : virtualRows[0]) === null || _a === void 0 ? void 0 : _a.start) || 0 : 0;
  var paddingBottom = virtualRows.length > 0 ? totalSize - (((_b = virtualRows === null || virtualRows === void 0 ? void 0 : virtualRows[virtualRows.length - 1]) === null || _b === void 0 ? void 0 : _b.end) || 0) : 0;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: clsx('Cyolo-TableV2-root', className, styles.root),
    ref: scrollableRef
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.tableWrapper
  }, /*#__PURE__*/React__default.createElement("table", {
    className: styles.table,
    ref: tableRef,
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React__default.createElement("thead", {
    className: clsx(styles.tableHead)
  }, table.getHeaderGroups().map(function (headerGroup, idx) {
    return /*#__PURE__*/React__default.createElement(HeaderRow, {
      key: headerGroup.id + idx,
      id: headerGroup.id + idx
    }, headerGroup.headers.map(function (header) {
      var isShadowColumn = isShadowGroupedKey( // @ts-ignore
      header.column.columnDef.accessorKey);
      var isColumnGrouped = header.column.getIsGrouped();

      if (isShadowColumn && !isColumnGrouped) {
        return null;
      }

      if (isShadowColumn && isColumnGrouped) {
        return /*#__PURE__*/React__default.createElement("th", {
          colSpan: 1,
          key: 'groupedColumn'
        }, /*#__PURE__*/React__default.createElement(CollapseAllBtn, {
          onClick: function onClick() {
            table.resetExpanded();
            rowVirtualizer.scrollToIndex(0);
          },
          isExpanded: table.getIsSomeRowsExpanded()
        }));
      }

      return /*#__PURE__*/React__default.createElement(HeaderCell, {
        key: header.id,
        id: header.id,
        title: flexRender(header.column.columnDef.header, header.getContext()),
        onClick: defaultSort(header.column),
        onFilterClick: handleQuickFilter === null || handleQuickFilter === void 0 ? void 0 : handleQuickFilter(header.column),
        options: {
          quickFiltersEnabled: header.column.columnDef.enableColumnFilter && Boolean(handleQuickFilter),
          enableResizing: header.column.columnDef.enableResizing,
          getIsResizing: header.column.getIsResizing,
          getResizeHandler: header.getResizeHandler,
          getSize: header.getSize,
          colSpan: header.colSpan,
          deltaOffset: table.getState().columnSizingInfo.deltaOffset,
          enableSorting: header.column.columnDef.enableSorting,
          getIsSorted: header.column.getIsSorted,
          getCanGroup: header.column.getCanGroup,
          getToggleGroupingHandler: header.column.getToggleGroupingHandler
        }
      });
    }));
  })), /*#__PURE__*/React__default.createElement("tbody", {
    style: {
      display: 'table-row-group'
    }
  }, paddingTop > 0 && /*#__PURE__*/React__default.createElement("tr", {
    style: {
      display: 'table-row'
    }
  }, /*#__PURE__*/React__default.createElement("td", {
    style: {
      display: 'table-cell',
      height: "".concat(paddingTop, "px")
    }
  })), virtualRows.length ? virtualRows.map(function (virtualRow) {
    var row = tableRows[virtualRow.index];

    if (!row) {
      return null;
    }

    var uniqueKey = "".concat(getSystemUniqueID(row.original), "-").concat(virtualRow.index);
    return /*#__PURE__*/React__default.createElement(Row, {
      key: uniqueKey,
      trRef: virtualRow.measureRef,
      row: row,
      isGroupedParent: (columnGroupingState === null || columnGroupingState === void 0 ? void 0 : columnGroupingState.length) && row.depth === 0,
      renderRowDetailView: renderRowDetailView,
      renderRowActions: renderRowActions,
      rowActionPos: rowActionPos,
      tableTotalSize: table.getTotalSize(),
      renderContextMenu: renderContextMenu,
      contextMenuRef: contextMenuRef
    });
  }) : renderNoDataView && /*#__PURE__*/React__default.createElement(NoDataRow, {
    colSpan: table.getAllColumns().length
  }, renderNoDataView), paddingBottom > 0 && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      height: "".concat(paddingBottom, "px")
    }
  }))), /*#__PURE__*/React__default.createElement("tfoot", null)))), enablePagination && /*#__PURE__*/React__default.createElement(TablePagination, {
    pageCount: table.getPageCount(),
    pageSize: table.getState().pagination.pageSize,
    currentPageIndex: table.getState().pagination.pageIndex,
    onPageSizeChange: table.setPageSize,
    onChangePageIndex: table.setPageIndex,
    canGoPreviousPage: table.getCanPreviousPage(),
    onPreviousPage: table.previousPage,
    canGoNextPage: table.getCanNextPage(),
    onNextPage: table.nextPage,
    totalItems: dataList.length,
    options: paginationOptions
  }));
};
var useStyles$3 = createUseStyles(function (theme) {
  return {
    root: {
      overflow: 'auto',
      flex: 'auto 0 0',
      maxHeight: '100%',
      boxShadow: "".concat(theme.shadows[1], ", ").concat(theme.shadows[0]),
      borderRadius: theme.shape.borderRadiusLight
    },
    tableWrapper: {
      position: 'relative',
      width: '100%'
    },
    table: _defineProperty$1({
      tableLayout: 'auto',
      width: '100%',
      boxShadow: "".concat(theme.shadows[1], ", ").concat(theme.shadows[0]),
      borderCollapse: 'collapse',
      position: 'relative'
    }, '& #selection', {
      width: 'auto'
    }),
    tableHead: {
      height: 48,
      display: 'table-row-group'
    },
    checkbox: _defineProperty$1({
      transition: "all ".concat(theme.transitions.fast)
    }, '&:active', {
      opacity: 0.7
    })
  };
});
var createTable = function createTable() {
  return {
    Table: function Table(props) {
      return /*#__PURE__*/React__default.createElement(TableV2, Object.assign({}, props));
    },
    Column: function Column$1(props) {
      return /*#__PURE__*/React__default.createElement(Column, Object.assign({}, props));
    }
  };
};

/**
 * Using Table
 * for using table as a stand alone component case please refer to Table.tsx
 *
 * init:
 * @function createTViewTable<T>() @returns <Table/> & <Column/> to be used
 *
 *
 * Table API:
 * @param dataList. the data the table should display
 * @optional @param showRowsSelection enable multiple row selection.
 * @optional @param handleSelection callback for multiple row selection onSelect event
 * @optional @param renderRowActions. in-row overlay for actions buttons
 * @optional @param renderNoDataView display a table body view on empty data cases
 * @optional @param groupBy
 * @optional @param onGroupByChange callback for groupBy state change handlers
 * @optional @param onEndPageScroll callback for scrolling end of rows call. fire both in groupby mode & flat mode
 *
 * Column API:
 * @param accessor the column data key
 * @param title the column title
 * @param cell render function (we expose utils function: @function RenderItem, @function RendererList)
 * @param size for custom sizing use @constant ColumnSize
 * @param enableSorting default sorting is true.
 * @param filterOp acts as both enable flag and the @constant FilterOp options for the filtering operators. if not passed filtering is disabled
 *
 */

var TViewTable$1 = function TViewTable(_a) {
  var children = _a.children,
      dataList = _a.dataList,
      groupBy = _a.groupBy,
      getGroupSubRows = _a.getGroupSubRows,
      handleEndPageScroll = _a.onEndPageScroll,
      props = __rest(_a, ["children", "dataList", "groupBy", "getGroupSubRows", "onEndPageScroll"]);

  var _useTableViewContext = useTableViewContext(),
      handleQuickFilter = _useTableViewContext.searchQuery.handleQuickFilter,
      _useTableViewContext$ = _useTableViewContext.table,
      rowSelectionState = _useTableViewContext$.rowSelectionState,
      setRowSelection = _useTableViewContext$.setRowSelection,
      columnVisibilityState = _useTableViewContext$.columnVisibilityState,
      setColumnVisibility = _useTableViewContext$.setColumnVisibility,
      sortingState = _useTableViewContext$.sortingState,
      setSorting = _useTableViewContext$.setSorting,
      columnOrderState = _useTableViewContext$.columnOrderState,
      setColumnOrder = _useTableViewContext$.setColumnOrder,
      setColumnList = _useTableViewContext$.setColumnList,
      columnSizing = _useTableViewContext$.columnSizing,
      initColumnSizing = _useTableViewContext$.initColumnSizing,
      setColumnSizing = _useTableViewContext$.setColumnSizing,
      columnGroupBy = _useTableViewContext$.columnGroupBy,
      columnGroupingState = _useTableViewContext$.columnGroupingState,
      setColumnGroupBy = _useTableViewContext$.setColumnGroupBy;

  var _useMemo = useMemo(function () {
    var _getTableColumns = getTableColumns(children),
        _getTableColumns2 = _slicedToArray$1(_getTableColumns, 3),
        columnProps = _getTableColumns2[1],
        columnSizeConf = _getTableColumns2[2];

    return [columnProps, columnSizeConf];
  }, []),
      _useMemo2 = _slicedToArray$1(_useMemo, 2),
      columnList = _useMemo2[0],
      columnSizeConf = _useMemo2[1];

  useEffect(function () {
    // @ts-ignore
    setColumnList(columnList);
  }, [columnList]);
  useEffect(function () {
    // @ts-ignore
    initColumnSizing(columnSizeConf);
  }, [columnList]);
  useEffect(function () {
    if (groupBy === columnGroupBy) {
      return;
    }

    setColumnGroupBy(groupBy);
  }, [groupBy, columnGroupBy]);
  return /*#__PURE__*/React__default.createElement(TableV2, Object.assign({}, props, {
    dataList: dataList,
    rowSelectionState: rowSelectionState,
    setRowSelection: setRowSelection,
    columnVisibility: columnVisibilityState,
    setColumnVisibility: setColumnVisibility,
    sorting: sortingState,
    setSorting: setSorting,
    columnOrder: columnOrderState,
    setColumnOrder: setColumnOrder,
    handleQuickFilter: handleQuickFilter,
    columnSizing: columnSizing,
    setColumnSizing: setColumnSizing,
    onColumnSizingInit: initColumnSizing,
    columnGroupingState: columnGroupingState,
    setColumnGroupBy: setColumnGroupBy,
    getSubRows: getGroupSubRows,
    onEndPageScroll: handleEndPageScroll
  }), children);
};

var createTViewTable = function createTViewTable() {
  return {
    Table: function Table(props) {
      return /*#__PURE__*/React__default.createElement(TViewTable$1, Object.assign({}, props));
    },
    Column: function Column$1(props) {
      return /*#__PURE__*/React__default.createElement(Column, Object.assign({}, props));
    }
  };
};

var TViewRoot = function TViewRoot(_ref) {
  var className = _ref.className,
      children = _ref.children;
  var theme = useThemeSafe();
  var styles = useStyles$2({
    theme: theme
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(styles.tableViewRoot, className)
  }, children);
};

var TViewBar = function TViewBar(_ref2) {
  var className = _ref2.className,
      children = _ref2.children;
  var theme = useThemeSafe();
  var styles = useStyles$2({
    theme: theme
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(styles.bar, className)
  }, children);
};

var TViewActions = function TViewActions(_ref3) {
  var className = _ref3.className,
      children = _ref3.children;
  var theme = useThemeSafe();
  var styles = useStyles$2({
    theme: theme
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(styles.actions, className)
  }, children);
};

var TViewTable = function TViewTable(_ref4) {
  var className = _ref4.className,
      children = _ref4.children;
  var theme = useThemeSafe();
  var styles = useStyles$2({
    theme: theme
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(styles.table, className)
  }, children);
};

var TViewFilter = function TViewFilter(_ref5) {
  var className = _ref5.className,
      children = _ref5.children;
  var theme = useThemeSafe();
  var styles = useStyles$2({
    theme: theme
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(styles.filter, className)
  }, children);
};

var TViewPagination = function TViewPagination(_ref6) {
  var className = _ref6.className,
      children = _ref6.children;
  var theme = useThemeSafe();
  var styles = useStyles$2({
    theme: theme
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx(styles.pagination, className)
  }, children);
};

var TViewLayout = {
  Root: TViewRoot,
  Bar: TViewBar,
  Actions: TViewActions,
  Table: TViewTable,
  Filter: TViewFilter,
  Pagination: TViewPagination
};
var navBarHeight = 108;
var paginationHeight = 56;
var rootPadding = 36;
var barHeight = 36;
var tableViewRootGap = 8;
var tableMaxHeight = "calc(100vh - ".concat(navBarHeight + paginationHeight + rootPadding + barHeight + tableViewRootGap, "px)");
var useStyles$2 = createUseStyles(function (theme) {
  return {
    tableViewRoot: {
      display: 'flex',
      flexDirection: 'column',
      gap: tableViewRootGap,
      '& .Cyolo-TableV2-root': {
        maxHeight: tableMaxHeight
      }
    },
    bar: {
      flex: '0 0 auto',
      display: 'flex',
      flexDirection: 'row',
      gap: 4
    },
    actions: {
      flex: 1,
      display: 'flex',
      gap: 8,
      alignItems: 'center',
      justifyContent: 'flex-end',
      flexWrap: 'nowrap'
    },
    filter: {
      display: 'flex',
      flex: 8,
      zIndex: theme.zIndex.high
    },
    table: {
      flex: '1 1 auto'
    },
    pagination: {}
  };
});

var Table = function Table(_ref) {
  var _ref$showShadow = _ref.showShadow,
      showShadow = _ref$showShadow === void 0 ? true : _ref$showShadow,
      children = _ref.children;
  var classs = ['CyoloUI-Table'];

  if (showShadow) {
    classs.push('CyoloUI-Table-Shadow');
  }

  return /*#__PURE__*/React__default.createElement("table", {
    className: classs.join(' ')
  }, children);
};

var TableBody = function TableBody(_ref) {
  var children = _ref.children;

  if (!children) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement("tbody", null, React__default.Children.map(children, function (child) {
    return /*#__PURE__*/React__default.cloneElement(child, {
      isHead: false
    });
  }));
};

var includesTypeOf = function includesTypeOf(children, type) {
  return React__default.Children.map(children, function (child) {
    var _a;

    return (_a = child) === null || _a === void 0 ? void 0 : _a.type;
  }).includes(type);
};

var TableCell = function TableCell(_ref) {
  var _ref$isHead = _ref.isHead,
      isHead = _ref$isHead === void 0 ? false : _ref$isHead,
      _ref$centerContent = _ref.centerContent,
      centerContent = _ref$centerContent === void 0 ? false : _ref$centerContent,
      width = _ref.width,
      children = _ref.children,
      _ref$sort = _ref.sort,
      sort = _ref$sort === void 0 ? 'disabled' : _ref$sort,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick;
  var cellClasses = ['CyoloUI-TableCell'];
  var contentClasses = ['CyoloUI-TableCell-Content']; // if the child is a checkbox add the proper class

  if (includesTypeOf(children, Checkbox)) {
    cellClasses.push('CyoloUI-TableCell-Checkbox');
    contentClasses.push('CyoloUI-TableCell-Content-Center');
  } // if the child is a banner, toggle or just needs to be centered


  if (includesTypeOf(children, Banner) || includesTypeOf(children, Toggle) || centerContent) {
    contentClasses.push('CyoloUI-TableCell-Content-Center');
  }

  if (sort !== 'disabled') {
    contentClasses.push('CyoloUI-TableCell-Clickable');

    if (sort !== 'none') {
      contentClasses.push('CyoloUI-TableCell-Flex-Start');
    }
  }

  if (isHead) {
    cellClasses.push('CyoloUI-TableCell-Head'); // show arrow only in cases the child component is not a checkbox
    // and the given 'sort' prop is not none

    var showSortingArrow = !includesTypeOf(children, Checkbox) && sort !== 'disabled' && sort !== 'none'; // the arrow defaults to pointing down

    var sortArrowRotationDegrees = 'rotate(0deg)';

    if (sort === 'asc') {
      // if the arrow needs to point up
      sortArrowRotationDegrees = 'rotate(180deg)';
    } // render out the head and pass prop of color (for the text comps)
    // which makes it light blue


    var pxWidth = width ? "".concat(width, "px") : '';
    return /*#__PURE__*/React__default.createElement("th", {
      className: cellClasses.join(' '),
      style: {
        width: pxWidth
      },
      onClick: onClick
    }, /*#__PURE__*/React__default.createElement("div", {
      className: contentClasses.join(' ')
    }, children && /*#__PURE__*/React__default.cloneElement(children, {
      color: colors.textLightBlue
    }), showSortingArrow && /*#__PURE__*/React__default.createElement("div", {
      className: "CyoloUI-TableCell-SortArrow",
      style: {
        transform: sortArrowRotationDegrees
      }
    }, /*#__PURE__*/React__default.createElement(IconButton, {
      size: 12,
      iconID: "sort-arrow"
    }))));
  }

  cellClasses.push('CyoloUI-TableCell-Body');
  return /*#__PURE__*/React__default.createElement("td", {
    className: cellClasses.join(' ')
  }, /*#__PURE__*/React__default.createElement("div", {
    className: contentClasses.join(' ')
  }, children));
};

var TableHead = function TableHead(_ref) {
  var children = _ref.children;

  // if no children are given return null
  if (!children) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.cloneElement(children, {
    isHead: true
  }));
};

var TableRow = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var _ref$isHead = _ref.isHead,
      isHead = _ref$isHead === void 0 ? false : _ref$isHead,
      _ref$isEdited = _ref.isEdited,
      isEdited = _ref$isEdited === void 0 ? false : _ref$isEdited,
      _ref$hoverStyle = _ref.hoverStyle,
      hoverStyle = _ref$hoverStyle === void 0 ? 'normal' : _ref$hoverStyle,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected,
      children = _ref.children,
      onClick = _ref.onClick,
      onContextMenu = _ref.onContextMenu;
  var classes = ['CyoloUI-TableRow'];

  if (isHead) {
    classes.push('CyoloUI-TableRow-head');
  } else {
    classes.push('CyoloUI-TableRow-body');
  }

  if (hoverStyle === 'blue') {
    classes.push('CyoloUI-TableRow-body-blue');
  }

  if (isEdited || selected) {
    classes.push('CyoloUI-TableRow-active-edit');
  }

  return /*#__PURE__*/React__default.createElement("tr", {
    ref: ref,
    className: classes.join(' '),
    onClick: onClick,
    onContextMenu: onContextMenu
  }, children && React__default.Children.map(children, function (child) {
    return /*#__PURE__*/React__default.cloneElement(child, {
      isHead: isHead
    });
  }));
});
TableRow.displayName = 'TableRow';

var tabbable_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object|iframe/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  try {
    // Otherwise we need to check some styles
    var style = window.getComputedStyle(element);
    return zeroSize ? style.getPropertyValue("overflow") !== "visible" ||
    // if 'overflow: visible' set, check if there is actually any overflow
    element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
  } catch (exception) {
    // eslint-disable-next-line no-console
    console.warn("Failed to inspect element style");
    return false;
  }
}

function visible(element) {
  var parentElement = element;
  var rootNode = element.getRootNode && element.getRootNode();
  while (parentElement) {
    if (parentElement === document.body) break;

    // if we are not hidden yet, skip to checking outside the Web Component
    if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;

    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function (finished, el) {
    return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
  }, []);
  return descendants.filter(tabbable);
}
module.exports = exports["default"];
});

var resetState_1$2 = resetState$2;
var log_1$2 = log$2;
var handleBlur_1 = handleBlur;
var handleFocus_1 = handleFocus;
var markForFocusLater_1 = markForFocusLater;
var returnFocus_1 = returnFocus;
var popWithoutFocus_1 = popWithoutFocus;
var setupScopedFocus_1 = setupScopedFocus;
var teardownScopedFocus_1 = teardownScopedFocus;



var _tabbable2 = _interopRequireDefault$2(tabbable_1);

function _interopRequireDefault$2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState$2() {
  focusLaterElements = [];
}

/* istanbul ignore next */
function log$2() {
  if (process.env.NODE_ENV !== "production") {
    console.log("focusManager ----------");
    focusLaterElements.forEach(function (f) {
      var check = f || {};
      console.log(check.nodeName, check.className, check.id);
    });
    console.log("end focusManager ----------");
  }
}
/* eslint-enable no-console */

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({ preventScroll: preventScroll });
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

var focusManager = /*#__PURE__*/Object.defineProperty({
	resetState: resetState_1$2,
	log: log_1$2,
	handleBlur: handleBlur_1,
	handleFocus: handleFocus_1,
	markForFocusLater: markForFocusLater_1,
	returnFocus: returnFocus_1,
	popWithoutFocus: popWithoutFocus_1,
	setupScopedFocus: setupScopedFocus_1,
	teardownScopedFocus: teardownScopedFocus_1
}, '__esModule', {value: true});

var scopeTab_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;



var _tabbable2 = _interopRequireDefault(tabbable_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getActiveElement() {
  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var target = void 0;

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];
  var activeElement = getActiveElement();

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  if (tail === activeElement && !shiftKey) {
    target = head;
  }

  if (head === activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  target = tabbable[x];

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof target === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  target.focus();
}
module.exports = exports["default"];
});

var exenv = createCommonjsModule$1(function (module) {
  /* global define */
  (function () {

    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
      canUseDOM: canUseDOM,
      canUseWorkers: typeof Worker !== 'undefined',
      canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
      canUseViewport: canUseDOM && !!window.screen
    };

    if (module.exports) {
      module.exports = ExecutionEnvironment;
    } else {
      window.ExecutionEnvironment = ExecutionEnvironment;
    }
  })();
});

var safeHTMLElement = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = exports.SafeNodeList = exports.SafeHTMLCollection = undefined;



var _exenv2 = _interopRequireDefault(exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

exports.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};

exports.SafeNodeList = EE.canUseDOM ? window.NodeList : {};

exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;
});

var resetState_1$1 = resetState$1;
var log_1$1 = log$1;
var assertNodeList_1 = assertNodeList;
var setElement_1 = setElement;
var validateElement_1 = validateElement;
var hide_1 = hide;
var show_1 = show;
var documentNotReadyOrSSRTesting_1 = documentNotReadyOrSSRTesting;



var _warning2 = _interopRequireDefault$1(warning_1);



function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState$1() {
  if (globalElement) {
    if (globalElement.removeAttribute) {
      globalElement.removeAttribute("aria-hidden");
    } else if (globalElement.length != null) {
      globalElement.forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    } else {
      document.querySelectorAll(globalElement).forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    }
  }
  globalElement = null;
}

/* istanbul ignore next */
function log$1() {
  if (process.env.NODE_ENV !== "production") {
    var check = globalElement || {};
    console.log("ariaAppHider ----------");
    console.log(check.nodeName, check.className, check.id);
    console.log("end ariaAppHider ----------");
  }
}
/* eslint-enable no-console */

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  var el = appElement || globalElement;
  if (el) {
    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
  } else {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return [];
  }
}

function hide(appElement) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;

      el.setAttribute("aria-hidden", "true");
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function show(appElement) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var el = _step2.value;

      el.removeAttribute("aria-hidden");
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

var ariaAppHider = /*#__PURE__*/Object.defineProperty({
	resetState: resetState_1$1,
	log: log_1$1,
	assertNodeList: assertNodeList_1,
	setElement: setElement_1,
	validateElement: validateElement_1,
	hide: hide_1,
	show: show_1,
	documentNotReadyOrSSRTesting: documentNotReadyOrSSRTesting_1
}, '__esModule', {value: true});

var classList = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetState = resetState;
exports.log = log;
var htmlClassList = {};
var docBodyClassList = {};

/* eslint-disable no-console */
/* istanbul ignore next */
function removeClass(at, cls) {
  at.classList.remove(cls);
}

/* istanbul ignore next */
function resetState() {
  var htmlElement = document.getElementsByTagName("html")[0];
  for (var cls in htmlClassList) {
    removeClass(htmlElement, htmlClassList[cls]);
  }

  var body = document.body;
  for (var _cls in docBodyClassList) {
    removeClass(body, docBodyClassList[_cls]);
  }

  htmlClassList = {};
  docBodyClassList = {};
}

/* istanbul ignore next */
function log() {
  if (process.env.NODE_ENV !== "production") {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n  ";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n  ";
    }

    classes = document.body.className;

    buffer += "\n\ndoc.body (" + classes + "):\n  ";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n  ";
    }

    buffer += "\n";

    console.log(buffer);
  }
}
/* eslint-enable no-console */

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};
});

var log_1 = log;
var resetState_1 = resetState;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Cannot register modal instance that's already open");
      }
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Unable to deregister " + openInstance + " as " + "it was never registered");
      }
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

/* eslint-disable no-console */
/* istanbul ignore next */
function log() {
  console.log("portalOpenInstances ----------");
  console.log(portalOpenInstances.openInstances.length);
  portalOpenInstances.openInstances.forEach(function (p) {
    return console.log(p);
  });
  console.log("end portalOpenInstances ----------");
}

/* istanbul ignore next */
function resetState() {
  portalOpenInstances = new PortalOpenInstances();
}
/* eslint-enable no-console */

var _default = portalOpenInstances;

var portalOpenInstances_1 = /*#__PURE__*/Object.defineProperty({
	log: log_1,
	resetState: resetState_1,
	default: _default
}, '__esModule', {value: true});

var _portalOpenInstances2 = _interopRequireDefault(portalOpenInstances_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];
/* eslint-enable no-console */

function focusContent() {
  if (instances.length === 0) {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn("React-Modal: Open instances > 0 expected");
    }
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before && !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);

var ModalPortal_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();





var _propTypes2 = _interopRequireDefault(_propTypes);



var focusManager$1 = _interopRequireWildcard(focusManager);



var _scopeTab2 = _interopRequireDefault(scopeTab_1);



var ariaAppHider$1 = _interopRequireWildcard(ariaAppHider);



var classList$1 = _interopRequireWildcard(classList);



var _safeHTMLElement2 = _interopRequireDefault(safeHTMLElement);



var _portalOpenInstances2 = _interopRequireDefault(portalOpenInstances_1);



function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      bodyOpenClassName && classList$1.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList$1.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider$1.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager$1.returnFocus(_this.props.preventScroll);
          focusManager$1.teardownScopedFocus();
        } else {
          focusManager$1.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }

      _portalOpenInstances2.default.deregister(_this);
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager$1.setupScopedFocus(_this.node);
          focusManager$1.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.openAnimationFrame = requestAnimationFrame(function () {
            _this.setState({ afterOpen: true });

            if (_this.props.isOpen && _this.props.onAfterOpen) {
              _this.props.onAfterOpen({
                overlayEl: _this.overlay,
                contentEl: _this.content
              });
            }
          });
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (process.env.NODE_ENV !== "production") {
        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
      cancelAnimationFrame(this.openAnimationFrame);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      bodyOpenClassName && classList$1.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList$1.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider$1.hide(appElement);
      }

      _portalOpenInstances2.default.register(this);
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles,
          children = _props2.children;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      if (this.shouldBeClosed()) {
        return null;
      }

      var overlayProps = {
        ref: this.setOverlayRef,
        className: this.buildClassName("overlay", overlayClassName),
        style: _extends({}, overlayStyles, this.props.style.overlay),
        onClick: this.handleOverlayOnClick,
        onMouseDown: this.handleOverlayOnMouseDown
      };

      var contentProps = _extends({
        id: id,
        ref: this.setContentRef,
        style: _extends({}, contentStyles, this.props.style.content),
        className: this.buildClassName("content", className),
        tabIndex: "-1",
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleContentOnMouseDown,
        onMouseUp: this.handleContentOnMouseUp,
        onClick: this.handleContentOnClick,
        role: this.props.role,
        "aria-label": this.props.contentLabel
      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
        "data-testid": this.props.testId
      });

      var contentElement = this.props.contentElement(contentProps, children);
      return this.props.overlayElement(overlayProps, contentElement);
    }
  }]);

  return ModalPortal;
}(React__default.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];
});

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}

var reactLifecyclesCompat_es = /*#__PURE__*/Object.freeze({
  __proto__: null,
  polyfill: polyfill
});

var _reactLifecyclesCompat = /*@__PURE__*/getAugmentedNamespace(reactLifecyclesCompat_es);

var Modal_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _reactDom2 = _interopRequireDefault(reactDom__default);



var _propTypes2 = _interopRequireDefault(_propTypes);



var _ModalPortal2 = _interopRequireDefault(ModalPortal_1);



var ariaAppHider$1 = _interopRequireWildcard(ariaAppHider);



var _safeHTMLElement2 = _interopRequireDefault(safeHTMLElement);



function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;

var createHTMLElement = function createHTMLElement(name) {
  return document.createElement(name);
};

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = createHTMLElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = createHTMLElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider$1.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(React__default.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2.default.createElement(
      "div",
      props,
      contentEl
    );
  },
  contentElement: function contentElement(props, children) {
    return _react2.default.createElement(
      "div",
      props,
      children
    );
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

if (process.env.NODE_ENV !== "production") {
  Modal.setCreateHTMLElement = function (fn) {
    return createHTMLElement = fn;
  };
}

exports.default = Modal;
});

var lib = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _Modal2 = _interopRequireDefault(Modal_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];
});

var Modal = /*@__PURE__*/getDefaultExportFromCjs(lib);

var useStyles$1 = createUseStyles({
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: [0, 4, 0, 8]
  }
});

var UsernamePasswordModal = /*#__PURE__*/function (_Component) {
  _inherits$1(UsernamePasswordModal, _Component);

  var _super = _createSuper$1(UsernamePasswordModal);

  function UsernamePasswordModal(props) {
    var _this;

    _classCallCheck$4(this, UsernamePasswordModal);

    _this = _super.call(this, props); // check this

    _this.isValid = function () {
      return _this.state.username.length > 0 && _this.state.password.length > 0;
    };

    _this.handleSubmit = function () {
      _this.props.onSubmitClick(_this.state.username, _this.state.password);
    };

    _this.handleUsernameChange = function (e) {
      _this.setState({
        username: e.target.value
      });
    };

    _this.handleSecretChange = function (e) {
      _this.setState({
        password: e.target.value
      });
    };

    _this.styles = useStyles$1(); // required setup for Modal library

    if (document && document.getElementById('root')) {
      Modal.setAppElement(document.getElementById('root'));
    }

    _this.state = {
      username: '',
      password: ''
    };
    return _this;
  }

  _createClass$1(UsernamePasswordModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          appName = _this$props.appName,
          onCancel = _this$props.onCancel;
      return /*#__PURE__*/React__default.createElement(Modal, {
        isOpen: true,
        onRequestClose: onCancel,
        style: {
          overlay: {
            background: 'rgba(0,0,0,0.5)',
            zIndex: 10,
            display: 'flex',
            justifyContent: 'center',
            padding: 0,
            alignItems: 'center'
          },
          content: {
            width: 'fit-content',
            padding: 0,
            height: 'fit-content',
            boxShadow: 'none',
            inset: 0,
            position: 'relative'
          }
        }
      }, /*#__PURE__*/React__default.createElement(Card, {
        style: cardStyle
      }, /*#__PURE__*/React__default.createElement("form", {
        onSubmit: function onSubmit(e) {
          e.preventDefault();
        },
        className: "CyoloUI-UsernamePasswordModal-form"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "CyoloUI-UsernamePasswordModal-x",
        onClick: onCancel
      }, /*#__PURE__*/React__default.createElement(Icon, {
        size: 15,
        id: "x-icon"
      })), this.isValid() ? /*#__PURE__*/React__default.createElement(Icon, {
        style: {
          justifySelf: 'center'
        },
        size: 60,
        id: "secure"
      }) : /*#__PURE__*/React__default.createElement(Icon, {
        style: {
          justifySelf: 'center'
        },
        size: 60,
        id: "secure-grey"
      }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Text$1, {
        variant: "body"
      }, "Please provide credentials for", ' ', /*#__PURE__*/React__default.createElement("span", {
        style: {
          color: colors.selected
        }
      }, appName))), /*#__PURE__*/React__default.createElement(TextField, {
        inlineElement: /*#__PURE__*/React__default.createElement("div", {
          className: this.styles.iconContainer
        }, /*#__PURE__*/React__default.createElement(Icon, {
          id: "person",
          size: 14
        })),
        placeholder: "Username",
        onChange: this.handleUsernameChange
      }), /*#__PURE__*/React__default.createElement(TextField, {
        inlineElement: /*#__PURE__*/React__default.createElement("div", {
          className: this.styles.iconContainer
        }, /*#__PURE__*/React__default.createElement(Icon, {
          id: "lock",
          size: 14
        })),
        type: "password",
        placeholder: "Password",
        onChange: this.handleSecretChange
      }), /*#__PURE__*/React__default.createElement(Button, {
        type: "submit",
        disabled: !this.isValid(),
        onClick: this.handleSubmit,
        variant: "primary"
      }, "Submit"))));
    }
  }]);

  return UsernamePasswordModal;
}(Component); // TODO fix Card to accept classnames

/* styles */


var cardStyle = {
  padding: '14px 30px 30px 30px',
  width: 260
};

var ViewName;

(function (ViewName) {
  ViewName["TABLE"] = "tableView";
  ViewName["GRID"] = "gridView";
})(ViewName || (ViewName = {}));

var defaultValue = ViewName.GRID;

var ViewSwitcherIcon = function ViewSwitcherIcon(_ref) {
  var color = _ref.color,
      activeView = _ref.activeView;
  var renderIcon = useCallback(function () {
    switch (activeView) {
      default:
      case ViewName.GRID:
        return /*#__PURE__*/React__default.createElement("svg", {
          width: "12",
          height: "11",
          viewBox: "0 0 12 11",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/React__default.createElement("path", {
          d: "M11 9.37012L1 9.37012",
          stroke: color,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/React__default.createElement("path", {
          d: "M11 5.37012L1 5.37012",
          stroke: color,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/React__default.createElement("path", {
          d: "M11 1.37012L1 1.37012",
          stroke: color,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }));

      case ViewName.TABLE:
        return /*#__PURE__*/React__default.createElement("svg", {
          width: "10",
          height: "11",
          viewBox: "0 0 10 11",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/React__default.createElement("rect", {
          y: "0.370117",
          width: "4",
          height: "4",
          rx: "1",
          fill: color
        }), /*#__PURE__*/React__default.createElement("rect", {
          y: "6.37012",
          width: "4",
          height: "4",
          rx: "1",
          fill: color
        }), /*#__PURE__*/React__default.createElement("rect", {
          x: "6",
          y: "0.370117",
          width: "4",
          height: "4",
          rx: "1",
          fill: color
        }), /*#__PURE__*/React__default.createElement("rect", {
          x: "6",
          y: "6.37012",
          width: "4",
          height: "4",
          rx: "1",
          fill: color
        }));
    }
  }, [activeView, color]);
  return renderIcon();
};

var ViewSwitcher = function ViewSwitcher(_ref2) {
  var onChange = _ref2.onChange,
      activeView = _ref2.activeView,
      onClick = _ref2.onClick;

  var _useState = useState(),
      _useState2 = _slicedToArray$1(_useState, 2),
      hoverRefElement = _useState2[0],
      setHoverRefElement = _useState2[1];

  var isHovering = useHover(hoverRefElement);
  var theme = useThemeSafe();
  var styles = useStyles({
    theme: theme
  });

  var _useState3 = useState(defaultValue),
      _useState4 = _slicedToArray$1(_useState3, 2),
      internalActiveView = _useState4[0],
      setActiveView = _useState4[1];

  var isControlled = useMemo(function () {
    return Boolean(activeView);
  }, [activeView]);
  var active = !isControlled ? internalActiveView : activeView;
  useEffect(function () {
    if (!isControlled) {
      setActiveView(defaultValue);
    }
  }, [isControlled]);
  useEffect(function () {
    if (!isControlled && onChange) {
      onChange(internalActiveView);
    }
  }, [isControlled, internalActiveView, onChange]);
  var iconColor = useMemo(function () {
    if (isHovering) {
      return theme.palette.white.color;
    }

    return theme.palette.primary.color;
  }, [theme, isHovering]);
  var handleClick = useCallback(function () {
    if (!isControlled) {
      setActiveView(function (prev) {
        return prev === ViewName.GRID ? ViewName.TABLE : ViewName.GRID;
      });
      return;
    }

    if (onClick) {
      onClick();
    }
  }, [isControlled, onClick]);
  return /*#__PURE__*/React__default.createElement("div", {
    ref: setHoverRefElement
  }, /*#__PURE__*/React__default.createElement(Button, {
    className: styles.actionButton,
    variant: "secondary",
    onClick: handleClick
  }, /*#__PURE__*/React__default.createElement(ViewSwitcherIcon, {
    activeView: active,
    color: iconColor
  })));
};
var useStyles = createUseStyles(function (theme) {
  return {
    actionButton: _defineProperty$1({
      padding: '4px !important',
      width: '24px !important',
      height: '24px !important'
    }, '&:hover', {
      backgroundColor: "".concat(theme.palette.primary.color, " !important")
    })
  };
});

export { ActionBarProvider, ActionButton, ActionIcon, Anchor, AppCard, Banner, Button, Card, CardHeader, Checkbox, Chip, Collapse, CollapseArrow, ColumnGroupByToggler, ColumnSize, ColumnToggler, ComponentBenchmarkWrapper, ContextMenu, DeleteModal, Dialog, Divider$1 as Divider, DropdownAddButton, DropdownCard, DropdownDivider, DropdownMenu, EmptyDropdown, FREE_TEXT_KEY, FieldView, Form, GeneralButton, GeneralIcon, GroupButton, INCLUDES_OP, Icon, IconButton, IconSwitch, Image, ListCell, LoadingIndicator, LoadingOverlay, MinimalNavBar, MinimalNavBarMobile, MutableSideNav, NoDataView, OP_VALUE_CONNECTOR, Operators, PasswordField, Popover, ProfileMenu, QueryBuilderSearch, RadioGroup, RenderCell, RenderGroupByCell, RetryTextAndButton, RichTextEditor, SHOW_ITEMS_OPTIONS, SearchField, SelectableCard, ShowMore, SideNav, SideNavOption, SnippetCard, StandaloneLoadingIndicator, StatusBanner, StatusIcon, TViewLayout, TViewQueryBuilder, Tab, TableBody as TableBody_legacy, TableCell as TableCell_legacy, TableHead as TableHead_legacy, TablePagination, TableRow as TableRow_legacy, TableViewProvider, Table as Table_legacy, Tabs, Tag, TagList, TagsListField, Text$1 as Text, TextArea, TextCell, TextField, Toggle, ToggleCell, Tooltip, UserDropDown, UsernamePasswordModal, ViewName, ViewSwitcher, boolFilter, colors, createTViewTable, createTable, cyTheme, dateFilter, fonts$1 as fonts, fromGroupedKey, getGroupByTargetToSubRows, getGroupByTargetToSubRowsForList, getGroupedRows, getGroupedRowsForList, isRowGroupByParent, nonApiFilter, nonApiResolver, nonApiSuggestions, numberFilter, queryToUrl, textFilter, toGroupedKey, useArrowKeysNavigation, useAutoScroller, useDebounce, useDropdownPopper, useHover, usePageRedirectBeanchMark, useRegisterListener, useTableViewContext, useThemeSafe, withTableContextProvider };
//# sourceMappingURL=index.es.js.map
